// Source: turkey-neighbourhoods@4.0.3 (MIT)
// Generated from cityNamesByCode, districtsByCityCode and neighbourhoodsByDistrictAndCityCode.
export const turkeyLocations = {
  "Adana": [
    "Aladağ",
    "Ceyhan",
    "Çukurova",
    "Feke",
    "İmamoğlu",
    "Karaisalı",
    "Karataş",
    "Kozan",
    "Pozantı",
    "Saimbeyli",
    "Sarıçam",
    "Seyhan",
    "Tufanbeyli",
    "Yumurtalık",
    "Yüreğir"
  ],
  "Adıyaman": [
    "Besni",
    "Çelikhan",
    "Gerger",
    "Gölbaşı",
    "Kahta",
    "Merkez",
    "Samsat",
    "Sincik",
    "Tut"
  ],
  "Afyonkarahisar": [
    "Başmakçı",
    "Bayat",
    "Bolvadin",
    "Çay",
    "Çobanlar",
    "Dazkırı",
    "Dinar",
    "Emirdağ",
    "Evciler",
    "Hocalar",
    "İhsaniye",
    "İscehisar",
    "Kızılören",
    "Merkez",
    "Sandıklı",
    "Sinanpaşa",
    "Sultandağı",
    "Şuhut"
  ],
  "Ağrı": [
    "Diyadin",
    "Doğubayazıt",
    "Eleşkirt",
    "Hamur",
    "Merkez",
    "Patnos",
    "Taşlıçay",
    "Tutak"
  ],
  "Amasya": [
    "Göynücek",
    "Gümüşhacıköy",
    "Hamamözü",
    "Merkez",
    "Merzifon",
    "Suluova",
    "Taşova"
  ],
  "Ankara": [
    "Akyurt",
    "Altındağ",
    "Ayaş",
    "Bala",
    "Beypazarı",
    "Çamlıdere",
    "Çankaya",
    "Çubuk",
    "Elmadağ",
    "Etimesgut",
    "Evren",
    "Gölbaşı",
    "Güdül",
    "Haymana",
    "Kahramankazan",
    "Kalecik",
    "Keçiören",
    "Kızılcahamam",
    "Mamak",
    "Nallıhan",
    "Polatlı",
    "Pursaklar",
    "Sincan",
    "Şereflikoçhisar",
    "Yenimahalle"
  ],
  "Antalya": [
    "Akseki",
    "Aksu",
    "Alanya",
    "Demre",
    "Döşemealtı",
    "Elmalı",
    "Finike",
    "Gazipaşa",
    "Gündoğmuş",
    "İbradı",
    "Kaş",
    "Kemer",
    "Kepez",
    "Konyaaltı",
    "Korkuteli",
    "Kumluca",
    "Manavgat",
    "Muratpaşa",
    "Serik"
  ],
  "Artvin": [
    "Ardanuç",
    "Arhavi",
    "Borçka",
    "Hopa",
    "Kemalpaşa",
    "Merkez",
    "Murgul",
    "Şavşat",
    "Yusufeli"
  ],
  "Aydın": [
    "Bozdoğan",
    "Buharkent",
    "Çine",
    "Didim",
    "Efeler",
    "Germencik",
    "İncirliova",
    "Karacasu",
    "Karpuzlu",
    "Koçarlı",
    "Köşk",
    "Kuşadası",
    "Kuyucak",
    "Nazilli",
    "Söke",
    "Sultanhisar",
    "Yenipazar"
  ],
  "Balıkesir": [
    "Altıeylül",
    "Ayvalık",
    "Balya",
    "Bandırma",
    "Bigadiç",
    "Burhaniye",
    "Dursunbey",
    "Edremit",
    "Erdek",
    "Gömeç",
    "Gönen",
    "Havran",
    "İvrindi",
    "Karesi",
    "Kepsut",
    "Manyas",
    "Marmara",
    "Savaştepe",
    "Sındırgı",
    "Susurluk"
  ],
  "Bilecik": [
    "Bozüyük",
    "Gölpazarı",
    "İnhisar",
    "Merkez",
    "Osmaneli",
    "Pazaryeri",
    "Söğüt",
    "Yenipazar"
  ],
  "Bingöl": [
    "Adaklı",
    "Genç",
    "Karlıova",
    "Kiğı",
    "Merkez",
    "Solhan",
    "Yayladere",
    "Yedisu"
  ],
  "Bitlis": [
    "Adilcevaz",
    "Ahlat",
    "Güroymak",
    "Hizan",
    "Merkez",
    "Mutki",
    "Tatvan"
  ],
  "Bolu": [
    "Dörtdivan",
    "Gerede",
    "Göynük",
    "Kıbrıscık",
    "Mengen",
    "Merkez",
    "Mudurnu",
    "Seben",
    "Yeniçağa"
  ],
  "Burdur": [
    "Ağlasun",
    "Altınyayla",
    "Bucak",
    "Çavdır",
    "Çeltikçi",
    "Gölhisar",
    "Karamanlı",
    "Kemer",
    "Merkez",
    "Tefenni",
    "Yeşilova"
  ],
  "Bursa": [
    "Büyükorhan",
    "Gemlik",
    "Gürsu",
    "Harmancık",
    "İnegöl",
    "İznik",
    "Karacabey",
    "Keles",
    "Kestel",
    "Mudanya",
    "Mustafakemalpaşa",
    "Nilüfer",
    "Orhaneli",
    "Orhangazi",
    "Osmangazi",
    "Yenişehir",
    "Yıldırım"
  ],
  "Çanakkale": [
    "Ayvacık",
    "Bayramiç",
    "Biga",
    "Bozcaada",
    "Çan",
    "Eceabat",
    "Ezine",
    "Gelibolu",
    "Gökçeada",
    "Lapseki",
    "Merkez",
    "Yenice"
  ],
  "Çankırı": [
    "Atkaracalar",
    "Bayramören",
    "Çerkeş",
    "Eldivan",
    "Ilgaz",
    "Kızılırmak",
    "Korgun",
    "Kurşunlu",
    "Merkez",
    "Orta",
    "Şabanözü",
    "Yapraklı"
  ],
  "Çorum": [
    "Alaca",
    "Bayat",
    "Boğazkale",
    "Dodurga",
    "İskilip",
    "Kargı",
    "Laçin",
    "Mecitözü",
    "Merkez",
    "Oğuzlar",
    "Ortaköy",
    "Osmancık",
    "Sungurlu",
    "Uğurludağ"
  ],
  "Denizli": [
    "Acıpayam",
    "Babadağ",
    "Baklan",
    "Bekilli",
    "Beyağaç",
    "Bozkurt",
    "Buldan",
    "Çal",
    "Çameli",
    "Çardak",
    "Çivril",
    "Güney",
    "Honaz",
    "Kale",
    "Merkezefendi",
    "Pamukkale",
    "Sarayköy",
    "Serinhisar",
    "Tavas"
  ],
  "Diyarbakır": [
    "Bağlar",
    "Bismil",
    "Çermik",
    "Çınar",
    "Çüngüş",
    "Dicle",
    "Eğil",
    "Ergani",
    "Hani",
    "Hazro",
    "Kayapınar",
    "Kocaköy",
    "Kulp",
    "Lice",
    "Silvan",
    "Sur",
    "Yenişehir"
  ],
  "Edirne": [
    "Enez",
    "Havsa",
    "İpsala",
    "Keşan",
    "Lalapaşa",
    "Meriç",
    "Merkez",
    "Süloğlu",
    "Uzunköprü"
  ],
  "Elazığ": [
    "Ağın",
    "Alacakaya",
    "Arıcak",
    "Baskil",
    "Karakoçan",
    "Keban",
    "Kovancılar",
    "Maden",
    "Merkez",
    "Palu",
    "Sivrice"
  ],
  "Erzincan": [
    "Çayırlı",
    "İliç",
    "Kemah",
    "Kemaliye",
    "Merkez",
    "Otlukbeli",
    "Refahiye",
    "Tercan",
    "Üzümlü"
  ],
  "Erzurum": [
    "Aşkale",
    "Aziziye",
    "Çat",
    "Hınıs",
    "Horasan",
    "İspir",
    "Karaçoban",
    "Karayazı",
    "Köprüköy",
    "Narman",
    "Oltu",
    "Olur",
    "Palandöken",
    "Pasinler",
    "Pazaryolu",
    "Şenkaya",
    "Tekman",
    "Tortum",
    "Uzundere",
    "Yakutiye"
  ],
  "Eskişehir": [
    "Alpu",
    "Beylikova",
    "Çifteler",
    "Günyüzü",
    "Han",
    "İnönü",
    "Mahmudiye",
    "Mihalgazi",
    "Mihalıççık",
    "Odunpazarı",
    "Sarıcakaya",
    "Seyitgazi",
    "Sivrihisar",
    "Tepebaşı"
  ],
  "Gaziantep": [
    "Araban",
    "İslahiye",
    "Karkamış",
    "Nizip",
    "Nurdağı",
    "Oğuzeli",
    "Şahinbey",
    "Şehitkamil",
    "Yavuzeli"
  ],
  "Giresun": [
    "Alucra",
    "Bulancak",
    "Çamoluk",
    "Çanakçı",
    "Dereli",
    "Doğankent",
    "Espiye",
    "Eynesil",
    "Görele",
    "Güce",
    "Keşap",
    "Merkez",
    "Piraziz",
    "Şebinkarahisar",
    "Tirebolu",
    "Yağlıdere"
  ],
  "Gümüşhane": [
    "Kelkit",
    "Köse",
    "Kürtün",
    "Merkez",
    "Şiran",
    "Torul"
  ],
  "Hakkari": [
    "Çukurca",
    "Derecik",
    "Merkez",
    "Şemdinli",
    "Yüksekova"
  ],
  "Hatay": [
    "Altınözü",
    "Antakya",
    "Arsuz",
    "Belen",
    "Defne",
    "Dörtyol",
    "Erzin",
    "Hassa",
    "İskenderun",
    "Kırıkhan",
    "Kumlu",
    "Payas",
    "Reyhanlı",
    "Samandağ",
    "Yayladağı"
  ],
  "Isparta": [
    "Aksu",
    "Atabey",
    "Eğirdir",
    "Gelendost",
    "Gönen",
    "Keçiborlu",
    "Merkez",
    "Senirkent",
    "Sütçüler",
    "Şarkikaraağaç",
    "Uluborlu",
    "Yalvaç",
    "Yenişarbademli"
  ],
  "Mersin": [
    "Akdeniz",
    "Anamur",
    "Aydıncık",
    "Bozyazı",
    "Çamlıyayla",
    "Erdemli",
    "Gülnar",
    "Mezitli",
    "Mut",
    "Silifke",
    "Tarsus",
    "Toroslar",
    "Yenişehir"
  ],
  "İstanbul": [
    "Adalar",
    "Arnavutköy",
    "Ataşehir",
    "Avcılar",
    "Bağcılar",
    "Bahçelievler",
    "Bakırköy",
    "Başakşehir",
    "Bayrampaşa",
    "Beşiktaş",
    "Beykoz",
    "Beylikdüzü",
    "Beyoğlu",
    "Büyükçekmece",
    "Çatalca",
    "Çekmeköy",
    "Esenler",
    "Esenyurt",
    "Eyüpsultan",
    "Fatih",
    "Gaziosmanpaşa",
    "Güngören",
    "Kadıköy",
    "Kağıthane",
    "Kartal",
    "Küçükçekmece",
    "Maltepe",
    "Pendik",
    "Sancaktepe",
    "Sarıyer",
    "Silivri",
    "Sultanbeyli",
    "Sultangazi",
    "Şile",
    "Şişli",
    "Tuzla",
    "Ümraniye",
    "Üsküdar",
    "Zeytinburnu"
  ],
  "İzmir": [
    "Aliağa",
    "Balçova",
    "Bayındır",
    "Bayraklı",
    "Bergama",
    "Beydağ",
    "Bornova",
    "Buca",
    "Çeşme",
    "Çiğli",
    "Dikili",
    "Foça",
    "Gaziemir",
    "Güzelbahçe",
    "Karabağlar",
    "Karaburun",
    "Karşıyaka",
    "Kemalpaşa",
    "Kınık",
    "Kiraz",
    "Konak",
    "Menderes",
    "Menemen",
    "Narlıdere",
    "Ödemiş",
    "Seferihisar",
    "Selçuk",
    "Tire",
    "Torbalı",
    "Urla"
  ],
  "Kars": [
    "Akyaka",
    "Arpaçay",
    "Digor",
    "Kağızman",
    "Merkez",
    "Sarıkamış",
    "Selim",
    "Susuz"
  ],
  "Kastamonu": [
    "Abana",
    "Ağlı",
    "Araç",
    "Azdavay",
    "Bozkurt",
    "Cide",
    "Çatalzeytin",
    "Daday",
    "Devrekani",
    "Doğanyurt",
    "Hanönü",
    "İhsangazi",
    "İnebolu",
    "Küre",
    "Merkez",
    "Pınarbaşı",
    "Seydiler",
    "Şenpazar",
    "Taşköprü",
    "Tosya"
  ],
  "Kayseri": [
    "Akkışla",
    "Bünyan",
    "Develi",
    "Felahiye",
    "Hacılar",
    "İncesu",
    "Kocasinan",
    "Melikgazi",
    "Özvatan",
    "Pınarbaşı",
    "Sarıoğlan",
    "Sarız",
    "Talas",
    "Tomarza",
    "Yahyalı",
    "Yeşilhisar"
  ],
  "Kırklareli": [
    "Babaeski",
    "Demirköy",
    "Kofçaz",
    "Lüleburgaz",
    "Merkez",
    "Pehlivanköy",
    "Pınarhisar",
    "Vize"
  ],
  "Kırşehir": [
    "Akçakent",
    "Akpınar",
    "Boztepe",
    "Çiçekdağı",
    "Kaman",
    "Merkez",
    "Mucur"
  ],
  "Kocaeli": [
    "Başiskele",
    "Çayırova",
    "Darıca",
    "Derince",
    "Dilovası",
    "Gebze",
    "Gölcük",
    "İzmit",
    "Kandıra",
    "Karamürsel",
    "Kartepe",
    "Körfez"
  ],
  "Konya": [
    "Ahırlı",
    "Akören",
    "Akşehir",
    "Altınekin",
    "Beyşehir",
    "Bozkır",
    "Cihanbeyli",
    "Çeltik",
    "Çumra",
    "Derbent",
    "Derebucak",
    "Doğanhisar",
    "Emirgazi",
    "Ereğli",
    "Güneysınır",
    "Hadim",
    "Halkapınar",
    "Hüyük",
    "Ilgın",
    "Kadınhanı",
    "Karapınar",
    "Karatay",
    "Kulu",
    "Meram",
    "Sarayönü",
    "Selçuklu",
    "Seydişehir",
    "Taşkent",
    "Tuzlukçu",
    "Yalıhüyük",
    "Yunak"
  ],
  "Kütahya": [
    "Altıntaş",
    "Aslanapa",
    "Çavdarhisar",
    "Domaniç",
    "Dumlupınar",
    "Emet",
    "Gediz",
    "Hisarcık",
    "Merkez",
    "Pazarlar",
    "Simav",
    "Şaphane",
    "Tavşanlı"
  ],
  "Malatya": [
    "Akçadağ",
    "Arapgir",
    "Arguvan",
    "Battalgazi",
    "Darende",
    "Doğanşehir",
    "Doğanyol",
    "Hekimhan",
    "Kale",
    "Kuluncak",
    "Pütürge",
    "Yazıhan",
    "Yeşilyurt"
  ],
  "Manisa": [
    "Ahmetli",
    "Akhisar",
    "Alaşehir",
    "Demirci",
    "Gölmarmara",
    "Gördes",
    "Kırkağaç",
    "Köprübaşı",
    "Kula",
    "Salihli",
    "Sarıgöl",
    "Saruhanlı",
    "Selendi",
    "Soma",
    "Şehzadeler",
    "Turgutlu",
    "Yunusemre"
  ],
  "Kahramanmaraş": [
    "Afşin",
    "Andırın",
    "Çağlayancerit",
    "Dulkadiroğlu",
    "Ekinözü",
    "Elbistan",
    "Göksun",
    "Nurhak",
    "Onikişubat",
    "Pazarcık",
    "Türkoğlu"
  ],
  "Mardin": [
    "Artuklu",
    "Dargeçit",
    "Derik",
    "Kızıltepe",
    "Mazıdağı",
    "Midyat",
    "Nusaybin",
    "Ömerli",
    "Savur",
    "Yeşilli"
  ],
  "Muğla": [
    "Bodrum",
    "Dalaman",
    "Datça",
    "Fethiye",
    "Kavaklıdere",
    "Köyceğiz",
    "Marmaris",
    "Menteşe",
    "Milas",
    "Ortaca",
    "Seydikemer",
    "Ula",
    "Yatağan"
  ],
  "Muş": [
    "Bulanık",
    "Hasköy",
    "Korkut",
    "Malazgirt",
    "Merkez",
    "Varto"
  ],
  "Nevşehir": [
    "Acıgöl",
    "Avanos",
    "Derinkuyu",
    "Gülşehir",
    "Hacıbektaş",
    "Kozaklı",
    "Merkez",
    "Ürgüp"
  ],
  "Niğde": [
    "Altunhisar",
    "Bor",
    "Çamardı",
    "Çiftlik",
    "Merkez",
    "Ulukışla"
  ],
  "Ordu": [
    "Akkuş",
    "Altınordu",
    "Aybastı",
    "Çamaş",
    "Çatalpınar",
    "Çaybaşı",
    "Fatsa",
    "Gölköy",
    "Gülyalı",
    "Gürgentepe",
    "İkizce",
    "Kabadüz",
    "Kabataş",
    "Korgan",
    "Kumru",
    "Mesudiye",
    "Perşembe",
    "Ulubey",
    "Ünye"
  ],
  "Rize": [
    "Ardeşen",
    "Çamlıhemşin",
    "Çayeli",
    "Derepazarı",
    "Fındıklı",
    "Güneysu",
    "Hemşin",
    "İkizdere",
    "İyidere",
    "Kalkandere",
    "Merkez",
    "Pazar"
  ],
  "Sakarya": [
    "Adapazarı",
    "Akyazı",
    "Arifiye",
    "Erenler",
    "Ferizli",
    "Geyve",
    "Hendek",
    "Karapürçek",
    "Karasu",
    "Kaynarca",
    "Kocaali",
    "Pamukova",
    "Sapanca",
    "Serdivan",
    "Söğütlü",
    "Taraklı"
  ],
  "Samsun": [
    "19 Mayıs",
    "Alaçam",
    "Asarcık",
    "Atakum",
    "Ayvacık",
    "Bafra",
    "Canik",
    "Çarşamba",
    "Havza",
    "İlkadım",
    "Kavak",
    "Ladik",
    "Salıpazarı",
    "Tekkeköy",
    "Terme",
    "Vezirköprü",
    "Yakakent"
  ],
  "Siirt": [
    "Baykan",
    "Eruh",
    "Kurtalan",
    "Merkez",
    "Pervari",
    "Şirvan",
    "Tillo"
  ],
  "Sinop": [
    "Ayancık",
    "Boyabat",
    "Dikmen",
    "Durağan",
    "Erfelek",
    "Gerze",
    "Merkez",
    "Saraydüzü",
    "Türkeli"
  ],
  "Sivas": [
    "Akıncılar",
    "Altınyayla",
    "Divriği",
    "Doğanşar",
    "Gemerek",
    "Gölova",
    "Gürün",
    "Hafik",
    "İmranlı",
    "Kangal",
    "Koyulhisar",
    "Merkez",
    "Suşehri",
    "Şarkışla",
    "Ulaş",
    "Yıldızeli",
    "Zara"
  ],
  "Tekirdağ": [
    "Çerkezköy",
    "Çorlu",
    "Ergene",
    "Hayrabolu",
    "Kapaklı",
    "Malkara",
    "Marmaraereğlisi",
    "Muratlı",
    "Saray",
    "Süleymanpaşa",
    "Şarköy"
  ],
  "Tokat": [
    "Almus",
    "Artova",
    "Başçiftlik",
    "Erbaa",
    "Merkez",
    "Niksar",
    "Pazar",
    "Reşadiye",
    "Sulusaray",
    "Turhal",
    "Yeşilyurt",
    "Zile"
  ],
  "Trabzon": [
    "Akçaabat",
    "Araklı",
    "Arsin",
    "Beşikdüzü",
    "Çarşıbaşı",
    "Çaykara",
    "Dernekpazarı",
    "Düzköy",
    "Hayrat",
    "Köprübaşı",
    "Maçka",
    "Of",
    "Ortahisar",
    "Sürmene",
    "Şalpazarı",
    "Tonya",
    "Vakfıkebir",
    "Yomra"
  ],
  "Tunceli": [
    "Çemişgezek",
    "Hozat",
    "Mazgirt",
    "Merkez",
    "Nazımiye",
    "Ovacık",
    "Pertek",
    "Pülümür"
  ],
  "Şanlıurfa": [
    "Akçakale",
    "Birecik",
    "Bozova",
    "Ceylanpınar",
    "Eyyübiye",
    "Halfeti",
    "Haliliye",
    "Harran",
    "Hilvan",
    "Karaköprü",
    "Siverek",
    "Suruç",
    "Viranşehir"
  ],
  "Uşak": [
    "Banaz",
    "Eşme",
    "Karahallı",
    "Merkez",
    "Sivaslı",
    "Ulubey"
  ],
  "Van": [
    "Bahçesaray",
    "Başkale",
    "Çaldıran",
    "Çatak",
    "Edremit",
    "Erciş",
    "Gevaş",
    "Gürpınar",
    "İpekyolu",
    "Muradiye",
    "Özalp",
    "Saray",
    "Tuşba"
  ],
  "Yozgat": [
    "Akdağmadeni",
    "Aydıncık",
    "Boğazlıyan",
    "Çandır",
    "Çayıralan",
    "Çekerek",
    "Kadışehri",
    "Merkez",
    "Saraykent",
    "Sarıkaya",
    "Sorgun",
    "Şefaatli",
    "Yenifakılı",
    "Yerköy"
  ],
  "Zonguldak": [
    "Alaplı",
    "Çaycuma",
    "Devrek",
    "Ereğli",
    "Gökçebey",
    "Kilimli",
    "Kozlu",
    "Merkez"
  ],
  "Aksaray": [
    "Ağaçören",
    "Eskil",
    "Gülağaç",
    "Güzelyurt",
    "Merkez",
    "Ortaköy",
    "Sarıyahşi",
    "Sultanhanı"
  ],
  "Bayburt": [
    "Aydıntepe",
    "Demirözü",
    "Merkez"
  ],
  "Karaman": [
    "Ayrancı",
    "Başyayla",
    "Ermenek",
    "Kazımkarabekir",
    "Merkez",
    "Sarıveliler"
  ],
  "Kırıkkale": [
    "Bahşılı",
    "Balışeyh",
    "Çelebi",
    "Delice",
    "Karakeçili",
    "Keskin",
    "Merkez",
    "Sulakyurt",
    "Yahşihan"
  ],
  "Batman": [
    "Beşiri",
    "Gercüş",
    "Hasankeyf",
    "Kozluk",
    "Merkez",
    "Sason"
  ],
  "Şırnak": [
    "Beytüşşebap",
    "Cizre",
    "Güçlükonak",
    "İdil",
    "Merkez",
    "Silopi",
    "Uludere"
  ],
  "Bartın": [
    "Amasra",
    "Kurucaşile",
    "Merkez",
    "Ulus"
  ],
  "Ardahan": [
    "Çıldır",
    "Damal",
    "Göle",
    "Hanak",
    "Merkez",
    "Posof"
  ],
  "Iğdır": [
    "Aralık",
    "Karakoyunlu",
    "Merkez",
    "Tuzluca"
  ],
  "Yalova": [
    "Altınova",
    "Armutlu",
    "Çınarcık",
    "Çiftlikköy",
    "Merkez",
    "Termal"
  ],
  "Karabük": [
    "Eflani",
    "Eskipazar",
    "Merkez",
    "Ovacık",
    "Safranbolu",
    "Yenice"
  ],
  "Kilis": [
    "Elbeyli",
    "Merkez",
    "Musabeyli",
    "Polateli"
  ],
  "Osmaniye": [
    "Bahçe",
    "Düziçi",
    "Hasanbeyli",
    "Kadirli",
    "Merkez",
    "Sumbas",
    "Toprakkale"
  ],
  "Düzce": [
    "Akçakoca",
    "Cumayeri",
    "Çilimli",
    "Gölyaka",
    "Gümüşova",
    "Kaynaşlı",
    "Merkez",
    "Yığılca"
  ]
};

export const turkeyNeighborhoods = {
  "Adana": {
    "Aladağ": [
      "Akpınar Mah",
      "Başpınar Mah",
      "Mansurlu Mah",
      "Sinanpaşa Mah",
      "Akören Mah",
      "Boztahta Mah",
      "Büyüksofulu Mah",
      "Ceritler Mah",
      "Dailer Mah",
      "Darılık Mah",
      "Dölekli Mah",
      "Ebrişim Mah",
      "Eğner Mah",
      "Gerdibi Mah",
      "Gireğiyeniköy Mah",
      "Gökçeköy Mah",
      "Kabasakal Mah",
      "Karahan Mah",
      "Kıcak Mah",
      "Kışlak Mah",
      "Kızıldam Mah",
      "Kökez Mah",
      "Köprücük Mah",
      "Küp Mah",
      "Madenli Mah",
      "Mazılık Mah",
      "Posyağbasan Mah",
      "Topallı Mah",
      "Uzunkuyu Mah",
      "Yetimli Mah",
      "Yüksekören Mah"
    ],
    "Ceyhan": [
      "Adapınar Mah",
      "Adatepe Mah",
      "Ağaçlı Mah",
      "Ağaçpınar Mah",
      "Akdam Mah",
      "Altıgözbekirli Mah",
      "Altıkara Mah",
      "Aydınlar Mah",
      "Azizli Mah",
      "Başören Mah",
      "Birkent Mah",
      "Burhanlı Mah",
      "Büyükburhaniye Mah",
      "Büyükmangıt Mah",
      "Camuzağılı Mah",
      "Ceyhanbekirli Mah",
      "Çakaldere Mah",
      "Çataklı Mah",
      "Çatalhüyük Mah",
      "Çevretepe Mah",
      "Çiçekli Mah",
      "Çiftlikler Mah",
      "Çokçapınar Mah",
      "Dağıstan Mah",
      "Değirmendere Mah",
      "Değirmenli Mah",
      "Dikilitaş Mah",
      "Dokuztekne Mah",
      "Doruk Mah",
      "Durhasandede Mah",
      "Dutlupınar Mah",
      "Ekinyazı Mah",
      "Elmagölü Mah",
      "Erenler Mah",
      "Gümürdülü Mah",
      "Gündoğan Mah",
      "Günlüce Mah",
      "Hamdilli Mah",
      "Hamidiye Mah",
      "Hamitbey Mah",
      "Hamitbeybucağı Mah",
      "Irmaklı Mah",
      "Isırganlı Mah",
      "İmran Mah",
      "İnceyer Mah",
      "İsalı Mah",
      "Karakayalı Mah",
      "Kılıçkaya Mah",
      "Kıvrıklı Mah",
      "Kızıldere Mah",
      "Köprülü Mah",
      "Körkuyu Mah",
      "Kösreli Mah",
      "Kurtkulağı Mah",
      "Kurtpınar Mah",
      "Kuzucak Mah",
      "Küçükburhaniye Mah",
      "Küçükmangıt Mah",
      "Mercimek Mah",
      "Mercin Mah",
      "Narlık Mah",
      "Nazımbey Yeniköy Mah",
      "Sağırlar Mah",
      "Sağkaya Mah",
      "Sarıbahçe Mah",
      "Sarımazı Mah",
      "Sarımazı Sb Mah",
      "Selimiye Mah",
      "Sirkeli Mah",
      "Soğukpınar Mah",
      "Soysallı Mah",
      "Tatarlı Mah",
      "Tatlıkuyu Mah",
      "Toktamış Mah",
      "Tumlu Mah",
      "Üçdutyeşilova Mah",
      "Veysiye Mah",
      "Yalak Mah",
      "Yellibel Mah",
      "Yeşilbahçe Mah",
      "Yeşildam Mah",
      "Yılankale Mah",
      "Altıocak Mah",
      "Atatürk Mah",
      "Aydemiroğlu Mah",
      "Belediye Evleri Mah",
      "Bota Mah",
      "Burhaniye Mah",
      "Büyükkırım Mah",
      "Civantayak Mah",
      "Cumhuriyet Mah",
      "Emek Mah",
      "Esentepe Mah",
      "Fatih Sultan Mehmet Mah",
      "Gazi Osman Paşa Mah",
      "Hürriyet Mah",
      "İnönü Mah",
      "İstiklal Mah",
      "Kelemeti Mah",
      "Konakoğlu Mah",
      "Koruklu Mah",
      "Küçükkırım Mah",
      "Mithat Paşa Mah",
      "Modernevler Mah",
      "Muradiye Mah",
      "Namık Kemal Mah",
      "Sarısakal Mah",
      "Şahin Özbilen Mah",
      "Şehit Hacı İbrahim Mah",
      "Ulus Mah",
      "Yarsuat Mah",
      "Zübeyde Hanım Mah",
      "Mustafabeyli Mah"
    ],
    "Çukurova": [
      "Belediye Evleri Mah",
      "Huzurevleri Mah",
      "Yüzüncüyıl Mah",
      "Beyazevler Mah",
      "Bozcalar Mah",
      "Dörtler Mah",
      "Esentepe Mah",
      "Fadıl Mah",
      "Gökkuyu Mah",
      "Güzelyalı Mah",
      "Kabasakal Mah",
      "Karahan Mah",
      "Karslılar Mah",
      "Kaşoba Mah",
      "Kocatepe Mah",
      "Kurttepe Mah",
      "Küçükçınar Mah",
      "Mahfesığmaz Mah",
      "Memişli Mah",
      "Örcün Mah",
      "Pirili Mah",
      "Söğütlü Mah",
      "Şambayadı Mah",
      "Toros Mah",
      "Yeni Mah",
      "Yurt Mah",
      "Salbaş Esentepe Mah"
    ],
    "Feke": [
      "Akkaya Mah",
      "Akoluk Mah",
      "Bağdatlı Mah",
      "Bahçecik Mah",
      "Çandırlar Mah",
      "Çondu Mah",
      "Çürükler Mah",
      "Değirmenciuşağı Mah",
      "Gaffaruşağı Mah",
      "Gedikli Mah",
      "Göbelli Mah",
      "Gürümze Mah",
      "Güzpınarı Mah",
      "Hıdıruşağı Mah",
      "İncirci Mah",
      "Kaleyüzü Mah",
      "Kaşaltı Mah",
      "Kayadibi Mah",
      "Kırıkuşağı Mah",
      "Kısacıklı Mah",
      "Kızılyer Mah",
      "Koçyazı Mah",
      "Konakkuran Mah",
      "Kovukçınar Mah",
      "Mansurlu Mah",
      "Musalar Mah",
      "Olucak Mah",
      "Ormancık Mah",
      "Ortaköy Mah",
      "Oruçlu Mah",
      "Paşalı Mah",
      "Süphandere Mah",
      "Şahmuratlı Mah",
      "Tenkerli Mah",
      "Tokmanaklı Mah",
      "Tortulu Mah",
      "Uğurlubağ Mah",
      "Yaylapınar Mah",
      "Yerebakan Mah",
      "Belenköy Mah",
      "Gökçeli Mah",
      "İslam Mah",
      "Karacaoğlan Mah",
      "Karacauşağı Mah",
      "Kazancı Mah",
      "Keklikçi Mah",
      "Sülemişli Mah",
      "Yeşil Düşmüş Mah"
    ],
    "İmamoğlu": [
      "Adalet Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "Menteş Mah",
      "Tuna Mah",
      "Ağzıkaraca Mah",
      "Alaybeyi Mah",
      "Aliler Mah",
      "Ayvalı Mah",
      "Camili Mah",
      "Çörten Mah",
      "Danacılı Mah",
      "Hacıhasanlı Mah",
      "Koyunevi Mah",
      "Malıhıdırlı Mah",
      "Otluk Mah",
      "Pekmezci Mah",
      "Sayca Mah",
      "Saygeçit Mah",
      "Sevinçli Mah",
      "Sokutaş Mah",
      "Ufacıkören Mah",
      "Uluçınar Mah",
      "Üçtepe Mah",
      "Yazıtepe Mah",
      "Yenievler Mah"
    ],
    "Karaisalı": [
      "Akçalı Mah",
      "Aktaş Mah",
      "Altınova Mah",
      "Aşağıbelemedik Mah",
      "Aşağıyörükler Mah",
      "Ayakkıf Mah",
      "Barakdağı Mah",
      "Başkıf Mah",
      "Bekirli Mah",
      "Beydemir Mah",
      "Bolacalı Mah",
      "Bucak Mah",
      "Çakallı Mah",
      "Çatalan Mah",
      "Çeceli Mah",
      "Çevlik Mah",
      "Çocuklar Mah",
      "Çorlu Mah",
      "Çukur Mah",
      "Demirçit Mah",
      "Döşekevi Mah",
      "Durak Mah",
      "Eğlence Mah",
      "Emelcik Mah",
      "Etekli Mah",
      "Fettahlı Mah",
      "Filikli Mah",
      "Gildirli Mah",
      "Gökhasanlı Mah",
      "Gülüşlü Mah",
      "Güvenç Mah",
      "Hacılı Mah",
      "Hacımusalı Mah",
      "Kaledağı Mah",
      "Kapıkaya Mah",
      "Karahasanlı Mah",
      "Karakılıç Mah",
      "Karakuyu Mah",
      "Karapınar Mah",
      "Kıralan Mah",
      "Kırıklı Mah",
      "Kocaveliler Mah",
      "Körüklü Mah",
      "Kuşcusofulu Mah",
      "Kuyucu Mah",
      "Kuzgun Mah",
      "Maraşlı Mah",
      "Merkezboztahta Mah",
      "Murtçukuru Mah",
      "Nergizlik Mah",
      "Nuhlu Mah",
      "Ömerli Mah",
      "Sadıkali Mah",
      "Sarımehmetli Mah",
      "Saypınar Mah",
      "Selampınar Mah",
      "Tatık Mah",
      "Topaktaş Mah",
      "Topkaralı Mah",
      "Torunsolaklı Mah",
      "Tümenli Mah",
      "Yazıbaşı Mah"
    ],
    "Karataş": [
      "Adalı Mah",
      "Ataköy Mah",
      "Bahçe Mah",
      "Bebeli Mah",
      "Çağşırlı Mah",
      "Çakırören Mah",
      "Çavuşlu Mah",
      "Çimeli Mah",
      "Çukurkamış Mah",
      "Damlapınar Mah",
      "Develiören Mah",
      "Dolaplı Mah",
      "Gölkaya Mah",
      "Hacıhasan Mah",
      "Hasırağacı Mah",
      "Helvacı Mah",
      "İnneplihüyüğü Mah",
      "İsahacılı Mah",
      "Kapı Mah",
      "Karagöçer Mah",
      "Karataş Mah",
      "Karşıyaka Mah",
      "Kemaliye Mah",
      "Kesik Mah",
      "Kırhasan Mah",
      "Kızıltahta Mah",
      "Kiremitli Mah",
      "Meletmez Mah",
      "Orta Mah",
      "Oymaklı Mah",
      "Sarımsak Mah",
      "Sirkenli Mah",
      "Tabaklar Mah",
      "Tabur Mah",
      "Terliksiz Mah",
      "Topraklı Mah",
      "Tuzkuyusu Mah",
      "Tuzla Mah",
      "Yassıveren Mah",
      "Yemişli Mah",
      "Yeni Mah",
      "Yenimurat Mah",
      "Yüzbaşı Mah"
    ],
    "Kozan": [
      "Gazi Mah",
      "Hacıbeyli Mah",
      "Acarmantaş Mah",
      "Akarca Mah",
      "Akçalıuşağı Mah",
      "Akdam Mah",
      "Akkaya Mah",
      "Alapınar Mah",
      "Andıl Mah",
      "Arslanlı Mah",
      "Aydın Mah",
      "Ayşehoca Mah",
      "Bağözü Mah",
      "Bağtepe Mah",
      "Boztahta Mah",
      "Bucak Mah",
      "Bulduklu Mah",
      "Çamdere Mah",
      "Çamlarca Mah",
      "Çandık Mah",
      "Çelenuşağı Mah",
      "Çobanpınarı Mah",
      "Çokak Mah",
      "Çukurören Mah",
      "Çulluuşağı Mah",
      "Çürüklü Mah",
      "Damyeri Mah",
      "Dikilitaş Mah",
      "Dilekkaya Mah",
      "Doğanalanı Mah",
      "Duraluşağı Mah",
      "Durmuşlu Mah",
      "Düzağaç Mah",
      "Enizçakırı Mah",
      "Ergenuşağı Mah",
      "Eskikabasakal Mah",
      "Eskimantaş Mah",
      "Faydalı Mah",
      "Ferhatlı Mah",
      "Gedikli Mah",
      "Gökçeyol Mah",
      "Gökgöz Mah",
      "Görbeyaz Mah",
      "Güneri Mah",
      "Hacımirzalı Mah",
      "Hamam Mah",
      "Ilıca Mah",
      "Işıkkaya Mah",
      "Işıklı Mah",
      "İdemköy Mah",
      "Kabaktepe Mah",
      "Kahveli Mah",
      "Kalkumaç Mah",
      "Kapıkaya Mah",
      "Karabucak Mah",
      "Karacaören Mah",
      "Karahamzalı Mah",
      "Karanebili Mah",
      "Kemerköy Mah",
      "Kıbrıslar Mah",
      "Kızıllar Mah",
      "Kızlarsekisi Mah",
      "Köseli Mah",
      "Kuytucak Mah",
      "Kuyubeli Mah",
      "Kuyuluk Mah",
      "Mahyalar Mah",
      "Marankeçili Mah",
      "Minnetli Mah",
      "Orçan Mah",
      "Oruçlu Mah",
      "Örendere Mah",
      "Özbaşı Mah",
      "Pekmezci Mah",
      "Postkabasakal Mah",
      "Salmanlı Mah",
      "Şerifli Mah",
      "Tepecikören Mah",
      "Tufanlı Mah",
      "Turgutlu Mah",
      "Turunçlu Mah",
      "Velicanlı Mah",
      "Yanalerik Mah",
      "Yassıçalı Mah",
      "Yeniköy Mah",
      "Yukarıkeçili Mah",
      "Yüksekören Mah",
      "Zerdali Mah",
      "Ağlıboğaz Mah",
      "Arslanpaşa Mah",
      "Bağlar Mah",
      "Cumhuriyet Mah",
      "Çanaklı Mah",
      "Hacıuşağı Mah",
      "Karacaoğlan Mah",
      "Mahmutlu Mah",
      "Şevkiye Mah",
      "Taş Mah",
      "Tavşantepe Mah",
      "Tufanpaşa Mah",
      "Türkeli Mah",
      "Varsaklar Mah",
      "Yarımoğlu Mah"
    ],
    "Pozantı": [
      "Akçatekir Mah",
      "Alpu Mah",
      "Aşçıbekirli Mah",
      "Belemedik Mah",
      "Çamlıbel Mah",
      "Dağdibi Mah",
      "Eskikonacık Mah",
      "Fındıklı Mah",
      "Gökbez Mah",
      "Hamidiye Mah",
      "Kamışlı Mah",
      "Karakışlakçı Mah",
      "Ömerli Mah",
      "Yağlıtaş Mah",
      "Yazıcak Mah",
      "Yenikonacık Mah",
      "Yukarıbelemedik Mah",
      "Cumhuriyet Mah",
      "İstiklal Mah",
      "Kurtuluş Mah",
      "Zafer Mah"
    ],
    "Saimbeyli": [
      "Aksaağaç Mah",
      "Avcıpınarı Mah",
      "Ayvacık Mah",
      "Beypınarı Mah",
      "Cumhurlu Mah",
      "Çatak Mah",
      "Çeralan Mah",
      "Çorak Mah",
      "Değirmenciuşağı Mah",
      "Eyüplü Mah",
      "Fatih Mah",
      "Gökmenler Mah",
      "Gürleşen Mah",
      "Halilbeyli Mah",
      "Himmetli Mah",
      "İslam Mah",
      "Kandilli Mah",
      "Kapaklıkuyu Mah",
      "Karakuyu Mah",
      "Kızılağaç Mah",
      "Mahmutlu Mah",
      "Naltaş Mah",
      "Narlıdere Mah",
      "Topallar Mah",
      "Tülü Mah",
      "Yardibi Mah",
      "Yeniköy Mah",
      "Yeşilbağlar Mah"
    ],
    "Sarıçam": [
      "Acıdereosb Mah",
      "Beyceli Mah",
      "Buruk Cumhuriyet Mah",
      "İstiklal Mah",
      "Sofudede Mah",
      "Hürriyet Mah",
      "Kemalpaşa Mah",
      "Yeni Mah",
      "Acıdere Mah",
      "Aflak Mah",
      "Akkuyu Mah",
      "Avcılar Mah",
      "Aydınyurdu Mah",
      "Ayvalı Mah",
      "Bayram Hacılı Mah",
      "Boynuyoğun Mah",
      "Boztepe Mah",
      "Büyük Baklalı Mah",
      "Cerenli Mah",
      "Cihadiye Mah",
      "Çamlıca Mah",
      "Çarkıpare Mah",
      "Çaylı Mah",
      "Çınarlı Mah",
      "Çiçekli Mah",
      "Çirişgediği Mah",
      "Dağcı Mah",
      "Dutluca Mah",
      "Eğeciuşağı Mah",
      "Ertuğrulgazi Mah",
      "Gökbuket Mah",
      "Göztepe Mah",
      "Hakkıbeyli Mah",
      "Hasanbeyli Mah",
      "Hocallı Mah",
      "Karaömerli Mah",
      "Karayusuflu Mah",
      "Kargakekeç Mah",
      "Karlık Mah",
      "Kaşobası Mah",
      "Kepeztepe Mah",
      "Kılbaş Mah",
      "Kılıçlı Mah",
      "Kızılkaş Mah",
      "Kösefakılı Mah",
      "Küçükbaklalı Mah",
      "Maltepe Mah",
      "Menekşe Mah",
      "Mustafalar Mah",
      "Müminli Mah",
      "Osmangazi Mah",
      "Sarıçam Mah",
      "Suluca Mah",
      "Turunçlu Mah",
      "Ünlüce Mah",
      "Yağızlar Mah",
      "Yarımca Mah",
      "Yeniyayla Mah",
      "Yürekli Mah",
      "Balcalı Mah",
      "Esentepe Mah",
      "Gültepe Mah",
      "Mehmet Akif Ersoy Mah",
      "Orhangazi Mah",
      "Remzi Oğuz Arık Mah",
      "Şahintepe Mah",
      "Yavuz Sultan Selim Mah",
      "Yeşiltepe Mah",
      "Yıldırım Beyazıt Mah"
    ],
    "Seyhan": [
      "Akkapı Mah",
      "Dağlıoğlu Mah",
      "Ahmet Remzi Yüreğir Mah",
      "Denizli Mah",
      "Kurtuluş Mah",
      "Mithatpaşa Mah",
      "Sakarya Mah",
      "Emek Mah",
      "Ova Mah",
      "Şakirpaşa Mah",
      "Uçak Mah",
      "Aydınlar Mah",
      "Barış Mah",
      "Fevzipaşa Mah",
      "Cemalpaşa Mah",
      "Reşatbey Mah",
      "Gülbahçesi Mah",
      "2000 Evler Mah",
      "Bahçeşehir Mah",
      "Gürselpaşa Mah",
      "Yeni Mah",
      "Hadırlı Mah",
      "Alidede Mah",
      "Beşocak Mah",
      "Mestanzade Mah",
      "Sarıyakup Mah",
      "Şehitduran Mah",
      "Türkocağı Mah",
      "Yenibey Mah",
      "Bahçelievler Mah",
      "Büyükçıldırım Mah",
      "Büyükdikili Mah",
      "Camuzcu Mah",
      "Çaputçu Mah",
      "Dervişler Mah",
      "Dörtağaç Mah",
      "Gökçeler Mah",
      "Gölbaşı Mah",
      "Karakuyu Mah",
      "Karayusuflu Mah",
      "Kayışlı Mah",
      "Koyuncu Mah",
      "Köylüoğlu Mah",
      "Kuyumcular Mah",
      "Küçükçıldırım Mah",
      "Mürseloğlu Mah",
      "Salmanbeyli Mah",
      "Sarıhuğlar Mah",
      "Serinevler Mah",
      "Yalmanlı Mah",
      "Yenidam Mah",
      "Yolgeçen Mah",
      "Zeytinli Mah",
      "Çınarlı Mah",
      "Döşeme Mah",
      "Hanedan Mah",
      "Hurmalı Mah",
      "İstiklal Mah",
      "Kocavezir Mah",
      "Kuruköprü Mah",
      "Kavaklı Mah",
      "Koza Mah",
      "Küçükdikili Mah",
      "Mekan Mah",
      "Fatih Mah",
      "Pınar Mah",
      "Tellidere Mah",
      "Dumlupınar Mah",
      "Gülpınar Mah",
      "Meydan Mah",
      "Mirzaçelebi Mah",
      "Yeşilyuva Mah",
      "Barbaros Mah",
      "Bey Mah",
      "Havuzlubahçe Mah",
      "Hürriyet Mah",
      "Mıdık Mah",
      "Sucuzade Mah",
      "Onur Mah",
      "Yeşiloba Mah",
      "Karasoku Mah",
      "Kayalıbağ Mah",
      "Tepebağ Mah",
      "Ulucamii Mah",
      "Demetevler Mah",
      "İsmetpaşa Mah",
      "Narlıca Mah",
      "Yeşilevler Mah",
      "Sarıhamzalı Mah",
      "Söğütlü Mah",
      "Yenibaraj Mah",
      "Yeşilyurt Mah",
      "Gazipaşa Mah",
      "Namık Kemal Mah",
      "Sümer Mah",
      "Ziyapaşa Mah"
    ],
    "Tufanbeyli": [
      "Akçal Mah",
      "Akpınar Mah",
      "Ayvat Mah",
      "Bolatpınarı Mah",
      "Bozgüney Mah",
      "Çatalçam Mah",
      "Çukurkışla Mah",
      "Damlalı Mah",
      "Demiroluk Mah",
      "Doğanbeyli Mah",
      "Doğanlı Mah",
      "Elemanlı Mah",
      "Evci Mah",
      "Fatmakuyu Mah",
      "Güzelim Mah",
      "Hanyeri Mah",
      "İğdebel Mah",
      "Karsavran Mah",
      "Kayapınar Mah",
      "Kayarcık Mah",
      "Kirazlıyurt Mah",
      "Koccağız Mah",
      "Ortaköy Mah",
      "Pekmezli Mah",
      "Pınarlar Mah",
      "Şar Mah",
      "Taşpınar Mah",
      "Tozlu Mah",
      "Yamanlı Mah",
      "Yeşilova Mah",
      "Cumhuriyet Mah",
      "İstiklal Mah",
      "Yenicami Mah"
    ],
    "Yumurtalık": [
      "Asmalı Mah",
      "Ayvalık Mah",
      "Demirtaş Mah",
      "Deveciuşağı Mah",
      "Gölovası Mah",
      "Hamzalı Mah",
      "Haylazlı Mah",
      "Kaldırım Mah",
      "Kalemli Mah",
      "Kesmeburun Mah",
      "Kırmızıdam Mah",
      "Kuzupınarı Mah",
      "Narlıören Mah",
      "Sugözü Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yumurtalık Mah",
      "Zeytinbeli Mah",
      "Akdeniz Mah",
      "Akyuva Mah",
      "Ayas Mah",
      "Devrişiye Mah",
      "Kemalpaşa Mah",
      "Ören Mah"
    ],
    "Yüreğir": [
      "Yakapınar Mah",
      "Abdioğlu Cumhuriyet Mah",
      "Ağzıbüyük Mah",
      "Akarcalı Mah",
      "Akdam Mah",
      "Akpınar Mah",
      "Alihocalı Mah",
      "Aydıncık Mah",
      "Belören Mah",
      "Beyköy Mah",
      "Büyükkapılı Mah",
      "Camili Mah",
      "Cırık Mah",
      "Cine Mah",
      "Çağırkanlı Mah",
      "Çatalpınar Mah",
      "Çelemli Mah",
      "Çotlu Mah",
      "Danışment Mah",
      "Dedepınarı Mah",
      "Denizkuyusu Mah",
      "Düzce Mah",
      "Eğriağaç Mah",
      "Esenler Mah",
      "Geçitli Cumhuriyet Mah",
      "Gökçeli Mah",
      "Gümüşyazı Mah",
      "Güveloğlu Mah",
      "Hacıali Mah",
      "Havraniye Mah",
      "Herekli Mah",
      "Irmakbaşı Mah",
      "Kadıköy Mah",
      "Kamışlı Mah",
      "Karaahmetli Mah",
      "Kaşlıca Mah",
      "Kayarlı Mah",
      "Köklüce Mah",
      "Köprügözü Mah",
      "Kütüklü Mah",
      "Özler Mah",
      "Paşaköy Mah",
      "Pekmezli Mah",
      "Sağdıçlı Mah",
      "Sakızlı Mah",
      "Sazak Mah",
      "Şahinağa Mah",
      "Şeyhmurat Mah",
      "Taşçı Mah",
      "Vayvaylı Mah",
      "Yahşiler Mah",
      "Yalnızca Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yerdelen Mah",
      "Yukarıçiçekli Mah",
      "Yunusoğlu Cumhuriyet Mah",
      "Yunusoğlu Hürriyet Mah",
      "Zağarlı Mah",
      "19 Mayıs Mah",
      "Anadolu Mah",
      "Bahçelievler Mah",
      "Başak Mah",
      "Dede Korkut Mah",
      "Güzelevler Mah",
      "Koza Mah",
      "Levent Mah",
      "Yeşil Bağlar Mah",
      "Yunus Emre Mah",
      "Doğankent Bahçelievler Mah",
      "Doğankent Cumhuriyet Mah",
      "Doğankent Kışla Mah",
      "Gazipaşa Mah",
      "Atatürk Mah",
      "Havutlu Mah",
      "Solaklı Cumhuriyet Mah",
      "Solaklı Hürriyet Mah",
      "Güzel Cumhuriyet Mah",
      "Atakent Mah",
      "Çamlıbel Mah",
      "Dervişler Mah",
      "Kiremithane Mah",
      "Mutlu Mah",
      "Şehit Erkut Akbay Mah",
      "Tahsilli Mah",
      "Ulubatlı Hasan Mah",
      "Cumhuriyet Mah",
      "Güneşli Mah",
      "Kazım Karabekir Mah",
      "Kışla Mah",
      "Köprülü Mah",
      "Yenidoğan Mah",
      "Dadaloğlu Mah",
      "Karacaoğlan Mah",
      "P.t.t Mah",
      "Selahattin Eyyubi Mah",
      "Serinevler Mah",
      "Eski Misis Mah",
      "Akdeniz Mah",
      "Haydaroğlu Mah",
      "Seyhan Mah",
      "Yamaçlı Mah",
      "Akıncılar Mah",
      "Özgür Mah",
      "Sarıçam Mah",
      "Sinanpaşa Mah",
      "Yavuzlar Mah"
    ]
  },
  "Adıyaman": {
    "Besni": [
      "15 Temmuz Şehitler Mah",
      "Aşağısarhan Mah",
      "Cirit Meydanı Mah",
      "Çat Mah",
      "Dumlupınar Mah",
      "Erdemoğlu Mah",
      "Kaymakam Hasan Tütün Mah",
      "Korupınar Mah",
      "Oyalı Mah",
      "Pınarbaşı Mah",
      "Pınarbaşıosb Mah",
      "Yeni Besni Mah",
      "Yukarı Sarhan Mah",
      "Abımıstık Mah (çakırhüyük Beldesi)",
      "Akdurak Köyü",
      "Akkuyu Köyü",
      "Aktepe Köyü",
      "Alıçlı Köyü",
      "Boybeypınarı Mah (çakırhüyük Beldesi)",
      "Camuşçu Köyü",
      "Çakmak Mah (akdurak Köyü)",
      "Çomak Köyü",
      "Gönderme Mah (konuklu Köyü)",
      "Hasanlı Köyü",
      "Höyük Mah (çomak Köyü)",
      "İznik Mah (konuklu Köyü)",
      "İzollu Köyü",
      "Kargalı Köyü",
      "Karnaçık Mah (kutluca Köyü)",
      "Konuklu Köyü",
      "Köprübaşı Mah (çakırhüyük Beldesi)",
      "Kutluca Köyü",
      "Levzin Mah (çakırhüyük Beldesi)",
      "Sarıçiçek Mah (konuklu Köyü)",
      "Tileyli Mah (yazıbeydili Köyü)",
      "Yazıbeydili Köyü",
      "Yenikurugöl Mah (akdurak Köyü)",
      "Yeşilova Mah (çakırhüyük Beldesi)",
      "Yoldüzü Köyü",
      "Yukarısöğütlü Köyü",
      "Yusufağa Mah (akkuyu Köyü)",
      "Atatürk Mah (kesmetepe Beldesi)",
      "Çakmak Mah (kesmetepe Beldesi)",
      "Fatih Mah (kesmetepe Beldesi)",
      "İnce Mah (kesmetepe Beldesi)",
      "İnönü Mah (kesmetepe Beldesi)",
      "Turgut Özal Mah (kesmetepe Beldesi)",
      "Aşağısöğütlü Mah (köseceli Beldesi)",
      "Cumhuriyet Mah (köseceli Beldesi)",
      "Hürriyet Mah (köseceli Beldesi)",
      "Tetirli Mah (köseceli Beldesi)",
      "Ahuri Mah (sarıkaya Köyü)",
      "Akdoğanlar Mah (berete Köyü)",
      "Akpınar Köyü",
      "Akyazı Köyü",
      "Ali Erdemoğlu Mah",
      "Aşağıçöplü Köyü",
      "Atatürk Mah (sugözü Köyü)",
      "Atatürk Mah (üçgöz Köyü)",
      "Bahri Mah (bahri Köyü)",
      "Balka Mah (beşyol Köyü)",
      "Bereketli Köyü",
      "Beşkoz Köyü",
      "Beşyol Köyü",
      "Boncuk Köyü",
      "Burunçayır Köyü",
      "Cumhuriyet Mah (sarıyaprak Köyü)",
      "Cumhurriyet Mah (üçgöz Köyü)",
      "Çamlıca Köyü",
      "Çaykaya Köyü",
      "Çilboğaz Köyü",
      "Çorman Mah (tokar Köyü)",
      "Çöplükışla Mah (yeniköy Köyü)",
      "Deliseki Mah (çamlıca Köyü)",
      "Dikilitaş Köyü",
      "Dörtyol Köyü",
      "Eğerli Köyü",
      "Fatih Mah (sarıyaprak Köyü)",
      "Geçitli Köyü",
      "Güneykaş Köyü",
      "Hacıhalil Köyü",
      "Harmanardı Köyü",
      "Höyük Mah (beşyol Köyü)",
      "İnönü Mah (sugözü Köyü)",
      "İnönü Mah (üçgöz Köyü)",
      "Karaağaç Mah (yelbastı Köyü)",
      "Karageçi Mah (beşyol Köyü)",
      "Karagüveç Köyü",
      "Kepirce Mah (yazıkarakuyu Köyü)",
      "Kesecik Köyü",
      "Kızılhisar Köyü",
      "Kızılin Köyü",
      "Kızılkaya Köyü",
      "Kızılpınar Köyü",
      "Kocapirli Mah (eğerli Köyü)",
      "Kurugöl Köyü",
      "Kuzevleri Köyü",
      "Nohudanlı Mah (hacıhalil Köyü)",
      "Oyratlı Köyü",
      "Ören Köyü",
      "Sarıkaya Köyü",
      "Satıluşağı Mah (oyratlı Köyü)",
      "Sayören Köyü",
      "Sumaklı Güzelevler Mah (kurugöl Köyü)",
      "Taşlıyazı Köyü",
      "Tokar Köyü",
      "Toklu Köyü",
      "Topkapı Köyü",
      "Ürecik Mah (yelbastı Köyü)",
      "Yayıklı Köyü",
      "Yazıbademce Mah (yazıkarakuyu Köyü)",
      "Yazıkarakuyu Köyü",
      "Yazıyurdu Mah (berete Köyü)",
      "Yelbastı Köyü",
      "Yemlice Mah (kesecik Köyü)",
      "Yeniköy Köyü",
      "Yeşilova Mah (ören Köyü)",
      "Yukarı Hozgişi Mah (yeniköy Köyü)",
      "Zormağara Mah (yeniköy Köyü)",
      "Adalet Mah (suvarlı Beldesi)",
      "Büyükoba Mah (karalar Köyü)",
      "Cumhuriyet Mah (suvarlı Beldesi)",
      "Çakallı Mah (çorak Köyü)",
      "Çakallı Mah (karalar Köyü)",
      "Çayırobası Mah (karalar Köyü)",
      "Çorak Köyü",
      "Hürriyet Mah (suvarlı Beldesi)",
      "Karalar Köyü",
      "Kıraçhayma Mah (pınarbaşı Köyü)",
      "Körtanlı Mah (pınarbaşı Köyü)",
      "Pınarbaşı Köyü",
      "Tutlupınar Mah (pınarbaşı Köyü)",
      "Uzunkuyu Köyü",
      "Akdere Mah (başlı Köyü)",
      "Akkuyu Mah (atmalı Köyü)",
      "Alişar Köyü",
      "Atmalı Köyü",
      "Başlı Köyü",
      "Bayat Mah (şambayat Beldesi)",
      "Beşir Mah (tekağaç Köyü)",
      "Bostancık Mah (tekağaç Köyü)",
      "Cumhuriyet Mah (şambayat Beldesi)",
      "Doğankaya Köyü",
      "Fatih Mah (şambayat Beldesi)",
      "Gümüşlü Köyü",
      "İnönü Mah (şambayat Beldesi)",
      "Karahalil Mah (başlı Köyü)",
      "Kılıçlı Mah (başlı Köyü)",
      "Kızılcamustafa Mah (başlı Köyü)",
      "Menderes Mah (şambayat Beldesi)",
      "Özbağlar Mah (atmalı Köyü)",
      "Tekağaç Köyü",
      "Yazıyalangoz Mah (tekağaç Köyü)",
      "Yeni Mah (şambayat Beldesi)"
    ],
    "Çelikhan": [
      "Bahçeli Evler Mah",
      "Başpınar Mah",
      "Cami Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Mahmut Nedim Ökmen Mah",
      "Merkez Mah",
      "Yunus Emre Mah",
      "Zafer Mah",
      "Aksu Köyü",
      "Aligür Mah (gölbağı Köyü)",
      "Alisaha Kümesi Mah (mutlu Köyü)",
      "Altıntaş Köyü",
      "Askerhan Köyü",
      "Bahçe Kümesi Mah (mutlu Köyü)",
      "Bozgedik Köyü",
      "Cemolar Mah (kalecik Köyü)",
      "Çampınar Köyü",
      "Çat Mah (şerefhan Köyü)",
      "Değirmen Başı Mah (çampınar Köyü)",
      "Deveboynu Mah (aksu Köyü)",
      "Düzağaç Mah (bozgedik Köyü)",
      "Esenli Mah (şerefhan Köyü)",
      "Eskiköy Mah (recep Köyü)",
      "Eskiköy Mah (yeşilyayla Köyü)",
      "Fatih Köyü",
      "Gölbağı Köyü",
      "Hamik Mah (köseuşağı Köyü)",
      "Hovirge Yaylası Mah (mutlu Köyü)",
      "İncirli Köyü",
      "Kale Mah (yeşiltepe Köyü)",
      "Kalecik Köyü",
      "Karaçayır Köyü",
      "Karagöl Köyü",
      "Karşı Küme Evleri Mah (mutlu Köyü)",
      "Kışıkan Yaylası Mah (mutlu Köyü)",
      "Korucak Köyü",
      "Koyuncular Mah (gölbağı Köyü)",
      "Köseuşağı Köyü",
      "Merkez Kümesi Mah (mutlu Köyü)",
      "Recep Köyü",
      "Soğukpınar Mah (korucak Köyü)",
      "Şahverdi Eskiköy Mah (recep Köyü)",
      "Şahverdi Mah (recep Köyü)",
      "Şahverdi Yaylaevleri Mah (recep Köyü)",
      "Şerefhan Köyü",
      "Yağızatlı Köyü",
      "Yağmurlu Mah (köseuşağı Köyü)",
      "Yayla Evleri Mah (çampınar Köyü)",
      "Yaylaevleri Mah (askerhan Köyü)",
      "Yeşilova Köyü",
      "Yeşiltepe Köyü",
      "Yeşilyayla Köyü",
      "Aktaş Mah (pınarbaşı Beldesi)",
      "Balıkburun Mah (pınarbaşı Beldesi)",
      "Cami Mah (pınarbaşı Beldesi)",
      "Çamlıyayla Mah (pınarbaşı Beldesi)",
      "Hacılar Mah (pınarbaşı Beldesi)",
      "İnönü Mah (pınarbaşı Beldesi)",
      "Kaya Mah (pınarbaşı Beldesi)",
      "Kurudere Mah (pınarbaşı Beldesi)"
    ],
    "Gerger": [
      "Fatih Mah",
      "Keleşan Mah",
      "Merkez Mah",
      "Yeni Mah",
      "Açma Köyü",
      "Ağaçlı Köyü",
      "Aksan Mah (yayladalı Köyü)",
      "Alduş Mah (konacık Köyü)",
      "Artilan Mah (dağdeviren Köyü)",
      "Aşağı Cimik Mah (güzelsu Köyü)",
      "Aşağıdağlıca Köyü",
      "Aydınlık  Mah (zuğur Mah) (dallarca Köyü)",
      "Bağlar Mah (geçitli Köyü)",
      "Bayik Mah (oymaklı Köyü)",
      "Bazik Mah (yayladalı Köyü)",
      "Bekiran Mah (kılıç Köyü)",
      "Bemirgo Mah (konacık Köyü)",
      "Beşgöze Köyü",
      "Beybostan Köyü",
      "Bildeş Mah (demirtaş Köyü)",
      "Bircan Mah (güngörmüş Köyü)",
      "Bodin Mah (gündoğdu Köyü)",
      "Budaklı Köyü",
      "Cevizpınar Köyü",
      "Çamiçi Köyü",
      "Çamik Mah (seyitmahmut Köyü)",
      "Çavgür Mah (çobanpınarı Köyü)",
      "Çavuş Mah (siver Mah) (sutepe Köyü)",
      "Çeman Mah (dağdeviren Köyü)",
      "Çet Mah (çamiçi Köyü)",
      "Çetin Mah (kütüklü Köyü)",
      "Çınarık Mah (yukarıdağlıca Köyü)",
      "Çınarlık Mah (gümüşkaşık Köyü)",
      "Çifthisar Köyü",
      "Çobanpınarı Köyü",
      "Çukurca Mah (açma Köyü)",
      "Dağdeviren Köyü",
      "Dallarca Köyü",
      "Demirtaş Köyü",
      "Despal Mah (yağmurlu Köyü)",
      "Deyro Mah (konacık Köyü)",
      "Dolorizan Mah (gölyurt Köyü)",
      "Döşnik Mah (kaşyazı Köyü)",
      "Erdoğmuş  Mah (baleyrek Mah) (dallarca Köyü)",
      "Eskikent Köyü",
      "Geçitli Köyü",
      "Gelebaz Mah (kılıç Köyü)",
      "Gölani Mah (onevler Köyü)",
      "Gölyurt Köyü",
      "Göme-i Masur Mah (gölyurt Köyü)",
      "Gömük Mah (ağaçlı Köyü)",
      "Gönan Köyü",
      "Gözpınar Köyü",
      "Güdayik Mah (gönan Köyü)",
      "Gümüşkaşık Köyü",
      "Gündoğdu Köyü",
      "Güneypınar Mah (yenibardak Köyü)",
      "Güngörmüş Köyü",
      "Gürgenli Köyü",
      "Güzelsu Köyü",
      "Hanberti Mah (burçaklı Köyü)",
      "Harmuzan Mah (gözpınar Köyü)",
      "Helezin Mah (gölyurt Köyü)",
      "Hevenk Mah (eskikent Köyü)",
      "Hırcık Mah (gürgenli Köyü)",
      "Hilim Mah (gönan Köyü)",
      "Horsaik Mah (dağdeviren Köyü)",
      "Hüsükan Mah (gölyurt Köyü)",
      "Kaf Mah (geçitli Köyü)",
      "Kağındak Mah (gözpınar Köyü)",
      "Kalecik Mah (kılıç Köyü)",
      "Karacaviran Mah (güzelsu Köyü)",
      "Kardigin Mah (yayladalı Köyü)",
      "Karuk Mah (kaşyazı Köyü)",
      "Kaşyazı Köyü",
      "Keferge Mah (korulu Köyü)",
      "Kelazin Mah (yağmurlu Köyü)",
      "Kerzel Mah (oymaklı Köyü)",
      "Kerzel Mah (yağmurlu Köyü)",
      "Kesertaş Köyü",
      "Kevirsor Mah (burçaklı Köyü)",
      "Kılıç Köyü",
      "Kırıngöl Mah (yenibardak Köyü)",
      "Kırmızıtarla Mah (yenibardak Köyü)",
      "Kızzık Mah (burçaklı Köyü)",
      "Kişik Mah (kılıç Köyü)",
      "Konacık Köyü",
      "Korulu Köyü",
      "Koşarlar Köyü",
      "Kozağaçı Mah (onevler Köyü)",
      "Köklüce Köyü",
      "Körtigin Mah (burçaklı Köyü)",
      "Kütüklü Köyü",
      "Maroni Mah (saraycık Köyü)",
      "Merkez Mah (burçaklı Köyü)",
      "Mezra Mah (gürgenli Köyü)",
      "Mırza Mah (dallarca Köyü)",
      "Nakışlı Köyü",
      "Ninyat Mah (gözpınar Köyü)",
      "Onevler Köyü",
      "Ortaca Köyü",
      "Oymaklı Köyü",
      "Ömeran Mah (güngörmüş Köyü)",
      "Özkuran Mah (nakışlı Köyü)",
      "Pamuluk Mah (gümüşkaşık Köyü)",
      "Pankin Mah (beybostan Köyü)",
      "Pemice Mah (yenibardak Köyü)",
      "Pınarbaşı Mah (gölyurt Köyü)",
      "Piyamli Mah (sutepe Köyü)",
      "Pupar Mah (oymaklı Köyü)",
      "Salavat Mah (beşgöze Köyü)",
      "Samak Mah (çamiçi Köyü)",
      "Sankosi Mah (korulu Köyü)",
      "Saraycık Köyü",
      "Sengeto Mah (cevizpınar Köyü)",
      "Seyitmahmut Köyü",
      "Sofyan Mah (koşarlar Köyü)",
      "Sorik Mah (demirtaş Köyü)",
      "Sutepe Köyü",
      "Şakol Mah (yenibardak Köyü)",
      "Şamani Mah (güzelsu Köyü)",
      "Şavi Mah (gölyurt Köyü)",
      "Şengül Mah (çamiçi Köyü)",
      "Tankül Mah (gölyurt Köyü)",
      "Taraksu Mah (üçkaya Köyü)",
      "Tırkıdin Mah (gürgenli Köyü)",
      "Tırşik Mah (seyitmahmut Köyü)",
      "Tillak Mah (beşgöze Köyü)",
      "Üçkaya Köyü",
      "Vankök Mah (gölyurt Köyü)",
      "Yağmurlu Köyü",
      "Yayladalı Köyü",
      "Yenibardak Köyü",
      "Yeşilyurt Köyü",
      "Yukarıdağlıca Köyü",
      "Yuvacık Mah (açma Köyü)"
    ],
    "Gölbaşı": [
      "Asfalt Mah (balkar Beldesi)",
      "Cumhuriyet Mah (balkar Beldesi)",
      "Cumhuriyet Mah (belören Beldesi)",
      "Merkez Mah (belören Beldesi)",
      "Asfalt Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "Kurugeçit Mah",
      "Mimar Sinan Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Cumhuriyet Mah (harmanlı Beldesi)",
      "Çakmak Mah (harmanlı Beldesi)",
      "Kalemkas Mah (harmanlı Beldesi)",
      "Yeni Mah (harmanlı Beldesi)",
      "Akçabel Köyü",
      "Akçakaya Köyü",
      "Aktoprak Köyü",
      "Alikaya Mah (akçakaya Köyü)",
      "Arpatarlası Mah (karabahşılı Köyü)",
      "Aşağıazaplı Köyü",
      "Aşağıkarakuyu Köyü",
      "Aşağınasırlı Köyü",
      "Bağlarbaşı Köyü",
      "Ballık Mah (savran Köyü)",
      "Beşevler Mah (haydarlı Köyü)",
      "Beşevler Mah (karabahşılı Köyü)",
      "Cankara Köyü",
      "Cerrahobası Mah (haydarlı Köyü)",
      "Civkur Mah (kösüklü Köyü)",
      "Cumhuriyet Mah",
      "Çatalağaç Köyü",
      "Çataltepe Köyü",
      "Çayır Mah (karabahşılı Köyü)",
      "Çelikköy Köyü",
      "Çelikköyosb Mah (çelikköy Köyü)",
      "Durak Mah (çatalağaç Köyü)",
      "Durak Mah (çelikköy Köyü)",
      "Gedikli Köyü",
      "Hacılar Köyü",
      "Hamzalar Köyü",
      "Hasanlar Mah (hamzalar Köyü)",
      "Haydarlı Köyü",
      "İstasyon Mah (çelikköy Köyü)",
      "Kandil Mah (hamzalar Köyü)",
      "Karabahşılı Köyü",
      "Karaburun Köyü",
      "Karaçukur Mah (karabahşılı Köyü)",
      "Karahasan Mah (çataltepe Köyü)",
      "Keçibaşı Mah (meydan Köyü)",
      "Keralmaz Mah (çatalağaç Köyü)",
      "Kezbi Mah (savran Köyü)",
      "Körpınarı Mah (meydan Köyü)",
      "Kösüklü Köyü",
      "Kötel Mah (karabahşılı Köyü)",
      "Kumlu Mezrası Mah (aktoprak Köyü)",
      "Kurucuova Mah (savran Köyü)",
      "Küçükören Köyü",
      "Meydan Köyü",
      "Mıçolar Mah (çataltepe Köyü)",
      "Ozan Köyü",
      "Örenli Köyü",
      "Savran Köyü",
      "Serpenolar Mah (haydarlı Köyü)",
      "Sırıklı Mah (hamzalar Köyü)",
      "Sorkun Mah (haydarlı Köyü)",
      "Söğütlü Mah (küçükören Köyü)",
      "Tecirli Mah (çataltepe Köyü)",
      "Uçarlar Mah (hamzalar Köyü)",
      "Yarbaşı Köyü",
      "Yaylacık Köyü",
      "Yenikent Mah",
      "Yeniköy Köyü",
      "Yeşilova Köyü",
      "Yıkıcak Mah (meydan Köyü)",
      "Yolbağı Mah (çataltepe Köyü)",
      "Yukarıçöplü Köyü",
      "Yukarıkarakuyu Köyü",
      "Yukarınasırlı Köyü"
    ],
    "Kahta": [
      "Acoğlu Mah (geldibuldu Köyü)",
      "Adalı Köyü",
      "Akalın Köyü",
      "Akçakent Mah (oluklu Köyü)",
      "Akçaveren Mah (ikizce Köyü)",
      "Akıncılar Atatürk Mah (akıncılar Beldesi)",
      "Aktaş Köyü",
      "Akyıldız Köyü",
      "Aşağı Tuğlu Mah (tuğlu Köyü)",
      "Ataköy Mah (ulupınar Köyü)",
      "Bahçe Mah (geldibuldu Köyü)",
      "Bakacak Mah (ulupınar Köyü)",
      "Berbanos Mah (tuğlu Köyü)",
      "Beşikli Köyü",
      "Buhara Mah (göçeri Köyü)",
      "Büyükgöz Mah (oluklu Köyü)",
      "Cumhuriyet Köyü",
      "Çamlıca Köyü",
      "Çamlıca Mah (akıncılar Beldesi)",
      "Damüstü Mah (eskitaş Köyü)",
      "Dardağan Köyü",
      "Dikenli Köyü",
      "Doğantepe Mah (oluklu Köyü)",
      "Elbeyi Köyü",
      "Elmalı Tuğlu Mah (tuğlu Köyü)",
      "Esentepe Mah (dardağan Köyü)",
      "Eskitaş Köyü",
      "Geldibuldu Köyü",
      "Gevazi Mah (tuğlu Köyü)",
      "Göçeri Köyü",
      "Güdülge Köyü",
      "Gülahmet Mah (tuğlu Köyü)",
      "Hasköy Köyü",
      "Hiniç Mah (adalı Köyü)",
      "Hüseyinli Mah (yenikuşak Köyü)",
      "İkizce Köyü",
      "Karamağara Mah (güdülge Köyü)",
      "Karataş Mah (karataş Köyü)",
      "Karmitli Mah (tuğlu Köyü)",
      "Kılavuz Mah (akıncılar Beldesi)",
      "Küçük Tomak Mah (ikizce Köyü)",
      "Mahmudiye Mah (dardağan Köyü)",
      "Menzil Köyü",
      "Mustafaçayır Mah (ulupınar Köyü)",
      "Nergiztepe Mah (hasköy Köyü)",
      "Oluklu Köyü",
      "Pınaryolu Mah (ikizce Köyü)",
      "Sıratut Mah (adalı Köyü)",
      "Sofya Mah (dardağan Köyü)",
      "Soğuksu Mah (akıncılar Beldesi)",
      "Süsük Mah (güdülge Köyü)",
      "Teriyan Mah (oluklu Köyü)",
      "Teta Mah (oluklu Köyü)",
      "Tilbe Mah (geldibuldu Köyü)",
      "Tuğlu Köyü",
      "Türeşik Mah (güdülge Köyü)",
      "Ulupınar Köyü",
      "Yenikuşak Köyü",
      "Yeşilkaya Mah (yeşilkaya Köyü)",
      "Yeşiltepe Mah (oluklu Köyü)",
      "Yolçatı Mah (oluklu Köyü)",
      "Atatürk Mah (bölükyayla Beldesi)",
      "Cumhuriyet Mah (bölükyayla Beldesi)",
      "Fatih Mah (bölükyayla Beldesi)",
      "Kangülü Mah (bölükyayla Beldesi)",
      "Atatürk Mah",
      "Bağlar Mah",
      "Bayraktar Mah",
      "Cami Mah",
      "Cumhuriyet Mah",
      "Çobanlı Mah",
      "Fatih Mah",
      "Fırat Mah",
      "Gazi Mah",
      "Girne Mah",
      "Hürriyet Mah",
      "Karşıyaka Mah",
      "Menderes Mah",
      "Şeyhbaba Mah",
      "Turgut Özal Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Abdullah Bey Mah (arılı Köyü)",
      "Akça Mah (arılı Köyü)",
      "Akçalı Mah (akkuş Köyü)",
      "Akdamar Mah (bozpınar Köyü)",
      "Akdoğan Köyü",
      "Akkavak Köyü",
      "Akkuş Köyü",
      "Akpınar Mah (kavaklı Köyü)",
      "Aktoprak Mah (erikli Köyü)",
      "Alidam Köyü",
      "Arılı Köyü",
      "Askeran Mah (yolaltı Köyü)",
      "Atlı Mah (gölgeli Köyü)",
      "Avnik Mah (gökçe Köyü)",
      "Aydınlar Mah (arılı Köyü)",
      "Aydınpınar Köyü",
      "Bağbaşı Köyü",
      "Bağözü Köyü",
      "Bahçe Mah (belören Köyü)",
      "Ballı Köyü",
      "Belenli Köyü",
      "Belören Köyü",
      "Beşevler Mah (dut Köyü)",
      "Beypınar Mah (kayadibi Köyü)",
      "Bırbır Mah (çıralık Köyü)",
      "Boğazkaya Köyü",
      "Bostanlı Köyü",
      "Bozpınar Köyü",
      "Boztarla Köyü",
      "Burmapınar Köyü",
      "Büyükbağ Köyü",
      "Büyükbejyan Köyü",
      "Büyükbey Köyü",
      "Büyütme Mah (turanlı Köyü)",
      "Çakıreşme Köyü",
      "Çaltılı Köyü",
      "Çardak Köyü",
      "Çataltepe Köyü",
      "Çaybaşı Köyü",
      "Çem Mah (eski Kahta Köyü)",
      "Çetinkaya Mah (kozağaç Köyü)",
      "Çıralık Köyü",
      "Çiçek Mah (zeytin Köyü)",
      "Çörtenek Mah (eski Kahta Köyü)",
      "Çukurtaş Köyü",
      "Dalince Mah (sıraca Köyü)",
      "Damlacık Köyü",
      "Damlı Mah (eceler Köyü)",
      "Darberi Mah (burmapınar Köyü)",
      "Derebaşı Mah (çukurtaş Köyü)",
      "Dikmetaş Mah (yapraklı Köyü)",
      "Divan Mah (erikli Köyü)",
      "Doluca Köyü",
      "Dumanlı Mah (çaybaşı Köyü)",
      "Dumlu Köyü",
      "Dut Köyü",
      "Eceler Köyü",
      "Ekinci Köyü",
      "Erikdere Köyü",
      "Erikli Köyü",
      "Esendere Köyü",
      "Eski Kahta Köyü",
      "Fıstıklı Köyü",
      "Gedik Mah (alidam Köyü)",
      "Gökçe Köyü",
      "Gölgeli Köyü",
      "Göllük Mah (kozağaç Köyü)",
      "Gömlek Mah (eski Kahta Köyü)",
      "Gülveren Mah (karadut Köyü)",
      "Gümüşkaya Mah (damlacık Köyü)",
      "Güzelçay Köyü",
      "Güzelkent Mah (büyükbağ Köyü)",
      "Habipler Köyü",
      "Haceri Mah (çaybaşı Köyü)",
      "Hacıyusuf Köyü",
      "Halice Mah (narince Köyü)",
      "Halifan Mah (bostanlı Köyü)",
      "Hamzalar Köyü",
      "Hasandiğin Köyü",
      "Hisar Mah (burmapınar Köyü)",
      "Işıktepe Köyü",
      "İngirce Mah (turanlı Köyü)",
      "İslamköy Köyü",
      "Kahta Osb Mah (salkımbağı Köyü)",
      "Kamışlı Mah (çaybaşı Köyü)",
      "Kanboğazı Mah (karadut Köyü)",
      "Karabağ Mah (taşlıca Köyü)",
      "Karacaören Köyü",
      "Karadut Köyü",
      "Karagül Mah (narince Köyü)",
      "Karakuş Mah (bağözü Köyü)",
      "Karaman Köyü",
      "Karanfil Mah (damlacık Köyü)",
      "Karapınar Mah (tütenocak Köyü)",
      "Karatut Mah (çaltılı Köyü)",
      "Kavaklı Köyü",
      "Kayadibi Köyü",
      "Keklik Mah (güzelçay Köyü)",
      "Keklik Mah (teğmenli Köyü)",
      "Kelpınar Mah (eski Kahta Köyü)",
      "Kerkah Mah (ekinci Köyü)",
      "Kınık Mah (hacıyusuf Köyü)",
      "Kilisik Mah (çıralık Köyü)",
      "Koçtepe Köyü",
      "Kosa Mah (çakıreşme Köyü)",
      "Kozağaç Köyü",
      "Köprübaşı Mah (esendere Köyü)",
      "Körgüdan Mah (yapraklı Köyü)",
      "Köseler Köyü",
      "Kubilay Mah (ortanca Köyü)",
      "Küçük Eceler Mah (eceler Köyü)",
      "Menderes Mah (dut Köyü)",
      "Mülk Mah (çıralık Köyü)",
      "Mülkköy Köyü",
      "Narince Köyü",
      "Narlı Mah (hasandiğin Köyü)",
      "Narlıdere Köyü",
      "Narsırtı Köyü",
      "Ortanca Köyü",
      "Osmanpınar Mah (koçtepe Köyü)",
      "Ovacık Köyü",
      "Özelevler Mah (boğazkaya Köyü)",
      "Sako Mah (erikdere Köyü)",
      "Salik Mah (karadut Köyü)",
      "Salkımbağı Köyü",
      "Samanlı Mah (eceler Köyü)",
      "Sarısu Köyü",
      "Sekük Mah (turanlı Köyü)",
      "Sıraca Köyü",
      "Sırakaya Köyü",
      "Sinke Mah (boğazkaya Köyü)",
      "Sultanmağara Mah (köseler Köyü)",
      "Susuz Köyü",
      "Şahintepe Köyü",
      "Şahintepe Mah (karadut Köyü)",
      "Şenköy Köyü",
      "Şirinevler Mah (karadut Köyü)",
      "Tabaklı Mah (belenli Köyü)",
      "Taşlıca Köyü",
      "Taşlıçay Köyü",
      "Teğmenli Köyü",
      "Teknecik Köyü",
      "Tepebaşı Mah (hamzalar Köyü)",
      "Terziyan Mah (narince Köyü)",
      "Tibil Mah (turanlı Köyü)",
      "Tütenocak Köyü",
      "Ulubey Mah (gölgeli Köyü)",
      "Yapraklı Köyü",
      "Yassıkaya Mah (doluca Köyü)",
      "Yelkovan Köyü",
      "Yenice Köyü",
      "Yenice Mah (koçtepe Köyü)",
      "Yolaltı Köyü",
      "Yüksekyayla Mah (belenli Köyü)",
      "Zeynan Mah (bostanlı Köyü)",
      "Zeytin Köyü",
      "Ziyaret Köyü"
    ],
    "Merkez": [
      "Eskisaray Mah",
      "Hocaömer Mah",
      "Kapcami Mah",
      "Musalla Mah",
      "Sıratut Mah",
      "Varlık Mah",
      "Yenipınar Mah",
      "Bahçecik Mah",
      "Bahçelievler Mah",
      "Fatih Mah",
      "İmamağa Mah",
      "Kayalık Mah",
      "Malazgirt Mah",
      "Mehmet Akif Mah",
      "Örenli Mah",
      "Siteler Mah",
      "Turgut Reis Mah",
      "Yeşilyurt Mah",
      "Yunus Emre Mah",
      "Bahçelievler Mah (kömür Beldesi)",
      "Cumhuriyet Mah (kömür Beldesi)",
      "Esence Mah (kömür Beldesi)",
      "Gazi Mah (kömür Beldesi)",
      "Hasankan Mah (kömür Beldesi)",
      "Hürriyet Mah (kömür Beldesi)",
      "Mustafa Yücel Özbilgin Mah (kömür Beldesi)",
      "Serintepe Mah (kömür Beldesi)",
      "Yakacık Mah (kömür Beldesi)",
      "Yeşilyurt Mah (kömür Beldesi)",
      "100. Yıl Mah (100.yıl Köyü)",
      "Acempınarı Mah (kayacık Köyü)",
      "Afetevleri Mah (kayaönü Köyü)",
      "Ağaçkonak Köyü",
      "Ağcin Köyü",
      "Ağikan Köyü",
      "Ağveren Köyü",
      "Ahmethoca Köyü",
      "Akçalı Köyü",
      "Akçik Mah (lokman Köyü)",
      "Akdere Köyü",
      "Akhisar Köyü",
      "Akın Mah (serhatlı Köyü)",
      "Akıncılar  Mah (çerçiyan Mah) (akdere Köyü)",
      "Akpınar Köyü",
      "Aksu  Mah (kır Mah) (doğanlı Köyü)",
      "Akyazı Köyü",
      "Akyurt Mah (uludam Köyü)",
      "Albet Köyü",
      "Alibey Köyü",
      "Altıntop Mah (büyükkavaklı Köyü)",
      "Altun Mah (kuyulu Köyü)",
      "Armutlu  Mah (hozik Mah) (kuyucak Köyü)",
      "Aslanoğlu Mah (hacıhalil Köyü)",
      "Asmalı Mah (varlık Köyü)",
      "Ataköy Köyü",
      "Atatürk Mah (atakent Köyü)",
      "Atatürk Mah (hasancık Köyü)",
      "Aydınlar Köyü",
      "B.ayranlı Mah (uzunköy Köyü)",
      "Bağdere Köyü",
      "Bağlıca Köyü",
      "Bağpınar Köyü",
      "Bağpınar Kuyucak Köyü",
      "Bağtepe Mah (yedioluk Köyü)",
      "Bahçe Mah (çamlıca Köyü)",
      "Bahçe Mah (pınaryayla Köyü)",
      "Balaban Mah (atakent Köyü)",
      "Bardakçı Mah (bozhüyük Köyü)",
      "Başpınar Köyü",
      "Battalhüyük Köyü",
      "Bebek Köyü",
      "Benav  Mah (darıca Mah) (incebağ Köyü)",
      "Beyler Mah (uludam Köyü)",
      "Bozatlı Köyü",
      "Bozhüyük Köyü",
      "Boztepe Köyü",
      "Börkenek Köyü",
      "Bulam Mah (doğanlı Köyü)",
      "Burç Mah (durak Köyü)",
      "Büklüm Köyü",
      "Büyük Boyalı Mah (atakent Köyü)",
      "Büyükkavaklı Köyü",
      "Büyükkırıklı Köyü",
      "Cumhuriyet Mah (atakent Köyü)",
      "Çakmaklar Köyü",
      "Çamgazi Köyü",
      "Çamlıca Köyü",
      "Çamyurdu Köyü",
      "Çatalağaç Köyü",
      "Çayırlı Köyü",
      "Çaylı  Mah (düdere Mah) (hasankendi Köyü)",
      "Çaylı Köyü",
      "Çemberlitaş Köyü",
      "Çınar Mah (akpınar Köyü)",
      "Çınarik Köyü",
      "Çiçek-1 Mah (bağpınar Kuyucak Köyü)",
      "Çiçek-2 Mah (bağpınar Kuyucak Köyü)",
      "Çitlice Mah (çamlıca Köyü)",
      "Çobandede Köyü",
      "Çokpınar Mah (kındırali Köyü)",
      "Daluca Mah (battalhüyük Köyü)",
      "Damdırmaz Köyü",
      "Damlıca Köyü",
      "Darbelik Mah (akpınar Köyü)",
      "Dardağan Köyü",
      "Davuthan Köyü",
      "Derinsu Köyü",
      "Dişbudak Köyü",
      "Doğanlı Köyü",
      "Doyran Köyü",
      "Durak Köyü",
      "Durukaynak Köyü",
      "Düzağaç Mah (uzunköy Köyü)",
      "Düzce Köyü",
      "Ekinci Köyü",
      "Elmacık Köyü",
      "Esence Köyü",
      "Eskihüsnümansur Köyü",
      "Eskiviran Mah (dişbudak Köyü)",
      "Gazihan Mah (bağpınar Kuyucak Köyü)",
      "Gedik Mah (çamlıca Köyü)",
      "Gısrik Mah (derinsu Köyü)",
      "Girik Köyü",
      "Gökçay Köyü",
      "Göktaş  Mah (köristan Mah) (uğurca Köyü)",
      "Göktepe Mah (aydınlar Köyü)",
      "Gölpınar Köyü",
      "Gömlütepe Mah (uzunköy Köyü)",
      "Gözebaşı Köyü",
      "Gözecik  Mah (kç. Çarkezi Mah) (uzunpınar Köyü)",
      "Göztepe Köyü",
      "Gültepe Mah (bağdere Köyü)",
      "Gümüşkaya Köyü",
      "Güneşli Köyü",
      "Güvenli Mah (koçali Köyü)",
      "Güzelevler Mah (bağdere Köyü)",
      "Güzelyurt Köyü",
      "Hacıhalil Köyü",
      "Haraba Mah (akpınar Köyü)",
      "Hasankendi Köyü",
      "Ilıcak Köyü",
      "Işıklı Köyü",
      "İncebağ Köyü",
      "İnceler Köyü",
      "İnönü Mah (hasancık Köyü)",
      "İpekli Köyü",
      "Kalburcu Köyü",
      "Kamışlı Mah (akyazı Köyü)",
      "Kamışlı Mah (yazlık Köyü)",
      "Kanikürk Mah (kaşköy Köyü)",
      "Karaağaç Köyü",
      "Karaburç Mah (battalhüyük Köyü)",
      "Karagöl Köyü",
      "Karahöyük Köyü",
      "Karakoç Köyü",
      "Karaköprü Mah (büyükkavaklı Köyü)",
      "Karaman  Mah (kovuk Deresi Mah) (pınaryayla Köyü)",
      "Karruz Mah (lokman Köyü)",
      "Karti Mah (gözebaşı Köyü)",
      "Kaşıklı Mah (varlık Köyü)",
      "Kaşköy Köyü",
      "Kavak Köyü",
      "Kavak Mah (pınaryayla Köyü)",
      "Kayabaşı  Mah (kazni Mah) (kayaönü Köyü)",
      "Kayacık Köyü",
      "Kayadibi Köyü",
      "Kayalı Köyü",
      "Kayaönü Köyü",
      "Kemalık Mah (ziyaretpayamlı Köyü)",
      "Kemerkaya Köyü",
      "Kerömer Mah (uzunköy Köyü)",
      "Kılıçlar Mah (bebek Köyü)",
      "Kındırali Köyü",
      "Kışla Mah (yazlık Köyü)",
      "Kıvırcık Mah (hacıhalil Köyü)",
      "Kızılcahöyük Köyü",
      "Kızılcapınar Köyü",
      "Kilisik Mah (güzelyurt Köyü)",
      "Koçali Köyü",
      "Konakdere Mah (gökçay Köyü)",
      "Koruköy Köyü",
      "Korulu  Mah (mermere Mah) (yazlık Köyü)",
      "Kotur Mah (akçalı Köyü)",
      "Kotur Mah (doğanlı Köyü)",
      "Kozan Köyü",
      "Köklü Mah (boztepe Köyü)",
      "Kumuşderesi Mah (koçali Köyü)",
      "Kuşakkaya Köyü",
      "Kuştepe Köyü",
      "Kuyucak Köyü",
      "Kuyulu Köyü",
      "Küçük Boyalı Mah (akpınar Köyü)",
      "Küçük Hacıvert Mah (zey Köyü)",
      "Küçük Kavaklı Mah (büyükkavaklı Köyü)",
      "Küçük Kırgı Mah (ekinci Köyü)",
      "Küçük Kırıklı Mah (büyükkırıklı Köyü)",
      "Küçükhasancık Köyü",
      "Küçükkırklı Mah (büyükkırıklı Köyü)",
      "Külafhüyük Köyü",
      "Kürk Mah (girik Köyü)",
      "Lokman Köyü",
      "Madun Mah (gözebaşı Köyü)",
      "Mahmut El Ensari Ziyareti Mah (ipekli Köyü)",
      "Mahmutlu Mah (alibey Köyü)",
      "Maloğlu Mah (akpınar Köyü)",
      "Malpınarı Köyü",
      "Maltepe Mah (zey Köyü)",
      "Mazlık Mah (bebek Köyü)",
      "Mestan Köyü",
      "Millik Mah (düzce Köyü)",
      "Miroğlu Mah (aydınlar Köyü)",
      "Mustafabeyli Mah (varlık Köyü)",
      "Mutluca Mah (gökçay Köyü)",
      "Mürsel Mah (büklüm Köyü)",
      "Narlık Mah (yeniköy Köyü)",
      "Olgunlar Köyü",
      "Oluklu Köyü",
      "Ordu Mah (güneşli Köyü)",
      "Ormaniçi Köyü",
      "Örümce Mah (yarmakaya Köyü)",
      "Özelevler Mah (bağdere Köyü)",
      "Paçık Mah (bebek Köyü)",
      "Palanlı Köyü",
      "Paşamezrası Köyü",
      "Payamlı Köyü",
      "Pınarbaşı Mah (durak Köyü)",
      "Pınaryayla Köyü",
      "Reşatlı Mah (kuyulu Köyü)",
      "Rezip Köyü",
      "Sakallı Mah (ağaçkonak Köyü)",
      "Sarıharman Köyü",
      "Sarıkaya Köyü",
      "Serhatlı Köyü",
      "Seyitevler Mah (bağlıca Köyü)",
      "Sıncık Mah (bağlıca Köyü)",
      "Şemikan Köyü",
      "Şerefli Köyü",
      "Şifrak  Mah (serince Mah) (incebağ Köyü)",
      "Şirazi Mah (bebek Köyü)",
      "Taklar Mah (serhatlı Köyü)",
      "Taşar Mah (serhatlı Köyü)",
      "Taşgedik Köyü",
      "Taşoluk  Mah (tetikan Mah) (derinsu Köyü)",
      "Taşpınar Köyü",
      "Tecir Köyü",
      "Tekpınar Köyü",
      "Tepebaşı Mah (hasancık Köyü)",
      "Tepeönü Mah (uzunköy Köyü)",
      "Terman Köyü",
      "Toptepe Köyü",
      "Tunçlar Mah (serhatlı Köyü)",
      "Tutluca Mah (dişbudak Köyü)",
      "Uğurca Köyü",
      "Uğurlu Mah (kayaönü Köyü)",
      "Ulubey Mah (kayaönü Köyü)",
      "Uludam Köyü",
      "Uzunköy Köyü",
      "Uzunömer Mah (bağdere Köyü)",
      "Uzunpınar Köyü",
      "Üçdirek Köyü",
      "Ürgüç Mah (atakent Köyü)",
      "Vali Halil Işık Mah (atakent Köyü)",
      "Varlık Köyü",
      "Vartana Mah (taşpınar Köyü)",
      "Yağlıca Mah (varlık Köyü)",
      "Yarmakaya Köyü",
      "Yassıhöyük Mah (güzelyurt Köyü)",
      "Yaylacık Mah (uzunköy Köyü)",
      "Yayladamı Köyü",
      "Yazıbaşı Köyü",
      "Yazıca Köyü",
      "Yazlık Köyü",
      "Yedioluk Köyü",
      "Yenice Köyü",
      "Yenigüven Köyü",
      "Yeniköy Köyü",
      "Yenimah. (çemberlitaş Köyü)",
      "Yeninacar Mah (akpınar Köyü)",
      "Yeşilköy Mah (şerefli Köyü)",
      "Yeşilova Köyü",
      "Yıldızlı Mah (battalhüyük Köyü)",
      "Yoğurtlu Mah (varlık Köyü)",
      "Yuvacık  Mah (belikan Mah) (akdere Köyü)",
      "Zey Köyü",
      "Ziyaret Mah (ziyaretpayamlı Köyü)",
      "Ziyaretpayamlı Köyü",
      "Zorköy Mah (gözebaşı Köyü)",
      "Alitaşı Mah",
      "Mara Mah",
      "Sümerevler Mah",
      "Ulucami Mah",
      "Çatderesi Mah (yaylakonak Beldesi)",
      "Çimenke Mah (yaylakonak Beldesi)",
      "İncekoz Mah (yaylakonak Beldesi)",
      "Karaçalı Mah (yaylakonak Beldesi)",
      "Merkez Mah (yaylakonak Beldesi)",
      "Zivar Mah (yaylakonak Beldesi)",
      "Altınşehir Mah",
      "Barbaros Hayrettin Mah",
      "Cumhuriyet Mah",
      "Esentepe Mah",
      "Karapınar Mah",
      "Mimar Sinan Mah",
      "Petrolosb Mah",
      "Türkiye Petrolleri Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Yeni Sanayi Mah"
    ],
    "Samsat": [
      "Ağaköy Mah (uzuntepe Köyü)",
      "Akdamar Köyü",
      "Altıntepe Mah (kırmacık Köyü)",
      "Bağarası Köyü",
      "Bakacak Mah (kırmacık Köyü)",
      "Başaklı Mah (bayırlı Köyü)",
      "Bayırlı Köyü",
      "Bekçiler Mah (tepeönü Köyü)",
      "Bekircik Mah (çiçek Köyü)",
      "Çeşmebaşı Mah (kırmacık Köyü)",
      "Çiçek Köyü",
      "Çille Mah (doğanca Köyü)",
      "Dasınca Mah (taşkuyu Köyü)",
      "Doğanca Köyü",
      "Doğanlar Mah (çiçek Köyü)",
      "Gölpınar Köyü",
      "Göltarla Köyü",
      "Gümüşsuyu Mah (çiçek Köyü)",
      "İnceali Mah (yarımbağ Köyü)",
      "Keçiören Mah (göltarla Köyü)",
      "Kergekuşu Mah (yarımbağ Köyü)",
      "Kıraç Mah (kırmacık Köyü)",
      "Kırmacık Köyü",
      "Kızılöz Köyü",
      "Kovanoluk Köyü",
      "Kuştepe Köyü",
      "Ovacık Köyü",
      "Sarıkök Mah (göltarla Köyü)",
      "Sefvanköy Mah (tepeönü Köyü)",
      "Taşkuyu Köyü",
      "Tepeönü Köyü",
      "Tokaçlı Mah (bayırlı Köyü)",
      "Uyanık Mah (doğanca Köyü)",
      "Uzuntepe Köyü",
      "Yarımbağ Köyü",
      "Yeşilbağ Mah (kırmacık Köyü)",
      "Baraj Mah",
      "Kale Mah",
      "Örentaş Mah",
      "Yavuz Selim Mah"
    ],
    "Sincik": [
      "Çınar Mah (inlice Beldesi)",
      "Çükan Mah (inlice Beldesi)",
      "Fırat Mah (inlice Beldesi)",
      "Karadağ Mah (inlice Beldesi)",
      "Özbilgin Mah (inlice Beldesi)",
      "Taşlıca Mah (inlice Beldesi)",
      "Tuna Mah (inlice Beldesi)",
      "Adaklar Mah (şahinbeyler Köyü)",
      "Aksu Köyü",
      "Alancık Köyü",
      "Arıkonak Köyü",
      "Aydın Mah (söğütlübahçe Köyü)",
      "Balkaya Köyü",
      "Biriman Mah (şahkolu Köyü)",
      "Çağlayan Mah (hüseyinli Köyü)",
      "Çalılık Mah (hüseyinli Köyü)",
      "Çamdere Köyü",
      "Çarhanek Mah (çatbahçe Köyü)",
      "Çat Köyü",
      "Çat Mah (geçitli Köyü)",
      "Çatbahçe Köyü",
      "Çavçük Mah (çatbahçe Köyü)",
      "Damlı Merkez Mah (taşkale Köyü)",
      "Derecik Mezrası Mah (sakız Köyü)",
      "Dervişan Mah (şahkolu Köyü)",
      "Dilektepe Köyü",
      "Düdan Mah (çat Köyü)",
      "Ekinci Kutan Mah (taşkale Köyü)",
      "Elmırtan Mah (çamdere Köyü)",
      "Eskiköy Köyü",
      "Fırın Mah (balkaya Köyü)",
      "Geçitli Köyü",
      "Ger Mah (alancık Köyü)",
      "Gevrik Yağmurlu Mah (aksu Köyü)",
      "Gevrol Mah (arıkonak Köyü)",
      "Gollusor Mah (serince Köyü)",
      "Göv Mah (arıkonak Köyü)",
      "Gümükhan Mah (hüseyinli Köyü)",
      "Güzelsu Mah (hasanlı Köyü)",
      "Hasanlı Köyü",
      "Hayırlı Mah (sakız Köyü)",
      "Hazaz Mah (çamdere Köyü)",
      "Hesikan Mah (çamdere Köyü)",
      "Hijik Mah (çamdere Köyü)",
      "Hodri Mah (yarpuzlu Köyü)",
      "Hürmer Mah (aksu Köyü)",
      "Hüseyinli Köyü",
      "Karakaya Mah (hasanlı Köyü)",
      "Karaköse Köyü",
      "Kaskanlı Mah (dilektepe Köyü)",
      "Kocagazi Mezrası Mah (sakız Köyü)",
      "Küçük Evler Mah (sakız Köyü)",
      "Küçükçay Mah (dilektepe Köyü)",
      "Küplüce Mah (şahinbeyler Köyü)",
      "Kürelifan Mah (şahinbeyler Köyü)",
      "Küsran Mah (alancık Köyü)",
      "Mengil Mah (arıkonak Köyü)",
      "Narlı Köyü",
      "Pınarbaşı Köyü",
      "Rezan Sağlam Mah (taşkale Köyü)",
      "Sakız Köyü",
      "Serbent Mah (çamdere Köyü)",
      "Serince Köyü",
      "Soğanlı Mah (serince Köyü)",
      "Sorut Mah (karaköse Köyü)",
      "Söğütlübahçe Köyü",
      "Subaşı Köyü",
      "Şahinbeyler Köyü",
      "Şahintepe Mah (yarpuzlu Köyü)",
      "Şahkolu Köyü",
      "Şamlük Kalımlı Mah (taşkale Köyü)",
      "Taşkale Köyü",
      "Tepebaşı Mah (çatbahçe Köyü)",
      "Tişik Mah (alancık Köyü)",
      "Tokluca Mah (balkaya Köyü)",
      "Turmuşan Mah (aksu Köyü)",
      "Tuzik Mah (geçitli Köyü)",
      "Uğurlu Köyü",
      "Yanıkkaya Mah (hasanlı Köyü)",
      "Yarpuzlu Köyü",
      "Yassıkaya Mah (serince Köyü)",
      "Yayla Evleri Mah (sakız Köyü)",
      "Yaylabaşı Mah (balkaya Köyü)",
      "Yüksekova Mah (hüseyinli Köyü)",
      "Zevisimilan Mah (taşkale Köyü)",
      "Ayengin Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Karaman Mah",
      "Mahmutoğlu Mah",
      "Onur Mah",
      "Zeynel Aslan Mah"
    ],
    "Tut": [
      "Akbel Mah (çiftlik Köyü)",
      "Akçatepe Köyü",
      "Boyundere Köyü",
      "Çiftlik Köyü",
      "Elçiler Köyü",
      "Havutlu Köyü",
      "Kaşlıca Köyü",
      "Kıllılı Mah (yaylımlı Köyü)",
      "Köseli Köyü",
      "Meryemuşağı Köyü",
      "Öğütlü Köyü",
      "Pamuklu Mah (kaşlıca Köyü)",
      "Pınarlı Mah (yeşilyurt Köyü)",
      "Sülmen Mah (çiftlik Köyü)",
      "Tepecik Köyü",
      "Ünlüce Köyü",
      "Yalankoz Köyü",
      "Yaylımlı Köyü",
      "Yeşilyamaç Mah (tepecik Köyü)",
      "Yeşilyurt Köyü",
      "Ayniye Mah",
      "Bulanık Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Fethiye Mah",
      "Reşadiye Mah",
      "Salah Mah"
    ]
  },
  "Afyonkarahisar": {
    "Başmakçı": [
      "Aşağı Hilal Mah",
      "Barbaros Mah",
      "Çağlayan Mah",
      "Fatih Mah",
      "Gülistan Mah",
      "Mimar Sinan Mah",
      "Yeni Mah",
      "Yukarı Hilal Mah",
      "Akkeçili Köyü",
      "Akkoyunlu Köyü",
      "Akpınar Köyü",
      "Aşağı Beltarla Köyü",
      "Aşağı Mah (çığrı Köyü)",
      "Aşağı Mah (yaka Köyü)",
      "Çevlik Köyü",
      "Ekinlik Köyü",
      "Emmiler Mah (ovacık Köyü)",
      "Hırkaköy Köyü",
      "Küllüce Köyü",
      "Merkez Mah (ovacık Köyü)",
      "Orta Mah (çığrı Köyü)",
      "Sarıköy Köyü",
      "Tınalar Mah (ovacık Köyü)",
      "Yassıören Köyü",
      "Yukarı Mah (çığrı Köyü)",
      "Yukarı Mah (yaka Köyü)",
      "Yukarıbeltarla Köyü"
    ],
    "Bayat": [
      "Büyük Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Yeni Mah",
      "Abdullahlı Mah (derbent Köyü)",
      "Akpınar Köyü",
      "Aşağıçaybelen Köyü",
      "Ceritli Mah (derbent Köyü)",
      "Çukurkuyu Köyü",
      "Eskigömü Köyü",
      "İmrallı Köyü",
      "İnpınar Köyü",
      "Kuzören Köyü",
      "Mallıca Köyü",
      "Muratkoru Köyü",
      "Orta Mah (derbent Köyü)",
      "Sağırlı Köyü",
      "Yukarıçaybelen Köyü"
    ],
    "Bolvadin": [
      "Akçeşme Mah",
      "Alaca Mah",
      "Ali Efendi Mah",
      "Aşağı Gökçeyayla Mah",
      "Aydınlar Mah",
      "Bademli Mah",
      "Bağlarbaşı Mah",
      "Bağlarüstü Mah",
      "Bahçelievler Mah",
      "Bekir Ağa Mah",
      "Bolvadin Osb Mah",
      "Bucak Mah",
      "Cirit Mah",
      "Çardaklı Mah",
      "Emrullah Mah",
      "Erkmen Mah",
      "Ethem Kelekçi Mah",
      "Gölbaşı Mah",
      "Hacı Esat Mah",
      "Hacı Halife Mah",
      "Hacı Ömer Mah",
      "Hacı Yusuf Mah",
      "Hastane Mah",
      "Hisar Mah",
      "İhsaniye Mah",
      "İmaret Mah",
      "Kale Mah",
      "Karabağlar Mah",
      "Kaymaz Mah",
      "Kestemet Mah",
      "Kırkgöz Mah",
      "Kırklar Mah",
      "Konak Mah",
      "Lala Sinan Paşa Mah",
      "Mescit Mah",
      "Müslümana Mah",
      "Ömeroğlu Mah",
      "Selçuklu Mah",
      "Süleymaniye Mah",
      "Şazi Mah",
      "Şıhlar Mah",
      "Taşağıl Mah",
      "Yakup Şevki Paşa Mah",
      "Yeni Doğan Mah",
      "Yenice Mah",
      "Yıldırım Mah",
      "Yukarı Gökçeyayla Mah",
      "Çaybaşı Mah (dişli Beldesi)",
      "Fatih Mah (dişli Beldesi)",
      "Köprübaşı Mah (dişli Beldesi)",
      "Malazgirt Mah (dişli Beldesi)",
      "Mevlana Mah (dişli Beldesi)",
      "Okul Mah (dişli Beldesi)",
      "Şeyh Şamil Mah (dişli Beldesi)",
      "Yavuz Selim Mah (dişli Beldesi)",
      "Yukarı Mah (dişli Beldesi)",
      "Yunus Emre Mah (dişli Beldesi)",
      "Atatürk Mah (büyükkarabağ Köyü)",
      "Avdan Mah (kemerkaya Köyü)",
      "Derekarabağ Köyü",
      "Dipevler Köyü",
      "Fatih Mah",
      "Fevziçakmak Mah (büyükkarabağ Köyü)",
      "Güney Köyü",
      "Hacıbekir Mah (büyükkarabağ Köyü)",
      "Hamidiye Köyü",
      "Hürriyet Mah (kemerkaya Köyü)",
      "Karayokuş Köyü",
      "Karşıyaka Mah (büyükkarabağ Köyü)",
      "Kurucaova Köyü",
      "Kutlu Köyü",
      "Malazgirt Mah",
      "Nusratlı Köyü",
      "Ortakarabağ Köyü",
      "Savaş Mah (kemerkaya Köyü)",
      "Taşağıl Köyü",
      "Taşlıdere Köyü",
      "Yaka Mah (kemerkaya Köyü)",
      "Yapraklı Mah (kemerkaya Köyü)",
      "Yeni Mah",
      "Yeni Mah (kemerkaya Köyü)",
      "Yürükkaracaören Köyü",
      "Zafer Mah (kemerkaya Köyü)",
      "Bahçelievler Mah (özburun Beldesi)",
      "Çaybaşı Mah (özburun Beldesi)",
      "Şehirönü Mah (özburun Beldesi)",
      "Ulucami Mah (özburun Beldesi)",
      "Üsküdar Mah (özburun Beldesi)"
    ],
    "Çay": [
      "Aktaş Mah",
      "Ali İhsan Paşa Mah",
      "Ali Kaleli Mah",
      "Bahçelievler Mah",
      "Cedit Mah",
      "Demirağaç Mah",
      "Dumlupınar Mah",
      "Elbiz Mah",
      "İstasyon Mah",
      "Köprübaşı Mah",
      "Orta Mah",
      "Şirinevler Mah",
      "Tekke Mah",
      "Vakıf Mah",
      "Yaka Mah",
      "Yeşilevler Mah",
      "Aşağı Mah (karamıkkaracaören Beldesi)",
      "Bağlar Mah (karamıkkaracaören Beldesi)",
      "Seka Mah (karamıkkaracaören Beldesi)",
      "Yukarı Mah (karamıkkaracaören Beldesi)",
      "75. Yıl Mah (karamık Köyü)",
      "Akhürrem Mah (akkonak Köyü)",
      "Alpaslan Mah (inli Köyü)",
      "Armutlu Köyü",
      "Aşağı Mah",
      "Aşağı Mah (koçbeyli Köyü)",
      "Aydoğmuş Köyü",
      "Baltacı Mah (akkonak Köyü)",
      "Bulanık Köyü",
      "Cumhuriyet Köyü",
      "Cumhuriyet Mah (akkonak Köyü)",
      "Cumhuriyet Mah (inli Köyü)",
      "Cumhuriyet Mah (karamık Köyü)",
      "Çayırpınar Köyü",
      "Çayıryazı Köyü",
      "Devederesi Köyü",
      "Evren Mah (inli Köyü)",
      "Göcen Köyü",
      "Göçmezler Mah (koçbeyli Köyü)",
      "Gülbaharlı Mah (koçbeyli Köyü)",
      "Gündoğdu Mah (deresinek Köyü)",
      "Hürriyet Mah (akkonak Köyü)",
      "Kadıköy Köyü",
      "Kahraman Mah (deresinek Köyü)",
      "Kavaklı Mah (inli Köyü)",
      "Kılıçyaka Köyü",
      "Kocatepe Mah (inli Köyü)",
      "Maltepe Köyü",
      "Milli Egemenlik Mah (akkonak Köyü)",
      "Orhaniye Köyü",
      "Orta Mah (eber Köyü)",
      "Pınarkaya Köyü",
      "Tekke Mah (eber Köyü)",
      "Yayla Mah (inli Köyü)",
      "Yeni Mah (eber Köyü)",
      "Yeni Mah (koçbeyli Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Mah (eber Köyü)",
      "Zafer Mah (deresinek Köyü)",
      "Afyon Mah (pazarağaç Beldesi)",
      "Beşevler Mah (pazarağaç Beldesi)",
      "Karabulut Mah (pazarağaç Beldesi)",
      "Orta Mah (pazarağaç Beldesi)",
      "Yukarı Mah (pazarağaç Beldesi)"
    ],
    "Çobanlar": [
      "Bucak Mah",
      "Gölcük Mah",
      "Işık Mah",
      "Karadede Mah",
      "Sırakapı Mah",
      "Termalkent Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Zafer Mah",
      "Atatürk Mah (kocaöz Beldesi)",
      "Cumhuriyet Mah (kocaöz Beldesi)",
      "Fatih Mah (kocaöz Beldesi)",
      "İstiklal Mah (kocaöz Beldesi)",
      "Akkoyunlu Köyü",
      "Göynük Köyü",
      "Kale Köyü"
    ],
    "Dazkırı": [
      "Barbaros Mah",
      "Çamlık Mah",
      "Esentepe Mah",
      "Kurtuluş Mah",
      "Vehbi Koç Sanayi Bölgesi Mah",
      "Yeniyol Mah",
      "Yeşilyurt Mah",
      "Akarca Köyü",
      "Arıköy Köyü",
      "Aşağıyenice Köyü",
      "Bozan Köyü",
      "Çiftlik Köyü",
      "Darıcılar Köyü",
      "Demirel Mah (yüreğil Köyü)",
      "Fatih Mah (yüreğil Köyü)",
      "Hasandede Köyü",
      "Hisaralan Köyü",
      "İdris Köyü",
      "Karaağaçkuyusu Köyü",
      "Kızılören Köyü",
      "Örtülü Köyü",
      "Sarıkavak Köyü",
      "Yaylaköy Köyü",
      "Yukarıyenice Köyü"
    ],
    "Dinar": [
      "Adliye Mah",
      "Altmışevler Mah",
      "Atatürk Mah",
      "Bağlar Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Dörtyol Mah",
      "Emniyet Mah",
      "Fatih Mah",
      "Gazi Mehmet Çavuş Mah",
      "Hürriyet Mah",
      "Ilıca Mah",
      "İncirli Mah",
      "İstasyon Mah",
      "İtfaiye Mah",
      "Konak Mah",
      "Korubaşı Mah",
      "Otogar Mah",
      "Pancar Mah",
      "Pazar Mah",
      "Pınarbaşı Mah",
      "Sanayi Mah",
      "Santral Mah",
      "Stadyum Mah",
      "Suçıkan Mah",
      "Toptepe Mah",
      "Üçlerce Mah",
      "Cumhuriyet Mah (haydarlı Beldesi)",
      "Hürriyet Mah (haydarlı Beldesi)",
      "İstiklal Mah (haydarlı Beldesi)",
      "Merkez Mah (haydarlı Beldesi)",
      "Ocaklı Mah (haydarlı Beldesi)",
      "Örnek Mah (haydarlı Beldesi)",
      "Yeni Mah (haydarlı Beldesi)",
      "11 Evler Mah (tekin Köyü)",
      "18 Evler Mah (tekin Köyü)",
      "60 Evler Mah (tekin Köyü)",
      "Afşar Köyü",
      "Akça Köyü",
      "Akça Mh. (cumhuriyet Köyü)",
      "Akçin Köyü",
      "Akgün Köyü",
      "Akkanatlı Mah (yüksel Köyü)",
      "Akpınarlı Köyü",
      "Aktoprak Köyü",
      "Aktoprak Mah (aktoprak Köyü)",
      "Alacatlı Köyü",
      "Alpaslan Mah (çiçektepe Köyü)",
      "Aşağı Mh. (alparslan Köyü)",
      "Atatürk Mah (çiçektepe Köyü)",
      "Atatürk Mah (kadılar Köyü)",
      "Avdan Köyü",
      "Aydınlı Mah (bademli Köyü)",
      "Bademli Köyü",
      "Bağcılar Köyü",
      "Bahçelievler Mah (kınık Köyü)",
      "Bahçelievler Mah (yıprak Köyü)",
      "Belenpınar Köyü",
      "Bilgiç Köyü",
      "Burunkaya Köyü",
      "Bülücalan Köyü",
      "Camikebir Mah (uluköy Köyü)",
      "Camili Mah (bademli Köyü)",
      "Camili Mah (genceli Köyü)",
      "Cerityaylası Köyü",
      "Cumhuriyet Köyü",
      "Cumhuriyet Mah (çiçektepe Köyü)",
      "Cumhuriyet Mah (doğanlı Köyü)",
      "Cumhuriyet Mah (kadılar Köyü)",
      "Çağlayan Köyü",
      "Çakıcı Köyü",
      "Çamlı Köyü",
      "Çapalı Köyü",
      "Çayüstü Köyü",
      "Çobansaray Köyü",
      "Çürüklü Köyü",
      "Dere Mh. (göçerli Köyü)",
      "Dikici Mah (dikici Köyü)",
      "Dombay Köyü",
      "Duman Köyü",
      "Eldere Köyü",
      "Erdoğan Ulusan Mah (dikici Köyü)",
      "Ergenli Köyü",
      "Esentepe Mah (kınık Köyü)",
      "Esentepe Mah (yıprak Köyü)",
      "Fatih Mah (çiçektepe Köyü)",
      "Fatih Mah (kınık Köyü)",
      "Gazi Mah (doğanlı Köyü)",
      "Gedik Altı Mevki Mh. (göçerli Köyü)",
      "Gedik Başı Mh. (göçerli Köyü)",
      "Genceli Mah (genceli Köyü)",
      "Gençaliosb Mah (genceli Köyü)",
      "Gökçeli Köyü",
      "Hacımahmut Mah (yeşilçat Köyü)",
      "Harman Yeri Mh. (göçerli Köyü)",
      "Hasan Hüseyin Çimen Mah (dikici Köyü)",
      "Hisar Mah (yıprak Köyü)",
      "İnönü Mah (kadılar Köyü)",
      "İstasyon Mah (karakuyu Köyü)",
      "Kabaklı Köyü",
      "Karabedir Köyü",
      "Karahacılı Köyü",
      "Karataş Köyü",
      "Kazanpınar Köyü",
      "Keklicek Köyü",
      "Kızıllı Köyü",
      "Körpeli Köyü",
      "Köy İçi Mah (karakuyu Köyü)",
      "Köy Konağı Mah (genceli Köyü)",
      "Küçük Kale Önü Mh. (göçerli Köyü)",
      "Mehmet Tuncay Mah (dikici Köyü)",
      "Mustafa Acar Mah (dikici Köyü)",
      "Okçular Köyü",
      "Orta Mah (bademli Köyü)",
      "Orta Mah (yeşilçat Köyü)",
      "Ömerli Mh. (cumhuriyet Köyü)",
      "Örnek Mah (doğanlı Köyü)",
      "Öztürk Mah (kınık Köyü)",
      "Palaz Köyü",
      "Peynir Yemez Mah (yeşilçat Köyü)",
      "Pınarlı Köyü",
      "Sağbaşlı Mah (yüksel Köyü)",
      "Seydilli Mh. (cumhuriyet Köyü)",
      "Sırataş Mh. (göçerli Köyü)",
      "Sütlaç Köyü",
      "Tugaylı Köyü",
      "Yaka Köyü",
      "Yaka Mah (yaka Köyü)",
      "Yapağlı Köyü",
      "Yelalan Köyü",
      "Yeni Mah",
      "Yeni Mah (genceli Köyü)",
      "Yeni Mah (uluköy Köyü)",
      "Yeşilçat Köyü",
      "Yeşilhüyük Köyü",
      "Yeşilyurt Köyü",
      "Yukarı Mh. (alparslan Köyü)",
      "Yücel Yalçın Mah (dikici Köyü)",
      "Yüksel Köyü",
      "Zafer Mah (kadılar Köyü)",
      "Altınhisar Mah (tatarlı Beldesi)",
      "Cumhuriyet Mah (tatarlı Beldesi)",
      "Çağlayan Mah (tatarlı Beldesi)",
      "Çamlıca Mah (tatarlı Beldesi)",
      "Fatih Mah (tatarlı Beldesi)",
      "Yeşilyurt Mah (tatarlı Beldesi)"
    ],
    "Emirdağ": [
      "Alasakallı Mah (davulga Beldesi)",
      "Domurlu Mah (davulga Beldesi)",
      "Hisarköy Mah (davulga Beldesi)",
      "İncik Mah (davulga Beldesi)",
      "Karakuyu Mah (davulga Beldesi)",
      "Sofulu Mah (davulga Beldesi)",
      "Cumhuriyet Mah",
      "Çilli Mah",
      "Eski Kacerli Mah",
      "İncili Mah",
      "İnkilap Mah",
      "Karşıyaka Mah",
      "Menderes Mah",
      "Yeni Kacerli Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Bağlarbaşı Mah (gömü Beldesi)",
      "Dörtyol Mah (gömü Beldesi)",
      "Fatih Mah (gömü Beldesi)",
      "Gökçeyaka Mah (gömü Beldesi)",
      "Toki Mah (gömü Beldesi)",
      "Ablak Köyü",
      "Adalet Mah (bademli Köyü)",
      "Ağılcık Köyü",
      "Alibeyce Köyü",
      "Arzılı Mah (başkonak Köyü)",
      "Aşağıaliçomak Köyü",
      "Aşağıkurudere Köyü",
      "Avdan Köyü",
      "Aydınyaka Köyü",
      "Aynılı Mah (başkonak Köyü)",
      "Bağlıca Köyü",
      "Balcam Köyü",
      "Başali Mah (başkonak Köyü)",
      "Beyköy Köyü",
      "Beyören Köyü",
      "Burunarkaç Köyü",
      "Büyüktuğluk Köyü",
      "Camili Köyü",
      "Civikli Mah (başkonak Köyü)",
      "Cumhuriyet Mah (adayazı Köyü)",
      "Cumhuriyet Mah (aşağıpiribeyli Köyü)",
      "Çatallı Köyü",
      "Çaykışla Köyü",
      "Çiftlikköy Köyü",
      "Dağılgan Köyü",
      "Dağınık Köyü",
      "Daydalı Köyü",
      "Demircili Köyü",
      "Dere Mah (aşağıkurudere Köyü)",
      "Dereköy Köyü",
      "Döneli Mah (yüreğil Köyü)",
      "Ekizce Köyü",
      "Elhan Köyü",
      "Emirinköyü Köyü",
      "Eskiakören Köyü",
      "Eşrefli Köyü",
      "Fakılı Mah (tezköy Köyü)",
      "Gedikevi Köyü",
      "Gelincik Köyü",
      "Gözeli Köyü",
      "Güney Köyü",
      "Güneysaray Köyü",
      "Güveççi Köyü",
      "Güzle Mah (tezköy Köyü)",
      "Hacı Hüseyinli Mah (başkonak Köyü)",
      "Hacı İsalı Mah (başkonak Köyü)",
      "Hacı Mustafalı Mah (başkonak Köyü)",
      "Hamzahacılı Köyü",
      "İnceli Mah (tezköy Köyü)",
      "Karaağaç Köyü",
      "Karacalar Köyü",
      "Karayatak Köyü",
      "Karşıyaka Mah (aşağıpiribeyli Köyü)",
      "Kavlaklı Mah (kılıçlı Kavlaklı Köyü)",
      "Kılıçlar Köyü",
      "Kılıçlı Mah (kılıçlı Kavlaklı Köyü)",
      "Kırkpınar Köyü",
      "Koyunlu Mah (kılıçlı Kavlaklı Köyü)",
      "Köseli Mah (yüreğil Köyü)",
      "Kuruca Köyü",
      "Kurucaosb Mah (kuruca Köyü)",
      "Leylekli Köyü",
      "Mahrumlu Mah (yukarıkurudere Köyü)",
      "Mazı Mah (yukarıkurudere Köyü)",
      "Örenköy Köyü",
      "Özkan Köyü",
      "Palıtlı Mah (yukarıkurudere Köyü)",
      "Rahimli Mah (tezköy Köyü)",
      "Salihler Köyü",
      "Sığracık Köyü",
      "Soğukkuyu Köyü",
      "Suvermez Köyü",
      "Tabaklar Köyü",
      "Tepeköy Köyü",
      "Tezköy Merkez Mah (tezköy Köyü)",
      "Toklucak Köyü",
      "Topçular Mah (başkonak Köyü)",
      "Topdere Köyü",
      "Türkmenakören Köyü",
      "Türkmenköy Köyü",
      "Ümraniye Köyü",
      "Veysel Köyü",
      "Yarıkkaya Köyü",
      "Yarımca Köyü",
      "Yavuz Köyü",
      "Yeni Mah (adayazı Köyü)",
      "Yeni Mah (aşağıpiribeyli Köyü)",
      "Yenidoğan Mah (adayazı Köyü)",
      "Yenikapı Köyü",
      "Yeniköy Köyü",
      "Yıldız Mah (bademli Köyü)",
      "Yusufağa Köyü",
      "Yüreğil Köyü",
      "Zafer Mah (bademli Köyü)"
    ],
    "Evciler": [
      "Camikebir Mah",
      "Fatih Mah",
      "Kayalık Mah",
      "Mehmet Akif Mah",
      "Yavuz Selim Mah",
      "Yunus Emre Mah",
      "Akyarma Köyü",
      "Bademli Mah (altınova Köyü)",
      "Barbaros Mah (gökçek Köyü)",
      "Bostancı Köyü",
      "Çayönü Mah (madenler Köyü)",
      "Deprem Evleri Mah (madenler Köyü)",
      "Dere Mah (altınova Köyü)",
      "Fatih Mah (gökçek Köyü)",
      "Gündoğdu Deprem Evleri Mah (gökçek Köyü)",
      "Körkuyu Köyü",
      "Küme Evleri Mah (altınova Köyü)",
      "Mevlana Mah (baraklı Köyü)",
      "Yunus Emre Mah (baraklı Köyü)"
    ],
    "Hocalar": [
      "Hürriyet Mah",
      "Şafak Mah",
      "Yeni Mah",
      "Akçadere Köyü",
      "Aşağı Mah (güre Köyü)",
      "Aşağı Mah (kozluca Köyü)",
      "Avgancık Köyü",
      "Cumhuriyet Mah (yeşilhisar Köyü)",
      "Çalça Köyü",
      "Çepni Köyü",
      "Davulga Köyü",
      "Devlethan Köyü",
      "Devrant Mah (güre Köyü)",
      "Eldizan Mah (çepni Köyü)",
      "Fatih Mah (yeşilhisar Köyü)",
      "Güre Köyü",
      "Hisar Mah (yeşilhisar Köyü)",
      "İhsaniye Köyü",
      "Kocagöl Köyü",
      "Kozluca Köyü",
      "Örencik Köyü",
      "Örtülü Köyü",
      "Uluköy Köyü",
      "Yağcı Köyü",
      "Yeni Mah (yeşilhisar Köyü)",
      "Yukarı Mah (akçadere Köyü)"
    ],
    "İhsaniye": [
      "Fatih Mah (döğer Beldesi)",
      "Kervansaray Mah (döğer Beldesi)",
      "Yeni Mah (döğer Beldesi)",
      "Yunus Emre Mah (döğer Beldesi)",
      "Belce Mah (gazlıgöl Beldesi)",
      "Cumhuriyet Mah (gazlıgöl Beldesi)",
      "Fatih Mah (gazlıgöl Beldesi)",
      "Yunus Emre Mah (gazlıgöl Beldesi)",
      "Akören Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Şahinler Mah",
      "Zafer Mah",
      "Cumhuriyet Mah (kayıhan Beldesi)",
      "Kunduzlu Mah (kayıhan Beldesi)",
      "Pınar Mah (kayıhan Beldesi)",
      "Türbe Mah (kayıhan Beldesi)",
      "Ablak Köyü",
      "Aşağıtandır Köyü",
      "Basırlar Köyü",
      "Bayramaliler Köyü",
      "Beyköy Köyü",
      "Cumalı Köyü",
      "Cumhuriyet Mah (ayazini Köyü)",
      "Cumhuriyet Mah (bozhüyük Köyü)",
      "Cumhuriyet Mah (karacaahmet Köyü)",
      "Demirli Köyü",
      "Dereköy Mah (eynehankuzviran Köyü)",
      "Eskieymir Mah (eskieymir Köyü)",
      "Fatih Mah",
      "Fatih Mah (ayazini Köyü)",
      "Hacıbeyli Köyü",
      "İğdemir Köyü",
      "Kadımürsel Köyü",
      "Kıldirler Mah (eynehankuzviran Köyü)",
      "Kıyır Köyü",
      "Kuzviran Mah (eynehankuzviran Köyü)",
      "Muratlar Köyü",
      "Oğulbeyli Köyü",
      "Orhanlı Köyü",
      "Osmanköy Köyü",
      "Öksüzler Mah (eynehankuzviran Köyü)",
      "Sarıcaova Köyü",
      "Susuz Osmaniye Mah",
      "Şehitler Mah (bozhüyük Köyü)",
      "Taşpınar Mah (eskieymir Köyü)",
      "Türbe Mah (karacaahmet Köyü)",
      "Üçlerkayası Köyü",
      "Yenice Köyü",
      "Yenikent Mah",
      "Yeşilyayla Köyü",
      "Yiğitpınarı Köyü",
      "Yukarıtandır Köyü",
      "Yunus Emre Mah (bozhüyük Köyü)",
      "Atatürk Mah (yaylabağı Beldesi)",
      "Bahçelievler Mah (yaylabağı Beldesi)",
      "Esentepe Mah (yaylabağı Beldesi)"
    ],
    "İscehisar": [
      "Çukur Mah",
      "Esentepe Mah",
      "Eski Hamam Mah",
      "Fatih Mah",
      "Kavak Mah",
      "Medrese Mah",
      "Mermer Osb Mah",
      "Selçuklu Mah",
      "Şirinevler Mah",
      "Tepecik Mah",
      "Zeybek Mah",
      "Ağzıkara Mah (çatağıl Köyü)",
      "Atatürk Mah (alanyurt Köyü)",
      "Bahçecik Köyü",
      "Cevizli Köyü",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (alanyurt Köyü)",
      "Çakmak Mah (alanyurt Köyü)",
      "Çalışlar Köyü",
      "Doğanlar Köyü",
      "Doğlat Köyü",
      "Duraklar Mah (çatağıl Köyü)",
      "Hürriyet Mah (alanyurt Köyü)",
      "Karaağaç Köyü",
      "Karakaya Mah (konarı Köyü)",
      "Kavruklar Mah (karakaya Köyü)",
      "Keserler Mah (karakaya Köyü)",
      "Kurtuluş Mah",
      "Kürtyurdu Mah (çatağıl Köyü)",
      "Merkez Mah (çatağıl Köyü)",
      "Merkez Mah (karakaya Köyü)",
      "Merkez Mah (konarı Köyü)",
      "Merkez Mah (olukpınar Köyü)",
      "Öldümler Mah (olukpınar Köyü)",
      "Selimiye Mah (alanyurt Köyü)",
      "Veliler Mah (karakaya Köyü)",
      "Yanıklar Mah (olukpınar Köyü)",
      "Cumhuriyet Mah (seydiler Beldesi)",
      "Hasan Basri Mah (seydiler Beldesi)"
    ],
    "Kızılören": [
      "Cumhuriyet Mah",
      "Yeni Mah",
      "Ekinova Köyü",
      "Gülyazı Köyü",
      "Türkbelkavak Köyü",
      "Yenibelkavak Köyü"
    ],
    "Merkez": [
      "Ataköy Mah",
      "Esentepe Mah",
      "İstiklal Mah",
      "Kanlıca Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Zafer Mah",
      "Atatürk Mah (beyyazı Beldesi)",
      "Cumhuriyet Mah (beyyazı Beldesi)",
      "Örnek Mah (beyyazı Beldesi)",
      "Cumhuriyet Mah",
      "Dairecep Mah",
      "Derviş Paşa Mah",
      "Dumlupınar Mah",
      "Hattat Karahisar Mah",
      "Karaman Mah",
      "Kasımpaşa Mah",
      "Kayadibi Mah",
      "Marulcu Mah",
      "Mecidiye Mah",
      "Ali Çetinkaya Mah (çayırbağ Beldesi)",
      "Fatih Mah (çayırbağ Beldesi)",
      "Huzur Mah (çayırbağ Beldesi)",
      "Uğur Mah (çayırbağ Beldesi)",
      "Erenler Mah (çıkrık Beldesi)",
      "Yunuslar Mah (çıkrık Beldesi)",
      "Kurtuluş Mah (değirmenayvalı Beldesi)",
      "Şehit Ahmet Mah (değirmenayvalı Beldesi)",
      "Cumhuriyet Mah (erkmen Beldesi)",
      "Fevzi Çakmak Mah (erkmen Beldesi)",
      "Hürriyet Mah (erkmen Beldesi)",
      "Akçin Mah",
      "Ali İhsan Paşa Mah",
      "Beyazıt Mah",
      "Eşrefpaşa Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Güvenevler Mah",
      "Hoca Ahmet Yesevi Mah",
      "Kocatepe Mah",
      "Nazmi Saatçi Mah",
      "Örnekevler Mah",
      "Sahipata Mah",
      "Veysel Karani Mah",
      "Fatih Mah (fethibey Beldesi)",
      "Yavuz Selim Mah (fethibey Beldesi)",
      "Yunus Emre Mah (fethibey Beldesi)",
      "Fatih Mah (gebeceler Beldesi)",
      "İstiklal Mah (gebeceler Beldesi)",
      "Kocatepe Mah (gebeceler Beldesi)",
      "Yeni Mah (gebeceler Beldesi)",
      "Zafer Mah (gebeceler Beldesi)",
      "Atatürk Mah (ışıklar Beldesi)",
      "Cumhuriyet Mah (ışıklar Beldesi)",
      "Hürriyet Mah (ışıklar Beldesi)",
      "İstiklal Mah (ışıklar Beldesi)",
      "Yaka Mah (ışıklar Beldesi)",
      "Yeni Mah (ışıklar Beldesi)",
      "Akmescit Mah",
      "Burmalı Mah",
      "Fakıpaşa Mah",
      "Hamidiye Mah",
      "Hasan Karaağaç Mah",
      "Olucak Mah",
      "Sümer Mah",
      "Tacı Ahmet Mah",
      "Taşpınar Mah",
      "Yarenler Mah",
      "Yunus Emre Mah",
      "Kocatepe Mah (kocatepe Beldesi)",
      "Kurtuluş Mah (kocatepe Beldesi)",
      "Alcalı Köyü",
      "Bayatcık Mah",
      "Bayramgazi Köyü",
      "Belkaracaören Köyü",
      "Bostanlı Köyü",
      "Burhaniye Köyü",
      "Cumhuriyet Mah (anıtkaya Köyü)",
      "Çakır Mah",
      "Çatalçeşme Mah (bayramgazi Köyü)",
      "Çavdarlı Köyü",
      "Değirmendere Köyü",
      "Demirçevre Mah",
      "Devren Mah (saadet Köyü)",
      "Gözsüzlü Köyü",
      "Halımoru Köyü",
      "İsmail Mah",
      "Kaplanlı Köyü",
      "Karaarslan Çayırı Mah (karaarslan Köyü)",
      "Karaarslan Köyü",
      "Kışlacık Mah",
      "Kızıldağ Köyü",
      "Koçaktepesi Mah (çavdarlı Köyü)",
      "Kozluca Köyü",
      "Köprülü Köyü",
      "Küçükçobanlı Mah",
      "Küçükkalecik Köyü",
      "Olucak Köyü",
      "Omuzca Köyü",
      "Saadet Köyü",
      "Sadıkbey Mah",
      "Saraydüzü Çayırı Mah (saraydüzü Köyü)",
      "Saraydüzü Köyü",
      "Sarık Köyü",
      "Şuhut Osb Mah (belkaracaören Köyü)",
      "Yarımca Köyü",
      "Zafer Mah (anıtkaya Köyü)",
      "Ali İhsan Paşa Mah (nuribey Beldesi)",
      "Fatih Mah (nuribey Beldesi)",
      "Mareşal Fevzi Çakmak Mah (nuribey Beldesi)",
      "Mehmet Akif Mah (nuribey Beldesi)",
      "Barbaros Mah (salar Beldesi)",
      "Fatih Mah (salar Beldesi)",
      "Gümüş Tepe Mah (salar Beldesi)",
      "Halil İbrahim Sultan Mah (salar Beldesi)",
      "Yavuz Selim Mah (salar Beldesi)",
      "Gökhan Mah (susuz Beldesi)",
      "Osmanlı Mah (susuz Beldesi)",
      "Sakarya Mah (susuz Beldesi)",
      "Selçuklu Mah (susuz Beldesi)",
      "Altındağ Mah (sülümenli Beldesi)",
      "Cumhuriyet Mah (sülümenli Beldesi)",
      "İstiklal Mah (sülümenli Beldesi)",
      "Şeker Mah (sülümenli Beldesi)",
      "Ulucami Mah (sülümenli Beldesi)",
      "Zafer Mah (sülümenli Beldesi)",
      "Gültepe Mah (sülün Beldesi)",
      "Hisar Mah (sülün Beldesi)",
      "Afyonkarahisar Osb Mah",
      "Ali Çetinkaya Mah",
      "Battalgazi Mah",
      "Dörtyol Mah",
      "Erenler Mah",
      "Ertuğrul Gazi Mah",
      "Karşıyaka Mah",
      "Orhangazi Mah",
      "Osman Gazi Mah",
      "Selçuklu Mah",
      "Yenice Mah",
      "Yeşilyurt Mah"
    ],
    "Sandıklı": [
      "Çiğiltepe Mah (akharım Beldesi)",
      "Dikmen Mah (akharım Beldesi)",
      "Hisar Mah (akharım Beldesi)",
      "Akin Köyü",
      "Alacami Köyü",
      "Alagöz Köyü",
      "Alamescit Köyü",
      "Arızlar Köyü",
      "Asmacık Köyü",
      "Bahçeli Mah (örenkaya Köyü)",
      "Başkuyucak Köyü",
      "Baştepe Köyü",
      "Bekteş Köyü",
      "Celiloğlu Köyü",
      "Cumhuriyet Mah (ballık Köyü)",
      "Cumhuriyet Mah (başağaç Köyü)",
      "Cumhuriyet Mah (karadirek Köyü)",
      "Cumhuriyet Mah (kusura Köyü)",
      "Cumhuriyet Mah (yavaşlar Köyü)",
      "Çambeyli Köyü",
      "Çamoğlu Köyü",
      "Çevrepınar Köyü",
      "Çiğiltepe Köyü",
      "Çukurca Köyü",
      "Daylık Köyü",
      "Dodurga Köyü",
      "Dutağaç Köyü",
      "Ekinhisar Köyü",
      "Emek Mah (sorkun Köyü)",
      "Emirhisar Köyü",
      "Esentepe Mah (ballık Köyü)",
      "Fatih Mah (kusura Köyü)",
      "Fatih Mah (menteş Köyü)",
      "Gökçealan Köyü",
      "Güney Mah (kızık Köyü)",
      "Gürsu Köyü",
      "Hırka Köyü",
      "Hisar Mah (yavaşlar Köyü)",
      "Hürriyet Mah (karadirek Köyü)",
      "Hürriyet Mah (kusura Köyü)",
      "Hürriyet Mah (menteş Köyü)",
      "İstiklal Mah (başağaç Köyü)",
      "İstiklal Mah (karadirek Köyü)",
      "Karacaören Köyü",
      "Karasandıklı Köyü",
      "Karkın Köyü",
      "Kestel Mah (sorkun Köyü)",
      "Kınık Köyü",
      "Kızılca Köyü",
      "Koçgazi Köyü",
      "Koçhisar Köyü",
      "Kozvan Köyü",
      "Kurtuluş Mah (yavaşlar Köyü)",
      "Kuzey Mah (kızık Köyü)",
      "Nasuhoğlu Köyü",
      "Nur Mah (örenkaya Köyü)",
      "Oda Köyü",
      "Orta Mah (kızık Köyü)",
      "Otluk Köyü",
      "Örmekuyu Köyü",
      "Reşadiye Köyü",
      "Saltık Köyü",
      "Selçik Köyü",
      "Soğucak Köyü",
      "Susuz Köyü",
      "Şafak Mah (başağaç Köyü)",
      "Şeyhyahşi Köyü",
      "Ülfeciler Köyü",
      "Ürküt Köyü",
      "Yanıkören Köyü",
      "Yayman Köyü",
      "Yolkonak Köyü",
      "Yumruca Köyü",
      "Yükseliş Mah (sorkun Köyü)",
      "Zafer Mah (ballık Köyü)",
      "Cuma Mah",
      "Çakır Mah",
      "Çay Mah",
      "Ece Mah",
      "Fatih Mah",
      "Hisar Mah",
      "İstasyon Mah",
      "Kevser Mah",
      "Sandıklı Osb Mah",
      "Sazak Mah",
      "Şirinevler Mah",
      "Tapduk Emre Mah",
      "Yunus Emre Mah",
      "Zafer Mah"
    ],
    "Sinanpaşa": [
      "Çiğiltepe Mah (ahmetpaşa Beldesi)",
      "Dibekbaşı Mah (ahmetpaşa Beldesi)",
      "Gölcük Mah (ahmetpaşa Beldesi)",
      "Halkalı Mah (ahmetpaşa Beldesi)",
      "Küçüktepe Mah (ahmetpaşa Beldesi)",
      "Yukarı Mah (ahmetpaşa Beldesi)",
      "Bağdat Mah (akören Beldesi)",
      "Fatih Mah (akören Beldesi)",
      "Yıldırım Beyazıt Mah (akören Beldesi)",
      "Cumhuriyet Mah (düzağaç Beldesi)",
      "Fatih Mah (düzağaç Beldesi)",
      "Işık Mah (düzağaç Beldesi)",
      "Zafer Mah (düzağaç Beldesi)",
      "Aşağı Mah (güney Beldesi)",
      "Çalışlar Mah (güney Beldesi)",
      "Orta Mah (güney Beldesi)",
      "Yeni Mah (güney Beldesi)",
      "Yukarı Mah (güney Beldesi)",
      "Atatürk Mah (kılıçarslan Beldesi)",
      "Cumhuriyet Mah (kılıçarslan Beldesi)",
      "Fevzi Çakmak Mah (kılıçarslan Beldesi)",
      "Kocatepe Mah (kılıçarslan Beldesi)",
      "Atatürk Mah (kırka Beldesi)",
      "Fatih Mah (kırka Beldesi)",
      "Yavuz Sultan Selim Mah (kırka Beldesi)",
      "Yıldırım Beyazıt Mah (kırka Beldesi)",
      "Atatürk Mah (küçükhüyük Beldesi)",
      "Cumhuriyet Mah (küçükhüyük Beldesi)",
      "Fatih Mah (küçükhüyük Beldesi)",
      "Kurtuluş Mah (küçükhüyük Beldesi)",
      "Zafer Mah (küçükhüyük Beldesi)",
      "Akçaşar Köyü",
      "Akdeğirmen Köyü",
      "Atatürk Mah (tokuşlar Köyü)",
      "Ayvalı Köyü",
      "Bahçelievler Mah (nuh Köyü)",
      "Balmahmut Köyü",
      "Baltepe Mah (kınık Köyü)",
      "Başkimse Köyü",
      "Bayrak Mah (kınık Köyü)",
      "Boyalı Köyü",
      "Bulca Köyü",
      "Cami Mah (kınık Köyü)",
      "Cumhuriyet Mah (nuh Köyü)",
      "Cumhuriyet Mah (tokuşlar Köyü)",
      "Çamtepe Mah (kınık Köyü)",
      "Çatkuyu Köyü",
      "Çayhisar Köyü",
      "Çayır Mah (kınık Köyü)",
      "Çobanözü Köyü",
      "Dede Mah (kınık Köyü)",
      "Elvanpaşa Köyü",
      "Eyice Köyü",
      "Garipce Köyü",
      "Gezler Köyü",
      "Hürriyet Mah (nuh Köyü)",
      "İğdeli Köyü",
      "İstiklal Mah (nuh Köyü)",
      "Karaca Ören Köyü",
      "Kayadibi Köyü",
      "Saraycık Köyü",
      "Tazlar Köyü",
      "Yıldırım Kemal Köyü",
      "Yörük Mezarı Köyü",
      "Zafer Mah (kınık Köyü)",
      "Cumhuriyet Mah (serban Beldesi)",
      "Hisar Mah (serban Beldesi)",
      "Hozman Mah (serban Beldesi)",
      "Köprübaşı Mah (serban Beldesi)",
      "Kümbet Mah (serban Beldesi)",
      "Orta Mah (serban Beldesi)",
      "Akpınar Mah",
      "Ali Çetinkaya Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Çiğiltepe Mah",
      "Fatih Mah",
      "Öğretmenler Mah",
      "Yukarı Mah",
      "Bahçelievler Mah (taşoluk Beldesi)",
      "Cumhuriyet Mah (taşoluk Beldesi)",
      "Çankaya Mah (taşoluk Beldesi)",
      "Çınarlı Mah (taşoluk Beldesi)",
      "Hürriyet Mah (taşoluk Beldesi)",
      "Yeni Mah (taşoluk Beldesi)",
      "Ambar Mah (tınaztepe Beldesi)",
      "Bahçelievler Mah (tınaztepe Beldesi)",
      "Fatih Mah (tınaztepe Beldesi)",
      "Saray Mah (tınaztepe Beldesi)",
      "Yeni Mah (tınaztepe Beldesi)",
      "Zafer Mah (tınaztepe Beldesi)"
    ],
    "Sultandağı": [
      "Atatürk Mah (dereçine Beldesi)",
      "Camikebir Mah (dereçine Beldesi)",
      "Cumhuriyet Mah (dereçine Beldesi)",
      "Karaman Mah (dereçine Beldesi)",
      "Kavaklı Mah (dereçine Beldesi)",
      "Akbaba Köyü",
      "Bahçelievler Mah (kırca Köyü)",
      "Balaban Mah (çukurcak Köyü)",
      "Cumhuriyet Mah (karapınar Köyü)",
      "Çağlayan Mah (kırca Köyü)",
      "Çamözü Köyü",
      "Çınarlı Mah (üçkuyu Köyü)",
      "Çukurcak Köyü",
      "Doğancık Köyü",
      "Hisar Mah (kırca Köyü)",
      "İmam Aziz Mah (yakasinek Köyü)",
      "İnönü Mah (karapınar Köyü)",
      "Karakışla Köyü",
      "Orta Mah (yakasinek Köyü)",
      "Pınarlı Mah (üçkuyu Köyü)",
      "Selçuk Mah",
      "Selçuk Mah (karapınar Köyü)",
      "Taşköprü Köyü",
      "Ulupınar Mah (yakasinek Köyü)",
      "Yeni Mah (yakasinek Köyü)",
      "Yenikarabağ Köyü",
      "Yeşilyurt Mah (üçkuyu Köyü)",
      "Çavuş Mah",
      "Kayran Mah",
      "Pazaraltı Mah",
      "Yeni Mah",
      "Yıldırım Mah",
      "Akpınar Mah (yeşilçiftlik Beldesi)",
      "Aşağı Mah (yeşilçiftlik Beldesi)",
      "Sıra Mah (yeşilçiftlik Beldesi)",
      "Tepebaşı Mah (yeşilçiftlik Beldesi)",
      "Yenikent Mah (yeşilçiftlik Beldesi)",
      "Yıldız Mah (yeşilçiftlik Beldesi)",
      "Yukarı Mah (yeşilçiftlik Beldesi)"
    ],
    "Şuhut": [
      "Çağlayan Mah (karaadilli Beldesi)",
      "Develi Mah (karaadilli Beldesi)",
      "Erenler Mah (karaadilli Beldesi)",
      "Zafer Mah (karaadilli Beldesi)",
      "Ağzıkara Köyü",
      "Aharoluk Mah (ortapınar Köyü)",
      "Akkaya Mah (koçyatağı Köyü)",
      "Akyatak Mah (koçyatağı Köyü)",
      "Akyuva Köyü",
      "Anayurt Köyü",
      "Arapoğlu Mah (dadak Köyü)",
      "Arızlı Köyü",
      "Atatürk Mah (efe Köyü)",
      "Atatürk Mah (kayabelen Köyü)",
      "Aydın Köyü",
      "Bademli Köyü",
      "Ballık Mah (dadak Köyü)",
      "Başarap Mah (koçyatağı Köyü)",
      "Başören Köyü",
      "Başyer Mah (dadak Köyü)",
      "Bozan Köyü",
      "Bürçek Mah (çakırözü Köyü)",
      "Cumhuriyet Mah (karacaören Köyü)",
      "Cumhuriyet Mah (kayabelen Köyü)",
      "Çakırözü Köyü",
      "Çallıoğlu Mah (dadak Köyü)",
      "Çanakpınarı Mah (koçyatağı Köyü)",
      "Çobankaya Köyü",
      "Dadak Köyü",
      "Demirbel Köyü",
      "Dolapderesi Mah (koçyatağı Köyü)",
      "Efe Sultan Mah (efe Köyü)",
      "Fatih Mah (atlıhisar Köyü)",
      "Fatih Mah (efe Köyü)",
      "Fatih Mah (karacaören Köyü)",
      "Gavuröreni Mah (koçyatağı Köyü)",
      "Güldede Mah (balçıkhisar Köyü)",
      "Güneytepe Köyü",
      "Hallaç Köyü",
      "Hisar Mah (atlıhisar Köyü)",
      "Hürriyet Mah (karacaören Köyü)",
      "İcikli Köyü",
      "İlyaslı Köyü",
      "İsalı Köyü",
      "İsmet İnönü Mah (kayabelen Köyü)",
      "İstiklal Mah (balçıkhisar Köyü)",
      "Karahallı Köyü",
      "Karlık Köyü",
      "Kavaklı Köyü",
      "Kayapınar Mah (ortapınar Köyü)",
      "Kılınçkaya Köyü",
      "Koçyatağı Köyü",
      "Kulak Köyü",
      "Mahmut Köyü",
      "Mauşan Mah (koçyatağı Köyü)",
      "Ortapınar Köyü",
      "Oynağan Köyü",
      "Örencik Mah (koçyatağı Köyü)",
      "Paşacık Köyü",
      "Sarıyar Mah (koçyatağı Köyü)",
      "Satılmış Mah (koçyatağı Köyü)",
      "Senir Köyü",
      "Siyek Mah (dadak Köyü)",
      "Suludere Mah (koçyatağı Köyü)",
      "Şahbendi Mah (ortapınar Köyü)",
      "Taşoluk Mah (koçyatağı Köyü)",
      "Tekke Köyü",
      "Tilkideresi Mah (koçyatağı Köyü)",
      "Toprakpınar Mah (ortapınar Köyü)",
      "Uzunpınar Köyü",
      "Üçin Mah (çakırözü Köyü)",
      "Yarışlı Köyü",
      "Yayla Mah (çakırözü Köyü)",
      "Yeni Mah (balçıkhisar Köyü)",
      "Yeni Mah (efe Köyü)",
      "Yeni Mah (karacaören Köyü)",
      "Yeni Mah (kayabelen Köyü)",
      "Zafer Mah (atlıhisar Köyü)",
      "Zafer Mah (balçıkhisar Köyü)",
      "Altıgöz Mah",
      "Baş Mah",
      "Gazipaşa Mah",
      "Hacı Musa Mah",
      "Hisar Mah",
      "İplik Mah",
      "İstiklal Mah",
      "Kurtuluş Mah",
      "Mehmet Akif Ersoy Mah",
      "Pazar Mah",
      "Taşlıca Mah",
      "Yalı Mah",
      "Zafer Mah"
    ]
  },
  "Ağrı": {
    "Diyadin": [
      "14 Nisan Mah",
      "Atatürk Mah",
      "Fatih Mah",
      "Göl Mah",
      "İsaağa Mah",
      "Ketenpınar Mah",
      "Murat Mah",
      "Abdulkadir Çetin Mah (sürmelikoç Köyü)",
      "Adakent Mah (davut Köyü)",
      "Ahmet Işık Mah (sürmelikoç Köyü)",
      "Akbıyık Mah (pirali Köyü)",
      "Akçay Mah (sürenkök Köyü)",
      "Akçevre Köyü",
      "Akyolaç Köyü",
      "Alaçayır Mah (dedebulak Köyü)",
      "Altınkilit Köyü",
      "Altınkilit Mah (altınkilit Köyü)",
      "Amereşk Mah (sürmelikoç Köyü)",
      "Apro Mah (mutlu Köyü)",
      "Aşağı Köh Mah (dedebulak Köyü)",
      "Aşağı Uğur Mah (dedebulak Köyü)",
      "Aşağıakpazar Köyü",
      "Aşağıdalören Köyü",
      "Aşağıkardeşli Köyü",
      "Aşağıtütek Köyü",
      "Atadamı Köyü",
      "Atayolu Köyü",
      "Batıbeyli Köyü",
      "Beşevler Mah (büvetli Köyü)",
      "Beşevler Mah (sürmelikoç Köyü)",
      "Beyaztaş Mah (atayolu Köyü)",
      "Boyalan Köyü",
      "Budak Köyü",
      "Buğdaylı Mah (dedebulak Köyü)",
      "Burgulu Köyü",
      "Büvetli Köyü",
      "Cumhuriyet Mah (taşkesen Köyü)",
      "Çifçi Mah (günbuldu Köyü)",
      "Davut Köyü",
      "Dedebulak Köyü",
      "Delihasan Köyü",
      "Dibekli Köyü",
      "Dokuztaş Köyü",
      "Durak Mah (batıbeyli Köyü)",
      "Gedik Köyü",
      "Göğebakan Köyü",
      "Gözüpek Köyü",
      "Gulebıst Mah (günbuldu Köyü)",
      "Gültepe Mah (akyolaç Köyü)",
      "Günbuldu Köyü",
      "Hacıhalit Köyü",
      "Harabe Mah (taşbasamak Köyü)",
      "Hası Kali Komu Mah (sürmelikoç Köyü)",
      "Heybeliyurt Köyü",
      "İbrahim Komu Mah (yeniçadır Köyü)",
      "İpek Mah (yeniçadır Köyü)",
      "İsaağa Köyü",
      "İsaselam Mah (yanıkçukur Köyü)",
      "Kamil Işık Komu Mah (sürmelikoç Köyü)",
      "Kapanca Köyü",
      "Kaplıca Mah (davut Köyü)",
      "Kaplıca Mah (kuşburnu Köyü)",
      "Karapazar Köyü",
      "Karataş Köyü",
      "Kaynaklı Mah (dedebulak Köyü)",
      "Kezo Mah (yukarıtütek Köyü)",
      "Kırmızı Kom Mah (mutlu Köyü)",
      "Kocaçoban Köyü",
      "Kom Mah (sürenkök Köyü)",
      "Kotancı Köyü",
      "Kurt Dere Mah (sürmelikoç Köyü)",
      "Kuşburnu Köyü",
      "Kuşlu Köyü",
      "Mecburiyet Mah (heybeliyurt Köyü)",
      "Mollakara Köyü",
      "Mutlu Köyü",
      "Oğuloba Köyü",
      "Omuzbaşı Köyü",
      "Otlubayır Mah (oğuloba Köyü)",
      "Pirali Köyü",
      "Rahmankulu Köyü",
      "Saitbey Mah (yanıkçukur Köyü)",
      "Satıcılar Köyü",
      "Seyitler Mah (yeniçadır Köyü)",
      "Soğuksu Köyü",
      "Sürenkök Köyü",
      "Sürmelikoç Köyü",
      "Şahinbey Mah (dedebulak Köyü)",
      "Şahinşah Köyü",
      "Şekerbulak Köyü",
      "Tarım Mah (günbuldu Köyü)",
      "Tarlabaşı Mah (batıbeyli Köyü)",
      "Taşbasamak Köyü",
      "Taşkesen Köyü",
      "Tazekent Köyü",
      "Teyip Mah (sürenkök Köyü)",
      "Toklucak Köyü",
      "Ulukent Köyü",
      "Uysallı Köyü",
      "Yanıkçukur Köyü",
      "Yeniçadır Köyü",
      "Yeşildurak Köyü",
      "Yıldırım Köyü",
      "Yıldız Köyü",
      "Yol Boyu Mah (yeşildurak Köyü)",
      "Yol Mah (omuzbaşı Köyü)",
      "Yol Üstü Mah (yeniçadır Köyü)",
      "Yolcupınarı Köyü",
      "Yörükatlı Köyü",
      "Yukarı Kardeşli Mah (aşağıkardeşli Köyü)",
      "Yukarı Köh Mah (dedebulak Köyü)",
      "Yukarı Mah (yeşildurak Köyü)",
      "Yukarı Satıcılar Mah (satıcılar Köyü)",
      "Yukarı Uğur Mah (dedebulak Köyü)",
      "Yukarıakpazar Köyü",
      "Yukarıdalören Köyü",
      "Yukarıtütek Köyü",
      "Yuva Köyü",
      "Yüceler Mah (akçevre Köyü)",
      "Zorava Mah (boyalan Köyü)"
    ],
    "Doğubayazıt": [
      "Abdigör Mah",
      "Ahmedihani Mah",
      "Barış Mah",
      "Büyük Ağrı Mah",
      "Çiftepınar Mah",
      "Hasankeyf Mah",
      "Hürriyet Mah",
      "İshakpaşa Mah",
      "Koçkıran Mah",
      "Sanayi Mah",
      "Sarıgül Mah",
      "Uluyol Mah",
      "Vatan Mah",
      "Yeni Mah",
      "Ağa Mah (üçgöze Köyü)",
      "Akçukur Mah (yanoba Köyü)",
      "Aktarla Köyü",
      "Aktuğlu Köyü",
      "Alıntepe Köyü",
      "Altun Tepe Mah (günyolu Köyü)",
      "Arpalı Mah (ayrancı Köyü)",
      "Aş.küçük Yılanlı Mah (yılanlı Köyü)",
      "Aşağı Güngören Mah (güngören Köyü)",
      "Aşağıtavla Köyü",
      "Atabakan Köyü",
      "Aydoğan Mah (ortadirek Köyü)",
      "Ayrancı Köyü",
      "Bardaklı Köyü",
      "Barındı Köyü",
      "Başköy Köyü",
      "Bedir Mah (bardaklı Köyü)",
      "Bekirağıl Mah (gölyüzü Köyü)",
      "Bereket Köyü",
      "Besler Köyü",
      "Bezirhane Köyü",
      "Binkaya Köyü",
      "Bozkurt Köyü",
      "Bozyayla Köyü",
      "Bölücek Köyü",
      "Bulakbaşı Köyü",
      "Buyuretti Köyü",
      "Cebekümbet Mah (çiftlik Köyü)",
      "Çalıköy Köyü",
      "Çatkıran Mah (yaygınyurt Köyü)",
      "Çayır Mah (örmeli Köyü)",
      "Çetenli Köyü",
      "Çevirme Mah (gölyüzü Köyü)",
      "Çiftlik Köyü",
      "Çömçeli Köyü",
      "Dağdelen Köyü",
      "Dalbahçe Köyü",
      "Darık Mah (esnemez Köyü)",
      "Demir Kapı Mah (yaygınyurt Köyü)",
      "Demir Kılıç Mah (bulakbaşı Köyü)",
      "Demirtepe Köyü",
      "Dolaklı Köyü",
      "Dostali Köyü",
      "Duryan Mah (günyolu Köyü)",
      "Elle Mah (gölyüzü Köyü)",
      "Eskisu Köyü",
      "Esnemez Köyü",
      "Gır Mah (güngören Köyü)",
      "Gökçebulak Mah (çetenli Köyü)",
      "Gökçekaynak Köyü",
      "Göksügüzel Mah (örmeli Köyü)",
      "Göller Köyü",
      "Gölyüzü Köyü",
      "Gözükara Köyü",
      "Güllüce Köyü",
      "Gültepe Köyü",
      "Güngören Köyü",
      "Günyolu Köyü",
      "Gürbulak Köyü",
      "Güzel Mah (yaygınyurt Köyü)",
      "Halaç Köyü",
      "Haso Mah (seslitaş Köyü)",
      "İncesu Köyü",
      "Kale Mah (günyolu Köyü)",
      "Kalecik Köyü",
      "Kalhasan Mah (güngören Köyü)",
      "Karabulak Köyü",
      "Karaburun Köyü",
      "Karaca Köyü",
      "Karakent Köyü",
      "Karaşeyh Köyü",
      "Kargakonmaz Köyü",
      "Kazan Köyü",
      "Kesme Taş Mah (bulakbaşı Köyü)",
      "Kızılkaya Köyü",
      "Konut Mah (yağmurdüşen Köyü)",
      "Konutlar Mah (seslitaş Köyü)",
      "Körük Mah (günyolu Köyü)",
      "Kucak Köyü",
      "Kurutepe Mah (tanıktepe Köyü)",
      "Kutlubulak Köyü",
      "Küçük Uzun Yazı Mah (uzunyazı Köyü)",
      "Küçük Yılanlı Mah (yılanlı Köyü)",
      "Künütepe Mah (tanıktepe Köyü)",
      "Küplü Mah (sağlıksuyu Köyü)",
      "Melikşah Köyü",
      "Mescitköy Köyü",
      "Mirağıl Mah (gölyüzü Köyü)",
      "Ortaca Mah (karaburun Köyü)",
      "Ortadirek Köyü",
      "Ortaköy Köyü",
      "Ömerbey Mah (karaşeyh Köyü)",
      "Örmeli Köyü",
      "Örtülü Köyü",
      "Pullutarla Köyü",
      "Rızde Mah (üzengili Köyü)",
      "Sağdıç Köyü",
      "Sağlıksuyu Köyü",
      "Samanlı Mah (bezirhane Köyü)",
      "Sarıbıyık Köyü",
      "Sarıçavuş Köyü",
      "Sazoba Köyü",
      "Seslitaş Köyü",
      "Somkaya Köyü",
      "Subeşiği Köyü",
      "Suluçem Köyü",
      "Sütcü Mah (yaygınyurt Köyü)",
      "Şevket Mah (yağmurdüşen Köyü)",
      "Tab Mah (yalınsaz Köyü)",
      "Tanıktepe Köyü",
      "Taşlı Mah (çalıköy Köyü)",
      "Telçeker Köyü",
      "Tepeli Mah (çalıköy Köyü)",
      "Tımır Mah (seslitaş Köyü)",
      "Topçatan Köyü",
      "Tutak Köyü",
      "Tutumlu Köyü",
      "Türkmen Mah (çiftlik Köyü)",
      "Uğrak Mah (mescitköy Köyü)",
      "Uzunyazı Köyü",
      "Üçgöze Köyü",
      "Üçmurat Köyü",
      "Üzengili Köyü",
      "Yağmurdüşen Köyü",
      "Yakacık Mah (güngören Köyü)",
      "Yalınsaz Köyü",
      "Yanoba Köyü",
      "Yaygınyurt Köyü",
      "Yeniharman Köyü",
      "Yeniköy Mah (atabakan Köyü)",
      "Yığınçal Köyü",
      "Yiğityatağı Köyü",
      "Yolüstü Mah (karaşeyh Köyü)",
      "Yukarı Melikşah Mah (melikşah Köyü)",
      "Yukarıtavla Köyü",
      "Ziyaret Mah (sağlıksuyu Köyü)"
    ],
    "Eleşkirt": [
      "Esentepe Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karşıyaka Mah",
      "Kazım Karabekir Mah",
      "Lozan Mah",
      "Müftüselim Mah",
      "Abdiköy Köyü",
      "Akyumak Köyü",
      "Akyumak Mezrası Mah (akyumak Köyü)",
      "Alagün Köyü",
      "Ali Paşa Mah (mollasüleyman Köyü)",
      "Alkuşak Köyü",
      "Arifbey Köyü",
      "Aşağıkopuz Köyü",
      "Aydoğdu Köyü",
      "Çatalpınar Köyü",
      "Çatkösedağ Köyü",
      "Çetinsu Köyü",
      "Çiftepınar Köyü",
      "Dalkılıç Konutlar Mah (dalkılıç Köyü)",
      "Dalkılıç Köyü",
      "Değirmenoluğu Köyü",
      "Dolutaş Köyü",
      "Düzağıl Köyü",
      "Düzyayla Köyü",
      "Ergözü Köyü",
      "Eyüpkomu Mah (yağmurlu Köyü)",
      "Goncalı Köyü",
      "Gözaydın Köyü",
      "Güneykaya Köyü",
      "Güvence Köyü",
      "Han Mah (yukarıkopuz Köyü)",
      "Harebegül Mah (aydoğdu Köyü)",
      "Hasanpınarı Köyü",
      "Haydaroğlu Köyü",
      "Hayrangöl Köyü",
      "Hürriyet Köyü",
      "İkizgeçe Köyü",
      "İkizgöl Köyü",
      "İndere Köyü",
      "Kanatgeren Köyü",
      "Karabacak Köyü",
      "Kayayolu Köyü",
      "Kokulupınar Köyü",
      "Körpeçayır Köyü",
      "Mollahüseyin Köyü",
      "Mollasüleyman Köyü",
      "Öztoprak Köyü",
      "Palakçayırı Köyü",
      "Pirabat Köyü",
      "Posto Mah (goncalı Köyü)",
      "Ramazan Köyü",
      "Sadaklı Köyü",
      "Salkımlı Köyü",
      "Sarıköy Köyü",
      "Söbetaş Köyü",
      "Sultanabat Köyü",
      "Süzgeçli Köyü",
      "Toprakkale Köyü",
      "Türkeli Köyü",
      "Uludal Köyü",
      "Uzunyazı Köyü",
      "Yağmurlu Köyü",
      "Yanıkdere Köyü",
      "Yelkesen Köyü",
      "Yeşilova Köyü",
      "Yığıntaş Köyü",
      "Yukarıkopuz Köyü",
      "Aydıntepe Mah (tahir Beldesi)",
      "Karşıyaka Mah (tahir Beldesi)",
      "Yeşil Mah (tahir Beldesi)",
      "Aşağıcihanbey Mah (yayladüzü Beldesi)",
      "Cumhuriyet Mah (yayladüzü Beldesi)",
      "Değirmengeçidi Mah (yayladüzü Beldesi)",
      "Gökçayır Mah (yayladüzü Beldesi)",
      "Karşıyaka Mah (yayladüzü Beldesi)",
      "Esentepe Mah (yücekapı Beldesi)",
      "Oklavalı Mah (yücekapı Beldesi)",
      "Şehit Engin Mah (yücekapı Beldesi)",
      "Yeşilyurt Mah (yücekapı Beldesi)"
    ],
    "Hamur": [
      "Buzhane Mah",
      "Kale Mah",
      "Kümbet Mah",
      "Yeni Mah",
      "Abdiçıkmaz Köyü",
      "Adımova Köyü",
      "Akören Mah (karakazan Köyü)",
      "Akyurt Köyü",
      "Alakoyun Köyü",
      "Aliağa Mah (kılıç Köyü)",
      "Altın Yurt Mah (özdirek Köyü)",
      "Aş Koyuncu Mah (süleymankümbet Köyü)",
      "Aşağı Göze Mah (gültepe Köyü)",
      "Aşağı Kayalar Mah (yukarıgözlüce Köyü)",
      "Aşağı Mollahasan Mah (yuvacık Köyü)",
      "Aşağı Yurt Mah (süleymankümbet Köyü)",
      "Aşağıaladağ Köyü",
      "Aşağıderedibi Köyü",
      "Aşağıgözlüce Köyü",
      "Aşağıkarabal Köyü",
      "Aşağıyenigün Köyü",
      "Aydınlar Mah (yuvacık Köyü)",
      "Ayvacık Köyü",
      "Baldere Köyü",
      "Bekciler Mezrası Mah (yuvacık Köyü)",
      "Beklemez Köyü",
      "Bozo Çayırı Mah (karakazan Köyü)",
      "Boztepe Mah (gümüşkuşak Köyü)",
      "Ceylanlı Köyü",
      "Çağlayan Köyü",
      "Çeşme Mah (esenören Köyü)",
      "Danacık Mah (karakazan Köyü)",
      "Danakıran Köyü",
      "Demirkapı Köyü",
      "Ekincik Köyü",
      "Erdoğan Köyü",
      "Esenören Köyü",
      "Gome Mah (baldere Köyü)",
      "Güllüce Mah (nallıkonak Köyü)",
      "Gültepe Köyü",
      "Gümüşkuşak Köyü",
      "Güveç Mah (aşağıyenigün Köyü)",
      "Hanik Mah (süleymankümbet Köyü)",
      "Kaçmaz Köyü",
      "Kamışlı Köyü",
      "Kandildağı Köyü",
      "Karadere Mah (süleymankümbet Köyü)",
      "Karadoğu Köyü",
      "Karakazan Köyü",
      "Karaseyitali Köyü",
      "Kardeşler Mah (beklemez Köyü)",
      "Karlıca Köyü",
      "Kayalar Mah (esenören Köyü)",
      "Kaynaklı Köyü",
      "Keleşkom Mah (yuvacık Köyü)",
      "Kılıç Köyü",
      "Köşk Köyü",
      "Kuncık Mah (aşağıderedibi Köyü)",
      "Mezra Mah (seyithanbey Köyü)",
      "Musabey Mah (ayvacık Köyü)",
      "Nallıkonak Köyü",
      "Nenik Mah (esenören Köyü)",
      "Oluklu Mah (özdirek Köyü)",
      "Orta Mollahasan Mah (yuvacık Köyü)",
      "Ortaköy Mah (ceylanlı Köyü)",
      "Ovakent Mah (abdiçıkmaz Köyü)",
      "Ömerşaban Mah (erdoğan Köyü)",
      "Örenli Mah (özdirek Köyü)",
      "Özdirek Köyü",
      "Sarıbuğday Köyü",
      "Selim Mah (esenören Köyü)",
      "Seslidoğan Köyü",
      "Seyithanbey Köyü",
      "Soğanlıtepe Köyü",
      "Süleymankümbet Köyü",
      "Şehit Mah (karakazan Köyü)",
      "Şikeft Mah (yuvacık Köyü)",
      "Tatlısu Mah (ceylanlı Köyü)",
      "Tazeköy Mah (ceylanlı Köyü)",
      "Tepecik Mah (abdiçıkmaz Köyü)",
      "Toklu Mah (yuvacık Köyü)",
      "Tutak Mah (yukarıyenigün Köyü)",
      "Tükenmez Köyü",
      "Uğurtaş Köyü",
      "Uzun Çeşme Mah (aşağıyenigün Köyü)",
      "Uzun Çeşme Mah (yukarıaladağ Köyü)",
      "Üç Evler Mah (süleymankümbet Köyü)",
      "Yamaç Mah (ekincik Köyü)",
      "Yapılı Köyü",
      "Yazılı Mah (karakazan Köyü)",
      "Yeşil Mah (yukarıyenigün Köyü)",
      "Yk Kuyuncu Mah (süleymankümbet Köyü)",
      "Yk Yurt Mah (süleymankümbet Köyü)",
      "Yk. Mollahasan Mah (yuvacık Köyü)",
      "Yoğunhisar Köyü",
      "Yoğurtçu Mah (gültepe Köyü)",
      "Yukarı Deredibi Mah (aşağıderedibi Köyü)",
      "Yukarı Göze Mah (gültepe Köyü)",
      "Yukarı Kaya Mah (gültepe Köyü)",
      "Yukarıaladağ Köyü",
      "Yukarıekincik Mah (ekincik Köyü)",
      "Yukarıgözlüce Köyü",
      "Yukarıtepecik Mah (abdiçıkmaz Köyü)",
      "Yukarıyenigün Köyü",
      "Yuvacık Köyü"
    ],
    "Merkez": [
      "100.yıl Mah",
      "Alpaslan Mah",
      "Cumhuriyet Mah",
      "Fevzi Çakmak Mah",
      "Fırat Mah",
      "Kurtuluş Mah",
      "Mehmet Akif Ersoy Mah",
      "Murat Mah",
      "Abide Mah",
      "Aşağıküpkıran Mah",
      "Bahçelievler Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Hürriyet Mah",
      "Kazım Karabekir Mah",
      "Leylek Pınar Mah",
      "Sıtkıye Mah",
      "Yavuz Mah",
      "Ağılbaşı Köyü",
      "Ağrı Osb Mah (murat Köyü)",
      "Ahmetbey Köyü",
      "Akbulgur Köyü",
      "Akçay Köyü",
      "Altınçayır Mah (kocataş Köyü)",
      "Anakaya Köyü",
      "Arakonak Köyü",
      "Arap Mah (çobanbeyi Köyü)",
      "Aslangazi Köyü",
      "Aşağı Pınar Mah (uzunveli Köyü)",
      "Aşağıağadeve Köyü",
      "Aşağıdürmeli Köyü",
      "Aşağıkent Köyü",
      "Aşağıpamuktaş Köyü",
      "Aşağısaklıca Köyü",
      "Aşağısubaşı Mah (kovancık Köyü)",
      "Aşağıyoldüzü Köyü",
      "Aşkale Köyü",
      "Ayranlı Mah (kovancık Köyü)",
      "Badıllı Köyü",
      "Balıksu Köyü",
      "Balkaynak Köyü",
      "Ballıbostan Köyü",
      "Baloluk Köyü",
      "Başçavuş Köyü",
      "Başkent Köyü",
      "Beşbulak Köyü",
      "Beşiktepe Köyü",
      "Bezirhane Köyü",
      "Boztoprak Köyü",
      "Bölükbaşı Köyü",
      "Cumaçay Köyü",
      "Çakıroba Köyü",
      "Çamurlu Köyü",
      "Çatalipaşa Köyü",
      "Çayır Mah (oğlaklı Köyü)",
      "Çayırköy Köyü",
      "Çobanbeyi Köyü",
      "Çukuralan Köyü",
      "Çukurçayır Köyü",
      "Darboğaz Mah (yukarıağadeve Köyü)",
      "Darıca Mah (kovancık Köyü)",
      "Dedemaksut Köyü",
      "Doğutepe Köyü",
      "Dönerdere Köyü",
      "Dumanlı Köyü",
      "Eğribelen Köyü",
      "Eliaçık Köyü",
      "Esen Köy Mah (esenköy Köyü)",
      "Esenköy Köyü",
      "Eskiharman Köyü",
      "Ferhat Mah (sarıca Köyü)",
      "Geçitalan Köyü",
      "Gölsevti Mah (kovancık Köyü)",
      "Gülçimen Mah (yukarıağadeve Köyü)",
      "Gümüşyazı Köyü",
      "Güneysu Köyü",
      "Güvendik Köyü",
      "Güvenli Köyü",
      "Hacısefer Köyü",
      "Hanoba Köyü",
      "Hıdır Köyü",
      "Kalender Köyü",
      "Karasu Köyü",
      "Kavacık Köyü",
      "Kavakköy Köyü",
      "Kayabey Köyü",
      "Kazlı Köyü",
      "Kocataş Köyü",
      "Koçbaşı Köyü",
      "Komik Mah (cumaçay Köyü)",
      "Konak Mah (mollaosman Köyü)",
      "Konuktepe Köyü",
      "Kovancık Köyü",
      "Kumlugeçit Köyü",
      "Mamık Mah (aşağısaklıca Köyü)",
      "Mezra Mah (aşağıpamuktaş Köyü)",
      "Mezra Mah (doğutepe Köyü)",
      "Mollaali Köyü",
      "Mollaosman Köyü",
      "Murat Köyü",
      "Murathan Köyü",
      "Oğlaklı Köyü",
      "Ortakent Köyü",
      "Ortayokuş Köyü",
      "Otlubayır Köyü",
      "Ozanlar Köyü",
      "Özbaşı Köyü",
      "Özveren Köyü",
      "Pınarcık Mah (kovancık Köyü)",
      "Reşo Mah (sarıca Köyü)",
      "Sabuncu Köyü",
      "Sağırtaş Köyü",
      "Sarıca Köyü",
      "Sarıdoğan Köyü",
      "Sarıharman Köyü",
      "Sarıtaş Köyü",
      "Soğancumaçay Köyü",
      "Soğanköy Köyü",
      "Söğütlü Köyü",
      "Suçatağı Köyü",
      "Taştekne Köyü",
      "Taypınar Köyü",
      "Tellisırt Köyü",
      "Tezeren Köyü",
      "Uçarkaya Köyü",
      "Üç Evler Mah (murat Köyü)",
      "Yakınca Köyü",
      "Yalnızkonak Köyü",
      "Yayıklı Mah (kovancık Köyü)",
      "Yaylaköy Köyü",
      "Yazıcı Köyü",
      "Yazılı Köyü",
      "Yığıntepe Köyü",
      "Yolluyazı Köyü",
      "Yolugüzel Köyü",
      "Yoncalı Köyü",
      "Yorgunsöğüt Köyü",
      "Yukarı Pınar Mah (uzunveli Köyü)",
      "Yukarı Subaşı Mah (sarıharman Köyü)",
      "Yukarıağadeve Köyü",
      "Yukarıdürmeli Köyü",
      "Yukarıküpkıran Köyü",
      "Yukarıpamuktaş Köyü",
      "Yukarısaklıca Köyü",
      "Yukarıyoldüzü Köyü",
      "Yurtpınar Köyü",
      "Ziyaret Köyü"
    ],
    "Patnos": [
      "Akbulut Mah (dedeli Beldesi)",
      "Arpacık Mah (bozoğlak Köyü)",
      "Balcılar Mah (karbasan Köyü)",
      "Baştarla Köyü",
      "Batıbeyli Mah (bozoğlak Köyü)",
      "Bozoğlak Köyü",
      "Budak Mah (dedeli Beldesi)",
      "Cızvız Mah (pirömer Köyü)",
      "Cumhuriyet Mah (dedeli Beldesi)",
      "Çavuş Mah (bozoğlak Köyü)",
      "Çaybaşı Mah (dedeli Beldesi)",
      "Çiçek Mah (hasandolu Köyü)",
      "Çimenli Köyü",
      "Çukurbağ Köyü",
      "Dambat Mah (baştarla Köyü)",
      "Değirmen Mah (dedeli Beldesi)",
      "Değirmendüzü Köyü",
      "Derecik Köyü",
      "Derekomu Mah (karbasan Köyü)",
      "Eryılmaz Köyü",
      "Fatih Mah (bozoğlak Köyü)",
      "Gündüz Köyü",
      "Hasandolu Köyü",
      "Hisar Köyü",
      "Karbasan Köyü",
      "Kaş Köyü",
      "Keleşler Mezrası Mah (çukurbağ Köyü)",
      "Kızılağıl Mah (değirmendüzü Köyü)",
      "Merkez Mah (dedeli Beldesi)",
      "Meydandağı Köyü",
      "Ortadamla Köyü",
      "Örendik Köyü",
      "Pirömer Köyü",
      "Şeytanova Mah (baştarla Köyü)",
      "Tozbelen Mah (ortadamla Köyü)",
      "Üzümlü Mah (dedeli Beldesi)",
      "Yeşilçimen Mah (bozoğlak Köyü)",
      "Yeşilhisar Köyü",
      "Yeşilova Mah (dedeli Beldesi)",
      "Yk.hırbe Mah (bozoğlak Köyü)",
      "Yukarıdamla Köyü",
      "Zali Mah (derecik Köyü)",
      "Zübeyt Komu Mah (bozoğlak Köyü)",
      "Akçaören Köyü",
      "Akdilek Köyü",
      "Akyemiş Köyü",
      "Alatay Köyü",
      "Andaçlı Köyü",
      "Aşağı Tepe Önü Mah (tanyeli Köyü)",
      "Aşağıgöçmez Köyü",
      "Aşağıkamışlı Köyü",
      "Bahçeli Mah (akdilek Köyü)",
      "Baltacık Köyü",
      "Budak Köyü",
      "Cumhuriyet  Mah (liç Mah) (yalçınkaya Köyü)",
      "Çakırbey Köyü",
      "Çamurlu Köyü",
      "Çavuşköy Köyü",
      "Demirören Köyü",
      "Dermo Mah (akyemiş Köyü)",
      "Dibek Mah (yukarıgöçmez Köyü)",
      "Dikilitaş Mah (yukarıkülecik Köyü)",
      "Dinçer Mah (edremit Köyü)",
      "Doğansu Köyü",
      "Düzce Mah (tanyeli Köyü)",
      "Düzceli Köyü",
      "Edremit Köyü",
      "Eskikonak Köyü",
      "Evren Mah (hacılar Köyü)",
      "Geçit Mah (yukarıkülecik Köyü)",
      "Gelebızın Mah (akçaören Köyü)",
      "Gökoğlu Köyü",
      "Gül Mah (baltacık Köyü)",
      "Gülçimen Mah (hacılar Köyü)",
      "Güldüz Mah (akdilek Köyü)",
      "Güllüce Köyü",
      "Güzeldere Mah (tanyeli Köyü)",
      "Hacılar Köyü",
      "Halife Mah (uzungün Köyü)",
      "İncesu Mah (yukarıgöçmez Köyü)",
      "Kale Mah (alatay Köyü)",
      "Kanışeviti Mah (yukarıkülecik Köyü)",
      "Karatoklu Köyü",
      "Kayadibi Mah (tanyeli Köyü)",
      "Kızıltepe Köyü",
      "Kızkapan Köyü",
      "Koçaklar Köyü",
      "Konakbeyi Köyü",
      "Kuruyaka Köyü",
      "Kuşkaya Köyü",
      "Küncük Mah (sağrıca Köyü)",
      "Kürekli Köyü",
      "Mezra Mah (tanyeli Köyü)",
      "Mezra Mah (yürekveren Köyü)",
      "Mollaibrahim Köyü",
      "Oyacık Köyü",
      "Özdemir Köyü",
      "Sağrıca Köyü",
      "Salahane Mah (yukarıkülecik Köyü)",
      "Suluca Köyü",
      "Susuz Köyü",
      "Şekerova Mah (akdilek Köyü)",
      "Şırık Mah (çakırbey Köyü)",
      "Tanguç Mah (kuruyaka Köyü)",
      "Tanyeli Köyü",
      "Tapu Mah (çakırbey Köyü)",
      "Tekik Mah (kuruyaka Köyü)",
      "Tekmal Mah (susuz Köyü)",
      "Tepeli Köyü",
      "Turgut Özal Mah",
      "Usluca Köyü",
      "Uzunca Köyü",
      "Uzungün Köyü",
      "Üçoymak Köyü",
      "Varan Mah (yukarıkülecik Köyü)",
      "Y.salahana Mah (tanyeli Köyü)",
      "Yalçınkaya Köyü",
      "Yayalar Mah (tanyeli Köyü)",
      "Yenice Mah (yukarıgöçmez Köyü)",
      "Yukarı Tepe Önü Mah (tanyeli Köyü)",
      "Yukarıgöçmez Köyü",
      "Yukarıkamışlı Köyü",
      "Yukarıkülecik Köyü",
      "Yukarımahalle Mah (yukarıgöçmez Köyü)",
      "Yusuf Mah (çavuşköy Köyü)",
      "Yüncüler Köyü",
      "Yürekveren Köyü",
      "Zincirkale Köyü",
      "Ziyaret Köyü",
      "14 Nisan Mah",
      "Abdulvehap Küfrevi Mah",
      "Ahmed-i Hani Mahallesi Mah",
      "Alpaslan Mah",
      "Atatürk Mah",
      "Badişan Mah",
      "Cami Mah",
      "Cumhuriyet Mah",
      "Çay Mah",
      "İnönü Mah",
      "Sanayi Mah",
      "Sarısu Mah",
      "Selahaddini Eyyubi Mah",
      "Serhad Mah",
      "Süphan Dağı Mah",
      "Sütlü Pınar Mah",
      "Yeni Mah",
      "Yeşil Çimen Mah",
      "Yunusemre Mah",
      "Abdullah Mah (taşkın Köyü)",
      "Adalet Mah (köseler Köyü)",
      "Aktepe Köyü",
      "Armutlu Köyü",
      "Bağbaşı Köyü",
      "Bozo Mah (zirekli Köyü)",
      "Canik Mah (gençali Köyü)",
      "Çaputlu Köyü",
      "Çatmaoluk Köyü",
      "Çevlik Mah (zirekli Köyü)",
      "Çiçek Köyü",
      "Çortali Mah (kazanbey Köyü)",
      "Çubuklu Mah (ergeçli Köyü)",
      "Dağalan Köyü",
      "Dizginkale Köyü",
      "Ergeçli Köyü",
      "Esenbel Köyü",
      "Esentepe Mah (ergeçli Köyü)",
      "Gençali Köyü",
      "Gökçeali Köyü",
      "Göl Mah (gökçeali Köyü)",
      "Göl Mah (taşkın Köyü)",
      "Gönlüaçık Köyü",
      "Günbeli Köyü",
      "Güvercinli Köyü",
      "Harabekent Mah (taşkın Köyü)",
      "Hazne Mah (gökçeali Köyü)",
      "Hırba Gülan Mah (zirekli Köyü)",
      "Hırbe Mah (kazanbey Köyü)",
      "Karabulak Mah (gönlüaçık Köyü)",
      "Kazanbey Köyü",
      "Keçelbaba Köyü",
      "Köseler Köyü",
      "Kucak Köyü",
      "Maltepe Mah (aktepe Köyü)",
      "Mecnungölü Mah (ergeçli Köyü)",
      "Onbaşılar Köyü",
      "Sarıdibek Köyü",
      "Satıbulak Mah (zirekli Köyü)",
      "Taşkın Köyü",
      "Ürküt Köyü",
      "Yağız Mah (ürküt Köyü)",
      "Yeşilce Mah (armutlu Köyü)",
      "Yeşilyurt Köyü",
      "Yılanlı Mah (ergeçli Köyü)",
      "Yk.dumanlı Mah (çaputlu Köyü)",
      "Yurtöven Köyü",
      "Zirekli Köyü",
      "Zorava Mah (ergeçli Köyü)"
    ],
    "Taşlıçay": [
      "Adakent Mah (tanyolu Köyü)",
      "Alakoçlu Köyü",
      "Aras Köyü",
      "Aşağıdumanlı Köyü",
      "Aşağıdüzmeydan Köyü",
      "Aşağıesen Köyü",
      "Aşağıtoklu Köyü",
      "Balçiçek Köyü",
      "Bayıraltı Köyü",
      "Bayramyazı Köyü",
      "Boyuncak Köyü",
      "Çermik Mah (çöğürlü Köyü)",
      "Çöğürlü Köyü",
      "Çökelge Köyü",
      "Çökelge Mah (çökelge Köyü)",
      "Dilekyazı Köyü",
      "Döşeme Mah (alakoçlu Köyü)",
      "Düzgören Köyü",
      "Esen Mah (kumlubucak Köyü)",
      "Geçitveren Köyü",
      "Gözucu Köyü",
      "Gültepe Mah (samanyolu Köyü)",
      "Gümüşlü Mah (yeltepe Köyü)",
      "Gündoğdu Köyü",
      "Güneysöğüt Köyü",
      "İkiyamaç Köyü",
      "İnanlı Mah (samanyolu Köyü)",
      "Kado Mah (taşteker Köyü)",
      "Kağnılı Köyü",
      "Kağnılı Mah (kağnılı Köyü)",
      "Karagöz Köyü",
      "Kayalık Mah (tanyolu Köyü)",
      "Kumlubucak Köyü",
      "Kumluca Köyü",
      "Kürekli Mah (tanrıverdi Köyü)",
      "Samanyolu Köyü",
      "Satikomu Mah (gözucu Köyü)",
      "Sivrice Mah (yukarıdüzmeydan Köyü)",
      "Tanrıverdi Köyü",
      "Tanyolu Köyü",
      "Taşteker Köyü",
      "Yanalyol Köyü",
      "Yankaya Köyü",
      "Yardımcılar Köyü",
      "Yassıkaya Köyü",
      "Yaylacık Mah (tanrıverdi Köyü)",
      "Yaylacık Mah (tanyolu Köyü)",
      "Yeltepe Köyü",
      "Yeniköy Mah (kumluca Köyü)",
      "Yukarıdumanlı Köyü",
      "Yukarıdüzmeydan Köyü",
      "Yukarıesen Köyü",
      "Yukarıtaşlıçay Köyü",
      "Yukarıtoklu Köyü",
      "15 Temmuz Şehitler Mah",
      "Adnan Menderes Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah"
    ],
    "Tutak": [
      "Ada Mah (soğukpınar Köyü)",
      "Adakent Köyü",
      "Ahmetabat Köyü",
      "Aksu Mah (palandöken Köyü)",
      "Akyele Köyü",
      "Alacahan Köyü",
      "Alihirco Mah (uzunöz Köyü)",
      "Aşağıkarahalit Köyü",
      "Aşağıkargalık Köyü",
      "Aşağıköşkköy Köyü",
      "Aşağıkülecik Köyü",
      "Aşağıözdek Köyü",
      "Atabindi Köyü",
      "Ataköy Köyü",
      "Aydın Mah (çelebaşı Köyü)",
      "Azizler Köyü",
      "Bahçe Köyü",
      "Batmış Köyü",
      "Bayındır Köyü",
      "Beydamarlı Köyü",
      "Bintosun Köyü",
      "Bişi Köyü",
      "Bolaşlı Köyü",
      "Bozkaş Köyü",
      "Bulutpınar Köyü",
      "Burnubulak Köyü",
      "Çelebaşı Köyü",
      "Çırpılı Köyü",
      "Çobanoba Köyü",
      "Çukurkonak Köyü",
      "Dağlıca Köyü",
      "Daldalık Köyü",
      "Damlakaya Köyü",
      "Dayıpınarı Köyü",
      "Dereköy Köyü",
      "Dibelek Köyü",
      "Dikbıyık Köyü",
      "Dikme Köyü",
      "Doğangün Köyü",
      "Dorukdibi Köyü",
      "Dönertaş Köyü",
      "Döşkaya Köyü",
      "Edisler Mah (karaağaç Köyü)",
      "Ekincek Köyü",
      "Erdal Köyü",
      "Ergeçidi Köyü",
      "Esmer Köyü",
      "Geçimli Köyü",
      "Gülçimen Mah (aşağıköşkköy Köyü)",
      "Gülçimen Mah (çelebaşı Köyü)",
      "Gültepe Köyü",
      "Güneşgören Köyü",
      "Hacı Ali Komu Mah (öndül Köyü)",
      "Hacıyusuf Köyü",
      "Hurisan Mah (karaağaç Köyü)",
      "Hurriyet Mah (soğukpınar Köyü)",
      "İkigözüm Köyü",
      "İpekkuşak Köyü",
      "İsaabat Köyü",
      "Karaağaç Köyü",
      "Karacan Köyü",
      "Karahan Köyü",
      "Karakuyu Köyü",
      "Kaşönü Köyü",
      "Kayadibi Mah (bahçe Köyü)",
      "Kesik Köyü",
      "Kılıçgediği Köyü",
      "Kuşkaya Mah (karacan Köyü)",
      "Lal Yusuf Mah (yukarıkargalık Köyü)",
      "Merpezer Mah (bolaşlı Köyü)",
      "Mızrak Köyü",
      "Mollahalit Mah (sarıgöze Köyü)",
      "Mollahasan Köyü",
      "Nüsret Mah (dağlıca Köyü)",
      "Ocakbaşı Köyü",
      "Oğlaksuyu Köyü",
      "Ortayamaç Köyü",
      "Otluca Köyü",
      "Ozanpınar Köyü",
      "Öndül Köyü",
      "Palandöken Köyü",
      "Sarıgöze Köyü",
      "Sincan Köyü",
      "Sofukacıl Mah (bintosun Köyü)",
      "Soğukpınar Köyü",
      "Sorguçlu Köyü",
      "Suvar Köyü",
      "Şekerbulak Köyü",
      "Taşbudak Köyü",
      "Tepebaşı Mah (bayındır Köyü)",
      "Topi Mah (güneşgören Köyü)",
      "Uzunöz Köyü",
      "Yayıklı Köyü",
      "Yazı Başı Mah (ipekkuşak Köyü)",
      "Yenikent Köyü",
      "Yeniköy Köyü",
      "Yukarıkarahalit Köyü",
      "Yukarıkargalık Köyü",
      "Yukarıköşk Köyü",
      "Yukarıözdek Köyü",
      "Zozo Mah (yukarıkargalık Köyü)",
      "Cami Mah",
      "Karşıyaka Mah",
      "Murat Mah",
      "Pınar Mah",
      "Yeni Mah"
    ]
  },
  "Amasya": {
    "Göynücek": [
      "Cumhuriyet Mah",
      "Merkez Mah",
      "Merkez Mah (damlaçimen Köyü)",
      "Yeni Mah",
      "Abacı Köyü",
      "Afet Evler Mah (karayakup Köyü)",
      "Ağcapınar Mah (karayakup Köyü)",
      "Alan Köyü",
      "Ardıçpınar Köyü",
      "Armutdibi Mah (karayakup Köyü)",
      "Asar Köyü",
      "Aşağı Çulpara Mah (çulpara Köyü)",
      "Aşılık Mah (karayakup Köyü)",
      "Aynının Önü Mah (karayakup Köyü)",
      "Ayvalıpınar Köyü",
      "Başpınar Köyü",
      "Bekdemir Köyü",
      "Beşiktepe Köyü",
      "Çamurlu Köyü",
      "Çayan Köyü",
      "Çaykışla Köyü",
      "Çeşmebaşı Mah (gediksaray Köyü)",
      "Çulpara Köyü",
      "Davutevi Köyü",
      "Gökçeli Köyü",
      "Güzalan Mah (karayakup Köyü)",
      "Harmancık Köyü",
      "Hasanbey Köyü",
      "Ilısu Köyü",
      "İkizyaka Köyü",
      "Kafarlı Köyü",
      "Karapınar Mevki Mah (ikizyaka Köyü)",
      "Karaşar Köyü",
      "Karayakup Köyü",
      "Kertme Köyü",
      "Kervansaray Köyü",
      "Kışlabeyi Köyü",
      "Kızılören Mah (terziköy Köyü)",
      "Kilise Mah (karayakup Köyü)",
      "Konuralan Köyü",
      "Koyuncu Köyü",
      "Kuruluk Mah (karayakup Köyü)",
      "Kuyma Mah (ılısu Köyü)",
      "Kuyulu Kavaklı Köyü",
      "Kuyulu Mah (kuyulu Kavaklı Köyü)",
      "Mezra Mah (yassıkışla Köyü)",
      "Orta Mevki Mah (ikizyaka Köyü)",
      "Orta Şarklı Mah (şarklı Köyü)",
      "Penpeli Köyü",
      "Sığırçayı Köyü",
      "Şarklı Köyü",
      "Şıhlar Köyü",
      "Şıhoğlu Köyü",
      "Tencirli Köyü",
      "Tepe Şarklı Mah (şarklı Köyü)",
      "Terziköy Köyü",
      "Yassıkışla Köyü",
      "Yeniköy Köyü",
      "Yeşildere Mah (gediksaray Köyü)",
      "Yeşilyurt Mah (tencirli Köyü)"
    ],
    "Gümüşhacıköy": [
      "Adatepe Mah",
      "Ağcadede Mah",
      "Artıkabat Mah",
      "Camikebir Mah",
      "Cumara Mah",
      "Çay Mah",
      "Hacıyahya Mah",
      "Irgat Mah",
      "Saray Mah",
      "Şıhlar Mah",
      "Tekke Mah",
      "Yenicami Mah",
      "Ahlatlı Mah (kızık Köyü)",
      "Akpınar Köyü",
      "Albaz Deresi Mah (çalköy Köyü)",
      "Alıçlı Çukur Mah (sarayözü Köyü)",
      "Alören Köyü",
      "Armutalan Mah (sarayözü Köyü)",
      "Aşağı Balıklı Mah (balıklı Köyü)",
      "Bacakoğlu Köyü",
      "Bademli Köyü",
      "Ballık Mah (saraycık Köyü)",
      "Beden Köyü",
      "Berberoğlu Mah (imirler Köyü)",
      "Bilaloğlu Mah (yeniköy Köyü)",
      "Cumaoğlu Kışlası Mah (imirler Köyü)",
      "Çalköy Köyü",
      "Çamınbaşı Mah (sarayözü Köyü)",
      "Çat Mah (koltuk Köyü)",
      "Çavuşköy Köyü",
      "Çayanlar Mah (yeniköy Köyü)",
      "Çetmi Köyü",
      "Çiftçioğlu Köyü",
      "Çitli Köyü",
      "Çömezler Mah (korkut Köyü)",
      "Darçinler Kışlası Mah (sarayözü Köyü)",
      "Derbentobruğu Köyü",
      "Dere Mah (aşağıovacık Köyü)",
      "Doluca Köyü",
      "Dumanlı Köyü",
      "Erenler Mah (imirler Köyü)",
      "Eslemez Köyü",
      "Güllüce Köyü",
      "Gültepe Mah (imirler Köyü)",
      "Güplüce Köyü",
      "Güvemözü Köyü",
      "Hayatdere Mah (kızık Köyü)",
      "Kağnıcı Köyü",
      "Karaali Köyü",
      "Karacaören Köyü",
      "Karakaya Köyü",
      "Karşı Mah (aşağıovacık Köyü)",
      "Keçi Köyü",
      "Kelahmetler Mah (güller Mah) (aşağıovacık Köyü)",
      "Kılıçaslan Köyü",
      "Kırca Köyü",
      "Kızık Köyü",
      "Kızılca Köyü",
      "Kızırcaören Mah (pusacak Köyü)",
      "Kiziroğlu Köyü",
      "Konuktepe Köyü",
      "Korkut Köyü",
      "Köseler Köyü",
      "Köyiçi Mah (çalköy Köyü)",
      "Kurtderesi Mah (sarayözü Köyü)",
      "Kuşburnu Mah (konuktepe Köyü)",
      "Kutluca Köyü",
      "Kuzalan Köyü",
      "Merkez Mah (aşağıovacık Köyü)",
      "Merkez Mah (balıklı Köyü)",
      "Merkez Mah (koltuk Köyü)",
      "Mürseller Mah (bademli Köyü)",
      "Nizamlar Mah (aşağıovacık Köyü)",
      "Ovabaşı Köyü",
      "Pusacak Köyü",
      "Sallar Köyü",
      "Saraycık Köyü",
      "Sarayözü Köyü",
      "Sekü Köyü",
      "Semercioğlu Mah (sarayözü Köyü)",
      "Yazıyeri Köyü",
      "Yongalık Mah (derbentobruğu Köyü)",
      "Yukarı Obruk Mah (derbentobruğu Köyü)"
    ],
    "Hamamözü": [
      "Arkutbey Mah",
      "Hamitkaplan Mah",
      "Köprübaşı Mah",
      "Saray Mah",
      "Aksu Mah (yukarıovacık Köyü)",
      "Alanköy Köyü",
      "Aycalar Mah (tepeköy Köyü)",
      "Çayköy Köyü",
      "Damladere Köyü",
      "Dedeköy Köyü",
      "Göçeri Köyü",
      "Gölköy Köyü",
      "Hıdırlar Köyü",
      "Karadere Mah (tepeköy Köyü)",
      "Kızılcaören Köyü",
      "Mağaraobruğu Köyü",
      "Merkez Mah (arpadere Köyü)",
      "Merkez Mah (tepeköy Köyü)",
      "Orta Mah (arpadere Köyü)",
      "Saraçlar Mah (arpadere Köyü)",
      "Sarayözü Köyü",
      "Tekçam Köyü",
      "Tutkunlar Köyü",
      "Umarca Köyü",
      "Yayla Mah (gölköy Köyü)",
      "Yemişen Köyü",
      "Yukarıovacık Köyü"
    ],
    "Merkez": [
      "Bahçeleriçi Mah",
      "Beyazıtpaşa Mah",
      "Ellibeşevler Mah",
      "Göllü Bağları Mah",
      "Gümüşlü Mah",
      "İhsaniye Mah",
      "Kirazlıdere Mah",
      "Mehmet Paşa Mah",
      "Nergiz Mah",
      "Pirinççi Mah",
      "Savadiye Mah",
      "Sofular Mah",
      "Şamlar Mah",
      "Yazı Bağları Mah",
      "Karasenir Mah",
      "Akbilek Mah",
      "Boğazköy Mah",
      "Çakallar Mah",
      "Demet Evler Mah",
      "Dere Mah",
      "Fethiye Mah",
      "Fındıklı Mah",
      "Gökmedrese Mah",
      "Hacı İlyas Mah",
      "Hacılar Meydanı Mah",
      "Hatuniye Mah",
      "Helvacı Mah",
      "Hızırpaşa Mah",
      "Koza Mah",
      "Kurşunlu Mah",
      "Orman Bağları Mah",
      "Şehirüstü Mah",
      "Şeyhcui Mah",
      "Üçler Mah",
      "Yeniköy Mah",
      "Yeşilyenice Mah",
      "Yüzevler Mah",
      "Abacı Köyü",
      "Ağıllar Mah (mahmatlar Köyü)",
      "Ahmet Koltuğu Mah (yeşildere Köyü)",
      "Aksalur Köyü",
      "Aktaş Köyü",
      "Akyazı Köyü",
      "Alakadı Köyü",
      "Alan Mah (avşar Köyü)",
      "Alaşık Mah (yağcıabdal Köyü)",
      "Albayrak Köyü",
      "Ardıçlar Köyü",
      "Atatürk Mah (albayrak Köyü)",
      "Avşar Köyü",
      "Aydınlık Köyü",
      "Aydoğdu Köyü",
      "Bağlarüstü Köyü",
      "Bağlarüstü Mah (bağlarüstü Köyü)",
      "Bağlıca Köyü",
      "Bağlıca Mah (bağlıca Köyü)",
      "Bağlıcaosb Mah (bağlıca Köyü)",
      "Bahçeleraltı Mah (yağcıabdal Köyü)",
      "Bayat Köyü",
      "Beke Köyü",
      "Beldağı Köyü",
      "Belmebük Mah (karaköprü Köyü)",
      "Boğaköy Köyü",
      "Böke Köyü",
      "Bulduklu Köyü",
      "Büyükkızılca Köyü",
      "Çanaklı Mah (yağcıabdal Köyü)",
      "Çatalçam Köyü",
      "Çavuş Köyü",
      "Çay Köyü Mah (aksalur Köyü)",
      "Çaydere Mah (sarıalan Köyü)",
      "Çengel Mah (karaibrahim Köyü)",
      "Çengelkayı Köyü",
      "Çıtırın Çördük Mah (yağcıabdal Köyü)",
      "Çiğdemlik Köyü",
      "Çivi Köyü",
      "Dadı Köyü",
      "Damudere Köyü",
      "Değirmendere Köyü",
      "Dikmenardı Mah (yağcıabdal Köyü)",
      "Dikyol Mah (damudere Köyü)",
      "Direkli Köyü",
      "Dirgen Mah (kızılkışlacık Köyü)",
      "Duruca Köyü",
      "Eliktekke Köyü",
      "Erikli Mah (yağcıabdal Köyü)",
      "Erkonaş Mah (yassıçal Köyü)",
      "Ermiş Köyü",
      "Eski Ardıçlar Mah (ardıçlar Köyü)",
      "Eskikızılca Köyü",
      "Fındıklı Mah (direkli Köyü)",
      "Filingirler Mah (yassıçal Köyü)",
      "Gerne Köyü",
      "Geygeler Mah (kızoğlu Köyü)",
      "Gökdere Köyü",
      "Gökhöyük Mah (doğantepe Köyü)",
      "Gölönü Mah (yassıçal Köyü)",
      "Gözlek Köyü",
      "Halifeli Köyü",
      "Hamdi Apaydın Çifliği Mah (oluz Köyü)",
      "Han Mah (çengelkayı Köyü)",
      "Hasabdal Köyü",
      "Hatun Pınarı Mah (musaköy Köyü)",
      "İbecik Köyü",
      "İbonun Ağıl Mah (sarıkız Köyü)",
      "İlgazi Köyü",
      "İlyas Köyü",
      "İnönü Mah (uygur Köyü)",
      "İpekköy Köyü",
      "İstasyon Mah (kızoğlu Köyü)",
      "Kabaardıç Mah (yağcıabdal Köyü)",
      "Kadirgilin Ağıl Mah (sarıkız Köyü)",
      "Kaleboğazı Köyü",
      "Kaleköy Köyü",
      "Kapıkaya Köyü",
      "Kapıkaya Mah (kapıkaya Köyü)",
      "Karaali Köyü",
      "Karaçalılık Mah (ipekköy Köyü)",
      "Karaçavuş Köyü",
      "Karadut Mah (sevincer Köyü)",
      "Karaibrahim Köyü",
      "Karakaya Mah (yeşildere Köyü)",
      "Karakese Köyü",
      "Karasu Mah (damudere Köyü)",
      "Karataş Köyü",
      "Karsan Köyü",
      "Karşıyaka Mah (doğantepe Köyü)",
      "Kaşka Mah (boğaköy Köyü)",
      "Kavaklıağıl Mah (ilyas Köyü)",
      "Kavalan Çayı Mah (kızılkışlacık Köyü)",
      "Kayabaşı Köyü",
      "Kayacık Köyü",
      "Kayadibi Mah (avşar Köyü)",
      "Kayrak Köyü",
      "Kazanasmaz Mah (ardıçlar Köyü)",
      "Kazanasmaz Mah (kutu Köyü)",
      "Keçili Köyü",
      "Keltir Mah (kızılkışlacık Köyü)",
      "Keşlik Köyü",
      "Kızılkışlacık Köyü",
      "Kızoğlu Köyü",
      "Kızseki Köyü",
      "Kirazpınarı Mah (ardıçlar Köyü)",
      "Koçalan Mah (kızılkışlacık Köyü)",
      "Köprübaşı Mah (meşeliçiftliği Köyü)",
      "Köyceğiz Köyü",
      "Kurban Armudu Mah (sarıkız Köyü)",
      "Kutu Köyü",
      "Kuzgeçe Köyü",
      "Küçük Sanayi Sitesi Mah (dadı Köyü)",
      "Küçükkızılca Köyü",
      "Mahmatlar Köyü",
      "Melikyurdu Mah (sarıkız Köyü)",
      "Merkez Mah (aydınca Köyü)",
      "Merkez Mah (doğantepe Köyü)",
      "Merkez Mah (ezinepazar Köyü)",
      "Merkez Mah (karaköprü Köyü)",
      "Meşeliçiftliği Köyü",
      "Musaköy Köyü",
      "Nohutluk Mah (karaibrahim Köyü)",
      "Oba Önü Mah (ardıçlar Köyü)",
      "Oluz Köyü",
      "Ormanözü Köyü",
      "Ortaköy Köyü",
      "Ova Mah (sarıyar Köyü)",
      "Ovasaray Köyü",
      "Özfındıklı Köyü",
      "Pamuklu Mah (ormanözü Köyü)",
      "Salamut Mah (aksalur Köyü)",
      "Saraycık Köyü",
      "Sarayözü Köyü",
      "Sarıalan Köyü",
      "Sarıkız Köyü",
      "Sarımeşe Köyü",
      "Sarıyar Köyü",
      "Sazköy Köyü",
      "Sevincer Köyü",
      "Sıracevizler Köyü",
      "Soma Köyü",
      "Sulakbaşı Mah (yağcıabdal Köyü)",
      "Şeyhsadi Köyü",
      "Tartışık Mah (ardıçlar Köyü)",
      "Tartışık Mah (sarıkız Köyü)",
      "Tatar Köyü",
      "Terziköy/kaplıca Mah (çivi Köyü)",
      "Tuzsuz Köyü",
      "Ümük Köyü",
      "Yağcıabdal Köyü",
      "Yağmur Köyü",
      "Yavru Köyü",
      "Yeni Mah (duruca Köyü)",
      "Yeni Mah (uygur Köyü)",
      "Yeşildere Köyü",
      "Yeşilöz Köyü",
      "Yıkılgan Köyü",
      "Yıldızköy Köyü",
      "Yıldızköy Mah (yıldızköy Köyü)",
      "Yolyanı Köyü",
      "Yolyanı Mah (mahmatlar Köyü)",
      "Yukarı Kayrak Mah (kayrak Köyü)",
      "Yukarı Kızseki Mah (kızseki Köyü)",
      "Yuvacık Köyü",
      "Yuvaköy Köyü",
      "Aşağı Mah (ziyaret Beldesi)",
      "Saraycık Mah (ziyaret Beldesi)",
      "Yukarı Mah (ziyaret Beldesi)"
    ],
    "Merzifon": [
      "Afet Evleri Mah (akören Köyü)",
      "Akpınar Köyü",
      "Aktarla Köyü",
      "Alıcık Köyü",
      "Alışar Köyü",
      "Aşağıbük Köyü",
      "Bağlar Mah (aksungur Köyü)",
      "Bahçecik Mah (bahçecik Köyü)",
      "Balgöze Köyü",
      "Bayazıt Köyü",
      "Bulak Köyü",
      "Büklüce Mah (derealan Köyü)",
      "Büyükçay Köyü",
      "Çamlıca Köyü",
      "Çavundur Köyü",
      "Çaybaşı Köyü",
      "Çayır Köyü",
      "Çayırözü Mah (çayırözü Köyü)",
      "Çobanören Köyü",
      "Değirmenyolu Mah (sarı Köyü)",
      "Demirpınar Köyü",
      "Diphacı Köyü",
      "Elmayolu Köyü",
      "Esentepe Köyü",
      "Eymir Köyü",
      "Gelinsini Köyü",
      "Gökçebağ Mah (gökçebağ Köyü)",
      "Gümüştepe Köyü",
      "Hacet Köyü",
      "Hacıyakup Köyü",
      "Han Köyü",
      "Han Mah (bayat Köyü)",
      "Hayrettin Köyü",
      "Hırka Köyü",
      "Irmakbaşı Mah (uzunyazı Köyü)",
      "Işıklar Mah (kayadüzü Köyü)",
      "İlemi Çayırı Mah (sazlıca Köyü)",
      "İnalanı Köyü",
      "Kalburcu Mah (kızıleğrek Köyü)",
      "Kamışlı Köyü",
      "Karacakaya Köyü",
      "Karamağara Köyü",
      "Karamustafapaşa Köyü",
      "Karatepe Köyü",
      "Karşıyaka Köyü",
      "Kıreymir Köyü",
      "Kızıleğrek Köyü",
      "Koç Köyü",
      "Kuyu Köyü",
      "Küçükçay Köyü",
      "Mahmutlu Köyü",
      "Mahsenli Mah (kayadüzü Köyü)",
      "Merkez Mah (aksungur Köyü)",
      "Merkez Mah (bayat Köyü)",
      "Merkez Mah (derealan Köyü)",
      "Merkez Mah (muşruf Köyü)",
      "Ortabük Köyü",
      "Ortaova Köyü",
      "Osmanoğlu Köyü",
      "Oymaağaç Köyü",
      "Oymak Köyü",
      "Ören Mah (gökçebağ Köyü)",
      "Pekmezci Köyü",
      "Saraycık Köyü",
      "Sarı Köyü",
      "Sarı Mah (sarı Köyü)",
      "Sarıbuğday Köyü",
      "Sazlıca Köyü",
      "Selimiye Köyü",
      "Şeyhyeni Mah (şeyhyeni Köyü)",
      "Tellioğlu Mah (muşruf Köyü)",
      "Türkoğlu Köyü",
      "Uzunyazı Mah (uzunyazı Köyü)",
      "Yakacık Mah (muşruf Köyü)",
      "Yakup Köyü",
      "Yalnız Köyü",
      "Yaylacık Köyü",
      "Yenice Köyü",
      "Yeniçeltek Mah (kayadüzü Köyü)",
      "Yeşilören Köyü",
      "Yeşiltepe Köyü",
      "Yeşilyurt Mah (kayadüzü Köyü)",
      "Yolüstü Köyü",
      "Yukarı Mah (akören Köyü)",
      "Yukarıbük Köyü",
      "Abidehatun Mah",
      "Bağlarbaşı Mah",
      "Bahçelievler Mah",
      "Buğdaylı Mah",
      "Camicedit Mah",
      "Eski Camii Mah",
      "Gazimahbup Mah",
      "Hacıbalı Mah",
      "Hacıhasan Mah",
      "Harmanlar Mah",
      "Hocasüleyman Mah",
      "Kümbet Hatun Mah",
      "Kümbethatunosb Mah",
      "Mahsen Mah",
      "Mehmet Akif Ersoy Mah",
      "Naccar Mah",
      "Nusratiye Mah",
      "Sofular Mah",
      "Tavşan Mah",
      "Yeni Mah",
      "Yunus Emre Mah"
    ],
    "Suluova": [
      "Afetevleri-cebeci Mah (armutlu Köyü)",
      "Akören Köyü",
      "Alabedir Köyü",
      "Arucak Köyü",
      "Aşağıkarasu Köyü",
      "Ayderesi Mah (karaağaç Köyü)",
      "Ayrancı Köyü",
      "Bayırlı Köyü",
      "Besi Osb Mah (salucu Köyü)",
      "Bingüş Mah (karaağaç Köyü)",
      "Boyalı Köyü",
      "Cürlü Köyü",
      "Çayüstü Köyü",
      "Çukurören Köyü",
      "Dere Ağılı Mezrası Mah (yüzbeyi Köyü)",
      "Derebaşalan Köyü",
      "Deveci Köyü",
      "Eğribük Köyü",
      "Erikli Mah (eğribük Köyü)",
      "Harmanağılı Köyü",
      "Hasan Emmi Çiftligi Mah (dere Köyü)",
      "Kanatpınar Köyü",
      "Kapancı Ağılı Köyü",
      "Karaağaç Köyü",
      "Kazanlı Köyü",
      "Kazanlı Organize Sanayi Bölgesi Mah (kazanlı Köyü)",
      "Kerimoğlu Köyü",
      "Kılıçaslan Köyü",
      "Kıranbaşalan Köyü",
      "Kolay Köyü",
      "Kulu Köyü",
      "Kurnaz Köyü",
      "Kutlu Köyü",
      "Kuzalan Köyü",
      "Küpeli Köyü",
      "Mahmut Demir Çiftliği Mah (dere Köyü)",
      "Merkez Mah (armutlu Köyü)",
      "Merkez Mah (dere Köyü)",
      "Oğulbağı Köyü",
      "Ortayazı Köyü",
      "Özalakadı Köyü",
      "Salucu Köyü",
      "Saygılı Köyü",
      "Seyfe Köyü",
      "Soku Köyü",
      "Uzunoba Köyü",
      "Yolpınar Köyü",
      "Yüzbeyi Köyü",
      "Ata Mah",
      "Beyazıt Mah",
      "Bir Eylül Mah",
      "Borsa Mah",
      "Cevizdibi Mah",
      "Cumhuriyet Mah",
      "Çeltekmadeni Mah",
      "Eymir Mah",
      "Fatih Mah",
      "Girne Mah",
      "Hacıbayram Mah",
      "Hacıhayta Mah",
      "Harmanlar Mah (eraslan Köyü)",
      "Hürriyet Mah",
      "Maarif Mah",
      "Magosa Mah",
      "Orta Mah",
      "Pazar Mah",
      "Saraydüzü Mah",
      "Şeker Mah",
      "Uluçınar Mah (eraslan Köyü)",
      "Yeni Mah",
      "Yenidoğan Mah"
    ],
    "Taşova": [
      "Akçanın Dere Mah (kavaloluğu Köyü)",
      "Akkişiler Mah (karlık Köyü)",
      "Akpınar Mah (karsavul Köyü)",
      "Alan Mah (kavaloluğu Köyü)",
      "Alan Mah (sofualan Köyü)",
      "Alçakbel Köyü",
      "Altınlı Köyü",
      "Andıran Köyü",
      "Ardıçönü Köyü",
      "Arpaderesi Köyü",
      "Aşağı Gökdere Mah (gökpınar Köyü)",
      "Aşağı Gökdere Mah (sofualan Köyü)",
      "Aşağı Mah (sepetli Köyü)",
      "Aydınlar Mah (esençay Köyü)",
      "Aydınyeri Mah (yeşiltepe Köyü)",
      "Bahçecik Mah (yeşiltepe Köyü)",
      "Bahçelievler Mah (boraboy Köyü)",
      "Bakırpınar Mah (kavaloluğu Köyü)",
      "Ballıca Mah (ballıca Köyü)",
      "Barcın Mah (kavaloluğu Köyü)",
      "Beyalan Mah (alçakbel Köyü)",
      "Cumhuriyet Mah (özbaraklı Köyü)",
      "Cumhuriyet Mah (uluköy Köyü)",
      "Çağlayan Mah (esençay Köyü)",
      "Çakılcık Mah (şeyhli Köyü)",
      "Çakırsu Köyü",
      "Çalkaya Köyü",
      "Çambükü Köyü",
      "Çaydibi Köyü",
      "Çerkezler Mah (kavaloluğu Köyü)",
      "Çermik Mah (şeyhli Köyü)",
      "Çılkıdır Köyü",
      "Çıngılık Mah (kavaloluğu Köyü)",
      "Çiftlik Mah (karlık Köyü)",
      "Çorak Mah (sepetli Köyü)",
      "Çöküyanı Mah (yeşiltepe Köyü)",
      "Dazlı Mah (hüsnüoğlu Köyü)",
      "Dere Mah (sepetli Köyü)",
      "Dereköy Köyü",
      "Dereli Mah (dereli Köyü)",
      "Devre Köyü",
      "Doğa Yeri Mah (kavaloluğu Köyü)",
      "Doğan Çukuru Mah (karlık Köyü)",
      "Doğanşah Mah (alpaslan Köyü)",
      "Döllük Mah (alçakbel Köyü)",
      "Dönertaş Mah (hüsnüoğlu Köyü)",
      "Dörtyol Köyü",
      "Durucasu Köyü",
      "Dutluk Köyü",
      "Ebece Mah (kavaloluğu Köyü)",
      "Elmakırı Köyü",
      "Elmalık Mah (sofualan Köyü)",
      "Erbeğendi Mah (alçakbel Köyü)",
      "Ergüneş Mah (uluköy Köyü)",
      "Fadara Mah (ardıçönü Köyü)",
      "Fevzioğlu Mah (alpaslan Köyü)",
      "Fındıcak Mah (şeyhli Köyü)",
      "Gelemiç Mah (ardıçönü Köyü)",
      "Gemibükü Köyü",
      "Geriş Mah (karlık Köyü)",
      "Geydoğan Köyü",
      "Gökpınar Köyü",
      "Gücükgeriş Mah (şeyhli Köyü)",
      "Güngörmüş Köyü",
      "Gürsu Köyü",
      "Güvencealan Mah (şeyhli Köyü)",
      "Güvendik Köyü",
      "Hacıbeyköyü Köyü",
      "Hacıgeriş Mah (kavaloluğu Köyü)",
      "Haydarağa Mah (korubaşı Köyü)",
      "Hüsnüoğlu Köyü",
      "Ilıca Köyü",
      "Ilıpınar Köyü",
      "İkipöğre Mah (karsavul Köyü)",
      "İkisamanlık Mah (kavaloluğu Köyü)",
      "İsmet Paşa Mah (belevi Köyü)",
      "Kadılar Mah (kavaloluğu Köyü)",
      "Karaağaç Mah (alçakbel Köyü)",
      "Karabük Köyü",
      "Karaçukur Mah (alçakbel Köyü)",
      "Karadüz Mah (yeşiltepe Köyü)",
      "Karamuk Köyü",
      "Karamuk Mah (korubaşı Köyü)",
      "Karlık Dere Mah (karlık Köyü)",
      "Karlık Köyü",
      "Karsavul Köyü",
      "Katıralan Mah (korubaşı Köyü)",
      "Kavaloluğu Köyü",
      "Kemalpaşa Mah (belevi Köyü)",
      "Kırdağın Mah (alçakbel Köyü)",
      "Kırık Çukuru Mah (karlık Köyü)",
      "Kırkharman Köyü",
      "Kızgüldüren Köyü",
      "Kızılağaç Mah (mercimekköy Köyü)",
      "Kızılcı Alan Mah (karlık Köyü)",
      "Kocalan Mah (korubaşı Köyü)",
      "Korubaşı Köyü",
      "Kozalan Mah (alçakbel Köyü)",
      "Kozluca Köyü",
      "Köseli Mah (alçakbel Köyü)",
      "Kumluca Köyü",
      "Kuz Mah (şeyhli Köyü)",
      "Kuzkışla Mah (karlık Köyü)",
      "Leğenkaya Mah (yeşiltepe Köyü)",
      "Mercimekköy Köyü",
      "Merkez Mah (destek Köyü)",
      "Merkez Mah (sofualan Köyü)",
      "Meşeli Mah (şeyhli Köyü)",
      "Meymaşlar Mah (kavaloluğu Köyü)",
      "Mülkbükü Köyü",
      "Nurettin Bey Mah (alpaslan Köyü)",
      "Oruçgazi Mah (kavaloluğu Köyü)",
      "Sakarat Mah (kavaloluğu Köyü)",
      "Sakızlık Arsası Mah (sepetli Köyü)",
      "Selçuklu Mah (özbaraklı Köyü)",
      "Serçeler Mah (kavaloluğu Köyü)",
      "Sıtma Pınarı Mah (karsavul Köyü)",
      "Sinan Paşa Mah (uluköy Köyü)",
      "Şahinler Köyü",
      "Şeyhli Köyü",
      "Tacettin Bey Mah (alpaslan Köyü)",
      "Taştepe Mah (karlık Köyü)",
      "Tatlıpınar Köyü",
      "Tekke Mah (tekke Köyü)",
      "Tekpınar Köyü",
      "Tepe Mah (sepetli Köyü)",
      "Terzili Mah (alçakbel Köyü)",
      "Topalın Fırın Mah (kavaloluğu Köyü)",
      "Turan Güneş Mah (esençay Köyü)",
      "Tuzlalı Geriş Mah (kavaloluğu Köyü)",
      "Türkmendamı Köyü",
      "Ulupara Mah (yeşiltepe Köyü)",
      "Yağbasan Mah (sofualan Köyü)",
      "Yakakent Mah (boraboy Köyü)",
      "Yalamageriş Mah (şeyhli Köyü)",
      "Yatak Mah (alçakbel Köyü)",
      "Yayladibi Köyü",
      "Yaylasaray Köyü",
      "Yenidere Köyü",
      "Yerkozlu Mah (yerkozlu Köyü)",
      "Yeşilyurt Köyü",
      "Yolaçan Köyü",
      "Yukarı Gökdere Mah (sofualan Köyü)",
      "Yukarıbaraklı Köyü",
      "Zana Mah (karsavul Köyü)",
      "Cumhuriyet Mah",
      "Doğu Mah",
      "Sanayii Mah",
      "Tepe Mah",
      "Yemişen Mah",
      "Yeni Mah",
      "Yeşilırmak Mah"
    ]
  },
  "Ankara": {
    "Akyurt": [
      "Ahmetadil Mah",
      "Atatürk Mah",
      "Balıkhisar Mah",
      "Beyazıt Mah",
      "Büğdüz Mah",
      "Cücük Mah",
      "Çam Mah",
      "Çardakbağı Mah",
      "Çınar Mah",
      "Elecik Mah",
      "Galaba Mah",
      "Güzelhisar Mah",
      "Haydar Mah",
      "Karacakaya Mah",
      "Karacalar Mah",
      "Karayatak Mah",
      "Kızık Mah",
      "Kozayağı Mah",
      "Samut Mah",
      "Saracalar Mah",
      "Şeyhler Mah",
      "Teberik Mah",
      "Timurhan Mah",
      "Uzunlar Mah",
      "Yeşiltepe Mah",
      "Yıldırım Mah"
    ],
    "Altındağ": [
      "Atıfbey Mah",
      "Gültepe Mah",
      "Örnek Mah",
      "Aydınlıkevler Mah",
      "Baraj Mah",
      "Doğantepe Mah",
      "Güneşevler Mah",
      "Solfasol Mah",
      "Yıldıztepe Mah",
      "Zübeyde Hanım Mah",
      "Karacaören Mah",
      "Hacettepe Mah",
      "Kale Mah",
      "Aydıncık Mah",
      "Başpınar Mah",
      "Battalgazi Mah",
      "Beşikkaya Mah",
      "Feridun Çelik Mah",
      "Gicik Mah",
      "Karapürçek Mah",
      "Kavaklı Mah",
      "Önder Mah",
      "Peçenek Mah",
      "Tatlar Mah",
      "Ulubey Mah",
      "Hacı Bayram Mah"
    ],
    "Ayaş": [
      "Akkaya Mah",
      "Başayaş Mah",
      "Başbereket Mah",
      "Bayat Mah",
      "Bayram Mah",
      "Camiatik Mah",
      "Çanıllı Çiğdemci Mah",
      "Çanıllı Uluyol Mah",
      "Dervişimam Mah",
      "Emine Tevfika Ayaşlı Mah",
      "Evci Mah",
      "Ferahfaki Mah",
      "Feruz Mah",
      "Gençali Mah",
      "Gökçebağ Mah",
      "Gökler Mah",
      "Hacımemi Mah",
      "Hacırecep Mah",
      "Hacıveli Mah",
      "Ilıca Mah",
      "İlhanköy Mah",
      "Oltan Mah",
      "Ortabereket Mah",
      "Ömeroğlu Mah",
      "Pınaryaka Mah",
      "Sinanlı Cuma Mah",
      "Sinanlı Hocasinan Mah",
      "Sinanlı Mahkeme Mah",
      "Şeyhmuhittin Mah",
      "Tekke Mah",
      "Uğurçayırı Mah",
      "Ulupınar Mah",
      "Yağmurdede Mah"
    ],
    "Bala": [
      "Abazlı Mah",
      "Afşar Mah",
      "Ahmetçayırı Mah",
      "Akkoyunlu Mah",
      "Aşağıhacıbekir Mah",
      "Aşıkoğlu Mah",
      "Aydoğan Mah",
      "Bahçekaradalak Mah",
      "Bektaşlı Mah",
      "Belçarşak Mah",
      "Beynam Mah",
      "Büyükbayat Mah",
      "Büyükboyalık Mah",
      "Büyükcamili Mah",
      "Çatalçeşme Mah",
      "Çatalören Mah",
      "Çiğdemli Mah",
      "Davdanlı Mah",
      "Derekışla Mah",
      "Eğribasan Mah",
      "Ergin Mah",
      "Göztepe Mah",
      "Gülbağı Mah",
      "Hamidiye Mah",
      "Hanburun Mah",
      "İsmetpaşa Mah",
      "Karahamzalı Mah",
      "Kartaltepe Mah",
      "Kerişli Mah",
      "Kesikköprü Erdemli Mah",
      "Kesikköprü Kızılırmak Mah",
      "Kesikköprü Mah",
      "Koçyayla Mah",
      "Köseli Mah",
      "Kuyular Mah",
      "Küçükbayat Mah",
      "Küçükbıyık Mah",
      "Küçükboyalık Mah",
      "Küçükcamili Mah",
      "Sarıhüyük Mah",
      "Sırapınar Mah",
      "Sofular Mah",
      "Suyugüzel Mah",
      "Şehriban Mah",
      "Şentepe Mah",
      "Tatarhüyük Mah",
      "Tepeköy Mah",
      "Tolköy Mah",
      "Üçem Mah",
      "Yaylalıözü Mah",
      "Yeniköy Mah",
      "Yeniyapançarşak Mah",
      "Yeniyapanşeyhli Mah",
      "Yöreli Mah",
      "Yukarıhacıbekir Mah"
    ],
    "Beypazarı": [
      "Acısu Mah",
      "Adaören Mah",
      "Akçakavak Mah",
      "Akçalı Mah",
      "Aşağıgüney Mah",
      "Ayvaşık Mah",
      "Bağözü Mah",
      "Başağaç Mah",
      "Başören Mah",
      "Batça Mah",
      "Beytepe Mah",
      "Boyalı Mah",
      "Cumhuriyet Mah",
      "Çakıloba Mah",
      "Çantırlı Mah",
      "Dağşeyhler Mah",
      "Dereli Mah",
      "Dibecik Mah",
      "Dibekören Mah",
      "Dikmen Mah",
      "Doğançalı Mah",
      "Doğanyurt Mah",
      "Dudaş Mah",
      "Fasıl Mah",
      "Gazipaşa Mah",
      "Geyikpınarı Mah",
      "Gürsöğüt Mah",
      "Hacıkara Mah",
      "Harmancık Mah",
      "Haydarlar Mah",
      "Hırkatepe Mah",
      "İncepelit Mah",
      "İstiklal Mah",
      "Kabaca Mah",
      "Kabalar Mah",
      "Kaplan Mah",
      "Kapullu Mah",
      "Karacaören Mah",
      "Karaören Mah",
      "Karaşar Mah",
      "Kargı Mah",
      "Kayabükü Mah",
      "Kerbanlar Mah",
      "Kırbaşı Mah",
      "Kırşeyhler Mah",
      "Kızılcasöğüt Mah",
      "Kozağaç Mah",
      "Kozalan Mah",
      "Köseler Mah",
      "Köst Mah",
      "Kurtkovan Mah",
      "Kurtuluş Mah",
      "Kuyucak Mah",
      "Kuyumcutekke Mah",
      "Macun Mah",
      "Mahmutlar Mah",
      "Mençeler Mah",
      "Mikail Mah",
      "Nuhhoca Mah",
      "Oymaağaç Mah",
      "Rüstempaşa Mah",
      "Saray Mah",
      "Sarıağıl Mah",
      "Sekli Mah",
      "Sopçaalan Mah",
      "Tacettin Mah",
      "Tahir Mah",
      "Uruş Mah",
      "Uşakgöl Mah",
      "Üreğil Mah",
      "Yalnızçam Mah",
      "Yeşilağaç Mah",
      "Yıldız Mah",
      "Yiğerler Mah",
      "Yoğunpelit Mah",
      "Yukarıgüney Mah",
      "Yukarıulucak Mah",
      "Zafer Mah"
    ],
    "Çamlıdere": [
      "Ahatlar Mah",
      "Akkaya Mah",
      "Alakoç Mah",
      "Atça Mah",
      "Avdan Mah",
      "Avşarlar Mah",
      "Bardakçılar Mah",
      "Bayındır Mah",
      "Beşbeyler Mah",
      "Beyler Mah",
      "Bökeler Mah",
      "Buğralar Mah",
      "Çamköy Mah",
      "Çukurören Mah",
      "Dağkuzören Mah",
      "Doğancı Mah",
      "Doğanlar Mah",
      "Doymuş Mah",
      "Dörtkonak Mah",
      "Eldelek Mah",
      "Elmalı Mah",
      "Elören Mah",
      "Elvanlar Mah",
      "Gümele Mah",
      "Güney Mah",
      "İnceöz Mah",
      "Kayabaşı Mah",
      "Körler Mah",
      "Kuşçular Mah",
      "Kuyubaşı Mah",
      "Meşeler Mah",
      "Muzrupağacın Mah",
      "Müsellim Mah",
      "Orta Mah",
      "Osmansin Mah",
      "Ömerağa Mah",
      "Örenköy Mah",
      "Özmüş Mah",
      "Peçenek Mah",
      "Pelitçik Mah",
      "Sarıkavak Mah",
      "Tatlak Mah",
      "Yahşihan Mah",
      "Yahyalar Mah",
      "Yayalar Mah",
      "Yediören Mah",
      "Yılanlı Mah",
      "Yoncatepe Mah"
    ],
    "Çankaya": [
      "Çiğdem Mah",
      "Çukurambar Mah",
      "İşçi Blokları Mah",
      "Kızılırmak Mah",
      "Mustafa Kemal Mah",
      "Söğütözü Mah",
      "Ahlatlıbel Mah",
      "Bahçelievler Mah",
      "Emek Mah",
      "Yukarı Bahçelievler Mah",
      "Balgat Mah",
      "Cevizlidere Mah",
      "Ehlibeyt Mah",
      "Nasuh Akar Mah",
      "Oğuzlar Mah",
      "Beytepe Mah",
      "Mutlukent Mah",
      "Üniversiteler Mah",
      "Birlik Mah",
      "Kırkkonaklar Mah",
      "50.yıl Mah",
      "Arka Topraklık Mah",
      "Cebeci Mah",
      "Çamlıtepe Mah",
      "Dilekler Mah",
      "Ertuğrulgazi Mah",
      "Erzurum Mah",
      "Fakülteler Mah",
      "İleri Mah",
      "İncesu Mah",
      "Ön Cebeci Mah",
      "Topraklık Mah",
      "Ayrancı Mah",
      "Aziziye Mah",
      "Çankaya Mah",
      "Güvenevler Mah",
      "Güzeltepe Mah",
      "Alacaatlı Mah",
      "Çayyolu Mah",
      "Dodurga Mah",
      "Konutkent Mah",
      "Koru Mah",
      "Prof. Dr. Ahmet Taner Kışlalı Mah",
      "Ümit Mah",
      "Yaşamkent Mah",
      "Akpınar Mah",
      "Gökkuşağı Mah",
      "İlkadım Mah",
      "İlker Mah",
      "Karapınar Mah",
      "Keklik Pınarı Mah",
      "Malazgirt Mah",
      "Metin Akkuş Mah",
      "Mürsel Uluç Mah",
      "Naci Çakır Mah",
      "Osman Temiz Mah",
      "Doğuş Mah",
      "Esatoğlu Mah",
      "Küçükesat Mah",
      "Muhsin Ertuğrul Mah",
      "Seyranbağları Mah",
      "Tınaztepe Mah",
      "Akarlar Mah",
      "Aşağı İmrahor Mah",
      "Çavuşlu Mah",
      "Evciler Mah",
      "Karahasanlı Mah",
      "Karataş Mah",
      "Kömürcü Mah",
      "Orta İmrahor Mah",
      "Tohumlar Mah",
      "Yakupabdal Mah",
      "Yayla Mah",
      "Yeşilkent Mah",
      "100.yıl Mah",
      "Barbaros Mah",
      "Büyükesat Mah",
      "Gaziosmanpaşa Mah",
      "Kavaklıdere Mah",
      "Kazım Özalp Mah",
      "Remzi Oğuz Arık Mah",
      "Anıttepe Mah",
      "Eti Mah",
      "Maltepe Mah",
      "Mebusevleri Mah",
      "Yücetepe Mah",
      "Aşağı Öveçler Mah",
      "Ata Mah",
      "Aydınlar Mah",
      "Harbiye Mah",
      "Huzur Mah",
      "Öveçler Mah",
      "Sokullu Mehmet Paşa Mah",
      "Şehit Cengiz Karaca Mah",
      "Şehit Cevdet Özdemir Mah",
      "Yukarı Öveçler Mah",
      "Cumhuriyet Mah",
      "Devlet Mah",
      "Fidanlık Mah",
      "Kızılay Mah",
      "Kocatepe Mah",
      "Korkutreis Mah",
      "Kültür Mah",
      "Meşrutiyet Mah",
      "Namık Kemal Mah",
      "Sağlık Mah",
      "Dumlupınar Mah",
      "Hilal Mah",
      "İlkbahar Mah",
      "Oran Mah",
      "Sancak Mah",
      "Yıldızevler Mah",
      "Yukarı Dikmen Mah",
      "Aşıkpaşa Mah",
      "Bademlidere Mah",
      "Bağcılar Mah",
      "Bayraktar Mah",
      "Boztepe Mah",
      "Göktürk Mah",
      "Metin Oktay Mah",
      "Mimar Sinan Mah",
      "Murat Mah",
      "Umut Mah",
      "Zafertepe Mah"
    ],
    "Çubuk": [
      "Ağılcık Mah",
      "Akbayır Mah",
      "Akkuzulu Mah",
      "Aşağıçavundur Mah",
      "Aşağıemirler Mah",
      "Aşağıobruk Mah",
      "Atatürk Mah",
      "Avcıova Mah",
      "Barbaros Mah",
      "Camili Mah",
      "Cumhuriyet Mah",
      "Çatokcular Mah",
      "Çitköy Mah",
      "Dağkalafat Mah",
      "Dalyasan Mah",
      "Dedeler Mah",
      "Demirci Mah",
      "Dumlupınar Mah",
      "Durhasan Mah",
      "Eğriekin Mah",
      "Esenboğa Merkez Mah",
      "Eskiçöte Mah",
      "Fatih Mah",
      "Gökçedere Mah",
      "Güldarpı Mah",
      "Gümüşyayla Mah",
      "Hacılar Mah",
      "İkipınar Mah",
      "İmamhüseyin Mah",
      "Kapaklı Mah",
      "Karaağaç Mah",
      "Karaçam Mah",
      "Karadana Mah",
      "Karaman Mah",
      "Karataş Mah",
      "Kargın Mah",
      "Kavaklı Mah",
      "Kışlacık Mah",
      "Kızılca Mah",
      "Kızılören Mah",
      "Kızılöz Mah",
      "Kösrelik Mah",
      "Kuruçay Mah",
      "Kutuören Mah",
      "Kuyumcu Mah",
      "Küçükali Mah",
      "Mahmutoğlan Mah",
      "Melikşah Mah",
      "Meşeli Mah",
      "Muhsin Yazıcıoğlu Mah",
      "Mutlu Mah",
      "Mutlu Osb Mah",
      "Nusratlar Mah",
      "Okçular Mah",
      "Ovacık Mah",
      "Oyumiğde Mah",
      "Ömercik Mah",
      "Özlüce Mah",
      "Saraycık Mah",
      "Sarıkoz Mah",
      "Sarısu Mah",
      "Sele Mah",
      "Sığırlıhacı Mah",
      "Susuz Mah",
      "Sünlü Mah",
      "Tahtayazı Mah",
      "Taşpınar Mah",
      "Tuğla Mah",
      "Uluağaç Mah",
      "Yakuphasan Mah",
      "Yavuzselim Mah",
      "Yaylak Mah",
      "Yazır Mah",
      "Yazlıca Mah",
      "Yenice Mah",
      "Yeşilkent Mah",
      "Yıldırım Beyazıt Mah",
      "Yıldırımaydoğan Mah",
      "Yıldırımelören Mah",
      "Yıldırımevci Mah",
      "Yılmazköy Mah",
      "Yiğitli Mah",
      "Yukarı Çavundur Mah",
      "Yukarıemirler Mah",
      "Yukarıobruk Mah"
    ],
    "Elmadağ": [
      "Akçaali Mah",
      "Aşağıkamışlı Mah",
      "Deliler Mah",
      "Ediğe Mah",
      "Gümüşpala Mah",
      "İsmetpaşa Mah",
      "Karacahasan Mah",
      "Kayadibi Mah",
      "Kemalpaşa Mah",
      "Kurtuluş Mah",
      "Kuşçuali Mah",
      "Lalabel Mah",
      "Seyitcemali Mah",
      "Süleymanlı Mah",
      "Taburlar Mah",
      "Tatlıca Mah",
      "Tekke Mah",
      "Üçevler Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Yenimahalle Mah",
      "Yenipınar Mah",
      "Yeşildere Fatih Mah",
      "Yukarıkamışlı Mah",
      "Hasanoğlan Bahçelievler Mah",
      "Hasanoğlan Fatih Mah",
      "Hasanoğlan Havuzbaşı Mah",
      "İstasyon Mah",
      "Muzaffer Ekşi Mah",
      "Şehitlik Mah"
    ],
    "Etimesgut": [
      "30 Ağustos Mah",
      "Ahi Mesut Mah",
      "Elvan Mah",
      "Kazım Karabekir Mah",
      "Piyade Mah",
      "Süvari Mah",
      "Bahçekapı Mah",
      "Atakent Mah",
      "Ayyıldız Mah",
      "Etiler Mah",
      "Oğuzlar Mah",
      "Topçu Mah",
      "Yeşilova Mah",
      "Devlet Mah",
      "Eryaman Mah",
      "Şeyh Şamil Mah",
      "Tunahan Mah",
      "Alsancak Mah",
      "Bağlıca Mah",
      "Erler Mah",
      "Fatih Sultan Mah",
      "İstasyon Mah",
      "Yapracık Mah",
      "Yeni Bağlıca Mah",
      "Altay Mah",
      "Göksu Mah",
      "Şehit Osman Avcı Mah",
      "Şeker Mah",
      "Güzelkent Mah",
      "Yavuz Selim Mah",
      "Aşağıyurtçu Mah",
      "Atayurt Mah",
      "Balıkuyumcu Mah",
      "Fevziye Mah",
      "Orhun Mah",
      "Şehitali Mah",
      "Turkuaz Mah",
      "Yukarıyurtçu Mah"
    ],
    "Evren": [
      "Altınbaşak Mah",
      "Cebirli Mah",
      "Çatalpınar Mah",
      "Demirayak Mah",
      "Esentepe Mah",
      "Eskitorunobası Mah",
      "İbrahimbeyli Mah",
      "İnebeyli Mah",
      "Modern Mah",
      "Solakuşağı Mah",
      "Şerafettin Yılmaz Mah",
      "Yeni Mah",
      "Yusufuşağı Mah"
    ],
    "Gölbaşı": [
      "Ahiboz Mah",
      "Akörençarşak Mah",
      "Altunçanak Mah",
      "Bağiçi Mah",
      "Bahçelievler Mah",
      "Ballıkpınar Mah",
      "Bezirhane Mah",
      "Boyalık Mah",
      "Çayırlı Mah",
      "Çeltek Mah",
      "Çimşit Mah",
      "Dikilitaş Mah",
      "Emirler Mah",
      "Eymir Mah",
      "Gaziosmanpaşa Mah",
      "Gökçehüyük Mah",
      "Gölbek Mah",
      "Günalan Mah",
      "Hacıhasan Mah",
      "Hacılar Mah",
      "Hacımuratlı Mah",
      "Halaçlı Mah",
      "İkizce Mah",
      "İncek Mah",
      "Karaali Merkez Mah",
      "Karaali Yazlık Mah",
      "Karacaören Mah",
      "Karagedik Aydın Mah",
      "Karagedik Ercan Mah",
      "Karaoğlan Mah",
      "Karşıyaka Mah",
      "Kırıklı Mah",
      "Kızılcaşar Mah",
      "Koparan Mah",
      "Mahmatlı Mah",
      "Mahmatlıbahçe Mah",
      "Oğulbey Mah",
      "Oyaca Akarsu Mah",
      "Oyaca Yeşilçam Mah",
      "Örencik Mah",
      "Seğmenler Mah",
      "Selametli Şehit Emrah Mah",
      "Soğulcak Mah",
      "Subaşı Mah",
      "Şafak Mah",
      "Taşpınar Mah",
      "Tepeyurt Mah",
      "Topaklı Mah",
      "Tulumtaş Mah",
      "Velihimmetli Mah",
      "Yağlıpınar Mah",
      "Yavrucuk Mah",
      "Yaylabağ Mah",
      "Yurtbeyi Mah"
    ],
    "Güdül": [
      "Adalıkuzu Mah",
      "Afşar Mah",
      "Akbaş Mah",
      "Akçakese Mah",
      "Aşağı Mah",
      "Boyalı Mah",
      "Çağa Mah",
      "Çukurören Mah",
      "Emirler Mah",
      "Garipçe Mah",
      "Güneyce Mah",
      "Güzel Mah",
      "Hacılar Mah",
      "Kadıobası Mah",
      "Kamanlar Mah",
      "Karacaören Mah",
      "Kavaközü Mah",
      "Kayı Mah",
      "Kırkkavak Mah",
      "Meyvabükü Mah",
      "Özçaltı Mah",
      "Özköy Mah",
      "Salihler Mah",
      "Sapanlı Mah",
      "Sorgun Mah",
      "Tahtacıörencik Mah",
      "Taşören Mah",
      "Yelli Mah",
      "Yeni Mah",
      "Yeşilöz Mah",
      "Yukarı Mah"
    ],
    "Haymana": [
      "Ahırlıkuyu Mah",
      "Alaçık Mah",
      "Alahacılı Mah",
      "Altıpınar Mah",
      "Ataköy Mah",
      "Bahçecik Mah",
      "Balçıkhisar Mah",
      "Baltalin Mah",
      "Boğazkaya Mah",
      "Bostanhüyük Mah",
      "Bumsuz Mah",
      "Büyükkonak Mah",
      "Büyükyağcı Mah",
      "Cihanşah Mah",
      "Cingirli Mah",
      "Culuk Mah",
      "Çaldağ Mah",
      "Çalış Mah",
      "Çatak Mah",
      "Çayraz Mah",
      "Çeltikli Mah",
      "Demirözü Mah",
      "Dereköy Mah",
      "Deveci Mah",
      "Devecipınarı Mah",
      "Durupınar Mah",
      "Durutlar Mah",
      "Emirler Mah",
      "Esen Mah",
      "Eskikışla Mah",
      "Evci Mah",
      "Evliyafakı Mah",
      "Gedik Mah",
      "Gültepe Mah",
      "Güzelcekale Mah",
      "İncirli Mah",
      "Kadıköy Mah",
      "Karahoca Mah",
      "Karapınar Mah",
      "Karasüleymanlı Mah",
      "Katrancı Mah",
      "Kavak Mah",
      "Kayabaşı Mah",
      "Kerpiç Mah",
      "Kesikkavak Mah",
      "Kızılkoyunlu Mah",
      "Kirazoğlu Mah",
      "Kutluhan Mah",
      "Küçükkonak Mah",
      "Küçükyağcı Mah",
      "Mandıra Mah",
      "Medrese Mah",
      "Saatli Mah",
      "Sarıdeğirmen Mah",
      "Sarıgöl Mah",
      "Sazağası Mah",
      "Serinyayla Mah",
      "Seyran Mah",
      "Sındıran Mah",
      "Sırçasaray Mah",
      "Sinanlı Mah",
      "Soğulca Mah",
      "Söğüttepe Mah",
      "Şerefligökgöz Mah",
      "Tabaklı Mah",
      "Tepeköy Mah",
      "Toyçayırı Mah",
      "Türkhüyük Mah",
      "Türkşerefli Mah",
      "Yamak Mah",
      "Yaprakbayırı Mah",
      "Yaylabeyi Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yergömü Mah",
      "Yeşilköy Mah",
      "Yukarısebil Mah",
      "Yurtbeyli Mah"
    ],
    "Kahramankazan": [
      "Ahi Mah",
      "Akçaören Mah",
      "Akıncı Mah",
      "Alpagut Mah",
      "Aşağıkaraören Mah",
      "Atatürk Mah",
      "Aydın Mah",
      "Bitik Mah",
      "Ciğir Mah",
      "Çalta Mah",
      "Çimşit Mah",
      "Dağyaka Mah",
      "Dutözü Mah",
      "Emirgazi Mah",
      "Fatih Mah",
      "Fethiye Mah",
      "Günbaşı Mah",
      "Güvenç Mah",
      "İçören Mah",
      "İmrendi Mah",
      "İnceğiz Mah",
      "İne Mah",
      "İymir Mah",
      "Kanuni Sultan Süleyman Mah",
      "Karalar Mah",
      "Kayı Mah",
      "Kılıçlar Mah",
      "Kınık Mah",
      "Kışla Mah",
      "Kumpınar Mah",
      "Orhaniye Mah",
      "Örencik Mah",
      "Peçenek Mah",
      "Sancar Mah",
      "Saraç Mah",
      "Saray Mah",
      "Sarayosb Mah",
      "Sarıayak Mah",
      "Sarılar Mah",
      "Satıkadın Mah",
      "Soğucak Mah",
      "Tekke Mah",
      "Uçarı Mah",
      "Yakupderviş Mah",
      "Yassıören Mah",
      "Yavuz Sultan Selim Mah",
      "Yayalar Mah",
      "Yazıbeyli Mah",
      "Yıldırımbeyazıt Mah"
    ],
    "Kalecik": [
      "Afşar Mah",
      "Ahikemalşenyurt Mah",
      "Ahiler Yenice Mah",
      "Akcataş Mah",
      "Akkaynak Mah",
      "Akkuzulu Mah",
      "Aktepe Mah",
      "Alibeyli Mah",
      "Altıntaş Mah",
      "Arkbürk Mah",
      "Beykavağı Mah",
      "Buğra Mah",
      "Cuma Saray Mah",
      "Çandır Mah",
      "Çanşa Kale Mah",
      "Çaykaya Mah",
      "Çiftlikköy Mah",
      "Dağdemir Mah",
      "Değirmenkaya Mah",
      "Demirtaş Mah",
      "Elmapınar Mah",
      "Eskiköy Mah",
      "Eşmedere Mah",
      "Gökçeören Mah",
      "Gökdere Mah",
      "Gölköy Mah",
      "Gümüşpınar Mah",
      "Hacıköy Mah",
      "Halilağa Tabakhane Mah",
      "Halitcevriaslangil Mah",
      "Hançılı Mah",
      "Hasayaz Mah",
      "Karahöyük Mah",
      "Karalar Mah",
      "Karatepe Mah",
      "Karkın Mah",
      "Keklicek Mah",
      "Kılçak Mah",
      "Kınık Mah",
      "Kızılkaya Mah",
      "Koyunbaba Mah",
      "Kuyucak Mah",
      "Mahmutlar Mah",
      "Samanlık Mah",
      "Satılar Mah",
      "Şemsettin Mah",
      "Şeyhmahmut Mah",
      "Tavşancık Mah",
      "Tilki Mah",
      "Uyurca Mah",
      "Yalımköy Mah",
      "Yeniçöte Mah",
      "Yenidoğan Yeşilyurt Mah",
      "Yeşilöz Mah",
      "Yılanlı Mah",
      "Yurtyenice Mah",
      "Yüzbey Mah"
    ],
    "Keçiören": [
      "23 Nisan Mah",
      "Adnan Menderes Mah",
      "Aktepe Mah",
      "Bademlik Mah",
      "Bağlarbaşı Mah",
      "Çaldıran Mah",
      "Güzelyurt Mah",
      "Kamil Ocak Mah",
      "Köşk Mah",
      "Şefkat Mah",
      "Şenyuva Mah",
      "Uyanış Mah",
      "Yeşilöz Mah",
      "Yeşiltepe Mah",
      "Bağlum Güzelyurt Mah",
      "Çalseki Mah",
      "Hisar Mah",
      "Kafkas Mah",
      "Karakaya Mah",
      "Karşıyaka Mah",
      "Kösrelik Mah",
      "Sarıbeyler Mah",
      "Esertepe Mah",
      "Sancaktepe Mah",
      "Şehit Kubilay Mah",
      "Yayla Mah",
      "Yükseltepe Mah",
      "Aşağı Eğlence Mah",
      "Ayvalı Mah",
      "Basınevleri Mah",
      "Emrah Mah",
      "Etlik Mah",
      "İncirli Mah",
      "Gümüşdere Mah",
      "Hasköy Mah",
      "Kavacık Subayevleri Mah",
      "Kalaba Mah",
      "Karargahtepe Mah",
      "19 Mayıs Mah",
      "Çiçekli Mah",
      "Kuşcağız Mah",
      "Tepebaşı Mah",
      "Güçlükaya Mah",
      "Şenlik Mah",
      "Yakacık Mah",
      "Atapark Mah",
      "Kanuni Mah",
      "Osmangazi Mah",
      "Ovacık Mah",
      "Pınarbaşı Mah",
      "Ufuktepe Mah"
    ],
    "Kızılcahamam": [
      "Akçakese Mah",
      "Akçay Mah",
      "Akdoğan Mah",
      "Aksak Mah",
      "Alibey Mah",
      "Alpagut Mah",
      "Aşağıada Mah",
      "Aşağıçanlı Mah",
      "Aşağıhüyük Mah",
      "Ayvacık Mah",
      "Bademli Mah",
      "Bağlıca Mah",
      "Bağören Mah",
      "Balcılar Mah",
      "Başağaç Mah",
      "Bayır Mah",
      "Belpınar Mah",
      "Berçinçatak Mah",
      "Berçinyayalar Mah",
      "Beşkonak Mah",
      "Bezcikuzören Mah",
      "Binkoz Mah",
      "Bulak Mah",
      "Ciğirler Mah",
      "Çavuşlar Mah",
      "Çeltikçi Akçaören Mah",
      "Çeltikçi Başören Mah",
      "Çeltikçi Kınık Mah",
      "Çeltikçi Mah",
      "Çeştepe Mah",
      "Çırpan Mah",
      "Çukurca Mah",
      "Çukurören Mah",
      "Değirmenönü Mah",
      "Demirciören Mah",
      "Dereneci Mah",
      "Doğanözü Mah",
      "Doymuşören Mah",
      "Eğerlialören Mah",
      "Eğerlibaşköy Mah",
      "Eğerlidere Mah",
      "Eğerlikozören Mah",
      "Esenler Mah",
      "Gazi Mustafa Kemalpaşa Mah",
      "Gebeler Mah",
      "Gökbel Mah",
      "Göl Mah",
      "Gümele Mah",
      "Güneysaray Mah",
      "Güvem Mah",
      "Hıdırlar Mah",
      "İğdir Mah",
      "İğmir Mah",
      "İnceğez Mah",
      "İsmetpaşa Mah",
      "İyceler Mah",
      "Kalemler Mah",
      "Karaağaç Mah",
      "Karacaören Mah",
      "Karşıyaka Mah",
      "Kasımlar Mah",
      "Kavaközü Mah",
      "Kırkırca Mah",
      "Kırköy Mah",
      "Kışlak Mah",
      "Kızık Mah",
      "Kızılcaköy Mah",
      "Kızılcaören Mah",
      "Kocalar Mah",
      "Kurumcu Mah",
      "Kuşcuören Mah",
      "Mahkemeağcin Mah",
      "Oğlakcı Mah",
      "Olucak Mah",
      "Ortaköy Mah",
      "Otacı Mah",
      "Örencik Mah",
      "Pazar Başören Mah",
      "Pazar Kınık Mah",
      "Pazar Mah",
      "Salın Mah",
      "Saray Mah",
      "Saraycık Mah",
      "Sazak Mah",
      "Semeler Mah",
      "Semer Mah",
      "Süleler Mah",
      "Şahinler Mah",
      "Tahtalar Mah",
      "Taşlıca Mah",
      "Turnalı Mah",
      "Uğurlu Mah",
      "Üçbaş Mah",
      "Üyücek Mah",
      "Yağcıhüseyin Mah",
      "Yakakaya Mah",
      "Yanık Özbekler Mah",
      "Yenice Mah",
      "Yeşilköy Mah",
      "Yıldırımçatak Mah",
      "Yıldırımdemirciler Mah",
      "Yıldırımhacılar Mah",
      "Yıldırımören Mah",
      "Yıldırımyağlıca Mah",
      "Yukarıada Mah",
      "Yukarıçanlı Mah",
      "Yukarıhüyük Mah",
      "Yukarıkaraören Mah",
      "Yukarıkese Mah"
    ],
    "Mamak": [
      "Abidinpaşa Mah",
      "Aşık Veysel Mah",
      "Balkiraz Mah",
      "Çağlayan Mah",
      "Kartaltepe Mah",
      "Mehtap Mah",
      "Saimekadın Mah",
      "Tuzluçayır Mah",
      "Akdere Mah",
      "General Zeki Doğan Mah",
      "Kazım Orbay Mah",
      "Kutlu Mah",
      "Mutlu Mah",
      "Peyami Safa Mah",
      "Şehit Cengiz Topel Mah",
      "Türközü Mah",
      "Demirlibahçe Mah",
      "Şafaktepe Mah",
      "Altınevler Mah",
      "Bahçelerüstü Mah",
      "Diriliş Mah",
      "Gülveren Mah",
      "Hürel Mah",
      "Başak Mah",
      "Bostancık Mah",
      "Ekin Mah",
      "Akşemsettin Mah",
      "Araplar Mah",
      "Bayındır Mah",
      "Boğaziçi Mah",
      "Cengizhan Mah",
      "Derbent Mah",
      "Dostlar Mah",
      "Durali Alıç Mah",
      "Dutluk Mah",
      "Ege Mah",
      "Fahri Korutürk Mah",
      "Gökçeyurt Mah",
      "Kayaş Mah",
      "Kıbrısköy Mah",
      "Kızılca Mah",
      "Köstence Mah",
      "Kusunlar Mah",
      "Kutludüğün Mah",
      "Küçük Kayaş Mah",
      "Ortaköy Mah",
      "Şahap Gürler Mah",
      "Şirintepe Mah",
      "Tepecik Mah",
      "Üreğil Mah",
      "Yeni Bayındır Mah",
      "Yeşilbayır Mah",
      "Yukarı İmrohor Mah",
      "Zirvekent Mah",
      "Karşıyaka Mah",
      "Lalahan Mah",
      "Altıağaç Mah",
      "Bahçeleriçi Mah",
      "Çiğiltepe Mah",
      "Harman Mah",
      "Hüseyingazi Mah",
      "Karaağaç Mah",
      "Misket Mah",
      "Şahintepe Mah"
    ],
    "Nallıhan": [
      "100.yıl Mah",
      "Akdere Mah",
      "Aksu Mah",
      "Alan Mah",
      "Aliağa Mah",
      "Aliefe Mah",
      "Alpağut Mah",
      "Arkutça Mah",
      "Aşağıbağdere Mah",
      "Aşağıbağlıca Mah",
      "Aşağıkavacık Mah",
      "Atatürk Mah",
      "Atça Mah",
      "Aydoğmuş Mah",
      "Belenalan Mah",
      "Belenören Mah",
      "Beyalan Mah",
      "Beycik Mah",
      "Beydili Mah",
      "Bozyaka Mah",
      "Cendere Mah",
      "Çalıcaalan Mah",
      "Çamalan Mah",
      "Çayırhan Mah",
      "Çiller Mah",
      "Çive Mah",
      "Çulhalar Mah",
      "Danişment Mah",
      "Davutoğlan Mah",
      "Demirköy Mah",
      "Dereköy Mah",
      "Doğandere Mah",
      "Döğmeci Mah",
      "Eğri Mah",
      "Emremsultan Mah",
      "Epçeler Mah",
      "Ericek Mah",
      "Eymir Mah",
      "Fatih Mah",
      "Gökçeöz Mah",
      "Güzelöz Mah",
      "Hacıbey Mah",
      "Hacıhasanlar Mah",
      "Hıdırlar Mah",
      "İslamalan Mah",
      "Kabaca Mah",
      "Kadıköy Mah",
      "Karacasu Mah",
      "Karahisar Mah",
      "Karahisargölcük Mah",
      "Karahisarkozlu Mah",
      "Karaköy Mah",
      "Kavakköy Mah",
      "Kulu Mah",
      "Kuruca Mah",
      "Kuzucular Mah",
      "Meyildere Mah",
      "Meyilhacılar Mah",
      "Nallıdere Mah",
      "Nallıgölcük Mah",
      "Nasuhpaşa Mah",
      "Nebioğlu Mah",
      "Osmanköy Mah",
      "Ozan Mah",
      "Ömerşeyhler Mah",
      "Öşürler Mah",
      "Sarıkaya Mah",
      "Sarıyar Mah",
      "Sobran Mah",
      "Soğukkuyu Mah",
      "Subaşı Mah",
      "Tekirler Mah",
      "Tekke Mah",
      "Tepe Mah",
      "Uluhan Mah",
      "Uluköy Mah",
      "Uzunöz Mah",
      "Yakapınar Mah",
      "Yazı Mah",
      "Yenice Mah",
      "Yeşilyurt Mah",
      "Yukarıbağdere Mah",
      "Yukarıbağlıca Mah",
      "Yukarıkavacık Mah"
    ],
    "Polatlı": [
      "Adatoprakpınar Mah",
      "Avdanlı Mah",
      "Avşar Mah",
      "Babayakup Mah",
      "Basrı Mah",
      "Beşköprü Mah",
      "Beyceğiz Mah",
      "Beylikköprü Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Çanakçı Mah",
      "Çekirdeksiz Mah",
      "Çekirdeksizosb Mah",
      "Çimenceğiz Mah",
      "Esentepe Mah",
      "Eskikarsak Mah",
      "Eskiköseler Mah",
      "Eskipolatlı Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Gedikli Mah",
      "Gençali Mah",
      "Gülpınar Mah",
      "Gülveren Mah",
      "Gümüşyaka Mah",
      "Gündoğan Mah",
      "Güreş Mah",
      "Hacımusa Mah",
      "Hacımuslu Mah",
      "Hacıosmanoğlu Mah",
      "Hacıtuğrul Mah",
      "Hıdırşeyh Mah",
      "Ilıca Mah",
      "İğciler Mah",
      "İnler Mah",
      "İstiklal Mah",
      "Kabak Mah",
      "Karaahmet Mah",
      "Karabenli Mah",
      "Karacaahmet Mah",
      "Karahamzalı Mah",
      "Karailyas Mah",
      "Karakaya Mah",
      "Karakuyu Mah",
      "Karapınar Mah",
      "Karayavşan Mah",
      "Kargalı Mah",
      "Kayabaşı Mah",
      "Kıranharmanı Mah",
      "Kızılcakışla Mah",
      "Kocahacılı Mah",
      "Kurtuluş Mah",
      "Kuşcu Mah",
      "Macun Mah",
      "Mehmetakif Mah",
      "Müslüm Mah",
      "Oğuzlar Mah",
      "Olukpınar Mah",
      "Ömerler Mah",
      "Ördekgölü Mah",
      "Özyurt Mah",
      "Poyraz Mah",
      "Sabanca Mah",
      "Sakarya Mah",
      "Sarıhalil Mah",
      "Sarıoba Mah",
      "Sazlar Mah",
      "Sinanlı Mah",
      "Sincik Mah",
      "Sivri Mah",
      "Şabanözü Mah",
      "Şehitlik Mah",
      "Şentepe Mah",
      "Şeyhali Mah",
      "Şıhahmetli Mah",
      "Taşpınar Mah",
      "Tatlıkuyu Mah",
      "Toydemir Mah",
      "Tüfekçioğlu Mah",
      "Türkkarsak Mah",
      "Türktaciri Mah",
      "Uzunbey Mah",
      "Üçpınar Mah",
      "Yağcıoğlu Mah",
      "Yağmurbaba Mah",
      "Yaralı Mah",
      "Yassıhüyük Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Yeniköseler Mah",
      "Yenimehmetli Mah",
      "Yeşilöz Mah",
      "Yıldızlı Mah",
      "Yüzükbaşı Mah",
      "Zafer Mah"
    ],
    "Pursaklar": [
      "Abadan Mah",
      "Altınova Mah",
      "Ayyıldız Mah",
      "Fatih Mah",
      "Karaköy Mah",
      "Karşıyaka Mah",
      "Kösrelikkızığı Mah",
      "Merkez Mah",
      "Mimar Sinan Mah",
      "Peçenek Mah",
      "Saray Cumhuriyet Mah",
      "Saray Fatih Mah",
      "Saray Gümüşoluk Mah",
      "Saray Osmangazi Mah",
      "Sirkeli Yeşilova Mah",
      "Sirkeli Yeşilyurt Mah",
      "Tevfik İleri Mah",
      "Yeni Karaköy Mah",
      "Yıldırım Beyazıt Mah",
      "Yunus Emre Mah",
      "Yuva Mah"
    ],
    "Sincan": [
      "Ahi Evran Mah",
      "Ahi Evran Osb Mah",
      "Fatih Mah",
      "Gazi Osmanpaşa Mah",
      "Gökçek Mah",
      "Mevlana Mah",
      "Törekent Mah",
      "Ulubatlı Hasan Mah",
      "Yunus Emre Mah",
      "Akşemsettin Mah",
      "Anayurt Mah",
      "Andiçen Mah",
      "Atatürk Mah",
      "Çiçektepe Mah",
      "Ertuğrulgazi Mah",
      "Esenler Mah",
      "İstasyon Mah",
      "Kesiktaş Mah",
      "Malazgirt Mah",
      "Maraşal Çakmak Mah",
      "Osmaniye Mah",
      "Osmanlı Mah",
      "Pınarbaşı Mah",
      "Plevne Mah",
      "Polatlar Mah",
      "Saraycık Mah",
      "Selçuklu Mah",
      "Tandoğan Mah",
      "Tatlar Mah",
      "Yeniçimşit Mah",
      "Yenipeçenek Mah",
      "Alagöz Mah",
      "Alcı Mah",
      "Alcı Osb Mah",
      "Bacı Mah",
      "Beyobası Mah",
      "Cumhuriyet Mah",
      "Çokören Mah",
      "Gazi Mah",
      "Girmeç Mah",
      "Hisarlıkaya Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Malıköy Anadolu Osb Mah",
      "Malıköy Başkent Osb Mah",
      "Malıköy Dökümcüler Osb Mah",
      "Malıköy Mah",
      "Türkobası Mah",
      "Ücret Mah",
      "Yenihisar Mah",
      "29 Ekim Mah",
      "Adalet Mah",
      "Akçaören Mah",
      "Çoğlu Mah",
      "Erkeksu Mah",
      "Fevzi Çakmak Mah",
      "İlyakut Mah",
      "İncirlik Mah",
      "Menderes Mah",
      "Mustafa Kemal Mah",
      "Mülk Mah",
      "Yenikayı Mah"
    ],
    "Şereflikoçhisar": [
      "Acıkuyu Mah",
      "Acıöz Mah",
      "Akarca Mah",
      "Akin Mah",
      "Akseki Mah",
      "Aktaş Mah",
      "Aliuşağı Mah",
      "Bağobası Mah",
      "Baltalı Mah",
      "Boğaziçi Mah",
      "Büyükdamlacık Mah",
      "Büyükkışla Mah",
      "Cıngıl Mah",
      "Cumhuriyet Mah",
      "Çalören Mah",
      "Çatçat Mah",
      "Çavuşköy Mah",
      "Çayırönü Mah",
      "Deliller Mah",
      "Devekovan Mah",
      "Doğankaya Mah",
      "Ekici Mah",
      "Eley Mah",
      "Emek Mah",
      "Fadıllı Mah",
      "Geçitli Mah",
      "Gülhüyük Mah",
      "Hacıbektaşlı Mah",
      "Hacıenbiya Mah",
      "Hamzalı Mah",
      "Haydarlı Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Kacarlı Mah",
      "Kadıncık Mah",
      "Kadıobası Mah",
      "Kale Mah",
      "Karabük Mah",
      "Karamollauşağı Mah",
      "Karandere Mah",
      "Küçükdamlacık Mah",
      "Mehmet Akif Ersoy Mah",
      "Mustafacık Mah",
      "Mustafacık Osb Mah",
      "Musular Mah",
      "Odunboğazı Mah",
      "Palazobası Mah",
      "Parlasan Mah",
      "Sadıklı Mah",
      "Sanayi Mah",
      "Sarıkaya Mah",
      "Seymenli Mah",
      "Şanlıkışla Mah",
      "Şekerköy Mah",
      "Şereflidavutlu Mah",
      "Şeyh Kuyusu Mah",
      "Şeyhli Mah",
      "Tuzla Mah",
      "Üzengilik Mah",
      "Yalnızpınar Mah",
      "Yazısöğüt Mah",
      "Yeni Mah",
      "Yeşilova Mah",
      "Yeşilyurt Mah",
      "Yusufkuyusu Mah"
    ],
    "Yenimahalle": [
      "Beştepe Mah",
      "Emniyet Mah",
      "Gazi Mah",
      "Batı Sitesi Mah",
      "Ergazi Mah",
      "İlkyerleşim Mah",
      "İnönü Mah",
      "Kardelen Mah",
      "Kentkoop Mah",
      "Turgut Özal Mah",
      "Uğur Mumcu Mah",
      "Yeni Batı Mah",
      "25 Mart Mah",
      "Çamlıca Mah",
      "Demetevler Mah",
      "Demetgül Mah",
      "Demetlale Mah",
      "Mehmet Akif Ersoy Mah",
      "İvedikköy Mah",
      "İvedikosb Mah",
      "Barış Mah",
      "Karşıyaka Mah",
      "Özevler Mah",
      "Yeşilevler Mah",
      "Ata Mah",
      "Karacakaya Mah",
      "Kuzey Yıldızı Mah",
      "Macun Mah",
      "Memlik Mah",
      "Susuz Mah",
      "Yakacık Mah",
      "Yuvaköy Mah",
      "Ostim Mah",
      "Ostim Osb Mah",
      "Serhat Mah",
      "Anadolu Mah",
      "Aşağı Yahyalar Mah",
      "Avcılar Mah",
      "Barıştepe Mah",
      "Burç Mah",
      "Çiğdemtepe Mah",
      "Güventepe Mah",
      "Güzelyaka Mah",
      "Kaletepe Mah",
      "Kayalar Mah",
      "Pamuklar Mah",
      "Yukarı Yahyalar Mah",
      "Çarşı Mah",
      "Ergenekon Mah",
      "Esentepe Mah",
      "Gayret Mah",
      "Işınlar Mah",
      "Ragıp Tüzün Mah",
      "Tepealtı Mah",
      "Varlık Mah",
      "Yeniçağ Mah",
      "Yunus Emre Mah"
    ]
  },
  "Antalya": {
    "Akseki": [
      "Akşahap Mah",
      "Alaçeşme Mah",
      "Aşağıaşıklar Mah",
      "Bademli Mah",
      "Belenalan Mah",
      "Boğaz Mah",
      "Bucakalan Mah",
      "Bucakkışla Mah",
      "Büyükalan Mah",
      "Ceceler Mah",
      "Cemerler Mah",
      "Cendeve Mah",
      "Çaltılıçukur Mah",
      "Çanakpınar Mah",
      "Çınardibi Mah",
      "Çimiköy Mah",
      "Çukurköy Mah",
      "Değirmenlik Mah",
      "Demirciler Mah",
      "Dikmen Mah",
      "Dutluca Mah",
      "Emiraşıklar Mah",
      "Erenyaka Mah",
      "Fakılar Mah",
      "Geriş Mah",
      "Güçlüköy Mah",
      "Gümüşdamla Mah",
      "Güneykaya Mah",
      "Günyaka Mah",
      "Güzelsu Mah",
      "Hacı İlyas Mah",
      "Hocaköy Mah",
      "Hüsamettinköy Mah",
      "Karakışla Mah",
      "Kepez Mah",
      "Kepezbeleni Mah",
      "Kuyucak Mah",
      "Mahmutlu Mah",
      "Menteşbey Mah",
      "Minareli Mah",
      "Pınarbaşı Mah",
      "Sadıklar Mah",
      "Salihler Mah",
      "Sarıhacılar Mah",
      "Sarıhaliller Mah",
      "Sinanhoca Mah",
      "Susuzşahap Mah",
      "Süleymaniye Mah",
      "Taşlıca Mah",
      "Yarpuz Mah",
      "Cevizli Mah"
    ],
    "Aksu": [
      "Alaylı Mah",
      "Altıntaş Mah",
      "Atatürk Mah",
      "Barbaros Mah",
      "Boztepe Mah",
      "Cihadiye Mah",
      "Cumhuriyet Mah",
      "Çalkaya Mah",
      "Çamköy Mah",
      "Dumanlar Mah",
      "Fatih Mah",
      "Fettahlı Mah",
      "Gökdere Mah",
      "Güloluk Mah",
      "Güzelyurt Mah",
      "Hacıaliler Mah",
      "İhsaniye Mah",
      "Karaçallı Mah",
      "Karaöz Mah",
      "Kayadibi Mah",
      "Kemerağzı Mah",
      "Konak Mah",
      "Kumköy Mah",
      "Kundu Mah",
      "Kurşunlu Mah",
      "Macun Mah",
      "Mandırlar Mah",
      "Murtuna Mah",
      "Pınarlı Mah",
      "Soğucaksu Mah",
      "Solak Mah",
      "Topallı Mah",
      "Yenidumanlar Mah",
      "Yeşilkaraman Mah",
      "Yurtpınar Mah"
    ],
    "Alanya": [
      "Akçatı Mah",
      "Akdam Mah",
      "Alacami Mah",
      "Alara Mah",
      "Asmaca Mah",
      "Bademağacı Mah",
      "Basırlı Mah",
      "Başköy Mah",
      "Bayır Mah",
      "Bayırkozağacı Mah",
      "Bektaş Mah",
      "Beldibi Mah",
      "Bıçakçı Mah",
      "Bucak Mah",
      "Burçaklar Mah",
      "Büyükhasbahçe Mah",
      "Cikcilli Mah",
      "Cumhuriyet Mah",
      "Çakallar Mah",
      "Çarşı Mah",
      "Çıplaklı Mah",
      "Değirmendere Mah",
      "Dere Mah",
      "Dinek Mah",
      "Elikesik Mah",
      "Emişbeleni Mah",
      "Fakırcalı Mah",
      "Fığla Mah",
      "Gözübüyük Mah",
      "Güller Pınarı Mah",
      "Gümüşgöze Mah",
      "Gümüşkavak Mah",
      "Güney Mah",
      "Güzelbağ Mah",
      "Hacet Mah",
      "Hacıkerimler Mah",
      "Hacımehmetli Mah",
      "Hisariçi Mah",
      "Kadıpaşa Mah",
      "Karakocalı Mah",
      "Karamanlar Mah",
      "Karapınar Mah",
      "Kayabaşı Mah",
      "Kızılcaşehir Mah",
      "Kızlar Pınarı Mah",
      "Küçükhasbahçe Mah",
      "Mahmutseydi Mah",
      "Oba Mah",
      "Obaalacami Mah",
      "Orhan Mah",
      "Öteköy Mah",
      "Paşaköy Mah",
      "Saburlar Mah",
      "Sapadere Mah",
      "Saray Mah",
      "Soğukpınar Mah",
      "Sugözü Mah",
      "Süleymanlar Mah",
      "Şekerhane Mah",
      "Şıhlar Mah",
      "Taşbaşı Mah",
      "Tepe Mah",
      "Tırılar Mah",
      "Tophane Mah",
      "Toslak Mah",
      "Tosmur Mah",
      "Türktaş Mah",
      "Uğurlu Mah",
      "Uzunöz Mah",
      "Üzümlü Mah",
      "Yalçı Mah",
      "Yasirali Mah",
      "Yaylakonak Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Avsallar Mah",
      "İncekum Mah",
      "Konaklı Mah",
      "Okurcalar Mah",
      "Payallar Mah",
      "Türkler Mah",
      "Demirtaş Mah",
      "Kestel Mah",
      "Aliefendi Mah",
      "Beyreli Mah",
      "Büyükpınar Mah",
      "Çamlıca Mah",
      "Gözüküçüklü Mah",
      "Hocalar Mah",
      "İmamlı Mah",
      "İsbatlı Mah",
      "İshaklı Mah",
      "Kargıcak Mah",
      "Keşefli Mah",
      "Kocaoğlanlı Mah",
      "Kuzyaka Mah",
      "Mahmutlar Mah",
      "Özvadi Mah",
      "Seki Mah",
      "Uğrak Mah",
      "Yaylalı Mah",
      "Yeşilöz Mah"
    ],
    "Demre": [
      "Belören Mah",
      "Çağman Mah",
      "Çevreli Mah",
      "Davazlar Mah",
      "Gürses Mah",
      "Kaleüçağız Mah",
      "Kapaklı Mah",
      "Yavu Mah",
      "Alakent Mah",
      "Büyükkum Mah",
      "Gökyazı Mah",
      "Karabucak Mah",
      "Küçükkum Mah",
      "Yaylakaya Mah",
      "Beymelek Mah",
      "Kayaaltı Mah",
      "Köşkerler Mah"
    ],
    "Döşemealtı": [
      "Ahırtaş Mah",
      "Akkoç Mah",
      "Altınkale Mah",
      "Aosb1kısım Mah",
      "Aosb2kısım Mah",
      "Aosb3kısım Mah",
      "Aşağıoba Mah",
      "Ayanlar Mah",
      "Aydınlar Mah",
      "Bademağacı Mah",
      "Bahçeyaka Mah",
      "Bıyıklı Mah",
      "Camili Mah",
      "Çığlık Mah",
      "Çıplaklı Mah",
      "Dağbeli Mah",
      "Dereli Mah",
      "Düzlerçamı Mah",
      "Ekşili Mah",
      "Ilıcaköy Mah",
      "Karaman Mah",
      "Karataş Mah",
      "Karaveliler Mah",
      "Kevşirler Mah",
      "Killik Mah",
      "Kovanlık Mah",
      "Kömürcüler Mah",
      "Nebiler Mah",
      "Orta Mah",
      "Selimiye Mah",
      "Tomalar Mah",
      "Yağca Mah",
      "Yalınlı Mah",
      "Yeniköy Mah",
      "Yeşilbayır Mah"
    ],
    "Elmalı": [
      "Akçay Mah",
      "Afşar Mah",
      "Ahatlı Mah",
      "Akçaeniş Mah",
      "Armutlu Mah",
      "Bayındır Mah",
      "Bayralar Mah",
      "Beyler Mah",
      "Bozhüyük Mah",
      "Büyüksöğle Mah",
      "Camiatik Mah",
      "Camicedit Mah",
      "Çaybaşı Mah",
      "Çobanisa Mah",
      "Çukurelma Mah",
      "Dereköy Mah",
      "Düden Mah",
      "Eskihisar Mah",
      "Eymir Mah",
      "Geçit Mah",
      "Geçmen Mah",
      "Gökpınar Mah",
      "Gölova Mah",
      "Göltarla Mah",
      "Gümüşyaka Mah",
      "Gündoğan Mah",
      "Hacımusalar Mah",
      "Hacıyusuflar Mah",
      "İlyağı Mah",
      "İmircik Mah",
      "İplik Pazarı Mah",
      "İslamlar Mah",
      "Kapmescit Mah",
      "Karaköy Mah",
      "Karamık Mah",
      "Karyağdı Mah",
      "Kışla Mah",
      "Kızılca Mah",
      "Kocapınar Mah",
      "Kuzköy Mah",
      "Küçüksöğle Mah",
      "Macun Mah",
      "Mursal Mah",
      "Ovacık Mah",
      "Özdemir Mah",
      "Pirhasanlar Mah",
      "Salur Mah",
      "Sarılar Mah",
      "Tahtamescit Mah",
      "Tavullar Mah",
      "Tekke Mah",
      "Toklular Mah",
      "Yakaçiftlikköyü Mah",
      "Yalnızdam Mah",
      "Yapraklı Mah",
      "Yeni Mah",
      "Yılmazlı Mah",
      "Yörenler Mah",
      "Yuva Mah",
      "Zümrütova Mah"
    ],
    "Finike": [
      "Akçaalan Mah",
      "Alacadağ Mah",
      "Arif Mah",
      "Asarönü Mah",
      "Boldağ Mah",
      "Çamlıbel Mah",
      "Dağbağ Mah",
      "Ernez Mah",
      "Eski Mah",
      "Gökbük Mah",
      "Gökçeyaka Mah",
      "Hasyurt Mah",
      "İskele Mah",
      "Kale Mah",
      "Karşıyaka Mah",
      "Kızılca Mah",
      "Kum Mah",
      "Sahilkent Mah",
      "Saklısu Mah",
      "Turunçova Mah",
      "Yalnız Mah",
      "Yazır Mah",
      "Yeni Mah",
      "Yeşilköy Mah",
      "Yeşilyurt Mah",
      "Yuvalı Mah"
    ],
    "Gazipaşa": [
      "Akoluk Mah",
      "Aydın Mah",
      "Aydıncık Mah",
      "Bakılar Mah",
      "Beyobası Mah",
      "Beyrebucak Mah",
      "Cumhuriyet Mah",
      "Çakmak Mah",
      "Çalıpınar Mah",
      "Çamlıca Mah",
      "Çığlık Mah",
      "Çile Mah",
      "Çimenbağ Mah",
      "Çobanlar Mah",
      "Çörüş Mah",
      "Doğanca Mah",
      "Ekmel Mah",
      "Esenpınar Mah",
      "Esentepe Mah",
      "Gazi Mah",
      "Göçük Mah",
      "Gökçebelen Mah",
      "Gökçesaray Mah",
      "Güneyköy Mah",
      "Gürçam Mah",
      "Hasdere Mah",
      "Ilıca Mah",
      "İnal Mah",
      "İnceğiz Mah",
      "İstiklal Mah",
      "Kahyalar Mah",
      "Karaçukur Mah",
      "Karalar Mah",
      "Karatepe Mah",
      "Kırahmetler Mah",
      "Kızılgüney Mah",
      "Koru Mah",
      "Korubaşı Mah",
      "Küçüklü Mah",
      "Macar Mah",
      "Muzkent Mah",
      "Öznurtepe Mah",
      "Pazarcı Mah",
      "Sarıağaç Mah",
      "Sugözü Mah",
      "Şahinler Mah",
      "Üçkonak Mah",
      "Yakacık Mah",
      "Yeni Mah",
      "Yenigüney Mah",
      "Yeniköy Mah",
      "Yeşilyurt Mah",
      "Zeytinada Mah"
    ],
    "Gündoğmuş": [
      "Akyar Mah",
      "Balkaya Mah",
      "Bedan Mah",
      "Çaltı Mah",
      "Çamlıalan Mah",
      "Çayırözü Mah",
      "Çiçekoluk Mah",
      "Eskibağ Mah",
      "Fatih Mah",
      "Güneycik Mah",
      "Güneyyaka Mah",
      "Kalecik Mah",
      "Karabul Mah",
      "Karadere Mah",
      "Karaisa Mah",
      "Karaköy Mah",
      "Kayabükü Mah",
      "Kozağacı Mah",
      "Köprülü Mah",
      "Narağacı Mah",
      "Ortakonuş Mah",
      "Ortaköy Mah",
      "Özügür Mah",
      "Pembelik Mah",
      "Rasih Kaplan Mah",
      "Senir Mah",
      "Serinyaka Mah",
      "Umutlu Mah",
      "Yeniköy Mah"
    ],
    "İbradı": [
      "Aşağı Mah",
      "Aydınyayla Mah",
      "Başlar Mah",
      "Çukurviran Mah",
      "Düzlen Mah",
      "Ormana Mah",
      "Ürünlü Mah",
      "Üzümdere Mah",
      "Yukarı Mah"
    ],
    "Kaş": [
      "Beldibi Mah",
      "Cemre Mah",
      "Çamlıköy Mah",
      "Çamlıova Mah",
      "Sütleğen Mah",
      "Yaylakılınçlı Mah",
      "Yaylapalamut Mah",
      "Yeşilbarak Mah",
      "Yuvacık Mah",
      "Gömbe Mah",
      "Aklar Mah",
      "Bezirgan Mah",
      "Çavdır Mah",
      "Çayköy Mah",
      "Gelemiş Mah",
      "Hacıoğlan Mah",
      "İkizce Mah",
      "İslamlar Mah",
      "Kalkan Mah",
      "Palamut Mah",
      "Sarıbelen Mah",
      "Üzümlü Mah",
      "Ağullu Mah",
      "Ahatlı Mah",
      "Akörü Mah",
      "Andifli Mah",
      "Bayındır Mah",
      "Belenli Mah",
      "Belkonak Mah",
      "Boğazcık Mah",
      "Çataloluk Mah",
      "Çerler Mah",
      "Çeşme Mah",
      "Çukurbağ Mah",
      "Dere Mah",
      "Dirgenler Mah",
      "Doğantaş Mah",
      "Gökçeören Mah",
      "Gökçeyazı Mah",
      "Gürsu Mah",
      "Karadağ Mah",
      "Kasaba Mah",
      "Kemer Mah",
      "Kızılağaç Mah",
      "Ortabağ Mah",
      "Pınarbaşı Mah",
      "Sahilkılınçlı Mah",
      "Sarılar Mah",
      "Sinneli Mah",
      "Uğrar Mah",
      "Yeniköy Mah",
      "Kınık Mah",
      "Ova Mah",
      "Yeşilköy Mah"
    ],
    "Kemer": [
      "Beldibi Mah",
      "Beycik Mah",
      "Ovacık Mah",
      "Ulupınar Mah",
      "Çamyuva Mah",
      "Göynük Mah",
      "Arslanbucak Mah",
      "Kiriş Mah",
      "Kuzdere Mah",
      "Merkez Mah",
      "Yeni Mah",
      "Tekirova Mah"
    ],
    "Kepez": [
      "Ahatlı Mah",
      "Fabrikalar Mah",
      "Kepez Mah",
      "Kültür Mah",
      "Santral Mah",
      "Yeni Doğan Mah",
      "Altınova Düden Mah",
      "Altınova Orta Mah",
      "Altınova Sinan Mah",
      "Atatürk Mah",
      "Özgürlük Mah",
      "Ulus Mah",
      "Yeşiltepe Mah",
      "Yükseliş Mah",
      "Zafer Mah",
      "Avni Tolunay Mah",
      "Duraliler Mah",
      "Gülveren Mah",
      "Şafak Mah",
      "Ünsal Mah",
      "Yeşilyurt Mah",
      "Beşkonaklılar Mah",
      "Düdenbaşı Mah",
      "Göksu Mah",
      "Güneş Mah",
      "Teomanpaşa Mah",
      "Barış Mah",
      "Çamlıbel Mah",
      "Çankaya Mah",
      "Erenköy Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Göçerler Mah",
      "Kanal Mah",
      "Kazım Karabekir Mah",
      "Kütükçü Mah",
      "Yavuz Selim Mah",
      "Baraj Mah",
      "Gazi Mah",
      "Habibler Mah",
      "Hüsnü Karakaş Mah",
      "Mehmet Akif Ersoy Mah",
      "Sütçüler Mah",
      "Aktoprak Mah",
      "Altıayak Mah",
      "Ayanoğlu Mah",
      "Aydoğmuş Mah",
      "Demirel Mah",
      "Fevzi Çakmak Mah",
      "Gaziler Mah",
      "Menderes Mah",
      "Şelale Mah",
      "Varsak Esentepe Mah",
      "Varsak Karşıyaka Mah",
      "Varsak Menderes Mah",
      "Zeytinlik Mah",
      "Başköy Mah",
      "Çamlıca Mah",
      "Duacı Mah",
      "Emek Mah",
      "Gündoğdu Mah",
      "Karşıyaka Mah",
      "Kızıllı Mah",
      "Kirişçiler Mah",
      "Kuzeyyaka Mah",
      "Odabaşı Mah",
      "Yeni Emek Mah",
      "Yeni Mah"
    ],
    "Konyaaltı": [
      "Akdamlar Mah",
      "Akkuyu Mah",
      "Altınkum Mah",
      "Arapsuyu Mah",
      "Aşağıkaraman Mah",
      "Çağlarca Mah",
      "Çitdibi Mah",
      "Doyran Çamlıbel Mah",
      "Doyran Dağ Mah",
      "Doyran Mah",
      "Geyikbayırı Mah",
      "Gökçam Mah",
      "Gürsu Mah",
      "Hacısekililer Mah",
      "Hisarçandır Mah",
      "Karatepe Mah",
      "Kır Mah",
      "Kuşkavağı Mah",
      "Molla Yusuf Mah",
      "Öğretmenevleri Mah",
      "Pınarbaşı Mah",
      "Siteler Mah",
      "Toros Mah",
      "Uluç Mah",
      "Uncalı Mah",
      "Üçoluk Mah",
      "Yarbaşçandır Mah",
      "Aydınlık Mah",
      "Bahtılı Mah",
      "Çakırlar Mah",
      "Demircilik Mah",
      "Gökdere Mah",
      "Hurma Mah",
      "Kuruçay Mah",
      "Liman Mah",
      "Liman Sb Mah",
      "Sarısu Mah",
      "Suiçecek Mah",
      "Yeni Mah",
      "Zümrüt Mah"
    ],
    "Korkuteli": [
      "Akyar Mah",
      "Alaaddin Mah",
      "Aşağıpazar Mah",
      "Avdan Mah",
      "Bahçeyaka Mah",
      "Bayat Mah",
      "Bayatbademleri Mah",
      "Beğiş Mah",
      "Bozova Mah",
      "Büyükköy Mah",
      "Çaykenarı Mah",
      "Çıvgalar Mah",
      "Çomaklı Mah",
      "Çukurca Mah",
      "Dereköy Mah",
      "Duraliler Mah",
      "Esenyurt Mah",
      "Garipce Mah",
      "Göçerler Mah",
      "Güzle Mah",
      "İmecik Mah",
      "İmrahor Mah",
      "Karabayır Mah",
      "Karakuyu Mah",
      "Karataş Mah",
      "Kargalık Mah",
      "Kargın Mah",
      "Karşıyaka Mah",
      "Kayabaş Mah",
      "Kemerağzı Mah",
      "Kevzer Mah",
      "Kırkpınar Mah",
      "Kızılaliler Mah",
      "Kızılcadağ Mah",
      "Kiremitli Mah",
      "Kozağacı Mah",
      "Köseler Mah",
      "Küçükköy Mah",
      "Küçüklü Mah",
      "Leylek Mah",
      "Mamatlar Mah",
      "Manay Mah",
      "Nebiler Mah",
      "Osmankalfalar Mah",
      "Sımandır Mah",
      "Söğütcük Mah",
      "Sülekler Mah",
      "Taşkesiği Mah",
      "Tatköy Mah",
      "Uzunoluk Mah",
      "Yakaköy Mah",
      "Yazır Mah",
      "Yeleme Mah",
      "Yelten Mah",
      "Yeni Mah",
      "Yeşiloba Mah",
      "Yeşilyayla Mah",
      "Yukarıkaraman Mah"
    ],
    "Kumluca": [
      "Adrasan Mah",
      "Altınyaka Mah",
      "Bağlık Mah",
      "Belen Mah",
      "Beşikçi Mah",
      "Beykonak Mah",
      "Büyükalan Mah",
      "Cumhuriyet Mah",
      "Çaltı Mah",
      "Çayiçi Mah",
      "Dereköy Mah",
      "Ellinci Yıl Mahallesi Mah",
      "Erentepe Mah",
      "Eskicami Mah",
      "Göksu Mah",
      "Gölcük Mah",
      "Güzören Mah",
      "Hacıveliler Mah",
      "Hızırkahya Mah",
      "İncircik Mah",
      "Karacaağaç Mah",
      "Karacaören Mah",
      "Karşıyaka Mah",
      "Kasapçayırı Mah",
      "Kavakköy Mah",
      "Kum Mah",
      "Kuzca Mah",
      "Merkez Mah",
      "Meydan Mah",
      "Narenciye Mah",
      "Ortaköy Mah",
      "Salur Mah",
      "Sarıcasu Mah",
      "Sarıkavak Mah",
      "Temel Eğitim Mahallesi Mah",
      "Toptaş Mah",
      "Yazır Mah",
      "Yeni Mah",
      "Yenikışla Mah",
      "Yeşilköy Mah",
      "Mavikent Mah"
    ],
    "Manavgat": [
      "Çolaklı Mah",
      "Evrenseki Mah",
      "A. Hisar Mah",
      "A. Pazarcı Mah",
      "Ahmetler Mah",
      "Aksaz Mah",
      "Aşağıışıklar Mah",
      "Aydınevler Mah",
      "Bahçelievler Mah",
      "Belenobası Mah",
      "Boztepe Mah",
      "Bucakşeyhler Mah",
      "Cevizler Mah",
      "Çağlayan Mah",
      "Çavuşköy Mah",
      "Çayyazı Mah",
      "Çeltikçi Mah",
      "Çenger Mah",
      "Demirciler Mah",
      "Dikmen Mah",
      "Doğançam Mah",
      "Dolbazlar Mah",
      "Emek Mah",
      "Eski Hisar Mah",
      "Evrenleryavşı Mah",
      "Gebece Mah",
      "Gençler Mah",
      "Gültepe Mah",
      "Gündoğdu Mah",
      "Güzelyalı Mah",
      "Hacıali Mah",
      "Hacıisalı Mah",
      "Hacıobası Mah",
      "Halitağalar Mah",
      "Hatipler Mah",
      "Hocalı Mah",
      "Ilıca Mah",
      "Kadılar Mah",
      "Kalemler Mah",
      "Karacalar Mah",
      "Karakaya Mah",
      "Karaöz Mah",
      "Karavca Mah",
      "Kasaplar Mah",
      "Kavaklı Mah",
      "Kızılağaç Mah",
      "Kızılot Mah",
      "Milli Egemenlik Mah",
      "Mimar Sinan Mah",
      "Namaras Mah",
      "Odaönü Mah",
      "Oymapınar Mah",
      "Örenşehir Mah",
      "Örnek Mah",
      "Salkım Evler Mah",
      "Salur Mah",
      "Sanayi Mah",
      "Saraçlı Mah",
      "Sarılar Mah",
      "Sevinçköy Mah",
      "Seydiler Mah",
      "Sırtköy Mah",
      "Sorgun Mah",
      "Sülek Mah",
      "Şelale Mah",
      "Şişeler Mah",
      "Taşkesiği Mah",
      "Tepeköy Mah",
      "Tilkiler Mah",
      "Ulukapı Mah",
      "Uzunkale Mah",
      "Uzunlar Mah",
      "Y.hisar Mah",
      "Y.pazarcı Mah",
      "Yalçıdibi Mah",
      "Yavrudoğan Mah",
      "Yayla Mah",
      "Yaylaalan Mah",
      "Yeniköy Mah",
      "Yukarıışıklar Mah",
      "Side Mah",
      "Altınkaya Mah",
      "Ballıbucak Mah",
      "Bereket Mah",
      "Beşkonak Mah",
      "Beydiğin Mah",
      "Burmahan Mah",
      "Büklüce Mah",
      "Çakış Mah",
      "Çaltepe Mah",
      "Çardakköy Mah",
      "Değirmenözü Mah",
      "Denizkent Mah",
      "Denizyaka Mah",
      "Düzağaç Mah",
      "Gaziler Mah",
      "Hocalar Mah",
      "Karabucak Mah",
      "Karabük Mah",
      "Kırkkavak Mah",
      "Kısalar Mah",
      "Kızıldağ Mah",
      "Perakende Mah",
      "Sağırin Mah",
      "Taşağıl Mah",
      "Yeşilbağ Mah"
    ],
    "Muratpaşa": [
      "Altındağ Mah",
      "Bahçelievler Mah",
      "Deniz Mah",
      "Memurevleri Mah",
      "Varlık Mah",
      "Yıldız Mah",
      "Balbey Mah",
      "Elmalı Mah",
      "Kışla Mah",
      "Kızılsaray Mah",
      "Tahılpazarı Mah",
      "Üçgen Mah",
      "Cumhuriyet Mah",
      "Dutlubahçe Mah",
      "Etiler Mah",
      "Konuksever Mah",
      "Muratpaşa Mah",
      "Sedir Mah",
      "Fener Mah",
      "Şirinyalı Mah",
      "Yeşilbahçe Mah",
      "Barbaros Mah",
      "Çaybaşı Mah",
      "Demircikara Mah",
      "Gençlik Mah",
      "Haşimişcan Mah",
      "Kılınçarslan Mah",
      "Selçuk Mah",
      "Sinan Mah",
      "Tuzcular Mah",
      "Zerdalilik Mah",
      "Doğuyaka Mah",
      "Gebizli Mah",
      "Kızılarık Mah",
      "Kızıltoprak Mah",
      "Mehmetçik Mah",
      "Topçular Mah",
      "Yenigün Mah",
      "Yeşildere Mah",
      "Yüksekalan Mah",
      "Çağlayan Mah",
      "Ermenek Mah",
      "Güzelbağ Mah",
      "Güzeloba Mah",
      "Yenigöl Mah",
      "Bayındır Mah",
      "Güvenlik Mah",
      "Meltem Mah",
      "Soğuksu Mah",
      "Güzeloluk Mah",
      "Kırcami Mah",
      "Meydankavağı Mah",
      "Tarım Mah",
      "Yeşilova Mah",
      "Zümrütova Mah"
    ],
    "Serik": [
      "Abdurrahmanlar Mah",
      "Akbaş Mah",
      "Akçaalan Mah",
      "Akçapınar Mah",
      "Alacami Mah",
      "Aşağıçatma Mah",
      "Aşağıkocayatak Mah",
      "Aşağıoba Mah",
      "Belek Mah",
      "Belkıs Mah",
      "Belpınar Mah",
      "Berendi Mah",
      "Bilginler Mah",
      "Boğazkent Mah",
      "Bozdoğan Mah",
      "Bucakköy Mah",
      "Burmahancı Mah",
      "Büğüş Mah",
      "Cumalı Mah",
      "Cumhuriyet Mah",
      "Çakallık Mah",
      "Çanakçı Mah",
      "Çandır Mah",
      "Çatallar Mah",
      "Demirciler Mah",
      "Deniztepesi Mah",
      "Dikmen Mah",
      "Dorumlar Mah",
      "Eminceler Mah",
      "Eskiyürük Mah",
      "Etler Mah",
      "Gebiz Mah",
      "Gedik Mah",
      "Gökçepınar Mah",
      "Hacıosmanlar Mah",
      "Hasdümen Mah",
      "Haskızılören Mah",
      "Haspınar Mah",
      "Kadriye Mah",
      "Karadayı Mah",
      "Karataş Mah",
      "Karıncalı Mah",
      "Kayaburnu Mah",
      "Kırbaş Mah",
      "Kozağacı Mah",
      "Kozan Mah",
      "Kökez Mah",
      "Kuşlar Mah",
      "Kürüş Mah",
      "Merkez Mah",
      "Nebiler Mah",
      "Orta Mah",
      "Pınarcık Mah",
      "Sarıabalı Mah",
      "Şatırlı Mah",
      "Tekke Mah",
      "Töngüşlü Mah",
      "Üründü Mah",
      "Yanköy Mah",
      "Yeni Mah",
      "Yeşilvadi Mah",
      "Yeşilyurt Mah",
      "Yukarıçatma Mah",
      "Yukarıkocayatak Mah",
      "Yumaklar Mah",
      "Zırlankaya Mah"
    ]
  },
  "Artvin": {
    "Ardanuç": [
      "Merkez Mah",
      "Afet Evleri Mah (ballı Köyü)",
      "Afet Evleri Mah (müezzinler Köyü)",
      "Ağagil Mah (gümüşhane Köyü)",
      "Ağagilin Mah (aydınköy Köyü)",
      "Ahmet Kayagil Mah (peynirli Köyü)",
      "Aliağagil Mah (gümüşhane Köyü)",
      "Aligil Mah (incilli Köyü)",
      "Anaçlı Köyü",
      "Arkim Mah (avcılar Köyü)",
      "Aşağı Cami Mah (aydınköy Köyü)",
      "Aşağı Mağnar Mah (aydınköy Köyü)",
      "Aşağı Mah (bağlıca Köyü)",
      "Aşağı Mah (hamurlu Köyü)",
      "Aşağı Mah (karlı Köyü)",
      "Aşağı Mah (kızılcık Köyü)",
      "Aşağı Mah (örtülü Köyü)",
      "Aşağı Şuvat Mah (aşıklar Köyü)",
      "Aşağı Yayla Mevkii Mah (güleş Köyü)",
      "Ayvazlar Mah (aşağıırmaklar Köyü)",
      "Bademli Mah (incilli Köyü)",
      "Bağlar Mah (bağlıca Köyü)",
      "Bağlar Mah (ferhatlı Köyü)",
      "Bağlar Mah (kutlu Köyü)",
      "Bahçelievler Mah (kapıköy Köyü)",
      "Bantaluğ Mah (aydınköy Köyü)",
      "Başaklar Mah (kızılcık Köyü)",
      "Başyiğitgil Mah (peynirli Köyü)",
      "Batak Mah (konaklı Köyü)",
      "Bayramgil Mah (bereket Köyü)",
      "Bekirgil Mah (peynirli Köyü)",
      "Beratlı Köyü",
      "Borgama Mah (aydınköy Köyü)",
      "Büyük Düz Mah (güleş Köyü)",
      "Büyük Yayla Mah (peynirli Köyü)",
      "Camandar Mah (aydınköy Köyü)",
      "Camandar Mah (peynirli Köyü)",
      "Camangelet Mah (aydınköy Köyü)",
      "Cami Mah (akarsu Köyü)",
      "Cami Mah (çakıllar Köyü)",
      "Cami Mah (geçitli Köyü)",
      "Cami Mah (incilli Köyü)",
      "Cami Mah (konaklı Köyü)",
      "Cami Mah (kutlu Köyü)",
      "Cami Mah (peynirli Köyü)",
      "Camili Mah (aşağıırmaklar Köyü)",
      "Cuğo Mah (soğanlı Köyü)",
      "Cumhuriyet Mah (kutlu Köyü)",
      "Çakızar Mah (çakıllar Köyü)",
      "Çatmalık Yaylası Mah (kızılcık Köyü)",
      "Çavuş Aligil Mah (ovacık Köyü)",
      "Çayağzı Mah (tepedüzü Köyü)",
      "Çevrelik Mah (bağlıca Köyü)",
      "Çınardibi Mah (gümüşhane Köyü)",
      "Dalahet Yaylası Mah (bereket Köyü)",
      "Demirci Mah (yolağzı Köyü)",
      "Dere Mah (akarsu Köyü)",
      "Derebağlar Mah (naldöken Köyü)",
      "Dikmen Yaylası Mah (ballı Köyü)",
      "Dorik Mah (çakıllar Köyü)",
      "Düz Mah (çakıllar Köyü)",
      "Efeköy Mah (peynirli Köyü)",
      "Ekşinar Köyü",
      "Emin Ağagil Mah (peynirli Köyü)",
      "Garaban Mah (aydınköy Köyü)",
      "Garbelet Mah (aydınköy Köyü)",
      "Gizelt Mah (aydınköy Köyü)",
      "Gomozor Yaylası Mah (aydınköy Köyü)",
      "Gonara Mah (soğanlı Köyü)",
      "Gorpota Mah (soğanlı Köyü)",
      "Gozirot Mah (bağlıca Köyü)",
      "Gölbaşı Mah (ovacık Köyü)",
      "Gülçayır Mah (aydınköy Köyü)",
      "Hacigil Mah (gümüşhane Köyü)",
      "Hamitgil Mah (gökçe Köyü)",
      "Harkbaşı Mah (akarsu Köyü)",
      "Harmanlı Köyü",
      "Has Mah (ovacık Köyü)",
      "Hasbahçe Mah (soğanlı Köyü)",
      "Hasmenlat Mah (peynirli Köyü)",
      "Hisarlı Köyü",
      "Horhot Mah (kızılcık Köyü)",
      "Hoşatgil Mah (incilli Köyü)",
      "Hürriyet Mah (kutlu Köyü)",
      "İmedegil Mah (gümüşhane Köyü)",
      "İsot Mah (bağlıca Köyü)",
      "Kadıgil Mah (aydınköy Köyü)",
      "Kadıgil Mah (incilli Köyü)",
      "Kadirağagil Mah (ovacık Köyü)",
      "Kaltdese Mah (aydınköy Köyü)",
      "Kanalt Mezrası Mah (aydınköy Köyü)",
      "Kansaliya Mah (aydınköy Köyü)",
      "Karagöl Yaylası Mah (aydınköy Köyü)",
      "Kavlaklı Mah (güleş Köyü)",
      "Kayadıbı Mah (sakarya Köyü)",
      "Kayadıbı Mah (torbalı Köyü)",
      "Kayagil Mah (kutlu Köyü)",
      "Kışla Mah (avcılar Köyü)",
      "Killit Mezrası Mah (kızılcık Köyü)",
      "Kirazlı Mah (bulanık Köyü)",
      "Kocaget Mah (bereket Köyü)",
      "Kolbaşı Mah (ovacık Köyü)",
      "Konaklı Yaylası Mah (akarsu Köyü)",
      "Konaklı Yaylası Mah (konaklı Köyü)",
      "Köprübaşı Mah (peynirli Köyü)",
      "Kurudat Mah (cevizlik Köyü)",
      "Kutul Mah (bulanık Köyü)",
      "Kuzey Mah (aydınköy Köyü)",
      "Künye Mah (sakarya Köyü)",
      "Kürdevan Yaylası Mah (aşıklar Köyü)",
      "Kürdeven İncilli Mah (incilli Köyü)",
      "Lanpuvar Mah (bağlıca Köyü)",
      "Lomat Mah (incilli Köyü)",
      "Lori Mah (bulanık Köyü)",
      "Mahmutlar Mah (kutlu Köyü)",
      "Mazman Mah (konaklı Köyü)",
      "Merkez Mah (akarsu Köyü)",
      "Merkez Mah (aşağıırmaklar Köyü)",
      "Merkez Mah (aşıklar Köyü)",
      "Merkez Mah (ballı Köyü)",
      "Merkez Mah (bulanık Köyü)",
      "Merkez Mah (cevizlik Köyü)",
      "Merkez Mah (çıralar Köyü)",
      "Merkez Mah (ferhatlı Köyü)",
      "Merkez Mah (geçitli Köyü)",
      "Merkez Mah (güleş Köyü)",
      "Merkez Mah (kapıköy Köyü)",
      "Merkez Mah (kaşıkçı Köyü)",
      "Merkez Mah (müezzinler Köyü)",
      "Merkez Mah (ovacık Köyü)",
      "Merkez Mah (örtülü Köyü)",
      "Merkez Mah (sakarya Köyü)",
      "Merkez Mah (tepedüzü Köyü)",
      "Merkez Mah (torbalı Köyü)",
      "Meşeköy Köyü",
      "Mezra Evleri Mah (kapıköy Köyü)",
      "Mezra Evleri Mah (karlı Köyü)",
      "Mezra Evleri Mah (tütünlü Köyü)",
      "Mezra Mah (yolağzı Köyü)",
      "Naldöken Köyü",
      "Nankar Mah (bağlıca Köyü)",
      "Ogeçe Mah (güleş Köyü)",
      "Orta Mah (bağlıca Köyü)",
      "Orta Mah (boyalı Köyü)",
      "Orta Mah (çakıllar Köyü)",
      "Orta Mah (soğanlı Köyü)",
      "Ozanlı Mah (bağlıca Köyü)",
      "Paşaağagilin Mah (kaşıkçı Köyü)",
      "Paşalık Yaylası Mah (kızılcık Köyü)",
      "Pintigil Mah (incilli Köyü)",
      "Sakatgil Mah (incilli Köyü)",
      "Salihağa Mah (bereket Köyü)",
      "Sanabet Mah (aydınköy Köyü)",
      "Sarsolot Mah (boyalı Köyü)",
      "Sedestpilin Mah (peynirli Köyü)",
      "Sık Mah (ovacık Köyü)",
      "Sıka Mah (kızılcık Köyü)",
      "Söğütlük Mah (güleş Köyü)",
      "Şatırgil Mah (bereket Köyü)",
      "Tabzor Mah (çıralar Köyü)",
      "Taşpınar Yaylası Mah (ballı Köyü)",
      "Tatlısu Mah (kızılcık Köyü)",
      "Taturgil Mah (bereket Köyü)",
      "Tayçala Mah (gökçe Köyü)",
      "Teknovet İnşaat Mah (soğanlı Köyü)",
      "Tikmanet Mah (bereket Köyü)",
      "Topçular Mah (peynirli Köyü)",
      "Tosunlu Köyü",
      "Tuzluca Mah (gümüşhane Köyü)",
      "Tütünlü Köyü",
      "Ustalar Köyü",
      "Uzun Çayır Yaylası Mah (hamurlu Köyü)",
      "Üzümlü Mah (akarsu Köyü)",
      "Varkenet Mah (aydınköy Köyü)",
      "Varzeli Mah (avcılar Köyü)",
      "Yanık Mah (konaklı Köyü)",
      "Yanıklar Mah (geçitli Köyü)",
      "Yapraklı Mah (bağlıca Köyü)",
      "Yayla Mah (geçitli Köyü)",
      "Yayla Mah (müezzinler Köyü)",
      "Yayla Mah (ovacık Köyü)",
      "Yayla Mah (tosunlu Köyü)",
      "Yayla Mah (zekeriyaköy Köyü)",
      "Yaylacık Köyü",
      "Yaylalar Mah (bulanık Köyü)",
      "Yıldızeli Mah (gümüşhane Köyü)",
      "Yobat Mah (peynirli Köyü)",
      "Yolağzı Köyü",
      "Yolüstü Köyü",
      "Yukarı Cami Mah (aydınköy Köyü)",
      "Yukarı Mağnar Mah (aydınköy Köyü)",
      "Yukarı Mah (bağlıca Köyü)",
      "Yukarı Mah (bereket Köyü)",
      "Yukarı Mah (boyalı Köyü)",
      "Yukarı Mah (hamurlu Köyü)",
      "Yukarı Mah (karlı Köyü)",
      "Yukarı Mah (peynirli Köyü)",
      "Yukarı Şuvat Mah (aşıklar Köyü)",
      "Yukarıırmaklar Köyü",
      "Zekeriyaköy Köyü"
    ],
    "Arhavi": [
      "Aşağı Hacılar Mah",
      "Boğaziçi Mah",
      "Cumhuriyet Mah",
      "Kale Mah",
      "Musazade Mah",
      "Yemişlik Mah",
      "Yukarı Hacılar Mah",
      "Akıncılar Mah (dikyamaç Köyü)",
      "Altılar Mah (üçler Köyü)",
      "Aslanlar Mah (sırtoba Köyü)",
      "Aşağı Mah (dereüstü Köyü)",
      "Aşağı Mah (konaklı Köyü)",
      "Aşağı Merkez Mah (başköy Köyü)",
      "Aşağı Üçler Mah (üçler Köyü)",
      "Aşağışahinler Köyü",
      "Aydoğdu Mah (yukarışahinler Köyü)",
      "Berzene Mah (kavak Köyü)",
      "Bıyıklıoğlu Mah (küçükköy Köyü)",
      "Boyuncuk Köyü",
      "Büyük Mah (derecik Köyü)",
      "Cenevizler Mah (dülgerli Köyü)",
      "Çamlıca Mah (başköy Köyü)",
      "Değirmendere Mah (ulukent Köyü)",
      "Demirciler Mah (dülgerli Köyü)",
      "Dere İçi Mah (üçırmak Köyü)",
      "Dereiçi 1 Mah (yukarışahinler Köyü)",
      "Dereiçi 2 Mah (yukarışahinler Köyü)",
      "Eskuat Mah (üçırmak Köyü)",
      "Eskuvat Mah (dülgerli Köyü)",
      "Güllavat Mah (küçükköy Köyü)",
      "Gültepe Mah (balıklı Köyü)",
      "Günaydın Mah (dereüstü Köyü)",
      "Gündoğdu Mah (yukarışahinler Köyü)",
      "Güneşli Köyü",
      "Güneyce Mah (balıklı Köyü)",
      "Güngören Köyü",
      "Gürgencik Köyü",
      "Hacılar Mah (soğucak Köyü)",
      "Hatinoğlu Mah (üçırmak Köyü)",
      "Hürriyet Mah (derecik Köyü)",
      "Isınali Mah (arılı Köyü)",
      "İsmail Çağ Mah (derecik Köyü)",
      "Kamilet Mah (arılı Köyü)",
      "Kamilet Mah (küçükköy Köyü)",
      "Kemerköprü Köyü",
      "Kestanealan Köyü",
      "Kireçlik Köyü",
      "Kozluca Mah (balıklı Köyü)",
      "Köroğlu Büyüklü Mah (kavak Köyü)",
      "Köseoğlu Mah (tepeyurt Köyü)",
      "Köyiçi Mah (arılı Köyü)",
      "Köyiçi Mah (soğucak Köyü)",
      "Kurtuluş Mah (üçler Köyü)",
      "Kusleta Mah (soğucak Köyü)",
      "Kuzey Mah (üçırmak Köyü)",
      "Küçük Mah (derecik Köyü)",
      "Mastaka Mah (başköy Köyü)",
      "Merkez Mah (derecik Köyü)",
      "Merkez Mah (dikyamaç Köyü)",
      "Merkez Mah (kavak Köyü)",
      "Merkez Mah (konaklı Köyü)",
      "Merkez Mah (ortacalar Köyü)",
      "Merkez Mah (sırtoba Köyü)",
      "Merkez Mah (tepeyurt Köyü)",
      "Merkez Mah (üçırmak Köyü)",
      "Merkez Mah (üçler Köyü)",
      "Merkez Mah (yolgeçen Köyü)",
      "Mezra Mah (başköy Köyü)",
      "Mezra Mah (dikyamaç Köyü)",
      "Mezra Mah (ortacalar Köyü)",
      "Naplat Mah (soğucak Köyü)",
      "Nopinare Mah (yolgeçen Köyü)",
      "Omjore Mah (dülgerli Köyü)",
      "Orta Mah (dereüstü Köyü)",
      "Orta Mah (kavak Köyü)",
      "Orta Mah (küçükköy Köyü)",
      "Orta Mah (üçırmak Köyü)",
      "Oymalı Mah (ortacalar Köyü)",
      "Örnek Mah (arılı Köyü)",
      "Peperdiha Mah (dülgerli Köyü)",
      "Sarıbaş Mah (dereüstü Köyü)",
      "Soğuksu Mah (dikyamaç Köyü)",
      "Sucuna Mah (dülgerli Köyü)",
      "Şahinler Mah (dülgerli Köyü)",
      "Şenköy Köyü",
      "Taşlık Mah (sırtoba Köyü)",
      "Taşpınar Mah (başköy Köyü)",
      "Türkmene Mah (kavak Köyü)",
      "Türkmene Mah (yolgeçen Köyü)",
      "Ulaş Köyü",
      "Yeni Mah (soğucak Köyü)",
      "Yeniyol Mah (yukarışahinler Köyü)",
      "Yeşillik Mah (ulukent Köyü)",
      "Yıldızlı Köyü",
      "Yılmazlar Mah (üçler Köyü)",
      "Yukarı Mah (dereüstü Köyü)",
      "Yukarı Mah (kavak Köyü)",
      "Yukarı Mah (konaklı Köyü)",
      "Yukarı Merkez Mah (başköy Köyü)",
      "Yukarı Ulukent Mah (ulukent Köyü)"
    ],
    "Borçka": [
      "Aksu Mah",
      "Gündoğdu Mah",
      "Küçük Köy Mah",
      "Merkez Mah",
      "Yeniyol Mah",
      "Adagül Köyü",
      "Adagül Mah (adagül Köyü)",
      "Akdilek Mah (boğazköy Köyü)",
      "Akpınar Köyü",
      "Ambarlı Köyü",
      "Aralık Köyü",
      "Aralık Mah (aralık Köyü)",
      "Aralık Mezra Mah (aralık Köyü)",
      "Arkaköy Köyü",
      "Arkaköy Mah (arkaköy Köyü)",
      "Atanoğlu Köyü",
      "Atanoğlu Mah (atanoğlu Köyü)",
      "Avcılar Köyü",
      "Balcı Köyü",
      "Başköy Mah (güzelyurt Köyü)",
      "Boğazköy Köyü",
      "Camili Köyü",
      "Camili Mah (camili Köyü)",
      "Civan Köyü",
      "Civan Mah (civan Köyü)",
      "Çarmakit Mah (kale Köyü)",
      "Çavuşlu Köyü",
      "Çaylıköy Köyü",
      "Çifteköprü Köyü",
      "Demirciler Köyü",
      "Düzenli Köyü",
      "Düzenli Mah (düzenli Köyü)",
      "Düzhanlar Mah (kale Köyü)",
      "Düzköy Köyü",
      "Efeler Köyü",
      "Esentepe Mah (ibrikli Köyü)",
      "Fındıklı Köyü",
      "Güneşli Köyü",
      "Güreşen Köyü",
      "Işıklı Mah (alaca Köyü)",
      "İbrikli Mah (ibrikli Köyü)",
      "Karşıköy Köyü",
      "Kayadibi Köyü",
      "Kayalar Köyü",
      "Kayalar Mah (kayalar Köyü)",
      "Kaynarca Köyü",
      "Kaynarca Mah (kaynarca Köyü)",
      "Kazanakapı Mah (güzelyurt Köyü)",
      "Longana Mah (güzelyurt Köyü)",
      "Maral Köy Mah (maralköy Köyü)",
      "Maralköy Köyü",
      "Merkez Mah (alaca Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (ibrikli Köyü)",
      "Mezra Mah (efeler Köyü)",
      "Muratlı Köyü",
      "Orhan Mah (alaca Köyü)",
      "Ortadere Mah (alaca Köyü)",
      "Örücüler Köyü",
      "Örücüler Mah (örücüler Köyü)",
      "Petrol Mah (kale Köyü)",
      "Şerefiye Köyü",
      "Taraklı Köyü",
      "Topçular Mah (kale Köyü)",
      "Uğur Mah (uğurköy Köyü)",
      "Uğurköy Köyü",
      "Uzunlar Mah (güzelyurt Köyü)",
      "Yangın Mah (alaca Köyü)",
      "Yayla Mah (arkaköy Köyü)",
      "Yayla Mah (efeler Köyü)",
      "Yeşilköy Köyü",
      "Zedoban Köyü",
      "Zorlu Köyü",
      "Zorlu Mah (zorlu Köyü)"
    ],
    "Hopa": [
      "Bucak Mah",
      "Cumhuriyet Mah",
      "Merkez Kuledibi Mah",
      "Ortahopa Mah",
      "Sugören Mah",
      "Sundura Mah",
      "Yukarı Kuledibi Mah",
      "Aşağı Yoldere Mah (yoldere Köyü)",
      "Balık Köyü",
      "Başköy Köyü",
      "Başoba Köyü",
      "Çarşı Mah (çamlı Köyü)",
      "Çavuşlu Köyü",
      "Çimenli Köyü",
      "Eşmekaya Köyü",
      "Güneşli Köyü",
      "Güvercinli Köyü",
      "Hacılar Mah (çamlı Köyü)",
      "Hendek Köyü",
      "Karşı Mah (çamlı Köyü)",
      "Kopmuş Mah (esenkıyı Köyü)",
      "Koyuncular Köyü",
      "Madenli Mah (çamlı Köyü)",
      "Merkez Mah (esenkıyı Köyü)",
      "Mısıllet Mah (çamlı Köyü)",
      "Orta Mah (çamlı Köyü)",
      "Pınarlı Köyü",
      "Subaşı Köyü",
      "Yeşilköy Köyü",
      "Yukarı Yoldere Mah (yoldere Köyü)"
    ],
    "Kemalpaşa": [
      "Cumhuriyet Mah",
      "Selimiye Mah",
      "Uzunyalı Mah",
      "Akdere Köyü",
      "Çamurlu Köyü",
      "Dereiçi Köyü",
      "Gümüşdere Köyü",
      "Karaosmaniye Köyü",
      "Karşı Mah (osmaniye Köyü)",
      "Kaya Köyü",
      "Kazimiye Köyü",
      "Köprücü Köyü",
      "Liman Köyü",
      "Merkez Mah (osmaniye Köyü)",
      "Sarp Köyü",
      "Üçkardeş Köyü"
    ],
    "Merkez": [
      "Balcıoğlu Mah",
      "Çamlık Mah",
      "Çarşı Mah",
      "Çayağzı Mah",
      "Dere Mah",
      "Orta Mah",
      "Yeni Mah",
      "Agora Mah (beşağıl Köyü)",
      "Aguset Mah (aşağımaden Köyü)",
      "Aharşen Mah (yukarımaden Köyü)",
      "Ahlat Mah (ahlat Köyü)",
      "Akbudak Mah (ortaköy Köyü)",
      "Aktaş Mah (yukarımaden Köyü)",
      "Alabalık Mah (alabalık Köyü)",
      "Altunbağ Mah (sümbüllü Köyü)",
      "Ançeloğlu Mah (şehitlik Köyü)",
      "Arıpınar Mah (taşlıca Köyü)",
      "Arif Çavuş Mah (bakırköy Köyü)",
      "Aşağı Bağlar Mah (yanıklı Köyü)",
      "Aşağı Maden Mah (aşağımaden Köyü)",
      "Aşağı Mah (dikmenli Köyü)",
      "Aşağı Mah (hamamlı Köyü)",
      "Aşağı Mah (hızarlı Köyü)",
      "Aşağı Mah (tütüncüler Köyü)",
      "Aşağı Tolgum Mah (salkımlı Köyü)",
      "Aşağıbağlık Mah (dokuzoğul Köyü)",
      "Atabeylar Mah (ortaköy Köyü)",
      "Atanasur Mah (ortaköy Köyü)",
      "Avaza Mah (hızarlı Köyü)",
      "Avazan Mah (aşağımaden Köyü)",
      "Aydoğan Mah (seyitler Köyü)",
      "Azizağaoğlu Mah (bakırköy Köyü)",
      "Babanoğlu Mah (yukarımaden Köyü)",
      "Bademlik Mah (derinköy Köyü)",
      "Bağlar Mah (sakalar Köyü)",
      "Bağlık Mah (ağıllar Köyü)",
      "Bağlık Mah (okumuşlar Köyü)",
      "Bahçeli Mah (yukarımaden Köyü)",
      "Ballı Mah (alabalık Köyü)",
      "Ballı Üzüm Mah (ballıüzüm Köyü)",
      "Bardaklı Mah (ortaköy Köyü)",
      "Basılavur Mah (vezirköy Köyü)",
      "Basot Mah (şehitlik Köyü)",
      "Bayramlı Mah (dokuzoğul Köyü)",
      "Berzeler Mah (varlık Köyü)",
      "Beşağaç Mah (yukarımaden Köyü)",
      "Beşağıl Mah (beşağıl Köyü)",
      "Beycur Mah (dikmenli Köyü)",
      "Bikililer Mah (ortaköy Köyü)",
      "Boluklu Mah (aşağımaden Köyü)",
      "Böreket Mah (derinköy Köyü)",
      "Büyük Yayla Mah (ortaköy Köyü)",
      "Cami Mah (ahlat Köyü)",
      "Cami Mah (aşağımaden Köyü)",
      "Cami Mah (hamamlı Köyü)",
      "Cami Mah (sarıbudak Köyü)",
      "Cami Mah (şehitlik Köyü)",
      "Cancağ Mah (hızarlı Köyü)",
      "Canoğlu Mah (yukarımaden Köyü)",
      "Cartiyet Mah (yukarımaden Köyü)",
      "Cartiyet Yaylası Mah (yukarımaden Köyü)",
      "Cennet Mah (kalburlu Köyü)",
      "Cevizli Mah (alabalık Köyü)",
      "Cicothev Mah (aşağımaden Köyü)",
      "Cimak Mah (dikmenli Köyü)",
      "Cinegara Mah (taşlıca Köyü)",
      "Çağrakan Mah (dikmenli Köyü)",
      "Çakmaklı Mah (ortaköy Köyü)",
      "Çalant Mah (varlık Köyü)",
      "Çalıkeu Mah (yukarımaden Köyü)",
      "Çalışkanlar Mah (ortaköy Köyü)",
      "Çam Mah (yukarımaden Köyü)",
      "Çamlık Mah (kalburlu Köyü)",
      "Çamlıkaya Mah (dokuzoğul Köyü)",
      "Çarbiyet Mah (seyitler Köyü)",
      "Çatalca Mah (ortaköy Köyü)",
      "Çavuşlar Mah (pırnallı Köyü)",
      "Çayağzı Mah (ormanlı Köyü)",
      "Çayırlı Mah (hozabir Mah) (yukarımaden Köyü)",
      "Çelikler Mah (aşağımaden Köyü)",
      "Çermik Mah (derinköy Köyü)",
      "Çeşmeli Mah (yanıklı Köyü)",
      "Çısğılıev Mah (sarıbudak Köyü)",
      "Çiğiyet Mah (taşlıca Köyü)",
      "Çimenli Mah (alabalık Köyü)",
      "Çimenli Mah (çimenli Köyü)",
      "Çitlik Mah (varlık Köyü)",
      "Çorasa Mah (ortaköy Köyü)",
      "Çömlekçi Mah (yukarımaden Köyü)",
      "Dagrak Mah (zeytinlik Köyü)",
      "Dalavut Mah (hızarlı Köyü)",
      "Dalizeler Mah (ahlat Köyü)",
      "Danayayımı Mah (taşlıca Köyü)",
      "Danzotlu Mah (taşlıca Köyü)",
      "Davtavur Mah (varlık Köyü)",
      "Demirci Mah (taşlıca Köyü)",
      "Dere Mah (varlık Köyü)",
      "Dereler Mah (alabalık Köyü)",
      "Dereler Mah (yanıklı Köyü)",
      "Didvake Mah (ahlat Köyü)",
      "Didvake Mah (varlık Köyü)",
      "Didvanak Mah (köseler Köyü)",
      "Dindaroğlu Mah (aşağımaden Köyü)",
      "Doğanlı Mah (dokuzoğul Köyü)",
      "Doğanlı Mah (fıstıklı Köyü)",
      "Dolişgil Mah (aşağımaden Köyü)",
      "Dube Mah (sarıbudak Köyü)",
      "Duganala Mah (ortaköy Köyü)",
      "Düz Mah (sümbüllü Köyü)",
      "Düzenli Mah (alabalık Köyü)",
      "Elikler Mah (pırnallı Köyü)",
      "Elmalı Mah (salkımlı Köyü)",
      "Erdemli Mah (bağcılar Köyü)",
      "Erenler Mah (erenler Köyü)",
      "Ericek Mah (taşlıca Köyü)",
      "Erikli Mah (yanıklı Köyü)",
      "Esenbigil Mah (hızarlı Köyü)",
      "Esentepe Mah (erenler Köyü)",
      "Felengaur Mah (varlık Köyü)",
      "Fidanlık Mah (seyitler Köyü)",
      "Gorazul Mah (vezirköy Köyü)",
      "Gorgot Mah (sarıbudak Köyü)",
      "Gorğon Mah (hızarlı Köyü)",
      "Gökçeyurt Mah (taşlıca Köyü)",
      "Gölehura Mah (taşlıca Köyü)",
      "Gözeler Mah (yukarımaden Köyü)",
      "Gurdaze Mah (sarıbudak Köyü)",
      "Gurganet Mah (sarıbudak Köyü)",
      "Guverta Bağlığı Mah (ortaköy Köyü)",
      "Güldibi Mah (sarıbudak Köyü)",
      "Gültepe Mah (alabalık Köyü)",
      "Gündoğdu Mah (fıstıklı Köyü)",
      "Güneyce Mah (yanıklı Köyü)",
      "Güzelköy Mah (çimenli Köyü)",
      "Ğoynar Mah (aşağımaden Köyü)",
      "Hacigil Mah (sarıbudak Köyü)",
      "Hafızağaoğlu Mah (erenler Köyü)",
      "Hamamlı Mah (hamamlı Köyü)",
      "Hans Mah (aşağımaden Köyü)",
      "Harkaltı Mah (varlık Köyü)",
      "Harot Mah (pırnallı Köyü)",
      "Haşut Mah (aşağımaden Köyü)",
      "Havnagara Mah (aşağımaden Köyü)",
      "Hekimoğulları Mah (ortaköy Köyü)",
      "Hırhan Mah (varlık Köyü)",
      "Hokmela Mah (zeytinlik Köyü)",
      "Hozegara Mah (aşağımaden Köyü)",
      "İhtiyaroğlu Mah (vezirköy Köyü)",
      "İmamgil Mah (hızarlı Köyü)",
      "İmniyet Mah (sarıbudak Köyü)",
      "İnek Yaylası Mah (varlık Köyü)",
      "İrgut Mah (zeytinlik Köyü)",
      "Kakacavur Mah (ahlat Köyü)",
      "Kakıabar Mah (vezirköy Köyü)",
      "Kalkanlı Mah (ortaköy Köyü)",
      "Kanatlı Mah (bağcılar Köyü)",
      "Karaca Mah (yukarımaden Köyü)",
      "Kasıkapı Mah (dokuzoğul Köyü)",
      "Kaşıkli Mah (ortaköy Köyü)",
      "Katnagara Mah (aşağımaden Köyü)",
      "Kavaklı Mah (yukarımaden Köyü)",
      "Kaymaklı Mah (aşağımaden Köyü)",
      "Keçenet Mah (yanıklı Köyü)",
      "Kenaht Mah (ortaköy Köyü)",
      "Keşoğulları Mah (ahlat Köyü)",
      "Kılıçlı Mah (taşlıca Köyü)",
      "Koçoğlu Mah (bakırköy Köyü)",
      "Kolbet Mah (hızarlı Köyü)",
      "Komasagora Mah (varlık Köyü)",
      "Koytarlar Mah (aşağımaden Köyü)",
      "Köprü Başı Mah (aşağımaden Köyü)",
      "Köprübaşı Mah (yanıklı Köyü)",
      "Köseler Mah (köseler Köyü)",
      "Köy İçi Mah (derinköy Köyü)",
      "Köyiçi Mah (ağıllar Köyü)",
      "Kurdiget Mah (fıstıklı Köyü)",
      "Kuslu Mah (kalburlu Köyü)",
      "Kuşluca Mah (erenler Köyü)",
      "Kuvap Mah (taşlıca Köyü)",
      "Lot Mah (yanıklı Köyü)",
      "Mamarne Mah (zeytinlik Köyü)",
      "Medresako Mah (hızarlı Köyü)",
      "Merkez Mah (aşağımaden Köyü)",
      "Merkez Mah (bağcılar Köyü)",
      "Merkez Mah (çimenli Köyü)",
      "Merkez Mah (fıstıklı Köyü)",
      "Merkez Mah (hızarlı Köyü)",
      "Merkez Mah (köseler Köyü)",
      "Merkez Mah (okumuşlar Köyü)",
      "Merkez Mah (ormanlı Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (pırnallı Köyü)",
      "Merkez Mah (sakalar Köyü)",
      "Merkez Mah (taşlıca Köyü)",
      "Merkez Mah (tütüncüler Köyü)",
      "Merkez Mah (vezirköy Köyü)",
      "Merkez Mah (yanıklı Köyü)",
      "Merkez Mah (zeytinlik Köyü)",
      "Meydan Mah (yukarımaden Köyü)",
      "Mezra Mah (çimenli Köyü)",
      "Mezra Mah (ormanlı Köyü)",
      "Mısırlı Mah (aşağımaden Köyü)",
      "Minyatür Mah (bağcılar Köyü)",
      "Mirzigil Mah (aşağımaden Köyü)",
      "Molas Mah (taşlıca Köyü)",
      "Muğa Mah (aşağımaden Köyü)",
      "Muskolu Mah (dokuzoğul Köyü)",
      "Nağmur Mah (sarıbudak Köyü)",
      "Nakorev Mah (alabalık Köyü)",
      "Napetur Mah (varlık Köyü)",
      "Natengelav Mah (taşlıca Köyü)",
      "Nazigil Mah (yukarımaden Köyü)",
      "Nıpala Mah (seyitler Köyü)",
      "Nuhsağara Mah (aşağımaden Köyü)",
      "Ocakbaşı Mah (ortaköy Köyü)",
      "Ormanlı Mah (ormanlı Köyü)",
      "Orta Mah (dikmenli Köyü)",
      "Orta Mah (hamamlı Köyü)",
      "Ortabağlar Mah (yanıklı Köyü)",
      "Osut Mah (aşağımaden Köyü)",
      "Örenli Mah (taşlıca Köyü)",
      "Parmaklı Mah (yukarımaden Köyü)",
      "Petrigil Mah (yukarımaden Köyü)",
      "Pırnallı Yaylası Mah (pırnallı Köyü)",
      "Rahtevanoğlu Mah (erenler Köyü)",
      "Rem Mah (yukarımaden Köyü)",
      "Reşitoğlu Mah (bakırköy Köyü)",
      "Ruhigil Mah (varlık Köyü)",
      "Sabur Mah (pırnallı Köyü)",
      "Saçınka Mah (salkımlı Köyü)",
      "Sağriyetul Mah (yanıklı Köyü)",
      "Salat Mah (dokuzoğul Köyü)",
      "Salicor Mah (aşağımaden Köyü)",
      "Salihoğlu Mah (erenler Köyü)",
      "Sarıdana Mah (pırnallı Köyü)",
      "Sarsıhev Mah (sarıbudak Köyü)",
      "Satibo Mah (beşağıl Köyü)",
      "Saygılı Mah (ağıllar Köyü)",
      "Selvaget Mah (hızarlı Köyü)",
      "Sevail Mah (beşağıl Köyü)",
      "Sıralan Mah (hamamlı Köyü)",
      "Sırt Mah (derinköy Köyü)",
      "Sırt Mah (ortaköy Köyü)",
      "Sikaşar Mah (sarıbudak Köyü)",
      "Sobar Mah (salkımlı Köyü)",
      "Soğukpınar Mah (yukarımaden Köyü)",
      "Solmaz Mah (dokuzoğul Köyü)",
      "Sotibar Mah (seyitler Köyü)",
      "Soylu Mah (ortaköy Köyü)",
      "Sumbatur Mah (varlık Köyü)",
      "Sümetağara Mah (varlık Köyü)",
      "Şanliyet Mah (yanıklı Köyü)",
      "Şavkaf Mah (sakalar Köyü)",
      "Talgum Mah (yukarımaden Köyü)",
      "Tanrıverdi Mah (aşağımaden Köyü)",
      "Tanzek Mah (aşağımaden Köyü)",
      "Tepebaşı Mah (yukarımaden Köyü)",
      "Tepecik Mah (yesirgil Mah) (yukarımaden Köyü)",
      "Tepecik Mah (yukarımaden Köyü)",
      "Tıhnara Mah (ormanlı Köyü)",
      "Tıraşgil Mah (yukarımaden Köyü)",
      "Topluca Mah (ortaköy Köyü)",
      "Tosunlu Mah (ortaköy Köyü)",
      "Tusaklar Mah (dokuzoğul Köyü)",
      "Uğur Mah (aşağımah Mah) (yukarımaden Köyü)",
      "Uğur Mah (hekimoğlumah Mah) (yukarımaden Köyü)",
      "Uğur Mah (mijnabara Mah) (yukarımaden Köyü)",
      "Uğur Mah (yukarımah Mah) (yukarımaden Köyü)",
      "Uskup Mah (aşağımaden Köyü)",
      "Uslufent Mah (ortaköy Köyü)",
      "Uyanık Mah (ortaköy Köyü)",
      "Uzundere Mah (ormanlı Köyü)",
      "Üçdut Mah (oruçlu Köyü)",
      "Üçpınar Mah (kalburlu Köyü)",
      "Üçpınar Mah (oruçlu Köyü)",
      "Üçpınar Mah (yanıklı Köyü)",
      "Vake Mah (sümbüllü Köyü)",
      "Vanat Mah (ahlat Köyü)",
      "Vehnat Mah (taşlıca Köyü)",
      "Vezirköyyaylası Mah (vezirköy Köyü)",
      "Veziroğlu Mah (yukarımaden Köyü)",
      "Yamaçlı Mah (yukarımaden Köyü)",
      "Yamaçlı Yaylası Mah (yukarımaden Köyü)",
      "Yanıklı Mah (yanıklı Köyü)",
      "Yaylalar Mah (yanıklı Köyü)",
      "Yenice Mah (ortaköy Köyü)",
      "Yenigün Mah (sarıbudak Köyü)",
      "Yenişli Mah (yukarımaden Köyü)",
      "Yukarı Mah (dikmenli Köyü)",
      "Yukarı Mah (fıstıklı Köyü)",
      "Yukarı Mah (hamamlı Köyü)",
      "Yukarı Mah (tütüncüler Köyü)",
      "Yukarı Sadro Mah (zeytinlik Köyü)",
      "Yukarı Şehitlik Mah (şehitlik Köyü)",
      "Yukarı Tolgum Mah (salkımlı Köyü)",
      "Zegoni Mah (tütüncüler Köyü)",
      "Zom Mah (aşağımaden Köyü)",
      "Zorlu Mah (yukarımaden Köyü)",
      "Zuvar Mah (hamamlı Köyü)"
    ],
    "Murgul": [
      "Küre Mah",
      "A.balaban Mah (başköy Köyü)",
      "Akantaş Köyü",
      "Ardıçlı Köyü",
      "Arslanlı Mah (başköy Köyü)",
      "Budiyet Mah (kabaca Köyü)",
      "Çimenli Köyü",
      "Damar Çarşı Mah (damar Köyü)",
      "Eğri Su Yaylası Mah (kabaca Köyü)",
      "Erenköy Köyü",
      "Gönüllü Mah (başköy Köyü)",
      "Karşıyaka Mah (başköy Köyü)",
      "Korucular Köyü",
      "Kuruçay Mah (kabaca Köyü)",
      "Küre Köyü",
      "Merkez Mah (başköy Köyü)",
      "Osmanlı Köyü",
      "Petek Köyü",
      "Salkaya Mah (kabaca Köyü)",
      "Y.balaban Mah (başköy Köyü)"
    ],
    "Şavşat": [
      "A.şindoban Mah (dalkırmaz Köyü)",
      "Abdulgil Mah (pınarlı Köyü)",
      "Abduloğlu Mah (kocabey Köyü)",
      "Agagil Mah (atalar Köyü)",
      "Agara Mah (çukur Köyü)",
      "Agara Mah (erikli Köyü)",
      "Agara Mezrası Mah (çukur Köyü)",
      "Ağagil Mah (akdamla Köyü)",
      "Ahaldabalılar Mah (yaşar Köyü)",
      "Ahalgasgil Mah (atalar Köyü)",
      "Ahaşen Mah (ciritdüzü Köyü)",
      "Akgöl Mah (karaağaç Köyü)",
      "Akkıraç Mah (kurudere Köyü)",
      "Aksakallar Mah (veliköy Köyü)",
      "Aksu Mah (maden Köyü)",
      "Alagöz Mah (pınarlı Köyü)",
      "Aligil Mah (ılıca Köyü)",
      "Altınoluk Mah (küplüce Köyü)",
      "Arçiler Mah (ciritdüzü Köyü)",
      "Ardıçlı Mah (dereiçi Köyü)",
      "Ardıyasmında Mah (çukur Köyü)",
      "Arılar Mah (ılıca Köyü)",
      "Arışet Mah (tepeköy Köyü)",
      "Arkiyet Mah (yukarıkoyunlu Köyü)",
      "Arsiyan Mah (cevizli Köyü)",
      "Arsiyan Mah (yoncalı Köyü)",
      "Arsiyan Yaylası Mah (kayadibi Köyü)",
      "Asnigil Mah (kayadibi Köyü)",
      "Aşağı Bağlı Mah (meşeli Köyü)",
      "Aşağı Cami Mah (kireçli Köyü)",
      "Aşağı Mah (çamlıca Köyü)",
      "Aşağı Mah (elmalı Köyü)",
      "Aşağı Mah (hanlı Köyü)",
      "Aşağı Mah (karaağaç Köyü)",
      "Aşağı Mah (karaköy Köyü)",
      "Aşağı Mah (kurudere Köyü)",
      "Aşağı Mah (maden Köyü)",
      "Aşağı Mah (susuz Köyü)",
      "Aşağı Mah (tepebaşı Köyü)",
      "Aşağı Mah (üzümlü Köyü)",
      "Aşağı Mah (yaşar Köyü)",
      "Aşağı Mah (yukarıkoyunlu Köyü)",
      "Aşağı Tetraket Mah (çukur Köyü)",
      "Avazanat Mah (elmalı Köyü)",
      "Avcala Mah (çamlıca Köyü)",
      "Avcılar Mah (eskikale Köyü)",
      "Ayvazgil Mah (yavuzköy Köyü)",
      "Bağbaşı Mah (dutlu Köyü)",
      "Bağceci Mah (kayadibi Köyü)",
      "Bağcılar Mah (üzümlü Köyü)",
      "Bağçukur Mah (köprülü Köyü)",
      "Bağlıca Mah (dereiçi Köyü)",
      "Bahçecik Mah (çağlıyan Köyü)",
      "Bahçecik Mah (küplüce Köyü)",
      "Bahçecik Mah (tepeköy Köyü)",
      "Bahçekapı Mah (dereiçi Köyü)",
      "Bahçeli Mah (şalcı Köyü)",
      "Balcılar Mah (yavuzköy Köyü)",
      "Balıklı Köyü",
      "Bana1 Mah (şenocak Köyü)",
      "Bana2 Mah (şenocak Köyü)",
      "Basavra Mah (ılıca Köyü)",
      "Baskallar Mah (pınarlı Köyü)",
      "Başağagil Mah (atalar Köyü)",
      "Başkale Mah (eskikale Köyü)",
      "Başpınar Mah (düzenli Köyü)",
      "Bayırca Mah (tepeköy Köyü)",
      "Bayraktarlar Mah (meşeli Köyü)",
      "Becitgil Mah (kayadibi Köyü)",
      "Beltiyet Mah (çağlıyan Köyü)",
      "Berekgil Mah (atalar Köyü)",
      "Beriyet Mah (çukur Köyü)",
      "Beşevler Mah (kurudere Köyü)",
      "Beyler Mah (cevizli Köyü)",
      "Beyler Mah (kurudere Köyü)",
      "Beylik Mah (yamaçlı Köyü)",
      "Bizingil Mah (saylıca Köyü)",
      "Borağal Mah (arpalı Köyü)",
      "Boztoprak Mah (kireçli Köyü)",
      "Bucat Mah (elmalı Köyü)",
      "Buçigil Mah (cevizli Köyü)",
      "Budaklı Mah (aşağıkoyunlu Köyü)",
      "Buhar Mah (kirazlı Köyü)",
      "Buluntugil Mah (ciritdüzü Köyü)",
      "Büyük Kışla Mah (cevizli Köyü)",
      "Büyük Kkışla Mah (pınarlı Köyü)",
      "Calacalat Mah (kurudere Köyü)",
      "Cami Mah (arpalı Köyü)",
      "Cami Mah (aşağıkoyunlu Köyü)",
      "Cami Mah (cevizli Köyü)",
      "Cami Mah (çağlıpınar Köyü)",
      "Cami Mah (çağlıyan Köyü)",
      "Cami Mah (çamlıca Köyü)",
      "Cami Mah (dutlu Köyü)",
      "Cami Mah (düzenli Köyü)",
      "Cami Mah (eskikale Köyü)",
      "Cami Mah (hanlı Köyü)",
      "Cami Mah (ılıca Köyü)",
      "Cami Mah (karaağaç Köyü)",
      "Cami Mah (kayadibi Köyü)",
      "Cami Mah (kirazlı Köyü)",
      "Cami Mah (kurudere Köyü)",
      "Cami Mah (küplüce Köyü)",
      "Cami Mah (meşeli Köyü)",
      "Cami Mah (saylıca Köyü)",
      "Cami Mah (şalcı Köyü)",
      "Cami Mah (şenocak Köyü)",
      "Cami Mah (üzümlü Köyü)",
      "Cami Mah (yağlı Köyü)",
      "Cami Mah (yavuzköy Köyü)",
      "Canoğlu Mah (ziyaret Köyü)",
      "Carat Mah (köprüyaka Köyü)",
      "Cedligil Mah (atalar Köyü)",
      "Cengelek Mah (çermik Köyü)",
      "Cengelek Mah (ılıca Köyü)",
      "Cengelek Mah (şalcı Köyü)",
      "Cengelek Mah (tepeköy Köyü)",
      "Cengelek Mah (yeşilce Köyü)",
      "Ceylanlı Mah (ılıca Köyü)",
      "Cimuhlar Mah (çağlıyan Köyü)",
      "Cindağı Mah (meşeli Köyü)",
      "Cindağı Mah (pınarlı Köyü)",
      "Cinolar Mah (veliköy Köyü)",
      "Cinşarlar Mah (kayadibi Köyü)",
      "Cirigil Mah (cevizli Köyü)",
      "Cola Mah (yukarıkoyunlu Köyü)",
      "Cudes Mah (dereiçi Köyü)",
      "Çaçat Mah (çiftlik Köyü)",
      "Çağlayan Yaylası Mah (çağlıyan Köyü)",
      "Çağlıpınar Mah (çağlıpınar Köyü)",
      "Çağlıpınar-2 Mah (çağlıpınar Köyü)",
      "Çakırlı Mah (meşeli Köyü)",
      "Çakvrizeler Mah (yağlı Köyü)",
      "Çamlıtepe Mah (demirci Köyü)",
      "Çarbaşı Mah (karaköy Köyü)",
      "Çatalkaya Mah (kireçli Köyü)",
      "Çavdarlı Yaylası Mah (çavdarlı Köyü)",
      "Çayağzı Mah (çayağzı Köyü)",
      "Çayırlar Mah (meşeli Köyü)",
      "Çaysalize Mah (kocabey Köyü)",
      "Çermik Mah (maden Köyü)",
      "Çiçekli Mah (erikli Köyü)",
      "Çiçekli Mah (kütav Mah) (erikli Köyü)",
      "Çiftehanlar Mah (eskikale Köyü)",
      "Çimenli Mah (yoncalı Köyü)",
      "Çivizeler Mah (oba Köyü)",
      "Çivlik Mah (karaağaç Köyü)",
      "Çivo Mah (arpalı Köyü)",
      "Çoraklı 2 Mah (çoraklı Köyü)",
      "Çoraklı Köyü",
      "Çoraklı Mah (çoraklı Köyü)",
      "Çukur 2 Mah (eskikale Köyü)",
      "Çukur Mah (eskikale Köyü)",
      "Çukur Yaylası Mah (çukur Köyü)",
      "Dadaşgil Mah (çavdarlı Köyü)",
      "Davlaur Mah (dereiçi Köyü)",
      "Davutlar Mah (ciritdüzü Köyü)",
      "Dede Mah (çiftlik Köyü)",
      "Dedeağa Mah (kireçli Köyü)",
      "Demircigil Mah (cevizli Köyü)",
      "Demircigil Mah (çavdarlı Köyü)",
      "Demircigil Mah (pınarlı Köyü)",
      "Demirciler Mah (cevizli Köyü)",
      "Demirciler Mah (meşeli Köyü)",
      "Demirciler Mah (pınarlı Köyü)",
      "Demircioğlu Mah (çermik Köyü)",
      "Demirkapı Köyü",
      "Demirkapı Mah (akdamla Köyü)",
      "Demirkapı Mah (demirkapı Köyü)",
      "Dere Mah (cevizli Köyü)",
      "Dere Mah (saylıca Köyü)",
      "Dere Mah (yağlı Köyü)",
      "Derecik Mah (demirci Köyü)",
      "Dereiçi Mah (ciritdüzü Köyü)",
      "Devrişler Mah (ciritdüzü Köyü)",
      "Dıcala Mah (üzümlü Köyü)",
      "Didmere Mah (dutlu Köyü)",
      "Doğandüzü Mah (köprülü Köyü)",
      "Doğanlar Mah (ciritdüzü Köyü)",
      "Drankoğlu Mah (kocabey Köyü)",
      "Duğabize Mah (yavuzköy Köyü)",
      "Dursunlar Mah (pınarlı Köyü)",
      "Dutlu Mah (dutlu Köyü)",
      "Dükkanlar Mah (atalar Köyü)",
      "Dükkanlar Mah (pınarlı Köyü)",
      "Düz Mah (kirazlı Köyü)",
      "Düz Mah (yavuzköy Köyü)",
      "Düzebakan Mah (ciritdüzü Köyü)",
      "Düzenli Yaylası Mah (düzenli Köyü)",
      "Eherli Mah (tepeköy Köyü)",
      "Ekinciler Mah (erikli Köyü)",
      "Erikli Mah (erikli Köyü)",
      "Eski Cami Mah (veliköy Köyü)",
      "Eskikale Mah (eskikale Köyü)",
      "Eskiyayla Mah (eskikale Köyü)",
      "Eyipgil Mah (yamaçlı Köyü)",
      "Gençağagil Mah (kocabey Köyü)",
      "Gıgazeler Mah (çukur Köyü)",
      "Gogelet Mah (tepeköy Köyü)",
      "Gorgaze Mah (oba Köyü)",
      "Göçoğulları Mah (çağlıyan Köyü)",
      "Göknizeler Mah (küplüce Köyü)",
      "Gökova Mah (tepeköy Köyü)",
      "Gökyuva Mah (tepeköy Köyü)",
      "Gündoğdu Mah (kayadibi Köyü)",
      "Günkaya  Mah (tosu Mah) (yavuzköy Köyü)",
      "Gürsoy Mah (dutlu Köyü)",
      "Gürzellar Mah (pınarlı Köyü)",
      "Güven Mah (kirazlı Köyü)",
      "Güzelce Mah (pınarlı Köyü)",
      "Haberler Mah (pınarlı Köyü)",
      "Hacılar Mah (karaağaç Köyü)",
      "Hacigil Mah (yamaçlı Köyü)",
      "Hafizoğlu Mah (arpalı Köyü)",
      "Halazeler Mah (meşeli Köyü)",
      "Halifgil Mah (atalar Köyü)",
      "Halogil Mah (cevizli Köyü)",
      "Havacıoğlu Mah (cevizli Köyü)",
      "Haytagil Mah (pınarlı Köyü)",
      "Haznadar Mah (atalar Köyü)",
      "Haznedaroğulları Mah (ciritdüzü Köyü)",
      "Hocagil Mah (çavdarlı Köyü)",
      "Hocagil Mah (pınarlı Köyü)",
      "Hozançayır Mah (çavdarlı Köyü)",
      "İbrahimoğlu Mah (arpalı Köyü)",
      "İki Su Arası Mah (hanlı Köyü)",
      "İnkavar Mah (aşağıkoyunlu Köyü)",
      "İspiroğlu Mah (kocabey Köyü)",
      "Kadirgil Mah (pınarlı Köyü)",
      "Kahvecioğlu Mah (atalar Köyü)",
      "Kambatlar Mah (çiftlik Köyü)",
      "Karabiber Mah (meşeli Köyü)",
      "Karagöl Mah (arpalı Köyü)",
      "Karisat Mah (çermik Köyü)",
      "Karşı Mah (köprüyaka Köyü)",
      "Karşıyaka Mah (dereiçi Köyü)",
      "Kartallar Mah (veliköy Köyü)",
      "Kavacık Mah (tepeköy Köyü)",
      "Kavaklık Mah (karaköy Köyü)",
      "Kavuzoğlu Mah (şalcı Köyü)",
      "Kayabaşı Köyü",
      "Kayabaşı Mah (düzenli Köyü)",
      "Kayabaşı Mah (veliköy Köyü)",
      "Kayabeglar Mah (çavdarlı Köyü)",
      "Kayaoğulları Mah (ılıca Köyü)",
      "Kıldıziret Mah (tepeköy Köyü)",
      "Kırık Mah (köprülü Köyü)",
      "Kışla Mah (hanlı Köyü)",
      "Kışlalar Mah (tepeköy Köyü)",
      "Kocabey Mah (kocabey Köyü)",
      "Kodana Mah (çavdarlı Köyü)",
      "Kortahaze Mah (oba Köyü)",
      "Korunga Mah (çavdarlı Köyü)",
      "Kökler Mah (atalar Köyü)",
      "Köprübaşı Mah (hanlı Köyü)",
      "Kumaşlar Mah (pınarlı Köyü)",
      "Kunelar Mah (pınarlı Köyü)",
      "Kurundere Mah (hanlı Köyü)",
      "Liban Mah (çukur Köyü)",
      "Maçkadet Mah (yeşilce Köyü)",
      "Mahigil Mah (çavdarlı Köyü)",
      "Mahigil Mah (yamaçlı Köyü)",
      "Mamogil Mah (cevizli Köyü)",
      "Manasgil Mah (ılıca Köyü)",
      "Mariasminda Mah (şalcı Köyü)",
      "Megreloğullar Mah (çağlıyan Köyü)",
      "Melekgil Mah (yaşar Köyü)",
      "Menemşe Mah (çavdarlı Köyü)",
      "Merkez Mah (cevizli Köyü)",
      "Merkez Mah (çukur Köyü)",
      "Merkez Mah (dalkırmaz Köyü)",
      "Merkez Mah (demirci Köyü)",
      "Merkez Mah (dereiçi Köyü)",
      "Merkez Mah (köprülü Köyü)",
      "Merkez Mah (meydancık Köyü)",
      "Merkez Mah (otluca Köyü)",
      "Merkez Mah (sebzeli Köyü)",
      "Merkez Mah (şenköy Köyü)",
      "Merkez Mah (veliköy Köyü)",
      "Merkez Mah (yeşilce Köyü)",
      "Merkez Mah (yoncalı Köyü)",
      "Meydanlar Mah (pınarlı Köyü)",
      "Mezra Mah (karaköy Köyü)",
      "Mısırlı Köyü",
      "Mikazeler Mah (yağlı Köyü)",
      "Mollagil Mah (arpalı Köyü)",
      "Mollaoğlu Mah (oba Köyü)",
      "Mortlazelar Mah (yaşar Köyü)",
      "Muratoğlu Mah (kocabey Köyü)",
      "Mutluca Mah (şenköy Köyü)",
      "Nadıroğulları Mah (ciritdüzü Köyü)",
      "Nakuşnev Mah (akdamla Köyü)",
      "Naparnev Yaylası Mah (çukur Köyü)",
      "Oba Mah (oba Köyü)",
      "Odabaşlar Mah (pınarlı Köyü)",
      "Ogeçe Mah (aşağıkoyunlu Köyü)",
      "Okçular Mah (eskikale Köyü)",
      "Okul Mah (şenocak Köyü)",
      "Okurlar Mah (meşeli Köyü)",
      "Oluklar Mah (çavdarlı Köyü)",
      "Orta Mah (akdamla Köyü)",
      "Orta Mah (arpalı Köyü)",
      "Orta Mah (aşağıkoyunlu Köyü)",
      "Orta Mah (çiftlik Köyü)",
      "Orta Mah (oba Köyü)",
      "Orta Mah (şenocak Köyü)",
      "Orta Mah (yamaçlı Köyü)",
      "Orta Mah (yukarıkoyunlu Köyü)",
      "Orta Mah (ziyaret Köyü)",
      "Orta Savayil Mah (eskikale Köyü)",
      "Oruçlu Mah (çağlıpınar Köyü)",
      "Ovacık Mah (kireçli Köyü)",
      "Örencik Mah (çayağzı Köyü)",
      "Öztürkler Mah (cevizli Köyü)",
      "Pancarlık Mah (kirazlı Köyü)",
      "Papiyet Mah (tepeköy Köyü)",
      "Paruet Mah (akdamla Köyü)",
      "Pınartarla Mah (kirazlı Köyü)",
      "Pirpizeler Mah (veliköy Köyü)",
      "Pukşalar Mah (çağlıyan Köyü)",
      "Rabat Mah (dereiçi Köyü)",
      "Ramadangil Mah (yavuzköy Köyü)",
      "Recephane Mah (veliköy Köyü)",
      "Sahara Mah (kocabey Köyü)",
      "Sakdar Mah (şenocak Köyü)",
      "Sakioğlu Mah (cevizli Köyü)",
      "Sakiriyet Mah (tepeköy Köyü)",
      "Sakorniyet Mah (yoncalı Köyü)",
      "Saraçoğlu Mah (kayadibi Köyü)",
      "Sarıçayır Mah (erikli Köyü)",
      "Sarıçiçek Mah (yukarıkoyunlu Köyü)",
      "Sarıkavak Mah (ılıca Köyü)",
      "Sarikevla Mah (ılıca Köyü)",
      "Sarkiseul Mah (arpalı Köyü)",
      "Sasongil Mah (kayadibi Köyü)",
      "Satarbaşı Mah (şenocak Köyü)",
      "Savahil Mah (arpalı Köyü)",
      "Savaş Köyü",
      "Savayil Mah (tepeköy Köyü)",
      "Sebzeli Mah (sebzeli Köyü)",
      "Serdallar Mah (küplüce Köyü)",
      "Sergici Mah (kocabey Köyü)",
      "Sırt Mah (dalkırmaz Köyü)",
      "Sırt Mah (yavuzköy Köyü)",
      "Soçlindor Mah (yamaçlı Köyü)",
      "Subaşgil Mah (atalar Köyü)",
      "Susuz Kışla Mah (pınarlı Köyü)",
      "Susuz Köyü",
      "Susuz Mah (şenocak Köyü)",
      "Şalikoğlu Mah (şalcı Köyü)",
      "Şartul Mah (küplüce Köyü)",
      "Şaturlar Mah (veliköy Köyü)",
      "Şenocak Mah (şenocak Köyü)",
      "Şeyhoğlu Mah (çermik Köyü)",
      "Şirinağagil Mah (karaağaç Köyü)",
      "Şobelalar Mah (yağlı Köyü)",
      "Tabanoğulları Mah (karaağaç Köyü)",
      "Tarlabaşı Mah (şenocak Köyü)",
      "Taşbaşı Mah (yavuzköy Köyü)",
      "Taşköprü Köyü",
      "Taşlı Yayla Mah (pınarlı Köyü)",
      "Tekdilde Mah (kayadibi Köyü)",
      "Tokazeler Mah (ziyaret Köyü)",
      "Topcular Mah (ılıca Köyü)",
      "Topçular Mah (yavuzköy Köyü)",
      "Toptaş Mah (meşeli Köyü)",
      "Tulazelar Mah (pınarlı Köyü)",
      "Turangil Mah (yamaçlı Köyü)",
      "Turutlar Mah (cevizli Köyü)",
      "Ulukent Mah (çağlıpınar Köyü)",
      "Üçyol Mah (hanlı Köyü)",
      "Ünyallar Mah (yağlı Köyü)",
      "Vaket Mah (yağlı Köyü)",
      "Velat Mah (pınarlı Köyü)",
      "Velta Mah (susuz Köyü)",
      "Y.koyunlu Mah (yukarıkoyunlu Köyü)",
      "Y.şindoban Mah (dalkırmaz Köyü)",
      "Yağlı Mah (yağlı Köyü)",
      "Yağmurlu Mah (dutlu Köyü)",
      "Yavuzköy Mah (yavuzköy Köyü)",
      "Yayalar Mah (tepeköy Köyü)",
      "Yayıklı Mah (köprüyaka Köyü)",
      "Yeni Kışla Mah (pınarlı Köyü)",
      "Yeni Mah (ciritdüzü Köyü)",
      "Yeni Mah (şenocak Köyü)",
      "Yenkahor Mah (arpalı Köyü)",
      "Yeşilce Mah (veliköy Köyü)",
      "Yeşilvadi Mah (karaağaç Köyü)",
      "Yıldırım Mah (meşeli Köyü)",
      "Yukarı Cami Mah (kayadibi Köyü)",
      "Yukarı Cami Mah (kireçli Köyü)",
      "Yukarı Mah (arpalı Köyü)",
      "Yukarı Mah (çamlıca Köyü)",
      "Yukarı Mah (çermik Köyü)",
      "Yukarı Mah (çiftlik Köyü)",
      "Yukarı Mah (elmalı Köyü)",
      "Yukarı Mah (hanlı Köyü)",
      "Yukarı Mah (karaköy Köyü)",
      "Yukarı Mah (kocabey Köyü)",
      "Yukarı Mah (küplüce Köyü)",
      "Yukarı Mah (maden Köyü)",
      "Yukarı Mah (savaş Köyü)",
      "Yukarı Mah (susuz Köyü)",
      "Yukarı Mah (tepebaşı Köyü)",
      "Yukarı Mah (veliköy Köyü)",
      "Yukarı Mah (yamaçlı Köyü)",
      "Yukarı Mah (yaşar Köyü)",
      "Yukarı Mah (yukarıkoyunlu Köyü)",
      "Yukarı Mah (ziyaret Köyü)",
      "Yukarı Tetraket Mah (çukur Köyü)",
      "Yukarı Yayla Mah (hanlı Köyü)",
      "Zamigil Mah (arpalı Köyü)",
      "Zanta Mah (yukarıkoyunlu Köyü)",
      "Ziyadoğlu Mah (cevizli Köyü)",
      "Ziyaret Mah (veliköy Köyü)",
      "Ziyaret Mah (ziyaret Köyü)",
      "Armutlu Mah",
      "Söğütlü Mah",
      "Yeniköy Mah"
    ],
    "Yusufeli": [
      "Abanoz Mah (bahçeli Köyü)",
      "Abramet  -kakrazevl Mah (altıparmak Köyü)",
      "Ada Mah (çevreli Köyü)",
      "Ada Mah (ırmakyanı Köyü)",
      "Ada Mah (yüncüler Köyü)",
      "Adatepe Mah (yaylalar Köyü)",
      "Ağaç Dibi Mah (cevizlik Köyü)",
      "Ağagil Mah (işhan Köyü)",
      "Ağara Mah (serinsu Köyü)",
      "Ahalt Mah (bostancı Köyü)",
      "Ahalt Mah (havuzlu Köyü)",
      "Ahangil Mah (tekkale Köyü)",
      "Aharşen Mah (bademkaya Köyü)",
      "Aharşin Mah (demirdöven Köyü)",
      "Ahet Mah (tekkale Köyü)",
      "Ahmetoğulları Mah (demirköy Köyü)",
      "Ahut Mah (kömürlü Köyü)",
      "Akaket Mah (taşkıran Köyü)",
      "Akarşen Mah (zeytincik Köyü)",
      "Akçay Mah (yaylalar Köyü)",
      "Akçiçek Mah (yokuşlu Köyü)",
      "Akmeşe  Mezrası Mah (cevizlik Köyü)",
      "Akmeşe Mah (cevizlik Köyü)",
      "Aknezor Mah (erenköy Köyü)",
      "Aligil Mah (narlık Köyü)",
      "Alikolat Mah (demirdöven Köyü)",
      "Allos Mah (işhan Köyü)",
      "Amenesket Mah (altıparmak Köyü)",
      "Arapgil Mah (işhan Köyü)",
      "Ardıçlı Mah (bostancı Köyü)",
      "Areke Mah (darıca Köyü)",
      "Arnutge Mah (bostancı Köyü)",
      "Arunze Mah (bostancı Köyü)",
      "Askent Mah (kömürlü Köyü)",
      "Aslanlı Mah (alanbaşı Köyü)",
      "Aslanoba Mah (gethane Mah) (kömürlü Köyü)",
      "Aşağı Çamlık Mah (bahçeli Köyü)",
      "Aşağı Güney Mah (tekkale Köyü)",
      "Aşağı Güp Mah (tekkale Köyü)",
      "Aşağı Mah (bahçeli Köyü)",
      "Aşağı Mah (dereiçi Köyü)",
      "Aşağı Mah (havuzlu Köyü)",
      "Aşağı Mah (kömürlü Köyü)",
      "Aşağı Mah (yüksekoba Köyü)",
      "Aşağı Misur Mah (işhan Köyü)",
      "Aşağı Uban Mah (taşkıran Köyü)",
      "Aşağı Varmet Mah ( Aşağı Çağlar Mah) (dereiçi Köyü)",
      "Aşık Muhibbi Mah (demirkent Köyü)",
      "Ataman Mah (erenköy Köyü)",
      "Atan Mah (cogara Mah) (kömürlü Köyü)",
      "Atbaşı Mah (zeytincik Köyü)",
      "Atmik Mah (dağeteği Köyü)",
      "Avarek Mah (darıca Köyü)",
      "Avrek Mah (işhan Köyü)",
      "Avres Mah (işhan Köyü)",
      "Ayazgil Mah (çevreli Köyü)",
      "Ayvalı Mah (yüncüler Köyü)",
      "Baçut Mah (işhan Köyü)",
      "Bademkaya Yaylası Mah (bademkaya Köyü)",
      "Bağcı Cami Mah (boyalı Köyü)",
      "Bağcı Mah (boyalı Köyü)",
      "Bağlar Mah (kınalıçam Köyü)",
      "Bağlık  Mah (sağ Mah) (arpacık Köyü)",
      "Bağlık Mah (bostancı Köyü)",
      "Bağlık Mah (cevizlik Köyü)",
      "Bağlık Mah (erenköy Köyü)",
      "Bağlık Mah (günyayla Köyü)",
      "Bağlık Mah (pamukçular Köyü)",
      "Bağlık Mah (yeniköy Köyü)",
      "Bağlık Mah (yokuşlu Köyü)",
      "Bahtev Mah (derecik Mah) (dereiçi Köyü)",
      "Bakırtepe  Yaylası Mah (bakırtepe Köyü)",
      "Balcıgil Mah (erenköy Köyü)",
      "Baleze Mah (bostancı Köyü)",
      "Balhıbar Mah (balcılı Köyü)",
      "Baliyet Mah (altıparmak Köyü)",
      "Ballıdut Mah (givnar Mah) (çevreli Köyü)",
      "Bambacıgil Mah (tekkale Köyü)",
      "Barış   Mah (çumat Mah) (esenyaka Köyü)",
      "Baselet-zuvare Mah (yarbaşı Köyü)",
      "Basilet Mah (demirdöven Köyü)",
      "Baş Mah (küplüce Köyü)",
      "Baş Mah (yağcılar Köyü)",
      "Başaklı Mah (demirkent Köyü)",
      "Başkeret Mah (mutlugün Köyü)",
      "Baut Mah (bahçeli Köyü)",
      "Bayraktargil - Veyisoğlu Mah (esenyaka Köyü)",
      "Bayraktaroğlu Mah (esenyaka Köyü)",
      "Beksler  Mah (damlataş Mah) (altıparmak Köyü)",
      "Belencik Mah (demirkent Köyü)",
      "Benara Mah (taşkıran Köyü)",
      "Beşkavak Mah (yüncüler Köyü)",
      "Bez Mah (demirkent Köyü)",
      "Biradiyet Mah (narlık Köyü)",
      "Bodurlar Mah (ırmakyanı Köyü)",
      "Boğaz Bağlık Mah (darıca Köyü)",
      "Borovan Mah (altıparmak Köyü)",
      "Borovan Mah (taşkıran Köyü)",
      "Borovanlar Mah (altıparmak Köyü)",
      "Bosminda Mah (bıçakçılar Köyü)",
      "Bozkuş Mah (bıçakçılar Köyü)",
      "Bölükbaşı Mah (tekkale Köyü)",
      "Bölükbaşı Mezrası Mah (tekkale Köyü)",
      "Börekli  Mah (köseoğullar Mah) (altıparmak Köyü)",
      "Burat Mah (verimli Mah) (dereiçi Köyü)",
      "Busaket Mah (demirdöven Köyü)",
      "Calat  Mah (gökceler Mah) (dereiçi Köyü)",
      "Camekar Mah ( Cami Mah) (bıçakçılar Köyü)",
      "Cami  Ve İhtiyaroğlu Mah (esenyaka Köyü)",
      "Cami Kapısı Mah (çevreli Köyü)",
      "Cami Mah (altıparmak Köyü)",
      "Cami Mah (bahçeli Köyü)",
      "Cami Mah (balalan Köyü)",
      "Cami Mah (bostancı Köyü)",
      "Cami Mah (demirkent Köyü)",
      "Cami Mah (dokumacılar Köyü)",
      "Cami Mah (işhan Köyü)",
      "Cami Mah (köprügören Köyü)",
      "Cami Mah (küplüce Köyü)",
      "Cami Mah (tarakçılar Köyü)",
      "Cami Mah (yağcılar Köyü)",
      "Cami Mah (yaylalar Köyü)",
      "Camii Mah (bıçakçılar Köyü)",
      "Camili Mah (balcılı Köyü)",
      "Cancak Mah (demirköy Köyü)",
      "Canıskala Mah (dokumacılar Köyü)",
      "Canol Mah (taşkıran Köyü)",
      "Caret Mah (altıparmak Köyü)",
      "Carkana Mah (havuzlu Köyü)",
      "Cateller Mah (altıparmak Köyü)",
      "Cateller Mezra Mah (altıparmak Köyü)",
      "Celicvar Mah (bostancı Köyü)",
      "Cevizli Mah (çıralı Köyü)",
      "Cihalor Ve Sivanzor Mah (çevreli Köyü)",
      "Cinagara Mah (ırmakyanı Köyü)",
      "Cinnar Mah (çevreli Köyü)",
      "Cires Mah (darıca Köyü)",
      "Ciselet Mah (kömürlü Köyü)",
      "Conzaret Mah (bademkaya Köyü)",
      "Cornak Mah (esendal Köyü)",
      "Curet Mah (cevizlik Köyü)",
      "Çağlayan Mah (bıçakçılar Köyü)",
      "Çağlayan Mah (demirkent Köyü)",
      "Çakmak Mah (erenköy Köyü)",
      "Çalılık Mah (boyalı Köyü)",
      "Çalışkanlar Mah (kirazalan Köyü)",
      "Çam Yuva Mah (yaylalar Köyü)",
      "Çamdibi Mah (narlık Köyü)",
      "Çamlıbel Mah (çevreli Köyü)",
      "Çamlıca Mah (yüncüler Köyü)",
      "Çamlık Mah (tekkale Köyü)",
      "Çamoluk Mah (bıçakçılar Köyü)",
      "Çarmanet Mah (taşkıran Köyü)",
      "Çarşı Mah (işhan Köyü)",
      "Çarşı Mah (köprügören Köyü)",
      "Çatalelma Mah (öğdem Köyü)",
      "Çavuşgil Mah (esenyaka Köyü)",
      "Çayağzı Mah (bostancı Köyü)",
      "Çayağzı Mah (mutlugün Köyü)",
      "Çayıriçi Mah (bakırtepe Köyü)",
      "Çayırlı  Mah (kahlar Mah) (demirköy Köyü)",
      "Çayırlı Mah (demirköy Köyü)",
      "Çelik Mah (bademkaya Köyü)",
      "Çınagara Mah (çeltikdüzü Köyü)",
      "Çınarlı Mah (tekkale Köyü)",
      "Çiçala Mah (tekkale Köyü)",
      "Çilkoset Mah (erenköy Köyü)",
      "Çilliket Mah (taşkıran Köyü)",
      "Çinsegara Mah (boyalı Köyü)",
      "Çintat Mah (çevreli Köyü)",
      "Çitoğulları Mah (çamlıca Köyü)",
      "Çobansuyu Mah (demirkent Köyü)",
      "Çolakoğlu Mah (pamukçular Köyü)",
      "Çoncur Mah (arpacık Köyü)",
      "Çorahlaket Mah (bıçakçılar Köyü)",
      "Çörgens Mah (yamaçüstü Köyü)",
      "Çubuklu Mah (dokumacılar Köyü)",
      "Çukur Mah (darıca Köyü)",
      "Çukur Mah (gümüşözü Köyü)",
      "Çukur Mah (işhan Köyü)",
      "Çuvar Mah (çevreli Köyü)",
      "Dagir Mah (dağeteği Köyü)",
      "Dağeze Mah (bostancı Köyü)",
      "Damlacık Mah (yüncüler Köyü)",
      "Darnuç Mah (işhan Köyü)",
      "Dart Mah (zeytincik Köyü)",
      "Dartav Mah (kömürlü Köyü)",
      "Dedehal Mah (işhan Köyü)",
      "Değirmencik Mah (demirköy Köyü)",
      "Deligil Mah ( Cilvana Mah) (altıparmak Köyü)",
      "Deligil Mah (taşkıran Köyü)",
      "Demircigil Mah (esendal Köyü)",
      "Demirkalem  Mezra Mah (altıparmak Köyü)",
      "Demirkalem Mah (altıparmak Köyü)",
      "Dere Mah (çamlıca Köyü)",
      "Dere Mah (işhan Köyü)",
      "Dere Mah (yamaçüstü Köyü)",
      "Derebaşı Mah (morkaya Köyü)",
      "Dereiçi Mah (kirazalan Köyü)",
      "Dereiçi Mah (yüncüler Köyü)",
      "Derekapı Mah (dereiçi Köyü)",
      "Devtise Mah (altıparmak Köyü)",
      "Dib Mah (esenyaka Köyü)",
      "Dibe Mah (demirdöven Köyü)",
      "Didmuğa Mah (bostancı Köyü)",
      "Didvake Mah (kirazalan Köyü)",
      "Dikmeler Mah (bıçakçılar Köyü)",
      "Diyaken  Mah (gökçala Mah) (zeytincik Köyü)",
      "Dizanot Mah (zeytincik Köyü)",
      "Doğankara Mah (öğdem Köyü)",
      "Doleys Mah (altıparmak Köyü)",
      "Dolupınar Mah (bıçakçılar Köyü)",
      "Duruçay Mah (demirkent Köyü)",
      "Dutdere Mah (bostancı Köyü)",
      "Dutdere Mah (küplüce Köyü)",
      "Dutlupınar Mah (öğdem Köyü)",
      "Düğünlü Mah (narlık Köyü)",
      "Düzce Mah (demirkent Köyü)",
      "Düzler Mah (çıralı Köyü)",
      "Düzler Mah (tekkale Köyü)",
      "Düzyol Mah (kacol Mah) (taşkıran Köyü)",
      "Eğritaş Mah (demirköy Köyü)",
      "Ekuter Mah (günyayla Köyü)",
      "Emetoğlu Mah (bostancı Köyü)",
      "Engüllü Mah (dağeteği Köyü)",
      "Erisman Mah (altıparmak Köyü)",
      "Esentepe Mah (ırmakyanı Köyü)",
      "Eski Cami Mah (erenköy Köyü)",
      "Eskiyayla Mah (taşkıran Köyü)",
      "Espek Mah (darıca Köyü)",
      "Eygar Mah (işhan Köyü)",
      "Gabandibi Mah (dereiçi Köyü)",
      "Galdamak Mah (dokumacılar Köyü)",
      "Gasmaliket Mah (taşkıran Köyü)",
      "Gavnar Mah (çeltikdüzü Köyü)",
      "Gavranzor Mah (taşkıran Köyü)",
      "Gedikli Taş Mah (mutlugün Köyü)",
      "Gevlet Mah (işhan Köyü)",
      "Gevrake Mah (boyalı Köyü)",
      "Gezlor Mah (günyayla Köyü)",
      "Gocoğet Mah (günyayla Köyü)",
      "Gomelt Mah (bostancı Köyü)",
      "Goriyet Mah (çevreli Köyü)",
      "Gostagara Mah (taşkıran Köyü)",
      "Gökçesu Mah (mutlugün Köyü)",
      "Göldere Mah (dokumacılar Köyü)",
      "Görgülü Mah (kınalıçam Köyü)",
      "Göteyara Mah (zeytincik Köyü)",
      "Gözecik Mah (dokumacılar Köyü)",
      "Gurgunze Mah (bostancı Köyü)",
      "Guyret Mah (taşkıran Köyü)",
      "Güdashev Mah (bıçakçılar Köyü)",
      "Güloğlu Mah (erenköy Köyü)",
      "Günaydın Mah (demirdöven Köyü)",
      "Gündoğdu Mah (balalan Köyü)",
      "Gündüz Mah (yüncüler Köyü)",
      "Güney Mah (pamukçular Köyü)",
      "Güney Mah (tekkale Köyü)",
      "Güney Mah (yüksekoba Köyü)",
      "Güngörmez Mah (tekkale Köyü)",
      "Gürmaşın Mah (çeltikdüzü Köyü)",
      "Haceret Mah (yüncüler Köyü)",
      "Hacıgil Mah (erenköy Köyü)",
      "Hacıgil Mah (esendal Köyü)",
      "Hacıgil Mah (yağcılar Köyü)",
      "Hacıoğlu Mah (boyalı Köyü)",
      "Hacıoğulları Mah (taşkıran Köyü)",
      "Hacıosmangil Mah (taşkıran Köyü)",
      "Hacoğlar Mah (taşkıran Köyü)",
      "Hakalı Mah (boyalı Köyü)",
      "Hakverdi Mah (altıparmak Köyü)",
      "Hantal Mah (kömürlü Köyü)",
      "Hanzarat Mah (altıparmak Köyü)",
      "Haran Mah (çağlıyan Köyü)",
      "Harat Mah (demirdöven Köyü)",
      "Harşigil Mah (narlık Köyü)",
      "Haset Mah (mutlugün Köyü)",
      "Hatagara Mah (havuzlu Köyü)",
      "Hav Bağları Mah (alanbaşı Köyü)",
      "Havuzbaşı Mah (bahçeli Köyü)",
      "Hıdıroğlu Mah (çevreli Köyü)",
      "Hınzıhov Mah (esendal Köyü)",
      "Hırcik Mah (boyalı Köyü)",
      "Hildishav Mah (dokumacılar Köyü)",
      "Hinzasor Mah (dağeteği Köyü)",
      "Hişnet Mah (çeltikdüzü Köyü)",
      "Hocagil Mah (yağcılar Köyü)",
      "Hocagiller Mah (çamlıca Köyü)",
      "Hork Mah (taşkıran Köyü)",
      "Hosilet Mah (taşkıran Köyü)",
      "Hostagara Mah (çamlıca Köyü)",
      "Hotmara Mah (erenköy Köyü)",
      "Humetgil Mah (çamlıca Köyü)",
      "Hunahatkar Mah (balcılı Köyü)",
      "Hurşitgil Mah (tekkale Köyü)",
      "Husillar Mah (balcılı Köyü)",
      "Hüseyin Hüsnü Paşa Mah (demirkent Köyü)",
      "Irmakyanı Mah (yüncüler Köyü)",
      "İkizkaya Mah (ırmakyanı Köyü)",
      "İmamgil Mah (tekkale Köyü)",
      "İmen Çimen Mah (sebzeciler Köyü)",
      "İncetepe Mah (kömürlü Köyü)",
      "İspandik Mah (işhan Köyü)",
      "İsret Mah (bayındır Mah) (dereiçi Köyü)",
      "Kadı Kışla Mah (altıparmak Köyü)",
      "Kadıoğlu Mah (balalan Köyü)",
      "Kağlık Mah (gümüşözü Köyü)",
      "Kahramangil Mah (erenköy Köyü)",
      "Kahramanlar Mah (balcılı Köyü)",
      "Kaledibi  Mah (karşı Mah) (çıralı Köyü)",
      "Kaledibi Mah (bıçakçılar Köyü)",
      "Kaledibi Mah (çıralı Köyü)",
      "Kaledibi Mah (tekkale Köyü)",
      "Kalmağot Mah (bostancı Köyü)",
      "Kamnegara Mah (kömürlü Köyü)",
      "Kanatlı Mah (narlık Köyü)",
      "Kannet Mah (öğdem Köyü)",
      "Kansas Mah (alanbaşı Köyü)",
      "Karacaoğlan  Mah ( Polistav Mah) (esenyaka Köyü)",
      "Karagözoğulları Mah (çamlıca Köyü)",
      "Karagözoğulları Mezra Mah (çamlıca Köyü)",
      "Karahanlar Mah (taşkıran Köyü)",
      "Karamanlar Mah (yokuşlu Köyü)",
      "Karameşe Mah (yeniköy Köyü)",
      "Karamezra Mah (yamaçüstü Köyü)",
      "Karayiğit Mah (küplüce Köyü)",
      "Karbasan Mah (demirdöven Köyü)",
      "Karmusör Mah (kınalıçam Köyü)",
      "Karşı Mah (darıca Köyü)",
      "Karşıköy  Mah (cami Mah) (yamaçüstü Köyü)",
      "Kartutan Mah (bıçakçılar Köyü)",
      "Karvana Mah (boyalı Köyü)",
      "Karzel Mah (köprügören Köyü)",
      "Kaşıkçıgil Mah (çevreli Köyü)",
      "Katolik Mah (taşkıran Köyü)",
      "Katvana Mah (esendal Köyü)",
      "Kavaklıdere Mah (öğdem Köyü)",
      "Kayabaşı Mah (yaylalar Köyü)",
      "Kayabaşı Mah (yüncüler Köyü)",
      "Kayagil Mah (tekkale Köyü)",
      "Kaymaklı Mah (kirazalan Köyü)",
      "Kaymaz Mah (dokumacılar Köyü)",
      "Kaynarca Mah (dokumacılar Köyü)",
      "Keda Mah (çıralı Köyü)",
      "Kedas Mah (dokumacılar Köyü)",
      "Kelazor Mah (bıçakçılar Köyü)",
      "Kelensev Mah (altıparmak Köyü)",
      "Keleş Mah (erenköy Köyü)",
      "Kerat  Mah (yapıcı Mah) (dereiçi Köyü)",
      "Keremoğlu Mah (esenyaka Köyü)",
      "Kerticiler Mah (taşkıran Köyü)",
      "Kervan Tepe Mah (dağeteği Köyü)",
      "Kesberler Mah (taşkıran Köyü)",
      "Keşoğlu Yayla Mah (altıparmak Köyü)",
      "Ketket  Mah (akalan Mah) (dereiçi Köyü)",
      "Ketket Mah (yüksekoba Köyü)",
      "Kır Mah (köprügören Köyü)",
      "Kıravet Mah (bademkaya Köyü)",
      "Kırma Mah (esendal Köyü)",
      "Kışla Mah (altıparmak Köyü)",
      "Kışla Mah (balalan Köyü)",
      "Kışla Mah (bostancı Köyü)",
      "Kışla Mah (çevreli Köyü)",
      "Kıtavet Mah (balalan Köyü)",
      "Kıvrak Mah (erenköy Köyü)",
      "Kidazor Mah (cevizlik Köyü)",
      "Kiletkar Mah (yarbaşı Köyü)",
      "Kiravat Mah (demirdöven Köyü)",
      "Kirazlı  Mah (yukarı Irgut Mah) (demirköy Köyü)",
      "Kirazlı Mah (demirköy Köyü)",
      "Kirazlı Mah (narlık Köyü)",
      "Kirazlı Mah (yüncüler Köyü)",
      "Kirtiyit Mah (günyayla Köyü)",
      "Kobalet Mah (cevizlik Köyü)",
      "Koca Ağa  Mah (şirin Mah) (erenköy Köyü)",
      "Koçaklar Mah (yüncüler Köyü)",
      "Koçaligil Mah (altıparmak Köyü)",
      "Koçat Mah (çamlıca Köyü)",
      "Koçket Mah (cevizlik Köyü)",
      "Koletet Mah (altıparmak Köyü)",
      "Kologil Mah (demirköy Köyü)",
      "Kolorta Mah (esendal Köyü)",
      "Konniyet Mah (esendal Köyü)",
      "Kornet Mah (demirdöven Köyü)",
      "Koryet Mah (bıçakçılar Köyü)",
      "Koşnahal Mah (dokumacılar Köyü)",
      "Koşuyolu Mah (kozanet Mah) (taşkıran Köyü)",
      "Köprübaşı Mah (çağlıyan Köyü)",
      "Köprübaşı Mah (çevreli Köyü)",
      "Köprübaşı Mah (esenyaka Köyü)",
      "Köprübaşı Mah (ırmakyanı Köyü)",
      "Körahmet Mah (yaylalar Köyü)",
      "Köşebaşı Mah (balalan Köyü)",
      "Köy Yanı Mah (cevizlik Köyü)",
      "Köybaşı Mah (köprügören Köyü)",
      "Köybaşı Mah (narlık Köyü)",
      "Krayekar  Mah (camii Mah) (bıçakçılar Köyü)",
      "Kumlu  Mezrası Mah (altıparmak Köyü)",
      "Kumlu Mah (altıparmak Köyü)",
      "Kuprat Mah (altıparmak Köyü)",
      "Kupriyet Mah (bıçakçılar Köyü)",
      "Kurtgil Mah (işhan Köyü)",
      "Kuzey   Mah (babutoğlu Mah) (esenyaka Köyü)",
      "Kuzey Mah (esenyaka Köyü)",
      "Kuzey Mah (morkaya Köyü)",
      "Kuzluca Mah (tarakçılar Köyü)",
      "Küçük Çatalelma Mah (öğdem Köyü)",
      "Küçük Kavaklıdere Mah (öğdem Köyü)",
      "Küçük Mah (yüksekoba Köyü)",
      "Laçinoğlu Mah (çevreli Köyü)",
      "Lazgil Mah (dokumacılar Köyü)",
      "Lazlar Mah (avcılar Köyü)",
      "Lazoğlu Mah (boyalı Köyü)",
      "Leknar Mah (yüksekoba Köyü)",
      "Lelvar Mah (dokumacılar Köyü)",
      "Litrev Mah (balcılı Köyü)",
      "Lukaset Mah (günyayla Köyü)",
      "M.cami Mah (serinsu Köyü)",
      "Maçhetler Mah (altıparmak Köyü)",
      "Mağara Mah (çevreli Köyü)",
      "Mahik Mah (çeltikdüzü Köyü)",
      "Mahmiyoğlar Mah (çamlıca Köyü)",
      "Maraş Mah (çevreli Köyü)",
      "Merekler Mah (işhan Köyü)",
      "Merkez  Yukarı Mah (çağlıyan Köyü)",
      "Merkez Mah (arpacık Köyü)",
      "Merkez Mah (bademkaya Köyü)",
      "Merkez Mah (bakırtepe Köyü)",
      "Merkez Mah (boyalı Köyü)",
      "Merkez Mah (cevizlik Köyü)",
      "Merkez Mah (çeltikdüzü Köyü)",
      "Merkez Mah (çıralı Köyü)",
      "Merkez Mah (dağeteği Köyü)",
      "Merkez Mah (demirdöven Köyü)",
      "Merkez Mah (esenyaka Köyü)",
      "Merkez Mah (gümüşözü Köyü)",
      "Merkez Mah (günyayla Köyü)",
      "Merkez Mah (inanlı Köyü)",
      "Merkez Mah (kılıçkaya Köyü)",
      "Merkez Mah (küplüce Köyü)",
      "Merkez Mah (mutlugün Köyü)",
      "Merkez Mah (ormandibi Köyü)",
      "Merkez Mah (öğdem Köyü)",
      "Merkez Mah (özgüven Köyü)",
      "Merkez Mah (pamukçular Köyü)",
      "Merkez Mah (yarbaşı Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Merkez Mah (yokuşlu Köyü)",
      "Merkez Mah (zeytincik Köyü)",
      "Merkez Osanbaşı Mah (çağlıyan Köyü)",
      "Meşecik Köyü",
      "Mevla Mah (öğdem Köyü)",
      "Meydan Mah (çevreli Köyü)",
      "Mezarlık Mah (yarbaşı Köyü)",
      "Mezra Mah (çevreli Köyü)",
      "Mezra Mah (yağcılar Köyü)",
      "Mısıroğulları Mah (yağcılar Köyü)",
      "Mıstafagil Mah (kömürlü Köyü)",
      "Miçingil Mah (altıparmak Köyü)",
      "Miyles Mah (yamaçüstü Köyü)",
      "Modut Mah (yaylalar Köyü)",
      "Molla Ömer Mah (tekkale Köyü)",
      "Moşnar-gimnar Mah (yağcılar Köyü)",
      "Murhaçgil  Mah (dutluk Mah) (tekkale Köyü)",
      "Musagil Mah (demirköy Köyü)",
      "Muşabes Mah (yamaçüstü Köyü)",
      "Nahsit Mah (narlık Köyü)",
      "Nakerav Mah (bostancı Köyü)",
      "Nakort-sakısdela Mah (yağcılar Köyü)",
      "Narcivel Mah (dokumacılar Köyü)",
      "Navanev -dalavar Mah (altıparmak Köyü)",
      "Naznara Mah (altıparmak Köyü)",
      "Nesligara Mah (çıralı Köyü)",
      "Niyart Mah (pamukçular Köyü)",
      "Nöbetket Mah (taşkıran Köyü)",
      "Nusret -kurdat Yayla Mah (altıparmak Köyü)",
      "Odun Deposu Mah (yeniköy Köyü)",
      "Ogeça Mah (esendal Köyü)",
      "Okurdağı Mah (çevreli Köyü)",
      "Olgunlar Mah (yaylalar Köyü)",
      "Orman Ağzı Mah (tekkale Köyü)",
      "Ormandibi Mah (küplüce Köyü)",
      "Orta  Cami Mah (erenköy Köyü)",
      "Orta Mah (alanbaşı Köyü)",
      "Orta Mah (demirköy Köyü)",
      "Orta Mah (havuzlu Köyü)",
      "Orta Mah (köprügören Köyü)",
      "Orta Mah (küplüce Köyü)",
      "Orta Mah (morkaya Köyü)",
      "Orta Mah (pamukçular Köyü)",
      "Orta Mah (yüncüler Köyü)",
      "Orta Varmet  Mah (orta Çağlar Mah) (dereiçi Köyü)",
      "Ortagül Mah (bostancı Köyü)",
      "Ortaklar Mah (dokumacılar Köyü)",
      "Ömergil Mah (altıparmak Köyü)",
      "Özenli Mah (şağvalet Mah) (taşkıran Köyü)",
      "Palsuyu Mah (çeltikdüzü Köyü)",
      "Pamukluk Mah (işhan Köyü)",
      "Parhat Mah (demirköy Köyü)",
      "Paşa Mah (pamukçular Köyü)",
      "Paşalar Mah (ırmakyanı Köyü)",
      "Patrikara Mah (taşkıran Köyü)",
      "Perset Mah (altıparmak Köyü)",
      "Pevzalar Mah (balcılı Köyü)",
      "Pınarbaşı Mah (balalan Köyü)",
      "Pınarbaşı Mah (yüncüler Köyü)",
      "Pınarlı  Mah (kadıyet Mah) (demirköy Köyü)",
      "Pınarlı Mah (demirköy Köyü)",
      "Pınarlı Mah (küplüce Köyü)",
      "Piçhet Mah (bostancı Köyü)",
      "Pikaltay Mah (küplüce Köyü)",
      "Pirinçlik Mah (bağlık Mah) (arpacık Köyü)",
      "Pisigara Mah (tarakçılar Köyü)",
      "Pişar Yaylası Mah (demirdöven Köyü)",
      "Pişhankara Mah (altıparmak Köyü)",
      "Pişnar Mah (demirdöven Köyü)",
      "Pişnarhev Mah (bıçakçılar Köyü)",
      "Poso Mah (küplüce Köyü)",
      "Posovat Mah (çamlıca Köyü)",
      "Puç Mah (küplüce Köyü)",
      "Pusagara Mah (havuzlu Köyü)",
      "Recepgil Mah (dokumacılar Köyü)",
      "Saatol Mah (havuzlu Köyü)",
      "Sabahte Mah (demirdöven Köyü)",
      "Sabanet Mah (çıralı Köyü)",
      "Sabzuvan Mah (taşkıran Köyü)",
      "Sadıkhane Mah (bıçakçılar Köyü)",
      "Sakat Mah (balalan Köyü)",
      "Sakura Mah (yaylalar Köyü)",
      "Sakut - Nato Mah (tekkale Köyü)",
      "Sakut Mah (yamaçüstü Köyü)",
      "Salbet Mah (dereiçi Köyü)",
      "Salkana Mah (küplüce Köyü)",
      "Samceliyat Mah (altıparmak Köyü)",
      "Samisagara Mah (dokumacılar Köyü)",
      "Sandıklı Mah (pamukçular Köyü)",
      "Sanikor Mah (günyayla Köyü)",
      "Sargüle Mah (küplüce Köyü)",
      "Sarıerik Mah (demirkent Köyü)",
      "Sarıgöl Mah (taşkıran Köyü)",
      "Sarıkoç Mah (serinsu Köyü)",
      "Sasepel  Mah (yenice Mah) (dereiçi Köyü)",
      "Satibe Mah (taşkıran Köyü)",
      "Savriyat Mah (balcılı Köyü)",
      "Seku Mah (taşlıca Mah) (dereiçi Köyü)",
      "Sepegar Mah (yarbaşı Köyü)",
      "Sepegara Mah (taşkıran Köyü)",
      "Sergat Mah (demirdöven Köyü)",
      "Serintepe Mah (küplüce Köyü)",
      "Serintepe Mah (yamaçüstü Köyü)",
      "Sethet Mah (kömürlü Köyü)",
      "Sıhiyat Mah (altıparmak Köyü)",
      "Sırt Mah (çevreli Köyü)",
      "Sırt Mah (esenyaka Köyü)",
      "Sırt Mah (işhan Köyü)",
      "Sırtüstü Mah (narlık Köyü)",
      "Sileminta Mah (demirdöven Köyü)",
      "Simağet Mah (taşkıran Köyü)",
      "Sipriyet Mah (boyalı Köyü)",
      "Sofuoğlu Mah (bostancı Köyü)",
      "Soğuk Oluk Mah (öğdem Köyü)",
      "Soğuksu Mah (balalan Köyü)",
      "Soğuksu Mah (demirkent Köyü)",
      "Soşt Mah (balalan Köyü)",
      "Söğütlü Mah (altıparmak Köyü)",
      "Söğütönü Mah (öğdem Köyü)",
      "Subabara Mah (işhan Köyü)",
      "Suhpeç Mah (işhan Köyü)",
      "Sultangil Mah (altıparmak Köyü)",
      "Sultangil Yaylası Mah (altıparmak Köyü)",
      "Suluova Mah (narlık Köyü)",
      "Sura Mah (taşkıran Köyü)",
      "Surhan-terek  Oğulları Mah (yağcılar Köyü)",
      "Susuzagara Mah (bıçakçılar Köyü)",
      "Suvak Mah (narlık Köyü)",
      "Sütlüce  Mah (köy Merkezi Mah) (sütlüce Köyü)",
      "Sütlüpınar Mah (caniyet Mah) (kömürlü Köyü)",
      "Şabangil  - Zekaratlar Mah (altıparmak Köyü)",
      "Şapet Mah (çevreli Köyü)",
      "Şatıroğlu Mah (esenyaka Köyü)",
      "Şavlak Mah (dokumacılar Köyü)",
      "Şehitlik Mah (çevreli Köyü)",
      "Şötget Mah (dokumacılar Köyü)",
      "Tahnagara Mah (günyayla Köyü)",
      "Tandırkaya Mah (yeniköy Köyü)",
      "Tarpogil Mah (erenköy Köyü)",
      "Taşbaşı Mah (demirdöven Köyü)",
      "Taşbaşı Mah (dokumacılar Köyü)",
      "Taşbaşı Mah (ırmakyanı Köyü)",
      "Taşbaşı Mah (öğdem Köyü)",
      "Taşbaşı Mah (pamukçular Köyü)",
      "Taşdelen Mah (öğdem Köyü)",
      "Taşdibi Mah (pamukçular Köyü)",
      "Taşdibi Mah (tekkale Köyü)",
      "Taşkent Mah (işhan Köyü)",
      "Taşköprü Mah (conet Mah) (taşkıran Köyü)",
      "Taşlı  Mah (aşağı Mah) (darıca Köyü)",
      "Tatlıçay Mah (boyalı Köyü)",
      "Tepe Mah (dokumacılar Köyü)",
      "Tibet Mah (demirdöven Köyü)",
      "Tilki Mah (alanbaşı Köyü)",
      "Tokat Mah (talıçayır Mah) (taşkıran Köyü)",
      "Topaloğlu Mah (balalan Köyü)",
      "Turnalar Mah (altıparmak Köyü)",
      "Tuspir Mah (demirdöven Köyü)",
      "Ucar Mah (kirazalan Köyü)",
      "Urumgil Mah (işhan Köyü)",
      "Usupgil Mah (çamlıca Köyü)",
      "Utletler Mah (çamlıca Köyü)",
      "Uysallar Mah (mutlugün Köyü)",
      "Uzun Mah (serinsu Köyü)",
      "Üzümlü Mah (yüncüler Köyü)",
      "Vaçget Mah (dokumacılar Köyü)",
      "Vake Mah (esendal Köyü)",
      "Vaket Mah (taşkıran Köyü)",
      "Van Mah (gürsu Mah) (taşkıran Köyü)",
      "Vanat-gedevnet-laşet Mah (esenyaka Köyü)",
      "Varlık Mah (cevizlik Köyü)",
      "Vehlan Mah (dokumacılar Köyü)",
      "Vehnal Mah (demirdöven Köyü)",
      "Veligil Mah (sebzeciler Köyü)",
      "Verneş Mah (esendal Köyü)",
      "Vink Bağlığı Mah (morkaya Köyü)",
      "Yağmurçay Mah (balcılı Köyü)",
      "Yakalı Mah (demirkent Köyü)",
      "Yakarı Çamlık Mah (tekkale Köyü)",
      "Yanık Aluzar Hakanet Mah (çevreli Köyü)",
      "Yanık Mah (dağeteği Köyü)",
      "Yarbaşı Mah (küplüce Köyü)",
      "Yarbaşı Mah (narlık Köyü)",
      "Yassıkaya Mah (dokumacılar Köyü)",
      "Yayıgil Mah (işhan Köyü)",
      "Yeni  Mah  -taşbaşı Mah (tekkale Köyü)",
      "Yeni Mah (yağcılar Köyü)",
      "Yeni Mah (yüncüler Köyü)",
      "Yeşilöz Mah (bıçakçılar Köyü)",
      "Yeşilyurt  Mah (kurtiket Mah) (demirköy Köyü)",
      "Yeşilyurt Mah (ağagil Mah) (demirköy Köyü)",
      "Yeşilyurt Mah (demirköy Köyü)",
      "Yokuşbaşı   Mah (nahnep Mah) (esenyaka Köyü)",
      "Yolbaşı Mah (yüncüler Köyü)",
      "Yoncalık  Mah (kot- Natelt Mah) (esenyaka Köyü)",
      "Yoncalık Mah (demirköy Köyü)",
      "Yukarı Bölükbaşı Mah (tekkale Köyü)",
      "Yukarı Çamlık Mah (bahçeli Köyü)",
      "Yukarı Güp Mah (tekkale Köyü)",
      "Yukarı Kayagil Mah (tekkale Köyü)",
      "Yukarı Kaymaz Mah (dokumacılar Köyü)",
      "Yukarı Leknar Mah (yüksekoba Köyü)",
      "Yukarı Mah (darıca Köyü)",
      "Yukarı Mah (dereiçi Köyü)",
      "Yukarı Mah (havuzlu Köyü)",
      "Yukarı Mah (yüksekoba Köyü)",
      "Yukarı Mısur Mah (işhan Köyü)",
      "Yukarı Sakura Mah (yaylalar Köyü)",
      "Yukarı Uban Mah (taşkıran Köyü)",
      "Yukarı Varmet  Mah (yukarı Çağlar Mah) (dereiçi Köyü)",
      "Yumurtalı Mah (alanbaşı Köyü)",
      "Yuvacık   Mah ( Mantagara Mah) (esenyaka Köyü)",
      "Yuvarlı Mah (yamaçüstü Köyü)",
      "Zangeller Mah (ırmakyanı Köyü)",
      "Zekarat Mah (demirdöven Köyü)",
      "Zeliyet Mah (yarbaşı Köyü)",
      "Zeytinlik Mah (yağcılar Köyü)",
      "Zeytinlik Mah (yarbaşı Köyü)",
      "Ziyaret Mah (narlık Köyü)",
      "Zolağara Mah (yüksekoba Köyü)",
      "Zoybar Mah (esendal Köyü)",
      "Zuvare Mah (yağcılar Köyü)",
      "Ahalt Mah",
      "Erdemler Mah",
      "Hasanağa Mah",
      "Kazım Karabekir Mah",
      "Merkez Mah"
    ]
  },
  "Aydın": {
    "Bozdoğan": [
      "Akçay Mah",
      "Akseki Mah",
      "Akyaka Mah",
      "Alamut Mah",
      "Alhisar Mah",
      "Altıntaş Mah",
      "Amasya Mah",
      "Asma Mah",
      "Başalan Mah",
      "Cumhuriyet Mah",
      "Çamlıdere Mah",
      "Çarşı Mah",
      "Dömen Mah",
      "Dutağaç Mah",
      "Eymir Mah",
      "Güney Mah",
      "Güneyyaka Mah",
      "Güre Mah",
      "Güvenir Mah",
      "Haydere Mah",
      "Hıdırbaba Mah",
      "Hışımlar Mah",
      "Hisar Mah",
      "Kakkalan Mah",
      "Kamışlar Mah",
      "Karaahmetler Mah",
      "Karabağlar Mah",
      "Kavaklı Mah",
      "Kazandere Mah",
      "Kemer Mah",
      "Kılavuzlar Mah",
      "Kızılca Mah",
      "Kızıltepe Mah",
      "Konaklı Mah",
      "Koyuncular Mah",
      "Körteke Mah",
      "Madran Mah",
      "Olukbaşı Mah",
      "Osmaniye Mah",
      "Örencik Mah",
      "Örentaht Mah",
      "Örmepınar Mah",
      "Örtülü Mah",
      "Pınarlı Mah",
      "Seki Mah",
      "Sırma Mah",
      "Tütüncüler Mah",
      "Yaka Mah",
      "Yazıkent Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yeşil Yenice Mah",
      "Yeşilçam Mah",
      "Ziyaretli Mah"
    ],
    "Buharkent": [
      "Ericek Mah",
      "Feslek Mah",
      "Gelenbe Mah",
      "Gündoğan Mah",
      "İstiklal Mah",
      "Kamilpaşa Mah",
      "Kayaburnu Mah",
      "Kızıldere Mah",
      "Menderes Mah",
      "Muratdağı Mah",
      "Ortakçı Mah",
      "Savcıllı Mah",
      "Üçeylül Mah",
      "Zafer Mah"
    ],
    "Çine": [
      "Akçaova Mah",
      "Akdam Mah",
      "Alabayır Mah",
      "Altınabat Mah",
      "Altınova Mah",
      "Bağlarbaşı Mah",
      "Bahçearası Mah",
      "Bedirler Mah",
      "Bereket Mah",
      "Bölüntü Mah",
      "Bucak Mah",
      "Camızağılı Mah",
      "Cumalı Mah",
      "Cumhuriyet Mah",
      "Çaltı Mah",
      "Çatak Mah",
      "Çöğürlük Mah",
      "Dereli Mah",
      "Doğanyurt Mah",
      "Dorumlar Mah",
      "Dutluoluk Mah",
      "Elderesi Mah",
      "Esentepe Mah",
      "Eskiçine Mah",
      "Evciler Mah",
      "Gökyaka Mah",
      "Hacıpaşalar Mah",
      "Hallaçlar Mah",
      "Hamitabat Mah",
      "Hasanlar Mah",
      "İbrahimkavağı Mah",
      "Kabalar Mah",
      "Kabataş Mah",
      "Kadılar Mah",
      "Kahraman Mah",
      "Karahayıt Mah",
      "Karakollar Mah",
      "Karanfiller Mah",
      "Karğı Mah",
      "Kasar Mah",
      "Kavşıt Mah",
      "Kırkışık Mah",
      "Kırksakallar Mah",
      "Kızılgüney Mah",
      "Kirazderesi Mah",
      "Kuruköy Mah",
      "Mutaflar Mah",
      "Ovacık Mah",
      "Özeren Mah",
      "Sağlık Mah",
      "Saraçlar Mah",
      "Sarıköy Mah",
      "Sarıoğlu Mah",
      "Sarnıç Mah",
      "Seferler Mah",
      "Soğancılar Mah",
      "Soğukoluk Mah",
      "Söğütçük Mah",
      "Subaşı Mah",
      "Şevketiye Mah",
      "Taşoluk Mah",
      "Tatarmemişler Mah",
      "Tepeköy Mah",
      "Topçam Mah",
      "Umurköy Mah",
      "Ünlüce Mah",
      "Yağcılar Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yolboyu Mah",
      "Yörükler Mah"
    ],
    "Didim": [
      "Ak-yeniköy Mah",
      "Akbük Mah",
      "Akköy Mah",
      "Altınkum Mah",
      "Balat Mah",
      "Batıköy Mah",
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Denizköy Mah",
      "Efeler Mah",
      "Fevzipaşa Mah",
      "Hisar Mah",
      "Mavişehir Mah",
      "Mersindere Mah",
      "Yalıköy Mah",
      "Yeni Mah"
    ],
    "Efeler": [
      "Alatepe Mah",
      "Ambarcık Mah",
      "Balıkköy Mah",
      "Dağeymiri Mah",
      "Danişment Mah",
      "Girne Mah",
      "Hasanefendi-ramazan Paşa Mah",
      "Horozköy Mah",
      "Kalfaköy Mah",
      "Kemer Mah",
      "Kızılcaköy Mah",
      "Konuklu Mah",
      "Köprülü-veysipaşa Mah",
      "Mesudiye Mah",
      "Meşrutiyet Mah",
      "Mimar Sinan Mah",
      "Zeytinköy Mah",
      "Cumhuriyet Mah",
      "Efeler Mah",
      "Fatih Mah",
      "Işıklı Mah",
      "İstiklal Mah",
      "Kadıköy Mah",
      "Kardeşköy Mah",
      "Kurtuluş Mah",
      "Kuyulu Mah",
      "Osman Yozgatlı Mah",
      "Ovaeymir Mah",
      "Şevketiye Mah",
      "Yedi Eylül Mah",
      "Zeybek Mah",
      "Adnan Menderes Mah",
      "Alanlı Mah",
      "Armutlu Mah",
      "Ata Mah",
      "Ataosb Mah",
      "Bademli Mah",
      "Baltaköy Mah",
      "Böcek Mah",
      "Cuma Mah",
      "Çeştepe Mah",
      "Çiftlikköy Mah",
      "Dalama Bucağı Yeniköy Mah",
      "Dalama Mah",
      "Dereköy Mah",
      "Doğan Mah",
      "Gödrenli Mah",
      "Gölhisar Mah",
      "Gözpınar Mah",
      "Güzelhisar Mah",
      "Ilıcabaşı Mah",
      "Karahayıt Mah",
      "Karaköy Mah",
      "Kenger Mah",
      "Kırıklar Mah",
      "Kozalaklı Mah",
      "Kuloğullar Mah",
      "Merkez Bucağı Yeniköy Mah",
      "Mesutlu Mah",
      "Orta Mah",
      "Savrandere Mah",
      "Sıralılar Mah",
      "Şahnalı Mah",
      "Tepecik Mah",
      "Tepeköy Mah",
      "Yağcılar Mah",
      "Yılmazköy Mah",
      "Zafer Mah",
      "Aşağıkayacık Mah",
      "Çayyüzü Mah",
      "Eğrikavak Mah",
      "Emirdoğan Mah",
      "Gölcük Mah",
      "İlyasdere Mah",
      "İmamköy Mah",
      "Kocagür Mah",
      "Kuyucular Mah",
      "Musluca Mah",
      "Ortaköy Mah",
      "Pınardere Mah",
      "Serçeköy Mah",
      "Terziler Mah",
      "Umurlu Mah",
      "Yukarıkayacık Mah"
    ],
    "Germencik": [
      "Alangüllü Mah",
      "Bozköy Mah",
      "Camikebir Mah",
      "Çamköy Mah",
      "Çarıklar Mah",
      "Dağkaraağaç Mah",
      "Dampınar Mah",
      "Habibler Mah",
      "Hıdırbeyli Mah",
      "İstasyon Mah",
      "Karaağaçlı Mah",
      "Kızılcagedik Mah",
      "Mesudiye Mah",
      "Meşeli Mah",
      "Mursallı Mah",
      "Ömerbeyli Mah",
      "Park Mah",
      "Reisköy Mah",
      "Turanlar Mah",
      "Üzümlü Mah",
      "Yedieylül Mah",
      "Yeni Mah",
      "Abdurrahmanlar Mah",
      "Balatçık Mah",
      "Dağyeni Mah",
      "Dereköy Mah",
      "Gümüşköy Mah",
      "Gümüşyeniköy Mah",
      "Kızılcapınar Mah",
      "Moralı Mah",
      "Naipli Mah",
      "Neşetiye Mah",
      "Ortaklar Mah",
      "Selatin Mah",
      "Tekin Mah",
      "Uzunkum Mah"
    ],
    "İncirliova": [
      "Acarlar Mah",
      "Akçeşme Mah",
      "Arpadere Mah",
      "Arzular Mah",
      "Atatürk Mah",
      "Beyköy Mah",
      "Cumhuriyet Mah",
      "Dereağzı Mah",
      "Eğrek Mah",
      "Erbeyli Mah",
      "Gerenkova Mah",
      "Hacıaliobası Mah",
      "Hamitler Mah",
      "Hürriyet Mah",
      "İkizdere Mah",
      "İsafakılar Mah",
      "İstiklal Mah",
      "Karabağ Mah",
      "Karagözler Mah",
      "Köprüova Mah",
      "Kurtuluş Mah",
      "Osmanbükü Mah",
      "Palamutköy Mah",
      "Sandıklı Mah",
      "Sınırteke Mah",
      "Şirindere Mah",
      "Yazıdere Mah",
      "Zafer Mah"
    ],
    "Karacasu": [
      "Alemler Mah",
      "Aşağıgörle Mah",
      "Ataeymir Mah",
      "Ataköy Mah",
      "Bahçeköy Mah",
      "Bereketli Mah",
      "Bingeç Mah",
      "Büyükdağlı Mah",
      "Cabi Mah",
      "Cuma Mah",
      "Çamarası Mah",
      "Çamköy Mah",
      "Dedeler Mah",
      "Dereköy Mah",
      "Dikmen Mah",
      "Esençay Mah",
      "Geyre Mah",
      "Görle Mah",
      "Güzelbeyli Mah",
      "Güzelköy Mah",
      "Hacıhıdırlar Mah",
      "Işıklar Mah",
      "Karabağlar Mah",
      "Karacaören Mah",
      "Küçükdağlı Mah",
      "Nargedik Mah",
      "Palamutçuk Mah",
      "Tekeliler Mah",
      "Tepecik Mah",
      "Yaykın Mah",
      "Yaylalı Mah",
      "Yazır Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yeşilyurt Mah",
      "Yolaltı Mah",
      "Yolüstü Mah"
    ],
    "Karpuzlu": [
      "Abak Mah",
      "Akçaabat Mah",
      "Bayraktepe Mah",
      "Cumalar Mah",
      "Çobanisa Mah",
      "Ektirli Mah",
      "Gölcük Mah",
      "Güney Mah",
      "Hatıpkışla Mah",
      "Işıklar Mah",
      "Koğuk Mah",
      "Meriçler Mah",
      "Mutluca Mah",
      "Orta Mah",
      "Ovapınarı Mah",
      "Ömerler Mah",
      "Şenköy Mah",
      "Tekeler Mah",
      "Tütünlük Mah",
      "Ulukonak Mah",
      "Umcular Mah",
      "Yağşılar Mah",
      "Yeni Mah"
    ],
    "Koçarlı": [
      "Adnan Menderes Mah",
      "Akmescit Mah",
      "Atatürk Mah",
      "Bağarcık Mah",
      "Bağcılar Mah",
      "Bıyıklı Mah",
      "Birci Mah",
      "Boğaziçi Mah",
      "Boydere Mah",
      "Büyükdere Mah",
      "Cincin Mah",
      "Çakırbeyli Mah",
      "Çakmar Mah",
      "Çallı Mah",
      "Çeşmeköy Mah",
      "Çulhalar Mah",
      "Dedeköy Mah",
      "Dereköy Mah",
      "Esentepe Mah",
      "Evsekler Mah",
      "Gaffarlar Mah",
      "Gözkaya Mah",
      "Güdüşlü Mah",
      "Gündoğan Mah",
      "Hacıhamzalar Mah",
      "Halilbeyli Mah",
      "Haydarlı Mah",
      "Karaağaç Mah",
      "Karacaören Mah",
      "Karadut Mah",
      "Kasaplar Mah",
      "Kızılcabölük Mah",
      "Kızılkaya Mah",
      "Kullar Mah",
      "Kuşlarbelen Mah",
      "Mersinbelen Mah",
      "Orhaniye Mah",
      "Orta Mah",
      "Sapalan Mah",
      "Satılar Mah",
      "Sobuca Mah",
      "Şahinciler Mah",
      "Şenköy Mah",
      "Taşköy Mah",
      "Tekeli Mah",
      "Tığıllar Mah",
      "Timinciler Mah",
      "Yağcıdere Mah",
      "Yağhanlı Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Zeytinköy Mah"
    ],
    "Köşk": [
      "Ahatlar Mah",
      "Akçaköy Mah",
      "Altıeylül Mah",
      "Baklaköy Mah",
      "Başçayır Mah",
      "Beyköy Mah",
      "Cumadere Mah",
      "Cumayanı Mah",
      "Çarşı Mah",
      "Çiftlikköy Mah",
      "Gökkiriş Mah",
      "Gündoğan Mah",
      "Güzelköy Mah",
      "Ilıdağ Mah",
      "Karatepe Mah",
      "Ketenyeri Mah",
      "Kıran Mah",
      "Kızılcaköy Mah",
      "Kızılcayer Mah",
      "Koçak Mah",
      "Menteşeler Mah",
      "Mezeköy Mah",
      "Ovaköy Mah",
      "Sarıçam Mah",
      "Serdaroğlu Mah",
      "Soğukkuyu Mah",
      "Uzundere Mah",
      "Yavuzköy Mah"
    ],
    "Kuşadası": [
      "Alacamescit Mah",
      "Bayraklıdede Mah",
      "Caferli Mah",
      "Camiatik Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Çınarköy Mah",
      "Dağ Mah",
      "Davutlar Mah",
      "Değirmendere Mah",
      "Ege Mah",
      "Güzelçamlı Mah",
      "Hacıfeyzullah Mah",
      "İkiçeşmelik Mah",
      "Kadıkalesi Mah",
      "Kadınlar Denizi Mah",
      "Karaova Mah",
      "Kirazlı Mah",
      "Soğucak Mah",
      "Türkmen Mah",
      "Yavansu Mah",
      "Yaylaköy Mah",
      "Yeniköy Mah"
    ],
    "Kuyucak": [
      "Aksaz Mah",
      "Aydınoğlu Mah",
      "Azizabat Mah",
      "Başaran Mah",
      "Belenova Mah",
      "Beşeylül  Mah (merkez Mah)",
      "Beşeylül Mah",
      "Bucakköy Mah",
      "Cumhuriyet Mah",
      "Çamdibi Mah",
      "Çobanisa Mah",
      "Dereköy Mah",
      "Fatih Mah",
      "Gencelli Mah",
      "Gencellidere Mah",
      "Horsunlu Mah",
      "İğdecik Mah",
      "Karapınar Mah",
      "Kayran Mah",
      "Kurtuluş  Mah (horsunlu Mah)",
      "Kurtuluş Mah",
      "Musakolu Mah",
      "Mustafapaşa Mah",
      "Ovacık Mah",
      "Ören Mah",
      "Pamucak Mah",
      "Pamukören Mah",
      "Sarıcaova Mah",
      "Taşoluk Mah",
      "Yakuppaşa Mah",
      "Yamalak Mah",
      "Yaylalı Mah",
      "Yeni Mah",
      "Yeşildere Mah",
      "Yöre Mah",
      "Yukarıyakacık Mah"
    ],
    "Nazilli": [
      "Akpınar Mah",
      "Aksu Mah",
      "Altıntaş Mah",
      "Apaklar Mah",
      "Arslanlı Mah",
      "Aşağıörencik Mah",
      "Aşağıyakacık Mah",
      "Aydoğdu Mah",
      "Bağcıllı Mah",
      "Bayındır Mah",
      "Beğerli Mah",
      "Bekirler Mah",
      "Bereketli Mah",
      "Bozyurt Mah",
      "Çatak Mah",
      "Çaylı Mah",
      "Çobanlar Mah",
      "Dallıca Mah",
      "Demirciler Mah",
      "Dereağzı Mah",
      "Derebaşı Mah",
      "Dualar Mah",
      "Durasıllı Mah",
      "Esenköy Mah",
      "Esentepe Mah",
      "Eycelli Mah",
      "Gedik Mah",
      "Gedikaltı Mah",
      "Güzelköy Mah",
      "Hamidiye Mah",
      "Hamzallı Mah",
      "Hasköy Mah",
      "Haydarlı Mah",
      "Hisarcık Mah",
      "Işıklar Mah",
      "İsabeyli Mah",
      "İstiklal Mah",
      "Kahvederesi Mah",
      "Karahallı Mah",
      "Kardeşköy Mah",
      "Kaşıkçılar Mah",
      "Kavacık Mah",
      "Kestel Mah",
      "Ketendere Mah",
      "Ketenova Mah",
      "Kırcaklı Mah",
      "Kızıldere Mah",
      "Kocakesik Mah",
      "Kozdere Mah",
      "Kurtuluş Mah",
      "Kuşçular Mah",
      "Mescitli Mah",
      "Ocaklı Mah",
      "Ovacık Mah",
      "Pınarbaşı Mah",
      "Pirlibey Mah",
      "Prof.muammer Aksoy Mah",
      "Rahmanlar Mah",
      "Sailer Mah",
      "Samailli Mah",
      "Sevindikli Mah",
      "Şimşelli Mah",
      "Toygar Mah",
      "Turan Mah",
      "Uzunçam Mah",
      "Yalınkuyu Mah",
      "Yaylapınar Mah",
      "Yazırlı Mah",
      "Yellice Mah",
      "Yeni Mah",
      "Yeni Sanayii Mah",
      "Yeşil Mah",
      "Yıldıztepe Mah",
      "Yukarıörencik Mah",
      "Zafer Mah",
      "Cumhuriyet Mah",
      "Çapahasan Mah",
      "Dumlupınar Mah",
      "Karaçay Mah",
      "Nazilli Osb Mah",
      "Sümer Mah",
      "Şirinevler Mah",
      "Yeşilyurt Mah"
    ],
    "Söke": [
      "Ağaçlı Mah",
      "Akçakaya Mah",
      "Akçakonak Mah",
      "Argavlı Mah",
      "Arslanyaylası Mah",
      "Atatürk Mah",
      "Atburgazı Mah",
      "Avcılar Mah",
      "Avşar Mah",
      "Bağarası Mah",
      "Bayırdamı Mah",
      "Burunköy Mah",
      "Cumhuriyet Mah",
      "Çalıköy Mah",
      "Çalışlı Mah",
      "Çavdar Mah",
      "Çeltikçi Mah",
      "Demirçay Mah",
      "Doğanbey Mah",
      "Fevzipaşa Mah",
      "Gölbent Mah",
      "Güllübahçe Mah",
      "Güneyyaka Mah",
      "Güzeltepe Mah",
      "Karaatlı Mah",
      "Karacahayıt Mah",
      "Karakaya Mah",
      "Kaygıllı Mah",
      "Kemalpaşa Mah",
      "Kisir Mah",
      "Konak Mah",
      "Köprüalan Mah",
      "Nalbantlar Mah",
      "Özbaşı Mah",
      "Pamukçular Mah",
      "Sarıkemer Mah",
      "Savuca Mah",
      "Sayrakçı Mah",
      "Sazlı Mah",
      "Serçin Mah",
      "Sofular Mah",
      "Söke Osb Mah",
      "Tuzburgazı Mah",
      "Yamaç Mah",
      "Yenicamii Mah",
      "Yenidoğan Mah",
      "Yenikent Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yuvaca Mah"
    ],
    "Sultanhisar": [
      "Atça Mah",
      "Beşeylül Mah",
      "Demirhan Mah",
      "Eskihisar Mah",
      "Güvendik Mah",
      "Hisar Mah",
      "İncealan Mah",
      "Kabaca Mah",
      "Kavaklı Mah",
      "Kılavuzlar Mah",
      "Kurtuluş Mah",
      "Malgaçemir Mah",
      "Malgaçmustafa Mah",
      "Rekmez Mah",
      "Salavatlı Mah",
      "Uzunlar Mah",
      "Yağdere Mah",
      "Zafer Mah"
    ],
    "Yenipazar": [
      "Alhan Mah",
      "Alioğullar Mah",
      "Çarşı Mah",
      "Çavdar Mah",
      "Çulhan Mah",
      "Dereköy Mah",
      "Direcik Mah",
      "Doğu Mah",
      "Donduran Mah",
      "Eğridere Mah",
      "Hacıköseler Mah",
      "Hamzabali Mah",
      "Hükümet Mah",
      "Karacaören Mah",
      "Karaçakal Mah",
      "Koyunlar Mah",
      "Paşaköy Mah",
      "Yeni Mah"
    ]
  },
  "Balıkesir": {
    "Altıeylül": [
      "Akarsu Mah",
      "Akçaköy Mah",
      "Altı Eylül Mah",
      "Aslıhan Mah",
      "Aslıhantepeciği Mah",
      "Atköy Mah",
      "Aynaoğlu Mah",
      "Ayşebacı Mah",
      "Ayvatlar Mah",
      "Balıklı Mah",
      "Boğatepe Mah",
      "Büyükbostancı Mah",
      "Cinge Mah",
      "Çandır Mah",
      "Çayırhisar Mah",
      "Çiftlikköy Mah",
      "Dereçiftlik Mah",
      "Dinkçiler Mah",
      "Gaziosmanpaşa Mah",
      "Gaziosmanpaşa Osb Mah",
      "Gaziosmanpaşaosb Mah",
      "Gökçeören Mah",
      "Gökköy Mah",
      "Hacı İlbey Mah",
      "Halalca Mah",
      "İnkaya Mah",
      "Kabaklı Mah",
      "Karakaya Mah",
      "Karaman Mah",
      "Kasaplar Mah",
      "Kesirven Mah",
      "Köseler Mah",
      "Köylü Köyü Mah",
      "Küçükbostancı Mah",
      "Kürse Mah",
      "Nergiz Mah",
      "Orhanlı Mah",
      "Ortamandıra Mah",
      "Ovabayındır Mah",
      "Ovaköy Mah",
      "Paşaköy Mah",
      "Selimiye Mah",
      "Sütlüce Mah",
      "Türkali Mah",
      "Yakupköy Mah",
      "Yenice Mah",
      "Yıldız Mah",
      "Aliağa Mah",
      "Bağalan Mah",
      "Bahçedere Mah",
      "Beşpınar Mah",
      "Çamköy Mah",
      "Çukurhüseyin Mah",
      "Dallımandıra Mah",
      "Dereköy Mah",
      "Ertuğrul Mah",
      "Karakavak Mah",
      "Karamanlar Mah",
      "Kozören Mah",
      "Kutludüğün Mah",
      "Kuyualan Mah",
      "Küpeler Mah",
      "Macarlar Mah",
      "Meryemdere Mah",
      "Sarıalan Mah",
      "Yeşilyurt Mah",
      "1.gündoğan Mah",
      "2.gündoğan Mah",
      "Gümüsçesme Mah",
      "Ataköy Mah",
      "Ayvacık Mah",
      "Bayat Mah",
      "Bereketli Mah",
      "Bozen Mah",
      "Çakıllık Mah",
      "Çınarlıdere Mah",
      "Çiftçidere Mah",
      "Dedeburnu Mah",
      "Dişbudak Mah",
      "Karabeyler Mah",
      "Kılcılar Mah",
      "Kirazköy Mah",
      "Kirazpınar Mah",
      "Konakpınar Mah",
      "Kozderegüvem Mah",
      "Kuşkaya Mah",
      "Sıvatpınar Mah",
      "Taşköy Mah",
      "Taşpınar Mah",
      "Tayyipler Mah",
      "Turnalar Mah",
      "Yeşiller Mah",
      "Pamukçu Mah",
      "Bahçelievler Mah",
      "Hasan Basri Çantay Mah",
      "Plevne Mah"
    ],
    "Ayvalık": [
      "Mithatpaşa Mah",
      "Namık Kemal Mah",
      "Altınova Mah",
      "150 Evler Mah",
      "Akçapınar Mah",
      "Ali Çetinkaya Mah",
      "Bağyüzü Mah",
      "Beşiktepe Mah",
      "Bulutçeşme Mah",
      "Çakmak Mah",
      "Çamoba Mah",
      "Fethiye Mah",
      "Fevzipaşa-vehbibey Mah",
      "Gazi Kemal Paşa Mah",
      "Hacıveliler Mah",
      "Hamdibey Mah",
      "Hayrettinpaşa Mah",
      "İsmetpaşa Mah",
      "Karaayıt Mah",
      "Kazım Karabekir Mah",
      "Kırcalar Mah",
      "Murateli Mah",
      "Mutlu Mah",
      "Odaburnu Mah",
      "Sahil Kent Mah",
      "Sakarya Mah",
      "Sefa Çamlık Mah",
      "Tıfıllar Mah",
      "Türközü Mah",
      "Üçkabaağaç Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Zekibey Mah",
      "Küçükköy Mah"
    ],
    "Balya": [
      "Enverpaşa Mah",
      "Koca Camii Mah",
      "Akbaş Mah",
      "Alidemirci Mah",
      "Bengiler Mah",
      "Çakallar Mah",
      "Çalova Mah",
      "Çamavşar Mah",
      "Çamucu Mah",
      "Çarmık Mah",
      "Çiğdem Mah",
      "Çukurcak Mah",
      "Danişment Mah",
      "Değirmendere Mah",
      "Dereköy Mah",
      "Doğanlar Mah",
      "Farsak Mah",
      "Gökmusa Mah",
      "Göktepe Mah",
      "Göloba Mah",
      "Habipler Mah",
      "Hacıhüseyin Mah",
      "Havutbaşı Mah",
      "Ilıca Mah",
      "Kadıköy Mah",
      "Karacahisar Mah",
      "Karlık Mah",
      "Kaşıkçı Mah",
      "Kavakalanı Mah",
      "Kayalar Mah",
      "Kayapınar Mah",
      "Kocabük Mah",
      "Koyuneri Mah",
      "Mancılık Mah",
      "Medrese Mah",
      "Müstecap Mah",
      "Narlı Mah",
      "Orhanlar Mah",
      "Örenköy Mah",
      "Patlak Mah",
      "Semizköy Mah",
      "Söbücealan Mah",
      "Yarışalanı Mah",
      "Yaylacık Mah",
      "Yazlık Mah",
      "Yenikavak Mah"
    ],
    "Bandırma": [
      "Doğa Mah",
      "Ergili Mah",
      "Kirazlı Mah",
      "Kuşcenneti Mah",
      "Yeşilçomlu Mah",
      "100.yıl Mah",
      "17 Eylül Mah",
      "600 Evler Mah",
      "Aksakal Mah",
      "Ayyıldız Mah",
      "Bentbaşı Mah",
      "Çalışkanlar Mah",
      "Çınarlı Mah",
      "Dere Mah",
      "Edincik Mah",
      "Günaydın Mah",
      "Hacı Yusuf Mah",
      "Haydar Çavuş Mah",
      "İhsaniye Mah",
      "Karaçalılık Mah",
      "Kayacık Mah",
      "Levent Mah",
      "Paşabayır Mah",
      "Paşakent Mah",
      "Paşakonak Mah",
      "Paşamescit Mah",
      "Sunullah Mah",
      "Yeni Mah",
      "Akçapınar Mah",
      "Bereketli Mah",
      "Çakılköy Mah",
      "Dedeoba Mah",
      "Doğruca Mah",
      "Dutliman Mah",
      "Emre Mah",
      "Erikli Mah",
      "Eskiziraatli Mah",
      "Mahbubeler Mah",
      "Ömerli Mah",
      "Yenice Mah",
      "Yenisığırcı Mah",
      "Yeniyenice Mah",
      "Yeniziraatli Mah",
      "Beyköy Mah",
      "Bezirci Mah",
      "Çarıkköy Mah",
      "Çepni Mah",
      "Çinge Mah",
      "Doğanpınar Mah",
      "Gölyaka Mah",
      "Hıdırköy Mah",
      "Külefli Mah",
      "Misakça Mah",
      "Orhaniye Mah",
      "Şirinçavuş Mah"
    ],
    "Bigadiç": [
      "4 Eylül Mah",
      "Abacı Mah",
      "Camii Mah",
      "Çavuş Mah",
      "Emek Mah",
      "Fethibey Mah",
      "Kuyu Mah",
      "Orta Mah",
      "Servi Mah",
      "Akyar Mah",
      "Başçeşme Mah",
      "Çağış Mah",
      "Çömlekçi Mah",
      "Değirmenli Mah",
      "Esenli Mah",
      "Güvemçetmi Mah",
      "Küçükyeniköy Mah",
      "Yeşildere Mah",
      "Adalı Mah",
      "Alanköy Mah",
      "Altınlar Mah",
      "Aşağıçamlı Mah",
      "Aşağıgöcek Mah",
      "Babaköy Mah",
      "Bademli Mah",
      "Balatlı Mah",
      "Beğendikler Mah",
      "Bekirler Mah",
      "Bozbük Mah",
      "Çamköy Mah",
      "Çayüstü Mah",
      "Çekirdekli Mah",
      "Çeribaşı Mah",
      "Çıtak Mah",
      "Davutça Mah",
      "Davutlar Mah",
      "Dedeçınar Mah",
      "Dere Çerkes Mah",
      "Dikkonak Mah",
      "Doğançam Mah",
      "Durasılar Mah",
      "Dündarcık Mah",
      "Elyapan Mah",
      "Emirler Mah",
      "Hacıömerderesi Mah",
      "Hamidiye Mah",
      "Hisarköy Mah",
      "Işıklar Mah",
      "İğciler Mah",
      "İlyaslar Mah",
      "İskeleköy Mah",
      "Kadıköy Mah",
      "Kalafat Mah",
      "Karabahçe Mah",
      "Kargın Mah",
      "Kayalıdere Mah",
      "Kayırlar Mah",
      "Kırca Mah",
      "Kızılçukur Mah",
      "Kozpınar Mah",
      "Köseler Mah",
      "Kürsü Mah",
      "Mecidiye Mah",
      "Meyvalı Mah",
      "Okçular Mah",
      "Okçularyeri Mah",
      "Osmanca Mah",
      "Özgören Mah",
      "Panayır Mah",
      "Salmanlı Mah",
      "Topalak Mah",
      "Tozağan Mah",
      "Turfullar Mah",
      "Yağcıbedir Mah",
      "Yağcılar Mah",
      "Yeniköy Mah",
      "Yolbaşı Mah",
      "Yukarıçamlı Mah",
      "Yukarıgöçek Mah",
      "Yürücekler Mah"
    ],
    "Burhaniye": [
      "Bahçelievler Mah",
      "Geriş Mah",
      "Hacıahmet Mah",
      "İskele Mah",
      "Kocacami Mah",
      "Mahkeme Mah",
      "Memiş Mah",
      "Öğretmenler Mah",
      "Ören Mah",
      "Yunus Mah",
      "Ağacık Mah",
      "Ali Çetinkaya Mah",
      "Avunduk Mah",
      "Bahadınlı Mah",
      "Börezli Mah",
      "Çallı Mah",
      "Çamtepe Mah",
      "Çoruk Mah",
      "Damlalı Mah",
      "Dutluca Mah",
      "Hacıbozlar Mah",
      "Hisarköy Mah",
      "Karadere Mah",
      "Kırtık Mah",
      "Kızıklı Mah",
      "Kurucaoluk Mah",
      "Kuyucak Mah",
      "Kuyumcu Mah",
      "Pelitköy Mah",
      "Sübeylidere Mah",
      "Şahinler Mah",
      "Şarköy Mah",
      "Şarköy Osb Mah",
      "Tahtacı Mah",
      "Taylıeli Mah",
      "Yabancılar Mah",
      "Yaylacık Mah",
      "Yunuslar Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah"
    ],
    "Dursunbey": [
      "Bozyokuş Mah",
      "Cebeci Mah",
      "Çakmak Mah",
      "Çiftçi Mah",
      "Ferah Mah",
      "İstasyon Mah",
      "Mollaoğlu Mah",
      "Üçeylül Mah",
      "Vakıf Mah",
      "Adaören Mah",
      "Akbaşlar Mah",
      "Akçagüney Mah",
      "Akyayla Mah",
      "Alaçam Mah",
      "Alagüney Mah",
      "Arıklar Mah",
      "Aşağımusalar Mah",
      "Aşağıyağcılar Mah",
      "Ayvacık Mah",
      "Aziziye Mah",
      "Bayıryüzügüney Mah",
      "Beyce Mah",
      "Beyel Mah",
      "Boyalıca Mah",
      "Büyükakçaalan Mah",
      "Çakırca Mah",
      "Çaltıcak Mah",
      "Çamharman Mah",
      "Çamköy Mah",
      "Çanakçı Mah",
      "Çatalçam Mah",
      "Çelikler Mah",
      "Çınarköy Mah",
      "Dada Mah",
      "Değirmenciler Mah",
      "Delice Mah",
      "Demirciler Mah",
      "Dereköy Mah",
      "Doğancılar Mah",
      "Durabeyler Mah",
      "Ericek Mah",
      "Gazellidere Mah",
      "Göbül Mah",
      "Gökçedağ Mah",
      "Gökçepınar Mah",
      "Gölcük Mah",
      "Güğü Mah",
      "Gürleyen Mah",
      "Hacıahmetpınarı Mah",
      "Hacılar Mah",
      "Hacıömerler Mah",
      "Hamzacık Mah",
      "Hasanlar Mah",
      "Hindikler Mah",
      "Hondular Mah",
      "Hopanlar Mah",
      "Işıklar Mah",
      "İrfaniye Mah",
      "İsmailler Mah",
      "Karagöz Mah",
      "Karakaya Mah",
      "Karamanlar Mah",
      "Karapınar Mah",
      "Kardeşler Mah",
      "Karyağmaz Mah",
      "Kavacık Mah",
      "Kavakköy Mah",
      "Kazimiye Mah",
      "Kızılcadere Mah",
      "Kızılöz Mah",
      "Kireç Mah",
      "Kumlu Mah",
      "Kurtlar Mah",
      "Kuzköy Mah",
      "Küçükakçaalan Mah",
      "Küçükler Mah",
      "Mahmudiye Mah",
      "Mahmutça Mah",
      "Meydançayırı Mah",
      "Mıcırlar Mah",
      "Naipler Mah",
      "Odaköy Mah",
      "Osmaniye Mah",
      "Örenköy Mah",
      "Poyracık Mah",
      "Ramazanlar Mah",
      "Resüller Mah",
      "Reşadiye Mah",
      "Saçayak Mah",
      "Sağırlar Mah",
      "Sakızköy Mah",
      "Sarısipahiler Mah",
      "Sarnıçköy Mah",
      "Sebiller Mah",
      "Selimağa Mah",
      "Sinderler Mah",
      "Süleler Mah",
      "Şabanlar Mah",
      "Şenköy Mah",
      "Tafak Mah",
      "Taşkesiği Mah",
      "Taşpınar Mah",
      "Tepeköy Mah",
      "Tezlik Mah",
      "Turnacık Mah",
      "Umurlar Mah",
      "Veliler Mah",
      "Yassıören Mah",
      "Yukarımusalar Mah",
      "Yukarıyağcılar Mah",
      "Yunuslar Mah"
    ],
    "Edremit": [
      "Akçay Mah",
      "Altınkum Mah",
      "Çamlıbel Mah",
      "Doyran Mah",
      "Güre Cumhuriyet Mah",
      "Güre Mah",
      "İkizçay Mah",
      "Kavlaklar Mah",
      "Kızılkeçili Mah",
      "Narlı Mah",
      "Sarıkız Mah",
      "Tahtakuşlar Mah",
      "Altınoluk Mah",
      "Arıtaşı Mah",
      "Avcılar Mah",
      "İskele Mah",
      "Şahindere Mah",
      "Atatürk Mah",
      "Beyoba Mah",
      "Bostancı Mah",
      "Camivasat Mah",
      "Cennetayağı Mah",
      "Cumhuriyet Mah",
      "Çamcı Mah",
      "Çıkrıkçı Mah",
      "Darsofa Mah",
      "Dereli Mah",
      "Eroğlan Mah",
      "Gazicelal Mah",
      "Gaziilyas Mah",
      "Hacıarslanlar Mah",
      "Hacıtuğrul Mah",
      "Hamidiye Mah",
      "Hekimzade Mah",
      "İbrahimce Mah",
      "Kadıköy Mah",
      "Kapıcıbaşı Mah",
      "Mehmetalan Mah",
      "Ortaoba Mah",
      "Pınarbaşı Mah",
      "Soğanyemez Mah",
      "Turhanbey Mah",
      "Tuzcumurat Mah",
      "Yaşyer Mah",
      "Yaylaönü Mah",
      "Yolören Mah",
      "Zeytinli Mah"
    ],
    "Erdek": [
      "Aşağıyapıcı Mah",
      "Ballıpınar Mah",
      "Belkıs Mah",
      "Çeltikçi Mah",
      "Doğanlar Mah",
      "Hamamlı Mah",
      "İlhan Mah",
      "Kestanelik Mah",
      "Ormanlı Mah",
      "Şahinburgaz Mah",
      "Tatlısu Mah",
      "Turan Mah",
      "Yukarıyapıcı Mah",
      "Alaettin Mah",
      "Atatürk Mah",
      "Balıklı Mah",
      "Çakıl Mah",
      "Halitpaşa Mah",
      "Harmanlı Mah",
      "Karşıyaka Mah",
      "Narlı Mah",
      "Ocaklar Mah",
      "Paşalimanı Mah",
      "Poyrazlı Mah",
      "Sahil Mah",
      "Tuzla Mah",
      "Yalı Mah",
      "Zeytinli Mah"
    ],
    "Gömeç": [
      "Dursunlu Mah",
      "Hacıhüseyinler Mah",
      "Hacıoğlu Mah",
      "Hacıosman Mah",
      "Keremköy Mah",
      "Kobaşlar Mah",
      "Kumgedik Mah",
      "Kuyualan Mah",
      "Ulubeyler Mah",
      "Kemalpaşa Mah",
      "Mithatpaşa Mah",
      "Yaya Mah",
      "Karaağaç Mah"
    ],
    "Gönen": [
      "100.yıl Mah",
      "Akçaali Mah",
      "Altay Mah",
      "Balcı Mah",
      "Gündoğdu Mah",
      "Karşıyaka Mah",
      "Kurtuluş Mah",
      "Malkoç Mah",
      "Plevne Mah",
      "Reşadiye Mah",
      "Rüstem Mah",
      "Sarıköy Mah",
      "Sebepli Mah",
      "Söğüt Mah",
      "Tırnova Mah",
      "Tuzakçı Mah",
      "Akçapınar Mah",
      "Alacaoluk Mah",
      "Alaettin Mah",
      "Alaşar Mah",
      "Asmalıdere Mah",
      "Atıcıoba Mah",
      "Babayaka Mah",
      "Bakırlı Mah",
      "Balcıdede Mah",
      "Bayramiç Mah",
      "Beyoluk Mah",
      "Bostancı Mah",
      "Buğdaylı Mah",
      "Büyüksoğuklar Mah",
      "Canbaz Mah",
      "Çakmak Mah",
      "Çalıca Mah",
      "Çalıoba Mah",
      "Çatak Mah",
      "Çınarlı Mah",
      "Çınarpınar Mah",
      "Çiftlikalan Mah",
      "Çobanhamidiye Mah",
      "Dumanalan Mah",
      "Ekşidere Mah",
      "Fındıklı Mah",
      "Gaybular Mah",
      "Gökçesu Mah",
      "Güneşli Mah",
      "Hacımenteş Mah",
      "Hacıvelioba Mah",
      "Hasanbey Mah",
      "Ilıcak Mah",
      "Ilıcaoba Mah",
      "İncirli Mah",
      "Kalburcu Mah",
      "Kalfaköy Mah",
      "Kaplanoba Mah",
      "Karaağaçalan Mah",
      "Karalarçiftliği Mah",
      "Karasukabaklar Mah",
      "Kavakoba Mah",
      "Keçeler Mah",
      "Killik Mah",
      "Kocapınar Mah",
      "Koçbayır Mah",
      "Korudeğirmen Mah",
      "Körpeağaç Mah",
      "Köteyli Mah",
      "Kumköy Mah",
      "Küçüksoğuklar Mah",
      "Küpçıktı Mah",
      "Muratlar Mah",
      "Ortaoba Mah",
      "Osmanpazar Mah",
      "Ömerler Mah",
      "Paşaçiftlik Mah",
      "Pehlivanhoca Mah",
      "Saraçlar Mah",
      "Suçıktı Mah",
      "Şaroluk Mah",
      "Taştepe Mah",
      "Tütüncü Mah",
      "Üçpınar Mah",
      "Üzümlü Mah",
      "Yeniakçapınar Mah",
      "Yürükkeçidere Mah",
      "Armutlu Mah",
      "Ayvalıdere Mah",
      "Çığmış Mah",
      "Çifteçeşmeler Mah",
      "Dereköy Mah",
      "Dışbudak Mah",
      "Gebeçınar Mah",
      "Gelgeç Mah",
      "Geyikli Mah",
      "Gündoğan Mah",
      "Hafızhüseyinbey Mah",
      "Havutça Mah",
      "Hodul Mah",
      "Kavakalan Mah",
      "Kınalar Mah",
      "Tahtalı Mah",
      "Turplu Mah",
      "Ulukır Mah"
    ],
    "Havran": [
      "Camiikebir Mah",
      "Çiğitzade Mah",
      "Ebubekir Mah",
      "Hamambaşı Mah",
      "Mescit Mah",
      "Tekke Mah",
      "Yeni Mah",
      "Büyükdere Mah",
      "Büyükşapçı Mah",
      "Çakırdere Mah",
      "Çakmak Mah",
      "Çamdibi Mah",
      "Dereören Mah",
      "Eğmir Mah",
      "Eseler Mah",
      "Fazlıca Mah",
      "Halılar Mah",
      "Hallaçlar Mah",
      "Hüseyinbeşeler Mah",
      "İnönü Mah",
      "Kalabak Mah",
      "Karalar Mah",
      "Karaoğlanlar Mah",
      "Kobaklar Mah",
      "Kocadağ Mah",
      "Kocaseyit Mah",
      "Köylüce Mah",
      "Küçükdere Mah",
      "Küçükşapçı Mah",
      "Sarnıç Mah",
      "Tarlabaşı Mah",
      "Taşarası Mah",
      "Temaşalık Mah",
      "Tepeoba Mah"
    ],
    "İvrindi": [
      "Büyükyenice Mah",
      "Gökçeyazı Mah",
      "7 Eylül Mah",
      "Bedrettin Mah",
      "Kurtuluş Mah",
      "Sakarya Mah",
      "Kayapa Mah",
      "Korucu Mah",
      "Akçal Mah",
      "Aşağıkaleoba Mah",
      "Ayaklı Mah",
      "Bozören Mah",
      "Büyükfındık Mah",
      "Büyükılıca Mah",
      "Çarkacı Mah",
      "Çatalan Mah",
      "Çelimler Mah",
      "Çiçekli Mah",
      "Çobanlar Mah",
      "Çukurlar Mah",
      "Çukuroba Mah",
      "Değirmenbaşı Mah",
      "Demirciler Mah",
      "Döşeme Mah",
      "Erdel Mah",
      "Eriklikömürcü Mah",
      "Evciler Mah",
      "Gebeçınar Mah",
      "Geçmiş Mah",
      "Gökçeler Mah",
      "Gömeniç Mah",
      "Gözlüçayır Mah",
      "Gümeli Mah",
      "Hacıahmetler Mah",
      "Haydar Mah",
      "Hüseyinbeyobası Mah",
      "Ilıcakpınar Mah",
      "İkizce Mah",
      "Karaçepiş Mah",
      "Kaşağıl Mah",
      "Kılcılar Mah",
      "Kına Mah",
      "Kınık Mah",
      "Kıpıklar Mah",
      "Kışladere Mah",
      "Kiraz Ören Mah",
      "Kocaeli Mah",
      "Kocaoba Mah",
      "Kuşdere Mah",
      "Küçükfındık Mah",
      "Küçükılıca Mah",
      "Küçükyenice Mah",
      "Mallıca Mah",
      "Okçular Mah",
      "Osmanköy Mah",
      "Osmanlar Mah",
      "Pelitören Mah",
      "Sarıca Mah",
      "Sarıpınar Mah",
      "Sofular Mah",
      "Soğanbükü Mah",
      "Susuzyayla Mah",
      "Taşdibi Mah",
      "Topuzlar Mah",
      "Yağlılar Mah",
      "Yaren Mah",
      "Yeşilköy Mah",
      "Yukarıkaleoba Mah",
      "Yürekli Mah"
    ],
    "Karesi": [
      "1.oruçgazi Mah",
      "2.oruçgazi Mah",
      "Ali Hikmet Paşa Mah",
      "Atatürk Mah",
      "Ege Mah",
      "Maltepe Mah",
      "Paşa Alanı Mah",
      "Toygar Mah",
      "Yeni Mah",
      "Adnan Menderes Mah",
      "Akıncılar Mah",
      "Aktarma Mah",
      "Aygören Mah",
      "Bakacak Mah",
      "Beyköy Mah",
      "Çanacık Mah",
      "Çaypınar Mah",
      "Davutlar Mah",
      "Deliklitaş Mah",
      "Dumlupınar Mah",
      "Eski Kuyumcular Mah",
      "Hacı İsmail Mah",
      "Hisariçi Mah",
      "İbirler Mah",
      "Kabakdere Mah",
      "Kalaycılar Mah",
      "Kamçıllı Mah",
      "Karaoğlan Mah",
      "Karesi Mah",
      "Kavaklı Mah",
      "Kırmızılar Mah",
      "Kızpınar Mah",
      "Kocaavşar Mah",
      "Köteyli Mah",
      "Mirzabey Mah",
      "Naipli Mah",
      "Ortaca Mah",
      "Ovacık Mah",
      "Turplu Mah",
      "Üçpınar Mah",
      "Yaylabayır Mah",
      "Yeniköy Mah",
      "Yeroluk Mah",
      "Yeşilova Mah",
      "Yıldırım Mah",
      "Ziyaretli Mah",
      "1.sakarya Mah",
      "2.sakarya Mah",
      "Çay Mah",
      "Kayabey Mah",
      "Kuva-i Milliye Mah",
      "Vicdaniye Mah",
      "Alacabayır Mah",
      "Armutalan Mah",
      "Boğazköy Mah",
      "Büyükpınar Mah",
      "Düzoba Mah",
      "Fethiye Mah",
      "Halkapınar Mah",
      "Hisaralan Mah",
      "Karabeyler Mah",
      "Karakol Mah",
      "Kurtdere Mah",
      "Şamlı Mah",
      "Taşkesiği Mah",
      "Tatlıpınar Mah",
      "Toybelen Mah",
      "Yağcılar Mah",
      "Yaylacık Mah",
      "Yeniiskender Mah"
    ],
    "Kepsut": [
      "Camiiatik Mah",
      "Camiicedit Mah",
      "İhsaniye Mah",
      "Kasapzade Mah",
      "Mahkeme Mah",
      "Yenice Mah",
      "Ahmetölen Mah",
      "Akçakertil Mah",
      "Akçaköy Mah",
      "Alagüney Mah",
      "Armutlu Mah",
      "Bağtepe Mah",
      "Bektaşlar Mah",
      "Beyköy Mah",
      "Bükdere Mah",
      "Büyükkatrancı Mah",
      "Çalkandil Mah",
      "Dalköy Mah",
      "Danahisar Mah",
      "Darıçukuru Mah",
      "Dedekaşı Mah",
      "Dereli Mah",
      "Dombaydere Mah",
      "Durak Mah",
      "Eşeler Mah",
      "Eyüpbükü Mah",
      "Göbel Mah",
      "Gökköy Mah",
      "Hotaşlar Mah",
      "Işıklar Mah",
      "İsaalan Mah",
      "Kalburcu Mah",
      "Karacaağaç Mah",
      "Karacaören Mah",
      "Karaçaltı Mah",
      "Karagöz Mah",
      "Karahaliller Mah",
      "Kayacıklar Mah",
      "Kayaeli Mah",
      "Keçidere Mah",
      "Kepekler Mah",
      "Kızıloluk Mah",
      "Küçükkatrancı Mah",
      "Mahmudiye Mah",
      "Mehmetler Mah",
      "Mestanlar Mah",
      "Mezitler Mah",
      "Nusret Mah",
      "Osmaniye Mah",
      "Ovacık Mah",
      "Örencik Mah",
      "Örenharman Mah",
      "Örenli Mah",
      "Piyade Mah",
      "Recep Mah",
      "Saraç Mah",
      "Sarıçayır Mah",
      "Sarıfakılar Mah",
      "Sayacık Mah",
      "Seçdere Mah",
      "Serçeören Mah",
      "Servet Mah",
      "Şeremetler Mah",
      "Tekkeışıklar Mah",
      "Tilkicik Mah",
      "Tuzak Mah",
      "Yaylabaşı Mah",
      "Yeşildağ Mah",
      "Yoğunoluk Mah"
    ],
    "Manyas": [
      "Akçaova Mah",
      "Boğazpınar Mah",
      "Bölceağaç Mah",
      "Cumhuriyet Mah",
      "Çakırca Mah",
      "Çal Mah",
      "Çamlı Mah",
      "Çataltepe Mah",
      "Çavuşköy Mah",
      "Darıca Mah",
      "Değirmenboğazı Mah",
      "Dereköy Mah",
      "Doğancı Mah",
      "Dura Mah",
      "Erecek Mah",
      "Eskiçatal Mah",
      "Eskimanyas Mah",
      "Eşen Mah",
      "Hacıibrahimpınarı Mah",
      "Hacıosman Mah",
      "Hacıyakup Mah",
      "Hamamlı Mah",
      "Haydar Mah",
      "Hekim Mah",
      "Işıklar Mah",
      "İrşadiye Mah",
      "Kalfa Mah",
      "Kapaklı Mah",
      "Karakabaağaç Mah",
      "Kayaca Mah",
      "Kızık Mah",
      "Kızıksa Mah",
      "Kocagöl Mah",
      "Koçoğlu Mah",
      "Kubaş Mah",
      "Kulak Mah",
      "Necip Mah",
      "Ören Mah",
      "Peynirkuyu Mah",
      "Salur Mah",
      "Süleymanlı Mah",
      "Şevketiye Mah",
      "Tepecik Mah",
      "Yayla Mah",
      "Yeniköy Mah",
      "Atatürk Mah",
      "Çarşı Mah",
      "Kalebayır Mah",
      "Maltepe Mah",
      "Yeni Mah"
    ],
    "Marmara": [
      "Ekinlik Mah",
      "Abroz Mah",
      "Asmalı Mah",
      "Avşa Mah",
      "Cumhuriyet Mah",
      "Çınarlı Mah",
      "Deniz Mah",
      "Gündoğdu Mah",
      "Hürriyet Mah",
      "Okullar Mah",
      "Saraylar Mah",
      "Topağaç Mah",
      "Yeni Mah",
      "Yiğitler Mah"
    ],
    "Savaştepe": [
      "Akpınar Mah",
      "Ardıçlı Mah",
      "Aşağıdanişment Mah",
      "Beyköy Mah",
      "Bozalan Mah",
      "Çaltılı Mah",
      "Çamurlu Mah",
      "Çavlı Mah",
      "Çiftlikdere Mah",
      "Çukurçayır Mah",
      "Deveören Mah",
      "Dikmeler Mah",
      "Eğerci Mah",
      "Güvem Mah",
      "Güvemküçüktarla Mah",
      "Hıdırbalı Mah",
      "İsadere Mah",
      "Kalemköy Mah",
      "Karacalar Mah",
      "Karaçam Mah",
      "Karapınar Mah",
      "Kocabıyıklar Mah",
      "Kocaören Mah",
      "Koğukyurt Mah",
      "Kongurca Mah",
      "Kurudere Mah",
      "Mecidiye Mah",
      "Minnetler Mah",
      "Pelitcik Mah",
      "Sarıbeyler Mah",
      "Sarısüleymanlar Mah",
      "Sıtmapınar Mah",
      "Soğucak Mah",
      "Söğütçük Mah",
      "Söğütlügözle Mah",
      "Tavşancık Mah",
      "Türediler Mah",
      "Yazören Mah",
      "Yeşilhisar Mah",
      "Yolcupınarı Mah",
      "Yukarıdanişment Mah",
      "Yukarıkaraçam Mah",
      "Yunakdere Mah",
      "Esenköy Mah",
      "Madenmezarı Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Zafer Mah"
    ],
    "Sındırgı": [
      "Akçakısrak Mah",
      "Aktaş Mah",
      "Alacaatlı Mah",
      "Alakır Mah",
      "Alayaka Mah",
      "Armutlu Mah",
      "Aslandede Mah",
      "Bayraklı Mah",
      "Bulak Mah",
      "Bükrecik Mah",
      "Büyükdağdere Mah",
      "Cüneyt Mah",
      "Çakıllı Mah",
      "Çaltılı Mah",
      "Çamalanı Mah",
      "Çaygören Mah",
      "Çayır Mah",
      "Çelebiler Mah",
      "Çıkrıkçı Mah",
      "Çılbırcı Mah",
      "Çoturtepe Mah",
      "Danaçayır Mah",
      "Dedeler Mah",
      "Derecikören Mah",
      "Devletlibaba Mah",
      "Düğüncüler Mah",
      "Düvertepe Mah",
      "Eğridere Mah",
      "Emendere Mah",
      "Eşmedere Mah",
      "Gölcük Mah",
      "Gözören Mah",
      "Hisaralan Mah",
      "Işıklar Mah",
      "İbiller Mah",
      "İzzettin Mah",
      "Karaağaç Mah",
      "Karacalar Mah",
      "Karagür Mah",
      "Karakaya Mah",
      "Kepez Mah",
      "Kertil Mah",
      "Kınık Mah",
      "Kıranköy Mah",
      "Kızılgür Mah",
      "Kocabey Mah",
      "Kocasinan Mah",
      "Kozlu Mah",
      "Küçükbükü Mah",
      "Küçükdağdere Mah",
      "Kürendere Mah",
      "Mandıra Mah",
      "Mumcuköy Mah",
      "Ormaniçi Mah",
      "Osmanlar Mah",
      "Pelitören Mah",
      "Pürsünler Mah",
      "Sinandede Mah",
      "Süller Mah",
      "Şahinkaya Mah",
      "Şapçı Mah",
      "Taşköy Mah",
      "Umurlar Mah",
      "Yaylabayır Mah",
      "Yaylacık Mah",
      "Yolcupınar Mah",
      "Yusufçamı Mah",
      "Yüreğil Mah",
      "Camicedit Mah",
      "Camikebir Mah",
      "Çavdaroğlu Mah",
      "Kocakonak Mah",
      "Kurtuluş Mah",
      "Rızaiye Mah",
      "Yağcıbedir Mah"
    ],
    "Susurluk": [
      "Beyköy Mah",
      "Ilıcaboğazı Mah",
      "Kepekler Mah",
      "Muradiye Mah",
      "Okçugöl Mah",
      "Söve Mah",
      "Ümiteli Mah",
      "Alibey Mah",
      "Asmalıdere Mah",
      "Aziziye Mah",
      "Babaköy Mah",
      "Balıklıdere Mah",
      "Bozen Mah",
      "Buzağılık Mah",
      "Danaveli Mah",
      "Demirkapı Mah",
      "Dereköy Mah",
      "Duman Mah",
      "Ekinlik Mah",
      "Eminpınarı Mah",
      "Göbel Mah",
      "Gökçeağaç Mah",
      "Gökçedere Mah",
      "Günaydın Mah",
      "Gürece Mah",
      "İclaliye Mah",
      "Kalfaköy Mah",
      "Karaköy Mah",
      "Karapürçek Mah",
      "Kayalıdere Mah",
      "Kayıkçı Mah",
      "Kiraz Mah",
      "Kocapınar Mah",
      "Kulat Mah",
      "Kurucaoluk Mah",
      "Odalıdam Mah",
      "Ömerköy Mah",
      "Paşaköy Mah",
      "Reşadiye Mah",
      "Söğütçayır Mah",
      "Sultançayır Mah",
      "Sülecek Mah",
      "Şeker Mah",
      "Yağcı Mah",
      "Yahyaköy Mah",
      "Yaylaçayır Mah",
      "Yıldız Mah",
      "Burhaniye Mah",
      "Han Mah",
      "Karşıyaka Mah",
      "Kışla Mah",
      "Orta Mah",
      "Sultaniye Mah",
      "Yeni Mah"
    ]
  },
  "Bilecik": {
    "Bozüyük": [
      "4 Eylül Mah",
      "Akpınar Mah",
      "Çarşı Mah",
      "İçköy Mah",
      "Kasımpaşa Mah",
      "Tekke Mah",
      "Yediler Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yeşilkent Mah",
      "Camiliyayla Köyü",
      "Çokçapınar Köyü",
      "Dombayçayırı Köyü",
      "Düzağaç Köyü",
      "Eceköy Köyü",
      "Erikli Köyü",
      "Gökçeli Köyü",
      "Göynücek Köyü",
      "Karaçayır Köyü",
      "Ketenlik Köyü",
      "Mehmet Akif Mah (dodurga Beldesi)",
      "Merkez Mah (cihangazi Köyü)",
      "Mithatpaşa Mah (dodurga Beldesi)",
      "Namık Kemal Mah (dodurga Beldesi)",
      "Osmaniye Köyü",
      "Yenidodurga Köyü",
      "Yeniüreğil Köyü",
      "Yeşilçukurca Köyü",
      "Ziya Gökalp Mah (dodurga Beldesi)",
      "Akçapınar Köyü",
      "Aksutekke Köyü",
      "Alibeydüzü Köyü",
      "Aşağıarmutlu Köyü",
      "Bozalan Köyü",
      "Çamyayla Köyü",
      "Çaydere Köyü",
      "Darıdere Köyü",
      "Delielmacık Köyü",
      "Dübekli Köyü",
      "Düzdağ Köyü",
      "Günyarık Köyü",
      "Hamidiye Köyü",
      "Kandilli Köyü",
      "Kapanalan Köyü",
      "Karaağaç Köyü",
      "Karabayır Köyü",
      "Kızılcapınar Köyü",
      "Kızıltepe Köyü",
      "Kovalıca Köyü",
      "Kozpınar Köyü",
      "Kuyupınar Köyü",
      "Metristepe Köyü",
      "Muratdere Köyü",
      "Nanedere Mah (düzdağ Köyü)",
      "Ormangüzle Köyü",
      "Poyra Köyü",
      "Poyra Mah (poyra Köyü)",
      "Poyraosb Mah (poyra Köyü)",
      "Revnak Köyü",
      "Saraycık Köyü",
      "Yeniçepni Köyü"
    ],
    "Gölpazarı": [
      "Bahçelievler Mah",
      "İsmetpaşa Mah",
      "İstiklal Mah",
      "Orta Mah",
      "Reşadiye Mah",
      "Akçakavak Köyü",
      "Akçaöküz Mah (alıç Köyü)",
      "Aktaş Köyü",
      "Alıç Köyü",
      "Arıcaklar Köyü",
      "Armutçuk Köyü",
      "Bağışlar Mah (kavak Köyü)",
      "Bahçelievler Mah (çımışkı Köyü)",
      "Baltalı Köyü",
      "Bayat Köyü",
      "Bedi Köyü",
      "Bolatlı Köyü",
      "Bostancılar Mah (incirli Köyü)",
      "Büyükbelen Köyü",
      "Büyüksusuz Köyü",
      "Büyüksürmeli Köyü",
      "Cansızlar Mah (sarıhacılar Köyü)",
      "Çengeller Köyü",
      "Çımışkı Köyü",
      "Çiftlik Köyü",
      "Çukurören Köyü",
      "Demirhanlar Köyü",
      "Derecikören Köyü",
      "Dereli Köyü",
      "Doğancılar Köyü",
      "Dokuz Köyü",
      "Dumanlar Mah (kümbet Köyü)",
      "Elmümin Mah (alıç Köyü)",
      "Gemici Mah (demirhanlar Köyü)",
      "Gökçeler Köyü",
      "Gökçeözü Köyü",
      "Göldağı Köyü",
      "Gözaçanlar Köyü",
      "Hacıdurmuşlar Mah (köprücek Köyü)",
      "Hacıköy Köyü",
      "Hamidiye Köyü",
      "İncirli Köyü",
      "Karaağaç Köyü",
      "Karaahmetler Köyü",
      "Karacalar Köyü",
      "Kasımlar Köyü",
      "Keskin Köyü",
      "Köprücek Mah (köprücek Köyü)",
      "Kurşunlu Köyü",
      "Kuşçuören Köyü",
      "Küçüksusuz Köyü",
      "Küçükyenice Köyü",
      "Kümbet Köyü",
      "Muratlar Mah (kavak Köyü)",
      "Neçinler Mah (softalar Köyü)",
      "Ormancılar Mah (kavak Köyü)",
      "Sarıhacılar Köyü",
      "Seyfiler Mah (taşçıahiler Köyü)",
      "Softalar Köyü",
      "Söğütcük Köyü",
      "Şahinler Köyü",
      "Şıhlar Mah (kavak Köyü)",
      "Taşçıahiler Mah (taşçıahiler Köyü)",
      "Tongurlar Köyü",
      "Türkmen Köyü",
      "Urgancılar Mah (tongurlar Köyü)",
      "Üyük Köyü",
      "Yağcı Mah (dokuz Köyü)",
      "Yağcılar Mah (kavak Köyü)"
    ],
    "İnhisar": [
      "Akkum Mah",
      "Güner Orbay Mah",
      "Karaağaç Mah",
      "Zafer Mah",
      "Akköy Köyü",
      "Çayköy Köyü",
      "Harmanköy Köyü",
      "Hisarcık Köyü",
      "Koyunlu Köyü",
      "Merkez Mah (tarpak Köyü)",
      "Muratça Köyü",
      "Samrı Köyü",
      "Tozman Köyü"
    ],
    "Merkez": [
      "Fatih Mah (bayırköy Beldesi)",
      "Gazi Mah (bayırköy Beldesi)",
      "Sarmaşık Mah (bayırköy Beldesi)",
      "Bahçelievler Mah",
      "Beşiktaş Mah",
      "Cumhuriyet Mah",
      "Ertuğrulgazi Mah",
      "Gazipaşa Mah",
      "Hürriyet 1.osb Mah",
      "Hürriyet 2.osb Mah",
      "Hürriyet Mah",
      "İsmetpaşa Mah",
      "İstasyon Mah",
      "İstiklal Mah",
      "Orhangazi Mah",
      "Osmangazi Mah",
      "Pelitözü Mah",
      "Abadiye Köyü",
      "Abbaslık Köyü",
      "Ahmetpınar Köyü",
      "Alpağut Köyü",
      "Aşağıköy Köyü",
      "Ayvacık Köyü",
      "Bahçecik Köyü",
      "Başköy Köyü",
      "Başköy Merkez Mah (başköy Köyü)",
      "Bekdemir Köyü",
      "Beyce Köyü",
      "Beyce Mah (beyce Köyü)",
      "Cumalı Köyü",
      "Çakırpınar Köyü",
      "Çakırpınar Mah (çakırpınar Köyü)",
      "Çamlık Mah (selbükü Köyü)",
      "Çavuşköy Köyü",
      "Çukurören Köyü",
      "Deresakarı Köyü",
      "Dereşemsettin Köyü",
      "Dereşemsettin Mah (dereşemsettin Köyü)",
      "Elmabahçe Köyü",
      "Erkoca Köyü",
      "Gökpınar Köyü",
      "Gökpınar Mah (gökpınar Köyü)",
      "Gülümbe Mah (gülümbe Köyü)",
      "Hasandere Köyü",
      "Hürriyet Mah (gülümbe Köyü)",
      "İkizce Köyü",
      "İlyasbey Köyü",
      "İlyasça Köyü",
      "Kapaklı Köyü",
      "Karaağaç Köyü",
      "Karasu Mevki Mah (kurtköy Köyü)",
      "Kavaklı Köyü",
      "Kendirli Köyü",
      "Kepirler Köyü",
      "Kınık Köyü",
      "Kızıldamlar Köyü",
      "Koyunköy Köyü",
      "Kurtköy Köyü",
      "Kurtuluş Mah (gülümbe Köyü)",
      "Kurular Mah (gülümbe Köyü)",
      "Kuyubaşı Köyü",
      "Künceğiz Köyü",
      "Küplü Köyü",
      "Küplü Merkez Mah (küplü Köyü)",
      "Necmiyeköy Köyü",
      "Okluca Köyü",
      "Ören Köyü",
      "Selbükü Köyü",
      "Selöz Köyü",
      "Selöz Mah (selöz Köyü)",
      "Sütlük Köyü",
      "Şükraniye Köyü",
      "Taşçılar Köyü",
      "Taşçılar Mah (taşçılar Köyü)",
      "Ulupınar Köyü",
      "Yeniköy Köyü",
      "Yeniköy Mah (yeniköy Köyü)",
      "Yunuslar Mah (gülümbe Köyü)",
      "Ertuğrulgazi Mah (vezirhan Beldesi)",
      "İstasyon Mah (vezirhan Beldesi)",
      "Kayalar Mah (vezirhan Beldesi)",
      "Köprülü Mehmet Paşa Mah (vezirhan Beldesi)",
      "Yeni Mah (vezirhan Beldesi)"
    ],
    "Osmaneli": [
      "Adliye Köyü",
      "Ağlan Köyü",
      "Akçapınar Mah (akçapınar Köyü)",
      "Avdan Köyü",
      "Balçıkhisar Köyü",
      "Belenalan Köyü",
      "Benli Mah (sarıyazı Köyü)",
      "Bereket Köyü",
      "Beşevler Mah (hisarcık Köyü)",
      "Borcak Köyü",
      "Boyunkaya Köyü",
      "Büyükyenice Köyü",
      "Büyükyenice Mah (büyükyenice Köyü)",
      "Ciciler Köyü",
      "Çerkeşli Köyü",
      "Çiftlik Köyü",
      "Dereyörük Köyü",
      "Düzmeşe Köyü",
      "Ericek Köyü",
      "Gaziler Mah (akçapınar Köyü)",
      "Günüören Köyü",
      "Hisarcık Mah (hisarcık Köyü)",
      "Kaşıkçı Mah (soğucakpınar Köyü)",
      "Kazancı Köyü",
      "Kızılöz Köyü",
      "Medetli Köyü",
      "Oğulpaşa Mah (oğulpaşa Köyü)",
      "Orhaniye Köyü",
      "Sarıyazı Mah (sarıyazı Köyü)",
      "Selçik Köyü",
      "Selçik Mah (selçik Köyü)",
      "Selimiye Köyü",
      "Selimiye Mah (selimiye Köyü)",
      "Selimiyeosb Mah (selimiye Köyü)",
      "Soğucakpınar Mah (soğucakpınar Köyü)",
      "Yeşilçimen Mah (oğulpaşa Köyü)",
      "Camicedit Mah",
      "Camikebir Mah",
      "Haceloğlu Mah",
      "İnönü Mah"
    ],
    "Pazaryeri": [
      "Ahmetler Köyü",
      "Alınca Köyü",
      "Arapdede Köyü",
      "Arapdede Mah (arapdede Köyü)",
      "Arpadere Köyü",
      "Bahçesultan Köyü",
      "Bozcaarmut Köyü",
      "Bulduk Köyü",
      "Burçalık Köyü",
      "Büyükelmalı Köyü",
      "Demirköy Köyü",
      "Dereköy Köyü",
      "Dereköy Mah (dereköy Köyü)",
      "Dülgeroğlu Köyü",
      "Esemen Köyü",
      "Fıranlar Köyü",
      "Fıranlar Mah (fıranlar Köyü)",
      "Güde Köyü",
      "Gümüşdere Köyü",
      "Günyurdu Köyü",
      "Karadede Köyü",
      "Karaköy Köyü",
      "Karaköy Mah (karaköy Köyü)",
      "Kınık Köyü",
      "Küçükelmalı Köyü",
      "Nazifpaşa Köyü",
      "Sarıdayı Köyü",
      "Sarnıç Köyü",
      "Süleymaniye Mah (demirköy Köyü)",
      "Yeni Yerleşim Yeri Mah (günyurdu Köyü)",
      "Beşikli Mah",
      "Çarşı Mah",
      "Dereboğaz Mah",
      "Doğanlar Mah",
      "Pamucakosb Mah",
      "Yeni Mah",
      "Yüzbaşı Mah"
    ],
    "Söğüt": [
      "Akarbaşı Mah (çaltı Köyü)",
      "Akçasu Köyü",
      "Borcak Köyü",
      "Dereboyu Köyü",
      "Dömez Köyü",
      "Dudaş Köyü",
      "Geçitli Köyü",
      "Gündüzbey Köyü",
      "Gür Mah (çaltı Köyü)",
      "Hamitabat Köyü",
      "Hayriye Köyü",
      "Kayabalı Köyü",
      "Kepen Köyü",
      "Kızılsaray Köyü",
      "Küreosb Mah (küre Köyü)",
      "Merkez Mah (küre Köyü)",
      "Oluklu Köyü",
      "Ortaca Köyü",
      "Rızapaşa Köyü",
      "Savcıbey Köyü",
      "Sırhoca Köyü",
      "Şen Mah (çaltı Köyü)",
      "Tuzaklı Köyü",
      "Yakacık Köyü",
      "Yeşilyurt Köyü",
      "Zemzemiye Köyü",
      "Balaban Mah",
      "Cumhuriyet Mah",
      "Kayhan Mah",
      "Orta Mah",
      "Türkmenbaşı Mah"
    ],
    "Yenipazar": [
      "Aşağıboğaz Köyü",
      "Aşağıçaylı Köyü",
      "Batıbelenören Köyü",
      "Belkese Köyü",
      "Caferler Mah (caferler Köyü)",
      "Danişment Köyü",
      "Dereköy Köyü",
      "Doğubelenören Köyü",
      "Esenköy Mah (esenköy Köyü)",
      "Karahasanlar Köyü",
      "Katran Köyü",
      "Kavacık Köyü",
      "Kösüre Köyü",
      "Kuşça Köyü",
      "Kükürt Köyü",
      "Nasuhlar Köyü",
      "Selim Köyü",
      "Sorguncukahiler Köyü",
      "Tekeciler Mah (esenköy Köyü)",
      "Tohumlar Köyü",
      "Ulucak Köyü",
      "Ümitler Mah (caferler Köyü)",
      "Yukarıboğaz Köyü",
      "Yukarıçaylı Köyü",
      "Yumaklı Köyü",
      "Çöte Mah",
      "Osmangazi Mah",
      "Yeni Mah",
      "Zafer Mah"
    ]
  },
  "Bingöl": {
    "Adaklı": [
      "Afet Konutları Mah",
      "Arıca Mah",
      "Demiroluk Mah",
      "Döşlüce Mah",
      "Güngörsün Mah",
      "Merkez Mah",
      "Yeşiltepe Mah",
      "Afet Konutları Mah (boyalı Köyü)",
      "Afet Konutları Mah (doğankaya Köyü)",
      "Afet Konutları Mah (yeldeğirmeni Köyü)",
      "Afetkonutları 2 Mah (hasbağlar Köyü)",
      "Afetkonutları Mah (hasbağlar Köyü)",
      "Ağa Köy Mah (sütlüce Köyü)",
      "Akbinek Köyü",
      "Akkuş Mah (sütlüce Köyü)",
      "Aktaş Köyü",
      "Altınbaşak Mah (sütlüce Köyü)",
      "Altınevler Köyü",
      "Altınyayık Mah (sütlüce Köyü)",
      "Arzu 1 Mah (sevkar Köyü)",
      "Arzu Mah (sevkar Köyü)",
      "Ayranlı Mah (mercan Köyü)",
      "Aysaklı Köyü",
      "Ayvadüzü Köyü",
      "Bağlarpınarı Köyü",
      "Bekan Mah (sütlüce Köyü)",
      "Bent Mah (kaynakdüzü Köyü)",
      "Boç Mah (kozlu Köyü)",
      "Caferan Mah (altınevler Köyü)",
      "Çakılca Mah (sarıdibek Köyü)",
      "Çamlıca Köyü",
      "Çanakçi Mah (gökçeli Köyü)",
      "Çatkuyu Mah (sütlüce Köyü)",
      "Çatma Köyü",
      "Çayağzı Mah (bağlarpınarı Köyü)",
      "Çelebi Mah (doğankaya Köyü)",
      "Çem Mah (sevkar Köyü)",
      "Çevrecik Mah (cevizli Köyü)",
      "Çevreli Köyü",
      "Çiçek Mah (kabaçalı Köyü)",
      "Çiçekli Mah (sarıdibek Köyü)",
      "Çiçekli Mah (sevkar Köyü)",
      "Çomak Mah (mercan Köyü)",
      "Çörekli Mah (çevreli Köyü)",
      "Dağdelen Mah (ayvadüzü Köyü)",
      "Doğanca Mah (kaynakdüzü Köyü)",
      "Doğankaya Köyü",
      "Doğlıca Mah (sarıdibek Köyü)",
      "Doluçay Köyü",
      "Dolutekne Köyü",
      "Elmaağaç Köyü",
      "Elmadüzü Köyü",
      "Erbaşlar Köyü",
      "Erler Köyü",
      "Goşan Mah (sarıdibek Köyü)",
      "Gökçeli Köyü",
      "Gözütek Mah (kozlu Köyü)",
      "Gurbet Mah (sütlüce Köyü)",
      "Güvercin Mah (sütlüce Köyü)",
      "Haraba Mah (ayvadüzü Köyü)",
      "Hasbağlar Köyü",
      "İkiz Mah (mercan Köyü)",
      "Kabaçalı Köyü",
      "Kale Mah (kaynakdüzü Köyü)",
      "Kamışgölü Köyü",
      "Kantar Mah (kaynakdüzü Köyü)",
      "Karaçubuk Köyü",
      "Karakoç Mah (kaynakdüzü Köyü)",
      "Karaman Mah (sütlüce Köyü)",
      "Kaynakdüzü Köyü",
      "Kırkpınar Köyü",
      "Korkmaz Mah (çevreli Köyü)",
      "Kozlu Köyü",
      "Kuri Mah (karaçubuk Köyü)",
      "Mercan Köyü",
      "Mergan Mah (ayvadüzü Köyü)",
      "Osmanuşağı Mah (akbinek Köyü)",
      "Sarıdibek Köyü",
      "Sevkar Köyü",
      "Sıralısöğütler Mah (kaynakdüzü Köyü)",
      "Sütlüce Köyü",
      "Şaban Mah (sütlüce Köyü)",
      "Topağaçlar Köyü",
      "Tosunlu Mah (kabaçalı Köyü)",
      "Uzunpazar Mah (çevreli Köyü)",
      "Yakınca Mah (hasbağlar Köyü)",
      "Yaylakonak Mah (aysaklı Köyü)",
      "Yeldeğirmeni Köyü",
      "Yoncalık Mah (çevreli Köyü)"
    ],
    "Genç": [
      "Cumhuriyet Mah",
      "Kültür Mah",
      "Yeşildere Mah",
      "Yoldaşan Mah",
      "Abasan Mah (binekli Köyü)",
      "Açıkalan Mah (büyükçağ Köyü)",
      "Akbüyük Mah (sarısaman Köyü)",
      "Akbüyük Mah (yiğitbaşı Köyü)",
      "Akçasüt Mah (alaaddin Köyü)",
      "Aksungur Mah (elmagünü Köyü)",
      "Aktoprak Köyü",
      "Akyumak Mah (doğanca Köyü)",
      "Alancık Mah (bayırlı Köyü)",
      "Alatlı Mah (geyikdere Köyü)",
      "Aliçapan Mah (ardıçdibi Köyü)",
      "Ameran Mah (şehittepe Köyü)",
      "Ardiven Mah (kavaklı Köyü)",
      "Arıtaş Mah (üçgül Köyü)",
      "Arpa Çay Mah (doğanca Köyü)",
      "Arpacik Mah (geyikdere Köyü)",
      "Aslancık Mah (büyükçağ Köyü)",
      "Aşağıbiçer Mah (dereköy Köyü)",
      "Aşağıelmagünü Mah (elmagünü Köyü)",
      "Aşağıgem Mah (yolaçtı Köyü)",
      "Aydıncık Mah (elmagünü Köyü)",
      "Aydınlı Mah (yiğitbaşı Köyü)",
      "Aydoğmuş Mah (yağızca Köyü)",
      "Ayrancı Mah (yiğitbaşı Köyü)",
      "Bahçebaşı Mah (bahçebaşı Köyü)",
      "Bardacık Mah (sarmakaya Köyü)",
      "Başmaklı Mah (yağızca Köyü)",
      "Bayırcık Mah (geyikdere Köyü)",
      "Bayramlı Mah (gerçekli Köyü)",
      "Bekçiler Mah (yolaçtı Köyü)",
      "Bereket Mah (sağgöze Köyü)",
      "Bindallı Mah (dilektaşı Köyü)",
      "Boylu Mah (sarmakaya Köyü)",
      "Bölüklü Mah (soğukpınar Köyü)",
      "Budak Mah (tarlabaşı Köyü)",
      "Bulgurlu Mah (yeniyazı Köyü)",
      "Büyükçağ Köyü",
      "Büyükköy Mah (üçgül Köyü)",
      "Cim Mah (doğanevler Köyü)",
      "Coşkunlar Mah (yolaçtı Köyü)",
      "Çakmaklı Mah (güzeldere Köyü)",
      "Çalışkanlar Mah (yazkonağı Köyü)",
      "Çaybaşı Köyü",
      "Çekmece Mah (dedebağı Köyü)",
      "Çetinkaya Mah (harmancık Köyü)",
      "Çevirme Köyü",
      "Çevreli Mah (yenisu Köyü)",
      "Çevreli Mah (yeniyazı Köyü)",
      "Çiçekli Mah (çevirme Köyü)",
      "Çobançeşmesi Köyü",
      "Çobankaya Mah (üçgül Köyü)",
      "Çöğürlü Mah (eskibağ Köyü)",
      "Dahlek Mah (doğanca Köyü)",
      "Demirkapı Mah (yenisu Köyü)",
      "Demirlibağ Mah (yayla Köyü)",
      "Demirören Mah (yeniyazı Köyü)",
      "Deremurt Mah (pınaraltı Köyü)",
      "Derman Mah (yazkonağı Köyü)",
      "Develi Mah (doğanca Köyü)",
      "Dibek Mah (doğanca Köyü)",
      "Dikmeci Mah (sarısaman Köyü)",
      "Dikmeli Mah (sarısaman Köyü)",
      "Dikmetaş Mah (yazkonağı Köyü)",
      "Dikpınar Köyü",
      "Direkli Mah (şehitköy Köyü)",
      "Doğanca Mah (karcı Köyü)",
      "Doğanevler Köyü",
      "Doğanlar Mah (yazkonağı Köyü)",
      "Doğrular Mah (sarısaman Köyü)",
      "Doğrular Mah (yayla Köyü)",
      "Doğukent Mah (servi Köyü)",
      "Doludere Mah (doludere Köyü)",
      "Domluca Mah (keklikdere Köyü)",
      "Doyumlu Mah (sağgöze Köyü)",
      "Durmuşlar Mah (sağgöze Köyü)",
      "Durmuşlu Mah (kepçeli Köyü)",
      "Dutluca Mah (balgöze Köyü)",
      "Düz Yayla Mah (doğanca Köyü)",
      "Ekincik Mah (yayla Köyü)",
      "Ekmekli Mah (yayla Köyü)",
      "Erdoğdu Mah (geyikdere Köyü)",
      "Erenler Mah (geyikdere Köyü)",
      "Esenler Mah (dedebağı Köyü)",
      "Eski Keklikdere Mah (keklikdere Köyü)",
      "Eski Köy Mah (doğanca Köyü)",
      "Eski Köy Mah (kepçeli Köyü)",
      "Eyerli Mah (güzeldere Köyü)",
      "Fırat Mah (yeniyazı Köyü)",
      "Gelbe Mah (geyikdere Köyü)",
      "Gelingik Mah (üçgül Köyü)",
      "Gılgör Mah (koçsırtı Köyü)",
      "Gökyazı Mah (çevirme Köyü)",
      "Görsü Mah (dilektaşı Köyü)",
      "Gözbasan Mah (üçgül Köyü)",
      "Gözlüce Mah (koçsırtı Köyü)",
      "Güllüce Mah (döşekkaya Köyü)",
      "Gümüşlü Mah (büyükçağ Köyü)",
      "Güngörmez Mah (dilektaşı Köyü)",
      "Günkondu Köyü",
      "Günkondu Mah (binekli Köyü)",
      "Günlüce Mah (yazkonağı Köyü)",
      "Güreşli Mah (yağızca Köyü)",
      "Gürlek Mah (güzeldere Köyü)",
      "Güvercinli Mah (bayırlı Köyü)",
      "Hasanan Mah (üçgül Köyü)",
      "Hasinan Mah (büyükçağ Köyü)",
      "Hayran Mah (keklikdere Köyü)",
      "Hegehırbon Mah (tarlabaşı Köyü)",
      "Hengimal Mah (sağgöze Köyü)",
      "Hoşek Mah (gözütok Köyü)",
      "Huzgunus Mah (geyikdere Köyü)",
      "Hülücek Mah (yeniyazı Köyü)",
      "Işıklı Mah (elmagünü Köyü)",
      "Işıklı Mah (yiğitbaşı Köyü)",
      "Işıkuluk Mah (yeniyazı Köyü)",
      "İbraman Mah (üçgül Köyü)",
      "İğdecik Mah (gerçekli Köyü)",
      "İkizler Mah (sarısaman Köyü)",
      "İkizler Mah (yağızca Köyü)",
      "İmeceli Mah (kepçeli Köyü)",
      "İpekli Mah (keklikdere Köyü)",
      "Kabataş Mah (doğanlı Köyü)",
      "Kaldırım Mah (yeniyazı Köyü)",
      "Kaledibi Mah (kepçeli Köyü)",
      "Kalkanlı Mah (balgöze Köyü)",
      "Kanatlı Mah (yazkonağı Köyü)",
      "Kapaklı Mah (gönülaçan Köyü)",
      "Kapılı Mah (gerçekli Köyü)",
      "Karabulut Mah (geyikdere Köyü)",
      "Karaoluk Mah (yayla Köyü)",
      "Karataş Mah (doğanevler Köyü)",
      "Kardeşler Mah (binekli Köyü)",
      "Kavacık Mah (çevirme Köyü)",
      "Kayacık Mah (binekli Köyü)",
      "Kayasırtı Mah (kepçeli Köyü)",
      "Kaymakcı Mah (yazkonağı Köyü)",
      "Kaymaz Mah (sağgöze Köyü)",
      "Kaynaklı Mah (yolaçtı Köyü)",
      "Kazancık Mah (büyükçağ Köyü)",
      "Kebir Mah (yenisu Köyü)",
      "Kehekelenin Mah (geyikdere Köyü)",
      "Keskin Mah (çanakçı Köyü)",
      "Kılıçlı Mah (binekli Köyü)",
      "Kılıçlı Mah (çanakçı Köyü)",
      "Kilimli Mah (bulgurluk Köyü)",
      "Kirişli Mah (bulgurluk Köyü)",
      "Kocakaya Mah (yelkaya Köyü)",
      "Korkut Mah (meşedalı Köyü)",
      "Kosiya Mah (geyikdere Köyü)",
      "Kovacık Mah (meşedalı Köyü)",
      "Koyuncuk Mah (keklikdere Köyü)",
      "Koyunlu Mah (yayla Köyü)",
      "Kozankaya Mah (şehitköy Köyü)",
      "Köklü Mah (büyükçağ Köyü)",
      "Kuruca Küme Evleri Mah (kepçeli Köyü)",
      "Kuruca Mah (kepçeli Köyü)",
      "Kuyucak Mah (kepçeli Köyü)",
      "Küçük Mah (koçsırtı Köyü)",
      "Küçükmezra Mah (bayırlı Köyü)",
      "Kültür Mah (servi Köyü)",
      "Kümelik Mah (yayla Köyü)",
      "Küpeli Mah (gözütok Köyü)",
      "Lavdere Mah (geyikdere Köyü)",
      "Mala Mah (gözütok Köyü)",
      "Merkez Mah (alaaddin Köyü)",
      "Merkez Mah (ardıçdibi Köyü)",
      "Merkez Mah (balgöze Köyü)",
      "Merkez Mah (bayırlı Köyü)",
      "Merkez Mah (binekli Köyü)",
      "Merkez Mah (bulgurluk Köyü)",
      "Merkez Mah (büyükçağ Köyü)",
      "Merkez Mah (çamlıyurt Köyü)",
      "Merkez Mah (çanakçı Köyü)",
      "Merkez Mah (çevirme Köyü)",
      "Merkez Mah (dedebağı Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (dikpınar Köyü)",
      "Merkez Mah (dilektaşı Köyü)",
      "Merkez Mah (direkli Köyü)",
      "Merkez Mah (doğanca Köyü)",
      "Merkez Mah (doğanlı Köyü)",
      "Merkez Mah (döşekkaya Köyü)",
      "Merkez Mah (elmagünü Köyü)",
      "Merkez Mah (ericek Köyü)",
      "Merkez Mah (eskibağ Köyü)",
      "Merkez Mah (gerçekli Köyü)",
      "Merkez Mah (geyikdere Köyü)",
      "Merkez Mah (gönülaçan Köyü)",
      "Merkez Mah (gözertepe Köyü)",
      "Merkez Mah (gözütok Köyü)",
      "Merkez Mah (güzeldere Köyü)",
      "Merkez Mah (harmancık Köyü)",
      "Merkez Mah (karcı Köyü)",
      "Merkez Mah (kavaklı Köyü)",
      "Merkez Mah (keklikdere Köyü)",
      "Merkez Mah (kepçeli Köyü)",
      "Merkez Mah (koçsırtı Köyü)",
      "Merkez Mah (meşedalı Köyü)",
      "Merkez Mah (pınaraltı Köyü)",
      "Merkez Mah (sağgöze Köyü)",
      "Merkez Mah (sarıbudak Köyü)",
      "Merkez Mah (sarısaman Köyü)",
      "Merkez Mah (sarmakaya Köyü)",
      "Merkez Mah (sırmalıoya Köyü)",
      "Merkez Mah (sürekli Köyü)",
      "Merkez Mah (şehitköy Köyü)",
      "Merkez Mah (şehittepe Köyü)",
      "Merkez Mah (tarlabaşı Köyü)",
      "Merkez Mah (üçgül Köyü)",
      "Merkez Mah (yağızca Köyü)",
      "Merkez Mah (yatansöğüt Köyü)",
      "Merkez Mah (yaydere Köyü)",
      "Merkez Mah (yayla Köyü)",
      "Merkez Mah (yazılı Köyü)",
      "Merkez Mah (yazkonağı Köyü)",
      "Merkez Mah (yelkaya Köyü)",
      "Merkez Mah (yiğitbaşı Köyü)",
      "Merkez Mah (yolaçtı Köyü)",
      "Meteşan Mah (şehittepe Köyü)",
      "Mirhican Mah (şehittepe Köyü)",
      "Mollaibrahim Köyü",
      "Mucuare Mah (büyükçağ Köyü)",
      "Mumdan Mah (çevirme Köyü)",
      "Mutluca Mah (meşedalı Köyü)",
      "Oğlaklı Mah (sarmakaya Köyü)",
      "Oğlaktepe Mah (yağızca Köyü)",
      "Olukbaşı Mah (alaaddin Köyü)",
      "Oluklu Mah (sarmakaya Köyü)",
      "Onbaşı Mah (keklikdere Köyü)",
      "Orgunlar Mah (büyükçağ Köyü)",
      "Oruçlu Mah (sarmakaya Köyü)",
      "Osmanlar Mah (çanakçı Köyü)",
      "Otluca Mah (koçsırtı Köyü)",
      "Örencik Mah (şehitköy Köyü)",
      "Örtülü Mah (yazkonağı Köyü)",
      "Özkaya Mah (yazkonağı Köyü)",
      "Özlüce Mah (çanakçı Köyü)",
      "Özyurt Mah (koçsırtı Köyü)",
      "Palacık Mah (balgöze Köyü)",
      "Pınarbaşı Mah (direkli Köyü)",
      "Sağan Mah (ardıçdibi Köyü)",
      "Sağlık Mah (yeniyazı Köyü)",
      "Sahuk Mah (geyikdere Köyü)",
      "Saklıca Mah (sarıbudak Köyü)",
      "Saluca Mah (geyikdere Köyü)",
      "Sancaklı Mah (üçgül Köyü)",
      "Sarıkaya Mah (pınaraltı Köyü)",
      "Sarısu Mah (yazkonağı Köyü)",
      "Savaş Mah (bulgurluk Köyü)",
      "Sayrek-gumeymus Mah (eskibağ Köyü)",
      "Seğel Mah (gözütok Köyü)",
      "Semat Mah (geyikdere Köyü)",
      "Sevimli Mah (sağgöze Köyü)",
      "Soğanlı Mah (çanakçı Köyü)",
      "Soğukpınar Köyü",
      "Sor Mah (elmagünü Köyü)",
      "Söğütlü Mah (çaytepe Köyü)",
      "Süveren Mah (doğanlı Köyü)",
      "Şaban Mah (keklikdere Köyü)",
      "Tanrıverdi Mah (sağgöze Köyü)",
      "Taşdam Mah (çevirme Köyü)",
      "Taşkapı Mah (bulgurluk Köyü)",
      "Taşlık Mah (sağgöze Köyü)",
      "Taşören Mah (direkli Köyü)",
      "Temeli Mah (kepçeli Köyü)",
      "Tepecik Mah (doğanca Köyü)",
      "Tepecik Mah (yeniyazı Köyü)",
      "Tımarlı Mah (yeniyazı Köyü)",
      "Toklu Mah (yolaçtı Köyü)",
      "Tulumlu Mah (pınaraltı Köyü)",
      "Türktaş Mah (yelkaya Köyü)",
      "Ulaklı Mah (yayla Köyü)",
      "Ulupınar Mah (alaaddin Köyü)",
      "Ulutaş Mah (çevirme Köyü)",
      "Umurlu Mah (geyikdere Köyü)",
      "Usluca Mah (direkli Köyü)",
      "Uysal Mah (balgöze Köyü)",
      "Üçkardeş Mah (geyikdere Köyü)",
      "Ünveren Mah (soğukpınar Köyü)",
      "Ürünlü Mah (yayla Köyü)",
      "Üstkaya Mah (yazkonağı Köyü)",
      "Üzümcük Mah (büyükçağ Köyü)",
      "Yağmurlu Mah (tarlabaşı Köyü)",
      "Yamaçlı Mah (geyikdere Köyü)",
      "Yamanlar Mah (keklikdere Köyü)",
      "Yapraklı Mah (sarısaman Köyü)",
      "Yardım Mah (çanakçı Köyü)",
      "Yatansöğüt Köyü",
      "Yayla Mah (binekli Köyü)",
      "Yazıcık Mah (yazkonağı Köyü)",
      "Yazmalı Mah (bulgurluk Köyü)",
      "Yeni Çiçekli Mah (doğanca Köyü)",
      "Yenice Mah (sağgöze Köyü)",
      "Yeniçağ Mah (günkondu Köyü)",
      "Yeniçevre Mah (yeniçevre Köyü)",
      "Yeniler Mah (güzeldere Köyü)",
      "Yenisu Köyü",
      "Yenişehir Mah",
      "Yenişehir Mah (servi Köyü)",
      "Yeniyazı Köyü",
      "Yeşiller Mah (keklikdere Köyü)",
      "Yeşilyurt Mah (dilektaşı Köyü)",
      "Yıldırım Mah (yeniyazı Köyü)",
      "Yıldız Mah (koçsırtı Köyü)",
      "Yıldız Mah (sarısaman Köyü)",
      "Yıldızlı Mah (bulgurluk Köyü)",
      "Yibo Mah (sürekli Köyü)",
      "Yoğurtlu Mah (dereköy Köyü)",
      "Yorulmaz Mah (meşedalı Köyü)",
      "Yukarı Biçer Mah (dereköy Köyü)",
      "Yukarıgem Mah (yolaçtı Köyü)",
      "Yumrulu Mah (yeniyazı Köyü)",
      "Yumurtali Mah (koçsırtı Köyü)",
      "Yuvaklı Mah (geyikdere Köyü)",
      "Yüceler Mah (yeniyazı Köyü)"
    ],
    "Karlıova": [
      "Kanıreş Mah",
      "Seyran Tepe Mah",
      "Turgut Özal Mah",
      "Yeşilyurt Mah",
      "Aktaş Mah (kaynarpınar Köyü)",
      "Ali Mah (kargapazarı Köyü)",
      "Altı Evler Mah (kaynarpınar Köyü)",
      "Aşağı Çır Mah (yorgançayır Köyü)",
      "Aşağıyağmurlu Köyü",
      "Aynik Mah (kızılağaç Köyü)",
      "Bağlıisa Köyü",
      "Bahçeköy Köyü",
      "Bedran Mah (serpmekaya Köyü)",
      "Binkoz Mah (soğukpınar Köyü)",
      "Boncukgöze Köyü",
      "Boyhane Mah (kargapazarı Köyü)",
      "Burmataş Mah (hasanova Köyü)",
      "Cilligöl Köyü",
      "Çatak Köyü",
      "Çatak Mah (yiğitler Köyü)",
      "Çiçekli Mah (bağlıisa Köyü)",
      "Çiçekpınar Mah (tuzluca Köyü)",
      "Çiftlikköy Köyü",
      "Çukurtepe Köyü",
      "Dağ Çayır Mah (çatak Köyü)",
      "Dörtyol Köyü",
      "Geçitli Köyü",
      "Gola Use Mah (kargapazarı Köyü)",
      "Göynük Köyü",
      "Gülabi Mah (yiğitler Köyü)",
      "Hacı Fevzli Mah (kızılçubuk Köyü)",
      "Hacılar Köyü",
      "Halifan Köyü",
      "Harmantepe Köyü",
      "Hasanova Köyü",
      "Hasar Mah (geçitli Köyü)",
      "Ilıpınar Köyü",
      "Kale Mah",
      "Kalencik Köyü",
      "Kanitaht Mah",
      "Kantarkaya Köyü",
      "Karabalçık Köyü",
      "Kargapazarı Köyü",
      "Karlıca Köyü",
      "Karşıyaka Mah (kaynarpınar Köyü)",
      "Kaşıkçı Köyü",
      "Kavakan Mah (kaynarpınar Köyü)",
      "Kaynak Köyü",
      "Kaynarpınar Köyü",
      "Kazanlı Köyü",
      "Kıraçtepe Köyü",
      "Kızılağaç Köyü",
      "Kızılçubuk Köyü",
      "Konak Mah (hasanova Köyü)",
      "Kümbet Köyü",
      "Kürük Köyü",
      "Mezracık Mah (yiğitler Köyü)",
      "Molla Hüseyin Mah (kargapazarı Köyü)",
      "Mollaşakir Köyü",
      "Morkoyun Mah (bağlıisa Köyü)",
      "Ortaköy Köyü",
      "Sakaören Köyü",
      "Sarıkuşak Köyü",
      "Serince Mah (kaynarpınar Köyü)",
      "Serpmekaya Köyü",
      "Seyrana Mah (kıraçtepe Köyü)",
      "Soğukpınar Köyü",
      "Suçatı Köyü",
      "Sudurağı Köyü",
      "Tarlacık Mah (mollaşakir Köyü)",
      "Taşlıçay Köyü",
      "Toklular Köyü",
      "Tuzluca Köyü",
      "Ulukapı Mah (bağlıisa Köyü)",
      "Üç Evler Mah (kaynarpınar Köyü)",
      "Viranşehir Köyü",
      "Yalnızlar Mah (serpmekaya Köyü)",
      "Yazlıkonak Mah (kaynarpınar Köyü)",
      "Yeniköy Köyü",
      "Yiğitler Köyü",
      "Yoncalık Köyü",
      "Yorgançayır Köyü",
      "Yukarı Çır Mah (hasanova Köyü)",
      "Yukarıyağmurlu Köyü"
    ],
    "Kiğı": [
      "Eskişehir Mah",
      "Yenişehir Mah",
      "Yeşilyurt Mah",
      "Açıkgüney Köyü",
      "Ağaçöven Köyü",
      "Akçalı Mah (billice Köyü)",
      "Alagöz Köyü",
      "Alican Mah (nacaklı Köyü)",
      "Altındiş Mah (billice Köyü)",
      "Arik Mah (eskikavak Köyü)",
      "Baklalı Köyü",
      "Balıklı Mah (yazgünü Köyü)",
      "Billice Köyü",
      "Çanakçı Köyü",
      "Çiçektepe Köyü",
      "Dallıca Köyü",
      "Demirdöş Köyü",
      "Demirkanat Köyü",
      "Devetaşı Mah (kadıköy Köyü)",
      "Dikenli Mah (nacaklı Köyü)",
      "Duranlar Köyü",
      "Eskikavak Köyü",
      "Eşme Köyü",
      "Fındıklı Mah (güneyağıl Köyü)",
      "Gedikli Mah (billice Köyü)",
      "Güneyağıl Köyü",
      "Hacikoğlu Mah (eskikavak Köyü)",
      "Halmek Mah (kadıköy Köyü)",
      "İncesu Mah (nacaklı Köyü)",
      "Kadıköy Köyü",
      "Kara Kamu Mah (billice Köyü)",
      "Karataş Mah (yazgünü Köyü)",
      "Karınca Mah (billice Köyü)",
      "Kılıcan Mah (darköprü Köyü)",
      "Köprübaşı Mah (eskikavak Köyü)",
      "Kurşunlu Mah (billice Köyü)",
      "Kuşçimeni Köyü",
      "Kuşluca Mah (billice Köyü)",
      "Kutluca Köyü",
      "Melekan Mah (alagöz Köyü)",
      "Nacaklı Köyü",
      "Payamlı Mah (yazgünü Köyü)",
      "Sabırtaşı Köyü",
      "Samantepe Mah (açıkgüney Köyü)",
      "Selenk Mah (eskikavak Köyü)",
      "Sırmaçek Köyü",
      "Solmaz Mah (billice Köyü)",
      "Sütlüce Mah (yazgünü Köyü)",
      "Taşağıl Mah (billice Köyü)",
      "Taşbaşı Mah (darköprü Köyü)",
      "Tekbaş Köyü",
      "Uzundal Mah (billice Köyü)",
      "Yazgünü Köyü",
      "Yoncalı Mah (açıkgüney Köyü)",
      "Yukarıserinyer Köyü",
      "Zengok Mah (ilbeyi Köyü)"
    ],
    "Merkez": [
      "Alatepe Köyü",
      "Aşağı Mah (elmalı Köyü)",
      "Atçayır Mah (elmalı Köyü)",
      "Bahçeli Mah (çavuşlar Köyü)",
      "Dalsi Mah (gökçeli Köyü)",
      "Derince Mah (çobantaşı Köyü)",
      "Elma Mah (ortaçanak Köyü)",
      "Gevir Mah (ortaçanak Köyü)",
      "Göl Mah (dallıtepe Köyü)",
      "Gözer Köyü",
      "Güzel Mah (çavuşlar Köyü)",
      "Heşvare Mah (çavuşlar Köyü)",
      "Hevir Mah (gökçeli Köyü)",
      "Hezaz Mah (ortaçanak Köyü)",
      "Hezaz Yayla Evleri Mah (ortaçanak Köyü)",
      "Hırtık Mah (ortaçanak Köyü)",
      "K.keşkare Mah (yenibaşlar Köyü)",
      "Köçek Mah (yenibaşlar Köyü)",
      "Köklü Köyü",
      "Köme Mah (çavuşlar Köyü)",
      "Kürkürü Mah (yenibaşlar Köyü)",
      "Leyman Mah (çavuşlar Köyü)",
      "Mahkar Mah (yenibaşlar Köyü)",
      "Merkez Mah (ağaçeli Köyü)",
      "Merkez Mah (çobantaşı Köyü)",
      "Merkez Mah (dallıtepe Köyü)",
      "Merkez Mah (gökçeli Köyü)",
      "Merkez Mah (ortaçanak Köyü)",
      "Naman Mah (yenibaşlar Köyü)",
      "Ömerli Mah (çavuşlar Köyü)",
      "Pınarlı Mah (çavuşlar Köyü)",
      "Samanlı Mah (ortaçanak Köyü)",
      "Seydan Mah (çavuşlar Köyü)",
      "Sofyan Mah (gökçeli Köyü)",
      "Soğuk Çeşme Mah (çobantaşı Köyü)",
      "Subaşı Mah (ortaçanak Köyü)",
      "Şenlik Mah (gökçeli Köyü)",
      "Şeyhalan Mah (çavuşlar Köyü)",
      "Taşlı Mah (çavuşlar Köyü)",
      "Tırşınek Mah (ortaçanak Köyü)",
      "Y.ağaçeli Mah (ağaçeli Köyü)",
      "Y.komsarik Mah (çavuşlar Köyü)",
      "Yenibaşlar Köyü",
      "Yeniyerleşim Mah (çavuşlar Köyü)",
      "Yeşil Mah (çavuşlar Köyü)",
      "Yeşilmezra Mah (çavuşlar Köyü)",
      "Yeşiltepe Mah (çavuşlar Köyü)",
      "Yukarı Mah (çavuşlar Köyü)",
      "Yukarı Mah (elmalı Köyü)",
      "Yukarı Yenibaşlar Mah (yenibaşlar Köyü)",
      "Bahçelievler Mah",
      "İçmeler Mah",
      "İnalı Mah",
      "İnönü Mah",
      "Karşıyaka Mah",
      "Kültür Mah",
      "Mirzan Mah",
      "Recep Tayyip Erdoğan Mah",
      "Saray Mah",
      "Selahaddin-i Eyyubi Mah",
      "Simani Mah",
      "Şehit Mustafa Gündoğdu Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Yeşilyurt Mah",
      "Çay Mah (ılıcalar Beldesi)",
      "Ilıca Mah (ılıcalar Beldesi)",
      "İçpınar Mah (ılıcalar Beldesi)",
      "Kamışlı Mah (ılıcalar Beldesi)",
      "Kılıçlı Mah (ılıcalar Beldesi)",
      "Uzundere Mah (ılıcalar Beldesi)",
      "71 Deprem Mah (gözeler Köyü)",
      "Ağaçyolu Köyü",
      "Akdurmuş Köyü",
      "Alataş Mah (çevrimpınar Köyü)",
      "Ali Mezrası Mah (aşağıakpınar Köyü)",
      "Alibir Köyü",
      "Altınışık Köyü",
      "Ardıçtepe Köyü",
      "Ardıçtepeosb Mah (ardıçtepe Köyü)",
      "Aşağı Mah (bilaloğlu Köyü)",
      "Aşağı Mah (suvaran Köyü)",
      "Aşağı Paymerk Mah (kıran Köyü)",
      "Aşağı Yumaklı Mah (yumaklı Köyü)",
      "Aşağı Zeynep Mah (küçüktekören Köyü)",
      "Aşağıköy Köyü",
      "Az Köyü",
      "Bahçeli Köyü",
      "Balpınar Köyü",
      "Bani Mah (emtağ Köyü)",
      "Batı Mah (kartal Köyü)",
      "Beyaztoprak Mah (ekinyolu Köyü)",
      "Büyüktekören Köyü",
      "Celal Mah (aşağıakpınar Köyü)",
      "Cevizli Mah (kuşburnu Köyü)",
      "Çallar Mah (sancaklı Köyü)",
      "Çanakalın Mah (çukurca Köyü)",
      "Çayağzı Köyü",
      "Çayboyu Köyü",
      "Çayırlı Mah (kuşburnu Köyü)",
      "Çeltiksuyu Köyü",
      "Çiçekdere Köyü",
      "Çiçekyayla Köyü",
      "Çiriş Köyü",
      "Çukurca Köyü",
      "Çukurcak Mah (sancaklı Köyü)",
      "Damcık Mah (yumaklı Köyü)",
      "Dikköy Köyü",
      "Dikme Mah (akdurmuş Köyü)",
      "Direkli Köyü",
      "Dişbudak Köyü",
      "Dügernan Köyü",
      "Erdemli Köyü",
      "Erentepe Köyü",
      "Eski Köy Mah (aşağıakpınar Köyü)",
      "Eski Köy Mah (kartal Köyü)",
      "Eski Yerleşim Mah (göltepesi Köyü)",
      "Eskiköy Mah (çiçekdere Köyü)",
      "Evciler Mah (gümüşlü Köyü)",
      "Garip Köyü",
      "Gayt Mah (akdurmuş Köyü)",
      "Germik Mah (sarıçiçek Köyü)",
      "Gökçekanat Köyü",
      "Gürpınar Köyü",
      "Güveçli Köyü",
      "Hacıçayır Mah (sarıçiçek Köyü)",
      "Hartını Mah (gökdere Köyü)",
      "Havsal Mah (göltepesi Köyü)",
      "Haziran Köyü",
      "Hevsel Mah (kardeşler Köyü)",
      "İkizgöl Mah (yumaklı Köyü)",
      "İncesu Köyü",
      "Kamışlı Mah (kurudere Köyü)",
      "Kantar Mah (sarıçiçek Köyü)",
      "Karakoç Mah (yumaklı Köyü)",
      "Karşı Mah (kartal Köyü)",
      "Kemalan Mah (çayağzı Köyü)",
      "Kılçadır Köyü",
      "Kıran Köyü",
      "Konak-dereygazan Mah (sancaklı Köyü)",
      "Köprübaşı Mah (ekinyolu Köyü)",
      "Körcüpınar Mah (çukurca Köyü)",
      "Kumgeçit Köyü",
      "Kuruca Köyü",
      "Kurudere Köyü",
      "Kuşluca Mah (çiçekdere Köyü)",
      "Lıncık Mah (gökdere Köyü)",
      "Merkez Mah (aşağıakpınar Köyü)",
      "Merkez Mah (çevrimpınar Köyü)",
      "Merkez Mah (dikme Köyü)",
      "Merkez Mah (düzyayla Köyü)",
      "Merkez Mah (ekinyolu Köyü)",
      "Merkez Mah (emtağ Köyü)",
      "Merkez Mah (gökdere Köyü)",
      "Merkez Mah (göltepesi Köyü)",
      "Merkez Mah (gözeler Köyü)",
      "Merkez Mah (gümüşlü Köyü)",
      "Merkez Mah (kardeşler Köyü)",
      "Merkez Mah (kartal Köyü)",
      "Merkez Mah (kuşburnu Köyü)",
      "Merkez Mah (küçüktekören Köyü)",
      "Merkez Mah (sancaklı Köyü)",
      "Merkez-y.yumaklı Mah (yumaklı Köyü)",
      "Olukpınar Köyü",
      "Ormanardı Köyü",
      "Ortaköy Köyü",
      "Ovacık Mah (dikme Köyü)",
      "Özlüce Mah (kılçadır Köyü)",
      "Polatlı Mah (yumaklı Köyü)",
      "Reng Mah (incesu Köyü)",
      "Sarıçiçek Köyü",
      "Şabanköy Köyü",
      "Topalan Köyü",
      "Yamaç Köyü",
      "Yedievler Mah (kardeşler Köyü)",
      "Yelesen Köyü",
      "Yeni Yerleşim Mah (aşağıakpınar Köyü)",
      "Yeni Yerleşim Mah (düzyayla Köyü)",
      "Yeniköy Köyü",
      "Yeşilköy Köyü",
      "Yolçatı Köyü",
      "Yukarı Kemalan Mah (ardıçtepe Köyü)",
      "Yukarı Mah (bilaloğlu Köyü)",
      "Yukarı Mah (suvaran Köyü)",
      "Yukarı Paymerk Mah (kıran Köyü)",
      "Yukarı Zeynep Mah (küçüktekören Köyü)",
      "Yukarıakpınar Köyü",
      "Akbudak Mah (sancak Beldesi)",
      "Bekmezli Mah (uğurova Köyü)",
      "Büyükbaşköy Mah (sancak Beldesi)",
      "Cami Mah (sudüğünü Köyü)",
      "Çimenli Mah (sancak Beldesi)",
      "Elmaçayır Mah (sudüğünü Köyü)",
      "Erenler Mah (uğurova Köyü)",
      "Esenler Mah (sudüğünü Köyü)",
      "Eskiköy Mah (sudüğünü Köyü)",
      "Güngören Köyü",
      "Haroçayırı Mah (sudüğünü Köyü)",
      "Hasanova Mah (balıklıçay Köyü)",
      "Hoşkar Mah (sancak Beldesi)",
      "Karapınar Mah (sancak Beldesi)",
      "Kilsek Mah (oğuldere Köyü)",
      "Kork Mah (arıcılar Köyü)",
      "Kurtuluş Köyü",
      "Kuşkondu Köyü",
      "Küçükbaşköy Mah (sancak Beldesi)",
      "Merkez Mah (arıcılar Köyü)",
      "Merkez Mah (balıklıçay Köyü)",
      "Merkez Mah (sütgölü Köyü)",
      "Merkez Mah (uzunsavat Köyü)",
      "Merkez Mah (yaygınçayır Köyü)",
      "Oğuldere Köyü",
      "Ortaokul Mah (sudüğünü Köyü)",
      "Sarıgümüş Mah (sancak Beldesi)",
      "Şeref Mah (sütgölü Köyü)",
      "Taş Mah (güngören Köyü)",
      "Tepebaşı Köyü",
      "Türkan Mah (arıcılar Köyü)",
      "Ünlüce Mah (balıklıçay Köyü)",
      "Üsküdar Mah (yaygınçayır Köyü)",
      "Yayımlı Mah (uzunsavat Köyü)",
      "Yazgülü Köyü",
      "Yeni Yerleşim Mah (uğurova Köyü)",
      "Yeşilova Mah (sancak Beldesi)"
    ],
    "Solhan": [
      "Karşıyaka Mah (arakonak Beldesi)",
      "Kültür Mah (arakonak Beldesi)",
      "Merkez Mah (arakonak Beldesi)",
      "Akbük Mah (gençtavus Köyü)",
      "Akdere Mah (asmakaya Köyü)",
      "Aksakal Komler Mah (hazarşah Köyü)",
      "Aksakal Mah (hazarşah Köyü)",
      "Aktasor Mah (kale Köyü)",
      "Akyürek Mah (sükyan Köyü)",
      "Alaca Mah (gençtavus Köyü)",
      "Alak Mah (murat Köyü)",
      "Allo Mah (yenidal Köyü)",
      "Altındüzü Mah (yenidal Köyü)",
      "Altınsu Mah (yenidal Köyü)",
      "Ardik Mah (gençtavus Köyü)",
      "Armut Mah (gençtavus Köyü)",
      "Arslanbeyli Köyü",
      "Aslanlar Mah (eşmetaş Köyü)",
      "Asmakaya Köyü",
      "Aşağı Cemalan Mah (yenidal Köyü)",
      "Aşağı Köprübaşı Mah (yenidal Köyü)",
      "Aşağı Kulan Mah (yenidal Köyü)",
      "Aşağı Otluca Mah (kırık Köyü)",
      "Aşağı Yayıklı Mah (mutluca Köyü)",
      "Aşağı Zork Mah (doğuyeli Köyü)",
      "Aydın Mah (demirkapı Köyü)",
      "Bağızlar Mah (asmakaya Köyü)",
      "Ballı Mah (arslanbeyli Köyü)",
      "Barakalar Mah (yiğitharman Köyü)",
      "Barbara Mah (yenibaşak Köyü)",
      "Bardaklı Mah (gençtavus Köyü)",
      "Başdere Mah (sükyan Köyü)",
      "Bejav Mah (kırık Köyü)",
      "Beşevler Mah (murat Köyü)",
      "Beşevler Mah (mutluca Köyü)",
      "Beşikli Mah (gençtavus Köyü)",
      "Beyazköm Mah (bozkanat Köyü)",
      "Birik Mah (dilektepe Köyü)",
      "Bozkanat Köyü",
      "Canut Mah (kale Köyü)",
      "Cemalan Mah (hazarşah Köyü)",
      "Cemil Mah (inandık Köyü)",
      "Cevizli Mah (mutluca Köyü)",
      "Çallı Mah (gençtavus Köyü)",
      "Çataldere Mah (demirkapı Köyü)",
      "Çeşmeli Mah (yenidal Köyü)",
      "Çıkrıklı Mah (şimşirpınar Köyü)",
      "Çıraltı Mah (dilektepe Köyü)",
      "Değirmen Dere Mah (kale Köyü)",
      "Değirmendere Mah (gençtavus Köyü)",
      "Deli Mah (doğuyeli Köyü)",
      "Demirkapı Köyü",
      "Deremalan Mah (elmasırtı Köyü)",
      "Derindere Mah (demirkapı Köyü)",
      "Dersor Mah (asmakaya Köyü)",
      "Derviş Mah (düzağaç Köyü)",
      "Dikkaya Mah (demirkapı Köyü)",
      "Dilektepe Köyü",
      "Dilova Mah (düzağaç Köyü)",
      "Diyar Mah (elbaşı Köyü)",
      "Doğuyeli Köyü",
      "Duraklı Mah (kale Köyü)",
      "Durmuşlu Mah (yenidal Köyü)",
      "Duygulu Mah (yenibaşak Köyü)",
      "Düz Mah (sükyan Köyü)",
      "Düzağaç Köyü",
      "Efendideresi Mah (yenidal Köyü)",
      "Eğridere Mah (demirkapı Köyü)",
      "Elbaşı Köyü",
      "Elmasırtı Köyü",
      "Elyan Mah (doğuyeli Köyü)",
      "Erdemler Mah (hazarşah Köyü)",
      "Eskiköy Mah (mutluca Köyü)",
      "Eskiköy Mah (oymapınar Köyü)",
      "Eskiköy Mah (yenidal Köyü)",
      "Eşmetaş Köyü",
      "Gaçır Mah (bozkanat Köyü)",
      "Gamır Mah (doğuyeli Köyü)",
      "Gelintepe Köyü",
      "Gençtavus Köyü",
      "Germik Mah (yenidal Köyü)",
      "Gıris Mah (elmasırtı Köyü)",
      "Gozer Mah (yenidal Köyü)",
      "Göksu Köyü",
      "Göl Mah (hazarşah Köyü)",
      "Göl Mah (yenidal Köyü)",
      "Gömdevdo Mah (elmasırtı Köyü)",
      "Gört Mah (bozkanat Köyü)",
      "Gözübüyük Mah (mutluca Köyü)",
      "Gültepe Mah (gelintepe Köyü)",
      "Gündoğdu Mah (yiğitharman Köyü)",
      "Güzeldere Mah (elmasırtı Köyü)",
      "Halidan Mah (oymapınar Köyü)",
      "Haliller Mah (oymapınar Köyü)",
      "Harabedüzü Mah (bozkanat Köyü)",
      "Hasan Mah (düzağaç Köyü)",
      "Hasenan Mah (gençtavus Köyü)",
      "Hatun Mah (murat Köyü)",
      "Hazarşah Köyü",
      "Hor Mah (sükyan Köyü)",
      "Horkum Mah (elmasırtı Köyü)",
      "Hosir Mah (oymapınar Köyü)",
      "Hun Mah (oymapınar Köyü)",
      "İnandık Köyü",
      "Kabaklı Mah (gençtavus Köyü)",
      "Kafzelin Mah (elmasırtı Köyü)",
      "Kandoz Mah (murat Köyü)",
      "Kapaklı Mah (arslanbeyli Köyü)",
      "Karan Mah (yenidal Köyü)",
      "Karatay Mah (asmakaya Köyü)",
      "Kartal Mah (eşmetaş Köyü)",
      "Karyağdı Mah (sükyan Köyü)",
      "Kavacık Mah (sülünkaş Köyü)",
      "Kavaklı Mah (bozkanat Köyü)",
      "Kavaklıdere Mah (yenidal Köyü)",
      "Kayabağ Mah (elmasırtı Köyü)",
      "Kayalar Mah (yenidal Köyü)",
      "Keşkan Mah (yiğitharman Köyü)",
      "Kıncal Mah (elmasırtı Köyü)",
      "Kırık Köyü",
      "Kokulupınar Mah (yenibaşak Köyü)",
      "Konakbaşı Mah (arslanbeyli Köyü)",
      "Köşk Mah (yenibaşak Köyü)",
      "Kuç Mah (doğuyeli Köyü)",
      "Kulan Mah (yenidal Köyü)",
      "Kuştepe Mah (gençtavus Köyü)",
      "Küllüce Mah (gençtavus Köyü)",
      "Kümbet Mah (sülünkaş Köyü)",
      "Liç Mah (arslanbeyli Köyü)",
      "Liç Mah (dilektepe Köyü)",
      "Liç Mah (elmasırtı Köyü)",
      "Mergan Mah (asmakaya Köyü)",
      "Merkez Komler Mah (hazarşah Köyü)",
      "Merkez Mah (kale Köyü)",
      "Mevlagiriş Mah (doğuyeli Köyü)",
      "Murat Köyü",
      "Muratüstü Mah (yenidal Köyü)",
      "Mutluca Köyü",
      "Nasıran Mah (kale Köyü)",
      "Nişrik Mah (kale Köyü)",
      "Oluklu Mah (sülünkaş Köyü)",
      "Ormaniçi Mah (hazarşah Köyü)",
      "Orta Mah (yenibaşak Köyü)",
      "Osmanan Mah (kırık Köyü)",
      "Oymapınar Köyü",
      "Öğrencik Mah (gençtavus Köyü)",
      "Ömerler Mah (sülünkaş Köyü)",
      "Özengili Mah (elmasırtı Köyü)",
      "Piskisor Mah (yenibaşak Köyü)",
      "Piyami Mah (doğuyeli Köyü)",
      "Post Mah (kale Köyü)",
      "Röle Altı Mah (yenidal Köyü)",
      "Sahak Mah (bozkanat Köyü)",
      "Samanlık Mah (tarhan Köyü)",
      "Sansarlı Mah (gençtavus Köyü)",
      "Sarıbaşak Mah (yenidal Köyü)",
      "Sedat Mah (elmasırtı Köyü)",
      "Sepetli Mah (yenidal Köyü)",
      "Seydangölü Mah (yenidal Köyü)",
      "Sımık Mah (elbaşı Köyü)",
      "Siman Mah (elmasırtı Köyü)",
      "Sinikan Mah (kale Köyü)",
      "Sivritepe Mah (gençtavus Köyü)",
      "Susan Mah (kale Köyü)",
      "Sükyan Köyü",
      "Sülünkaş Köyü",
      "Şenlik Mah (demirkapı Köyü)",
      "Şenova Mah (eşmetaş Köyü)",
      "Şerefmeydanı Mah (yenidal Köyü)",
      "Şimşirpınar Köyü",
      "Tanzut Mah (oymapınar Köyü)",
      "Tarbaş Mah (dilektepe Köyü)",
      "Tarhan Köyü",
      "Taş Mah (gençtavus Köyü)",
      "Taşlıdere Mah (yenidal Köyü)",
      "Taşoluk Mah (yenidal Köyü)",
      "Topluca Mah (bozkanat Köyü)",
      "Turna İstasyonu Mah (bozkanat Köyü)",
      "Turnacık Mah (düzağaç Köyü)",
      "Uyanık Mah (bozkanat Köyü)",
      "Ünlüce Mah (gençtavus Köyü)",
      "Üstkaran Mah (yenidal Köyü)",
      "Yamanlar Mah (asmakaya Köyü)",
      "Yayladüzü Mah (yenidal Köyü)",
      "Yazmalı Mah (dilektepe Köyü)",
      "Yeni Mah (yenibaşak Köyü)",
      "Yenidal Köyü",
      "Yeniyerleşim Mah (hazarşah Köyü)",
      "Yenyerleşim Komler Mah (hazarşah Köyü)",
      "Yeşilova Mah (yenidal Köyü)",
      "Yiğitharman Köyü",
      "Yukarı Çeşmeli Mah (yenidal Köyü)",
      "Yukarı Karan Mah (yenidal Köyü)",
      "Yukarı Köprübaşı Mah (yenidal Köyü)",
      "Yukarı Otluca Mah (kırık Köyü)",
      "Yukarı Yayıklı Mah (mutluca Köyü)",
      "Yukarı Zork Mah (doğuyeli Köyü)",
      "Yuva Mah (gençtavus Köyü)",
      "Yüksekova Mah (sülünkaş Köyü)",
      "Yürekli Mah (kırık Köyü)",
      "Yüzenada Mah (hazarşah Köyü)",
      "Zakaran Mah (tarhan Köyü)",
      "Zedik Mah (hazarşah Köyü)",
      "Ziyaret Mah (doğuyeli Köyü)",
      "Ziyaret Mah (yenidal Köyü)",
      "Boğlan Mah",
      "Halime Pınar Mah",
      "Yeni Mah",
      "Yeşilova Mah"
    ],
    "Yayladere": [
      "Alınyazı Köyü",
      "Bakımlı Mah (çikan Köyü)",
      "Başparmak Mah (güneşlik Köyü)",
      "Boğazköy Köyü",
      "Bölükören Mah (aydınlar Köyü)",
      "Çay Mah (sürmelikoç Köyü)",
      "Çaylıca Mah (güneşlik Köyü)",
      "Çikan Köyü",
      "Dağarcık Mah (aydınlar Köyü)",
      "Dikilitaş Mah (çalıkağıl Köyü)",
      "Durusu Mah (aydınlar Köyü)",
      "Düğünlü Mah (korlu Köyü)",
      "Elmacık Mah (çayağzı Köyü)",
      "Eyüphan Mah (korlu Köyü)",
      "Gökçedal Köyü",
      "Göl Mah (korlu Köyü)",
      "Hacı Kömü Mah (korlu Köyü)",
      "Hacı Mah (aydınlar Köyü)",
      "Halil Mah (çikan Köyü)",
      "Kalecik Mah (kalkanlı Köyü)",
      "Karadiken Mah (yaylabağ Köyü)",
      "Kayadibi Mah (çayağzı Köyü)",
      "Kırkağaç Mah (çalıkağıl Köyü)",
      "Kırköy Köyü",
      "Kullan Mah (batıayaz Köyü)",
      "Kurt Mah (kalkanlı Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (batıayaz Köyü)",
      "Merkez Mah (bilekkaya Köyü)",
      "Merkez Mah (çalıkağıl Köyü)",
      "Merkez Mah (çatalkaya Köyü)",
      "Merkez Mah (çayağzı Köyü)",
      "Merkez Mah (dalbasan Köyü)",
      "Merkez Mah (güneşlik Köyü)",
      "Merkez Mah (günlük Köyü)",
      "Merkez Mah (kalkanlı Köyü)",
      "Merkez Mah (korlu Köyü)",
      "Merkez Mah (sürmelikoç Köyü)",
      "Merkez Mah (yaylabağ Köyü)",
      "Merkez Mah (zeynelli Köyü)",
      "Ova Mah (batıayaz Köyü)",
      "Öğrencik Mah (günlük Köyü)",
      "Ömerler Mah (zeynelli Köyü)",
      "Özlüce Mah (kalkanlı Köyü)",
      "Pınarcık Mah (aydınlar Köyü)",
      "Sarıkonak Mah (kalkanlı Köyü)",
      "Sarmaşık Mah (kalkanlı Köyü)",
      "Sarp Mah (kalkanlı Köyü)",
      "Taşdirek Mah (günlük Köyü)",
      "Yağmurdere Mah (aydınlar Köyü)",
      "Yakalı Mah (korlu Köyü)",
      "Yavuztaş Mah (yavuztaş Köyü)",
      "Yellice Mah (sürmelikoç Köyü)",
      "Yıldızlı Mah (çikan Köyü)",
      "Akçadamlar Mah",
      "Conag Mah",
      "Haktanır Mah",
      "Hasköy Mah",
      "Merkez Mah",
      "Yolgüden Mah"
    ],
    "Yedisu": [
      "Akımlı Köyü",
      "Aşağı Salkımlar Mah (elmalı Köyü)",
      "Ayanoğlu Köyü",
      "Büyükdere Mah (yağmurpınar Köyü)",
      "Çaltepe Mah (güzgülü Köyü)",
      "Çiçekli Mezrası Mah (gelinpertek Köyü)",
      "Dinarbey Köyü",
      "Ekşipınar Mah (yeşilgöl Köyü)",
      "Elmalı Köyü",
      "Eskibalta Köyü",
      "Gazi Mah (elmalı Köyü)",
      "Gelincik Mah (elmalı Köyü)",
      "Gelinpertek Köyü",
      "Giyimli Mah (kabayel Köyü)",
      "Göl Mah (gelinpertek Köyü)",
      "Göl Mah (kabayel Köyü)",
      "Güleç Mah (güzgülü Köyü)",
      "Güzgülü Köyü",
      "Harmanlı Mah (güzgülü Köyü)",
      "Hatuntarla Mah (kabayel Köyü)",
      "Hıraba Mah (kabayel Köyü)",
      "İbiş Mah (elmalı Köyü)",
      "K.ç.dinarbey Mah (dinarbey Köyü)",
      "Kabayel Köyü",
      "Karapolat Köyü",
      "Kasar Mah (elmalı Köyü)",
      "Kaşıklı Köyü",
      "Katırcı Mah (kabayel Köyü)",
      "Kom Mah (şenköy Köyü)",
      "Konuklu Mah (güzgülü Köyü)",
      "Koyuncular Mah (güzgülü Köyü)",
      "Köy Karşı Mah (yağmurpınar Köyü)",
      "Merkez Mah (kaşıklı Köyü)",
      "Merkez Mah (şenköy Köyü)",
      "Mezra Mah (kaşıklı Köyü)",
      "Şemo Mezrası Mah (eskibalta Köyü)",
      "Umurlu Mah (elmalı Köyü)",
      "Yağmurpınar Köyü",
      "Yazıpınar Mah (elmalı Köyü)",
      "Yeşilgöl Köyü",
      "Yukarı Salkımlar Mah (elmalı Köyü)",
      "Yurt İçi Mah (güzgülü Köyü)",
      "Döşengi Mah",
      "Kabaoluk Mah",
      "Koşan Mah",
      "Merkez Mah",
      "Yeni Mah"
    ]
  },
  "Bitlis": {
    "Adilcevaz": [
      "Alacaatlı Mah",
      "Atatürk Mah",
      "Cevizli Mah",
      "Çayır Mah",
      "Hıdırşah Mah",
      "Kaleboynu Mah",
      "Orta Mah",
      "Selçuklu Mah",
      "Atatürk Mah (aydınlar Beldesi)",
      "Budaklı Mah (aydınlar Beldesi)",
      "Esentepe Mah (aydınlar Beldesi)",
      "Gültepe Mah (aydınlar Beldesi)",
      "İsmet Paşa Mah (aydınlar Beldesi)",
      "Kışkılı Mah (aydınlar Beldesi)",
      "Menderes Mah (aydınlar Beldesi)",
      "Akçıra Köyü",
      "Akyazı Köyü",
      "Asvalt Üstü Mah (erikbağı Köyü)",
      "Aşağı Mah (ipekçayır Köyü)",
      "Aşağı Mah (yarımada Köyü)",
      "Aşağısüphan Köyü",
      "Aygırgölü Köyü",
      "Ayvacık Mah (yukarısüphan Köyü)",
      "Bahçedere Köyü",
      "Cihangir Köyü",
      "Çanakyayla Köyü",
      "Dizdar Köyü",
      "Erikbağı Köyü",
      "Esenkıyı Köyü",
      "Gölbaşı Mah (akçıra Köyü)",
      "Göldüzü Köyü",
      "Gölüstü Köyü",
      "Gümüşdüven Köyü",
      "Harmantepe Köyü",
      "Heybeli Köyü",
      "Işıklar Mah (yukarısüphan Köyü)",
      "Karakol Köyü",
      "Karaşeyh Köyü",
      "Karşıyaka Köyü",
      "Kavuştuk Köyü",
      "Kömürlü Köyü",
      "Kuzel Mah (erikbağı Köyü)",
      "Mollafadıl Köyü",
      "Örentaş Köyü",
      "Sarıçay Mah (karakol Köyü)",
      "Sefasahil Köyü",
      "Yazlık Mah (karaşeyh Köyü)",
      "Yıldızköy Köyü",
      "Yolçatı Köyü",
      "Yukarı Mah (ipekçayır Köyü)",
      "Yukarı Mah (yarımada Köyü)",
      "Yukarısüphan Köyü"
    ],
    "Ahlat": [
      "Erkizan Mah",
      "Haraba Şehir Mah",
      "İki Kubbe Mah",
      "Kacer Mah",
      "Kale Mah",
      "Kırklar Mah",
      "Kulaksız Mah",
      "Selçuklu Mah",
      "Tahtı Süleyman Mah",
      "Tunus Mah",
      "1.küme Mah (cemalettin Köyü)",
      "1.küme Mah (çatalağzı Köyü)",
      "1.küme Mah (saka Köyü)",
      "2.küme Mah (cemalettin Köyü)",
      "2.küme Mah (çatalağzı Köyü)",
      "2.küme Mah (saka Köyü)",
      "Aşağı Küme Mah (uludere Köyü)",
      "Çukurtarla Köyü",
      "Kırkdönüm Köyü",
      "Kuşhane Köyü",
      "Saka Köyü",
      "Serinbayır Köyü",
      "Seyrantepe Köyü",
      "Soğanlı Köyü",
      "Taşharman Köyü",
      "Yolun Alt Mevkii Mah (develik Köyü)",
      "Yolun Sağı Mah (kınalıkoç Köyü)",
      "Yolun Sağı Mah (yeniköprü Köyü)",
      "Yolun Solu Mah (kınalıkoç Köyü)",
      "Yolun Solu Mah (yeniköprü Köyü)",
      "Yolun Üst Mevkii Mah (develik Köyü)",
      "Yukarı Küme Mah (uludere Köyü)",
      "Yuvadamı Köyü",
      "1. Küme Mah (güzelsu Köyü)",
      "1.küme Mah (alakır Köyü)",
      "2.küme Mah (alakır Köyü)",
      "2.küme Mah (güzelsu Köyü)",
      "3.küme Mah (alakır Köyü)",
      "Akçaören Köyü",
      "Bahçe Köyü",
      "Burcukaya Köyü",
      "Dilburnu Köyü",
      "Gölgören Köyü",
      "Karaağaç Mah (kırıkkaya Köyü)",
      "Kırıkkaya Köyü",
      "Kurtuluş Mah (ovakışla Beldesi)",
      "Kültür Mah (ovakışla Beldesi)",
      "Nazik Köyü",
      "Orta Mah (ovakışla Beldesi)",
      "Otluyazı Köyü",
      "Saray Mah (ovakışla Beldesi)",
      "Yıldızlar Mah (ovakışla Beldesi)",
      "Yoğurtyemez Köyü"
    ],
    "Güroymak": [
      "Gültepe Mah (gölbaşı Beldesi)",
      "Köşk Mah (gölbaşı Beldesi)",
      "Şenkaya Mah (gölbaşı Beldesi)",
      "Şenyayla Mah (gölbaşı Beldesi)",
      "Yeni Mah (gölbaşı Beldesi)",
      "Yeşiltepe Mah (gölbaşı Beldesi)",
      "Cami Mah (günkırı Beldesi)",
      "Cumhuriyet Mah (günkırı Beldesi)",
      "Hürriyet Mah (günkırı Beldesi)",
      "Pınarbaşı Mah (günkırı Beldesi)",
      "Refahiye Mah (günkırı Beldesi)",
      "Şenyurt Mah (günkırı Beldesi)",
      "Yeşilyurt Mah (günkırı Beldesi)",
      "Bağlar Mah",
      "Barajyolu Mah",
      "Barış Mah",
      "Bölmedere Mah",
      "Erentepe Mah",
      "Girne Mah",
      "Haydar Mah",
      "Kümbet Mah",
      "Nurtepe Mah",
      "Şenevler Mah",
      "Şenova Mah",
      "Şentepe Mah",
      "Şirintepe Mah",
      "Uğurlu Mah",
      "Yeşilova Mah",
      "Akbulut Mah (çayarası Köyü)",
      "Arpacık Köyü",
      "Aşağıkolbaşı Köyü",
      "Budaklı Köyü",
      "Cevizyatağı Köyü",
      "Çallı Köyü",
      "Çayarası Köyü",
      "Çıtak Köyü",
      "Değirmen Köyü",
      "Gedikpınar Köyü",
      "Güzelli Köyü",
      "Işıklı Mah (saklı Köyü)",
      "Kaleli Köyü",
      "Kani Reş Mah (çıtak Köyü)",
      "Kavunlu Köyü",
      "Keklikpınar Tescilsiz Mezrası Mah (gedikpınar Köyü)",
      "Kekliktepe Köyü",
      "Konak Mah (arpacık Köyü)",
      "Köşk Mah (değirmen Köyü)",
      "Kuştaşı Köyü",
      "Oduncular Köyü",
      "Özkavak Köyü",
      "Saklı Köyü",
      "Sorani Mah (budaklı Köyü)",
      "Sütderesi Köyü",
      "Tahtalı Köyü",
      "Taşüstü Köyü",
      "Üzümveren Köyü",
      "Yağmurlu Mah (kaleli Köyü)",
      "Yamaçköy Köyü",
      "Yayladere Köyü",
      "Yazıkonak Köyü",
      "Yemişveren Köyü",
      "Yukarıkolbaşı Köyü"
    ],
    "Hizan": [
      "Altınoluk Mah",
      "Aşağıkarasu Mah",
      "Bahçelievler Mah",
      "Esentepe Mah",
      "Gökçimen Mah",
      "Kültür Mah",
      "Taşlı Pınar Mah",
      "Yemişli Mah",
      "Yeni Kent Mah",
      "Yeşil Ova Mah",
      "Ağaçlı Mah (gayda Köyü)",
      "Ağılözü Köyü",
      "Akbaş Mah (horozdere Köyü)",
      "Akbıyık Köyü",
      "Akça Köyü",
      "Akçakonak Mah (gönüllü Köyü)",
      "Akçevre Köyü",
      "Akdik Köyü",
      "Akdik Mah (akdik Köyü)",
      "Akdiken Mah (doğancı Köyü)",
      "Akköprü Mah (akbıyık Köyü)",
      "Akşar Köyü",
      "Akyazı Mah (sarıtaş Köyü)",
      "Akyol Mah (koçyiğit Köyü)",
      "Aladana Köyü",
      "Alancık Mah (koçyiğit Köyü)",
      "Alyanak Mah (ağılözü Köyü)",
      "Aşağı Aksüt Mah (ballıca Köyü)",
      "Aşağı Ayvacık Mah (nurs Köyü)",
      "Aşağı Kazanlı Mah (gayda Köyü)",
      "Aşağı Şenlik Mah (nurs Köyü)",
      "Avlak Mah (karbastı Köyü)",
      "Aybattı Mah (meydan Köyü)",
      "Ayrancı Mah (bölüklü Köyü)",
      "Bağbaşı Mah (ağılözü Köyü)",
      "Bağışlı Mah (gayda Köyü)",
      "Bağlararası Mah (meydan Köyü)",
      "Bahçedere Mah (çökekyazı Köyü)",
      "Ballı Köyü",
      "Ballıca Köyü",
      "Bayır Mah (esenler Köyü)",
      "Bereket Mah (ağılözü Köyü)",
      "Besili Mah (sarpkaya Köyü)",
      "Beyari Mah (akşar Köyü)",
      "Bilgili Mah (yaylacık Köyü)",
      "Bozpınar Köyü",
      "Bölüklü Köyü",
      "Budaklı Köyü",
      "Cevizli Mah (kalkanlı Köyü)",
      "Çakırkaya Mah (örgülü Köyü)",
      "Çalışkanlar Köyü",
      "Çatakdeğirmen Köyü",
      "Çavuşlar Mah (nurs Köyü)",
      "Çayır Köyü",
      "Çayırlı Mah (çatakdeğirmen Köyü)",
      "Çevrecik Mah (akşar Köyü)",
      "Çıkçık Mah (ürünveren Köyü)",
      "Çiçekli Mah (kapısuyu Köyü)",
      "Çökekyazı Köyü",
      "Dağören Köyü",
      "Dayılar Köyü",
      "Deliklitaş Mah (ekinli Köyü)",
      "Dereağzı Mah (süttaşı Köyü)",
      "Derince Köyü",
      "Dibekli Mah (kapısuyu Köyü)",
      "Dilek Mah (nurs Köyü)",
      "Doğancı Köyü",
      "Doğrular Mah (esenler Köyü)",
      "Doyumlu Mah (koçyiğit Köyü)",
      "Döküktaş Köyü",
      "Durak Mah (gayda Köyü)",
      "Düztepe Mah (akşar Köyü)",
      "Ekinli Köyü",
      "Ekintepe Köyü",
      "Elmacık Köyü",
      "Elmalı Mah (elmacık Köyü)",
      "Erencik Köyü",
      "Esenler Köyü",
      "Fıstıklı Mah (sağırkaya Köyü)",
      "Gayda Köyü",
      "Gedik Mah (sarıtaş Köyü)",
      "Gelincik Mah (elmacık Köyü)",
      "Gökay Köyü",
      "Göktepe Köyü",
      "Gönüllü Köyü",
      "Göze Mah (kalkanlı Köyü)",
      "Güçlü Mah (horozdere Köyü)",
      "Gümüşoluk Mah (yenicik Köyü)",
      "Güngören Köyü",
      "Gürece Köyü",
      "Güvendik Mah (ağılözü Köyü)",
      "Hacımehmet Köyü",
      "Harmandöven Köyü",
      "Hıdır Mah (içlikaval Köyü)",
      "Horozdere Köyü",
      "İçlikaval Köyü",
      "İncirli Köyü",
      "Kalkanlı Köyü",
      "Kapısuyu Köyü",
      "Karaağaç Köyü",
      "Karadal Mah (keklik Köyü)",
      "Karaduman Mah (esenler Köyü)",
      "Karakoyun Mah (ürünveren Köyü)",
      "Karbastı Köyü",
      "Kardeşlik Mah (yığınkaya Köyü)",
      "Karlıtepe Köyü",
      "Kaval Mah (çayır Köyü)",
      "Kayadeler Köyü",
      "Kayalar Mah (gayda Köyü)",
      "Kayalı Köyü",
      "Kayaş Mah (döküktaş Köyü)",
      "Kaymaklı Köyü",
      "Keçeli Köyü",
      "Keklik Köyü",
      "Kestaneli Mah (karbastı Köyü)",
      "Kezer Mah (akçevre Köyü)",
      "Kılavuz Mah (akşar Köyü)",
      "Kıratlı Mah (keçeli Köyü)",
      "Kilimli Mah (keçeli Köyü)",
      "Kiş Mah (çatakdeğirmen Köyü)",
      "Koç Mah (karbastı Köyü)",
      "Koçlu Köyü",
      "Koçyiğit Köyü",
      "Kolludere Köyü",
      "Konak Mah (sarpkaya Köyü)",
      "Konaklar Mah (esenler Köyü)",
      "Koşluca Mah (sarpkaya Köyü)",
      "Koyunlu Köyü",
      "Köprü Mah (gayda Köyü)",
      "Köprü Mah (yelkıran Köyü)",
      "Mahmutlar Mah (akçevre Köyü)",
      "Meşelik Mah (horozdere Köyü)",
      "Meydan Köyü",
      "Mut Mah (sarpkaya Köyü)",
      "Nuh Köyü",
      "Nurs Köyü",
      "Ocak Mah (meydan Köyü)",
      "Oğlaklı Mah (oğlaklı Köyü)",
      "Ortaca Köyü",
      "Otlu Mah (harmandöven Köyü)",
      "Otluca Mah (esenler Köyü)",
      "Otluca Mah (horozdere Köyü)",
      "Ovi Mah (sağınlı Köyü)",
      "Oymapınar Köyü",
      "Ölçülü Mah (bozpınar Köyü)",
      "Örenbaş Mah (akçevre Köyü)",
      "Örgülü Köyü",
      "Özenli Mah (sarıtaş Köyü)",
      "Öztoprak Mah (sarpkaya Köyü)",
      "Sağınlı Köyü",
      "Sağırkaya Köyü",
      "Samanyolu Mah (budaklı Köyü)",
      "Sarıbal Mah (yaylacık Köyü)",
      "Sarıtaş Köyü",
      "Sarpkaya Köyü",
      "Soğuksu Köyü",
      "Sürücüler Köyü",
      "Süttaşı Köyü",
      "Taş Mah (karbastı Köyü)",
      "Taşevler Mah (akşar Köyü)",
      "Topağacı Mah (bölüklü Köyü)",
      "Topluca Mah (döküktaş Köyü)",
      "Tuğlu Mah (ürünveren Köyü)",
      "Tutumlu Köyü",
      "Uzuntaş Köyü",
      "Üçkardeş Mah (meydan Köyü)",
      "Ürünveren Köyü",
      "Üspiislam Mah (esenler Köyü)",
      "Üzümlü Mah (horozdere Köyü)",
      "Verimli Mah (akşar Köyü)",
      "Yamaç Mah (karbastı Köyü)",
      "Yapağı Mah (ürünveren Köyü)",
      "Yaylacık Köyü",
      "Yaylalı Mah (yukarıayvacık Köyü)",
      "Yazmalı Mah (kapısuyu Köyü)",
      "Yedikardeş Mah (aladana Köyü)",
      "Yelkıran Köyü",
      "Yenicik Köyü",
      "Yeniçay Mah (yolbilen Köyü)",
      "Yenigün Mah (döküktaş Köyü)",
      "Yığınkaya Köyü",
      "Yoğurtlu Köyü",
      "Yolbaşı Mah (gayda Köyü)",
      "Yolbilen Köyü",
      "Yoluslu Mah (karbastı Köyü)",
      "Yukarı Aksüt Mah (ballıca Köyü)",
      "Yukarı Gelincik Mah (nurs Köyü)",
      "Yukarı Kazanlı Mah (gayda Köyü)",
      "Yukarı Şenlik Mah (nurs Köyü)",
      "Yukarıayvacık Köyü",
      "Yukarıçalı Köyü",
      "Yumacık Mah (yenicik Köyü)",
      "Yurtiçi Mah (sarpkaya Köyü)",
      "Zivi Mah (gayda Köyü)"
    ],
    "Merkez": [
      "Atatürk Mah",
      "Beş Minare Mah",
      "Gazi Bey Mah",
      "Hersan Mah",
      "Hüsrev Paşa Mah",
      "İnönü Mah",
      "Muştakbaba Mah",
      "Saray Mah",
      "Sekiz Ağustos Mah",
      "Şemsi Bitlis Mah",
      "Taş Mah",
      "Yükseliş Mah",
      "Zeydan Mah",
      "Akçalı Köyü",
      "Arıdağ Köyü",
      "Aşağıbalcılar Köyü",
      "Aşağıölek Köyü",
      "Başmaklı Köyü",
      "Bayramalan Köyü",
      "Boylu Mah (geçitbaşı Köyü)",
      "Bölükyazı Köyü",
      "Çadırlı Mah (doğruyol Köyü)",
      "Çayırbaşı Köyü",
      "Çaylı Mah (kokarsu Köyü)",
      "Çubuk Mah (kokarsu Köyü)",
      "Dereağzı Köyü",
      "Doğruyol Köyü",
      "Geçitbaşı Köyü",
      "Ilıcak Köyü",
      "İçgeçit Köyü",
      "Kaplı Mah (geçitbaşı Köyü)",
      "Kavakdibi Köyü",
      "Kayabaşı Köyü",
      "Keklikdüzü Köyü",
      "Kokarsu Köyü",
      "Kulibik Tescilsiz Mezra Mah (arıdağ Köyü)",
      "Kuşlu Mah (keklikdüzü Köyü)",
      "Oğulcak Köyü",
      "Ören Mah (yolcular Köyü)",
      "Samanlı Mah (yolcular Köyü)",
      "Üçevler Köyü",
      "Yayalar Köyü",
      "Yolağzı Köyü",
      "Yolcular Köyü",
      "Yukarı Yuvacık Mah (yuvacık Köyü)",
      "Yukarıbalcılar Köyü",
      "Yukarıölek Köyü",
      "Yuvacık Köyü",
      "Ağaçdere Köyü",
      "Ağaçköprü Köyü",
      "Ağaçpınar Köyü",
      "Akçalı Mah (tabanözü Köyü)",
      "Akgün Mah (çobansuyu Köyü)",
      "Aktaş Mah (alaniçi Köyü)",
      "Alaniçi Köyü",
      "Aşağıkaraboy Köyü",
      "Aşağıkoç Mah (aşağıyolak Köyü)",
      "Aşağıyolak Köyü",
      "Ayrancılar Köyü",
      "Başhan Köyü",
      "Bayırlı Mah (kınalı Köyü)",
      "Beşkaynak Köyü",
      "Buğdaylı Mah (tabanözü Köyü)",
      "Cevizdalı Köyü",
      "Cevizüstü Mah (dörtağaç Köyü)",
      "Cumhuriyet 2 Mah (cumhuriyet Köyü)",
      "Cumhuriyet Köyü",
      "Çalıdüzü Köyü",
      "Çallı Mah (çeltikli Köyü)",
      "Çayır Mah (tatlıkaynak Köyü)",
      "Çeltikli Köyü",
      "Çobansuyu Köyü",
      "Değirmenaltı Köyü",
      "Deliktaş Köyü",
      "Dikme Köyü",
      "Direktaşı Köyü",
      "Doğanlı Mah (karbastı Köyü)",
      "Dörtağaç Köyü",
      "Döşkaya Köyü",
      "Ekinli Köyü",
      "Esen Mah (sarpkaya Köyü)",
      "İçmeli Köyü",
      "Karakaş Mah (aşağıyolak Köyü)",
      "Karınca Köyü",
      "Kayadağ Mah (kayadağ Köyü)",
      "Keçeli Mah (ortakapı Köyü)",
      "Kılyat Mah (tanrıyar Köyü)",
      "Kireçtaşı Köyü",
      "Konalga Köyü",
      "Konuksayar Köyü",
      "Koruk Köyü",
      "Kömüryakan Köyü",
      "Kutlu Mah (çobansuyu Köyü)",
      "Küllice Mah (esenburun Köyü)",
      "Küllüce Köyü",
      "Narlıdere Köyü",
      "Ortakapı Köyü",
      "Otluk Mah (deliktaş Köyü)",
      "Sarıkonak Köyü",
      "Sarıyıldız Mah (aşağıkaraboy Köyü)",
      "Sinekar Mah (kayalıbağ Köyü)",
      "Şehitlik Tescilsiz Mezrası Mah (tanrıyar Köyü)",
      "Tabanözü Köyü",
      "Tanrıyar Köyü",
      "Taş Mah (ağaçköprü Köyü)",
      "Tatlıkaynak Köyü",
      "Tınar Köyü",
      "Uçankuş Köyü",
      "Ünaldı Köyü",
      "Yanlızçamlar Köyü",
      "Yarönü Köyü",
      "Yavuzlar Mah (çalıdüzü Köyü)",
      "Yaygın Köyü",
      "Yenice Mah (alaniçi Köyü)",
      "Yeşilsırt Köyü",
      "Yolyazı Köyü",
      "Yukarıkaraboy Köyü",
      "Yukarıyolak Köyü",
      "Yumurtatepe Köyü",
      "Yücebaş Köyü",
      "Ziyaret Mah (sarpkaya Köyü)",
      "Boztepe Mah (yolalan Beldesi)",
      "Çınarbaşı Mah (yolalan Beldesi)",
      "Düz Mah (yolalan Beldesi)",
      "Kale Mah (yolalan Beldesi)",
      "Konaç Mah (yolalan Beldesi)",
      "Pınarbaşı Mah (yolalan Beldesi)",
      "Üç Kardeş Mah (yolalan Beldesi)",
      "Yeni Mah (yolalan Beldesi)",
      "Yolalan Mah (yolalan Beldesi)"
    ],
    "Mutki": [
      "Bağ Mah (çiğdemalan Köyü)",
      "Beyaz Su Mah (yuvalıdam Köyü)",
      "Çiğdemalan Köyü",
      "Esenyurt Mah (geyikpınar Köyü)",
      "Geyikpınar Köyü",
      "Kapıkaya Köyü",
      "Kaşak Köyü",
      "Kayran Köyü",
      "Köprübaşı Mah (kayran Köyü)",
      "Ocakbaşı Mah (tolgalı Köyü)",
      "Ölçülü Mah (geyikpınar Köyü)",
      "Sivrice Mah (tolgalı Köyü)",
      "Taş Mah (geyikpınar Köyü)",
      "Taşyol Mah (kayran Köyü)",
      "Tolgalı Köyü",
      "Yanıkçakır Köyü",
      "Yazıcık Köyü",
      "Yuvalıdam Köyü",
      "Arpalıseki Mah (kavakbaşı Beldesi)",
      "Cami Mah (kavakbaşı Beldesi)",
      "Çimen Mah (kavakbaşı Beldesi)",
      "Gölbaşı Mah (kavakbaşı Beldesi)",
      "Orta Mah (kavakbaşı Beldesi)",
      "Yeni Mah (kavakbaşı Beldesi)",
      "Yüksekova Mah (kavakbaşı Beldesi)",
      "Ağıllı Mah (bozburun Köyü)",
      "Akçaağaç Köyü",
      "Akıncı Köyü",
      "Akpınar Köyü",
      "Aksakal Mah (göztepe Köyü)",
      "Alatoprak Köyü",
      "Alıcık Köyü",
      "Alkoyun Köyü",
      "Aydemir Köyü",
      "Aydınlar Mah (akıncı Köyü)",
      "Bahçeli Mah (erler Köyü)",
      "Balkaya Mah (ikizler Köyü)",
      "Beşevler Köyü",
      "Boğazönü Köyü",
      "Bozburun Köyü",
      "Çağdaş Mah (akçaağaç Köyü)",
      "Çanaklı Mah (alatoprak Köyü)",
      "Çatalsöğüt Köyü",
      "Çaygeçit Köyü",
      "Çayırlı Köyü",
      "Çevreli Mah (çitliyol Köyü)",
      "Çığır Köyü",
      "Çitliyol Köyü",
      "Çukurca Mah (ikizler Köyü)",
      "Dağarcık Köyü",
      "Dağlık Köyü",
      "Dereönü Mah (erler Köyü)",
      "Dereyolu Köyü",
      "Ekizler Köyü",
      "Erler Köyü",
      "Eyubiye Mah (koyunlu Köyü)",
      "Fatih Mah (koyunlu Köyü)",
      "Göztepe Köyü",
      "Güvenli Mah (bozburun Köyü)",
      "Havarik Mah (erler Köyü)",
      "Ilıcak Mah (alatoprak Köyü)",
      "İkizler Köyü",
      "İnişli Mah (üstyayla Köyü)",
      "Kapaklı Köyü",
      "Kayabaşı Köyü",
      "Kocainiş Köyü",
      "Kuşcu Mah (dağlık Köyü)",
      "Kuşdili Köyü",
      "Küllüce Köyü",
      "Levent Mah (koyunlu Köyü)",
      "Merkez Mah (çitliyol Köyü)",
      "Mezra Mah (çaygeçit Köyü)",
      "Ocaklı Mah (çığır Köyü)",
      "Oluklu Köyü",
      "Onbaşı Mah (kocainiş Köyü)",
      "Ömeriye Mah (koyunlu Köyü)",
      "Özenli Köyü",
      "Sarıçiçek Köyü",
      "Sekiliyazı Köyü",
      "Serince Mah (bozburun Köyü)",
      "Şerefhan Mah (alatoprak Köyü)",
      "Taşkapı Mah (çaygeçit Köyü)",
      "Tosunlar Mah (üstyayla Köyü)",
      "Uğur Mah (ikizler Köyü)",
      "Ulaş Mah (yenidoğan Köyü)",
      "Uran Köyü",
      "Üstyayla Köyü",
      "Yalıntaş Köyü",
      "Yenidoğan Köyü",
      "Yeniköy Köyü",
      "Yeşilce Mah (oluklu Köyü)",
      "Yeşilyurt Mah (alatoprak Köyü)",
      "Yiğitler Mah (dağlık Köyü)",
      "Yoncalı Mah (ekizler Köyü)",
      "Yumrumeşe Köyü",
      "Açıkalan Köyü",
      "Akarsu Mah (bağarası Köyü)",
      "Aşağı Uzunyar Mah (uzunyar Köyü)",
      "Atbaşı Mah (gümüşkanat Köyü)",
      "Aydınlık Mah (karabudak Köyü)",
      "Bağarası Köyü",
      "Bağlık Mah (üçadım Köyü)",
      "Ballı Köyü",
      "Başçavuş Mah (gümüşkanat Köyü)",
      "Bekçiler Mah (çatalerik Köyü)",
      "Cevizli Mah (bağarası Köyü)",
      "Cevizli Mah (gümüşkanat Köyü)",
      "Ç.meşe Mah (gümüşkanat Köyü)",
      "Çatalerik Köyü",
      "Dere Mah (karabudak Köyü)",
      "Gosing Mah (taşboğaz Köyü)",
      "Gül Mah (karabudak Köyü)",
      "Gümüşkanat Köyü",
      "Karabudak Köyü",
      "Kaşıklı Köyü",
      "Koçyatağı Mah (çatalerik Köyü)",
      "Kovanlı Köyü",
      "Kurtyan Mah (uzunyar Köyü)",
      "Kütüklü Mah (ballı Köyü)",
      "Merkez Mah (taşboğaz Köyü)",
      "Meşelik Mah (gümüşkanat Köyü)",
      "Meydan Köyü",
      "Övencik Mah (gümüşkanat Köyü)",
      "Salman Köyü",
      "Sarıçubuk Mah (çatalerik Köyü)",
      "Taşlık Mah (üçadım Köyü)",
      "Tescilsiz Mah (salman Köyü)",
      "Uzunyar Köyü",
      "Uzunyol Mah (meydan Köyü)",
      "Üçadım Köyü",
      "Üçevler Mah (bağarası Köyü)",
      "Vaskar Mah (taşboğaz Köyü)",
      "Vezik Mah (gümüşkanat Köyü)",
      "Yağlıca Mah (taşboğaz Köyü)",
      "Yalçınkaya Mah (bağarası Köyü)",
      "Yıldız Mah (gümüşkanat Köyü)",
      "Yuvalı Mah (taşboğaz Köyü)",
      "Yünlü Mah (kovanlı Köyü)",
      "Zeydan Mah (meydan Köyü)",
      "Pınarbaşı Mah",
      "Taşlı Pınar Mah",
      "Yeni Mah",
      "Yenibağ Mah"
    ],
    "Tatvan": [
      "2.km Mah (adabağ Köyü)",
      "Adabağ Köyü",
      "Benekli Köyü",
      "Beştaş Mah (adabağ Köyü)",
      "Çekmece Köyü",
      "Dalda Köyü",
      "Kıyıdüzü Köyü",
      "Örenlik Köyü",
      "Sarıkum Köyü",
      "Yumurtatepe Köyü",
      "Aydınlar Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Dumlupınar Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Fuar Mah",
      "Hidayet Mah",
      "İşletme Mah",
      "Kale Mah",
      "Karataş Mah",
      "Karşıyaka Mah",
      "Kültür Mah",
      "Pınarbaşı Mah",
      "Sahil Mah",
      "Saray Mah",
      "Sosyal Mah",
      "Şirinevler Mah",
      "Tuğ Mah",
      "Yeni Mah",
      "Yeşilmezra Mah",
      "Aksoğan Mah (alacabük Köyü)",
      "Aktoprak Mah (dönertaş Köyü)",
      "Alacabük Köyü",
      "Anadere Köyü",
      "Arılı Mah (dibekli Köyü)",
      "Bağmeşesi Mah (çanakdüzü Köyü)",
      "Beşikli Mah (teknecik Köyü)",
      "Beşparmak Mah (koruklu Köyü)",
      "Bolalan Köyü",
      "Budaklı Köyü",
      "Çalıdüzü Köyü",
      "Çamaltı Mah (düzcealan Köyü)",
      "Çanakdüzü Köyü",
      "Çataltaş Mah (bolalan Köyü)",
      "Çavuşlar Köyü",
      "Çevre Köyü",
      "Çörekli Mah (sarıdal Köyü)",
      "Dağdibi Köyü",
      "Dibekli Köyü",
      "Dirlik Mah (suboyu Köyü)",
      "Doluca Mah (budaklı Köyü)",
      "Dönertaş Köyü",
      "Düzcealan Köyü",
      "Eğritaş Köyü",
      "Ekindüzü Mah (ulusoy Köyü)",
      "Emek Mah (köprücük Köyü)",
      "Gölgele Mah (dönertaş Köyü)",
      "Göllü Köyü",
      "Güntepe Köyü",
      "Güreşçi Köyü",
      "Güvenli Mah (uncular Köyü)",
      "Hanelmalı Köyü",
      "Harmanlı Köyü",
      "İncekaya Mah (bolalan Köyü)",
      "Kağanlı Köyü",
      "Karaçalı Mah (kuşluca Köyü)",
      "Kaynarca Köyü",
      "Kepenek Mah (kısıklı Köyü)",
      "Kırkbulak Köyü",
      "Kısıklı Köyü",
      "Kolbaşı Köyü",
      "Koruklu Köyü",
      "Koyluca Köyü",
      "Koyunpınarı Köyü",
      "Kömürlü Mah (teknecik Köyü)",
      "Köprücük Köyü",
      "Kuruyaka Köyü",
      "Kuşluca Köyü",
      "Küçüksu Köyü",
      "Nohutlu Köyü",
      "Obuz Köyü",
      "Odabaşı Köyü",
      "Ortaklar Mah (koyunpınarı Köyü)",
      "Özekli Mah (sallıca Köyü)",
      "Paşaelmalı Mah (tokaçlı Köyü)",
      "Pekmezli Mah (köprücük Köyü)",
      "Pınarlı Mah (yediveren Köyü)",
      "Sallıca Köyü",
      "Sandıklı Mah (köprücük Köyü)",
      "Sarıdal Köyü",
      "Söğütlü Köyü",
      "Suboyu Köyü",
      "Sugurlu Mah (odabaşı Köyü)",
      "Taşdemir Mah (güreşçi Köyü)",
      "Taştop Mah (eğritaş Köyü)",
      "Teknecik Köyü",
      "Tokaçlı Köyü",
      "Top Mah (eğritaş Köyü)",
      "Topraklı Köyü",
      "Tosunlu Köyü",
      "Uçankuş Mah (sarıdal Köyü)",
      "Ulusoy Köyü",
      "Uncular Köyü",
      "Uslu Köyü",
      "Ustabaşı Mah (budaklı Köyü)",
      "Üçtepe Mah (kuşluca Köyü)",
      "Üzümlü Mah (çavuşlar Köyü)",
      "Yapraklı Mah (kağanlı Köyü)",
      "Yassıca Köyü",
      "Yayıklı Mah (göllü Köyü)",
      "Yediveren Köyü",
      "Yelkenli Köyü",
      "Yenitoprak Mah (koruklu Köyü)",
      "Yoncabaşı Köyü",
      "Yorgalar Mah (sarıdal Köyü)",
      "Yumrukaya Köyü"
    ]
  },
  "Bolu": {
    "Dörtdivan": [
      "Adakınık Mah",
      "Bayramlar Mah",
      "Çavuşlar Mah",
      "Çitler Mah",
      "Deveciler Mah",
      "Hacetler Mah",
      "Kadılar Mah",
      "Kargıbayramlar Mah",
      "Adaköy Merkez Mah (adaköy Köyü)",
      "Aladağ Mah (sorkun Köyü)",
      "Aladağ Mah (yukarıdüğer Köyü)",
      "Aşağı Mah (doğancılar Köyü)",
      "Aşağı Mah (sorkun Köyü)",
      "Aşağı Mah (yukarıdüğer Köyü)",
      "Aşağı Mandıra Mah (sorkun Köyü)",
      "Aşağı Yayla Mah (göbüler Köyü)",
      "Aşağı Yayla Mah (ömerpaşalar Köyü)",
      "Aşağı Yayla Mah (yukarıdüğer Köyü)",
      "Aşağıdüğer Merkez Mah (aşağıdüğer Köyü)",
      "Aşağıdüğer Yaylası Mah (aşağıdüğer Köyü)",
      "Aşağıdülger Mah (dülger Köyü)",
      "Aşağısayık Merkez Mah (aşağısayık Köyü)",
      "Azaplar Mah (ömerpaşalar Köyü)",
      "Batı Mah (bünüş Köyü)",
      "Bayır Mah (doğancılar Köyü)",
      "Bıçkı Yaylası Mah (sorkun Köyü)",
      "Bünüş Aladağı Mah (bünüş Köyü)",
      "Bünüş Mandırası Mah (bünüş Köyü)",
      "Bünüş Merkez Mah (bünüş Köyü)",
      "Cemaller Çiçekli Yaylası Mah (cemaller Köyü)",
      "Cemaller Hokak Yaylası Mah (cemaller Köyü)",
      "Cemaller Karagöz Yaylası Mah (cemaller Köyü)",
      "Cemaller Kirazlı Yaylası Mah (cemaller Köyü)",
      "Cemaller Merkez Mah (cemaller Köyü)",
      "Çalköy Beydüşlüh Mah.yaylası Mah (çalköy Köyü)",
      "Çalköy Köroğlu Yaylası Mah (çalköy Köyü)",
      "Çalköy Merkez Mah (çalköy Köyü)",
      "Çardak Köyü",
      "Çardak Yaylası Mah (çardak Köyü)",
      "Çetikören Aladağ Yaylası Mah (çetikören Köyü)",
      "Çetikören Kirazlı Yaylası Mah (çetikören Köyü)",
      "Çetikören Mandıraları Mah (çetikören Köyü)",
      "Çimencik Yaylası Mah (ömerpaşalar Köyü)",
      "Çukurca Aladağı Mah (aşağısayık Köyü)",
      "Çukurca Yaylası Mah (yukarısayık Köyü)",
      "Dülger Merkez Mah (dülger Köyü)",
      "Gerede Yolu Mah (doğancılar Köyü)",
      "Göbüler Merkez Mah (göbüler Köyü)",
      "Göl Yayla Mah (bünüş Köyü)",
      "Göllü Yayla Mah (sorkun Köyü)",
      "Gücükler Merkez Mah (gücükler Köyü)",
      "Gücükler Yaylası Mah (gücükler Köyü)",
      "Hasinler Mah (aşağısayık Köyü)",
      "İmamlar Mah (doğancılar Köyü)",
      "Kabaklar Mah (yağbaşlar Köyü)",
      "Kabaklar Yaylası Mah (yağbaşlar Köyü)",
      "Kadirler Mah (doğancılar Köyü)",
      "Karaçayır Yaylası Mah (doğancılar Köyü)",
      "Karslar Mah (gücükler Köyü)",
      "Kılıçlar Merkez Mah (kılıçlar Köyü)",
      "Kılıçlar Yaylası Mah (kılıçlar Köyü)",
      "Kirazlı Yayla Mah (ortaköy Köyü)",
      "Konaklar Mah (çetikören Köyü)",
      "Kuruca Köyü",
      "Kuzköy Mah (kılıçlar Köyü)",
      "Mandıra Mah (aşağısayık Köyü)",
      "Mursallar  Yaylası Mah (yağbaşlar Köyü)",
      "Mursallar Mah (yağbaşlar Köyü)",
      "Nahçıvan Mah (adaköy Köyü)",
      "Ortaköy Merkez Mah (ortaköy Köyü)",
      "Ömerpaşalar Merkez Mah (ömerpaşalar Köyü)",
      "Seyitaliler Merkez Mah (seyitaliler Köyü)",
      "Softalar Mah (göbüler Köyü)",
      "Süleler Merkez Mah (süleler Köyü)",
      "Şahallar Mah (doğancılar Köyü)",
      "Tabaklar Mah (doğancılar Köyü)",
      "Tepecik Mah (çetikören Köyü)",
      "Uzunlar Mah (doğancılar Köyü)",
      "Yağbaşlar Merkez Mah (yağbaşlar Köyü)",
      "Yağbaşlar Yaylası Mah (yağbaşlar Köyü)",
      "Yalacık Köyü",
      "Yalacık Yaylası Mah (yalacık Köyü)",
      "Yaslıcalı Yaylası Mah (ortaköy Köyü)",
      "Yayalar Köyü",
      "Yayla Mah (aşağısayık Köyü)",
      "Yeni Mah (ömerpaşalar Köyü)",
      "Yeni Mah (sorkun Köyü)",
      "Yeni Mah (yukarıdüğer Köyü)",
      "Yukarı Mah (sorkun Köyü)",
      "Yukarı Mah (yukarıdüğer Köyü)",
      "Yukarı Mandıra Mah (sorkun Köyü)",
      "Yukarı Yayla Mah (göbüler Köyü)",
      "Yukarısayık Merkez Mah (yukarısayık Köyü)"
    ],
    "Gerede": [
      "Bahçelievler Mah",
      "Dayıoğlu Mah",
      "Demirciler Mah",
      "Demircilerosb Mah",
      "Kabiller Mah",
      "Kitirler Mah",
      "Orta Mah",
      "Seviller Mah",
      "Yeni Mah",
      "Afatlar Mah (yazıköy Köyü)",
      "Afatlar Yayla Mah (yazıköy Köyü)",
      "Ağagil Mah (karacadağdemirciler Köyü)",
      "Akçagil Mah (çağış Köyü)",
      "Akkadim Mah (ortaca Köyü)",
      "Aktaş Mah (aktaşkurtlar Köyü)",
      "Apsarı Mah (yeşilvadi Köyü)",
      "Aşağı Mah (balcılar Köyü)",
      "Aşağı Mah (bünüş Köyü)",
      "Aşağı Mah (nuhören Köyü)",
      "Aşağı Yayla Mah (göynükören Köyü)",
      "Avcılar Mah (yukarıörenbaşı Köyü)",
      "Avlasızgil Mah (karacadağdemirciler Köyü)",
      "Ayvatlar Mah (göynükören Köyü)",
      "Baltacılar Mah (örencik Köyü)",
      "Battallar Mah (aydınlar Köyü)",
      "Bıçakcılar Mah (güneydemirciler Köyü)",
      "Bıçakcılar Yayla Mah (güneydemirciler Köyü)",
      "Birinciafşar Köyü",
      "Bozkuş Mah (aktaşkurtlar Köyü)",
      "Bozuklar Mah (davutbeyli Köyü)",
      "Burgucu Mah (eymür Köyü)",
      "Çağış Mah (çağış Köyü)",
      "Çağış Yaylası Mah (çağış Köyü)",
      "Çalca Mah (asmaca Köyü)",
      "Çengeller Mah (muratfakılar Köyü)",
      "Çengeller Yayla Mah (muratfakılar Köyü)",
      "Çobanlar Mah (göynükören Köyü)",
      "Çongallar Mah (macarlar Köyü)",
      "Çukur Mah (yunuslar Köyü)",
      "Demirci Mah (külef Köyü)",
      "Demirci Mah (yukarıörenbaşı Köyü)",
      "Demirciler  Mah (merkez Mah) (güneydemirciler Köyü)",
      "Dere  Mah (merkez Mah) (çayörengüney Köyü)",
      "Dere Mah (kapaklı Köyü)",
      "Dere Mah (karacadağdemirciler Köyü)",
      "Dereköy Mah (karacadağ Köyü)",
      "Deveyatağı Yaylası Mah (karapazar Köyü)",
      "Deyişler Mah (sofular Köyü)",
      "Deyişler Yaylası Mah (sofular Köyü)",
      "Doğancılar Mah (akçabey Köyü)",
      "Dursunlar Mah (yakakaya Köyü)",
      "Dümenler Mah (geçitler Köyü)",
      "Dümenler Yayla Mah (geçitler Köyü)",
      "Ecinlioğlu Mah (macarlar Köyü)",
      "Ekmenler Mah (bahçedere Köyü)",
      "Eminağa Mah (beşkonak Köyü)",
      "Emirler Mah (sungurlar Köyü)",
      "Evrenler Mah (yakakaya Köyü)",
      "Fadıllar Mah (beşkonak Köyü)",
      "Gaziler Mah (güneydemirciler Köyü)",
      "Gaziler Yayla Mah (güneydemirciler Köyü)",
      "Gökçeler Mah (bahçedere Köyü)",
      "Gölcük Mah (aktaş Köyü)",
      "Gözümler Mah (demircisopran Köyü)",
      "Güney Mah (çayörengüney Köyü)",
      "Hacı İpekler Mah (güneydemirciler Köyü)",
      "Hacı Muslar Mah (demircisopran Köyü)",
      "Hatıplar Mah (enseliler Köyü)",
      "Ispahlar Mah (sipahiler Köyü)",
      "Işıklı Mah (ulaşlar Köyü)",
      "İmamlar Mah (karacadağdemirciler Köyü)",
      "İmanlar Mah (bahçedere Köyü)",
      "İmreşe Mah (mangallar Köyü)",
      "Kabaklar Mah (güneydemirciler Köyü)",
      "Kadimler Mah (ortaca Köyü)",
      "Kandak Mah (davutbeyli Köyü)",
      "Kapçı Evi Mah (çağış Köyü)",
      "Karakuz Mah (ertuğrulköy Köyü)",
      "Karşı Mah (beşkonak Köyü)",
      "Karşı Yayla Mah (çoğullu Köyü)",
      "Katırcıoğlu Mah (akçabey Köyü)",
      "Kayabaşı Mah (karacadağ Köyü)",
      "Kıncallar Mah (koçumlar Köyü)",
      "Kıncallar Yaylası Mah (koçumlar Köyü)",
      "Kırbızlar Mah (yukarıörenbaşı Köyü)",
      "Koçlar Mah (tatlar Köyü)",
      "Koçlar Yaylası Mah (tatlar Köyü)",
      "Köseler Mah (akçabey Köyü)",
      "Köy Yaylası Mah (bahçedere Köyü)",
      "Kurtça Mah (yağdaş Köyü)",
      "Kurtlar Mah (aktaşkurtlar Köyü)",
      "Kurtlar Mah (zeyneller Köyü)",
      "Küllü Yayla Mah (karapazar Köyü)",
      "Macarlar Mah (macarlar Köyü)",
      "Mandıra Mah (çukurca Köyü)",
      "Mandıralar Mah (samat Köyü)",
      "Markuşa Yaylası Mah (göynükören Köyü)",
      "Mehmet Beylik Mah (havullu Köyü)",
      "Mehmet Beylik Yaylası Mah (havullu Köyü)",
      "Merkez Mah (afşartarakçı Köyü)",
      "Merkez Mah (ağızörengüney Köyü)",
      "Merkez Mah (ahmetler Köyü)",
      "Merkez Mah (akbaş Köyü)",
      "Merkez Mah (akçabey Köyü)",
      "Merkez Mah (akçaşehir Köyü)",
      "Merkez Mah (aktaş Köyü)",
      "Merkez Mah (asmaca Köyü)",
      "Merkez Mah (aşağıovacık Köyü)",
      "Merkez Mah (aşağıörenbaşı Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (bahçedere Köyü)",
      "Merkez Mah (balcılar Köyü)",
      "Merkez Mah (bünüş Köyü)",
      "Merkez Mah (çalaman Köyü)",
      "Merkez Mah (çalışlar Köyü)",
      "Merkez Mah (çayören Köyü)",
      "Merkez Mah (çoğullu Köyü)",
      "Merkez Mah (çukurca Köyü)",
      "Merkez Mah (dağkara Köyü)",
      "Merkez Mah (danişmentler Köyü)",
      "Merkez Mah (davutbeyli Köyü)",
      "Merkez Mah (demircisopran Köyü)",
      "Merkez Mah (demirler Köyü)",
      "Merkez Mah (dikmen Köyü)",
      "Merkez Mah (dursunfakı Köyü)",
      "Merkez Mah (elören Köyü)",
      "Merkez Mah (enseliler Köyü)",
      "Merkez Mah (ertuğrulköy Köyü)",
      "Merkez Mah (eymür Köyü)",
      "Merkez Mah (geçitler Köyü)",
      "Merkez Mah (göynükören Köyü)",
      "Merkez Mah (hacılar Köyü)",
      "Merkez Mah (halaçlar Köyü)",
      "Merkez Mah (hasanlar Köyü)",
      "Merkez Mah (havullu Köyü)",
      "Merkez Mah (ıbrıcak Köyü)",
      "Merkez Mah (ikinciafşar Köyü)",
      "Merkez Mah (imamlar Köyü)",
      "Merkez Mah (inköy Köyü)",
      "Merkez Mah (kalaç Köyü)",
      "Merkez Mah (kapaklı Köyü)",
      "Merkez Mah (karacadağ Köyü)",
      "Merkez Mah (karacadağdemirciler Köyü)",
      "Merkez Mah (karapazar Köyü)",
      "Merkez Mah (kavacık Köyü)",
      "Merkez Mah (kayıkiraz Köyü)",
      "Merkez Mah (kayısopran Köyü)",
      "Merkez Mah (kazanlar Köyü)",
      "Merkez Mah (koçumlar Köyü)",
      "Merkez Mah (kösreli Köyü)",
      "Merkez Mah (kürkçüler Köyü)",
      "Merkez Mah (macarlar Köyü)",
      "Merkez Mah (mangallar Köyü)",
      "Merkez Mah (mircekiraz Köyü)",
      "Merkez Mah (mukamlar Köyü)",
      "Merkez Mah (muratfakılar Köyü)",
      "Merkez Mah (mürdükler Köyü)",
      "Merkez Mah (nuhören Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (salur Köyü)",
      "Merkez Mah (samat Köyü)",
      "Merkez Mah (sapanlıurgancılar Köyü)",
      "Merkez Mah (sarıoğlu Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (sungurlar Köyü)",
      "Merkez Mah (tatlar Köyü)",
      "Merkez Mah (ulaşlar Köyü)",
      "Merkez Mah (ümitköy Köyü)",
      "Merkez Mah (yağdaş Köyü)",
      "Merkez Mah (yakaboy Köyü)",
      "Merkez Mah (yazıkara Köyü)",
      "Merkez Mah (yazıköy Köyü)",
      "Merkez Mah (yelkenler Köyü)",
      "Merkez Mah (yenecik Köyü)",
      "Merkez Mah (yeniyapar Köyü)",
      "Merkez Mah (yeşilvadi Köyü)",
      "Merkez Mah (yukarıovacık Köyü)",
      "Merkez Mah (yukarıörenbaşı Köyü)",
      "Merkez Mah (yunuslar Köyü)",
      "Merkez Mah (zeyneller Köyü)",
      "Merkez Yayla Mah (çalaman Köyü)",
      "Merkez Yayla Mah (dağkara Köyü)",
      "Merkez Yayla Mah (geçitler Köyü)",
      "Merkez Yayla Mah (karacadağdemirciler Köyü)",
      "Merkez Yayla Mah (kösreli Köyü)",
      "Merkez Yayla Mah (muratfakılar Köyü)",
      "Merkez Yayla Mah (ortaca Köyü)",
      "Merkez Yayla Mah (sapanlıurgancılar Köyü)",
      "Merkez Yayla Mah (tatlar Köyü)",
      "Merkez Yayla Mah (ulaşlar Köyü)",
      "Merkez Yayla Mah (yazıköy Köyü)",
      "Merkez Yayla Mah (yunuslar Köyü)",
      "Merkez Yaylası Mah (hasanlar Köyü)",
      "Merkez Yaylası Mah (havullu Köyü)",
      "Merkez Yaylası Mah (kalaç Köyü)",
      "Merkez Yaylası Mah (koçumlar Köyü)",
      "Merkez Yaylası Mah (yukarıovacık Köyü)",
      "Orta Mah (asmaca Köyü)",
      "Orta Mah (ıbrıcak Köyü)",
      "Sağlık Mah (halaçlar Köyü)",
      "Seyfe Mah (külef Köyü)",
      "Seyitler Mah (ulaşlar Köyü)",
      "Seyitler Yaylası Mah (ulaşlar Köyü)",
      "Sinanlar Mah (ortaca Köyü)",
      "Siyamlar Mah (ıbrıcak Köyü)",
      "Sofular Yaylası Mah (sofular Köyü)",
      "Sömerciler Mah (karacadağdemirciler Köyü)",
      "Sömerciler Yayla Mah (karacadağdemirciler Köyü)",
      "Süller Mah (süllertoklar Köyü)",
      "Süller Yaylası Mah (süllertoklar Köyü)",
      "Şahallar Mah (çoğullu Köyü)",
      "Şükürler Mah (demircisopran Köyü)",
      "Tataroğlu Mah (beşkonak Köyü)",
      "Teççebel Yaylası Mah (karapazar Köyü)",
      "Tekfur Mah (ertuğrulköy Köyü)",
      "Tepe Mah (yakakaya Köyü)",
      "Toklar Mah (süllertoklar Köyü)",
      "Toklar Yaylası Mah (süllertoklar Köyü)",
      "Tozaklar Mah (karacadağ Köyü)",
      "Üçpınar Mah (yazıköy Köyü)",
      "Üçpınar Yayla Mah (yazıköy Köyü)",
      "Yaman Mah (çalaman Köyü)",
      "Yaman Yaylası Mah (çalaman Köyü)",
      "Yanıklar Mah (yelkenler Köyü)",
      "Yanşaba Mah (dağkara Köyü)",
      "Yanşaba Yaylası Mah (dağkara Köyü)",
      "Yayla Mah (afşartarakçı Köyü)",
      "Yayla Mah (ağızörengüney Köyü)",
      "Yayla Mah (ahmetler Köyü)",
      "Yayla Mah (akbaş Köyü)",
      "Yayla Mah (akçabey Köyü)",
      "Yayla Mah (akçaşehir Köyü)",
      "Yayla Mah (aktaşkurtlar Köyü)",
      "Yayla Mah (asmaca Köyü)",
      "Yayla Mah (aşağıovacık Köyü)",
      "Yayla Mah (aşağıörenbaşı Köyü)",
      "Yayla Mah (aydınlar Köyü)",
      "Yayla Mah (bahçedere Köyü)",
      "Yayla Mah (balcılar Köyü)",
      "Yayla Mah (beşkonak Köyü)",
      "Yayla Mah (bünüş Köyü)",
      "Yayla Mah (çalışlar Köyü)",
      "Yayla Mah (çayören Köyü)",
      "Yayla Mah (çayörengüney Köyü)",
      "Yayla Mah (çukurca Köyü)",
      "Yayla Mah (danişmentler Köyü)",
      "Yayla Mah (davutbeyli Köyü)",
      "Yayla Mah (demircisopran Köyü)",
      "Yayla Mah (demirler Köyü)",
      "Yayla Mah (dikmen Köyü)",
      "Yayla Mah (dursunfakı Köyü)",
      "Yayla Mah (elören Köyü)",
      "Yayla Mah (enseliler Köyü)",
      "Yayla Mah (ertuğrulköy Köyü)",
      "Yayla Mah (eymür Köyü)",
      "Yayla Mah (hacılar Köyü)",
      "Yayla Mah (halaçlar Köyü)",
      "Yayla Mah (ikinciafşar Köyü)",
      "Yayla Mah (imamlar Köyü)",
      "Yayla Mah (inköy Köyü)",
      "Yayla Mah (kapaklı Köyü)",
      "Yayla Mah (karacadağ Köyü)",
      "Yayla Mah (kayıkiraz Köyü)",
      "Yayla Mah (kayısopran Köyü)",
      "Yayla Mah (kazanlar Köyü)",
      "Yayla Mah (külef Köyü)",
      "Yayla Mah (kürkçüler Köyü)",
      "Yayla Mah (macarlar Köyü)",
      "Yayla Mah (mangallar Köyü)",
      "Yayla Mah (mircekiraz Köyü)",
      "Yayla Mah (mukamlar Köyü)",
      "Yayla Mah (mürdükler Köyü)",
      "Yayla Mah (nuhören Köyü)",
      "Yayla Mah (örencik Köyü)",
      "Yayla Mah (salur Köyü)",
      "Yayla Mah (samat Köyü)",
      "Yayla Mah (sipahiler Köyü)",
      "Yayla Mah (sungurlar Köyü)",
      "Yayla Mah (ümitköy Köyü)",
      "Yayla Mah (yağdaş Köyü)",
      "Yayla Mah (yakaboy Köyü)",
      "Yayla Mah (yakakaya Köyü)",
      "Yayla Mah (yelkenler Köyü)",
      "Yayla Mah (yenecik Köyü)",
      "Yayla Mah (yeniyapar Köyü)",
      "Yayla Mah (zeyneller Köyü)",
      "Yeni Mah (ıbrıcak Köyü)",
      "Yukarı Mah (halaçlar Köyü)",
      "Yukarı Mah (ortaca Köyü)",
      "Yunuslar Mah (yakakaya Köyü)",
      "Zadatlar Mah (enseliler Köyü)"
    ],
    "Göynük": [
      "Cuma Mah",
      "Çeşme Mah",
      "Hacı Abdi Mah",
      "Kepkebir Mah",
      "Sofu Ali Mah",
      "Yenice Mah",
      "Ahmetbeyler Köyü",
      "Akçaalan Merkez Mah (akçaalan Köyü)",
      "Aksaklar Merkez Mah (aksaklar Köyü)",
      "Aktaş Mah (yeniköy Köyü)",
      "Alan Merkez Mah (alanköy Köyü)",
      "Alan Yaylası Mah (alanköy Köyü)",
      "Alancık Mah (yeniköy Köyü)",
      "Altıncılar Mah (çaylak Köyü)",
      "Arabacılar Mah (gökçesaray Köyü)",
      "Arıkçayırı Merkez Mah (arıkçayırı Köyü)",
      "Arızlar Köyü",
      "Aşağı Mah (himmetoğlu Köyü)",
      "Aşağıkınık Merkez Mah (çatacık Mah) (aşağıkınık Köyü)",
      "Aşağıkozcağız Mah (kozcağız Köyü)",
      "Aşağısafranlar Mah (ibrahimözü Köyü)",
      "Aydınlar Mah (yeniköy Köyü)",
      "Ayvatlar Mah (bekirfakılar Köyü)",
      "Ayvatlar Mah (hisarözü Köyü)",
      "Bayındır Merkez Mah (bayındır Köyü)",
      "Bekirfakılar Merkez Mah (bekirfakılar Köyü)",
      "Bekirler Mah (kaşıkçışeyhler Köyü)",
      "Boyacılar Merkez Mah (boyacılar Köyü)",
      "Boyalıca Mah (ibrahimözü Köyü)",
      "Bozcaarmut Köyü",
      "Bölücekova Merkez Mah (bölücekova Köyü)",
      "Bulanık Merkez Mah (bulanık Köyü)",
      "Caferler Mah (kızılkuyu Köyü)",
      "Ceylanlı Köyü",
      "Conlar Mah (yeşilyazı Köyü)",
      "Çalıca Mah (güneyçalıca Köyü)",
      "Çamlıca Merkez Mah (çamlıca Köyü)",
      "Çapar Köyü",
      "Çatacık Merkez Mah (çatacık Köyü)",
      "Çatak Mah (bölücekova Köyü)",
      "Çaykol Mah (örencik Köyü)",
      "Çayköy Köyü",
      "Çaylak Merkez Mah (çaylak Köyü)",
      "Çiftlik Mah (çatacık Köyü)",
      "Çiftlik Mah (hacımahmut Köyü)",
      "Çiftlik Mah.yaylası Mah (hacımahmut Köyü)",
      "Çubuk Merkez Mah (çubukköy Köyü)",
      "Dağhacılar Merkez Mah (dağhacılar Köyü)",
      "Dağşeyhleri Köyü",
      "Dedeler Köyü",
      "Değirmenözü Köyü",
      "Demirhanlar Köyü",
      "Depo Mah (ibrahimözü Köyü)",
      "Dere Mah (arıkçayırı Köyü)",
      "Doğruk Mah (ekinciler Köyü)",
      "Ekinciler Merkez Mah (ekinciler Köyü)",
      "Elmacılar Mah (yukarıkınık Köyü)",
      "Fakılar Mah (gürpınar Köyü)",
      "Fındıcak Mah (sünnet Köyü)",
      "Gavurlar Pınarı Mah (hisarözü Köyü)",
      "Gerişler Köyü",
      "Göbeller Mah (kızılkuyu Köyü)",
      "Gökçesaray Merkez Mah (gökçesaray Köyü)",
      "Gökçesaray Yayla Evleri Mah (gökçesaray Köyü)",
      "Gölbaşı Mah (çubukköy Köyü)",
      "Gölözü Mah (çamlıca Köyü)",
      "Gözler Mah (memeceler Köyü)",
      "Güneyçalıca Merkez Mah (güneyçalıca Köyü)",
      "Gürpınar Merkez Mah (gürpınar Köyü)",
      "Hacıahmetler Mah (yeşilyazı Köyü)",
      "Hacımahmut Merkez Mah (hacımahmut Köyü)",
      "Hacımahmut Merkez Mah.yaylası Mah (hacımahmut Köyü)",
      "Hallar Mah (aşağıkınık Köyü)",
      "Hapşanlar Mah (hisarözü Köyü)",
      "Hasanlar Köyü",
      "Hebiller Mah (karaardıç Köyü)",
      "Hilaller Köyü",
      "Himmetoğlu Merkez Mah (himmetoğlu Köyü)",
      "Hisarözü Merkez Mah (hisarözü Köyü)",
      "Ilıca Mah (bayındır Köyü)",
      "Kabakulak Mah (örencik Köyü)",
      "Kabakulakaltı Mah (örencik Köyü)",
      "Kabalar Mah (dağhacılar Köyü)",
      "Karaaliler Merkez Mah (karaaliler Köyü)",
      "Karaardıç Merkez Mah (karaardıç Köyü)",
      "Karacalar Köyü",
      "Karafakılar Mah (bayındır Köyü)",
      "Karısıklar Mah (himmetoğlu Köyü)",
      "Kaşıkçışeyhler Merkez Mah (kaşıkçışeyhler Köyü)",
      "Kavacık Mah (akçaalan Köyü)",
      "Kayabaşı Köyü",
      "Kayalıdere Merkez Mah (kayalıdere Köyü)",
      "Kılavuzlar Köyü",
      "Kılavuzlar Yaylası Mah (kılavuzlar Köyü)",
      "Kızılkuyu Merkez Mah (kızılkuyu Köyü)",
      "Kilciler Köyü",
      "Killer Mah (mustanlar Köyü)",
      "Kozcağız Merkez Mah (kozcağız Köyü)",
      "Kozdere Mah (örencik Köyü)",
      "Köroğlu Mah (aşağıkınık Köyü)",
      "Köstek Mah (kozcağız Köyü)",
      "Köstekler Mah (kızılkuyu Köyü)",
      "Köybaşı Köyü",
      "Kumarlar Mah (bulanık Köyü)",
      "Kumcuk Merkez Mah (kumcuk Köyü)",
      "Kurtuluş Mah (kumcuk Köyü)",
      "Kuyupınar Merkez Mah (kuyupınar Köyü)",
      "Kürnüç Köyü",
      "Maden Aksa Mah (çayköy Köyü)",
      "Mantarlar Mah (karaaliler Köyü)",
      "Memeceler Merkez Mah (memeceler Köyü)",
      "Memeceler Yaylası Mah (memeceler Köyü)",
      "Merkez Mah (ibrahimözü Köyü)",
      "Meşeli Mah (hisarözü Köyü)",
      "Muratlar Mah (sünnet Köyü)",
      "Mustanlar Merkez Mah (mustanlar Köyü)",
      "Narzanlar Köyü",
      "Nasuhlar Mah (gökçesaray Köyü)",
      "Niğit Mah (boyacılar Köyü)",
      "Okçular Mah (alanköy Köyü)",
      "Orta Mah (bulanık Köyü)",
      "Ovaboyu Mah (kuyupınar Köyü)",
      "Örencik Merkez Mah (örencik Köyü)",
      "Örencik Yaylası Mah (örencik Köyü)",
      "Pelitcik Köyü",
      "Safalar Mah (aşağıkınık Köyü)",
      "Safranlar Mah (ibrahimözü Köyü)",
      "Sarıcalar Köyü",
      "Sarılar Merkez Mah (sarılar Köyü)",
      "Seferler Mah (çaylak Köyü)",
      "Seki Mah (çubukköy Köyü)",
      "Seki Mah (kumcuk Köyü)",
      "Sifyanlar Mah (sarılar Köyü)",
      "Soğukçam Köyü",
      "Susuz Köyü",
      "Sünnet Merkez Mah (sünnet Köyü)",
      "Şabanlar Mah (hisarözü Köyü)",
      "Tekirler Merkez Mah (tekirler Köyü)",
      "Tembeller Mah (kozcağız Köyü)",
      "Tepebaşı Köyü",
      "Turgutlar Mah (aksaklar Köyü)",
      "Turgutlar Mah (kayalıdere Köyü)",
      "Umurlar Köyü",
      "Umutdere Mah (örencik Köyü)",
      "Yağcılar Mah (kaşıkçışeyhler Köyü)",
      "Yahyalar Mah (karaaliler Köyü)",
      "Yapraklı Mah (sünnet Köyü)",
      "Yeni Mah (çamlıca Köyü)",
      "Yeni Mah (ekinciler Köyü)",
      "Yeniköy Merkez Mah (yeniköy Köyü)",
      "Yeşilova Mahallesi (bölücekova Köyü)",
      "Yeşilyazı  Merkez Mah (yeşilyazı Köyü)",
      "Yörükler Mah (tekirler Köyü)",
      "Yukarıkınık Merkez Mah (yukarıkınık Köyü)"
    ],
    "Kıbrıscık": [
      "Karadoğan Mah",
      "Köroğlu Mah",
      "Akpınar Mah (belen Köyü)",
      "Alanhimmetler Köyü",
      "Alemdar Köyü",
      "Alpağut Mah (taşlık Köyü)",
      "Ardalan Mah (deveören Köyü)",
      "Aşağı Aladağ Yaylası Mah (çökeler Köyü)",
      "Bağışlar Mah (kökez Köyü)",
      "Balı Köyü",
      "Bataklık Mah (belen Köyü)",
      "Bedeste Mah (belen Köyü)",
      "Bedesten Mah (belen Köyü)",
      "Borucak Köyü",
      "Bölücekkaya Köyü",
      "Bölücekkaya Mah (bölücekkaya Köyü)",
      "Bulkaz Mah (deveci Köyü)",
      "Bulkaz Yaylası Mah (dokumacılar Köyü)",
      "Çalkara Mah (kuzca Köyü)",
      "Çarıklar Mah (belen Köyü)",
      "Çorluk Yaylası Mah (çökeler Köyü)",
      "Çökeler Köyü",
      "Çukur Mah (belen Köyü)",
      "Çukur Yaylası Mah (belen Köyü)",
      "Deveci Köyü",
      "Deveören Köyü",
      "Dokumacılar Köyü",
      "Elmalı Mah (kılkara Köyü)",
      "Erikli Mah (belen Köyü)",
      "Geriş Köyü",
      "Geriş Mah (geriş Köyü)",
      "Güneyoluk Mah (alemdar Köyü)",
      "Karacaören Köyü",
      "Kılkara Köyü",
      "Kızık Mah (sarıkaya Köyü)",
      "Kızık Yaylası Mah (sarıkaya Köyü)",
      "Kızılcaören Köyü",
      "Kösdenlik Mah (kızılcaören Köyü)",
      "Köseler Köyü",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (karaköy Köyü)",
      "Merkez Mah (kökez Köyü)",
      "Merkez Mah (kuzca Köyü)",
      "Merkez Mah (nadas Köyü)",
      "Mondu Mah (taşlık Köyü)",
      "Örencik Mah (kılkara Köyü)",
      "Peçenek Mah (nadas Köyü)",
      "Saraycık Mah (karaköy Köyü)",
      "Sarıbasım Yaylası Mah (yazıca Köyü)",
      "Sarıkaya Mah (sarıkaya Köyü)",
      "Sarıkaya Yaylası Mah (sarıkaya Köyü)",
      "Serke Yaylası Mah (karacaören Köyü)",
      "Sinnecik Mah (kızılcaören Köyü)",
      "Sinnecik Yaylası Mah (karacaören Köyü)",
      "Soğuksu Mah (taşlık Köyü)",
      "Solaca Hatbol Tarlası Yaylası Mah (çökeler Köyü)",
      "Sorudak Yaylası Mah (yazıca Köyü)",
      "Taşlık Mah (taşlık Köyü)",
      "Tembel Mah (deveören Köyü)",
      "Yayla Bölgesi Mah (belen Köyü)",
      "Yazıca Köyü",
      "Yukarı Aladağ Yaylası Mah (çökeler Köyü)",
      "Yukarı Bedesten Mah (belen Köyü)"
    ],
    "Mengen": [
      "Adasal Mah (gökçesu Beldesi)",
      "Akmehmetoğlu Mah (kayabaşı Köyü)",
      "Alioğlu Mah (çorakkadirler Köyü)",
      "Aşağı  Emirler Mah (emirler Köyü)",
      "Atatürk Mah (gökçesu Beldesi)",
      "Avlanlar Mah (küçükkuz Köyü)",
      "Balatoğlu Mah (afşar Köyü)",
      "Bıyıklar Mah (küçükkuz Köyü)",
      "Bökrü Mah (kayışlar Köyü)",
      "Camiyanı Mah (elemen Köyü)",
      "Civciler Mah (kayışlar Köyü)",
      "Çakırlar Mah (gökçesu Beldesi)",
      "Çamlı Köy Mah (turna Köyü)",
      "Değirmenciler Mah (küçükkuz Köyü)",
      "Demirciler Mah (emirler Köyü)",
      "Demirciler Mah (karakaya Köyü)",
      "Demircioğlu Mah (elemen Köyü)",
      "Dere Mah (şahbazlar Köyü)",
      "Doplar Mah (çorakkadirler Köyü)",
      "Dömbekçioğlu Mah (elemen Köyü)",
      "Durallar Mah (emirler Köyü)",
      "Duran Bahçesi Mah (kadılar Köyü)",
      "Elemen  Yaylası Mah (kayabaşı Köyü)",
      "Ellezler Mah (kadılar Köyü)",
      "Esenler Mah (mamatlar Köyü)",
      "Göçler Mah (güneygökçesu Köyü)",
      "Göncü Mah (kayışlar Köyü)",
      "Gurlar Mah (kadılar Köyü)",
      "Gücükler Mah (karakaya Köyü)",
      "Hacıgüzel Mah (afşar Köyü)",
      "Hacımehmetoğlu Mah (elemen Köyü)",
      "Hacıoğlu Mah (karakaya Köyü)",
      "Haliloğlu Mah (elemen Köyü)",
      "Hamzalar Mah (küçükkuz Köyü)",
      "Hatipoğlu Mah (kayabaşı Köyü)",
      "Hoşcanlar Mah (kayabaşı Köyü)",
      "Hürriyet Mah (gökçesu Beldesi)",
      "İslamlar Mah (kayışlar Köyü)",
      "İsmailler Mah (çorakmıtırlar Köyü)",
      "İyisan Mah (küçükkuz Köyü)",
      "Kadıköy Mah (mamatlar Köyü)",
      "Kadirler Mah (çorakkadirler Köyü)",
      "Kalaycılar Mah (kayışlar Köyü)",
      "Kantaroğlu Mah (elemen Köyü)",
      "Karabacaklar Mah (kayışlar Köyü)",
      "Karageyikler Mah (küçükkuz Köyü)",
      "Karahüseyinler Mah (afşar Köyü)",
      "Karapınar Mah (şahbazlar Köyü)",
      "Kasımlar Mah (kadılar Köyü)",
      "Kavşaklar Mah (küçükkuz Köyü)",
      "Kayaaltı Mah (kadılar Köyü)",
      "Keseroğlu Mah (afşar Köyü)",
      "Keyfanoğlu Mah (kayabükü Köyü)",
      "Kulaksızoğlu Mah (turna Köyü)",
      "Kuleşler Mah (kayışlar Köyü)",
      "Kuruhaliller Mah (çorakmıtırlar Köyü)",
      "Kuşlar Mah (çorakmıtırlar Köyü)",
      "Kürtoğlu Mah (şahbazlar Köyü)",
      "Merkez Mah (afşar Köyü)",
      "Merkez Mah (elemen Köyü)",
      "Merkez Mah (güneygökçesu Köyü)",
      "Merkez Mah (hayranlar Köyü)",
      "Merkez Mah (kadılar Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kayışlar Köyü)",
      "Merkez Mah (mamatlar Köyü)",
      "Merkez Mah (şahbazlar Köyü)",
      "Merkez Mah (turna Köyü)",
      "Mısırlı Mah (çorakkadirler Köyü)",
      "Muharremoğlu Mah (karakaya Köyü)",
      "Musluoğlu Mah (karakaya Köyü)",
      "Noktalar Mah (kadılar Köyü)",
      "Olucak Mah (kayabaşı Köyü)",
      "Orta Mah (emirler Köyü)",
      "Oruçoğlu Mah (karakaya Köyü)",
      "Otlak Mah (kadılar Köyü)",
      "Paşaköyü Mah (kadılar Köyü)",
      "Seferler Mah (mamatlar Köyü)",
      "Sepetci Mah (emirler Köyü)",
      "Somuncuoğlu Mah (kayabükü Köyü)",
      "Şabanlar Mah (turna Köyü)",
      "Şembelek Mah (emirler Köyü)",
      "Şevkioğlu Mah (afşar Köyü)",
      "Şıhlar Mah (kayabaşı Köyü)",
      "Taşcami Mah (kayışlar Köyü)",
      "Tavukcuoğlu Mah (karakaya Köyü)",
      "Tekeoğlu Mah (çorakkadirler Köyü)",
      "Terziler Mah (mamatlar Köyü)",
      "Tilkioğlu Mah (kayabükü Köyü)",
      "Tokatlı Değirmeni Mah (güneygökçesu Köyü)",
      "Tomasoğlu Mah (karakaya Köyü)",
      "Türdüoğlu Mah (kayabaşı Köyü)",
      "Veliler Mah (küçükkuz Köyü)",
      "Yeni Mah (çorakmıtırlar Köyü)",
      "Yeşiller Mah (çorakmıtırlar Köyü)",
      "Yirmialtıoğlu Mah (elemen Köyü)",
      "Yirmibeşoğlu Mah (elemen Köyü)",
      "Yukarı  Emirler Mah (emirler Köyü)",
      "Yukarı Mah (küçükkuz Köyü)",
      "Yunuslar Mah (hayranlar Köyü)",
      "Beşler Mah",
      "Karapınar Mah",
      "Tabaklar Yazıyaka Mah",
      "Türkbeyli Mah",
      "Ahmetler Mah (babahızır Köyü)",
      "Ahmetoğlu Mah (karaşeyhler Köyü)",
      "Akbük Mah (babahızır Köyü)",
      "Akçaoğlu Mah (düzağaç Köyü)",
      "Akkaya Yaylası Mah (karaşeyhler Köyü)",
      "Alageriş Mah (akören Köyü)",
      "Aliçelebiler Mah (akçakoca Köyü)",
      "Aliefendiler Mah (nazırlar Köyü)",
      "Apti Mah (kadısusuz Köyü)",
      "Arak Mah (arak Köyü)",
      "Arslanlar Mah (karaşeyhler Köyü)",
      "Astı Mah (kadısusuz Köyü)",
      "Aşağı Karşı Mah (çubuk Köyü)",
      "Aşağı Mah (ağalar Köyü)",
      "Aşağı Mah (çubuk Köyü)",
      "Aşağı Mah (hacıahmetler Köyü)",
      "Aşağı Mah (kavacık Köyü)",
      "Aşağı Mah (teberikler Köyü)",
      "Aşıkoğlu Mah (akören Köyü)",
      "Ballar Mah (arak Köyü)",
      "Baraj Alanı Mah (köprübaşı Köyü)",
      "Baraklar Mah (demirciler Köyü)",
      "Bayraktarlar Mah (düzağaç Köyü)",
      "Bayrambeyler Mah (gözecik Köyü)",
      "Bayramoğlu Mah (çukurca Köyü)",
      "Bekirler Mah (nazırlar Köyü)",
      "Belengölcük Mah (başyellice Köyü)",
      "Beşevler Mah (çayköy Köyü)",
      "Cazlar Mah (konak Köyü)",
      "Curur Yayla Mah (düzağaç Köyü)",
      "Cünütler Mah (düzağaç Köyü)",
      "Çay Oba Mah (çukurca Köyü)",
      "Çayboyu Mah (hacıahmetler Köyü)",
      "Çelebiler Mah (aktepe Köyü)",
      "Çengeller Mah (kadısusuz Köyü)",
      "Çıraklar Mah (bölükören Köyü)",
      "Çıralıköprü Mah (kıyaslar Köyü)",
      "Değirmenbükü Mah (babahızır Köyü)",
      "Değirmenyanı Mah (köprübaşı Köyü)",
      "Deliahmetler Mah (karacalar Köyü)",
      "Demirciler Mah (karacalar Köyü)",
      "Dere Mah (bölükören Köyü)",
      "Dereköy Mah (yellicedemirciler Köyü)",
      "Dereler Mah (arak Köyü)",
      "Doğanlar Mah (bürnük Köyü)",
      "Doruk Mah (ağalar Köyü)",
      "Doruk Mah (ilyaslar Köyü)",
      "Dost Mah (düzköy Köyü)",
      "Dörtyol Mah (ağalar Köyü)",
      "Dumanlar Mah (kadısusuz Köyü)",
      "Duranlar Mah (yellicedemirciler Köyü)",
      "Ellezler Mah (çayköy Köyü)",
      "Ellezoğlu Mah (akören Köyü)",
      "Esatlar Mah (gözecik Köyü)",
      "Eski Mah (teberikler Köyü)",
      "Evcik Mah (başyellice Köyü)",
      "Eynebeyler Mah (bölükören Köyü)",
      "Gebeşoğlu Mah (kıyaslar Köyü)",
      "Geriş Mah (yellicedemirciler Köyü)",
      "Gökmenoğlu Mah (kavacık Köyü)",
      "Göl Mah (nazırlar Köyü)",
      "Gölcük Mah (babahızır Köyü)",
      "Gülistan Mah (banaz Köyü)",
      "Güneyhisar Mah (düzköy Köyü)",
      "H.çelebiler Mah (düzköy Köyü)",
      "Hacceller Mah (babahızır Köyü)",
      "Hacıoğlu Mah (çukurca Köyü)",
      "Haliloğlu Mah (çukurca Köyü)",
      "Harcıgölü Mah (çubuk Köyü)",
      "Hasanbeyler Mah (sazlar Köyü)",
      "Hatıplar Mah (düzağaç Köyü)",
      "Hatipler Mah (sarıkadılar Köyü)",
      "Hayranlar Mah (rüknettin Köyü)",
      "Hocalar Mah (çırdak Köyü)",
      "İmamoğlu Mah (başyellice Köyü)",
      "İsmail Beyler Mah (kuzgöl Köyü)",
      "K.yaylası Mah (akçakoca Köyü)",
      "Kadı Mah (kadısusuz Köyü)",
      "Kadıoğlu Mah (düzağaç Köyü)",
      "Kadirler Mah (ağalar Köyü)",
      "Kahyalar Mah (akçakoca Köyü)",
      "Kahyaoğlu Mah (akören Köyü)",
      "Kalemler Mah (akçakoca Köyü)",
      "Kalemler Mah (karaşeyhler Köyü)",
      "Kancılar Mah (sarıkadılar Köyü)",
      "Karacaağaç Mah (başyellice Köyü)",
      "Karaçam Mah (konak Köyü)",
      "Karaeyüpler Mah (rüknettin Köyü)",
      "Karahacılar Mah (alibeyler Köyü)",
      "Karakaşlar Mah (teberikler Köyü)",
      "Karakuz Mah (ağalar Köyü)",
      "Karaman Mah (karaşeyhler Köyü)",
      "Karandu Mah (akçakoca Köyü)",
      "Karaşeyhler Yaylasa Mah (karaşeyhler Köyü)",
      "Karataş Mah (yumrutaş Köyü)",
      "Kargalar Mah (rüknettin Köyü)",
      "Karşı Mah (çubuk Köyü)",
      "Karşıyaka Mah (teberikler Köyü)",
      "Katırcıoğlu Mah (yellicedemirciler Köyü)",
      "Kayılar Mah (arak Köyü)",
      "Kaynarca Mah (kıyaslar Köyü)",
      "Kediler Mah (hacıahmetler Köyü)",
      "Keleşler Mah (düzköy Köyü)",
      "Keller Mah (ilyaslar Köyü)",
      "Kemaller Mah (rüknettin Köyü)",
      "Kemikler Mah (düzköy Köyü)",
      "Kertil Mah (yumrutaş Köyü)",
      "Kılavuzlar Mah (düzağaç Köyü)",
      "Kiremitlik Mah (sazlar Köyü)",
      "Kocabeyler Mah (demirciler Köyü)",
      "Kocaoğlu Mah (bölükören Köyü)",
      "Korkutlar Mah (sarıkadılar Köyü)",
      "Kökem Mah (kavacık Köyü)",
      "Kösekadılar Mah (alibeyler Köyü)",
      "Kültür Mah (pazarköy Köyü)",
      "Marazlar Mah (akören Köyü)",
      "Mekez Mah (aktepe Köyü)",
      "Merkez Mah (ağacalar Köyü)",
      "Merkez Mah (akören Köyü)",
      "Merkez Mah (alibeyler Köyü)",
      "Merkez Mah (babahızır Köyü)",
      "Merkez Mah (banaz Köyü)",
      "Merkez Mah (başyellice Köyü)",
      "Merkez Mah (bürnük Köyü)",
      "Merkez Mah (çayköy Köyü)",
      "Merkez Mah (çırdak Köyü)",
      "Merkez Mah (çubuk Köyü)",
      "Merkez Mah (çukurca Köyü)",
      "Merkez Mah (demirciler Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (düzköy Köyü)",
      "Merkez Mah (gözecik Köyü)",
      "Merkez Mah (karacalar Köyü)",
      "Merkez Mah (karaishak Köyü)",
      "Merkez Mah (kıyaslar Köyü)",
      "Merkez Mah (konak Köyü)",
      "Merkez Mah (köprübaşı Köyü)",
      "Merkez Mah (kuzgöl Köyü)",
      "Merkez Mah (sarıkadılar Köyü)",
      "Merkez Mah (sazlar Köyü)",
      "Merkez Mah (yellicedemirciler Köyü)",
      "Merkez Mah (yumrutaş Köyü)",
      "Mesler Mah (dereköy Köyü)",
      "Mesutlar Mah (bürnük Köyü)",
      "Mutioğlu Mah (başyellice Köyü)",
      "Mürsel Mah (rüknettin Köyü)",
      "Müşürler Mah (düzağaç Köyü)",
      "Okulyanı Mah (hacıahmetler Köyü)",
      "On Evler Mah (teberikler Köyü)",
      "Orta Mah (ağalar Köyü)",
      "Orta Mah (akçakoca Köyü)",
      "Orta Mah (bölükören Köyü)",
      "Orta Mah (kuzgöl Köyü)",
      "Orta Mah (teberikler Köyü)",
      "Orta-süleyman Kadılar Mah (kavacık Köyü)",
      "Osmankadılar Mah (rüknettin Köyü)",
      "Osmanoğlu Mah (kıyaslar Köyü)",
      "Ömer Sipahi Mah (akören Köyü)",
      "Örem Mah (gözecik Köyü)",
      "Ötekeçe Mah (ilyaslar Köyü)",
      "Pazarbaşı Mah (pazarköy Köyü)",
      "Sağırkaya Mah (yumrutaş Köyü)",
      "Saray Mah (ağacalar Köyü)",
      "Sarıkızlar Mah (ağacalar Köyü)",
      "Selamoğlu Mah (kavacık Köyü)",
      "Seldiren Mah (ilyaslar Köyü)",
      "Seyitler Mah (nazırlar Köyü)",
      "Seyrek Mah (başyellice Köyü)",
      "Softalar Mah (çayköy Köyü)",
      "Susuz Mah (kadısusuz Köyü)",
      "Şahinler Mah (nazırlar Köyü)",
      "Şembelek Mah (çukurca Köyü)",
      "Şıhlar Mah (aktepe Köyü)",
      "Taşan Mah (başyellice Köyü)",
      "Türkmenler Mah (karacalar Köyü)",
      "Veliler Mah (çukurca Köyü)",
      "Yağlar Mah (ağalar Köyü)",
      "Yaka Mah (bürnük Köyü)",
      "Yayla Evleri Mah (akçakoca Köyü)",
      "Yazıcılar Mah (demirciler Köyü)",
      "Yeni Mah (ağalar Köyü)",
      "Yıldız Mah (kuzgöl Köyü)",
      "Yonsaklar Mah (teberikler Köyü)",
      "Yörükler Mah (akören Köyü)",
      "Yörükler Mah (kuzgöl Köyü)",
      "Yukarı Mah (akçakoca Köyü)",
      "Yukarı Mah (akören Köyü)",
      "Yukarı Mah (bürnük Köyü)",
      "Yukarı Mah (hacıahmetler Köyü)",
      "Yukarı Mah (teberikler Köyü)",
      "Zayımlar Mah (karaşeyhler Köyü)",
      "Zebunlar Mah (karaşeyhler Köyü)",
      "Zilferoğlu Mah (akören Köyü)"
    ],
    "Merkez": [
      "Alpağut Mah",
      "Alpağutbey Mah",
      "Aşağısoku Mah",
      "Beşkavaklar Mah",
      "Çakmaklar Mah",
      "Çivril Mah",
      "Dağkent Mah",
      "Dodurga Mah",
      "İzzet Baysal Mah",
      "Karacaağaç Mah",
      "Kılıçarslan Mah",
      "Kuruçay Mah",
      "Kültür Mah",
      "Kürkçüler Mah",
      "Sağlık Mah",
      "Salıbeyler Mah",
      "Sarıcalar Mah",
      "Umutkent Mah",
      "Yaşamkent Mah",
      "Yukarısoku Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Büyükcami Mah",
      "Çıkınlar Mah",
      "Gölyüzü Mah",
      "İhsaniye Mah",
      "Karaçayır Mah",
      "Köroğlu Mah",
      "Küçükberk Mah",
      "Ovadüzü Mah",
      "Semerkant Mah",
      "Yenimahalle Mah",
      "Ağalan Mah (taşoluk Köyü)",
      "Çampınar Güzleme Mah (çampınar Köyü)",
      "Çampınar Mah (çampınar Köyü)",
      "Çampınar Merkez Mah (çampınar Köyü)",
      "Emen Mah (mesciler Köyü)",
      "Hıdırşeyhler Güzleme Mah (hıdırşeyhler Köyü)",
      "Hıdırşeyhler Mah (hıdırşeyhler Köyü)",
      "Karacasu Fatih Mah (karacasu Beldesi)",
      "Mesciler Mah (mesciler Köyü)",
      "Taşoluk Mah (taşoluk Köyü)",
      "Taşoluk Merkez Mah (taşoluk Köyü)",
      "Bahçelievler Mah",
      "Borazanlar Mah",
      "Karaköy Mah",
      "Karamanlı Mah",
      "Kasaplar Mah",
      "Paşaköy Mah",
      "Sandallar Mah",
      "Seyit Mah",
      "Sümer Mah",
      "Tabaklar Mah",
      "Tepecik Mah",
      "Aftallar Mah (ulumescit Köyü)",
      "Akçalar Mah (kuzörendağlı Köyü)",
      "Alagözler Mah (çepni Köyü)",
      "Alıçören Merkez Mah (alıçören Köyü)",
      "Apalar Mah (yakabayat Köyü)",
      "Arap Mah (değirmenbeli Köyü)",
      "Ardıç Yaylası Mah (pelitcik Köyü)",
      "Arıklar Mah (kındıra Köyü)",
      "Aşağı Çandır Mah (banaz Köyü)",
      "Aşağı Mah (aydıncık Köyü)",
      "Aşağı Mah (çepni Köyü)",
      "Aşağı Mah (ericek Köyü)",
      "Aşağı Mah (güneyfelekettin Köyü)",
      "Aşağı Mah (hamzabey Köyü)",
      "Aşağı Mah (sebenardı Köyü)",
      "Aşağı Mah (sultan Köyü)",
      "Aşağı Mah (yenisefa Köyü)",
      "Aşağı Yayla Mah (sebenardı Köyü)",
      "Aşağı Yaylası Mah (aydıncık Köyü)",
      "Aşağı Yaylası Mah (hamzabey Köyü)",
      "Aşağıçamlı Yaylası Mah (aşağıçamlı Köyü)",
      "Aşağıkuzören Yaylası Mah (aşağıkuzören Köyü)",
      "Aşçılar Mah (sazakkınık Köyü)",
      "Aydınlar Mah (topardıç Köyü)",
      "Bahçeköy Mezrası Mah (bahçeköy Köyü)",
      "Bahçeköy Yaylası Mah (bahçeköy Köyü)",
      "Bakırlı Mah (bakırlı Köyü)",
      "Baltalı Yaylası Mah (baltalı Köyü)",
      "Bayat Mah (yakabayat Köyü)",
      "Bayramlar Mah (bağışlar Köyü)",
      "Bayramlar Mah (çepni Köyü)",
      "Belkaraağaç Köyü",
      "Bozcaarmut Mah (baltalı Köyü)",
      "Bulutlar Mah (yakabayat Köyü)",
      "Bürnük Merkez Mah (bürnük Köyü)",
      "Bürnük Yaylası Mah (bürnük Köyü)",
      "Cami Yanı Mah (topardıç Köyü)",
      "Camilibölük Mah (gövem Köyü)",
      "Çakıldere Mah (merkeşler Köyü)",
      "Çamyayla Mah (çamyayla Köyü)",
      "Çamyayla Yaylası Mah (çamyayla Köyü)",
      "Çatak Mah (kızılağıl Köyü)",
      "Çatak Mah (yenisefa Köyü)",
      "Çatakören Yaylası Mah (çatakören Köyü)",
      "Çaygökpınar Yaylası Mah (çaygökpınar Köyü)",
      "Çengeller Mah (yukarıçamlı Köyü)",
      "Çepni Yaylası Mah (çepni Köyü)",
      "Çıtaklar Mah (ericek Köyü)",
      "Çilingirler Mah (değirmenbeli Köyü)",
      "Çukur Mah (piroğlu Köyü)",
      "Dağdelen Mah (tetemeçele Köyü)",
      "Değirmenözü Mah (çamyayla Köyü)",
      "Değirmenözü Yaylası Mah (çamyayla Köyü)",
      "Değirmenyanı Mah (güneyfelekettin Köyü)",
      "Demirciler Mah (pirahmetler Köyü)",
      "Demirciler Yaylası Mah (demirciler Köyü)",
      "Depo Sanayi Mah (topardıç Köyü)",
      "Dere Mah (merkeşler Köyü)",
      "Derekarşı Mah (vakıfgeçitveren Köyü)",
      "Devren Mah (tekkedere Köyü)",
      "Dumanoğlu Mah (merkeşler Köyü)",
      "Düvenlik Mah (çaygökpınar Köyü)",
      "Ecirler Mah (kındıra Köyü)",
      "Ediller Mah (muratlar Köyü)",
      "Elmacık Mah (değirmenbeli Köyü)",
      "Elmalık Mah (elmalık Köyü)",
      "Ercek Mah (kındıra Köyü)",
      "Eseler Mah (yenisefa Köyü)",
      "Evril Mah (değirmenderesi Köyü)",
      "Fakılar Mah (afşar Köyü)",
      "Fakılar Yaylası Mah (afşar Köyü)",
      "Ferdinler Mah (tarakçı Köyü)",
      "Fındıcak Mah (musluklar Köyü)",
      "Fırınlık Mah (yenipelitcik Köyü)",
      "Gidiriş Mah (afşar Köyü)",
      "Gidiriş Yaylası Mah (afşar Köyü)",
      "Göklemezler Mah (mesciçele Köyü)",
      "Gökpınar Yaylası Mah (gökpınar Köyü)",
      "Göl Mah (çepni Köyü)",
      "Gölcük Mah (aşağıkuzören Köyü)",
      "Güçömerler Mah (tarakçı Köyü)",
      "Güdükler Mah (kındıra Köyü)",
      "Güvem Yaylası Mah (gövem Köyü)",
      "Hacılar Mah (çepni Köyü)",
      "Hacılar Mah (merkeşler Köyü)",
      "Hacılar Mah (ulumescit Köyü)",
      "Hallar Mah (kozlu Köyü)",
      "Han Mah (merkeşler Köyü)",
      "Hasan Köyü Mah (topardıç Köyü)",
      "Hasanlar Mah (topardıç Köyü)",
      "Horbacı Mah (tetemeçele Köyü)",
      "Hümmetler Mah (tatlar Köyü)",
      "Iğdır Mah (saççılar Köyü)",
      "İmamlar Mah (banaz Köyü)",
      "İmamlar Mah (güneyfelekettin Köyü)",
      "İmamlar Mah (kozlu Köyü)",
      "İzeler Mah (merkeşler Köyü)",
      "Kadılar Mah (bağışlar Köyü)",
      "Kâhyalar Mah (bahçeköy Köyü)",
      "Kalenderoğlu Mah (merkeşler Köyü)",
      "Karabozlar Mah (pelitcik Köyü)",
      "Karacalar Mah (ericek Köyü)",
      "Karagözler Mah (pelitcik Köyü)",
      "Karagözler Mah (sazakkınık Köyü)",
      "Karakaya Yaylası Mah (musluklar Köyü)",
      "Karalar Mah (çaygökpınar Köyü)",
      "Karalar Yaylası Mah (çaygökpınar Köyü)",
      "Karamanlar Çatak Mah (kızılağıl Köyü)",
      "Karamanlar Mah (kızılağıl Köyü)",
      "Karamanyaka Mah (pelitcik Köyü)",
      "Karaseferler Mah (tetemeçele Köyü)",
      "Karşıyaka Mah (musluklar Köyü)",
      "Kartallar Mah (kuzörenemirler Köyü)",
      "Kayı Mah (yenigüney Köyü)",
      "Kayseller Mah (çobankaya Köyü)",
      "Kendigelenler Mah (çepni Köyü)",
      "Kındıra Yaylası Mah (kındıra Köyü)",
      "Kıran Mah (karca Köyü)",
      "Kırha Yaylası Mah (kırha Köyü)",
      "Kırık Yaylası Mah (musluklar Köyü)",
      "Kolca Mah (kuzörendağlı Köyü)",
      "Kolköy Yaylası Mah (kolköy Köyü)",
      "Kovalaklar Mah (semerciler Köyü)",
      "Köroğlu Mah (kuzörenemirler Köyü)",
      "Köseler Mah (çepni Köyü)",
      "Kuzfındık Yaylası Mah (kuzfındık Köyü)",
      "Kuzörendağlı Yaylası Mah (kuzörendağlı Köyü)",
      "Kuzörenemirler Yaylası Mah (kuzörenemirler Köyü)",
      "Kütükçüler Mah (baltalı Köyü)",
      "Merkeşler Yaylası Mah (merkeşler Köyü)",
      "Merkez  Mah (örencik Köyü)",
      "Merkez Mah (afşar Köyü)",
      "Merkez Mah (ağaçcılar Köyü)",
      "Merkez Mah (ahmetler Köyü)",
      "Merkez Mah (akçaalan Köyü)",
      "Merkez Mah (aşağıçamlı Köyü)",
      "Merkez Mah (aşağıkuzören Köyü)",
      "Merkez Mah (avdan Köyü)",
      "Merkez Mah (bağışlar Köyü)",
      "Merkez Mah (bahçeköy Köyü)",
      "Merkez Mah (bakırlı Köyü)",
      "Merkez Mah (baltalı Köyü)",
      "Merkez Mah (banaz Köyü)",
      "Merkez Mah (berk Köyü)",
      "Merkez Mah (bozarmut Köyü)",
      "Merkez Mah (bünüş Köyü)",
      "Merkez Mah (çamyayla Köyü)",
      "Merkez Mah (çanakçılar Köyü)",
      "Merkez Mah (çatakören Köyü)",
      "Merkez Mah (çaygökpınar Köyü)",
      "Merkez Mah (çayırköy Köyü)",
      "Merkez Mah (çömlekçiler Köyü)",
      "Merkez Mah (çukurören Köyü)",
      "Merkez Mah (değirmenbeli Köyü)",
      "Merkez Mah (değirmenderesi Köyü)",
      "Merkez Mah (demirciler Köyü)",
      "Merkez Mah (dereceören Köyü)",
      "Merkez Mah (doğancı Köyü)",
      "Merkez Mah (ericek Köyü)",
      "Merkez Mah (fasıl Köyü)",
      "Merkez Mah (gökpınar Köyü)",
      "Merkez Mah (gölcük Köyü)",
      "Merkez Mah (gölköy Köyü)",
      "Merkez Mah (gövem Köyü)",
      "Merkez Mah (güneyfelekettin Köyü)",
      "Merkez Mah (ılıcakınık Köyü)",
      "Merkez Mah (ışıklar Köyü)",
      "Merkez Mah (kandamış Köyü)",
      "Merkez Mah (karamanlar Köyü)",
      "Merkez Mah (karca Köyü)",
      "Merkez Mah (ketenler Köyü)",
      "Merkez Mah (kındıra Köyü)",
      "Merkez Mah (kırha Köyü)",
      "Merkez Mah (kızılağıl Köyü)",
      "Merkez Mah (kolköy Köyü)",
      "Merkez Mah (köprücüler Köyü)",
      "Merkez Mah (kuzfındık Köyü)",
      "Merkez Mah (kuzörendağlı Köyü)",
      "Merkez Mah (kuzörenemirler Köyü)",
      "Merkez Mah (küplüce Köyü)",
      "Merkez Mah (muratlar Köyü)",
      "Merkez Mah (musluklar Köyü)",
      "Merkez Mah (müstakimler Köyü)",
      "Merkez Mah (nuhlar Köyü)",
      "Merkez Mah (okçular Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (pirahmetler Köyü)",
      "Merkez Mah (piroğlu Köyü)",
      "Merkez Mah (rüzgarlar Köyü)",
      "Merkez Mah (saççılar Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (sazakşeyhler Köyü)",
      "Merkez Mah (sebenardı Köyü)",
      "Merkez Mah (semerciler Köyü)",
      "Merkez Mah (sultan Köyü)",
      "Merkez Mah (sultanbey Köyü)",
      "Merkez Mah (susuzkınık Köyü)",
      "Merkez Mah (tarakçı Köyü)",
      "Merkez Mah (taşçılar Köyü)",
      "Merkez Mah (tatlar Köyü)",
      "Merkez Mah (tekkedere Köyü)",
      "Merkez Mah (tetemeçele Köyü)",
      "Merkez Mah (tokmaklar Köyü)",
      "Merkez Mah (ulumescit Köyü)",
      "Merkez Mah (yakuplar Köyü)",
      "Merkez Mah (yayladınlar Köyü)",
      "Merkez Mah (yazıören Köyü)",
      "Merkez Mah (yenicepınar Köyü)",
      "Merkez Mah (yenigüney Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Merkez Mah (yenipelitcik Köyü)",
      "Merkez Mah (yenisefa Köyü)",
      "Merkez Mah (yeşilçele Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Merkez Mah (yolçatı Köyü)",
      "Merkez Mah (yukarıçamlı Köyü)",
      "Merkez Mah (yumrukaya Köyü)",
      "Merkez Yayla Mah (sebenardı Köyü)",
      "Merkez Yaylası Mah (afşar Köyü)",
      "Meşeci Mah (nuhlar Köyü)",
      "Musa Mah (kuzörenemirler Köyü)",
      "Muslar Mah (güneyfelekettin Köyü)",
      "Mustafa Vehbi Koç Mah (gövem Köyü)",
      "Nakıblar Mah (güneyfelekettin Köyü)",
      "Nuhlar Yaylası Mah (nuhlar Köyü)",
      "Ocuklar Mah (tatlar Köyü)",
      "Ocuklar Yaylası Mah (tatlar Köyü)",
      "Oğulduruk Mah (oğulduruk Köyü)",
      "Oğulduruk Merkez Mah (oğulduruk Köyü)",
      "Orta Mah (kozlu Köyü)",
      "Orta Mah (rüzgarlar Köyü)",
      "Orta Mah (ulumescit Köyü)",
      "Ömerler Merkez Mah (ömerler Köyü)",
      "Örencik Mah (karca Köyü)",
      "Pelitçik Yaylası Mah (pelitcik Köyü)",
      "Poyrazlar Mah (ulumescit Köyü)",
      "Rıfatlar Mah (çaygökpınar Köyü)",
      "Rüzgarlar Yaylası Mah (rüzgarlar Köyü)",
      "Saçcılar Yaylası Mah (saççılar Köyü)",
      "Sadıklar Mah (mesciçele Köyü)",
      "Saraç Mah (ericek Köyü)",
      "Saraycık Mah (saraycık Köyü)",
      "Saraycık Yaylası Mah (saraycık Köyü)",
      "Sarıahmetler Mah (çobankaya Köyü)",
      "Sığındı Mah (ulumescit Köyü)",
      "Sinir Mah (gökpınar Köyü)",
      "Siyamoğlu Mah (taşçılar Köyü)",
      "Softalar Mah (piroğlu Köyü)",
      "Susuzkınık Yaylası Mah (susuzkınık Köyü)",
      "Susuzkınıkosb Mah (susuzkınık Köyü)",
      "Şabanlar Mah (pelitcik Köyü)",
      "Şeremetler Mah (rüzgarlar Köyü)",
      "Tarakçı Yaylası Mah (tarakçı Köyü)",
      "Tatarlar Mah (gövem Köyü)",
      "Tataroğlu Mah (merkeşler Köyü)",
      "Tatlar Yaylası Mah (tatlar Köyü)",
      "Tekeler Mah (piroğlu Köyü)",
      "Tekneler Mah (çaygökpınar Köyü)",
      "Tilkicek Mah (muratlar Köyü)",
      "Türkmenler Mah (pelitcik Köyü)",
      "Uran Mah (fasıl Köyü)",
      "Üçküner Mevkii Mah (musluklar Köyü)",
      "Vakıfgeçitveren Merkez Mah (vakıfgeçitveren Köyü)",
      "Vayıslar Mah (çobankaya Köyü)",
      "Yaka Mah (karamanlar Köyü)",
      "Yanıklar Mah (topardıç Köyü)",
      "Yayla Evleri Mah (yenisefa Köyü)",
      "Yayla Mah (fasıl Köyü)",
      "Yazıören Mah (yazıören Köyü)",
      "Yeni Mah (ericek Köyü)",
      "Yeniakçakavak Merkez Mah (yeniakçakavak Köyü)",
      "Yeniçaydurt Merkez Mah (yeniçaydurt Köyü)",
      "Yenigeçitveren Merkez Mah (yenigeçitveren Köyü)",
      "Yenigüney Yaylası Mah (yenigüney Köyü)",
      "Yeniköy Mah (yeniköy Köyü)",
      "Yeşilçele Yaylası Mah (yeşilçele Köyü)",
      "Yukarı Mah (aydıncık Köyü)",
      "Yukarı Mah (baltalı Köyü)",
      "Yukarı Mah (banaz Köyü)",
      "Yukarı Mah (hamzabey Köyü)",
      "Yukarı Mah (saraycık Köyü)",
      "Yukarı Mah (sazakşeyhler Köyü)",
      "Yukarı Mah (yenisefa Köyü)",
      "Yukarı Yaylası Mah (aydıncık Köyü)",
      "Yukarı Yaylası Mah (hamzabey Köyü)",
      "Yukarıçamlı Yaylası Mah (yukarıçamlı Köyü)",
      "Yuva Aşağı Mah (yuva Köyü)",
      "Yuva Merkez  Mah (yuva Köyü)",
      "Yuva Merkez Mah (yuva Köyü)",
      "Yuvalca Mah (kuzörenemirler Köyü)",
      "Zahmanlar Mah (bürnük Köyü)",
      "Zahmanlar Yaylası Mah (bürnük Köyü)"
    ],
    "Mudurnu": [
      "Mah (hayallar Mah)yayla Evleri (alpagut Köyü)",
      "100.yıl Mah (bostancılar Köyü)",
      "100.yıl Mah (kurtlar Köyü)",
      "Abazalar Mah (hüsamettindere Köyü)",
      "Abdullar Mah (elmacıkdere Köyü)",
      "Acemler Mah (çağşak Köyü)",
      "Akbaşlar Mah (dolayüz Köyü)",
      "Akçaalan Mah (bekdemirler Köyü)",
      "Alaçam Mah (karamurat Köyü)",
      "Alanbaşı Mah (beyderesi Köyü)",
      "Alasinir Mah (yazılar Köyü)",
      "Alasinir Yayla Evi Mah (yazılar Köyü)",
      "Albalar Mah (çamurluk Köyü)",
      "Alıç Mah (gelinözü Köyü)",
      "Asarlık Mah (karşıköy Köyü)",
      "Asma Mah (bulanık Köyü)",
      "Aşağı Anayol Mah (çepni Köyü)",
      "Aşağı Dedekan Mah (gökören Köyü)",
      "Aşağı Mah (çepni Köyü)",
      "Aşağı Mah (çevreli Köyü)",
      "Aşağı Mah (elmacıkdere Köyü)",
      "Aşağı Mah (karapınarkavağı Köyü)",
      "Aşağı Mah (ova Mah) (çevreli Köyü)",
      "Aşağı Mah (sarpıncık Köyü)",
      "Aşağı Mah (yayal Evleri Mah) (çepni Köyü)",
      "Avdullar Mah (avdullar Köyü)",
      "Babalar Mah (çepni Köyü)",
      "Babalar Mah (yayla Evleri Mah) (çepni Köyü)",
      "Bayramlı Mah (delice Köyü)",
      "Beğendik Mah (dağyolu Köyü)",
      "Beşli Mah (kovucak Köyü)",
      "Beyderesi Mah (beyderesi Köyü)",
      "Bürücek Mah (kovucak Köyü)",
      "Büyük Mah (göncek Köyü)",
      "Caferler Mah (yazılar Köyü)",
      "Cami Yanı Mah (göncek Köyü)",
      "Çamyurdu Mah (çamyurdu Köyü)",
      "Çayıraltı Mah (sürmeli Köyü)",
      "Çayköy Mah (ortaköy Köyü)",
      "Çobanlar Mah (keçikıran Köyü)",
      "Davutlar Mah (güveytepe Köyü)",
      "Dedeler Mah (samsaçavuş Köyü)",
      "Deliceler Mah (ferüz Köyü)",
      "Demirciler Mah (göncek Köyü)",
      "Dere Mah (dağyolu Köyü)",
      "Dere Mah (dereçetinören Köyü)",
      "Dere Mah (dolayüz Köyü)",
      "Dere Mah (kovucak Köyü)",
      "Dere Mah (mangırlar Köyü)",
      "Dere Mah (samat Köyü)",
      "Dereceören Mah (karapınarkavağı Köyü)",
      "Dibektaşı Mah (alpagut Köyü)",
      "Dibektaşı-eseler-kaneller-mustanlar-yayla Evleri Mah (alpagut Köyü)",
      "Dodoraz Mah (ormanpınar Köyü)",
      "Dodurga Mah (dodurga Köyü)",
      "Dolayüz Mah (dolayüz Köyü)",
      "Ekincik Mah (sarpıncık Köyü)",
      "Elmacılar Mah (çamurluk Köyü)",
      "Encevez-kayaboğazı Mah (beyderesi Köyü)",
      "Erceşler Mah (sırçalı Köyü)",
      "Eseler Mah (alpagut Köyü)",
      "Fındıcak Mah (fındıcak Köyü)",
      "Gebem Mah (dağyolu Köyü)",
      "Gedikler Mah (pelitözü Köyü)",
      "Gelinözü Mah (gelinözü Köyü)",
      "Gemberuz Mah (güveytepe Köyü)",
      "Gölderesi Mah (göncek Köyü)",
      "Güney Mah (gelinözü Köyü)",
      "Güney Mah (iğneciler Köyü)",
      "Hacı Mah (elmacıkdere Köyü)",
      "Hacıaliler Mah (cuma Köyü)",
      "Hacımusalar Mah (hacımusalar Köyü)",
      "Hala Mah (kovucak Köyü)",
      "Han Mah (hacıhalimler Köyü)",
      "Hanicebiler Mah (sarpıncık Köyü)",
      "Harmanseki Mah (gölcük Köyü)",
      "Hatipler Mah (kovucak Köyü)",
      "Hayallar Mah (alpagut Köyü)",
      "Hayrettinler Mah (samsaçavuş Köyü)",
      "Hüseyinpaşalar Mah (hacıhalimler Köyü)",
      "İdrisler Mah (karşıköy Köyü)",
      "İleçin Mah (çavuşderesi Köyü)",
      "İmamlar Mah (vakıfaktaş Köyü)",
      "Kabalar Mah (karapınarkavağı Köyü)",
      "Kacık Köyü",
      "Kahyalar Mah (tımaraktaş Köyü)",
      "Kaneller Mah (alpagut Köyü)",
      "Karaağaç Mah (yaylabeli Köyü)",
      "Karaahmetler Mah (gürçam Köyü)",
      "Karapınar Mah (pelitözü Köyü)",
      "Kaya Mah (hacıhalimler Köyü)",
      "Kayabaşı Mah (fındıcak Köyü)",
      "Kayapınar Mah (gökören Köyü)",
      "Kepez Mah (karataş Köyü)",
      "Kıngılar Mah (gürçam Köyü)",
      "Kızılcıklı Mah (samat Köyü)",
      "Köseler Mah (akyokuş Köyü)",
      "Köseler Mah (gürçam Köyü)",
      "Kuzalıç Mah (samsaçavuş Köyü)",
      "Kuzören Mah (samsaçavuş Köyü)",
      "Kuzyaka Mah (çağşak Köyü)",
      "Küsem Mah (dağyolu Köyü)",
      "Merkez Mah (akyokuş Köyü)",
      "Merkez Mah (bekdemirler Köyü)",
      "Merkez Mah (bostancılar Köyü)",
      "Merkez Mah (cuma Köyü)",
      "Merkez Mah (çamurluk Köyü)",
      "Merkez Mah (çavuşderesi Köyü)",
      "Merkez Mah (dedeler Köyü)",
      "Merkez Mah (delice Köyü)",
      "Merkez Mah (dereçetinören Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (ekinören Köyü)",
      "Merkez Mah (esenkaya Köyü)",
      "Merkez Mah (ferüz Köyü)",
      "Merkez Mah (gökören Köyü)",
      "Merkez Mah (gölcük Köyü)",
      "Merkez Mah (göllüören Köyü)",
      "Merkez Mah (göncek Köyü)",
      "Merkez Mah (gürçam Köyü)",
      "Merkez Mah (hacıhalimler Köyü)",
      "Merkez Mah (hacımusalar Köyü)",
      "Merkez Mah (hüsamettindere Köyü)",
      "Merkez Mah (ılıca Köyü)",
      "Merkez Mah (iğneciler Köyü)",
      "Merkez Mah (karamurat Köyü)",
      "Merkez Mah (karataş Köyü)",
      "Merkez Mah (karşıköy Köyü)",
      "Merkez Mah (kavallar Köyü)",
      "Merkez Mah (keçikıran Köyü)",
      "Merkez Mah (kilözü Köyü)",
      "Merkez Mah (kurtlar Köyü)",
      "Merkez Mah (mangırlar Köyü)",
      "Merkez Mah (ordular Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (samsaçavuş Köyü)",
      "Merkez Mah (sarıyar Köyü)",
      "Merkez Mah (sarpıncık Köyü)",
      "Merkez Mah (sırçalı Köyü)",
      "Merkez Mah (sürmeli Köyü)",
      "Merkez Mah (tımaraktaş Köyü)",
      "Merkez Mah (uzunçam Köyü)",
      "Merkez Mah (vakıfaktaş Köyü)",
      "Merkez Mah (yaylabeli Köyü)",
      "Merkez Mah (yazılar Köyü)",
      "Merkez Mah (yeniceşeyhler Köyü)",
      "Merkez Öte Mah (gökören Köyü)",
      "Merkez Yayla Mah (sırçalı Köyü)",
      "Meşe Yaylası Mah (yazılar Köyü)",
      "Mongoşlar Mah (çamurluk Köyü)",
      "Munduşlar Köyü",
      "Muratlar Mah (sarpıncık Köyü)",
      "Mustanlar Mah (alpagut Köyü)",
      "Okuşlar Mah (beyderesi Köyü)",
      "Orman İşletme Mah (kilözü Köyü)",
      "Ormanpınar Mah (ormanpınar Köyü)",
      "Orta Mah (çepni Köyü)",
      "Orta Mah (karapınarkavağı Köyü)",
      "Orta-yukarı Yayla Evleri Mah (çepni Köyü)",
      "Osmançavuşlar Mah (beyderesi Köyü)",
      "Ova Mah (avdullar Köyü)",
      "Ova Mah (çamyurdu Köyü)",
      "Ova Mah (karapınarkavağı Köyü)",
      "Öküz Ova Mah (avdullar Köyü)",
      "Öküz Ova Mah (çamyurdu Köyü)",
      "Pirler Mah (pelitözü Köyü)",
      "Salmanlar Mah (munduşlar Köyü)",
      "Samutlar Mah (güveytepe Köyü)",
      "Sarıcalar Mah (fındıcak Köyü)",
      "Seyitaller Mah (gökören Köyü)",
      "Süveyköy Mah (ortaköy Köyü)",
      "Şemsi Mah (kovucak Köyü)",
      "Şuayipler Mah (gölcük Köyü)",
      "Taşçılar Mah (taşcılar Köyü)",
      "Tatarlar Mah (karamurat Köyü)",
      "Tavşansuyu Mah (tavşansuyu Köyü)",
      "Tekirler Mah (gölcük Köyü)",
      "Tepe Mah (dağyolu Köyü)",
      "Topallar Mah (yazılar Köyü)",
      "Topyeri Mah (elmacıkdere Köyü)",
      "Toraman Mah (kovucak Köyü)",
      "Uğurlualan Mah (uğurlualan Köyü)",
      "Uluçay Mah (çepni Köyü)",
      "Yalamalar Mah (uzunçam Köyü)",
      "Yarbaşı Mah (karamurat Köyü)",
      "Yayla Evi Mah (alanbaşı Mah) (beyderesi Köyü)",
      "Yayla Evi Mah (beyderesi Mah) (beyderesi Köyü)",
      "Yayla Evleri Mah (bayramlı Mah) (delice Köyü)",
      "Yayla Evleri Mah (merkez Mah) (delice Köyü)",
      "Yayla Evleri Mah (osmançavuşlar Mah) (beyderesi Köyü)",
      "Yayla Mah (elmacıkdere Köyü)",
      "Yazılar Yaylası Mah (yazılar Köyü)",
      "Yeni Mah (abant Sapağı Mah) (alpagut Köyü)",
      "Yeni Mah (güveytepe Köyü)",
      "Yeni Mah (kovucak Köyü)",
      "Yeni Mah (samat Köyü)",
      "Yeni Yerleşim Yeri Mah (hüsamettindere Köyü)",
      "Yenimahalle Mah (esenkaya Köyü)",
      "Yukarı Dedekan Mah (gökören Köyü)",
      "Yukarı Güney Mah (iğneciler Köyü)",
      "Yukarı Mah (bulanık Köyü)",
      "Yukarı Mah (çağşak Köyü)",
      "Yukarı Mah (çepni Köyü)",
      "Yukarı Mah (elmacıkdere Köyü)",
      "Yukarı Mah (merkez Mah) (çevreli Köyü)",
      "Yukarı Mah (örencik Köyü)",
      "Yukarı Mah (pelitözü Köyü)",
      "Büyükcami Mah",
      "Hızırfakı Mah",
      "Karacakaya Mah",
      "Kaygana Mah",
      "Musalla Mah",
      "Seyrancık Mah",
      "Yıldırım Bayazıd Mah",
      "Karacasu Mah (ortaköy Köyü)",
      "Karacasumandıra Mah (taşkesti Beldesi)",
      "Karaçomak Mah (taşkesti Beldesi)",
      "Merkez Mah (taşkesti Beldesi)",
      "Tosunlar Mah (taşkesti Beldesi)",
      "Yeğenderesi Mah (taşkesti Beldesi)"
    ],
    "Seben": [
      "Alpagut Köyü",
      "Aşağı Mah (değirmenkaya Köyü)",
      "Aşağı Mah (kızık Köyü)",
      "Aşağı Mah (korucuk Köyü)",
      "Aşağı Mah (kuzgölcük Köyü)",
      "Aşağı Yayla Mah (kuzgölcük Köyü)",
      "Avdan Mah (dedeler Köyü)",
      "Avudan Çavuşlar Yayla Mah (kozyaka Köyü)",
      "Avudan Demirciler Yayla Mah (kozyaka Köyü)",
      "Avudan Yayla Mah (nimetli Köyü)",
      "Bağ Evleri Mah (susuz Köyü)",
      "Bakırlı Köyü",
      "Bekirfakılar Mah (nimetli Köyü)",
      "Beylik Mah (haccağız Köyü)",
      "Bıyıklar Mah (kaşbıyıklar Köyü)",
      "Bıyıklar Yayla Mah (kaşbıyıklar Köyü)",
      "Çatak Mah (bozyer Köyü)",
      "Çatak Mah (susuz Köyü)",
      "Çavuşlar Mah (kozyaka Köyü)",
      "Çavuşlar Yayla Mah (kozyaka Köyü)",
      "Çirkinler Mah (dereboy Köyü)",
      "Çirkinler Yayla Mah (dereboy Köyü)",
      "Dağ Yayla Mah (bakırlı Köyü)",
      "Dedeler Mah (dedeler Köyü)",
      "Demirciler Mah (kozyaka Köyü)",
      "Demirciler Yayla Mah (kozyaka Köyü)",
      "Denizler Mah (nimetli Köyü)",
      "Denizler Yayla Mah (nimetli Köyü)",
      "Dereboy Yayla Mah (dereboy Köyü)",
      "Dereceviran Mah (kuzgölcük Köyü)",
      "Dikenli Mah (tepe Köyü)",
      "Dikenli Yayla Mah (gökhaliller Köyü)",
      "Dikmen Mah (gerenözü Köyü)",
      "Ekiciler Köyü",
      "Eyvazlar Mah (kozyaka Köyü)",
      "Gökhaliller Köyü",
      "Gölcük Mah (kabak Köyü)",
      "Güneşler Mah (dedeler Köyü)",
      "Güney Mah (dereboy Köyü)",
      "Güney Mah (kızık Köyü)",
      "Güneyce Köyü",
      "Haccağız  Yayla Mah (haccağız Köyü)",
      "Haccağız Mah (haccağız Köyü)",
      "Haydar Yayla Mah (haccağız Köyü)",
      "Hıdırlar Mah (yağma Köyü)",
      "Hoçaş Köyü",
      "Hoçaş Yayla Mah (hoçaş Köyü)",
      "İneklikuruk Mah (tepe Köyü)",
      "Kabak Yayla Mah (kabak Köyü)",
      "Kalıncak Mah (tepe Köyü)",
      "Kalıncak Yayla Mah (gökhaliller Köyü)",
      "Kanduzla Yayla Mah (gökhaliller Köyü)",
      "Karaağaç Köyü",
      "Karabunar Mah (gerenözü Köyü)",
      "Karacaören Mah (gerenözü Köyü)",
      "Kaş Mah (kaşbıyıklar Köyü)",
      "Kavaklıdağ Yayla Mah (kaşbıyıklar Köyü)",
      "Kesenözü Köyü",
      "Kınıkçı Mah (çeltikdere Köyü)",
      "Kıvrı Mah (kozyaka Köyü)",
      "Kızık Yayla Mah (kızık Köyü)",
      "Koçcevaz Yaylası Mah (alpagut Köyü)",
      "Korucuk Yayla Mah (korucuk Köyü)",
      "Kuz Mah (kızık Köyü)",
      "Mandır Mah (değirmenkaya Köyü)",
      "Merkez Mah (bozyer Köyü)",
      "Merkez Mah (dereboy Köyü)",
      "Merkez Mah (nimetli Köyü)",
      "Merkez Mah (solaklar Köyü)",
      "Merkez Mah (susuz Köyü)",
      "Merkez Mah (tepe Köyü)",
      "Merkez Mah (yağma Köyü)",
      "Musasofular Köyü",
      "Musasofular Yayla Mah (musasofular Köyü)",
      "Muslar Mah (kaşbıyıklar Köyü)",
      "Nimetli Yayla Mah (nimetli Köyü)",
      "Orta Mah (değirmenkaya Köyü)",
      "Orta Mah (gerenözü Köyü)",
      "Orta Mah (kabak Köyü)",
      "Orta Mah (korucuk Köyü)",
      "Orta Mah (kuzgölcük Köyü)",
      "Orta Yayla Mah (bakırlı Köyü)",
      "Solaklar Yayla Mah (solaklar Köyü)",
      "Söğüt Mah (yağma Köyü)",
      "Şahmanlar Mah (gerenözü Köyü)",
      "Şıhlar Mah (dedeler Köyü)",
      "Taşoluk Mah (solaklar Köyü)",
      "Tazılar Köyü",
      "Tepecik Mah (çeltikdere Köyü)",
      "Yayla Mah (ekiciler Köyü)",
      "Yayla Mah (tazılar Köyü)",
      "Yeni Mah (kaşbıyıklar Köyü)",
      "Yukarı Kucak Mah (gerenözü Köyü)",
      "Yukarı Mah (bozyer Köyü)",
      "Yukarı Mah (değirmenkaya Köyü)",
      "Yukarı Mah (gerenözü Köyü)",
      "Yukarı Mah (kabak Köyü)",
      "Yukarı Mah (korucuk Köyü)",
      "Yukarı Mah (kuzgölcük Köyü)",
      "Yukarı Yayla Mah (alpagut Köyü)",
      "Yukarı Yayla Mah (kuzgölcük Köyü)",
      "Yuva Köyü",
      "Çarşı Mah",
      "Keskinli Mah"
    ],
    "Yeniçağa": [
      "Acısu Mah (aşağıkuldan Köyü)",
      "Ahmetler Mah (ören Köyü)",
      "Akıncılar Köyü",
      "Aşağı Mah (doğancı Köyü)",
      "Aşağı Mah (şahnalar Köyü)",
      "Bey Mah (kındıra Köyü)",
      "Cevekeller Mah (kemaller Köyü)",
      "Çakırlar Mah (ören Köyü)",
      "Çamlık Köyü",
      "Çamurcuk Mah (adaköy Köyü)",
      "Çay Mah (şahnalar Köyü)",
      "Dereköy Mah (şahnalar Köyü)",
      "Dumanlar Mah (hamzabey Köyü)",
      "Ela Mah (gölbaşı Köyü)",
      "Eroğlu Mah (sarayköy Köyü)",
      "Gıgalar Mah (ören Köyü)",
      "Hamzalar Mah (ören Köyü)",
      "Hasanağalar Mah (kındıra Köyü)",
      "İzmirli Mah (sarayköy Köyü)",
      "Karabeyler Mah (hamzabey Köyü)",
      "Karamanlar Mah (dereköy Köyü)",
      "Karşı Mah (dereköy Köyü)",
      "Merkez Mah (adaköy Köyü)",
      "Merkez Mah (aşağıkuldan Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (doğancı Köyü)",
      "Merkez Mah (eskiçağa Köyü)",
      "Merkez Mah (gölbaşı Köyü)",
      "Merkez Mah (kemaller Köyü)",
      "Merkez Mah (kındıra Köyü)",
      "Merkez Mah (yamanlar Köyü)",
      "Merkez Mah (yukarıkuldan Köyü)",
      "Mitatlar Mah (ören Köyü)",
      "Müezzinler Mah (kemaller Köyü)",
      "Nallar Mah (kemaller Köyü)",
      "Orta Mah (yamanlar Köyü)",
      "Osman Ağalar Mah (ören Köyü)",
      "Sağırlar Mah (hamzabey Köyü)",
      "Saray Mah (sarayköy Köyü)",
      "Süleymanlar Mah (sarayköy Köyü)",
      "Tavşallar Mah (kemaller Köyü)",
      "Tepe Mah (şahnalar Köyü)",
      "Üç Evler Mah (şahnalar Köyü)",
      "Yayalar Mah (hamzabey Köyü)",
      "Yayla Evleri Mah (gölbaşı Köyü)",
      "Yayla Evleri Mah (ören Köyü)",
      "Yayla Evleri Mah (yukarıkuldan Köyü)",
      "Yayla Mah (adaköy Köyü)",
      "Yayla Mah (akıncılar Köyü)",
      "Yayla Mah (çamlık Köyü)",
      "Yayla Mah (doğancı Köyü)",
      "Yayla Mah (sarayköy Köyü)",
      "Yayla Mah (şahnalar Köyü)",
      "Yukarı Mah (aşağıkuldan Köyü)",
      "Yukarı Mah (şahnalar Köyü)",
      "Asil Bey Mah",
      "Camiatik Mah",
      "Gölyüzü Mah"
    ]
  },
  "Burdur": {
    "Ağlasun": [
      "Bala Mah",
      "Çınar Mah",
      "Hamam Mah",
      "Kıraç Mah",
      "Kum Mah",
      "Sakarca Mah",
      "Aşağıyumrutaş Köyü",
      "Bakırlı Mah (yumrutaş Köyü)",
      "Çamlıdere Köyü",
      "Çamova Mah (yumrutaş Köyü)",
      "Deregözü Mah (yeşilbaşköy Köyü)",
      "Dereköy Köyü",
      "Eynazlı Mah (yeşilbaşköy Köyü)",
      "Fatih Mah (mamak Köyü)",
      "Gökbel Mah (çamlıdere Köyü)",
      "Harmancık Mah (çamlıdere Köyü)",
      "Hisar Köyü",
      "Karagöl Mah (çamlıdere Köyü)",
      "Kiprit Köyü",
      "Sakarlar Mah (yazır Köyü)",
      "Sakızlık Mah (çamlıdere Köyü)",
      "Yavuz Mah (mamak Köyü)",
      "Yazır Köyü"
    ],
    "Altınyayla": [
      "Gülpınar Mah",
      "Heybeli Mah",
      "Taşyaka Mah",
      "Yeni Mah",
      "Bel Mah (ballık Köyü)",
      "Çukurkavak Mah (ballık Köyü)",
      "Kavakpınarı Mah (çörten Köyü)",
      "Kaymakcı Mah (ballık Köyü)",
      "Merkez Mah (asmabağ Köyü)",
      "Merkez Mah (ballık Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çörten Köyü)",
      "Merkez Mah (kızılyaka Köyü)",
      "Söben Mah (ballık Köyü)",
      "Süpürgelik Mah (ballık Köyü)"
    ],
    "Bucak": [
      "Alaattin Mah",
      "Atilla Mah",
      "Barboros Mah",
      "Çamlıca Mah",
      "Çamlıcaosb Mah",
      "Çavuşlar Mah",
      "Çukur Mah",
      "Karayvatlar Mah",
      "Konak Mah",
      "Mehmet Akif Mah",
      "Mimar Sinan Mah",
      "Oğuzhan Mah",
      "Onaç Mah",
      "Sanayi Mah",
      "Yetmiş Evler Mah",
      "Yörükler Mah",
      "Yunus Emre Mah",
      "Avdan Mah (kızılkaya Beldesi)",
      "Pazar Mah (kızılkaya Beldesi)",
      "Yeni Mah (kızılkaya Beldesi)",
      "Yuva Mah (kızılkaya Beldesi)",
      "Camii Mah (kocaaliler Beldesi)",
      "Esirlik Mah (kızılseki Köyü)",
      "Gökalan Mah (kocaaliler Beldesi)",
      "Karşıyaka Mah (kocaaliler Beldesi)",
      "Pazar Mah (kocaaliler Beldesi)",
      "Sarıotlu Mah (kızılseki Köyü)",
      "Seki Avlığı Mah (kızılseki Köyü)",
      "Sinanbaba Mah (kızılseki Köyü)",
      "Yoncaağaç Mah (kızılseki Köyü)",
      "Afetler Mah (taşyayla Köyü)",
      "Akçapınar Mah (kuşbaba Köyü)",
      "Ali Hüseyin Sarınçları Mah (kuyubaşı Köyü)",
      "Alkaya Köyü",
      "Anbahan Köyü",
      "Ankara Mah (ürkütlü Köyü)",
      "Aşağı Mah (kuşbaba Köyü)",
      "Aşağı Mah (taşyayla Köyü)",
      "Aykırı Mah (karaot Köyü)",
      "Belören Köyü",
      "Beşkonak Köyü",
      "Boğaz Mah (elsazı Köyü)",
      "Boğazköy Köyü",
      "Bozyaka Mah (elsazı Köyü)",
      "Cami Mah (karaot Köyü)",
      "Cami Mah (kızılseki Köyü)",
      "Camii Mah",
      "Cumhuriyet Mah (uğurlu Köyü)",
      "Çobanlar Mah (kargı Köyü)",
      "Dağarcık Köyü",
      "Değirmen Deresi Mah (kuşbaba Köyü)",
      "Dereağzı Mah (çobanpınarı Köyü)",
      "Elmalıbük Mah (kızıllı Köyü)",
      "Erekli Mah (karaot Köyü)",
      "Fatih Mah",
      "Fatih Mah (uğurlu Köyü)",
      "Güllüalan Mah (karaot Köyü)",
      "Hacıbağ Mah (çamlık Köyü)",
      "Hacıismailler Mah (kızıllı Köyü)",
      "Hanyıkığı Mah (karaot Köyü)",
      "Harmancık Mah (kargı Köyü)",
      "Hatipköy Mah (kızıllı Köyü)",
      "İncirdere Köyü",
      "Karaağaç Mah (çobanpınarı Köyü)",
      "Karaaliler Köyü",
      "Karacaören Köyü",
      "Karapınar Köyü",
      "Karaseki Köyü",
      "Kavacık Köyü",
      "Kavak Mah (elsazı Köyü)",
      "Kavaklı Mah (çamlık Köyü)",
      "Kayı Köyü",
      "Keçili Köyü",
      "Kestel Köyü",
      "Ketrit Mah (dutalanı Köyü)",
      "Kızılca Mah (çobanpınarı Köyü)",
      "Kızılcaağaç Köyü",
      "Kocayer Mah (çobanpınarı Köyü)",
      "Kozağacı Mah (karaot Köyü)",
      "Köletaşı Mah (karaot Köyü)",
      "Köyyatağı Mah (karaot Köyü)",
      "Merkez Mah (avdancık Köyü)",
      "Merkez Mah (dutalanı Köyü)",
      "Merkez Mah (elsazı Köyü)",
      "Merkez Mah (gündoğdu Köyü)",
      "Merkez Mah (kargı Köyü)",
      "Merkez Mah (kuyubaşı Köyü)",
      "Mersinaltı Mah (kuşbaba Köyü)",
      "Narağacı Mah (çobanpınarı Köyü)",
      "Narlı Mah (çamlık Köyü)",
      "Orta Mah (kuşbaba Köyü)",
      "Pazar Mah",
      "Pazar Mah (ürkütlü Köyü)",
      "Pazaralan Mah (çobanpınarı Köyü)",
      "Sahil Mah (çamlık Köyü)",
      "Saka Mah (çamlık Köyü)",
      "Seydiköy Köyü",
      "Sığındı Mah (dutalanı Köyü)",
      "Sivişler Mah (avdancık Köyü)",
      "Susuz Köyü",
      "Taşbaşı Mah (kargı Köyü)",
      "Taşdibi Mah (kargı Köyü)",
      "Tepe Boynu Mah (dutalanı Köyü)",
      "Üzümlübel Köyü",
      "Yeni Mah",
      "Yeni Mah (gündoğdu Köyü)",
      "Yenice Mah (elsazı Köyü)",
      "Yukarı Mah (kuyubaşı Köyü)",
      "Yüreğil Köyü"
    ],
    "Çavdır": [
      "Atatürk Mah",
      "Bayır Mah",
      "Çınar Mah",
      "Kocapınar Mah",
      "Menevşelik Mah",
      "Anbarcık Köyü",
      "Belen Mah (kozağacı Köyü)",
      "Bölmepınar Köyü",
      "Büyükalan Köyü",
      "Çakır Mah (kızıllar Köyü)",
      "Depo Mah (kozağacı Köyü)",
      "İshakköy Köyü",
      "Karaköy Köyü",
      "Kayacık Köyü",
      "Küçükalan Köyü",
      "Merkez Mah (kızıllar Köyü)",
      "Pazar Mah",
      "Saray Burnu Mah (kozağacı Köyü)",
      "Yazır Köyü",
      "Yeni Mah",
      "Çeşme Mah (söğüt Beldesi)",
      "Fatih Mah (söğüt Beldesi)",
      "Pazar Mah (söğüt Beldesi)",
      "Yeşil Mah (söğüt Beldesi)"
    ],
    "Çeltikçi": [
      "Camii Mah",
      "Konak Mah",
      "Aşağı Mah (güvenli Köyü)",
      "Bucak Çay Kenarı Mah (çebiş Köyü)",
      "Değirmenönü Mah (kuzköy Köyü)",
      "En İçi Mah (çebiş Köyü)",
      "Güney Mah (kuzköy Köyü)",
      "Kuzey Mah (kuzköy Köyü)",
      "Merkez Mah (çebiş Köyü)",
      "Ortayol Mah (çebiş Köyü)",
      "Ovacık Köyü",
      "Sarot Kayalı Yolu Mah (çebiş Köyü)",
      "Tekkeköy Köyü",
      "Yaka Mah (bağsaray Köyü)",
      "Yukarı Mah (bağsaray Köyü)",
      "Yukarı Mah (güvenli Köyü)"
    ],
    "Gölhisar": [
      "Armutlu Mah",
      "Çakmak Mah",
      "Çeşme Mah",
      "Fatih Mah",
      "Horzum Mah",
      "Konak Mah",
      "Merkez Camii Mah",
      "Pazar Mah",
      "Ulucamii Mah",
      "Asmalı Köyü",
      "Balcılar Mah (elmalıyurt Köyü)",
      "Başpınar Mah (elmalıyurt Köyü)",
      "Bayramlar Mah (elmalıyurt Köyü)",
      "Çamiçi Mah (elmalıyurt Köyü)",
      "Çamköy Köyü",
      "Çamlık Mah (ibecik Köyü)",
      "Çayiçi Mah (elmalıyurt Köyü)",
      "Damarası Mah (elmalıyurt Köyü)",
      "Delicin Mah (elmalıyurt Köyü)",
      "Deprem Evleri Mah (evciler Köyü)",
      "Divre Mah (elmalıyurt Köyü)",
      "Doğanlar Mah (elmalıyurt Köyü)",
      "Göçekiçi Mah (elmalıyurt Köyü)",
      "Gökçe Pınar Mah (yeşildere Köyü)",
      "Hanyanı Mah (elmalıyurt Köyü)",
      "Karataş Mah (elmalıyurt Köyü)",
      "Kelaliler Mah (elmalıyurt Köyü)",
      "Kocatarla Mah (hisarardı Köyü)",
      "Kuşdili Mevkii Mah (karapınar Köyü)",
      "Künüklü Mah (elmalıyurt Köyü)",
      "Kürtlüyamaç Mah (elmalıyurt Köyü)",
      "Merkez Mah (elmalıyurt Köyü)",
      "Merkez Mah (evciler Köyü)",
      "Merkez Mah (hisarardı Köyü)",
      "Merkez Mah (karapınar Köyü)",
      "Merkez Mah (kargalı Köyü)",
      "Merkez Mah (uylupınar Köyü)",
      "Merkez Mah (yeşildere Köyü)",
      "Orta Mah (elmalıyurt Köyü)",
      "Pazar Yeri Mah (elmalıyurt Köyü)",
      "Selmanlar Mah (elmalıyurt Köyü)",
      "Sorkun Köyü",
      "Tekeliler Mah (elmalıyurt Köyü)",
      "Turanlar Mah (elmalıyurt Köyü)",
      "Üçoluk Mah (yeşildere Köyü)",
      "Yağpınarı Mah (kargalı Köyü)",
      "Yamadı Köyü",
      "Yapraklı Mah (ibecik Köyü)",
      "Yeni Mah (ibecik Köyü)",
      "Yılanlı Mah (elmalıyurt Köyü)",
      "Yukarı Mah (uylupınar Köyü)",
      "Yusufça Mah (yusufça Beldesi)"
    ],
    "Karamanlı": [
      "Barbaros Mah",
      "Cafer Mah",
      "Camii Mah",
      "Çamlık Mah",
      "Eşeler Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karaman Mah",
      "Pazar Mah",
      "Yeni Mah",
      "Zafer Mah",
      "Aşağı Mah (bademli Köyü)",
      "Aşağı Mah (manca Köyü)",
      "Cami Mah (kılçan Köyü)",
      "Çay Mevkii Mah (dereköy Köyü)",
      "Dere Mah (kılavuzlar Köyü)",
      "Hantaşı Mevkii Mah (dereköy Köyü)",
      "Kantar Mah (kağılcık Köyü)",
      "Kayalı Köyü",
      "Kılavuzlar Köyü",
      "Kılçan Köyü",
      "Mürseller Köyü",
      "Okul Mah (kağılcık Köyü)",
      "Okul Mah (kılavuzlar Köyü)",
      "Taşocağı Mah (manca Köyü)",
      "Tepe Mah (kılavuzlar Köyü)",
      "Tepe Mah (kılçan Köyü)",
      "Tepe Mevkii Mah (dereköy Köyü)",
      "Yukarı Mah (bademli Köyü)",
      "Yukarı Mah (kağılcık Köyü)",
      "Yukarı Mah (manca Köyü)"
    ],
    "Kemer": [
      "Konak Mah",
      "Saray Mah",
      "Yeni Camii Mah",
      "Akçaören Köyü",
      "Akören Köyü",
      "Aşağı Mah (belenli Köyü)",
      "Aşağı Mah (yakalar Köyü)",
      "Çay Kenarı Mah (kayı Köyü)",
      "Elmacık Köyü",
      "Köyiçi Mah (yakalar Köyü)",
      "Orta Mah (kayı Köyü)",
      "Orta Tepe Mah (belenli Köyü)",
      "Pınarbaşı Köyü",
      "Yukarı Mah (kayı Köyü)",
      "Yukarı Tepe Mah (belenli Köyü)",
      "Yukarı Tepe Mah (yakalar Köyü)"
    ],
    "Merkez": [
      "Armağan İlci Mah",
      "Atatürk Mah",
      "Bağlar Mah",
      "Bahçelievler Mah",
      "Emek Mah",
      "Fevzi Çakmak Mah",
      "Hızır İlyas Mah",
      "Menderes Mah",
      "Şeker Evleri Mah",
      "Burç Mah",
      "Çeşmedamı Mah",
      "Değirmenler Mah",
      "İnönü Mah",
      "Karasenir Mah",
      "Konak Mah",
      "Özgür Mah",
      "Pazar Mah",
      "Sakarya Mah",
      "Sinan Mah",
      "Tepe Mah",
      "Üçdibek Mah",
      "Zafer Mah",
      "Aksu Köyü",
      "Akyaka Köyü",
      "Armut Mah (gökçebağ Köyü)",
      "Aşağı Cinbilli Mah (cimbilli Köyü)",
      "Aşağı Mah (çallıca Köyü)",
      "Aşağı Müslümler Köyü",
      "Aşağı Tekkeönü Mah (askeriye Köyü)",
      "Aziziye Köyü",
      "Başakevler Mah (gökçebağ Köyü)",
      "Başakevler Osb Mah (gökçebağ Köyü)",
      "Başmakçı Köyü",
      "Bayındır Köyü",
      "Bereket Köyü",
      "Beşkavak Köyü",
      "Boğaziçi Köyü",
      "Bozlar Köyü",
      "Cami Mah (akyayla Köyü)",
      "Cami Mah (askeriye Köyü)",
      "Çay Mah (ilyas Köyü)",
      "Çendik Köyü",
      "Çeşmeönü Mah (ilyas Köyü)",
      "Çine Köyü",
      "Çukurçeşme Mah (askeriye Köyü)",
      "Deştimankale Mah (kayaaltı Köyü)",
      "Düğer Köyü",
      "Erikli Köyü",
      "Fatih Mah (büğdüz Köyü)",
      "Günalan Köyü",
      "Güneyyayla Köyü",
      "Hacılar Köyü",
      "Hal Mah (askeriye Köyü)",
      "Halıcılar Köyü",
      "İğdederesi Mah (kayaaltı Köyü)",
      "İğdeli Köyü",
      "İnsuyu Mah (çatağıl Köyü)",
      "Kapaklı Köyü",
      "Kara Taş Mah (gökçebağ Köyü)",
      "Karacaören Köyü",
      "Karaçal Köyü",
      "Karadere Mah (askeriye Köyü)",
      "Karakent Köyü",
      "Karşı Mah (akyayla Köyü)",
      "Kartalpınar Köyü",
      "Kavacık Köyü",
      "Kavak Altı Mah (gökçebağ Köyü)",
      "Kayadibi Suludere Mah (suludere Köyü)",
      "Kayış Köyü",
      "Kerpiççukuru Mah (kayaaltı Köyü)",
      "Kocapınar Köyü",
      "Kökez Köyü",
      "Köyiçi Mah (gökçebağ Köyü)",
      "Kumluca Köyü",
      "Kurna Köyü",
      "Kuruçay Köyü",
      "Mandıra Mah (çatağıl Köyü)",
      "Menderes Mah (büğdüz Köyü)",
      "Mezarlık Mah (kayaaltı Köyü)",
      "Mithat Paşa Mah (kozluca Köyü)",
      "Oğuzhan Mah (büğdüz Köyü)",
      "Orta Mah (ilyas Köyü)",
      "Orta Mah (kayaaltı Köyü)",
      "Ova Mah (çallıca Köyü)",
      "Ova Mah (kayaaltı Köyü)",
      "Park Mah (kozluca Köyü)",
      "Saray Mah (kozluca Köyü)",
      "Sarıova Köyü",
      "Sığırbiriken Mah (kayaaltı Köyü)",
      "Soğanlı Köyü",
      "Taşkapı Köyü",
      "Tepe Mah (cimbilli Köyü)",
      "Ulupınar Köyü",
      "Y.kökez Mah (kökez Köyü)",
      "Yaka Mah (askeriye Köyü)",
      "Yarıköy Köyü",
      "Yassıgüme Köyü",
      "Yaylabeli Köyü",
      "Yazıköy Köyü",
      "Yeni Cami Mah (askeriye Köyü)",
      "Yeni Suludere Mah (suludere Köyü)",
      "Yeşildağ Köyü",
      "Yol Altı Mah (gökçebağ Köyü)",
      "Yukarı Cinbilli Mah (cimbilli Köyü)",
      "Yukarı Mah (çallıca Köyü)",
      "Yukarı Suludere Mah (suludere Köyü)",
      "Yukarı Tekkeönü Mah (askeriye Köyü)",
      "Aydınlıkevler Mah",
      "Kışla Mah",
      "Kışlaosb Mah",
      "Şirinevler Mah",
      "Akın Mah",
      "Bozkurt Mah",
      "Cemil Mah",
      "Dere Mah",
      "Kuyu Mah",
      "Mehmet Akif Ersoy Mah",
      "Necati Bey Mah",
      "Recep Mah",
      "Yeni Mah",
      "Yenice Mah"
    ],
    "Tefenni": [
      "Aşıklar Mah (hasanpaşa Köyü)",
      "Başpınar Köyü",
      "Bayramlar Köyü",
      "Belkaya Köyü",
      "Beşiktaş Mah (beyköy Köyü)",
      "Cumhuriyet Mah (hasanpaşa Köyü)",
      "Çaylı Köyü",
      "Ece Köyü",
      "Göktürk Mah",
      "Kaklık Mah (beyköy Köyü)",
      "Karamusa Köyü",
      "Sazak Köyü",
      "Seydiler Köyü",
      "Yaylaköy Köyü",
      "Yeni Mah (hasanpaşa Köyü)",
      "Yeşilköy Köyü",
      "Yuva Köyü",
      "Yuvalak Köyü",
      "Zafer Mah (beyköy Köyü)",
      "Esentepe Mah",
      "Eşeler Mah",
      "Fatih Mah",
      "Kır Mah",
      "Pazar Mah",
      "Yenice Mah",
      "Yokuş Mah",
      "Zafer Mah"
    ],
    "Yeşilova": [
      "1.küme Evler Mah (orhanlı Köyü)",
      "2.küme Evler Mah (orhanlı Köyü)",
      "Armut Köyü",
      "Aşağı Cami Mah (güney Köyü)",
      "Aşağı Kırlı Köyü",
      "Aşağı Mah (salda Köyü)",
      "Atatürk Mah (çuvallı Köyü)",
      "Bahçeli Evler Mah (çaltepe Köyü)",
      "Bayındır Köyü",
      "Bayırbaşı Köyü",
      "Beyköy Köyü",
      "Cami Mah (çuvallı Köyü)",
      "Çardak Köyü",
      "Dereköy Köyü",
      "Düden Köyü",
      "Elden Köyü",
      "Gençali Köyü",
      "Gökçeyaka Köyü",
      "Horozköy Köyü",
      "Hüyük Mah (yarışlı Köyü)",
      "İğdir Köyü",
      "Karaköy Köyü",
      "Karaköy Mah (harmanlı Köyü)",
      "Karşı Mah (harmanlı Köyü)",
      "Kavak Köyü",
      "Kayaköy Mah (alanköy Köyü)",
      "Köyiçi Mah (akçaköy Köyü)",
      "Köyiçi Mah (alanköy Köyü)",
      "Köyiçi Mah (başkuyu Köyü)",
      "Köyiçi Mah (bedirli Köyü)",
      "Köyiçi Mah (büyükyaka Köyü)",
      "Köyiçi Mah (çaltepe Köyü)",
      "Köyiçi Mah (çeltek Köyü)",
      "Köyiçi Mah (çuvallı Köyü)",
      "Köyiçi Mah (doğanbaba Köyü)",
      "Köyiçi Mah (ışıklar Köyü)",
      "Köyiçi Mah (onacak Köyü)",
      "Köyiçi Mah (örencik Köyü)",
      "Köyiçi Mah (yarışlı Köyü)",
      "Kumluk Mah (çuvallı Köyü)",
      "Merkez Mah (harmanlı Köyü)",
      "Niyazlar Köyü",
      "Orhanlı Köyü",
      "Ömerler Mah (örencik Köyü)",
      "Sağlık Ocağı Mah (yarışlı Köyü)",
      "Sazak Köyü",
      "Şehit İsmail Erçoban Mah (çaltepe Köyü)",
      "Taşpınar Köyü",
      "Tekke Mah (yarışlı Köyü)",
      "Yaka Mah (çaltepe Köyü)",
      "Yeni Bağlar Mah (çuvallı Köyü)",
      "Yeni Mah (çaltepe Köyü)",
      "Yukarı Cami Mah (güney Köyü)",
      "Yukarı Kırlı Köyü",
      "Yukarı Mah (onacak Köyü)",
      "Yukarı Mah (salda Köyü)",
      "Yukarı Müslümler Mah (yarışlı Köyü)",
      "Bahcelievler Mah",
      "Değirmen Mah",
      "Emek Mah",
      "Karaatlı Mah",
      "Kayadibi Mah",
      "Koyunlar Çeşme Mah",
      "Merkez Mah"
    ]
  },
  "Bursa": {
    "Büyükorhan": [
      "Akçasaz Mah",
      "Aktaş Mah",
      "Armutçuk Mah",
      "Bademlik Mah",
      "Balaban Mah",
      "Bayındır Mah",
      "Burunca Mah",
      "Cumhuriyet Mah",
      "Çakıryenice Mah",
      "Çeribaşı Mah",
      "Danacılar Mah",
      "Danaçalı Mah",
      "Demirler Mah",
      "Derecik Mah",
      "Durhasan Mah",
      "Düğüncüler Mah",
      "Elekçalı Mah",
      "Ericek Mah",
      "Gedikler Mah",
      "Geynik Mah",
      "Hacıahmetler Mah",
      "Hacılar Mah",
      "Hemşeriler Mah",
      "Hocahasan Mah",
      "İsmetiye Mah",
      "Karaağız Mah",
      "Karaçukur Mah",
      "Karalar Mah",
      "Kayapa Mah",
      "Kınık Mah",
      "Kuşlar Mah",
      "Mazlumlar Mah",
      "Orhan Mah",
      "Osmanlar Mah",
      "Örencik Mah",
      "Özlüce Mah",
      "Perçin Mah",
      "Pınarköy Mah",
      "Pirebeyler Mah",
      "Sarnıç Mah",
      "Tekerler Mah",
      "Yenice Mah",
      "Zaferiye Mah"
    ],
    "Gemlik": [
      "Adliye Mah",
      "Ata Mah",
      "Ata Sb Mah",
      "Balıkpazarı Mah",
      "Büyükkumla Mah",
      "Cihatlı Mah",
      "Cumhuriyet Mah",
      "Demirsubaşı Mah",
      "Dr.ziya Kaya Mah",
      "Engürücük Mah",
      "Eşref Dinçer Mah",
      "Feyziye Mah",
      "Fındıcak Mah",
      "Gençali Mah",
      "Güvenli Mah",
      "Halitpaşa Mah",
      "Hamidiye Mah",
      "Hamidiyeköy Mah",
      "Haydariye Mah",
      "Hisar Mah",
      "Karacaali Mah",
      "Katırlı Mah",
      "Kayhan Mah",
      "Kumla Mah",
      "Kurşunlu Mah",
      "Kurtul Mah",
      "Küçükkumla Mah",
      "Muratoba Mah",
      "Narlı Mah",
      "Orhaniye Mah",
      "Osmaniye Mah",
      "Şahinyurdu Mah",
      "Şükriye Mah",
      "Umurbey Mah",
      "Yeni Mah",
      "Yeniköy Mah"
    ],
    "Gürsu": [
      "Adaköy Mah",
      "Ağaköy Mah",
      "Canbazlarköyü Mah",
      "Dışkayaköyü Mah",
      "Ericekköyü Mah",
      "Hasanköy Mah",
      "İğdirköyü Mah",
      "İpekyolu Mah",
      "İstiklal Mah",
      "Karahıdırköyü Mah",
      "Kazıklıköyü Mah",
      "Kumlukalan Mah",
      "Kurtuluş Mah",
      "Kurtuluşosb Mah",
      "Yenidoğan Mah",
      "Yenidoğanosb Mah",
      "Zafer Mah"
    ],
    "Harmancık": [
      "Akpınar Mah",
      "Alutca Mah",
      "Balatdanişment Mah",
      "Ballısaray Mah",
      "Bekdemirler Mah",
      "Çakmak Mah",
      "Çamoğlu Mah",
      "Çatalsöğüt Mah",
      "Dedebali Mah",
      "Delicegüney Mah",
      "Dutluca Mah",
      "Ece Mah",
      "Gedikören Mah",
      "Gökçeler Mah",
      "Gülözü Mah",
      "Harmancık Akalan Mah",
      "Hopandanişment Mah",
      "Ilıcaksu Mah",
      "İshaklar Mah",
      "Karaca Mah",
      "Kepekdere Mah",
      "Kılavuzlar Mah",
      "Kışmanlar Mah",
      "Kocapınar Mah",
      "Kozluca Mah",
      "Merkez Mah",
      "Nalbant Mah",
      "Okçular Mah",
      "Saçaklı Mah",
      "Yayabaşı Mah",
      "Yeşilyurt Mah"
    ],
    "İnegöl": [
      "Akbaşlar Mah",
      "Akhisar Mah",
      "Akıncılar Mah",
      "Alibey Mah",
      "Aşağıballık Mah",
      "Babaoğlu Mah",
      "Bahariye Mah",
      "Bahçekaya Mah",
      "Baykoca Mah",
      "Bayramşah Mah",
      "Bilalköy Mah",
      "Boğazköy Mah",
      "Burhaniye Mah",
      "Cemiyet Mah",
      "Cerrah Mah",
      "Cuma Mah",
      "Cumhuriyet Mah",
      "Çavuşköy Mah",
      "Çaylıca Mah",
      "Çayyaka Mah",
      "Çeltikçi Mah",
      "Çiftlikköy Mah",
      "Çitli Mah",
      "Deydinler Mah",
      "Dipsizgöl Mah",
      "Doğanyurdu Mah",
      "Dömez Mah",
      "Edebey Mah",
      "Elmaçayır Mah",
      "Ertuğrulgazi Mah",
      "Esenköy Mah",
      "Esentepe Mah",
      "Eski Bahçekaya Mah",
      "Eskikaracakaya Mah",
      "Eskiköy Mah",
      "Eymir Mah",
      "Fatih Mah",
      "Fevziye Mah",
      "Fındıklı Mah",
      "Gazelli Mah",
      "Gedikpınar Mah",
      "Gülbahçe Mah",
      "Gündüzlü Mah",
      "Güneykestane Mah",
      "Güzelyurt Mah",
      "Hacıkara Mah",
      "Halhalca Mah",
      "Hamamlı Mah",
      "Hamidiye Mah",
      "Hamitabat Mah",
      "Hamzabey Mah",
      "Hamzabey Osb Mah",
      "Hasanpaşa Mah",
      "Hayriye Mah",
      "Hilmiye Mah",
      "Hocaköy Mah",
      "Huzur Mah",
      "İclaliye Mah",
      "İhsaniye Mah",
      "İsaören Mah",
      "Karagölet Mah",
      "Karahasanlar Mah",
      "Karakadı Mah",
      "Karalar Mah",
      "Kayapınar Mah",
      "Kemalpaşa Mah",
      "Kestanealanı Mah",
      "Kınık Mah",
      "Kıran Mah",
      "Kocakonak Mah",
      "Konurlar Mah",
      "Kozluca Mah",
      "Kulaca Mah",
      "Kurşunlu Mah",
      "Küçükyenice Mah",
      "Lütfiye Mah",
      "Madenköy Mah",
      "Mahmudiye Mah",
      "Mesudiye Mah",
      "Mezit Mah",
      "Muratbey Mah",
      "Olukman Mah",
      "Orhaniye Mah",
      "Ortaköy Mah",
      "Osmaniye Mah",
      "Osmaniyeköy Mah",
      "Özlüce Mah",
      "Paşaören Mah",
      "Rüştiye Mah",
      "Saadet Mah",
      "Sarıpınar Mah",
      "Sinanbey Mah",
      "Soğukdere Mah",
      "Sulhiye Mah",
      "Sultaniye Mah",
      "Sungurpaşa Mah",
      "Süle Mah",
      "Süleymaniye Mah",
      "Süleymaniyeosb Mah",
      "Sülüklügöl Mah",
      "Süpürtü Mah",
      "Şehitler Mah",
      "Şipali Mah",
      "Tahtaköprü Mah",
      "Tekkeköy Mah",
      "Tokuş Mah",
      "Turgutalp Mah",
      "Turgutalpköy Mah",
      "Tuzla Mah",
      "Tüfekçikonak Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yeniceköy Mah",
      "Yeniköy Mah",
      "Yeniyörük Mah",
      "Yiğit Mah",
      "Yukarıballık Mah",
      "Yunusemre Mah"
    ],
    "İznik": [
      "Aydınlar Mah",
      "Bayındır Mah",
      "Beyler Mah",
      "Boyalıca Mah",
      "Candarlı Mah",
      "Çakırca Mah",
      "Çamdibi Mah",
      "Çamoluk Mah",
      "Çampınar Mah",
      "Çiçekli Mah",
      "Derbent Mah",
      "Dereköy Mah",
      "Dırazali Mah",
      "Elbeyli Mah",
      "Elmalı Mah",
      "Eşrefzade Mah",
      "Göllüce Mah",
      "Gürmüzlü Mah",
      "Hacıosman Mah",
      "Hisardere Mah",
      "Hocaköy Mah",
      "İhsaniye Mah",
      "İnikli Mah",
      "Karatekin Mah",
      "Kaynarca Mah",
      "Kırıntı Mah",
      "Kutluca Mah",
      "Mahmudiye Mah",
      "Mahmut Çelebi Mah",
      "Mecidiye Mah",
      "Mustafa Kemal Paşa Mah",
      "Mustafalı Mah",
      "Müşküle Mah",
      "Orhaniye Mah",
      "Osmaniye Mah",
      "Ömerli Mah",
      "Sansarak Mah",
      "Sarıağıl Mah",
      "Selçuk Mah",
      "Süleymaniye Mah",
      "Şerefiye Mah",
      "Tacir Mah",
      "Yeni Mah",
      "Yenişerefiye Mah",
      "Yeşil Camii Mah",
      "Yürükler Mah"
    ],
    "Karacabey": [
      "Abdullahpaşa Mah",
      "Akçakoyun Mah",
      "Akçasusurluk Mah",
      "Akhisar Mah",
      "Arız Mah",
      "Bakırköy Mah",
      "Ballıkaya Mah",
      "Bayramdere Mah",
      "Beylik Mah",
      "Boğazköy Mah",
      "Canbalı Mah",
      "Canbaz Mah",
      "Çamlıca Mah",
      "Çarıkköy Mah",
      "Çavuş Mah",
      "Çeşnigir Mah",
      "Dağesemen Mah",
      "Dağkadı Mah",
      "Danişment Mah",
      "Doğla Mah",
      "Drama Mah",
      "Ekinli Mah",
      "Ekmekçi Mah",
      "Emirsultan Mah",
      "Esentepe Mah",
      "Eskikaraağaç Mah",
      "Eskisarıbey Mah",
      "Fevzipaşa Mah",
      "Garipçe Mah",
      "Gazi Mah",
      "Gölecik Mah",
      "Gölkıyı Mah",
      "Gönü Mah",
      "Güngörmez Mah",
      "Hamidiye Mah",
      "Harmanlı Mah",
      "Hayırlar Mah",
      "Hotanlı Mah",
      "Hüdavendigar Mah",
      "Hürriyet Mah",
      "İkizce Mah",
      "İnkaya Mah",
      "İsmetpaşa Mah",
      "Karacaahmet Mah",
      "Karakoca Mah",
      "Karasu Mah",
      "Kedikaya Mah",
      "Keşlik Mah",
      "Kıranlar Mah",
      "Kulakpınar Mah",
      "Kurşunlu Mah",
      "Küçükkaraağaç Mah",
      "Mamuriyet Mah",
      "Mecidiye Mah",
      "Muratlı Mah",
      "Nasrettin Mah",
      "Okçular Mah",
      "Orhaniye Mah",
      "Ortasarıbey Mah",
      "Ova Hamidiye Mah",
      "Ovaesemen Mah",
      "Örencik Mah",
      "Runguşpaşa Mah",
      "Saadet Mah",
      "Sazlıca Mah",
      "Selimiye Mah",
      "Seyran Mah",
      "Sırabademler Mah",
      "Subaşı Mah",
      "Sultaniye Mah",
      "Şahinköy Mah",
      "Şahmelek Mah",
      "Tabaklar Mah",
      "Taşlık Mah",
      "Taşpınar Mah",
      "Tavşanlı Mah",
      "Tophisar Mah",
      "Uluabat Mah",
      "Yarış Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenikaraağaç Mah",
      "Yenisarıbey Mah",
      "Yeşildere Mah",
      "Yolağzı Mah"
    ],
    "Keles": [
      "Akçapınar Mah",
      "Alpağut Mah",
      "Avdan Mah",
      "Baraklı Mah",
      "Basak Mah",
      "Belenören Mah",
      "Bıyıklıalanı Mah",
      "Cuma Mah",
      "Çukur Mah",
      "Dağ Demirciler Mah",
      "Dağdibi Mah",
      "Davutlar Mah",
      "Dedeler Mah",
      "Delice Mah",
      "Denizler Mah",
      "Durak Mah",
      "Düvenli Mah",
      "Epçeler Mah",
      "Ertuğrulgazi Mah",
      "Gelemiç Mah",
      "Gököz Mah",
      "Harmanalanı Mah",
      "Harmancık Demirci Mah",
      "Haydar Mah",
      "Hereke Mah",
      "Issızören Mah",
      "Karaardıç Mah",
      "Kemaliye Mah",
      "Kıran Işıklar Mah",
      "Kirazlı Mah",
      "Koca Kovacık Mah",
      "Kozbudaklar Mah",
      "Küçük Kovacık Mah",
      "Menteşe Mah",
      "Pınarcık Mah",
      "Sofular Mah",
      "Sorgun Mah",
      "Uzunöz Mah",
      "Yağcılar Mah",
      "Yazıbaşı Mah",
      "Yenice Mah",
      "Yunuslar Mah"
    ],
    "Kestel": [
      "Ağlaşan Mah",
      "Ahmet Vefik Paşa Osb Mah",
      "Ahmetvefikpaşa Mah",
      "Aksu Mah",
      "Alaçam Mah",
      "Babasultan Mah",
      "Barakfakih Mah",
      "Barakfakih Osb Mah",
      "Burhaniye Mah",
      "Çataltepe Mah",
      "Derekızık Mah",
      "Dudaklı Mah",
      "Erdoğan Mah",
      "Esentepe Mah",
      "Gölbaşı Mah",
      "Gölcük Mah",
      "Gözede Mah",
      "Kale Mah",
      "Kayacık Mah",
      "Kazancı Mah",
      "Kozluören Mah",
      "Lütfiye Mah",
      "Narlıdere Mah",
      "Nüzhetiye Mah",
      "Orhaniye Mah",
      "Osmaniye Mah",
      "Saitabat Mah",
      "Sayfiye Mah",
      "Serme Mah",
      "Seymen Mah",
      "Soğuksu Mah",
      "Şevketiye Mah",
      "Turanköy Mah",
      "Ümitalan Mah",
      "Vanimehmet Mah",
      "Yağmurlu Mah",
      "Yeni Mah"
    ],
    "Mudanya": [
      "Akköy Mah",
      "Altıntaş Mah",
      "Aydınpınar Mah",
      "Bademli Mah",
      "Balabancık Mah",
      "Çağrışan Mah",
      "Çamlık Mah",
      "Çayönü Mah",
      "Çekrice Mah",
      "Çepni Mah",
      "Çınarlı Mah",
      "Dedeköy Mah",
      "Dereköy Mah",
      "Eğerce Mah",
      "Emirleryenicesi Mah",
      "Esence Mah",
      "Evciler Mah",
      "Göynüklü Mah",
      "Güzelyalı Burgaz Mah",
      "Güzelyalı Eğitim Mah",
      "Güzelyalı Siteler Mah",
      "Güzelyalı Yalı Mah",
      "Halitpaşa Mah",
      "Hançerli Mah",
      "Hasanbey Mah",
      "Hasköy Mah",
      "Işıklı Mah",
      "İpekyayla Mah",
      "Kaymakoba Mah",
      "Kumyaka Mah",
      "Küçükyenice Mah",
      "Mesudiye Mah",
      "Mirzaoba Mah",
      "Mürsel Mah",
      "Mütareke Mah",
      "Orhaniye Mah",
      "Ömerbey Mah",
      "Söğütpınar Mah",
      "Şükrüçavuş Mah",
      "Tirilye Mah",
      "Ülkü Mah",
      "Yalıçiftlik Mah",
      "Yaman Mah",
      "Yaylacık Mah",
      "Yeni Mah",
      "Yörükali Mah",
      "Yörükyenicesi Mah"
    ],
    "Mustafakemalpaşa": [
      "Adaköy Mah",
      "Adalet Mah",
      "Ağaçlı Mah",
      "Akarca Mah",
      "Akçapınar Mah",
      "Alacaat Mah",
      "Aliseydi Mah",
      "Alpağut Mah",
      "Aralık Mah",
      "Aşağıbalı Mah",
      "Atariye Mah",
      "Atatürk Mah",
      "Ayaz Mah",
      "Bahariye Mah",
      "Barış Mah",
      "Behram Mah",
      "Boğaz Mah",
      "Bostandere Mah",
      "Bük Mah",
      "Camandar Mah",
      "Cumhuriyet Mah",
      "Çakallar Mah",
      "Çaltılıbük Mah",
      "Çamlıca Mah",
      "Çardakbelen Mah",
      "Çavuş Mah",
      "Çeltikçi Mah",
      "Çırpan Mah",
      "Çiviliçam Mah",
      "Çömlekçi Mah",
      "Çördük Mah",
      "Dallıca Mah",
      "Demirdere Mah",
      "Demireli Mah",
      "Dere Mah",
      "Derecik Mah",
      "Derekadı Mah",
      "Devecikonağı Mah",
      "Doğanalan Mah",
      "Doğancı Mah",
      "Dorak Mah",
      "Döllük Mah",
      "Durumtay Mah",
      "Eskibalçık Mah",
      "Eskikızılelma Mah",
      "Fevzidede Mah",
      "Fındıcak Mah",
      "Garipçetekke Mah",
      "Güller Mah",
      "Güllüce Mah",
      "Gündoğdu Mah",
      "Güveçdere Mah",
      "Güvem Mah",
      "Hacıahmet Mah",
      "Hacıali Mah",
      "Hamidiye Mah",
      "Hamidiyeköyü Mah",
      "Hamzabey Mah",
      "Hisaraltı Mah",
      "Işıklar Mah",
      "İlyasçılar Mah",
      "İncealipınar Mah",
      "Kabulbaba Mah",
      "Kadirçeşme Mah",
      "Kapaklıoluk Mah",
      "Karacalar Mah",
      "Karaköy Mah",
      "Karaoğlan Mah",
      "Karaorman Mah",
      "Karapınar Mah",
      "Kayabaşı Mah",
      "Kazanpınar Mah",
      "Keltaş Mah",
      "Kestelek Mah",
      "Killik Mah",
      "Kocakoru Mah",
      "Kosova Mah",
      "Koşuboğazı Mah",
      "Kömürcükadı Mah",
      "Körekem Mah",
      "Kösehoroz Mah",
      "Kumkadı Mah",
      "Kurşunlu Mah",
      "Lalaşahin Mah",
      "Lütfiye Mah",
      "Melik Mah",
      "Muradiyesarnıç Mah",
      "Ocaklı Mah",
      "Onaç Mah",
      "Orhaniye Mah",
      "Ormankadı Mah",
      "Orta Mah",
      "Osmaniye Mah",
      "Ovaazatlı Mah",
      "Ömeraltı Mah",
      "Paşalar Mah",
      "Sarımustafalar Mah",
      "Selimiye Mah",
      "Sincansarnıç Mah",
      "Soğucak Mah",
      "Soğukpınar Mah",
      "Söğütalan Mah",
      "Sünlük Mah",
      "Şapçı Mah",
      "Şehriman Mah",
      "Şerefiye Mah",
      "Şevketiye Mah",
      "Şeyhmüftü Mah",
      "Taşköprü Mah",
      "Taşpınar Mah",
      "Tatkavaklı Mah",
      "Tepecik Mah",
      "Tırnova Mah",
      "Uğurlupınar Mah",
      "Üçbeyli Mah",
      "Vıraca Mah",
      "Yalıntaş Mah",
      "Yamanlı Mah",
      "Yavelli Mah",
      "Yaylaçayır Mah",
      "Yenibalçık Mah",
      "Yenice Mah",
      "Yenidere Mah",
      "Yenikızılelma Mah",
      "Yeşilova Mah",
      "Yoncaağaç Mah",
      "Yukarıbalı Mah",
      "Yumurcaklı Mah",
      "Yunus Emre Mah",
      "Yüzbaşı Sabribey Mah",
      "Züferbey Mah"
    ],
    "Nilüfer": [
      "Alaaddinbey Mah",
      "Ürünlü Mah",
      "19 Mayıs Mah",
      "23 Nisan Mah",
      "Altınşehir Mah",
      "Ataevler Mah",
      "Barış Mah",
      "Cumhuriyet Mah",
      "Fethiye Mah",
      "Ahmet Yesevi Mah",
      "Balat Mah",
      "Balatosb Mah",
      "Beşevler Mah",
      "Çamlıca Mah",
      "Gümüştepe Mah",
      "Çalı Mah",
      "29 Ekim Mah",
      "Ertuğrul Mah",
      "Özlüce Mah",
      "Yüzüncüyıl Mah",
      "Balkan Mah",
      "Dumlupınar Mah",
      "Görükle Mah",
      "Kurtuluş Mah",
      "30 Ağustos Zafer Mah",
      "Hasanağa Mah",
      "Hasanağa Osb Mah",
      "Kayapa Mah",
      "Kızılcıklı Mah",
      "Tahtalı Mah",
      "Yaylacık Mah",
      "Esentepe Mah",
      "İhsaniye Mah",
      "Karaman Mah",
      "Akçalar Mah",
      "Büyükbalıklı Mah",
      "Doğanköy Mah",
      "Gökçe Mah",
      "Gölyazı Mah",
      "İrfaniye Mah",
      "Konaklı Mah",
      "Yolçatı Mah",
      "Konak Mah",
      "Kültür Mah",
      "Odunluk Mah",
      "Atlas Mah",
      "Ayvaköy Mah",
      "Badırga Mah",
      "Başköy Mah",
      "Çatalağıl Mah",
      "Çaylı Mah",
      "Dağyenice Mah",
      "Fadıllı Mah",
      "Güngören Mah",
      "İnegazi Mah",
      "Kadriye Mah",
      "Karacaoba Mah",
      "Korubaşı Mah",
      "Kuruçeşme Mah",
      "Makşempınarı Mah",
      "Unçukuru Mah",
      "Üçpınar Mah",
      "Minareliçavuş Bursa Osb Mah",
      "Minareliçavuş Mah",
      "Minareliçavuşosb Mah",
      "Fethiyeosb Mah",
      "Işıktepe Mah",
      "Işıktepeosb Mah",
      "Demirci Mah",
      "Üçevler Mah"
    ],
    "Orhaneli": [
      "300 Evler Mah",
      "Ağaçhisar Mah",
      "Akalan Mah",
      "Akçabük Mah",
      "Altıntaş Mah",
      "Argın Mah",
      "Balıoğlu Mah",
      "Başköy Mah",
      "Belenoluk Mah",
      "Celepler Mah",
      "Çeki Mah",
      "Çınarcık Mah",
      "Çivili Mah",
      "Çöreler Mah",
      "Dağgüney Mah",
      "Deliballılar Mah",
      "Demirci Mah",
      "Dere Mah",
      "Dündar Mah",
      "Emir Mah",
      "Erenler Mah",
      "Esentepe Mah",
      "Eskidanişment Mah",
      "Fadıl Mah",
      "Fevzipaşa Mah",
      "Firoz Mah",
      "Gazioluk Mah",
      "Gazipaşa Mah",
      "Girencik Mah",
      "Göktepe Mah",
      "Göynükbelen Mah",
      "Gümüşpınar Mah",
      "İkizoluk Mah",
      "İsmetpaşa Mah",
      "Kabaklar Mah",
      "Kadı Mah",
      "Karabekirpaşa Mah",
      "Karaoğlanlar Mah",
      "Karasi Mah",
      "Karıncalı Mah",
      "Koçu Mah",
      "Kusumlar Mah",
      "Küçükorhan Mah",
      "Letafet Mah",
      "Mahaller Mah",
      "Nalınlar Mah",
      "Orta Mah",
      "Osmaniyeçatak Mah",
      "Sadağı Mah",
      "Semerci Mah",
      "Serçeler Mah",
      "Sırıl Mah",
      "Söğüt Mah",
      "Süleymanbey Mah",
      "Şükriye Mah",
      "Tepecik Mah",
      "Topuk Mah",
      "Yakuplar Mah",
      "Yenidanişment Mah",
      "Yeşiller Mah",
      "Yörükler Mah"
    ],
    "Orhangazi": [
      "Akharem Mah",
      "Arapzade Mah",
      "Bayırköy Mah",
      "Camiikebir Mah",
      "Cihanköy Mah",
      "Çakırlı Mah",
      "Çeltikçi Mah",
      "Dutluca Mah",
      "Fatih Mah",
      "Fındıklı Mah",
      "Gedelek Mah",
      "Gemiç Mah",
      "Gölyaka Mah",
      "Gürle Mah",
      "Hamzalı Mah",
      "Heceler Mah",
      "Hürriyet Mah",
      "Karsak Mah",
      "Keramet Mah",
      "Mahmudiye Mah",
      "Muradiye Mah",
      "Narlıca Mah",
      "Ortaköy Mah",
      "Örnekköy Mah",
      "Paşapınar Mah",
      "Sölöz Mah",
      "Tekke Mah",
      "Üreğil Mah",
      "Yenigürle Mah",
      "Yeniköy Mah",
      "Yenisölöz Mah"
    ],
    "Osmangazi": [
      "Alemdar Mah",
      "Armutköy Mah",
      "Çeltikköy Mah",
      "Çukurcaköy Mah",
      "Gaziakdemir Mah",
      "Mehmet Akif Mah",
      "Sırameşeler Mah",
      "Soğanlı Mah",
      "Yeniceabat Mah",
      "Ahmetpaşa Mah",
      "Aktarhüssam Mah",
      "Altıparmak Mah",
      "Çırpan Mah",
      "Hocahasan Mah",
      "İntizam Mah",
      "Kuruçeşme Mah",
      "Selimiye Mah",
      "Şehabettinpaşa Mah",
      "Yahşibey Mah",
      "Bağlarbaşı Mah",
      "Atıcılar Mah",
      "Bahar Mah",
      "Gülbahçe Mah",
      "Kemerçeşme Mah",
      "Koğukçınar Mah",
      "Namık Kemal Mah",
      "Selamet Mah",
      "Zafer Mah",
      "Altınova Mah",
      "Başaran Mah",
      "Küçükbalıklı Mah",
      "Veysel Karani Mah",
      "Yeşilova Mah",
      "Alacamescit Mah",
      "Ebu İshak Mah",
      "Reyhan Mah",
      "Şehreküstü Mah",
      "Tuzpazarı Mah",
      "Çekirge Mah",
      "Kükürtlü Mah",
      "Demirtaş Barbaros Mah",
      "Demirtaş Cumhuriyet Mah",
      "Demirtaş Dumlupınar Mah",
      "Demirtaş Sakarya Mah",
      "Demirtaş Dumlupınarosb Mah",
      "Akpınar Mah",
      "Emek Adnan Menderes Mah",
      "Emek Fatih Sultan Mehmet Mah",
      "Emek Zekai Gümüşdiş Mah",
      "Geçit Mah",
      "Nilüferköy Mah",
      "Hamitler Mah",
      "Yenibağlar Mah",
      "Yenikent Mah",
      "Alaaddin Mah",
      "Alacahırka Mah",
      "Alipaşa Mah",
      "Demirkapı Mah",
      "Hamzabey Mah",
      "İvazpaşa Mah",
      "Kavaklı Mah",
      "Kocanaip Mah",
      "Mollafenari Mah",
      "Mollagürani Mah",
      "Muradiye Mah",
      "Osmangazi Mah",
      "Pınarbaşı Mah",
      "Tahtakale Mah",
      "Dikkaldırım Mah",
      "Doburca Mah",
      "Hüdavendigar Mah",
      "Adalet Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Soğukkuyu Mah",
      "Yenikaraman Mah",
      "Çiftehavuzlar Mah",
      "Çirişhane Mah",
      "Fatih Mah",
      "Küplüpınar Mah",
      "Santral Garaj Mah",
      "Tuna Mah",
      "Hocaalizade Mah",
      "İbrahimpaşa Mah",
      "Kayıhan Mah",
      "Maksem Mah",
      "Nalbantoğlu Mah",
      "Orhanbey Mah",
      "Ahmetbey Mah",
      "Aksungur Mah",
      "Avdancık Mah",
      "Bağlı Mah",
      "Büyükdeliller Mah",
      "Çağlayan Mah",
      "Çaybaşı Mah",
      "Dağakça Mah",
      "Doğancı Mah",
      "Dürdane Mah",
      "Gökçeören Mah",
      "Gündoğdu Mah",
      "Güneybayır Mah",
      "Güneybudaklar Mah",
      "Hüseyinalan Mah",
      "İnkaya Mah",
      "Karabalçık Mah",
      "Karaislah Mah",
      "Kirazlı Mah",
      "Küçükdeliller Mah",
      "Mürseller Mah",
      "Seç Mah",
      "Seferışıklar Mah",
      "Selçukgazi Mah",
      "Soğukpınar Mah",
      "Süleymaniye Mah",
      "Tuzaklı Mah",
      "Uluçam Mah",
      "Yiğitali Mah",
      "Ovaakça Çeşmebaşı Mah",
      "Ovaakça Eğitim Mah",
      "Ovaakça Merkez Mah",
      "Ovaakça Santral Mah",
      "Alaşarköy Mah",
      "Doğanevler Mah",
      "İsmetiye Mah",
      "Panayır Mah",
      "Demirtaşpaşa Mah",
      "Doğanbey Mah",
      "Elmasbahçeler Mah",
      "Hacı İlyas Mah",
      "Kırcaali Mah",
      "Kiremitçi Mah",
      "Sakarya Mah",
      "Tayakadın Mah",
      "Ulu Mah",
      "Dereçavuşköy Mah",
      "Güneştepe Mah",
      "Yunuseli Mah"
    ],
    "Yenişehir": [
      "Afşar Mah",
      "Akbıyık Mah",
      "Akçapınar Mah",
      "Akdere Mah",
      "Alaylı Mah",
      "Ayaz Mah",
      "Aydoğdu Mah",
      "Barcın Mah",
      "Beypınar Mah",
      "Burcun Mah",
      "Cihadiye Mah",
      "Çamönü Mah",
      "Çardak Mah",
      "Çayır Mah",
      "Çayırlı Mah",
      "Çelebi Mah",
      "Çeltikçi Mah",
      "Çiçeközü Mah",
      "Demirboğa Mah",
      "Dereköy Mah",
      "Ebeköy Mah",
      "Eğerce Mah",
      "Fethiye Mah",
      "Gökçesu Mah",
      "Gündoğan Mah",
      "Günece Mah",
      "Hayriye Mah",
      "Hıdırbali Mah",
      "İncirli Mah",
      "Karaamca Mah",
      "Karabahadır Mah",
      "Karacaahmet Mah",
      "Karacaali Mah",
      "Karaköy Mah",
      "Karasıl Mah",
      "Kavaklı Mah",
      "Kıblepınar Mah",
      "Kızılhisar Mah",
      "Kızılköy Mah",
      "Kirazlıyayla Mah",
      "Koyunhisar Mah",
      "Kozdere Mah",
      "Köprühisar Mah",
      "Kurtuluş Mah",
      "Mahmudiye Mah",
      "Marmaracık Mah",
      "Mecidiye Mah",
      "Menteşe Mah",
      "Orhaniye Mah",
      "Osmaniye Mah",
      "Papatya Mah",
      "Paşayayla Mah",
      "Reşadiye Mah",
      "Selimiye Mah",
      "Söylemiş Mah",
      "Subaşı Mah",
      "Süleymaniye Mah",
      "Tabakhane Mah",
      "Terziler Mah",
      "Toprakdere Mah",
      "Toprakocak Mah",
      "Ulucami Mah",
      "Yarhisar Mah",
      "Yazılı Mah",
      "Yeni Mah",
      "Yenigün Mah",
      "Yeniköy Mah",
      "Yıldırım Mah",
      "Yılmaz Mah",
      "Yolören Mah",
      "Yüzüncüyıl Mah"
    ],
    "Yıldırım": [
      "Arabayatağı Mah",
      "Çınarönü Mah",
      "Demetevler Mah",
      "Hacivat Mah",
      "İsabey Mah",
      "Mevlana Mah",
      "Şirinevler Mah",
      "Ulus Mah",
      "Vakıf Mah",
      "Yavuzselım Mah",
      "152evler Mah",
      "Baruthane Mah",
      "Beyazıt Mah",
      "Değirmenlikızık Mah",
      "Eğitim Mah",
      "Mehmetakifersoy Mah",
      "Şükraniye Mah",
      "Yeşilyayla Mah",
      "Akçağlayan Mah",
      "Davutkadı Mah",
      "Maltepe Mah",
      "Musababa Mah",
      "Piremir Mah",
      "Sıracevizler Mah",
      "Yediselviler Mah",
      "Zümrütevler Mah",
      "Anadolu Mah",
      "Duaçınarı Mah",
      "Kazım Karabekir Mah",
      "Millet Mah",
      "Samanlı Mah",
      "Vatan Mah",
      "Yunusemre Mah",
      "75.yıl Mah",
      "Bağlaraltı Mah",
      "Cumalıkızık Mah",
      "Değirmenönü Mah",
      "Erikli Mah",
      "Esenevler Mah",
      "Fidyekızık Mah",
      "Hamamlıkızık Mah",
      "Karapınar Mah",
      "Yiğitler Mah",
      "Balaban Mah",
      "Ertuğrulgazi Mah",
      "Güllük Mah",
      "Kaplıkaya Mah",
      "Mimarsinan Mah",
      "Ortabağlar Mah",
      "Selçukbey Mah",
      "Siteler Mah",
      "Zeyniler Mah",
      "Emirsultan Mah",
      "Hocataşkın Mah",
      "Karaağaç Mah",
      "Karamazak Mah",
      "Kurtoğlu Mah",
      "Meydancık Mah",
      "Mollaarap Mah",
      "Namazgah Mah",
      "Teferrüç Mah",
      "Umurbey Mah",
      "Yenımahalle Mah",
      "Yeşil Mah",
      "Davutdede Mah",
      "Hacıseyfettin Mah",
      "Selimzade Mah",
      "Sinandede Mah",
      "Yıldırım Mah"
    ]
  },
  "Çanakkale": {
    "Ayvacık": [
      "Fatih Mah",
      "Hamdibey Mah",
      "Ümmühan Mah",
      "Adatepe Köyü",
      "Adatepebaşı Çamtepe Mah (adatepe Köyü)",
      "Adatepebaşı Değirmendere Mah (adatepe Köyü)",
      "Adatepebaşı Mah (adatepe Köyü)",
      "Adatepebaşı Palamutluk Mah (adatepe Köyü)",
      "Agora Mah (yeşilyurt Köyü)",
      "Arıklı Köyü",
      "Babadere Köyü",
      "Bahçedere Köyü",
      "Başdeğirmen Şelale Mah (adatepe Köyü)",
      "Boztepe Mah (bahçedere Köyü)",
      "Cevizliburun Mah (bahçedere Köyü)",
      "Çetmibaşı Mah (küçükçetmi Köyü)",
      "Çetmibaşı-çamegrek Mah (küçükçetmi Köyü)",
      "Çetmibaşı-telligıran Mah (küçükçetmi Köyü)",
      "Dereoba Mah (küçükçetmi Köyü)",
      "Gökçetepe Mah (küçükkuyu Beldesi)",
      "Hasanobası Mah (nusratlı Köyü)",
      "Ilıca Mah (küçükçetmi Köyü)",
      "Karayolları Dinlenme Mah (yeşilyurt Köyü)",
      "Kıztaşı Mah (nusratlı Köyü)",
      "Küçükçetmi Köyü",
      "Küpyanı Mah (nusratlı Köyü)",
      "Mıhlı Mah (küçükkuyu Beldesi)",
      "Nusratlı Köyü",
      "Pınaraltı Mah (adatepe Köyü)",
      "Sahil Mah (küçükkuyu Beldesi)",
      "Sivrice Mah (bahçedere Köyü)",
      "Yalı Mah (arıklı Köyü)",
      "Yeşilyurt Köyü",
      "Acıgöl Mah (büyükhusun Köyü)",
      "Acıgöl Mah (kösedere Köyü)",
      "Ahmetçe Köyü",
      "Ahmetçe Mah (ahmetçe Köyü)",
      "Ahmetçe Sahil Yolu Mah (ahmetçe Köyü)",
      "Ahmetler Köyü",
      "Akçin Köyü",
      "Akdede Mah (bademli Köyü)",
      "Akliman Mah (babakale Köyü)",
      "Aşağı Oba Mah (yukarıköy Köyü)",
      "Aşağı Tartışık Mah (tartışık Köyü)",
      "Atatürk Mah (gülpınar Köyü)",
      "Ayvacık Alanı Mah (uzunalan Köyü)",
      "Babakale Köyü",
      "Bademli Köyü",
      "Baharlar Köyü",
      "Balabanlı Köyü",
      "Başbahçe Mah (bademli Köyü)",
      "Behram Köyü",
      "Bektaş Köyü",
      "Beyalanı Mah (keçikaya Köyü)",
      "Bilaller Köyü",
      "Budaklar Köyü",
      "Büngüldek Mah (akçin Köyü)",
      "Büyükhusun Köyü",
      "Cemaller Köyü",
      "Çakmak Mah (bademli Köyü)",
      "Çakmaklar Köyü",
      "Çaltepe Mah (ahmetçe Köyü)",
      "Çaltı Köyü",
      "Çamiçi Mah (çamkalabak Köyü)",
      "Çamkalabak Köyü",
      "Çamköy Köyü",
      "Çamlık Mah (sapanca Köyü)",
      "Çamoba Mah (kösedere Köyü)",
      "Çamtepe Mah (çamkalabak Köyü)",
      "Çardakbayırı Mah (kocaköy Köyü)",
      "Çayiçi Mah (söğütlü Köyü)",
      "Çınarpınar Köyü",
      "Demirci Köyü",
      "Dereoba Mah (baharlar Köyü)",
      "Dibekli Köyü",
      "Doğruçardak Mah (kösedere Köyü)",
      "Erecek Köyü",
      "Güzelköy Köyü",
      "Harapiçi Mah (kuruoba Köyü)",
      "Hüseyinfakı Köyü",
      "Ilıcak Mah (bademli Köyü)",
      "İlyasfakı Köyü",
      "İnönü Yaylası Mah (sazlı Köyü)",
      "İskele Mevkii Mah (behram Köyü)",
      "Kadırga Mevkii Mah (behram Köyü)",
      "Karaayıt Mah (kösedere Köyü)",
      "Karabaşınoba Mah (pınardere Köyü)",
      "Karaburun Mah (yukarıköy Köyü)",
      "Karadiken Mah (bademli Köyü)",
      "Karbastı Mah (kösedere Köyü)",
      "Karşıoba Mah (pınardere Köyü)",
      "Kaşkaya Mah (çamkalabak Köyü)",
      "Kayaköy Kooperatifi Mah (sazlı Köyü)",
      "Kayalar Köyü",
      "Kayalar Mah (kayalar Köyü)",
      "Kayalar Sahil Yolu Mah (kayalar Köyü)",
      "Kayanlar Mah (söğütlü Köyü)",
      "Keçikaya Köyü",
      "Keleşinoba Mah (pınardere Köyü)",
      "Kestanelik Köyü",
      "Kıran Üstü Mah (balabanlı Köyü)",
      "Kırca Köyü",
      "Kısacık Köyü",
      "Kızılkeçili Mah (gülpınar Köyü)",
      "Kocaköy Köyü",
      "Korubaşı Köyü",
      "Koyunevi Köyü",
      "Kozlu Köyü",
      "Kökyeri Mah (keçikaya Köyü)",
      "Kulfal Köyü",
      "Kuruoba Köyü",
      "Kuşkonmaz Mah (büyükhusun Köyü)",
      "Küçük Kestanelik Mah (kestanelik Köyü)",
      "Küçükhusun Köyü",
      "Küplü Yaylaları Mah (sazlı Köyü)",
      "Merkez 1 Mah (kösedere Köyü)",
      "Merkez 2 Mah (kösedere Köyü)",
      "Misvak Köyü",
      "Naldöken Köyü",
      "Namazgah Mah (büyükhusun Köyü)",
      "Paşaköy Altı Mah (paşaköy Köyü)",
      "Paşaköy Köyü",
      "Paşaköy Mah (paşaköy Köyü)",
      "Pınardere Köyü",
      "Sahil Mah (kocaköy Köyü)",
      "Sahil Mah (kozlu Köyü)",
      "Sapanca Köyü",
      "Sarnıçaltı Mah (balabanlı Köyü)",
      "Sazak Mah (büyükhusun Köyü)",
      "Sazlı Altı Mah (sazlı Köyü)",
      "Sazlı Köyü",
      "Sivrice Mah (bektaş Köyü)",
      "Sokakağzı Mah (koyunevi Köyü)",
      "Söğütlü Köyü",
      "Süleymanköy Köyü",
      "Şapköy Köyü",
      "Tabaklar Köyü",
      "Tamış Köyü",
      "Taşağıl Köyü",
      "Taşboğaz Köyü",
      "Tuzla Köyü",
      "Tuztaşı Köyü",
      "Uzunalan Köyü",
      "Yalı Mah (büyükhusun Köyü)",
      "Yalı Mevkii Mah (ahmetçe Köyü)",
      "Yalıpara Mah (bademli Köyü)",
      "Yayla Evleri Akpınar Mevkii Mah (ahmetçe Köyü)",
      "Yayla Evleri Mah (söğütlü Köyü)",
      "Yeniçam Köyü",
      "Yenioba Mah (tuztaşı Köyü)",
      "Yeşilliman Mah (korubaşı Köyü)",
      "Yörükler Evi Mah (balabanlı Köyü)",
      "Yukarı Tartışık Mah (tartışık Köyü)",
      "Yukarıköy Köyü"
    ],
    "Bayramiç": [
      "Camicedit Mah",
      "Camikebir Mah",
      "Menderes Mah",
      "Tepecik Mah",
      "Aşağı Mah (evciler Köyü)",
      "Ayazma Yolu Üzeri Mah (evciler Köyü)",
      "Beşik Köyü",
      "Çalıobaakçakıl Köyü",
      "Çaltılık Mah (evciler Köyü)",
      "Çavuşlu Köyü",
      "Çırpılar Köyü",
      "Dağoba Köyü",
      "Gedik Köyü",
      "Karaköy Köyü",
      "Köseler Köyü",
      "Külcüler Köyü",
      "Mollahasanlar Köyü",
      "Sarıot Köyü",
      "Serhat Köyü",
      "Toluklar Köyü",
      "Tongurlu Köyü",
      "Yeşilköy Köyü",
      "Yukarı Mah (evciler Köyü)",
      "Ağaçköy Köyü",
      "Ahmetçeli Köyü",
      "Akpınar Köyü",
      "Alakeçi Köyü",
      "Alikabaklar Köyü",
      "Asmalı Mah (doğancı Köyü)",
      "Bıyıklı Köyü",
      "Çavuşköy Köyü",
      "Dağahmetçe Köyü",
      "Daloba Köyü",
      "Doğancı Köyü",
      "Dombaylar Mah (alakeçi Köyü)",
      "Güvemcik Mah (örenli Köyü)",
      "Güzeltepe Köyü",
      "Işıklar Mah (pıtıreli Köyü)",
      "Karşıoba Mah (çalıdağı Köyü)",
      "Kaykılar Köyü",
      "Koşuburnutürkmenleri Köyü",
      "Köseler Mah (çalıdağı Köyü)",
      "Kurşunlu Köyü",
      "Kutluoba Köyü",
      "Macır Mah (türkmenli Köyü)",
      "Merkez Mah (çalıdağı Köyü)",
      "Mescit Mah (türkmenli Köyü)",
      "Nebiler Köyü",
      "Nizam Mah (türkmenli Köyü)",
      "Örenli Köyü",
      "Palamutoba Köyü",
      "Pınarbaşı Köyü",
      "Pıtıreli Köyü",
      "Saçaklı Köyü",
      "Saraycık Köyü",
      "Sarıdüz Köyü",
      "Tülüler Köyü",
      "Türkmenli Köyü",
      "Tütüler Mah (nebiler Köyü)",
      "Üzümlü Köyü",
      "Yahşieli Köyü",
      "Yassıbağ Köyü",
      "Yukarıpalamut Mah (palamutoba Köyü)",
      "Zerdalilik Köyü",
      "Zeytinli Köyü",
      "Aşağışapcı Köyü",
      "Aşağışevik Köyü",
      "Bekirler Köyü",
      "Bezirganlar Köyü",
      "Cazgirler Köyü",
      "Çatalçam Köyü",
      "Çiftlik Köyü",
      "Gökçeiçi Köyü",
      "Hacıbekirler Köyü",
      "Hacıdervişler Köyü",
      "Hacıköy Köyü",
      "Işıkeli Köyü",
      "Karaibrahimler Köyü",
      "Karıncalık Köyü",
      "Korucak Köyü",
      "Köylü Köyü",
      "Kuşçayır Köyü",
      "Muratlar Köyü",
      "Osmaniye Köyü",
      "Söğütgediği Köyü",
      "Tepeköy Mah (muratlar Köyü)",
      "Üçyol Köyü",
      "Yanıklar Köyü",
      "Yaylacık Köyü",
      "Yeniceköy Köyü",
      "Yeniköy Köyü",
      "Yeniköy Mah (muratlar Köyü)",
      "Yiğitaliler Köyü",
      "Yukarışapçı Köyü",
      "Yukarışevik Köyü"
    ],
    "Biga": [
      "Cumhuriyet Mah",
      "Esentepe Mah",
      "Gazikemal Mah",
      "Hamdibey Mah",
      "İstiklal Mah",
      "Sakarya Mah",
      "Şirintepe Mah",
      "Turan Mah",
      "Adliye Köyü",
      "Aşağıdemirci Köyü",
      "Cumhuriyet Mah (gümüşçay Beldesi)",
      "Çeşmealtı Köyü",
      "Çınarköprü Köyü",
      "Eğridere Köyü",
      "Emirorman Köyü",
      "Hacıköy Köyü",
      "İğdelik Mah (gümüşçay Beldesi)",
      "Kanibey Köyü",
      "Osmaniye Köyü",
      "Şirinköy Köyü",
      "Yukarıdemirci Köyü",
      "Aksaz Mah (aksaz Köyü)",
      "Çakırlı Köyü",
      "Çınarlı Tarla Mevkii Mah (çakırlı Köyü)",
      "Değirmencik Köyü",
      "Dere Mah (değirmencik Köyü)",
      "Hacıhüseyinyaylası Köyü",
      "Karapürçek Köyü",
      "Kocagür Köyü",
      "Örtülüce Köyü",
      "Şahmelek Mah (aksaz Köyü)",
      "Tokatkırı Köyü",
      "Ulucamii Mah (karabiga Beldesi)",
      "Yalı Mah (karabiga Beldesi)",
      "Zeytinlik Mah (karabiga Beldesi)",
      "Abdiağa Köyü",
      "Ağaköy  Mah (ağaköy Köyü)",
      "Ağaköy Köyü",
      "Ahatoba Mah (sarnıç Köyü)",
      "Ahmetler Köyü",
      "Akkayrak Köyü",
      "Akköprü Köyü",
      "Akpınar Köyü",
      "Akyaprak Köyü",
      "Ambaroba Köyü",
      "Arabaalan Köyü",
      "Arabakonağı Köyü",
      "Aşağı Mah (sinekçi Köyü)",
      "Ayıtdere Köyü",
      "Aziziye Köyü",
      "Bahçeli Köyü",
      "Bakacak Köyü",
      "Bakacaklıçiftliği Köyü",
      "Balıklıçeşme Merkez Mah (balıklıçeşme Köyü)",
      "Bekirli Köyü",
      "Bezirganlar Köyü",
      "Bozlar Köyü",
      "Camialan Köyü",
      "Cihadiye Köyü",
      "Çavuşköy Mah",
      "Çelikgürü Köyü",
      "Çeltik Köyü",
      "Çınardere Köyü",
      "Çömlekçi Köyü",
      "Danişment Köyü",
      "Dereköy Köyü",
      "Dikmen Köyü",
      "Doğancı Köyü",
      "Ece Mah (yeniçiftlik Köyü)",
      "Elmalı Köyü",
      "Eskibalıklı Köyü",
      "Eybekli Köyü",
      "Gemicikırı Köyü",
      "Geredelli Köyü",
      "Gerlengeç Köyü",
      "Geyikkırı Köyü",
      "Gökçesu Mah (sarnıç Köyü)",
      "Göktepe Köyü",
      "Güleç Köyü",
      "Gündoğdu Köyü",
      "Gürçeşme Köyü",
      "Gürgendere Köyü",
      "Güvem Mah (güvemalan Köyü)",
      "Güvemalan Köyü",
      "Hacıpehlivan Köyü",
      "Harmanlı Köyü",
      "Havdan Köyü",
      "Hisarlı Köyü",
      "Hoşoba Köyü",
      "Ilıcabaşı Köyü",
      "Işıkeli Köyü",
      "İlyasalan Köyü",
      "İskender Köyü",
      "Kahvetepe Köyü",
      "Kaldırımbaşı Köyü",
      "Kapanbelen Köyü",
      "Karaağaç Köyü",
      "Karacaali Köyü",
      "Karahamzalar Köyü",
      "Kaşıkçıoba Köyü",
      "Katrancı Köyü",
      "Kayapınar Köyü",
      "Kaynarca Köyü",
      "Kazıklı Mah (sarnıç Köyü)",
      "Kazmalı Köyü",
      "Kemer Köyü",
      "Kepekli Köyü",
      "Koruoba Köyü",
      "Köyiçi Mah (idriskoru Köyü)",
      "Kumkent Mah (bozlar Köyü)",
      "Küçükköy Mah (idriskoru Köyü)",
      "Merkez Mah (kalafat Köyü)",
      "Merkez Mah (kozçeşme Köyü)",
      "Organize Sanayi Bölgesi Mah (balıklıçeşme Köyü)",
      "Otlukdere Köyü",
      "Ovacık Köyü",
      "Paşaçayı Köyü",
      "Pekmezli Köyü",
      "Ramazanlar Köyü",
      "Sarıca Köyü",
      "Sarıkaya Köyü",
      "Sarısıvat Köyü",
      "Savaştepe Köyü",
      "Sazkent Mah (gerlengeç Köyü)",
      "Sazoba Köyü",
      "Selvi Köyü",
      "Sığırcık Köyü",
      "Sinekçi Köyü",
      "Sülünoba Mah (sarnıç Köyü)",
      "Şakirbey Köyü",
      "Türkbakacak Köyü",
      "Uzundere Mah (kemer Köyü)",
      "Yanıç Köyü",
      "Yeni Eşelek Mah (bezirganlar Köyü)",
      "Yeniceköy Mah",
      "Yenimahalle Köyü",
      "Yeşilköy Köyü",
      "Yolindi Köyü"
    ],
    "Bozcaada": [
      "Alaybey Mah",
      "Cumhuriyet Mah"
    ],
    "Çan": [
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "İstiklal Mah",
      "Karşıyaka Mah",
      "Osmanefendi Mah",
      "Seramik Mah",
      "Ahlatlıburun Köyü",
      "Alibeyçiftliği Köyü",
      "Altıkulaç Köyü",
      "Asmalı Köyü",
      "Bahadırlı Köyü",
      "Bardakçılar Köyü",
      "Bilaller Köyü",
      "Bostandere Köyü",
      "Bozguç Köyü",
      "Bükler Mah (yuvalar Köyü)",
      "Büyükpaşa Köyü",
      "Büyükpaşa Mah (büyükpaşa Köyü)",
      "Büyüktepe Köyü",
      "Cicikler Köyü",
      "Çakılköy Köyü",
      "Çaltıkara Köyü",
      "Çamköy Köyü",
      "Çekiçler Köyü",
      "Çomaklı Köyü",
      "Danapınar Köyü",
      "Derenti Köyü",
      "Dereoba Köyü",
      "Doğaca Köyü",
      "Doğancılar Köyü",
      "Dondurma Köyü",
      "Duman Köyü",
      "Durali Köyü",
      "Durali Mah (durali Köyü)",
      "Emeşe Köyü",
      "Eskiyayla Köyü",
      "Etili Köyü",
      "Göle Köyü",
      "Hacıkasım Köyü",
      "Hacılar Köyü",
      "Halilağa Köyü",
      "Helvacı Köyü",
      "Hurma Köyü",
      "Hurmaköy Mah (hurma Köyü)",
      "İlyasağaçiftliği Köyü",
      "Kadılar Köyü",
      "Kalburcu Köyü",
      "Kaplıcalar Mah (bardakçılar Köyü)",
      "Karadağ Köyü",
      "Karakadılar Köyü",
      "Karakoca Köyü",
      "Karlı Köyü",
      "Kazabat Köyü",
      "Keçiağılı Köyü",
      "Kızılelma Köyü",
      "Kilimli Mah (dondurma Köyü)",
      "Kocayayla Köyü",
      "Koyunyeri Köyü",
      "Kulfal Köyü",
      "Kulfal Mah (kulfal Köyü)",
      "Kumarlar Köyü",
      "Küçüklü Köyü",
      "Küçükpaşa Köyü",
      "Mallı Köyü",
      "Maltepe Köyü",
      "Manyasoba Mah (doğancılar Köyü)",
      "Okçular Köyü",
      "Ozancık Köyü",
      "Sameteli Köyü",
      "Söğütalan Köyü",
      "Şerbetli Köyü",
      "Tepeköy Köyü",
      "Uzunalan Köyü",
      "Üvezdere Köyü",
      "Yaya Köyü",
      "Yaykın Köyü",
      "Yeniçeri Köyü",
      "Yukarıköy Mah (küçüklü Köyü)",
      "Yuvalar Köyü",
      "Zeybekçayır Köyü",
      "Çakmakçayır Mah (terzialan Beldesi)",
      "Süle Mah (terzialan Beldesi)"
    ],
    "Eceabat": [
      "İsmetpaşa Mah",
      "Kemalpaşa Mah",
      "Ahıldere Altı Mah (yalova Köyü)",
      "Alçıtepe Köyü",
      "Azmak Mah (seddülbahir Köyü)",
      "Başçeşme Mah (seddülbahir Köyü)",
      "Behramlı Köyü",
      "Beşyol Köyü",
      "Bigalı Köyü",
      "Boyacıburnu Yalılar Mah (yalova Köyü)",
      "Büyükanafarta Köyü",
      "Göztepe Mah (seddülbahir Köyü)",
      "Kocadere Köyü",
      "Kumköy Köyü",
      "Küçükanafarta Köyü",
      "Merkez Mah (kilidülbahir Köyü)",
      "Morto Koyu Mah (seddülbahir Köyü)",
      "Seddülbahir Duası Mah (seddülbahir Köyü)",
      "Seddülbahir Köyü",
      "Tekke Mah (seddülbahir Köyü)",
      "Yalova Köyü",
      "Yolağzı Köyü",
      "Zığındere Mah (seddülbahir Köyü)"
    ],
    "Ezine": [
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Danişment Mah",
      "Gazi Mah",
      "Seferşah Mah",
      "Atatürk Mah (mahmudiye Köyü)",
      "Beşike Eserevler Sitesi Mah (kumburun Köyü)",
      "Bozalan Köyü",
      "Cumhuriyet Mah (geyikli Beldesi)",
      "Çamoba Köyü",
      "Hürriyet Mah (geyikli Beldesi)",
      "Hürriyet Mah (mahmudiye Köyü)",
      "İnlimanı Mah (kumburun Köyü)",
      "Köy İçi Mah (dalyan Köyü)",
      "Kumburun Köyü",
      "Mecidiye Köyü",
      "Pınarbaşı Köyü",
      "Taşkapı Çamlık Mah (kumburun Köyü)",
      "Üvecik Köyü",
      "Yeniköy Köyü",
      "Ahlatlı Mah (köprübaşı Köyü)",
      "Akçakeçili Köyü",
      "Akçakeçili Mah (akçakeçili Köyü)",
      "Akköy Köyü",
      "Aladağ Köyü",
      "Alemşah Köyü",
      "Alemşah Mah (alemşah Köyü)",
      "Araplar Boğazı Mah (derbentbaşı Köyü)",
      "Arasanlı Köyü",
      "Bahçeli Köyü",
      "Balıklı Köyü",
      "Balıklı Mah (balıklı Köyü)",
      "Belen Köyü",
      "Bozeli Köyü",
      "Bozköy Köyü",
      "Çamköy Köyü",
      "Çamlıca Köyü",
      "Çarıksız Köyü",
      "Çetmi Köyü",
      "Çınarköy Köyü",
      "Derbentbaşı Köyü",
      "Gökçebayır Köyü",
      "Güllüce Köyü",
      "Hacı Eyüpler Mah (karagömlek Köyü)",
      "Hacı Garipler Mah (karagömlek Köyü)",
      "Hacı Hüseyinler Mah (yenioba Köyü)",
      "Hisaralan Köyü",
      "Kanarya Sırtı Mah (derbentbaşı Köyü)",
      "Karadağ Köyü",
      "Kayacık Köyü",
      "Kayalı Mah (çarıksız Köyü)",
      "Kemallı Köyü",
      "Kemallı Mah (kemallı Köyü)",
      "Kestanbol Kaplıcası Mah (körüktaşı Köyü)",
      "Kızılköy Köyü",
      "Kızıltepe Köyü",
      "Kiremitoba Mah (aladağ Köyü)",
      "Kozova Mah (köprübaşı Köyü)",
      "Köprübaşı Köyü",
      "Körüktaşı Köyü",
      "Köseler Köyü",
      "Orta Mah (karagömlek Köyü)",
      "Pazarköy Köyü",
      "Sarısöğüt Köyü",
      "Sarpdere Köyü",
      "Şapköy Köyü",
      "Taş Oba Mah (derbentbaşı Köyü)",
      "Taştepe Köyü",
      "Tavaklı İskelesi Mah (tavaklı Köyü)",
      "Tavaklı Köyü",
      "Uluköy Köyü",
      "Uluköy Mah (uluköy Köyü)",
      "Üsküfçü Köyü",
      "Yahyaçavuş Köyü",
      "Yavaşlar Köyü",
      "Yaylacık Köyü",
      "Yenioba Köyü"
    ],
    "Gelibolu": [
      "Adilhan Köyü",
      "Armutdere Mah (adilhan Köyü)",
      "Armutdere1 Mah (adilhan Köyü)",
      "Bağlardere Mah (adilhan Köyü)",
      "Bayramiç Köyü",
      "Bostanlık Mah (adilhan Köyü)",
      "Çeşme Mah (evreşe Beldesi)",
      "Çokal Köyü",
      "Hamamaltı Mah (adilhan Köyü)",
      "Kalealtı Köyü",
      "Keşanoğlu Mah (evreşe Beldesi)",
      "Kocaçeşme Köyü",
      "Kurtlukuyu Mah (adilhan Köyü)",
      "Kurtlukuyu1 Mah (adilhan Köyü)",
      "Kurtlukuyu2 Mah (adilhan Köyü)",
      "Süleymaniye Köyü",
      "Şadıllı Köyü",
      "Yeni Mah (evreşe Beldesi)",
      "Yülüce Köyü",
      "Alaeddin Mah",
      "Camiikebir Mah",
      "Gazi Süleyman Paşa Mah",
      "Hoca Hamza Mah",
      "Yazıcızade Mah",
      "Cumhuriyet Mah (kavakköy Beldesi)",
      "Hürriyet Mah (kavakköy Beldesi)",
      "Atıfbey Çiftliği Mah (güneyli Köyü)",
      "Bayırköy Köyü",
      "Burhanlı Köyü",
      "Burhanlı Mah (burhanlı Köyü)",
      "Büyük Mithatlar Mah (koruköy Köyü)",
      "Camiikebir Mah (bolayır Köyü)",
      "Cevizli Köyü",
      "Cevizli Mah (cevizli Köyü)",
      "Cumalı Köyü",
      "Çiftlikaltı Mah (koruköy Köyü)",
      "Damlar Mah (burhanlı Köyü)",
      "Değirmendüzü Köyü",
      "Demirtepe Köyü",
      "Demirtepe Mah (demirtepe Köyü)",
      "Doğa Mah (burhanlı Köyü)",
      "Doğan Arslan Mah (demirtepe Köyü)",
      "Doğanarslan1 Mah (demirtepe Köyü)",
      "Doğanarslan2 Mah (demirtepe Köyü)",
      "Doğanarslan3 Mah (demirtepe Köyü)",
      "Fevziçakmak Mah (bolayır Köyü)",
      "Fındıklı Köyü",
      "Gazisüleymanpaşa Mah (bolayır Köyü)",
      "Güneyli Köyü",
      "Ilgardere Köyü",
      "Ilgardere Mucavir Mah (ılgardere Köyü)",
      "Karainebeyli Köyü",
      "Kavaklı Köyü",
      "Kayrandere Mah (koruköy Köyü)",
      "Koruköy Köyü",
      "Küçük  Mithatlar Mah (koruköy Köyü)",
      "Mutatlar Mah (koruköy Köyü)",
      "Ocaklı Köyü",
      "Ocaklı Mah (ocaklı Köyü)",
      "Ova Mah (ılgardere Köyü)",
      "Pazarlı Köyü",
      "Pazarlı Mah (pazarlı Köyü)",
      "Salavurtepe Mah (koruköy Köyü)",
      "Sütlüce Köyü",
      "Sütlüce Mah (sütlüce Köyü)",
      "Tayfurköy Köyü",
      "Yeniköy Köyü",
      "Yeniköy Mah (yeniköy Köyü)"
    ],
    "Gökçeada": [
      "Cumhuriyet Mah",
      "Çınarlı Mah",
      "Fatih Mah",
      "Yeni Mah",
      "Bademli Köyü",
      "Dereköy Köyü",
      "Eşelek Köyü",
      "Kaleköy Köyü",
      "Kuzulimanı Mah",
      "Şahinkaya Mah (dereköy Köyü)",
      "Şirinköy Köyü",
      "Tepeköy Köyü",
      "Uğurlu Köyü",
      "Yenibademli Köyü",
      "Zeytinliköy Köyü"
    ],
    "Lapseki": [
      "Gaziyakupbey Mah (çardak Beldesi)",
      "Hacıömerler Köyü",
      "Tekke Mah (çardak Beldesi)",
      "Cumhuriyet Mah",
      "Dalyan Mah",
      "Gazi Süleyman Paşa Mah",
      "Alpagut Köyü",
      "Balcılar Köyü",
      "Beyçayırı Köyü",
      "Beypınar Köyü",
      "Bozkent Mah (şevketiye Köyü)",
      "Çamyurt Köyü",
      "Çataltepe Köyü",
      "Çavuşköy Köyü",
      "Demirli Sahil Sitesi Mah (suluca Köyü)",
      "Dereköy Köyü",
      "Dişbudak Köyü",
      "Doğandere Köyü",
      "Dumanlı Köyü",
      "Eçialan Köyü",
      "Güreci Köyü",
      "Gürecialtı Mah (güreci Köyü)",
      "Hisarkent Mah (şevketiye Köyü)",
      "İlyasköy Köyü",
      "Karamusalar Köyü",
      "Karaömerler Köyü",
      "Kariyer Tatil Sitesi Mah (suluca Köyü)",
      "Kemiklialan Köyü",
      "Kırcalar Köyü",
      "Kızıldam Köyü",
      "Kirazlıdere Mah (güreci Köyü)",
      "Kocabaşlar Köyü",
      "Kocaveli Köyü",
      "Kundakçılar Mah (yaylalar Köyü)",
      "Mecidiye Köyü",
      "Nusratiye Köyü",
      "Subaşı Köyü",
      "Suluca Köyü",
      "Suluca Tatil Sitesi Mah (suluca Köyü)",
      "Şahinli Köyü",
      "Şevketiye Köyü",
      "Taştepe Köyü",
      "Yaylalar Köyü",
      "Yeniceköy Köyü",
      "Yol Altı Mevkii Mah (adatepe Köyü)",
      "Yol Üstü Mah (adatepe Köyü)",
      "Akçaalan Köyü",
      "Beybaş Köyü",
      "Büberler Mah (hacıgelen Köyü)",
      "Eskikışla Mah (akçaalan Köyü)",
      "Gökköy Köyü",
      "Hacıgelen Köyü",
      "Hacılar Obası Mah (harmancık Köyü)",
      "Harmancık Köyü",
      "Kangırlı Köyü",
      "Koru Mah (hacıgelen Köyü)",
      "Kunduz Mah (kangırlı Köyü)",
      "Saltık Mah (kangırlı Köyü)",
      "Sazak Obası Mah (beybaş Köyü)",
      "Sındal Köyü",
      "Umurbey Merkez Mah (umurbey Beldesi)",
      "Üçpınar Köyü"
    ],
    "Merkez": [
      "Barbaros Mah",
      "Cevat Paşa Mah",
      "Esenler Mah",
      "Fevzipaşa Mah",
      "İsmetpaşa Mah",
      "Kemalpaşa Mah",
      "Namık Kemal Mah",
      "Armutlu Mah (çınarlı Köyü)",
      "Boğazkent Mah (kepez Beldesi)",
      "Cumhuriyet Mah (kepez Beldesi)",
      "Çınarlı Köyü",
      "Dardanos Mah (çınarlı Köyü)",
      "Hamidiye Mah (kepez Beldesi)",
      "Akçalı Köyü",
      "Akçapınar Köyü",
      "Akçeşme Köyü",
      "Akköy Mah (akçalı Köyü)",
      "Alanköy Köyü",
      "Andıktaşı Mah (aşağıokçular Köyü)",
      "Armutalan Mah (karapınar Köyü)",
      "Aşağıokçular Köyü",
      "Atikhisar Mah (kayadere Köyü)",
      "Belen Köyü",
      "Bodurlar Köyü",
      "Civler Köyü",
      "Çamyayla Köyü",
      "Çanakalan Mah (kızılcaören Köyü)",
      "Çıplak Köyü",
      "Çiftlik Mah (belen Köyü)",
      "Çiftlikdere Köyü",
      "Çömlekler Mah (karapınar Köyü)",
      "Damyeri Mah (maraşalfevziçakmak Köyü)",
      "Dedeler Köyü",
      "Değirmendere Mah (elmacık Köyü)",
      "Denizgöründü Köyü",
      "Dörtyol Mah (ışıklar Köyü)",
      "Dümrek Köyü",
      "Elmacık Köyü",
      "Erenköy Merkez Mah (erenköy Köyü)",
      "Erenköy Yeni Mah (erenköy Köyü)",
      "Gökçalı Köyü",
      "Gürecik Mah (denizgöründü Köyü)",
      "Güzelyalı Mah (güzelyalı Köyü)",
      "Halileli Köyü",
      "Haliloğlu Köyü",
      "Işıklar Köyü",
      "İğdelik Mah (kızılkeçili Köyü)",
      "Kalabaklı Köyü",
      "Kalafat Köyü",
      "Karaburunlar Mah (kirazlı Köyü)",
      "Karacalar Köyü",
      "Karacaören Köyü",
      "Karacaören Mah (karacaören Köyü)",
      "Karapınar Köyü",
      "Kayadere Köyü",
      "Kayışlar Mah (salihler Köyü)",
      "Kemel Köyü",
      "Kemerdere Mah (civler Köyü)",
      "Kızılcaören Köyü",
      "Kızılkeçili Köyü",
      "Kirazlı Alan Mah (kirazlı Köyü)",
      "Kirazlı Köyü",
      "Kocalar Köyü",
      "Kovandağı Mah (dedeler Köyü)",
      "Kurşunlu Köyü",
      "Maraşalfevziçakmak Köyü",
      "Mehmet Çavuş Mah (kumkale Köyü)",
      "Mersin Çeşme Mah (ovacık Köyü)",
      "Musaköy Köyü",
      "Obaköy Mah (bodurlar Köyü)",
      "Organize Sanayi Bölgesi Mah (karacaören Köyü)",
      "Ortaca Köyü",
      "Ortaoba Mah (aşağıokçular Köyü)",
      "Osmanlar Mah (bodurlar Köyü)",
      "Ovacık Köyü",
      "Özbek Köyü",
      "Salavat Mah (aşağıokçular Köyü)",
      "Salihler Köyü",
      "Saltık Mah (yapıldak Köyü)",
      "Saraycık Köyü",
      "Sarıbeyli Köyü",
      "Sarıcaeli Köyü",
      "Serçiler Köyü",
      "Sığırlı Mah (sarıbeyli Köyü)",
      "Şehitler Mah (kumkale Köyü)",
      "Taşlıtarla Köyü",
      "Tavşantepe Mah (bodurlar Köyü)",
      "Terziler Köyü",
      "Testicikırı Mah (ışıklar Köyü)",
      "Tevfikiye Mah (tevfikiye Köyü)",
      "Ulupınar Köyü",
      "Yağcılar Köyü",
      "Yapıldak Köyü",
      "Yukarıokçular Köyü"
    ],
    "Yenice": [
      "Akköy Köyü",
      "Armutçuk Köyü",
      "Aşağıçavuş Köyü",
      "Atatürk Mah (akçakoyun Köyü)",
      "Atatürk Mah (kalkım Beldesi)",
      "Bağlı Köyü",
      "Canbaz Köyü",
      "Cumhuriyet Mah (akçakoyun Köyü)",
      "Cumhuriyet Mah (kalkım Beldesi)",
      "Çiftlik Köyü",
      "Çukuroba Köyü",
      "Kalabakbaşı Köyü",
      "Karaaydın Köyü",
      "Kıraçoba Mah (çukuroba Köyü)",
      "Kırıklar Köyü",
      "Oğlanalanı Köyü",
      "Örencik Köyü",
      "Yarış Köyü",
      "Yukarıçavuş Köyü",
      "Ahiler Köyü",
      "Ahmetler Mah (suuçtu Köyü)",
      "Alancık Köyü",
      "Alanoba Mah (ballıçay Köyü)",
      "Altıparmaklar Mah (darıalan Köyü)",
      "Araovacık Köyü",
      "Aşağı Mah (nevruz Köyü)",
      "Aşağıinova Köyü",
      "Aşağıkaraaşık Köyü",
      "Ballıçay Köyü",
      "Başkoz Köyü",
      "Bayatlar Köyü",
      "Bekten Köyü",
      "Boynanlar Köyü",
      "Cumhuriyet Mah (pazarköy Köyü)",
      "Çakır Köyü",
      "Çakıroba Köyü",
      "Çal Köyü",
      "Çaltı Mah (koruköy Köyü)",
      "Çam Mah (koruköy Köyü)",
      "Çamoba Köyü",
      "Çargan Oba Mah (çakır Köyü)",
      "Çınarcık Köyü",
      "Çınarköy Köyü",
      "Çırpılar Köyü",
      "Darıalan Köyü",
      "Davutköy Köyü",
      "Engeci Köyü",
      "Gedikoba Mah (karaköy Köyü)",
      "Gümüşler Köyü",
      "Gündoğdu Köyü",
      "Güveyler Mah (torhasan Köyü)",
      "Güzeloba Köyü",
      "Hacılar Köyü",
      "Hacıyusuflar Köyü",
      "Hamdibey Mah (hamdibey Köyü)",
      "Hasanlar Mah (alancık Köyü)",
      "Haydaroba Köyü",
      "Hıdırlar Köyü",
      "İbrahimler Mah (yağdıran Köyü)",
      "İstiklal Mah (pazarköy Köyü)",
      "Kabaağaç Arası Mah (yağdıran Köyü)",
      "Kabalı Köyü",
      "Karabey Köyü",
      "Karadoru Köyü",
      "Karaköy Köyü",
      "Karasu Köyü",
      "Kargacı Köyü",
      "Kızıldam Köyü",
      "Kovancı Köyü",
      "Kurtlar Köyü",
      "Kuzupınarı Köyü",
      "Namazgah Köyü",
      "Orta Mah (nevruz Köyü)",
      "Öğmen Köyü",
      "Pınaroba Mah (alancık Köyü)",
      "Reşadiye Köyü",
      "Sameteli Köyü",
      "Sarıçayır Köyü",
      "Sazak Köyü",
      "Seyvan Köyü",
      "Sofular Köyü",
      "Soğucak Köyü",
      "Suuçtu Köyü",
      "Taban Köyü",
      "Torhasan Köyü",
      "Umurlar Köyü",
      "Üçkabaağaç Köyü",
      "Yalıoba Köyü",
      "Yeni Mah (umurlar Köyü)",
      "Yeniköy Köyü",
      "Yeşilköy Köyü",
      "Yeşiller Mah (yağdıran Köyü)",
      "Yukarı Mah (nevruz Köyü)",
      "Yukarıinova Köyü",
      "Yukarıkaraaşık Köyü",
      "Eski Yenice Mah",
      "Kışlalar Mah",
      "Kurtuluş Mah",
      "Yeni Mah"
    ]
  },
  "Çankırı": {
    "Atkaracalar": [
      "Gazibey Mah",
      "Hoca Mah",
      "İlker Mah",
      "Kıran Mah",
      "Mollaosman Mah",
      "Bozkuş Mah (çardaklı Beldesi)",
      "Cumhuriyet Mah (çardaklı Beldesi)",
      "Hürriyet Mah (çardaklı Beldesi)",
      "Mustafa Kemal Mah (çardaklı Beldesi)",
      "Nevzat Ayaz Mah (çardaklı Beldesi)",
      "Budakpınar Köyü",
      "Demirciler Mah (kükürt Köyü)",
      "Demirli Köyü",
      "Dere Mah (yakalı Köyü)",
      "Eyüpözü Köyü",
      "Hüyükköy Köyü",
      "Ilıpınar Mah",
      "Kadıgil Mah (yakalı Köyü)",
      "Kızılibrik Köyü",
      "Kolavlağı Mah (kükürt Köyü)",
      "Orta Mah (kükürt Köyü)",
      "Orta Mah (yakalı Köyü)",
      "Susuz Köyü",
      "Zevdeş Mah (kükürt Köyü)"
    ],
    "Bayramören": [
      "Köprülübey Mah",
      "Merkez Mah",
      "Zübeyde Hanım Mah",
      "Akgüney Köyü",
      "Akseki Mah (akseki Köyü)",
      "Aluç Mah (akseki Köyü)",
      "Aşağı Mah (dereköy Köyü)",
      "Aşağı Mah (incekaya Köyü)",
      "Aşağı Mah (karakuzu Köyü)",
      "Aşağı Mah (sarıkaya Köyü)",
      "Belenli Köyü",
      "Boğazkaya Köyü",
      "Bürümcek Mah (incekaya Köyü)",
      "Çamdibi Mah (göynükören Köyü)",
      "Dahanlar Mah (karakuzu Köyü)",
      "Dalkoz Köyü",
      "Dere Mah (göynükören Köyü)",
      "Dere Mah (karakuzu Köyü)",
      "Doğan Mah (yusufoğlu Köyü)",
      "Dolaşlar Köyü",
      "Ecük Mah (topçu Köyü)",
      "Ekincik Mah (kavakköy Köyü)",
      "Erenler Köyü",
      "Evkadı Mah (çayırcık Köyü)",
      "Feriz Köyü",
      "Gökçukur Mah (topçu Köyü)",
      "Güllüpınar Mah (incekaya Köyü)",
      "Hacılar Mah (çakırbağ Köyü)",
      "Hacılar Mah (karakuzu Köyü)",
      "Harmancık Köyü",
      "Hasanlar Mah (göynükören Köyü)",
      "İmatlar Mah (göynükören Köyü)",
      "Karabük Mah (kavakköy Köyü)",
      "Karakışla Mah (yusufoğlu Köyü)",
      "Karaoluk Mah (oluklu Köyü)",
      "Karataş Köyü",
      "Kavakdibi Mah (yusufoğlu Köyü)",
      "Kışla Mah (yusufoğlu Köyü)",
      "Kıyan Mah (yusufoğlu Köyü)",
      "Koçlu Köyü",
      "Merkez Mah (çakırbağ Köyü)",
      "Merkez Mah (çayırcık Köyü)",
      "Merkez Mah (kavakköy Köyü)",
      "Merkez Mah (oluklu Köyü)",
      "Merkez Mah (sarıkaya Köyü)",
      "Merkez Mah (topçu Köyü)",
      "Merkez Mah (yusufoğlu Köyü)",
      "Orta Mah (göynükören Köyü)",
      "Ova Mah (topçu Köyü)",
      "Oymaağaç Köyü",
      "Ören Mah (göynükören Köyü)",
      "Ötedağ Mah (oluklu Köyü)",
      "Sazak Mah (oluklu Köyü)",
      "Sazak Mah (topçu Köyü)",
      "Soğukoluk Mah (göynükören Köyü)",
      "Üçgazi Köyü",
      "Yayla Mah (göynükören Köyü)",
      "Yayla Mah (karakuzu Köyü)",
      "Yaylatepesi Köyü",
      "Yazıören Köyü",
      "Yukarı Mah (dereköy Köyü)",
      "Yukarı Mah (incekaya Köyü)",
      "Yukarı Mah (karakuzu Köyü)",
      "Yukarı Mah (yusufoğlu Köyü)",
      "Yurtpınar Köyü"
    ],
    "Çerkeş": [
      "Cumhuriyet Mah",
      "Çerkeş Osb Mah",
      "İdris Mah",
      "İstasyon Mah",
      "Karalar Mah",
      "Karamuklu Mah",
      "Kurtlar Mah",
      "Okçular Mah",
      "Ulusu Mah",
      "Yeni Kent Mah",
      "Yeni Mah",
      "Abdullar Mah (dağçukurören Köyü)",
      "Ağaca Köyü",
      "Ahallar Mah (örenli Köyü)",
      "Akbaş Köyü",
      "Aliözü Köyü",
      "Avdan Yaylası Mah (yeşilöz Köyü)",
      "Bayındır Köyü",
      "Bayındır Yaylası Mah (bayındır Köyü)",
      "Bedil Köyü",
      "Bey Mah (gökçeler Köyü)",
      "Boyuncak Mah (saraycık Köyü)",
      "Bozcaarmut Mah (kısaç Köyü)",
      "Bölükören Mah (göynükçukuru Köyü)",
      "Çakmak Köyü",
      "Çetin Mah (çalcıören Köyü)",
      "Çoroğlu Mah (çalcıören Köyü)",
      "Çömlekçi Mah (kadıköy Köyü)",
      "Dağlı Mah (göynükçukuru Köyü)",
      "Dere Yayla Mah (örenköy Köyü)",
      "Dodurga Köyü",
      "Elpirek Mah (yakuplar Köyü)",
      "Erenler Mah (gökçeler Köyü)",
      "Eymür Mah (şeyhdoğan Köyü)",
      "Fındıcak Köyü",
      "Gelik Mah (gelik Ovacık Köyü)",
      "Güvem Mah (çaylı Köyü)",
      "Hacılar Köyü",
      "Halkaoğlu Köyü",
      "Ilıca Mah (kadıköy Köyü)",
      "İncegez Mah (afşar Köyü)",
      "Kabak Köyü",
      "Kadıözü Köyü",
      "Karaağaç Mah (belkavak Köyü)",
      "Karakoca Mah (kuzören Köyü)",
      "Karamustafa Köyü",
      "Karaşar Köyü",
      "Karga Köyü",
      "Kınık Mah (aydınlar Köyü)",
      "Kışla Mah (beymelik Köyü)",
      "Kirenözü Mah (yıprak Köyü)",
      "Kuzdere Köyü",
      "Kürüz Mah (bayındır Köyü)",
      "Merkez Mah (afşar Köyü)",
      "Merkez Mah (akhasan Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (belkavak Köyü)",
      "Merkez Mah (beymelik Köyü)",
      "Merkez Mah (bozoğlu Köyü)",
      "Merkez Mah (çalcıören Köyü)",
      "Merkez Mah (çaylı Köyü)",
      "Merkez Mah (çördük Köyü)",
      "Merkez Mah (dağçukurören Köyü)",
      "Merkez Mah (dikenli Köyü)",
      "Merkez Mah (gelik Ovacık Köyü)",
      "Merkez Mah (gökçeler Köyü)",
      "Merkez Mah (göynükçukuru Köyü)",
      "Merkez Mah (kadıköy Köyü)",
      "Merkez Mah (karacahöyük Köyü)",
      "Merkez Mah (kısaç Köyü)",
      "Merkez Mah (kiremitçi Köyü)",
      "Merkez Mah (kuzören Köyü)",
      "Merkez Mah (örenköy Köyü)",
      "Merkez Mah (örenli Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (şeyhdoğan Köyü)",
      "Merkez Mah (türbaşı Köyü)",
      "Merkez Mah (yakuplar Köyü)",
      "Merkez Mah (yeşilöz Köyü)",
      "Merkez Mah (yıprak Köyü)",
      "Meydan Köyü",
      "Nahallar Mah (örenli Köyü)",
      "Ömerler Mah (dağçukurören Köyü)",
      "Örencik Mah (afşar Köyü)",
      "Örencik Mah (türbaşı Köyü)",
      "Songeçit Mah (çördük Köyü)",
      "Taşanlar Köyü",
      "Tohumlar Mah (yıprak Köyü)",
      "Uluköy Köyü",
      "Yalnızca Mah (kadıköy Köyü)",
      "Yayla Evleri Mah (dikenli Köyü)",
      "Yayla Mah (türbaşı Köyü)",
      "Yeniköy Köyü",
      "Yeşilova Mah (yeşilöz Köyü)",
      "Yeşilören Mah (göynükçukuru Köyü)",
      "Yoncalı Köyü",
      "Yortan Mah (kiremitçi Köyü)",
      "Yörük Mah (çaylı Köyü)",
      "Yumaklı Köyü",
      "Yusufoğlu Mah (kuzören Köyü)",
      "Güzelyurt Mah (saçak Beldesi)",
      "Kayabaşı Mah (saçak Beldesi)",
      "Yalıözü Mah (saçak Beldesi)",
      "Yeni Mah (saçak Beldesi)"
    ],
    "Eldivan": [
      "Bahçelievler Mah",
      "Beydere Mah",
      "Cami Mah",
      "Çay Mah",
      "Dere Mah",
      "Topraklık Mah",
      "Akbulut Köyü",
      "Akçalı Köyü",
      "Alva Köyü",
      "Beşevler Mah (hisarcıkkayı Köyü)",
      "Büyükhacıbey Köyü",
      "Çalıdere-yığındaş Mah (sarayköy Köyü)",
      "Çiftlikköy Köyü",
      "Çukuröz Köyü",
      "Elmacı Köyü",
      "Gölez Köyü",
      "Gömene Mah (gölezkayı Köyü)",
      "Hisarcık Köyü",
      "Köy İçi Mah (gölezkayı Köyü)",
      "Köy İçi Mah (hisarcıkkayı Köyü)",
      "Küçükhacıbey Köyü",
      "Sarayköy Köyü",
      "Sarıtarla Köyü",
      "Seydiköy Köyü",
      "Yukarıyanlar Köyü"
    ],
    "Ilgaz": [
      "Fatih Mah",
      "Gazi Dede Mah",
      "Karataş Mah",
      "Şentepe Mah",
      "Ulupınar Mah",
      "Yavuz Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Ziraat Mah",
      "Akcaören Köyü",
      "Aktaş Köyü",
      "Alıç Köyü",
      "Alpagut Köyü",
      "Arpayeri Köyü",
      "Asar Mah (ödemiş Köyü)",
      "Aşağı Mah (alibey Köyü)",
      "Aşağı Mah (okcular Köyü)",
      "Aşağıbozan Köyü",
      "Aşağıdere Köyü",
      "Aşağımeydan Köyü",
      "Aşıklar Köyü",
      "Balcı Mah (balcı Köyü)",
      "Başaraz Mah (yuvademirciler Köyü)",
      "Başdibek Köyü",
      "Belören Köyü",
      "Belören Yenice Köyü",
      "Belsöğüt Köyü",
      "Beyköy Köyü",
      "Bozatlı Köyü",
      "Bükcük Köyü",
      "Candere Köyü",
      "Cömert Köyü",
      "Çaltıpınar Köyü",
      "Çatak Köyü",
      "Çeltikbaşı Köyü",
      "Danişment Köyü",
      "Dönaşa Mah (mülayım Köyü)",
      "Düz Mah (mülayım Köyü)",
      "Eksik Köyü",
      "Ericek Köyü",
      "Eskice Köyü",
      "Gaziler Köyü",
      "Güneyköy Köyü",
      "Hacıhasan Köyü",
      "Ilısılık Köyü",
      "İkikavak Köyü",
      "İnköy Köyü",
      "Kaleköy Köyü",
      "Karataş Mah (alibey Köyü)",
      "Kavaklı Köyü",
      "Kayı Köyü",
      "Keseköy Köyü",
      "Kırışlar Köyü",
      "Kıssenir Mah (kazancı Köyü)",
      "Kışla Mah (yukarıdere Köyü)",
      "Kıyısın Köyü",
      "Kızılıbrık Köyü",
      "Köy Merkezi Mah (serçeler Köyü)",
      "Kurmalar Köyü",
      "Kuşçayırı Köyü",
      "Kuyupınar Köyü",
      "Lüllük Mah (çörekçiler Köyü)",
      "Memetler Mah (gökceyazı Köyü)",
      "Menşer Mah (yukarıdere Köyü)",
      "Merkez Mah (alibey Köyü)",
      "Merkez Mah (balcı Köyü)",
      "Merkez Mah (gökceyazı Köyü)",
      "Merkez Mah (kazancı Köyü)",
      "Merkez Mah (okcular Köyü)",
      "Merkez Mah (sarmaşık Köyü)",
      "Merkez Mah (şeyhyunus Köyü)",
      "Merkez Mah (yeşildumlupınar Köyü)",
      "Merkez Mah (yukarıdere Köyü)",
      "Merkez Mah (yuvademirciler Köyü)",
      "Mesutören Köyü",
      "Murat Hacı Mah (mülayım Köyü)",
      "Musaköy Köyü",
      "Mülayim Mah (mülayım Köyü)",
      "Mülayim Yenice Köyü",
      "Onaç Köyü",
      "Orta Mah (mülayım Köyü)",
      "Orta Mah (ödemiş Köyü)",
      "Ömerli Köyü",
      "Sağırlar Köyü",
      "Saray Mah (ödemiş Köyü)",
      "Saraycık Köyü",
      "Satılar Köyü",
      "Sazak Köyü",
      "Seki Köyü",
      "Serçeler Yaylası Mah (serçeler Köyü)",
      "Sezginler Mah (ılısılık Köyü)",
      "Söğütcük Köyü",
      "Süleymanhacılar Köyü",
      "Şeyhyunus Mah (şeyhyunus Köyü)",
      "Terziler Mah (gökceyazı Köyü)",
      "Yaka Mah (çörekçiler Köyü)",
      "Yalaycık Köyü",
      "Yarağzı Mah (çörekçiler Köyü)",
      "Yaylaören Köyü",
      "Yazıköy Köyü",
      "Yenidemirciler Köyü",
      "Yerkuyu Köyü",
      "Yukarı Sarmaşık Mah (sarmaşık Köyü)",
      "Yukarıbozan Köyü",
      "Yukarımeydan Köyü",
      "Yuvasaray Köyü"
    ],
    "Kızılırmak": [
      "Hüseyinli Mah",
      "Osmanlı Mah",
      "Yeni Mah",
      "Aşağıalegöz Köyü",
      "Aşağıovacık Köyü",
      "Bayanpınar Köyü",
      "Bostanlı Köyü",
      "Boyacıoğlu Köyü",
      "Büyükbahçeli Köyü",
      "Cacıklar Köyü",
      "Gazibekir Mah (kapaklı Köyü)",
      "Güneykışla Köyü",
      "Hacılar Köyü",
      "Hallaçlı Köyü",
      "Kahyalı Köyü",
      "Kapaklı Köyü",
      "Karadibek Köyü",
      "Karallı Köyü",
      "Karamürsel Köyü",
      "Karaömer Köyü",
      "Kavlaklı Köyü",
      "Kemallı Köyü",
      "Korçullu Köyü",
      "Kuzeykışla Köyü",
      "Küçükbahçeli Mah (tepealegöz Köyü)",
      "Sakarca Köyü",
      "Saraycık Köyü",
      "Sultançiftliği Mah (kapaklı Köyü)",
      "Tepealegöz Köyü",
      "Tımarlı Köyü",
      "Yeniyapan Köyü",
      "Yukarıalegöz Köyü"
    ],
    "Korgun": [
      "Büyük Mah",
      "Büyükosb Mah",
      "Doğu Mah",
      "Uludağ Mah",
      "Alpsarı Köyü",
      "Batıbeli Mah (dikenli Köyü)",
      "Buğay Köyü",
      "Çukurören Köyü",
      "Hıcıp Köyü",
      "Ikın Yaylası Mah (maruf Köyü)",
      "Ildızım Köyü",
      "Ildızım Yaylası Mah (ıldızım Köyü)",
      "İkiçam Köyü",
      "Karatekin Köyü",
      "Kaş Yayla Mah (maruf Köyü)",
      "Kayıçivi Köyü",
      "Kesecik Köyü",
      "Maruf Köyü",
      "Merkez Mah (dikenli Köyü)",
      "Sanı Yaylası Mah (maruf Köyü)",
      "Şıhlar Köyü"
    ],
    "Kurşunlu": [
      "Beşpınar Mah",
      "Cömertler Mah",
      "Çal Mah",
      "Erenler Mah",
      "Hacı Bekir Mah",
      "Kale Mah",
      "Kalekapu Mah",
      "Müslüm Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Ağılözü Köyü",
      "Başovacık Köyü",
      "Bereket Köyü",
      "Çatkese Köyü",
      "Çaylıca Köyü",
      "Çırdak Köyü",
      "Çiyni Mah",
      "Dağören Köyü",
      "Demirciören Köyü",
      "Ekinli Mah (çukurca Köyü)",
      "Eskiahır Köyü",
      "Fatih Mah (çavundur Köyü)",
      "Fatih Mah (sivricek Köyü)",
      "Göllüce Köyü",
      "Hocahasan Köyü",
      "Hürriyet Mah (çavundur Köyü)",
      "İğdir Köyü",
      "Kapaklı Köyü",
      "Kızılca Köyü",
      "Köpürlü Köyü",
      "Madenli Köyü",
      "Merkez Mah (çukurca Köyü)",
      "Merkez Mah (dumanlı Köyü)",
      "Merkez Mah (hacımuslu Köyü)",
      "Merkez Mah (sarıalan Köyü)",
      "Merkez Mah (taşkaracalar Köyü)",
      "Pınarcık Mah (sarıalan Köyü)",
      "Sumucak Köyü",
      "Sünürlü Köyü",
      "Uzunoğlu Mah (sarıalan Köyü)",
      "Yeni Mah (sivricek Köyü)",
      "Yeşilören Köyü",
      "Yeşilöz Köyü"
    ],
    "Merkez": [
      "Alibey Mah",
      "Buğday Pazarı Mah",
      "Cumhuriyet Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "İncili  Çeşme Mah",
      "Karataş Mah",
      "Karatekin Mah",
      "Kırkevler Mah",
      "Mimar Sinan Mah",
      "Tabakhane Mah",
      "Ahlat Köyü",
      "Akçavakıf Köyü",
      "Alıca Köyü",
      "Aşağıçavuş Köyü",
      "Aşağıpelitözü Köyü",
      "Balıbağı Köyü",
      "Ballıca Mah (aşağıyanlar Köyü)",
      "Başeğmez Köyü",
      "Bayındır Köyü",
      "Beştut Köyü",
      "Bozkır Köyü",
      "Çağabey Köyü",
      "Çatalelma Köyü",
      "Çayırpınar Köyü",
      "Çırçır Köyü",
      "Çiftlik Mah (çivi Köyü)",
      "Danabaş Köyü",
      "Dede Köyü",
      "Dede Mah (çivi Köyü)",
      "Değim Köyü",
      "Dutağaç Köyü",
      "Germece Köyü",
      "Goncaoğlu Mah (altınlı Köyü)",
      "Gülburun Mah (karadayı Köyü)",
      "Haciömer Mah (ağzıbüyük Köyü)",
      "Handırı Köyü",
      "Hasakça Köyü",
      "Haydam Mah (alaçat Köyü)",
      "Hıdırlık Köyü",
      "İçyenice Köyü",
      "İnaç Köyü",
      "İnandık Köyü",
      "İncik Köyü",
      "Kara Ciceli Mah (taytak Köyü)",
      "Karakışla Mah (süleymanlı Köyü)",
      "Karaşeyh Köyü",
      "Kılıçargı Altı Mah (aşağıyanlar Köyü)",
      "Köy İçi Mah (aşağıyanlar Köyü)",
      "Köy İçi Mah (çivi Köyü)",
      "Köy Merkezi Mah (doğantepe Köyü)",
      "Köyiçi Mah (karadayı Köyü)",
      "Kuzu Köyü",
      "Küçüklü Köyü",
      "Merkez Mah (ağzıbüyük Köyü)",
      "Merkez Mah (akören Köyü)",
      "Merkez Mah (alaçat Köyü)",
      "Merkez Mah (altınlı Köyü)",
      "Merkez Mah (ayan Köyü)",
      "Merkez Mah (taytak Köyü)",
      "Merkez Mah (ünür Köyü)",
      "Merzi Köyü",
      "Mollamehmet Mah (ağzıbüyük Köyü)",
      "Organize Sanayi Bölgesi Mah (tüney Köyü)",
      "Ovacık Köyü",
      "Öz Mah (aşağıyanlar Köyü)",
      "Paşa Köyü",
      "Pehlivanlı Köyü",
      "Satıyüzü Köyü",
      "Süleymanlı Mah (süleymanlı Köyü)",
      "Tepe Mah (ayan Köyü)",
      "Terme Mah (akören Köyü)",
      "Tuzlağan Mah (balıbağı Köyü)",
      "Tuzlu Köyü",
      "Tüney Köyü",
      "Yenidoğan Mah (doğantepe Köyü)",
      "Yılanlı Mah (dede Köyü)",
      "Yukarıçavuş Köyü",
      "Yukarıpelitözü Köyü",
      "Zafer Mah (akören Köyü)",
      "Abdulhalik Renda Mah",
      "Aksu Mah",
      "Yeni Mah"
    ],
    "Orta": [
      "Akçaören Mah (elmalık Köyü)",
      "Buğurören Köyü",
      "Büğdüz Köyü",
      "Derebayındır Köyü",
      "Doğanlar Köyü",
      "Elden Köyü",
      "Elvan Mah (elmalık Köyü)",
      "Fatih Mah (özlü Köyü)",
      "Gökçeören Köyü",
      "Hacı Hasan Mah (kalfat Köyü)",
      "Hamamönü Mah (dodurga Beldesi)",
      "Hasanhacı Köyü",
      "Hatipler Mah (kalfat Köyü)",
      "Hüyükköy Köyü",
      "İncecik Köyü",
      "Kanarya Mah (dodurga Beldesi)",
      "Karaağaç Köyü",
      "Kayıören Köyü",
      "Kırsakal Köyü",
      "Kısaç Köyü",
      "Naltepe Mah (dodurga Beldesi)",
      "Nevzat Ayaz Mah (kalfat Köyü)",
      "Ortabayındır Köyü",
      "Sakaeli Köyü",
      "Sakarcaören Köyü",
      "Salur Köyü",
      "Sancak Mah (özlü Köyü)",
      "Sancar Köyü",
      "Seydi Mah (elmalık Köyü)",
      "Sünnetçiler Mah (kalfat Köyü)",
      "Taşlı Tarla Mah (tutmaçbayındır Köyü)",
      "Tutmaçbayındır Köyü",
      "Yayla Evleri Mah (elden Köyü)",
      "Yayla Evleri Mah (gökçeören Köyü)",
      "Yayla Evleri Mah (hasanhacı Köyü)",
      "Yeni Harman Yeri Mah (elden Köyü)",
      "Yeni Ortabayındır Mah (ortabayındır Köyü)",
      "Yenice Köyü",
      "Yuva Köyü",
      "Cem Sultan Mah",
      "Eski Yayla Mah",
      "Kanlıca Mah",
      "Sultan Beyazıt Mah",
      "Cumhuriyet Mah (yaylakent Beldesi)",
      "Hürriyet Mah (yaylakent Beldesi)",
      "İnkilap Mah (yaylakent Beldesi)",
      "Kayılar Mah (yaylakent Beldesi)"
    ],
    "Şabanözü": [
      "Bakırlı Köyü",
      "Bulduk Köyü",
      "Bulgurcu Köyü",
      "Büyükyakalı Köyü",
      "Çadır Mah (martköy Köyü)",
      "Çapar Köyü",
      "Çaparkayı Köyü",
      "Çerçi Köyü",
      "Demirsahan Mah (ödek Köyü)",
      "Deprem Konutları Mah (kamışköy Köyü)",
      "Göldağı Köyü",
      "Gündoğmuş Köyü",
      "Kamışköy Köyü",
      "Karahacı Köyü",
      "Karakoçaş Köyü",
      "Karamusa Köyü",
      "Kayapınar Mah (çaparkayı Köyü)",
      "Kurtsivrisi Mah (özbek Köyü)",
      "Kutluşar Köyü",
      "Küçükyakalı Köyü",
      "Martköy Köyü",
      "Oluklu Mah (çaparkayı Köyü)",
      "Ödek Köyü",
      "Özbek Köyü",
      "Sırıklı Mah (gündoğmuş Köyü)",
      "Cumhuriyet Mah",
      "Gümerdiğin Mah",
      "Gürpınar Mah",
      "Karaören Mah",
      "Mahmudiye Mah",
      "Sağlık Mah",
      "Yeni Mah",
      "Yeniosb Mah"
    ],
    "Yapraklı": [
      "Aşağıöz Köyü",
      "Ayseki Köyü",
      "Ayva Köyü",
      "Bademçay Köyü",
      "Balıbıdık Köyü",
      "Belibedir Köyü",
      "Buğay Köyü",
      "Buluca Köyü",
      "Büyük Cami Mah (yüklü Köyü)",
      "Büyükakseki Köyü",
      "Çakırlar Köyü",
      "Çevrecik Köyü",
      "Çiçek Köyü",
      "Davutlar Köyü",
      "Doğanbey Köyü",
      "Gürmeç Köyü",
      "Karacaözü Köyü",
      "Kayacık Köyü",
      "Kaymaz Köyü",
      "Kıvcak Köyü",
      "Kirliakça Köyü",
      "Kullar Köyü",
      "Müsellim Köyü",
      "Ovacık Köyü",
      "Sarıkaya Köyü",
      "Sazcağız Köyü",
      "Sofuoğlu Köyü",
      "Subaşı Köyü",
      "Şeyh İsmail Mah (yukarıöz Köyü)",
      "Şeyh Osman Köyü",
      "Topuzsaray Köyü",
      "Yaka Köyü",
      "Yakadere Köyü",
      "Yamaçbaşı Köyü",
      "Yeni Mah (ikizören Köyü)",
      "Yenice Köyü",
      "Yeşilyayla Köyü",
      "Zekeriya Köyü",
      "Akyazı Mah",
      "Aşağı Mah",
      "Camikebir Mah",
      "İğdir Mah",
      "Kavak Mah",
      "Yukarı Mah"
    ]
  },
  "Çorum": {
    "Alaca": [
      "Ayhan Mah",
      "Cengizhan Mah",
      "Cumhuriyet Mah",
      "Denizhan Mah",
      "Günhan Mah",
      "Özhan Mah",
      "Yıldızhan Mah",
      "Akçaköy Köyü",
      "Akçiçek Köyü",
      "Akören Köyü",
      "Akpınar Köyü",
      "Altıntaş Köyü",
      "Bahçeli Köyü",
      "Balçıkhisar Köyü",
      "Belpınar Köyü",
      "Beşiktepe Köyü",
      "Boğaziçi Köyü",
      "Bolatçık Köyü",
      "Bozdoğan Köyü",
      "Büyükcamili Köyü",
      "Büyükdona Köyü",
      "Büyükkeşlik Köyü",
      "Büyüksöğütözü Köyü",
      "Cumhuriyet Mah (büyükhırka Köyü)",
      "Cumhuriyet Mah (çopraşık Köyü)",
      "Çal Köyü",
      "Çatak Köyü",
      "Çatalbaş Köyü",
      "Çatalkaya Köyü",
      "Çelebibağ Köyü",
      "Çetederesi Köyü",
      "Çevreli Köyü",
      "Çırçır Köyü",
      "Çikhasan Köyü",
      "Çöplü Köyü",
      "Çöplüavutmuş Köyü",
      "Dedepınar Köyü",
      "Değirmendere Köyü",
      "Değirmenönü Köyü",
      "Dereyazıcı Köyü",
      "Dutluca Köyü",
      "Eren Köyü",
      "Eskiyapar Köyü",
      "Evci Köyü",
      "Fakılar Köyü",
      "Fatih Mah (büyükhırka Köyü)",
      "Fatih Mah (çopraşık Köyü)",
      "Gazipaşa Köyü",
      "Gerdekkaya Köyü",
      "Geven Köyü",
      "Gökören Köyü",
      "Gülderesi Köyü",
      "Güllük Köyü",
      "Harhar Köyü",
      "Haydar Köyü",
      "Höyük Mah (alacahüyük Köyü)",
      "İbrahim Köyü",
      "İmat Köyü",
      "İsahacı Köyü",
      "İsmailli Köyü",
      "Kalecikkaya Köyü",
      "Kalınkaya Köyü",
      "Kapaklı Köyü",
      "Karaçal Köyü",
      "Karamahmut Köyü",
      "Karatepe Köyü",
      "Kargın Köyü",
      "Karnıkara Köyü",
      "Kayabüvet Köyü",
      "Kıcılı Köyü",
      "Kılavuz Köyü",
      "Kızıllı Köyü",
      "Kızılyar Köyü",
      "Kızkaraca Köyü",
      "Killik Köyü",
      "Koçhisar Köyü",
      "Koyunoğlu Köyü",
      "Körpınar Köyü",
      "Kuyluş Köyü",
      "Kuyumcusaray Köyü",
      "Kuzkışla Köyü",
      "Küçükcamili Köyü",
      "Küçükdona Köyü",
      "Küçükhırka Köyü",
      "Küçükkeşlik Köyü",
      "Külah Köyü",
      "Küre Köyü",
      "Kürkçü Köyü",
      "Mahmudiye Köyü",
      "Mazıbaşı Köyü",
      "Miyanesultan Köyü",
      "Oğuzhan Mah (büyükhırka Köyü)",
      "Onbaşılar Köyü",
      "Örükaya Köyü",
      "Perçem Köyü",
      "Sancı Köyü",
      "Sarısüleyman Köyü",
      "Seyitnizam Köyü",
      "Sincan Köyü",
      "Soğucak Köyü",
      "Sultan Köyü",
      "Suludere Köyü",
      "Tahirabat Köyü",
      "Tevfikiye Köyü",
      "Tutaş Köyü",
      "Ünalan Köyü",
      "Yatankavak Köyü",
      "Yenice Köyü",
      "Yeniköy Köyü",
      "Yeşilyurt Köyü",
      "Yüksekyayla Köyü"
    ],
    "Bayat": [
      "Dere Mah",
      "Kayabaşı Mah",
      "Tepebayat Mah",
      "Yatukcu Mah",
      "Yeni Mah",
      "Akkaya Mah (saray Köyü)",
      "Akseki Köyü",
      "Alibey Mah (eskialibey Köyü)",
      "Ankara Yolu Mah (saray Köyü)",
      "Asma Mah (beydili Köyü)",
      "Aşağı Emirhalil Köyü",
      "Aşağı Mah (çayköy Köyü)",
      "Aşağı Yeşilçat Mah (yeşilçat Köyü)",
      "Ayvalıca Köyü",
      "Bağ Arkası Mah (hacıbayram Köyü)",
      "Bağözü Mah (kuruçay Köyü)",
      "Barak Köyü",
      "Boyalık Mah (derekutuğun Köyü)",
      "Büyük Mah (tevekli Köyü)",
      "Cevizli Köyü",
      "Çağıl Mah (yoncalı Köyü)",
      "Çalı Sökü Mah (kuruçay Köyü)",
      "Çamlıgüney Köyü",
      "Çay Kavuştu Mah (çerkeş Köyü)",
      "Çebiş Gediği Mah (köpüklü Köyü)",
      "Çerkeş Köyü",
      "Çukuröz Köyü",
      "Dangazlar Mah (demirciler Köyü)",
      "Derekutuğun Köyü",
      "Dorukseki Köyü",
      "Emirşah Köyü",
      "Enaltı Çayı Mah (ahacık Köyü)",
      "Fatih Mah (kunduzlu Köyü)",
      "Fındıcak Mah (ahacık Köyü)",
      "Gazi Mah (eskialibey Köyü)",
      "Gazi Mah (yeşilçat Köyü)",
      "Geriş Mah (kalınpelit Köyü)",
      "Göynük Harman Altı Mah (tevekli Köyü)",
      "Güleç Mah (yoncalı Köyü)",
      "Güllevük Mah (çerkeş Köyü)",
      "Güzel Bağlar Mah (çerkeş Köyü)",
      "Hacıayvat Mah (ahacık Köyü)",
      "Hacılar Mah (demirciler Köyü)",
      "Havdan Mah (tevekli Köyü)",
      "Haydar Mah (derekutuğun Köyü)",
      "Horozlar Mah (ileği Köyü)",
      "İmamoğlu Mah (evci Köyü)",
      "Karabalçık Mah (ahacık Köyü)",
      "Karakaya Köyü",
      "Karşıköy Mah (ahacık Köyü)",
      "Karşıyaka Mah (eskialibey Köyü)",
      "Kavakkırı Mah (köpüklü Köyü)",
      "Kayabaşı Mah (demirciler Köyü)",
      "Kaytazlar Mah (yeşilçat Köyü)",
      "Keskinler Mah (demirciler Köyü)",
      "Kızılpelit Mah (ahacık Köyü)",
      "Kirenle Mah (evci Köyü)",
      "Kom Mah (ileği Köyü)",
      "Kozdere Mah (kunduzlu Köyü)",
      "Köm Mah (tepekutuğun Köyü)",
      "Köm Mah (yoncalı Köyü)",
      "Kömür Ocağı-1 Mah (karakaya Köyü)",
      "Kömür Ocağı-2 Mah (karakaya Köyü)",
      "Köyyeri Mah (yoncalı Köyü)",
      "Kubbedin Köyü",
      "Kuruçay Köyü",
      "Kurugöl Mah (hacıbayram Köyü)",
      "Kürtali Damı Mah (kalınpelit Köyü)",
      "Lapa Köyü",
      "Merkez Mah (bayan Köyü)",
      "Merkez Mah (beydili Köyü)",
      "Merkez Mah (çukuröz Köyü)",
      "Merkez Mah (emirhalil Köyü)",
      "Merkez Mah (evci Köyü)",
      "Merkez Mah (falı Köyü)",
      "Merkez Mah (hacıbayram Köyü)",
      "Merkez Mah (ileği Köyü)",
      "Merkez Mah (ishaklı Köyü)",
      "Merkez Mah (kalınpelit Köyü)",
      "Merkez Mah (köpüklü Köyü)",
      "Merkez Mah (sağpazar Köyü)",
      "Merkez Mah (saray Köyü)",
      "Merkez Mah (yenişıhlar Köyü)",
      "Mezarlık Mevki Mah (emirhalil Köyü)",
      "Nasıflar Mah (ahacık Köyü)",
      "Nazpınar Mah (ahacık Köyü)",
      "Oba Mah (ileği Köyü)",
      "Orta Mah (tevekli Köyü)",
      "Osmanyeri Mah (hacıbayram Köyü)",
      "Pancarlık Köyü",
      "Semer Deresi Mah (tepekutuğun Köyü)",
      "Soyuk Mah (ahacık Köyü)",
      "Sungur Mah (yoncalı Köyü)",
      "Taşlık Mah (evci Köyü)",
      "Taytak Mah (ahacık Köyü)",
      "Tepekutuğun Köyü",
      "Toyhane Köyü",
      "Ürgüpler Mah (kalınpelit Köyü)",
      "Yazlık Mah (kunduzlu Köyü)",
      "Yeni Mah (eskialibey Köyü)",
      "Yeni Mah (kunduzlu Köyü)",
      "Yenicami Mah (demirciler Köyü)",
      "Yeniköy Köyü",
      "Yeşilyurt Mah (kalınpelit Köyü)",
      "Yukarı Mah (çayköy Köyü)",
      "Yukarı Mah (yoncalı Köyü)",
      "Yukarı Taşlık Mah (evci Köyü)",
      "Yüceardı Mah (ahacık Köyü)"
    ],
    "Boğazkale": [
      "Çarşı Mah",
      "Hattusas Mah",
      "Hisar Mah",
      "Bağlarbaşı Mah (yekbas Köyü)",
      "Bahçelievler Mah (yekbas Köyü)",
      "Çarşıcuma Köyü",
      "Derebağlar Mah (evci Köyü)",
      "Emirler Köyü",
      "Fatih Mah (yekbas Köyü)",
      "Gölpınarlar Köyü",
      "Kadılıtürk Köyü",
      "Karakeçili Köyü",
      "Kaymaz Köyü",
      "Örenkaya Köyü",
      "Sarıçiçek Köyü",
      "Yanıcak Köyü",
      "Yazır Köyü",
      "Yeni Mah (evci Köyü)",
      "Yenikadılı Köyü",
      "Yukarıfındıklı Köyü",
      "Yunus Emre Mah (evci Köyü)"
    ],
    "Dodurga": [
      "Çatar Mah",
      "Doğu Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Okul Mah",
      "Ulucami Mah",
      "Akkaya Köyü",
      "Camii Mah (alpagut Köyü)",
      "Cumhuriyet Mah (alpagut Köyü)",
      "Çiftlikköy Köyü",
      "Dikenli Köyü",
      "Kabakdere Mah (dikenli Köyü)",
      "Kirenci Köyü",
      "Kirenpınarı Mah (ayvaköy Köyü)",
      "Kuyucak Köyü",
      "Mehmetdedeobruğu Köyü",
      "Mehmetdedetekkesi Köyü",
      "Merkez Mah (ayvaköy Köyü)",
      "Merkez Mah (berkköy Köyü)",
      "Soğukeşme Mah (dikenli Köyü)",
      "Şehit Ali Şirin Mah (dikenli Köyü)",
      "Tırıklar Mah (yeniköy Köyü)",
      "Tokuş Mah (ayvaköy Köyü)",
      "Tutuş Köyü",
      "Yayla Evleri Mah (tutuş Köyü)",
      "Yeniköy Köyü",
      "Yeniokul Mah (alpagut Köyü)",
      "Yukarı Mah (alpagut Köyü)",
      "Yusuflar Mah (ayvaköy Köyü)"
    ],
    "İskilip": [
      "Bahabey Mah",
      "Büyüktaş Mah",
      "Çavuş Mah",
      "Ekizoğlu Mah",
      "Erenler Mah",
      "Hacıpiri Mah",
      "Kaleboğazı Mah",
      "Meydan Mah",
      "Mutaflar Mah",
      "Sakarya Mah",
      "Tabakhane Mah",
      "Ulaştepe Mah",
      "Uludere Mah",
      "Yenicami Mah",
      "Acıpınar Mah (musular Köyü)",
      "Ahlat Mah (karaçukur Köyü)",
      "Ahlatcık Köyü",
      "Akkil Mah (eskiköy Köyü)",
      "Alibeyli Mah (hallı Köyü)",
      "Aluç Köyü",
      "Araplar Mah (çomu Köyü)",
      "Aşağı Ekşioğlu Mah (aşağışeyhler Köyü)",
      "Aşağı Karlık Mah (karlık Köyü)",
      "Aşağı Kıran Mah (aşağışeyhler Köyü)",
      "Aşağı Mah (ikikise Köyü)",
      "Aşağıseki Mah (yaylacıkseki Köyü)",
      "Aşina Tavukçuluk Mah (şehirkuruçay Köyü)",
      "Bahçelievler Mah (yalakçay Köyü)",
      "Barutcu Çiftliği Mah (derekargın Köyü)",
      "Boyrazlar Mah (başmakcı Köyü)",
      "Buruncuk Mah (aşağışeyhler Köyü)",
      "Cansızlar Mah (ikipınar Köyü)",
      "Cıngıllıoğlu Mah (kılıçdere Köyü)",
      "Cuhalar Mah (güneyaluç Köyü)",
      "Curalar Mah (hallı Köyü)",
      "Çağılardı Mah (çavuşoğlu Köyü)",
      "Çatkara Köyü",
      "Çelikler Çiftliği Mah (şehirkuruçay Köyü)",
      "Çıraklar Mah (hallı Köyü)",
      "Çimenler Alidayı Mah (yanoğlan Köyü)",
      "Çördük Mah (akpınar Köyü)",
      "Çördük Mah (aşağıörenseki Köyü)",
      "Çuhalar Mah (güneyaluç Köyü)",
      "Çukurköy Köyü",
      "Damruyurt Mah (akpınar Köyü)",
      "Delikkaya Mah (aşağışeyhler Köyü)",
      "Demirciler Mah (seyirçayı Köyü)",
      "Dere Mah (yenice Köyü)",
      "Dereköy Mah (yanoğlan Köyü)",
      "Dereli Mah (yaylacıkseki Köyü)",
      "Deveci Mah (derekargın Köyü)",
      "Dikbıyıklar Mah (çetmi Köyü)",
      "Divanoğlu Mah (avhatyaka Köyü)",
      "Doğangir Köyü",
      "Doruk Harman Mah (ibik Köyü)",
      "Düzbağ Mah (ibik Köyü)",
      "Eller Saklar Mah (yaylacıkseki Köyü)",
      "Ellezler Mah (çomu Köyü)",
      "Esentepe Mah (çavuşoğlu Köyü)",
      "Evlik Mah (dereseki Köyü)",
      "Gıcıklar Mah (beyoğlan Köyü)",
      "Göl Köyü",
      "Göldağı Mah (kavak Köyü)",
      "Gülekler Mah (elmalı Köyü)",
      "Güney Merkez Mah (elmalı Köyü)",
      "Hacılar Mah (çomu Köyü)",
      "Halilpaşa Mah (karaçukur Köyü)",
      "Harun Köyü",
      "Hasandeğen Mah (yalakçay Köyü)",
      "Hasanfakı Mah (akcasu Köyü)",
      "Hinolar Mah (çomu Köyü)",
      "Hüsemoğlu Köyü Mah (hacıhalil Köyü)",
      "İkipınarköyü Yolüzeri Mah (derekargın Köyü)",
      "İnnice Mah (ibik Köyü)",
      "Kadirliler Mah (şeyh Köyü)",
      "Kale Mah (şeyh Köyü)",
      "Kalfa Mah (kayaağzı Köyü)",
      "Kamışağıl Mah (musular Köyü)",
      "Kapı Mah (yaylacıkseki Köyü)",
      "Karaburun Köyü",
      "Karagöz Köyü",
      "Karakaya Mah (ibik Köyü)",
      "Karamuk Mah (dağkıyısı Köyü)",
      "Karaşar Mah (şeyh Köyü)",
      "Karayanık Mah (sorkun Köyü)",
      "Karkın Mah (dereseki Köyü)",
      "Karkın Mah (kavak Köyü)",
      "Karmış Köyü",
      "Kavacık Mah (ibik Köyü)",
      "Kaynarca Mah (kılıçdere Köyü)",
      "Kelağa Mah (çomu Köyü)",
      "Kelleli Mah (ikikise Köyü)",
      "Kenger Mah (karaçukur Köyü)",
      "Kıyı Mah (kurusaray Köyü)",
      "Kızılcabayır Köyü",
      "Kızılibrik Köyü Mah (hacıhalil Köyü)",
      "Koçcağız Mah (yalak Köyü)",
      "Kozveren Mah (asarcık Köyü)",
      "Kuşlar Mah (sarıkavak Köyü)",
      "Kutluözü Köyü",
      "Kuz Köyü",
      "Kuzahlat Mah (sarıkavak Köyü)",
      "Kuzey Mah (elmalı Köyü)",
      "Kuzören Mah (aşağışeyhler Köyü)",
      "Kuzuluk Köyü",
      "Küyükler Mah (beyoğlan Köyü)",
      "Manastır Mah (ikipınar Köyü)",
      "Mantarlı Mah (ikipınar Köyü)",
      "Memiler Mah (güneyaluç Köyü)",
      "Mercimeklik Mah (ahmetce Köyü)",
      "Merkez Mah (ahmetce Köyü)",
      "Merkez Mah (akcasu Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (asarcık Köyü)",
      "Merkez Mah (aşağıörenseki Köyü)",
      "Merkez Mah (aşağışeyhler Köyü)",
      "Merkez Mah (avhatyaka Köyü)",
      "Merkez Mah (başmakcı Köyü)",
      "Merkez Mah (beyoğlan Köyü)",
      "Merkez Mah (çavuşoğlu Köyü)",
      "Merkez Mah (çetmi Köyü)",
      "Merkez Mah (dağkıyısı Köyü)",
      "Merkez Mah (derekargın Köyü)",
      "Merkez Mah (dereseki Köyü)",
      "Merkez Mah (eskiköy Köyü)",
      "Merkez Mah (güneyaluç Köyü)",
      "Merkez Mah (hacıhalil Köyü)",
      "Merkez Mah (hallı Köyü)",
      "Merkez Mah (ibik Köyü)",
      "Merkez Mah (ikikise Köyü)",
      "Merkez Mah (ikipınar Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (karaçukur Köyü)",
      "Merkez Mah (karlık Köyü)",
      "Merkez Mah (kavak Köyü)",
      "Merkez Mah (kayaağzı Köyü)",
      "Merkez Mah (kılıçdere Köyü)",
      "Merkez Mah (kurusaray Köyü)",
      "Merkez Mah (musular Köyü)",
      "Merkez Mah (onaç Köyü)",
      "Merkez Mah (örübağ Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (sarıkavak Köyü)",
      "Merkez Mah (seki Köyü)",
      "Merkez Mah (seyirçayı Köyü)",
      "Merkez Mah (sorkun Köyü)",
      "Merkez Mah (şehirkuruçay Köyü)",
      "Merkez Mah (şeyh Köyü)",
      "Merkez Mah (yalak Köyü)",
      "Merkez Mah (yalakçay Köyü)",
      "Merkez Mah (yanoğlan Köyü)",
      "Merkez Mah (yaylacıkseki Köyü)",
      "Merkez Mah (yenice Köyü)",
      "Merkez Mah (yerli Köyü)",
      "Obruk Mah (yaylacıkseki Köyü)",
      "Okçular Mah (seyirçayı Köyü)",
      "Okçular Mah (yaylacıkseki Köyü)",
      "Orta Mah (akcasu Köyü)",
      "Orta Mah (kurusaray Köyü)",
      "Parpucu Çiftliği Mah (derekargın Köyü)",
      "Paşalı Mah (ikikise Köyü)",
      "Porsuklar Mah (avhatyaka Köyü)",
      "Sadıklar Mah (kurusaray Köyü)",
      "Saldere Mah (seki Köyü)",
      "Sekizevler Mah (ibik Köyü)",
      "Semoğlu Mah (güneyaluç Köyü)",
      "Semüşler Mah (hallı Köyü)",
      "Sennüç Mah (ibik Köyü)",
      "Sipahi Mah (çetmi Köyü)",
      "Soğucak Köyü",
      "Sopak Mah (karaçukur Köyü)",
      "Sorguncuk Mah (ikikise Köyü)",
      "Söylemezler Mah (avhatyaka Köyü)",
      "Suhilan Köyü",
      "Susuzdağ Mah (aşağışeyhler Köyü)",
      "Süleli Mah (hallı Köyü)",
      "Şadıman Mah (çomu Köyü)",
      "Şahinler Mah (kavak Köyü)",
      "Şahinler Mah (onaç Köyü)",
      "Taşkestik Mah (seyirçayı Köyü)",
      "Teberoğlu Mah (güneyaluç Köyü)",
      "Tepeyakası Mah (şehirkuruçay Köyü)",
      "Tetiri Mah (ahmetce Köyü)",
      "Tevgeler Mah (saraycık Köyü)",
      "Tıraşlar Mah (örübağ Köyü)",
      "Tilkiler Mah (yaylacıkseki Köyü)",
      "Tosya Yolu Korardı Mah (yanoğlan Köyü)",
      "Tültepe Mah (karaağaç Köyü)",
      "Ulugürgen Mevkii Mah (derekargın Köyü)",
      "Üçpınar Mah (ibik Köyü)",
      "Ürküler Mah (karaağaç Köyü)",
      "Veletler Mah (kılıçdere Köyü)",
      "Yalınkise Mah (ikikise Köyü)",
      "Yama Mah (beyoğlan Köyü)",
      "Yanıklar Mah (ikikise Köyü)",
      "Yaskam Mah (seyirçayı Köyü)",
      "Yavaşlar Mah (çomu Köyü)",
      "Yavu Köyü",
      "Yavular Mah (sarıkavak Köyü)",
      "Yenimahalle Mah (yanoğlan Köyü)",
      "Yeniyol Mah (akcasu Köyü)",
      "Yukarı Ekşioğlu Mah (aşağışeyhler Köyü)",
      "Yukarı Kıran Mah (aşağışeyhler Köyü)",
      "Yukarıörenseki Köyü",
      "Yunus Pınarı Mah (ibik Köyü)"
    ],
    "Kargı": [
      "Bahçelievler Mah",
      "Fatih Mah",
      "İmambey Mah",
      "Mihrihatun Mah",
      "Orta Mah",
      "Yeni Mah",
      "Abdi Mah (saraçlar Köyü)",
      "Acekse Mah (bademce Köyü)",
      "Akçayazı Mah (arık Köyü)",
      "Akçayazı Mah (beygircioğlu Köyü)",
      "Akkaya Yayla Mah (dereköy Köyü)",
      "Akkaya Yaylası Mah (gölet Köyü)",
      "Aktaş Mah (sinanözü Köyü)",
      "Alacinek Mah (cihadiye Köyü)",
      "Aladağ Mah (karacaoğlan Köyü)",
      "Alayürek Mah (karacaoğlan Köyü)",
      "Arzumanlar Mah (bademce Köyü)",
      "Aşağı Kayadibi Mah (güney Köyü)",
      "Aşağı Mah (bayat Köyü)",
      "Aşağı Mora Mah (uzunyurt Köyü)",
      "Aşağı Yayla Mah (çobanlar Köyü)",
      "Aşağı Yayla Mah (dereköy Köyü)",
      "Aşıklar Mah (pelitcik Köyü)",
      "Bahçelievler Mah (hacıhamza Köyü)",
      "Başpınar Mah (göl Köyü)",
      "Bayaslı Mah (gökbudak Köyü)",
      "Bayat Yaylası Mah (bayat Köyü)",
      "Bokluca Mah (çakırlar Köyü)",
      "Bosseki Mah (karacaoğlan Köyü)",
      "Celleler Mah (pelitcik Köyü)",
      "Cembekli Mah (göletdere Köyü)",
      "Cineminin  Mah (kuşbağın Mah) (göletdere Köyü)",
      "Çalarası Mah (göl Köyü)",
      "Çalıklar Mah (pelitcik Köyü)",
      "Çatak Mah (bayat Köyü)",
      "Çatak Yaylası Mah (bayat Köyü)",
      "Çay Mah (bayat Köyü)",
      "Çaykışla Mah (bağözü Köyü)",
      "Çeştepe Mah (çal Köyü)",
      "Çiçek Yaylası Mah (uzunyurt Köyü)",
      "Çorak Mah (uzunyurt Köyü)",
      "Çörçör Mah (dereköy Köyü)",
      "Değirmendere Mah (hacıhamza Köyü)",
      "Demirci Mah (saraçlar Köyü)",
      "Dere Mah (karacaoğlan Köyü)",
      "Devrez Mah (pelitcik Köyü)",
      "Düzenli Mah (arık Köyü)",
      "Elikoğlu Mah (çobankaya Köyü)",
      "Erkeş Mah (cihadiye Köyü)",
      "Eski Arık Mah (arık Köyü)",
      "Eski Yerleşim Yeri Mah (çakırlar Köyü)",
      "Eskiköy Mah (gökbudak Köyü)",
      "Eynönü Mah (çobanlar Köyü)",
      "Fadıloğlu Mah (göletdere Köyü)",
      "Fındıcak Mah (güney Köyü)",
      "Geriççik Mah (gökbudak Köyü)",
      "Göcen Mah (sünlük Köyü)",
      "Göcen Yaylası Mah (sünlük Köyü)",
      "Gökyer Mah (çal Köyü)",
      "Gölceğiz Mah (günyazı Köyü)",
      "Gölceğiz Yaylası Mah (günyazı Köyü)",
      "Güney Mah (çakırlar Köyü)",
      "Güney Mah (karakise Köyü)",
      "Günyazı Yaylası Mah (günyazı Köyü)",
      "Hacı Ahmet Mah (bayat Köyü)",
      "Hacı Ahmet Yaylası Mah (bayat Köyü)",
      "Hacılar Mah (pelitcik Köyü)",
      "Hamzalar Mah (seki Köyü)",
      "Harmancı Mah (saraçlar Köyü)",
      "İbideresi Yaylası Mah (uzunyurt Köyü)",
      "İğdiş Mah (dereköy Köyü)",
      "İkitaş Mah (çakırlar Köyü)",
      "İkizler Mah (sünlük Köyü)",
      "Kabakçı Yaylası Mah (kabakcı Köyü)",
      "Kadimli Mah (karaosmanlı Köyü)",
      "Kale Mah (hacıhamza Köyü)",
      "Karaahmetler Mah (pelitcik Köyü)",
      "Karaalioğlu Mah (çobankaya Köyü)",
      "Karagöl Mah (gölet Köyü)",
      "Karagöz Güney Mah (dereköy Köyü)",
      "Karaoğlan Kızı Mah (kabakcı Köyü)",
      "Karaoluk Mah (beygircioğlu Köyü)",
      "Karatuzla Yaylası Mah (bozarmut Köyü)",
      "Kargı Mah (uzunyurt Köyü)",
      "Karsu Alabalık Tesisleri Mah (başköy Köyü)",
      "Kasımlar Mah (göl Köyü)",
      "Kaş Mah (uzunyurt Köyü)",
      "Kavak Mah (göl Köyü)",
      "Kavakdibi Mah (karacaoğlan Köyü)",
      "Keleşler Mah (seki Köyü)",
      "Kesek Mah (çakırlar Köyü)",
      "Kırıntı Mah (pelitcik Köyü)",
      "Kırıntı Yaylası Mah (pelitcik Köyü)",
      "Kırkpöyre Mah (çetmi Köyü)",
      "Kışla Mah (çobankaya Köyü)",
      "Kışla Mah (günyazı Köyü)",
      "Kışla Mah (pelitcik Köyü)",
      "Kızıltaş Mah (sinanözü Köyü)",
      "Kızıltaş Yaylası Mah (bayat Köyü)",
      "Kızlankırağı Mah (cihadiye Köyü)",
      "Kirazdibi Güney Mah (dereköy Köyü)",
      "Kocaömer Mah (yuvanın Mah) (göletdere Köyü)",
      "Koru Mah (çobankaya Köyü)",
      "Köprübaşı Mah (inceçay Köyü)",
      "Küyükçügil Mah (çobankaya Köyü)",
      "Malkayası Mah (hacıveli Köyü)",
      "Mandıra Mah (sünlük Köyü)",
      "Mehdioğlu Mah (cihadiye Köyü)",
      "Merkez Mah (abdullah Köyü)",
      "Merkez Mah (akçataş Köyü)",
      "Merkez Mah (akkaya Köyü)",
      "Merkez Mah (akkise Köyü)",
      "Merkez Mah (alioğlu Köyü)",
      "Merkez Mah (avşar Köyü)",
      "Merkez Mah (bademce Köyü)",
      "Merkez Mah (bağözü Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (beygircioğlu Köyü)",
      "Merkez Mah (bozarmut Köyü)",
      "Merkez Mah (cihadiye Köyü)",
      "Merkez Mah (çakırlar Köyü)",
      "Merkez Mah (çal Köyü)",
      "Merkez Mah (çeltiközü Köyü)",
      "Merkez Mah (çetmi Köyü)",
      "Merkez Mah (çobankaya Köyü)",
      "Merkez Mah (çobanlar Köyü)",
      "Merkez Mah (çukuraluç Köyü)",
      "Merkez Mah (demirören Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (gökbudak Köyü)",
      "Merkez Mah (gökçedoğan Köyü)",
      "Merkez Mah (göl Köyü)",
      "Merkez Mah (gölet Köyü)",
      "Merkez Mah (göletdere Köyü)",
      "Merkez Mah (gümüşoğlu Köyü)",
      "Merkez Mah (günyazı Köyü)",
      "Merkez Mah (hacıveli Köyü)",
      "Merkez Mah (halılar Köyü)",
      "Merkez Mah (inceçay Köyü)",
      "Merkez Mah (kabakcı Köyü)",
      "Merkez Mah (karaboya Köyü)",
      "Merkez Mah (karacaoğlan Köyü)",
      "Merkez Mah (karakise Köyü)",
      "Merkez Mah (karaosmanlı Köyü)",
      "Merkez Mah (karapürçek Köyü)",
      "Merkez Mah (kavakçayı Köyü)",
      "Merkez Mah (koyunkıran Köyü)",
      "Merkez Mah (köprübaşı Köyü)",
      "Merkez Mah (maksutlu Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (pelitözü Köyü)",
      "Merkez Mah (saraçlar Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (sinanözü Köyü)",
      "Merkez Mah (sünlük Köyü)",
      "Merkez Mah (tepelice Köyü)",
      "Merkez Mah (uğuz Köyü)",
      "Merkez Mah (yağcılar Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Mestanlar Mah (güney Köyü)",
      "Mollalar Mah (pelitcik Köyü)",
      "Mora Yaylası Mah (uzunyurt Köyü)",
      "Nasıflar Mah (saraçlar Köyü)",
      "Obruk Mah (hacıhamza Köyü)",
      "Onbaşılar Güney Mah (dereköy Köyü)",
      "Orta Mah (abdullah Köyü)",
      "Orta Mah (güney Köyü)",
      "Osmansırdığı Mah (karacaoğlan Köyü)",
      "Öksüzler Mah (arık Köyü)",
      "Ömerkaya Mah (çetmi Köyü)",
      "Ömerler Mah (saraçlar Köyü)",
      "Öteköy Mah (uzunyurt Köyü)",
      "Özbaşı Mah (sinanözü Köyü)",
      "Özköy Mah (saraçlar Köyü)",
      "Pınar Mah (bayat Köyü)",
      "Pıtılar Mah (seki Köyü)",
      "Pişbilik Mah (karacaoğlan Köyü)",
      "Sakızçayı Mah (kavakçayı Köyü)",
      "Seki Mah (karacaoğlan Köyü)",
      "Sovla Mah (sinanözü Köyü)",
      "Söpseki Mah (bademce Köyü)",
      "Sünlük Yaylası Mah (sünlük Köyü)",
      "Şıhlar Mah (gümüşoğlu Köyü)",
      "Tekkeşin Mah (gökçedoğan Köyü)",
      "Tepe Mah (göl Köyü)",
      "Tepearkası Mah (alioğlu Köyü)",
      "Uzuntarla Mah (karacaoğlan Köyü)",
      "Yayla Mah (akkise Köyü)",
      "Yayla Mah (alioğlu Köyü)",
      "Yayla Mah (arık Köyü)",
      "Yayla Mah (bademce Köyü)",
      "Yayla Mah (çal Köyü)",
      "Yayla Mah (çukuraluç Köyü)",
      "Yayla Mah (gökçedoğan Köyü)",
      "Yayla Mah (göl Köyü)",
      "Yayla Mah (inceçay Köyü)",
      "Yayla Mah (karaboya Köyü)",
      "Yayla Mah (karakise Köyü)",
      "Yayla Mah (köprübaşı Köyü)",
      "Yayla Mah (örencik Köyü)",
      "Yayla Mah (pelitcik Köyü)",
      "Yayla Mah (pelitözü Köyü)",
      "Yayla Mah (uğuz Köyü)",
      "Yayla Mah (yağcılar Köyü)",
      "Yazıpınar Mah (göl Köyü)",
      "Yemişli Mah (çetmi Köyü)",
      "Yemişli Mah (göletdere Köyü)",
      "Yenice Mah (çobankaya Köyü)",
      "Yeniköy Mah (tepelice Köyü)",
      "Yeşilköy Yaylası Mah (yeşilköy Köyü)",
      "Yiğren Yaylası Mah (yağcılar Köyü)",
      "Yirgen Mah (karacaoğlan Köyü)",
      "Yukarı Dereköy Mah (dereköy Köyü)",
      "Yukarı Kayadibi Mah (güney Köyü)",
      "Yukarı Mah (bayat Köyü)",
      "Yukarı Mah (güney Köyü)",
      "Yukarı Yayla Mah (dereköy Köyü)",
      "Zaimler Mah (saraçlar Köyü)",
      "Zeynel Mah (hacıhamza Köyü)",
      "Zeyve Mah (uzunyurt Köyü)"
    ],
    "Laçin": [
      "Bahçelievler Mah",
      "Fatih Mah",
      "Yeni Mah",
      "Ada Mah (narlı Köyü)",
      "Bağlarbaşı Mah (narlı Köyü)",
      "Cavraşlar Mah (narlı Köyü)",
      "Çamlıpınar Köyü",
      "Doğanlar Köyü",
      "Dutludere Mah (kuyumcu Köyü)",
      "Gökçekaya Köyü",
      "Güney Mah (narlı Köyü)",
      "İkizce Köyü",
      "Karaköy Mah (gökgözler Köyü)",
      "Karakütük Mah (gözübüyük Köyü)",
      "Karasoku Köyü",
      "Kavaklıçiftlik Köyü",
      "Kuyumcu Mah (kuyumcu Köyü)",
      "Merkez Mah (gökgözler Köyü)",
      "Mescitli Köyü",
      "Sıtma Köyü",
      "Şenyurt Mah (çamlıca Köyü)",
      "Yeni Mah (narlı Köyü)",
      "Yeşilpınar Köyü",
      "Yeşilyurt Mah (çamlıca Köyü)"
    ],
    "Mecitözü": [
      "Bahçelievler Mah",
      "Bahçelievler Mah (elvançelebi Köyü)",
      "Camikebir Mah",
      "Çamlık Mah (elvançelebi Köyü)",
      "Dediği Mah (elvançelebi Köyü)",
      "Doğu Mah",
      "Hıdırlık Mah",
      "Mescit Mah",
      "Sarıdede Mah",
      "Şehler Mah",
      "Tutluk Mah",
      "Ağcakoyun Köyü",
      "Akpınar Köyü",
      "Alancık Köyü",
      "Alören Köyü",
      "Aşağı Mah (boyacı Köyü)",
      "Aşağıkörücek Köyü",
      "Bayındır Köyü",
      "Bekişler Köyü",
      "Beyözü Köyü",
      "Boğazkaya Köyü",
      "Boyacı Köyü",
      "Bükse Köyü",
      "Çam Bekiş Mah (bekişler Köyü)",
      "Çayköy Köyü",
      "Çitli Köyü",
      "Dağsaray Köyü",
      "Devletoğlan Köyü",
      "Doğla Köyü",
      "Doruk Bekiş Mah (bekişler Köyü)",
      "Elmapınar Köyü",
      "Emirbağı Köyü",
      "Fakıahmet Köyü",
      "Fındıklı Köyü",
      "Figani Köyü",
      "Geykoca Köyü",
      "Gökçebel Köyü",
      "Güngörmez Köyü",
      "Hisarkavak Köyü",
      "Işıklı Köyü",
      "İbek Köyü",
      "Kalecik Köyü",
      "Karacaören Köyü",
      "Karacuma Köyü",
      "Kargı Köyü",
      "Kayı Köyü",
      "Kışlacık Köyü",
      "Koloğlu Mah (figani Köyü)",
      "Konaç Köyü",
      "Koyunağılı Köyü",
      "Kozören Köyü",
      "Köprübaşı Köyü",
      "Körücek Köyü",
      "Köseeyüp Köyü",
      "Kuyucak Köyü",
      "Mollacop Mah (karacuma Köyü)",
      "Pınarbaşı Köyü",
      "Pınarbaşı Mah (pınarbaşı Köyü)",
      "Sarıhasan Köyü",
      "Sırçalı Köyü",
      "Sorkoğlan Köyü",
      "Söğütönü Köyü",
      "Söğütyolu Köyü",
      "Sülüklü Köyü",
      "Tanrıvermiş Köyü",
      "Terken Köyü",
      "Totali Köyü",
      "Vakıflar Köyü",
      "Yedigöz Köyü",
      "Yeşilova Köyü"
    ],
    "Merkez": [
      "Ataköy Mah (düvenci Beldesi)",
      "Fatih Sultan Mehmet Mah (düvenci Beldesi)",
      "Gedikbekir Mah (düvenci Beldesi)",
      "İkipınar Mah (düvenci Beldesi)",
      "Kışladeresi Mah (düvenci Beldesi)",
      "Kultak Mah (düvenci Beldesi)",
      "Mimarsinan Mah (düvenci Beldesi)",
      "Yunusemre Mah (düvenci Beldesi)",
      "Gülabibey Mah",
      "Kale Mah",
      "Mimarsinan Mah",
      "Buharaevler Mah",
      "Karakeçili Mah",
      "Pınarçayosb Mah",
      "Üçtutlar Mah",
      "Abdalata Köyü",
      "Ahiilyas Köyü",
      "Ahiilyas Mah (ahiilyas Köyü)",
      "Ahmediye Köyü",
      "Ahmet Şahna Mah (kadıkırı Köyü)",
      "Akçaaz Mah (dutçakallı Köyü)",
      "Akçakaya Köyü",
      "Akdam Mah (karakeçili Köyü)",
      "Akkol Mah (çalyayla Köyü)",
      "Akseki Mah (eskiköy Köyü)",
      "Aktaş Mah (şendere Köyü)",
      "Akyazı Köyü",
      "Aliki Mah (eskiekin Köyü)",
      "Altınbaş Mah (altınbaş Köyü)",
      "Arslan Köyü",
      "Arzum Pınarı Mah (sırıklı Köyü)",
      "Aş.sarılık Mah (sarılık Köyü)",
      "Aşağı Mah (acıpınar Köyü)",
      "Aşağı Mah (hamdiköy Köyü)",
      "Aşağı Üçdam Mah (seydimçakallı Köyü)",
      "Atcalı Mah (atçalı Köyü)",
      "Ayvalı Köyü",
      "Babaoğlu Köyü",
      "Babaoğlu Mah (kertme Köyü)",
      "Bademli Mah (yakuparpa Köyü)",
      "Bahçelievler Mah (konaklı Köyü)",
      "Balımsultan Köyü",
      "Balıyakup Köyü",
      "Bayat Mah",
      "Bekaroğlu Mah (düdüklük Köyü)",
      "Beydili Köyü",
      "Boğabağı Köyü",
      "Boğacık Köyü",
      "Boğazönü Köyü",
      "Borsunlu Mah (morsümbül Köyü)",
      "Boyralı Mah (kılıçören Köyü)",
      "Bozbuğa Mah (bozboğa Köyü)",
      "Budağan Mah (şahinkaya Köyü)",
      "Budakören Köyü",
      "Burun Köyü",
      "Büğrüoğlu Köyü",
      "Büklüce Mah (öksüzler Köyü)",
      "Büyükdivan Köyü",
      "Büyükgülücek Köyü",
      "Cerit Köyü",
      "Çağşak Köyü",
      "Çaltıcak Köyü",
      "Çanakçı Köyü",
      "Çayseki Mah (seydimçakallı Köyü)",
      "Çelikkaya Mah (eskiköy Köyü)",
      "Çeşmeören Köyü",
      "Çobandivan Köyü",
      "Çomarbaşı Mah (çomarbaşı Köyü)",
      "Çorak Köyü",
      "Dağbağ Mah (çalyayla Köyü)",
      "Dağkarapınar Köyü",
      "Danaderesi Mah (aşağısaraylı Köyü)",
      "Deliler Köyü",
      "Deliler Mah (deliler Köyü)",
      "Dere Köyü",
      "Derebey Mah (eskiköy Köyü)",
      "Dut Köyü",
      "Eğridere Mah (eskiköy Köyü)",
      "Elicek Köyü",
      "Elköy Köyü",
      "Elmalı Köyü",
      "Erdek Köyü",
      "Ertuğrul Köyü",
      "Eskice Köyü",
      "Eskice Mah (eskice Köyü)",
      "Eskiekin Bağları Mah (eskiekin Köyü)",
      "Eskiekin Mah (eskiekin Köyü)",
      "Eskikaradona Köyü",
      "Eskiköy Mah (eskiköy Köyü)",
      "Evcikuzkışla Köyü",
      "Evciortakışla Köyü",
      "Evciyenikışla Köyü",
      "Eyerci Köyü",
      "Fatih Mah (ovasaray Köyü)",
      "Ferhatlı Mah (eskiören Köyü)",
      "Feruz Köyü",
      "Gemet Köyü",
      "Gök Mah (atçalı Köyü)",
      "Gökçepınar Köyü",
      "Gökdere Köyü",
      "Gölyeri Mah (seydim Köyü)",
      "Gözübüyük Mah (kırkdilim Köyü)",
      "Gülveren Mah (harmancık Köyü)",
      "Güney Köyü",
      "Güveçli Köyü",
      "Güvenli Köyü",
      "Hacı Mah (ovasaray Köyü)",
      "Hacıahmetderesi Köyü",
      "Hacıbey Köyü",
      "Hacımusa Köyü",
      "Hacıpaşa Köyü",
      "Hacıpaşa Mah (hacıpaşa Köyü)",
      "Hacivat Mah (eskiköy Köyü)",
      "Hamamlıçay Köyü",
      "Hankozlusu Köyü",
      "Harmantarla Mah (eskiekin Köyü)",
      "Hızırdede Köyü",
      "Hüseyinağ Mah (hımıroğlu Köyü)",
      "İmamlar Mah (eskiköy Köyü)",
      "İsmailköy Köyü",
      "Kadıkırı Mah (kadıkırı Köyü)",
      "Kalehisar Köyü",
      "Karaağaç Köyü",
      "Karabürçek Köyü",
      "Karabürçek Mah (karabürçek Köyü)",
      "Karacaören Köyü",
      "Karakaya Mah (eskiköy Köyü)",
      "Karapınar Köyü",
      "Karapınar Mah (karapınar Köyü)",
      "Karşıyaka Mah (güzelyurt Köyü)",
      "Karşıyaka Mah (hımıroğlu Köyü)",
      "Karşıyaka Mah (konaklı Köyü)",
      "Kaşgaga Mah (morsümbül Köyü)",
      "Kavacık Köyü",
      "Kavaklı Mah (aksungur Köyü)",
      "Kazıklıkaya Köyü",
      "Kazıklıkaya Mah (kazıklıkaya Köyü)",
      "Kendisi Mah (altınbaş Köyü)",
      "Kendisi Mah (karahisar Köyü)",
      "Kınık Köyü",
      "Kışlacık Mah (eskiköy Köyü)",
      "Kıvırcık Mah (kayı Köyü)",
      "Kızılkır Mah (iğdeli Köyü)",
      "Kızılpınar Köyü",
      "Kiranlık Köyü",
      "Kirazlıpınar Köyü",
      "Kireçocağı Köyü",
      "Koğuduruk Mah (eskiköy Köyü)",
      "Konaklı Mah (konaklı Köyü)",
      "Koparan Köyü",
      "Kozanoğlu Mah (aksungur Köyü)",
      "Kozluca Köyü",
      "Kösrelik Mah (karabayır Köyü)",
      "Kumçeltiği Köyü",
      "Kuruçay Köyü",
      "Kuşsaray Mah (kuşsaray Köyü)",
      "Kuşveren Mah (yakuparpa Köyü)",
      "Küçük Eymir Mah (eymir Köyü)",
      "Küçükdüvenci Köyü",
      "Küçükgülücek Köyü",
      "Küçükpalabıyık Köyü",
      "Laloğlu Köyü",
      "Mecidiyekavak Köyü",
      "Memişler Mah (aksungur Köyü)",
      "Merkez Mah (acıpınar Köyü)",
      "Merkez Mah (ahmetoğlan Köyü)",
      "Merkez Mah (aksungur Köyü)",
      "Merkez Mah (altınbaş Köyü)",
      "Merkez Mah (arpalık Köyü)",
      "Merkez Mah (arpaöz Köyü)",
      "Merkez Mah (aşağısaraylı Köyü)",
      "Merkez Mah (atçalı Köyü)",
      "Merkez Mah (ayaz Köyü)",
      "Merkez Mah (bektaşoğlu Köyü)",
      "Merkez Mah (bozboğa Köyü)",
      "Merkez Mah (büğdüz Köyü)",
      "Merkez Mah (büğet Köyü)",
      "Merkez Mah (celilkırı Köyü)",
      "Merkez Mah (çakır Köyü)",
      "Merkez Mah (çalıca Köyü)",
      "Merkez Mah (çalkışla Köyü)",
      "Merkez Mah (çalyayla Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çayhatap Köyü)",
      "Merkez Mah (çıkrık Köyü)",
      "Merkez Mah (çukurören Köyü)",
      "Merkez Mah (değirmendere Köyü)",
      "Merkez Mah (delibekiroğlu Köyü)",
      "Merkez Mah (deniz Köyü)",
      "Merkez Mah (düdüklük Köyü)",
      "Merkez Mah (esençay Köyü)",
      "Merkez Mah (eskiekin Köyü)",
      "Merkez Mah (eskiören Köyü)",
      "Merkez Mah (eymir Köyü)",
      "Merkez Mah (göcenovacığı Köyü)",
      "Merkez Mah (gökköy Köyü)",
      "Merkez Mah (hamdiköy Köyü)",
      "Merkez Mah (harmancık Köyü)",
      "Merkez Mah (hımıroğlu Köyü)",
      "Merkez Mah (iğdeli Köyü)",
      "Merkez Mah (inalözü Köyü)",
      "Merkez Mah (kadıderesi Köyü)",
      "Merkez Mah (kadıkırı Köyü)",
      "Merkez Mah (karabayır Köyü)",
      "Merkez Mah (karaca Köyü)",
      "Merkez Mah (karadona Köyü)",
      "Merkez Mah (karagöz Köyü)",
      "Merkez Mah (karahisar Köyü)",
      "Merkez Mah (karakeçili Köyü)",
      "Merkez Mah (kayı Köyü)",
      "Merkez Mah (kertme Köyü)",
      "Merkez Mah (kılıçören Köyü)",
      "Merkez Mah (kınıkdeliler Köyü)",
      "Merkez Mah (kırkdilim Köyü)",
      "Merkez Mah (köprüalan Köyü)",
      "Merkez Mah (kuşsaray Köyü)",
      "Merkez Mah (kutluca Köyü)",
      "Merkez Mah (mollahasan Köyü)",
      "Merkez Mah (morsümbül Köyü)",
      "Merkez Mah (narlık Köyü)",
      "Merkez Mah (öksüzler Köyü)",
      "Merkez Mah (ömerbey Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (sarılık Köyü)",
      "Merkez Mah (sazak Köyü)",
      "Merkez Mah (serban Köyü)",
      "Merkez Mah (seyfe Köyü)",
      "Merkez Mah (sırıklı Köyü)",
      "Merkez Mah (soğuksu Köyü)",
      "Merkez Mah (şahinkaya Köyü)",
      "Merkez Mah (şanlıosman Köyü)",
      "Merkez Mah (şendere Köyü)",
      "Merkez Mah (şeyhhamza Köyü)",
      "Merkez Mah (şeyhmustafa Köyü)",
      "Merkez Mah (tarhan Köyü)",
      "Merkez Mah (tozluburun Köyü)",
      "Merkez Mah (turgut Köyü)",
      "Merkez Mah (türkayşe Köyü)",
      "Merkez Mah (üyük Köyü)",
      "Merkez Mah (yakuparpa Köyü)",
      "Merkez Mah (yeşilyayla Köyü)",
      "Mislerovacığı Köyü",
      "Mustafaçelebi Köyü",
      "Mühürler Köyü",
      "Oluközü Mah (sırıklı Köyü)",
      "Orta Mah (dutçakallı Köyü)",
      "Orta-akçaaz Mah (dutçakallı Köyü)",
      "Osmaniye Köyü",
      "Oymaağaç Köyü",
      "Örencik Kaçağı Mah (örencik Köyü)",
      "Örencikkaçağı Mah (hımıroğlu Köyü)",
      "Palabıyık Köyü",
      "Pancarlık Köyü",
      "Pancarlık Mah (pancarlık Köyü)",
      "Paşa Köyü",
      "Pembecik Köyü",
      "Pınarcık Köyü",
      "Pınarçay Köyü",
      "Rıçvanlar Mah (çomarbaşı Köyü)",
      "Salur Köyü",
      "Sapa Köyü",
      "Saray Mah (ovasaray Köyü)",
      "Saraylı Köyü",
      "Sarıkaya Köyü",
      "Sarımbey Köyü",
      "Sarımbey Mah (sarımbey Köyü)",
      "Sarışeyh Köyü",
      "Sarıyar Mah (seydimçakallı Köyü)",
      "Sarmaşa Köyü",
      "Sazdeğirmeni Köyü",
      "Serpin Köyü",
      "Sevindikalanı Köyü",
      "Seyitmurat Mah (seydim Köyü)",
      "Sorsavuş Mah (hamdiköy Köyü)",
      "Söğütseki Mah (esençay Köyü)",
      "Sülüklü Mah (inalözü Köyü)",
      "Şehit Bekir Özaydın Aliki Bağlısı Mah (eskiekin Köyü)",
      "Şekerbey Köyü",
      "Şenyurt Mah (konaklı Köyü)",
      "Tarhankozlusu Köyü",
      "Taşpınar Köyü",
      "Tatar Köyü",
      "Tatar Mah (tatar Köyü)",
      "Tepe Mah (ömerbey Köyü)",
      "Teslim Köyü",
      "Tolamehmet Köyü",
      "Tolamehmet Mah (tolamehmet Köyü)",
      "Türkler Köyü",
      "Uğrak Köyü",
      "Üçdam Mah (seydimçakallı Köyü)",
      "Üçevler Mah (acıpınar Köyü)",
      "Üçköy Köyü",
      "Ülkenpınarı Köyü",
      "Yaydiğin Köyü",
      "Yeni Mah (ovasaray Köyü)",
      "Yenice Köyü",
      "Yenice Mah (yenice Köyü)",
      "Yenihayat Köyü",
      "Yeşildere Köyü",
      "Yeşilyurt Mah (güzelyurt Köyü)",
      "Yoğunpelit Köyü",
      "Yunusemre Mah (seydim Köyü)",
      "Ak Kent Mah",
      "Çepni Mah",
      "Çöplü Mah",
      "Kunduzhan Mah",
      "Ulukavak Mah",
      "Bahçelievler Mah",
      "Yavruturna Mah",
      "Yeniyol Mah"
    ],
    "Oğuzlar": [
      "Asarçay Mah",
      "Birtatlı Mah",
      "Çarşı Mah",
      "Çeşme Mah",
      "Gölbaşı Mah",
      "Karadonlu Mah",
      "Kızılcapelit Mah",
      "Aşırlık Mah (ağaççamı Köyü)",
      "Çaparahmetler Mah (ağaççamı Köyü)",
      "Çemal Mah (ağaççamı Köyü)",
      "Çiğdemlik Mah (cevizli Köyü)",
      "Gafurlar Mah (ağaççamı Köyü)",
      "Göleçük Mah (kayı Köyü)",
      "Kamburlar Mah (derinöz Köyü)",
      "Karaboyalık Mah (erenler Köyü)",
      "Karaya Mah (ağaççamı Köyü)",
      "Kasımlar Mah (ağaççamı Köyü)",
      "Kavakdağ Mah (ağaççamı Köyü)",
      "Kayadibi Mah (ağaççamı Köyü)",
      "Keloğlanlar Mah (ağaççamı Köyü)",
      "Kışlı İçi Mevki Mah (cevizli Köyü)",
      "Kızıkcıköy Mah (cevizli Köyü)",
      "Körpaşalar Mah (cevizli Köyü)",
      "Köseler Mah (derinöz Köyü)",
      "Kötelekler Mah (ağaççamı Köyü)",
      "Merkez Mah (ağaççamı Köyü)",
      "Merkez Mah (erenler Köyü)",
      "Merkez Mah (kayı Köyü)",
      "Mezarlık Yanı Mah (kayı Köyü)",
      "Onbeş Evler Mah (kayı Köyü)",
      "Ömerler Mah (cevizli Köyü)",
      "Sordoğlu Mah (ağaççamı Köyü)",
      "Şaphane Köyü",
      "Tekkeşinler Mah (derinöz Köyü)",
      "Yamaç Mah (cevizli Köyü)",
      "Yoğunpelit Mah (ağaççamı Köyü)"
    ],
    "Ortaköy": [
      "Bahçelievler Mah (aştavul Beldesi)",
      "Şirinevler Mah (aştavul Beldesi)",
      "Akyar Mah (senemoğlu Köyü)",
      "Asar Köyü",
      "Büyükkışla Köyü",
      "Cevizli Köyü",
      "Cumhuriyet Mah (karahacip Köyü)",
      "Esentepe Köyü",
      "Fatih Mah (karahacip Köyü)",
      "Fındıklı Köyü",
      "İncesu Köyü",
      "Kavakalan Köyü",
      "Kızılhamza Köyü",
      "Merkez Mah (senemoğlu Köyü)",
      "Oruçpınar Köyü",
      "Salbaş Köyü",
      "Sirkeoğlu Mah (senemoğlu Köyü)",
      "Yaylacık Köyü",
      "Yukarı Kuyucak Köyü",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Suyolu Mah"
    ],
    "Osmancık": [
      "Ağıroğlan Köyü",
      "Ağızsuyu Mah (gecek Köyü)",
      "Ahatlı Mah (karalargüney Köyü)",
      "Ahatlı Mah (yağsiyan Köyü)",
      "Ahıbaba Mah (gecek Köyü)",
      "Ahırçayı Mah (yağsiyan Köyü)",
      "Alacakışla Mah (yağsiyan Köyü)",
      "Alan Mah (fındık Köyü)",
      "Alibey Köyü",
      "Araplı Mah (avlağı Köyü)",
      "Aşağısaltuk Mah (sarıalan Köyü)",
      "Aşağızeytin Köyü",
      "Ayvalık Mah (baltacımehmetpaşa Köyü)",
      "Ballıpınar Mah (fındık Köyü)",
      "Batak Mah (tepeyolaltı Köyü)",
      "Bekirçavuş Mah (baltacımehmetpaşa Köyü)",
      "Belkavak Köyü",
      "Çaldibi Mah (sarıalan Köyü)",
      "Çatak Köyü",
      "Çaylı Mah (kamil Köyü)",
      "Çeneler Mah (ardıç Köyü)",
      "Çerçili Mah (konaca Köyü)",
      "Danişment Köyü",
      "Deller Köyü",
      "Dilimhisar Mah (yağsiyan Köyü)",
      "Doğan Köyü",
      "Durucasu Köyü",
      "Elmacık Mah (kuz Köyü)",
      "Elmalı Mah (seki Köyü)",
      "Esenli Mah (aşıkbükü Köyü)",
      "Eski Köy Mah (ovacıksuyu Köyü)",
      "Eskiköy Mah (çampınar Köyü)",
      "Evlik Köyü",
      "Fındıcak Köyü",
      "Fındıklı Mah (yukarızeytin Köyü)",
      "Germeç Mah (öbektaş Köyü)",
      "Girinoğlan Köyü",
      "Göcük Yaylası Mah (kuz Köyü)",
      "Göcükbaşı Mah (baltacımehmetpaşa Köyü)",
      "Gökçeli Mah (hanefi Köyü)",
      "Göletcik Yaylası Mah (kuz Köyü)",
      "Güneşören Köyü",
      "Güney Mah (baltacımehmetpaşa Köyü)",
      "Güney Mah (karalargüney Köyü)",
      "Güvercinlik Köyü",
      "Hacı Hasan Mah (akören Köyü)",
      "Haliller Mah (yağsiyan Köyü)",
      "Hamitler Mah (yağsiyan Köyü)",
      "Hasançavuşlar Mah (yağsiyan Köyü)",
      "Havdan Mah (yağsiyan Köyü)",
      "Hayrat Mah (baltacımehmetpaşa Köyü)",
      "İğdeyiçal Mah (gökdere Köyü)",
      "İnal Köyü",
      "İncesu Köyü",
      "İsaklı Mah (aşıkbükü Köyü)",
      "Kabala Mah (ovacıksuyu Köyü)",
      "Kalinse Mah (baldıran Köyü)",
      "Karacakaya 1 Mah (karalargüney Köyü)",
      "Karacakaya Mah (karalargüney Köyü)",
      "Karaçay Köyü",
      "Karaköy Köyü",
      "Karataş Mah (tekmen Köyü)",
      "Kargı Köyü",
      "Karşı Mah (tepeyolaltı Köyü)",
      "Kavacık Mah (aşağızeytin Köyü)",
      "Kayalıdere Mah (yağsiyan Köyü)",
      "Kepçeli Mah (fındık Köyü)",
      "Kınalıtaş Mah (yenidanişment Köyü)",
      "Kıyıköy Mah (konaca Köyü)",
      "Kızılkaya Mah (gökdere Köyü)",
      "Kızıltepe Köyü",
      "Kumbaba Köyü",
      "Kumbel Mah (baldıran Köyü)",
      "Kuz Mah (baltacımehmetpaşa Köyü)",
      "Kuzhayat Köyü",
      "Merkez Mah (akören Köyü)",
      "Merkez Mah (ardıç Köyü)",
      "Merkez Mah (aşıkbükü Köyü)",
      "Merkez Mah (avlağı Köyü)",
      "Merkez Mah (aydın Köyü)",
      "Merkez Mah (baldıran Köyü)",
      "Merkez Mah (çampınar Köyü)",
      "Merkez Mah (çayır Köyü)",
      "Merkez Mah (fındık Köyü)",
      "Merkez Mah (gökdere Köyü)",
      "Merkez Mah (hanefi Köyü)",
      "Merkez Mah (kamil Köyü)",
      "Merkez Mah (konaca Köyü)",
      "Merkez Mah (kuz Köyü)",
      "Merkez Mah (ovacıksuyu Köyü)",
      "Merkez Mah (öbektaş Köyü)",
      "Merkez Mah (sarıalan Köyü)",
      "Merkez Mah (sarpunkavak Köyü)",
      "Merkez Mah (seki Köyü)",
      "Merkez Mah (tekmen Köyü)",
      "Merkez Mah (tepeyolaltı Köyü)",
      "Merkez Mah (yenidanişment Köyü)",
      "Merkez Mah (yukarızeytin Köyü)",
      "Mezra Mah (avlağı Köyü)",
      "Pamukoğlu Mah (gökdere Köyü)",
      "Pelitçik Köyü",
      "Pelitpınarı Mah (çampınar Köyü)",
      "Poydorlı Mah (konaca Köyü)",
      "Saltık Mah (tekmen Köyü)",
      "Saralle Mah (baldıran Köyü)",
      "Sarıyar Mah (baltacımehmetpaşa Köyü)",
      "Sarıyar Mah (ovacıksuyu Köyü)",
      "Sarpun Mah (sarpunkavak Köyü)",
      "Savaştepe Mah (konaca Köyü)",
      "Seki Mah (aydın Köyü)",
      "Sekibağı Köyü",
      "Seyitgazi Mah (başpınar Köyü)",
      "Soruk Mah (yenidanişment Köyü)",
      "Söğütlü Bahçe Mah (sarıalan Köyü)",
      "Süleymandemir Mah (yağsiyan Köyü)",
      "Sütlüce Köyü",
      "Tekmen Bağları Mah (tekmen Köyü)",
      "Ulucamii Mah (başpınar Köyü)",
      "Umaç Köyü",
      "Yanalak Mah (yukarızeytin Köyü)",
      "Yanankışla Mah (baltacımehmetpaşa Köyü)",
      "Yanankışla Mah (yağsiyan Köyü)",
      "Yayla Evleri Mah (akören Köyü)",
      "Yayla Mah (tepeyolaltı Köyü)",
      "Yaylabaşı Köyü",
      "Yedioluk Mah (yağsiyan Köyü)",
      "Yeni Mah (baltacımehmetpaşa Köyü)",
      "Yenicamii Mah (başpınar Köyü)",
      "Yer Alçağı Mah (konaca Köyü)",
      "Yeşildere Mah (başpınar Köyü)",
      "Yeşiltepe Mah (çayır Köyü)",
      "Yıldız Mah (konaca Köyü)",
      "Yoldere Mah (ovacıksuyu Köyü)",
      "Yürük Mah (tepeyolaltı Köyü)",
      "Zeyneller Mah (sarıalan Köyü)",
      "Cumhuriyet Mah",
      "Çay Mah",
      "Çiftlikler Mah",
      "Esentepe Mah",
      "Eymir Mah",
      "Gemici Mah",
      "Güney Mah",
      "Gürleyik Mah",
      "Hıdırlık Mah",
      "Karapınar Mah",
      "Kızılırmak Mah",
      "Koyunbaba Mah",
      "Şenyurt Mah",
      "Temençe Mah",
      "Ulucamii Mah",
      "Yazı Mah",
      "Yeni Mah",
      "Yeşilçatma Mah"
    ],
    "Sungurlu": [
      "Akçakoyunlu Köyü",
      "Akçalı Köyü",
      "Akdere Köyü",
      "Akpınar Köyü",
      "Alembeyli Köyü",
      "Arabaçayı Köyü",
      "Arıcı Köyü",
      "Asayiş Köyü",
      "Aşağıbalkaya Mah (balkaya Köyü)",
      "Aşağıbeşpınar Köyü",
      "Aşağıfındıklı Köyü",
      "Ata Mah (arifegazili Köyü)",
      "Ayağıbüyük Köyü",
      "Aydın Mah (kaledere Köyü)",
      "Aydoğan Köyü",
      "Bağcılı Köyü",
      "Bağdatlı Köyü",
      "Bahçelievler Mah (tuğlu Köyü)",
      "Bahşılı Köyü",
      "Beşdam Köyü",
      "Beşkız Köyü",
      "Beylice Köyü",
      "Beyyurdu Köyü",
      "Boztepe Köyü",
      "Bozyayla Köyü",
      "Bunalan Köyü",
      "Büyükincesu Köyü",
      "Büyükpolatlı Köyü",
      "Cevheri Mah",
      "Çadırhüyük Köyü",
      "Çamoluk Köyü",
      "Çavuşçu Köyü",
      "Çavuşköy Köyü",
      "Çayan Köyü",
      "Çayırova Mah (eşme Köyü)",
      "Çayyaka Köyü",
      "Çiçekli Köyü",
      "Çiçeklikeller Köyü",
      "Çiftlikköy Köyü",
      "Çingiller Köyü",
      "Çukurlu Köyü",
      "Çulhalı Köyü",
      "Dayıncık Köyü",
      "Denizli Köyü",
      "Derekışla Köyü",
      "Dertli Köyü",
      "Ekmekçi Köyü",
      "Ergülübaba Mah (yörüklü Köyü)",
      "Eşme Köyü",
      "Fatih Mah (demirşeyh Köyü)",
      "Gafurlu Köyü",
      "Gazi Mah (arifegazili Köyü)",
      "Gökçam Köyü",
      "Gökçeköy Köyü",
      "Göller Köyü",
      "Gülderesi Köyü",
      "Güloluk Köyü",
      "Güvendik Köyü",
      "Hacıosman Köyü",
      "Hilallı Köyü",
      "İkizli Köyü",
      "İmirli Köyü",
      "İnegazili Köyü",
      "Kalenderoğlu Köyü",
      "Kamışlı Köyü",
      "Karacabey Köyü",
      "Karaçay Köyü",
      "Karakaya Köyü",
      "Karakocalı Köyü",
      "Karaoğlu Köyü",
      "Karşıyaka Mah (tuğlu Köyü)",
      "Kavşut Köyü",
      "Kemalli Köyü",
      "Kertme Köyü",
      "Kırankışla Köyü",
      "Kışlaköy Köyü",
      "Kızılcakışla Köyü",
      "Körkü Köyü",
      "Kula Köyü",
      "Kurbağlı Köyü",
      "Kuşçalı Köyü",
      "Kuzucak Köyü",
      "Küçükincesu Köyü",
      "Küçükpolatlı Köyü",
      "Kültür Mah (demirşeyh Köyü)",
      "Mahmatlı Köyü",
      "Mehmetaliçiftliği Köyü",
      "Mehmetbeyli Köyü",
      "Merkez Mah (balkaya Köyü)",
      "Muratkolu Köyü",
      "Oğlaközü Köyü",
      "Organize Sanayi Bölgesi Mah (yorgalı Köyü)",
      "Ortakışla Köyü",
      "Ortaköy Köyü",
      "Oyaca Köyü",
      "Paşa Mah (demirşeyh Köyü)",
      "Salmanköy Köyü",
      "Saraycık Köyü",
      "Sarıcalar Köyü",
      "Sarıkaya Köyü",
      "Şahlı Mah (arifegazili Köyü)",
      "Şekerhacılı Köyü",
      "Şen Mah (kaledere Köyü)",
      "Tatlı Köyü",
      "Terzili Köyü",
      "Tirkeş Köyü",
      "Tokullu Köyü",
      "Topuz Köyü",
      "Tuğcu Köyü",
      "Turgutlu Köyü",
      "Türkhacılarhanı Köyü",
      "Üçoluk Köyü",
      "Yarımsöğüt Köyü",
      "Yavuz Sultan Selim Mah (yörüklü Köyü)",
      "Yeni Mah (arifegazili Köyü)",
      "Yeni Mah (tuğlu Köyü)",
      "Yenihacılarhanı Köyü",
      "Yeşilova Köyü",
      "Yeşilyurt Köyü",
      "Yirce Köyü",
      "Yorgalı Köyü",
      "Yukarıbeşpınar Köyü",
      "Zafer Mah (kaledere Köyü)",
      "Akçakent Mah",
      "Akçay Mah",
      "Bahçelievler Mah",
      "Başpınar Mah",
      "Fatih Mah",
      "Fevzi Paşa Mah",
      "Gürpınar Mah",
      "Hacettepe Mah",
      "İsmetpaşa Mah",
      "Örnekevler Mah",
      "Sunguroğlu Mah",
      "Şekerpınar Mah",
      "Turan Mah",
      "Yenidoğan Mah",
      "Yenihayat Mah"
    ],
    "Uğurludağ": [
      "Anbarcı Köyü",
      "Aşılıarmut Köyü",
      "Belkavak Köyü",
      "Boztepe Köyü",
      "Büyükerikli Köyü",
      "Dağönü Köyü",
      "Eskiçeltek Köyü",
      "Gökçeağaç Köyü",
      "Karaevliya Köyü",
      "Karakısık Köyü",
      "Kırköy Köyü",
      "Kızağlı Köyü",
      "Köpeç Köyü",
      "Küçükerikli Köyü",
      "Resuloğlu Köyü",
      "Sazköy Köyü",
      "Torunlar Köyü",
      "Üçdam Köyü",
      "Yarımca Köyü",
      "Yeniyapan Köyü",
      "Karşıyaka Mah",
      "Tutpınar Mah",
      "Yenicamii Mah",
      "Yeşilyurt Mah",
      "Yüzgeç Mah"
    ]
  },
  "Denizli": {
    "Acıpayam": [
      "Akalan Mah",
      "Akşar Mah",
      "Alaattin Mah",
      "Alcı Mah",
      "Aliveren Mah",
      "Apa Mah",
      "Aşağı Mah",
      "Avşar Mah",
      "Bademli Mah",
      "Bedirbey Mah",
      "Benlik Mah",
      "Boğazdere Mah",
      "Corum Mah",
      "Çakır Mah",
      "Çamlık Mah",
      "Çiftlik Mah",
      "Çubukçular Mah",
      "Darıveren Mah",
      "Dedebağı Mah",
      "Dodurga Mah",
      "Eskiköy Mah",
      "Gedikli Mah",
      "Gölcük Mah",
      "Gümüş Mah",
      "Güney Mah",
      "Hacıkurtlar Mah",
      "Hisar Mah",
      "Karahüyük Mah",
      "Karaismailler Mah",
      "Kelekçi Mah",
      "Kırca Mah",
      "Köke Mah",
      "Kumafşarı Mah",
      "Kurtlar Mah",
      "Kuyucak Mah",
      "Kuzören Mah",
      "Mevlütler Mah",
      "Oğuz Mah",
      "Olukbaşı Mah",
      "Ovayurt Mah",
      "Ören Mah",
      "Pınarbaşı Mah",
      "Pınaryazı Mah",
      "Sandalcık Mah",
      "Sırçalık Mah",
      "Suçatı Mah",
      "Ucarı Mah",
      "Yassıhüyük Mah",
      "Yazır Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşildere Mah",
      "Yeşilyuva Mah",
      "Yolçatı Mah",
      "Yukarı Mah",
      "Yumrutaş Mah"
    ],
    "Babadağ": [
      "Ahıllı Mah",
      "Bekirler Mah",
      "Cumhuriyet Mah",
      "Demirli Mah",
      "Gazi Mah",
      "Gündoğdu Mah",
      "İncilipınar Mah",
      "Kelleci Mah",
      "Kıranyer Mah",
      "Mollaahmet Mah",
      "Oğuzlar Mah",
      "Yeniköy Mah"
    ],
    "Baklan": [
      "Balca Mah",
      "Beyelli Mah",
      "Boğaziçi Mah",
      "Çataloba Mah",
      "Dağal Mah",
      "Gökpınar Mah",
      "Gürlük Mah",
      "Hadim Mah",
      "Hüsamettin Dede Mah",
      "İcikli Mah",
      "Kavaklar Mah",
      "Kirazlı Mah",
      "Konak Mah",
      "Şenyayla Mah"
    ],
    "Bekilli": [
      "Bahçeli Mah",
      "Bükrüce Mah",
      "Çamköy Mah",
      "Çoğaşlı Mah",
      "Deşdemir Mah",
      "Ekizbaba Mah",
      "Gömce Mah",
      "Köselli Mah",
      "Kutlubey Mah",
      "Poyrazlı Mah",
      "Sırıklı Mah",
      "Üçkuyu Mah",
      "Yahyalar Mah",
      "Yeni Mah",
      "Yeşiloba Mah"
    ],
    "Beyağaç": [
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Eşenler Mah",
      "Fatih Mah",
      "Geriçam Mah",
      "Hürriyet Mah",
      "Kapuz Mah",
      "Kızılcaağaç Mah",
      "Pınarönü Mah",
      "Sazak Mah",
      "Subaşı Mah",
      "Uzunoluk Mah",
      "Yeni Mah",
      "Yeniçeşme Mah",
      "Zafer Mah"
    ],
    "Bozkurt": [
      "Alikurt Mah",
      "Armutalanı Mah",
      "Avdan Mah",
      "Baklankuyucak Mah",
      "Barbaros Mah",
      "Başçeşme Mah",
      "Cumalı Mah",
      "Çambaşı Mah",
      "Fatih Mah",
      "Hamdiye Mah",
      "Hayrettinköy Mah",
      "İnceler Mah",
      "İncelertekkesi Mah",
      "Mahmudiye Mah",
      "Mecidiye Mah",
      "Mehmetçik Mah",
      "Mimar Sinan Mah",
      "Sazköy Mah",
      "Tutluca Mah",
      "Yenibağlar Mah"
    ],
    "Buldan": [
      "Aktaş Mah",
      "Alacaoğlu Mah",
      "Alandız Mah",
      "Beyler Mah",
      "Boğazçiftlik Mah",
      "Bostanyeri Mah",
      "Bozalan Mah",
      "Bölmekaya Mah",
      "Bursa Mah",
      "Cumhuriyet Mah",
      "Çamköy Mah",
      "Çarşı Mah",
      "Çatak Mah",
      "Çaybaşı Mah",
      "Derbent Mah",
      "Dımbazlar Mah",
      "Doğan Mah",
      "Dört Eylül Mah",
      "Düzalan Mah",
      "Girne Mah",
      "Gölbaşı Mah",
      "Gülalan Mah",
      "Güroluk Mah",
      "Hasanbeyler Mah",
      "Helvacılar Mah",
      "Kadıköy Mah",
      "Karaköy Mah",
      "Karşıyaka Mah",
      "Kaşıkcı Mah",
      "Kırandamı Mah",
      "Kovanoluk Mah",
      "Kurtuluş Mah",
      "Kurudere Mah",
      "Mahmutlu Mah",
      "Oğuz Mah",
      "Sarımahmutlu Mah",
      "Süleymanlı Mah",
      "Turan Mah",
      "Türlübey Mah",
      "Yalçınkaya Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yenicekent Mah",
      "Yeniçam Mah",
      "Yeşil Dere Mah"
    ],
    "Çal": [
      "Akkent Mah",
      "Alfaklar Mah",
      "Aşağıseyit Mah",
      "Bahadınlar Mah",
      "Baklançakırlar Mah",
      "Bayıralan Mah",
      "Belevi Mah",
      "Çalçakırlar Mah",
      "Çalkuyucak Mah",
      "Dağmarmara Mah",
      "Dayılar Mah",
      "Denizler Mah",
      "Develler Mah",
      "Gelinören Mah",
      "Hançalar Mah",
      "Hüseyinler Mah",
      "İsabey Mah",
      "İsmailler Mah",
      "Kabalar Mah",
      "Kaplanlar Mah",
      "Karakaya Mah",
      "Karapınar Mah",
      "Kocaköy Mah",
      "Mahmutgazi Mah",
      "Ortaköy Mah",
      "Peynirciler Mah",
      "Sakızcılar Mah",
      "Sazak Mah",
      "Selcen Mah",
      "Süller Mah",
      "Şapcılar Mah",
      "Yazır Mah",
      "Yeşilyurt Mah",
      "Yukarıseyit Mah"
    ],
    "Çameli": [
      "Akpınar Mah",
      "Arıkaya Mah",
      "Ayvacık Mah",
      "Belevi Mah",
      "Bıçakçı Mah",
      "Cevizli Mah",
      "Cumaalanı Mah",
      "Çamlıbel Mah",
      "Çiğdemli Mah",
      "Elmalı Mah",
      "Emecik Mah",
      "Ericek Mah",
      "Gökçeyaka Mah",
      "Gürsu Mah",
      "Güzelyurt Mah",
      "İmamlar Mah",
      "Kalınkoz Mah",
      "Karabayır Mah",
      "Kınıkyeri Mah",
      "Kızılyaka Mah",
      "Kirazlıyayla Mah",
      "Kocaova Mah",
      "Kolak Mah",
      "Sarıkavak Mah",
      "Sofular Mah",
      "Taşçılar Mah",
      "Yaylapınar Mah",
      "Yeni Mah",
      "Yeşilyayla Mah",
      "Yumrutaş Mah",
      "Yunuspınarı Mah"
    ],
    "Çardak": [
      "Ayvaz Mah",
      "Bahçelievler Mah",
      "Beylerli Mah",
      "Cumhuriyet Mah",
      "Cumhuriyet Sb Mah",
      "Çaltı Mah",
      "Çınar Mah",
      "Denizli Çardak Osb Mah",
      "Gemişli Mah",
      "Gemişpınarı Mah",
      "Gölcük Mah",
      "Hayriye Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Saray Mah",
      "Söğütlü Mah",
      "Söğütözü Mah"
    ],
    "Çivril": [
      "Akçaköy Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Aşağı Mah",
      "Balçıkhisar Mah",
      "Bayat Mah",
      "Bekirli Mah",
      "Belence Mah",
      "Beydilli Mah",
      "Beyköy Mah",
      "Bozdağ Mah",
      "Bucak Mah",
      "Bulgurlar Mah",
      "Cabar Mah",
      "Cumalar Mah",
      "Çağlayan Mah",
      "Çakallar Mah",
      "Çandır Mah",
      "Çapak Mah",
      "Çarşı Mah",
      "Çatlar Mah",
      "Çayır Mah",
      "Çetinler Mah",
      "Çıtak Mah",
      "Düzbel Mah",
      "Emircik Mah",
      "Gökgöl Mah",
      "Gümüşsu Mah",
      "Gürpınar Mah",
      "Hamam Mah",
      "Haydan Mah",
      "Irgıllı Mah",
      "Işıklı Mah",
      "İğdir Mah",
      "İmrallı Mah",
      "İnceköy Mah",
      "İshaklı Mah",
      "Karabedirler Mah",
      "Karahacılı Mah",
      "Karalar Mah",
      "Karamanlı Mah",
      "Karayahşiler Mah",
      "Kavakalanı Mah",
      "Kavakköy Mah",
      "Kıralan Mah",
      "Kızılcasöğüt Mah",
      "Kızılcayer Mah",
      "Kocayaka Mah",
      "Koçak Mah",
      "Menteş Mah",
      "Osmanköy Mah",
      "Ömerli Mah",
      "Özdemirci Mah",
      "Reşadiye Mah",
      "Saray Mah",
      "Sarıbeyli Mah",
      "Sarılar Mah",
      "Savran Mah",
      "Seraserli Mah",
      "Somak Mah",
      "Sökmen Mah",
      "Stadyum Mah",
      "Sundurlu Mah",
      "Süngüllü Mah",
      "Şehitler Mah",
      "Şenköy Mah",
      "Tekke Mah",
      "Tokça Mah",
      "Tuğlu Mah",
      "Yahyalı Mah",
      "Yakacık Mah",
      "Yalınlı Mah",
      "Yamanlar Mah",
      "Yassıhüyük Mah",
      "Yukarı Çapak Mah",
      "Yukarı Mah",
      "Yuvaköy Mah"
    ],
    "Güney": [
      "Adıgüzeller Mah",
      "Aşağıçeşme Mah",
      "Aydoğdu Mah",
      "Cindere Mah",
      "Çamrak Mah",
      "Çorbacılar Mah",
      "Doğanlı Mah",
      "Ertuğrul Mah",
      "Eziler Mah",
      "Fatih Mah",
      "Hamidiye Mah",
      "Haylamaz Mah",
      "Karaağaçlı Mah",
      "Karagözler Mah",
      "Kerimler Mah",
      "Koparan Mah",
      "Orta Mah",
      "Ortaçeşme Mah",
      "Parmaksızlar Mah",
      "Tilkilik Mah",
      "Üç Eylül Mah",
      "Yağcılar Mah",
      "Yeni Mah",
      "Yenikonak Mah"
    ],
    "Honaz": [
      "Afşın Bey Mah",
      "Akbaş Mah",
      "Aşağıdağdere Mah",
      "Aydınlar Mah",
      "Cumhuriyet Mah",
      "Denizli Osb Mah",
      "Dereçiftlik Mah",
      "Emirazizli Mah",
      "Gürleyik Mah",
      "Haydar Mah",
      "Hisar Mah",
      "Hürriyet Mah",
      "Kaklık Mah",
      "Karaçay Mah",
      "Karateke Mah",
      "Kızılyer Mah",
      "Kocabaş Mah",
      "Menteşe Mah",
      "Ovacık Mah",
      "Sapaca Mah",
      "Yeni Mah",
      "Yokuşbaşı Mah",
      "Yukarıdağdere Mah"
    ],
    "Kale": [
      "Adamharmanı Mah",
      "Alanyurt Mah",
      "Belenköy Mah",
      "Cevherpaşa Mah",
      "Cumhuriyet Mah",
      "Çakırbağ Mah",
      "Çamlarca Mah",
      "Demirciler Mah",
      "Doğanköy Mah",
      "Esenkaya Mah",
      "Gökçeören Mah",
      "Gölbaşı Mah",
      "Gülbağlık Mah",
      "Habipler Mah",
      "Hürriyet Mah",
      "İnceğiz Mah",
      "Karaköy Mah",
      "Karayayla Mah",
      "Kayabaşı Mah",
      "Kırköy Mah",
      "Koçarboğazı Mah",
      "Köprübaşı Mah",
      "Künar Mah",
      "Muslugüme Mah",
      "Narlı Mah",
      "Ortaköy Mah",
      "Ortatepe Mah",
      "Özlüce Mah",
      "Toki Mah",
      "Uluçam Mah",
      "Yenidere Mah",
      "Yeniköy Mah"
    ],
    "Merkezefendi": [
      "Adalet Mah",
      "Bahçelievler Mah",
      "Barutçular Mah",
      "Bereketler Mah",
      "Gerzele Mah",
      "Hisar Mah",
      "Kadılar Mah",
      "Servergazi Mah",
      "Şirinköy Mah",
      "Yenişehir Mah",
      "Alpaslan Mah",
      "Gültepe Mah",
      "Gümüşçay Mah",
      "Kayalar Mah",
      "Mehmet Akif Ersoy Mah",
      "Selçuk Bey Mah",
      "Şemikler Mah",
      "Yeni Mah",
      "Yenişafak Mah",
      "Akkonak Mah",
      "Altıntop Mah",
      "Değirmenönü Mah",
      "İlbade Mah",
      "Karaman Mah",
      "Merkez Efendı Mah",
      "Muratdede Mah",
      "Saraylar Mah",
      "Sırakapılar Mah",
      "Akçeşme Mah",
      "Bozburun Mah",
      "Eskihisar Mah",
      "Kumkısık Mah",
      "Sevindik Mah",
      "Sümer Mah",
      "Zafer Mah",
      "1200 Evler Mah",
      "Altındere Mah",
      "Barbaros Mah",
      "Başkarcı Mah",
      "Çakmak Mah",
      "Göveçlik Mah",
      "Hacıeyüplü Mah",
      "Hallaçlar Mah",
      "Karahasanlı Mah",
      "Saruhan Mah",
      "Yeşilyayla Mah",
      "Aşağışamlı Mah",
      "Çeltikçi Mah",
      "Salihağa Mah",
      "Üzerlik Mah"
    ],
    "Pamukkale": [
      "Akköy Mah",
      "Karahayıt Mah",
      "Pamukkale Mah",
      "Yeniköy Mah",
      "Akçapınar Mah",
      "Akdere Mah",
      "Belenardıç Mah",
      "Çeşmebaşı Mah",
      "Develi Mah",
      "Eldenizli Mah",
      "Eymir Mah",
      "Goncalı Mah",
      "Gölemezli Mah",
      "Gözler Mah",
      "Güzelpınar Mah",
      "Haytabey Mah",
      "Irlıganlı Mah",
      "Karakova Mah",
      "Kavakbaşı Mah",
      "Kocadere Mah",
      "Kurtluca Mah",
      "Küçükdere Mah",
      "Uzunpınar Mah",
      "Yukarışamlı Mah",
      "15 Mayıs Mah",
      "Atalar Mah",
      "Fesleğen Mah",
      "Hacıkaplanlar Mah",
      "İncilipınar Mah",
      "İstiklal Mah",
      "Kuşpınar Mah",
      "Mehmetçik Mah",
      "Pelitlibağ Mah",
      "Topraklık Mah",
      "Akhan Mah",
      "Aktepe Mah",
      "Anafartalar Mah",
      "Deliktaş Mah",
      "Dokuzkavaklar Mah",
      "Fatih Mah",
      "Güzelköy Mah",
      "Kale Mah",
      "Karakurt Mah",
      "Karşıyaka Mah",
      "Korucuk Mah",
      "Pınarkent Mah",
      "Asmalıevler Mah",
      "Bağbaşı Mah",
      "Cankurtaran Mah",
      "Cumhuriyet Mah",
      "Gökpınar Mah",
      "Hürriyet Mah",
      "Karataş Mah",
      "Kayıhan Mah",
      "Kervansaray Mah",
      "Kınıklı Mah",
      "Siteler Mah",
      "Tekke Mah",
      "Yunusemre Mah",
      "Zeytinköy Mah",
      "Zümrüt Mah"
    ],
    "Sarayköy": [
      "Acıdere Mah",
      "Acısu Mah",
      "Ada Mah",
      "Ahmetli Mah",
      "Altıntepe Mah",
      "Aşağı Mah",
      "Atatürk Mah",
      "Bala Mah",
      "Beylerbeyi Mah",
      "Caber Mah",
      "Cumhuriyet Mah",
      "Duacılı Mah",
      "Gerali Mah",
      "Hasköy Mah",
      "Hisar Mah",
      "Kabaağaç Mah",
      "Karakıran Mah",
      "Karataş Mah",
      "Köprübaşı Mah",
      "Kumluca Mah",
      "Sakarya Mah",
      "Sarayköy Tdi Osb Mah",
      "Sazak Mah",
      "Sığma Mah",
      "Tekke Mah",
      "Tepeköy Mah",
      "Tırkaz Mah",
      "Tosunlar Mah",
      "Trafo Mah",
      "Turan Mah",
      "Uyanık Mah",
      "Yakayurt Mah",
      "Yeşilyurt Mah"
    ],
    "Serinhisar": [
      "Aşağı Mah",
      "Ayaz Mah",
      "Cumhuriyet Mah",
      "Kaya Mah",
      "Kocapınar Mah",
      "Orta Mah",
      "Pınarcık Mah",
      "Şair Eşref Mah",
      "Yatağan Mah",
      "Yenice Mah",
      "Yüreğil Mah"
    ],
    "Tavas": [
      "Akıncılar Mah",
      "Akyar Mah",
      "Alpa Mah",
      "Altınova Mah",
      "Avdan Mah",
      "Aydoğdu Mah",
      "Baharlar Mah",
      "Bahçeköy Mah",
      "Balkıca Mah",
      "Çağırgan Mah",
      "Çalıköy Mah",
      "Çiftlikköy Mah",
      "Damlacık Mah",
      "Denizoluğu Mah",
      "Dereağzı Mah",
      "Derinkuyu Mah",
      "Ebecik Mah",
      "Garipköy Mah",
      "Gökçeler Mah",
      "Gümüşdere Mah",
      "Güzelköy Mah",
      "Hırka Mah",
      "Horasanlı Mah",
      "Karahisar Mah",
      "Kayaca Mah",
      "Kayapınar Mah",
      "Keçeliler Mah",
      "Kızılca Mah",
      "Kızılcabölük Mah",
      "Kozlar Mah",
      "Medet Mah",
      "Nikfer Mah",
      "Orta Mah",
      "Ovacık Mah",
      "Pınarlar Mah",
      "Pınarlık Mah",
      "Samanlık Mah",
      "Sarabat Mah",
      "Seki Mah",
      "Sofular Mah",
      "Solmaz Mah",
      "Tekkeköy Mah",
      "Ulukent Mah",
      "Vakıf Mah",
      "Yahşiler Mah",
      "Yaka Mah",
      "Yeni Mah",
      "Yeşilköy Mah",
      "Yorga Mah",
      "Yukarıboğaz Mah"
    ]
  },
  "Diyarbakır": {
    "Bağlar": [
      "Ağaçgeçit Mah",
      "Alipınar Mah",
      "Bağcılar Mah",
      "Batıçanakçı Mah",
      "Batıkarakoç Mah",
      "Buçuktepe Mah",
      "Çiçekliyurt Mah",
      "Çiftlik Mah",
      "Develi Mah",
      "Gömmetaş Mah",
      "Kolludere Mah",
      "Körtepe Mah",
      "Özdemir Mah",
      "Pınaroğlu Mah",
      "Sarıdallı Mah",
      "Tavşantepe Mah",
      "Tellikaya Mah",
      "Tokluca Mah",
      "Topraktaş Mah",
      "Topyolu Mah",
      "Uzunbahçe Mah",
      "Yeşildallı Mah",
      "Yukarı Mollaali Mah",
      "5 Nisan Mah",
      "Alankoz Mah",
      "Buyuransu Mah",
      "Ekince Mah",
      "Fatih Mah",
      "Kabahıdır Mah",
      "Kamışpınar Mah",
      "Karacadağ Mah",
      "Karahanköy Mah",
      "Kaynartepe Mah",
      "Kırkıncık Mah",
      "Kırkkoyun Mah",
      "Körhat Mah",
      "Muradiye Mah",
      "Oğlaklı Mah",
      "Övündüler Mah",
      "Sakallı Mah",
      "Yiğityolu Mah",
      "Yukarıakdibek Mah",
      "Yunus Emre Mah",
      "Mevlana Halit Mah",
      "Ortaören Mah",
      "Selahattin Eyyubi Mah",
      "Şeyh Şamil Mah",
      "Yeniköy Mah"
    ],
    "Bismil": [
      "Ağılköy Mah",
      "Ağıllı Mah",
      "Ahmetli Mah",
      "Akbaş Mah",
      "Akçay Mah",
      "Akköy Mah",
      "Akpınar Mah",
      "Alıncak Mah",
      "Alibey Mah",
      "Altıok Mah",
      "Aluç Mah",
      "Ambar Mah",
      "Aralık Mah",
      "Arapkent Mah",
      "Arıkgöl Mah",
      "Aslanoğlu Mah",
      "Aşağıdolay Mah",
      "Aşağıoba Mah",
      "Ataköy Mah",
      "Aygeçti Mah",
      "Babahaki Mah",
      "Bademli Mah",
      "Baharlı Mah",
      "Bahçe Mah",
      "Balcılar Mah",
      "Başhan Mah",
      "Başköy Mah",
      "Başören Mah",
      "Belli Mah",
      "Boyacı Mah",
      "Bozçalı Mah",
      "Bölümlü Mah",
      "Çakallı Mah",
      "Çakıllı Mah",
      "Çatalköy Mah",
      "Çavuşlu Mah",
      "Çeltikli Mah",
      "Çorapa Mah",
      "Çölağan Mah",
      "Çöltepe Mah",
      "Derbent Mah",
      "Dicle Mah",
      "Doruk Mah",
      "Dumlupınar Mah",
      "Eliaçık Mah",
      "Erler Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Fırat Mah",
      "Gedikbaşı Mah",
      "Göksu Mah",
      "Güngeçti Mah",
      "Güroluk Mah",
      "Güzelköy Mah",
      "Harmanlı Mah",
      "Hasanpınar Mah",
      "Işıklar Mah",
      "İsalı Mah",
      "İsapınar Mah",
      "Kağıtlı Mah",
      "Kamberli Mah",
      "Kamışlı Mah",
      "Karabörk Mah",
      "Karacık Mah",
      "Karaçölya Mah",
      "Karagöz Mah",
      "Karapınar Mah",
      "Karatepe Mah",
      "Karayiğit Mah",
      "Kavuşak Mah",
      "Kayıköy Mah",
      "Kazancı Mah",
      "Keberli Mah",
      "Kılavuztepe Mah",
      "Koğuk Mah",
      "Kopmaz Mah",
      "Kopuzlu Mah",
      "Korukçu Mah",
      "Koyunlu Mah",
      "Köprüköy Mah",
      "Köseli Mah",
      "Kumrulu Mah",
      "Kurtuluş Mah",
      "Kurudeğirmen Mah",
      "Kurudere Mah",
      "Merdan Mah",
      "Meydanlık Mah",
      "Mirzabey Mah",
      "Obalı Mah",
      "Ofköy Mah",
      "Oğuzlar Mah",
      "Pınarbaşı Mah",
      "Sanayi Mah",
      "Sarıköy Mah",
      "Sarıtoprak Mah",
      "Sazlı Mah",
      "Seki Mah",
      "Serçeler Mah",
      "Seyit Hasan Mah",
      "Seyrantepe Mah",
      "Sinanköy Mah",
      "Şahintepe Mah",
      "Şentepe Mah",
      "Tatlıçayır Mah",
      "Tekel Mah",
      "Tepe Mah",
      "Tepecik Mah",
      "Tilkilik Mah",
      "Topraklı Mah",
      "Türkmenhacı Mah",
      "Uğrak Mah",
      "Uğurlu Mah",
      "Ulutürk Mah",
      "Uyanık Mah",
      "Üçtepe Mah",
      "Yağmurköy Mah",
      "Yamaçköy Mah",
      "Yasince Mah",
      "Yenice Mah",
      "Yukarıdolay Mah",
      "Yukarıharım Mah",
      "Yukarısalat Mah"
    ],
    "Çermik": [
      "Ağaçhan Mah",
      "Akçörten Mah",
      "Akkoyunlu Mah",
      "Akpınar Mah",
      "Alabuğday Mah",
      "Alakoç Mah",
      "Arabük Mah",
      "Armağantaşı Mah",
      "Armutlu Mah",
      "Artuk Mah",
      "Asmalı Mah",
      "Aşağışeyhler Mah",
      "Aşağıtaşmalı Mah",
      "Aynalı Mah",
      "Bademli Mah",
      "Bahçe Mah",
      "Balıksırtı Mah",
      "Başarı Mah",
      "Bayat Mah",
      "Bayırbağı Mah",
      "Baykal Mah",
      "Bayrak Mah",
      "Bintaş Mah",
      "Bircemal Mah",
      "Bulundu Mah",
      "Ceylan Mah",
      "Çalıtepe Mah",
      "Çukur Mah",
      "Çukurelma Mah",
      "Değirmenli Mah",
      "Dikyol Mah",
      "Dilekpınar Mah",
      "Elifuşağı Mah",
      "Eskibağ Mah",
      "Genceli Mah",
      "Göktepe Mah",
      "Gözerek Mah",
      "Güçlütaş Mah",
      "Günaşan Mah",
      "Gürüz Mah",
      "Güzel Mah",
      "Haburman Mah",
      "İkiçeltik Mah",
      "İncili Mah",
      "Kala Mah",
      "Kalaç Mah",
      "Kalecik Mah",
      "Karacaviran Mah",
      "Karakaya Mah",
      "Karamusa Mah",
      "Karataş Mah",
      "Kartaltaşı Mah",
      "Kayagediği Mah",
      "Keklik Mah",
      "Kırmatepe Mah",
      "Konaklı Mah",
      "Konuksever Mah",
      "Korudağ Mah",
      "Köksal Mah",
      "Kömürcüler Mah",
      "Kuşlukçayırı Mah",
      "Kuyu Mah",
      "Örenkuyu Mah",
      "Pamuklu Mah",
      "Petekkaya Mah",
      "Pınarlı Mah",
      "Recep Mah",
      "Saltepe Mah",
      "Saray Mah",
      "Sarıbalta Mah",
      "Sarıca Mah",
      "Sinek Mah",
      "Şeyhandede Mah",
      "Tepe Mah",
      "Toplu Mah",
      "Yabanardı Mah",
      "Yayıklı Mah",
      "Yaylacık Mah",
      "Yeşilova Mah",
      "Yiğitler Mah",
      "Yoğun Mah"
    ],
    "Çınar": [
      "Ağaçsever Mah",
      "Akçomak Mah",
      "Aktepe Mah",
      "Alabaş Mah",
      "Alancık Mah",
      "Altınakar Mah",
      "Arafat Mah",
      "Aşağı Mollaali Mah",
      "Aşağıkonak Mah",
      "Avdalı Mah",
      "Ayveri Mah",
      "Bağacık Mah",
      "Ballıbaba Mah",
      "Başaklı Mah",
      "Başalan Mah",
      "Bayırkonağı Mah",
      "Belenli Mah",
      "Bellitaş Mah",
      "Beneklitaş Mah",
      "Beşpınar Mah",
      "Bilmece Mah",
      "Bira Mehmet Ağa Mah",
      "Boğazören Mah",
      "Bozçalı Mah",
      "Bulutçeker Mah",
      "Cumhuriyet Mah",
      "Çakırkaya Mah",
      "Çakırtutmaz Mah",
      "Çataltarla Mah",
      "Çatmadal Mah",
      "Çeltikaltı Mah",
      "Çınarköy Mah",
      "Çömçeli Mah",
      "Çukurbaşı Mah",
      "Demirölçek Mah",
      "Dikmencik Mah",
      "Dişlibaşak Mah",
      "Düğrük Mah",
      "Düzova Mah",
      "Ekinveren Mah",
      "Eski Mah",
      "Fatih Mah",
      "Filizören Mah",
      "Gazi Mah",
      "Göktepe Mah",
      "Görece Mah",
      "Gümüştaş Mah",
      "Gürses Mah",
      "Halıören Mah",
      "Halkapınar Mah",
      "Harabe Mah",
      "Hasköy Mah",
      "Höyükdibi Mah",
      "İnanöz Mah",
      "İncirtepe Mah",
      "Karababa Mah",
      "Karabudak Mah",
      "Karaçevre Mah",
      "Karalar Mah",
      "Karasungur Mah",
      "Kazıktepe Mah",
      "Kılıçkaya Mah",
      "Kırkağaç Mah",
      "Köksalan Mah",
      "Kubacık Mah",
      "Kuruyazı Mah",
      "Kutluk Mah",
      "Kuyuluhöyük Mah",
      "Kürekli Mah",
      "Leblebitaş Mah",
      "Meydanköy Mah",
      "Muratcık Mah",
      "Ortaşar Mah",
      "Ovabağ Mah",
      "Öncülü Mah",
      "Özgider Mah",
      "Özyar Mah",
      "Pembeviran Mah",
      "Selyazı Mah",
      "Sevindik Mah",
      "Sırımkeser Mah",
      "Soğansuyu Mah",
      "Solmaz Mah",
      "Sürendal Mah",
      "Şekerören Mah",
      "Şeyhçoban Mah",
      "Şükürlü Mah",
      "Taşhelvası Mah",
      "Tekkaynak Mah",
      "Tilver Mah",
      "Toraman Mah",
      "Yaprakbaşı Mah",
      "Yarımkaş Mah",
      "Yazçiçeği Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Yeşilbağ Mah",
      "Yeşiltaş Mah",
      "Yıllarca Mah",
      "Yukarıortaören Mah",
      "Yuvacık Mah"
    ],
    "Çüngüş": [
      "Akbaşak Mah",
      "Aktaş Mah",
      "Albayrak Mah",
      "Arpadere Mah",
      "Atalar Mah",
      "Avut Mah",
      "Aydınlı Mah",
      "Balcılar Mah",
      "Camii Kebir Mah",
      "Camiisuk Mah",
      "Çataldut Mah",
      "Çaybaşı Mah",
      "Değirmensuyu Mah",
      "Deveboynu Mah",
      "Elmadere Mah",
      "Elyos Mah",
      "Geçitköy Mah",
      "Gökçepelit Mah",
      "Güneydere Mah",
      "Handere Mah",
      "Hindibaba Mah",
      "İbikkaya Mah",
      "Karakaya Mah",
      "Karşıyaka Mah",
      "Kaynakköy Mah",
      "Keleşevleri Mah",
      "Koçören Mah",
      "Norşin Mah",
      "Ormançayı Mah",
      "Oyuklu Mah",
      "Polatuşağı Mah",
      "Sağtepe Mah",
      "Seferuşağı Mah",
      "Türkmen Mah",
      "Üçpınar Mah",
      "Yaygınkonak Mah",
      "Yazyağmuru Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yukarışeyhler Mah"
    ],
    "Dicle": [
      "15 Temmuz Mah",
      "Acar Mah",
      "Altayköy Mah",
      "Arıköy Mah",
      "Bademli Mah",
      "Bağlarbaşı Mah",
      "Bahçedere Mah",
      "Bahçeköy Mah",
      "Baltacı Mah",
      "Başköy Mah",
      "Baturköy Mah",
      "Biçer Mah",
      "Boğaz Mah",
      "Boğazköy Mah",
      "Bozoba Mah",
      "Çavlı Mah",
      "Çelebi Mah",
      "Dedeköy Mah",
      "Değirmenli Mah",
      "Döğer Mah",
      "Durabeyli Mah",
      "Gelincik Mah",
      "Gölbaşı Mah",
      "Gündoğdu Mah",
      "Kaygısız Mah",
      "Kayıköy Mah",
      "Kelekçi Mah",
      "Kırklar Mah",
      "Kırkpınar Mah",
      "Kocaalan Mah",
      "Koruköy Mah",
      "Kurşunlu Mah",
      "Kurudere Mah",
      "Meydan Mah",
      "Pekmezciler Mah",
      "Pınar Mah",
      "Sergenli Mah",
      "Süsümlü Mah",
      "Taşağıl Mah",
      "Tepe Mah",
      "Tepebaşı Mah",
      "Uğrak Mah",
      "Ulubaş Mah",
      "Uluçeşme Mah",
      "Üzümlü Mah",
      "Yeşilsırt Mah",
      "Yeşiltepe Mah",
      "Yokuşlu Mah"
    ],
    "Eğil": [
      "Akalan Mah",
      "Babalar Mah",
      "Bahşilar Mah",
      "Balaban Mah",
      "Balım Mah",
      "Baysu Mah",
      "Dere Mah",
      "Döşemeler Mah",
      "Düzlük Mah",
      "Gündoğuran Mah",
      "Gürünlü Mah",
      "Ilgın Mah",
      "Kale Mah",
      "Kalecik Mah",
      "Kalkan Mah",
      "Kaya Mah",
      "Kazanlı Mah",
      "Kırkkuyu Mah",
      "Konak Mah",
      "Meşeler Mah",
      "Oyalı Mah",
      "Oyalı Osb Mah",
      "Sağlam Mah",
      "Sarıca Mah",
      "Sarmaşık Mah",
      "Selman Mah",
      "Taşdam Mah",
      "Tepecik Mah",
      "Yatır Mah",
      "Yenişehir Mah",
      "Yukarıhaydan Mah"
    ],
    "Ergani": [
      "Adnan Menderes Mah",
      "Ahmetli Mah",
      "Akçakale Mah",
      "Akçoban Mah",
      "Alitaşı Mah",
      "Armutova Mah",
      "Aşağıbitikçi Mah",
      "Aşağıkuyulu Mah",
      "Azıklı Mah",
      "Aziziye Mah",
      "Bademli Mah",
      "Bagür Mah",
      "Bahçekaşı Mah",
      "Bereketli Mah",
      "Boğazköy Mah",
      "Boncuklu Mah",
      "Bozyer Mah",
      "Caferan Mah",
      "Canveren Mah",
      "Coşkun Mah",
      "Cömert Mah",
      "Çakartaş Mah",
      "Çakırfakır Mah",
      "Çayırdere Mah",
      "Çayköy Mah",
      "Çimlihöyük Mah",
      "Çukurdere Mah",
      "Dağarası Mah",
      "Dallıdağ Mah",
      "Değirmendere Mah",
      "Demirli Mah",
      "Dereboyu Mah",
      "Deringöze Mah",
      "Develi Mah",
      "Devletkuşu Mah",
      "Dibektaş Mah",
      "Doğanköy Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Giraylar Mah",
      "Gökiçi Mah",
      "Gözekaya Mah",
      "Gözlü Mah",
      "Gülerce Mah",
      "Güneştepe Mah",
      "Güzelyurt Mah",
      "Hançerli Mah",
      "Hendekköy Mah",
      "Hilar Mah",
      "İncehıdır Mah",
      "İstasyon Mah",
      "Karaburçak Mah",
      "Karpuzlu Mah",
      "Karşıbağlar Mah",
      "Kavaklı Mah",
      "Kavurmaküpü Mah",
      "Kayan Mah",
      "Kemaliye Mah",
      "Kemertaş Mah",
      "Kesentaş Mah",
      "Kıralan Mah",
      "Kocaali Mah",
      "Kortaş Mah",
      "Koyunalan Mah",
      "Kömürtaş Mah",
      "Kumçi Mah",
      "Morkoyun Mah",
      "Namık Kemal Mah",
      "Olgun Mah",
      "Ortaağaç Mah",
      "Ortayazı Mah",
      "Otluca Mah",
      "Özbilek Mah",
      "Pınarkaya Mah",
      "Sabırlı Mah",
      "Salihli Mah",
      "Sallar Mah",
      "Sallıca Mah",
      "Sanayi Mah",
      "Saray Mah",
      "Savaş Mah",
      "Selmanköy Mah",
      "Sökündüzü Mah",
      "Şirinevler Mah",
      "Şölen Mah",
      "Tevekli Mah",
      "Usluca Mah",
      "Üçkardeş Mah",
      "Üzümlü Mah",
      "Yakacık Mah",
      "Yamaçlar Mah",
      "Yapraklı Mah",
      "Yayvantepe Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yolbulan Mah",
      "Yolköprü Mah",
      "Yoncalı Mah",
      "Yukarıbitikçi Mah",
      "Yukarıkarpuzlu Mah",
      "Yukarıkuyulu Mah",
      "Ziyaret Mah"
    ],
    "Hani": [
      "Abacılar Mah",
      "Akçayurt Mah",
      "Anıl Mah",
      "Belen Mah",
      "Çardaklı Mah",
      "Çarşı Mah",
      "Çukurköy Mah",
      "Dereli Mah",
      "Gömeç Mah",
      "Gürbüz Mah",
      "Kalaba Mah",
      "Kaledibi Mah",
      "Kırım Mah",
      "Kuyular Mah",
      "Merkez Mah",
      "Okurköy Mah",
      "Serenköy Mah",
      "Sergen Mah",
      "Soylu Mah",
      "Süslü Mah",
      "Topçular Mah",
      "Uzunlar Mah",
      "Veziri Mah",
      "Yayvan Mah",
      "Yukarıturalı Mah",
      "Zirve Mah"
    ],
    "Hazro": [
      "Ağartı Mah",
      "Bağyurdu Mah",
      "Bahçe Mah",
      "Bayırdüzü Mah",
      "Cami Mah",
      "Çitlibahçe Mah",
      "Çökeksu Mah",
      "Dadaş Mah",
      "Elhuvan Mah",
      "Gedikalan Mah",
      "Gözlü Mah",
      "Hürriyet Mah",
      "İncekavak Mah",
      "İşkar Mah",
      "Kavaklıboğaz Mah",
      "Kırkkaşık Mah",
      "Kırmataş Mah",
      "Koçbaba Mah",
      "Kulaçtepe Mah",
      "Meşebağları Mah",
      "Mutluca Mah",
      "Ormankaya Mah",
      "Reşik Mah",
      "Sarıçanak Mah",
      "Sarıerik Mah",
      "Terdöken Mah",
      "Topalan Mah",
      "Uzunargıt Mah",
      "Ülgen Mah",
      "Varınca Mah",
      "Yazgı Mah"
    ],
    "Kayapınar": [
      "Avcısuyu Mah",
      "Barış Mah",
      "Baykara Mah",
      "Beneklitaş Mah",
      "Cankatran Mah",
      "Cumhuriyet Mah",
      "Cücük Mah",
      "Çölgüzeli Mah",
      "Diclekent Mah",
      "Esentepe Mah",
      "Fırat Mah",
      "Gözalan Mah",
      "Gözegöl Mah",
      "Güleçoba Mah",
      "Harmanardı Mah",
      "Hatipoğlu Mah",
      "Huzurevleri Mah",
      "Kaldırım Mah",
      "Karayakup Mah",
      "Keklik Mah",
      "Kırkpınar Mah",
      "Medya Mah",
      "Mezopotamya Mah",
      "Petek Mah",
      "Peyas Mah",
      "Sağkulak Mah",
      "Sultantepe Mah",
      "Taban Mah",
      "Talaytepe Mah",
      "Tişo Mah",
      "Tosunlu Mah",
      "Uyandık Mah",
      "Yeniözerli Mah",
      "Yolboyu Pirinçlik Mah"
    ],
    "Kocaköy": [
      "Ambar Mah",
      "Arkbaşı Mah",
      "Boyunlu Mah",
      "Bozbağlar Mah",
      "Bozyer Mah",
      "Çakmaklı Mah",
      "Çayırlı Mah",
      "Çaytepe Mah",
      "Eyüpler Mah",
      "Gökçen Mah",
      "Gözebaşı Mah",
      "Günalan Mah",
      "Hacı Reşit Mah",
      "Kaya Mah",
      "Kokulupınar Mah",
      "Suçıktı Mah",
      "Şaklat Mah",
      "Şerifoğulları Mah",
      "Şeyh Şerafettin Mah",
      "Tepecik Mah",
      "Yazıköy Mah",
      "Yenişehir Mah"
    ],
    "Kulp": [
      "Ağaçkorur Mah",
      "Ağaçlı Mah",
      "Ağıllı Mah",
      "Akbulak Mah",
      "Akçesir Mah",
      "Akdoruk Mah",
      "Alaca Mah",
      "Argün Mah",
      "Aygün Mah",
      "Ayhan Mah",
      "Bağcılar Mah",
      "Baloğlu Mah",
      "Barın Mah",
      "Başbuğ Mah",
      "Bayır Mah",
      "Çağlayan Mah",
      "Çukurca Mah",
      "Demirli Mah",
      "Dolun Mah",
      "Düzce Mah",
      "Elmalı Mah",
      "Güleç Mah",
      "Güllük Mah",
      "Hamzalı Mah",
      "İnkaya Mah",
      "İslamköy Mah",
      "Kamışlı Mah",
      "Karaağaç Mah",
      "Karabulak Mah",
      "Karaorman Mah",
      "Karpuzlu Mah",
      "Kayacık Mah",
      "Kayahan Mah",
      "Kaynak Mah",
      "Koçkar Mah",
      "Konuklu Mah",
      "Kurudere Mah",
      "Merkez Eski Mah",
      "Merkez Yeni Mah",
      "Narlıca Mah",
      "Özbek Mah",
      "Salkımlı Mah",
      "Saltuk Mah",
      "Taşköprü Mah",
      "Temran Mah",
      "Tepecik Mah",
      "Turgut Özal Mah",
      "Tuzla Mah",
      "Uygur Mah",
      "Uzunova Mah",
      "Üçkuyu Mah",
      "Ünal Mah",
      "Yakıt Mah",
      "Yayık Mah",
      "Yaylak Mah",
      "Yeşilköy Mah",
      "Yuvacık Mah",
      "Zeyrek Mah"
    ],
    "Lice": [
      "Abalı Mah",
      "Akçabudak Mah",
      "Arıklı Mah",
      "Bağlan Mah",
      "Baharlar Mah",
      "Bayırlı Mah",
      "Birlik Mah",
      "Budak Mah",
      "Camikebir Mah",
      "Çağdaş Mah",
      "Çarşı Mah",
      "Çavundur Mah",
      "Çeper Mah",
      "Çıralı Mah",
      "Dallıca Mah",
      "Damar Mah",
      "Daralan Mah",
      "Delvan Mah",
      "Dernek Mah",
      "Dibek Mah",
      "Dolunay Mah",
      "Duru Mah",
      "Ecemiş Mah",
      "Ergin Mah",
      "Esenler Mah",
      "Gökçe Mah",
      "Güçlü Mah",
      "Güldiken Mah",
      "Gürbeyli Mah",
      "Hedik Mah",
      "Kabakaya Mah",
      "Kali Mah",
      "Karahasan Mah",
      "Kelvan Mah",
      "Kılıçlı Mah",
      "Kıpçak Mah",
      "Kıralan Mah",
      "Kıyı Mah",
      "Körtük Mah",
      "Kumluca Mah",
      "Kutlu Mah",
      "Mulla Mah",
      "Muradiye Mah",
      "Müminağa Mah",
      "Ortaç Mah",
      "Oyuklu Mah",
      "Örtülü Mah",
      "Savat Mah",
      "Saydamlı Mah",
      "Serin Mah",
      "Sığınak Mah",
      "Şaar Mah",
      "Şenlik Mah",
      "Tepe Mah",
      "Tuzla Mah",
      "Türeli Mah",
      "Uçarlı Mah",
      "Ulucak Mah",
      "Üçdamlar Mah",
      "Yalaza Mah",
      "Yalımlı Mah",
      "Yamaçlı Mah",
      "Yaprak Mah",
      "Yenişehir Mah",
      "Yeşilburç Mah",
      "Yolçatı Mah",
      "Yorulmaz Mah",
      "Yünlüce Mah",
      "Ziyaret Mah",
      "Zümrüt Mah"
    ],
    "Silvan": [
      "Akçayır Mah",
      "Akçeltik Mah",
      "Akdere Mah",
      "Akyol Mah",
      "Alibey Mah",
      "Altınkum Mah",
      "Arı Mah",
      "Aşağıkaya Mah",
      "Aşağıveysi Mah",
      "Babakaya Mah",
      "Bağdere Mah",
      "Bağlar Mah",
      "Bahçe Mah",
      "Bahçelievler Mah",
      "Başdeğirmen Mah",
      "Başıbüyük Mah",
      "Bayrambaşı Mah",
      "Bellibahçe Mah",
      "Bereketli Mah",
      "Beypınar Mah",
      "Boyunlu Mah",
      "Camii Mah",
      "Çakıltaşı Mah",
      "Çaldere Mah",
      "Çardak Mah",
      "Çevriksu Mah",
      "Çiğdemli Mah",
      "Çiğil Mah",
      "Çobantepe Mah",
      "Dağcılar Mah",
      "Darköprü Mah",
      "Demirkuyu Mah",
      "Dolapdere Mah",
      "Doluçanak Mah",
      "Duru Mah",
      "Düzalan Mah",
      "Erikyazı Mah",
      "Eskiköy Mah",
      "Eskiocak Mah",
      "Eşme Mah",
      "Feridun Mah",
      "Gökçetevek Mah",
      "Görentepe Mah",
      "Görmez Mah",
      "Güçlü Mah",
      "Gündüz Mah",
      "Gürpınar Mah",
      "Güzderesi Mah",
      "Heybelikonak Mah",
      "İncesu Mah",
      "Kale Mah",
      "Karacalar Mah",
      "Karahacı Mah",
      "Karamus Mah",
      "Kasımlı Mah",
      "Kayadere Mah",
      "Kazandağı Mah",
      "Keklikdere Mah",
      "Kıraçtepe Mah",
      "Kızlal Mah",
      "Konak Mah",
      "Kumgölü Mah",
      "Kumluk Mah",
      "Kutlualan Mah",
      "Malabadi Mah",
      "Mescit Mah",
      "Nohuttepe Mah",
      "Onbaşılar Mah",
      "Ormandışı Mah",
      "Otluk Mah",
      "Sağlık Mah",
      "Sarıbuğday Mah",
      "Selahattin Mah",
      "Sulak Mah",
      "Sulubağ Mah",
      "Susuz Mah",
      "Şanlı Mah",
      "Taşpınar Mah",
      "Tekel Mah",
      "Tokluca Mah",
      "Umur Mah",
      "Üçbasamak Mah",
      "Yenidoğan Mah",
      "Yeniköy Mah",
      "Yenişehir Mah",
      "Yeşerdi Mah",
      "Yeşilbahçe Mah",
      "Yeşilköy Mah",
      "Yolaç Mah",
      "Yolarası Mah",
      "Yukarıveysi Mah",
      "Yuva Mah",
      "Yüksek Mah"
    ],
    "Sur": [
      "Ağaçlıdere Mah",
      "Alabal Mah",
      "Alcık Mah",
      "Alibardak Mah",
      "Arpaderesi Mah",
      "Bağıvar Mah",
      "Bağpınar Mah",
      "Bahçecik Mah",
      "Baroğlu Mah",
      "Beybulak Mah",
      "Bostanpınar Mah",
      "Bozdemir Mah",
      "Büyükakören Mah",
      "Büyükkadı Mah",
      "Cemal Yılmaz Mah",
      "Cevat Paşa Mah",
      "Çarıklı Mah",
      "Çataksu Mah",
      "Çelikli Mah",
      "Çubuklu Mah",
      "Dervişhasan Mah",
      "Doğanlı Mah",
      "Doğu Çanakçı Mah",
      "Dumrul Mah",
      "Erimli Mah",
      "Eryolu Mah",
      "Esenbağ Mah",
      "Fatihpaşa Mah",
      "Fetih Mah",
      "Fidanlar Mah",
      "Gencan Mah",
      "Gölpınar Mah",
      "Gültepe Mah",
      "Hacıosman Mah",
      "Harmanlar Mah",
      "Hasırlı Mah",
      "Havacılar Mah",
      "Hızır İlyas Mah",
      "Kabasakal Mah",
      "Kapaklıpınar Mah",
      "Karabaş Mah",
      "Karacaören Mah",
      "Karaçalı Mah",
      "Karaçimen Mah",
      "Kardeşler Mah",
      "Karpuzlu Mah",
      "Karpuztepe Mah",
      "Kartaltepe Mah",
      "Kavaklıbağ Mah",
      "Kayayolu Mah",
      "Kengerli Mah",
      "Kervanpınar Mah",
      "Kırmasırt Mah",
      "Konacık Mah",
      "Koyungüden Mah",
      "Kozan Mah",
      "Köprübaşı Mah",
      "Köşk Mah",
      "Kumluçat Mah",
      "Kumrucak Mah",
      "Kuşburnu Mah",
      "Kuşlukbağı Mah",
      "Küçükakören Mah",
      "Küçükkadı Mah",
      "Mermer Mah",
      "Mermeri Mah",
      "Nefirtaş Mah",
      "Özekli Mah",
      "Pınardüzü Mah",
      "Sağdıçlı Mah",
      "Sapanca Mah",
      "Sarıkamış Mah",
      "Sarılar Mah",
      "Sarıyazma Mah",
      "Sati Mah",
      "Savaş Mah",
      "Sayarlar Mah",
      "Soğanlı Mah",
      "Süngüler Mah",
      "Tanoğlu Mah",
      "Tezgeçer Mah",
      "Yarımca Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Yenievler Mah",
      "Yeşilköy Mah",
      "Yeşilli Mah",
      "Yiğitçavuş Mah",
      "Yukarıkılıçtaşı Mah",
      "Ziyaret Mah",
      "Abdaldede Mah",
      "Ali Paşa Mah",
      "Cami Kebir Mah",
      "Cami Nebi Mah",
      "Dabanoğlu Mah",
      "İskenderpaşa Mah",
      "Lalebey Mah",
      "Melikahmet Mah",
      "Süleyman Nazif Mah",
      "Ziya Gökalp Mah"
    ],
    "Yenişehir": [
      "Aziziye Mah",
      "Cumhuriyet Mah",
      "Gürdoğan Mah",
      "Alpu Mah",
      "Bahçelievler Mah",
      "Çimenler Mah",
      "Dokuzçeltik Mah",
      "Dökmetaş Mah",
      "Dönümlü Mah",
      "Elidolu Mah",
      "Eser Mah",
      "Güvendere Mah",
      "Güvercinlik Mah",
      "Güzelköy Mah",
      "İlbaş Mah",
      "Kesikağaç Mah",
      "Sancar Mah",
      "Şehitlik Mah",
      "Tanışık Mah",
      "Üçkuyu Mah",
      "Yolaltı Mah",
      "Yüksek Mah",
      "Al Mah",
      "Alangör Mah",
      "Başil Mah",
      "Bozek Mah",
      "Çakmak Mah",
      "Çelikevler Mah",
      "Dicle Mah",
      "Dikentepe Mah",
      "Ekinciler Mah",
      "Fabrika Mah",
      "Ferit Köşk Mah",
      "Geyiktepe Mah",
      "Hantepe Mah",
      "Kooperatifler Mah",
      "Sarıyatak Mah",
      "Seyrantepe Sanayi Mah",
      "Sivritepe Mah",
      "Yaytaş Mah",
      "Yenişehir Mah",
      "Yukarı Nasırlar Mah"
    ]
  },
  "Edirne": {
    "Enez": [
      "Çataltepe Mah",
      "Gaziömerbey Mah",
      "Yeni Mah",
      "Abdurrahim Köyü",
      "Büyükevren Köyü",
      "Çandır Köyü",
      "Çavuşköy Köyü",
      "Çeribaşı Köyü",
      "Gülçavuş Köyü",
      "Hasköy Köyü",
      "Hisarlı Köyü",
      "Işıklı Köyü",
      "Karaincirli Köyü",
      "Kocaali Köyü",
      "Küçükevren Köyü",
      "Sultaniçe Köyü",
      "Sütçüler Köyü",
      "Şehitler Köyü",
      "Umurbey Köyü",
      "Vakıf Köyü",
      "Yazır Köyü",
      "Yenice Köyü"
    ],
    "Havsa": [
      "Arpaç Köyü",
      "Habiller Köyü",
      "Hasköy Köyü",
      "Musulca Köyü",
      "Söğütlüdere Köyü",
      "Cumhuriyet Mah",
      "Hacıgazi Mah",
      "Hacıisa Mah",
      "Helvacı Mah",
      "Varoş Mah",
      "Yeni Mah",
      "Abalar Mah (abalar Köyü)",
      "Abalar Merkez Mah (abalar Köyü)",
      "Azatlı Köyü",
      "Bakışlar Köyü",
      "Bostanlı Köyü",
      "Çukurköy Köyü",
      "Kabaağaç Köyü",
      "Köseömer Köyü",
      "Kulubalık Köyü",
      "Kuzucu Köyü",
      "Naipyusuf Köyü",
      "Necatiye Köyü",
      "Oğulpaşa Köyü",
      "Oğulpaşa Mah (oğulpaşa Köyü)",
      "Osmanlı Köyü",
      "Şerbettar Köyü",
      "Tahal Köyü",
      "Taptık Köyü",
      "Yolageldi Köyü"
    ],
    "İpsala": [
      "Atatürk Mah (esetçe Beldesi)",
      "Cumhuriyet Mah (esetçe Beldesi)",
      "Kurtuluş Mah (esetçe Beldesi)",
      "Bayrambey Mah",
      "Bozkurt Mah",
      "Fatih Mah",
      "Kapucu Mah",
      "Köprü Mah",
      "Saraç İlyas Mah",
      "Aliçopehlivan Köyü",
      "Atatürk Mah (kocahıdır Köyü)",
      "Atatürk Mah (sultan Köyü)",
      "Balabancık Köyü",
      "Cumhuriyet Mah (kocahıdır Köyü)",
      "Gemici Mah (ibriktepe Köyü)",
      "Gündoğan Mah (hacı Köyü)",
      "Hamidiye Mah (ibriktepe Köyü)",
      "Hıdırköy Köyü",
      "İnönü Mah (ibriktepe Köyü)",
      "Karaağaç Köyü",
      "Korucu Köyü",
      "Koyuntepe Köyü",
      "Kumdere Köyü",
      "Küçükdoğanca Köyü",
      "Menderes Mah (sultan Köyü)",
      "Paşaköy Köyü",
      "Pazardere Köyü",
      "Sarıcaali Köyü",
      "Sarpdere Köyü",
      "Selanik Mah (hacı Köyü)",
      "Selanik Mah (ibriktepe Köyü)",
      "Tevfikiye Köyü",
      "Turpçular Köyü",
      "Yapıldak Köyü",
      "Zaferiye Mah (hacı Köyü)",
      "Fevzi Çakmak Mah (yenikarpuzlu Beldesi)",
      "Gazi Mah (yenikarpuzlu Beldesi)",
      "İnönü Mah (yenikarpuzlu Beldesi)"
    ],
    "Keşan": [
      "Aydoğan Mah (beğendik Beldesi)",
      "Beykent Mah (beğendik Beldesi)",
      "Kemalpaşa Mah (beğendik Beldesi)",
      "Yeni Mah (beğendik Beldesi)",
      "Aşağı Zaferiye Mah",
      "Büyük Cami Mah",
      "Cumhuriyet Mah",
      "İspat Cami Mah",
      "İstasyon Mah",
      "Mustafa Kemal Paşa Mah",
      "Yeni Mah",
      "Yenimescit Mah",
      "Yukarı Zaferiye Mah",
      "Akhoca Köyü",
      "Atatürk Mah (mecidiye Köyü)",
      "Barağı Köyü",
      "Beyköy Köyü",
      "Cumhuriyet Mah (mecidiye Köyü)",
      "Çelebi Köyü",
      "Çeltik Köyü",
      "Danişment Köyü",
      "Danişment Mah (danişment Köyü)",
      "Dişbudak Köyü",
      "Erikli Köyü",
      "Erikli Mah (erikli Köyü)",
      "Kızkapan Köyü",
      "Koruklu Köyü",
      "Orhaniye Köyü",
      "Suluca Köyü",
      "Şabanmera Köyü",
      "Yayla Mah (yaylaköy Köyü)",
      "Yaylaköy Köyü",
      "Yeşilköy Köyü",
      "Akçeşme Köyü",
      "Altıntaş Köyü",
      "Boztepe Köyü",
      "Çobançeşmesi Köyü",
      "Gündüzler Köyü",
      "İzzetiye Mah",
      "Karacaali Köyü",
      "Karahisar Köyü",
      "Karasatı Köyü",
      "Kılıçköy Köyü",
      "Kozköy Köyü",
      "Küçükdoğanca Köyü",
      "Lalacık Köyü",
      "Maltepe Köyü",
      "Paşayiğit Mah",
      "Siğilli Köyü",
      "Türkmen Köyü",
      "Yeniceçiftlik Köyü",
      "Atatürk Mah (yenimuhacir Beldesi)",
      "Cumhuriyet Mah (yenimuhacir Beldesi)",
      "İnönü Mah (yenimuhacir Beldesi)",
      "İstiklal Mah (yenimuhacir Beldesi)",
      "Atatürk Mah (çamlıca Köyü)",
      "Bahçeköy Köyü",
      "Büyükdoğanca Köyü",
      "Fevzipaşa Mah (çamlıca Köyü)",
      "Gökçetepe Köyü",
      "Gökçetepe Mah (gökçetepe Köyü)",
      "Kadıköy Köyü",
      "Karlı Köyü",
      "Mahmutköy Köyü",
      "Mercan Köyü",
      "Pırnar Köyü",
      "Sazlıdere Köyü",
      "Sazlıdere Mah (sazlıdere Köyü)",
      "Seydiköy Köyü",
      "Şükrüköy Köyü",
      "Yerlisu Köyü"
    ],
    "Lalapaşa": [
      "Merkez Mah",
      "Büyünlü Köyü",
      "Çallıdere Köyü",
      "Çatma Köyü",
      "Çömlek Köyü",
      "Çömlekakpınar Köyü",
      "Demirköy Köyü",
      "Doğanköy Köyü",
      "Dombay Köyü",
      "Hacıdanişment Köyü",
      "Hacılar Köyü",
      "Hamzabeyli Köyü",
      "Hanlıyenice Köyü",
      "Hüseyinpınar Köyü",
      "Kalkansöğüt Köyü",
      "Kavaklı Köyü",
      "Küçünlü Köyü",
      "Ortakçı Köyü",
      "Ömeroba Köyü",
      "Saksağan Köyü",
      "Sarıdanişment Köyü",
      "Sinanköy Köyü",
      "Süleymandanişment Köyü",
      "Taşlımüsellim Köyü",
      "Tuğlalık Köyü",
      "Uzunbayır Köyü",
      "Vaysal Köyü",
      "Yünlüce Köyü"
    ],
    "Meriç": [
      "Adasarhanlı Köyü",
      "Büyükaltıağaç Köyü",
      "Gazi Mah (küplü Beldesi)",
      "Küçükaltıağaç Köyü",
      "Merkez Mah (küplü Beldesi)",
      "B.doğanca Mah",
      "K. Doğanca Mah",
      "Akçadam Köyü",
      "Akıncılar Köyü",
      "Alibey Köyü",
      "Hasırcıarnavutköy Köyü",
      "Kadıdondurma Köyü",
      "Karahamza Köyü",
      "Karayusuflu Köyü",
      "Kavaklı Köyü",
      "Küpdere Köyü",
      "Nasuhbey Köyü",
      "Olacak Köyü",
      "Paşayenice Köyü",
      "Rahmanca Köyü",
      "Saatağacı Köyü",
      "Serem Köyü",
      "Umurca Köyü",
      "Yakupbey Köyü",
      "Yenicegörüce Köyü",
      "İzzet Paşa Mah (subaşı Beldesi)",
      "Şehit Mehmet Aydın Mah (subaşı Beldesi)"
    ],
    "Merkez": [
      "1.murat Mah",
      "Abdurrahman Mah",
      "Babademirtaş Mah",
      "Barutluk Mah",
      "Çavuşbey Mah",
      "Dilaverbey Mah",
      "Fatih Mah",
      "İstasyon Mah",
      "Karaağaç Mah",
      "Koca Sinan Mah",
      "Medrese Ali Bey Mah",
      "Menzilahır Mah",
      "Meydan Mah",
      "Mithat Paşa Mah",
      "Nişancıpaşa Mah",
      "Sabuni Mah",
      "Sarıcapaşa Mah",
      "Şükrüpaşa Mah",
      "Talatpaşa Mah",
      "Umurbey Mah",
      "Yancıkçı Şahin Mah",
      "Yeniimaret Mah",
      "Yıldırım Beyazıt Mah",
      "Yıldırım Hacı Sarraf Mah",
      "Ahı Köyü",
      "Avarız Köyü",
      "Bosna Köyü",
      "Budakdoğanca Köyü",
      "Büyükdöllük Köyü",
      "Büyükismailçe Köyü",
      "Değirmenyeni Köyü",
      "Demirhanlı Köyü",
      "Doyran Köyü",
      "Ekmekçi Köyü",
      "Elçili Köyü",
      "Eskikadın Köyü",
      "Hacıumur Köyü",
      "Hasanağa Köyü",
      "Hatip Köyü",
      "Hıdırağa Köyü",
      "İskender Köyü",
      "Karabulut Köyü",
      "Karakasım Köyü",
      "Karayusuf Köyü",
      "Kayapa Köyü",
      "Kemal Köyü",
      "Korucu Köyü",
      "Köşençiftliği Köyü",
      "Küçükdöllük Köyü",
      "Menekşesofular Köyü",
      "Muratçalı Köyü",
      "Musabeyli Köyü",
      "Orhaniye Köyü",
      "Sarayakpınar Köyü",
      "Sazlıdere Köyü",
      "Suakacağı Köyü",
      "Tayakadın Köyü",
      "Uzgaç Köyü",
      "Üyüklütatar Köyü",
      "Yenikadın Köyü",
      "Yolüstü Köyü"
    ],
    "Süloğlu": [
      "Akardere Köyü",
      "Büyük Gerdelli Köyü",
      "Domurcalı Köyü",
      "Geçkinli Köyü",
      "Keramettin Köyü",
      "Küküler Köyü",
      "Sülecik Köyü",
      "Taşlısekban Köyü",
      "Tatarlar Köyü",
      "Yağcılı Köyü",
      "Cumhuriyet Mah",
      "Merkez Mah",
      "Organize Sanayi Bölgesi Mah",
      "Şafak Mah",
      "Yeni Mah"
    ],
    "Uzunköprü": [
      "Aşçıoğlu Mah",
      "Atatürk Mah",
      "Demirtaş Mah",
      "Kavak Mah",
      "Muradiye Mah",
      "Başağıl Köyü",
      "Bayramlı Köyü",
      "Beykonak Köyü",
      "Bıldır Köyü",
      "Danişment Köyü",
      "Elmalı Köyü",
      "Gazimehmet Köyü",
      "Karabürçek Köyü",
      "Muhacırkadı Köyü",
      "Ömerbey Köyü",
      "Sipahi Köyü",
      "Sultanşah Köyü",
      "Turnacı Köyü",
      "Yağmurca Köyü",
      "Alıç Köyü",
      "Altınyazı Köyü",
      "Atatürk Mah (kurtbey Köyü)",
      "Balaban Köyü",
      "Balabankoru Köyü",
      "Çavuşlu Köyü",
      "Çobanpınar Köyü",
      "Dereköy Köyü",
      "Fevzi Çakmak Mah (kurtbey Köyü)",
      "Hamidiye Köyü",
      "Harmanlı Köyü",
      "Hasanpınar Köyü",
      "İnönü Mah (kurtbey Köyü)",
      "Kadıağılı Köyü",
      "Kadıköy Köyü",
      "Karapınar Köyü",
      "Kavakayazma Köyü",
      "Kırköy Köyü",
      "Maksutlu Köyü",
      "Namık Kemal Mah (kurtbey Köyü)",
      "Süleymaniye Köyü",
      "Türkobası Köyü",
      "Aslıhan Köyü",
      "Balaban Mah (kırcasalih Beldesi)",
      "Cumhuriyet Mah (kırcasalih Beldesi)",
      "İstiklal Mah (kırcasalih Beldesi)",
      "Meşeli Köyü",
      "Okullar Mah (kırcasalih Beldesi)",
      "Sazlımalkoç Köyü",
      "Çakmak Köyü",
      "Çalı Köyü",
      "Çiftlik Köyü",
      "Değirmenci Köyü",
      "Eskiköy Köyü",
      "Gemici Köyü",
      "Hamitli Köyü",
      "Karayayla Köyü",
      "Kavacık Köyü",
      "Kırkkavak Köyü",
      "Kiremitçisalih Köyü",
      "Kurdu Köyü",
      "Kurttepe Köyü",
      "Malkoç Köyü",
      "Saçlımüsellim Köyü",
      "Salarlı Köyü",
      "Sığırcılı Köyü",
      "Büyük Şehsuvarbey Mah",
      "Cumhuriyet Mah",
      "Çöpköy Mah",
      "Habib Hoca Mah",
      "Halise Hatun Mah",
      "Küçük Şehsuvarbey Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Mescit Mah",
      "Muradiye Cami Mah",
      "Rızaefendi Mah",
      "Yeniköy Mah"
    ]
  },
  "Elazığ": {
    "Ağın": [
      "Akpınar Mah",
      "Başpınar Mah",
      "Merkez Mah",
      "Şenpınar Mah",
      "Afet Evleri Mah (yeni Yerleşim Yeri Mah) (demirçarık Köyü)",
      "Altınayva Köyü",
      "Armutlu Mah (samançay Köyü)",
      "Aşağıyabanlı Köyü",
      "Bademli Köyü",
      "Bahadırlar Köyü",
      "Balkayası Köyü",
      "Beyelması Köyü",
      "Demirçarık Köyü",
      "Dibekli Köyü",
      "Gümüşsuyu Mah (samançay Köyü)",
      "Kaşpınar Köyü",
      "Konak Mah (saraycık Köyü)",
      "Kurtuluş Mah (öğrendik Köyü)",
      "Modanlı Köyü",
      "Ortayabanlı Mah (aşağıyabanlı Köyü)",
      "Öğrendik Köyü",
      "Pulköy Köyü",
      "Salkımlı Mah (yenipayam Köyü)",
      "Samançay Köyü",
      "Saraycık Köyü",
      "Tarlabaşı Mah (öğrendik Köyü)",
      "Yedibağ Köyü",
      "Yenipayam Köyü"
    ],
    "Alacakaya": [
      "Altınçanak Mah",
      "Altıoluk Mah",
      "Gülaman Mah",
      "Gündoğdu Mah",
      "Merkez Mah",
      "Sularbaşı Mah",
      "Bağin Mah (yalnızdamlar Köyü)",
      "Bakladamlar Köyü",
      "Çakmakkaya Köyü",
      "Çallıca Mah (çataklı Köyü)",
      "Çanakça Köyü",
      "Çataklı Köyü",
      "Davan Mah (çanakça Köyü)",
      "Düzağaç Mah (incebayır Köyü)",
      "Esenlik Köyü",
      "Gürçubuk Köyü",
      "Halkalı Köyü",
      "İncebayır Köyü",
      "Kayranlı Köyü",
      "Oğuz Mah (incebayır Köyü)",
      "Yalnızdamlar Köyü",
      "Yılmaz Mah (incebayır Köyü)"
    ],
    "Arıcak": [
      "Gümüşyaka Mah",
      "Halil Yavuz Mah",
      "Hürriyet Mah",
      "Mustafa Çelebi Mah",
      "Saman Mah",
      "Serinevler Mah",
      "Simserkis Mah",
      "Vali Göktayoğlu Mah",
      "Bölükbaşı Mah (bükardı Beldesi)",
      "Kaplanbağ Mah (bükardı Beldesi)",
      "Pınarbaşı Mah (bükardı Beldesi)",
      "Yaylabaşı Mah (bükardı Beldesi)",
      "Zeynet Mah (bükardı Beldesi)",
      "Cami Mah (erimli Beldesi)",
      "Cumhuriyet Mah (erimli Beldesi)",
      "Güleç Mah (erimli Beldesi)",
      "Güvenevler Mah (erimli Beldesi)",
      "Kışla Mah (erimli Beldesi)",
      "Akyıldız Mah (küplüce Köyü)",
      "Albayrak Mah (küplüce Köyü)",
      "Bozçavuş Köyü",
      "Çavuşdere Köyü",
      "Çevrecik Köyü",
      "Erbağı Köyü",
      "Göründü Köyü",
      "Göztepe Mah (yoğunbilek Köyü)",
      "Ilıcak Mah (küplüce Köyü)",
      "Kambertepe Köyü",
      "Karakaş Köyü",
      "Küplüce Köyü",
      "Ormanpınar Köyü",
      "Til Mah (karakaş Köyü)",
      "Uzun Söğüt Mah (yoğunbilek Köyü)",
      "Yoğunbilek Köyü",
      "Çay Mah (üçocak Beldesi)",
      "Haberci Mah (üçocak Beldesi)",
      "Kutlu Düğün Mah (üçocak Beldesi)",
      "Merkez Mah (üçocak Beldesi)",
      "Ziyaret Mah (üçocak Beldesi)"
    ],
    "Baskil": [
      "Canbeyler Mah",
      "Cumhuriyet Mah",
      "Eskibaskil Mah",
      "Mustafa Demirel Mah",
      "Odabaşı Mah",
      "Şefkat Mah",
      "Adacık Mah (topaluşağı Köyü)",
      "Akarsu Mah (emirhan Köyü)",
      "Akbayır Mah (eskiköy Köyü)",
      "Akçalar Mah (konacık Köyü)",
      "Akdemir Köyü",
      "Akkonak Mah (şeyh Hasan Köyü)",
      "Akkuş Mah (doğancık Köyü)",
      "Aksakal Mah (suyatağı Köyü)",
      "Aktaş Mah (hacımustafaköy Köyü)",
      "Akyazı Mah (aşağıkuluşağı Köyü)",
      "Aladikme Köyü",
      "Alangören Köyü",
      "Ali Bal Mah (akdemir Köyü)",
      "Aliağa Mah (şahindere Köyü)",
      "Alibaba Mah (gemici Köyü)",
      "Alihac Mah (karagedik Köyü)",
      "Altınuşağı Köyü",
      "Ambarlı Mah (koçyolu Köyü)",
      "Asaflar Mah (doğancık Köyü)",
      "Aşağı Ardışlı Mah (karakaş Köyü)",
      "Aşağı Atlılar Mah (karakaş Köyü)",
      "Aşağı Eşme Mah (yalındam Köyü)",
      "Aşağı Kardeşler Mah (harabekayış Köyü)",
      "Aşağıevler Mah (yaylanlı Köyü)",
      "Aşağıgeçit Mah (akuşağı Köyü)",
      "Atamlar Mah (karoğlu Köyü)",
      "Aydınlar Mezrası Mah (aşağıkuluşağı Köyü)",
      "Aydoğan Mah (aladikme Köyü)",
      "Bahçeli Evler Mah (kadıköy Köyü)",
      "Ballıca Mah (sarıtaş Köyü)",
      "Barış Mah (aşağıkuluşağı Köyü)",
      "Başağaç Mah (hacıuşağı Köyü)",
      "Baznalar Mah (yukarıkuluşağı Köyü)",
      "Bejan Mah (şahaplı Köyü)",
      "Bekcili Mah (doğancık Köyü)",
      "Bekirmustafa Mah (paşakonağı Köyü)",
      "Belhan Mah (kayabeyli Köyü)",
      "Besikan Mah (koçyolu Köyü)",
      "Beyler Mah (aşağıkuluşağı Köyü)",
      "Beyler Mah (resulkahya Köyü)",
      "Bilaluşağı Köyü",
      "Bolucuk Mah (doğancık Köyü)",
      "Bozarmut Mah (sarıtaş Köyü)",
      "Bozoğlak Köyü",
      "Bozolar Mah (aladikme Köyü)",
      "Büyüler Mah (karaali Köyü)",
      "Cansız Kayış Mah (aladikme Köyü)",
      "Ceberler Mah (çavuşlu Köyü)",
      "Cebrail Mah (akuşağı Köyü)",
      "Çağlar Mah (meydancık Köyü)",
      "Çakırlı Mah (karaali Köyü)",
      "Çamaltı Mah (yaylanlı Köyü)",
      "Çamlı Mah (hacımustafaköy Köyü)",
      "Çapkurlar Mah (çavuşlu Köyü)",
      "Çavuşlu Mah (beşbölük Köyü)",
      "Çayıran Mah (paşakonağı Köyü)",
      "Çevreköy Mah (suyatağı Köyü)",
      "Çitili Mah (karaali Köyü)",
      "Çoğanlı Mah (imikuşağı Köyü)",
      "Çoğraş Mah (aladikme Köyü)",
      "Çubuklu Mah (karoğlu Köyü)",
      "Çulhalar Mah (koçyolu Köyü)",
      "Dallıca Mah (altınuşağı Köyü)",
      "Damlataş Mah (hacımustafaköy Köyü)",
      "Davut Mah (yıldızlı Köyü)",
      "Dayılar Mah (kutlugün Köyü)",
      "Deliktaş Köyü",
      "Demirlibahçe Köyü",
      "Dervişler Mah (akuşağı Köyü)",
      "Deşt Mah (gemici Köyü)",
      "Diğer Karakaş Mah (karakaş Köyü)",
      "Dilek Mah (konalga Köyü)",
      "Diyerbeyler Mah (akuşağı Köyü)",
      "Doğanlar Mah (altınuşağı Köyü)",
      "Dokoşağı Mah (karaali Köyü)",
      "Dolma Mah (bozoğlak Köyü)",
      "Doraş Mah (tavşanuşağı Köyü)",
      "Dörtyol Mah (kızıluşağı Köyü)",
      "Dursunlar Mah (hacımustafaköy Köyü)",
      "Düğüntepe Köyü",
      "Düşeli Mah (aladikme Köyü)",
      "Düz Mah (beşbölük Köyü)",
      "Düz Mah (doğancık Köyü)",
      "Erler Mah (hacıhüseyinler Köyü)",
      "Eskiköy Köyü",
      "Faduluşağı Mah (sarıtaş Köyü)",
      "Fakir Mah (emirhan Köyü)",
      "Fırat Mah (yaylanlı Köyü)",
      "Gedebük Mah (pınarlı Köyü)",
      "Gedek Mah (yukarıkuluşağı Köyü)",
      "Gejikan Mah (şahaplı Köyü)",
      "Geli Mah (topaluşağı Köyü)",
      "Gemici Köyü",
      "Göleler Mah (akuşağı Köyü)",
      "Göllüce Mah (karakaş Köyü)",
      "Göluşağı Mah (beşbölük Köyü)",
      "Gülhaç Mah (resulkahya Köyü)",
      "Güllübağ Mah (konalga Köyü)",
      "Güllüce Mah (alangören Köyü)",
      "Gümüşçay Mah (konalga Köyü)",
      "Gündüz Mah (kızıluşağı Köyü)",
      "Güneşli Mah (şituşağı Köyü)",
      "Güzelli Mah (düğüntepe Köyü)",
      "Hacı Hasan Mah (ışıklar Köyü)",
      "Hacı Mah (hacımustafaköy Köyü)",
      "Hacı Ömer Mah (aladikme Köyü)",
      "Hacıhaliloğlu Mah (kızıluşağı Köyü)",
      "Hacıhüseyinler Köyü",
      "Hacımehmetli Köyü",
      "Hacımustafa Mah (hacıhüseyinler Köyü)",
      "Hacıuşağı Köyü",
      "Hacıyusuflar Mah (konalga Köyü)",
      "Haci  Bekir Mah (harabekayış Köyü)",
      "Haci Temur Mah (akuşağı Köyü)",
      "Haliçler Mah (koçyolu Köyü)",
      "Halitoğlu Mah (akuşağı Köyü)",
      "Harabekayış Köyü",
      "Hardi Mah (gemici Köyü)",
      "Hardiçay Mah (deliktaş Köyü)",
      "Harman Mah (karaali Köyü)",
      "Harmanlı Mah (yıldızlı Köyü)",
      "Harmetik Mah (koçyolu Köyü)",
      "Haydarkulu Mah (konacık Köyü)",
      "Hocalar Mah (hacıhüseyinler Köyü)",
      "Hüyükköy Köyü",
      "Işıklar Köyü",
      "Işıklı Mah (yeniocak Köyü)",
      "İlhanlar Mah (çavuşlu Köyü)",
      "İlhanlar Mah (doğancık Köyü)",
      "İnanç Mah (akdemir Köyü)",
      "İpşir Mah (karakaş Köyü)",
      "İskender Mah (aşağıkuluşağı Köyü)",
      "Kale Mah (suyatağı Köyü)",
      "Kalecik Mah (sarıtaş Köyü)",
      "Kaluşağı Mah (çavuşlu Köyü)",
      "Kamikli Mah (çiğdemlik Köyü)",
      "Kanatlı Mah (eskiköy Köyü)",
      "Karaali Köyü",
      "Karaca Mah (hacımustafaköy Köyü)",
      "Karagedik Köyü",
      "Karakaş Köyü",
      "Karakavak Mah (hacımustafaköy Köyü)",
      "Karameşe Mah (karakaş Köyü)",
      "Karpuzlu Mah (karagedik Köyü)",
      "Karşıyaka Mah (pınarlı Köyü)",
      "Kasımlar Mah (yukarıkuluşağı Köyü)",
      "Kasuşağı Mah (karagedik Köyü)",
      "Kayabeyli Köyü",
      "Keçik Mah (karoğlu Köyü)",
      "Keçilli Mah (emirhan Köyü)",
      "Kem Mah (topaluşağı Köyü)",
      "Kemerli Mah (doğancık Köyü)",
      "Kılıçlı Mah (söğütdere Köyü)",
      "Kıran Mah (konacık Köyü)",
      "Kırhasan Mah (çiğdemlik Köyü)",
      "Kızılyazı Mah (hacımehmetli Köyü)",
      "Kiziruşağı Mah (tatlıpayam Köyü)",
      "Koçyolu Köyü",
      "Konacık Köyü",
      "Konalga Köyü",
      "Konuklu Mah (akuşağı Köyü)",
      "Köfteler Mah (gemici Köyü)",
      "Körbekir Mah (harabekayış Köyü)",
      "Kösek Mah (kızıluşağı Köyü)",
      "Köseoğlu Mah (kızıluşağı Köyü)",
      "Köz Mah (resulkahya Köyü)",
      "Kumlu Mah (düğüntepe Köyü)",
      "Kuran Mah (yaylanlı Köyü)",
      "Kurucu Mah (konalga Köyü)",
      "Kurugül Mah (yaylanlı Köyü)",
      "Kuşsarayı Köyü",
      "Kut Mah (karoğlu Köyü)",
      "Kuzucuk Mah (yukarıkuluşağı Köyü)",
      "Küllük Mah (kutlugün Köyü)",
      "Laçular Mah (konalga Köyü)",
      "Memişler Mah (aşağıkuluşağı Köyü)",
      "Merkez Mah (akuşağı Köyü)",
      "Merkez Mah (altınuşağı Köyü)",
      "Merkez Mah (aşağıkuluşağı Köyü)",
      "Merkez Mah (beşbölük Köyü)",
      "Merkez Mah (çavuşlu Köyü)",
      "Merkez Mah (çiğdemlik Köyü)",
      "Merkez Mah (emirhan Köyü)",
      "Merkez Mah (habibuşağı Köyü)",
      "Merkez Mah (içlikaval Köyü)",
      "Merkez Mah (imikuşağı Köyü)",
      "Merkez Mah (kadıköy Köyü)",
      "Merkez Mah (karagedik Köyü)",
      "Merkez Mah (karakaş Köyü)",
      "Merkez Mah (karoğlu Köyü)",
      "Merkez Mah (kızıluşağı Köyü)",
      "Merkez Mah (kumlutarla Köyü)",
      "Merkez Mah (kutlugün Köyü)",
      "Merkez Mah (paşakonağı Köyü)",
      "Merkez Mah (pınarlı Köyü)",
      "Merkez Mah (sarıtaş Köyü)",
      "Merkez Mah (söğütdere Köyü)",
      "Merkez Mah (suyatağı Köyü)",
      "Merkez Mah (şituşağı Köyü)",
      "Merkez Mah (yalındam Köyü)",
      "Merkez Mah (yeniocak Köyü)",
      "Merkez Mah (yukarıkuluşağı Köyü)",
      "Meşeşaban Mah (yıldızlı Köyü)",
      "Meval Uşağı Mah (akuşağı Köyü)",
      "Meydancık Köyü",
      "Mışmişler Mah (yaylanlı Köyü)",
      "Mollabekir Mah (aşağıkuluşağı Köyü)",
      "Mollaismail Mah (yukarıkuluşağı Köyü)",
      "Munzur Mah (şahaplı Köyü)",
      "Ocaklı Mah (söğütdere Köyü)",
      "Okul Ve Sağlık Ocağı Mah (şituşağı Köyü)",
      "Omik Mah (topaluşağı Köyü)",
      "Onbaşı Mah (kızıluşağı Köyü)",
      "Ovacık Mah (konalga Köyü)",
      "Öteşaluşağı Mah (akuşağı Köyü)",
      "Özbaşı Mah (konalga Köyü)",
      "Resulkahya Köyü",
      "Sağırlar Mah (yalındam Köyü)",
      "Sakolar Mah (söğütdere Köyü)",
      "Sal Mah (konalga Köyü)",
      "Samanlı Mah (hacıuşağı Köyü)",
      "Sapanlı Mah (topaluşağı Köyü)",
      "Sekmen Mah (sarıtaş Köyü)",
      "Selviler Mah (aladikme Köyü)",
      "Sinan Mah (gemici Köyü)",
      "Sincan Mah (tatlıpayam Köyü)",
      "Soylu Mah (beşbölük Köyü)",
      "Subaşı Mah (doğancık Köyü)",
      "Subaylar Mah (akdemir Köyü)",
      "Süleyman Mah (yıldızlı Köyü)",
      "Sütlüce Mah (emirhan Köyü)",
      "Şah Mah (söğütdere Köyü)",
      "Şahaplı Köyü",
      "Şahindere Köyü",
      "Şahinler Mah (altınuşağı Köyü)",
      "Şarge Mah (hacımehmetli Köyü)",
      "Şeyh Hasan Köyü",
      "Şimşek Mah (karaali Köyü)",
      "Şituşağı Köyü",
      "Şükür Mah (şituşağı Köyü)",
      "Tabaklar Mah (yukarıkuluşağı Köyü)",
      "Tacikan Mah (söğütdere Köyü)",
      "Tarlacık Mah (şituşağı Köyü)",
      "Taşkapı Mah (hacıuşağı Köyü)",
      "Taşlık Mah (karakaş Köyü)",
      "Tatlıpayam Köyü",
      "Tavuklu Mah (düğüntepe Köyü)",
      "Tekağaç Mah (aladikme Köyü)",
      "Temurhalil Mah (yukarıkuluşağı Köyü)",
      "Tepe Altı Mah (tavşanuşağı Köyü)",
      "Topal Mah (karoğlu Köyü)",
      "Topaluşağı Köyü",
      "Tuzluca Mah (ışıklar Köyü)",
      "Türbe Mah (hacımehmetli Köyü)",
      "Uğurlu Mah (konalga Köyü)",
      "Üçbölük Mah (şeyh Hasan Köyü)",
      "Üsmıhtan Mah (söğütdere Köyü)",
      "Üzümlü Mah (konalga Köyü)",
      "Velipalas Mah (aladikme Köyü)",
      "Y.i.ö.b.o. Mah (doğancık Köyü)",
      "Yağmurlu Mah (konalga Köyü)",
      "Yamaçlı Mah (hacımustafaköy Köyü)",
      "Yanık Bağ Mah (hacıhüseyinler Köyü)",
      "Yapraklı Mah (eskiköy Köyü)",
      "Yapraklı Mah (hacıhüseyinler Köyü)",
      "Yaşar Mah (hacımustafaköy Köyü)",
      "Yaylanlı Köyü",
      "Yazıevleri Mah (yeniocak Köyü)",
      "Yazıkonak Mah (harabekayış Köyü)",
      "Yeni Mah (çavuşlu Köyü)",
      "Yeni Mah (yukarıkuluşağı Köyü)",
      "Yıldızlı Köyü",
      "Yırıklar Mah (koçyolu Köyü)",
      "Yukarı Ardıçlı Mah (karakaş Köyü)",
      "Yukarı Atlılar Mah (karakaş Köyü)",
      "Yukarı Çide Mah (akuşağı Köyü)",
      "Yukarı Deliktaş Mah (deliktaş Köyü)",
      "Yukarı Eşme Mah (yalındam Köyü)",
      "Yukarı Kardeşler Mah (harabekayış Köyü)",
      "Yukarı Zemzem Mah (karoğlu Köyü)",
      "Yukarıgeçit Mah (akuşağı Köyü)",
      "Yukarıköy Mah (doğancık Köyü)",
      "Yusuflu Mah (çavuşlu Köyü)",
      "Yuvacık Mah (şituşağı Köyü)",
      "Yuvalar Mah (şituşağı Köyü)",
      "Yüzgeçler Mah (çiğdemlik Köyü)",
      "Zelihan Mah (aladikme Köyü)",
      "Ziyaret Mah (doğancık Köyü)"
    ],
    "Karakoçan": [
      "Bahçelievler Mah",
      "Gölpınar Mah",
      "Karşıyaka Mah",
      "Kırkpınar Mah",
      "Kulubaba Mah",
      "Tepe Mah",
      "Yeni Mah",
      "Abdalan Mah (okçular Köyü)",
      "Ağamezrası Köyü",
      "Akarbaşı Köyü",
      "Akbulak Köyü",
      "Akçiçek Köyü",
      "Akkuş Köyü",
      "Akpınar Köyü",
      "Akyokuş Köyü",
      "Alabal Köyü",
      "Alayağmur Köyü",
      "Ali Mezrası Mah (yoğunağaç Köyü)",
      "Altınoluk Köyü",
      "Aşağı Mah (kuşçu Köyü)",
      "Aşağıovacık Köyü",
      "Bağlıağaç Köyü",
      "Bahçecik Köyü",
      "Balcalı Köyü",
      "Bardaklı Köyü",
      "Başyurt Köyü",
      "Bazlama Köyü",
      "Beydere Köyü",
      "Bulgurcuk Köyü",
      "Cabbar Mah (alayağmur Köyü)",
      "Cumhuriyet Köyü",
      "Çalıkaya Köyü",
      "Çamardı Köyü",
      "Çan Köyü",
      "Çanakçı Köyü",
      "Çatalyol Köyü",
      "Çavuşyolu Köyü",
      "Çayırdam Köyü",
      "Çayırgülü Köyü",
      "Çayırlık Mah (çayırgülü Köyü)",
      "Çelebi Köyü",
      "Çitak Köyü",
      "Çukurca Mah (yoğunağaç Köyü)",
      "Dal Mah (koçyiğitler Köyü)",
      "Dede Mezrası Mah (üçbudak Köyü)",
      "Değirmen Mah (alayağmur Köyü)",
      "Değirmendere Mah (alabal Köyü)",
      "Değirmendüzü Mah (balcalı Köyü)",
      "Delitaş Mah (korudibi Köyü)",
      "Demirdelen Köyü",
      "Demirtaş Köyü",
      "Demirtepe Köyü",
      "Derince Mah (yalıntaş Köyü)",
      "Deveci Köyü",
      "Deveci Yol Altı Mah (kuşçu Köyü)",
      "Doğançukur Mah (sarihan Köyü)",
      "Doğanoğlu Köyü",
      "Dokuz Veren Mah (kümbet Köyü)",
      "Dumluyazı Köyü",
      "Durmuşköy Köyü",
      "Dursun Mah (çamardı Köyü)",
      "Düğünlü Mah (kavakdere Köyü)",
      "Elif Mah (akarbaşı Köyü)",
      "Gelincik Mah (okçular Köyü)",
      "Gordan Mah (pamuklu Köyü)",
      "Gözerek Köyü",
      "Gülhüseyin Mah (okçular Köyü)",
      "Güllüce Köyü",
      "Gümüşakar Köyü",
      "Gündeğdi Köyü",
      "Hamurkesen Köyü",
      "Hamzalı Köyü",
      "İlbey Mah (akarbaşı Köyü)",
      "İnceler Mah (kızılpınar Köyü)",
      "İsabey Köyü",
      "Kalecik Köyü",
      "Kalkankaya Köyü",
      "Karabük Mah (mahmutlu Köyü)",
      "Karaçan Köyü",
      "Karakoçan Köyü",
      "Karapınar Köyü",
      "Karasakal Köyü",
      "Kavakdere Köyü",
      "Kavalcık Köyü",
      "Keklikköy Köyü",
      "Kengerli Mah (yeniköy Köyü)",
      "Kırgıl Köyü",
      "Kızılca Köyü",
      "Kızılpınar Köyü",
      "Kocadayı Köyü",
      "Koç Mah (akarbaşı Köyü)",
      "Koçan Mah (okçular Köyü)",
      "Koçyiğitler Köyü",
      "Korudibi Köyü",
      "Köm Mah (hamurkesen Köyü)",
      "Köryusuf Köyü",
      "Kubatlı Mah (kuşbayırı Köyü)",
      "Kucak Mah (korudibi Köyü)",
      "Kulundere Köyü",
      "Kuruca Mah (koçyiğitler Köyü)",
      "Kuruk Mah (doğanoğlu Köyü)",
      "Kuşbayırı Köyü",
      "Kuşçu Köyü",
      "Kuşçu Palu Yolu Mah (kuşçu Köyü)",
      "Kümbet Köyü",
      "Mahmutlu Köyü",
      "Maksutali Köyü",
      "Meşeli Mah (okçular Köyü)",
      "Mezra Mah (gündeğdi Köyü)",
      "Milahasan Mah (akbulak Köyü)",
      "Mirahmet Köyü",
      "Okçular Köyü",
      "Ormancık Köyü",
      "Orta Mah (pamuklu Köyü)",
      "Özlüce Köyü",
      "Paşayaylası Köyü",
      "Pembelik Mah (pamuklu Köyü)",
      "Pilavtepe Köyü",
      "Polan Mah (alabal Köyü)",
      "Sağın Köyü",
      "Sağucak Köyü",
      "Sarı Ceviz Mah (yalıntaş Köyü)",
      "Sarıbaşak Köyü",
      "Sarihan Köyü",
      "Söğütlü Mah (altınoluk Köyü)",
      "Süleyman Çiftliği Mah (akçiçek Köyü)",
      "Şahhüseyin Mah (ağamezrası Köyü)",
      "Şeman Mah (korudibi Köyü)",
      "Tatlıca Mah (kızılpınar Köyü)",
      "Tekardıç Köyü",
      "Tepebaşı Mah (çelebi Köyü)",
      "Turan Mah (dumluyazı Köyü)",
      "Uysal Mah (durmuşköy Köyü)",
      "Üçbudak Köyü",
      "Ürünlü Mah (koçyiğitler Köyü)",
      "Yalıntaş Köyü",
      "Yamac Yolu Mah (kuşçu Köyü)",
      "Yemişlik Mah (sağın Köyü)",
      "Yenice Köyü",
      "Yenikaya Köyü",
      "Yeniköy Köyü",
      "Yeşilbelen Köyü",
      "Yoğunağaç Köyü",
      "Yolcatı Mah (yenice Köyü)",
      "Yoncalı Mah (dumluyazı Köyü)",
      "Yukarıovacık Köyü",
      "Yücekonak Köyü",
      "Yüzev Köyü",
      "Zilgölü Mah (alayağmur Köyü)",
      "Gölyaylası Mah (sarıcan Beldesi)",
      "Subaşı Mah (sarıcan Beldesi)"
    ],
    "Keban": [
      "Baraj Mah",
      "Değirmenbaşı Mah",
      "Fırat Mah",
      "Kallar Mah",
      "Acısu Mah (akçatepe Köyü)",
      "Akçatepe Köyü",
      "Akgömlek Köyü",
      "Alikan Mezrası Mah (çevrekaya Köyü)",
      "Altınkürek Köyü",
      "Arkulu Mah (aslankaşı Köyü)",
      "Aslankaşı Köyü",
      "Aşağı Demirli Mah (beydeğirmeni Köyü)",
      "Aşağı Mah (örenyaka Köyü)",
      "Aşağıçakmak Köyü",
      "Aşörgen Mah (altıyaka Köyü)",
      "Bademli Köyü",
      "Bahçeli Köyü",
      "Bayındır Köyü",
      "Beydeğirmeni Köyü",
      "Bölükçalı Köyü",
      "Büklümlü Köyü",
      "Cabbar Mah (altıyaka Köyü)",
      "Ciban Mezrası Mah (akgömlek Köyü)",
      "Çakmaklı Mah (beydeğirmeni Köyü)",
      "Çalık Köyü",
      "Çay Mezrası Mah (çevrekaya Köyü)",
      "Çevrekaya Köyü",
      "Dede Mah (altıyaka Köyü)",
      "Değirmen Mevkii Mah (bademli Köyü)",
      "Denizli Köyü",
      "Derince Mezrası Mah (altınkürek Köyü)",
      "Doğan Mah (akçatepe Köyü)",
      "Dursunlu Mah (göldere Köyü)",
      "Dursunlu Mezrası Mah (kuşçu Köyü)",
      "Dürümlü Köyü",
      "Emre Mah (akçatepe Köyü)",
      "Gökbelen Köyü",
      "Göldere Köyü",
      "Güneytepe Köyü",
      "Hamurlu Mezrası Mah (çevrekaya Köyü)",
      "İbolar Mah (aslankaşı Köyü)",
      "Karabey Mezrası Mah (topkıran Köyü)",
      "Karaçor Mezrası Mah (akgömlek Köyü)",
      "Karaçor Mezrası Mah (gökbelen Köyü)",
      "Karahüseyin Mezrası Mah (gökbelen Köyü)",
      "Karşı Mah (örenyaka Köyü)",
      "Karşı Mevkii Mah (altınkürek Köyü)",
      "Karşıyaka Mah (altıyaka Köyü)",
      "Kırklar Mezrası Mah (sağdıçlar Köyü)",
      "Koçemin Mah (altıyaka Köyü)",
      "Konak Mezrası Mah (topkıran Köyü)",
      "Kopuzlu Köyü",
      "Koyunuşağı Köyü",
      "Kurşunkaya Köyü",
      "Kuşçu Köyü",
      "Mandere Mezrası Mah (taşkesen Köyü)",
      "Melilan Mah (beydeğirmeni Köyü)",
      "Merkez Mah (altıyaka Köyü)",
      "Orta Mevkii Mah (altınkürek Köyü)",
      "Orta Mezra Mah (sağdıçlar Köyü)",
      "Pınarlar Mah (nimri Köyü)",
      "Sağdıçlar Köyü",
      "Sino Mezrası Mah (bademli Köyü)",
      "Soğuk Su Mezrası Mah (gökbelen Köyü)",
      "Süleymanlı Mah (çalık Köyü)",
      "Şahverdiyen Mah (altınkürek Köyü)",
      "Şüşan Mah (altınkürek Köyü)",
      "Taktah Mezrası Mah (çevrekaya Köyü)",
      "Taşkesen Köyü",
      "Taşkonak Mezrası Mah (çevrekaya Köyü)",
      "Topkıran Köyü",
      "Ulupınar Köyü",
      "Üçpınar Köyü",
      "Yahyalı Mezrası Mah (denizli Köyü)",
      "Yukarı Demirli Mah (beydeğirmeni Köyü)",
      "Yukarı Kuşçu Mah (kuşçu Köyü)",
      "Yukarı Mah (örenyaka Köyü)",
      "Yukarı Mevkii Mah (altınkürek Köyü)"
    ],
    "Kovancılar": [
      "Bağlar Mah",
      "Bahçelievler Mah",
      "Çarşı Başı Mah",
      "Çay Başı Mah",
      "Fatih Mah",
      "Gültepe Mah",
      "Heybet Mah",
      "İsmet Paşa Mah",
      "Kapıaçmaz Mah",
      "Karacimşit Mah",
      "Toki Mah",
      "Tuna Mah",
      "Yeni Mah",
      "Adalı Köyü",
      "Akmezra Köyü",
      "Akpınar Mah (karaman Köyü)",
      "Altınkum Mah (çaybağı Köyü)",
      "Aşağı Kazanlar Mah (yukarıkazanlar Köyü)",
      "Aşağı Mezra Mah (kolluca Köyü)",
      "Aşağıdemirci Köyü",
      "Aşağıkanatlı Köyü",
      "Aşağıköse Köyü",
      "Aşağımirahmet Köyü",
      "Avlağı Köyü",
      "Ayyıldız Mah (ekinözü Köyü)",
      "Bağgülü Köyü",
      "Bahçelievler Mah (kavakköy Köyü)",
      "Bahçelievler Mah (yarımca Köyü)",
      "Başaklı Mah (karasungur Köyü)",
      "Bayramyazı Köyü",
      "Beroç Mah (yenidam Köyü)",
      "Beşaret Mah (kuşçu Köyü)",
      "Beşpınar Köyü",
      "Beyaz Pınar Mah (karıncaköy Köyü)",
      "Bilalköy Köyü",
      "Bülbül Mah (bağgülü Köyü)",
      "Cumhuriyet Mah (çakırkaş Köyü)",
      "Çarşı Mah (yarımca Köyü)",
      "Çatakbaşı Köyü",
      "Çaybağı Köyü",
      "Çelebi Köyü",
      "Çiftlik Köyü",
      "Değirmentaşı Köyü",
      "Demirbaş Mah (yeşildere Köyü)",
      "Demirci Köyü",
      "Dörtyol Mah (uyandık Köyü)",
      "Durmuşlar Köyü",
      "Ekinbağı Köyü",
      "Ekinözü Köyü",
      "Emirhan Mah (gözecik Köyü)",
      "Esenkavak Mah (yeşildere Köyü)",
      "Esentepe Mah (ekinözü Köyü)",
      "Fatih Mah (yarımca Köyü)",
      "Gedikyurt Köyü",
      "Giyimli Mah (uyandık Köyü)",
      "Göçmezler Köyü",
      "Gökçedal Köyü",
      "Gölbaşı Mah (çatakbaşı Köyü)",
      "Gözecik Köyü",
      "Gülçatı Köyü",
      "Güler Mah (soğukpınar Köyü)",
      "Günceren Mah (aşağımirahmet Köyü)",
      "Güneşli Mah (topağaç Köyü)",
      "Hacı Yusuf Mah (yeşildere Köyü)",
      "Hacımekke Köyü",
      "Hacısam Köyü",
      "Hoşmat Mah (çakırkaş Köyü)",
      "İğdeli Köyü",
      "İncedal Mah (durmuşlar Köyü)",
      "İsaağamezrası Köyü",
      "Kacar Köyü",
      "Kamışlı Mah (soğukpınar Köyü)",
      "Karabörk Köyü",
      "Karagedik Mah (akmezra Köyü)",
      "Karaman Köyü",
      "Karasungur Köyü",
      "Karıncaköy Köyü",
      "Kavakköy Köyü",
      "Kayalık Köyü",
      "Kemaşlı Mah (karasungur Köyü)",
      "Kireçalan Mah (uyandık Köyü)",
      "Kolluca Köyü",
      "Konaklı Mah (değirmentaşı Köyü)",
      "Kopuzlar Mah (uyandık Köyü)",
      "Köprüdere Köyü",
      "Kuşağacı Köyü",
      "Kuşaklı Mah (uyandık Köyü)",
      "Kuşçu Köyü",
      "Levent Mah (soğanlı Köyü)",
      "Mezra Mezrası Mah (kuşçu Köyü)",
      "Mirmehmet Mah (çatakbaşı Köyü)",
      "Muratbağı Köyü",
      "Mustafaköy Köyü",
      "Mutlucan Mah (uyandık Köyü)",
      "Nişankaya Köyü",
      "Okçular Köyü",
      "Osmanağa Köyü",
      "Payamlı Köyü",
      "Piyazgül Mah (karıncaköy Köyü)",
      "Salkımlı Köyü",
      "Saraybahçe Köyü",
      "Sarı Çoban Mah (soğanlı Köyü)",
      "Sarıbuğday Köyü",
      "Selim Mah (çelebi Köyü)",
      "Seyrantepe Mah (yeşildere Köyü)",
      "Soğanlı Köyü",
      "Soğukpınar Köyü",
      "Sorukom Mah (soğanlı Köyü)",
      "Sultanbağ Mah (çelebi Köyü)",
      "Sürekli Köyü",
      "Sütpınar Mah (iğdeli Köyü)",
      "Şekerci Köyü",
      "Şenova Köyü",
      "Tabanözü Köyü",
      "Taşçanak Köyü",
      "Taşören Köyü",
      "Tatar Köyü",
      "Tepebağ Köyü",
      "Topağaç Köyü",
      "Topağaç Mah (çaybağı Köyü)",
      "Topraklı Mah (soğanlı Köyü)",
      "Tuluk Mah (karasungur Köyü)",
      "Uyandık Köyü",
      "Uyandık Mah (çaybağı Köyü)",
      "Uzunova Köyü",
      "Vali Fahribey Köyü",
      "Yamaçova Mah (karaman Köyü)",
      "Yanıkara Mah (gökçedal Köyü)",
      "Yanlızçam Mah (aşağımirahmet Köyü)",
      "Yazıbaşı Köyü",
      "Yenidam Köyü",
      "Yenikaya Mah (sarıbuğday Köyü)",
      "Yeniköy Köyü",
      "Yeşildere Köyü",
      "Yeşilköy Köyü",
      "Yıdıbek Mah (soğanlı Köyü)",
      "Yılbaşı Köyü",
      "Yol Bükü Mah (çakırkaş Köyü)",
      "Yoncalıbayır Köyü",
      "Yukarı Köse Mah (aşağıköse Köyü)",
      "Yukarıdemirli Köyü",
      "Yukarıkanatlı Köyü",
      "Yukarıkazanlar Köyü",
      "Yukarımirahmet Köyü",
      "Yünlüce Mah (değirmentaşı Köyü)"
    ],
    "Maden": [
      "Bahçelievler Mah",
      "Camii Kebir Mah",
      "Acıbadem Mah (çitliköy Köyü)",
      "Ağadibek Köyü",
      "Akboğa Köyü",
      "Akburç Mah (naldöken Köyü)",
      "Altıntarla Köyü",
      "Arslantaşı Köyü",
      "Aşağı Karatop Mah (karatop Köyü)",
      "Aşağı Meydancık Mah (çayırköy Köyü)",
      "Bağarası Mah (dutpınar Köyü)",
      "Bahçe Mah (naldöken Köyü)",
      "Bahçedere Köyü",
      "Bakaçak Mah (dutpınar Köyü)",
      "Bezikan Mah (çayırköy Köyü)",
      "Bük Mah (kaşlıca Köyü)",
      "Camii Mah (çitliköy Köyü)",
      "Cumhuriyetçi Köyü",
      "Çakıroğlu Köyü",
      "Çalkaya Köyü",
      "Çay Mah (naldöken Köyü)",
      "Çayırköm Mah (çitliköy Köyü)",
      "Çayırköy Köyü",
      "Çınarçık Mah (dutpınar Köyü)",
      "Çörekli Mah (tekevler Köyü)",
      "Dağ Mah (polatköy Köyü)",
      "Demokan Mah (naldöken Köyü)",
      "Dere Mah (çitliköy Köyü)",
      "Dere Mah (örtülü Köyü)",
      "Dilekkaya Mah (tekevler Köyü)",
      "Dutpınar Köyü",
      "Eğrikavak Köyü",
      "Göl Önü Mah (gezin Köyü)",
      "Günbağı Mah (kaşlıca Köyü)",
      "Güvendik Mah (durmuştepe Köyü)",
      "Güzelbağ Mah (kayalar Köyü)",
      "Güzelevler Mah (naldöken Köyü)",
      "Hanevleri Köyü",
      "Haraba Mah (cumhuriyetçi Köyü)",
      "Haraba Mah (çitliköy Köyü)",
      "Harabe Mah (tekevler Köyü)",
      "Hatunköy Köyü",
      "Hopanlar Mah (ağadibek Köyü)",
      "Işıktepe Köyü",
      "İstasyon Mah (kızıltepe Köyü)",
      "Karabıyık Mah (çayırköy Köyü)",
      "Karagülle Mah (durmuştepe Köyü)",
      "Karataş Mah (ışıktepe Köyü)",
      "Karatop Köyü",
      "Kartaldere Köyü",
      "Kaşlıca Köyü",
      "Kavak Gazi Ercan Mah (kavak Köyü)",
      "Kavak Kara Ali Mah (kavak Köyü)",
      "Kavak Köyü",
      "Kavak Küçük Bilal Mah (kavak Köyü)",
      "Kayalar Köyü",
      "Kısabekir Mah (sağrılı Köyü)",
      "Kızıltepe Köyü",
      "Kirazlı Mah (cumhuriyetçi Köyü)",
      "Koçkonağı Köyü",
      "Köy Sokağı Mah (kızıltepe Köyü)",
      "Kumyazı Köyü",
      "Kutuşağı Mah (naldöken Köyü)",
      "Küçükkömler Mah (sağrılı Köyü)",
      "Küçükova Köyü",
      "Mastek Mah (karatop Köyü)",
      "Merkez Mah (gezin Köyü)",
      "Meşedibi Mah (karatop Köyü)",
      "Mollalar Mah (çakıroğlu Köyü)",
      "Naldöken Köyü",
      "Nüzul Mah (sağrılı Köyü)",
      "Osman Çayır Mah (çalkaya Köyü)",
      "Örtülü Köyü",
      "Özay Mah (eğrikavak Köyü)",
      "Özyurt Mah (tekevler Köyü)",
      "Plajköy Köyü",
      "Polatköy Köyü",
      "Sağrılı Köyü",
      "Samanlı Mah (çitliköy Köyü)",
      "Sarıkavak Mah (çalkaya Köyü)",
      "Sarıyer Mah (naldöken Köyü)",
      "Seterli Mah (arslantaşı Köyü)",
      "Seyhan Mah (koçkonağı Köyü)",
      "Sinan Mah (durmuştepe Köyü)",
      "Süran Mah (kayalar Köyü)",
      "Şaman Mah (naldöken Köyü)",
      "Şehbayram Mah (kayalar Köyü)",
      "Şehoğlu Mah (yoncapınar Köyü)",
      "Tecer Mah (yoncapınar Köyü)",
      "Tekevler Köyü",
      "Tellikaya Mah (koçkonağı Köyü)",
      "Tellolar Mah (çakıroğlu Köyü)",
      "Tepe Mah (polatköy Köyü)",
      "Tepecik Köyü",
      "Ter Yaylası Mah (arslantaşı Köyü)",
      "Tokmak Mah (karatop Köyü)",
      "Topaluşağı Köyü",
      "Tut Mah (koçkonağı Köyü)",
      "Tuzluca Mah (kumyazı Köyü)",
      "Yalınca Mah (kaşlıca Köyü)",
      "Yeni Mah (naldöken Köyü)",
      "Yenibahçe Köyü",
      "Yeşilova Köyü",
      "Yıldızhan Köyü",
      "Yoncalı Mah (ağadibek Köyü)",
      "Yoncalı Mah (kayalar Köyü)",
      "Yoncapınar Köyü",
      "Yörecik Mah (dutpınar Köyü)",
      "Yukarı Konaklar Mah (çitliköy Köyü)",
      "Yukarı Meydancık Mah (çayırköy Köyü)",
      "Yurtbaşı Mah (örtülü Köyü)",
      "Zahuran Mah (sağrılı Köyü)",
      "Zibe Mah (tekevler Köyü)",
      "Ziyaret Evleri Mah (kartaldere Köyü)",
      "Zuğur Evleri Mah (çalkaya Köyü)"
    ],
    "Merkez": [
      "Abdullah Paşa Mah",
      "Cumhuriyet Mah",
      "Hilalkent Mah",
      "Bahçekapı Mah (akçakiraz Beldesi)",
      "Hürriyet Mah (akçakiraz Beldesi)",
      "Kıraç Mah (akçakiraz Beldesi)",
      "Kültür Mah (akçakiraz Beldesi)",
      "Paşalar Mah (akçakiraz Beldesi)",
      "Yenice Mah (akçakiraz Beldesi)",
      "Yeşilkuşak Mah (akçakiraz Beldesi)",
      "Yeşilyurt Mah (akçakiraz Beldesi)",
      "Yüzbaşı Mah (akçakiraz Beldesi)",
      "Zafer Mah (akçakiraz Beldesi)",
      "Aksaray Mah",
      "Ala Yaprak Mah",
      "Çaydaçıra Mah",
      "Göllü Bağ Mah",
      "Gümüş Kavak Mah",
      "Hayvan Ürünleri Osb Mah",
      "Kızılay Mah",
      "Sugözü Mah",
      "Yıldız Bağları Mah",
      "Doğu Kent Mah",
      "Ağılcık Mah (çalıca Köyü)",
      "Akçakale Mah (akçakale Köyü)",
      "Ali Çavuş Mah (öksüzuşağı Köyü)",
      "Aydınlar Mah (öksüzuşağı Köyü)",
      "Ayranlı Mah (karaali Köyü)",
      "Bahçelievler Mah (hankendi Köyü)",
      "Bakidere Mah (gülpınar Köyü)",
      "Bölüklü Mah (bölüklü Köyü)",
      "Bulutlu Mah (bulutlu Köyü)",
      "Cami Mah (sakabaşı Köyü)",
      "Cansızlar Mah (çalıca Köyü)",
      "Cumhuriyet Mah (gölköy Köyü)",
      "Çalıca Mah (çalıca Köyü)",
      "Çavuş Mah (çalıca Köyü)",
      "Çayırlar Mah (gökçe Köyü)",
      "Çolaklar Mah (öksüzuşağı Köyü)",
      "Danalı Mah (gülpınar Köyü)",
      "Dikili Mah (sütlüce Köyü)",
      "Dilek Mah (hankendi Köyü)",
      "Doloca Mah (koçharmanı Köyü)",
      "Durupınar Mah (durupınar Köyü)",
      "Emiruşağı Mah (sütlüce Köyü)",
      "Gökçe Mah (gökçe Köyü)",
      "Gölköy Mah (gölköy Köyü)",
      "Gözpınar Mah (gözpınar Köyü)",
      "Güleç Mah (bölüklü Köyü)",
      "Gülmahmut Mah (kelmahmut Köyü)",
      "Günaçtı Köyü",
      "Günaçtı Mah (günaçtı Köyü)",
      "Günbağı Mah (günbağı Köyü)",
      "Hacı Ali Mah (bölüklü Köyü)",
      "Hacı Efendi Mah (öksüzuşağı Köyü)",
      "Halilağa Mah (küllük Köyü)",
      "Haraba Cami Mah (çalıca Köyü)",
      "Harikalan Mah (koçharmanı Köyü)",
      "Işıkyolu Mah (ışıkyolu Köyü)",
      "İlyas Mah (sakabaşı Köyü)",
      "Karaali Köyü",
      "Karaali Mah (karaali Köyü)",
      "Kıluşağı Mah (sütlüce Köyü)",
      "Koçharmanı Mah (koçharmanı Köyü)",
      "Konacık Mah (küllük Köyü)",
      "Koparuşağı Mah (koparuşağı Köyü)",
      "Küllük Mah (küllük Köyü)",
      "Kütuşağı Mah (öksüzuşağı Köyü)",
      "Mahmutlu Mah (karaali Köyü)",
      "Meduşağı Mah (küllük Köyü)",
      "Oğulcuk Mah (sütlüce Köyü)",
      "Oluklu Mah (öksüzuşağı Köyü)",
      "Ortaçalı Mah (ortaçalı Köyü)",
      "Özgürler Mah (hankendi Köyü)",
      "Resul Kerim Mah (bölüklü Köyü)",
      "Sakabaşı Mah (sakabaşı Köyü)",
      "Sancaklı Mah (sancaklı Köyü)",
      "Sarıgül Mah (sarıgül Köyü)",
      "Sarılı Mah (sarılı Köyü)",
      "Sarıtosun Mah (gülpınar Köyü)",
      "Sarıyumak Mah (bulutlu Köyü)",
      "Savuşağı Mah (koçharmanı Köyü)",
      "Sinan Mah (sinanköy Köyü)",
      "Sütlüce Köyü",
      "Sütlüce Mah (sütlüce Köyü)",
      "Şabanlı Mah (şabanlı Köyü)",
      "Şahaplı Mah (şahaplı Köyü)",
      "Şehit Saffet Akbaş Mah (öksüzuşağı Köyü)",
      "Şiğolar Mah (sakabaşı Köyü)",
      "Temürköy Mah (temürköy Köyü)",
      "Yağızlar Mah (bölüklü Köyü)",
      "Yalındamlar Mah (yalındamlar Köyü)",
      "Yazıpınarı Mah (yazıpınarı Köyü)",
      "Yedievler Mah (gökçe Köyü)",
      "Yenikonak Mah (yenikonak Köyü)",
      "Yenikonutlar Mah (gökçe Köyü)",
      "Yenimah Mah (sütlüce Köyü)",
      "Yeşilkent Mah (hankendi Köyü)",
      "Yıldız Mah (gökçe Köyü)",
      "Yolçatı Mah (yolçatı Köyü)",
      "Zeynikler Mah (öksüzuşağı Köyü)",
      "Alibey Mah (aydıncık Köyü)",
      "Aydıncık Mah (aydıncık Köyü)",
      "Beşoluk Mah (beşoluk Köyü)",
      "Beydalı Mah (beydalı Köyü)",
      "Beydoğmuş Mah (beydoğmuş Köyü)",
      "Bük Mah (beşoluk Köyü)",
      "Çakıl Mah (aydıncık Köyü)",
      "Çakmaközü Mah (erbildi Köyü)",
      "Çatalharman Mah (çatalharman Köyü)",
      "Çırçır Mah (gümüşbağlar Köyü)",
      "Çolaklı Mah (kurtdere Köyü)",
      "Çömlek Mah (meşeli Köyü)",
      "Düzler-gülmez Mah (gümüşbağlar Köyü)",
      "Ebil Mah (kaplıkaya Köyü)",
      "Ekinli Mah (kurtdere Köyü)",
      "Erbildi Mah (erbildi Köyü)",
      "Gümüşbağlar Mah (gümüşbağlar Köyü)",
      "Güneyçayırı Mah (güneyçayırı Köyü)",
      "Hacıhasan Mah (beydoğmuş Köyü)",
      "Han Mah (meşeli Köyü)",
      "Hıdolar Mah (kurtdere Köyü)",
      "Kabakçılar Mah (kurtdere Köyü)",
      "Kaplıkaya Mah (kaplıkaya Köyü)",
      "Karataş Mah (karataş Köyü)",
      "Koparoğlu Mah (kurtdere Köyü)",
      "Kölemehmet Mah (kurtdere Köyü)",
      "Körpe Mah (körpe Köyü)",
      "Kurtoğlu Mah (kurtdere Köyü)",
      "Kümeevler Mah (gümüşbağlar Köyü)",
      "Meşeli Mah (meşeli Köyü)",
      "Obuz Mah (obuz Köyü)",
      "Oymaağaç Mah (oymaağaç Köyü)",
      "Pinoğlu Mah (çatalharman Köyü)",
      "Salkaya Mah (salkaya Köyü)",
      "Sarıbük Mah (sarıbük Köyü)",
      "Seki Mah (beydoğmuş Köyü)",
      "Serince Mah (serince Köyü)",
      "Tanrıvermiş Mah (aydıncık Köyü)",
      "Toraman Mah (kaplıkaya Köyü)",
      "Yılangeçiren Mah (salkaya Köyü)",
      "Esen Tepe Mah",
      "Fevzi Çakmak Mah",
      "İcadiye Mah",
      "İzzet Paşa Mah",
      "Rızaiye Mah",
      "Safran Mah",
      "Üniversite Mah",
      "Yeni Mah",
      "Acıpayam Mah (acıpayam Köyü)",
      "Alaca Mah (merkez Mah) (alaca Köyü)",
      "Alatarla Mah (alatarla Köyü)",
      "Allahuekber Mah (şahinkaya Köyü)",
      "Alpagut Mah (merkez Mah) (alpağut Köyü)",
      "Altınkuşak Köyü",
      "Altınkuşak Mah (altınkuşak Köyü)",
      "Arındık Mah (merkez Mah) (arındık Köyü)",
      "Asagııçme Mah (içme Köyü)",
      "Aşağı Beyleruşağı Mah (sünköy Köyü)",
      "Aşağıbağ Mah (şeyhhacı Köyü)",
      "Aşağıdemirtaş Mah (aşağıdemirtaş Köyü)",
      "Avcılı Mah (merkez Mah) (avcılı Köyü)",
      "Aydınlar Mah (aydınlar Köyü)",
      "Azozgen Mah (üçağaç Köyü)",
      "Badempınarı Mah (badempınarı Köyü)",
      "Bağdere Mah (bağdere Köyü)",
      "Bağlar Mah (korucu Köyü)",
      "Bağlarca Mah (bağlarca Köyü)",
      "Balıbey Mah (balıbey Köyü)",
      "Ballıca Mah (ballıca Köyü)",
      "Balpınarı Mah (merkez Mah) (balpınar Köyü)",
      "Bektaş Mah (sünköy Köyü)",
      "Beşevler Mah (fatmalı Köyü)",
      "Beşik Mah (merkez Mah) (beşikköy Köyü)",
      "Budaklı Mah (sultanuşağı Köyü)",
      "Bük Mah (yolüstü Köyü)",
      "Cadde Boyu Mah (sultanuşağı Köyü)",
      "Cevizlik Mah (şeyhhacı Köyü)",
      "Cipköy Mah (merkez Mah) (cipköy Köyü)",
      "Çellik Mah (şahinkaya Köyü)",
      "Çırak Mah (üçağaç Köyü)",
      "Çiçek Mah (aşağıdemirtaş Köyü)",
      "Çöteli Mah (merkez Mah) (çöteli Köyü)",
      "Dallıca Mah (dallıca Köyü)",
      "Dambüyük Mah (dambüyük Köyü)",
      "Dedepınarı Mah (dedepınarı Köyü)",
      "Değirmendere Mah (şeyhhacı Köyü)",
      "Değirmenönü Mah (değirmenönü Köyü)",
      "Esenkent Mah (esenkent Köyü)",
      "Fatmalı Mah (fatmalı Köyü)",
      "Gadıderesi Mah (şeyhhacı Köyü)",
      "Gedenek Mah (yemişlik Köyü)",
      "Gedikyolu Mah (gedikyolu Köyü)",
      "Gözebaşı Mah (gözebaşı Köyü)",
      "Güneşli Mah (aşağıdemirtaş Köyü)",
      "Gürdal Mah (hıdırbaba Köyü)",
      "Güzelyalı Mah (güzelyalı Köyü)",
      "Hacı Mah (koçkale Köyü)",
      "Hacıosman Mah (aşağıdemirtaş Köyü)",
      "Hacıömer Mah (yukarıdemirtaş Köyü)",
      "Hal Mah (hal Köyü)",
      "Halil Ağa Mah (sarıkamış Köyü)",
      "Harmantepe Mah (merkez Mah) (harmantepe Köyü)",
      "Hazar Gölü Mah (içme Köyü)",
      "Hıdırbaba Mah (merkez Mah) (hıdırbaba Köyü)",
      "Hıdıroğlu Mah (yemişlik Köyü)",
      "Hoşköy Mah (hoşköy Köyü)",
      "İstasiyon Mah (korucu Köyü)",
      "Kalkantepe Mah (merkez Mah) (kalkantepe Köyü)",
      "Karaçavuş Mah (merkez Mah) (karaçavuş Köyü)",
      "Karagöl Mah (aşağıdemirtaş Köyü)",
      "Karagöl Mah (yukarıdemirtaş Köyü)",
      "Karaman Mah (tohumlu Köyü)",
      "Karasu Mah (yemişlik Köyü)",
      "Karpınar Mah (şahinkaya Köyü)",
      "Kaşıkçılar Mah (sarıkamış Köyü)",
      "Kavakpınar Mah (merkez Mah) (kavakpınar Köyü)",
      "Kavaktepe Mah (kavaktepe Köyü)",
      "Kayalar Mah (balpınar Köyü)",
      "Kengerli Mah (yemişlik Köyü)",
      "Kepektaş Mah (merkez Mah) (kepektaş Köyü)",
      "Kesikköprü Mah (aşağıdemirtaş Köyü)",
      "Kıraç Mah (kıraçköy Köyü)",
      "Kireçli Mah (kıraçköy Köyü)",
      "Koçabağı Mah (sünköy Köyü)",
      "Koçkale Mah (koçkale Köyü)",
      "Kom Mah (kuşhane Köyü)",
      "Konak Mah (dallıca Köyü)",
      "Konakalmaz Mah (konakalmaz Köyü)",
      "Korucu Mah (korucu Köyü)",
      "Koruk Mah (koruköy Köyü)",
      "Korular Mah (balpınar Köyü)",
      "Kozluk Mah (merkez Mah) (kozluk Köyü)",
      "Kumla Mah (kumla Köyü)",
      "Kumlukbağları Mah (sarıyakup Köyü)",
      "Kuruçay Mah (üçağaç Köyü)",
      "Kuşhane Mah (kuşhane Köyü)",
      "Kuyulu Mah (kuyulu Köyü)",
      "Mağara Mah (üçağaç Köyü)",
      "Mansurşağı Mah (sünköy Köyü)",
      "Mastar Mah (değirmenönü Köyü)",
      "Mastar Mah (içme Köyü)",
      "Merkez Mah (muratcık Köyü)",
      "Merkez Mah (poyraz Köyü)",
      "Merkez Mah (yürekli Köyü)",
      "Meryem Mah (yemişlik Köyü)",
      "Mollahasan Mah (sultanuşağı Köyü)",
      "Munzuroğlu Mah (kıraçköy Köyü)",
      "Muzuroğlu Mah (güzelyalı Köyü)",
      "Nuralı Mah (nuralı Köyü)",
      "Ortahan Mah (koruköy Köyü)",
      "Ömerağa Mah (aşağıdemirtaş Köyü)",
      "Örehan Mah (çöteli Köyü)",
      "Örençay Mah (örençay Köyü)",
      "Öztürk Mah (değirmenönü Köyü)",
      "Pelteköy Mah (merkez Mah) (pelteköy Köyü)",
      "Pirinçci Mah (pirinççi Köyü)",
      "Pürüntüz Mah (yemişlik Köyü)",
      "Sarıçubuk Mah (sarıçubuk Köyü)",
      "Sarıkamış Mah (sarıkamış Köyü)",
      "Sarıyakup Mah (sarıyakup Köyü)",
      "Sedeftepe Mah (sedeftepe Köyü)",
      "Sipahi Mah (yemişlik Köyü)",
      "Solhunpınar Mah (karaçavuş Köyü)",
      "Sultanuşağı Köyü",
      "Süleyman Mah (sultanuşağı Köyü)",
      "Sünköy Mah (merkez Mah) (sünköy Köyü)",
      "Şahinkaya Mah (şahinkaya Köyü)",
      "Şavaklı Mah (yürekli Köyü)",
      "Şehsuvar Mah (şehsuvar Köyü)",
      "Şemsiveren Mah (altınkuşak Köyü)",
      "Şıkan Mah (üçağaç Köyü)",
      "Şoş Mah (tohumlu Köyü)",
      "Tadım Mah (tadım Köyü)",
      "Tapanlı Mah (dambüyük Köyü)",
      "Tepeköy Mah (tepeköy Köyü)",
      "Tohumlu Mah (tohumlu Köyü)",
      "Uzuntarla Mah (merkez Mah) (uzuntarla Köyü)",
      "Üçağaç Mah (merkez Mah) (üçağaç Köyü)",
      "Üçtepe Mah (altınkuşak Köyü)",
      "Ürünveren Mah (ürünveren Köyü)",
      "Vartinik Mah (kuşhane Köyü)",
      "Venk Mah (yalnız Köyü)",
      "Veran Mah (şahinkaya Köyü)",
      "Y.içme Mah (içme Köyü)",
      "Yadigar Mah (yemişlik Köyü)",
      "Yalnız Mah (yalnız Köyü)",
      "Yedigöze Mah (yedigöze Köyü)",
      "Yemişlik Mah (yemişlik Köyü)",
      "Yeniköy Mah (yemişlik Köyü)",
      "Yeşilyurt Mah (gözebaşı Köyü)",
      "Yolüstü Mah (yolüstü Köyü)",
      "Yukarı Beyleruşağı Mah (sünköy Köyü)",
      "Yukarıbağ Mah (şeyhhacı Köyü)",
      "Yukarıçakmak Mah (merkez Mah) (yukarıçakmak Köyü)",
      "Yukarıdemirtaş Mah (yukarıdemirtaş Köyü)",
      "Yusuf Mah (beşikköy Köyü)",
      "Alamutsitesi Mah (gölardı Köyü)",
      "Alikaya Mah (karasaz Köyü)",
      "Cevizdere Mah (cevizdere Köyü)",
      "Çağlar Mah (çağlar Köyü)",
      "Dereboğazı Mah (merkez Mah) (dereboğazı Köyü)",
      "Doğankuş Mah (merkez Mah) (doğankuş Köyü)",
      "Elmapınarı Mah (merkez Mah) (elmapınarı Köyü)",
      "Eyüp Bağları Mah (yenikapı Köyü)",
      "Gölardı Mah (merkez Mah) (gölardı Köyü)",
      "Gölardısitesi-1 Mah (gölardı Köyü)",
      "Gölardısitesi-2 Mah (gölardı Köyü)",
      "Gölkenarı Mah (cevizdere Köyü)",
      "Güntaşı Mah (mollakendi Beldesi)",
      "Hacıali Mah (gölardı Köyü)",
      "İkitepe Mah (merkez Mah) (ikitepe Köyü)",
      "Karasaz Mah (merkez Mah) (karasaz Köyü)",
      "Karşıbağ Mah (mollakendi Beldesi)",
      "Kuşcu Mah (cevizdere Köyü)",
      "Mollakendi Mah (mollakendi Beldesi)",
      "Sarıcan Mah (gölardı Köyü)",
      "Seringölsitesi Mah (gölardı Köyü)",
      "Sevsak Mah (gölardı Köyü)",
      "Soğukpınar Mah (cevizdere Köyü)",
      "Sulaf Mah (cevizdere Köyü)",
      "Tepebaşısitesi Mah (gölardı Köyü)",
      "Yenikapı Mah (merkez Mah) (yenikapı Köyü)",
      "Yünlüce Mah (merkez Mah) (yünlüce Köyü)",
      "Çatal Çeşme Mah",
      "Harput Mah",
      "Karşıyaka Mah",
      "Kırklar Mah",
      "Mustafa Paşa Mah",
      "Salı Baba Mah",
      "Sanayi Mah",
      "Ulu Kent Mah",
      "Akpınar Mah",
      "Çarşı Mah",
      "Kültür Mah",
      "Nail Bey Mah",
      "Rüstem Paşa Mah",
      "Sarayatik Mah",
      "Ataşehir Mah",
      "Hicret Mah",
      "Olgunlar Mah",
      "Sürsürü Mah",
      "Cumhuriyet Mah (yazıkonak Beldesi)",
      "Fatih Mah (yazıkonak Beldesi)",
      "Konak Mah (yazıkonak Beldesi)",
      "Merkez Mah (yazıkonak Beldesi)",
      "Sanayi Mah (yazıkonak Beldesi)",
      "Sanayiosb Mah (yazıkonak Beldesi)",
      "Yeni Bağlar Mah (yazıkonak Beldesi)",
      "Akmezra Sahil Önü Mah (yurtbaşı Beldesi)",
      "Bağlar Mah (yurtbaşı Beldesi)",
      "Cumhuriyet Mah (yurtbaşı Beldesi)",
      "Gülpınar Mah (yurtbaşı Beldesi)",
      "Org. Eşref Bitlis Mah (yurtbaşı Beldesi)",
      "Sanayi Mah (yurtbaşı Beldesi)",
      "Yeni Mah (yurtbaşı Beldesi)"
    ],
    "Palu": [
      "Girne Mah (beyhan Beldesi)",
      "Güney Mah (beyhan Beldesi)",
      "İstasyon Mah (beyhan Beldesi)",
      "Karşıyaka Mah (beyhan Beldesi)",
      "Akbulut Köyü",
      "Akdemir Mah (gökdere Köyü)",
      "Aksaray Mah (karataş Köyü)",
      "Akyürek Köyü",
      "Altınölçek Köyü",
      "Andılar Köyü",
      "Arındık Köyü",
      "Atik Köyü",
      "Bahçelievler Mah (baltaşı Köyü)",
      "Balkaya Mah (keklikdere Köyü)",
      "Beydoğan Köyü",
      "Bircan Mah (bozçanak Köyü)",
      "Boğazlı Mah (kayahisar Köyü)",
      "Bozçanak Köyü",
      "Bölükelma Köyü",
      "Burgudere Köyü",
      "Bük Mezrası Mah (köklüce Köyü)",
      "Büyükçaltı Köyü",
      "Çaybaşı Mah (baltaşı Köyü)",
      "Damlapınar Köyü",
      "Dol Küçük Mezrası Mah (köklüce Köyü)",
      "Dutağacı Mah (kırkbulak Köyü)",
      "Eşmekaya Mah (karataş Köyü)",
      "Gemtepe Köyü",
      "Gökdere Köyü",
      "Gömelan Mah (damlapınar Köyü)",
      "Güllüce Köyü",
      "Gümeçbağlar Köyü",
      "Gümüşkaynak Köyü",
      "Gümüşlü Mah (akbulut Köyü)",
      "Hama Mah (bozçanak Köyü)",
      "Hamzabey Mah (karacabağ Köyü)",
      "Hanönü Mah (bozçanak Köyü)",
      "Hasbey Köyü",
      "Hüssam Mah (arındık Köyü)",
      "İncesu Mah (andılar Köyü)",
      "Karacabağ Köyü",
      "Karasalkım Köyü",
      "Karataş Köyü",
      "Kasıl Köyü",
      "Kayahisar Köyü",
      "Kayaönü Köyü",
      "Keklikdere Köyü",
      "Keseköprü Mah (örencik Köyü)",
      "Kırkbulak Köyü",
      "Köklüce Köyü",
      "Köroğlu Mah (üçdeğirmenler Köyü)",
      "Küçükçaltı Köyü",
      "Örencik Köyü",
      "Örgülü Köyü",
      "Payamlı Mah (kırkbulak Köyü)",
      "Pınarbaşı Mah (karasalkım Köyü)",
      "Seydili Köyü",
      "Sivrikaya Mah (gökdere Köyü)",
      "Şeyhpiran Mah (arındık Köyü)",
      "Tarhana Köyü",
      "Taştek Mah (karacabağ Köyü)",
      "Umurca Mah (akyürek Köyü)",
      "Umutkaya Köyü",
      "Üçdeğirmenler Köyü",
      "Yarımtepe Köyü",
      "Yaylacık Mah (kayaönü Köyü)",
      "Yazmacık Mah (akyürek Köyü)",
      "Yeşilbayır Köyü",
      "Aşağı Mah",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Esentepe Mah",
      "Kalekent Mah",
      "Karşıbahçeler Mah",
      "Kültür Mah",
      "Numune Mah",
      "Yenimahalle Mah",
      "Yukarı Palu Mah"
    ],
    "Sivrice": [
      "Ağılözü Mah (kürkköy Köyü)",
      "Akbuğday Köyü",
      "Akseki Köyü",
      "Alaattinköy Köyü",
      "Alıncık Köyü",
      "Ali Topal Mah (topaluşağı Köyü)",
      "Asaf Mah (gelindere Köyü)",
      "Aşağı Çolitır Mah (gözeli Köyü)",
      "Aşağı Mah (çevrimtaş Köyü)",
      "Aşağıçanakçı Köyü",
      "Atayurdu Mah (kösebayır Köyü)",
      "Aylık Mah (kayabağları Köyü)",
      "Badem Ağacı Mah (kürkköy Köyü)",
      "Başkaynak Köyü",
      "Bekçitepe Köyü",
      "Bekerme Mah (akseki Köyü)",
      "Bekirağa Mah (topaluşağı Köyü)",
      "Bekirgölü Mah (gözeli Köyü)",
      "Boğaz Mah (kavallı Köyü)",
      "Cami Mah (gözeli Köyü)",
      "Canbek Mah (üğrük Köyü)",
      "Candı Mah (çatakkaya Köyü)",
      "Cellatlar Mah (dörtbölük Köyü)",
      "Çamurluk Mah (topaluşağı Köyü)",
      "Çatakkaya Köyü",
      "Çelemlik Mah (yaruşağı Köyü)",
      "Çortunlu Köyü",
      "Çöl Dere Mah (kürkköy Köyü)",
      "Dedeyolu Köyü",
      "Değirmen Önü Mah (haftasar Köyü)",
      "Delolar Mah (dörtbölük Köyü)",
      "Demuşağı Mah (çortunlu Köyü)",
      "Derebey Mah (topaluşağı Köyü)",
      "Dereboynu Köyü",
      "Dikmen Köyü",
      "Doğanbağı Köyü",
      "Doğanlar Mah (bekçitepe Köyü)",
      "Dörtbölük Köyü",
      "Durak Mah (bekçitepe Köyü)",
      "Duygulu Köyü",
      "Düztaş Mah (gelindere Köyü)",
      "Elbistan Mah (akbuğday Köyü)",
      "Elmalıdere Mah (nergize Köyü)",
      "Elmasuyu Köyü",
      "Esaflar Mah (gözeli Köyü)",
      "Eski Bağlar Mah (kürkköy Köyü)",
      "Eskiköy Mah (kamışlık Köyü)",
      "Eylolar Mah (gözeli Köyü)",
      "Fenk Mah (akseki Köyü)",
      "Gazazi Mah (görgülü Köyü)",
      "Gelindere Köyü",
      "Göl Mezrası Mah (sürek Köyü)",
      "Göl Önü Mah (kürkköy Köyü)",
      "Gölcük Mah (sürek Köyü)",
      "Görgülü Köyü",
      "Gözeli Köyü",
      "Günay Köyü",
      "Günbalı Köyü",
      "Hacılar Köyü",
      "Hacılar Mah (hacılar Köyü)",
      "Haraba Mah (dörtbölük Köyü)",
      "Hayat Mah (gelindere Köyü)",
      "Hindogiller Mah (yedikardeş Köyü)",
      "Huğ Üzü Mah (kürkköy Köyü)",
      "Ilıncak Köyü",
      "İbokaçlar Mah (gözeli Köyü)",
      "İbolar Mah (soğukpınar Köyü)",
      "İmran Göze Mah (kürkköy Köyü)",
      "Kalaba Köyü",
      "Kaldırım Mah (dörtbölük Köyü)",
      "Kamışlık Köyü",
      "Karlık Mah (haftasar Köyü)",
      "Karşılan Mah (kürkköy Köyü)",
      "Kasaplar Mah (gelindere Köyü)",
      "Kasımuşağı Mah (çortunlu Köyü)",
      "Kavak Mah (akbuğday Köyü)",
      "Kavak Üstü Mah (kavakköy Köyü)",
      "Kavakköy Köyü",
      "Kavallı Köyü",
      "Kayabağları Köyü",
      "Kayapınar Köyü",
      "Keçiler Mah (topaluşağı Köyü)",
      "Kekeç Mah (gözeli Köyü)",
      "Kel Hüseyin Mah (günbalı Köyü)",
      "Kesrik Mah (sürek Köyü)",
      "Kıdiş Mah (topaluşağı Köyü)",
      "Kılıçkaya Köyü",
      "Konak Mah (canuşağı Köyü)",
      "Kösebayır Köyü",
      "Köy Karşısı Mah (dereboynu Köyü)",
      "Kürkköy Köyü",
      "Merkez Mah (canuşağı Köyü)",
      "Merkez Mah (çevrimtaş Köyü)",
      "Merkez Mah (haftasar Köyü)",
      "Merkez Mah (sürek Köyü)",
      "Merkez Mah (topaluşağı Köyü)",
      "Merkez Mah (yedikardeş Köyü)",
      "Moğal Mah (haftasar Köyü)",
      "Molla Hüseyin Mah (günbalı Köyü)",
      "Mullaali Köyü",
      "Nahal Mah (haftasar Köyü)",
      "Nene Gölü Mah (görgülü Köyü)",
      "Nergize Köyü",
      "Omolar Mah (soğukpınar Köyü)",
      "Paha Mah (nergize Köyü)",
      "Sakız Ağacı Mah (kürkköy Köyü)",
      "Sekiler Mah (kavallı Köyü)",
      "Simotlar Mah (gözeli Köyü)",
      "Sincan Mah (dereboynu Köyü)",
      "Soğukpınar Köyü",
      "Söğütler Mah (çatakkaya Köyü)",
      "Suludere Mah (dörtbölük Köyü)",
      "Şirin Mah (gözeli Köyü)",
      "Tahtikler Mah (tarlatepe Köyü)",
      "Tarlatepe Köyü",
      "Taşlıyayla Köyü",
      "Tek Pınar Mah (yedikardeş Köyü)",
      "Teyara Mah (nergize Köyü)",
      "Tilkidere Mah (tarlatepe Köyü)",
      "Tuztaşı/değirmen Mah (kürkköy Köyü)",
      "Urlik Mah (yedikardeş Köyü)",
      "Uslu Köyü",
      "Uzun Çimen Mah (yedikardeş Köyü)",
      "Üçlerce Köyü",
      "Üğrük Köyü",
      "Ürüdüler Mah (topaluşağı Köyü)",
      "Yaruşağı Köyü",
      "Yayla Evleri Mah (çevrimtaş Köyü)",
      "Yaylaevleri Mah (bekçitepe Köyü)",
      "Yazevleri Mah (çatakkaya Köyü)",
      "Yazı Mah (kösebayır Köyü)",
      "Yedipınar Köyü",
      "Yenice Mah (uslu Köyü)",
      "Yeniköy Mah (günay Köyü)",
      "Yukarı Teştek Mah (dereboynu Köyü)",
      "Yukarıçanakçı Köyü",
      "Yürekkaya Köyü",
      "Ziyalar Mah (canuşağı Köyü)",
      "Akpınar Mah",
      "Gölbaşı Mah",
      "Hazar Mah",
      "Karaçalı Mah",
      "Kültür Mah",
      "Olgunlar Mah",
      "Sanayi Mah"
    ]
  },
  "Erzincan": {
    "Çayırlı": [
      "Atatürk Mah",
      "Barbaros Mah",
      "Fatih Mah",
      "Ahmetağa Mah (büyükyaylaköy Köyü)",
      "Akdaş Mah (göller Köyü)",
      "Akdoğan Mah (büyükyaylaköy Köyü)",
      "Arıtaş Mah (çilligöl Köyü)",
      "Aşağı Kom Mah (çayönü Köyü)",
      "Aşağıçamurdere Köyü",
      "Aşağıkartallı Köyü",
      "Balıklı Köyü",
      "Başköy Köyü",
      "Beyin Komu Mah (çaykent Köyü)",
      "Botaş Mah (başköy Köyü)",
      "Boybeyi Köyü",
      "Bozağa Köyü",
      "Bölükova Köyü",
      "Büyükgelengeç Köyü",
      "Büyükyaylaköy Köyü",
      "Cennetpınar Köyü",
      "Çataksu Köyü",
      "Çaykent Köyü",
      "Çayönü Köyü",
      "Çilhoroz Köyü",
      "Çilligöl Köyü",
      "Deliktaş Mah (çilhoroz Köyü)",
      "Deliktaş Mah (göller Köyü)",
      "Direkli Mah (büyükyaylaköy Köyü)",
      "Doğanyuva Köyü",
      "Doluca Köyü",
      "Erbaş İstasyonu Mah (çataksu Köyü)",
      "Esendoruk Köyü",
      "Eşmepınar Köyü",
      "Gelinpınar Köyü",
      "Göller Köyü",
      "Harmantepe Köyü",
      "Hastarla Köyü",
      "Henege Mah (yazıkaya Köyü)",
      "Kahnut Mah (çayönü Köyü)",
      "Karamelik Mah (çayönü Köyü)",
      "Karataş Köyü",
      "Kavaklı Mah (hastarla Köyü)",
      "Küçükgelengeç Köyü",
      "Kümbeler Mah (büyükyaylaköy Köyü)",
      "Mazlumağa Köyü",
      "Mezra Mah (yaylakent Köyü)",
      "Mirzaoğlu Köyü",
      "Oğultaşı Köyü",
      "Ortaçat Köyü",
      "Ozanlı Köyü",
      "Paşayurdu Köyü",
      "Pınarlı Köyü",
      "Saraycık Köyü",
      "Sarıgüney Köyü",
      "Saygılı Köyü",
      "Sırataş Köyü",
      "Şenlik Baba Mah (ozanlı Köyü)",
      "Toprakkale Köyü",
      "Tosunlar Köyü",
      "Turnaçayırı Köyü",
      "Verimli Köyü",
      "Yapraklı Mah (çataksu Köyü)",
      "Yaylakent Köyü",
      "Yaylalar Köyü",
      "Yazıkaya Köyü",
      "Yeşilyaka Köyü",
      "Yukarıçamurdere Köyü",
      "Yukarıkartallı Köyü",
      "Yürekli Köyü"
    ],
    "İliç": [
      "Abdullah Paşa Mah",
      "Fatih Mah",
      "İbrahim Çeçen Mah",
      "Kazım Karabekir Mah",
      "Akçayazı Köyü",
      "Akdoğu Köyü",
      "Altıntaş Köyü",
      "Apuşta Mah (ağıldere Köyü)",
      "Atma Köyü",
      "Bağderesi Mah (turgutlu Köyü)",
      "Bağlıca Köyü",
      "Bahçecik Mah (bağıştaş Köyü)",
      "Balkaya Köyü",
      "Boyalık Köyü",
      "Bozçalı Köyü",
      "Bozyayla Köyü",
      "Bürüncek Köyü",
      "Büyükarmutlu Köyü",
      "Büyükgümüşlü Köyü",
      "Çaltı Köyü",
      "Çayyaka Köyü",
      "Çiftlik Köyü",
      "Çilesiz Köyü",
      "Çobanlı Köyü",
      "Çöpler Köyü",
      "Çörekli Köyü",
      "Dikmen Köyü",
      "Doğan Köyü",
      "Dolugün Köyü",
      "Doruksaray Köyü",
      "Dostal Köyü",
      "Elmacık Mah (çilesiz Köyü)",
      "Garipçay Mah (çayyaka Köyü)",
      "Güngören Köyü",
      "Hasanova Mah (boyalık Köyü)",
      "İslamköy Köyü",
      "Kapıkaya Köyü",
      "Karakaya Köyü",
      "Kayacık Köyü",
      "Kaymaklı Köyü",
      "Konukçu Köyü",
      "Kozluca Köyü",
      "Kuran Köyü",
      "Kuzkışla Köyü",
      "Küçükarmutlu Köyü",
      "Küçükgümüşlü Köyü",
      "Küplüce Mah (sarıkonak Köyü)",
      "Leventpınar Köyü",
      "Merkez Mah (ağıldere Köyü)",
      "Merkez Mah (bağcuğaz Köyü)",
      "Merkez Mah (bağıştaş Köyü)",
      "Merkez Mah (büyükköy Köyü)",
      "Merkez Mah (çaylı Köyü)",
      "Merkez Mah (kuruçay Köyü)",
      "Orta Ağıldere Mah (ağıldere Köyü)",
      "Ortatepe Köyü",
      "Özlü Köyü",
      "Sabırlı Köyü",
      "Sağ Mah (bağcuğaz Köyü)",
      "Sarıkonak Köyü",
      "Sarıpınar Köyü",
      "Sularbaşı Köyü",
      "Sütlüce Köyü",
      "Tabanlı Köyü",
      "Tardere Mah (kuruçay Köyü)",
      "Taşkonak Mah (büyükköy Köyü)",
      "Turgutlu Köyü",
      "Uğur Köyü",
      "Uluyamaç Köyü",
      "Yakuplu Köyü",
      "Yalıngöze Köyü",
      "Yaylapınar Köyü",
      "Yeşilyurt Mah (çaltı Köyü)",
      "Yılmaz Köyü",
      "Yukarı Ağıldere Mah (ağıldere Köyü)"
    ],
    "Kemah": [
      "Aşağıgedik Mah",
      "Beklimçay Mah",
      "Cirgişin Mah",
      "Çarşı Mah",
      "Göğüsbağı Mah",
      "Karşıbağ Mah",
      "Mektepönü Mah",
      "Ortagedik Mah",
      "Pörhenkbaşı Mah",
      "Yukarı Mah",
      "Ağaba Mah (muratboynu Köyü)",
      "Ağaçsaray Köyü",
      "Akbudak Köyü",
      "Akça Köyü",
      "Aksakal Mah (olukpınar Köyü)",
      "Aktaş Köyü",
      "Akyünlü Köyü",
      "Aligıcikgil Mah (karaca Köyü)",
      "Alp Köyü",
      "Antak Mah (kerer Köyü)",
      "Aşağı Mah (dikyamaç Köyü)",
      "Aşağı Mah (elmalı Köyü)",
      "Aşağı Mah (kömür Köyü)",
      "Aşağı Mah (yastıktepe Köyü)",
      "Aşağıavcılar Mah (bozoğlak Köyü)",
      "Aşağıavcılar Mah (kardere Köyü)",
      "Ateşler Mah (karaca Köyü)",
      "Ayranpınar Köyü",
      "Bağlarbaşı Mah (koçkar Köyü)",
      "Bahçe Mah (cevizlik Köyü)",
      "Balkaya Mah (yahşılar Köyü)",
      "Ballı Kışla Mah (gediktepe Köyü)",
      "Buzla Mah (gediktepe Köyü)",
      "Cebesoy İstasyonu Mah (küplü Köyü)",
      "Cemolar Mah (karaca Köyü)",
      "Cevizli Mah (cevizlik Köyü)",
      "Çakşır Mah (atma Köyü)",
      "Çalgı Köyü",
      "Çalıklar Köyü",
      "Çalolar Mah (karaca Köyü)",
      "Çamlıyayla Köyü",
      "Çay Mah (bozoğlak Köyü)",
      "Çay Mah (çiğdemli Köyü)",
      "Çay Mah (dikyamaç Köyü)",
      "Çay Mah (koçkar Köyü)",
      "Çay Mah (muratboynu Köyü)",
      "Dedek Köyü",
      "Dedeoğlu Köyü",
      "Dere Köyü",
      "Doğan Köyü",
      "Doğanbeyli Köyü",
      "Dolmabahçe Mah (hakbilir Köyü)",
      "Doruca Köyü",
      "Dutlu Köyü",
      "Elmalı Mah (seringöze Köyü)",
      "Esentepe Mah (yahşılar Köyü)",
      "Esimli Köyü",
      "Eski Köy Mah (beşikli Köyü)",
      "Eskibağlar Köyü",
      "Gavuryurdu Mah (kedek Köyü)",
      "Gindira Mah (gölkaynak Köyü)",
      "Gökdere Mah (gökkaya Köyü)",
      "Gölbaşı Mah (küplü Köyü)",
      "Gölkaynak Köyü",
      "Gülbahçe Köyü",
      "Güllübağ Mah (kayabaşı Köyü)",
      "Hacıkomu Mah (karaca Köyü)",
      "Hakbilir Köyü",
      "Ilgarlı Köyü",
      "İncedere Köyü",
      "İncesu Mah (hakbilir Köyü)",
      "Kalemis Mah (muratboynu Köyü)",
      "Karadağ Köyü",
      "Karamustafalar Mah (karaca Köyü)",
      "Kardere Köyü",
      "Kardeşler Mah (şahintepe Köyü)",
      "Karşıyaka Mah (koçkar Köyü)",
      "Kayabaşı Köyü",
      "Kazankaya Köyü",
      "Kedek Köyü",
      "Kemeryaka Köyü",
      "Kırıkdere Köyü",
      "Kızılmağara Mah (atma Köyü)",
      "Kızılpınar Mah (koçkar Köyü)",
      "Kızılyazı Mah (yastıktepe Köyü)",
      "Konuksever Köyü",
      "Koruyolu Köyü",
      "Köseler Mah (maksutuşağı Köyü)",
      "Kurt Bahçesi Mah (elmalı Köyü)",
      "Kuşlu Mah (taşbulak Köyü)",
      "Kutluova Köyü",
      "Merkez Mah (atma Köyü)",
      "Merkez Mah (beşikli Köyü)",
      "Merkez Mah (boğaziçi Köyü)",
      "Merkez Mah (bozoğlak Köyü)",
      "Merkez Mah (cevizlik Köyü)",
      "Merkez Mah (çakırlar Köyü)",
      "Merkez Mah (çiğdemli Köyü)",
      "Merkez Mah (dere Köyü)",
      "Merkez Mah (dikyamaç Köyü)",
      "Merkez Mah (eriç Köyü)",
      "Merkez Mah (gediktepe Köyü)",
      "Merkez Mah (gökkaya Köyü)",
      "Merkez Mah (kardere Köyü)",
      "Merkez Mah (kerer Köyü)",
      "Merkez Mah (küplü Köyü)",
      "Merkez Mah (maksutuşağı Köyü)",
      "Merkez Mah (muratboynu Köyü)",
      "Merkez Mah (olukpınar Köyü)",
      "Merkez Mah (seringöze Köyü)",
      "Merkez Mah (şahintepe Köyü)",
      "Merkez Mah (taşbulak Köyü)",
      "Merkez Mah (yahşılar Köyü)",
      "Mermerli Köyü",
      "Mezra Köyü",
      "Oğuz Köyü",
      "Orta Mah (kömür Köyü)",
      "Ötegeçe Mah (kerer Köyü)",
      "Özdamar Köyü",
      "Parmakkaya Köyü",
      "Pınarbaşı Mah (koçkar Köyü)",
      "Samanlı Mah (aktaş Köyü)",
      "Sarıyazı Köyü",
      "Sürek Köyü",
      "Tan Köyü",
      "Tandırbaşı Köyü",
      "Tan'ın Komları Mah (boğaziçi Köyü)",
      "Tuzla Köyü",
      "Uluçınar Köyü",
      "Yağca Köyü",
      "Yardere Köyü",
      "Yazmalı Mah (dikyamaç Köyü)",
      "Yeniyerleşim Mah (yastıktepe Köyü)",
      "Yukarı Çakırlar Mah (çakırlar Köyü)",
      "Yukarı Mah (elmalı Köyü)",
      "Yukarı Mah (kömür Köyü)",
      "Yukarı Mah (yastıktepe Köyü)",
      "Yusuflar Mah (elmalı Köyü)",
      "Yuvacık Mah (dere Köyü)",
      "Yücebelen Köyü"
    ],
    "Kemaliye": [
      "Armağan Köyü",
      "Aşağıumutlu Köyü",
      "Avcı Köyü",
      "Bahçecik Mah (başpınar Köyü)",
      "Balkırı Köyü",
      "Başbağlar Köyü",
      "Buğdaypınar Köyü",
      "Değirmendere Mah (aşağıumutlu Köyü)",
      "Ekindere Mah (şahinler Köyü)",
      "Esence Köyü",
      "Günyolu Köyü",
      "Kavacık Köyü",
      "Komlar Mah (başpınar Köyü)",
      "Kutluca Köyü",
      "Merkez Mah (başpınar Köyü)",
      "Subaşı Köyü",
      "Şahinler Köyü",
      "Yeşilyayla Köyü",
      "Yıldızlı Köyü",
      "Yukarıumutlu Köyü",
      "Adak Köyü",
      "Akçalı Köyü",
      "Akçiçek Mah (dutluca Köyü)",
      "Aşağı Mah (dutluca Köyü)",
      "Aşağı Yuvacık Mah (ocak Köyü)",
      "Boylu Köyü",
      "Çakırtaş Köyü",
      "Çat Köyü",
      "Çit Köyü",
      "Demir Köyü",
      "Efeler Köyü",
      "Karapınar Köyü",
      "Karşı Mah (ocak Köyü)",
      "Kekikpınarı Köyü",
      "Kışlacık Köyü",
      "Kıyı Mezra Mah (karapınar Köyü)",
      "Kızılçukur Mah (efeler Köyü)",
      "Konacık Mah (karapınar Köyü)",
      "Kuşak Köyü",
      "Orta Mah (dutluca Köyü)",
      "Salkımlı Mah (karapınar Köyü)",
      "Topkapı Köyü",
      "Yazmakaya Köyü",
      "Yeni Mah (dutluca Köyü)",
      "Yukarı Mah (dutluca Köyü)",
      "Yukarı Mah (ocak Köyü)",
      "Yukarı Yuvacık Mah (ocak Köyü)",
      "Ariki Mah",
      "Bahçe Mah",
      "Dörtyolağzı Mah",
      "Gençağa Mah",
      "Hacı Yusuf Mah",
      "Halilağa Mah",
      "İshakpaşa Mah",
      "Naip Mah",
      "Sandıkbağı Mah",
      "Taşdibi Mah",
      "Ağıl Köyü",
      "Ağıllar Mah (gümüşçeşme Köyü)",
      "Aksöğüt Köyü",
      "Arslanoba Köyü",
      "Başarı Köyü",
      "Bey Mah (apçağa Köyü)",
      "Cami Mah (tuğlu Köyü)",
      "Çaldere Köyü",
      "Çaltı Mah (gümüşçeşme Köyü)",
      "Çanakçı Köyü",
      "Çerez Mah (apçağa Köyü)",
      "Dallıca Köyü",
      "Dilli Köyü",
      "Dolunay Köyü",
      "Emirli Mah (apçağa Köyü)",
      "Ergü Köyü",
      "Esertepe Mah",
      "Gözaydın Köyü",
      "Güldibi Köyü",
      "Gümüşçeşme Köyü",
      "Hacca Mah (apçağa Köyü)",
      "Harmankaya Köyü",
      "Kabataş Köyü",
      "Karşı Mah (karakoçlu Köyü)",
      "Kayabaşı Mah (apçağa Köyü)",
      "Kemeraltı Mah (apçağa Köyü)",
      "Kocaçimen Köyü",
      "Kozlupınar Köyü",
      "Merekler Mah (tuğlu Köyü)",
      "Merkez Mah (karakoçlu Köyü)",
      "Mescit Mah (tuğlu Köyü)",
      "Nerkat Mah (apçağa Köyü)",
      "Orta Mah (apçağa Köyü)",
      "Ottaş Mah (apçağa Köyü)",
      "Poser Mah (apçağa Köyü)",
      "Salihli Köyü",
      "Sandık Köyü",
      "Sırakonak Köyü",
      "Toybelen Köyü",
      "Ulaş Mah (karakoçlu Köyü)",
      "Yaka Köyü",
      "Yayla Mah (apçağa Köyü)",
      "Yayladamı Köyü",
      "Yeniköy Mah (dilli Köyü)",
      "Yeşilyamaç Köyü",
      "Yeşilyurt Köyü",
      "Yuva Köyü"
    ],
    "Merkez": [
      "Akşemsettin Mah",
      "Atatürk Mah",
      "Barbaros Mah",
      "Başbağlar Mah",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Ersevenler Mah",
      "Fatih Mah",
      "Gülabibey Mah",
      "İzzetpaşa Mah",
      "Karaağaç Mah",
      "Mengüceli Mah",
      "Yunus Emre Mah",
      "Arslanlı Mah",
      "Bahçelievler Mah",
      "Demirkent Mah",
      "Ergenekon Mah",
      "Halitpaşa Mah",
      "Hocabey Mah",
      "İnönü Mah",
      "Kazım Karabekir Mah",
      "Kızılay Mah",
      "Menderes Mah",
      "Mimar Sinan Mah",
      "Osmanlı Mah",
      "Taksim Mah",
      "Yavuz Selim Mah",
      "Yenimahalle Mah",
      "Atatürk Mah (çağlayan Beldesi)",
      "Cumhuriyet Mah (çağlayan Beldesi)",
      "Derebağ Mah (çağlayan Beldesi)",
      "Erdene Mah (çağlayan Beldesi)",
      "Mertekli Mah (çağlayan Beldesi)",
      "Şelale Mah (çağlayan Beldesi)",
      "Yamaçlı Mah (çağlayan Beldesi)",
      "Adalar Mah (binkoç Köyü)",
      "Ahmetli Köyü",
      "Aktepe Mah (soğukoluk Köyü)",
      "Aktoprak Mah",
      "Akyazı Mah",
      "Alsancak Mah",
      "Atatürk Mah (tatlısu Köyü)",
      "Aydoğdu Köyü",
      "Aziz Baba Mah",
      "Bahçeyazı Köyü",
      "Balıbeyi Köyü",
      "Ballı Köyü",
      "Baltaşı Köyü",
      "Barış Mah",
      "Barış Mah (tatlısu Köyü)",
      "Başpınar Mah",
      "Bayrak Mah",
      "Beşiktaş Mah (çatalören Köyü)",
      "Beşsaray Köyü",
      "Binkoç Köyü",
      "Bozyazı Mah",
      "Buğdaylı Mah",
      "Bulutlu Mah",
      "Büyükçakırman Mah",
      "Caferli Köyü",
      "Cafolar Mah (caferli Köyü)",
      "Cemal Gürsel Mah",
      "Cevizli Köyü",
      "Cevizli Mah (çubuklu Köyü)",
      "Cumhuriyet Mah (tatlısu Köyü)",
      "Çadırkaya Mah (ağılözü Köyü)",
      "Çatalarmut Köyü",
      "Çatalören Köyü",
      "Çay Mah (bahçeliköy Köyü)",
      "Çubuklu Köyü",
      "Çukurkuyu Mah",
      "Davarlı Mah",
      "Değirmenköy Mah (değirmenköy Köyü)",
      "Demetevler Mah",
      "Dereyurt Mah",
      "Ekinci Köyü",
      "Ekinli Mah (çubuklu Köyü)",
      "Ekmekli Köyü",
      "Elmaköy Köyü",
      "Ergan Köyü",
      "Ertuğrul Gazi Mah",
      "Esentepe Mah",
      "Eyüp Sultan Mah (uluköy Köyü)",
      "Faikosman Mah (uluköy Köyü)",
      "Fatih Mah (uluköy Köyü)",
      "Ganiefendiçiftliği Köyü",
      "Gazi Mah",
      "Gölcük Mah",
      "Gölpınar Köyü",
      "Göyne Köyü",
      "Güllüce Mah",
      "Gümüştarla Köyü",
      "Günbağı Köyü",
      "Günebakan Köyü",
      "Günebakan Mah (günebakan Köyü)",
      "Gürlevik Köyü",
      "Hacıalipalangası Köyü",
      "Hamidiye Mah",
      "Hancı Mah",
      "Hancıçiftliği Köyü",
      "Hanidere Köyü",
      "Heybeli Köyü",
      "Hoca Ahmet Yesevi Mah",
      "Hürrempalangası Mah",
      "Ilıdere Köyü",
      "Işıkpınar Mah",
      "Kalecik Köyü",
      "Karadiğin Köyü",
      "Karatuş Köyü",
      "Kavakyolu Mah",
      "Keklikkayası Mah",
      "Kılıçkaya Köyü",
      "Kır Mah (günbağı Köyü)",
      "Kilimli Köyü",
      "Koçyatağı Köyü",
      "Konakbaşı Mah (konakbaşı Köyü)",
      "Köklü Mah (çubuklu Köyü)",
      "Köprübaşı Mah (türkmenoğlu Köyü)",
      "Kurtuluş Mah (tatlısu Köyü)",
      "Kurutilek Mah",
      "Küçükçakırman Köyü",
      "Mecidiye Köyü",
      "Memetalibey Mah (binkoç Köyü)",
      "Munzur Mah",
      "Mustafa Kemal Paşa Mah",
      "Müftüoğlu Mah (kilimli Köyü)",
      "Oğlaktepe Köyü",
      "Oluklu Mah (çubuklu Köyü)",
      "Orta Mah (bahçeliköy Köyü)",
      "Ortayurt Mah (ortayurt Köyü)",
      "Osb Mah (aydoğdu Köyü)",
      "Osman Gazi Mah",
      "Özgürlük Mah",
      "Paşa Mah",
      "Pekmezli Köyü",
      "Pınarönü Köyü",
      "Sancak Mah",
      "Sarıgöl Mah",
      "Sazlıpınar Köyü",
      "Saztepe Köyü",
      "Selçuklu Mah",
      "Seyitler Mah (mecidiye Köyü)",
      "Soğukoluk Köyü",
      "Söğütözü Köyü",
      "Sütpınar Köyü",
      "Şehit Cengiz Topel Mah",
      "Şehit Serhat Yurtbaşı Mah",
      "Şehitserhat Mah",
      "Şorak Mah (ağılözü Köyü)",
      "Tandırlı Köyü",
      "Terzibaba Mah",
      "Türkmenoğlu Köyü",
      "Ulalar Mah",
      "Üçkonak Mah",
      "Ürek Mah (ürek Köyü)",
      "Vank Mah (günbağı Köyü)",
      "Yalınca Köyü",
      "Yalnızbağ Mah",
      "Yenidoğan Mah",
      "Yeniköy Köyü",
      "Yeşilçat Köyü",
      "Yeşilçay Köyü",
      "Atatürk Mah (mollaköy Beldesi)",
      "Cumhuriyet Mah (mollaköy Beldesi)",
      "Mahmutlu Mah (mollaköy Beldesi)",
      "Tepecik Mah (mollaköy Beldesi)",
      "Yeşilyurt Mah (mollaköy Beldesi)"
    ],
    "Otlukbeli": [
      "Ağamçağam Köyü",
      "Avcıçayırı Köyü",
      "Boğazlı Köyü",
      "Karadivan Köyü",
      "Küçükotlukbeli Köyü",
      "Mezra Mah (ağamçağam Köyü)",
      "Mezra Mah (söğütlü Köyü)",
      "Ördekhacı Köyü",
      "Söğütlü Köyü",
      "Umurlu Köyü",
      "Yeniköy Köyü",
      "Yeşilbük Köyü",
      "Fatih Mah",
      "Mehmet Akif Ersoy Mah",
      "Şehitler Mah"
    ],
    "Refahiye": [
      "Ağmusa Köyü",
      "Ağtaş Mah (babaaslan Köyü)",
      "Akarsu Köyü",
      "Akbağ Köyü",
      "Akçiğdem Köyü",
      "Akmeşe Mah (ortagöze Köyü)",
      "Alacahan Mah (kürelik Köyü)",
      "Alacatlı Köyü",
      "Alaçayır Köyü",
      "Alapınar Köyü",
      "Altköy Köyü",
      "Ardıçlık Köyü",
      "Armutlu Köyü",
      "Arpayazı Köyü",
      "Aslanyusuf Köyü",
      "Aşağımaden-çamdibi Mah (madendere Köyü)",
      "Aşağısütlü Köyü",
      "Aşut Köyü",
      "Avşarözü Köyü",
      "Aydıncık Köyü",
      "Aydıncık Mah (kamberağa Köyü)",
      "Aydoğan Köyü",
      "Aydoğan Mah (aydoğan Köyü)",
      "Babaaslan Köyü",
      "Babolar Mah (gülensu Köyü)",
      "Bakacak Köyü",
      "Baloğlu Köyü",
      "Baştosun Köyü",
      "Bektaşlı Mah (mendemebaşı Köyü)",
      "Biçer Köyü",
      "Bostandere Köyü",
      "Bölüktepe Köyü",
      "Bulak Mah (ortagöze Köyü)",
      "Cengerli Köyü",
      "Çaltı Köyü",
      "Çamdibi Köyü",
      "Çamlımülk Köyü",
      "Çat Köyü",
      "Çatak Köyü",
      "Çatalçam Köyü",
      "Çavuş Köyü",
      "Çerçiler Mah (diştaş Köyü)",
      "Çıragediği Köyü",
      "Çiçekali Köyü",
      "Çobanlı Mah (resullar Köyü)",
      "Çukurçimen Köyü",
      "Çukuryazı Köyü",
      "Damlaca Köyü",
      "Dedepınar Mah (yukarısütlü Köyü)",
      "Deliktaş Mah (yeniyurt Köyü)",
      "Derebaşı Köyü",
      "Dere-yayla Mah (çukurçimen Köyü)",
      "Dikke--bayırlı Mah (keçegöz Köyü)",
      "Diştaş Köyü",
      "Diyarlar Köyü",
      "Doğandere Köyü",
      "Dolaylı Köyü",
      "Dostolar-uysal Mah (leventler Köyü)",
      "Ekecik Köyü",
      "Emirdere Mah (kamberağa Köyü)",
      "Erecek Köyü",
      "Eskikonak Mah (yeniyurt Köyü)",
      "Gazipınarı Köyü",
      "Gemecik Köyü",
      "Gencolar-esenlik Mah (çukurçimen Köyü)",
      "Gökseki Köyü",
      "Gölcük Mah (kaçak Köyü)",
      "Gölköy Köyü",
      "Gömü Mah (mendemebaşı Köyü)",
      "Gülensu Köyü",
      "Gümüşakar Köyü",
      "Günyüzü Köyü",
      "Güvendik Mah (yaylabeli Köyü)",
      "Güventepe Köyü",
      "Güzle Köyü",
      "Hacıköy Köyü",
      "Halitler Köyü",
      "Hinisler-başaklı Mah (babaaslan Köyü)",
      "Işıklı Mah (gazipınarı Köyü)",
      "İmecik Mah (gülensu Köyü)",
      "İncehatipler Mah (diştaş Köyü)",
      "Kabuller Köyü",
      "Kaçak Köyü",
      "Kadıköy Köyü",
      "Kalkancı Köyü",
      "Kamberağa Köyü",
      "Kandil Köyü",
      "Kanlıtaş Köyü",
      "Karasu Köyü",
      "Karayaprak Köyü",
      "Kardeşler Mah (söğütlü Köyü)",
      "Karyatağı Mah (çamlımülk Köyü)",
      "Kayı Köyü",
      "Kazı Mah (arpayazı Köyü)",
      "Kazören Köyü",
      "Keçegöz Köyü",
      "Kel Süleyman Mah (söğütlü Köyü)",
      "Kerdağ Mah (derebaşı Köyü)",
      "Kersen Köyü",
      "Kınoğlu Mah (tepe Köyü)",
      "Kırantepe Köyü",
      "Kırıktaş Köyü",
      "Kırkbulak Köyü",
      "Kızıleniş Köyü",
      "Koçkaya Köyü",
      "Koço Mah (söğütlü Köyü)",
      "Konakköy Köyü",
      "Kova Mah (yurtbaşı Köyü)",
      "Köçevi Köyü",
      "Körismail Mah (çamlımülk Köyü)",
      "Kuşcullu Mah (sağlık Köyü)",
      "Kuzuluk Köyü",
      "Kürelik Köyü",
      "Laleli Köyü",
      "Leventler Köyü",
      "Madendere Köyü",
      "Memiyurdu Mah (söğütlü Köyü)",
      "Mendemebaşı Köyü",
      "Mendemeköyçukuru Köyü",
      "Merkez Kalkancı Köyü",
      "Muratçayırı Köyü",
      "Mülk Köyü",
      "Olgunlar Köyü",
      "Oluklu Mah (koçkaya Köyü)",
      "Onurlu Köyü",
      "Ortagöze Köyü",
      "Ozan Mah (aşut Köyü)",
      "Ören Köyü",
      "Ören Mah (resullar Köyü)",
      "Örtülü Mah (kırantepe Köyü)",
      "Perçem Köyü",
      "Pınaryolu Köyü",
      "Piroğlu Mah (çamlımülk Köyü)",
      "Resullar Köyü",
      "Resuloğlu Mah (söğütlü Köyü)",
      "Sağlık Köyü",
      "Salur Köyü",
      "Sarhan Köyü",
      "Sarıbayır Köyü",
      "Sarıkoç Köyü",
      "Sıralı Köyü",
      "Söğütlü Köyü",
      "Şahaloğlu Köyü",
      "Şahverdi Köyü",
      "Şaip Köyü",
      "Şakka-çiftlik Mah (bostandere Köyü)",
      "Şıhoruç Mah (gölköy Köyü)",
      "Tahar Mah (konakköy Köyü)",
      "Taşdibi-taşbaşı Mah (arpayazı Köyü)",
      "Taşlıca Mah (söğütlü Köyü)",
      "Teknecik Köyü",
      "Temür Mah (arpayazı Köyü)",
      "Tepe Köyü",
      "Topağaç Köyü",
      "Tosunlu Mah (kızıleniş Köyü)",
      "Tuzlakonağı Mah (ortagöze Köyü)",
      "Tuzluçayır Köyü",
      "Tülü Köyü",
      "Ulucak Köyü",
      "Uludere Köyü",
      "Üçören Köyü",
      "Yağmurtepe Mah (kalkancı Köyü)",
      "Yanık Mah (çamlımülk Köyü)",
      "Yayla Mah (gazipınarı Köyü)",
      "Yayla Mah (yıldızören Köyü)",
      "Yaylabaşı Mah (gazipınarı Köyü)",
      "Yaylabeli Köyü",
      "Yaylacık Mah (şahverdi Köyü)",
      "Yaylapınarı Köyü",
      "Yazı Köyü",
      "Yazı Mah (salur Köyü)",
      "Yazıgediği Köyü",
      "Yeniköy Köyü",
      "Yeniyurt Köyü",
      "Yerlice Mah (diştaş Köyü)",
      "Yıldızören Köyü",
      "Yukarısütlü Köyü",
      "Yukarıyeniköy Köyü",
      "Yurtbaşı Köyü",
      "Yuvadağı Köyü",
      "Yünlüce Mah (güventepe Köyü)",
      "Zereler Mah (gülensu Köyü)",
      "Binali Yıldırım Mah",
      "Camiişerif Mah",
      "Hakoğlu Mah",
      "Hökümet Mah",
      "Yenidoğan Mah"
    ],
    "Tercan": [
      "Camii Kebir Mah (çadırkaya Beldesi)",
      "Gözeler Mah (çadırkaya Beldesi)",
      "Yeni Mah (çadırkaya Beldesi)",
      "Camii Şerif Mah (kargın Beldesi)",
      "İstasyon Mah (kargın Beldesi)",
      "Sucuali Mah (kargın Beldesi)",
      "Şehit Ahmet Aytekin Mah (kargın Beldesi)",
      "Yollarüstü Mah (kargın Beldesi)",
      "Akşemsettin Mah (mercan Beldesi)",
      "Atatürk Mah (mercan Beldesi)",
      "Fatih Mah (mercan Beldesi)",
      "A.tepecik  Mah (iğiki Mah) (ılısu Köyü)",
      "Ağören Köyü",
      "Akmezar Mezrası Mah (balyayla Köyü)",
      "Aktaş Köyü",
      "Akyurt Köyü",
      "Altınkaya Köyü",
      "Altınova Mezrası Mah (bulmuş Köyü)",
      "Arakel Komu Mah (başbudak Köyü)",
      "Armutluk Köyü",
      "Aslan Çayır Mah (gedikdere Köyü)",
      "Aşağı Bahçe Mezrası Mah (konarlı Köyü)",
      "Aşağı Cemal Mezrası Mah (konarlı Köyü)",
      "Aşağı Konarlı Mezrası Mah (konarlı Köyü)",
      "Atçayırı Mah (doluca Köyü)",
      "Azime Mah (yazıören Köyü)",
      "Bağpınar Köyü",
      "Bakçecik Mah (çalkışla Köyü)",
      "Balözü Mezrası Mah (balyayla Köyü)",
      "Balyayla Köyü",
      "Başbudak Köyü",
      "Beğendik Köyü",
      "Beşgöze Köyü",
      "Beşkaya Köyü",
      "Bey Komu Mezrası Mah (yaylım Köyü)",
      "Beykonak Köyü",
      "Bulmuş Köyü",
      "Bulmuş-kom Mah (bulmuş Köyü)",
      "Büklümdere Köyü",
      "Cırnavuk Mah (fındıklı Köyü)",
      "Çalkışla Köyü",
      "Çatakdere Köyü",
      "Çayırdüzü Köyü",
      "Çerme Mah (ılısu Köyü)",
      "Çifteler Mezrası Mah (esenevler Köyü)",
      "Çukuryurt Köyü",
      "Dallıca Köyü",
      "Darıtepe Köyü",
      "Değirmen Arkası Mah (konarlı Köyü)",
      "Demirkapı Mah (darıtepe Köyü)",
      "Dere Mah (yaylım Köyü)",
      "Dereçayırı Mah (ılısu Köyü)",
      "Derviş Mezrası Mah (gedikdere Köyü)",
      "Doluca Köyü",
      "Edebük Köyü",
      "Elaldı Köyü",
      "Elmalı Merkez Mah (elmalı Köyü)",
      "Esenevler Köyü",
      "Fındıklı Köyü",
      "Gafurefendi Köyü",
      "Gedikdere Köyü",
      "Gençali Mah (yaylım Köyü)",
      "Gevenlik Köyü",
      "Girnevik Mah (konarlı Köyü)",
      "Gökçe Köyü",
      "Gökdere Köyü",
      "Gökpınar Köyü",
      "Göktaş Köyü",
      "Göl Mezrası Mah (konarlı Köyü)",
      "Göllüce Mah (yaylım Köyü)",
      "Göncükhan Mah (yaylım Köyü)",
      "Güzbulak Köyü",
      "Hacıbayram Köyü",
      "Harhuru Mah (başbudak Köyü)",
      "Hayranlı Mah (konarlı Köyü)",
      "Hot Mah (yaylım Köyü)",
      "İbrahimağa Mezrası Mah (esenevler Köyü)",
      "İbrahimağa Mezrası Mah (güzbulak Köyü)",
      "İkizler Köyü",
      "İnaklı Mezrası Mah (yaylım Köyü)",
      "İshak Mah (yaylım Köyü)",
      "İsmail Ağa Mah (konarlı Köyü)",
      "Kale Mezrası Mah (gedikdere Köyü)",
      "Kalecik Köyü",
      "Kamer Komu Mah (konarlı Köyü)",
      "Kanço Mezrası Mah (gedikdere Köyü)",
      "Karabaş Mah (konarlı Köyü)",
      "Karacakışlak Köyü",
      "Karacaören Köyü",
      "Karahüseyin Köyü",
      "Karlık Mah (ikizler Köyü)",
      "Karşıkarabaş Mah (konarlı Köyü)",
      "Karumna Mezrası Mah (yaylım Köyü)",
      "Kavaklı Mah (karacakışlak Köyü)",
      "Kavaklık Köyü",
      "Kebani Mezrası Mah (güzbulak Köyü)",
      "Kemerçam Köyü",
      "Keşiş Komu Mah (gedikdere Köyü)",
      "Kızılca Köyü",
      "Kilise Komu Mah (başbudak Köyü)",
      "Kilise Mezrası Mah (yaylım Köyü)",
      "Konarlı Köyü",
      "Kot Mah (yaylım Köyü)",
      "Köprübaşı Köyü",
      "Kösebey Kışlağı Mezrası Mah (yuvalı Köyü)",
      "Közme Mah (konarlı Köyü)",
      "Kurubey Mah (yastıkköy Köyü)",
      "Kurukol Köyü",
      "Kuşlu Mah (yazıören Köyü)",
      "Kuzören Köyü",
      "Küçükağa Köyü",
      "Küllüce Köyü",
      "Kürük Mezrası Mah (yaylım Köyü)",
      "Lolan Mezrası Mah (yaylım Köyü)",
      "Mantarlı Köyü",
      "Mollaveli Mah (yazıören Köyü)",
      "Musa Komu Mah (altınkaya Köyü)",
      "Mustafabey Köyü",
      "Müftüoğlu Köyü",
      "Oğulveren Köyü",
      "Ortakom Mah (doluca Köyü)",
      "Ortaköy Köyü",
      "Oymataş Mah (yaylım Köyü)",
      "Pencirek Mah (konarlı Köyü)",
      "Rosto Mezrası Mah (güzbulak Köyü)",
      "Sağır Komu Mah (başbudak Köyü)",
      "Sağlıca Köyü",
      "Sarıkaya Köyü",
      "Seygi Mezrası Mah (yalınkaş Köyü)",
      "Sırmalı Mah (aktaş Köyü)",
      "Şakirağa Mah (konarlı Köyü)",
      "Şengül Köyü",
      "Tepebaşı Köyü",
      "Topalhasan Köyü",
      "Topdurağı Mah (hacıbayram Köyü)",
      "Üçpınar Köyü",
      "Y.tepecik Mah (iğiki Mah) (ılısu Köyü)",
      "Yalınkaş Köyü",
      "Yamanlar Köyü",
      "Yastıkköy Köyü",
      "Yaylacık Köyü",
      "Yaylayolu Köyü",
      "Yaylım Köyü",
      "Yazıören Köyü",
      "Yeni Köy Mezrası Mah (esenevler Köyü)",
      "Yenibucak Köyü",
      "Yenievler Mah (ikizler Köyü)",
      "Yeşilyayla Köyü",
      "Yoğurtlu  Mah ( Mazan Mah) (yastıkköy Köyü)",
      "Yolluca Mah (çalkışla Köyü)",
      "Yoncalar Mah (konarlı Köyü)",
      "Yukarı Bahçe Mezrası Mah (konarlı Köyü)",
      "Yukarı Büklümdere Mah (büklümdere Köyü)",
      "Yukarı Cemal Mazrası Mah (konarlı Köyü)",
      "Yukarı Gedikdere Mezrası Mah (gedikdere Köyü)",
      "Yukarı Konarlı Mezrası Mah (konarlı Köyü)",
      "Yukarı Pun Mah (ikizler Köyü)",
      "Yukarıkom Mah (konarlı Köyü)",
      "Yuvalı Köyü",
      "Zincirli Mah (aktaş Köyü)",
      "Ahmet Yesevi Mah",
      "Atatürk Mah",
      "Fatih Mah",
      "Kazım Karabekir Mah",
      "Mamahatun Mah",
      "Yavuz Selim Mah"
    ],
    "Üzümlü": [
      "Büyük Kadağan Mah (altınbaşak Beldesi)",
      "Fırat Mahellesi Mah (altınbaşak Beldesi)",
      "İstasyon Mah (altınbaşak Beldesi)",
      "Küçükkadağan Mah (altınbaşak Beldesi)",
      "Pınarbaşı Mah (altınbaşak Beldesi)",
      "Süleymanlı Mahellesi Mah (altınbaşak Beldesi)",
      "Ahmetağa Mah (kureyşlisarıkaya Köyü)",
      "Akbinburnu Mah (kureyşlisarıkaya Köyü)",
      "Akbulut Mah (bayırbağ Köyü)",
      "Akören Ve Aşağı Akören Mah (kureyşlisarıkaya Köyü)",
      "Atatürk Mah (bayırbağ Köyü)",
      "Avcılar Köyü",
      "Bağlar Demirkapı Mah (bağlar Köyü)",
      "Bağlar Köyü",
      "Bahçelievler Mah (bayırbağ Köyü)",
      "Balabanlı Köyü",
      "Bektaş Mah (pelitli Köyü)",
      "Bulanık Köyü",
      "Büyükköy Eski Yerleşim Mah (büyükköy Köyü)",
      "Büyükköy Köyü",
      "Çadırtepe Köyü",
      "Çamlıca Köyü",
      "Çardaklı Dermeli Mezrası Mah (çardaklı Köyü)",
      "Çardaklı Düzali Mezrası Mah (çardaklı Köyü)",
      "Çardaklı Köyü",
      "Çardaklı Murat Komu Mezrası Mah (çardaklı Köyü)",
      "Çardaklı Şako Mezrası Mah (çardaklı Köyü)",
      "Çayıryazı Köyü",
      "Çaykomu Mah (balabanlı Köyü)",
      "Çermik Mah (karakaya Köyü)",
      "Çınarlı Mah (karakaya Köyü)",
      "Çikolar Mah (bağlar Köyü)",
      "Değirmendere Mah (pelitli Köyü)",
      "Demirpınar Köyü",
      "Denizdamı Köyü",
      "Derebük Köyü",
      "Düzali Mah (çardaklı Köyü)",
      "Ergenekon Mah (karakaya Köyü)",
      "Esenyurt Köyü",
      "Eski Avcılar Mah (avcılar Köyü)",
      "Fevzipaşa Mah (karakaya Köyü)",
      "Galca Mah (avcılar Köyü)",
      "Gedikarkası Mah (çardaklı Köyü)",
      "Göller Köyü",
      "Gülpınar Mah (kureyşlisarıkaya Köyü)",
      "Hasanağa Mah (kureyşlisarıkaya Köyü)",
      "İnandık Mah (esenyurt Köyü)",
      "İstasyon Geçit Mah (pelitli Köyü)",
      "Karacalar Eski Köy",
      "Karacalar Köyü",
      "Kazmalı Mah (kureyşlisarıkaya Köyü)",
      "Kom Mah (avcılar Köyü)",
      "Kureyşlisarıkaya Köyü",
      "Maho Mezrası Mah (çardaklı Köyü)",
      "Ocakbaşı Köyü",
      "Orum Mezrası Mah (çardaklı Köyü)",
      "Otluk Köyü",
      "Pelitli Köyü",
      "Pınarlıkaya Köyü",
      "Pişkidağ Köyü",
      "Reso Sarıçam Mah (kureyşlisarıkaya Köyü)",
      "Sağlamlı Mah (ocakbaşı Köyü)",
      "Sansa Mah (bağlar Köyü)",
      "Sedo Mah (kureyşlisarıkaya Köyü)",
      "Yıldız Mah (pelitli Köyü)",
      "Yunus Emre Mah (bayırbağ Köyü)",
      "Babacan Mah",
      "Bahçeşehir Mah",
      "Ciminli Baba Mah",
      "Çavuşlu Mah",
      "Çay Mah",
      "Fatih Mah",
      "Geyikli Mah",
      "Mimar Sinan Mah",
      "Muhsin Yazıcıoğlu Mah",
      "Oruçlu Mah",
      "Piri Sami Mah",
      "Terzibaba Mah",
      "Üçler Mah",
      "Yavuz Selim Mah",
      "Yunus Emre Mah"
    ]
  },
  "Erzurum": {
    "Aşkale": [
      "Abdalcık Mah",
      "Akören Mah",
      "Altıntaş Mah",
      "Bahçelievler Mah",
      "Ballıtaş Mah",
      "Bozburun Mah",
      "Büyükgeçit Mah",
      "Cahit Aybar Mah",
      "Çarşı Mah",
      "Çatalbayır Mah",
      "Çayköy Mah",
      "Çiftlik Bucağı Çatören Mah",
      "Çiftlik Mah",
      "Dağyurdu Mah",
      "Dallı Mah",
      "Demirkıran Mah",
      "Dereköy Mah",
      "Düzyurt Mah",
      "Emek Mah",
      "Esentepe Mah",
      "Eyüpoğlu Mah",
      "Gökçebük Mah",
      "Güllüdere Mah",
      "Gümüşseren Mah",
      "Güneyçam Mah",
      "Gürkaynak Mah",
      "Hacıbekir Mah",
      "Hacıhamza Mah",
      "Hacımahmut Mah",
      "Hatuncuk Mah",
      "Haydarhacı Mah",
      "İstasyon Mah",
      "Kandilli Mah",
      "Kapıkale Mah",
      "Karahasan Mah",
      "Karasu Mah",
      "Kavurmaçukuru Mah",
      "Kıbrıs Mah",
      "Koçbaba Mah",
      "Koşapınar Mah",
      "Kurtmahmut Mah",
      "Küçükgeçit Mah",
      "Küçükova Mah",
      "Kükürtlü Mah",
      "Merdivenköy Mah",
      "Merkez Bucağı Çatören Mah",
      "Merkez Bucağı Gölören Mah",
      "Meydan Mah",
      "Mezrea Mah",
      "Musatanışman Mah",
      "Nahiye Gölören Mah",
      "Ocaklı Mah",
      "Ovacık Mah",
      "Özler Mah",
      "Pırnakaban Mah",
      "Saptıran Mah",
      "Sarıbaba Mah",
      "Sazlı Mah",
      "Şafak Mah",
      "Taşağıl Mah",
      "Taşlıçayır Mah",
      "Tecer Mah",
      "Tepsicik Mah",
      "Tokça Mah",
      "Topalçavuş Mah",
      "Tosunlu Mah",
      "Tozluca Mah",
      "Turaç Mah",
      "Üç Mart Mah",
      "Yaylaköy Mah",
      "Yaylayolu Mah",
      "Yaylımlı Mah",
      "Yeni Mah",
      "Yeniköy Halitpaşa Mah",
      "Yeşilova Mah",
      "Yumruveren Mah"
    ],
    "Aziziye": [
      "Adaçay Mah",
      "Ağcakent Mah",
      "Ağören Mah",
      "Ahırcık Mah",
      "Akdağ Mah",
      "Akyazı Mah",
      "Alaca Mah",
      "Alaybeyi Mah",
      "Aşağı Yenice Mah",
      "Aşağıcanören Mah",
      "Atlıkonak Mah",
      "Aynalıkale Mah",
      "Başçakmak Mah",
      "Başkent Mah",
      "Başkurtdere Mah",
      "Başovacık Mah",
      "Beypınarı Mah",
      "Bingöze Mah",
      "Çamlıca Mah",
      "Çatak Mah",
      "Çavdarlı Mah",
      "Çavuşoğlu Mah",
      "Çıkrıklı Mah",
      "Çiğdemli Mah",
      "Dağdagül Mah",
      "Demirgeçit Mah",
      "Düztoprak Mah",
      "Eğerti Mah",
      "Elmalı Mah",
      "Emrecik Mah",
      "Eskipolat Mah",
      "Eşkinkaya Mah",
      "Gelinkaya Mah",
      "Geyik Mah",
      "Gez Köyüosb Mah",
      "Güllüce Mah",
      "Halilkaya Mah",
      "Ilıca Mah",
      "Kabaktepe Mah",
      "Kahramanlar Mah",
      "Kapulu Mah",
      "Karakale Mah",
      "Kavaklıdere Mah",
      "Kayapa Mah",
      "Kızılkale Mah",
      "Kumluyazı Mah",
      "Kuşçu Mah",
      "Kuzgun Mah",
      "Kuzuluk Mah",
      "Ocak Mah",
      "Ömertepe Mah",
      "Özbek Mah",
      "Özbilen Mah",
      "Paşayurdu Mah",
      "Rizekent Mah",
      "Sakalıkesik Mah",
      "Saltuklu Mah",
      "Sarıyayla Mah",
      "Selçuklu Mah",
      "Sırlı Mah",
      "Sorkunlu Mah",
      "Söğütlü  Mah (ovacık Mah)",
      "Söğütlü Mah",
      "Taşpınar Mah",
      "Tebrizcik Mah",
      "Tınazlı Mah",
      "Toprakkale Mah",
      "Üçköşe Mah",
      "Yarımca Mah",
      "Yeşilova Mah",
      "Yeşilvadi Mah",
      "Yoncalık Mah",
      "Yukarıcanören Mah"
    ],
    "Çat": [
      "Ağaköy Mah",
      "Aşağıçat Mah",
      "Babaderesi Mah",
      "Bağlıca Mah",
      "Bardakçı Mah",
      "Başköy Mah",
      "Bayındır Mah",
      "Bozyazı Mah",
      "Budaklar Mah",
      "Çayırtepe Mah",
      "Çimenözü Mah",
      "Çirişli Mah",
      "Çukurçayır Mah",
      "Değirmenli Mah",
      "Elmapınar Mah",
      "Göbekören Mah",
      "Gökçeşeyh Mah",
      "Gölköy Mah",
      "Hatunköy Mah",
      "İşkinli Mah",
      "Kaplıca Mah",
      "Karabey Mah",
      "Karaca Mah",
      "Karaşeyh Mah",
      "Kızılca Mah",
      "Köseler Mah",
      "Kumaşlı Mah",
      "Kurbanlı Mah",
      "Mollaömer Mah",
      "Muratçayırı Mah",
      "Oyuklu Mah",
      "Parmaksız Mah",
      "Saltaş Mah",
      "Sarıkaşık Mah",
      "Sarıkaya Mah",
      "Soğukpınar Mah",
      "Söbeçayır Mah",
      "Şeyhhasan Mah",
      "Taşağıl Mah",
      "Tuzlataşı Mah",
      "Tuzluca Mah",
      "Yarmak Mah",
      "Yavi Mah",
      "Yaylasuyu Mah",
      "Yukarıçat Mah"
    ],
    "Hınıs": [
      "Acarköy Mah",
      "Akbayır Mah",
      "Akçamelik Mah",
      "Akgelin Mah",
      "Akgöze Mah",
      "Akören Mah",
      "Alaca Mah",
      "Alagöz Mah",
      "Alınteri Mah",
      "Alikırı Mah",
      "Altınpınar Mah",
      "Arpaderesi Mah",
      "Aşağıkayabaşı Mah",
      "Avcılar Mah",
      "Bahçe Mah",
      "Başköy Mah",
      "Bayırköy Mah",
      "Bellitaş Mah",
      "Beyyurdu Mah",
      "Burhanköy Mah",
      "Çakmak Mah",
      "Çamurlu Mah",
      "Çatak Mah",
      "Çilligöl Mah",
      "Dağçayırı Mah",
      "Demirci Mah",
      "Derince Mah",
      "Dervişali Mah",
      "Dibekli Mah",
      "Dikili Mah",
      "Divanhüseyin Mah",
      "Elmadalı Mah",
      "Erbeyli Mah",
      "Erduran Mah",
      "Erence Mah",
      "Esenli Mah",
      "Göller Mah",
      "Gülistan Mah",
      "Güllüçimen Mah",
      "Gürçayır Mah",
      "Güzeldere Mah",
      "Halilçavuş Mah",
      "Hayran Mah",
      "Ilıcaköy Mah",
      "İsmail Mah",
      "Kalecik Mah",
      "Karaağaç Mah",
      "Karabudak Mah",
      "Karakula Mah",
      "Karamolla Mah",
      "Kazancı Mah",
      "Ketenci Mah",
      "Kısık Mah",
      "Kızılahmet Mah",
      "Kızmusa Mah",
      "Kolhisar Mah",
      "Kongur Mah",
      "Köprübaşı Mah",
      "Meydanköy Mah",
      "Mezra Mah",
      "Mollacelil Mah",
      "Mollakulaç Mah",
      "Mutluca Mah",
      "Ortaköy Mah",
      "Ovaçevirme Mah",
      "Ovakozlu Mah",
      "Parmaksız Mah",
      "Pınarbaşı Mah",
      "Pınarköy Mah",
      "Saltepe Mah",
      "Sanayi Mah",
      "Sarılı Mah",
      "Sıldız Mah",
      "Söğütlü Mah",
      "Sultanlı Mah",
      "Suvaran Mah",
      "Şahabettinköy Mah",
      "Şahverdi Mah",
      "Şalgamköy Mah",
      "Tanır Mah",
      "Tapuköy Mah",
      "Taşbudak Mah",
      "Tellitepe Mah",
      "Tipideresi Mah",
      "Toprakkale Mah",
      "Toraman Mah",
      "Uluçayır Mah",
      "Uyanık Mah",
      "Ünlüce Mah",
      "Yamanlar Mah",
      "Yaylakonak Mah",
      "Yelpiz Mah",
      "Yenikent Mah",
      "Yeniköy Mah",
      "Yeşilbahçe Mah",
      "Yeşilyazı Mah",
      "Yolüstü Mah",
      "Yukarıkayabaşı Mah"
    ],
    "Horasan": [
      "Adnan Menderes Mah",
      "Ağıllı Mah",
      "Akçataş Mah",
      "Akçatoprak Mah",
      "Alagöz Mah",
      "Aliçeyrek Mah",
      "Aras Mah",
      "Ardı Mah",
      "Arpaçayır Mah",
      "Aşağıaktaş Mah",
      "Aşağıbademözü Mah",
      "Azap Mah",
      "Bahçe Mah",
      "Bulgurlu Mah",
      "Camii Kebir Mah",
      "Çamlıkale Mah",
      "Çamurlu Mah",
      "Çayırdüzü Mah",
      "Çiftlik Mah",
      "Dalbaşı Mah",
      "Danişment Mah",
      "Değirmenler Mah",
      "Dikili Mah",
      "Döllek Mah",
      "Dönertaş Mah",
      "Eğertaşlar Mah",
      "Esentepe Mah",
      "Fatih Sultan Mehmet Mah",
      "Gerek Mah",
      "Gündeğer Mah",
      "Güzelyayla Mah",
      "Hacıahmet Mah",
      "Hacıhalil Mah",
      "Harçlı Mah",
      "Hasanbaba Mah",
      "Hasanbey Mah",
      "Haydarlı Mah",
      "Hızardere Mah",
      "Hızırilyas Mah",
      "Iğırbığır Mah",
      "İğdeli Mah",
      "İncesu Mah",
      "İnönü Mah",
      "Kadıcelal Mah",
      "Kalender Mah",
      "Karabıyık Mah",
      "Karacaören Mah",
      "Karaçuha Mah",
      "Karapınar Mah",
      "Kaynarca Mah",
      "Kazım Karabekir Mah",
      "Kemerli Mah",
      "Kepenek Mah",
      "Kırık Mah",
      "Kırkdikme Mah",
      "Kırkgözeler Mah",
      "Kırklar Mah",
      "Kızılca Mah",
      "Kızlarkale Mah",
      "Küçükkonak Mah",
      "Kükürtlü Mah",
      "Mollaahmet Mah",
      "Mollamelik Mah",
      "Muratbağı Mah",
      "Mümtaz Turan Mah",
      "Pinarli Mah",
      "Pirali Mah",
      "Pirhasan Mah",
      "Recep Tayyip Erdoğan Mah",
      "Saçlık Mah",
      "Sekman Mah",
      "Şerefiye Mah",
      "Şeyhyusuf Mah",
      "Tahirhoca Mah",
      "Tavşancık Mah",
      "Teknecik Mah",
      "Yarboğaz Mah",
      "Yaylacık Mah",
      "Yazılıtaş Mah",
      "Yeşildere Mah",
      "Yeşilöz Mah",
      "Yıldıran Mah",
      "Yukarıbademözü Mah",
      "Yukarıhorum Mah",
      "Yukarıtahirhoca Mah",
      "Yürükatlı Mah",
      "Yüzören Mah"
    ],
    "İspir": [
      "Ahlatlı Mah",
      "Akgüney Mah",
      "Akpınar Mah",
      "Akseki Mah",
      "Aksu Mah",
      "Aktaş Mah",
      "Alacabük Mah",
      "Araköy Mah",
      "Ardıçlı Mah",
      "Armutlu Mah",
      "Aşağı Fındıklı Mah",
      "Aşağı Özbağ Mah",
      "Atürküten Mah",
      "Avcıköy Mah",
      "Bademli Mah",
      "Bahçeli Mah",
      "Başçeşme Mah",
      "Başköy Mah",
      "Başpınar Mah",
      "Bostancı Mah",
      "Bozan Mah",
      "Cankurtaran Mah",
      "Cibali Mah",
      "Çakmaklı Mah",
      "Çamlıca Mah",
      "Çamlıkaya Mah",
      "Çatakkaya Mah",
      "Çayırbaşı Mah",
      "Çayırözü Mah",
      "Çiçekli Mah",
      "Değirmendere Mah",
      "Değirmenli Mah",
      "Demirbilek Mah",
      "Demirkaya Mah",
      "Devedağı Mah",
      "Duruköy Mah",
      "Düzköy Mah",
      "Elmalı Mah",
      "Gaziler Mah",
      "Geçitağzı Mah",
      "Göçköy Mah",
      "Gölyurt Mah",
      "Gülhas Mah",
      "Güllübağ Mah",
      "Gündoğdu Mah",
      "Güney Mah",
      "Halilpaşa Mah",
      "Irmakköy Mah",
      "İkisu Mah",
      "İncesu Mah",
      "İyidere Mah",
      "Karahan Mah",
      "Karakale Mah",
      "Karakamış Mah",
      "Karakaya Mah",
      "Karaseydi Mah",
      "Karşıyaka Mah",
      "Kavaklı Mah",
      "Kaynakbaşı Mah",
      "Kırık Mah",
      "Kızılhasan Mah",
      "Kirazlı Mah",
      "Koç Mah",
      "Köprüköy Mah",
      "Kümetaş Mah",
      "Leylekköy Mah",
      "Madenköprübaşı Mah",
      "Mescitli Mah",
      "Moryayla Mah",
      "Mülkköy Mah",
      "Numanpaşa Mah",
      "Ortaköy Mah",
      "Ortaören Mah",
      "Özlüce Mah",
      "Öztoprak Mah",
      "Petekli Mah",
      "Pınarlı Mah",
      "Sandıklı Mah",
      "Sırakonak Mah",
      "Soğuksu Mah",
      "Şenköy Mah",
      "Taşbaşı Mah",
      "Taşlıca Mah",
      "Tekpınar Mah",
      "Tepecik Mah",
      "Ulubel Mah",
      "Ulutaş Mah",
      "Üzümbağı Mah",
      "Yağlı Mah",
      "Yaylacık Mah",
      "Yedigöl Mah",
      "Yedigöze Mah",
      "Yeşiltepe Mah",
      "Yeşilyurt Mah",
      "Yıldıztepe Mah",
      "Yukarı Fındıklı Mah",
      "Yukarı Mah",
      "Yukarı Özbağ Mah",
      "Yunusköy Mah",
      "Zeyrek Mah"
    ],
    "Karaçoban": [
      "Akkavak Mah",
      "Bağlar Mah",
      "Bahçeli Mah",
      "Binpınar Mah",
      "Bozyar Mah",
      "Budaklı Mah",
      "Burnaz Mah",
      "Çatalgül Mah",
      "Dedeören Mah",
      "Doğanbey Mah",
      "Duman Mah",
      "Erenler Mah",
      "Erhanlar Mah",
      "Gündüz Mah",
      "Hacılar Mah",
      "Karagöz Mah",
      "Karaköprü Mah",
      "Karmış Mah",
      "Kavaklı Mah",
      "Kırımkaya Mah",
      "Kopal Mah",
      "Kuşluca Mah",
      "Maruf Mah",
      "Molladavut Mah",
      "Ovayoncalı Mah",
      "Sarıveli Mah",
      "Seyhan Mah"
    ],
    "Karayazı": [
      "Abdurrahmanköy Mah",
      "Ağaçlı Mah",
      "Akarsu Mah",
      "Akpınar Mah",
      "Alemdağı Mah",
      "Aliküllek Mah",
      "Anıtlı Mah",
      "Aşağıincesu Mah",
      "Aşağısöylemez Mah",
      "Aydınsu Mah",
      "Bayraktar Mah",
      "Bezirhane Mah",
      "Çakmaközü Mah",
      "Çalışkan Mah",
      "Çaltılı Mah",
      "Çatalören Mah",
      "Çavuşköy Mah",
      "Çayırbeyli Mah",
      "Çelikli Mah",
      "Çepi Mah",
      "Değirmenkaya Mah",
      "Doruca Mah",
      "Dörtpınar Mah",
      "Duruca Mah",
      "Dündar Mah",
      "Elmaağaç Mah",
      "Geventepe Mah",
      "Göksu Mah",
      "Göktepe Mah",
      "Güllü Mah",
      "Hacıbayram Mah",
      "Hasanova Mah",
      "Kapanlı Mah",
      "Karaağıl Mah",
      "Karabey Mah",
      "Karakale Mah",
      "Karakaya Mah",
      "Karasu Mah",
      "Karşıyaka Mah",
      "Kayalar Mah",
      "Kazbel Mah",
      "Kırgındere Mah",
      "Kırıkpınar Mah",
      "Kösehasan Mah",
      "Köyceğiz Mah",
      "Kurupınar Mah",
      "Molla Osman Mah",
      "Mollabekir Mah",
      "Muratlı Mah",
      "Payveren Mah",
      "Salyamaç Mah",
      "Sancaktar Mah",
      "Sarıçiçek Mah",
      "Selenli Mah",
      "Sukonak Mah",
      "Sulutaş Mah",
      "Şakirköy Mah",
      "Taşan Mah",
      "Tosunlu Mah",
      "Turnagöl Mah",
      "Uğurdalı Mah",
      "Ulucanlar Mah",
      "Üzengili Mah",
      "Yahyaköy Mah",
      "Yalındal Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilova Mah",
      "Yeşilyurt Mah",
      "Yiğityolu Mah",
      "Yolgören Mah",
      "Yukarıcihanbey Mah",
      "Yukarıçığılgan Mah",
      "Yukarısöylemez Mah",
      "Yücelik Mah"
    ],
    "Köprüköy": [
      "Ağcaşar Mah",
      "Akçam Mah",
      "Alaca Mah",
      "Aşağıçakmak Mah",
      "Aşağıkızılkale Mah",
      "Ataköy Mah",
      "Buğdaylı Mah",
      "Camikebir Mah",
      "Çullu Mah",
      "Derebaşı Mah",
      "Dilek Mah",
      "Duatepe Mah",
      "Dumankaya Mah",
      "Eğirmez Mah",
      "Emre Mah",
      "Eyüpler Mah",
      "Geyikli Mah",
      "Gölçayır Mah",
      "Güzelhisar Mah",
      "Ilıcasu Mah",
      "Karataşlar Mah",
      "Kayabaşı Mah",
      "Kıyıkonak Mah",
      "Marifet Mah",
      "Mescitli Mah",
      "Ortaklar Mah",
      "Örentaş Mah",
      "Pekecik Mah",
      "Sarıtaş Mah",
      "Savatlı Mah",
      "Soğuksu Mah",
      "Şehitler Mah",
      "Topçu Mah",
      "Yağan Mah",
      "Yapağılı Mah",
      "Yemlik Mah",
      "Yeşilöz Mah",
      "Yılanlı Mah",
      "Yukarıkızılca Mah",
      "Yukarıkızılkale Mah",
      "Yukarısöğütlü Mah",
      "Ziyaret Mah"
    ],
    "Narman": [
      "Alabalık Mah",
      "Alacayar Mah",
      "Araköy Mah",
      "Aşağıyayla Mah",
      "Başkale Mah",
      "Beyler Mah",
      "Boğakale Mah",
      "Camiikebir Mah",
      "Camiisağır Mah",
      "Çamlıyayla Mah",
      "Çimenli Mah",
      "Dağyolu Mah",
      "Demirdağ Mah",
      "Ergazi Mah",
      "Gökdağ Mah",
      "Göllü Mah",
      "Güllüdağ Mah",
      "Güvenlik Mah",
      "Kamışözü Mah",
      "Karadağ Mah",
      "Karapınar Mah",
      "Kışlaköy Mah",
      "Kilimli Mah",
      "Koçkaya Mah",
      "Koyunören Mah",
      "Kuruçalı Mah",
      "Mahmutçavuş Mah",
      "Mercimekli Mah",
      "Otlutepe Mah",
      "Pınaryolu Mah",
      "Samikale Mah",
      "Sapanlı Mah",
      "Savaşçılar Mah",
      "Serinsu Mah",
      "Seyyid Ali Baba Mah",
      "Sülüklü Mah",
      "Sütpınar Mah",
      "Şehitler Mah",
      "Şekerli Mah",
      "Taşburun Mah",
      "Telli Mah",
      "Toygarlı Mah",
      "Tuzla Mah",
      "Yanıktaş Mah",
      "Yoldere Mah",
      "Yukarıyayla Mah"
    ],
    "Oltu": [
      "Alatarla Mah",
      "Arıtaş Mah",
      "Aslanpaşa Mah",
      "Aşağıçamlı Mah",
      "Aşağıkumlu Mah",
      "Ayvalı Mah",
      "Ayyıldız Mah",
      "Bahçecik Mah",
      "Bahçelikışla Mah",
      "Ballıca Mah",
      "Başaklı Mah",
      "Başbağlar Mah",
      "Cumhuriyet Mah",
      "Çamlıbel Mah",
      "Çanakpınar Mah",
      "Çatak Mah",
      "Çatalsöğüt Mah",
      "Çayüstü Mah",
      "Çengelli Mah",
      "Dağdibi Mah",
      "Damarlıtaş Mah",
      "Demirtaş Mah",
      "Derebaşı Mah",
      "Dokuzdeğirmen Mah",
      "Duralar Mah",
      "Elmadüzü Mah",
      "Erdoğmuş Mah",
      "Esenyamaç Mah",
      "Gökçedere Mah",
      "Günlüce Mah",
      "Güryaprak Mah",
      "Güzelsu Mah",
      "Halitpaşa Mah",
      "İğdeli Mah",
      "İnanmış Mah",
      "İnci Mah",
      "İpekçayırı Mah",
      "İriağaç Mah",
      "Kaleboğazı Mah",
      "Karabekir Mah",
      "Karataş Mah",
      "Kayaaltı Mah",
      "Kemerkaya Mah",
      "Konukseven Mah",
      "Küçükorucuk Mah",
      "Nüğürcük Mah",
      "Obayayla Mah",
      "Orucuk Mah",
      "Özdere Mah",
      "Sağlıcak Mah",
      "Sarısaz Mah",
      "Subatuk Mah",
      "Süleymanlı Mah",
      "Sülünkaya Mah",
      "Şehitler Mah",
      "Şendurak Mah",
      "Tekeli Mah",
      "Toklu Mah",
      "Topkaynak Mah",
      "Toprakkale Mah",
      "Tutlu Mah",
      "Tutmaç Mah",
      "Tuzla Mah",
      "Ünlükaya Mah",
      "Vişneli Mah",
      "Yarbaşı Mah",
      "Yasin Haşimoğlu Mah",
      "Yaylaçayır Mah",
      "Yolboyu Mah",
      "Yukarıçamlı Mah",
      "Yukarıkumlu Mah",
      "Yusuf Ziyabey Mah"
    ],
    "Olur": [
      "Akbayır Mah",
      "Aktepe Mah",
      "Altunkaya Mah",
      "Aşağıçayırlı Mah",
      "Aşağıkaracasu Mah",
      "Atlı Mah",
      "Beğendik Mah",
      "Beşkaya Mah",
      "Boğazgören Mah",
      "Bozdoğan Mah",
      "Coşkunlar Mah",
      "Çataksu Mah",
      "Eğlek Mah",
      "Ekinlik Mah",
      "Filizli Mah",
      "Güngöründü Mah",
      "Hükkam Mah",
      "Ilıkaynak Mah",
      "Kaban Mah",
      "Kaledibi Mah",
      "Karakoçlar Mah",
      "Keçili Mah",
      "Kekikli Mah",
      "Köprübaşı Mah",
      "Merkez Mah",
      "Merkez Yeşilbağlar Mah",
      "Oğuzkent Mah",
      "Olgun Mah",
      "Olurdere Mah",
      "Ormanağzı Mah",
      "Sarıbaşak Mah",
      "Soğukgöze Mah",
      "Süngübayır Mah",
      "Şalpazarı Mah",
      "Taşgeçit Mah",
      "Uzunharman Mah",
      "Ürünlü Mah",
      "Yaylabaşı Mah",
      "Yeşilbağlar Mah",
      "Yıldızkaya Mah",
      "Yolgözler Mah",
      "Yukarıçayırlı Mah",
      "Yukarıkaracasu Mah"
    ],
    "Palandöken": [
      "Abdurrahman Gazi Mah",
      "Adnan Menderes Mah",
      "Ali Bezirgan Mah",
      "Aziziye Mah",
      "Dereboğazı Mah",
      "Güzelyurt Mah",
      "Hüseyin Avni Ulaş Mah",
      "Nene Hatun Mah",
      "Tekkederesi Mah",
      "Uzun Ahmet Mah",
      "Yıkılgan Mah",
      "Yukarıyenice Mah",
      "Yunusemre Mah",
      "Börekli Mah",
      "Çeperli Mah",
      "Güllü Mah",
      "Hancığaz Mah",
      "Konaklı Mah",
      "Kümbet Mah",
      "Müftü Solakzade Mah",
      "Sığırlı Mah",
      "Şehitler Mah",
      "Taşlıgüney Mah",
      "Tepeköy Mah",
      "Toparlak Mah",
      "Yağmurcuk Mah"
    ],
    "Pasinler": [
      "Acı Mah",
      "Ağaçminare Mah",
      "Ağcalar Mah",
      "Altınbaşak Mah",
      "Alvar Mah",
      "Ardıçlı Mah",
      "Aşıtlar Mah",
      "Bahçelievler Mah",
      "Baldızı Mah",
      "Başören Mah",
      "Bulkasım Mah",
      "Büyükdere Mah",
      "Büyüktüy Mah",
      "Camikebir Mah",
      "Çakırtaş Mah",
      "Çalıyazı Mah",
      "Çamlıca Mah",
      "Çiçekli Mah",
      "Çöğender Mah",
      "Demirdöven Mah",
      "Emirşeyh Mah",
      "Epsemce Mah",
      "Erzurumkapı Mah",
      "Esendere Mah",
      "Gerdekkaya Mah",
      "Gölciğez Mah",
      "Hanahmet Mah",
      "Hasandede Mah",
      "Kaplıcalar Mah",
      "Karakale Mah",
      "Karavelet Mah",
      "Kasımpaşa Mah",
      "Kavuşturan Mah",
      "Kethuda Mah",
      "Kevenlik Mah",
      "Kızılören Mah",
      "Kotandüzü Mah",
      "Kurbançayır Mah",
      "Kurtuluş Mah",
      "Küçüktüy Mah",
      "Otlukkapı Mah",
      "Ovaköy Mah",
      "Övenler Mah",
      "Paşabey Mah",
      "Pelitli Mah",
      "Porsuk Mah",
      "Pusudere Mah",
      "Reşadiye Mah",
      "Saksı Mah",
      "Serçeboğazı Mah",
      "Sivas Mah",
      "Sunak Mah",
      "Şehit Burak Karakoç Mah",
      "Taşağıl Mah",
      "Taşkaynak Mah",
      "Taşlıgüney Mah",
      "Taşlıyurt Mah",
      "Tepecik Mah",
      "Timar Mah",
      "Uzunark Mah",
      "Üğümü Mah",
      "Yamaç Mah",
      "Yastıktepe Mah",
      "Yavuzlu Mah",
      "Yayla Mah",
      "Yayladağ Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yiğitpınarı Mah",
      "Yiğittaşı Mah",
      "Yukarıçakmak Mah",
      "Yukarıdanişment Mah"
    ],
    "Pazaryolu": [
      "21 Haziran Mah",
      "Akbulut Mah",
      "Alıçlı Mah",
      "Ambaralan Mah",
      "Ayçukuru Mah",
      "Bayındır Mah",
      "Burçaklı Mah",
      "Büyükdere Mah",
      "Cennetpınarı Mah",
      "Cevizlidere Mah",
      "Çatakbahçe Mah",
      "Çaydere Mah",
      "Çiftepınar Mah",
      "Deliktaş Mah",
      "Demirgöze Mah",
      "Dikmetaş Mah",
      "Esenyurt Mah",
      "Gölyanı Mah",
      "Göztepe Mah",
      "Gülçimen Mah",
      "Güneysu Mah",
      "Hacılar Mah",
      "Karakoç Mah",
      "Karataş Mah",
      "Kılıççı Mah",
      "Konakyeri Mah",
      "Korkutköy Mah",
      "Kozlu Mah",
      "Köşeyolu Mah",
      "Kumaşkaya Mah",
      "Kuymaklı Mah",
      "Kümbettepe Mah",
      "Laleli Mah",
      "Merkez Mah",
      "Meşebaşı Mah",
      "Pamukludağ Mah",
      "Sadaka Mah",
      "Sergenkaya Mah",
      "Süleymanbağı Mah",
      "Şehitlik Mah",
      "Yaylalı Mah",
      "Yaylaözü Mah",
      "Yeni Mah",
      "Yiğitbaşı Mah"
    ],
    "Şenkaya": [
      "Akşar Mah",
      "Aktaş Mah",
      "Alıcık Mah",
      "Aşağı Mah",
      "Aşağıbakraçlı Mah",
      "Atyolu Mah",
      "Aydoğdu Mah",
      "Balkaya Mah",
      "Bereketli Mah",
      "Beşpınarlar Mah",
      "Beykaynak Mah",
      "Çamlıalan Mah",
      "Çatalelma Mah",
      "Değirmenlidere Mah",
      "Deliktaş Mah",
      "Doğanköy Mah",
      "Dokuzelma Mah",
      "Dolunay Mah",
      "Dörtyol Mah",
      "Esence Mah",
      "Esenyurt Mah",
      "Evbakan Mah",
      "Gaziler Mah",
      "Gezenek Mah",
      "Göllet Mah",
      "Göreşken Mah",
      "Gözalan Mah",
      "Gözebaşı Mah",
      "Gülveren Mah",
      "Hoşköy Mah",
      "İçmesu Mah",
      "İğdeli Mah",
      "İkizpınar Mah",
      "İnceçay Mah",
      "Kayalısu Mah",
      "Kaynak Mah",
      "Kireçli Mah",
      "Köroğlu Mah",
      "Köşkköy Mah",
      "Kürkçü Mah",
      "Nişantaşı Mah",
      "Ormanlı Mah",
      "Oyuktaş Mah",
      "Özyurt Mah",
      "Paşalı Mah",
      "Penek Mah",
      "Sarıkayalar Mah",
      "Sarıyar Mah",
      "Sındıran Mah",
      "Söğütler Mah",
      "Susuz Mah",
      "Şenpınar Mah",
      "Tahtköy Mah",
      "Tazeköy Mah",
      "Teketaş Mah",
      "Timurkışla Mah",
      "Turnalı Mah",
      "Tütenocak Mah",
      "Uğurlu Mah",
      "Yanıkkaval Mah",
      "Yaymeşe Mah",
      "Yazılı Mah",
      "Yelkıran Mah",
      "Yeşildemet Mah",
      "Yeşilkaya Mah",
      "Yoğurtçular Mah",
      "Yukarı Mah",
      "Yukarıbakraçlı Mah",
      "Yünören Mah",
      "Yürekli Mah",
      "Zümrüt Mah"
    ],
    "Tekman": [
      "Ağcakoca Mah",
      "Akdağ Mah",
      "Akdamar Mah",
      "Akpınar Mah",
      "Alabayır Mah",
      "Aşağıhanbeyi Mah",
      "Aşağıtepecik Mah",
      "Aydınlı Mah",
      "Aydınlık Mah",
      "Beşdere Mah",
      "Beyköy Mah",
      "Cihan Mah",
      "Çağlar Mah",
      "Çatak Mah",
      "Çatkale Mah",
      "Çayırdağı Mah",
      "Çevirme Mah",
      "Çiçekdağı Mah",
      "Çukuryayla Mah",
      "Dalsöğüt Mah",
      "Deliler Mah",
      "Dengiz Mah",
      "Düzyurt Mah",
      "Erence Mah",
      "Geçitköy Mah",
      "Gökoğlan Mah",
      "Gözlüce Mah",
      "Gülveren Mah",
      "Gümüşlük Mah",
      "Gündamı Mah",
      "Güneşli Mah",
      "Gürgür Mah",
      "Güzeldere Mah",
      "Hacıömer Mah",
      "Hamzalar Mah",
      "Hürriyet Mah",
      "Hüseyinağa Mah",
      "Ilıgöze Mah",
      "Işıklar Mah",
      "İncesu Mah",
      "İsmetpaşa Mah",
      "Kalaycı Mah",
      "Karapınar Mah",
      "Karataş Mah",
      "Karatepe Mah",
      "Karlıca Mah",
      "Katranlı Mah",
      "Kayaboğaz Mah",
      "Kazancık Mah",
      "Kırıkan Mah",
      "Koçyayla Mah",
      "Körsu Mah",
      "Kuruca Mah",
      "Küllü Mah",
      "Mescitli Mah",
      "Mollamehmet Mah",
      "Susuz Mah",
      "Şakşak Mah",
      "Taşkesen Mah",
      "Toptepe Mah",
      "Turnagöl Mah",
      "Vatan Mah",
      "Yalınca Mah",
      "Yerköy Mah",
      "Yeşilören Mah",
      "Yiğitler Mah",
      "Yoncalı Mah",
      "Yukarıhanbeyi Mah",
      "Yukarıtepecik Mah",
      "Yuvaklı Mah",
      "Yücepınar Mah"
    ],
    "Tortum": [
      "Akbaba Mah",
      "Aksu Mah",
      "Aktaş Mah",
      "Alapınar Mah",
      "Alparslan Mah",
      "Arılı Mah",
      "Aşağı Serdarlı Mah",
      "Bağbaşı Mah",
      "Bahçeli Mah",
      "Ballı Mah",
      "Cihanlı Mah",
      "Çakıllı Mah",
      "Çamlıca Mah",
      "Çardaklı Mah",
      "Çataldere Mah",
      "Çaylıca Mah",
      "Çiftlik Mah",
      "Çivilikaya Mah",
      "Demirciler Mah",
      "Derekapı Mah",
      "Derinpınar Mah",
      "Dikmen Mah",
      "Doruklu Mah",
      "Esendurak Mah",
      "Gökdere Mah",
      "Hamidiye Mah",
      "İncedere Mah",
      "Kaleboynu Mah",
      "Kaledibi Mah",
      "Kapıkaya Mah",
      "Karlı Mah",
      "Kazandere Mah",
      "Kemerkaya Mah",
      "Kırmalı Mah",
      "Kireçli Mah",
      "Konak Mah",
      "Meydanlar Mah",
      "Pehlivanlı Mah",
      "Peynirli Mah",
      "Serdarlı Mah",
      "Söğütlü Mah",
      "Suyatağı Mah",
      "Şenyurt Mah",
      "Taşbaşı Mah",
      "Taşoluk Mah",
      "Tatlısu Mah",
      "Tipili Mah",
      "Tortumkale Mah",
      "Uzunkavak Mah",
      "Vişneli Mah",
      "Yağcılar Mah",
      "Yamankaya Mah",
      "Yavuz Sultan Selim Mah",
      "Yazyurdu Mah",
      "Yellitepe Mah",
      "Yukarısivri Mah",
      "Yumaklı Mah",
      "Ziyaretli Mah"
    ],
    "Uzundere": [
      "Altınçanak Mah",
      "Balıklı Mah",
      "Cevizli Mah",
      "Cömertler Mah",
      "Çağlayan Mah",
      "Çamlıyamaç Mah",
      "Çaybaşı Mah",
      "Dikyar Mah",
      "Erikli Mah",
      "Gölbaşı Mah",
      "Kirazlı Mah",
      "Merkez Mah",
      "Muratefendi Mah",
      "Sapaca Mah",
      "Seyitefendi Mah",
      "Ulubağ Mah",
      "Uzundere Mah",
      "Yayla Mah"
    ],
    "Yakutiye": [
      "Şükrüpaşa Mah",
      "Aktoprak Mah",
      "Altınbulak Mah",
      "Altıntepe Mah",
      "Çiftlik Mah",
      "Değirmenler Mah",
      "Gülpınar Mah",
      "Güzelova Mah",
      "Karasu Mah",
      "Kırmızıtaş Mah",
      "Muratgeldi Mah",
      "Üniversite Mah",
      "Yeşilyayla Mah",
      "Akdağ Mah",
      "Arıbahçe Mah",
      "Çayırca Mah",
      "Çayırtepe Mah",
      "Dadaşköy Mah",
      "Dumlu Mah",
      "Gökçeyamaç Mah",
      "Güngörmez Mah",
      "Güzelyayla Mah",
      "İbrahim Hakkı Mah",
      "Karagöbek Mah",
      "Kazım Karabekir Paşa Mah",
      "Kırkgöze Mah",
      "Köse Mehmet Mah",
      "Köşkköy Mah",
      "Kurtuluş Mah",
      "Lalapaşa Mah",
      "Muratpaşa Mah",
      "Mülk Mah",
      "Orta Düzü Mah",
      "Ömer Nasuhi Bilmen Mah",
      "Rabia Ana Mah",
      "Soğukçermik Mah",
      "Söğütyanı Mah",
      "Şenyurt Mah",
      "Umudum Mah",
      "Uzunyayla Mah",
      "Yazı Pınarı Mah",
      "Yerli Su Mah",
      "Yeşildere Mah",
      "Yeşilova Mah"
    ]
  },
  "Eskişehir": {
    "Alpu": [
      "Ağaçhisar Mah",
      "Aktepe Mah",
      "Alapınar Mah",
      "Arıkaya Mah",
      "Bahçecik Mah",
      "Başören Mah",
      "Belkese Mah",
      "Bozan Mah",
      "Büğdüz Mah",
      "Çardakbaşı Mah",
      "Çerkez Çukurhisar Mah",
      "Dereköy Mah",
      "Esence Mah",
      "Fatih Mah",
      "Fevzi Paşa Mah",
      "Fevziye Mah",
      "Gökçekaya Mah",
      "Gökçeoğlu Mah",
      "Güroluk Mah",
      "Işıkören Mah",
      "Karacaören Mah",
      "Karakamış Mah",
      "Kemalpaşa Mah",
      "Koşmat Mah",
      "Mamure Mah",
      "Osmaniye Mah",
      "Özdenk Mah",
      "Sakarıkaracaören Mah",
      "Sarıkavak Mah",
      "Söğütçük Mah",
      "Uyuzhamamköyü Mah",
      "Yeşildon Mah",
      "Yunusemre Mah"
    ],
    "Beylikova": [
      "Akköprü Mah",
      "Aşağıdudaş Mah",
      "Aşağıiğdeağacı Mah",
      "Ata Mah",
      "Doğanoğlu Mah",
      "Doğray Mah",
      "Emircik Mah",
      "Gökçeayva Mah",
      "Halilbağı Mah",
      "İkipınar Mah",
      "İmikler Mah",
      "Kızılcaören Mah",
      "Köprübaşı Mah",
      "Köprübaşı Osb Mah",
      "Okçu Mah",
      "Parsıbey Mah",
      "Rahmiye Mah",
      "Sultaniye Mah",
      "Süleymaniye Mah",
      "Uzunburun Mah",
      "Yalınlı Mah",
      "Yeni Mah",
      "Yeniyurt Mah",
      "Yukarıdudaş Mah",
      "Yukarıiğdeağacı Mah",
      "Yunus Emre Mah"
    ],
    "Çifteler": [
      "Abbashalimpaşa Mah",
      "Adalar Mah",
      "Alikan Mah",
      "Arslanlı Mah",
      "Başkurt Mah",
      "Belpınar Mah",
      "Çatmapınar Mah",
      "Çiftçi Mah",
      "Dikilikaya Mah",
      "Dikmen Mah",
      "Doğanay Mah",
      "Eminekin Mah",
      "Erbap Mah",
      "Hayriye Mah",
      "Ilıcabaşı Mah",
      "Kadıkuyusu Mah",
      "Körhasan Mah",
      "Orhaniye Mah",
      "Ortaköy Mah",
      "Osmaniye Mah",
      "Sadıroğlu Mah",
      "Saithalimpaşa Mah",
      "Sakarya Mah",
      "Sarıkavak Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yıldızören Mah",
      "Zaferhamit Mah"
    ],
    "Günyüzü": [
      "Atlas Mah",
      "Ayvalı Mah",
      "Bedil Mah",
      "Beyyayla Mah",
      "Çakmak Mah",
      "Çardaközü Mah",
      "Doğray Mah",
      "Fatih Mah",
      "Gecek Mah",
      "Gümüşkonak Mah",
      "Kavacık Mah",
      "Kavuncu Mah",
      "Kayakent Mah",
      "Kuzören Mah",
      "Mercan Mah",
      "Özler Mah",
      "Sümer Mah",
      "Tutlu Mah",
      "Yağrı Mah",
      "Yazır Mah",
      "Yenikent Mah",
      "Yeşilyaka Mah"
    ],
    "Han": [
      "Ağlarca Mah",
      "Akdere Mah",
      "Akhisar Mah",
      "Başara Mah",
      "Erten Mah",
      "Gökçekuyu Mah",
      "Gökçeyayla Mah",
      "Hacılar Mah",
      "Hankaraağaç Mah",
      "Hüsrevpaşa Mah",
      "İskankuyu Mah",
      "Kayı Mah",
      "Peçene Mah",
      "Tepeköy Mah",
      "Yazılı Mah"
    ],
    "İnönü": [
      "Aşağıkuzfındık Mah",
      "Çarşı Mah",
      "Dereyalak Mah",
      "Dutluca Mah",
      "Erenköy Mah",
      "Esnemez Mah",
      "İsmetpaşa Mah",
      "Kümbet Mah",
      "Kümbetakpınar Mah",
      "Kümbetyeniköy Mah",
      "Oklubalı Mah",
      "Orta Mah",
      "Seyitaliköyü Mah",
      "Yenice Mah",
      "Yukarıkuzfındık Mah",
      "Yürükyayla Mah"
    ],
    "Mahmudiye": [
      "Akyurt Mah",
      "Balçıkhisar Mah",
      "Çal Mah",
      "Doğanca Mah",
      "Fahriye Mah",
      "Güllüce Mah",
      "Hamidiye Mah",
      "Işıklar Mah",
      "İsmetpaşa Mah",
      "Kaymazyayla Mah",
      "Mesudiye Mah",
      "Orta Mah",
      "Şerefiye Mah",
      "Tokathan Mah",
      "Topkaya Mah",
      "Türkmenmecidiye Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilyurt Mah"
    ],
    "Mihalgazi": [
      "Alpagut Mah",
      "Bozaniç Mah",
      "Cumhuriyet Mah",
      "Demirciler Mah",
      "Dokuz Mayıs Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karaoğlan Mah",
      "Sakarıılıca Mah"
    ],
    "Mihalıççık": [
      "Adahisar Mah",
      "Ahur Mah",
      "Ahurözü Mah",
      "Akçaören Mah",
      "Aydınlar Mah",
      "Bahtiyar Mah",
      "Belen Mah",
      "Bey Mah",
      "Camikebir Mah",
      "Çalçı Mah",
      "Çalkaya Mah",
      "Çardak Mah",
      "Çukurören Mah",
      "Dağcı Mah",
      "Diközü Mah",
      "Dinek Mah",
      "Dümrek Mah",
      "Gözeler Mah",
      "Güce Mah",
      "Güreş Mah",
      "Gürleyik Mah",
      "Hamidiye Mah",
      "Ilıcalar Mah",
      "İğdecik Mah",
      "İkizafer Mah",
      "Karaçam Mah",
      "Karageyikli Mah",
      "Kavak Mah",
      "Kayı Mah",
      "Kızılbörüklü Mah",
      "Korucu Mah",
      "Koyunağılı Mah",
      "Kozlu Mah",
      "Lütfiye Mah",
      "Mahmuthisar Mah",
      "Medrese Mah",
      "Narlı Mah",
      "Obruk Mah",
      "Otluk Mah",
      "Ömer Mah",
      "Saray Mah",
      "Sazak Mah",
      "Seki Mah",
      "Sekiören Mah",
      "Sorkun Mah",
      "Süleler Mah",
      "Tatarcık Mah",
      "Uşakbükü Mah",
      "Üçbaşlı Mah",
      "Yalımkaya Mah",
      "Yayla Mah",
      "Yeşilyurt Mah",
      "Yunusemre Mah"
    ],
    "Odunpazarı": [
      "Akçağlan Mah",
      "Alanönü Mah",
      "Cunudiye Mah",
      "Dede Mah",
      "Karapınar Mah",
      "Orta Mah",
      "Paşa Mah",
      "Şarkiye Mah",
      "Arifiye Mah",
      "İstiklal Mah",
      "Büyükdere Mah",
      "Göztepe Mah",
      "Gültepe Mah",
      "Yıldıztepe Mah",
      "71 Evler Mah",
      "Emek Mah",
      "Gökmeydan Mah",
      "Gündoğdu Mah",
      "Erenköy Mah",
      "Huzur Mah",
      "Yenidoğan Mah",
      "Akçakaya Mah",
      "Akkaya Mah",
      "Akpınar Mah",
      "Aşağıılıca Mah",
      "Avdan Mah",
      "Ayvacık Mah",
      "Çamlıca Mah",
      "Demirli Mah",
      "Doğankaya Mah",
      "Eşenkara Mah",
      "Gülpınar Mah",
      "Gümele Mah",
      "Harmandalı Mah",
      "İmişehir Mah",
      "Kanlıpınar Mah",
      "Karaalan Mah",
      "Karacaşehir Mah",
      "Karaçay Mah",
      "Karahüyük Mah",
      "Karamustafa Mah",
      "Karapazar Mah",
      "Karatepe Mah",
      "Kargın Mah",
      "Kayacık Mah",
      "Kıravdan Mah",
      "Kireç Mah",
      "Kuyucak Mah",
      "Lütfiye Mah",
      "Musalar Mah",
      "Sarısungur Mah",
      "Seklice Mah",
      "Sultandere Mah",
      "Süpüren Mah",
      "Türkmentokat Mah",
      "Uluçayır Mah",
      "Yahnikapan Mah",
      "Yenisofça Mah",
      "Yukarıçağlan Mah",
      "Yukarıılıca Mah",
      "Yukarıkalabak Mah",
      "Yürükkaracaören Mah",
      "Yürükkırka Mah",
      "Akcami Mah",
      "Deliklitaş Mah",
      "Kurtuluş Mah",
      "Ağapınar Mah",
      "Aşağı Çağlan Mah",
      "Çavlum Mah",
      "Kalkanlı Mah",
      "Karacahöyük Mah",
      "Kayapınar Mah",
      "Sevinç Mah",
      "Yassıhöyük Mah",
      "Orhangazi Mah",
      "75. Yıl Osb Mah",
      "75.yıl  Mah (sultandere Mah)",
      "Osmangazi Mah",
      "Sümer Mah",
      "Çankaya Mah",
      "Ihlamurkent Mah",
      "Vadişehir Mah",
      "Akarbaşı Mah",
      "Kırmızıtoprak Mah",
      "Vişnelik Mah",
      "Yenikent Mah"
    ],
    "Sarıcakaya": [
      "Beyköy Mah",
      "Beyyayla Mah",
      "Bilal Habeşi Mah",
      "Camikebir Mah",
      "Dağküplü Mah",
      "Düzköy Mah",
      "Fatih Mah",
      "Güney Mah",
      "İğdir Mah",
      "Kapıkaya Mah",
      "Laçin Mah",
      "Mayıslar Mah",
      "Sarıkaya Mah",
      "Yeni Mah"
    ],
    "Seyitgazi": [
      "Akin Mah",
      "Aksaklı Mah",
      "Aslanbeyli Mah",
      "Aşağısöğüt Mah",
      "Ayvalı Mah",
      "Bardakçı Mah",
      "Beşsaray Mah",
      "Beykışla Mah",
      "Büyükdere Mah",
      "Büyükyayla Mah",
      "Cevizli Mah",
      "Çatören Mah",
      "Çukurağıl Mah",
      "Çukurca Mah",
      "Çürüttüm Mah",
      "Değişören Mah",
      "Derebenek Mah",
      "Doğançayır Mah",
      "Fethiye Mah",
      "Gemiç Mah",
      "Göcenoluk Mah",
      "Gökbahçe Mah",
      "Gökçegüney Mah",
      "Göknebi Mah",
      "Gümüşbel Mah",
      "İdrisyayla Mah",
      "İkiçeşme Mah",
      "İkizoluk Mah",
      "Karacalık Mah",
      "Karaören Mah",
      "Kesenler Mah",
      "Kırka Mah",
      "Kümbet Mah",
      "Numanoluk Mah",
      "Oynaş Mah",
      "Örencik Mah",
      "Salihler Mah",
      "Sancar Mah",
      "Sandıközü Mah",
      "Sarayören Mah",
      "Sarıcailyas Mah",
      "Şükranlı Mah",
      "Taşlıkköy Mah",
      "Üçsaray Mah",
      "Yapıldak Mah",
      "Yarbasan Mah",
      "Yazıdere Mah",
      "Yenikent Mah",
      "Yeşiltepe Mah",
      "Yukarısöğüt Mah",
      "Yunus Mah"
    ],
    "Sivrihisar": [
      "Ahiler Mah",
      "Aktaş Mah",
      "Aşağıkepen Mah",
      "Aydınlı Mah",
      "Babadat Mah",
      "Bahçecik Mah",
      "Ballıhisar Mah",
      "Benlikuyu Mah",
      "Benliyaver Mah",
      "Beyyazı Mah",
      "Biçer Mah",
      "Böğürtlen Mah",
      "Buhara Mah",
      "Buzluca Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Çandır Mah",
      "Çaykoz Mah",
      "Demirci Mah",
      "Demirciköy Mah",
      "Dinek Mah",
      "Dumluca Mah",
      "Dümrek Mah",
      "Elcik Mah",
      "Elmalı Mah",
      "Ertuğrulköy Mah",
      "Gedik Mah",
      "Gerenli Mah",
      "Göktepe Mah",
      "Gülçayır Mah",
      "Güvemli Mah",
      "Hamamkarahisar Mah",
      "Hızırbey Mah",
      "Hüdavendigar Mah",
      "İbikseydi Mah",
      "İğdecik Mah",
      "İlören Mah",
      "İlyaspaşa Mah",
      "İstiklalbağı Mah",
      "Kadıncık Mah",
      "Kaldırımköy Mah",
      "Karabaşlı Mah",
      "Karaburhan Mah",
      "Karacakaya Mah",
      "Karacalar Mah",
      "Karacaören Mah",
      "Karacaörenyaylası Mah",
      "Karadat Mah",
      "Karakaya Mah",
      "Karkın Mah",
      "Kaymaz Mah",
      "Kertek Mah",
      "Kılıç Mah",
      "Kınık Mah",
      "Koçaş Mah",
      "Koltan Mah",
      "Kubbeli Mah",
      "Kurşunlu Mah",
      "Kurtşeyh Mah",
      "Memik Mah",
      "Mülkköy Mah",
      "Nasrettin Hoca Mah",
      "Oğlakçı Mah",
      "Ortaklar Mah",
      "Paşakadın Mah",
      "Sadıkbağı Mah",
      "Sarıkavak Mah",
      "Selimiye Mah",
      "Sığırcık Mah",
      "Tekören Mah",
      "Yaverören Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yukarıkepen Mah",
      "Yunusemre Mah",
      "Zeyköyü Mah"
    ],
    "Tepebaşı": [
      "Bahçelievler Mah",
      "Eskibağlar Mah",
      "Güllük Mah",
      "Yenibağlar Mah",
      "Cumhuriye Mah",
      "Hoşnudiye Mah",
      "Batıkent Mah",
      "Çamlıca Mah",
      "Aşağıkartal Mah",
      "Boyacıoğlu Mah",
      "Çukurhisar Yeni Mah",
      "Eğriöz Mah",
      "Gökdere Mah",
      "Hasanbey Mah",
      "Hisar Mah",
      "Kavacık Mah",
      "Keskin Mah",
      "Kozkayı Mah",
      "Satılmışoğlu Mah",
      "Yukarı Söğütönü Mah",
      "Fatih Mah",
      "Kumlubel Mah",
      "Ömerağa Mah",
      "Tunalı Mah",
      "Zafer Mah",
      "Fevziçakmak Mah",
      "Şarhöyük Mah",
      "Hacı Ali Bey Mah",
      "Hacı Seyit Mah",
      "Hayriye Mah",
      "Işıklar Mah",
      "İhsaniye Mah",
      "Mamure Mah",
      "Merkez Yeni Mah",
      "Mustafa Kemal Paşa Mah",
      "Şeker Mah",
      "Emirceoğlu Mah",
      "Gazipaşa Mah",
      "Muttalip Emirler Mah",
      "Muttalip Koyunlar Mah",
      "Muttalip Orta Mah",
      "Sakintepe Mah",
      "Ertuğrulgazi Mah",
      "Sazova Mah",
      "Ahılar Mah",
      "Atalan Mah",
      "Atalantekke Mah",
      "Avlamış Mah",
      "Behçetiye Mah",
      "Bektaşpınarı Mah",
      "Beyazaltın Mah",
      "Bozdağ Mah",
      "Buldukpınar Mah",
      "Cumhuriyet Mah",
      "Çalkara Mah",
      "Çanakkıran Mah",
      "Danişment Mah",
      "Gökçekısık Mah",
      "Gündüzler Mah",
      "Hekimdağ Mah",
      "Karaçobanpınarı Mah",
      "Karadere Mah",
      "Karagözler Mah",
      "Kızılcaören Mah",
      "Kızılinler Mah",
      "Kozlubel Mah",
      "Mollaoğlu Mah",
      "Musaözü Mah",
      "Nemli Mah",
      "Sulukaraağaç Mah",
      "Takmak Mah",
      "Tandır Mah",
      "Taycılar Mah",
      "Tekeciler Mah",
      "Turgutlar Mah",
      "Uludere Mah",
      "Yakakayı Mah",
      "Yarımca Mah",
      "Yeniakçayır Mah",
      "Yeniincesu Mah",
      "Yukarıkartal Mah",
      "Yusuflar Mah",
      "Yürükakçayır Mah",
      "Uluönder Mah",
      "Alınca Mah",
      "Aşağı Söğütönü Mah",
      "Esentepe Mah",
      "Sütlüce Mah",
      "Şirintepe Mah",
      "Yaşamkent Mah",
      "Yeşiltepe Mah",
      "Zincirlikuyu Mah"
    ]
  },
  "Gaziantep": {
    "Araban": [
      "Akbudak Mah",
      "Akkoç Mah",
      "Altınpınar Mah",
      "Aşağıkaravaiz Mah",
      "Aşağıyufkalı Mah",
      "Bağlıca Mah",
      "Başpınar Mah",
      "Beydili Mah",
      "Çiftekoz Mah",
      "Dağdancık Mah",
      "Doğan Mah",
      "Dumlupınar Mah",
      "Elif Mah",
      "Emirhaydar Mah",
      "Erenbağ Mah",
      "Esentepe Mah",
      "Eskialtıntaş Mah",
      "Fakılı Mah",
      "Fevzi Çakmak Mah",
      "Fıstıklıdağ Mah",
      "Gelinbuğday Mah",
      "Gökçepayam Mah",
      "Güllüce Mah",
      "Gümüşpınar Mah",
      "Güzey Mah",
      "Hasanoğlu Mah",
      "Hisar Mah",
      "Kale Mah",
      "Karababa Mah",
      "Karacaören Mah",
      "Köklüce Mah",
      "Körhacıobası Mah",
      "Küçüklü Mah",
      "Mehmet Gökçek Mah",
      "Muratlı Mah",
      "Nurettin Mah",
      "Sarıkaya Mah",
      "Sarıtepe Mah",
      "Şerif Peri Mah",
      "Tarlabaşı Mah",
      "Taşdeğirmen Mah",
      "Turgut Özal Mah",
      "Yaylacık Mah",
      "Yeni Altıntaş Mah",
      "Yeşilova Mah",
      "Yolveren Mah",
      "Yukarıkaravaiz Mah",
      "Yukarıyufkalı Mah",
      "Ziyaret Mah"
    ],
    "İslahiye": [
      "Ağabey Mah",
      "Ağalarobası Mah",
      "Akınyolu Mah",
      "Alaca Mah",
      "Altınüzüm Mah",
      "Arpalı Mah",
      "Atatürk Mah",
      "Aydınlık Mah",
      "Bahçelievler Mah",
      "Bayraktepe Mah",
      "Beyler Mah",
      "Boğaziçi Mah",
      "Burhaniye Mah",
      "Burunsuzlar Mah",
      "Cevdetpaşa Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Çerçili Mah",
      "Çınarlı Mah",
      "Çolaklar Mah",
      "Çubuk Mah",
      "Değirmencik Mah",
      "Dervişpaşa Mah",
      "Elbistanhüyüğü Mah",
      "Erenler Mah",
      "Esenler Mah",
      "Fevzi Çakmak Mah",
      "Fevzipaşa Mah",
      "Göltepe Mah",
      "Güllühüyük Mah",
      "Güngören Mah",
      "Haci Ali Öztürk Mah",
      "Hanağzı Mah",
      "Hasanlök Mah",
      "Hürriyet Mah",
      "İdilli Mah",
      "Kabaklar Mah",
      "Kalaycık Mah",
      "Kale Mah",
      "Karacaören Mah",
      "Karakaya Mah",
      "Karapınar Mah",
      "Karapolat Mah",
      "Kayabaşı Mah",
      "Kazıklı Mah",
      "Kırıkçalı Mah",
      "Koçcağız Mah",
      "Kozdere Mah",
      "Köklü Mah",
      "Kuşçumustafa Mah",
      "Ortaklı Mah",
      "Örtülü Mah",
      "Pınarbaşı Mah",
      "Serinevler Mah",
      "Sulumağara Mah",
      "Şahmaran Mah",
      "Şerikanlı Mah",
      "Tandır Mah",
      "Telli Mah",
      "Türkbahçe Mah",
      "Yağızlar Mah",
      "Yelliburun Mah",
      "Yeni Mah",
      "Yeniceli Mah",
      "Yeniköy Mah",
      "Yesemek Mah",
      "Yeşilova Mah",
      "Yeşilyurt Mah",
      "Yolbaşı Mah",
      "Yukarıbilenler Mah",
      "Zincirli Mah"
    ],
    "Karkamış": [
      "Akçaköy Mah",
      "Alaçalı Mah",
      "Alagöz Mah",
      "Arıkdere Mah",
      "Ayyıldız Mah",
      "Balaban Mah",
      "Beşkılıç Mah",
      "Çarşı Mah",
      "Çiftlik Mah",
      "Eceler Mah",
      "Elifoğlu Mah",
      "Erenyolu Mah",
      "Etiler Mah",
      "Gürçay Mah",
      "Karacurun Mah",
      "Karanfil Mah",
      "Karşıyaka Mah",
      "Kelekli Mah",
      "Kepirler Mah",
      "Kıvırcık Mah",
      "Korkmazlar Mah",
      "Kuruyazı Mah",
      "Lojmanlar Mah",
      "Öncüler Mah",
      "Örmetaş Mah",
      "Savaş Mah",
      "Soylu Mah",
      "Subağı Mah",
      "Şenlik Mah",
      "Teketaşı Mah",
      "Tosunlu Mah",
      "Türkyurdu Mah",
      "Yarımca Mah",
      "Yaşar Mah",
      "Yazır Mah",
      "Yeşerti Mah",
      "Yolağzı Mah",
      "Yurtbağı Mah",
      "Zührecik Mah"
    ],
    "Nizip": [
      "Adaklı Mah",
      "Akçakent Mah",
      "Akkuyu Mah",
      "Alahacı Mah",
      "Altındağ Mah",
      "Aşağıbayındır Mah",
      "Aşağıçardak Mah",
      "Atatürk Mah",
      "Bağlıca Mah",
      "Bahçeli Mah",
      "Ballı Mah",
      "Belkıs  Mah (merkez Mah)",
      "Belkıs Mah",
      "Boyluca Mah",
      "Bozalioğlu Mah",
      "Cumhuriyet Mah",
      "Çakmaktepe Mah",
      "Çanakçı Mah",
      "Çatalca Mah",
      "Dayıdağı Mah",
      "Dazhüyük Mah",
      "Dernek Mah",
      "Doğrular Mah",
      "Duraklı Mah",
      "Dutlu Mah",
      "Düzbayır Mah",
      "Ekinci Mah",
      "Erenköy Mah",
      "Eskikonak Mah",
      "Eyüp Sultan Mah",
      "Fatih Sultan Mah",
      "Fevkani Mah",
      "Fevzi Paşa Mah",
      "Fırat Mah",
      "Gaziler Mah",
      "Gevence Mah",
      "Gökçeli Mah",
      "Güder Mah",
      "Gülkaya Mah",
      "Gümüşgün Mah",
      "Günaltı Mah",
      "Gürbaşak Mah",
      "Güzelköy Mah",
      "Hafızpaşa Mah",
      "Hancağız Mah",
      "Hazımoğlu Mah",
      "İkizce Mah",
      "İntepe Mah",
      "İstasyon Mah",
      "İstiklal Mah",
      "Kaleköy Mah",
      "Kamışlı Mah",
      "Karaburç Mah",
      "Karşıyaka Mah",
      "Kayalar Mah",
      "Keklik Mah",
      "Kesiktaş Mah",
      "Kıbrıs Mah",
      "Kıraçgülü Mah",
      "Kıratlı Mah",
      "Kızılcakent Mah",
      "Kızılin Mah",
      "Kocatepe Mah",
      "Korucak Mah",
      "Köseler Mah",
      "Kumla Mah",
      "Kurucahüyük Mah",
      "Mağaracık Mah",
      "Mehmetobası Mah",
      "Menderes Mah",
      "Mercanlı Mah",
      "Mevlana Mah",
      "Mihrap Mah",
      "Mimar Sinan Mah",
      "Nahırtepe Mah",
      "Namık Kemal Mah",
      "Nizip Osb Mah",
      "Özyurt Mah",
      "Pazar Camii Mah",
      "Saha Mah",
      "Salkım Mah",
      "Samandöken Mah",
      "Samanlı Mah",
      "Saray Mah",
      "Sarıkoç Mah",
      "Sekili Mah",
      "Söğütlü Mah",
      "Suboyu Mah",
      "Sultan Abdülhamit Mah",
      "Şahinbey Mah",
      "Şıhlar Mah",
      "Tahtani Mah",
      "Tanır Mah",
      "Tatlıcak Mah",
      "Tosunlu Mah",
      "Toydemir Mah",
      "Tuluktaş Mah",
      "Turlu Mah",
      "Turnalı Mah",
      "Uluyatır Mah",
      "Yağcılar Mah",
      "Yağmuralan Mah",
      "Yarımtepe Mah",
      "Yeniyapan Mah",
      "Yeniyazı Mah",
      "Yeşilevler Mah",
      "Yolçatı Mah",
      "Yukarıbayındır Mah",
      "Yukarıçardak Mah",
      "Yunus Emre Mah",
      "Zeytinlik Mah"
    ],
    "Nurdağı": [
      "Alpaslan Türkeş Mah",
      "Altınova Mah",
      "Aslanlı Mah",
      "Ataköy Mah",
      "Atatürk Mah",
      "Atmalı Mah",
      "Bademli Mah",
      "Bahçelievler Mah",
      "Balıkalan Mah",
      "Başpınar Mah",
      "Belpınar Mah",
      "Çakmak Mah",
      "Demirler Mah",
      "Durmuşlar Mah",
      "Emirler Mah",
      "Esenyurt Mah",
      "Fatih Mah",
      "Gedikli Mah",
      "Gökçedere Mah",
      "Gözlühüyük Mah",
      "Hamidiye Mah",
      "Hisar Mah",
      "İçerisu Mah",
      "İkizkuyu Mah",
      "İncegedik Mah",
      "İncirli Mah",
      "Karaburçlu Mah",
      "Kartal Mah",
      "Kırışkal Mah",
      "Kırkpınar Mah",
      "Kömürler Mah",
      "Kurudere Mah",
      "Kuzoluk Mah",
      "Mehmet Akif Ersoy Mah",
      "Mesthüyük Mah",
      "Naimler Mah",
      "Nogaylar Mah",
      "Olucak Mah",
      "Sakçagözü Mah",
      "Sayburun Mah",
      "Şatırhüyük Mah",
      "Tandırlı Mah",
      "Terken Mah",
      "Torunlar Mah",
      "Tüllüce Mah",
      "Yavuzselim Mah",
      "Yaylacık Mah",
      "Yeni Mah"
    ],
    "Oğuzeli": [
      "Acer Mah",
      "Akçamezra Mah",
      "Altınyurt Mah",
      "Ambarcık Mah",
      "Arslanlı Mah",
      "Asmacık Mah",
      "Aşağı Güneyse Mah",
      "Aşağı Yeniyapan Mah",
      "Aydınkaya Mah",
      "Belören Mah",
      "Beşdeli Mah",
      "Bulduk Mah",
      "Büyükkaracaviran Mah",
      "Cumhuriyet Mah",
      "Çatalçam Mah",
      "Çatalsu Mah",
      "Çavuşbaşı Mah",
      "Çaybaşı Mah",
      "Çaybaşı Osb Mah",
      "Çaybeyi Mah",
      "Demirkonak Mah",
      "Dero Küçükkaracaviran Mah",
      "Devehüyüğü Mah",
      "Dibecik Mah",
      "Dikmetaş Mah",
      "Direkli Mah",
      "Doğanpınar Mah",
      "Dokuzyol Mah",
      "Duruköy Mah",
      "Dutluca Mah",
      "Ekinveren Mah",
      "Ermiş Mah",
      "Fatih Mah",
      "Gebe Mah",
      "Gedik Mah",
      "Güllük Mah",
      "Gündoğan Mah",
      "Güveçli Mah",
      "Güzelce Mah",
      "Hacar Mah",
      "Hatunlu Mah",
      "Hötoğlu Mah",
      "Hürriyet Mah",
      "İkizkuyu Mah",
      "İnceyol Mah",
      "İnkılap Mah",
      "İnönü Mah",
      "Kabacaağaç Mah",
      "Karaburun Mah",
      "Karadibek Mah",
      "Karaman Mah",
      "Karataş Mah",
      "Kaşyolu Mah",
      "Kavunluk Mah",
      "Kayacık Mah",
      "Kayalıpınar Mah",
      "Keçikuyusu Mah",
      "Keçili Mah",
      "Kersentaş Mah",
      "Kılavuz Mah",
      "Koçaklar Mah",
      "Kovanlı Mah",
      "Körkün Mah",
      "Kurtuluş Mah",
      "Kuruçay Mah",
      "Mimar Sinan Mah",
      "Oğuzlar Mah",
      "Sazgın Mah",
      "Sergili Mah",
      "Sevindi Mah",
      "Subaşı Mah",
      "Sütlüce Mah",
      "Şahinbey Mah",
      "Şıh Küçükkaracaviran Mah",
      "Taşçanak Mah",
      "Taşlı Mah",
      "Taşyazı Mah",
      "Tınazdere Mah",
      "Tüzel Mah",
      "Uğurova Mah",
      "Ulaşlı Mah",
      "Üçdamlar Mah",
      "Üçkubbe Mah",
      "Yakacık Mah",
      "Yalnızbağ Mah",
      "Yazılı Mah",
      "Yeni Cumhuriyet Mah",
      "Yeniköy Mah",
      "Yeşildere Mah",
      "Yeşiltepe Mah",
      "Yukarıgüneyse Mah",
      "Gürsu Mah"
    ],
    "Şahinbey": [
      "Akyol Mah",
      "Alaybey Mah",
      "Alleben Mah",
      "Bahçelievler Mah",
      "Bey Mah",
      "Eyüpoğlu Mah",
      "Karatarla Mah",
      "Kozanlı Mah",
      "Şahveli Mah",
      "Akdere Mah",
      "Alibaba Mah",
      "Aydınbaba Mah",
      "Barış Mah",
      "Beybahçe Mah",
      "Beydilli Mah",
      "Cemal Gürsel Mah",
      "Cengiz Topel Mah",
      "Dumlupınar Mah",
      "Düztepe Mah",
      "Esentepe Mah",
      "Güzelvadi Mah",
      "İnönü Mah",
      "Karayılan Mah",
      "Kılınçoğlu Mah",
      "Saçaklı Mah",
      "Sultan Selim Mah",
      "Şenyurt Mah",
      "Türkmenler Mah",
      "Ünaldı Mah",
      "Yavuzlar Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Etiler Mah",
      "Gümüştekin Mah",
      "Hoşgör Mah",
      "Kahvelipınar Mah",
      "Kıbrıs Mah",
      "Kurbanbaba Mah",
      "Nuripazarbaşı Mah",
      "Onur Mah",
      "Sakarya Mah",
      "Savcılı Mah",
      "Turan Emeksiz Mah",
      "Ulaş Mah",
      "Yukarıbayır Mah",
      "75.yıl Mah",
      "Abdülhamid Han Mah",
      "Akkent Mah",
      "Bağlarbaşı Mah",
      "Beştepe Mah",
      "Bülbülzade Mah",
      "Ertuğrulgazi Mah",
      "Geylani Mah",
      "Güneş Mah",
      "Güneykent Mah",
      "İbn-i Sina Mah",
      "Karataş Mah",
      "Küçükkızılhisar Mah",
      "Mavikent Mah",
      "Selçuklu Mah",
      "Şahintepe Mah",
      "Yamaçtepe Mah",
      "Yeditepe Mah",
      "Yeşilyurt Mah",
      "23 Nisan Mah",
      "60.yıl Mah",
      "Beyazlar Mah",
      "Binevler Mah",
      "Çağdaş Mah",
      "Deniz Mah",
      "Fidanlık Mah",
      "İstiklal Mah",
      "Kavaklık Mah",
      "Kolejtepe Mah",
      "Konak Mah",
      "Mimar Sinan Mah",
      "Öğretmenevleri Mah",
      "Yeşilevler Mah",
      "25 Aralık Mah",
      "Barak Mah",
      "Bozoklar Mah",
      "Fırat Mah",
      "Narlıtepe Mah",
      "Ocaklar Mah",
      "Perilikaya Mah",
      "Serinevler Mah",
      "Tekstilkent Mah",
      "Üçoklar Mah",
      "Vatan Mah",
      "Akbayır Mah",
      "Akbulut Mah",
      "Akpınar Mah",
      "Akyazı Mah",
      "Almalı Mah",
      "Bayramlı Mah",
      "Bekişli Mah",
      "Belenköy Mah",
      "Beşkuyu Mah",
      "Bostancık Mah",
      "Bozca Mah",
      "Burç Esentepe Mah",
      "Burç Karakuyu Mah",
      "Cebeler Mah",
      "Cevizli Mah",
      "Çamtepe Mah",
      "Çapalı Mah",
      "Çevreli Mah",
      "Çimenli Mah",
      "Çöreklik Mah",
      "Çubukdiken Mah",
      "Damlacık Mah",
      "Deredüzü Mah",
      "Doğanca Mah",
      "Dokur Mah",
      "Durantaş Mah",
      "Ekinli Mah",
      "Gazitepe Mah",
      "Geneyik Mah",
      "Gerciğin Mah",
      "Güllüce Mah",
      "Gülpınar Mah",
      "Hacıarslan Mah",
      "Hacıköprü Mah",
      "Hacıköy Mah",
      "Kabarcık Mah",
      "Kale Mah",
      "Kaleboynu Mah",
      "Kapçağız Mah",
      "Karaçomak Mah",
      "Kavşak Mah",
      "Kayakent Mah",
      "Kazıklı Mah",
      "Kerer Mah",
      "Killik Mah",
      "Kumruhamurkesen Mah",
      "Kuşçu Mah",
      "Külecik Mah",
      "Kürüm Mah",
      "Malazgirt Mah",
      "Morcalı Mah",
      "Muhacirosman Mah",
      "Narlıca Mah",
      "Ortaklar Mah",
      "Osmanlı Mah",
      "Ozanlı Mah",
      "Pancarlı Mah",
      "Sarıbaşak Mah",
      "Sarıkaya Mah",
      "Sarısalkım Mah",
      "Sarıt Mah",
      "Serince Mah",
      "Sırasöğüt Mah",
      "Şahinbey Mülk Mah",
      "Tiyekli Mah",
      "Töreli Mah",
      "Türközü Mah",
      "Ufacık Mah",
      "Uğurtepe Mah",
      "Yağdöver Mah",
      "Yaycı Mah",
      "Yaylacık Mah",
      "Yazıbağı Mah",
      "Yeniköy Mah",
      "Yeşilkent Mah",
      "Yeşilköy Mah",
      "Yeşilpınar Mah",
      "Yığmatepe Mah",
      "Yoğuntaş Mah",
      "Zeytinli Mah",
      "Bekirbey Mah",
      "Bostancı Mah",
      "Boyacı Mah",
      "Cabi Mah",
      "Kanalıcı Mah",
      "Karagöz Mah",
      "Kepenek Mah",
      "Kozluca Mah",
      "Seferpaşa Mah",
      "Suyabatmaz Mah",
      "Şekeroğlu Mah",
      "Tışlaki Mah",
      "Türktepe Mah",
      "Yazıcık Mah"
    ],
    "Şehitkamil": [
      "29 Ekim Mah",
      "Çakmak Mah",
      "Çıksorut Mah",
      "Girne Mah",
      "Göllüce Mah",
      "Güzelyurt Mah",
      "Humanız Mah",
      "İncilikaya Mah",
      "Karaoğlan Mah",
      "Sacır Mah",
      "Selahattin Eyyubi Mah",
      "Seyrantepe Mah",
      "Şirinevler Mah",
      "Taşlıca Mah",
      "Umut Mah",
      "Yaprak Mah",
      "Yeni Mah",
      "Emek Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Pancarlı Mah",
      "Sarıgüllük Mah",
      "Atakent Mah",
      "Aydınlar Mah",
      "Belkız Mah",
      "Beykent Mah",
      "Burak Mah",
      "Çamlıtepe Mah",
      "Gazikent Mah",
      "Gaziler Mah",
      "15 Temmuz Mah",
      "Atatürk Mah",
      "Batıkent Mah",
      "Güvenevler Mah",
      "İbrahimli Mah",
      "Osmangazi Mah",
      "Sancaktepe Mah",
      "Şehirgösteren Mah",
      "Değirmiçem Mah",
      "İncili Pınar Mah",
      "Mücahitler Mah",
      "Aydıntepe Mah",
      "Boyno Mah",
      "Çağlayan Mah",
      "Dülükbaba Mah",
      "Eydibaba Mah",
      "Göztepe Mah",
      "Hacıbaba Mah",
      "Hasırcıoğlu Mah",
      "Hürriyet Mah",
      "Karşıyaka Mah",
      "Kayaönü Mah",
      "Kocatepe Mah",
      "Mithatpaşa Mah",
      "Münüfpaşa Mah",
      "Nurtepe Mah",
      "Özgürlük Mah",
      "Pirsultan Mah",
      "Yunus Emre Mah",
      "Zeytinli Mah",
      "Sanayi Mah",
      "8 Şubat Mah",
      "Alpaslan Mah",
      "Beylerbeyi Mah",
      "Eyüpsultan Mah",
      "Fıstıklık Mah",
      "Karacaahmet Mah",
      "Karacaoğlan Mah",
      "Merveşehir Mah",
      "Mevlana Mah",
      "Onat Kutlar Mah",
      "Selimiye Mah",
      "Aktoprak Sb Mah",
      "Başpınar Mah (organize Mah)osb",
      "Acaroba Mah",
      "Ağaçlıboyno Mah",
      "Akçaburç Mah",
      "Akçagöze Mah",
      "Aktoprak Mah",
      "Aşağı Arıl Mah",
      "Atabek Mah",
      "Atalar Mah",
      "Bağbaşı Mah",
      "Battal Mah",
      "Bayatlı Mah",
      "Bedirköy Mah",
      "Beyreli Mah",
      "Bilek Mah",
      "Bozobası Mah",
      "Büyükpınar Mah",
      "Cerityeniyapan Mah",
      "Çağkuyu Mah",
      "Dımışkılı Mah",
      "Durnalık Mah",
      "Dülük Mah",
      "Dündarlı Mah",
      "Erikli Mah",
      "Eskişarkaya Mah",
      "Göksüncük Mah",
      "Göktürk Mah",
      "Günbulur Mah",
      "Güngürge Mah",
      "Işıklı Mah",
      "İbrahimşehir Mah",
      "İncesu Mah",
      "İskenderli Mah",
      "Kabasakız Mah",
      "Karacaburç Mah",
      "Karacaören Mah",
      "Karadede Mah",
      "Karahüyük Mah",
      "Karakesek Mah",
      "Karayusuflu Mah",
      "Karpuzkaya Mah",
      "Kızık Karasakal Mah",
      "Kızıkhamurkesen Mah",
      "Koçlu Mah",
      "Kozluyazı Mah",
      "Köksalan Mah",
      "Küllü Mah",
      "Medegöz Mah",
      "Nesimi Mah",
      "Öğümsöğüt Mah",
      "Övündük Mah",
      "Sam Mah",
      "Sarılar Mah",
      "Sefaşehir Mah",
      "Serintepe Mah",
      "Seymenli Mah",
      "Sinan Mah",
      "Sinan Osb Mah",
      "Sofalıcı Mah",
      "Suboğaz Mah",
      "Sülüklü Mah",
      "Tekirsin Mah",
      "Tokdemir Mah",
      "Tuğlu Mah",
      "Türkyurdu Mah",
      "Uğruca Mah",
      "Üçgöze Mah",
      "Ülkerli Mah",
      "Yalankoz Mah",
      "Yamaçoba Mah",
      "Yayıktaş Mah",
      "Yenişarkaya Mah",
      "Yeşilce Mah",
      "Yığınlı Mah",
      "Yukarı Arıl Mah",
      "Zülfikar Mah"
    ],
    "Yavuzeli": [
      "Akbayır Mah",
      "Aşağıhöçüklü Mah",
      "Aşağıkayabaşı Mah",
      "Aşağıkekliktepe Mah",
      "Bağtepe Mah",
      "Bakırca Mah",
      "Ballık Mah",
      "Beğendik Mah",
      "Bülbül Mah",
      "Büyükkarakuyu Mah",
      "Cingife Mah",
      "Cumhuriyet Mah",
      "Çiltoprak Mah",
      "Çimenli Mah",
      "Değirmitaş Mah",
      "Düzce Mah",
      "Fevzi Çakmak Mah",
      "Göçmez Mah",
      "Gülpınar Mah",
      "Hacımallı Mah",
      "Havuz Mah",
      "Hürriyet Mah",
      "Ilıcak Mah",
      "Karabey Mah",
      "Karahan Mah",
      "Karahüseyinli Mah",
      "Kasaba Mah",
      "Keşrobası Mah",
      "Kuzuyatağı Mah",
      "Küçükkarakuyu Mah",
      "Örenli Mah",
      "Saraymağara Mah",
      "Sarıbuğday Mah",
      "Sarılar Mah",
      "Sultan Selim Mah",
      "Süleymanobası Mah",
      "Şenlikçe Mah",
      "Tokaçlı Mah",
      "Üçgöl Mah",
      "Yarımca Mah",
      "Yeniyurt Mah",
      "Yöreli Mah",
      "Yukarıkekliktepe Mah",
      "Yukarıyeniköy Mah"
    ]
  },
  "Giresun": {
    "Alucra": [
      "Mesudiye Mah",
      "Yunus Emre Mah",
      "Ahmetli Mah (hacıhasan Köyü)",
      "Akçiçek Köyü",
      "Akpınar Mah (demirözü Köyü)",
      "Aktepe Mah (yükselen Köyü)",
      "Akyatak Mah (fevzi Çakmak Köyü)",
      "Alamacan Mah (tepeköy Köyü)",
      "Alantarla Mah (elmacık Köyü)",
      "Aliuşağı Mah (aktepe Köyü)",
      "Andırlı Mah (tepeköy Köyü)",
      "Arda Köyü",
      "Arduç Köyü",
      "Armutalağı Mah (tepeköy Köyü)",
      "Armutlu Köyü",
      "Avluk Ağzı Mah (elmacık Köyü)",
      "Aydınyayla Köyü",
      "Babapınar Mah",
      "Batu Mah (çakrak Köyü)",
      "Bekirli Mah (boyluca Köyü)",
      "Belançayır Mah (aktepe Köyü)",
      "Bereketli Köyü",
      "Beylerce Köyü",
      "Camı Yanı Mah (elmacık Köyü)",
      "Çalgan Köyü",
      "Çığrıkalan Mah (demirözü Köyü)",
      "Çoşkur Mah (elmacık Köyü)",
      "Çukur Mah (karabörk Köyü)",
      "Değirmice Mah (boyluca Köyü)",
      "Dere Mah (demirözü Köyü)",
      "Dere Mah (gürbulak Köyü)",
      "Dereçiftlik Köyü",
      "Doludere Köyü",
      "Ekizli Mah (boyluca Köyü)",
      "Eskiköy Mah (tepeköy Köyü)",
      "Fatih Mah (fevzi Çakmak Köyü)",
      "Gelinkaya Mah (konaklı Köyü)",
      "Gevezeli Mah (boyluca Köyü)",
      "Gökçebel Köyü",
      "Günügüzel Köyü",
      "Güvenbükü Mah (tepeköy Köyü)",
      "Habibli Mah (hacıhasan Köyü)",
      "Hacılı Köyü",
      "Hapanbele Mah (aktepe Köyü)",
      "İğdecik Köyü",
      "Kabaktepe Köyü",
      "Kaledibi Köyü",
      "Kamışlı Köyü",
      "Kamışlık Mah (demirözü Köyü)",
      "Kanlıoğlu Mah (hacıhasan Köyü)",
      "Karaağaç Mah",
      "Karagöz Mah (aktepe Köyü)",
      "Karayazı Mah (demirözü Köyü)",
      "Kavaklıdere Köyü",
      "Kayadibi Mah (aktepe Köyü)",
      "Kemallı Mah",
      "Kılıçlar Mah (boyluca Köyü)",
      "Kılıçlı Mah (çakrak Köyü)",
      "Kımıllı Mah (hacıhasan Köyü)",
      "Kışla Mah (aktepe Köyü)",
      "Kilise Pınarı Mah (aktepe Köyü)",
      "Kirazdibi Mah (demirözü Köyü)",
      "Koman Köyü",
      "Kumluk Mah (karabörk Köyü)",
      "Kurucaali Mah (demirözü Köyü)",
      "Kuruçay Mah (tepeköy Köyü)",
      "Küçük Mah (köklüce Köyü)",
      "Macara Mah (çakrak Köyü)",
      "Merkez Mah (çakrak Köyü)",
      "Merkez Mah (çamlıyayla Köyü)",
      "Merkez Mah (demirözü Köyü)",
      "Merkez Mah (gürbulak Köyü)",
      "Merkez Mah (köklüce Köyü)",
      "Merkez Mah (yükselen Köyü)",
      "Mezra Mah (karabörk Köyü)",
      "Mutaflı Mah (tepeköy Köyü)",
      "Müseel Mah (boyluca Köyü)",
      "Orta Mah (konaklı Köyü)",
      "Örnek Mah (gürbulak Köyü)",
      "Paravarlı Mah (elmacık Köyü)",
      "Pirili Köyü",
      "Saraçlı Mah (aktepe Köyü)",
      "Seferli Mah (aktepe Köyü)",
      "Seyyidhan Mah (aktepe Köyü)",
      "Sık Mah (demirözü Köyü)",
      "Solaklı Mah (fevzi Çakmak Köyü)",
      "Subaşı Köyü",
      "Suiçti Mah (fevzi Çakmak Köyü)",
      "Suyurdu Köyü",
      "Şahanlı Mah (aktepe Köyü)",
      "Şıhlı Mah (boyluca Köyü)",
      "Taştamir Mah (yükselen Köyü)",
      "Tefilli Mah (boyluca Köyü)",
      "Tepe Mah (boyluca Köyü)",
      "Tepe Mah (fevzi Çakmak Köyü)",
      "Tohumluk Köyü",
      "Topçam Mah",
      "Turnalı Mah (çakrak Köyü)",
      "Uncuoğlu Mah (boyluca Köyü)",
      "Üst Mah (çamlıyayla Köyü)",
      "Veyselli Mah (hacıhasan Köyü)",
      "Yeni Mah (aktepe Köyü)",
      "Yeniköy Mah (çakrak Köyü)",
      "Yeşilyurt Köyü",
      "Yoğurdugara Mah (hacıhasan Köyü)"
    ],
    "Bulancak": [
      "Aydınlar Mah (aydındere Beldesi)",
      "Derecikalan Mah (aydındere Beldesi)",
      "Güney Mah (aydındere Beldesi)",
      "Merkez Mah (aydındere Beldesi)",
      "Yeni Mah (aydındere Beldesi)",
      "Acısu Mah",
      "Bahçelievler Mah",
      "Ballıca Mah",
      "Bulancak Mah",
      "Duacıoğlu Mah",
      "Güzelyalı Mah",
      "İhsaniye Mah",
      "İsmet Paşa Mah",
      "Kızılot Mah",
      "Sanayii Mah",
      "Saraçlı Mah",
      "Sisin Mah",
      "Şemsettin Mah",
      "Toprakdeğirmeni Mah",
      "Ucarlı Mah",
      "Ahurlu Mah (kovanlık Beldesi)",
      "Alçakbel Mah (tokmadin Köyü)",
      "Alibey Köyü",
      "Ardıç Mah (bayındır Köyü)",
      "Aşağı Yatak Mah (tandır Köyü)",
      "Bektaş Mah (tandır Köyü)",
      "Beyalan Mah (döngeri Köyü)",
      "Büyükdüz Mah (döngeri Köyü)",
      "Cami Yanı Merkez Mah (yeniköy Köyü)",
      "Çalık Mah (tandır Köyü)",
      "Çamkırı Mah (tandır Köyü)",
      "Çatal Çam Mah (tandır Köyü)",
      "Düz Mah (kovanlık Beldesi)",
      "Ericealan Mah (bayındır Köyü)",
      "Erikobuzu Mah (döngeri Köyü)",
      "Gamar Mah (bayındır Köyü)",
      "Hacı Kazan Mah (tandır Köyü)",
      "Hacıgüney Mah (döngeri Köyü)",
      "Hasandede Mah (tandır Köyü)",
      "Kabalı Mah (tandır Köyü)",
      "Kaburlu Mah (güzelyurt Köyü)",
      "Kalaboyun Mah (tandır Köyü)",
      "Karaağaç Mah (tandır Köyü)",
      "Kertboğaz Mah (yeniköy Köyü)",
      "Kırımlar Mah (elmalı Köyü)",
      "Kızalan Mah (döngeri Köyü)",
      "Kor Mah (tandır Köyü)",
      "Kömyanı Mah (döngeri Köyü)",
      "Kurban Pınarı Mah (tandır Köyü)",
      "Kuşburnu Mah (tandır Köyü)",
      "Manastır Mah (tandır Köyü)",
      "Maşat Yaylası İki Oluk Ve Dalman Obası Mah (döngeri Köyü)",
      "Merkez Mah (bayındır Köyü)",
      "Merkez Mah (döngeri Köyü)",
      "Merkez Mah (elmalı Köyü)",
      "Merkez Mah (kovanlık Beldesi)",
      "Merkez Mah (tandır Köyü)",
      "Merkez Mah (tokmadin Köyü)",
      "Oyrak Mah (elmalı Köyü)",
      "Pazarsuyu Mah (tandır Köyü)",
      "Pencik Mah (tokmadin Köyü)",
      "Sazoba Mah (yeniköy Köyü)",
      "Sofulu Mah (kovanlık Beldesi)",
      "Soğuksu Mah (kovanlık Beldesi)",
      "Taflancık Mah (elmalı Köyü)",
      "Taşal Mah (tandır Köyü)",
      "Teknekesek Mah (döngeri Köyü)",
      "Tepe Yatak Mah (tandır Köyü)",
      "Üst Mah (elmalı Köyü)",
      "Yanıkalan Mah (tandır Köyü)",
      "Yanıkhayat Mah (bayındır Köyü)",
      "Yanıkoba Mah (döngeri Köyü)",
      "Yeşiltepe Köyü",
      "Yoğundere Mah (güzelyurt Köyü)",
      "Yokuşyol Mah (tandır Köyü)",
      "Abanuz Mah (erdoğan Köyü)",
      "Akkaş Mah (duttepe Köyü)",
      "Aktepe Mah (burunucu Köyü)",
      "Alt Mah (kayabaşı Köyü)",
      "Alt Mah (samugüney Köyü)",
      "Aralıcak Mah (talipli Köyü)",
      "Ardahan Köyü",
      "Arifli Mah",
      "Armutçukuru Mah (bostanlı Köyü)",
      "Aşağı Mah (bostanlı Köyü)",
      "Aydınlar Mah (ezeltere Köyü)",
      "Bakacak Mah (ahmetli Köyü)",
      "Balıkçıkmaz Mah (ezeltere Köyü)",
      "Beleğen Mah (karaağaç Köyü)",
      "Boduroğlu Mah (hisarkaya Köyü)",
      "Bölükbaşı Mah (hisarkaya Köyü)",
      "Bük Mezra Mah (karaağaç Köyü)",
      "Büyük Yaylım Mah (karaağaç Köyü)",
      "Caferoğlu Mah (kuşluhan Köyü)",
      "Cami Mah (yunuslu Köyü)",
      "Camiyanı Mah (ezeltere Köyü)",
      "Camiyanı Mah (inece Köyü)",
      "Camiyanı Mah (kuzköy Köyü)",
      "Camiyanı Mah (samugüney Köyü)",
      "Camiyanı Mah (yaslıbahçe Köyü)",
      "Canali Mah (erdoğan Köyü)",
      "Cerelli Mah (icilli Köyü)",
      "Cılanbus Mah (bostanlı Köyü)",
      "Cukurca Mah (icilli Köyü)",
      "Cürgüloğlu Mah (kuşluhan Köyü)",
      "Çakıldak Mah (ataköy Köyü)",
      "Çakıroğlu Mah (erdoğan Köyü)",
      "Çardaktepe Mah (pazarsuyu Köyü)",
      "Çarşık Mah (bahçeli Köyü)",
      "Çekmebel Mah (kayabaşı Köyü)",
      "Çel Mah (büyükada Köyü)",
      "Çıraklı Mah (ataköy Köyü)",
      "Çukur Mah (erdoğan Köyü)",
      "Damudere Köyü",
      "Davutoğlu Mah (inece Köyü)",
      "Demircili Köyü",
      "Dere Pazarı Mah (büyükada Köyü)",
      "Deredibi / Duacıoğlu Mah (inece Köyü)",
      "Dışkaya Mah (karaağaç Köyü)",
      "Duacıoğlu Mah (kuşluhan Köyü)",
      "Düz Mah (büyükada Köyü)",
      "Düz Mah (kayhan Köyü)",
      "Elyaslı Mah (pazarsuyu Köyü)",
      "Esebey Mah (şeyhmusa Köyü)",
      "Eski Cami Yanı Mah (pazarsuyu Köyü)",
      "Eyüpağa Mah (kuşluhan Köyü)",
      "Fındık Çukur Mah (bahçeli Köyü)",
      "Gancu Mah (talipli Köyü)",
      "Gültepe Köyü",
      "Gündoğdu Köyü",
      "Güney Mah (tepecik Köyü)",
      "Güney Mah (yaslıbahçe Köyü)",
      "Güzeren Mah (karaağaç Köyü)",
      "Hacet Köyü",
      "Hacılar Mah (pazarsuyu Köyü)",
      "Hanalan Mah (ezeltere Köyü)",
      "Hasan Yatağı Mah (karaağaç Köyü)",
      "Hasanbaşlı Mah (hisarkaya Köyü)",
      "Hebilli Mah (talipli Köyü)",
      "Henden Mah (erdoğan Köyü)",
      "Hendenli Mah (icilli Köyü)",
      "Iı Osb Mah (pazarsuyu Köyü)",
      "İdiçoğlu Mah (yunuslu Köyü)",
      "İmidolu Mah (ataköy Köyü)",
      "İncal Mah (küçükdere Köyü)",
      "İncebel Mah (pazarsuyu Köyü)",
      "İnüstü Mah (ataköy Köyü)",
      "Kabakçıoğlu Mah (kayhan Köyü)",
      "Kale Güney Köyü",
      "Karakoç Mah (yaslıbahçe Köyü)",
      "Karamanlı Mah (yeşilhisar Köyü)",
      "Karaşlı Mah (hisarkaya Köyü)",
      "Karşıkuşluhan Mah (kuşluhan Köyü)",
      "Kavaklar Ve Belen Mah (cindi Köyü)",
      "Kayadibi Köyü",
      "Kelalioğlu Mah (kuşluhan Köyü)",
      "Keller Mah (cindi Köyü)",
      "Kılıçlı Mah (bostanlı Köyü)",
      "Kılıçtarla Mah (cindi Köyü)",
      "Kıran Mah (ataköy Köyü)",
      "Kıran Mah (inece Köyü)",
      "Kıran Mah (tepecik Köyü)",
      "Kıran Mah (yaslıbahçe Köyü)",
      "Kırma Mah (talipli Köyü)",
      "Kış Yatağı Mah (karaağaç Köyü)",
      "Kışla Köyü",
      "Kışla Mah (hisarkaya Köyü)",
      "Kışlacık Mah (eriklik Köyü)",
      "Kibarcar Mah (kayabaşı Köyü)",
      "Kirazlık Mah (şeyhmusa Köyü)",
      "Kirezli Mah (hisarkaya Köyü)",
      "Konakyanı Mah (burunucu Köyü)",
      "Kovancak Mah (karacaresul Köyü)",
      "Kovancak Mah (yalıköy Köyü)",
      "Kozluk Mah (yalıköy Köyü)",
      "Kurukoca Mah (büyükada Köyü)",
      "Küçükada Köyü",
      "Küçüklü Mah (bostanlı Köyü)",
      "Lazlar Mah (hisarkaya Köyü)",
      "Lazoğlu Mah (yeşilhisar Köyü)",
      "Madenaltı Mah (pazarsuyu Köyü)",
      "Melikli Oğlu Mah (burunucu Köyü)",
      "Merkez Mah (ahmetli Köyü)",
      "Merkez Mah (ataköy Köyü)",
      "Merkez Mah (bahçeli Köyü)",
      "Merkez Mah (cindi Köyü)",
      "Merkez Mah (duttepe Köyü)",
      "Merkez Mah (erdoğan Köyü)",
      "Merkez Mah (eriklik Köyü)",
      "Merkez Mah (esenköy Köyü)",
      "Merkez Mah (güneyköy Köyü)",
      "Merkez Mah (icilli Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (karacaresul Köyü)",
      "Merkez Mah (kuzköy Köyü)",
      "Merkez Mah (küçükdere Köyü)",
      "Merkez Mah (talipli Köyü)",
      "Merkez Mah (tepecik Köyü)",
      "Merkez Mah (yalıköy Köyü)",
      "Muhal Mah (küçüklü Köyü)",
      "Muratlı Köyü",
      "Odabaşoğlu Mah (kayhan Köyü)",
      "Odadüzü Köyü",
      "Ofran Mah (burunucu Köyü)",
      "Okulyanı Mah (yaslıbahçe Köyü)",
      "Orta Dikmen Mah (burunucu Köyü)",
      "Orta Mah (kayabaşı Köyü)",
      "Orta Mah (küçüklü Köyü)",
      "Orta Mah (şeyhmusa Köyü)",
      "Orta Mah (yunuslu Köyü)",
      "Osman Şıh Mah (talipli Köyü)",
      "Öksüzoğlu Mah (bostanlı Köyü)",
      "Pazarsuyu Emecen Mah",
      "Resuloğlu Mah (kuşluhan Köyü)",
      "Salibaşı Mah (samugüney Köyü)",
      "Salman Mah (şeyhmusa Köyü)",
      "Sandık Kaya Kirazlık Mah (pazarsuyu Köyü)",
      "Sarımusa Mah (büyükada Köyü)",
      "Sarıveli Mah (ahmetli Köyü)",
      "Soğulca Mah (duttepe Köyü)",
      "Süleymanşeyh Mah (kuşluhan Köyü)",
      "Süme Köyü",
      "Sünnetçi Mah (yunuslu Köyü)",
      "Şardağ Düz Mah (pazarsuyu Köyü)",
      "Şardağ Yukarı Mah (pazarsuyu Köyü)",
      "Şebli Mah (güneyköy Köyü)",
      "Şehit Yakup Özgen Mah (inece Köyü)",
      "Şenkaya Mah (eriklik Köyü)",
      "Şevhmusa Mah (şeyhmusa Köyü)",
      "Taşdibek Mah (eriklik Köyü)",
      "Taşo Mah (erdoğan Köyü)",
      "Tatarlı Mah (tepecik Köyü)",
      "Tataroğlu Mah (talipli Köyü)",
      "Tekmezar Köyü",
      "Teknetaş Mah (karaağaç Köyü)",
      "Tellioğlu Mah (kayhan Köyü)",
      "Tepecik Mah (yunuslu Köyü)",
      "Tepeören Köyü",
      "Tezilli Mah (talipli Köyü)",
      "Topalak Mah (ahmetli Köyü)",
      "Topaloğlu Mah (yunuslu Köyü)",
      "Torçan Köyü",
      "Torun Mah (samugüney Köyü)",
      "Torunoğlu Mah (kuzköy Köyü)",
      "Tömgeldüzü Mah (kayabaşı Köyü)",
      "Trıngo-topçu-culha Mah (erdoğan Köyü)",
      "Uğurlu Mah (bostanlı Köyü)",
      "Üst Mah (küçüklü Köyü)",
      "Üst Mah (samugüney Köyü)",
      "Üst Mah (tepecik Köyü)",
      "Yalı Mah (küçüklü Köyü)",
      "Yaslı Mah (ezeltere Köyü)",
      "Yazı Mah (burunucu Köyü)",
      "Yeni Mah (bahçeli Köyü)",
      "Yeşilköy Köyü",
      "Yılandiloğlu Mah (yunuslu Köyü)",
      "Yıldız Köyü",
      "Yukarı Dikmen Mah (burunucu Köyü)"
    ],
    "Çamoluk": [
      "Karşıyaka Mah",
      "Kurtuluş Mah",
      "Akyapı Köyü",
      "Alızsız Mah (hacıören Köyü)",
      "Bayır Köyü",
      "Çakılkaya Köyü",
      "Daldibi Köyü",
      "Dulundas Mah",
      "Eğnir Köyü",
      "Fındıklı Köyü",
      "Gücer Köyü",
      "Gürçalı Köyü",
      "Hacıahmetoğlu Köyü",
      "Hotar Mah (pınarlı Köyü)",
      "Hürriyet Mah",
      "Hüseyin Ağa Deresi Mah (kılıçtutan Köyü)",
      "Kadil Mah (kılıçtutan Köyü)",
      "Kaledere Köyü",
      "Karabayır Mah (kılıçtutan Köyü)",
      "Karadikmen Köyü",
      "Kayacık Köyü",
      "Kaynar Köyü",
      "Koçak Köyü",
      "Köroğlu Mah",
      "Kurukol Mah",
      "Kutluca Köyü",
      "Merkez Mah (hacıören Köyü)",
      "Merkez Mah (kılıçtutan Köyü)",
      "Merkez Mah (pınarlı Köyü)",
      "Okçaören Köyü",
      "Ozan Köyü",
      "Pazar Mah (yenice Köyü)",
      "Pınarbaşı Mah (yenice Köyü)",
      "Sarpkaya Köyü",
      "Taşcılar Köyü",
      "Taşdemir Köyü",
      "Usluca Köyü",
      "Yazılar Mah",
      "Yeniköy Köyü",
      "Yusufeli Köyü",
      "Yuvacık Mah"
    ],
    "Çanakçı": [
      "Armutdüzü Mah (düzköy Köyü)",
      "Aşağı Mah (akköy Köyü)",
      "Aşağı Mah (bakımlı Köyü)",
      "Aşağı Mah (doğanköy Köyü)",
      "Beküşlü Mah (egeköy Köyü)",
      "Beyli Mah",
      "Boztoprak Mah (egeköy Köyü)",
      "Cami Mah (deregözü Köyü)",
      "Cami Yanı Mah",
      "Cücüklü Mah (düzköy Köyü)",
      "Çağlayan Köyü",
      "Çorak Mah (deregözü Köyü)",
      "Çöcen Mah (karabörk Köyü)",
      "Dalmanlı Mah (egeköy Köyü)",
      "Dergözü Mah (egeköy Köyü)",
      "Ege Mah (egeköy Köyü)",
      "Erikbükü Mah (deregözü Köyü)",
      "Gücer Mah (deregözü Köyü)",
      "Güney Mah (kaledibi Köyü)",
      "Gürebükü 2 Mah (kuşköy Köyü)",
      "Gürebükü Mah (kuşköy Köyü)",
      "Güregeriş Mah (deregözü Köyü)",
      "Güvende Çubuğu Mah (kuşköy Köyü)",
      "Güzören Mah (bakımlı Köyü)",
      "Harman Kıranı Mah (egeköy Köyü)",
      "İzzetli Mah (kuşköy Köyü)",
      "Kale Mah (kaledibi Köyü)",
      "Karaçatak Mah (kahraman Köyü)",
      "Kaşdibi Mah (bakımlı Köyü)",
      "Kavak Mah (deregözü Köyü)",
      "Kıran Mah (doğanköy Köyü)",
      "Kıran Mah (sarayköy Köyü)",
      "Kırıklı Mah (egeköy Köyü)",
      "Kirazören Mah (deregözü Köyü)",
      "Kise 2 Mah (kuşköy Köyü)",
      "Kise Mah (kuşköy Köyü)",
      "Konak Mah (bakımlı Köyü)",
      "Kösekıranı Mah (erenköy Köyü)",
      "Kuz Mah (kaledibi Köyü)",
      "Kuz Mah (karabörk Köyü)",
      "Kuz Mah (yeşilköy Köyü)",
      "Merkez Alt Mah (kuşköy Köyü)",
      "Merkez Mah",
      "Merkez Mah (deregözü Köyü)",
      "Merkez Mah (düzköy Köyü)",
      "Merkez Mah (erenköy Köyü)",
      "Merkez Mah (karabörk Köyü)",
      "Merkez Üst Mah (kuşköy Köyü)",
      "Orta Mah",
      "Orta Mah (sarayköy Köyü)",
      "Ömerli Mah (egeköy Köyü)",
      "Öte Mah (bakımlı Köyü)",
      "Sekü Mah (deregözü Köyü)",
      "Şıhlı Mah (egeköy Köyü)",
      "Tekdoruk Mah (kahraman Köyü)",
      "Tezderesi Mah (kahraman Köyü)",
      "Üst Mah (sarayköy Köyü)",
      "Yakuplu Mah (yeşilköy Köyü)",
      "Yaplu Mah (deregözü Köyü)",
      "Yargeliş Mah (yeşilköy Köyü)",
      "Yazlık Mah (deregözü Köyü)",
      "Yenişadı Köyü",
      "Yukarı Mah (akköy Köyü)",
      "Yukarı Mah (doğanköy Köyü)"
    ],
    "Dereli": [
      "Bahçeli Mah",
      "Dereli Mah",
      "Fatih Mah",
      "Kuşluhan Mah",
      "Kuzca Mah",
      "Sütlüce Mah",
      "Ada Mah (eğrianbar Köyü)",
      "Adıbeş Mah (yüce Köyü)",
      "Ağgözlü Mah (aksu Köyü)",
      "Ağut Mah (güzelköy Köyü)",
      "Ahmetli Mah (küknarlı Köyü)",
      "Akkaya Mah (akkaya Köyü)",
      "Akmazgöl Mah (çengelköy Köyü)",
      "Alageriş Mah (çalca Köyü)",
      "Aliçavuşlu Mah (heydere Köyü)",
      "Alipaşa Mah (kümbet Köyü)",
      "Alt Mah (küçükahmet Köyü)",
      "Angutlu Mah (taşlıca Köyü)",
      "Aralcak Mah (eğrianbar Köyü)",
      "Ardıçlı Mah (içmesu Köyü)",
      "Armutalanı Mah (kümbet Köyü)",
      "Arpaçukuru Mah (çamlı Köyü)",
      "Asarbelen Mah (kurtulmuş Köyü)",
      "Aşağı Mah (alancık Köyü)",
      "Aşağı Mah (hisarköy Köyü)",
      "Aşağı Mah (kızıltaş Köyü)",
      "Aşağı Mah (taşlıca Köyü)",
      "Aşağı Mah (uzundere Köyü)",
      "Ayılıyatak Mah (eğrianbar Köyü)",
      "Ayıyatağı Mah (çalköy Köyü)",
      "Aymaç Mah (uzundere Köyü)",
      "Ayno Mah (çamlı Köyü)",
      "Aytepesi-gavur Hendeği Mah (akkaya Köyü)",
      "Bakacak Mah (kurtulmuş Köyü)",
      "Baltamı Mah (kurtulmuş Köyü)",
      "Baş Yayla Mah (akkaya Köyü)",
      "Başalan Mah (yüce Köyü)",
      "Başçatak Mah (uzundere Köyü)",
      "Başlak Mah (pınarlar Köyü)",
      "Batı Mah (çalköy Köyü)",
      "Bayramlı Mah (uzundere Köyü)",
      "Bekirler Mah (çengelköy Köyü)",
      "Bektaş Mah (konuklu Köyü)",
      "Bektaş Yaylası Mah (oba Mah) (konuklu Köyü)",
      "Bidiko Mah (yeşilkaya Köyü)",
      "Budağağzı Mah (kurtulmuş Köyü)",
      "Bük Mah (kurtulmuş Köyü)",
      "Bük Mah (tepeküknarlı Köyü)",
      "Cablı Mah (yüce Köyü)",
      "Cal Mah (kümbet Köyü)",
      "Cami Mah (aksu Köyü)",
      "Cami Mah (çalca Köyü)",
      "Camiyanı Mah (akkaya Köyü)",
      "Camiyanı Mah (güdül Köyü)",
      "Camiyanı Mah (güzelköy Köyü)",
      "Camiyanı Mah (içmesu Köyü)",
      "Camiyanı Mah (küçükahmet Köyü)",
      "Camiyanı Mah (yıldız Köyü)",
      "Cevizlik Mah (güdül Köyü)",
      "Cinahmetli Mah (heydere Köyü)",
      "Çağman-ağa Kaya Mah (akkaya Köyü)",
      "Çağman-gavraz Mah (akkaya Köyü)",
      "Çamağzı Mah (tamdere Köyü)",
      "Çambelen Mah (yeşilvadi Köyü)",
      "Çamlıcı Mah (eğrianbar Köyü)",
      "Çamurboğazı Mah (heydere Köyü)",
      "Çanakçı Mah (meşeliyatak Köyü)",
      "Çatak Mah (akkaya Köyü)",
      "Çatak Mah (yeşilkaya Köyü)",
      "Çatalan Mah (sarıyakup Köyü)",
      "Çayırlı Mah (kümbet Köyü)",
      "Çıraktamı Mah (kurtulmuş Köyü)",
      "Çıtlak Mah (yeşilkaya Köyü)",
      "Çıtlaklı Mah (yıldız Köyü)",
      "Çiftçioğlu Mah (kümbet Köyü)",
      "Çilingir Mah (yeşiltepe Köyü)",
      "Çobanlı Mah (güdül Köyü)",
      "Çobanlı Mah (yüce Köyü)",
      "Çomakkonağı Mah (kümbet Köyü)",
      "Çorakalan Mah (yüce Köyü)",
      "Çorukoğlu Mah (kümbet Köyü)",
      "Çubuk Mah (yüce Köyü)",
      "Dağ Güzleği Mah (alancık Köyü)",
      "Dağlıağaç Mah (alancık Köyü)",
      "Dalino Mah (yeşiltepe Köyü)",
      "Darakcı Mah (tepeköy Köyü)",
      "Dayıpoğlu Mah (çamlı Köyü)",
      "Değinmenarkası Mah (yüce Köyü)",
      "Derecik Mah (konuklu Köyü)",
      "Doğuca Mah (konuklu Köyü)",
      "Düzçayır Mah (çamlı Köyü)",
      "Düzyatak Mah (eğrianbar Köyü)",
      "Efelioğlu Mah (tamdere Köyü)",
      "Eğme Mah (küçükahmet Köyü)",
      "Eğmedağ Mah (küçükahmet Köyü)",
      "Elemeği Mah (uzundere Köyü)",
      "Emingil Mah (yıldız Köyü)",
      "Emir Alioğlu Mah (güzelköy Köyü)",
      "Emürağa Mah (çamlı Köyü)",
      "Erikderesi Mah (uzundere Köyü)",
      "Eseli Mah (çamlı Köyü)",
      "Eskışla Mah (yıldız Köyü)",
      "Evliyadüzü Mah (yüce Köyü)",
      "Faikoğlu Mah (güzelköy Köyü)",
      "Falcılı Mah (eğrianbar Köyü)",
      "Fındıklı Mah (yüce Köyü)",
      "Fişekli Mah (aksu Köyü)",
      "Garipli Mah (çalköy Köyü)",
      "Gemidireği Mah (küknarlı Köyü)",
      "Geyrez Mah (kümbet Köyü)",
      "Göbel 2 Mah (kümbet Köyü)",
      "Göbel Mah (kümbet Köyü)",
      "Göblü Mah (konuklu Köyü)",
      "Göçek Mah (çalköy Köyü)",
      "Gökçebel Mah (kurtulmuş Köyü)",
      "Gökseki Mah (çalca Köyü)",
      "Gücese Mah (pınarlar Köyü)",
      "Gücükburun Mah (yeşiltepe Köyü)",
      "Güdüldibi Mah (güdül Köyü)",
      "Güney Mah (içmesu Köyü)",
      "Güney Mah (tepeköy Köyü)",
      "Güney Mah (yıldız Köyü)",
      "Güvelen Mah (aksu Köyü)",
      "Hacıderesi Mah (kümbet Köyü)",
      "Hacıköy Mah (kızıltaş Köyü)",
      "Hacıoğlu Mah (yıldız Köyü)",
      "Hacıyeri Mah (heydere Köyü)",
      "Hamurlu Mah (kümbet Köyü)",
      "Hancıyanı Mah (yıldız Köyü)",
      "Hanto Mah (güzelköy Köyü)",
      "Hanyanı Mah (çalca Köyü)",
      "Harmanbaşı Mah (çalca Köyü)",
      "Hatipli Mah (yeşilkaya Köyü)",
      "Hıdımlı Mah (heydere Köyü)",
      "Hıdırellez Mah (çalköy Köyü)",
      "Holunlu Mah (aksu Köyü)",
      "İkisu Mah (tamdere Köyü)",
      "İnçeşme Mah (güzelköy Köyü)",
      "İnişdibi Mah (çalköy Köyü)",
      "İskender Mah (eğrianbar Köyü)",
      "Kabaklı Mah (kızıltaş Köyü)",
      "Kadıgil Mah (meşeliyatak Köyü)",
      "Kapıkaya Mah (aksu Köyü)",
      "Kaptancı Mah (güzelköy Köyü)",
      "Karaçukur Mah (güdül Köyü)",
      "Karakışla Mah (çalca Köyü)",
      "Karakoç Mah (konuklu Köyü)",
      "Karakoççayırı Mah (uzundere Köyü)",
      "Karaşlı Kıran Mah (küknarlı Köyü)",
      "Karaveli Mah (küknarlı Köyü)",
      "Karınca Mah (tamdere Köyü)",
      "Kavuzoğlu Mah (çalköy Köyü)",
      "Kayaaltı Mah (konuklu Köyü)",
      "Kayadibi Mah (yıldız Köyü)",
      "Keleşkıran Mah (küknarlı Köyü)",
      "Kendirlik Mah (çalköy Köyü)",
      "Kertil Mah (çengelköy Köyü)",
      "Keşoğlu Mah (küçükahmet Köyü)",
      "Keşoğlu Mah (kümbet Köyü)",
      "Keymana Mah (yüce Köyü)",
      "Kıran Mah (çalca Köyü)",
      "Kıran Mah (eğrianbar Köyü)",
      "Kıran Mah (yeşiltepe Köyü)",
      "Kıranyatak Mah (yüce Köyü)",
      "Kırık Mah (yeşiltepe Köyü)",
      "Kışla Mah (heydere Köyü)",
      "Kışla Mah (küknarlı Köyü)",
      "Kızılot Mah (çamlı Köyü)",
      "Kirazören Mah (eğrianbar Köyü)",
      "Koçdere Mah (yeşilkaya Köyü)",
      "Koçkayası Mah (kümbet Köyü)",
      "Koçtepe Mah (alancık Köyü)",
      "Koyunalan Mah (alancık Köyü)",
      "Koz Köyü Mah (alancık Köyü)",
      "Kozdere Mah (heydere Köyü)",
      "Köprübaşı Mah (küçükahmet Köyü)",
      "Köprübaşı Mah (yüce Köyü)",
      "Kösehasan Mah (konuklu Köyü)",
      "Köselioğlu Mah (tepeküknarlı Köyü)",
      "Köyiçi Mah (çamlı Köyü)",
      "Köyiçi Mah (kurtulmuş Köyü)",
      "Köyyeri Mah (uzundere Köyü)",
      "Kuzalan Mah (alancık Köyü)",
      "Kuzca Mah (çalköy Köyü)",
      "Kümbet Mah (kümbet Köyü)",
      "Kümbet Mah (uzundere Köyü)",
      "Kürtün Mah (pınarlar Köyü)",
      "Maden Mah (maden Köyü)",
      "Maden Mah (meşeliyatak Köyü)",
      "Maskara Mah (kurtulmuş Köyü)",
      "Melense Mah (konuklu Köyü)",
      "Melikalan Mah (yüce Köyü)",
      "Merkez Mah (kümbet Köyü)",
      "Merkez Mah (sarıyakup Köyü)",
      "Merkez Mah (tamdere Köyü)",
      "Merkez Mah (tepeküknarlı Köyü)",
      "Merkez Mah (yaylacık Köyü)",
      "Merkez Mah (yüce Köyü)",
      "Meryemana Mah (güdül Köyü)",
      "Molla Ahmet Mah (çengelköy Köyü)",
      "Mollakıran Mah (küknarlı Köyü)",
      "Mor Mah (eğrianbar Köyü)",
      "Musalı Mah (küknarlı Köyü)",
      "Namlu Mah (konuklu Köyü)",
      "Nefesli Mah (heydere Köyü)",
      "Okulyanı Mah (güdül Köyü)",
      "Orta Mah (güzelköy Köyü)",
      "Ören Mah (kurtulmuş Köyü)",
      "Özül Mah (eğrianbar Köyü)",
      "Pınarçukuru Mah (tepeküknarlı Köyü)",
      "Pıtırak Mah (güdül Köyü)",
      "Sakarlı Mah (küknarlı Köyü)",
      "Salonçayırı Mah (kümbet Köyü)",
      "Saltuk Mah (çamlı Köyü)",
      "Sandıkkaya Mah (yıldız Köyü)",
      "Saraycık Mah (yüce Köyü)",
      "Sarımsak Mah (uzundere Köyü)",
      "Satırgil Mah (meşeliyatak Köyü)",
      "Sırganlı Mah (uzundere Köyü)",
      "Sıylık Mah (meşeliyatak Köyü)",
      "Susuz Mah (uzundere Köyü)",
      "Suüstü Mah (çalköy Köyü)",
      "Suüstü Mah (yeşilkaya Köyü)",
      "Süngütlü Mah (alancık Köyü)",
      "Sürmen Mah (yeşilvadi Köyü)",
      "Şeker Mah (küçükahmet Köyü)",
      "Şıh Mah (kümbet Köyü)",
      "Şıhlar Mah (çalköy Köyü)",
      "Şimşirlik Mah (güdül Köyü)",
      "Şirinler Mah (yıldız Köyü)",
      "Tamdere Yaylası Mah (tamdere Köyü)",
      "Taşbaşı Mah (kümbet Köyü)",
      "Tekke Mah (kümbet Köyü)",
      "Tekkelioğlu Mah (güzelköy Köyü)",
      "Tesbi Mah (alancık Köyü)",
      "Titirik Mah (uzundere Köyü)",
      "Tokaç Kıranı Mah (güzelköy Köyü)",
      "Tonar Mah (uzundere Köyü)",
      "Töngel Mah (çamlı Köyü)",
      "Türüdülü Mah (heydere Köyü)",
      "Ucumengil Mah (meşeliyatak Köyü)",
      "Umutlu Mah (güdül Köyü)",
      "Ustalı Mah (çalca Köyü)",
      "Üst Mah (çengelköy Köyü)",
      "Üst Mah (eğrianbar Köyü)",
      "Üst Mah (küçükahmet Köyü)",
      "Yağmurca Mah (kümbet Köyü)",
      "Yangıncı Mah (güzelköy Köyü)",
      "Yaslıbel Mah (uzundere Köyü)",
      "Yavaşcadere Mah (çalköy Köyü)",
      "Yazlık Mah (akkaya Köyü)",
      "Yeşilvadi Köyü",
      "Yeşilyurt Mah (akkaya Köyü)",
      "Yılanlıca Mah (uzundere Köyü)",
      "Yukarı Mah (aksu Köyü)",
      "Yukarı Mah (hisarköy Köyü)",
      "Yukarı Mah (kızıltaş Köyü)",
      "Yukarı Mah (taşlıca Köyü)",
      "Yukarı Mah (uzundere Köyü)",
      "Ziyaret Obası Mah (akkaya Köyü)",
      "Güzyurdu Mah (yavuzkemal Beldesi)",
      "Hapan Mah (yavuzkemal Beldesi)",
      "Kulakkaya Mah (yavuzkemal Beldesi)",
      "Şıhlar Mah (yavuzkemal Beldesi)",
      "Yeni Mah (yavuzkemal Beldesi)",
      "Yuva Mah (yavuzkemal Beldesi)"
    ],
    "Doğankent": [
      "Merkez Mah",
      "Sadaklı Mah",
      "Süttaşı Mah",
      "Yeni Mah",
      "Yeşiltepe Mah",
      "Ahmetoğlu Mah (güvenlik Köyü)",
      "Almadibi Mah (güvenlik Köyü)",
      "Almadibi Mah (söğütağzı Köyü)",
      "Alt Mah (güdül Köyü)",
      "Annakkıran Mah (çatak Köyü)",
      "Aşağı Mah (söğütağzı Köyü)",
      "Başhozan Mah (güvenlik Köyü)",
      "Büyükdağ Mah (çatak Köyü)",
      "Camiyanı Mah (çatalağaç Köyü)",
      "Camiyanı Mah (kozköy Köyü)",
      "Celel Mah (doymuş Köyü)",
      "Çakırlı Mah (çatak Köyü)",
      "Çerkezli Mah (doymuş Köyü)",
      "Dere Mah (söğütağzı Köyü)",
      "Deregözü Mah (söğütağzı Köyü)",
      "Dereyatak Mah (güvenlik Köyü)",
      "Derindere Mah (çatalağaç Köyü)",
      "Ellezli Mah (oyraca Köyü)",
      "Emirli Mah (kozköy Köyü)",
      "Eskimaden Mah (oyraca Köyü)",
      "Gökçebel Mah (doymuş Köyü)",
      "Güney Mah (güdül Köyü)",
      "İslam Mah (yeniköy Köyü)",
      "Kahveyanı Mah (çatak Köyü)",
      "Kaleboynu Mah (kozköy Köyü)",
      "Kavrazlı Mah (çatak Köyü)",
      "Kıran Mah (güdül Köyü)",
      "Kıran Mah (oyraca Köyü)",
      "Kocamanlı Mah (çatak Köyü)",
      "Melikli Mah (çatak Köyü)",
      "Melikli Mah (doymuş Köyü)",
      "Orta Mah (çatak Köyü)",
      "Orta Mah (çatalağaç Köyü)",
      "Orta Mah (güdül Köyü)",
      "Oyraca Mah (oyraca Köyü)",
      "Örenalan Mah (güvenlik Köyü)",
      "Töngelbükü Mah (kozköy Köyü)",
      "Ustalı Mah (çatak Köyü)",
      "Üzümce Mah (doymuş Köyü)",
      "Yamaklı Mah (çatak Köyü)",
      "Yanağzı Mah (söğütağzı Köyü)",
      "Yanlızca Mah (güvenlik Köyü)",
      "Yazlık Mah (çatak Köyü)",
      "Yerlice Mah (yeniköy Köyü)",
      "Zögeli Mah (oyraca Köyü)"
    ],
    "Espiye": [
      "Adabük Mah",
      "Çam Mah",
      "Esentepe Mah",
      "Karadere Mah",
      "Merkez Mah",
      "Ağaçlık Mah (çepniköy Köyü)",
      "Ağalıkmadeni Mah",
      "Akkaş Mah (sakarya Köyü)",
      "Aktaş Mah (gülburnu Köyü)",
      "Alaşerit Mah (ibrahimşeyh Köyü)",
      "Alican Mah (yeşilköy Köyü)",
      "Andoz Mah (sakarya Köyü)",
      "Arpagerişi Mah (aralıcak Köyü)",
      "Aşağı Balıklı Mah (şahinyuva Köyü)",
      "Aşağı Mah (bayrambey Köyü)",
      "Attutan Mah (demircili Köyü)",
      "Avruk Mah (yeşilköy Köyü)",
      "Aydınlar Köyü",
      "Ayvazlı Kıranı Mah (gebelli Köyü)",
      "Azaplı Mah (ibrahimşeyh Köyü)",
      "Balıklı Orta Mah (şahinyuva Köyü)",
      "Bekirli Mah (ibrahimşeyh Köyü)",
      "Bitene-yar Mah (şahinyuva Köyü)",
      "Bocullu Mah (hacımahmutlu Köyü)",
      "Boğmanlık Mah (gümüşdere Köyü)",
      "Boncuk Kıranı Mah (güzelyurt Köyü)",
      "Boncukçu Mah",
      "Buruntarla Mah (çepniköy Köyü)",
      "Buruşlu Mah (avluca Köyü)",
      "Cennetli Mah (ibrahimşeyh Köyü)",
      "Cibril Mah",
      "Cinali Mah (ibrahimşeyh Köyü)",
      "Civek Mah (gülburnu Köyü)",
      "Çam Mah (yeniköy Köyü)",
      "Çamanlı Mah (kurugeriş Köyü)",
      "Çamburnu Mah (değirmenağzı Köyü)",
      "Çamdibi Mah (bayrambey Köyü)",
      "Çay Gözü Mah (akkaya Köyü)",
      "Çay Mah (güzelyurt Köyü)",
      "Çaykara Mah (kaşdibi Köyü)",
      "Çıngıl Mah (şahinyuva Köyü)",
      "Çitlibeli Mah (tikence Köyü)",
      "Çukur Mah (çalkaya Köyü)",
      "Değirmenardı Mah (ericek Köyü)",
      "Depen  Kız Mah (yeşilköy Köyü)",
      "Dere Mah (güzelyurt Köyü)",
      "Dere Mah (hacıköy Köyü)",
      "Diken Düzü-ömer Tarla Mah (şahinyuva Köyü)",
      "Direkbükü Mah (direkbükü Köyü)",
      "Düz Mah (bahçecik Köyü)",
      "Düz Mah (çalkaya Köyü)",
      "Elevli Mah (aralıcak Köyü)",
      "Ellezli Mah (sakarya Köyü)",
      "Engelek Mah (ibrahimşeyh Köyü)",
      "Firarlı Mah (kurugeriş Köyü)",
      "Gedikli Mah (hacıköy Köyü)",
      "Gezinli Mah (aralıcak Köyü)",
      "Göl Yanı Mah (aralıcak Köyü)",
      "Guyanı Mah (çalkaya Köyü)",
      "Gülburnu Köyü",
      "Güney Mah (avluca Köyü)",
      "Güney Mah (güzelyurt Köyü)",
      "Hacaklı Mah (sakarya Köyü)",
      "Hacıköy Köyü",
      "Haçbey Mah (arpacık Köyü)",
      "Hanyanı Mah (ericek Köyü)",
      "Harman Mah (kurugeriş Köyü)",
      "Harşıtlı Mah (hacımahmutlu Köyü)",
      "Hendek Altı Mah (akkaya Köyü)",
      "Hendek Üstü Mah (akkaya Köyü)",
      "Henek Mah (gülburnu Köyü)",
      "Hıdıroğlu Mah (yeniköy Köyü)",
      "Hızarcıoğlu Mah (ibrahimşeyh Köyü)",
      "Hurma Kıran Mah (sakarya Köyü)",
      "Isaklı Mah (kurugeriş Köyü)",
      "İkilikli Mah (hacıköy Köyü)",
      "İnişdibi Mah (avluca Köyü)",
      "Kabak Çukuru Mah (tikence Köyü)",
      "Kaleboynu Mah",
      "Kandaor Mah (yeniköy Köyü)",
      "Karakaş Mah (aralıcak Köyü)",
      "Karakuzu Mah (ericek Köyü)",
      "Karamanlı Mah (kurugeriş Köyü)",
      "Karşı Mah (bayrambey Köyü)",
      "Karşıköy Mah (ericek Köyü)",
      "Kayadibi Mah (hacımahmutlu Köyü)",
      "Kayadüzü Mah (çepniköy Köyü)",
      "Keçigeriş Mah (yeşilyurt Köyü)",
      "Keldağ Abanozlu Mah (sakarya Köyü)",
      "Keleşli Mah (kurugeriş Köyü)",
      "Kıdıl Mah (gülburnu Köyü)",
      "Kıran Alt Mah (gülburnu Köyü)",
      "Kıran Mah (aralıcak Köyü)",
      "Kıran Mah (yeniköy Köyü)",
      "Kıran Üst  Mah (gülburnu Köyü)",
      "Kızıldere Mah (bahçecik Köyü)",
      "Kızılevkur Mah (yeşilköy Köyü)",
      "Kızılot Mah (seydiköy Köyü)",
      "Killik Mah (şahinyuva Köyü)",
      "Kireççili Mah (ericek Köyü)",
      "Konak Kıranı Mah (gebelli Köyü)",
      "Konakkıranı Mah (kaşdibi Köyü)",
      "Kozbükü Mah (avluca Köyü)",
      "Kökdiken Mah (ericek Köyü)",
      "Köprübaşı Mah (kurugeriş Köyü)",
      "Köse Mah (yeşilyurt Köyü)",
      "Köse Tepesi Mah (yeşilyurt Köyü)",
      "Köy Eteği Mah (avluca Köyü)",
      "Kunduz Mrk Mah (sakarya Köyü)",
      "Kuz Mah (hacıköy Köyü)",
      "Kuz Mah (yeniköy Köyü)",
      "Kuz Sağmanı Mah (direkbükü Köyü)",
      "Kuzbahçe Mah (çepniköy Köyü)",
      "Kuzbaşı Mah (bayrambey Köyü)",
      "Külcülü Mah (aralıcak Köyü)",
      "Liman Mah (gülburnu Köyü)",
      "Maden Merkez Mah (şahinyuva Köyü)",
      "Mamak Evyanı Mah (aralıcak Köyü)",
      "Merkez Mah (arpacık Köyü)",
      "Merkez Mah (çepniköy Köyü)",
      "Merkez Mah (gebelli Köyü)",
      "Merkez Mah (gümüşdere Köyü)",
      "Merkez Mah (güneyköy Köyü)",
      "Merkez Mah (hacıköy Köyü)",
      "Merkez Mah (hacımahmutlu Köyü)",
      "Merkez Mah (seydiköy Köyü)",
      "Merkez Mah (şahinyuva Köyü)",
      "Merkez Mah (taflancık Köyü)",
      "Merkez Mah (tikence Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Neel Mah (hacıköy Köyü)",
      "Orta Alan Mah (avluca Köyü)",
      "Orta Burun Mah (güzelyurt Köyü)",
      "Orta Mah (ericek Köyü)",
      "Orta Mah (ibrahimşeyh Köyü)",
      "Öteköy Mah (çepniköy Köyü)",
      "Portakallı Mah (gebelli Köyü)",
      "Portlu Mah (güzelyurt Köyü)",
      "Püllü Mah (avluca Köyü)",
      "Sali Mah (avluca Köyü)",
      "Salihli Mah (hacımahmutlu Köyü)",
      "Salman Mah (yeşilköy Köyü)",
      "Sarıbaşlı Mah (avluca Köyü)",
      "Sarımahmut Mah (demircili Köyü)",
      "Sasu Mah (avluca Köyü)",
      "Saz Mah (çalkaya Köyü)",
      "Sedelekli Mah (sakarya Köyü)",
      "Sülük Gölü Mah (tikence Köyü)",
      "Şalcı Mah (çepniköy Köyü)",
      "Tamdüzü Mah (avluca Köyü)",
      "Tepe Mah (çalkaya Köyü)",
      "Tepe Mah (taflancık Köyü)",
      "Tepe Mah (yeşilyurt Köyü)",
      "Tepeçubuk Mah (sakarya Köyü)",
      "Tepekoru Mah (kaşdibi Köyü)",
      "Tepeköy Mah (hacımahmutlu Köyü)",
      "Tezderesi Mah (ericek Köyü)",
      "Törselcik Mah (ericek Köyü)",
      "Turunçönü Mah (değirmenağzı Köyü)",
      "Uluburun Mah (değirmenağzı Köyü)",
      "Uzunkum Mah (güneyköy Köyü)",
      "Vardomuz -alişangil Mah (şahinyuva Köyü)",
      "Velipli Mah (hacıköy Köyü)",
      "Yakaağzı Mah (sakarya Köyü)",
      "Yaykın Mah (çalkaya Köyü)",
      "Yazlık Mah (kaşdibi Köyü)",
      "Yeni Mah (gülburnu Köyü)",
      "Yeni Mah (ibrahimşeyh Köyü)",
      "Yıldırımlar Mah (yeniköy Köyü)",
      "Yırtaklı Mah (hacıköy Köyü)",
      "Yukarı Mah (bayrambey Köyü)",
      "Yusufev Yanı Mah (yeşilyurt Köyü)",
      "Yusuflu Mah (kurugeriş Köyü)",
      "Dikmen Mah (soğukpınar Beldesi)",
      "Kozköy Mah (soğukpınar Beldesi)",
      "Merkez Mah (soğukpınar Beldesi)",
      "Tuygun Mah (soğukpınar Beldesi)"
    ],
    "Eynesil": [
      "Altınlı Mah",
      "Boztepe Mah",
      "Derebaşı Mah",
      "Gümüşçay Mah",
      "Köseli Mah",
      "Adaköy Köyü",
      "Alt Mah (kemaliye Köyü)",
      "Alt Mah (yarımca Köyü)",
      "Aralık Köyü",
      "Armutlu Alan Mah (yarımca Köyü)",
      "Aşağı Mah (dereköy Köyü)",
      "Berberli Mah (dereköy Köyü)",
      "Çolaklı Mah (balcılı Köyü)",
      "Dere Mah (yarımca Köyü)",
      "Emanetli Güney Mah (kemerli Köyü)",
      "Gençaligil Kayalı Mah (kemerli Köyü)",
      "Gülalan Mah (balcılı Köyü)",
      "Haliloğlu Mah (çorapçılar Köyü)",
      "İshaklı Köyü",
      "Kazaklı Mah (kemerli Köyü)",
      "Kekiktepe Köyü",
      "Kıran Mah (çorapçılar Köyü)",
      "Kıran Mah (dereköy Köyü)",
      "Kırcaali Mah (kemaliye Köyü)",
      "Kösemen Köyü",
      "Merkez Mah (kemaliye Köyü)",
      "Merkez Mah (kemerli Köyü)",
      "Orta Mah (balcılı Köyü)",
      "Orta Mah (kemaliye Köyü)",
      "Orta Mah (yarımca Köyü)",
      "Sisdağı Mevkii Mah (kemaliye Köyü)",
      "Taşbaşı Mah (kemaliye Köyü)",
      "Tiryakiler Mah (balcılı Köyü)",
      "Toklugil Mah (kemerli Köyü)",
      "Üst Mah (kemaliye Köyü)",
      "Üst Mah (yarımca Köyü)",
      "Yakuplu Mah (çorapçılar Köyü)",
      "Yeşiltepe Mah (kemerli Köyü)",
      "Belen Mah (ören Beldesi)",
      "Camidüzü Mah (ören Beldesi)",
      "Erzikıranı Mah (ören Beldesi)",
      "Kıran Mah (ören Beldesi)",
      "Sokak Mah (ören Beldesi)",
      "Tamyanı Mah (ören Beldesi)",
      "Yakuplu Mah (ören Beldesi)"
    ],
    "Görele": [
      "Bahşiş Mah (çavuşlu Beldesi)",
      "Beyli Mah (çavuşlu Beldesi)",
      "Merkez Mah (çavuşlu Beldesi)",
      "Obakıran Mah (çavuşlu Beldesi)",
      "Orta Mah (çavuşlu Beldesi)",
      "Şahali Mah (çavuşlu Beldesi)",
      "Yeniköy Mah (çavuşlu Beldesi)",
      "Aydınlıkevler Mah",
      "Bahçelievler Mah",
      "Bozcaali Mah",
      "Çeşmebaşı Mah",
      "Hendekbaşı Mah",
      "Kumyalı Mah",
      "Sayfiye Mah",
      "Soğuksu Mah",
      "Yeşiltepe Mah",
      "Acıman Mah (beşirli Köyü)",
      "Ağnak Mah (maksutlu Köyü)",
      "Ahmetli Mah (sağlık Köyü)",
      "Alamatlı Mah (haydarlı Köyü)",
      "Alt Mah (dedeli Köyü)",
      "Alt Mah (köprübaşı Köyü Köyü)",
      "Alt Mah (seferli Köyü)",
      "Alt Mah (şenlik Köyü)",
      "Ambarlı Mah (tepeköy Köyü)",
      "Aralıkoz Köyü",
      "Aşağı Mah (akharman Köyü)",
      "Aşağı Mah (kuşçulu Köyü)",
      "Aşağı Mah (terziali Köyü)",
      "Ataköy Köyü",
      "Atıcıgıran Mah (haydarlı Köyü)",
      "Aycılı Mah (tepeköy Köyü)",
      "Balkanlı Mah (eserli Köyü)",
      "Bayramlı Mah (karaburun Köyü)",
      "Bekirli Mah (karadere Köyü)",
      "Belen Mah (gölbaşı Köyü)",
      "Belen Mah (kuşçulu Köyü)",
      "Beytamı Mah (çiftlikköy Köyü)",
      "Bozbaşı Mah (seferli Köyü)",
      "Burunucu Köyü",
      "Büyük Beyazıt Mah (bayazıt Köyü)",
      "Cami Yanı Mah (haydarlı Köyü)",
      "Camiyanı Mah (akharman Köyü)",
      "Camiyanı Mah (dikmen Köyü)",
      "Camiyanı Mah (karaburun Köyü)",
      "Camiyanı Mah (seferli Köyü)",
      "Camiyanı Mah (soğukpınar Köyü)",
      "Cınbatlı Mah (güneyköy Köyü)",
      "Cillioğlu Mah",
      "Civilli Mah (türkelli Köyü)",
      "Çağman Mah (beşirli Köyü)",
      "Çakallı Mah (kuşçulu Köyü)",
      "Çakırca Mah (koyunhamza Köyü)",
      "Çalış Köyü",
      "Çatak Mah (çatak Köyü)",
      "Çatakkırı Köyü",
      "Çeşme Yanı Mah (haydarlı Köyü)",
      "Çınarlar Mah (menteşe Köyü)",
      "Çolaklı Mah (sağlık Köyü)",
      "Çolaklı Mah (türkelli Köyü)",
      "Çortuklu Mah (şahinyuva Köyü)",
      "Çölen Mah (bayazıt Köyü)",
      "Çukur Altı Mah (haydarlı Köyü)",
      "Çukur Mah (dikmen Köyü)",
      "Dayılı Köyü",
      "Değirmen Yanı Mah (haydarlı Köyü)",
      "Değirmenyanı Mah (dedeli Köyü)",
      "Değirmenyanı Mah (karadere Köyü)",
      "Dere Mah (bayazıt Köyü)",
      "Dere Mah (haydarlı Köyü)",
      "Dereboyu Köyü",
      "Deregözü Mah (esenli Köyü)",
      "Deregözü Mah (karadere Köyü)",
      "Dudukıran Mah (tepeköy Köyü)",
      "Egeli Mah (yeğenli Köyü)",
      "Erikyanı Mah (gülpınar Köyü)",
      "Eseli Mah (ismailbeyli Köyü)",
      "Esenyurt Köyü",
      "Evci Mah (ardıç Köyü)",
      "Eyüpoğlu Mah (akharman Köyü)",
      "Geçit Mah (gölbaşı Köyü)",
      "Geçit Mah (şahinyuva Köyü)",
      "Gocuklu Mah (çiftlikköy Köyü)",
      "Gölbaşı Mah (recepli Köyü)",
      "Gönder Mah (çiftlikköy Köyü)",
      "Gülpınar Mah (dikmen Köyü)",
      "Güney Mah (esenli Köyü)",
      "Güney Mah (gültepe Köyü)",
      "Güney Mah (soğukpınar Köyü)",
      "Güneyköy Köyü",
      "Hacılı Mah (koyunhamza Köyü)",
      "Hacılı Mah (türkelli Köyü)",
      "Hacıoğlu Mah (kuşçulu Köyü)",
      "Hamzalı Köyü",
      "Haramlı Mah (terziali Köyü)",
      "Hastaflanlar Mah (esenli Köyü)",
      "Haydarlı Mah (şenlik Köyü)",
      "Hıdır Mah (esenli Köyü)",
      "Himmet Mah (türkelli Köyü)",
      "Hocalı Mah (ismailbeyli Köyü)",
      "Hopa Mah (esenli Köyü)",
      "Horozköy Mah (ismailbeyli Köyü)",
      "Hotmakçı Mah (kuşçulu Köyü)",
      "Hurmacıoğlu Mah (şafaklı Köyü)",
      "Hürriyet Mah",
      "Irmakdüzü Mah (çalış Köyü)",
      "İğdir Mah (çiftlikköy Köyü)",
      "İkizli Mah (güneyköy Köyü)",
      "İkizli Mah (kuşçulu Köyü)",
      "İmatlı Mah (türkelli Köyü)",
      "İyibağ Mah (güvendik Köyü)",
      "Kaba Mah",
      "Kabakulak Mah (karaburun Köyü)",
      "Kahvecioğlu Mah (karadere Köyü)",
      "Kahveyanı Mah (gülpınar Köyü)",
      "Kale Mah (soğukpınar Köyü)",
      "Kaleköy Köyü",
      "Karaahmet Mah (haydarlı Köyü)",
      "Karaallı Mah (maksutlu Köyü)",
      "Karaçomak Mah (haydarlı Köyü)",
      "Karadere Mah (güneyköy Köyü)",
      "Karadudullu Mah (gülpınar Köyü)",
      "Karakeş Köyü",
      "Karayanlı Mah (haydarlı Köyü)",
      "Karganyatak Mah (güvendik Köyü)",
      "Karlıbel Köyü",
      "Karnallı Mah (gölbaşı Köyü)",
      "Karşı Mah (seferli Köyü)",
      "Kavrazlı Mah (recepli Köyü)",
      "Kavrazlı Mah (şafaklı Köyü)",
      "Kayayanı Mah (gülpınar Köyü)",
      "Kaynar Köyü",
      "Kefereli Mah (bayazıt Köyü)",
      "Keldüzü Mah (gülpınar Köyü)",
      "Kıdır Köyü",
      "Kıran Mah (akharman Köyü)",
      "Kıran Mah (derekuşçulu Köyü)",
      "Kıran Mah (gültepe Köyü)",
      "Kıran Mah (köprübaşı Köyü Köyü)",
      "Kıran Mah (kuşçulu Köyü)",
      "Kıran Mah (maksutlu Köyü)",
      "Kıran Mah (şenlik Köyü)",
      "Kıran Mah (türkelli Köyü)",
      "Kıran Mah (yeğenli Köyü)",
      "Kıranağzı Mah (terziali Köyü)",
      "Kırcalı Mah (ardıç Köyü)",
      "Kışla Mah (köprübaşı Köyü Köyü)",
      "Kışla Mah (şenlik Köyü)",
      "Kızancık Mah (beşirli Köyü)",
      "Kızılelma Mah (bayazıt Köyü)",
      "Kirse Mah (güvendik Köyü)",
      "Koballı Mah (güneyköy Köyü)",
      "Kodalak Mah (karadere Köyü)",
      "Kodalkıran Mah (türkelli Köyü)",
      "Kömürlük Mah (seferli Köyü)",
      "Körükkıranı Mah (derekuşçulu Köyü)",
      "Köseli Mah (ardıç Köyü)",
      "Köseli Mah (boğalı Köyü)",
      "Köseli Mah (güvendik Köyü)",
      "Kudret Mah (gültepe Köyü)",
      "Kulaklı Mah (karadere Köyü)",
      "Kuloğlu Mah (çatak Köyü)",
      "Kurtoğlu Mah (karadere Köyü)",
      "Kutlu Mah (akharman Köyü)",
      "Kuz Mah (şenlik Köyü)",
      "Menteşeli Mah (tepeköy Köyü)",
      "Menzilli Mah (şenlik Köyü)",
      "Merkez Mah (ardıç Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (boğalı Köyü)",
      "Merkez Mah (derekuşçulu Köyü)",
      "Merkez Mah (eserli Köyü)",
      "Merkez Mah (inanca Köyü)",
      "Merkez Mah (kırıklı Köyü)",
      "Merkez Mah (köprübaşı Köyü Köyü)",
      "Merkez Mah (maksutlu Köyü)",
      "Merkez Mah (recepli Köyü)",
      "Merkez Mah (şafaklı Köyü)",
      "Merkez Mah (yeğenli Köyü)",
      "Meyitoğlu Mah (güvendik Köyü)",
      "Mezarlıkbaşı Mah (yeğenli Köyü)",
      "Mezbahaneyanı Mah (yeğenli Köyü)",
      "Muncu Mah (güvendik Köyü)",
      "Mustafaoğlu Mah (beşirli Köyü)",
      "Mustafaoğlu Mah (güvendik Köyü)",
      "Nebili Mah (çalış Köyü)",
      "Okulyanı Mah (sağlık Köyü)",
      "Orta Mah (beşirli Köyü)",
      "Orta Mah (dedeli Köyü)",
      "Orta Mah (derekuşçulu Köyü)",
      "Orta Mah (gültepe Köyü)",
      "Orta Mah (menteşe Köyü)",
      "Orta Mah (şahinyuva Köyü)",
      "Orta Mah (türkelli Köyü)",
      "Ortaköy Köyü",
      "Önerli Mah (önerli Köyü)",
      "Örnek Mah (aydınlar Köyü)",
      "Özdemir Mah (güvendik Köyü)",
      "Özdemir Mah (haydarlı Köyü)",
      "Özdemir Mah (karaburun Köyü)",
      "Özkarlıbel Mah (karlıbel Köyü)",
      "Patanlı Mah (soğukpınar Köyü)",
      "Pazaryeri Mah (koyunhamza Köyü)",
      "Pıramatlı Mah (terziali Köyü)",
      "Sahil Mah (ismailbeyli Köyü)",
      "Sahil Mah (karaburun Köyü)",
      "Sarıçamurluk Mah (kuşçulu Köyü)",
      "Seki Mah (terziali Köyü)",
      "Sofullu Mah (inanca Köyü)",
      "Sofulu Köyü",
      "Şıhlı Mah (maksutlu Köyü)",
      "Tamyanı Mah (ardıç Köyü)",
      "Taşlık Mah (taşlık Köyü)",
      "Tavacıoğlu Mah (yeğenli Köyü)",
      "Tekgöz Köyü",
      "Temelağa Mah (kuşçulu Köyü)",
      "Tenkoğlu Mah (esenli Köyü)",
      "Tepebaşı Mah",
      "Tepebaşı Mah (terziali Köyü)",
      "Terzili Mah (gölbaşı Köyü)",
      "Tıngırlı Mah (karadere Köyü)",
      "Torunlu Mah (sağlık Köyü)",
      "Turp Mah (terziali Köyü)",
      "Turpallı Mah (akharman Köyü)",
      "Tuzluk Mah (gülpınar Köyü)",
      "Türkelli Mah (türkelli Köyü)",
      "Umutlu Mah (umutlu Köyü)",
      "Ustalı Mah (sağlık Köyü)",
      "Uzunoğlu Mah (yeğenli Köyü)",
      "Uzunönerli Mah (ismailbeyli Köyü)",
      "Ünlüce Mah",
      "Ünlüce Mah (sağlık Köyü)",
      "Üst Mah (dedeli Köyü)",
      "Üst Mah (derekuşçulu Köyü)",
      "Üst Mah (köprübaşı Köyü Köyü)",
      "Üst Mah (menteşe Köyü)",
      "Üst Mah (türkelli Köyü)",
      "Verdili Mah (terziali Köyü)",
      "Yalı Mah (kuşçulu Köyü)",
      "Yalıköy Köyü",
      "Yasımlı Mah (kuşçulu Köyü)",
      "Yelüce Mah (kuşçulu Köyü)",
      "Yeni Mah (ardıç Köyü)",
      "Yeniyol Mah (çatak Köyü)",
      "Yeşildere Köyü",
      "Yukarı Mah (gülpınar Köyü)",
      "Yukarı Mah (inanca Köyü)",
      "Yukarı Mah (menteşe Köyü)",
      "Yukarı Mah (soğukpınar Köyü)",
      "Yukarı Mah (şahinyuva Köyü)",
      "Zıva Mah (türkelli Köyü)"
    ],
    "Güce": [
      "Güce Mah",
      "Abdugil Mah (kuluncak Köyü)",
      "Absak Mah (gürağaç Köyü)",
      "Ahmatlı Mah (boncukçukur Köyü)",
      "Akbaş Mah (tekkeköy Köyü)",
      "Akkakonağı Mah (sarıyar Köyü)",
      "Alanağzı Mah (boncukçukur Köyü)",
      "Aloğlu Mah (ilit Köyü)",
      "Aşağı Mah (akpınar Köyü)",
      "Aşağı Mah (dayıcık Köyü)",
      "Aşağı Mah (düzçukur Köyü)",
      "Aşağı Mah (fındıklı Köyü)",
      "Aşağı Mah (gürağaç Köyü)",
      "Aydınlar Mah (fırınlı Köyü)",
      "Baş Çukur Mah (gürağaç Köyü)",
      "Belen Mah (yukarıboynuyoğun Köyü)",
      "Boynu Kıran Mah (kuluncak Köyü)",
      "Bük Mah (boncukçukur Köyü)",
      "Cami Mah (ilit Köyü)",
      "Cami Yanı Mah (kuluncak Köyü)",
      "Cami Yanı Mah (sarıyar Köyü)",
      "Cardak Çukuru Mah (sarıyar Köyü)",
      "Çakalağzı Mah (kuluncak Köyü)",
      "Çal Mah (kuluncak Köyü)",
      "Çamdüzü Mah (ilit Köyü)",
      "Çatak Mah (yukarıboynuyoğun Köyü)",
      "Danışman Mah (ergenekon Köyü)",
      "Derebük Mah (sarıyar Köyü)",
      "Derebükü Mah (boncukçukur Köyü)",
      "Düz Mah (gürağaç Köyü)",
      "Ebulu Mah (gürağaç Köyü)",
      "Eyüpgil Mah (kuluncak Köyü)",
      "Ezeltepe Mah (boncukçukur Köyü)",
      "Fevzi Çakmak Mah (ilit Köyü)",
      "Fındıklı Mah (ergenekon Köyü)",
      "Gargan Tazlağı Mah (sarıyar Köyü)",
      "Gıran Mah (düzçukur Köyü)",
      "Giyimli Mah",
      "Güney Mah (sarıyar Köyü)",
      "Güni Mah (düzçukur Köyü)",
      "Hasanşıh Mah (yukarıboynuyoğun Köyü)",
      "Hene Mah (akpınar Köyü)",
      "İrizoğlu Mah (gürağaç Köyü)",
      "Kabaalan Mah (tekkeköy Köyü)",
      "Karadere Mah (kuluncak Köyü)",
      "Kavacık Mah (kuluncak Köyü)",
      "Kaya Güney Mah (fındıklı Köyü)",
      "Kemal Kışla Mah (akpınar Köyü)",
      "Kemaliye Mah",
      "Kıran Mah (gürağaç Köyü)",
      "Kıran Mah (ilit Köyü)",
      "Kırık Mah (düzçukur Köyü)",
      "Kovancak Mah (yukarıboynuyoğun Köyü)",
      "Kök Diken Mah (akpınar Köyü)",
      "Köyeteği Mah (boncukçukur Köyü)",
      "Küçük Kargaşa Mah (fındıklı Köyü)",
      "Küçükköy Mah (tekkeköy Köyü)",
      "Mazıdüzü Mah (ilit Köyü)",
      "Merkez Mah (yukarıboynuyoğun Köyü)",
      "Ocak Tamı  Mah (mezra Mah) (tekkeköy Köyü)",
      "Ocak Tamı Mah (tekkeköy Köyü)",
      "Okul Yanı Mah (kuluncak Köyü)",
      "Orta Mah (boncukçukur Köyü)",
      "Orta Mah (düzçukur Köyü)",
      "Orta Mah (fındıklı Köyü)",
      "Orta Mah (kuluncak Köyü)",
      "Örnekköy Köyü",
      "Soğukpınar Köyü",
      "Şehit Muhammer Dur Mah (gürağaç Köyü)",
      "Tevekli Mah",
      "Tuzlakbaşı Mah (fırınlı Köyü)",
      "Üs Mah (fındıklı Köyü)",
      "Üst Mah (akpınar Köyü)",
      "Veledinağzı Mah (boncukçukur Köyü)",
      "Yaylı Gıran Mah (yukarıboynuyoğun Köyü)",
      "Yazlık Mah (ergenekon Köyü)",
      "Yazlık Mah (tekkeköy Köyü)",
      "Yeni Mah (sarıyar Köyü)",
      "Yukarı Mah (dayıcık Köyü)",
      "Yukarı Mah (gürağaç Köyü)"
    ],
    "Keşap": [
      "Bozkurt Mah",
      "Fındıklı Mah",
      "Abdullah Bahçe Mah (karadere Köyü)",
      "Abidinoğlu Mah (güneyköy Köyü)",
      "Acı Armut Mah (çamlıca Köyü)",
      "Ağot Mah (karakoç Köyü)",
      "Akçukur Mah (saraycık Köyü)",
      "Akelma Mah (alataş Köyü)",
      "Akelma Mah (demirci Köyü)",
      "Aktaş Mah (çamlıca Köyü)",
      "Alakaş Mah",
      "Alaşalvaroğlu Mah (arnavut Köyü)",
      "Alın Mah (dokuztepe Köyü)",
      "Alt Mah (harmandarlı Köyü)",
      "Alt Mah (yivdincik Köyü)",
      "Araca Mah (geçit Köyü)",
      "Aralcak Mah (çamlıca Köyü)",
      "Araplı Mah (dokuztepe Köyü)",
      "Armutdüzü Mah (armutdüzü Köyü)",
      "Arnavut Mah (arnavut Köyü)",
      "Aşağı Mah (alataş Köyü)",
      "Aşağı Mah (bayramşah Köyü)",
      "Aşağı Mah (dokuztepe Köyü)",
      "Aşağı Mah (hisarüstü Köyü)",
      "Aşağı Mah (küçükgeriş Köyü)",
      "Aşağı Mah (tepeköy Köyü)",
      "Aşağı Mah (yolbaşı Köyü)",
      "Avut Mah (taflancık Köyü)",
      "Aydınlı Mah (dokuztepe Köyü)",
      "Ayhanlar Mah (evşen Mah) (yolağzı Köyü)",
      "Aykıtlı Mah (karadere Köyü)",
      "Azaplı Mah (düzköy Köyü)",
      "Balıklısu Mah (sancaklıtepe Köyü)",
      "Başköy Mah (karakoç Köyü)",
      "Bekirli Mah (kirazlı Köyü)",
      "Bektaşoğulları Mah (sancaklıtepe Köyü)",
      "Beşirli Mah (gürpınar Köyü)",
      "Bıdıklı Mah (yivdincik Köyü)",
      "Bölükbaşlar Mah (taflancık Köyü)",
      "Burun Mah (küçükgeriş Köyü)",
      "Büyük Şerefli Mah (karadere Köyü)",
      "Büyükgeriş Mah (armutdüzü Köyü)",
      "Cami Mah (çamlıca Köyü)",
      "Cami Mah (halkalı Köyü)",
      "Cami Yanı Mah (dokuztepe Köyü)",
      "Camii Mah (kurbanpınarı Köyü)",
      "Camiyanı Mah (balıklısu Köyü)",
      "Camiyanı Mah (güneyköy Köyü)",
      "Camiyanı Mah (kayabaşı Köyü)",
      "Cebecioğlu Mah (güneyköy Köyü)",
      "Cımula Mah (altınpınar Köyü)",
      "Cibilli Mah (yünlüce Köyü)",
      "Citköprü  Mah (davulcuoğlu Mah) (yolağzı Köyü)",
      "Çağlayan Mah (karabulduk Köyü)",
      "Çağlayan Mah (yolbaşı Köyü)",
      "Çakaltuzağı Mah (geçit Köyü)",
      "Çakıroğlu Mah (güneyköy Köyü)",
      "Çakmaklı Mah (gürpınar Köyü)",
      "Çakraklı Mah (kayabaşı Köyü)",
      "Çapar Mah (küçükgeriş Köyü)",
      "Çardakdüzü Mah (çakırlı Köyü)",
      "Çardaklı Mah (kayabaşı Köyü)",
      "Çataloluk Mah (demirci Köyü)",
      "Çayır Mah (alataş Köyü)",
      "Çayır Mah (altınpınar Köyü)",
      "Çayır Mah (demirci Köyü)",
      "Çengel Değirmeni Mah (geçit Köyü)",
      "Çeşme Yanı Mah (kayabaşı Köyü)",
      "Çiftırlı Mah (gönüllü Köyü)",
      "Çilesizoğlu Mah (hisarüstü Köyü)",
      "Çiriş Mah (halkalı Köyü)",
      "Çobanlı Mah (karaishak Köyü)",
      "Çolakoğlu Mah (taflancık Köyü)",
      "Çukur Mah (dokuztepe Köyü)",
      "Çukur Mah (karadere Köyü)",
      "Dağ Dibi Mah (kayabaşı Köyü)",
      "Dağ Mah (çakırlı Köyü)",
      "Dağ Mah (demirci Köyü)",
      "Dağ Mah (sancaklıtepe Köyü)",
      "Dağtarla Mah (halkalı Köyü)",
      "Dedeli Mah (yazlık Köyü)",
      "Değirmen Ardı Mah (sancaklıtepe Köyü)",
      "Değirmen Mah (sürmenli Köyü)",
      "Değirmenli Mah (sürmenli Köyü)",
      "Delicioğlu Mah (hisarüstü Köyü)",
      "Depozan Çifteler Tarla Mah (karadere Köyü)",
      "Dervişli Mah (kayabaşı Köyü)",
      "Dilberli Mah (kurbanpınarı Köyü)",
      "Dizağız Mah (halkalı Köyü)",
      "Doğanlı Mah (düzköy Köyü)",
      "Döllek Mah (karadere Köyü)",
      "Duman Çukuru Mah (yünlüce Köyü)",
      "Duman Mah (çamlıca Köyü)",
      "Düz Mah (bayrambey Köyü)",
      "Düz Mah (erköy Köyü)",
      "Düz Mah (kurbanpınarı Köyü)",
      "Düzkestane Mah (yivdincik Köyü)",
      "Eğircen Mah (yünlüce Köyü)",
      "Elekçioğlu Mah (çamlıca Köyü)",
      "Elmalık Mah (çamlıca Köyü)",
      "Elmalık Mah (yazlık Köyü)",
      "Ferizderen Mah (yivdincik Köyü)",
      "Gazanferli  Mah (aşağı Mah) (sürmenli Köyü)",
      "Gazanferli  Mah (yukarı Mah) (sürmenli Köyü)",
      "Gelene Mah (düzköy Köyü)",
      "Gıran Mah (karaishak Köyü)",
      "Gödeç Altı Mah (saraycık Köyü)",
      "Göldüzü Mah (düzköy Köyü)",
      "Göldüzü Mah (töngel Köyü)",
      "Göneb Mah (altınpınar Köyü)",
      "Gönep Mah (dokuztepe Köyü)",
      "Guraba Mah (balıklısu Köyü)",
      "Guraba Mah (karadere Köyü)",
      "Gülbaharoğlu Mah (güneyköy Köyü)",
      "Güneyçukur Mah (geçit Köyü)",
      "Güre Mah (altınpınar Köyü)",
      "Hacıhasan Mah (balıklısu Köyü)",
      "Hacıhasanoğlu Mah (kılıçlı Köyü)",
      "Hanyanı Mah (karakoç Köyü)",
      "Hapsa Mah (düzköy Köyü)",
      "Harmancık Güzlük Mah (küçükgeriş Köyü)",
      "Hasanca Mah (gürpınar Köyü)",
      "Havaoğlu Mah (gönüllü Köyü)",
      "Haydarlı Mah (gönüllü Köyü)",
      "Hıdıroğulları Mah (sancaklıtepe Köyü)",
      "Hüseyin Tepe Mah (kılıçlı Köyü)",
      "Hüseyin Tepesi Mah (sürmenli Köyü)",
      "İbilli Mah (karadere Köyü)",
      "İmamlı-1 Mah (karadere Köyü)",
      "İmamlı-2 Mah (karadere Köyü)",
      "İncirlik Mah (düzköy Köyü)",
      "Kabaca Yatak Mah (çamlıca Köyü)",
      "Kabacaoğlu Mah (halkalı Köyü)",
      "Kahyalı Mah (dokuztepe Köyü)",
      "Kalev Mah (düzköy Köyü)",
      "Kara Yunus Mah (halkalı Köyü)",
      "Karabedir Mah",
      "Karabiçli Mah (gönüllü Köyü)",
      "Karahasan Mah (altınpınar Köyü)",
      "Karakaş Mah (ceylanpınar Köyü)",
      "Karamustafaoğlu Mah (halkalı Köyü)",
      "Karavelioğlu Mah (güneyköy Köyü)",
      "Kargın Mah (güneyköy Köyü)",
      "Karşı Mah (alataş Köyü)",
      "Karşıyaka Mah (karabulduk Köyü)",
      "Kaşaltı Mah (bayrambey Köyü)",
      "Kavacık Mah (armutdüzü Köyü)",
      "Kavacık Mah (karakoç Köyü)",
      "Kayadibi Mah (kayabaşı Köyü)",
      "Kayalar Mah (sayca Köyü)",
      "Kayişoğlu Mah (yünlüce Köyü)",
      "Keleşli Mah (karadere Köyü)",
      "Kendiroğlu Mah (hisarüstü Köyü)",
      "Kerimli Mah (sürmenli Köyü)",
      "Kesebelen Mah (dokuztepe Köyü)",
      "Kesikağızlar Mah (kılıçlı Köyü)",
      "Kez Mah (yünlüce Köyü)",
      "Kılıçlı Köyü",
      "Kıran Mah (altınpınar Köyü)",
      "Kıran Mah (bayramşah Köyü)",
      "Kıran Mah (güneyköy Köyü)",
      "Kıran Mah (karadere Köyü)",
      "Kıran Mah (karakoç Köyü)",
      "Kıran Mah (sancaklıtepe Köyü)",
      "Kıran Mah (saraycık Köyü)",
      "Kıran Mah (sürmenli Köyü)",
      "Kıran Mah (töngel Köyü)",
      "Kıranardi Mah (çakırlı Köyü)",
      "Kışla Mah (dokuztepe Köyü)",
      "Kışlak Mah (yazlık Köyü)",
      "Kızıl Belen Mah (dokuztepe Köyü)",
      "Kızılcainiş Mah (sancaklıtepe Köyü)",
      "Kiliseli Mah (karakoç Köyü)",
      "Köklüce-mağdalı Mah (kirazlı Köyü)",
      "Kömyanı Mah (geçit Köyü)",
      "Köroğlu Keloğulları Mah (yolağzı Köyü)",
      "Köyiçi Mah (çakırlı Köyü)",
      "Kulak Mah (tepeköy Köyü)",
      "Kurtağzı Mah (çamlıca Köyü)",
      "Kurukiraz Mah (ceylanpınar Köyü)",
      "Kuşkayası Mah (armutdüzü Köyü)",
      "Kuzanlı Mah (kirazlı Köyü)",
      "Kuzçukur Mah (çakırlı Köyü)",
      "Kuzçukur Mah (kayabaşı Köyü)",
      "Küçük Şerefli Mah (karadere Köyü)",
      "Kürthasanlı Mah (dokuztepe Köyü)",
      "Küştül Mah (geçit Köyü)",
      "Libos Mah (erköy Köyü)",
      "Lombatoğlu Mah (hisarüstü Köyü)",
      "Mehraç Mah (gürpınar Köyü)",
      "Mektepyanı Mah (sürmenli Köyü)",
      "Merkez Mah (bayramşah Köyü)",
      "Merkez Mah (demirci Köyü)",
      "Merkez Mah (düzköy Köyü)",
      "Merkez Mah (geçit Köyü)",
      "Merkez Mah (harmandarlı Köyü)",
      "Merkez Mah (karadere Köyü)",
      "Merkez Mah (kaşaltı Köyü)",
      "Merkez Mah (kılıçlı Köyü)",
      "Merkez Mah (sancaklıtepe Köyü)",
      "Merkez Mah (sayca Köyü)",
      "Merkez Mah (töngel Köyü)",
      "Merkez Okul Mah (gönüllü Köyü)",
      "Meyvalık Mah (yolbaşı Köyü)",
      "Okul Yanı Mah (taflancık Köyü)",
      "Orta Eski Çif Mah (küçükgeriş Köyü)",
      "Orta Mah (alataş Köyü)",
      "Orta Mah (bayramşah Köyü)",
      "Orta Mah (harmandarlı Köyü)",
      "Orta Mah (karabulduk Köyü)",
      "Orta Mah (karakoç Köyü)",
      "Orta Mah (töngel Köyü)",
      "Orta Mah (yivdincik Köyü)",
      "Orta Mah (yolbaşı Köyü)",
      "Oruçlu Mah (alataş Köyü)",
      "Oruçlu Mah (demirci Köyü)",
      "Ömer Oğlu Mah (karaishak Köyü)",
      "Öte Geçe Mah (altınpınar Köyü)",
      "Öte Mah (yivdincik Köyü)",
      "Pamukoğlu Mah (taflancık Köyü)",
      "Pancarcı Mah (çamlıca Köyü)",
      "Paşalı Oğlu Mah (karaishak Köyü)",
      "Pazaryolu Mah (çamlıca Köyü)",
      "Pinazoğlu Mah (taflancık Köyü)",
      "Rahmiler Mah (taflancık Köyü)",
      "Samsunlu Mah (güneyköy Köyü)",
      "Sarı Mah (çamlıca Köyü)",
      "Sarı Ömer Oğlu Mah (çamlıca Köyü)",
      "Saybaşı Mah (kayabaşı Köyü)",
      "Sayyanı Mah (töngel Köyü)",
      "Serdaroğlu Mah (yünlüce Köyü)",
      "Sokulcuk Mah (hisarüstü Köyü)",
      "Sokurcuk Mah (karadere Köyü)",
      "Tamgeriş Mah (geçit Köyü)",
      "Tapanoğlu Mah (hisarüstü Köyü)",
      "Taşbaşı Mah (karadere Köyü)",
      "Tavukluk Mah (dokuztepe Köyü)",
      "Tekbaşlı Mah (karadere Köyü)",
      "Tekerli Mah (düzköy Köyü)",
      "Tepebaşı Mah (sürmenli Köyü)",
      "Tohtamur Mah (yolağzı Köyü)",
      "Tokuşlu Mah (halkalı Köyü)",
      "Tosunlu Mah (kirazlı Köyü)",
      "Uğurca Mah",
      "Unaca Köyü",
      "Unacakuzu Mah (arnavut Köyü)",
      "Uzunkum Bademeli Mah (güneyköy Köyü)",
      "Uzunkum Bodur Mah (güneyköy Köyü)",
      "Uzunkum Mah (güneyköy Köyü)",
      "Uzunkum Sahil Mah (güneyköy Köyü)",
      "Uzunkum Yıftı Mah (güneyköy Köyü)",
      "Üst Mah (harmandarlı Köyü)",
      "Üst Mah (yivdincik Köyü)",
      "Veziroğlu Mah (yolağzı Köyü)",
      "Yağlıkuz Mah (bayrambey Köyü)",
      "Yakuplu Mah (karakoç Köyü)",
      "Yalı Mah (hisarüstü Köyü)",
      "Yalıguz Mah (demirci Köyü)",
      "Yeni Mah (dokuztepe Köyü)",
      "Yeni Mah (karakoç Köyü)",
      "Yolağzı Merkez 1. Nolu Yerleşim Mah (yolağzı Köyü)",
      "Yolağzı Merkez 2. Nolu Yerleşim Mah (yolağzı Köyü)",
      "Yoliçi Mah",
      "Yukarı  Mah (kaya Ardı Mah) (karadere Köyü)",
      "Yukarı Mah (tepeköy Köyü)",
      "Zıbıç Mah (sancaklıtepe Köyü)"
    ],
    "Merkez": [
      "Aksu Mah",
      "Aydınlar Mah",
      "Çaykara Mah",
      "Çınarlar Mah",
      "Gedikkaya Mah",
      "Gemilerçekeği Mah",
      "Hacı Hüseyin Mah",
      "Kale Mah",
      "Kapu Mah",
      "Kavaklar Mah",
      "Kayadibi Mah",
      "Küçükköy Mah",
      "Organize Sanayi Bölgesi Mah",
      "Osmaniye Mah",
      "Samanlıkkıranı Mah",
      "Sultan Selim Mah",
      "Çıtlakkale Mah",
      "Erikliman Mah",
      "Fevzi Çakmak Mah",
      "Gaziler Mah",
      "Güre Mah",
      "Hacımiktat Mah",
      "Hacısiyam Mah",
      "Nizamiye Mah",
      "Seldeğirmeni Mah",
      "Şeyhkeramettin Mah",
      "Teyyaredüzü Mah",
      "Yalı Mah",
      "Çağlayan Mah (duroğlu Beldesi)",
      "Demirci Mah (duroğlu Beldesi)",
      "Homurlu Mah (duroğlu Beldesi)",
      "Konacık Mah (duroğlu Beldesi)",
      "Tekke Mah (duroğlu Beldesi)",
      "Ağalı Mah (sarvan Köyü)",
      "Ağsak Mah (çimşir Köyü)",
      "Akçayoğlu Mah (barça Köyü)",
      "Akseki Mah (yağmurca Köyü)",
      "Alibaşoğlu Mah (darıköy Köyü)",
      "Aligara Mah (yazlık Köyü)",
      "Alikahyaoğlu Mah (sultaniye Köyü)",
      "Alioğulları Mah (yaykınlık Köyü)",
      "Alt Mah (çukurköy Köyü)",
      "Alt Mah (uzgur Köyü)",
      "Aralıcak Mah (akköy Köyü)",
      "Armuttepe Mah (güney Köyü)",
      "Aşağı Mah (çamlık Köyü)",
      "Aşağı Mah (yenicehisar Köyü)",
      "Aşağı Yaraş Mah (esentepe Köyü)",
      "Aşşa Mah (incegeriş Köyü)",
      "Ayaroğlu Mah (boztekke Köyü)",
      "Ayaroğlu Mah (yaykınlık Köyü)",
      "Aydın Mah (darıköy Köyü)",
      "Aydınoğlu Mah (sultaniye Köyü)",
      "Ayınca Mah (kemaliye Köyü)",
      "Balçıklı Mah (orhaniye Köyü)",
      "Barçaçakırlı Mah (barçaçakırlı Köyü)",
      "Barganu Mah (camili Köyü)",
      "Başdüz Mah (karaali Köyü)",
      "Başkonak Mah (kemaliye Köyü)",
      "Batlama Mah (alınca Köyü)",
      "Batlama Mah (uzgur Köyü)",
      "Bekirli Mah (barça Köyü)",
      "Bekiroğlu Mah (ergence Köyü)",
      "Beyazıt Mah (uzgur Köyü)",
      "Bıçakcı Mah (sıvacı Köyü)",
      "Boğuntu Mah (kemaliye Köyü)",
      "Boztepe Mah (yukarıalınlı Köyü)",
      "Bük Mah (barçaçakırlı Köyü)",
      "Bük Mah (ülper Köyü)",
      "Büyük Karaali Mah (karaali Köyü)",
      "Cami Mah (lapa Köyü)",
      "Cami Yanı Mah (incegeriş Köyü)",
      "Camii Yanı Mah (barça Köyü)",
      "Camii Yanı Mah (güney Köyü)",
      "Camii Yanı Mah (sayca Köyü)",
      "Camiyanı Mah (akköy Köyü)",
      "Camiyanı Mah (alınca Köyü)",
      "Camiyanı Mah (bayazıt Köyü)",
      "Camiyanı Mah (boztekke Köyü)",
      "Camiyanı Mah (burhaniye Köyü)",
      "Camiyanı Mah (camili Köyü)",
      "Camiyanı Mah (çiçekli Köyü)",
      "Camiyanı Mah (hamidiye Köyü)",
      "Camiyanı Mah (kemaliye Köyü)",
      "Camiyanı Mah (sarvan Köyü)",
      "Camiyanı Mah (seyitköy Köyü)",
      "Camiyanı Mah (yazlık Köyü)",
      "Camiyanı Ustalar Mah (yenicehisar Köyü)",
      "Cımanoğlu Mah (darıköy Köyü)",
      "Cınarak Mah (alınca Köyü)",
      "Civelekoğlu Mah (barça Köyü)",
      "Colar Mah (pınarçukuru Köyü)",
      "Cumhuriyet Mah",
      "Cürgüllü Mah (esentepe Köyü)",
      "Çağlanbaşı Mah (yenicehisar Köyü)",
      "Çakıroğlu Mah (ülper Köyü)",
      "Çardakyanı Mah (yazlık Köyü)",
      "Çaşak Mah (gedikli Köyü)",
      "Çatak Mah (mesudiye Köyü)",
      "Çataltepe Mah (boztekke Köyü)",
      "Çavuşoğlu Mah (sayca Köyü)",
      "Çayırağzı Mah (sayca Köyü)",
      "Çerkezli Mah (ülper Köyü)",
      "Çığdibi Mah (inişdibi Köyü)",
      "Çınarlar Mah (çiçekli Köyü)",
      "Çıngılı Mah (ülper Köyü)",
      "Çimşir Köyü",
      "Çinko Deresi Mah (barça Köyü)",
      "Çirişli Mah (eriklimanı Köyü)",
      "Çobanlı Mah (barça Köyü)",
      "Çonukoğlu Mah (barça Köyü)",
      "Çoraklık Mah (çamlık Köyü)",
      "Çortyol Mah (akçalı Köyü)",
      "Çukur Mah (akçalı Köyü)",
      "Çukur Mah (çandır Köyü)",
      "Dağ Bahçe Mah (hisargeriş Köyü)",
      "Dağ Mah (uzkara Köyü)",
      "Dağtarla Mah (orhaniye Köyü)",
      "Dallıkıran Mah (anbaralan Köyü)",
      "Damçukuru Mah (mesudiye Köyü)",
      "Damdüzü Mah (yağmurca Köyü)",
      "Darıbükü Mah (alınca Köyü)",
      "Darıbükü Mah (orhaniye Köyü)",
      "Daşdibi Mah (gürköy Köyü)",
      "Delemaddu Mah (yağmurca Köyü)",
      "Demirci Ağzı Mah (pınarçukuru Köyü)",
      "Demiroluk Mah (çavuşoğlu Köyü)",
      "Deregözü Mah (lapa Köyü)",
      "Dereiçi Mah (çavuşoğlu Köyü)",
      "Dereiçi Mah (eriklimanı Köyü)",
      "Derekol Mah (gedikli Köyü)",
      "Dervişoğlu Mah (barça Köyü)",
      "Devecioğlu Mah (uzkara Köyü)",
      "Dikmen Mah (çandır Köyü)",
      "Dikmendibi Mah (ortaköy Köyü)",
      "Dilber Mah (sıvacı Köyü)",
      "Dillioğlu Mah (uzkara Köyü)",
      "Divan Mah (ülper Köyü)",
      "Diyelcik Mah (güney Köyü)",
      "Doruk Mah (incegeriş Köyü)",
      "Duman Mah (anbaralan Köyü)",
      "Duzak Mah (orhaniye Köyü)",
      "Düz Mah (anbaralan Köyü)",
      "Düz Mah (esentepe Köyü)",
      "Elma Tepesi Mah (güney Köyü)",
      "Eselo Mah (seyitköy Köyü)",
      "Esenbük Mah (barça Köyü)",
      "Esenyurt Mah (yağmurca Köyü)",
      "Eylence Mah (gedikli Köyü)",
      "Ezirkancı Mah (uzkara Köyü)",
      "Fatih Mah (osmaniye Köyü)",
      "Fellahoğlu Mah (uzkara Köyü)",
      "Gamaro Mah (yağmurca Köyü)",
      "Gaziler Tepesi Alt Mah (eriklimanı Köyü)",
      "Gaziler Tepesi Üst Mah (eriklimanı Köyü)",
      "Geçicioğlu Mah (evrenköy Köyü)",
      "Gedik Çukuru Mah (hisargeriş Köyü)",
      "Gedikli Köyü",
      "Gerdencik Mah (esentepe Köyü)",
      "Gıran Mah (darıköy Köyü)",
      "Gıran Mah (melikli Köyü)",
      "Gıran Mah (yenicehisar Köyü)",
      "Gönep Mah (barça Köyü)",
      "Gündoğdu Mah (ülper Köyü)",
      "Güney Mah (akıncı Köyü)",
      "Güney Mah (hisargeriş Köyü)",
      "Güney Mah (sayca Köyü)",
      "Güre Mah (çandır Köyü)",
      "Gürleğen Mah (gürköy Köyü)",
      "Hacı Emin Mah (alınca Köyü)",
      "Hacı İlyas Mah (hisargeriş Köyü)",
      "Hacıbahar Mah (kemaliye Köyü)",
      "Hacıoğlu Mah (ortaköy Köyü)",
      "Hacıömer Mah (inişdibi Köyü)",
      "Halac Mah (yenicehisar Köyü)",
      "Halil Ağa Mah (esentepe Köyü)",
      "Haliloğlu Mah (mesudiye Köyü)",
      "Haliloğlu Mah (okçu Köyü)",
      "Hambarca Mah (ergence Köyü)",
      "Hatipoğlu Mah (sayca Köyü)",
      "Himmetoğlu Mah (çavuşoğlu Köyü)",
      "Hocaoğlu Mah (inişdibi Köyü)",
      "Hüseyindağ Mah (lapa Köyü)",
      "İbiloğlu Mah (incegeriş Köyü)",
      "İkisu Mah (seyitköy Köyü)",
      "İmam Torunoğlu Mah (barça Köyü)",
      "İmamlı Mah (çavuşoğlu Köyü)",
      "İmamlı Mah (sarvan Köyü)",
      "İmamlı Mah (sayca Köyü)",
      "İmamoğlu Alt Mah (ergence Köyü)",
      "İmamoğlu Mah (ortaköy Köyü)",
      "İmamoğlu Üst Mah (ergence Köyü)",
      "İncirli Mah (melikli Köyü)",
      "İncirli Mah (ülper Köyü)",
      "İndibi Mah (burhaniye Köyü)",
      "İndibi Mah (yukarıalınlı Köyü)",
      "Kabaköse Mah (orhaniye Köyü)",
      "Kadıoğlu Mah (osmaniye Köyü)",
      "Kalafatlı Mah (sayca Köyü)",
      "Kale Mah (barça Köyü)",
      "Kale Mah (sarvan Köyü)",
      "Kaleyanı Mah (boztekke Köyü)",
      "Kamuzlu Mah (lapa Köyü)",
      "Karaağaç Mah (seyitköy Köyü)",
      "Karabacakoğlu Mah (yağmurca Köyü)",
      "Karabalçık Mah (sultaniye Köyü)",
      "Karadağ Mah (sultaniye Köyü)",
      "Karahıdır Mah (melikli Köyü)",
      "Karakestane Mah (güveç Köyü)",
      "Karaosmanoğlu Mah (akköy Köyü)",
      "Karaoyrak Mah (anbaralan Köyü)",
      "Karatepe Mah (okçu Köyü)",
      "Karayakup Mah (sıvacı Köyü)",
      "Karga Tarlası Mah (hamidiye Köyü)",
      "Kargaoğlu Mah (darıköy Köyü)",
      "Katmecioğlu Mah (uzkara Köyü)",
      "Kavacık Mah (kemaliye Köyü)",
      "Kavak Mah (gedikli Köyü)",
      "Kavakboğazı Mah (incegeriş Köyü)",
      "Kavaklı Mah (sayca Köyü)",
      "Kavalcıoğlu Dere Mah (çamlık Köyü)",
      "Kavlaklı Mah (gürköy Köyü)",
      "Kayışoğlu Mah (barça Köyü)",
      "Kaynarca Mah (ergence Köyü)",
      "Keçemenli Mah (sayca Köyü)",
      "Kemaliye Köyü",
      "Kemallı Mah (güveç Köyü)",
      "Kemaloğlu Mah (sarvan Köyü)",
      "Kertboğaz Mah (sarvan Köyü)",
      "Kestane Deresi Mah (mesudiye Köyü)",
      "Kıran Mah (burhaniye Köyü)",
      "Kıran Mah (camili Köyü)",
      "Kıran Mah (çandır Köyü)",
      "Kıran Mah (esentepe Köyü)",
      "Kıran Mah (evrenköy Köyü)",
      "Kıran Mah (güveç Köyü)",
      "Kıran Mah (hisargeriş Köyü)",
      "Kıran Mah (kemaliye Köyü)",
      "Kıran Mah (orhaniye Köyü)",
      "Kıran Mah (sayca Köyü)",
      "Kıran Mah (ülper Köyü)",
      "Killik Mah (çiçekli Köyü)",
      "Kiltik Kıran Mah (çavuşoğlu Köyü)",
      "Koçmar Mah (ülper Köyü)",
      "Koloğlu Mah (boztekke Köyü)",
      "Kovanacık Mah (hamidiye Köyü)",
      "Kozoğlu Mah (camili Köyü)",
      "Kömürce Mah (yenicehisar Köyü)",
      "Köroğlu Mah (seyitköy Köyü)",
      "Köyiçi Mah (güveç Köyü)",
      "Kumaşoğlu Mah (boztekke Köyü)",
      "Kuşçulu Mah (güney Köyü)",
      "Kuyu Tepesi Mah (akçalı Köyü)",
      "Kuz Çukuru Mah (güney Köyü)",
      "Kuz Mah (akıncı Köyü)",
      "Kuz Mah (bayazıt Köyü)",
      "Kuz Mah (çandır Köyü)",
      "Küçük Karaali Mah (karaali Köyü)",
      "Küçüklü Mah (hisargeriş Köyü)",
      "Küçüksanayi Mah (alınca Köyü)",
      "Külcüoğlu Mah (evrenköy Köyü)",
      "Külüoğlu Mah (ülper Köyü)",
      "Küperoğlu Mah (incegeriş Köyü)",
      "Kürtünlü Mah (yağmurca Köyü)",
      "Lefkoşe Mah (barça Köyü)",
      "Macaro Mah (ortaköy Köyü)",
      "Macaroğlu Mah (barça Köyü)",
      "Maden Mah (yağmurca Köyü)",
      "Mağdalu Mah (çamlık Köyü)",
      "Mahmutcalı Mah (güveç Köyü)",
      "Manar Mah (yenicehisar Köyü)",
      "Mehmet Yusufoğlu Mah (anbaralan Köyü)",
      "Mehmetağa Mah (inişdibi Köyü)",
      "Melikli Köyü",
      "Merkez Cami Yanı Mah (anbaralan Köyü)",
      "Merkez Mah (inişdibi Köyü)",
      "Merkez Mah (pınarçukuru Köyü)",
      "Meşeli Mah (yazlık Köyü)",
      "Mındız Mah (hisargeriş Köyü)",
      "Molla Mustafa Mah (esentepe Köyü)",
      "Mollaali Mah (güveç Köyü)",
      "Molo Mahmut Mah (ülper Köyü)",
      "Musacoğlu Mah (ergence Köyü)",
      "Müezzinoğlu Mah (ergence Köyü)",
      "Nebioğlu Mah (sayca Köyü)",
      "Nuri Seyit Alioğlu Mah (pınarçukuru Köyü)",
      "Okul Yanı Mah (güney Köyü)",
      "Oluk Mah (seyitköy Köyü)",
      "Orta Mah (camili Köyü)",
      "Orta Mah (çamlık Köyü)",
      "Orta Mah (gürköy Köyü)",
      "Orta Mah (mesudiye Köyü)",
      "Orta Mah (okçu Köyü)",
      "Orta Mah (uzgur Köyü)",
      "Orta Mah (uzkara Köyü)",
      "Orta Mah (yaykınlık Köyü)",
      "Osmanağa Mah (çavuşoğlu Köyü)",
      "Osmaniye Mah (osmaniye Köyü)",
      "Ömerli Mah (yazlık Köyü)",
      "Ören Mah (akçalı Köyü)",
      "Ören Mah (çamlık Köyü)",
      "Ören Mah (osmaniye Köyü)",
      "Örencik Mah (burhaniye Köyü)",
      "Özgürlük Mah (mesudiye Köyü)",
      "Paşalı Mah (esentepe Köyü)",
      "Piriler Mah (incegeriş Köyü)",
      "Posluoğlu Mah (barça Köyü)",
      "Saka Mah (yenicehisar Köyü)",
      "Sakallıdağ Mah (alınca Köyü)",
      "Sakaoğlu Mah (çavuşoğlu Köyü)",
      "Seydimal Mah (evrenköy Köyü)",
      "Sıvacı Mah (sıvacı Köyü)",
      "Sindel Mah (okçu Köyü)",
      "Sultaniye Köyü",
      "Sultaniye Mah (çimşir Köyü)",
      "Sükük Narlı Mah (karaali Köyü)",
      "Şabanlı Mah (sayca Köyü)",
      "Şehit Oral Demiral Mah (pınarçukuru Köyü)",
      "Şehit Zafer Konak Mah (pınarçukuru Köyü)",
      "Şıhlı Mah (barçaçakırlı Köyü)",
      "Şişbaş Mah (sultaniye Köyü)",
      "Taş Başı Mah (akçalı Köyü)",
      "Taşhan Mah (mesudiye Köyü)",
      "Taşhan Mah (sıvacı Köyü)",
      "Tekiroğlu Mah (barçaçakırlı Köyü)",
      "Tepe Mah (incegeriş Köyü)",
      "Topaloğlu Mah (osmaniye Köyü)",
      "Topçuali Mah (çiçekli Köyü)",
      "Topçuoğlu Mah (akköy Köyü)",
      "Tozlu Mah (alınca Köyü)",
      "Tömen Tarla Mah (karaali Köyü)",
      "Türkmenli Mah (sayca Köyü)",
      "Türkmenoğlu Mah (barça Köyü)",
      "Ulumeşe Mah (incegeriş Köyü)",
      "Ulupelit Mah (akköy Köyü)",
      "Usta Ali Oğlu Mah (barça Köyü)",
      "Ustalı Mah (akköy Köyü)",
      "Ustalı Mah (hamidiye Köyü)",
      "Ustaoğlu Mah (darıköy Köyü)",
      "Uzunoğlu Mah (kemaliye Köyü)",
      "Uzunoğlu Mah (yukarıalınlı Köyü)",
      "Üst Mah (akıncı Köyü)",
      "Üst Mah (bayazıt Köyü)",
      "Üst Mah (camili Köyü)",
      "Üst Mah (çukurköy Köyü)",
      "Üst Mah (seyitköy Köyü)",
      "Üst Mah (uzgur Köyü)",
      "Üzümlük Mah (darıköy Köyü)",
      "Velioğlu Mah (sayca Köyü)",
      "Yağmurca Mah (yağmurca Köyü)",
      "Yahyalı Mah (çukurköy Köyü)",
      "Yahyalı Mah (osmaniye Köyü)",
      "Yavşuluk Mah (inişdibi Köyü)",
      "Yaylalı Mah (yazlık Köyü)",
      "Yazlık Mah (çamlık Köyü)",
      "Yazlık Mah (yenicehisar Köyü)",
      "Yeni Mah (güveç Köyü)",
      "Yeni Mah (yenicehisar Köyü)",
      "Yeniçağ Mah (barça Köyü)",
      "Yeniyol Mah (alınca Köyü)",
      "Yılancıoğlu Mah (camili Köyü)",
      "Yukarı Çavuşoğlu Mah (çavuşoğlu Köyü)",
      "Yumrutaş Mah (darıköy Köyü)",
      "Zehiroğlu Mah (güney Köyü)",
      "Zuvalı Mah (ergence Köyü)"
    ],
    "Piraziz": [
      "Akçay Köyü",
      "Akelma Mah (gökçeali Köyü)",
      "Aktaş Mah (medrese Köyü)",
      "Alameşe Mah (deregözü Köyü)",
      "Alidede Köyü",
      "Alt Mah (tepeköy Köyü)",
      "Armutçukuru Köyü",
      "Armutdüzü Mah (yunusemre Köyü)",
      "Aşağı Mah (narlık Köyü)",
      "Bakacak Mah (tepeköy Köyü)",
      "Bayramşah Mah (gökçeali Köyü)",
      "Bektaş Mah (şerefli Köyü)",
      "Bitene Mah (bozat Köyü)",
      "Bozat Mah (bozat Köyü)",
      "Bülbüllü Köyü",
      "Çağlandere Köyü",
      "Çayırköy Köyü",
      "Dere Mah (esentepe Köyü)",
      "Deregözü Mah (deregözü Köyü)",
      "Dereyanı Mah (şerefli Köyü)",
      "Gökçeali Mah (gökçeali Köyü)",
      "Göldüzü Mah (bozat Köyü)",
      "Güneyköy Köyü",
      "Güzelköy Köyü",
      "Hapanca Yolu Mah (balçıklı Köyü)",
      "Hasanşeyh Köyü",
      "Hekimoğlu Mah (balçıklı Köyü)",
      "Kaleyanı Mah (esentepe Köyü)",
      "Kavrazlı Mah (esentepe Köyü)",
      "Kayabaşı Mah (gökçeali Köyü)",
      "Kendirçukuru Mah (tepeköy Köyü)",
      "Kılıçlı Köyü",
      "Kıran Mah (balçıklı Köyü)",
      "Kıran Mah (esentepe Köyü)",
      "Kuzyaka Mah (balçıklı Köyü)",
      "Medrese Mah (medrese Köyü)",
      "Merkez Mah (balçıklı Köyü)",
      "Merkez Mah (esentepe Köyü)",
      "Merkez Mah (şerefli Köyü)",
      "Merkez Mah (yunusemre Köyü)",
      "Nefsi Piraziz Köyü",
      "Orta Mah (tepeköy Köyü)",
      "Örnekköy Köyü",
      "Petbaşı Mah (balçıklı Köyü)",
      "Pınarçukuru Mah (şerefli Köyü)",
      "Sevdanlı Mah (balçıklı Köyü)",
      "Şahintepe Mah (medrese Köyü)",
      "Taflancık Mah (gökçeali Köyü)",
      "Tepe Mah (balçıklı Köyü)",
      "Yavrutamı Mah (tepeköy Köyü)",
      "Yukarı Mah (narlık Köyü)",
      "Aydere Mah",
      "Eren Mah",
      "Etlikkıran Mah",
      "Kaleyanı Mah",
      "Kargı Mah",
      "Maden Mah",
      "Şeyhli Mah",
      "Şıhkıran Mah",
      "Yeni Mah"
    ],
    "Şebinkarahisar": [
      "Ağcaimam Mah (karaağaç Köyü)",
      "Akviran Köyü",
      "Aluç Mah (evcili Köyü)",
      "Asarcık Köyü",
      "Aşağı Armutlu Mah (ovacık Köyü)",
      "Aşağı Mah (ozanlı Köyü)",
      "Bağdere Mah (arslanşah Köyü)",
      "Batı Hacıköy Mah (evcili Köyü)",
      "Bayramköy Köyü",
      "Bulduklu Mah (güneygören Köyü)",
      "Burseyit Mah (toplukonak Köyü)",
      "Busait Mah (ekecek Köyü)",
      "Cüş Mah (tekkaya Köyü)",
      "Çağlayan Köyü",
      "Çamlıbel Köyü",
      "Çileder Mah (çakır Köyü)",
      "Çoğlu Mah (çakır Köyü)",
      "Dedeli Mah (çakır Köyü)",
      "Dervişoğlu Mah (hacıömer Köyü)",
      "Doğanyuva Köyü",
      "Doğu Hacıköy Mah (evcili Köyü)",
      "Doruklu Mah (toplukonak Köyü)",
      "Dönençay Köyü",
      "Elmaağaç Mah (bayhasan Köyü)",
      "Esentepe Köyü",
      "Etir Mah (ovacık Köyü)",
      "Gökçetaş Köyü",
      "Görene Mah (yakınca Köyü)",
      "Gürpınar Köyü",
      "Hahavla Mah (sarıyer Köyü)",
      "Hamzalı Mah (yedikardeş Köyü)",
      "Han Mah (konak Köyü)",
      "Hocaoğlu Köyü",
      "Hozana Mah (toplukonak Köyü)",
      "Kamberli Mah (arslanşah Köyü)",
      "Kapaklı Mah (alişar Köyü)",
      "Karacaören Merkez Mah (karacaören Köyü)",
      "Karaoğul Mah (dereköy Köyü)",
      "Karlı Mah (buzkeçi Köyü)",
      "Kavaklı Mah (yeniyol Köyü)",
      "Kayadibi Mah (sarıyer Köyü)",
      "Kayalı Köyü",
      "Kestane Mah (alişar Köyü)",
      "Kısık Mah (balcana Köyü)",
      "Kızık Mah (bayhasan Köyü)",
      "Killik Mah (alişar Köyü)",
      "Kozluca Mah (yaycı Köyü)",
      "Küçük Mah (kule Köyü)",
      "Lapa Mah (duman Köyü)",
      "Laz Mah (tekkaya Köyü)",
      "Licese Mah (şaplıca Köyü)",
      "Merkez Mah (ahurcuk Köyü)",
      "Merkez Mah (altınçevre Köyü)",
      "Merkez Mah (arslanşah Köyü)",
      "Merkez Mah (balcana Köyü)",
      "Merkez Mah (baltaşı Köyü)",
      "Merkez Mah (bayhasan Köyü)",
      "Merkez Mah (buzkeçi Köyü)",
      "Merkez Mah (çakır Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (diler Köyü)",
      "Merkez Mah (duman Köyü)",
      "Merkez Mah (ekecek Köyü)",
      "Merkez Mah (evcili Köyü)",
      "Merkez Mah (güneygören Köyü)",
      "Merkez Mah (güvercinlik Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (hacıömer Köyü)",
      "Merkez Mah (hasanşeyh Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (kınık Köyü)",
      "Merkez Mah (konak Köyü)",
      "Merkez Mah (kule Köyü)",
      "Merkez Mah (ovacık Köyü)",
      "Merkez Mah (sipahi Köyü)",
      "Merkez Mah (şaplıca Köyü)",
      "Merkez Mah (tekkaya Köyü)",
      "Merkez Mah (toplukonak Köyü)",
      "Merkez Mah (yakınca Köyü)",
      "Merkez Mah (yaycı Köyü)",
      "Meykel Mah (diler Köyü)",
      "Ocaktaşı Köyü",
      "Orta Mah (kınık Köyü)",
      "Orta Mah (yeniyol Köyü)",
      "Örencik Köyü",
      "Pazarönü Mah (güzelyurt Köyü)",
      "Pınarönü Mah (yeniyol Köyü)",
      "Saraycık Köyü",
      "Sayderesi Mah (şaplıca Köyü)",
      "Soğulcak Mah (hasanşeyh Köyü)",
      "Söğüteli Mah (hasanşeyh Köyü)",
      "Subak Mah (dereköy Köyü)",
      "Suboyu Köyü",
      "Sucak Mah (baltaşı Köyü)",
      "Sultankonağı Köyü",
      "Şahinler Köyü",
      "Tabanlı Mah (altınçevre Köyü)",
      "Taş Mah (arslanşah Köyü)",
      "Taşcılı Köyü",
      "Tenemeli Mah (sipahi Köyü)",
      "Tepelce Mah (güvercinlik Köyü)",
      "Tepeltepe Köyü",
      "Tingilli Mah (arslanşah Köyü)",
      "Tokluağıl Köyü",
      "Toramanlı Mah (toplukonak Köyü)",
      "Torluk Mah (arslanşah Köyü)",
      "Turpçu Köyü",
      "Uğurca Köyü",
      "Uluyazı Mah (yedikardeş Köyü)",
      "Velioğlu Mah (ahurcuk Köyü)",
      "Yalnıztam Mah (kınık Köyü)",
      "Yedipınar Mah (çakır Köyü)",
      "Yenice Mah (evcili Köyü)",
      "Yeşilyayla Köyü",
      "Yeşilyurt Köyü",
      "Yeteroğlu Mah (toplukonak Köyü)",
      "Yıltarıç Köyü",
      "Yukarı Armutlu Mah (ovacık Köyü)",
      "Yukarı Mah (ozanlı Köyü)",
      "Yumurcaktaş Köyü",
      "Akbudak Mah",
      "Avutmuş Mah",
      "Biroğul Mah",
      "Bülbül Mah",
      "Çiftlik Mah",
      "Fatih Mah",
      "İkioğul Mah",
      "Kavaklar Mah",
      "Kırkgöz Mah",
      "Kızılca Mah",
      "Kütküt Mah",
      "Müftü Mah",
      "Tamzara Mah",
      "Taş Mah",
      "Yavuz Selim Mah"
    ],
    "Tirebolu": [
      "Abdullu Mah (kuskunlu Köyü)",
      "Abdullu Pattellasi Mah (kuskunlu Köyü)",
      "Abdullu Yayca Mah (kuskunlu Köyü)",
      "Ağdarı Mah (aşağıboynuyoğun Köyü)",
      "Ahmetçalı Mah (ışıklı Köyü)",
      "Akçakese Mah (arslancık Köyü)",
      "Akkaya Mah (iğnece Köyü)",
      "Akyar Mah (harkköy Köyü)",
      "Alaco Mah (avcılı Köyü)",
      "Alakaş Mah (arslancık Köyü)",
      "Alçakkıran Mah (yukarıboğalı Köyü)",
      "Ali Evi Mah (kovanpınar Köyü)",
      "Alt Mah (kovancık Köyü)",
      "Altıparmak Mah (yukarıboğalı Köyü)",
      "Anlak Mah (yalıköy Köyü)",
      "Armutağzı Mah (karaahmetli Köyü)",
      "Aşağı Çınarcık Mah (kuzgun Köyü)",
      "Aşağı Mah (danışman Köyü)",
      "Aşağı Mah (kuskunlu Köyü)",
      "Aşağı Mah (örenkaya Köyü)",
      "Aşağıkıran Mah (yağlıkuyumcu Köyü)",
      "Aşağıosmanlı Mah (yağlıkuyumcu Köyü)",
      "Aşhapçuk Mah (sultanköy Köyü)",
      "Balçıkbelen Mah",
      "Bayraktarlı Mah (yaraş Köyü)",
      "Bedrama Mah (karaahmetli Köyü)",
      "Bekirli Mah (ketençukur Köyü)",
      "Berberli Mah (avcılı Köyü)",
      "Beşkise Mah (menderes Köyü)",
      "Binektaşı Mah (harkköy Köyü)",
      "Boğacıklı İpek Ali Mah (ışıklı Köyü)",
      "Boğacıklı Karık Mah (ışıklı Köyü)",
      "Boğacıklı Kıran Mah (ışıklı Köyü)",
      "Boğacıklı Orta Mah (ışıklı Köyü)",
      "Buğdalık Mah (harkköy Köyü)",
      "Bük Mah (menderes Köyü)",
      "Bükaltı Mah (yılgın Köyü)",
      "Caferkuzu Mah (karademir Köyü)",
      "Cami Mah (sekü Köyü)",
      "Cami Yanı Mah (dokuzkonak Köyü)",
      "Cami Yanı Mah (ede Köyü)",
      "Cami Yani Mah (kuskunlu Köyü)",
      "Camiyanı Mah (aşağıboynuyoğun Köyü)",
      "Camiyanı Mah (düzköy Köyü)",
      "Camiyanı Mah (harkköy Köyü)",
      "Camiyanı Mah (iğnece Köyü)",
      "Camiyanı Mah (ketençukur Köyü)",
      "Camiyanı Mah (kuzgun Köyü)",
      "Camiyanı Mah (ortaköy Köyü)",
      "Camiyanı Mah (yalç Köyü)",
      "Cardak Kıran Mah (aşağıboynuyoğun Köyü)",
      "Cebecioğlu Mah (arslancık Köyü)",
      "Celli Mah (ortacami Köyü)",
      "Cerrahoğlu Mah (çamlıköy Köyü)",
      "Cırıtlı Mah (ortacami Köyü)",
      "Çal Mah (yılgın Köyü)",
      "Çalıklı Mah (avcılı Köyü)",
      "Çamlıköy Köyü",
      "Çamtam Mah (iğnece Köyü)",
      "Çandırlı Mah (ortacami Köyü)",
      "Çatak Mah (özlü Köyü)",
      "Çavuşlu Mah (avcılı Köyü)",
      "Çeğel Köyü",
      "Çıltıma Mah (doğancı Köyü)",
      "Çıraklı Mah (harkköy Köyü)",
      "Çiftlik Mah (akıncılar Köyü)",
      "Çiftlik Mah (kovanpınar Köyü)",
      "Çityeri Mah (kovanpınar Köyü)",
      "Çubuk Dağı Mah (arslancık Köyü)",
      "Çukur Mah (şenyuva Köyü)",
      "Çukurtam Mah (eymür Köyü)",
      "Değirmensuyu Mah (kuskunlu Köyü)",
      "Dere Mah (iğnece Köyü)",
      "Dere Mah (yalç Köyü)",
      "Dereağzı Mah (sultanköy Köyü)",
      "Deregözü Mah (eymür Köyü)",
      "Deregözü Mah (kuzgun Köyü)",
      "Devecikboynu Mah (köseler Köyü)",
      "Dipyatak Mah (iğnece Köyü)",
      "Dişikara Mah (doğancı Köyü)",
      "Doğancı Köyü",
      "Doğancı Mah (doğancı Köyü)",
      "Domaçlı Mah (doğancı Köyü)",
      "Duancı Mah (aşağıboynuyoğun Köyü)",
      "Düver Mah (ketençukur Köyü)",
      "Düz Kuyumcu Mah (yağlıkuyumcu Köyü)",
      "Düz Mah (belen Köyü)",
      "Düzköy Mah (ataköy Köyü)",
      "Düztarla Kıran Mevkii Mah (yaraş Köyü)",
      "Düztarla Mah (yaraş Köyü)",
      "Ekizler Mah (eymür Köyü)",
      "Elma Mah (sekü Köyü)",
      "Emetce Mah (ede Köyü)",
      "Emingil Mah (fatih Köyü)",
      "Eminoğlu Mah (avcılı Köyü)",
      "Eski Kahve Yanı Mah (ketençukur Köyü)",
      "Eskiköy Mah (aşağıboynuyoğun Köyü)",
      "Fatmabükü Mah (ketençukur Köyü)",
      "Gazanferli Mah (karaahmetli Köyü)",
      "Gebeceli Mah (arslancık Köyü)",
      "Gebeşler Mah (danışman Köyü)",
      "Gerdan Mah (özlü Köyü)",
      "Gerden Mah (civil Köyü)",
      "Göbelli Alt Mah (halaçlı Köyü)",
      "Göbelli Orta Mah (halaçlı Köyü)",
      "Göbelli Yukarı Mah (halaçlı Köyü)",
      "Göğcebel Mah (aşağıboynuyoğun Köyü)",
      "Gökçeli Mah (ortaköy Köyü)",
      "Gökçeyazı Mah (belen Köyü)",
      "Göksil Mah (kovanpınar Köyü)",
      "Gölağazı Mah (düzköy Köyü)",
      "Göldüzü Mah (ketençukur Köyü)",
      "Göldüzü Mah (kuzgun Köyü)",
      "Görpeli Mah (civil Köyü)",
      "Güney Mah (kovanpınar Köyü)",
      "Güney Mah (şenyuva Köyü)",
      "Güney Mah (yalç Köyü)",
      "Güneyköy Alt Mah (aşağıboynuyoğun Köyü)",
      "Güneyköy Üst Mah (aşağıboynuyoğun Köyü)",
      "Hacıalioğlu Alt Mah (düzköy Köyü)",
      "Hacıalioğlu Mah (düzköy Köyü)",
      "Hacıhüseyin Köyü",
      "Halaç Mah (eymür Köyü)",
      "Haliloğlu Çamiyanı Mevki Mah (fatih Köyü)",
      "Haliloğlu Mah (fatih Köyü)",
      "Hamasgil Mah (aşağıboynuyoğun Köyü)",
      "Harkköy Köyü",
      "Harmancık Mah (sekü Köyü)",
      "Henkioğlu Mah (arslancık Köyü)",
      "Henkioğlu Zaim Yeri Mah (arslancık Köyü)",
      "Herekli Mah (arageriş Köyü)",
      "Hıdırlı Mah (yukarıortacami Köyü)",
      "Hozanlar Mah (aşağıboynuyoğun Köyü)",
      "Hüseyinoğlu Evliyayanı Mevki Mah (fatih Köyü)",
      "İmamkıranı Mah (karademir Köyü)",
      "İmamoğlu Mah (yağlıkuyumcu Köyü)",
      "İnceburun Mah (ketençukur Köyü)",
      "İnyanı Mah (kovanpınar Köyü)",
      "İsmailli Mah (özlü Köyü)",
      "Kabacalı Mah (yalıköy Köyü)",
      "Kadıoğlu Mah (kovanpınar Köyü)",
      "Kahveyanı Mah (kuzgun Köyü)",
      "Kahyalı Mah (kuskunlu Köyü)",
      "Kallo Mah (kovanpınar Köyü)",
      "Kalpakbükü Mah (ketençukur Köyü)",
      "Kamatlı Mah (kuzgun Köyü)",
      "Kandazlı Mah (ataköy Köyü)",
      "Kara Ali Mah (düzköy Köyü)",
      "Karaağaç Mah (köseler Köyü)",
      "Karaarifgil Mah (avcılı Köyü)",
      "Karabıyık Mah (yukarıortacami Köyü)",
      "Karaçukur Mah (sultanköy Köyü)",
      "Karademir Köyü",
      "Karakütük Mah (harkköy Köyü)",
      "Karaman Mah (ataköy Köyü)",
      "Karamehmetli Mah (yağlıkuyumcu Köyü)",
      "Karasakal Mah (karademir Köyü)",
      "Karcanlı Mah (ışıklı Köyü)",
      "Kargalı Mah (ortacami Köyü)",
      "Karşı Mah (civil Köyü)",
      "Karşı Mah (hacıhüseyin Köyü)",
      "Kavgalı Mah (arageriş Köyü)",
      "Kayaboğazı Mah (kovancık Köyü)",
      "Kayaboynu Mah (ataköy Köyü)",
      "Kayadibi Mah (yukarıortacami Köyü)",
      "Kaynarpazarı Mah (yağlıkuyumcu Köyü)",
      "Kedilli Mah (avcılı Köyü)",
      "Keloğlu  Mah (danacı Mah) (menderes Köyü)",
      "Kerimli Mah (yalıköy Köyü)",
      "Kerimlik Mah (arslancık Köyü)",
      "Kerpiçli Mah (şirin Köyü)",
      "Kıran Cami Mah (ataköy Köyü)",
      "Kıran Mah (akıncılar Köyü)",
      "Kıran Mah (avcılı Köyü)",
      "Kıran Mah (çamlıköy Köyü)",
      "Kıran Mah (danışman Köyü)",
      "Kıran Mah (ede Köyü)",
      "Kıran Mah (karaahmetli Köyü)",
      "Kıran Mah (yalç Köyü)",
      "Kilinli Mah (danışman Köyü)",
      "Kirazlık Mah (arslancık Köyü)",
      "Koz Mah (mursal Köyü)",
      "Kömürlük Mah (düzköy Köyü)",
      "Kör Omar Mah (danışman Köyü)",
      "Kösemerli Mah (ortacami Köyü)",
      "Köyaltı Mah (sekü Köyü)",
      "Kuloğlu Mah (yağlıkuyumcu Köyü)",
      "Kuşboynu Mah (arslancık Köyü)",
      "Kuz Mah (doğancı Köyü)",
      "Kuz Mah (karaahmetli Köyü)",
      "Kuzçukuru Mah (kovanpınar Köyü)",
      "Kuzduran Mah (aşağıboynuyoğun Köyü)",
      "Kuziz Mah (kovanpınar Köyü)",
      "Kübüçlü Mah (çamlıköy Köyü)",
      "Küçükmehmetoğlu Mah (karademir Köyü)",
      "Lazlar Mah (şirin Köyü)",
      "Maden Mah (kuskunlu Köyü)",
      "Maden Mah (yeşilpınar Köyü)",
      "Mahmutgil Mah (aşağıboynuyoğun Köyü)",
      "Mahmutlu Mah (eymür Köyü)",
      "Mehmet Çavuş Mah (yukarıboğalı Köyü)",
      "Melikli Mah (ortacami Köyü)",
      "Merkez Bük Mah (köseler Köyü)",
      "Merkez Kahveyanı Mah (şirin Köyü)",
      "Merkez Mah (arslancık Köyü)",
      "Merkez Mah (avcılı Köyü)",
      "Merkez Mah (civil Köyü)",
      "Merkez Mah (ede Köyü)",
      "Merkez Mah (eymür Köyü)",
      "Merkez Mah (halaçlı Köyü)",
      "Merkez Mah (karaahmetli Köyü)",
      "Merkez Mah (kuskunlu Köyü)",
      "Merkez Mah (menderes Köyü)",
      "Merkez Mah (sultanköy Köyü)",
      "Merkez Mah (yeşilpınar Köyü)",
      "Merkez Mah (yukarıboğalı Köyü)",
      "Merkez Mah (yukarıortacami Köyü)",
      "Meyrecük Mah (doğancı Köyü)",
      "Miraseke Mah (civil Köyü)",
      "Moz Mah (sultanköy Köyü)",
      "Munakuzu Mah (ede Köyü)",
      "Naiboğlu Mah (avcılı Köyü)",
      "Naipli Mah (özlü Köyü)",
      "O Yüz Mah (ataköy Köyü)",
      "Okul Yanı Mah (arslancık Köyü)",
      "Okulyanı Mah (harkköy Köyü)",
      "Okulyanı Mah (yalç Köyü)",
      "Orta Bada Mah (özlü Köyü)",
      "Orta Mah (akıncılar Köyü)",
      "Orta Mah (belen Köyü)",
      "Orta Mah (danışman Köyü)",
      "Orta Mah (ede Köyü)",
      "Orta Mah (kayalar Köyü)",
      "Orta Mah (kovanpınar Köyü)",
      "Orta Mah (kuzgun Köyü)",
      "Orta Mah (mursal Köyü)",
      "Orta Mah (örenkaya Köyü)",
      "Orta Mah (yalç Köyü)",
      "Orta Mah (yılgın Köyü)",
      "Orta Mah (yukarıortacami Köyü)",
      "Ortagüney Aşağı Mah (ışıklı Köyü)",
      "Ortagüney Kıran Mah (ışıklı Köyü)",
      "Ortagüney Orta Mah (ışıklı Köyü)",
      "Ortagüney Üst Mah (ışıklı Köyü)",
      "Öksüzoğlu  Mah (laz Mah) (menderes Köyü)",
      "Ömerli Mah (hacıhüseyin Köyü)",
      "Örencik Mah (sultanköy Köyü)",
      "Padarlı Mah (ketençukur Köyü)",
      "Paloğlu Mah (akıncılar Köyü)",
      "Pazar Yeri Mah (kovanpınar Köyü)",
      "Pulluk Mah (şirin Köyü)",
      "Sahil Mah (doğancı Köyü)",
      "Salman Mah (yılgın Köyü)",
      "Sarıosmanoğlu Mah (çamlıköy Köyü)",
      "Sayıca Mah (fatih Köyü)",
      "Sazanlık Mah (kovanpınar Köyü)",
      "Seisoğlu Mah (menderes Köyü)",
      "Sırtıkara Mah (yaraş Köyü)",
      "Siyezlik Mah (kovanpınar Köyü)",
      "Soğuksu Cebeci Mah (halaçlı Köyü)",
      "Soğuksu Kedivelli Mah (halaçlı Köyü)",
      "Soğuksu Mah (karademir Köyü)",
      "Soğuksu Mustafaoğlu Mah (halaçlı Köyü)",
      "Süleymangil Mah (kuzgun Köyü)",
      "Sümbüllü Mah (şirin Köyü)",
      "Şedelli Mah (avcılı Köyü)",
      "Şenyuva Köyü",
      "Şimşir Dibi Mah (danışman Köyü)",
      "Takırlı Mah (halaçlı Köyü)",
      "Tepe Mah (karaahmetli Köyü)",
      "Tepeyatak Mah (iğnece Köyü)",
      "Tomaklı Mah (arslancık Köyü)",
      "Tongazlı Mah (şirin Köyü)",
      "Topaloğlu Mah (şirin Köyü)",
      "Toptaş Mah (doğancı Köyü)",
      "Toptepe Mah (danışman Köyü)",
      "Töngel Mah (arslancık Köyü)",
      "Tütüncülü Mah (çamlıköy Köyü)",
      "Tütünlük Mah (kovanpınar Köyü)",
      "Tütünlük-dutkıranı Mah (dokuzkonak Köyü)",
      "Uzunali Mah (şirin Köyü)",
      "Uzunlu Mah (hacıhüseyin Köyü)",
      "Üçdere Mah (arslancık Köyü)",
      "Üst Mah (kovancık Köyü)",
      "Üzümlük Mah (arslancık Köyü)",
      "Velibaşoğlu Mah (fatih Köyü)",
      "Velioğlu Mah (arslancık Köyü)",
      "Yalak Mah (karademir Köyü)",
      "Yalı Mah (düzköy Köyü)",
      "Yamaklı Mah (arslancık Köyü)",
      "Yamanlı Mah (yağlıkuyumcu Köyü)",
      "Yanıklık Mah (ketençukur Köyü)",
      "Yaraş Mah (ortaköy Köyü)",
      "Yarderesi Mah (belen Köyü)",
      "Yavergil Mah (kuzgun Köyü)",
      "Yeşilpınar Köyü",
      "Yokuşbaşı Mah (arageriş Köyü)",
      "Yukarı Çınarcık Mah (kuzgun Köyü)",
      "Yukarı Kıran Mah (yağlıkuyumcu Köyü)",
      "Yukarı Mah (danışman Köyü)",
      "Yukarı Mah (halaçlı Köyü)",
      "Yukarı Mah (kovanpınar Köyü)",
      "Yukarı Mah (örenkaya Köyü)",
      "Yukarı Mursal Mah (mursal Köyü)",
      "Yukarıköy Kıran Mah (dokuzkonak Köyü)",
      "Yukarıosmanlı Mah (yağlıkuyumcu Köyü)",
      "Yumurtacı Mah (belen Köyü)",
      "Zamarı Mah (arageriş Köyü)",
      "Zeyret Mah (ede Köyü)",
      "Zıvalı Mah (ortacami Köyü)",
      "Cintaşı Mah",
      "Çarşı Mah",
      "Demirci Mah",
      "Hamam Mah",
      "İstiklal Mah",
      "Körliman Mah",
      "Yeniköy Mah"
    ],
    "Yağlıdere": [
      "Ağcalı Obası Mah (akpınar Köyü)",
      "Ahallı Mah",
      "Akdarı Mah",
      "Akdoğan Mah",
      "Aktaş Karhanlı Mah (sınırköy Köyü)",
      "Aktaş Mah (ortaköy Köyü)",
      "Alayurt Mah (yenice Köyü)",
      "Ali Obuzu Mah (tekkeköy Köyü)",
      "Ambaryalağı Fındıcak Mah (sınırköy Köyü)",
      "Aralcak Mah (dereköy Köyü)",
      "Avut Mah (yeniyazlık Köyü)",
      "Ayvacıoğlu Mah (elmabelen Köyü)",
      "Ayvat Mah (yeşilpınar Köyü)",
      "Bahçe Güni Mah (ortaköy Köyü)",
      "Balkan Çayırı Mah (yeşilyurt Köyü)",
      "Barutçuoğlu Mah (sınırköy Köyü)",
      "Batman Mah (ümütbükü Köyü)",
      "Bayburtlu Kıranı Mah (hisarcık Köyü)",
      "Bayramiç Mah (akpınar Köyü)",
      "Bayramlı Mah (güllüce Köyü)",
      "Belen Mah (elmabelen Köyü)",
      "Belen Mah (yazlık Köyü)",
      "Beloba Mah (yeşilpınar Köyü)",
      "Biroluk Mah (derindere Köyü)",
      "Boyacı Obası Mah (akpınar Köyü)",
      "Boyalanı Mah (yeşilpınar Köyü)",
      "Boyuntarla Mah (yeniyazlık Köyü)",
      "Buları Mah (güllüce Köyü)",
      "Bük Mah (yeşilpınar Köyü)",
      "Büyük Düz Mah (hisarcık Köyü)",
      "Büyükdüz Mah (hisarcık Köyü)",
      "Cındızoğlu Mah (ümütbükü Köyü)",
      "Çadıralanı Mah (güllüce Köyü)",
      "Çamurlu Oba Mah (yeşilpınar Köyü)",
      "Çeğel Mah (akköy Köyü)",
      "Çeğel Mah (kanlıca Köyü)",
      "Çeğel Mah (koçlu Köyü)",
      "Çeşmeardı Çelebi Mah (sınırköy Köyü)",
      "Çıkrıkkapı Yaylası Mah (akpınar Köyü)",
      "Çıkrıkkıran Mah (ortaköy Köyü)",
      "Çilderesi Mah (yeşilpınar Köyü)",
      "Çöğürcü Mah (ümütbükü Köyü)",
      "Çukur Mah (kanlıca Köyü)",
      "Çukur Mah (tekkeköy Köyü)",
      "Debecük Mah (akköy Köyü)",
      "Değirmen Yanı Mah (koçlu Köyü)",
      "Değirmenağzı Mah (koçlu Köyü)",
      "Deliktaş Mah (akpınar Köyü)",
      "Delmece Mah (elmabelen Köyü)",
      "Demir Gelisi Obası Mah (akpınar Köyü)",
      "Direkdibi Mah (ümütbükü Köyü)",
      "Doymuş Mah (koçlu Köyü)",
      "Düz Mah (güllüce Köyü)",
      "Eğerlik Mah (yeşilpınar Köyü)",
      "Ekindere Mah (akpınar Köyü)",
      "Elmaderesi Mah (kanlıca Köyü)",
      "Emidüzü Mah (yeşilpınar Köyü)",
      "Fındıcak Mah (sınırköy Köyü)",
      "Fındık Çukuru Mah (hisarcık Köyü)",
      "Fındıkçukuru Mah (hisarcık Köyü)",
      "Fındıklı Mah (akpınar Köyü)",
      "Gevuryatağı Obası Mah (akpınar Köyü)",
      "Geyikci Oba Mah (güllüce Köyü)",
      "Geyikgölü Mah (yeniyazlık Köyü)",
      "Goru Düzü Mah (akköy Köyü)",
      "Göktepe Obası Mah (akpınar Köyü)",
      "Göldüzü Mah (kanlıca Köyü)",
      "Gölyanı Mah (yeşilpınar Köyü)",
      "Gufça Mah (hisarcık Köyü)",
      "Gufça Mezrası Mah (hisarcık Köyü)",
      "Guzyatak Mah (yazlık Köyü)",
      "Günece Mah",
      "Güney Mah (yeniakköy Köyü)",
      "Günlük Sırataş Mah (sınırköy Köyü)",
      "Hacıderesi Obası Mah (akpınar Köyü)",
      "Hacıhüseyin Bey Mah (akpınar Köyü)",
      "Hamaz Mah (yazlık Köyü)",
      "Hanyanı Mah (kanlıca Köyü)",
      "Hanyanı Mah (yeşilpınar Köyü)",
      "Hastaflan Mah (ümütbükü Köyü)",
      "Hatlı Düzü Mah (tekkeköy Köyü)",
      "İlkiliyatak Mah (derindere Köyü)",
      "İmamlar Mah (yeniakköy Köyü)",
      "İsaklı Mah (akköy Köyü)",
      "İsmailler Mah (yeniyazlık Köyü)",
      "Kabadüz Mah (kanlıca Köyü)",
      "Kağışkıranı Mah (ümütbükü Köyü)",
      "Kamışlık Mah (sınırköy Köyü)",
      "Kanderesi Mezrası Mah (akpınar Köyü)",
      "Karabaş Mah (akpınar Köyü)",
      "Karadağ Mah (yeşilpınar Köyü)",
      "Karakışla Mah (ortaköy Köyü)",
      "Karşı Mah (dereköy Köyü)",
      "Karşı Mah (güllüce Köyü)",
      "Kayabaşı Mah (tekkeköy Köyü)",
      "Kayabaşı Yaylası Mah (akpınar Köyü)",
      "Keller Mah (yeniyazlık Köyü)",
      "Keymeni Mah (derindere Köyü)",
      "Kıran Madeni Mah (hisarcık Köyü)",
      "Kıran Mah (dereköy Köyü)",
      "Kıran Mah (elmabelen Köyü)",
      "Kıran Mah (kanlıca Köyü)",
      "Kıran Mah (yeniyazlık Köyü)",
      "Kıranyatak Mah (kanlıca Köyü)",
      "Kırhasan Mah (yeniyazlık Köyü)",
      "Kırkharman Mah (akpınar Köyü)",
      "Kızılca Yatak Mah (ortaköy Köyü)",
      "Kızılelma Mah",
      "Kızıllar Mah (koçlu Köyü)",
      "Kirazkıran Mah (küçükköy Köyü)",
      "Kirazlık Mah (dereköy Köyü)",
      "Kirazlık Mah (yazlık Köyü)",
      "Kocukoğlu Mah (ümütbükü Köyü)",
      "Koyun Alanı Mah (güllüce Köyü)",
      "Kozyaka Mah (sinanlı Köyü)",
      "Kumanağzı Mah (yeşilyurt Köyü)",
      "Kumyalı Mah (akpınar Köyü)",
      "Kuraklık Mah (akpınar Köyü)",
      "Kurucalı Mah",
      "Kuşkıran Mah (dereköy Köyü)",
      "Kuz Mah (yeniakköy Köyü)",
      "Kuzualan Obası Mah (akpınar Köyü)",
      "Küşlü Mah (hisarcık Köyü)",
      "Kütükoğulları Mah (ümütbükü Köyü)",
      "Maden Mah (akköy Köyü)",
      "Manastır Mah (güllüce Köyü)",
      "Manasur Mah (güllüce Köyü)",
      "Melahmet Mah (ortaköy Köyü)",
      "Merkez Mah (derindere Köyü)",
      "Merkez Mah (güllüce Köyü)",
      "Merkez Mah (küçükköy Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (tekkeköy Köyü)",
      "Merkez Mah (yazlık Köyü)",
      "Merkez Mah (yenice Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Mıcıklı Obası Mah (akpınar Köyü)",
      "Mihmatoğlu Mah (ümütbükü Köyü)",
      "Mollar Mah (yeniyazlık Köyü)",
      "Mollo Mah (yeşilpınar Köyü)",
      "Mollooğlu Mah (akpınar Köyü)",
      "Okmeydanı Mah (elmabelen Köyü)",
      "Orta Mah (elmabelen Köyü)",
      "Orta Mah (hisarcık Köyü)",
      "Oruçbey Mah",
      "Öküz Çukuru Mah (yeşilpınar Köyü)",
      "Porsuk Mah (hisarcık Köyü)",
      "Portlu Mah (akpınar Köyü)",
      "Portlu Mah (sinanlı Köyü)",
      "Salim Bükü Mah (koçlu Köyü)",
      "Sancar Düzü Mah (ortaköy Köyü)",
      "Saraydüzü Mah (derindere Köyü)",
      "Sarıalan Obası Mah (akpınar Köyü)",
      "Sarıhasan Mah (sınırköy Köyü)",
      "Sarıyer Mah (yeşilpınar Köyü)",
      "Saypoyrak Mah (sınırköy Köyü)",
      "Seydili Mah (elmabelen Köyü)",
      "Sığırereği Mah (yeşilpınar Köyü)",
      "Sıradaş Mah (sınırköy Köyü)",
      "Sipsilik Mah (yeşilpınar Köyü)",
      "Sofu Mah (sınırköy Köyü)",
      "Soğukpınar Mah (akpınar Köyü)",
      "Soğuksu Mah (sınırköy Köyü)",
      "Sulak Obası Mah (akpınar Köyü)",
      "Susuz Mah (yeşilpınar Köyü)",
      "Süğlük Mah (yeşilpınar Köyü)",
      "Şahlı Mah (hisarcık Köyü)",
      "Tahmazlı Mah (yeniyazlık Köyü)",
      "Tahtalıyatak Mah (derindere Köyü)",
      "Talipoğulları Mah (ümütbükü Köyü)",
      "Tarakçı Mah (akpınar Köyü)",
      "Taşlık Mah (ortaköy Köyü)",
      "Tekçam Mah (yeşilpınar Köyü)",
      "Tekercek Mah (akköy Köyü)",
      "Tepeköy Mah",
      "Tesbi Mah (yeşilpınar Köyü)",
      "Tilhan Mah (akköy Köyü)",
      "Topluca Mah (kanlıca Köyü)",
      "Torunuyanı Mah (hisarcık Köyü)",
      "Tuzlak Kıran Mah (ümütbükü Köyü)",
      "Uludüz Mah (yenice Köyü)",
      "Uzunabduoğulları Mah (akköy Köyü)",
      "Yalça Mah (koçlu Köyü)",
      "Yamuçlu Mah (küçükköy Köyü)",
      "Yananev Mah (akpınar Köyü)",
      "Yeni Oba Mah (güllüce Köyü)",
      "Yenioba Mah (akpınar Köyü)",
      "Yokuşbaşı Mah (koçlu Köyü)",
      "Yoni Kızıllığı Mah (yeşilpınar Köyü)",
      "Yukarı Mah (dereköy Köyü)",
      "Yukarı Mah (kanlıca Köyü)",
      "Yumbat Obası Mah (akpınar Köyü)",
      "Yunusören Mah (kanlıca Köyü)",
      "Çağlayan Mah (üçtepe Beldesi)",
      "Gültepe Mah (üçtepe Beldesi)",
      "Kozbükü Mah (üçtepe Beldesi)",
      "Tuğlacık Mah (üçtepe Beldesi)",
      "Bük Mah",
      "Merkez Mah",
      "Ömerli Mah",
      "Palaklı Mah"
    ]
  },
  "Gümüşhane": {
    "Kelkit": [
      "Cumhuriyet Mah (deredolu Beldesi)",
      "Hürriyet Mah (deredolu Beldesi)",
      "Mahmatlı Mah (deredolu Beldesi)",
      "Fatih Mah (gümüşgöze Beldesi)",
      "Göztepe Mah (gümüşgöze Beldesi)",
      "Özyurt Mah (gümüşgöze Beldesi)",
      "Atatürk Mah",
      "Bahçelievler Mah",
      "Büyükcami Mah",
      "Cumhuriyet Mah",
      "İnönü Mah",
      "Küçükcami Mah",
      "Ağıl Köyü",
      "Ağlık Köyü",
      "Ahmet Yesevi Mah",
      "Akdağ Köyü",
      "Aksöğüt Köyü",
      "Alacat Köyü",
      "Aşağı Bezendi Mah (bezendi Köyü)",
      "Aşağıözlüce Köyü",
      "Aşut Köyü",
      "Aydoğdu Köyü",
      "Aziz Köyü",
      "Babakonağı Köyü",
      "Balıklı Köyü",
      "Balkaya Köyü",
      "Başpınar Köyü",
      "Belenli Köyü",
      "Beşdeğirmen Köyü",
      "Bindal Köyü",
      "Bulak Köyü",
      "Cemalli Köyü",
      "Çağlar Köyü",
      "Çakırlar Köyü",
      "Çamur Köyü",
      "Çimenli Köyü",
      "Dayısı Köyü",
      "Deliler Köyü",
      "Dereyüzü Köyü",
      "Devekorusu Köyü",
      "Doğanca Köyü",
      "Doğankavak Köyü",
      "Dölek Köyü",
      "Elmelik Köyü",
      "Esenler Mah (kaş Köyü)",
      "Eskikadı Köyü",
      "Eskiyol Köyü",
      "Eymür Köyü",
      "Fatih Mah (kaş Köyü)",
      "Gevezit Mah (yenice Köyü)",
      "Güllüce Köyü",
      "Gültepe Köyü",
      "Günbatur Köyü",
      "Güneyçevirme Köyü",
      "Gürleyik Köyü",
      "Güzyurdu Köyü",
      "Karacaören Köyü",
      "Karaçayır Mah",
      "Karşıyaka Köyü",
      "Kayacık Mah (çömlecik Köyü)",
      "Kılıççı Köyü",
      "Kılıçtaşı Köyü",
      "Kınalıtaş Köyü",
      "Kındıralık Mah (bezendi Köyü)",
      "Kozoğlu Köyü",
      "Kömür Köyü",
      "Köycük Köyü",
      "Kuşluk Köyü",
      "Merkez Mah (bezendi Köyü)",
      "Merkez Mah (çömlecik Köyü)",
      "Merkez Mah (gerdekhisar Köyü)",
      "Merkez Mah (gödül Köyü)",
      "Merkez Mah (kazanpınar Köyü)",
      "Merkez Mah (kızılca Köyü)",
      "Meydanlar Mah (gerdekhisar Köyü)",
      "Mezra Mah (gödül Köyü)",
      "Obalar Köyü",
      "Oğuz Köyü",
      "Öğütlü Köyü",
      "Örenbel Köyü",
      "Özen Köyü",
      "Sadak Köyü",
      "Salördek Köyü",
      "Sarışeyh Köyü",
      "Savcı Mah (bezendi Köyü)",
      "Sökmen Köyü",
      "Sula Mah (kazanpınar Köyü)",
      "Sütveren Köyü",
      "Şen Köyü",
      "Tütenli Köyü",
      "Uyanık Mah (yenice Köyü)",
      "Uzunkol Köyü",
      "Yarbaşı Köyü",
      "Yayla Mah (babakonağı Köyü)",
      "Yayla Mah (gürleyik Köyü)",
      "Yayla Mah (kızılca Köyü)",
      "Yayla Mah (yeşilpınar Köyü)",
      "Yeniköy Köyü",
      "Yeniyol Köyü",
      "Yeşilova Köyü",
      "Yeşilpınar Köyü",
      "Yeşilyurt Köyü",
      "Yolçatı Köyü",
      "Yukarıözlüce Köyü",
      "Yunus Emre Mah",
      "Esentepe Mah (öbektaş Beldesi)",
      "Fatih Mah (öbektaş Beldesi)",
      "Halkevi Mah (öbektaş Beldesi)",
      "Merkez Mah (söğütlü Beldesi)",
      "Büyükcami Mah (ünlüpınar Beldesi)",
      "Fatih Mah (ünlüpınar Beldesi)"
    ],
    "Köse": [
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Akbaba Mah (akbaba Köyü)",
      "Altıntaş Mah (altıntaş Köyü)",
      "Bizgili Mah (bizgili Köyü)",
      "Cumhuriyet Mah (salyazı Köyü)",
      "Gökçeköy Mah (gökçeköy Köyü)",
      "Hürriyet Mah (salyazı Köyü)",
      "Kabaktepe Mah (kabaktepe Köyü)",
      "Kayadibi Mah (kayadibi Köyü)",
      "Oylumdere Mah (oylumdere Köyü)",
      "Örenşar Mah (örenşar Köyü)",
      "Övünce Mah (övünce Köyü)",
      "Özbeyli Mah (özbeyli Köyü)",
      "Subaşı Mah (subaşı Köyü)",
      "Yaylım Mah (yaylım Köyü)",
      "Yuvacık Mah (yuvacık Köyü)"
    ],
    "Kürtün": [
      "Aşağı Uluköy Mah",
      "Cami Yanı Mah",
      "Köyiçi Mah",
      "Melikli Mah",
      "Ortaköy Mah",
      "Yukarı Uluköy Mah",
      "Akbaba Mah (ekinciler Köyü)",
      "Akköy Mah (üçtaş Köyü)",
      "Alacainek Mah (üçtaş Köyü)",
      "Alan Mah (bağlama Köyü)",
      "Alan Mah (elciğez Köyü)",
      "Alan Mah (yeşilköy Köyü)",
      "Alan Yayla Mah (gürgenli Köyü)",
      "Alantarla Mah (elmalı Köyü)",
      "Alda Düzü Mah (demirciler Köyü)",
      "Alınca Mah (yeşilköy Köyü)",
      "Alt Mah (şendere Köyü)",
      "Anbarlı Mah (üçtaş Köyü)",
      "Apsa Mah (yaylalı Köyü)",
      "Aralıcak Mah (taşlıca Köyü)",
      "Armutalanı Mah (sapmaz Köyü)",
      "Aşağı Alan Mah (kızılot Köyü)",
      "Aşağı Mah (kızılot Köyü)",
      "Aşağı Mah (söğüteli Köyü)",
      "Aşağı Mah (yaylalı Köyü)",
      "Avleka Mah (konacık Köyü)",
      "Ayazmane Mah (aşağıkaradere Köyü)",
      "Aygeriş Mah (yeşilköy Köyü)",
      "Aykutlu Mah (gündoğdu Köyü)",
      "Balıklı Mah (sarıbaba Köyü)",
      "Baliçukur Mah (araköy Köyü)",
      "Baş Mah (söğüteli Köyü)",
      "Baş Mah (yaylalı Köyü)",
      "Başövet Mah (elciğez Köyü)",
      "Bayrakalanı Mah (konacık Köyü)",
      "Beşiraltı Mah (beşirköy Köyü)",
      "Büyük Çeğel Mah (yeşilköy Köyü)",
      "Büyük Köyceğiz Mah (yeşilköy Köyü)",
      "Cami Mah (beşirköy Köyü)",
      "Cami Mah (günyüzü Köyü)",
      "Cami Mah (yaylalı Köyü)",
      "Camii Mah (akçal Köyü)",
      "Camii Mah (damlı Köyü)",
      "Camii Mah (gürgenli Köyü)",
      "Camii Mah (kızılcadam Köyü)",
      "Camii Mah (sarıbaba Köyü)",
      "Camii Yanı Mah (elciğez Köyü)",
      "Camönü Mah (yukarıkaradere Köyü)",
      "Çakmakkaya Mah (gündoğdu Köyü)",
      "Çalalanı Mah (yeşilköy Köyü)",
      "Çamat Mah (yeşilköy Köyü)",
      "Çardak Alanı Mah (yeşilköy Köyü)",
      "Çardakyanı Mah (taşlıca Köyü)",
      "Çarşı Mah (demirciler Köyü)",
      "Çatak Mah (göndere Köyü)",
      "Çatalkaya Mah (taşlıca Köyü)",
      "Çavuş Kıran Mah (elciğez Köyü)",
      "Çetlice-cinkayası Mah (taşlıca Köyü)",
      "Çıkrıkdüzü Mah (yeşilköy Köyü)",
      "Çokma Mah (gürgenli Köyü)",
      "Çoruhlu Mah (beytarla Köyü)",
      "Çöplüce Mah (çayırçukur Köyü)",
      "Dağtarla-karaağaç-kökbükü Mah (taşlıca Köyü)",
      "Delmece Mah (sapmaz Köyü)",
      "Dere Mah (sarıbaba Köyü)",
      "Dere Mah (yaylalı Köyü)",
      "Dere Oba Mah (tilkicek Köyü)",
      "Deregözü Mah (taşlıca Köyü)",
      "Derindere Mah (yaylalı Köyü)",
      "Doğuba Mah (araköy Köyü)",
      "Düz Mah (aşağıkaradere Köyü)",
      "Düz Mah (günyüzü Köyü)",
      "Düz Yayla Mah (akçal Köyü)",
      "Düzlüce Mah (çayırçukur Köyü)",
      "Eğrikar Mah (yukarıkaradere Köyü)",
      "Eminli Mah (akçal Köyü)",
      "Engözü Mah (taşlıca Köyü)",
      "Ericek Mah (beşirköy Köyü)",
      "Erik Deresi Mah (yukarıkaradere Köyü)",
      "Eselüce-kurumaden-körükalanı-göndere Mah (taşlıca Köyü)",
      "Eskiyurt Mah (araköy Köyü)",
      "Fındıcak Mah (elciğez Köyü)",
      "Gevüklü Mah (ekinciler Köyü)",
      "Göcü Mereği Mah (şendere Köyü)",
      "Gölceğiz Mah (yeşilköy Köyü)",
      "Gölönü Mah (yaylalı Köyü)",
      "Güllüşah Mah (kızılcadam Köyü)",
      "Güney Mah (beşirköy Köyü)",
      "Güvende Mah (yeşilköy Köyü)",
      "Hacılı Mah (sapmaz Köyü)",
      "Halil Bey Mah (yeşilköy Köyü)",
      "Hapandüzü Mah (kırgeriş Köyü)",
      "Harmancık Mah (gürgenli Köyü)",
      "Hayatderesi Mah (sapmaz Köyü)",
      "Hayin Dere Mah (kızılot Köyü)",
      "Herekli Mah (kızılcadam Köyü)",
      "Hocali Mah (konacık Köyü)",
      "Horoz Mah (konacık Köyü)",
      "Imukyurt Mah (sarıbaba Köyü)",
      "İbrahim Alanı Mah (yeşilköy Köyü)",
      "İkibaca Mah (taşlıca Köyü)",
      "İmat Kıranı Mah (üçtaş Köyü)",
      "İncelidüz Mah (üçtaş Köyü)",
      "İsmirli Mah (çayırçukur Köyü)",
      "Kabadüz Mah (şendere Köyü)",
      "Kabayalak Mah (günyüzü Köyü)",
      "Kabayalak Mah (taşlıca Köyü)",
      "Kakıllı Mah (elciğez Köyü)",
      "Kaledüzü Mah (demirciler Köyü)",
      "Kanyaş Mah (aktaş Köyü)",
      "Karaağaç Mah (aşağıkaradere Köyü)",
      "Karaağaç Mah (günyüzü Köyü)",
      "Karaboya Mah (yukarıkaradere Köyü)",
      "Karaçukur Mah (sapmaz Köyü)",
      "Karahamzalı Mah (günyüzü Köyü)",
      "Karallı Mah (kızılcadam Köyü)",
      "Karşı Mah (damlı Köyü)",
      "Karşı Mah (kızılot Köyü)",
      "Karşı Mah (tilkicek Köyü)",
      "Karşıkı Mah (araköy Köyü)",
      "Kavastamyanı Mah (çayırçukur Köyü)",
      "Kavraz Mah (taşlıca Köyü)",
      "Kayalgil Mah (elciğez Köyü)",
      "Keleşoğlu Mah (yeşilköy Köyü)",
      "Kepez Mah (beşirköy Köyü)",
      "Kıran Çeğel Mah (yeşilköy Köyü)",
      "Kıran Mah (demirciler Köyü)",
      "Kırıcak Mah (yukarıkaradere Köyü)",
      "Kırık Mah (şendere Köyü)",
      "Kızılali Alt Mah (taşlıca Köyü)",
      "Kızılali Üst Mah (taşlıca Köyü)",
      "Kızılçukur Mah (taşlıca Köyü)",
      "Kızıllık Mah (elmalı Köyü)",
      "Kızıltaş Mah (bağlama Köyü)",
      "Kirazalanı Mah (çayırçukur Köyü)",
      "Kiselice Mah (yeşilköy Köyü)",
      "Komanyurt Mah (beytarla Köyü)",
      "Kökeç Mah (bağlama Köyü)",
      "Köprübaşı Mah (sapmaz Köyü)",
      "Köro-deliklitaş-yaylacık Mah (taşlıca Köyü)",
      "Köroğ Mah (konacık Köyü)",
      "Kurukıran Mah (bağlama Köyü)",
      "Kuş Alanı Mah (tilkicek Köyü)",
      "Kuşlağanağzı Mah (günyüzü Köyü)",
      "Kutlu Mah (konacık Köyü)",
      "Kuz Mah (kırgeriş Köyü)",
      "Kuz Mah (kızılcadam Köyü)",
      "Kuzugölü Mah (çayırçukur Köyü)",
      "Kuzugölü Mah (şendere Köyü)",
      "Küçük Köyceğiz Mah (yeşilköy Köyü)",
      "Küçükdere Mah (yeşilköy Köyü)",
      "Kütüklüyurt Mah (yeşilköy Köyü)",
      "Langas Mah (akçal Köyü)",
      "Mallıca Mah (tilkicek Köyü)",
      "Masul Yurdu Mah (yeşilköy Köyü)",
      "Melikli Mah (demirciler Köyü)",
      "Memişli Mah (gündoğdu Köyü)",
      "Merekdere Mah (kırgeriş Köyü)",
      "Merkez Mah (aktaş Köyü)",
      "Merkez Mah (arpacık Köyü)",
      "Merkez Mah (bağlama Köyü)",
      "Merkez Mah (beytarla Köyü)",
      "Merkez Mah (eğrigüney Köyü)",
      "Merkez Mah (ekinciler Köyü)",
      "Merkez Mah (elmalı Köyü)",
      "Merkez Mah (göndere Köyü)",
      "Merkez Mah (gürgenli Köyü)",
      "Merkez Mah (konacık Köyü)",
      "Merkez Mah (kuşluk Köyü)",
      "Merkez Mah (sapmaz Köyü)",
      "Merkez Mah (şendere Köyü)",
      "Merkez Mah (taşlıca Köyü)",
      "Merkez Mah (üçtaş Köyü)",
      "Merkez Mah (yukarıkaradere Köyü)",
      "Mindizli Mah (kırgeriş Köyü)",
      "Mursal Mah (gürgenli Köyü)",
      "Mürütlü Mah (üçtaş Köyü)",
      "Nasrettin Yaylası Mah (gürgenli Köyü)",
      "Ocak Mah (sarıbaba Köyü)",
      "Okulyanı Mah (günyüzü Köyü)",
      "Orta Mah (demirciler Köyü)",
      "Orta Mah (kırgeriş Köyü)",
      "Orta Mah (kızılot Köyü)",
      "Orta Mah (söğüteli Köyü)",
      "Öksüz Mah (akçal Köyü)",
      "Öksüzlü Mah (beşirköy Köyü)",
      "Patıryurdu Mah (yeşilköy Köyü)",
      "Pınar Gözü Mah (gürgenli Köyü)",
      "Pınarbaşı Mah (şendere Köyü)",
      "Ramazanyurdu Mah (yaylalı Köyü)",
      "Sarıç Mah (aşağıkaradere Köyü)",
      "Sarıtaş Mah (üçtaş Köyü)",
      "Sazlıbük Mah (günyüzü Köyü)",
      "Sevincek Mah (gündoğdu Köyü)",
      "Sicimli Mah (günyüzü Köyü)",
      "Sobatlı Mah (demirciler Köyü)",
      "Soğuk Oluk Mah (elmalı Köyü)",
      "Suluca Mah (taşlıca Köyü)",
      "Suluçayır Mah (taşlıca Köyü)",
      "Taşbaşı Mah (sapmaz Köyü)",
      "Taşboğazı Mah (sarıbaba Köyü)",
      "Taşdibi Mah (çayırçukur Köyü)",
      "Taşdibi Mah (yaylalı Köyü)",
      "Teknecük Mah (yukarıkaradere Köyü)",
      "Tepeköy Mah (kızılot Köyü)",
      "Tohtamur Mah (taşlıca Köyü)",
      "Tutluca Mah (çayırçukur Köyü)",
      "Tüfekçili Mah (göndere Köyü)",
      "Türkmen Mah (yaylalı Köyü)",
      "Üst Mah (demirciler Köyü)",
      "Üst Mah (gündoğdu Köyü)",
      "Üst Mah (tilkicek Köyü)",
      "Ütük Mah (şendere Köyü)",
      "Yaraş Mah (aktaş Köyü)",
      "Yayla Mah (günyüzü Köyü)",
      "Yazıcı Oğulları Mah (konacık Köyü)",
      "Yehenceli Mah (konacık Köyü)",
      "Yelbeleği Mah (yeşilköy Köyü)",
      "Yemişen Mah (üçtaş Köyü)",
      "Yeni Mah (arpacık Köyü)",
      "Yeniçeri Mah (sapmaz Köyü)",
      "Yılanlı Mah (yaylalı Köyü)",
      "Yoncalık Mah (kızılcadam Köyü)",
      "Yukarı Alan Mah (kızılot Köyü)",
      "Yukarı-orta-karşı Mah (aşağıkaradere Köyü)",
      "Yürümez Mah (yaylalı Köyü)",
      "Cayra Mah (özkürtün Beldesi)",
      "Karaçukur Mah (özkürtün Beldesi)",
      "Süme Mah (özkürtün Beldesi)"
    ],
    "Merkez": [
      "Ekinciler Mah (arzularkabaköy Beldesi)",
      "Esentepe Mah (arzularkabaköy Beldesi)",
      "Fatih Mah (arzularkabaköy Beldesi)",
      "Gaziler Mah (arzularkabaköy Beldesi)",
      "Mezire Mah (arzularkabaköy Beldesi)",
      "Osman Gazi Mah (arzularkabaköy Beldesi)",
      "Bağlarbaşı Mah",
      "Canca Mah",
      "Çamlıca Mah",
      "Eskibağlar Mah",
      "Hacıemin Mah",
      "Hasanbey Mah",
      "İnönü Mah",
      "Karaer Mah",
      "Karşıyaka Mah",
      "Oltanbey Mah",
      "Özcan Mah",
      "Süleymaniye Mah",
      "Yeni Mah",
      "Acısu Mah (yağlıdere Köyü)",
      "Ağalık Mah (çamlı Köyü)",
      "Ağılören Mah (olucak Köyü)",
      "Akçakale Mah",
      "Akdikli Mah (mescitli Köyü)",
      "Akhisar Köyü",
      "Alacaçayır Mah (çorak Köyü)",
      "Alamanlı Mah (aktutan Köyü)",
      "Alçakdere Mah (alçakdere Köyü)",
      "Alçakdere Yaylası Mah (alçakdere Köyü)",
      "Alemdar Mah (alemdar Köyü)",
      "Arpalı Mah (çorak Köyü)",
      "Arslanca Mah (arslanca Köyü)",
      "Aslankılıçlar Mah (ikisu Köyü)",
      "Aşağı Alıçlı Mah (aşağıalıçlı Köyü)",
      "Aşağı Dışbudak Mah (yağlıdere Köyü)",
      "Aşağı Havriya Mah (hasköy Köyü)",
      "Aşağı Kurugöl Mah (çorak Köyü)",
      "Aşağı Mah (çayırardı Köyü)",
      "Aşağı Mah (esenyurt Köyü)",
      "Aşağı Mah (güvercinlik Köyü)",
      "Aşağı Mah (olukdere Köyü)",
      "Aşağı Mah (yaydemir Köyü)",
      "Aşağı Yuvalı Mah (aşağı Yuvalı Köyü)",
      "Aşağı Zuvas Mah (arslanca Köyü)",
      "Avşarbeyli Mah (avşarbeyli Köyü)",
      "Ayene Mah (dumanlı Köyü)",
      "Ayranlı Mah (mescitli Köyü)",
      "Ayvazlı Mah (yağlıdere Köyü)",
      "Babese Mah (ikisu Köyü)",
      "Bağ Mah (dibekli Köyü)",
      "Bağ Mah (mescitli Köyü)",
      "Bağcılar Mah (yitirmez Köyü)",
      "Bahçe Mah (kırıklı Köyü)",
      "Bahçeli Mah (gözeler Köyü)",
      "Bahçelievler Mah (sargınkaya Köyü)",
      "Balahor Yaylası 2 Mah (arslanca Köyü)",
      "Balahor Yaylası Mah (arslanca Köyü)",
      "Baş Mah (hasköy Köyü)",
      "Bayraktarlar Mah (ikisu Köyü)",
      "Bayramoğlu Mah (kaletaş Köyü)",
      "Bazmetli Mah (yağlıdere Köyü)",
      "Bektaşlı Mah (aktutan Köyü)",
      "Beşoba Köyü",
      "Beyçam Mah (beyçam Köyü)",
      "Beyler Mah (hasköy Köyü)",
      "Binatlı Mah (dumanlı Köyü)",
      "Boğalı Mah (buğalı Köyü)",
      "Boğalı Yaylası Mah (buğalı Köyü)",
      "Boyhane Mah (dumanlı Köyü)",
      "Bulut Mah (yağlıdere Köyü)",
      "Bulutlu Mah (yağlıdere Köyü)",
      "Bulutlu Yaylası Mah (yağlıdere Köyü)",
      "Büyük Çimen Mah (arslanca Köyü)",
      "Büyükyayla Mah (çorak Köyü)",
      "Cabaylı Mah (yeşilyurt Köyü)",
      "Cabri Mah (aktutan Köyü)",
      "Caferli Mah (erdemler Köyü)",
      "Cami Boğazı Mah (yağlıdere Köyü)",
      "Cami Mah (dölek Köyü)",
      "Cami Mah (gözeler Köyü)",
      "Cami Mah (yeniyol Köyü)",
      "Camiönü Mah (mescitli Köyü)",
      "Cingarlı Mah (dumanlı Köyü)",
      "Cirip Mah (dumanlı Köyü)",
      "Cumhuriyet Mah (tekke Köyü)",
      "Cücüklü Mah (aktutan Köyü)",
      "Çağıl Göl Mah (çorak Köyü)",
      "Çakallı Mah (dumanlı Köyü)",
      "Çakırlı Mah (dörtkonak Köyü)",
      "Çako Mah (övündü Köyü)",
      "Çaltılı Mah (çaltılı Köyü)",
      "Çamlıca Mah (gözeler Köyü)",
      "Çardaklı Mah (dumanlı Köyü)",
      "Çatalçayır Mah (arslanca Köyü)",
      "Çatalpınar Mah (çorak Köyü)",
      "Çerkezli Mah (akgedik Köyü)",
      "Çiçek Mah (dumanlı Köyü)",
      "Çiçekli Mah (gözeler Köyü)",
      "Çiçekli Mah (sarıçiçek Köyü)",
      "Çolakgil Mah (dölek Köyü)",
      "Çorak Köyü",
      "Çorak Mah (söğütağıl Köyü)",
      "Çukur Mah (dumanlı Köyü)",
      "Daşlıova Mah (dumanlı Köyü)",
      "Değirmen Mah (çamlı Köyü)",
      "Demirören Mah (demirören Köyü)",
      "Dere Mah (övündü Köyü)",
      "Derindere Mah (çorak Köyü)",
      "Derinırmak Mah (dumanlı Köyü)",
      "Derinırmak Mah (yağlıdere Köyü)",
      "Deveboynu Mah (yağlıdere Köyü)",
      "Devrenci Mah (boyluca Köyü)",
      "Divane Mah (çorak Köyü)",
      "Dolanlı Mah (dölek Köyü)",
      "Dörtkonak Mah (dörtkonak Köyü)",
      "Düğünyazı Mah (düğünyazı Köyü)",
      "Düzce Mah (yağlıdere Köyü)",
      "Efeler Mah (ikisu Köyü)",
      "Efendiler Mah (mescitli Köyü)",
      "Eftelan Mah (dumanlı Köyü)",
      "Eğrisi Mah (çorak Köyü)",
      "Ekmekçi Mah (dibekli Köyü)",
      "Emirler Mah (dörtkonak Köyü)",
      "Erikli Mah (yitirmez Köyü)",
      "Esenler Mah (esenler Köyü)",
      "Esentepe Mah (aktutan Köyü)",
      "Eski Yayla Mah (buğalı Köyü)",
      "Eskiköy Mah (geçit Köyü)",
      "Evlice Mah (yağlıdere Köyü)",
      "Evreni Mah (karamustafa Köyü)",
      "Fazlıoğlu Mah (ikisu Köyü)",
      "Fırtına Mah (mescitli Köyü)",
      "Gacili Mah (buğalı Köyü)",
      "Garipli Mah (dölek Köyü)",
      "Gırlavu Mah (çorak Köyü)",
      "Giretli Mah (aktutan Köyü)",
      "Gobal Mah (dumanlı Köyü)",
      "Gofi Mah (dumanlı Köyü)",
      "Gologos Mah (çorak Köyü)",
      "Gökçepınar Mah (gökçepınar Köyü)",
      "Gökdere 2 Mah (gökdere Köyü)",
      "Gökdere Mah (gökdere Köyü)",
      "Gümüşlük Mah (akgedik Köyü)",
      "Gündoğdu Mah (demirkaynak Köyü)",
      "Güneşli Mah (yeşildere Köyü)",
      "Güney Mah (buğalı Köyü)",
      "Güngören Mah (güngören Köyü)",
      "Hacıgil Mah (dölek Köyü)",
      "Hacılar Mah (akgedik Köyü)",
      "Hacılı Mah (aktutan Köyü)",
      "Hacılı Mah (yeşildere Köyü)",
      "Haleverne Mah (ikisu Köyü)",
      "Halezara Mah (boyluca Köyü)",
      "Haliloğlu Mah (boyluca Köyü)",
      "Hamitler Mah (ikisu Köyü)",
      "Hamzaağa Mah (güngören Köyü)",
      "Hanemgil Mah (dölek Köyü)",
      "Hanlarındere Mah (yağlıdere Köyü)",
      "Hapencili Mah (gözeler Köyü)",
      "Harabe Mah (yağlıdere Köyü)",
      "Harava Mah (ikisu Köyü)",
      "Harmancık Mah (harmancık Köyü)",
      "Haşutlar Mah (sungurbeyli Köyü)",
      "Hurşit Ağagil Mah (mescitli Köyü)",
      "Irmak Mah (dumanlı Köyü)",
      "Irmakbaşı Mah (dumanlı Köyü)",
      "Işıkdere Mah (çamlı Köyü)",
      "Işıklı Mah (kazantaş Köyü)",
      "İbrahimefendi Mah (kaletaş Köyü)",
      "İkisu Mah (ikisu Köyü)",
      "İkiz Mah (ikiz Köyü)",
      "İkiz Yaylası Mah (ikiz Köyü)",
      "İncesu Mah (incesu Köyü)",
      "İskan Mah (akgedik Köyü)",
      "İspatan Mah (güngören Köyü)",
      "İstavrama Mah (dumanlı Köyü)",
      "İşbirli Mah (dörtkonak Köyü)",
      "İşhanlı Mah (dumanlı Köyü)",
      "Kaban Mah (dumanlı Köyü)",
      "Kaden Mah (karamustafa Köyü)",
      "Kaleönü Mah (tekke Köyü)",
      "Kalkanlı Mah (yeşilyurt Köyü)",
      "Karaağaç Mah (yağlıdere Köyü)",
      "Karaali Mah (mescitli Köyü)",
      "Karaburun Mah (çorak Köyü)",
      "Karahava Mah (çorak Köyü)",
      "Karakaya Mah (dibekli Köyü)",
      "Karakaya Mah (gökçepınar Köyü)",
      "Karamustafa Mah (karamustafa Köyü)",
      "Karayayla Mah (yağlıdere Köyü)",
      "Karşı Mah (alemdar Köyü)",
      "Karşı Mah (dölek Köyü)",
      "Karşı Mah (kazantaş Köyü)",
      "Karşı Mah (mescitli Köyü)",
      "Karşı Mah (söğütağıl Köyü)",
      "Karşı Mah (sungurbeyli Köyü)",
      "Karşı Mah (yaydemir Köyü)",
      "Karşı Mah (yayladere Köyü)",
      "Karşıyaka Mah (ballıca Köyü)",
      "Karşıyaka Mah (dibekli Köyü)",
      "Kasapoğlu Mah (çorak Köyü)",
      "Katmerkaya Mah (tekke Köyü)",
      "Kayabaşı Mah (kayabaşı Köyü)",
      "Kayabaşı Yaylası 2 Mah (kayabaşı Köyü)",
      "Kayabaşı Yaylası Mah (kayabaşı Köyü)",
      "Kayalçı Mah (akgedik Köyü)",
      "Kelhasan Mah (dumanlı Köyü)",
      "Kıran Mah (dörtkonak Köyü)",
      "Kızılca Mah (kızılca Köyü)",
      "Kızılkaya Mah (akocak Köyü)",
      "Kızıltaş Mah (beşoba Köyü)",
      "Kilise Sırtı Mah (dumanlı Köyü)",
      "Kirazlı Mah (sungurbeyli Köyü)",
      "Kocayokuş Mah (kocayokuş Köyü)",
      "Kocayokuş Mezrası Mah (kocayokuş Köyü)",
      "Kolathanları Mah (yağlıdere Köyü)",
      "Konacık Mah (yeşilyurt Köyü)",
      "Konaklı Mah (çorak Köyü)",
      "Koyunoğlu Mah (çamlı Köyü)",
      "Köklüce Mah (olucak Köyü)",
      "Krom Mah (yağlıdere Köyü)",
      "Kumlar Mah (karamustafa Köyü)",
      "Kurtdere Mah (çorak Köyü)",
      "Kurtdere-dilaver Mah (çorak Köyü)",
      "Kurtgil Mah (dölek Köyü)",
      "Kurtoğlu Mah (kurtoğlu Köyü)",
      "Kuşlu Mah (yeşildere Köyü)",
      "Kuzugölü Mah (dumanlı Köyü)",
      "Küçük Çimen Mah (arslanca Köyü)",
      "Küçükçiçekli Mah (dumanlı Köyü)",
      "Küçükyurt Mah (çorak Köyü)",
      "Kütük Mah (dumanlı Köyü)",
      "Lenda Mah (dumanlı Köyü)",
      "Limonsuyu Mah (güngören Köyü)",
      "Lorya Mah (yağlıdere Köyü)",
      "Maden Mah (yağlıdere Köyü)",
      "Mağaldos Mah (çamlı Köyü)",
      "Malaha Mah (dörtkonak Köyü)",
      "Mandagölü Mah (yağlıdere Köyü)",
      "Marondu Mah (çorak Köyü)",
      "Melitli Mah (çamlı Köyü)",
      "Memişli Mah (hasköy Köyü)",
      "Merkez Mah (akçahisar Köyü)",
      "Merkez Mah (akhisar Köyü)",
      "Merkez Mah (akocak Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (aksu Köyü)",
      "Merkez Mah (arduç Köyü)",
      "Merkez Mah (bahçecik Köyü)",
      "Merkez Mah (bandırlık Köyü)",
      "Merkez Mah (boyluca Köyü)",
      "Merkez Mah (çalık Köyü)",
      "Merkez Mah (çamlı Köyü)",
      "Merkez Mah (çorak Köyü)",
      "Merkez Mah (demirkaynak Köyü)",
      "Merkez Mah (duymadık Köyü)",
      "Merkez Mah (geçit Köyü)",
      "Merkez Mah (gümüşkaya Köyü)",
      "Merkez Mah (güvercinlik Köyü)",
      "Merkez Mah (incesu Köyü)",
      "Merkez Mah (kale Köyü)",
      "Merkez Mah (keçikaya Köyü)",
      "Merkez Mah (kılıçören Köyü)",
      "Merkez Mah (kırıklı Köyü)",
      "Merkez Mah (kocapınar Köyü)",
      "Merkez Mah (olucak Köyü)",
      "Merkez Mah (pehlivantaşı Köyü)",
      "Merkez Mah (sargınkaya Köyü)",
      "Merkez Mah (sarıçiçek Köyü)",
      "Merkez Mah (sungurbeyli Köyü)",
      "Merkez Mah (süle Köyü)",
      "Merkez Mah (süngübayır Köyü)",
      "Merkez Mah (tamzı Köyü)",
      "Merkez Mah (tandırlık Köyü)",
      "Merkez Mah (yağlıdere Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Mescitli Mah (mescitli Köyü)",
      "Minconos Mah (çorak Köyü)",
      "Mizit Yaylası Mah (yağlıdere Köyü)",
      "Mollaali Mah (yağlıdere Köyü)",
      "Mollaoğlu Mah (buğalı Köyü)",
      "Muhara Mah (yağlıdere Köyü)",
      "Muratgil Mah (dölek Köyü)",
      "Murathanoğlu Mah (akgedik Köyü)",
      "Muzgulu Mah (aktutan Köyü)",
      "Nazlıçayır Mah (nazlıçayır Köyü)",
      "Nöbünt Mah (arslanca Köyü)",
      "Okul Mah (dölek Köyü)",
      "Orta Mah (aktutan Köyü)",
      "Orta Mah (arslanca Köyü)",
      "Orta Mah (çorak Köyü)",
      "Orta Mah (dumanlı Köyü)",
      "Orta Mah (esenyurt Köyü)",
      "Orta Mah (kazantaş Köyü)",
      "Orta Mah (söğütağıl Köyü)",
      "Orta Mah (yaydemir Köyü)",
      "Orta Mah (yayladere Köyü)",
      "Oruçlu Mah (dölek Köyü)",
      "Osmangil Mah (dörtkonak Köyü)",
      "Örenler Mah (örenler Köyü)",
      "Örenler Yaylası Mah (örenler Köyü)",
      "Öteki Mah (arslanca Köyü)",
      "Paşalar Mah (hasköy Köyü)",
      "Pazaryeri Mah (hasköy Köyü)",
      "Pehlivanlar Mah (mescitli Köyü)",
      "Piknik Mah (çamlı Köyü)",
      "Pirahmet Mah (pirahmet Köyü)",
      "Pirahmet Y Mah (pirahmet Köyü)",
      "Piştofli Mah (dumanlı Köyü)",
      "Recepli Mah (erdemler Köyü)",
      "Sallahlı Mah (dörtkonak Köyü)",
      "Sarıoğlu Mah (yağlıdere Köyü)",
      "Sarıtaş Mah (çorak Köyü)",
      "Satıroğlu Mah (arslanca Köyü)",
      "Semerciler Mah (yitirmez Köyü)",
      "Serogoz Mah (boyluca Köyü)",
      "Sevimli Mah (erdemler Köyü)",
      "Sığırlı Mah (yeşildere Köyü)",
      "Sırt Yayla Mah (dumanlı Köyü)",
      "Soğanlı Mah (çamlı Köyü)",
      "Soğanlı Mah (yağlıdere Köyü)",
      "Soğukpınar Mah (yağlıdere Köyü)",
      "Soğuksu Mah (hasköy Köyü)",
      "Sulaklı Mah (dumanlı Köyü)",
      "Sulanmış Mah (harmancık Köyü)",
      "Sungurbeyli Mah (sungurbeyli Köyü)",
      "Şakallı Mah (yeşildere Köyü)",
      "Şaphane Mah (şephane Köyü)",
      "Şican Mah (çorak Köyü)",
      "Tarazalı Mah (aktutan Köyü)",
      "Taşaltı Mah (dumanlı Köyü)",
      "Taşdibi Mah (çorak Köyü)",
      "Taşdibi Mah (yeşildere Köyü)",
      "Taşköprü Mah (çorak Köyü)",
      "Taşlıca Mah (yeşildere Köyü)",
      "Tefil Mah (aktutan Köyü)",
      "Tekke Mah (çorak Köyü)",
      "Temelağa Mah (mescitli Köyü)",
      "Temürlü Mah (aktutan Köyü)",
      "Terzili Mah (dumanlı Köyü)",
      "Tokluca Mah (çamlı Köyü)",
      "Topculu Mah (dibekli Köyü)",
      "Toramanlı Mah (aktutan Köyü)",
      "Torlakoğlu Mah (kaletaş Köyü)",
      "Turhanlı Mah (dörtkonak Köyü)",
      "Türkmenler Mah (tekke Köyü)",
      "Türkmenli Mah (yeşilyurt Köyü)",
      "Ulukale Mah (yeniköy Köyü)",
      "Uslugun Mah (yağlıdere Köyü)",
      "Uzunsırt Mah (dumanlı Köyü)",
      "Uzunyol Mah (karamustafa Köyü)",
      "Üçkol Mah (üçkol Köyü)",
      "Üstünkü Zügü Mah (aşağı Yuvalı Köyü)",
      "Yağlıdere Köyü",
      "Yağmurdere Mah (yağmurdere Köyü)",
      "Yamaç Mah (yağlıdere Köyü)",
      "Yapraklı Mah (yukarı Yuvalı Köyü)",
      "Yayla Yolu Mah (kaletaş Köyü)",
      "Yeni Çamlık Mah (yağlıdere Köyü)",
      "Yeni Mah (ballıca Köyü)",
      "Yeni Mah (yeniyol Köyü)",
      "Yeni Yayla Mah (arslanca Köyü)",
      "Yeni Yayla Mah (dumanlı Köyü)",
      "Yenice Mah (yenice Köyü)",
      "Yeşilyurt Mah (erdemler Köyü)",
      "Yetimli Mah (yeşilyurt Köyü)",
      "Yılmazlar Mah (ikisu Köyü)",
      "Yoğurtlu Mah (yağlıdere Köyü)",
      "Yoncalı Mah (harmancık Köyü)",
      "Yoncalı Osb Mah (harmancık Köyü)",
      "Yukarı Alıçlı Mah (yukarı Alıçlı Köyü)",
      "Yukarı Havrıya Mah (hasköy Köyü)",
      "Yukarı Kurugöl Mah (çorak Köyü)",
      "Yukarı Mah (çayırardı Köyü)",
      "Yukarı Mah (esenyurt Köyü)",
      "Yukarı Mah (olukdere Köyü)",
      "Yukarı Mah (yaydemir Köyü)",
      "Yukarı Mah (yayladere Köyü)",
      "Yukarı Öteki Dere Mah (dölek Köyü)",
      "Yukarı Övündü Mah (övündü Köyü)",
      "Yukarı Parti Mah (yağlıdere Köyü)",
      "Yukarı Yuvalı Mah (yukarı Yuvalı Köyü)",
      "Yukarı Zuvas Mah (arslanca Köyü)",
      "Zeynepli Mah (yeşildere Köyü)",
      "Zurnacili Mah (dumanlı Köyü)"
    ],
    "Şiran": [
      "Akbulak Yaylası Mah (akbulak Köyü)",
      "Aksaray Köyü",
      "Alacahan Köyü",
      "Alıç Köyü",
      "Araköy Köyü",
      "Ardıçlı Köyü",
      "Argu Mah (söğütalan Köyü)",
      "Arıtaş Köyü",
      "Aşağı Mah (sarıca Köyü)",
      "Aşağıduruçay Köyü",
      "Babacan Köyü",
      "Babuş Köyü",
      "Bağ Mah (seydibaba Köyü)",
      "Bahçeli Köyü",
      "Bahçeli Yaylası Mah (bahçeli Köyü)",
      "Balıkhisar Köyü",
      "Belen Köyü",
      "Bilgili Mah",
      "Boğazyayla Köyü",
      "Bolluk Köyü",
      "Çağıl Köyü",
      "Çakırkaya Köyü",
      "Çalköy Köyü",
      "Çambaşı Köyü",
      "Çamlıca Mah (başköy Köyü)",
      "Çanakçı Köyü",
      "Çanakçı Yaylası Mah (çanakçı Köyü)",
      "Çatmalar Köyü",
      "Çavlan Köyü",
      "Çevrepınar Köyü",
      "Çırdak Mah (seydibaba Köyü)",
      "Darıbükü Köyü",
      "Dilekyolu Köyü",
      "Dumanoluğu Köyü",
      "Eldiğin Köyü",
      "Elmaçukuru Köyü",
      "Ericek Köyü",
      "Evren Köyü",
      "Gökçeler Köyü",
      "Günbatur Köyü",
      "Günyüzü Köyü",
      "Güreşköy Köyü",
      "Hamdüt Yaylası Mah (akbulak Köyü)",
      "İncedere Köyü",
      "İnceören Mah (seydibaba Köyü)",
      "İnözü Köyü",
      "Kadıçayırı Köyü",
      "Kale Mah (seydibaba Köyü)",
      "Kanatlı Mah (seydibaba Köyü)",
      "Karaşeyh Köyü",
      "Karşı Mah (paşapınarı Köyü)",
      "Kavaklıdere Köyü",
      "Kavakpınarı Köyü",
      "Kaynakbaşı Köyü",
      "Kırıntı Köyü",
      "Kızılca Su Mah (kırıntı Köyü)",
      "Koyunbaba Köyü",
      "Kozağaç Köyü",
      "Merkez Mah (akbulak Köyü)",
      "Merkez Mah (akçalı Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (paşapınarı Köyü)",
      "Merkez Mah (sarıca Köyü)",
      "Merkez Mah (selimiye Köyü)",
      "Merkez Mah (seydibaba Köyü)",
      "Merkez Mah (söğütalan Köyü)",
      "Mumya Mah (akbulak Köyü)",
      "Orta Mah (paşapınarı Köyü)",
      "Ozanca Köyü",
      "Örenkale Mah",
      "Pelitli Köyü",
      "Sadıkköy Köyü",
      "Sarıtaş Mah (seydibaba Köyü)",
      "Sarıyer Mah (seydibaba Köyü)",
      "Seki  Mah (tomara Mah) (seydibaba Köyü)",
      "Sellidere Köyü",
      "Sinanlı Köyü",
      "Siteler Mah (selimiye Köyü)",
      "Susuz Köyü",
      "Telme Köyü",
      "Tepedam Köyü",
      "Toygar Mah (seydibaba Köyü)",
      "Ündüren Mah (başköy Köyü)",
      "Yedibölük Köyü",
      "Yeniköy Köyü",
      "Yeniköy Yaylası Mah (yeniköy Köyü)",
      "Yolbilen Köyü",
      "Yukarı Akçalı Mah (akçalı Köyü)",
      "Yukarıduruçay Köyü",
      "Yukarıkulaca Köyü",
      "Erenkaya Mah",
      "Fatih Mah",
      "Karaca Mah",
      "Mertekli Mah",
      "Şehit Hakan Mah",
      "Tekke Mah",
      "Akyayla Mah (yeşilbük Beldesi)",
      "Beydere Mah (yeşilbük Beldesi)",
      "Konaklı Mah (yeşilbük Beldesi)",
      "Yeşilkent Mah (yeşilbük Beldesi)",
      "Yeşilyurt Mah (yeşilbük Beldesi)"
    ],
    "Torul": [
      "Acekise Mh. (ilecik Köyü)",
      "Adisa Yaylası Mah (yıldız Köyü)",
      "Ahmatlı Mh. (budak Köyü)",
      "Aksüt Yaylası Mah (aksüt Köyü)",
      "Allan Mh. (güzeloluk Köyü)",
      "Alpullu Mah (uğurtaşı Köyü)",
      "Altıntaşlar Mah (kocadal Köyü)",
      "Altıntaşlar Mh. (kocadal Köyü)",
      "Altıokkalar Mah (bahçelik Köyü)",
      "Arılı Yaylası Mah (arılı Köyü)",
      "Armultu Ve Yuva Mh. (kirazlık Köyü)",
      "Aslanoğlu Mah (demirkapı Köyü)",
      "Aşağı Mh. (arılı Köyü)",
      "Aşağı Mh. (yurt Köyü)",
      "Atgüney Mah (demirkapı Köyü)",
      "Avcılar Mah (gülaçar Köyü)",
      "Ayazlı Mh. (ışık Köyü)",
      "Aydınlar Mah (atalar Köyü)",
      "Aydınlar Yayla Mah (atalar Köyü)",
      "Ayonos Mah (aksüt Köyü)",
      "B.yücebelen Mh. (yücebelen Köyü)",
      "Babacıklı Mah (bahçelik Köyü)",
      "Balcılar Mh. (gümüştuğ Köyü)",
      "Balcılar Mh.dere Mh.mevki (gümüştuğ Köyü)",
      "Balcılar Mh.kavraz Yaylası (gümüştuğ Köyü)",
      "Baş Güvemli Mah (güvemli Köyü)",
      "Baş Güvemli Yaylası Mah (güvemli Köyü)",
      "Baş Mh. (kirazlık Köyü)",
      "Baş Mh. Mah (mezra Mah) (kirazlık Köyü)",
      "Başaklı Mh. (kirazlık Köyü)",
      "Başaklı Mh.mezrası (kirazlık Köyü)",
      "Başpınar Mah (altınpınar Köyü)",
      "Bayır Mah (dedeli Köyü)",
      "Bayır Mh. (demirkapı Köyü)",
      "Bekiroğulları Mah (zigana Köyü)",
      "Binayde Deresi Mah (budak Köyü)",
      "Budak Yaylası Dağ Mevki Mah (budak Köyü)",
      "Budak Yaylası Mah (budak Köyü)",
      "Buleman Dere Mah (budak Köyü)",
      "Bülbüloğlu Mah (gülaçar Köyü)",
      "Büyük Yücebelen Mh. (yücebelen Köyü)",
      "Cami Mh. (budak Köyü)",
      "Cami Mh. (demirkapı Köyü)",
      "Cami Mh. (kirazlık Köyü)",
      "Cami Mh. (köstere Köyü)",
      "Cami Mh. (yeşilköy Köyü)",
      "Cami Mh. Mah (mezra Mah) (kirazlık Köyü)",
      "Çalışkanlar Mah (demirkapı Köyü)",
      "Çamdibi Mh. (yıldız Köyü)",
      "Çamdibi Yaylası Mah (yıldız Köyü)",
      "Çarşı Mh. (zigana Köyü)",
      "Çavuşali Mah (bahçelik Köyü)",
      "Çayırköy Mah (zigana Köyü)",
      "Çengelli Dere Mh. (cebeli Köyü)",
      "Çengelli Yukarı Mh. (cebeli Köyü)",
      "Çerçiler Mah (bahçelik Köyü)",
      "Çiçekli Mh. (cebeli Köyü)",
      "Çiçekli Yaylası Mah (cebeli Köyü)",
      "Çubuklu Mah (alöne Mah) Mh. (zigana Köyü)",
      "Çubuklu Mh. (zigana Köyü)",
      "Çukurlar Mh. (ışık Köyü)",
      "Darıdere Mh. (demirkapı Köyü)",
      "Davutlu Mah (bahçelik Köyü)",
      "Dedeli Merkez Mah (dedeli Köyü)",
      "Değirmen Taş Mah (atalar Köyü)",
      "Demirciler Mh. (yeşilköy Köyü)",
      "Dere Mh. (güvemli Köyü)",
      "Dere Mh. (köstere Köyü)",
      "Dere Mh. (yıldız Köyü)",
      "Dere Mh. (zigana Köyü)",
      "Dikmeler Mh Mah (budak Köyü)",
      "Dokuzgöze Mah (köstere Köyü)",
      "Dokuzgöze Yaylası Mah (köstere Köyü)",
      "Dörene Mh. (kocadal Köyü)",
      "Dugla Yaylası Orta Mh. (gümüştuğ Köyü)",
      "Durmuşlar Mh. (gülaçar Köyü)",
      "Düz Mh. (demirkapı Köyü)",
      "Elma Mh. (kocadal Köyü)",
      "Emirler Dere Mh. (büyükçit Köyü)",
      "Emirler Mh. (büyükçit Köyü)",
      "Emirler Mh. Mah (yayla Evleri Mah) (büyükçit Köyü)",
      "Emrük Mah (demirkapı Köyü)",
      "Erdemler Mh. (kocadal Köyü)",
      "Esentepe Mah (gülaçar Köyü)",
      "Esentepe Mah (herek Köyü)",
      "Eski Muhtarlar Mah (bahçelik Köyü)",
      "Eskiköy Mh. (güzeloluk Köyü)",
      "Falcılı Mah (budak Köyü)",
      "Fehmeler Mah (bahçelik Köyü)",
      "Gadohor Mh. (aksüt Köyü)",
      "Gambat Mh. (budak Köyü)",
      "Gardoba Mah (aksüt Köyü)",
      "Gelinkaya Mh. (harmancık Köyü)",
      "Gorofta Mah (köstere Köyü)",
      "Göğüs Mh. (güzeloluk Köyü)",
      "Gömleksiz Mh. (yeşilköy Köyü)",
      "Gözgören Mh. (demirkapı Köyü)",
      "Gran Yaylası Mah (güvemli Köyü)",
      "Gugule Mah (aşağıkaradere Köyü)",
      "Güllü Mah (herek Köyü)",
      "Güllü Mh. (kocadal Köyü)",
      "Güneşli Mah (altınpınar Köyü)",
      "Gürpınar Mah (altınpınar Köyü)",
      "Güvercinlik Mah (yalınkavak Köyü)",
      "Halilli Mh. (büyükçit Köyü)",
      "Harhara Mh. (demirkapı Köyü)",
      "Has Mh. (atalar Köyü)",
      "Hasan Ağa Mah (zigana Köyü)",
      "Havriya Mah (bahçelik Köyü)",
      "Hemdiler Mah (bahçelik Köyü)",
      "Hıtırıllez Mh. (demirkapı Köyü)",
      "Horobos Mh. (demirkapı Köyü)",
      "Işıklar Mh. (zigana Köyü)",
      "K.yücebelen Mh. (yücebelen Köyü)",
      "K.yücebelen Minarli Yay. Mah (yücebelen Köyü)",
      "K.yücebelen Şep Mezrası Mah (yücebelen Köyü)",
      "Kadirli Mah (kalecik Köyü)",
      "Kaflikaya Mah (demirkapı Köyü)",
      "Kalcı Mah (demirkapı Köyü)",
      "Kalemide Ve Maloba Mah (yücebelen Köyü)",
      "Kambos Mah (köstere Köyü)",
      "Kapaklı Yakuplar Mah (bahçelik Köyü)",
      "Karaca Mh. (cebeli Köyü)",
      "Karel Mh. (harmancık Köyü)",
      "Karşıyaka Mah (dedeli Köyü)",
      "Karşıyaka Mah (inkılap Köyü)",
      "Kayadibi Mh. (demirkapı Köyü)",
      "Kaycılar Yaylası Mah (güvemli Köyü)",
      "Keklik Mah (yalınkavak Köyü)",
      "Kılan Mh. (demirkapı Köyü)",
      "Kılıçkaya Mah (yurt Köyü)",
      "Kirazlı Mh. (güvemli Köyü)",
      "Koçaklar Mh. (cebeli Köyü)",
      "Koçlar Mh. (zigana Köyü)",
      "Komlar Mah (aksüt Köyü)",
      "Konak Mah (dedeli Köyü)",
      "Konak Mah (kalecik Köyü)",
      "Konani Mezrası Mah (yücebelen Köyü)",
      "Konen Mah (köstere Köyü)",
      "Kozluca Mh. (demirkapı Köyü)",
      "Köhren Mah (budak Köyü)",
      "Köklü Mah (gülaçar Köyü)",
      "Köyceğiz Mh. (güzeloluk Köyü)",
      "Kran Mh. (aksüt Köyü)",
      "Kurtdüzü Mah (demirkapı Köyü)",
      "Kuşlu Mh. (demirkapı Köyü)",
      "Küçükdere Mah (bahçelik Köyü)",
      "Küpcüler Mh. (cebeli Köyü)",
      "Kürtlü Mh. (güzeloluk Köyü)",
      "Lahlu Mh Mah (budak Köyü)",
      "Lameder Mah (zigana Köyü)",
      "Lehordu Mezrası Mah (yücebelen Köyü)",
      "Maden Mh. (zigana Köyü)",
      "Manastır Mah (budak Köyü)",
      "Manat Mah (gülaçar Köyü)",
      "Mandişka Mah (aksüt Köyü)",
      "Maraş Mah (bahçelik Köyü)",
      "Mazmanlı Mh. (ışık Köyü)",
      "Mehmetli Mah (kalecik Köyü)",
      "Merekler Mah (alınyayla Köyü)",
      "Merkez Alas Mah (atalar Köyü)",
      "Merkez Mah (alınyayla Köyü)",
      "Merkez Mah (arpalı Köyü)",
      "Merkez Mah (büyükçit Köyü)",
      "Merkez Mah (dağdibi Köyü)",
      "Merkez Mah (gümüştuğ Köyü)",
      "Merkez Mah (günay Köyü)",
      "Merkez Mah (harmancık Köyü)",
      "Merkez Mah (ilecik Köyü)",
      "Merkez Mah (inkılap Köyü)",
      "Merkez Mah (kirazlık Köyü)",
      "Merkez Mah (kopuz Köyü)",
      "Merkez Mah (küçükçit Köyü)",
      "Merkez Mah (tokçam Köyü)",
      "Merkez Mah (uğurtaşı Köyü)",
      "Merkez Mh. (atalar Köyü)",
      "Merkez Mh. (cebeli Köyü)",
      "Merkez Mh. (güzeloluk Köyü)",
      "Merkez Mh. (ışık Köyü)",
      "Merkez Mh. (yalınkavak Köyü)",
      "Merkez Mh.2 (atalar Köyü)",
      "Mesmele- Yunuzlu Mah (budak Köyü)",
      "Meyramana Mh. (güvemli Köyü)",
      "Meyremana Mh. (cebeli Köyü)",
      "Mezire Mh. (bahçelik Köyü)",
      "Mezra Mah (arpalı Köyü)",
      "Mezra Mah (kirazlık Köyü)",
      "Mezre Mh. (güvemli Köyü)",
      "Molla Mh. (aksüt Köyü)",
      "Mollalar Mah (bahçelik Köyü)",
      "Moloska Mezrası Mah (yücebelen Köyü)",
      "Mösiye Ve Kurtharmanı Mah (kirazlık Köyü)",
      "Musalar-haytalar Mah (bahçelik Köyü)",
      "Muslu Mah (bahçelik Köyü)",
      "Mustafa Mereği Mh. (demirkapı Köyü)",
      "Nohutlu Mah (altınpınar Köyü)",
      "Ocaklı Mh. (kocadal Köyü)",
      "Orta Mh. (büyükçit Köyü)",
      "Orta Mh. (gümüştuğ Köyü)",
      "Orta Mh. (yurt Köyü)",
      "Ortova Mah (kopuz Köyü)",
      "Otalan Mh. (güzeloluk Köyü)",
      "Özlüce Mh. (atalar Köyü)",
      "Pasova Mah (güvemli Köyü)",
      "Ramadanlı Mh. (gülaçar Köyü)",
      "Rebiyeler Mah (bahçelik Köyü)",
      "Sahatlı Mh. (alınyayla Köyü)",
      "Sarı Osman Mah (budak Köyü)",
      "Sarıç Mah (aşağıkaradere Köyü)",
      "Selen Mah (zigana Köyü)",
      "Sofular Mah (zigana Köyü)",
      "Söğütözü Mah (herek Köyü)",
      "Şena Mah (küçükçit Köyü)",
      "Şep Mezrası Mah (yücebelen Köyü)",
      "Şimonoy Mah (dedeli Köyü)",
      "Temeller Mah (bahçelik Köyü)",
      "Tokçam Mah (tokçam Köyü)",
      "Topcular Mah (zigana Köyü)",
      "Toroman Mah (bahçelik Köyü)",
      "Udali Mah (budak Köyü)",
      "Usluca Mah (tokçam Köyü)",
      "Usluca Yaylası Mah (tokçam Köyü)",
      "Yalınkavak Yaylası Mah (yalınkavak Köyü)",
      "Yaycılı Mah (demirkapı Köyü)",
      "Yayıkcılar Mezere Mevki Mah (gümüştuğ Köyü)",
      "Yayıkcılar Mh. (gümüştuğ Köyü)",
      "Yayıkcılar Mh.yaylası (gümüştuğ Köyü)",
      "Yayla  Evleri Mah (arpalı Köyü)",
      "Yayla  Evleri Mah (küçükçit Köyü)",
      "Yayla Evleri Mah (büyükçit Köyü)",
      "Yayla Evleri Mah (kirazlık Köyü)",
      "Yayla Evleri Mah (küçükçit Köyü)",
      "Yede Mah (inkılap Köyü)",
      "Yılanlı Yaylası Mah (gümüştuğ Köyü)",
      "Yukarı Mh. (arılı Köyü)",
      "Yukarı Mh. (yıldız Köyü)",
      "Yukarı Mh. (yurt Köyü)",
      "Yusuflar Mah (zigana Köyü)",
      "Yuva Mh. (kirazlık Köyü)",
      "Zabuk Mh. (demirkapı Köyü)",
      "Zevre Mah (herek Köyü)",
      "Zigana Dağı Yaylası Mah (zigana Köyü)",
      "Zivildi Mh. (demirkapı Köyü)",
      "Zuysa Mah (herek Köyü)",
      "Bahçecik Mah",
      "Çamlıca Mah",
      "Kaledibi Mah",
      "Köprübaşı Mah",
      "Merkez Mah",
      "Soğuksu Mah",
      "Tufaniye Mah",
      "Tuğrulbey Mah"
    ]
  },
  "Hakkari": {
    "Çukurca": [
      "Aşağı Akkaya Köyü",
      "Çığlı Köyü",
      "Sariyer Mah (akkaya Köyü)",
      "Yukarıakkaya Mah (akkaya Köyü)",
      "Cumhuriyet Mah",
      "Emirşaban Mah",
      "Yeşil Çeşme Mah",
      "Cevizli Köyü",
      "Çeltik Mah (kayalık Köyü)",
      "Çimenli Mah (gündeş Köyü)",
      "Guzeldere Mah (gündeş Köyü)",
      "Gündeş Köyü",
      "Kayalık Köyü",
      "Kaynak Mah (kayalık Köyü)",
      "Kazan Köyü",
      "Köprülü Mah (gündeş Köyü)",
      "Meşeli Mah (kayalık Köyü)",
      "Narlı Köyü",
      "Ormanlı Mah (gündeş Köyü)",
      "Üzümlü Köyü"
    ],
    "Derecik": [
      "Balkaya Mah",
      "Güney Mah",
      "Gürmeşe Mah",
      "Hacıbey Mah",
      "Merkez Mah",
      "Orta Mah",
      "Rize Mah",
      "Üçyan Mah",
      "Vapurtepe Mah",
      "Akören Mah (uslu Köyü)",
      "Aralık Mah (gelişen Köyü)",
      "Beşikağaç Mah (anadağ Köyü)",
      "Bölek Mah (anadağ Köyü)",
      "Gelişen Köyü",
      "Gökçetaş Mah (anadağ Köyü)",
      "Karakoç Mah (gelişen Köyü)",
      "Koryürek Mah (gelişen Köyü)",
      "Kütüklü Mah (gelişen Köyü)",
      "Mordağ Mah (gelişen Köyü)",
      "Ortaklar Köyü",
      "Örencik Mah (ortaklar Köyü)",
      "Serhatkale Mah (gelişen Köyü)",
      "Su Çıktı Mah (gelişen Köyü)",
      "Taşlıçay Mah (uslu Köyü)",
      "Toklu Mah (gelişen Köyü)",
      "Ulaşan Mah (uslu Köyü)",
      "Uslu Köyü",
      "Yeşilova Mah (anadağ Köyü)"
    ],
    "Merkez": [
      "Bağlarbaşı Mah (durankaya Beldesi)",
      "Biçenek Mah (durankaya Beldesi)",
      "Cumhuriyet Mah (durankaya Beldesi)",
      "Çaylıca Mah (durankaya Beldesi)",
      "Köyiçi Mah (durankaya Beldesi)",
      "Pınarbaşı Mah (durankaya Beldesi)",
      "Yeni Mah (durankaya Beldesi)",
      "Bağlar Mah",
      "Berçelan Mah",
      "Biçer Mah",
      "Bulak Mah",
      "Dağgöl Mah",
      "Gazi Mah",
      "Halife Derviş Mah",
      "Karşıyaka Mah",
      "Keklikpınar Mah",
      "Kıran Mah",
      "Medrese Mah",
      "Merzan Mah",
      "Pehlivan Mah",
      "Sümbül Mah",
      "Yeni Mah",
      "1.harput Mah (aşağı Derecik Köyü)",
      "2.harput Mah (aşağı Derecik Köyü)",
      "Ağaçdibi Köyü",
      "Ağaçsız Mah (oğul Köyü)",
      "Akbulut Köyü",
      "Akçalı Köyü",
      "Akkuş Köyü",
      "Aksu Köyü",
      "Armutlu Mezrası Mah (kavaklı Köyü)",
      "Aşağı Derecik Köyü",
      "Aşağı Kayacık Mah (bağışlı Köyü)",
      "Aşağı Otluca Mah (otluca Köyü)",
      "Aşağıkırbaşı Mah (kırıkdağ Köyü)",
      "Ayranlı Mah (pınarca Köyü)",
      "Bağışlı Köyü",
      "Bağlar Mah (doğanyurt Köyü)",
      "Bahçeli Mah (geçimli Köyü)",
      "Bahi Mah (ağaçdibi Köyü)",
      "Bayköy Köyü",
      "Boğazlı Mah (doğanyurt Köyü)",
      "Boybeyi Köyü",
      "Budaklı Mah (bağışlı Köyü)",
      "Cevizdibi Köyü",
      "Ceylanlı Köyü",
      "Çaltıkoru Köyü",
      "Çanaklı Köyü",
      "Çavuşlu Mah (ışıklar Köyü)",
      "Çeltik Mezrası Mah (kavaklı Köyü)",
      "Çetintaş Mah (akkuş Köyü)",
      "Çimenli Köyü",
      "Dağ Komando Tugayı Mah (otluca Köyü)",
      "Demirlimez Mah (akbulut Köyü)",
      "Demirtaş Köyü",
      "Dereboyu Mah (otluca Köyü)",
      "Deren Mah (üzümcü Köyü)",
      "Dereşaban Mah (kırıkdağ Köyü)",
      "Dereüstü Mah (üzümcü Köyü)",
      "Dez Mah (aşağı Derecik Köyü)",
      "Dikilitaş Mah (boybeyi Köyü)",
      "Dikmen Mah (aşağı Derecik Köyü)",
      "Dilek Mah (oğul Köyü)",
      "Doğanlı Mah (ceylanlı Köyü)",
      "Doğanyurt Köyü",
      "Eğercik Mah (akçalı Köyü)",
      "Elmacık Köyü",
      "Eski Ördekli Mah (ördekli Köyü)",
      "Geçitli Köyü",
      "Gelinli Mah (ceylanlı Köyü)",
      "Gipe Mah (ceylanlı Köyü)",
      "Göze Mah (oğul Köyü)",
      "Güzel Mah (otluca Köyü)",
      "Hendek Mah (pınarca Köyü)",
      "Ilıca Mah (oğul Köyü)",
      "Işık Köyü",
      "Işıklar Köyü",
      "İncir Mah (geçimli Köyü)",
      "Kanatlı Mah (akçalı Köyü)",
      "Kavaklı Köyü",
      "Kavalköy Köyü",
      "Kaymaklı Köyü",
      "Kırıkdağ Köyü",
      "Koçlu Mah (kaymaklı Köyü)",
      "Köprücük Mah (otluca Köyü)",
      "Köyceyiz Mah (kamışlı Köyü)",
      "Küçükköşk Mah (ışıklar Köyü)",
      "Kürüm Mah (sarıtaş Köyü)",
      "Merkez Mah (kamışlı Köyü)",
      "Musahan Mah (bağışlı Köyü)",
      "Musahan Mah (sarıtaş Köyü)",
      "Oğulcul Mah (bağışlı Köyü)",
      "Oğurlu Mah (pınarca Köyü)",
      "Olgunlar Köyü",
      "Oluklu Mah (demirtaş Köyü)",
      "Otlubel Mah (otluca Köyü)",
      "Otluca Dağ Komando Togayı Mah (otluca Köyü)",
      "Öğrencik Mah (demirtaş Köyü)",
      "Pınarca Köyü",
      "Rez Mah (kırıkdağ Köyü)",
      "Sarıgül Mah (pınarca Köyü)",
      "Sarıkaya Mah (otluca Köyü)",
      "Sarıtaş Bağlısı Mah (sarıtaş Köyü)",
      "Seranüs Mah (aşağı Derecik Köyü)",
      "Stoka Mah (olgunlar Köyü)",
      "Su Ocağı Mah (doğanyurt Köyü)",
      "Sulak Mah (aşağı Derecik Köyü)",
      "Sütçüler Mah (ceylanlı Köyü)",
      "Sütlüce Mah (kaymaklı Köyü)",
      "Taşbaşı Köyü",
      "Taşlıca Işık Mah (pınarca Köyü)",
      "Tepecik Mah (ışık Köyü)",
      "Trafik Mah (aşağı Derecik Köyü)",
      "Tümsek Mah (otluca Köyü)",
      "Uyanık Mah (otluca Köyü)",
      "Üzümcü Köyü",
      "Yağmurlu Mah (demirtaş Köyü)",
      "Yapraklı Mah (ışık Köyü)",
      "Yeni Mah (kırıkdağ Köyü)",
      "Yeni Mah (olgunlar Köyü)",
      "Yeni Mah (ördekli Köyü)",
      "Yeni Oğul Mah (oğul Köyü)",
      "Yeniyol Mah (akçalı Köyü)",
      "Yeniyol Mah (pınarca Köyü)",
      "Yeşilbulak Mah (boybeyi Köyü)",
      "Yığınlı Mah (ceylanlı Köyü)",
      "Yoncalı Köyü",
      "Yukarı Çaltıkoru Mah (çaltıkoru Köyü)",
      "Yukarı Derecik Mah (aşağı Derecik Köyü)",
      "Yukarı Dereli Mah (olgunlar Köyü)",
      "Yukarı Kayacık Mah (bağışlı Köyü)",
      "Yukarı Otluca Mah (otluca Köyü)",
      "Yumrukaya Mah (akbulut Köyü)",
      "Zavite Mah (konak Köyü)",
      "Zavite Mezrası Mah (konak Köyü)"
    ],
    "Şemdinli": [
      "Akbal Mah (korgan Köyü)",
      "Akkavak Mah (korgan Köyü)",
      "Aktütün Mah (konur Köyü)",
      "Alan Köyü",
      "Alkava Mah (korgan Köyü)",
      "Aşağı Kayacık Mah (boğazköy Köyü)",
      "Aşağı Korgan Mah (korgan Köyü)",
      "Aşağı Tuğlu Mah (yufkalı Köyü)",
      "Bağlar Köyü",
      "Balıklı Mah (tekeli Köyü)",
      "Balova Mah (korgan Köyü)",
      "Beytera Mah (bağlar Köyü)",
      "Beyyurdu Köyü",
      "Binahere Mah (yufkalı Köyü)",
      "Bozyamaç Köyü",
      "Çalışkanlar Mah (çalışkanlar Köyü)",
      "Çamlıca Mah (bağlar Köyü)",
      "Çatalca Köyü",
      "Çem Mah (bağlar Köyü)",
      "Çem Mah (boğazköy Köyü)",
      "Çevre Mah (korgan Köyü)",
      "Çubuklu Köyü",
      "Deravi Mah (bozyamaç Köyü)",
      "Dereboyu Mah (altınsu Köyü)",
      "Dereyanı Mah (konur Köyü)",
      "Dinarte Mah (çubuklu Köyü)",
      "Durak Mah (korgan Köyü)",
      "Elde Mah (altınsu Köyü)",
      "Elmalı Mah (yufkalı Köyü)",
      "Erdemli Mah (çatalca Köyü)",
      "Erikli Mah (kayalar Köyü)",
      "Güleç Mah (tütünlü Köyü)",
      "Günyazı Köyü",
      "Güvenli Mah (çatalca Köyü)",
      "Güzelkaya Mah (bağlar Köyü)",
      "Güzelkonak Mah (korgan Köyü)",
      "Harmanlı Mah (öveç Köyü)",
      "Hazne Mah (çalışkanlar Köyü)",
      "Husrova Mah (kayalar Köyü)",
      "İncesu Mah (altınsu Köyü)",
      "Karaağaç Mah (öveç Köyü)",
      "Kayalar Köyü",
      "Kepenek Mah (çalışkanlar Köyü)",
      "Koçbaşı Mah (çalışkanlar Köyü)",
      "Kolita Mah (çubuklu Köyü)",
      "Konur Köyü",
      "Korgan Köyü",
      "Kula Mah (yufkalı Köyü)",
      "Kule Mah (kayalar Köyü)",
      "Mağaraönü Mah (kayalar Köyü)",
      "Merkez Mah (altınsu Köyü)",
      "Meşeli Mah (bağlar Köyü)",
      "Meydan Mah (altınsu Köyü)",
      "Muşi Mah (bağlar Köyü)",
      "Oğlaklı Mah (tekeli Köyü)",
      "Olgunlar Mah (günyazı Köyü)",
      "Öveç Köyü",
      "Rüzgarlı Mah (bağlar Köyü)",
      "Samanlı Mah (çalışkanlar Köyü)",
      "Sarıca Mah (kayalar Köyü)",
      "Seçkin Mah (kayalar Köyü)",
      "Soğuksu Mah (çatalca Köyü)",
      "Tanyolu Mah (tekeli Köyü)",
      "Tatlıca Mah (korgan Köyü)",
      "Tekeli Köyü",
      "Tuğlu Mah (yufkalı Köyü)",
      "Tuva Mah (bağlar Köyü)",
      "Türe Mah (bağlar Köyü)",
      "Tütünlü Köyü",
      "Uğuraçan Köyü",
      "Üçgöze Mah (çalışkanlar Köyü)",
      "Üstünağaç Mah (tekeli Köyü)",
      "Üzümkıran Kampı Mah (korgan Köyü)",
      "Veliköy Mah (çalışkanlar Köyü)",
      "Yaylapınar Köyü",
      "Yeniceli Mah (günyazı Köyü)",
      "Yeşilbayır Mah (uğuraçan Köyü)",
      "Yeşilöz Mah (çalışkanlar Köyü)",
      "Yiğitler Mah (günyazı Köyü)",
      "Yufkalı Köyü",
      "Yukarı Kayacık Mah (boğazköy Köyü)",
      "Yukarı Kayalar Mah (kayalar Köyü)",
      "Yukarı Korgan Mah (korgan Köyü)",
      "Zorgeçit Mah (bağlar Köyü)",
      "Beşevler Mah",
      "Karşıyaka Mah",
      "Moda Mah",
      "Yayla Mah",
      "Yeni Mah"
    ],
    "Yüksekova": [
      "Kerem Zeydan Mah (büyükçiftlik Beldesi)",
      "Merkez Mah (büyükçiftlik Beldesi)",
      "Yeşilova Mah (büyükçiftlik Beldesi)",
      "Akpınar Köyü",
      "Altınbaşak Mah (akpınar Köyü)",
      "Beşevler Mah (akpınar Köyü)",
      "Dereiçi  Mah (birdik Mah) (akpınar Köyü)",
      "Duranlar Mah (akpınar Köyü)",
      "Güldalı Köyü",
      "Güvenli Mah (esendere Beldesi)",
      "Merkez Mah (esendere Beldesi)",
      "Ovaiçi Mah (akpınar Köyü)",
      "Sarıyıldız Mah (esendere Beldesi)",
      "Yılmaz Mah (esendere Beldesi)",
      "A.güveç Mah (kısıklı Köyü)",
      "A.olukbaşı Mah (akocak Köyü)",
      "A.ölçek Mah (değerli Köyü)",
      "Adaklı Köyü",
      "Ağaçlık Mah (onbaşılar Köyü)",
      "Ağılcık Mah (onbaşılar Köyü)",
      "Akalın Köyü",
      "Akar Mah (dağlıca Köyü)",
      "Akçalı Köyü",
      "Akocak Köyü",
      "Aksu Köyü",
      "Aktoprak Mah (armutdüzü Köyü)",
      "Alacık Mah (yeniışık Köyü)",
      "Altınoluk Köyü",
      "Armutdüzü Köyü",
      "Armutlu Mah (onbaşılar Köyü)",
      "Arpalı Mah (armutdüzü Köyü)",
      "Aşağıuluyol Köyü",
      "Bağdaş Köyü",
      "Basamak Mah (yeniışık Köyü)",
      "Bataklık Köyü",
      "Beşatlı Köyü",
      "Beşbulak Köyü",
      "Beşpınar Mah (karlı Köyü)",
      "Bostancık Köyü",
      "Bölük Köyü",
      "Bulaklı Köyü",
      "Bulgurlu Mah (güllüce Köyü)",
      "Cevizlik Mah (gürkavak Köyü)",
      "Çakırkaya Mah (beşatlı Köyü)",
      "Çakmak Mah (beşatlı Köyü)",
      "Çalımlı Mah (dilektaşı Köyü)",
      "Çamdalı Mah (onbaşılar Köyü)",
      "Çatalkaya Mah (bölük Köyü)",
      "Çatma Köyü",
      "Çayır Mah (tuğlu Köyü)",
      "Çevreli Mah (yoncalık Köyü)",
      "Çiçeközü Mah (karlı Köyü)",
      "Çimenli Mah (karlı Köyü)",
      "Çobanpınar Mah (onbaşılar Köyü)",
      "Çukurca Köyü",
      "Daglıca Mah (dağlıca Köyü)",
      "Dağdibi Mah (köşkönü Köyü)",
      "Dalice Mah (dibekli Köyü)",
      "Damlacık Mah (armutdüzü Köyü)",
      "Dedeler Köyü",
      "Değerli Köyü",
      "Demirkonak Köyü",
      "Dereiçi Mah (dilektaşı Köyü)",
      "Dereiçi Mah (onbaşılar Köyü)",
      "Dibekli Köyü",
      "Dilekli Köyü",
      "Dilektaşı Köyü",
      "Dilimli Mah (bölük Köyü)",
      "Dişli Mah (değerli Köyü)",
      "Doğanlı Köyü",
      "Duraklı Mah (demirkonak Köyü)",
      "Duraklı Mah (güçlü Köyü)",
      "Erbaş Mah (köşkönü Köyü)",
      "Ericik Mah (bağdaş Köyü)",
      "Gedikli Mah (bağdaş Köyü)",
      "Gove Mah (gürkavak Köyü)",
      "Gökyurt Köyü",
      "Güçlü Köyü",
      "Güllüce Köyü",
      "Gümüşlü Mah (ortaç Köyü)",
      "Gürdere Köyü",
      "Gürkaynak Mah (salkımlı Köyü)",
      "İkizler Mah (gürkavak Köyü)",
      "İnanlı Köyü",
      "İnceyol Mah (pınargözü Köyü)",
      "İncirlik Mah (dağlıca Köyü)",
      "Kadıköy Köyü",
      "Kalemli Mah (kadıköy Köyü)",
      "Kamışlı Köyü",
      "Kapılı Mah (ortaç Köyü)",
      "Karabağ Mah (karlı Köyü)",
      "Karabey Köyü",
      "Karataş Mah (tuğlu Köyü)",
      "Kargılı Mah (ortaç Köyü)",
      "Karlı Köyü",
      "Kayakonak Mah (bağdaş Köyü)",
      "Kazan Köyü",
      "Keçili Köyü",
      "Kısıklı Köyü",
      "Kışlacık Mah (pınargözü Köyü)",
      "Kilimli Mah (karlı Köyü)",
      "Kolbaşı Köyü",
      "Konak Mah (ortaç Köyü)",
      "Kornak Mah (armutdüzü Köyü)",
      "Köprübaşı Mah (salkımlı Köyü)",
      "Köprücek Köyü",
      "Köşk Mah (akocak Köyü)",
      "Köşkönü Köyü",
      "Köycük Mah (değerli Köyü)",
      "Kurucak Mah (köşkönü Köyü)",
      "Mamak Mah (kadıköy Köyü)",
      "Mezra Mah (yeniışık Köyü)",
      "Miranava Mah (serindere Köyü)",
      "Odabaşı Mah (dibekli Köyü)",
      "Onbaşılar Köyü",
      "Ormanarası Mah (kolbaşı Köyü)",
      "Ortaç Köyü",
      "Örnekköy Köyü",
      "Pınargözü Köyü",
      "Pirbılan Mah (kısıklı Köyü)",
      "Pirinceyin Mah (ortaç Köyü)",
      "Reşadiye Mah (salkımlı Köyü)",
      "Salkımlı Köyü",
      "Sarıtaş Köyü",
      "Serindere Köyü",
      "Sualtı Mah (kısıklı Köyü)",
      "Suüstü Köyü",
      "Sülük Mah (akocak Köyü)",
      "Sürekli Köyü",
      "Şahince Mah (armutdüzü Köyü)",
      "Şimte Mah (salkımlı Köyü)",
      "Tarlacık Mah (sürekli Köyü)",
      "Taşyazı Mah (sürekli Köyü)",
      "Tatlı Köyü",
      "Tatlıcak Mah (bağdaş Köyü)",
      "Tepebaşı Mah (armutdüzü Köyü)",
      "Tokağaç Mah (gürkavak Köyü)",
      "Tuğlu Köyü",
      "Vezirli Köyü",
      "Y.güveç Mah (serindere Köyü)",
      "Y.ölçek Mah (değerli Köyü)",
      "Y.uluyol Mah (aşağıuluyol Köyü)",
      "Yazılı Mah (yazılı Köyü)",
      "Yemişli Mah (sarıtaş Köyü)",
      "Yeniışık Köyü",
      "Yeniköy Mah (aşağıuluyol Köyü)",
      "Yeşilce Mah (pınargözü Köyü)",
      "Yeşildere Mah (gökyurt Köyü)",
      "Yeşildere Mah (gürkavak Köyü)",
      "Yeşiltaş Köyü",
      "Yoncalık Köyü",
      "Yukarı Ulukbaşı Mah (yeniışık Köyü)",
      "Yumrutaş Mah (demirkonak Köyü)",
      "Yuvalı Mah (armutdüzü Köyü)",
      "Yürekli Köyü",
      "Cumhuriyet Mah",
      "Dize Mah",
      "Esen Yurt Mah",
      "Esentepe Mah",
      "Eski Kışla Mah",
      "Güngör Mah",
      "İpek Mah",
      "Mezarlık Mah",
      "Yeni Mah",
      "Yeşildere Mah"
    ]
  },
  "Hatay": {
    "Altınözü": [
      "Akamber Mah",
      "Akdarı Mah",
      "Alakent Mah",
      "Altınkaya Mah",
      "Atayurdu Mah",
      "Avuttepe Mah",
      "Babatorun Mah",
      "Boynuyoğun Mah",
      "Büyükburç Mah",
      "Çetenli Mah",
      "Dokuzdal Mah",
      "Enek Mah",
      "Erbaşı Mah",
      "Fatikli Mah",
      "Gözecik Mah",
      "Günvuran Mah",
      "Hacıpaşa Mah",
      "Hanyolu Mah",
      "Kamberli Mah",
      "Kansu Mah",
      "Karbeyaz Mah",
      "Karsu Mah",
      "Kazancık Mah",
      "Keskincik Mah",
      "Kılıçtutan Mah",
      "Kıyıgören Mah",
      "Kolcular Mah",
      "Kozkalesi Mah",
      "Kurtmezraası Mah",
      "Mayadalı Mah",
      "Oymaklı Mah",
      "Sarıbük Mah",
      "Sarılar Mah",
      "Seferli Mah",
      "Sivrikavak Mah",
      "Sofular Mah",
      "Tepehan Mah",
      "Tokaçlı Mah",
      "Tokdemir Mah",
      "Toprakhisar Mah",
      "Türkmenmezraası Mah",
      "Yanıkpınar Mah",
      "Yarseli Mah",
      "Yenihisar Mah",
      "Yenişehir Mah",
      "Yolağzı Mah",
      "Yunushanı Mah",
      "Ziyaret Mah"
    ],
    "Antakya": [
      "Altınçay Mah",
      "Cumhuriyet Mah",
      "Emek Mah",
      "Esenlik Mah",
      "Esentepe Mah",
      "Gazi Mah",
      "Açıkdere Mah",
      "Akcurun Mah",
      "Akçaova Mah",
      "Akhisar Mah",
      "Alaattin Mah",
      "Alahan Mah",
      "Alazı Mah",
      "Anayazı Mah",
      "Apaydın Mah",
      "Arpahan Mah",
      "Aşağıoba Mah",
      "Avsuyu Mah",
      "Aydınlıkevler Mah",
      "Barbaros Mah",
      "Biniciler Mah",
      "Bitiren Mah",
      "Bohşin Mah",
      "Bozhöyük Mah",
      "Büyükdalyan Mah",
      "Demirköprü Mah",
      "Derince Mah",
      "Dikmece Mah",
      "Doğanköy Mah",
      "Dutdibi Mah",
      "Gökçegöz Mah",
      "Gülderen Mah",
      "Günyazı Mah",
      "Güzelburç Mah",
      "Habib-i Neccar Mah",
      "Hacı Ömer Alpagot Mah",
      "Haraparası Mah",
      "Hasanlı Mah",
      "İplik Pazarı Mah",
      "Kantara Mah",
      "Karaali Bölüğü Mah",
      "Karaali Mah",
      "Kardeşler Mah",
      "Karlısu Mah",
      "Kisecik Mah",
      "Kocaabdi Mah",
      "Kuruyer Mah",
      "Küçükdalyan Mah",
      "Madenboyu Mah",
      "Mansurlu Mah",
      "Maraşboğazı Mah",
      "Maşuklu Mah",
      "Melekli Mah",
      "Meydan Mah",
      "Narlıca Mah",
      "Oğlakören Mah",
      "Orhanlı Mah",
      "Ovakent Mah",
      "Paşaköy Mah",
      "Saçaklı Mah",
      "Saraycık Mah",
      "Serinyol Mah",
      "Sofular Mah",
      "Suvatlı Mah",
      "Şehitler Mah",
      "Şeyhali Mah",
      "Şirince Mah",
      "Tahtaköprü Mah",
      "Tanışma Mah",
      "Ulucamii Mah",
      "Uzunaliç Mah",
      "Üçgedik Mah",
      "Üzümdalı Mah",
      "Yaylacık Mah",
      "Yeni Camii Mah",
      "Yeşilova Mah",
      "Zülüflühan Mah",
      "Akasya Mah",
      "Akevler Mah",
      "Aksaray Mah",
      "Cebrail Mah",
      "Ekinci Mah",
      "General Şükrü Kanatlı Mah",
      "Kuzeytepe Mah",
      "Odabaşı Mah",
      "Saraykent Mah",
      "Ürgen Paşa Mah",
      "Bağrıyanık Mah",
      "Fevzi Çakmak Mah",
      "Gazi Paşa Mah",
      "Güllü Bahçe Mah",
      "Havuzlar Mah",
      "Kışla Saray Mah",
      "Kuyulu Mah",
      "Zenginler Mah"
    ],
    "Arsuz": [
      "Akçalı Mah",
      "Arpaçiftlik Mah",
      "Arpagedik Mah",
      "Aşağı Kepirce Mah",
      "Avcılarsuyu Mah",
      "Beyköyü Mah",
      "Çetillik Mah",
      "Derekuyu Mah",
      "Gökmeydan Mah",
      "Gözcüler Mah",
      "Gülcihan Mah",
      "Hacıahmetli Mah",
      "Haymaseki Mah",
      "Helvalı Mah",
      "Hüyük Mah",
      "Işıklı Mah",
      "Kale Mah",
      "Karagöz Mah",
      "Konacık Mah",
      "Kurtbağı Mah",
      "Madenli Mah",
      "Pirinçlik Mah",
      "Tatarlı Mah",
      "Tülek Mah",
      "Uluçınar Mah",
      "Üçgüllük Mah",
      "Yukarıkepirce Mah",
      "Arpaderesi Mah",
      "Harlısu Mah",
      "Karaağaç Cumhuriyet Mah",
      "Karaağaç Konarlı Mah",
      "Karaağaç Övündük Mah",
      "Karaağaç Şarkonak Mah",
      "Karahüseyinli Mah",
      "Kışla Mah",
      "Kozaklı Mah",
      "Nardüzü Mah",
      "Nergizlik Mah"
    ],
    "Belen": [
      "Atik Mah",
      "Bakras Mah",
      "Benlidere Mah",
      "Cumhuriyet Mah",
      "Çakallı Mah",
      "Çerçikaya Mah",
      "Derebahçe Mah",
      "Fatih Mah",
      "Halilbey Mah",
      "İssume Mah",
      "Kıcı Mah",
      "Kömürçukuru Mah",
      "Muhlisali Mah",
      "Müftüler Mah",
      "Ötençay Mah",
      "Sarımazı Mah",
      "Soğukoluk Mah",
      "Şekere Mah",
      "Şenbük Mah"
    ],
    "Defne": [
      "Akdeniz Mah",
      "Aknehir Mah",
      "Armutlu Mah",
      "Aşağıokçular Mah",
      "Bahçeköy Mah",
      "Balıklıdere Mah",
      "Ballıöz Mah",
      "Bostancık Mah",
      "Büyükçat Mah",
      "Çardaklı Mah",
      "Çekmece Mah",
      "Çınarlı Mah",
      "Çökek Mah",
      "Değirmenyolu Mah",
      "Döver Mah",
      "Dursunlu Mah",
      "Elektrik Mah",
      "Gümüşgöze Mah",
      "Güneysöğüt Mah",
      "Hancağız Mah",
      "Harbiye Mah",
      "Hüseyinli Mah",
      "Karşıyaka Mah",
      "Koçören Mah",
      "Meydancık Mah",
      "Orhanlı Mah",
      "Özbek Mah",
      "Samankaya Mah",
      "Sinanlı Mah",
      "Subaşı Mah",
      "Sümerler Mah",
      "Tavla Mah",
      "Toygarlı Mah",
      "Turunçlu Mah",
      "Üzengili Mah",
      "Yeniçağ Mah",
      "Yeşilpınar Mah"
    ],
    "Dörtyol": [
      "Altınçağ Mah",
      "Çatköy Mah",
      "Çaylı Mah",
      "Kapılı Mah",
      "Karakese Mah",
      "Kışlalar Mah",
      "Konaklı Mah",
      "Kuzuculu Mah",
      "Numune Evler Mah",
      "Ocaklı Mah",
      "Özerli Mah",
      "Sanayi Mah",
      "Yeniyurt Mah",
      "Yeşil Mah",
      "Yeşilköy Mah"
    ],
    "Erzin": [
      "Aşağıburnaz Mah",
      "Bahçelievler Mah",
      "Başlamış Mah",
      "Cumhuriyet Mah",
      "Gökdere Mah",
      "Gökgöl Mah",
      "Hürriyet Mah",
      "İsali Mah",
      "İstiklal Mah",
      "Karamustafalı Mah",
      "Kızlarçayı Mah",
      "Kuyuluk Mah",
      "Mahmutlu Mah",
      "Mustafalı Mah",
      "Şükrü Paşa Mah",
      "Turunçlu Mah",
      "Yeni Mah",
      "Yeşiltepe Mah",
      "Yoncadüzü Mah",
      "Yukarıburnaz Mah"
    ],
    "Hassa": [
      "15 Kasım Mah",
      "Akbez Mah",
      "Akkülek Mah",
      "Aktepe Mah",
      "Ardıçlı Mah",
      "Arpalıuşağı Mah",
      "Aşağıkarafakılı Mah",
      "Bademli Mah",
      "Bintaş Mah",
      "Buhara Mah",
      "Çay Mah",
      "Çınarbaşı Mah",
      "Dedemli Mah",
      "Demrek Mah",
      "Derviş Paşa Mah",
      "Eğribucak Mah",
      "Gazeluşağı Mah",
      "Girne Mah",
      "Gülkent Mah",
      "Gülpınar Mah",
      "Güvenç Mah",
      "Hacılar Mah",
      "Haydarlar Mah",
      "Katranlık Mah",
      "Koruhüyük Mah",
      "Küreci Mah",
      "Mazmanlı Mah",
      "Sapanözü Mah",
      "Söğüt Mah",
      "Sugediği Mah",
      "Tepebaşı Mah",
      "Tiyek Mah",
      "Yeni Mah",
      "Yeniyapan Mah",
      "Yoluklar Mah",
      "Yukarıbucak Mah",
      "Yukarıkarafakılı Mah",
      "Yuvalı Mah",
      "Zeytinoba Mah"
    ],
    "İskenderun": [
      "Akarca Mah",
      "Akçay Mah",
      "Aşkarbeyli Mah",
      "Azganlık Mah",
      "Azganlık Osb Mah",
      "Bekbele Mah",
      "Bitişik Mah",
      "Büyükdere Mah",
      "Cırtıman Mah",
      "Çınarlı Mah",
      "Denizciler Mah",
      "Düğünyurdu Mah",
      "Kaledibi Mah",
      "Karayılan Mah",
      "Kavaklıoluk Mah",
      "Orhangazi Mah",
      "Sarıseki Mah",
      "Suçıkağı Mah",
      "Barbaros Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Kurtuluş Mah",
      "Pirireis Mah",
      "Savaş Mah",
      "Süleymaniye Mah",
      "Yenişehir Mah",
      "Gürsel Mah",
      "İsmet İnönü Mah",
      "Meydan Mah",
      "Mustafa Kemal Mah",
      "Numune Mah",
      "Pınarbaşı Mah",
      "Çay Mah",
      "Dumlupınar Mah",
      "Fatih Sultan Mehmet Mah",
      "Güzelçay Mah",
      "Modernevler Mah",
      "Muradiye Mah",
      "Sakarya Mah",
      "Yunus Emre Mah",
      "Barıştepe Mah",
      "Buluttepe Mah",
      "Esentepe Mah",
      "Gültepe Mah",
      "Kocatepe Mah",
      "Yıldırımtepe Mah"
    ],
    "Kırıkhan": [
      "408 Evler Mah",
      "Abalaklı Mah",
      "Adalar Mah",
      "Alaybeyli Mah",
      "Alibeyçağıllı Mah",
      "Alparslan Mah",
      "Alsancak Mah",
      "Arkıtça Mah",
      "Attutan Mah",
      "Aydınlı Mah",
      "Aygırgölü Mah",
      "Bahçelievler Mah",
      "Balarmudu Mah",
      "Baldıran Mah",
      "Barbaros Mah",
      "Başpınar Mah",
      "Bektaşlı Mah",
      "Camuzkışlası Mah",
      "Ceylanlı Mah",
      "Cumhuriyet Mah",
      "Çamsarı Mah",
      "Çamseki Mah",
      "Çankaya Mah",
      "Çataltepe Mah",
      "Çiloğlanhüyüğü Mah",
      "Danaahmetli Mah",
      "Dedeçınar Mah",
      "Delibekirli Mah",
      "Demirkonak Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Gölbaşı Mah",
      "Gültepe Mah",
      "Gündüz Mah",
      "Güventaşı Mah",
      "Güzelce Mah",
      "Ilıkpınar Mah",
      "İçada Mah",
      "İncirli Mah",
      "Kaletepe Mah",
      "Kamberlikaya Mah",
      "Kamışlar Mah",
      "Kangallar Mah",
      "Karaçağıl Mah",
      "Karadurmuşlu Mah",
      "Karaelmaslı Mah",
      "Karamağara Mah",
      "Karamankaşı Mah",
      "Karataş Mah",
      "Kazkeli Mah",
      "Kızılkaya Mah",
      "Kodallı Mah",
      "Kurtlusarımazı Mah",
      "Kurtlusoğuksu Mah",
      "Kurtuluş Mah",
      "Mahmutlu Mah",
      "Menderes Mah",
      "Mimar Sinan Mah",
      "Muratpaşa Mah",
      "Narlıhopur Mah",
      "Özkızılkaya Mah",
      "Özsoğuksu Mah",
      "Özyörük Mah",
      "Reşatlı Mah",
      "Saylak Mah",
      "Söğütlüöz Mah",
      "Sucuköy Mah",
      "Taşoluk Mah",
      "Topboğazı Mah",
      "Torun Mah",
      "Yalangoz Mah",
      "Yeni Mah",
      "Yılanlı Mah"
    ],
    "Kumlu": [
      "Akkerpiç Mah",
      "Akkuyu Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Batıayrancı Mah",
      "Cumhuriyet Mah",
      "Doğuayrancı Mah",
      "Fevzi Çakmak Mah",
      "Gökçeoğlu Mah",
      "Gülova Mah",
      "Hamam Mah",
      "Hatayhamamı Mah",
      "Kaletepe Mah",
      "Keli Mah",
      "Kırcaoğlu Mah",
      "Muharrem Mah"
    ],
    "Payas": [
      "Cumhuriyet Mah",
      "Çağlalık Mah",
      "Fatih Mah",
      "İstiklal Mah",
      "Karacami Mah",
      "Karbeyaz Mah",
      "Karşı Mah",
      "Karşıosb Mah",
      "Kozludere Mah",
      "Kürtül Mah",
      "Sincan Mah",
      "Yenişehir Mah",
      "Yıldırım Beyazıt Mah"
    ],
    "Reyhanlı": [
      "Adabucak Mah",
      "Ahmetbeyli Mah",
      "Akyayla Mah",
      "Alakuzu Mah",
      "Bağlar Mah",
      "Bahçelievler Mah",
      "Bayır Mah",
      "Beşaslan Mah",
      "Bükülmez Mah",
      "Cilvegözü Mah",
      "Cumhuriyet Mah",
      "Cüdeyde Mah",
      "Çakıryiğit Mah",
      "Davutpaşa Mah",
      "Değirmenkaşı Mah",
      "Esentepe Mah",
      "Fevzipaşa Mah",
      "Fidanlık Mah",
      "Gazimürseltepesi Mah",
      "Göktepe Mah",
      "Gültepe Mah",
      "Harran Mah",
      "Karacanlık Mah",
      "Karahüyük Mah",
      "Karasüleymanlı Mah",
      "Konuk Mah",
      "Kuletepe Mah",
      "Kumtepe Mah",
      "Kurtuluş Mah",
      "Kuşaklı Mah",
      "Mehmetbeyli Mah",
      "Mustafa Kemal Mah",
      "Nergizli Mah",
      "Oğulpınar Mah",
      "Öz Kurtuluş Mah",
      "Paşahüyük Mah",
      "Paşaköy Mah",
      "Pınarbaşı Mah",
      "Suluköy Mah",
      "Tayfursökmen Mah",
      "Terzihüyük Mah",
      "Uzunkavak Mah",
      "Üçtepe Mah",
      "Varışlı Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Yeşilova Mah"
    ],
    "Samandağ": [
      "Ataköy Mah",
      "Atatürk Mah",
      "Avcılar Mah",
      "Batıayaz Mah",
      "Büyükoba Mah",
      "Cemal Gürsel Mah",
      "Ceylandere Mah",
      "Cumhuriyet Mah",
      "Çamlıyayla Mah",
      "Çanakoluk Mah",
      "Çiğdede Mah",
      "Çöğürlü Mah",
      "Çubuklu Mah",
      "Değirmenbaşı Mah",
      "Deniz Mah",
      "Eriklikuyu Mah",
      "Fidanlı Mah",
      "General Şükrü Kanadlı Mah",
      "Gözene Mah",
      "Hıdırbey Mah",
      "Huzurlu Mah",
      "Kapısuyu Mah",
      "Karaçay Mah",
      "Koyunoğlu Mah",
      "Kurtderesi Mah",
      "Kuşalanı Mah",
      "Mağaracık Mah",
      "Meydan Mah",
      "Mızraklı Mah",
      "Seldiren Mah",
      "Sutaşı Mah",
      "Tekebaşı Mah",
      "Tomruksuyu Mah",
      "Uzunbağ Mah",
      "Vakıfköy Mah",
      "Yaylıca Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilada Mah",
      "Yeşilköy Mah",
      "Yeşilyazı Mah",
      "Yoğunoluk Mah"
    ],
    "Yayladağı": [
      "Arslanyazı Mah",
      "Aşağıpulluyazı Mah",
      "Aydınbahçe Mah",
      "Ayışığı Mah",
      "Bezge Mah",
      "Bozlu Mah",
      "Çabala Mah",
      "Çakı Mah",
      "Çaksına Mah",
      "Çamaltı Mah",
      "Çandır Mah",
      "Çatbaşı Mah",
      "Çayır Mah",
      "Denizgören Mah",
      "Dusduru Mah",
      "Eğerci Mah",
      "Görentaş Mah",
      "Gözlüce Mah",
      "Gürışık Mah",
      "Güveççi Mah",
      "Güzelyurt Mah",
      "Hisarcık Mah",
      "Karacurun Mah",
      "Karaköse Mah",
      "Kışlak Mah",
      "Kızılçat Mah",
      "Kösrelik Mah",
      "Kulaç Mah",
      "Kurtuluş Mah",
      "Leylekli Mah",
      "Olgunlar Mah",
      "Sebenoba Mah",
      "Sungur Mah",
      "Sürütme Mah",
      "Şakşak Mah",
      "Şenköy Mah",
      "Turfanda Mah",
      "Tutlubahçe Mah",
      "Uluyol Mah",
      "Üçırmak Mah",
      "Yalaz Mah",
      "Yayıkdamlar Mah",
      "Yenice Mah",
      "Yeşiltepe Mah",
      "Yoncakaya Mah",
      "Yukarıokçular Mah",
      "Yukarıpulluyazı Mah"
    ]
  },
  "Isparta": {
    "Aksu": [
      "Akçaşar Mah",
      "Bahçeli Mah",
      "Çay Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Kurtuluş Mah",
      "Orta Mah",
      "Pazarcık Mah",
      "Tepe Mah",
      "Eldere Köyü",
      "Elecik Köyü",
      "İmamlar Mah (yakaafşar Köyü)",
      "Karacahisar Köyü",
      "Karağı Köyü",
      "Katip Köyü",
      "Koçular Köyü",
      "Kösre Köyü",
      "Mantaklar Mah (yakaafşar Köyü)",
      "Sofular Köyü",
      "Terziler Köyü",
      "Yaka Köyü",
      "Yılanlı Köyü",
      "Yukarı Mah (yakaafşar Köyü)",
      "Yukarıyaylabel Köyü"
    ],
    "Atabey": [
      "Altunba Mah",
      "Çeşme Mah",
      "Gezirler Mah",
      "Müftü Mah",
      "Onaç Mah",
      "Pazar Mah",
      "Sinan Mah",
      "Sökmen Mah",
      "Yeni Mah",
      "Bayat Köyü",
      "Harmanören Köyü",
      "Hıdır Mah (islamköy Köyü)",
      "Kapıcak Köyü",
      "Müftü Mah (islamköy Köyü)",
      "Orta Mah (islamköy Köyü)",
      "Pembeli Köyü",
      "Yeni Mah (islamköy Köyü)"
    ],
    "Eğirdir": [
      "Ağa Mah",
      "Altınkum Mah",
      "Bağbuyan Mah",
      "Bağlar Mah",
      "Camii Mah",
      "Demirkapı Mah",
      "Hacışeyh Mah",
      "Hamam Mah",
      "İmaret Mah",
      "İstasyon Mah",
      "Kale Mah",
      "Katip Mah",
      "Kızılçubuk Mah",
      "Konya Bucağı Mah",
      "Kubbeli Mah",
      "Menderes Mah",
      "Pınar Pazarı Mah",
      "Poyraz Mah",
      "Sanayi Mah",
      "Sekibağ Mah",
      "Seydim Mah",
      "Yazla Mah",
      "Yeni Mah",
      "Yeşilada Mah",
      "Ağılköy Köyü",
      "Akdoğan Köyü",
      "Akmescit Mah (barla Köyü)",
      "Akpınar Köyü",
      "Aşağı Gökdere Köyü",
      "Aşağı Mah (pazarköy Köyü)",
      "Bademli Köyü",
      "Bağıcık Köyü",
      "Bağıllı Köyü",
      "Bağören Köyü",
      "Bahçıvan Mah (yuvalı Köyü)",
      "Baklan Köyü",
      "Balkırı Köyü",
      "Baş Mah (barla Köyü)",
      "Beşevler Mah (sevinçbey Köyü)",
      "Boyalı Mah (barla Köyü)",
      "Camikebir Mah (barla Köyü)",
      "Cirbeli Mah (haymana Köyü)",
      "Cumhuriyet Mah (gökçehöyük Köyü)",
      "Çaltı Arası Mah (serpil Köyü)",
      "Çay Köyü",
      "Çiftlik Mah (eyüpler Köyü)",
      "Deniz Altı Mah (haymana Köyü)",
      "Erenler Mah (sipahiler Köyü)",
      "Eyüpler Köyü",
      "Göktaş Köyü",
      "Hacıramazanlar Mah (eyüpler Köyü)",
      "Harmanyeri Mah (ağılköy Köyü)",
      "Havutlu Köyü",
      "Haymana Köyü",
      "Hürriyet Mah (gökçehöyük Köyü)",
      "İstiklal Mah (gökçehöyük Köyü)",
      "Karşıyaka Mah (akdoğan Köyü)",
      "Kırıntı Köyü",
      "Koca Cesme Mah (haymana Köyü)",
      "Mahmatlar Köyü",
      "Merkez Mah (beydere Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Pazar Mah (barla Köyü)",
      "Sahil Mah (beydere Köyü)",
      "Serpil Köyü",
      "Sevinçbey Köyü",
      "Sorkuncak Köyü",
      "Tepeli Köyü",
      "Yelliler Mah (yuvalı Köyü)",
      "Yeni Mah (barla Köyü)",
      "Yeni Mah (pazarköy Köyü)",
      "Yılgıncak Köyü",
      "Yokuşbaşı Mah (barla Köyü)",
      "Yukarı Gökdere Köyü",
      "Yukarı Mah (pazarköy Köyü)",
      "Yuvalı Köyü",
      "Zafer Mah (gökçehöyük Köyü)",
      "Ağa Mah (sarıidris Beldesi)",
      "Dere Mah (sarıidris Beldesi)",
      "Hürriyet Mah (sarıidris Beldesi)",
      "İstiklal Mah (sarıidris Beldesi)"
    ],
    "Gelendost": [
      "17 Eylül Mah",
      "Aşağı Mah",
      "Bahçelievler Mah",
      "Haydarpaşa Mah",
      "Hüseyin Avni Paşa Mah",
      "Kırevler Mah",
      "Muharrem Mah",
      "Orta Mah",
      "Selçuk Mah",
      "Yeni Mah",
      "Afşar Köyü",
      "Akdağ Köyü",
      "Aşağı Mah (bağıllı Köyü)",
      "Aşağı Mah (yenice Köyü)",
      "Bahçeli Evler Mah (yaka Köyü)",
      "Balcı Köyü",
      "Cumhuriyet Mah (yaka Köyü)",
      "Çaltı Köyü",
      "Çay Mah (yaka Köyü)",
      "Esinyurt Köyü",
      "Hacılar Köyü",
      "Hanönü Mah (yeşilköy Köyü)",
      "Keçili Köyü",
      "Kemer Mah (yenice Köyü)",
      "Kızdaşı Mah (yenice Köyü)",
      "Köke Köyü",
      "Madenli Köyü",
      "Orta Mah (yaka Köyü)",
      "Şehitler Mah (bağıllı Köyü)",
      "Yakadibi Mah (yenice Köyü)",
      "Yeni Mah (bağıllı Köyü)",
      "Yeni Mah (yaka Köyü)",
      "Yeşilköy Köyü",
      "Yukarı Mah (bağıllı Köyü)",
      "Yukarı Mah (yaka Köyü)",
      "Yukarı Mah (yenice Köyü)"
    ],
    "Gönen": [
      "Alaca Mescit Mah",
      "Cami Mah",
      "Göletevleri Mah",
      "Kasap Mah",
      "Musalla Mah",
      "Pazar Mah",
      "Baladız Mah (güneykent Beldesi)",
      "Orta Mah (güneykent Beldesi)",
      "Tekke Mah (güneykent Beldesi)",
      "Yenice Mah (güneykent Beldesi)",
      "Gölbaşı Köyü",
      "İğdecik Mah (iğdecik Köyü)",
      "Kızılcık Köyü",
      "Koçtepe Köyü",
      "Senirce Mah (senirce Köyü)"
    ],
    "Keçiborlu": [
      "Aşağı Mah",
      "Cumhuriyet Mah",
      "Hacı Köyü Mah",
      "Hasanbey Mah",
      "Kaya Mah",
      "Kükürt Mah",
      "Orta Mah",
      "Orta Mah (kılıç Köyü)",
      "Tuzla Mah",
      "Yenice Mah",
      "Yenice Mah (kılıç Köyü)",
      "Yukarı Mah",
      "Yukarı Mah (kılıç Köyü)",
      "Ardıçlı Köyü",
      "Camii Kebir Mah (aydoğmuş Köyü)",
      "Cumhuriyet Mah (incesu Köyü)",
      "Çukurören Köyü",
      "Gülköy Köyü",
      "Gültepe Mah (aydoğmuş Köyü)",
      "Hürriyet Mah (incesu Köyü)",
      "İstiklal Mah (incesu Köyü)",
      "Kaplanlı Köyü",
      "Kavak Köyü",
      "Kozluca Köyü",
      "Kurtuluş Mah (aydoğmuş Köyü)",
      "Kuyucak Köyü",
      "Özbahçe Köyü",
      "Saracık Köyü",
      "Toki Mah",
      "Yenitepe Köyü",
      "Yeşilyurt Köyü",
      "Cumhuriyet Mah (senir Beldesi)",
      "Kuşçular Mah (senir Beldesi)",
      "Orta Mah (senir Beldesi)",
      "Tepecik Mah (senir Beldesi)",
      "Yeni Mah (senir Beldesi)"
    ],
    "Merkez": [
      "Ayazmana Mah",
      "Çelebiler Mah",
      "Dere Mah",
      "Doğancı Mah",
      "Emre Mah",
      "Gazi Kemal Mah",
      "Gülcü Mah",
      "Gülevler Mah",
      "Halıkent Mah",
      "Halife Sultan Mah",
      "Hisar Mah",
      "İskender Mah",
      "Keçeci Mah",
      "Kurtuluş Mah",
      "Sidre Mah",
      "Sülübey Mah",
      "Turan Mah",
      "Vatan Mah",
      "Vatanosb Mah",
      "Yenice Mah",
      "Davraz Mah",
      "İstiklal Mah",
      "Karaağaç Mah",
      "Kepeci Mah",
      "Sermet Mah",
      "Kemal Mah (kuleönü Beldesi)",
      "Okul Mah (kuleönü Beldesi)",
      "Yenicami Mah (kuleönü Beldesi)",
      "Bağlar Mah",
      "Batıkent Mah",
      "Binbirevler Mah",
      "Gülistan Mah",
      "Hızırbey Mah",
      "Işıkkent Mah",
      "Kutlubey Mah",
      "Pirimehmet Mah",
      "Yayla Mah",
      "Absarı Mah (kadılar Köyü)",
      "Ağıl Mah (darıören Köyü)",
      "Aliköy Köyü",
      "Aşağı Mah (deregümü Köyü)",
      "Aşağı Mah (direkli Köyü)",
      "Bahçelievler Mah (yakaören Köyü)",
      "Bozanönü Köyü",
      "Bögürtlenli Mah (darıderesi Köyü)",
      "Bucakdere Mah (darıören Köyü)",
      "Büyükhacılar Köyü",
      "Çatal Mah (büyükgökçeli Köyü)",
      "Çıkrıklı Mah (darıören Köyü)",
      "Çobanisa Köyü",
      "Çukurköy Köyü",
      "Derebogazı  Mah (karahafız Mah) (küçükkışla Köyü)",
      "Dereboğazı Mah (kışlaköy Köyü)",
      "Gelincik Köyü",
      "Güney Bahçe Evleri Mah (küçükgökçeli Köyü)",
      "Güneyce Köyü",
      "Hocantı Mah (direkli Köyü)",
      "İmrezi Mah (küçükkışla Köyü)",
      "Kavak Mah (küçükkışla Köyü)",
      "Kavaklı Çeşme Mah (direkli Köyü)",
      "Kayıköy Köyü",
      "Kaynarpınar Mah (direkli Köyü)",
      "Kırkayak Mah (büyükgökçeli Köyü)",
      "Kışlaköy Köyü",
      "Kolcubeli Mah (kadılar Köyü)",
      "Köy İçi Merkez Mah (darıören Köyü)",
      "Köy İçi Merkez Mah (kadılar Köyü)",
      "Kuzey Bahçeevleri Mah (küçükgökçeli Köyü)",
      "Küçükgökçeli Köyü",
      "Küçükhacılar Köyü",
      "Merkez Mah (yakaören Köyü)",
      "Okul Mah (büyükgökçeli Köyü)",
      "Okul Mah (yakaören Köyü)",
      "Sarıyer Mah (darıören Köyü)",
      "Şekerler Mah (kadılar Köyü)",
      "Tilkilik Mah (darıören Köyü)",
      "Yağcıoğlu Mah (darıderesi Köyü)",
      "Yayla Mah (direkli Köyü)",
      "Yazısöğüt Köyü",
      "Yukarı Mah (darıderesi Köyü)",
      "Yukarı Mah (deregümü Köyü)",
      "Yukarı Mah (direkli Köyü)",
      "Akkent Mah",
      "Anadolu Mah",
      "Bahçelievler Mah",
      "Çünür Mah",
      "Fatih Mah",
      "Mehmet Tönge Mah",
      "Modern Evler Mah",
      "Muzaffer Türkeş Mah",
      "Sanayi Mah",
      "Yedişehitler Mah",
      "Zafer Mah",
      "Aşağı Mah (sav Beldesi)",
      "Fatih Mah (sav Beldesi)",
      "Yukarı Mah (sav Beldesi)"
    ],
    "Senirkent": [
      "Camii Mah (büyükkabaca Beldesi)",
      "Dere Mah (büyükkabaca Beldesi)",
      "Karşı Mah (büyükkabaca Beldesi)",
      "Orta Mah (büyükkabaca Beldesi)",
      "Sultan Süleyman Mah (büyükkabaca Beldesi)",
      "Zafer Mah (büyükkabaca Beldesi)",
      "Aşağı Mah (gençali Köyü)",
      "Aşağı Mah (yassıören Köyü)",
      "Başköy Köyü",
      "Bozdurmuş Mah (gençali Köyü)",
      "Bülbül Mah (akkeçili Köyü)",
      "Büyükçeşme Mah (uluğbey Köyü)",
      "Çanlar Mah (yassıören Köyü)",
      "Eski Köy Mah (gençali Köyü)",
      "Karababa Mah (akkeçili Köyü)",
      "Kayaağzı Mah (karip Köyü)",
      "Kuzyaka Mah (akkeçili Köyü)",
      "Merkez Mah (karip Köyü)",
      "Onkuyu Mah (gençali Köyü)",
      "Ortayazı Köyü",
      "Türbe Mah (uluğbey Köyü)",
      "Yayla Mah (uluğbey Köyü)",
      "Yukarı Mah (gençali Köyü)",
      "Yukarı Mah (yassıören Köyü)",
      "16 Haziran Mah",
      "Cumhuriyet Mah",
      "Hamidiye Mah",
      "İstiklal Mah",
      "Kıbrıs Mah",
      "Süleyman Demirel Mah",
      "Şehler Mah",
      "Taşmescit Mah",
      "Turgutlar Mah"
    ],
    "Sütçüler": [
      "Aşağıyaylabel Köyü",
      "Ayvapınarı Mah (ayvalıpınar Köyü)",
      "Bekirağalar Köyü",
      "Belence Köyü",
      "Beydili Köyü",
      "Boğazköy Köyü",
      "Bucakdere Köyü",
      "Cami Mah (kesme Köyü)",
      "Camii Mah (kasımlar Köyü)",
      "Çandır Köyü",
      "Çıraklar Mah (ayvalıpınar Köyü)",
      "Çobanisa Köyü",
      "Çökek Mah (kesme Köyü)",
      "Çukurca Köyü",
      "Çürük Belen Mah (kasımlar Köyü)",
      "Darıbükü Köyü",
      "Derindere Mah (kesme Köyü)",
      "Güldallı Köyü",
      "Gümü Köyü",
      "Güney Mah (kasımlar Köyü)",
      "Hacıahmetler Köyü",
      "Hacıaliler Köyü",
      "İbişler Köyü",
      "İncedere Köyü",
      "Karadiken Köyü",
      "Kızılbelen Mah (kesme Köyü)",
      "Köprübaşı Mah (ayvalıpınar Köyü)",
      "Kuz Mah (ayvalıpınar Köyü)",
      "Kuzca Köyü",
      "Melikler Köyü",
      "Müezzinler Köyü",
      "Öbektaş Mah (ayvalıpınar Köyü)",
      "Pınarköy Köyü",
      "Sağrak Köyü",
      "Saray Köyü",
      "Sarımehmetler Köyü",
      "Şehler Köyü",
      "Yeniköy Köyü",
      "Yeşilyurt Köyü",
      "Başkoz Mah",
      "Belen Mah",
      "Birlik Mah",
      "Cami Mah",
      "Erenler Mah",
      "Yeşildere Mah",
      "Yukarı Mah"
    ],
    "Şarkikaraağaç": [
      "Bölükler Mah (çarıksaraylar Beldesi)",
      "Cumhuriyet Mah (çarıksaraylar Beldesi)",
      "Çukur Mah (çarıksaraylar Beldesi)",
      "Suvar Mah (çarıksaraylar Beldesi)",
      "Ulu Mah (çarıksaraylar Beldesi)",
      "Aşağı Mah (çiçekpınar Beldesi)",
      "Çördük Mah (çiçekpınar Beldesi)",
      "Orta Mah (çiçekpınar Beldesi)",
      "Arak Köyü",
      "Armutlu Köyü",
      "Aslandoğmuş Köyü",
      "Aşağı Mah (göksöğüt Köyü)",
      "Aşağıdinek Köyü",
      "Başdeğirmen Köyü",
      "Belceğiz Köyü",
      "Beyköy Köyü",
      "Çaltı Köyü",
      "Çavundur Köyü",
      "Çeltek Köyü",
      "Fakılar Köyü",
      "Fele Köyü",
      "Gedikli Köyü",
      "Karayaka Köyü",
      "Kıyakdede Köyü",
      "Köprü Köyü",
      "Muratbağı Köyü",
      "Ördekci Köyü",
      "Örenköy Köyü",
      "Salur Köyü",
      "Sarıkaya Köyü",
      "Yakaemir Köyü",
      "Yeni Mah (göksöğüt Köyü)",
      "Yenicekale Köyü",
      "Yeniköy Köyü",
      "Yukarı Mah (göksöğüt Köyü)",
      "Yukarıdinek Köyü",
      "Alcıklar Mah",
      "Asılkale Mah",
      "Aşağıkale Mah",
      "Camikebir Mah",
      "Fatih Mah",
      "Kerkük Mah",
      "Orta Mah",
      "Ulvikale Mah"
    ],
    "Uluborlu": [
      "Dere Köyü",
      "İleydağı Köyü",
      "İnhisar Köyü",
      "Küçükkabaca Köyü",
      "Güreşyeri Mah",
      "Hamideli Mah",
      "Kabaağaç Mah",
      "Kösehasan Mah",
      "Namazgah Mah",
      "Pazar Mah",
      "Selçuklu Mah",
      "Serenler Mah",
      "Taşköprü Mah",
      "Topraklık Mah",
      "Zincirli Mah"
    ],
    "Yalvaç": [
      "Eskigeçit Mah (hüyüklü Beldesi)",
      "Mescit Mah (hüyüklü Beldesi)",
      "Nalbant Mah (hüyüklü Beldesi)",
      "Yanarık Mah (hüyüklü Beldesi)",
      "Yeni Mah (hüyüklü Beldesi)",
      "Akçaşar Köyü",
      "Altıkapı Köyü",
      "Ardıçlı Mah (kozluçay Köyü)",
      "Aşağı Mah (celeptaş Köyü)",
      "Aşağı Mah (çetince Köyü)",
      "Aşağı Mah (kozluçay Köyü)",
      "Aşağı Mah (körküler Köyü)",
      "Aşağı Mah (kumdanlı Köyü)",
      "Aşağı Mah (sağırköy Köyü)",
      "Aşağı Mah (sücüllü Köyü)",
      "Aşağı Yukarı Mah (aşağıkaşıkara Köyü)",
      "Aşağıkaşıkara Köyü",
      "Ayvalı Köyü",
      "Bahçelievler Mah (dedeçam Köyü)",
      "Bahtiyar Köyü",
      "Bolatlık Mah (tokmacık Köyü)",
      "Cumhuriyet Mah (bağkonak Köyü)",
      "Cumhuriyet Mah (çetince Köyü)",
      "Çakırçal Köyü",
      "Çamharman Köyü",
      "Çayır Mah (kumdanlı Köyü)",
      "Deliktaş Mah (sücüllü Köyü)",
      "Dere Gültepe Mah (aşağıkaşıkara Köyü)",
      "Dere Mah (kozluçay Köyü)",
      "Eğirler Köyü",
      "Esentepe Mah (tokmacık Köyü)",
      "Eski Mah (körküler Köyü)",
      "Eyüpler Köyü",
      "Fatih Mah (bağkonak Köyü)",
      "Fatih Mah (kozluçay Köyü)",
      "Fatih Mah (özgüney Köyü)",
      "Fatih Mah (yukarıkaşıkara Köyü)",
      "Gökçay Mah (tokmacık Köyü)",
      "Gökçeali Köyü",
      "Gülkent Mah (tokmacık Köyü)",
      "Gümüşlü Mah (aşağıtırtar Köyü)",
      "Harman Mah (kuyucak Köyü)",
      "Harman Mah (özbayat Köyü)",
      "Harman Mah (sücüllü Köyü)",
      "Harman Mah (yukarıkaşıkara Köyü)",
      "Hisarardı Köyü",
      "Hurşitler Mah (sücüllü Köyü)",
      "İleği Köyü",
      "İslibucağı Mah (aşağıtırtar Köyü)",
      "Kale Mah (bağkonak Köyü)",
      "Karşıyaka Mah (çetince Köyü)",
      "Kırkbaş Köyü",
      "Koruyaka Köyü",
      "Kurusarı Köyü",
      "Kuzyaka Mah (özbayat Köyü)",
      "Küçüktepe Mah (aşağıtırtar Köyü)",
      "Mezarlık Mah (aşağıtırtar Köyü)",
      "Mısırlı Köyü",
      "Mithatpaşa Mah (çetince Köyü)",
      "Orta Mah (dedeçam Köyü)",
      "Orta Mah (kumdanlı Köyü)",
      "Orta Mah (kuyucak Köyü)",
      "Orta Mah (özbayat Köyü)",
      "Pazar Mah (körküler Köyü)",
      "Pazar Mah (özgüney Köyü)",
      "Selçuklu Mah (özgüney Köyü)",
      "Taşevi Köyü",
      "Tepecik Mah (bağlarbaşı Köyü)",
      "Terziler Köyü",
      "Tolyüzü Mah (aşağıtırtar Köyü)",
      "Ulucamii Mah (bağkonak Köyü)",
      "Yağcılar Köyü",
      "Yarıkkaya Köyü",
      "Yayla Mah (kozluçay Köyü)",
      "Yayla Mah (tokmacık Köyü)",
      "Yayla Mah (yukarıkaşıkara Köyü)",
      "Yeni Mah (bağkonak Köyü)",
      "Yeni Mah (çetince Köyü)",
      "Yeni Mah (dedeçam Köyü)",
      "Yeni Mah (kozluçay Köyü)",
      "Yeni Mah (körküler Köyü)",
      "Yeni Mah (kumdanlı Köyü)",
      "Yeni Mah (kuyucak Köyü)",
      "Yeni Mah (özbayat Köyü)",
      "Yeni Mah (özgüney Köyü)",
      "Yeni Mah (sücüllü Köyü)",
      "Yeni Mah (tokmacık Köyü)",
      "Yeni Mah (yağcılar Köyü)",
      "Yeni Mah (yukarıkaşıkara Köyü)",
      "Yukarı Mah (bağlarbaşı Köyü)",
      "Yukarı Mah (celeptaş Köyü)",
      "Yukarı Mah (çetince Köyü)",
      "Yukarı Mah (ileği Köyü)",
      "Yukarı Mah (kozluçay Köyü)",
      "Yukarı Mah (kumdanlı Köyü)",
      "Yukarı Mah (kuyucak Köyü)",
      "Yukarı Mah (sağırköy Köyü)",
      "Yukarı Mah (sücüllü Köyü)",
      "Yukarıtırtar Köyü",
      "Yusuflar Mah (bağlarbaşı Köyü)",
      "Abacılar Mah",
      "Akköprü Mah",
      "Bağlar Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Debbağlar Mah",
      "Eski Mah",
      "Fatih Mah",
      "Görgü Bayram Mah",
      "Görgü Camii Mah",
      "Görgüorta Mah",
      "Kaşaşağı Mah",
      "Kaşcami Mah",
      "Kaşhacıbey Mah",
      "Kaşyukarı Mah",
      "Kızılca Mah",
      "Kuşku Mah",
      "Leblebiciler Mah",
      "Müderris Mah",
      "Pazar Aşağı Mah",
      "Pazar Yukarı Mah",
      "Salur Mah",
      "Sanayi Mah",
      "Saray Mah",
      "Sofular Mah",
      "Zafer Mah"
    ],
    "Yenişarbademli": [
      "Gölkonak Köyü",
      "Gündoğdu Mah",
      "Pınarbaşı Mah",
      "Yenicami Mah",
      "Yenice Mah"
    ]
  },
  "Mersin": {
    "Akdeniz": [
      "Adanalıoğlu Limonlu Mah",
      "Adanalıoğlu Mah",
      "Akdeniz Mah",
      "Anadolu Mah",
      "Bahçe Mah",
      "Barış Mah",
      "Hamidiye Mah",
      "Kiremithane Mah",
      "Kültür Mah",
      "Turgutreis Mah",
      "Cami Şerif Mah",
      "Mesudiye Mah",
      "Çankaya Mah",
      "İhsaniye Mah",
      "Mahmudiye Mah",
      "Akdam Mah",
      "Bekirde Mah",
      "Camili Mah",
      "Civanyaylağı Mah",
      "Demirhisar Mah",
      "Dikilitaş Mah",
      "Esenli Mah",
      "Hebilli Mah",
      "Iğdır Mah",
      "Parmakkurdu Mah",
      "Puğkaracadağ Mah",
      "Yanpar Mah",
      "Yeşilova Mah",
      "Bağcılar-ihsaniye Mah",
      "Bahçeli Aşağıburhan Mah",
      "Bahçeli Kürkçü Mah",
      "Bahçeli Yukarıburhan Mah",
      "Burhanosb Mah",
      "Evci Mah",
      "Evciosb Mah",
      "Sarıibrahimli Mah",
      "Toroslar Mah",
      "Gündoğdu Mah",
      "Güneş Mah",
      "Mithatpaşa Mah",
      "Siteler Mah",
      "Hal Mah",
      "Müfide İlhan Mah",
      "Özgürlük Mah",
      "Şevketsümer Mah",
      "Adnan Menderes Mah",
      "Bağlarbaşı Mah",
      "Bahşiş Mah",
      "Gazi Mah",
      "Köselerli Mah",
      "Kulak Mah",
      "Nacarlı Mah",
      "Nacarlıosb Mah",
      "Abdullah Şahutoğlu Mah",
      "Karacailyas Emek Mah",
      "Karacailyas Evren Mah",
      "Karacailyas Mah",
      "Şakirgülmen Mah",
      "Çay Mah",
      "Çilek Mah",
      "Karaduvar Mah",
      "Karaduvar Sb Mah",
      "Yeşilçimen Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Kazanlı Mah",
      "Nusratiye Mah",
      "Üçocak Mah",
      "Yeni Mah"
    ],
    "Anamur": [
      "Akarca Mah",
      "Akine Mah",
      "Alataş Mah",
      "Anıtlı Mah",
      "Aşağıkükür Mah",
      "Boğuntu Mah",
      "Bozdoğan Mah",
      "Çaltıbükü Mah",
      "Çamlıpınar Mah",
      "Çamlıpınaralanı Mah",
      "Çarıklar Mah",
      "Çataloluk Mah",
      "Çeltikçi Mah",
      "Çukurabanoz Mah",
      "Demirören Mah",
      "Emirşah Mah",
      "Esentepe Mah",
      "Evciler Mah",
      "Gercebahşiş Mah",
      "Güleç Mah",
      "Güneybahşiş Mah",
      "Güngören Mah",
      "Kalınören Mah",
      "Karaağa Mah",
      "Karaçukur Mah",
      "Karadere Mah",
      "Karalarbahşiş Mah",
      "Kaşdişlen Mah",
      "Kılıç Mah",
      "Kızılaliler Mah",
      "Korucuk Mah",
      "Köprübaşı Mah",
      "Lale Mah",
      "Malaklar Mah",
      "Ormancık Mah",
      "Ovabaşı Mah",
      "Ören Mah",
      "Sarıağaç Mah",
      "Sarıdana Mah",
      "Sugözü Mah",
      "Sultan Alaaddin Mah",
      "Uçarı Mah",
      "Yıldırım Beyazıt Mah",
      "Yukarı Kükür Mah",
      "Bahçe Mah",
      "Göktaş Mah",
      "Sağlık Mah",
      "Saray Mah",
      "Toroslar Mah",
      "Yeşilyurt Mah",
      "Akdeniz Mah",
      "Bahçelievler Mah",
      "Fatih Mah",
      "Güzelyurt Mah",
      "İskele Mah",
      "Yalıevleri Mah"
    ],
    "Aydıncık": [
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Merkez Mah",
      "Yeni Mah",
      "Duruhan Mah",
      "Eskiyürük Mah",
      "Hacıbahattin Mah",
      "Karadere Mah",
      "Karaseki Mah",
      "Pembecik Mah",
      "Teknecik Mah",
      "Yenikaş Mah",
      "Yeniyürük Mah",
      "Yeniyürükkaş Mah"
    ],
    "Bozyazı": [
      "Ardıçlıtaş Mah",
      "Dereköy Mah",
      "Elmakuzu Mah",
      "Kızılca Mah",
      "Akcami Mah",
      "Bahçekoyağı Mah",
      "Beyreli Mah",
      "Çopurlu Mah",
      "Çubukkoyağı Mah",
      "Denizciler Mah",
      "Derebaşı Mah",
      "Gözce Mah",
      "Gözsüzce Mah",
      "Gürlevik Mah",
      "Kaledibi Mah",
      "Karaisalı Mah",
      "Kömürlü Mah",
      "Kötekler Mah",
      "Lenger Mah",
      "Merkez Mah",
      "Narince Mah",
      "Sıcakyurt Mah",
      "Tekedüzü Mah",
      "Tekeli Mah",
      "Tekmen Mah",
      "Ustalar Mah"
    ],
    "Çamlıyayla": [
      "Cumayakası Mah",
      "Çayırekinliği Mah",
      "Kale Mah",
      "Sebil Mah",
      "Bağçatağı Mah",
      "Belçınar Mah",
      "Darıpınarı Mah",
      "Fakılar Mah",
      "Giden Mah",
      "Kesecik Mah",
      "Korucak Mah",
      "Körmenlik Mah",
      "Sarıkavak Mah",
      "Sarıkoyak Mah"
    ],
    "Erdemli": [
      "Adnan Menderes Mah",
      "Akdeniz Mah",
      "Akpınar Mah",
      "Alata Mah",
      "Alibeyli Mah",
      "Arpaçbahşiş Mah",
      "Arslanlı Mah",
      "Ayaş Mah",
      "Aydınlar Mah",
      "Barbaros Mah",
      "Batısandal Mah",
      "Çamlı Mah",
      "Çerçili Mah",
      "Çeşmeli Mah",
      "Çiftepınar Mah",
      "Çiriş Mah",
      "Dağlı Mah",
      "Doğusandal Mah",
      "Elbeyli Mah",
      "Elvanlı Mah",
      "Esenpınar Mah",
      "Evdilek Mah",
      "Fakılı Mah",
      "Fatih Mah",
      "Gücüş Mah",
      "Güneyli Mah",
      "Güzeloluk Mah",
      "Hacıalanı Mah",
      "Hacıhalilarpaç Mah",
      "Harfilli Mah",
      "Hüsametli Mah",
      "İlemin Mah",
      "Karaahmetli Mah",
      "Karahıdırlı Mah",
      "Karakeşli Mah",
      "Karayakup Mah",
      "Kargıcak Mah",
      "Kargıpınarı Mah",
      "Kayacı Mah",
      "Kızılen Mah",
      "Kızkalesi Mah",
      "Kocahasanlı Mah",
      "Koramşalı Mah",
      "Koyuncu Mah",
      "Kösbucağı Mah",
      "Kösereli Mah",
      "Kuşluca Mah",
      "Küstülü Mah",
      "Limonlu Mah",
      "Merkez Mah",
      "Pınarbaşı Mah",
      "Sarıkaya Mah",
      "Sarıyer Mah",
      "Sıraç Mah",
      "Sinap Mah",
      "Sorgun Mah",
      "Şahna Mah",
      "Tabiye Mah",
      "Tapureli Mah",
      "Tırtar Mah",
      "Toros Mah",
      "Tozlu Mah",
      "Tömük Mah",
      "Türbe Mah",
      "Üçtepe Mah",
      "Üzümlü Mah",
      "Veyselli Mah",
      "Yağda Mah",
      "Yarenler Mah",
      "Yeniyurt Mah",
      "Yüksek Mah"
    ],
    "Gülnar": [
      "Akdeniz Mah",
      "Ayvalı Mah",
      "Hacıpınar Mah",
      "Saray Mah",
      "Akova Mah",
      "Ardıçpınarı Mah",
      "Arıkuyusu Mah",
      "Bereket Mah",
      "Beydili Mah",
      "Bolyaran Mah",
      "Bozağaç Mah",
      "Büyükeceli Mah",
      "Çavuşlar Mah",
      "Çukurasma Mah",
      "Çukurkonak Mah",
      "Dayıcık Mah",
      "Dedeler Mah",
      "Delikkaya Mah",
      "Demirözü Mah",
      "Emirhacı Mah",
      "Gezende Mah",
      "Göktürk Mah",
      "Halifeler Mah",
      "Ilısu Mah",
      "İshaklar Mah",
      "Kavakoluğu Mah",
      "Kayrak Mah",
      "Koçaşlı Mah",
      "Konur Mah",
      "Korucuk Mah",
      "Köseçobanlı Mah",
      "Kurbağa Mah",
      "Kuskan Mah",
      "Mollaömerli Mah",
      "Örenpınar Mah",
      "Örtülü Mah",
      "Sarıkavak Mah",
      "Sipahili Mah",
      "Şeyhömer Mah",
      "Taşoluk Mah",
      "Tepe Mah",
      "Tırnak Mah",
      "Tozkovan Mah",
      "Ulupınar Mah",
      "Üçoluk Mah",
      "Yanışlı Mah",
      "Yarmasu Mah",
      "Yassıbağ Mah",
      "Yenice Mah",
      "Zeyne Mah"
    ],
    "Mezitli": [
      "Akdeniz Mah",
      "Çamlıca Mah",
      "Çankaya Mah",
      "Esenbağlar Mah",
      "Eski Mezitli Mah",
      "Kaleköy Mah",
      "Kuyuluk Mah",
      "Atatürk Mah",
      "Fatih Mah",
      "Menderes Mah",
      "Merkez Mah",
      "Viranşehir Mah",
      "Yeni Mah",
      "75.yıl Mah",
      "Anayurt Mah",
      "Cumhuriyet Mah",
      "Davultepe Mah",
      "İstiklal Mah",
      "Akarca Mah",
      "Bozön Mah",
      "Cemilli Mah",
      "Çevlik Mah",
      "Demirışık Mah",
      "Doğançay Mah",
      "Doğlu Mah",
      "Fındıkpınarı Mah",
      "Kocayer Mah",
      "Kuzucu Mah",
      "Kuzucubelen Mah",
      "Pelitkoyağı Mah",
      "Sarılar Mah",
      "Takanlı Mah",
      "Tepeköy Mah",
      "Tol Mah",
      "Zeybekler Mah",
      "Deniz Mah",
      "Hürriyet Mah",
      "Seymenli Mah",
      "Şahin Tepesi Mah",
      "Tece Mah"
    ],
    "Mut": [
      "Alaçam Mah",
      "Aşağıköselerli Mah",
      "Aydınoğlu Mah",
      "Bağcağız Mah",
      "Ballı Mah",
      "Barabanlı Mah",
      "Bozdoğan Mah",
      "Burunköy Mah",
      "Ceritler Mah",
      "Cumhuriyet Mah",
      "Çağlayangedik Mah",
      "Çaltılı Mah",
      "Çamlıca Mah",
      "Çampınar Mah",
      "Çatakbağ Mah",
      "Çatalharman Mah",
      "Çınarlı Mah",
      "Çivi Mah",
      "Çortak Mah",
      "Çömelek Mah",
      "Çukurbağ Mah",
      "Dağpazarı Mah",
      "Demirkapı Mah",
      "Dereköy Mah",
      "Derinçay Mah",
      "Deveci Mah",
      "Diştaş Mah",
      "Doğancı Mah",
      "Elbeyli Mah",
      "Elmapınar Mah",
      "Esençay Mah",
      "Evren Mah",
      "Fakırca Mah",
      "Geçimli Mah",
      "Gençali Mah",
      "Göcekler Mah",
      "Gökçetaş Mah",
      "Göksu Mah",
      "Güllük Mah",
      "Güme Mah",
      "Güzelköy Mah",
      "Güzelyurt Mah",
      "Hacıahmetli Mah",
      "Hacıilyaslı Mah",
      "Hacınuhlu Mah",
      "Hacısait Mah",
      "Hamam Mah",
      "Haydarköy Mah",
      "Hisarköy Mah",
      "Hocalı Mah",
      "Ilıca Mah",
      "Irmaklı Mah",
      "Işıklar Mah",
      "İbrahimli Mah",
      "Kadıköy Mah",
      "Kale Mah",
      "Karacaoğlan Mah",
      "Karadiken Mah",
      "Karşıyaka Mah",
      "Kavaklı Mah",
      "Kavaközü Mah",
      "Kayabaşı Mah",
      "Kayaönü Mah",
      "Kelceköy Mah",
      "Kemenli Mah",
      "Kırkkavak Mah",
      "Kışlaköy Mah",
      "Kızılalan Mah",
      "Köselerli Mah",
      "Kumaçukuru Mah",
      "Kurtsuyu Mah",
      "Kurtuluş Mah",
      "Kültür Mah",
      "Kürkçü Mah",
      "Meydan Mah",
      "Mirahor Mah",
      "Mucuk Mah",
      "Narlı Mah",
      "Narlıdere Mah",
      "Ortaköy Mah",
      "Özköy Mah",
      "Özlü Mah",
      "Palantepe Mah",
      "Pamuklu Mah",
      "Pınarbaşı Mah",
      "Sakız Mah",
      "Sarıveliler Mah",
      "Selamlı Mah",
      "Suçatı Mah",
      "Tekeli Mah",
      "Topkaya Mah",
      "Topluca Mah",
      "Tuğrul Mah",
      "Yalnızcabağ Mah",
      "Yapıntı Mah",
      "Yatırtaş Mah",
      "Yazalanı Mah",
      "Yeşilköy Mah",
      "Yeşilyurt Mah",
      "Yıldızköy Mah",
      "Yukarıköselerli Mah",
      "Zeytinçukuru Mah"
    ],
    "Silifke": [
      "Atakent Mah",
      "Atayurt Mah",
      "Arkum Mah",
      "Gazi Mah",
      "Göksu Mah",
      "Kabasakallı Mah",
      "Sarıcalar Mah",
      "Sayağzı Mah",
      "Atik Mah",
      "Bucaklı Mah",
      "Camiikebir Mah",
      "Mukaddem Mah",
      "Pazarkaşı Mah",
      "Saray Mah",
      "Say Mah",
      "Toros Mah",
      "Yeni Mah",
      "Ayaştürkmenli Mah",
      "Bahçe Mah",
      "Bahçederesi Mah",
      "Balandız Mah",
      "Bayındır Mah",
      "Bolacalıkoyuncu Mah",
      "Burunucu Mah",
      "Bükdeğirmeni Mah",
      "Canbazlı Mah",
      "Cılbayır Mah",
      "Çadırlı Mah",
      "Çaltıbozkır Mah",
      "Çamlıbel Mah",
      "Çamlıca Mah",
      "Çatak Mah",
      "Çeltikçi Mah",
      "Demircili Mah",
      "Ekşiler Mah",
      "Evkafçiftliği Mah",
      "Gedikpınarı Mah",
      "Gökbelen Mah",
      "Gülümpaşalı Mah",
      "Gündüzler Mah",
      "Hırmanlı Mah",
      "Hüseyinler Mah",
      "Işıklı Mah",
      "İmambekirli Mah",
      "İmamlı Mah",
      "İmamuşağı Mah",
      "Karahacılı Mah",
      "Karakaya Mah",
      "Kargıcak Mah",
      "Kavak Mah",
      "Keben Mah",
      "Kepez Mah",
      "Keşlitürkmenli Mah",
      "Kıca Mah",
      "Kırtıl Mah",
      "Kızılgeçit Mah",
      "Kocaoluk Mah",
      "Kocapınar Mah",
      "Kurtuluş Mah",
      "Mara Mah",
      "Narlıkuyu Mah",
      "Nasrullah Mah",
      "Nuru Mah",
      "Ortaören Mah",
      "Ovacık Mah",
      "Ören Mah",
      "Özboynuinceli Mah",
      "Öztürkmenli Mah",
      "Pelitpınarı Mah",
      "Sabak Mah",
      "Sarıaydın Mah",
      "Senir Mah",
      "Seydili Mah",
      "Seyranlık Mah",
      "Sökün Mah",
      "Sömek Mah",
      "Şahmurlu Mah",
      "Tosmurlu Mah",
      "Tosmurlu Osb Mah",
      "Türkmenuşağı Mah",
      "Ulugöz Mah",
      "Uşakpınarı Mah",
      "Uzuncaburç Mah",
      "Yeğenli Mah",
      "Yenibahçe Mah",
      "Yenisu Mah",
      "Akdere Mah",
      "Taşucu Mah",
      "Yeşilovacık Mah"
    ],
    "Tarsus": [
      "82evler Mah",
      "Çağlayan Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Tekke Mah",
      "Akşemsettin Mah",
      "Kırklarsırtı Mah",
      "Şehitler Tepesi Mah",
      "Yeni Mah",
      "Altaylılar Mah",
      "Atatürk Mah",
      "Bağlar Mah",
      "Ergenekon Mah",
      "Gaziler Mah",
      "Anıt Mah",
      "Gazipaşa Mah",
      "Mithatpaşa Mah",
      "Akçakocalı Mah",
      "Aladağ Mah",
      "Alifakı Mah",
      "Arıklı Mah",
      "Avadan Mah",
      "Ballıca Mah",
      "Baltalı Mah",
      "Büyükkösebalcı Mah",
      "Camilimanda Mah",
      "Cırbıklar Mah",
      "Çağbaşı Mah",
      "Çiçekli Mah",
      "Esenler Mah",
      "Eskişehir Mah",
      "Günyurdu Mah",
      "Hacıbozan Mah",
      "Heleke Mah",
      "İncirgediği Mah",
      "İncirlikuyu Mah",
      "Kanberhüyüğü Mah",
      "Karaçerçili Mah",
      "Karayayla Mah",
      "Kargılı Mah",
      "Karsavran Mah",
      "Kocaköy Mah",
      "Konaklar Mah",
      "Kösebalcı Mah",
      "Kumdere Mah",
      "Kütüklü Mah",
      "Mahmutağa Mah",
      "Muratlı Mah",
      "Nemiroğlu Mah",
      "Özlüce Mah",
      "Simithacılı Mah",
      "Tekeliören Mah",
      "Tepeçaylak Mah",
      "Topçu Mah",
      "Verimli Mah",
      "Yunusoğlu Mah",
      "Yüksek Mah",
      "Bahçe Mah",
      "Barbaros Mah",
      "Girne Mah",
      "Şahin Mah",
      "Yeşil Mah",
      "Yeşilevler Mah",
      "Yunus Emre Mah",
      "Beydeğirmeni Mah",
      "Fahrettin Paşa Mah",
      "Ferahimşalvuz Mah",
      "Kemalpaşa Mah",
      "Tozkoparan Zahit Mah",
      "Yarbay Şemsettin Mah",
      "Caminur Mah",
      "Eski Ömerli Mah",
      "Hürriyet Mah",
      "Reşadiye Mah",
      "Şehitkerim Mah",
      "Yeni Ömerli Mah",
      "Yeşilyurt Mah",
      "Belen Mah",
      "Beylice Mah",
      "Boztepe Mah",
      "Böğrüeğri Mah",
      "Cin Mah",
      "Çakırlı Mah",
      "Çavdarlı Mah",
      "Çiriştepe Mah",
      "Dedeler Mah",
      "Dorak Mah",
      "İbrişim Mah",
      "Kaklıktaşı Mah",
      "Kaleburcu Mah",
      "Karadiken Mah",
      "Karadirlik Mah",
      "Kerimler Mah",
      "Meşelik Mah",
      "Pirömerli Mah",
      "Sarıveli Mah",
      "Sayköy Mah",
      "Sucular Mah",
      "Takbaş Mah",
      "Taşçılı Mah",
      "Taşkuyu Mah",
      "Tepeköy Mah",
      "Tepetaşpınar Mah",
      "Topaklı Mah",
      "Ulaş Mah",
      "Yalamık Mah",
      "Kavaklı Mah",
      "Şehitishak Mah",
      "Cumhuriyet Mah",
      "Duatepe Mah",
      "Gözlükule Mah",
      "İsmetpaşa Mah",
      "Kızılmurat Mah",
      "Öğretmenler Mah",
      "Şehitmustafa Mah",
      "Yenice Mah",
      "Ağzıdelik Mah",
      "Akarsu Mah",
      "Aliağa Mah",
      "Aliefendioğlu Mah",
      "Atalar Mah",
      "Baharlı Mah",
      "Bahşiş Mah",
      "Çamtepe Mah",
      "Çatalca Mah",
      "Çöplü Mah",
      "Egemen Mah",
      "Halitağa Mah",
      "Hasanağa Mah",
      "Kefeli Mah",
      "Kelahmet Mah",
      "Köselerli Mah",
      "Kulak Mah",
      "Kurbanlı Mah",
      "Mantaş Mah",
      "Özbek Mah",
      "Sağlıklı Mah",
      "Yaramış Mah",
      "Yeniçay Mah",
      "Yeşiltepe Mah",
      "Akgedik Mah",
      "Alibeyli Mah",
      "Ardıçlı Mah",
      "Boğazpınar Mah",
      "Bolatlı Mah",
      "Çamalan B.m Mah",
      "Çavuşlu Mah",
      "Çevreli Mah",
      "Çiftlik Mah",
      "Çokak Mah",
      "Çukurbağ Mah",
      "Dadalı Mah",
      "Damlama Mah",
      "Eminlik Mah",
      "Emirler Mah",
      "Göçük Mah",
      "Gömmece Mah",
      "Gülek Mah",
      "Hacıhamzalı Mah",
      "İnköy Mah",
      "Kaburgediği Mah",
      "Kadelli Mah",
      "Karakütük Mah",
      "Kayadibi Mah",
      "Keşli Mah",
      "Kırıt Mah",
      "Kızılçukur Mah",
      "Koçmarlı Mah",
      "Kozoluk Mah",
      "Körlü Beyi Mah",
      "Kurtçukuru Mah",
      "Kuşçular Mah",
      "Olukkoyağı Mah",
      "Sandal Mah",
      "Sanlıca Mah",
      "Sıraköy Mah",
      "Taşobası Mah",
      "Yanıkkışla Mah",
      "Yazlık Mah",
      "Yeniköy Mah"
    ],
    "Toroslar": [
      "Akbelen Mah",
      "Osmaniye Mah",
      "Yusuf Kılıç Mah",
      "Zeki Ayan Mah",
      "Aladağ Mah",
      "Alanyalı Mah",
      "Arslanköy Mah",
      "Ayvagediği Mah",
      "Bekiralanı Mah",
      "Buluklu Mah",
      "Çağlarca Mah",
      "Çamlıdere Mah",
      "Çandır Mah",
      "Çelebili Mah",
      "Çopurlu Mah",
      "Dalakdere Mah",
      "Darısekisi Mah",
      "Değirmendere Mah",
      "Değnek Mah",
      "Doruklu Mah",
      "Düğdüören Mah",
      "Evrenli Mah",
      "Gözne Mah",
      "Güzelyayla Mah",
      "Hamzabeyli Mah",
      "Horozlu Mah",
      "Işıktepe Mah",
      "Karaisalı Mah",
      "Kaşlı Mah",
      "Kavaklıpınar Mah",
      "Kayrakkeşli Mah",
      "Kepirli Mah",
      "Kerimler Mah",
      "Kızılkaya Mah",
      "Korucular Mah",
      "Kurudere Mah",
      "Musalı Mah",
      "Resulköy Mah",
      "Sadiye Mah",
      "Soğucak Mah",
      "Şahinpınarı Mah",
      "Tırtar Mah",
      "Yavca Mah",
      "Yeniköy Mah",
      "Yüksekoluk Mah",
      "Çağdaşkent Mah",
      "Çavuşlu Mah",
      "Çukurova Mah",
      "Korukent Mah",
      "Alsancak Mah",
      "Demirtaş Mah",
      "Hüseyin Okan Merzeci Mah",
      "Mustafa Kemal Mah",
      "Portakal Mah",
      "Turgut Türkalp Mah",
      "Turunçlu Mah",
      "Arpaçsakarlar Mah",
      "Güneykent Mah",
      "Halkkent Mah",
      "Yalınayak Mah",
      "Mithat Toroğlu Mah",
      "Sağlık Mah",
      "Tozkoparan Mah",
      "Kurdali Mah",
      "Mevlana Mah",
      "Selçuklar Mah",
      "Toroslar Mah"
    ],
    "Yenişehir": [
      "50. Yıl Mah",
      "Deniz Mah",
      "Fuatmorel Mah",
      "Gökçebelen Mah",
      "Kocavilayet Mah",
      "Kuzeykent Mah",
      "Aydınlıkevler Mah",
      "Bahçelievler Mah",
      "Dumlupınar Mah",
      "Gazi Mah",
      "Güvenevler Mah",
      "İnönü Mah",
      "Akkent Mah",
      "Barbaros Mah",
      "Batıkent Mah",
      "Çiftlikköy Mah",
      "Eğriçam Mah",
      "Menteş Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Limonluk Mah",
      "Palmiye Mah",
      "Pirireis Mah",
      "Çavak Mah",
      "Çukurkeşli Mah",
      "Değirmençay Mah",
      "Emirler Mah",
      "İnsu Mah",
      "Karahacılı Mah",
      "Kocahamzalı Mah",
      "Turunçlu Mah",
      "Uzunkaş Mah"
    ]
  },
  "İstanbul": {
    "Adalar": [
      "Burgazada Mah",
      "Maden Mah",
      "Nizam Mah",
      "Heybeliada Mah",
      "Kınalıada Mah"
    ],
    "Arnavutköy": [
      "Anadolu Mah",
      "Arnavutköy Merkez Mah",
      "İmrahor Mah",
      "İslambey Mah",
      "Mustafa Kemal Paşa Mah",
      "Nenehatun Mah",
      "Yavuz Selim Mah",
      "Adnan Menderes Mah",
      "Baklalı Mah",
      "Balaban Mah",
      "Boyalık Mah",
      "Çilingir Mah",
      "Dursunköy Mah",
      "Durusu Mah",
      "Fatih Mah",
      "Hacımaşlı Mah",
      "Karaburun Mah",
      "Sazlıbosna Mah",
      "Tayakadın Mah",
      "Terkos Mah",
      "Yassıören Mah",
      "Yeniköy Mah",
      "Atatürk Mah",
      "Boğazköy İstiklal Mah",
      "Yunus Emre Mah",
      "Bolluca Mah",
      "Hicret Mah",
      "Mavigöl Mah",
      "Deliklikaya Mah",
      "Hadımköy Mah",
      "Hastane Mah",
      "Ömerli Mah",
      "Yeşilbayır Mah",
      "Haraççı Mah",
      "Karlıbayır Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Mehmet Akif Ersoy Mah",
      "Taşoluk Mah"
    ],
    "Ataşehir": [
      "Atatürk Mah",
      "Ferhatpaşa Mah",
      "İçerenköy Mah",
      "İnönü Mah",
      "Kayışdağı Mah",
      "Küçükbakkalköy Mah",
      "Aşıkveysel Mah",
      "Mustafa Kemal Mah",
      "Esatpaşa Mah",
      "Fetih Mah",
      "Örnek Mah",
      "Mevlana Mah",
      "Mimar Sinan Mah",
      "Yeni Çamlıca Mah",
      "Yenişehir Mah",
      "Barbaros Mah",
      "Yenisahra Mah"
    ],
    "Avcılar": [
      "Ambarlı Mah",
      "Denizköşkler Mah",
      "Cihangir Mah",
      "Merkez Mah",
      "Firuzköy Mah",
      "Yeşilkent Mah",
      "Gümüşpala Mah",
      "Mustafa Kemalpaşa Mah",
      "Tahtakale Mah",
      "Üniversite Mah"
    ],
    "Bağcılar": [
      "Barbaros Mah",
      "Çınar Mah",
      "Fevzi Çakmak Mah",
      "İnönü Mah",
      "Kazım Karabekir Mah",
      "Merkez Mah",
      "Sancaktepe Mah",
      "Yavuz Selim Mah",
      "Yenigün Mah",
      "Yıldıztepe Mah",
      "15 Temmuz Mah",
      "Bağlar Mah",
      "Güneşli Mah",
      "Hürriyet Mah",
      "Kirazlı Mah",
      "Yenimahalle Mah",
      "100. Yıl Mah",
      "Demirkapı Mah",
      "Fatih Mah",
      "Göztepe Mah",
      "Kemalpaşa Mah",
      "Mahmutbey Mah"
    ],
    "Bahçelievler": [
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Siyavuşpaşa Mah",
      "Soğanlı Mah",
      "Hürriyet Mah",
      "Kocasinan Merkez Mah",
      "Şirinevler Mah",
      "Çobançeşme Mah",
      "Fevzi Çakmak Mah",
      "Yenibosna Merkez Mah",
      "Zafer Mah"
    ],
    "Bakırköy": [
      "Ataköy 1. Kısım Mah",
      "Ataköy 2-5-6. Kısım Mah",
      "Ataköy 3-4-11. Kısım Mah",
      "Ataköy 7-8-9-10. Kısım Mah",
      "Cevizlik Mah",
      "Sakızağacı Mah",
      "Yenimahalle Mah",
      "Basınköy Mah",
      "Şenlikköy Mah",
      "Kartaltepe Mah",
      "Osmaniye Mah",
      "Yeşilköy Mah",
      "Yeşilköy Sb Mah",
      "Yeşilyurt Mah",
      "Zeytinlik Mah",
      "Zuhuratbaba Mah"
    ],
    "Başakşehir": [
      "Altınşehir Mah",
      "Güvercintepe Mah",
      "Kayabaşı Mah",
      "Şahintepe Mah",
      "Bahçeşehir 1. Kısım Mah",
      "Bahçeşehir 2. Kısım Mah",
      "Başak Mah",
      "Başakşehir Mah",
      "İkitelli Osb Mah",
      "Ziya Gökalp Mah",
      "Şamlar Mah"
    ],
    "Bayrampaşa": [
      "Altıntepsi Mah",
      "Terazidere Mah",
      "Vatan Mah",
      "İsmet Paşa Mah",
      "Kartaltepe Mah",
      "Muratpaşa Mah",
      "Orta Mah",
      "Yenidoğan Mah",
      "Cevatpaşa Mah",
      "Kocatepe Mah",
      "Yıldırım Mah"
    ],
    "Beşiktaş": [
      "Abbasağa Mah",
      "Cihannüma Mah",
      "Sinanpaşa Mah",
      "Akat Mah",
      "Arnavutköy Mah",
      "Kuruçeşme Mah",
      "Bebek Mah",
      "Etiler Mah",
      "Balmumcu Mah",
      "Dikilitaş Mah",
      "Gayrettepe Mah",
      "Yıldız Mah",
      "Kültür Mah",
      "Levazım Mah",
      "Nisbetiye Mah",
      "Ulus Mah",
      "Konaklar Mah",
      "Levent Mah",
      "Mecidiye Mah",
      "Ortaköy Mah",
      "Muradiye Mah",
      "Türkali Mah",
      "Vişnezade Mah"
    ],
    "Beykoz": [
      "Anadolu Hisarı Mah",
      "Kanlıca Mah",
      "Kavacık Mah",
      "Gümüşsuyu Mah",
      "Merkez Mah",
      "Yalıköy Mah",
      "Baklacı Mah",
      "Çengeldere Mah",
      "Çiftlik Mah",
      "Fatih Mah",
      "Yavuz Selim Mah",
      "Çubuklu Mah",
      "Rüzgarlıbahçe Mah",
      "Göksu Mah",
      "Göztepe Mah",
      "Yeni Mahalle Mah",
      "Acarlar Mah",
      "Çiğdem Mah",
      "İncirköy Mah",
      "Paşabahçe Mah",
      "Soğuksu Mah",
      "Alibahadır Mah",
      "Anadolufeneri Mah",
      "Bozhane Mah",
      "Cumhuriyet Mah",
      "Göllü Mah",
      "İshaklı Mah",
      "Kaynarca Mah",
      "Kılıçlı Mah",
      "Mahmutşevketpaşa Mah",
      "Öğümce Mah",
      "Paşamandıra Mah",
      "Polonezköy Mah",
      "Poyrazköy Mah",
      "Riva Mah",
      "Zerzavatçı Mah",
      "Akbaba Mah",
      "Anadolu Kavağı Mah",
      "Çamlıbahçe Mah",
      "Dereseki Mah",
      "Elmalı Mah",
      "Görele Mah",
      "Ortaçeşme Mah",
      "Örnekköy Mah",
      "Tokatköy Mah"
    ],
    "Beylikdüzü": [
      "Barış Mah",
      "Büyükşehir Mah",
      "Cumhuriyet Mah",
      "Kavaklı Mah",
      "Adnan Kahveci Mah",
      "Dereağzı Mah",
      "Gürpınar Mah",
      "Beylikdüzüosb Mah",
      "Marmara Mah",
      "Sahil Mah",
      "Yakuplu Mah"
    ],
    "Beyoğlu": [
      "Arap Cami Mah",
      "Bereketzade Mah",
      "Emekyemez Mah",
      "Şahkulu Mah",
      "Cihangir Mah",
      "Katipmustafa Çelebi Mah",
      "Kılıçali Paşa Mah",
      "Kuloğlu Mah",
      "Tomtom Mah",
      "Fetihtepe Mah",
      "Halıcıoğlu Mah",
      "Keçeci Piri Mah",
      "Örnektepe Mah",
      "Piripaşa Mah",
      "Sütlüce Mah",
      "Asmalı Mescit Mah",
      "Çatma Mescit Mah",
      "Evliya Çelebi Mah",
      "Bedrettin Mah",
      "Camiikebir Mah",
      "Hacıahmet Mah",
      "İstiklal Mah",
      "Kadımehmet Efendi Mah",
      "Kaptanpaşa Mah",
      "Kulaksız Mah",
      "Küçük Piyale Mah",
      "Piyalepaşa Mah",
      "Yahya Kahya Mah",
      "Firuzağa Mah",
      "Hacımimi Mah",
      "Kemankeş Karamustafapaşa Mah",
      "Müeyyetzade Mah",
      "Ömer Avni Mah",
      "Pürtelaş Hasan Efendi Mah",
      "Gümüşsuyu Mah",
      "Kocatepe Mah",
      "Bostan Mah",
      "Bülbül Mah",
      "Çukur Mah",
      "Hüseyinağa Mah",
      "Kalyoncu Kulluğu Mah",
      "Kamer Hatun Mah",
      "Sururi Mehmet Efendi Mah",
      "Şehit Muhtar Mah",
      "Yenişehir Mah"
    ],
    "Büyükçekmece": [
      "19 Mayıs Mah",
      "Alkent 2000 Mah",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Çakmaklı Mah",
      "Dizdariye Mah",
      "Fatih Mah",
      "Karaağaç Mah",
      "Pınartepe Mah",
      "Celaliye Mah",
      "Kamiloba Mah",
      "Bahçelievler Mah",
      "Güzelce Mah",
      "Kumburgaz Mah",
      "Yenimahalle Mah",
      "Ekinoba Mah",
      "Mimaroba Mah",
      "Mimarsinan Mah",
      "Murat Çesme Mah",
      "Sinanoba Mah",
      "Ahmediye Mah",
      "Hürriyet Mah",
      "Türkoba Mah",
      "Ulus Mah"
    ],
    "Çatalca": [
      "Akalan Mah",
      "Atatürk Mah",
      "Aydınlar Mah",
      "Bahşayiş Mah",
      "Başak Mah",
      "Belgrat Mah",
      "Celepköy Mah",
      "Çakıl Mah",
      "Çanakça Mah",
      "Çiftlikköy Mah",
      "Dağyenice Mah",
      "Elbasan Mah",
      "Fatih Mah",
      "Ferhatpaşa Mah",
      "Ferhatpaşa Sb Mah",
      "Gökçeali Mah",
      "Gümüşpınar Mah",
      "Hallaçlı Mah",
      "Hisarbeyli Mah",
      "İhsaniye Mah",
      "İnceğiz Mah",
      "İzzettin Mah",
      "Kabakça Mah",
      "Kaleiçi Mah",
      "Kalfa Mah",
      "Karacaköy Merkez Mah",
      "Karamandere Mah",
      "Kestanelik Mah",
      "Kızılcaali Mah",
      "Muratbey Merkez Mah",
      "Nakkaş Mah",
      "Oklalı Mah",
      "Ormanlı Mah",
      "Ovayenice Mah",
      "Örcünlü Mah",
      "Örencik Mah",
      "Subaşı Mah",
      "Yalıköy Mah",
      "Yaylacık Mah",
      "Yazlık Mah"
    ],
    "Çekmeköy": [
      "Alemdağ Mah",
      "Çatalmeşe Mah",
      "Ekşioğlu Mah",
      "Nişantepe Mah",
      "Çamlık Mah",
      "Hamidiye Mah",
      "Mehmet Akif Mah",
      "Merkez Mah",
      "Mimar Sinan Mah",
      "Hüseyinli Mah",
      "Koçullu Mah",
      "Ömerli Mah",
      "Reşadiye Mah",
      "Sırapınar Mah",
      "Aydınlar Mah",
      "Cumhuriyet Mah",
      "Güngören Mah",
      "Kirazlıdere Mah",
      "Soğukpınar Mah",
      "Sultançiftliği Mah",
      "Taşdelen Mah"
    ],
    "Esenler": [
      "15 Temmuz Mah",
      "Birlik Mah",
      "Havaalanı Mah",
      "Kemer Mah",
      "Çifte Havuzlar Mah",
      "Davutpaşa Mah",
      "Fevzi Çakmak Mah",
      "Mimar Sinan Mah",
      "Namık Kemal Mah",
      "Nine Hatun Mah",
      "Yavuz Selim Mah",
      "Fatih Mah",
      "Kazım Karabekir Mah",
      "Menderes Mah",
      "Tuna Mah",
      "Oruçreis Mah",
      "Turgut Reis Mah"
    ],
    "Esenyurt": [
      "Bağlarçeşme Mah",
      "Çınar Mah",
      "Örnek Mah",
      "Pınar Mah",
      "Selahaddin Eyyubi Mah",
      "Akşemseddin Mah",
      "Ardıçlı Mah",
      "Balıkyolu Mah",
      "İncirtepe Mah",
      "İnönü Mah",
      "Sultaniye Mah",
      "Süleymaniye Mah",
      "Yenikent Mah",
      "Yunus Emre Mah",
      "Atatürk Mah",
      "Barbaros Hayrettin Paşa Mah",
      "Battalgazi Mah",
      "Gökevler Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Necip Fazıl Kısakürek Mah",
      "Şehitler Mah",
      "Cumhuriyet Mah",
      "Güzelyurt Mah",
      "Mehmet Akif Ersoy Mah",
      "Mehterçeşme Mah",
      "Mevlana Mah",
      "Piri Reis Mah",
      "Yeşilkent Mah",
      "Akevler Mah",
      "Fatih Mah",
      "Namık Kemal Mah",
      "Saadetdere Mah",
      "Talatpaşa Mah",
      "Turgut Özal Mah",
      "Üçevler Mah",
      "Zafer Mah",
      "Akçaburgaz Mah",
      "Aşık Veysel Mah",
      "Esenkent Mah",
      "Koza Mah",
      "Orhan Gazi Mah",
      "Osmangazi Mah"
    ],
    "Eyüpsultan": [
      "5.levent Mah",
      "Alibeyköy Mah",
      "Emniyettepe Mah",
      "Güzeltepe Mah",
      "Akşemsettin Mah",
      "Çırçır Mah",
      "Defterdar Mah",
      "İslambey Mah",
      "Merkez Mah",
      "Nişancı Mah",
      "Sakarya Mah",
      "Silahtarağa Mah",
      "Göktürk Merkez Mah",
      "Ağaçlı Mah",
      "Akpınar Mah",
      "Çiftalan Mah",
      "Işıklar Mah",
      "İhsaniye Mah",
      "Odayeri Mah",
      "Pirinççi Mah",
      "Mimar Sinan Mah",
      "Mithatpaşa Mah",
      "Düğmeciler Mah",
      "Rami Cuma Mah",
      "Rami Yeni Mah",
      "Topçular Mah",
      "Esentepe Mah",
      "Karadolap Mah",
      "Yeşilpınar Mah"
    ],
    "Fatih": [
      "Aksaray Mah",
      "Haseki Sultan Mah",
      "Atikali Mah",
      "Ayvansaray Mah",
      "Balat Mah",
      "Derviş Ali Mah",
      "Beyazıt Mah",
      "Emin Sinan Mah",
      "Mimar Hayrettin Mah",
      "Şehsuvar Bey Mah",
      "Alemdar Mah",
      "Hocapaşa Mah",
      "Akşemsettin Mah",
      "İskenderpaşa Mah",
      "Hırka-i Şerif Mah",
      "Karagümrük Mah",
      "Cerrahpaşa Mah",
      "Koca Mustafapaşa Mah",
      "Seyyid Ömer Mah",
      "Katip Kasım Mah",
      "Mesihpaşa Mah",
      "Mimar Kemalettin Mah",
      "Muhsine Hatun Mah",
      "Nişanca Mah",
      "Saraç İshak Mah",
      "Molla Fenari Mah",
      "Sururi Mah",
      "Taya Hatun Mah",
      "Hobyar Mah",
      "Binbirdirek Mah",
      "Cankurtaran Mah",
      "Küçük Ayasofya Mah",
      "Sultan Ahmet Mah",
      "Mevlanakapı Mah",
      "Şehremini Mah",
      "Mercan Mah",
      "Rüstempaşa Mah",
      "Süleymaniye Mah",
      "Tahtakale Mah",
      "Molla Gürani Mah",
      "Topkapı Mah",
      "Balabanağa Mah",
      "Demirtaş Mah",
      "Hacı Kadın Mah",
      "Hoca Gıyasettin Mah",
      "Kalenderhane Mah",
      "Kemalpaşa Mah",
      "Molla Hüsrev Mah",
      "Sarıdemir Mah",
      "Yavuz Sinan Mah",
      "Silivrikapı Mah",
      "Sümbül Efendi Mah",
      "Yedikule Mah",
      "Ali Kuşçu Mah",
      "Cibali Mah",
      "Yavuz Sultan Selim Mah",
      "Zeyrek Mah"
    ],
    "Gaziosmanpaşa": [
      "Bağlarbaşı Mah",
      "Merkez Mah",
      "Sarıgöl Mah",
      "Barbaros Hayrettin Paşa Mah",
      "Hürriyet Mah",
      "Karadeniz Mah",
      "Şemsipaşa Mah",
      "Yeni Mahalle Mah",
      "Fevzi Çakmak Mah",
      "Karayolları Mah",
      "Kazım Karabekir Mah",
      "Mevlana Mah",
      "Karlıtepe Mah",
      "Pazariçi Mah",
      "Yenidoğan Mah",
      "Yıldıztabya Mah"
    ],
    "Güngören": [
      "Akıncılar Mah",
      "Güven Mah",
      "Haznedar Mah",
      "Mareşal Çakmak Mah",
      "Güneştepe Mah",
      "Merkez Mah",
      "Gençosman Mah",
      "Sanayi Mah",
      "Abdurrahman Nafiz Gürman Mah",
      "Mehmet Nesih Özmen Mah",
      "Tozkoparan Mah"
    ],
    "Kadıköy": [
      "Bostancı Mah",
      "Caddebostan Mah",
      "Caferağa Mah",
      "Eğitim Mah",
      "Hasanpaşa Mah",
      "Erenköy Mah",
      "Fenerbahçe Mah",
      "Feneryolu Mah",
      "Zühtüpaşa Mah",
      "Dumlupınar Mah",
      "Fikirtepe Mah",
      "Göztepe Mah",
      "Acıbadem Mah",
      "Koşuyolu Mah",
      "Kozyatağı Mah",
      "Merdivenköy Mah",
      "19 Mayıs Mah",
      "Osmanağa Mah",
      "Rasimpaşa Mah",
      "Sahrayıcedit Mah",
      "Suadiye Mah"
    ],
    "Kağıthane": [
      "Çağlayan Mah",
      "Hürriyet Mah",
      "Çeliktepe Mah",
      "Ortabayır Mah",
      "Gültepe Mah",
      "Harmantepe Mah",
      "Telsizler Mah",
      "Yahya Kemal Mah",
      "Gürsel Mah",
      "Mehmet Akif Ersoy Mah",
      "Talatpaşa Mah",
      "Hamidiye Mah",
      "Merkez Mah",
      "Nurtepe Mah",
      "Seyrantepe Mah",
      "Yeşilce Mah",
      "Emniyet Evleri Mah",
      "Sultan Selim Mah",
      "Şirintepe Mah"
    ],
    "Kartal": [
      "Atalar Mah",
      "Petrol İş Mah",
      "Esentepe Mah",
      "Karlıktepe Mah",
      "Kordonboyu Mah",
      "Yukarı Mah",
      "Cevizli Mah",
      "Orhantepe Mah",
      "Gümüşpınar Mah",
      "Orta Mah",
      "Soğanlık Yeni Mah",
      "Çavuşoğlu Mah",
      "Topselvi Mah",
      "Yalı Mah",
      "Yunus Mah",
      "Uğur Mumcu Mah",
      "Yakacık Yeni Mah",
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Yakacık Çarşı Mah"
    ],
    "Küçükçekmece": [
      "Atakent Mah",
      "Atatürk Mah",
      "Küçükçekmece İkitelliosb Mah",
      "Mehmet Akif Mah",
      "Halkalı Merkez Mah",
      "İstasyon Mah",
      "Yarımburgaz Mah",
      "Cennet Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Kanarya Mah",
      "Yeni Mahalle Mah",
      "Beşyol Mah",
      "Fevzi Çakmak Mah",
      "Gültepe Mah",
      "İnönü Mah",
      "Kartaltepe Mah",
      "Kemalpaşa Mah",
      "Söğütlü Çeşme Mah",
      "Sultan Murat Mah",
      "Tevfikbey Mah",
      "Yeşilova Mah"
    ],
    "Maltepe": [
      "Aydınevler Mah",
      "Başıbüyük Mah",
      "Fındıklı Mah",
      "Büyükbakkalköy Mah",
      "Cevizli Mah",
      "Altayçeşme Mah",
      "Feyzullah Mah",
      "Esenkent Mah",
      "Gülensu Mah",
      "Gülsuyu Mah",
      "Çınar Mah",
      "İdealtepe Mah",
      "Altıntepe Mah",
      "Küçükyalı Merkez Mah",
      "Bağlarbaşı Mah",
      "Yalı Mah",
      "Girne Mah",
      "Zümrütevler Mah"
    ],
    "Pendik": [
      "Bahçelievler Mah",
      "Sapan Bağları Mah",
      "Yeni Mah",
      "Yeşilbağlar Mah",
      "Çamçeşme Mah",
      "Esenler Mah",
      "Fevzi Çakmak Mah",
      "Kavakpınar Mah",
      "Batı Mah",
      "Doğu Mah",
      "Kaynarca Mah",
      "Çınardere Mah",
      "Dumlupınar Mah",
      "Orta Mah",
      "Velibaba Mah",
      "Ahmet Yesevi Mah",
      "Esenyalı Mah",
      "Fatih Mah",
      "Güzelyalı Mah",
      "Orhangazi Mah",
      "Ballıca Mah",
      "Emirli Mah",
      "Göçbeyli Mah",
      "Kurna Mah",
      "Kurtdoğmuş Mah",
      "Güllü Bağlar Mah",
      "Ramazanoğlu Mah",
      "Sanayi Mah",
      "Şeyhli Mah",
      "Ertuğrul Gazi Mah",
      "Sülüntepe Mah",
      "Yayalar Mah",
      "Çamlık Mah",
      "Harmandere Mah",
      "Kurtköy Mah",
      "Yenişehir Mah"
    ],
    "Sancaktepe": [
      "Akpınar Mah",
      "Eyüp Sultan Mah",
      "Fatih Mah",
      "Veysel Karani Mah",
      "Abdurrahmangazi Mah",
      "Osmangazi Mah",
      "Atatürk Mah",
      "Emek Mah",
      "İnönü Mah",
      "Kemal Türkler Mah",
      "Meclis Mah",
      "Sarıgazi Mah",
      "Hilal Mah",
      "Merve Mah",
      "Mevlana Mah",
      "Paşaköy Mah",
      "Safa Mah",
      "Yenidoğan Mah",
      "Yunus Emre Mah"
    ],
    "Sarıyer": [
      "Bahçeköy Kemer Mah",
      "Bahçeköy Merkez Mah",
      "Bahçeköy Yeni Mah",
      "Büyükdere Mah",
      "Çayırbaşı Mah",
      "Kocataş Mah",
      "Ptt Evleri Mah",
      "Emirgan Mah",
      "Reşitpaşa Mah",
      "İstinye Mah",
      "Pınar Mah",
      "Poligon Mah",
      "Ayazağa Mah",
      "Huzur Mah",
      "Maslak Mah",
      "Baltalimanı Mah",
      "Fatih Sultan Mehmet Mah",
      "Rumelihisarı Mah",
      "Demirciköy Mah",
      "Garipçe Mah",
      "Gümüşdere Mah",
      "Kazım Karabekir Paşa Mah",
      "Kısırkaya Mah",
      "Kumköy  Mah (kilyos Mah)",
      "Maden Mah",
      "Rumelifeneri Mah",
      "Rumelikavağı Mah",
      "Sarıyer Merkez Mah",
      "Uskumruköy Mah",
      "Yeni Mah",
      "Zekeriyaköy Mah",
      "Cumhuriyet Mah",
      "Çamlıtepe Mah",
      "Darüşşafaka Mah",
      "Ferahevler Mah",
      "Kireçburnu Mah",
      "Tarabya Mah",
      "Yeniköy Mah"
    ],
    "Silivri": [
      "Beyciler Mah",
      "Büyük Çavuşlu Mah",
      "Büyük Sinekli Mah",
      "Çayırdere Mah",
      "Danamandıra Mah",
      "Küçük Sinekli Mah",
      "Sayalar Mah",
      "Çanta Balaban Mah",
      "Çanta Sancaktepe Mah",
      "Değirmenköy Fevzipaşa Mah",
      "Değirmenköy İsmetpaşa Mah",
      "Bekirli Mah",
      "Büyük Kılıçlı Mah",
      "Çeltik Mah",
      "Fener Mah",
      "Kurfallı Mah",
      "Küçük Kılıçlı Mah",
      "Seymen Mah",
      "Yolçatı Mah",
      "Gümüşyaka Mah",
      "Kavaklı Hürriyet Mah",
      "Kavaklı İstiklal Mah",
      "Akören Mah",
      "Gazitepe Mah",
      "Kadıköy Mah",
      "Ortaköy Mah",
      "Selimpaşa Mah",
      "Alibey Mah",
      "Alipaşa Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Mimar Sinan Mah",
      "Piri Mehmet Paşa Mah",
      "Semizkumlar Mah",
      "Yeni Mah"
    ],
    "Sultanbeyli": [
      "Abdurrahmangazi Mah",
      "Fatih Mah",
      "Hasanpaşa Mah",
      "Mehmet Akif Mah",
      "Adil Mah",
      "Battalgazi Mah",
      "Mimar Sinan Mah",
      "Akşemsettin Mah",
      "Hamidiye Mah",
      "Necip Fazıl Mah",
      "Orhangazi Mah",
      "Yavuz Selim Mah",
      "Ahmet Yesevi Mah",
      "Mecidiye Mah",
      "Turgut Reis Mah"
    ],
    "Sultangazi": [
      "50. Yıl Mah",
      "Cumhuriyet Mah",
      "Esentepe Mah",
      "Sultançiftliği Mah",
      "Uğur Mumcu Mah",
      "Cebeci Mah",
      "Eski Habipler Mah",
      "Habibler Mah",
      "İsmetpaşa Mah",
      "Malkoçoğlu Mah",
      "Yayla Mah",
      "75. Yıl Mah",
      "Gazi Mah",
      "Yunus Emre Mah",
      "Zübeyde Hanım Mah"
    ],
    "Şile": [
      "Ağva Merkez Mah",
      "Bucaklı Mah",
      "Çataklı Mah",
      "Çelebi Mah",
      "Geredeli Mah",
      "Göçe Mah",
      "Gökmaşlı Mah",
      "Göksu Mah",
      "Hacıllı Mah",
      "İsaköy Mah",
      "Kadıköy Mah",
      "Kalem Mah",
      "Kurfallı Mah",
      "Soğullu Mah",
      "Şuayipli Mah",
      "Ağaçdere Mah",
      "Ahmetli Mah",
      "Akçakese Mah",
      "Alacalı Mah",
      "Avcıkoru Mah",
      "Bıçkıdere Mah",
      "Bozgoca Mah",
      "Çayırbaşı Mah",
      "Çengilli Mah",
      "Darlık Mah",
      "Değirmençayırı Mah",
      "Doğancılı Mah",
      "Erenler Mah",
      "Esenceli Mah",
      "Hasanlı Mah",
      "İmrendere Mah",
      "İmrenli Mah",
      "Kabakoz Mah",
      "Karabeyli Mah",
      "Karacaköy Mah",
      "Karakiraz Mah",
      "Karamandere Mah",
      "Kervansaray Mah",
      "Kızılca Mah",
      "Korucu Mah",
      "Kömürlük Mah",
      "Kurna Mah",
      "Meşrutiyet Mah",
      "Oruçoğlu Mah",
      "Osmanköy Mah",
      "Ovacık Mah",
      "Sahilköy Mah",
      "Satmazlı Mah",
      "Sofular Mah",
      "Sortullu Mah",
      "Teke Mah",
      "Ulupelit Mah",
      "Üvezli Mah",
      "Yaka Mah",
      "Yaylalı Mah",
      "Yazımanayır Mah",
      "Yeniköy Mah",
      "Yeşilvadi Mah",
      "Balibey Mah",
      "Çavuş Mah",
      "Hacı Kasım Mah",
      "Kumbaba Mah"
    ],
    "Şişli": [
      "Bozkurt Mah",
      "Eskişehir Mah",
      "Cumhuriyet Mah",
      "Duatepe Mah",
      "Paşa Mah",
      "Esentepe Mah",
      "Fulya Mah",
      "Gülbahar Mah",
      "Feriköy Mah",
      "Yayla Mah",
      "Halaskargazi Mah",
      "Harbiye Mah",
      "İzzet Paşa Mah",
      "Kuştepe Mah",
      "Mecidiyeköy Mah",
      "19 Mayıs Mah",
      "Meşrutiyet Mah",
      "Halide Edip Adıvar Mah",
      "Halil Rıfat Paşa Mah",
      "Kaptanpaşa Mah",
      "Mahmut Şevket Paşa Mah",
      "Merkez Mah",
      "Ergenekon Mah",
      "İnönü Mah",
      "Teşvikiye Mah"
    ],
    "Tuzla": [
      "Akfırat Mah",
      "Tepeoren İtosb Mah",
      "Tepeören Mah",
      "Aydınlı - Birlik Osb Mah",
      "Aydınlı - İstanbul Ayosb Mah",
      "Aydınlı Mah",
      "Aydınlı Sb Mah",
      "Aydınlı-kosb Mah",
      "Cami Mah",
      "İstasyon Mah",
      "Postane Mah",
      "Aydıntepe Mah",
      "İçmeler Mah",
      "Mimar Sinan Mah",
      "Şifa Mah",
      "Anadolu Mah",
      "Deri Osb Mah",
      "Fatih Mah",
      "Mescit Mah",
      "Orhanlı Mah",
      "Orta Mah",
      "Evliya Çelebi Mah",
      "Yayla Mah"
    ],
    "Ümraniye": [
      "Adem Yavuz Mah",
      "Aşağı Dudullu Mah",
      "Huzur Mah",
      "Necip Fazıl Mah",
      "Parseller Mah",
      "Armağanevler Mah",
      "Atakent Mah",
      "Finanskent Mah",
      "Site Mah",
      "Yenişehir Mah",
      "Atatürk Mah",
      "Elmalıkent Mah",
      "Tantavi Mah",
      "Çakmak Mah",
      "Çamlık Mah",
      "Mehmet Akif Mah",
      "Tatlısu Mah",
      "Esenkent Mah",
      "Esenşehir Mah",
      "Madenler Mah",
      "Cemil Meriç Mah",
      "Fatih Sultan Mehmet Mah",
      "Ihlamurkuyu Mah",
      "Tepeüstü Mah",
      "İnkılap Mah",
      "Saray Mah",
      "Yamanevler Mah",
      "Dumlupınar Mah",
      "Hekimbaşı Mah",
      "Kazım Karabekir Mah",
      "Topağacı Mah",
      "Esenevler Mah",
      "İstiklal Mah",
      "Namık Kemal Mah",
      "Altınşehir Mah",
      "Dudullu Osb Mah",
      "Şerifali Mah",
      "Yukarı Dudullu Mah"
    ],
    "Üsküdar": [
      "Acıbadem Mah",
      "Altunizade Mah",
      "Barbaros Mah",
      "Bahçelievler Mah",
      "Beylerbeyi Mah",
      "Burhaniye Mah",
      "Küplüce Mah",
      "Bulgurlu Mah",
      "Küçük Çamlıca Mah",
      "Cumhuriyet Mah",
      "Çengelköy Mah",
      "Güzeltepe Mah",
      "Ferah Mah",
      "Kısıklı Mah",
      "Kandilli Mah",
      "Kuleli Mah",
      "Küçüksu Mah",
      "Kirazlıtepe Mah",
      "Mehmet Akif Ersoy Mah",
      "İcadiye Mah",
      "Kuzguncuk Mah",
      "Sultantepe Mah",
      "Ahmediye Mah",
      "Aziz Mahmut Hüdayi Mah",
      "Mimar Sinan Mah",
      "Muratreis Mah",
      "Selami Ali Mah",
      "Valide-i Atik Mah",
      "Salacak Mah",
      "Selimiye Mah",
      "Zeynep Kamil Mah",
      "Ünalan Mah",
      "Yavuztürk Mah"
    ],
    "Zeytinburnu": [
      "Çırpıcı Mah",
      "Nuripaşa Mah",
      "Sümer Mah",
      "Veliefendi Mah",
      "Yeşiltepe Mah",
      "Merkezefendi Mah",
      "Seyitnizam Mah",
      "Beştelsiz Mah",
      "Gökalp Mah",
      "Kazlıçeşme Mah",
      "Telsiz Mah",
      "Yenidoğan Mah",
      "Maltepe Mah"
    ]
  },
  "İzmir": {
    "Aliağa": [
      "Aşağışakran Mah",
      "Atatürk Mah",
      "B.hayrettin Paşa Mah",
      "Bahçedere Mah",
      "Bozköy Mah",
      "Çakmaklı Mah",
      "Çaltılıdere Mah",
      "Çıtak Mah",
      "Çoraklar Mah",
      "Güzelhisar Mah",
      "Hacıömerli Mah",
      "Horozgediği Mah",
      "Kalabak Mah",
      "Kapukaya Mah",
      "Karaköy Mah",
      "Karakuzu Mah",
      "Kazım Dirik Mah",
      "Kurtuluş Mah",
      "Kültür Mah",
      "Mimar Sinan Mah",
      "Samurlu Mah",
      "Siteler Mah",
      "Şehitkemal Mah",
      "Uzunhasanlar Mah",
      "Yalı Mah",
      "Yeni Mah",
      "Yenişakran Mah",
      "Yukarı Şehitkemal Mah",
      "Yüksekköy Mah",
      "Fatih Mah"
    ],
    "Balçova": [
      "Bahçelerarası Mah",
      "Çetin Emeç Mah",
      "Eğitim Mah",
      "Fevzi Çakmak Mah",
      "İnciraltı Mah",
      "Korutürk Mah",
      "Onur Mah",
      "Teleferik Mah"
    ],
    "Bayındır": [
      "Alankıyı Mah",
      "Alanköy Mah",
      "Arıkbaşı Mah",
      "Balcılar Mah",
      "Bıyıklar Mah",
      "Buruncuk Mah",
      "Camii Mah",
      "Çamlıbel Mah",
      "Çenikler Mah",
      "Çınar Mah",
      "Çınardibi Mah",
      "Çiftçigediği Mah",
      "Demircilik Mah",
      "Dereköy Mah",
      "Dernekli Mah",
      "Elifli Mah",
      "Ergenli Mah",
      "Fatih Mah",
      "Fırınlı Mah",
      "Gaziler Mah",
      "Hacı Beşir Mah",
      "Hacı İbrahim Mah",
      "Hatay Mah",
      "Havuzbaşı Mah",
      "Hisarlık Mah",
      "Kabaağaç Mah",
      "Karahalilli Mah",
      "Karahayıt Mah",
      "Karapınar Mah",
      "Kızılcaağaç Mah",
      "Kızılcaova Mah",
      "Kızılkeçili Mah",
      "Kızıloba Mah",
      "Kurt Mah",
      "Lütuflar Mah",
      "Mithatpaşa Mah",
      "Orta Mah",
      "Osmanlar Mah",
      "Pınarlı Mah",
      "Sadıkpaşa Mah",
      "Sarıyurt Mah",
      "Söğütören Mah",
      "Tokatbaşı Mah",
      "Turan Mah",
      "Yakacık Mah",
      "Yakapınar Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yeşilova Mah",
      "Yusuflu Mah",
      "Zeytinova Mah",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Karaveliler Mah",
      "Çırpı Cami Mah",
      "Hasköy Mah",
      "İbrahimçavuş Mah",
      "Mektep Mah",
      "Necati Uza Mah"
    ],
    "Bayraklı": [
      "75. Yıl Mah",
      "Alpaslan Mah",
      "Cengizhan Mah",
      "Çiçek Mah",
      "Fuat Edip Baksı Mah",
      "Muhittin Erener Mah",
      "R.şevket İnce Mah",
      "Turan Mah",
      "Adalet Mah",
      "Bayraklı Mah",
      "Çay Mah",
      "Tepekule Mah",
      "Doğançay Mah",
      "Emek Mah",
      "Gümüşpala Mah",
      "Org.nafiz Gürman Mah",
      "Yamanlar Mah",
      "Manavkuyu Mah",
      "Mansuroğlu Mah",
      "Osmangazi Mah",
      "Körfez Mah",
      "Onur Mah",
      "Postacılar Mah",
      "Soğukkuyu Mah"
    ],
    "Bergama": [
      "Ahmetbeyler Mah",
      "Akçenger Mah",
      "Alacalar Mah",
      "Alhatlı Mah",
      "Alibeyli Mah",
      "Armağanlar Mah",
      "Aşağıbey Mah",
      "Aşağıcuma Mah",
      "Aşağıılgındere Mah",
      "Aşağıkırıklar Mah",
      "Atatürk Mah",
      "Atçılar Mah",
      "Atmaca Mah",
      "Avunduk Mah",
      "Avunduruk Mah",
      "Ayaskent Mah",
      "Ayvatlar Mah",
      "Aziziye Mah",
      "Bahçelievler Mah",
      "Balaban Mah",
      "Barbaros Mah",
      "Bayramcılar Mah",
      "Bekirler Mah",
      "Bergama Osb Mah",
      "Bozköy Mah",
      "Bozyerler Mah",
      "Bölcek Mah",
      "Cevaplı Mah",
      "Çakırlar Mah",
      "Çalıbahçe Mah",
      "Çaltıkoru Mah",
      "Çamavlu Mah",
      "Çamköy Mah",
      "Çamoba Mah",
      "Çeltikçi Mah",
      "Çitköy Mah",
      "Çobanlar Mah",
      "Çürükbağlar Mah",
      "Dağıstan Mah",
      "Demircidere Mah",
      "Dereköy Mah",
      "Doğancı Mah",
      "Durmuşlar Mah",
      "Eğiller Mah",
      "Eğrigöl Mah",
      "Ertuğrul Mah",
      "Fatih Mah",
      "Ferizler Mah",
      "Fevzipaşa Mah",
      "Gaylan Mah",
      "Gaziosmanpaşa Mah",
      "Gazipaşa Mah",
      "Göbeller Mah",
      "Göçbeyli Mah",
      "Gökçeyurt Mah",
      "Gültepe Mah",
      "Güneşli Mah",
      "Hacıhamzalar Mah",
      "Hacılar  Mah (dereköy Bucağı Mah)",
      "Hacılar  Mah (ismailli Bucağı Mah)",
      "Halilağalar Mah",
      "Hamzalısüleymaniye Mah",
      "Hisarköy Mah",
      "Ilgıncaber Mah",
      "İkizler Mah",
      "İncecikler Mah",
      "İneşir Mah",
      "İnkılap Mah",
      "İslamsaray Mah",
      "İsmailli Mah",
      "Kadıköy Mah",
      "Kadriye Mah",
      "Kaleardı Mah",
      "Kaplan  Mah (göçbeyli Bucağı Mah)",
      "Kaplan  Mah (yukarıbey Bucağı Mah)",
      "Kapukaya Mah",
      "Karahıdırlı Mah",
      "Karalar Mah",
      "Karaveliler Mah",
      "Kaşıkçı Mah",
      "Katrancı Mah",
      "Kıranlı Mah",
      "Kırcalar Mah",
      "Kızıltepe Mah",
      "Kocahaliller Mah",
      "Kocaköy Mah",
      "Koyuneli Mah",
      "Kozluca Mah",
      "Kurfallı Mah",
      "Kurtuluş Mah",
      "Mahmudiye Mah",
      "Maltepe Mah",
      "Maruflar Mah",
      "Muratlar Mah",
      "Narlıca Mah",
      "Okçular Mah",
      "Oruşlar Mah",
      "Ovacık Mah",
      "Öksüzler Mah",
      "Örenli Mah",
      "Örlemiş Mah",
      "Paşaköy Mah",
      "Pınarköy Mah",
      "Pireveliler Mah",
      "Rahmanlar Mah",
      "Sağancı Mah",
      "Sarıcalar Mah",
      "Sarıcaoğlu Mah",
      "Sarıdere Mah",
      "Seklik Mah",
      "Selçuk Mah",
      "Sindel Mah",
      "Süleymanlı Mah",
      "Talatpaşa Mah",
      "Tavukçukuru Mah",
      "Tekkedere Mah",
      "Tepeköy Mah",
      "Terzihaliller Mah",
      "Tırmanlar Mah",
      "Tiyelti Mah",
      "Topallar Mah",
      "Turabey Mah",
      "Ulucamii Mah",
      "Üçtepe Mah",
      "Ürkütler Mah",
      "Yalnızdam Mah",
      "Yalnızev Mah",
      "Yenikent Mah",
      "Yeniler Mah",
      "Yerlitahtacı Mah",
      "Yortanlı Mah",
      "Yukarıada Mah",
      "Yukarıbey Mah",
      "Yukarıcuma Mah",
      "Yukarıkırıklar Mah",
      "Zafer Mah",
      "Zağnoz Mah",
      "Zeytindağ Mah"
    ],
    "Beydağ": [
      "Adaküre Mah",
      "Aktepe Mah",
      "Alakeçili Mah",
      "Atatürk Mah",
      "Bakırköy Mah",
      "Beyköy Mah",
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Çiftlikköy Mah",
      "Çomaklar Mah",
      "Eğridere Mah",
      "Erikli Mah",
      "Halıköy Mah",
      "Karaoba Mah",
      "Kurudere Mah",
      "Menderes Mah",
      "Mutaflar Mah",
      "Palamutçuk Mah",
      "Sarıkaya Mah",
      "Tabaklar Mah",
      "Yağcılar Mah",
      "Yeniyurt Mah",
      "Yeşiltepe Mah",
      "Yukarıaktepe Mah",
      "Yukarıtosunlar Mah"
    ],
    "Bornova": [
      "Birlik Mah",
      "Çamkule Mah",
      "Koşukavak Mah",
      "Merkez Mah",
      "Serintepe Mah",
      "Yeşilova Mah",
      "Zafer Mah",
      "Atatürk Mah",
      "Evka 4 Mah",
      "İnönü Mah",
      "Kızılay Mah",
      "Beşyol Mah",
      "Çamiçi Mah",
      "Çiçekli Mah",
      "Eğridere Mah",
      "Ergene Mah",
      "Erzene Mah",
      "Gökdere Mah",
      "Karaçam Mah",
      "Kavaklıdere Mah",
      "Kayadibi Mah",
      "Kurudere Mah",
      "Laka Mah",
      "Sarnıçköy Mah",
      "Yakaköy Mah",
      "Barbaros Mah",
      "Çınar Mah",
      "Gazi Osman Paşa Mah",
      "Meriç Mah",
      "Rafet Paşa Mah",
      "Tuna Mah",
      "Yıldırım Beyazıt Mah",
      "Egemenlik Mah",
      "Işıklar Mah",
      "Karacaoğlan Mah",
      "Kazımdirik Mah",
      "Doğanlar Mah",
      "Evka 3 Mah",
      "Mevlana Mah",
      "Naldöken Mah",
      "Yeşilçam Mah",
      "Gürpınar Mah",
      "Kemalpaşa Mah",
      "Ümit Mah",
      "Yunus Emre Mah"
    ],
    "Buca": [
      "Atatürk Mah",
      "Belenbaşı Mah",
      "Buca Koop Mah",
      "Çamlıkule Mah",
      "Çamlıpınar Mah",
      "Doğancılar Mah",
      "Karacaağaç Mah",
      "Kaynaklar Merkez Mah",
      "Kırklar Mah",
      "Kozağaç Mah",
      "Kuruçeşme Mah",
      "Yenigün Mah",
      "Yıldız Mah",
      "Adatepe Mah",
      "Aydoğdu Mah",
      "Bucaosb Mah",
      "Cumhuriyet Mah",
      "Çağdaş Mah",
      "Dumlupınar Mah",
      "Gaziler Mah",
      "İzkent Mah",
      "Karanfil Mah",
      "Murathan Mah",
      "Şirinkapı Mah",
      "Yaylacık Mah",
      "Barış Mah",
      "Çaldıran Mah",
      "Çamlık Mah",
      "Dicle Mah",
      "Güven Mah",
      "Hürriyet Mah",
      "Laleli Mah",
      "Menderes Mah",
      "Ufuk Mah",
      "Yiğitler Mah",
      "29 Ekim Mah",
      "Yıldızlar Mah",
      "Zafer Mah",
      "Akıncılar Mah",
      "Efeler Mah",
      "Fırat Mah",
      "Göksu Mah",
      "İnkılap Mah",
      "İnönü Mah",
      "Mustafa Kemal Mah",
      "Seyhan Mah",
      "Vali Rahmi Bey Mah",
      "Yeşilbağlar Mah"
    ],
    "Çeşme": [
      "Alaçatı Mah",
      "16 Eylül Mah",
      "Altınkum Mah",
      "Altınyunus Mah",
      "Ardıç Mah",
      "Boyalık Mah",
      "Celal Bayar Mah",
      "Çakabey Mah",
      "Çiftlik Mah",
      "Fahrettinpaşa Mah",
      "Germiyan Mah",
      "Ildır Mah",
      "Ilıca Mah",
      "İsmet İnönü Mah",
      "Karaköy Mah",
      "Musalla Mah",
      "Ovacık Mah",
      "Reisdere Mah",
      "Sakarya Mah",
      "Şehit Mehmet Mah",
      "Şifne Mah",
      "Yalı Mah",
      "Cumhuriyet Mah",
      "Dalyan Mah",
      "Üniversite Mah"
    ],
    "Çiğli": [
      "Ahmet Taner Kışlalı Mah",
      "Aydınlıkevler Mah",
      "Evka-2 Mah",
      "Evka-6 Mah",
      "Güzeltepe Mah",
      "Köyiçi Mah",
      "Maltepe Mah",
      "Şirintepe Mah",
      "Yakakent Mah",
      "Aosb Mah",
      "Ataşehir Mah",
      "Balatçık Mah",
      "Kaklıç Mah",
      "Küçük Çiğli Mah",
      "Sasalı Merkez Mah",
      "Yeni Mahalle Mah",
      "Atatürk Mah",
      "Çağdaş Mah",
      "Egekent Mah",
      "Esentepe Mah",
      "Evka-5 Mah",
      "İzkent Mah",
      "Ahmet Efendi Mah",
      "Cumhuriyet Mah",
      "Harmandalı Gazi Mustafa Kemal Atatürk Mah",
      "İnönü Mah",
      "Uğur Mumcu Mah"
    ],
    "Dikili": [
      "Bademli Mah",
      "Bahçeli Mah",
      "Cumhuriyet Mah",
      "Çağlan Mah",
      "Çandarlı Mah",
      "Çukuralanı Mah",
      "Deliktaş Mah",
      "Demirtaş Mah",
      "Denizköy Mah",
      "Esentepe Mah",
      "Gazipaşa Mah",
      "Gökçeağıl Mah",
      "İslamlar Mah",
      "İsmetpaşa Mah",
      "Kabakum Mah",
      "Katıralanı Mah",
      "Kıratlı Mah",
      "Kıroba Mah",
      "Kızılçukur Mah",
      "Kocaoba Mah",
      "Mazılı Mah",
      "Merdivenli Mah",
      "Nebiler Mah",
      "Salihler Mah",
      "Salimbey Mah",
      "Samanlıkköy Mah",
      "Uzunburun Mah",
      "Yahşibey Mah",
      "Yaylayurt Mah",
      "Yenice Mah"
    ],
    "Foça": [
      "Hacıveli Mah",
      "Kazım Dirik Mah",
      "Atatürk Mah",
      "Fevzipaşa Mah",
      "Ilıpınar Mah",
      "İsmetpaşa Mah",
      "Kemal Atatürk Mah",
      "Koca Mehmetler Mah",
      "Kozbeyli Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Mustafa Kemal Atatürk Mah",
      "Yenibağarası Mah",
      "Yeniköy Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah"
    ],
    "Gaziemir": [
      "Aktepe Mah",
      "Atatürk Mah",
      "Atıfbey Mah",
      "Beyazevler Mah",
      "Binbaşı Reşatbey Mah",
      "Dokuz Eylül Mah",
      "Emrez Mah",
      "Fatih Mah",
      "Gazi Mah",
      "Gazikent Mah",
      "Hürriyet Mah",
      "Irmak Mah",
      "Menderes Mah",
      "Sevgi Mah",
      "Yeşil Mah",
      "Zafer Mah",
      "Zafer Sb Mah"
    ],
    "Güzelbahçe": [
      "Atatürk Mah",
      "Çamlı Mah",
      "Çelebi Mah",
      "Kahramandere Mah",
      "Küçükkaya Mah",
      "Maltepe Mah",
      "Mustafa Kemal Paşa Mah",
      "Payamlı Mah",
      "Siteler Mah",
      "Yaka Mah",
      "Yalı Mah",
      "Yelki Mah"
    ],
    "Karabağlar": [
      "Adnan Süvari Mah",
      "Esentepe Mah",
      "Esenyalı Mah",
      "Fahrettin Altay Mah",
      "General Kazım Özalp Mah",
      "Maliyeciler Mah",
      "Metin Oktay Mah",
      "Muammer Akar Mah",
      "Poligon Mah",
      "Şehitler Mah",
      "Üçkuyular Mah",
      "Arap Hasan Mah",
      "Bahçelievler Mah",
      "Basın Sitesi Mah",
      "Aydın Mah",
      "Barış Mah",
      "Günaltay Mah",
      "İhsan Alyanak Mah",
      "Kavacık Mah",
      "Peker Mah",
      "Selvili Mah",
      "Sevgi Mah",
      "Tırazlı Mah",
      "Yunus Emre Mah",
      "Abdi İpekçi Mah",
      "Cennetçeşme Mah",
      "Devrim Mah",
      "Gazi Mah",
      "Kibar Mah",
      "Özgür Mah",
      "Umut Mah",
      "Uzundere Mah",
      "Yaşar Kemal Mah",
      "Yurdoğlu Mah",
      "Yüzbaşı Şerafettin Mah",
      "Ali Fuat Cebesoy Mah",
      "Ali Fuat Erden Mah",
      "Bahriye Üçok Mah",
      "Doğanay Mah",
      "Esenlik Mah",
      "Kazım Karabekir Mah",
      "Limontepe Mah",
      "Refet Bele Mah",
      "Reis Mah",
      "Salih Omurtak Mah",
      "Tahsin Yazıcı Mah",
      "Vatan Mah",
      "Aşık Veysel Mah",
      "Bahar Mah",
      "Bozyaka Mah",
      "Cennetoğlu Mah",
      "Çalıkuşu Mah",
      "General Asım Gündüz Mah",
      "Gülyaka Mah",
      "Karabağlar Mah",
      "Osman Aksüner Mah",
      "Sarıyer Mah",
      "Uğur Mumcu Mah"
    ],
    "Karaburun": [
      "Anbarseki Mah",
      "Bozköy Mah",
      "Eğlenhoca Mah",
      "Hasseki Mah",
      "İnecik Mah",
      "İskele Mah",
      "Kösedere Mah",
      "Küçükbahçe Mah",
      "Merkez Mah",
      "Parlak Mah",
      "Saip Mah",
      "Salman Mah",
      "Sarpıncık Mah",
      "Tepeboz Mah",
      "Yayla Mah",
      "Mordoğan Mah"
    ],
    "Karşıyaka": [
      "Alaybey Mah",
      "Bahariye Mah",
      "Bahçelievler Mah",
      "Tersane Mah",
      "Tuna Mah",
      "Cumhuriyet Mah",
      "İnönü Mah",
      "Mustafa Kemal Mah",
      "Zübeyde Hanım Mah",
      "Atakent Mah",
      "Bostanlı Mah",
      "Mavişehir Mah",
      "İmbatlı Mah",
      "Latife Hanım Mah",
      "Örnekköy Mah",
      "Aksoy Mah",
      "Bahriye Üçok Mah",
      "Donanmacı Mah",
      "Sancaklı Mah",
      "Yamanlar Mah",
      "Dedebaşı Mah",
      "Demirköprü Mah",
      "Fikri Altay Mah",
      "Goncalar Mah",
      "Nergiz Mah",
      "Şemikler Mah",
      "Yalı Mah"
    ],
    "Kemalpaşa": [
      "Armutlu 85.yıl Cumhuriyet Mah",
      "Armutlu Hürriyet Mah",
      "Bağyurdu 29 Ekim Mah",
      "Bağyurdu Kazımpaşa Mah",
      "Bağyurdu Kemal Atatürk Mah",
      "Bağyurdu Yeni Mah",
      "Halilbeyli Mah",
      "Akalan Mah",
      "Ansızca Mah",
      "Aşağı Yenmiş Mah",
      "Aşağıkızılca Mah",
      "Atatürk Mah",
      "Bayramlı Mah",
      "Beşpınar Mah",
      "Cumalı Mah",
      "Çambel Mah",
      "Çınarköy Mah",
      "Çiniliköy Mah",
      "Damlacık Mah",
      "Dereköy Mah",
      "Gökçeyurt Mah",
      "Gökyaka Mah",
      "Halilbeyli Osb Mah",
      "Hamzababa Mah",
      "Kamberler Mah",
      "Kemalpaşa Osb Mah",
      "Kızılüzüm Mah",
      "Kuyucak Mah",
      "Mehmet Akif Ersoy Mah",
      "Nazarköy Mah",
      "Ovacık Mah",
      "Ören 75.yıl Cumhuriyet Mah",
      "Örnekköy Mah",
      "Sarıçalı Mah",
      "Sarılar Mah",
      "Sekiz Eylül Mah",
      "Sinancılar Mah",
      "Soğukpınar Mah",
      "Sütçüler Mah",
      "Vişneli Mah",
      "Yenikurudere Mah",
      "Yenmiş Mah",
      "Yeşilköy Mah",
      "Yeşilyurt Mah",
      "Yiğitler Mah",
      "Yukarıkızılca Merkez Mah",
      "Zeamet Mah",
      "Ören Egemen Mah",
      "Ulucak Cumhuriyet Mah",
      "Ulucak İstiklal Mah",
      "Ulucak Mustafa Kemal Atatürk Mah"
    ],
    "Kınık": [
      "Arpadere Mah",
      "Arpaseki Mah",
      "Aşağı Mah",
      "Aziziye Mah",
      "Bademalan Mah",
      "Bağalan Mah",
      "Balaban Mah",
      "Büyükoba Mah",
      "Cumalı Mah",
      "Çaltı Mah",
      "Çanköy Mah",
      "Çiftlikköy Mah",
      "Değirmencieli Mah",
      "Dündarlı Mah",
      "Elmadere Mah",
      "Fatih Mah",
      "Hamzahocalı Mah",
      "Işıklar Mah",
      "İbrahimağa Mah",
      "Kalemköy Mah",
      "Karadere Mah",
      "Karatekeli Mah",
      "Kınık Osb Mah",
      "Kocaömer Mah",
      "Kodukburun Mah",
      "Köseler Mah",
      "Mıstıklar Mah",
      "Musacalı Mah",
      "Osmaniye Mah",
      "Örtülü Mah",
      "Poyracık Mah",
      "Sucahlı Mah",
      "Taştepe Mah",
      "Türkcedit Mah",
      "Yayakent Mah",
      "Yaylaköy Mah",
      "Yeni Mah",
      "Yukarı Mah"
    ],
    "Kiraz": [
      "Ahmetler Mah",
      "Akpınar Mah",
      "Altınoluk Mah",
      "Arkacılar Mah",
      "Avunduruk Mah",
      "Aydoğdu Mah",
      "Bahçearası Mah",
      "Başaran Mah",
      "Ceritler Mah",
      "Cevizli Mah",
      "Cumhuriyet Mah",
      "Çanakçı Mah",
      "Çatak Mah",
      "Çayağzı Mah",
      "Çömlekçi Mah",
      "Doğancılar Mah",
      "Dokuzlar Mah",
      "Emenler Mah",
      "Gedik Mah",
      "Haliller Mah",
      "Hisar Mah",
      "İğdeli Mah",
      "İstiklal Mah",
      "Kaleköy Mah",
      "Karabağ Mah",
      "Karabulu Mah",
      "Karaburç Mah",
      "Karaman Mah",
      "Kırköy Mah",
      "Kibar Mah",
      "Mavidere Mah",
      "Mersinlidere Mah",
      "Olgunlar Mah",
      "Ovacık Mah",
      "Ören Mah",
      "Örencik Mah",
      "Pınarbaşı Mah",
      "Saçlı Mah",
      "Sarıkaya Mah",
      "Sarısu Mah",
      "Sırımlı Mah",
      "Solaklar Mah",
      "Suludere Mah",
      "Şemsiler Mah",
      "Taşlıyatak Mah",
      "Tekbıçaklar Mah",
      "Tumbullar Mah",
      "Umurcalı Mah",
      "Umurlu Mah",
      "Uzunköy Mah",
      "Veliler Mah",
      "Yağlar Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yenişehir Mah",
      "Yeşildere Mah"
    ],
    "Konak": [
      "Alsancak Mah",
      "Kültür Mah",
      "Mimar Sinan Mah",
      "Akarcalı Mah",
      "Akıncı Mah",
      "Ali Reis Mah",
      "Altay Mah",
      "Altınordu Mah",
      "Dayıemir Mah",
      "Dolaplıkuyu Mah",
      "Etiler Mah",
      "Faik Paşa Mah",
      "Hurşidiye Mah",
      "Kocakapı Mah",
      "Kubilay Mah",
      "Kurtuluş Mah",
      "Mirali Mah",
      "Namazgah Mah",
      "Pazaryeri Mah",
      "Sakarya Mah",
      "Selçuk Mah",
      "Süvari Mah",
      "Tuzcu Mah",
      "Ülkü Mah",
      "Yeni Mah",
      "1.kadriye Mah",
      "19 Mayıs Mah",
      "2.kadriye Mah",
      "Atilla Mah",
      "Aziziye Mah",
      "Ballıkuyu Mah",
      "Çimentepe Mah",
      "Duatepe Mah",
      "Güneşli Mah",
      "Hasan Özdemir Mah",
      "İmariye Mah",
      "Kadifekale Mah",
      "Kocatepe Mah",
      "Kosova Mah",
      "Tınaztepe Mah",
      "Vezirağa Mah",
      "Yeşildere Mah",
      "Zafertepe Mah",
      "26 Ağustos Mah",
      "Anadolu Mah",
      "Atamer Mah",
      "Çınartepe Mah",
      "Huzur Mah",
      "Mehmet Akif Mah",
      "Millet Mah",
      "Murat Mah",
      "Saygı Mah",
      "Trakya Mah",
      "Ulubatlı Mah",
      "Yavuz Selim Mah",
      "Zeybek Mah",
      "Boğaziçi Mah",
      "Cengiz Topel Mah",
      "Emir Sultan Mah",
      "Ferahlı Mah",
      "Güney Mah",
      "İsmet Paşa Mah",
      "Küçükada Mah",
      "Lale Mah",
      "Levent Mah",
      "Mehtap Mah",
      "Yenidoğan Mah",
      "Zeytinlik Mah",
      "Göztepe Mah",
      "Güzelyalı Mah",
      "Mehmet Ali Akman Mah",
      "Ege Mah",
      "Kahramanlar Mah",
      "Oğuzlar Mah",
      "Umurbey Mah",
      "Güneş Mah",
      "Güzelyurt Mah",
      "Kestelli Mah",
      "Konak Mah",
      "Yenigün Mah",
      "Altıntaş Mah",
      "Barbaros Mah",
      "Bozkurt Mah",
      "Çahabey Mah",
      "Fatih Mah",
      "Fevzi Paşa Mah",
      "Güngör Mah",
      "Kahraman Mescit Mah",
      "Mecidiye Mah",
      "Namık Kemal Mah",
      "Odunkapı Mah",
      "Sümer Mah",
      "Şehit Nedim Tuğaltay Mah",
      "Tan Mah",
      "Türkyılmaz Mah",
      "Uğur Mah",
      "Yeşiltepe Mah",
      "Yıldız Mah",
      "Akın Simav Mah",
      "Çankaya Mah",
      "Kemal Reis Mah",
      "Kılıç Reis Mah",
      "Mithatpaşa Mah",
      "Murat Reis Mah",
      "Piri Reis Mah",
      "Turgut Reis Mah",
      "Akdeniz Mah",
      "İsmet Kaptan Mah",
      "Çınarlı Mah",
      "Halkapınar Mah",
      "Hilal Mah",
      "Mersinli Mah",
      "Yenişehir Mah"
    ],
    "Menderes": [
      "Ataköy Mah",
      "Değirmendere Mah",
      "Develi Mah",
      "Ata Mah",
      "Görece Cumhuriyet Mah",
      "Hürriyet Mah",
      "Gümüldür Atatürk Mah",
      "Gümüldür Cumhuriyet Mah",
      "Gümüldür Fevzi Çakmak Mah",
      "Gümüldür İnönü Mah",
      "Kısık Mah",
      "Ahmetbeyli Mah",
      "Akçaköy Mah",
      "Altıntepe Mah",
      "Barbaros Mah",
      "Bulgurca Mah",
      "Cüneytbey Mah",
      "Çakaltepe Mah",
      "Çamönü Mah",
      "Çatalca Mah",
      "Çile Mah",
      "Çileme Mah",
      "Dereköy Mah",
      "Efemçukuru Mah",
      "Gazipaşa Mah",
      "Gölcükler Mah",
      "Gölova Mah",
      "İtob Osb Mah",
      "Karakuyu Mah",
      "Kasımpaşa Mah",
      "Keler Mah",
      "Kemalpaşa Mah",
      "Kuyucak Mah",
      "Küner Mah",
      "Mithatpaşa Mah",
      "Oğlananası Atatürk Mah",
      "Oğlananası Cumhuriyet Mah",
      "Sancaklı Mah",
      "Şaşal Mah",
      "Yeniköy Mah",
      "Çukuraltı Mah",
      "Orta Mah",
      "Özdere Cumhuriyet Mah",
      "Tekeli Atatürk Mah",
      "Tekeli Fevzi Çakmak Mah"
    ],
    "Menemen": [
      "29 Ekim Mah",
      "30 Ağustos Mah",
      "75.yıl Cumhuriyet Mah",
      "85.yıl Cumhuriyet Mah",
      "9 Eylül Mah",
      "Ahıhıdır Mah",
      "Alaniçi Mah",
      "Atatürk Mah",
      "Atatürk Plastikosb Mah",
      "Ayvacık Mah",
      "Bağcılar Mah",
      "Belen Mah",
      "Bozalan Mah",
      "Buruncuk Mah",
      "Camiikebir Mah",
      "Cumhuriyet Mah",
      "Çaltı Mah",
      "Çavuş Mah",
      "Çukurköy Mah",
      "Değirmendere Mah",
      "Doğa Mah",
      "Emiralem Merkez Mah",
      "Esatpaşa Mah",
      "Fatih Mah",
      "Gaybi Mah",
      "Gazi Mah",
      "Gazi Mustafa Kemal Mah",
      "Göktepe Mah",
      "Gölcük Mah",
      "Görece Mah",
      "Günerli Mah",
      "Hasanlar Mah",
      "Hatundere Mah",
      "Haykıran Mah",
      "Irmak Mah",
      "İğnedere Mah",
      "İncirli Pınar Mah",
      "İnönü Mah",
      "İsmet İnönü Mah",
      "İstiklal Mah",
      "Karaorman Mah",
      "Kasımpaşa Mah",
      "Kazımpaşa Mah",
      "Kemal Atatürk Mah",
      "Kesik Mah",
      "Kır Mah",
      "Maltepe Sb Mah",
      "Mermerli Mah",
      "Musabey Mah",
      "Mustafa Kemal Atatürk Mah",
      "Seydinnasrullah Mah",
      "Süleymanlı Mah",
      "Süzbeyli Mah",
      "Telekler Mah",
      "Turgutlar Mah",
      "Tuzçullu Mah",
      "Tülbentli Mah",
      "Uğur Mumcu Mah",
      "Ulus Mah",
      "Villakent Mah",
      "Yahşelli Mah",
      "Yanıkköy Mah",
      "Yayla Mah",
      "Yeşil Pınar Mah",
      "Yıldırım Mah",
      "Zafer Mah",
      "Zeytinlik Mah"
    ],
    "Narlıdere": [
      "2. İnönü Mah",
      "Altıevler Mah",
      "Atatürk Mah",
      "Çamtepe Mah",
      "Çatalkaya Mah",
      "Huzur Mah",
      "Ilıca Mah",
      "Limanreis Mah",
      "Narlı Mah",
      "Sahilevleri Mah",
      "Yenikale Mah"
    ],
    "Ödemiş": [
      "Akıncılar Mah",
      "Alaşarlı Mah",
      "Anafartalar Mah",
      "Artıcak Mah",
      "Atatürk Mah",
      "Bademli Mah",
      "Balabanlı Mah",
      "Bayırlı Mah",
      "Bebekler Mah",
      "Bengisu Mah",
      "Beyazıtlar Mah",
      "Bıçakçı Mah",
      "Birgi Mah",
      "Bozcayaka Mah",
      "Bozdağ Mah",
      "Bucak Mah",
      "Bülbüller Mah",
      "Büyükavulcuk Mah",
      "Cevizalan Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Çamlıca Mah",
      "Çamyayla Mah",
      "Çayır Mah",
      "Çaylı Mah",
      "Çobanlar Mah",
      "Demircili Mah",
      "Demirdere Mah",
      "Dereuzunyer Mah",
      "Dolaylar Mah",
      "Emirli Mah",
      "Emmioğlu Mah",
      "Ertuğrul Mah",
      "Gerçekli Mah",
      "Gereli Mah",
      "Gölcük Mah",
      "Güney Mah",
      "Günlüce Mah",
      "Hacıhasan Mah",
      "Hamam Mah",
      "Horzum Mah",
      "Hürriyet Mah",
      "Işık Mah",
      "İlkkurşun Mah",
      "İnönü Mah",
      "Karadoğan Mah",
      "Karakova Mah",
      "Kayaköy Mah",
      "Kaymakçı Mah",
      "Kazanlı Mah",
      "Kemenler Mah",
      "Kemer Mah",
      "Kerpiçlik Mah",
      "Kışla Mah",
      "Kızılca Mah",
      "Kızılcaavlu Mah",
      "Konaklı Mah",
      "Köfündere Mah",
      "Köseler Mah",
      "Kurucuova Mah",
      "Kutlubeyler Mah",
      "Kuvvetli Mah",
      "Küçükavulcuk Mah",
      "Küçükören Mah",
      "Küre Mah",
      "Mescitli Mah",
      "Meşrutiyet Mah",
      "Mimar Sinan Mah",
      "Mursallı Mah",
      "Ocaklı Mah",
      "Oğuzlar Mah",
      "Orhangazi Mah",
      "Ortaköy Mah",
      "Ovacık Mah",
      "Ovakent Mah",
      "Pirinççi Mah",
      "Sekiköy Mah",
      "Seyrekli Mah",
      "Suçıktı Mah",
      "Süleyman Demirel Mah",
      "Süleymanlar Mah",
      "Şirinköy Mah",
      "Tekke Mah",
      "Tosunlar Mah",
      "Türkmen Mah",
      "Türkönü Mah",
      "Umurbey Mah",
      "Uzundere Mah",
      "Üç Eylül Mah",
      "Üçkonak Mah",
      "Üzümlü Mah",
      "Veliler Mah",
      "Yeniceköy Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yılanlı Mah",
      "Yolüstü Mah",
      "Yusufdere Mah",
      "Zafer Mah"
    ],
    "Seferihisar": [
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Payamlı Mah",
      "Beyler Mah",
      "Camikebir Mah",
      "Çamtepe Mah",
      "Çolak İbrahim Bey Mah",
      "Düzce Mah",
      "Gödence Mah",
      "Gölcük Mah",
      "Hıdırlık Mah",
      "İhsaniye Mah",
      "Kavakdere Mah",
      "Orhanlı Mah",
      "Sığacık Mah",
      "Tepecik Mah",
      "Turabiye Mah",
      "Turgut Mah",
      "Ulamış Mah",
      "Bengiler Mah",
      "Mersin Alanı Mah"
    ],
    "Selçuk": [
      "14 Mayıs Mah",
      "Acarlar Mah",
      "Atatürk Mah",
      "Barutçu Mah",
      "Belevi Mah",
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Gökçealan Mah",
      "Havutçulu Mah",
      "İsa Bey Mah",
      "Sultaniye Mah",
      "Şirince Mah",
      "Zafer Mah",
      "Zeytinköy Mah"
    ],
    "Tire": [
      "4 Eylül Mah",
      "Adnan Menderes Mah",
      "Akçaşehir Mah",
      "Akkoyunlu Mah",
      "Akmescit Mah",
      "Akyurt Mah",
      "Alacalı Mah",
      "Alaylı Mah",
      "Armutlu Mah",
      "Atatürk Mah",
      "Ayaklıkırı Mah",
      "Bahariye Mah",
      "Başköy Mah",
      "Boynuyoğun Mah",
      "Büyükkale Mah",
      "Büyükkemerdere Mah",
      "Büyükkömürcü Mah",
      "Cambazlı Mah",
      "Cumhuriyet Mah",
      "Çayırlı Mah",
      "Çeriközü Mah",
      "Çiniyeri Mah",
      "Çobanköy Mah",
      "Çukurköy Mah",
      "Dağdere Mah",
      "Dallık Mah",
      "Dere Mah",
      "Derebaşı Mah",
      "Dereli Mah",
      "Dibekçi Mah",
      "Doyranlı Mah",
      "Duatepe Mah",
      "Dumlupınar Mah",
      "Dündarlı Mah",
      "Eğridere Mah",
      "Ertuğrul Mah",
      "Eskioba Mah",
      "Fatih Mah",
      "Gökçen Mah",
      "Halkapınar Mah",
      "Hasançavuşlar Mah",
      "Hisarlık Mah",
      "Hürriyet Mah",
      "Işıklar Mah",
      "Işıklı Mah",
      "İbni Melek Mah",
      "İbni Melek Osb Mah",
      "İhsaniye Mah",
      "İpekçiler Mah",
      "İstiklal Mah",
      "Kahrat Mah",
      "Kaplan Mah",
      "Karaca Ali Mah",
      "Karateke Mah",
      "Ketenci Mah",
      "Kırtepe Mah",
      "Kızılcahavlu Mah",
      "Kireli Mah",
      "Kocaaliler Mah",
      "Kurşak Mah",
      "Kurtuluş Mah",
      "Küçükburun Mah",
      "Küçükkale Mah",
      "Küçükkemerdere Mah",
      "Küçükkömürcü Mah",
      "Kürdüllü Mah",
      "Mahmutlar Mah",
      "Mehmetler Mah",
      "Musalar Mah",
      "Ortaköy Mah",
      "Osmancık Mah",
      "Paşa Mah",
      "Peşrefli Mah",
      "Sarılar Mah",
      "Saruhanlı Mah",
      "Somak Mah",
      "Toki Mah",
      "Topalak Mah",
      "Toparlar Mah",
      "Turan Mah",
      "Turgutlu Mah",
      "Üzümler Mah",
      "Yamandere Mah",
      "Yeğenli Mah",
      "Yemişler Mah",
      "Yeni Mah",
      "Yeniçiftlik Mah",
      "Yenioba Mah",
      "Yenişehir Mah"
    ],
    "Torbalı": [
      "Ayrancılar Mah",
      "Fevzi Çakmak Mah",
      "İnönü Mah",
      "Türkmenköy Mah",
      "Çaybaşı Mah",
      "Karşıyaka Mah",
      "Mustafa Kemal Atatürk Mah",
      "Yeni Mah",
      "Kazım Karabekir Mah",
      "Organize Sanayi Bölgesi Mah",
      "Pancar Mah",
      "19 Mayıs Mah",
      "Pamukyazı Mah",
      "Subaşı Mah",
      "Ahmetli Mah",
      "Alpkent Mah",
      "Arslanlar Mah",
      "Atalan Mah",
      "Atatürk Mah",
      "Bozköy Mah",
      "Bülbüldere Mah",
      "Cumhuriyet Mah",
      "Çakırbeyli Mah",
      "Çamlıca Mah",
      "Çapak Mah",
      "Dağkızılca Mah",
      "Dağteke Mah",
      "Demirci Mah",
      "Dirmil Mah",
      "Düverlik Mah",
      "Eğerci Mah",
      "Ertuğrul Mah",
      "Gazi Mustafa Kemal Mah",
      "Göllüce Mah",
      "Helvacı Mah",
      "Kaplancık Mah",
      "Karakızlar Mah",
      "Karakuyu Mah",
      "Karaot Mah",
      "Kırbaş Mah",
      "Kuşçuburun Mah",
      "Muratbey Mah",
      "Naime Mah",
      "Ormanköy Mah",
      "Ortaköy Mah",
      "Özbey Mah",
      "Sağlık Mah",
      "Saipler Mah",
      "Şehitler Mah",
      "Taşkesik Mah",
      "Tepeköy Mah",
      "Torbalı Mah",
      "Tulum Mah",
      "Yedi Eylül Mah",
      "Yemişlik Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yoğurtçular Mah",
      "Bahçelievler Mah",
      "İstiklal Mah",
      "Yazıbaşı Mah",
      "Yeniköy Osb Mah"
    ],
    "Urla": [
      "Bademler Mah",
      "Balıklıova Mah",
      "Denizli Mah",
      "Güvendik Mah",
      "Atatürk Mah",
      "İskele Mah",
      "Kalabak Mah",
      "Gülbahçe Mah",
      "Kuşçular Mah",
      "Özbek Mah",
      "Altıntaş Mah",
      "Barbaros Mah",
      "Birgi Mah",
      "Camiatik Mah",
      "Demircili Mah",
      "Hacı İsa Mah",
      "İçmeler Mah",
      "Kadıovacık Mah",
      "Naipli Mah",
      "Nohutalan Mah",
      "Ovacık Mah",
      "Rüstem Mah",
      "Sıra Mah",
      "Torasan Mah",
      "Uzunkuyu Mah",
      "Yağcılar Mah",
      "Yaka Mah",
      "Yelaltı Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenikent Mah",
      "Zeytineli Mah",
      "Zeytinler Mah",
      "Çamlıçay Mah",
      "M.fevzi Çakmak Mah",
      "Şirinkent Mah",
      "Zeytinalanı Mah"
    ]
  },
  "Kars": {
    "Akyaka": [
      "İstasyon Mah",
      "Tepe Mah",
      "Topkaya Mah",
      "Akbulak Köyü",
      "Aslahane Köyü",
      "Aşağı Mah (kalkankale Köyü)",
      "Boyuntaş Köyü",
      "Büyükdurduran Köyü",
      "Büyükpirveli Köyü",
      "Camuşlu Köyü",
      "Cebeci Köyü",
      "Çetindurak Köyü",
      "Demirkent Köyü",
      "Duraklı Köyü",
      "Esenyayla Köyü",
      "Geçitköy Köyü",
      "Hacıpiri Köyü",
      "İbişköy Köyü",
      "İncedere Köyü",
      "Karahan Köyü",
      "Karşı Mah (kayaköprü Köyü)",
      "Kayadöven Köyü",
      "Küçükaküzüm Köyü",
      "Kürekdere Köyü",
      "Merkez Mah (kayaköprü Köyü)",
      "Sulakbahçe Köyü",
      "Süngüderesi Köyü",
      "Şahnalar Köyü",
      "Üçpınar Köyü",
      "Yerlikavak Köyü",
      "Yok Mah (küçükdurduran Köyü)",
      "Yukarı Mah (kalkankale Köyü)"
    ],
    "Arpaçay": [
      "Bahçeler Mah",
      "Orta Mah",
      "Yalınçayır Mah",
      "Yeni Mah",
      "Akçakale Köyü",
      "Akçalar Köyü",
      "Akmazdam Köyü",
      "Arslanoğlu Köyü",
      "Atcılar Köyü",
      "Aydıngün Köyü",
      "Bacıoğlu Köyü",
      "Bardaklı Köyü",
      "Bozyiğit Köyü",
      "Burcalı Köyü",
      "Büyükçatma Köyü",
      "Carcı Köyü",
      "Carcıoğlu Afet Evleri Mah (carcıoğlu Köyü)",
      "Carcıoğlu Köyü",
      "Çanaksu Köyü",
      "Dağköyü Köyü",
      "Değirmenköprü Köyü",
      "Doğruyol Köyü",
      "Gaziler Mah (koçköyü Köyü)",
      "Gediksatılmış Köyü",
      "Göldalı Köyü",
      "Gönülalan Köyü",
      "Gültepe Mah (koçköyü Köyü)",
      "Gülyüzü Köyü",
      "Güvercin Köyü",
      "Hasançavuş Köyü",
      "Kakaç Köyü",
      "Karakale Köyü",
      "Karaurgan Köyü",
      "Kardeştepe Köyü",
      "Kıraç Köyü",
      "Kuyucuk Köyü",
      "Kuzgunlu Köyü",
      "Küçükboğaz Köyü",
      "Küçükçatma Köyü",
      "Kümbet Köyü",
      "Melikköyü Köyü",
      "Mescitli Köyü",
      "Meydancık Köyü",
      "Okçuoğlu Köyü",
      "Orta Mah (koçköyü Köyü)",
      "Polatköyü Köyü",
      "Söğütlü Köyü",
      "Taşbaşı Köyü",
      "Taşdere Köyü",
      "Taşköprü Köyü",
      "Taşlıağıl Köyü",
      "Telek Köyü",
      "Tepecik Köyü",
      "Tepeköy Köyü",
      "Tomarlı Köyü"
    ],
    "Digor": [
      "Merkez Mah (dağpınar Beldesi)",
      "Merkez Mah",
      "Afetevler Mah (varlı Köyü)",
      "Alem Köyü",
      "Arpalı Köyü",
      "Aşağıbaşköy Köyü",
      "Bacalı Köyü",
      "Başköy Köyü",
      "Bayırbağı Köyü",
      "Bostankale Köyü",
      "Celalköy Köyü",
      "Çarıkçı Mah (dolaylı Köyü)",
      "Çatak Köyü",
      "Çukurca Mah (dolaylı Köyü)",
      "Derinöz Köyü",
      "Düzgeçit Köyü",
      "Eren Köyü",
      "Gülhayran Köyü",
      "Halıkışlak Köyü",
      "Hasancan Köyü",
      "Hisarönü Köyü",
      "Karabağ Köyü",
      "Karakale Köyü",
      "Kilittaşı Köyü",
      "Kocaköy Köyü",
      "Köseler Köyü",
      "Mahirbey Köyü",
      "Merkez Mah (dolaylı Köyü)",
      "Nebiyurdu Mah (sorkunlu Köyü)",
      "Oyuklu Köyü",
      "Saklıca Köyü",
      "Sorguçkavak Köyü",
      "Sorkunlu Köyü",
      "Şatıroğlu Köyü",
      "Şenol Köyü",
      "Şirinköy Köyü",
      "Türkmeşen Köyü",
      "Uzunkaya Köyü",
      "Varlı Köyü",
      "Yağlıca Köyü",
      "Yaylacık Köyü",
      "Yemençayır Köyü",
      "Yeniköy Köyü"
    ],
    "Kağızman": [
      "Aşağı Kümbet Mah",
      "Aşağıdere Mah",
      "Bayam Mah",
      "Haznedar Mah",
      "Şahindere Mah",
      "Toprakkale Mah",
      "Yukarı Dere Mah",
      "Yukarı Kümbet Mah",
      "Zuvar Mah",
      "1.mezra Mah (bulanık Köyü)",
      "2.mezra Mah (bulanık Köyü)",
      "3,mezra Mah (bulanık Köyü)",
      "Afet Evleri Mah (ağdam Köyü)",
      "Ağdam Köyü",
      "Akçakale Köyü",
      "Akçay Köyü",
      "Akören Köyü",
      "Akyayla Köyü",
      "Altungedik Köyü",
      "Aras Mah (karakuş Köyü)",
      "Aşağıkaragüney Köyü",
      "Aşağıkaragüney Mezrası Mah (aşağıkaragüney Köyü)",
      "Aşağıtut Köyü",
      "Bahçecik Mah (çiçekli Köyü)",
      "Bulanık Köyü",
      "Bücüklü Köyü",
      "Camuşlu Köyü",
      "Çallı Afetevleri Mah (çallı Köyü)",
      "Çallı Bayam Mah (çallı Köyü)",
      "Çallı Mah (çallı Köyü)",
      "Çavuşlar Mah (kuruyayla Köyü)",
      "Çayarası Köyü",
      "Çaybük Köyü",
      "Çengilli Köyü",
      "Çengilli Mah (çengilli Köyü)",
      "Çeperli Köyü",
      "Çiçekli Köyü",
      "Çiflik Mah (kuruyayla Köyü)",
      "Çilehane Köyü",
      "Çukurayva Köyü",
      "Değirmen Mah (aydınkavak Köyü)",
      "Değirmendere Köyü",
      "Değirmendere Mah (tunçkaya Köyü)",
      "Demirkapı Mah (kuloğlu Köyü)",
      "Denizgölü Köyü",
      "Devebük Köyü",
      "Dibekkaya Köyü",
      "Diktaş Mah (aydınkavak Köyü)",
      "Duranlar Köyü",
      "Esenkır Köyü",
      "Esenkır Mah (esenkır Köyü)",
      "Evyapan Köyü",
      "Görecek Köyü",
      "Gözlüce Mah (yankıpınar Köyü)",
      "Gümüştepe Köyü",
      "Günindi Köyü",
      "Günindiyaylası Köyü",
      "Güven Mah (yankıpınar Köyü)",
      "Güvendik Köyü",
      "Hizan Mah (kuloğlu Köyü)",
      "Karabağ Köyü",
      "Karaboncuk Köyü",
      "Karacaören Köyü",
      "Karakale Köyü",
      "Keşişkıran Köyü",
      "Keşişkıran Mah (keşişkıran Köyü)",
      "Kozlu Köyü",
      "Kömürlü Köyü",
      "Köprübaşı Mah (akçay Köyü)",
      "Köprübaşı Mah (aydınkavak Köyü)",
      "Körpınar Köyü",
      "Kötek Köyü",
      "Köyiçi Mah (aydınkavak Köyü)",
      "Kuloğlu Köyü",
      "Kuruyayla Köyü",
      "Merkez Mah (donandı Köyü)",
      "Merkez Mah (karakuş Köyü)",
      "Ortaköy Köyü",
      "Paslı Köyü",
      "Pınar Göze Mah (camuşlu Köyü)",
      "Rızvan Mah (günindi Köyü)",
      "Sağbaş Köyü",
      "Seksen Mah (şaban Köyü)",
      "Sesveren Köyü",
      "Şaban Köyü",
      "Tab Mah (karakale Köyü)",
      "Taşbilek Köyü",
      "Taşburun Afet Evleri Mah (taşburun Köyü)",
      "Taşburun Köyü",
      "Tek Evler Mah (altungedik Köyü)",
      "Tomruktaş Köyü",
      "Tunçkaya Köyü",
      "Tut Mah (kuloğlu Köyü)",
      "Ürker Köyü",
      "Yağlıca Köyü",
      "Yalnızağaç Köyü",
      "Yankıpınar Köyü",
      "Yellikıran Köyü",
      "Yenice Köyü",
      "Yolkorur Köyü",
      "Yukarı Donandı Mah (donandı Köyü)",
      "Yukarıgüney Kara Mah (yukarıkaragüney Köyü)",
      "Yukarıkaragüney Köyü"
    ],
    "Merkez": [
      "30 Ekim Mah",
      "Alpaslan Mah",
      "Atatürk Mah",
      "Aydınlıkevler Mah",
      "Bahçelievler Mah",
      "Bayrampaşa Mah",
      "Bülbül Mah",
      "Cumhuriyet Mah",
      "Fevziçakmak Mah",
      "Hafızpaşa Mah",
      "Halitpaşa Mah",
      "İstasyon Mah",
      "Kaleiçi Mah",
      "Kaleiçi Osb Mah",
      "Karadağ Mah",
      "Merkez Mah",
      "Ortakapı Mah",
      "Örnek Mah",
      "Paşaçayırı Mah",
      "Paşaçayırıosb Mah",
      "Sukapı Mah",
      "Şehitler Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Yusufpaşa Mah",
      "Ağadeve Köyü",
      "Akdere Köyü",
      "Alaca Köyü",
      "Alçılı Köyü",
      "Ani Köyü",
      "Arazoğlu Köyü",
      "Aşağı Mah (arslanizi Köyü)",
      "Ataköy Köyü",
      "Atayurt Köyü",
      "Ayakgedikler Köyü",
      "Aydınalan Köyü",
      "Azat Köyü",
      "Başgedikler Köyü",
      "Başkaya Köyü",
      "Bayraktar Köyü",
      "Bekler Köyü",
      "Boğatepe Köyü",
      "Boğazköy Köyü",
      "Borluk Köyü",
      "Bozkale Köyü",
      "Bulanık Köyü",
      "Büyükaküzüm Köyü",
      "Cami Mah (akbaba Köyü)",
      "Cumhuriyet Köyü",
      "Çağlayan Köyü",
      "Çakmak Köyü",
      "Çamurlu Köyü",
      "Çerme Köyü",
      "Çığırgan Köyü",
      "Çorak Köyü",
      "Davul Köyü",
      "Derecik Köyü",
      "Dikme Köyü",
      "Esenkent Köyü",
      "Esenyazı Köyü",
      "Eşmeyazı Köyü",
      "Gelirli Köyü",
      "Güdeli Köyü",
      "Hacıhalil Köyü",
      "Hacıveli Köyü",
      "Halefoğlu Köyü",
      "Hamzagerek Köyü",
      "Hapanlı Köyü",
      "Hasçiftlik Köyü",
      "Karacaören Köyü",
      "Karaçoban Köyü",
      "Karakale Köyü",
      "Karakaş Köyü",
      "Kocabahçe Köyü",
      "Kozluca Köyü",
      "Küçükboğatepe Köyü",
      "Küçükpirveli Köyü",
      "Küçükyusuf Köyü",
      "Külveren Köyü",
      "Kümbetli Köyü",
      "Maksutçuk Köyü",
      "Mezraa Köyü",
      "Oğuzlu Köyü",
      "Orta Mah (akbaba Köyü)",
      "Ortagedikler Köyü",
      "Ölçülü Köyü",
      "Soylu Köyü",
      "Söğütlü Köyü",
      "Subatan Köyü",
      "Şemsi Mah (soylu Köyü)",
      "Tazekent Köyü",
      "Tekneli Köyü",
      "Tekneli Mah (tekneli Köyü)",
      "Tepe Mah (akbaba Köyü)",
      "Üçbölük Köyü",
      "Verimli Köyü",
      "Yağıkesen Köyü",
      "Yalçınlar Köyü",
      "Yalınkaya Köyü",
      "Yılanlı Köyü",
      "Yukarı Mah (arslanizi Köyü)",
      "Yücelen Köyü"
    ],
    "Sarıkamış": [
      "Akkoz Köyü",
      "Akkoz Yayla Evleri Mah (akkoz Köyü)",
      "Akören Köyü",
      "Alisofu Köyü",
      "Altınbulak Köyü",
      "Armutlu Köyü",
      "Asbuğa Köyü",
      "Aşağı Mah (kayalıboğaz Köyü)",
      "Aşağı Mah (sırbasan Köyü)",
      "Aşağı Mah (taşlıgüney Köyü)",
      "Aşağısallıpınar Köyü",
      "Balabantaş Köyü",
      "Balıklı Köyü",
      "Başköy Köyü",
      "Belencik Köyü",
      "Beşyol Köyü",
      "Boyalı Köyü",
      "Bozat Köyü",
      "Çamyazı Köyü",
      "Çardakçatı Köyü",
      "Çatak Köyü",
      "Çolaklı Köyü",
      "Değirmen Mah (gecikmez Köyü)",
      "Eşmeçayır Köyü",
      "Gecikmez Köyü",
      "Hamamlı Köyü",
      "Handere Köyü",
      "Hoşgeldi Mah (güllüce Köyü)",
      "İnkaya Köyü",
      "İsisu Köyü",
      "Kalebaşı Köyü",
      "Karaköse Köyü",
      "Karakurt Köyü",
      "Karapınar Köyü",
      "Karataş Mah (inkaya Köyü)",
      "Karaurgan Köyü",
      "Kazantaş Köyü",
      "Kazıkkaya Köyü",
      "Koçoğlu Köyü",
      "Kozan Köyü",
      "Köroğlu Köyü",
      "Kurbançayır Köyü",
      "Küçük Güllüce Mah (güllüce Köyü)",
      "Maksutçuk Mah (taşlıgüney Köyü)",
      "Merkez Mah (güllüce Köyü)",
      "Mescitli Köyü",
      "Odalar Köyü",
      "Okul Mah (güllüce Köyü)",
      "Ortakale Köyü",
      "Parmakdere Köyü",
      "Sırataşlar Köyü",
      "Sonveren Mah (taşlıgüney Köyü)",
      "Süngütaşı Köyü",
      "Şehitemin Köyü",
      "Şehithalit Köyü",
      "Topkaya Köyü",
      "Uzungazi Köyü",
      "Yağbasan Köyü",
      "Yarkaya Deprem Konutları Mah (yarkaya Köyü)",
      "Yarkaya Köyü",
      "Yayıklı Köyü",
      "Yenigazi Köyü",
      "Yeniköy Köyü",
      "Yukarı Mah (kayalıboğaz Köyü)",
      "Yukarı Mah (sırbasan Köyü)",
      "Yukarı Mah (taşlıgüney Köyü)",
      "Yukarısallıpınar Köyü",
      "Cumhuriyet Mah",
      "Erenler Mah",
      "İnönü Mah",
      "İstasyon Mah",
      "İstiklal Mah",
      "Kazımkarabekir Mah",
      "Şehitler Mah",
      "Tepe Mah",
      "Yeni Mah"
    ],
    "Selim": [
      "Akçakale Köyü",
      "Akpınar Köyü",
      "Alisofu Köyü",
      "Aşağı Mah (bölükbaş Köyü)",
      "Aşağı Mah (büyükdere Köyü)",
      "Aşağı Mah (iğdir Köyü)",
      "Aşağı Mah (katranlı Köyü)",
      "Aşağı Mah (koyunyurdu Köyü)",
      "Aşağıdamlapınar Köyü",
      "Aşağıkotanlı Köyü",
      "Başköy Köyü",
      "Baykara Köyü",
      "Benliahmet Köyü",
      "Beyköy Köyü",
      "Bozkuş Köyü",
      "Büyük Oluklu Köyü",
      "Cami Altı Mah (hasbey Köyü)",
      "Cami Üstü Mah (hasbey Köyü)",
      "Camii Mah (bayburt Köyü)",
      "Cavlak Köyü",
      "Çaybaşı Köyü",
      "Çıplaklı Köyü",
      "Darboğaz Köyü",
      "Değirmen Mah (iğdir Köyü)",
      "Değirmenbaşı Mah (akyar Köyü)",
      "Dölbentli Köyü",
      "Eskigazi Köyü",
      "Eskigeçit Köyü",
      "Gelinalan Köyü",
      "Giriş Mah (hasbey Köyü)",
      "Gürbüzler Köyü",
      "Kamışlı Köyü",
      "Karaçayır Köyü",
      "Karahamza Köyü",
      "Karakale Köyü",
      "Kaynarlı Köyü",
      "Kekeç Köyü",
      "Kırkpınar Köyü",
      "Koşapınar Köyü",
      "Laloğlu Köyü",
      "Mollamustafa Köyü",
      "Okul Mah (bayburt Köyü)",
      "Okul Mah (hasbey Köyü)",
      "Oluklu Köyü",
      "Orta Mah (akyar Köyü)",
      "Ortakale Köyü",
      "Sarıgün Köyü",
      "Söğütlü Köyü",
      "Tepe Mah (akyar Köyü)",
      "Tozluca Köyü",
      "Tuygun Köyü",
      "Yalnızçam Köyü",
      "Yamaçlı Köyü",
      "Yassıca Köyü",
      "Yaylacık Köyü",
      "Yenice Köyü",
      "Yeşiltepe Köyü",
      "Yolgeçmez Köyü",
      "Yukarı Mah (bölükbaş Köyü)",
      "Yukarı Mah (büyükdere Köyü)",
      "Yukarı Mah (iğdir Köyü)",
      "Yukarı Mah (katranlı Köyü)",
      "Yukarı Mah (koyunyurdu Köyü)",
      "Yukarıdamlapınar Köyü",
      "Yukarıkotanlı Köyü",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Köprübaşı Mah"
    ],
    "Susuz": [
      "Afet Evleri Mah (büyükçatak Köyü)",
      "Afetevleri Mah (kırkpınar Köyü)",
      "Aksu Köyü",
      "Aynalı Köyü",
      "Beşevler Mah (kurugöl Köyü)",
      "Çamçavuş Köyü",
      "Çığrıklı Köyü",
      "Doyumlu Köyü",
      "Erdağı Köyü",
      "Ermişler Köyü",
      "Gölbaşı Köyü",
      "Gölbaşı Mezra Mah (gölbaşı Köyü)",
      "Harmanlı Köyü",
      "İncesu Köyü",
      "İncilipınar Köyü",
      "Kalecik Köyü",
      "Karapınar Köyü",
      "Karatuzak Mah (taşlıca Köyü)",
      "Kayadibi Köyü",
      "Keçili Köyü",
      "Kırçiçeği Köyü",
      "Kiziroğlu Köyü",
      "Köyiçi Mah (kayalık Köyü)",
      "Kurugöl Köyü",
      "Küçükçatak Köyü",
      "Merkez Mah (büyükçatak Köyü)",
      "Merkez Mah (kırkpınar Köyü)",
      "Ortalar Köyü",
      "Porsuklu Köyü",
      "Taşlıca Köyü",
      "Tepe Mah (kayalık Köyü)",
      "Yaylacık Köyü",
      "Yolboyu Köyü",
      "Cumhuriyet Mah",
      "İnkılap Mah",
      "İnönü Mah",
      "Kazım Karabekir Mah"
    ]
  },
  "Kastamonu": {
    "Abana": [
      "Bağlık Mah",
      "Çayırcık Mah",
      "Hacıveli Mah",
      "Konakören Mah",
      "Merkez Mah",
      "Akçam Mah (maca Mah) (akçam Köyü)",
      "Ali Kahya Mah (akçam Köyü)",
      "Ali Onbaşı Mah (yeşilyuva Köyü)",
      "Altıkulaç  Mah (kadı Mah) (altıkulaç Köyü)",
      "Aşçı Mah (elmaçukuru Köyü)",
      "Badımana Mah (yakabaşı Köyü)",
      "Çampınar Mah (çampınar Köyü)",
      "Çölmek Mah (altıkulaç Köyü)",
      "Deles Mah (yeşilyuva Köyü)",
      "Denizbükü Mah (denizbükü Köyü)",
      "Elmaçukuru Mah (elmaçukuru Köyü)",
      "Göynükler Mah (göynükler Köyü)",
      "Gülen Mah (göynükler Köyü)",
      "Hamza Mah (yemeni Köyü)",
      "Kadıyusuf Mah (kadıyusuf Köyü)",
      "Kalafat Mah (göynükler Köyü)",
      "Karahacılar Mah (çampınar Köyü)",
      "Kartal Mah (kadıyusuf Köyü)",
      "Kayış Mah (yemeni Köyü)",
      "Kerim Mah (altıkulaç Köyü)",
      "Kışlacık Mah (altıkulaç Köyü)",
      "Kirenpınarı Mah (denizbükü Köyü)",
      "Koç Mah (yakabaşı Köyü)",
      "Konak Mah (göynükler Köyü)",
      "Kovalak Mah (çampınar Köyü)",
      "Kurtlama Mah (yemeni Köyü)",
      "Kuzgun Mah (akçam Köyü)",
      "Macar Mah (göynükler Köyü)",
      "Manav Mah (çampınar Köyü)",
      "Mollaahmet Mah (göynükler Köyü)",
      "Müsellim Mah (akçam Köyü)",
      "Nadar Mah (yeşilyuva Köyü)",
      "Olukyanı Mah (yeşilyuva Köyü)",
      "Orza Mah (altıkulaç Köyü)",
      "Paşa Mah (altıkulaç Köyü)",
      "Recep Mah (göynükler Köyü)",
      "Soltu Mah (kadıyusuf Köyü)",
      "Tarakçı Mah (akçam Köyü)",
      "Tepe Mah (akçam Köyü)",
      "Terzi Mah (göynükler Köyü)",
      "Yakabaşı Mah (yaylas Mah) (yakabaşı Köyü)",
      "Yemeni Mah (yemeni Köyü)",
      "Yeşilyuva Mah (yeşilyuva Köyü)",
      "Ziraatlık Mah (akçam Köyü)",
      "Ziyratlık Mah (elmaçukuru Köyü)"
    ],
    "Ağlı": [
      "Alınca Mah",
      "Danacı Mah",
      "Dikmen Mah",
      "Ketenciler Mah",
      "Kırlardere Mah",
      "Merkez Mah",
      "Örencik Mah",
      "Selmanlı Mah",
      "Sinan Mah",
      "Yağlıca Mah",
      "Arapoğlu Mah (oluközü Köyü)",
      "Aşağı Turnacık Mah (turnacık Köyü)",
      "Balca Mah (akdivan Köyü)",
      "Baloğlu Mah (selmanlı Köyü)",
      "Cami Yanı Mah (bereketli Köyü)",
      "Cincioğlu Mah (oluközü Köyü)",
      "Çapal Mah (bereketli Köyü)",
      "Çaylı Mah (yeşilpınar Köyü)",
      "Çöpcü Mah (oluközü Köyü)",
      "Dana Mah (yeşilpınar Köyü)",
      "Delihasan Mah (fırıncık Köyü)",
      "Dikeloğlu Mah (oluközü Köyü)",
      "Ese Mah (gölcüğez Köyü)",
      "Evrenler Mah (akçakese Köyü)",
      "Eyüpağa Mah (gölcüğez Köyü)",
      "Galta Mah (fırıncık Köyü)",
      "Halil Mah (kabacı Köyü)",
      "Hasanlı Mah (gölcüğez Köyü)",
      "Hatip Mah (fırıncık Köyü)",
      "Hüseyinefendi Mah (gölcüğez Köyü)",
      "İbatoğlu Mah (oluközü Köyü)",
      "Kabalar Mah (yeşilpınar Köyü)",
      "Kadı Mah (selmanlı Köyü)",
      "Karaköy Mah (fırıncık Köyü)",
      "Karaoğlan Mah (oluközü Köyü)",
      "Karapınar Mah (kabacı Köyü)",
      "Kayabaşı Mah (bereketli Köyü)",
      "Keller Mah (kabacı Köyü)",
      "Kesim Mah (bereketli Köyü)",
      "Kızılcaelma Mah (akdivan Köyü)",
      "Kocabaş Mah (akçakese Köyü)",
      "Koçcuğaz Mah (akdivan Köyü)",
      "Kurtderesi Mah (tunuslar Köyü)",
      "Kuru Mah (selmanlı Köyü)",
      "Mazak Mah (yeşilpınar Köyü)",
      "Merkez Mah (adalar Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (akdivan Köyü)",
      "Merkez Mah (bereketli Köyü)",
      "Merkez Mah (fırıncık Köyü)",
      "Merkez Mah (gölcüğez Köyü)",
      "Merkez Mah (kabacı Köyü)",
      "Merkez Mah (müsellimler Köyü)",
      "Merkez Mah (selmanlı Köyü)",
      "Merkez Mah (tunuslar Köyü)",
      "Mırlavat Mah (akçakese Köyü)",
      "Muratoğlu Mah (oluközü Köyü)",
      "Murtazaoğlu Mah (kabacı Köyü)",
      "Ornu Mah (akdivan Köyü)",
      "Osmançelebi Mah (adalar Köyü)",
      "Öcür Mah (akçakese Köyü)",
      "Örencik Mah (müsellimler Köyü)",
      "Paşaoğlu Mah (akçakese Köyü)",
      "Selver Mah (oluközü Köyü)",
      "Şahin Mah (selmanlı Köyü)",
      "Şeyhoğlu Mah (bereketli Köyü)",
      "Tavlıoğlu Mah (akçakese Köyü)",
      "Tavlıoğlu Mah (selmanlı Köyü)",
      "Tepe Mah (gölcüğez Köyü)",
      "Tepe Mah (oluközü Köyü)",
      "Yayla Mah (fırıncık Köyü)",
      "Yukarı Turnacık Mah (turnacık Köyü)"
    ],
    "Araç": [
      "Çay Mah",
      "İnönü Mah",
      "Mesudiye Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Yukarıaraç Mah",
      "Abdogil Mah (doğanpınar Köyü)",
      "Ado Mah (karcılar Köyü)",
      "Afet Mah (yenice Köyü)",
      "Ahmetler Mah (uğur Köyü)",
      "Akseki Mah (bahçecik Köyü)",
      "Aksöğüt Mah (çukurpelit Köyü)",
      "Alan Mah (güzlük Köyü)",
      "Ali Gado Mah (kıyıdibi Köyü)",
      "Alibey Mah (çalköy Köyü)",
      "Apdudoğu Mah (avlağıçayırı Köyü)",
      "Asar Mah (cevizlik Köyü)",
      "Aşağı Diphan Mah (huruçören Köyü)",
      "Aşağı Mah (aşağıçobanözü Köyü)",
      "Aşağı Mah (bahçecik Köyü)",
      "Aşağı Mah (çaykaşı Köyü)",
      "Aşağı Mah (doğanpınar Köyü)",
      "Aşağı Mah (gökçesu Köyü)",
      "Aşağı Mah (kavacık Köyü)",
      "Aşağı Mah (kavak Köyü)",
      "Aşağı Mah (köklüdere Köyü)",
      "Aşağı Mah (okçular Köyü)",
      "Aşağı Mah (oycalı Köyü)",
      "Aşağı Ören Mah (yukarıılıpınar Köyü)",
      "Aşağı Sindire Mah (dereçatı Köyü)",
      "Aşağıören Mah (avlağıçayırı Köyü)",
      "Bahçecik Mah (ihsanlı Köyü)",
      "Bakılcak Mah (okluk Köyü)",
      "Barıtcı Mah (şehrimanlar Köyü)",
      "Bektaşlar Mah (karcılar Köyü)",
      "Bektüre Mah (bektüre Köyü)",
      "Berber Mah (alınören Köyü)",
      "Boduroğlu Mah (gölcük Köyü)",
      "Bostan Mah (köse Köyü)",
      "Boyalı Mah (kemerler Köyü)",
      "Bürümcek Mah (çukurpelit Köyü)",
      "Canlar Mah (yukarıılıpınar Köyü)",
      "Celler Mah (hatip Köyü)",
      "Çakıllar Mah (ekinözü Köyü)",
      "Çakırın Mah (avlacık Köyü)",
      "Çalca Mah (alınören Köyü)",
      "Çalık Mah (karcılar Köyü)",
      "Çamlı Tepe Mah (köklüdere Köyü)",
      "Çavuş Yaylası Mah (çavuş Köyü)",
      "Çıkrıkçı Mah (yukarıılıpınar Köyü)",
      "Çiftçi Mah (alınören Köyü)",
      "Çiftlik Mah (kayabaşı Köyü)",
      "Çorak Mah (deretepe Köyü)",
      "Çorak Mah (muratlı Köyü)",
      "Çorakdere Mah (samatlar Köyü)",
      "Çorum Mah (serdar Köyü)",
      "Çukurtarla Mah (yukarıılıpınar Köyü)",
      "Dayıoğlu Mah (eskiiğdir Köyü)",
      "Dedecük Mah (yukarıılıpınar Köyü)",
      "Değirmen Başı Mah (güzlük Köyü)",
      "Deli Hüseyin Mah (bektüre Köyü)",
      "Demirci Mah (celepler Köyü)",
      "Dere Mah (çerçiler Köyü)",
      "Dere Mah (deretepe Köyü)",
      "Dere Mah (güzlük Köyü)",
      "Dere Mah (palazlar Köyü)",
      "Derekışla Mah (serdar Köyü)",
      "Dereler Mah (yenice Köyü)",
      "Derya Mah (serdar Köyü)",
      "Diphan Mah (çukurpelit Köyü)",
      "Doruk Mah (bahçecik Köyü)",
      "Doruk Mah (yukarıoba Köyü)",
      "Duraklar Mah (yukarıoba Köyü)",
      "Durmuşoğlu Mah (kıyıdibi Köyü)",
      "Ebuleys Mah (kıyan Köyü)",
      "Ebuleys-ova Mah (kıyan Köyü)",
      "Ecemler Mah (sofcular Köyü)",
      "Ekincik Mah (bektüre Köyü)",
      "Elmacık Mah (hatip Köyü)",
      "Elmaçukuru Mah (güzlük Köyü)",
      "Encibo Mah (çaykaşı Köyü)",
      "Ercek Mah (avlağıçayırı Köyü)",
      "Erekli Köyü",
      "Erencik Mah (palazlar Köyü)",
      "Eseler Mah (deretepe Köyü)",
      "Esir Mah (avlacık Köyü)",
      "Eski Mah (ahatlar Köyü)",
      "Eski Susuz Mah (susuz Köyü)",
      "Eskici Mah (tuzaklı Köyü)",
      "Eynibey Mah (ekinözü Köyü)",
      "Fındıcak Mah (avlacık Köyü)",
      "Fındıcak Mah (hatip Köyü)",
      "Gemici Mah (alınören Köyü)",
      "Geriş Mah (doğanpınar Köyü)",
      "Geriş-yayla Evi Mah (susuz Köyü)",
      "Geztarla Mah (palazlar Köyü)",
      "Göcenin Kışlası Mah (bektüre Köyü)",
      "Göççün Mah (belkavak Köyü)",
      "Göde Mah (karcılar Köyü)",
      "Gökceoğlu Mah (çukurpelit Köyü)",
      "Göller Mah (uğur Köyü)",
      "Göynük Mah (ulucak Köyü)",
      "Güllük Mah (okçular Köyü)",
      "Güney Mah (yukarıılıpınar Köyü)",
      "Güzlük Mah (güzlük Köyü)",
      "Halaçlar Mah (samatlar Köyü)",
      "Hallar Mah (alakaya Köyü)",
      "Harmancık Mah (cevizlik Köyü)",
      "Hasbeyler Mah (çaykaşı Köyü)",
      "Hatıbogil Mah (doğanpınar Köyü)",
      "Hatip Mah (çavuş Köyü)",
      "Hatipgil Mah (doğanpınar Köyü)",
      "Haydaroğlu Mah (recepbey Köyü)",
      "Hepcanlar Mah (aktaş Köyü)",
      "Hızar Mah (alınören Köyü)",
      "Hoşafcı Mah (kızılsaray Köyü)",
      "Hümmetoğlu Mah (doğanpınar Köyü)",
      "Irbatlı Mah (köse Köyü)",
      "İğdir Mah (yukarıçobanözü Köyü)",
      "İmam Mah (aktaş Köyü)",
      "İmrehalar Mah (karcılar Köyü)",
      "İntaş Mah (kışlaköy Köyü)",
      "İspiroğlu Mah (tavşanlı Köyü)",
      "Kadıköy Mah (serdar Köyü)",
      "Kahya Mah (ömersin Köyü)",
      "Kalaycıoğlu Mah (gökçesu Köyü)",
      "Kapıllı Mah (çalköy Köyü)",
      "Karaağaç Mah (ömersin Köyü)",
      "Karacalık Mah (okluk Köyü)",
      "Karacaoluk Mah (çavuş Köyü)",
      "Karaçalılık Mah (samatlar Köyü)",
      "Karaçayır Mah (aşağıılıpınar Köyü)",
      "Karagöz Mah (ihsanlı Köyü)",
      "Karamcak Mah (huruçören Köyü)",
      "Karandı Mah (avlacık Köyü)",
      "Kararecep Mah (dereçatı Köyü)",
      "Karasu Mah (akgeçit Köyü)",
      "Karayolları Altı Mah (sümenler Köyü)",
      "Karcı Mah (karcılar Köyü)",
      "Karkalmaz Mah (avlacık Köyü)",
      "Karolo Mah (kıyıdibi Köyü)",
      "Kavacık Mah (aktaş Köyü)",
      "Kavak Mah (bektüre Köyü)",
      "Kavurga Mah (ulucak Köyü)",
      "Kayadibi Mah (iğdirkışla Köyü)",
      "Kayakısığı Mah (sarıhacı Köyü)",
      "Keller Mah (muratlı Köyü)",
      "Kıncı Mah (bektüre Köyü)",
      "Kışla Mah (alakaya Köyü)",
      "Kışla Mah (bektüre Köyü)",
      "Kışla Mah (kışlaköy Köyü)",
      "Kışla Mah (kovanlı Köyü)",
      "Kışla Mah (muratlı Köyü)",
      "Kışla Mah (okluk Köyü)",
      "Kızakyokuşu Mah (yukarıılıpınar Köyü)",
      "Kızılçalar Mah (gökceçat Köyü)",
      "Kirazlı Mah (kirazlı Köyü)",
      "Kireccik Mah (gemi Köyü)",
      "Koççuaz Mah (kızılsaray Köyü)",
      "Konak Mah (karcılar Köyü)",
      "Konaklar Mah (alakaya Köyü)",
      "Kölehasan Mah (aşağıılıpınar Köyü)",
      "Köleoğlu Mah (yukarıılıpınar Köyü)",
      "Köprübaşı Mah (deretepe Köyü)",
      "Köprüyanı Mah (kayabaşı Köyü)",
      "Köse Mah (ömersin Köyü)",
      "Köseler Mah (yenice Köyü)",
      "Köseoğlu Mah (bektüre Köyü)",
      "Köşklü Mah (çaykaşı Köyü)",
      "Köyyeri Mah (yukarıılıpınar Köyü)",
      "Kuzlan Mah (pelitören Köyü)",
      "Küçük Belen Mah (belen Köyü)",
      "Kürekçi Mah (eskiiğdir Köyü)",
      "Kütükoğlu Mah (taşpınar Köyü)",
      "Mahmatlar Mah (okluk Köyü)",
      "Mandra Mah (palazlar Köyü)",
      "Memişoğlu Mah (sarpun Köyü)",
      "Merkez Mah (ahatlar Köyü)",
      "Merkez Mah (akgeçit Köyü)",
      "Merkez Mah (akıncılar Köyü)",
      "Merkez Mah (aksu Köyü)",
      "Merkez Mah (aktaş Köyü)",
      "Merkez Mah (alınören Köyü)",
      "Merkez Mah (aşağıılıpınar Köyü)",
      "Merkez Mah (aşağıikizören Köyü)",
      "Merkez Mah (aşağıoba Köyü)",
      "Merkez Mah (aşağıyazı Köyü)",
      "Merkez Mah (avlacık Köyü)",
      "Merkez Mah (avlağıçayırı Köyü)",
      "Merkez Mah (balçıkhisar Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (boğdam Köyü)",
      "Merkez Mah (celepler Köyü)",
      "Merkez Mah (cevizlik Köyü)",
      "Merkez Mah (çalköy Köyü)",
      "Merkez Mah (çamaltı Köyü)",
      "Merkez Mah (çavuş Köyü)",
      "Merkez Mah (çubukludere Köyü)",
      "Merkez Mah (çukurpelit Köyü)",
      "Merkez Mah (damla Köyü)",
      "Merkez Mah (değirmençay Köyü)",
      "Merkez Mah (deretepe Köyü)",
      "Merkez Mah (doğanca Köyü)",
      "Merkez Mah (doruk Köyü)",
      "Merkez Mah (ekinözü Köyü)",
      "Merkez Mah (erekli Köyü)",
      "Merkez Mah (fındıklı Köyü)",
      "Merkez Mah (gemi Köyü)",
      "Merkez Mah (gergen Köyü)",
      "Merkez Mah (gökceçat Köyü)",
      "Merkez Mah (gölcük Köyü)",
      "Merkez Mah (gülükler Köyü)",
      "Merkez Mah (güzelce Köyü)",
      "Merkez Mah (haliloba Köyü)",
      "Merkez Mah (hanözü Köyü)",
      "Merkez Mah (hatip Köyü)",
      "Merkez Mah (huruçören Köyü)",
      "Merkez Mah (iğdir Köyü)",
      "Merkez Mah (iğdirkışla Köyü)",
      "Merkez Mah (ihsanlı Köyü)",
      "Merkez Mah (karacık Köyü)",
      "Merkez Mah (karaçalar Köyü)",
      "Merkez Mah (karakaya Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kayaboğazı Köyü)",
      "Merkez Mah (kemerler Köyü)",
      "Merkez Mah (kışlaköy Köyü)",
      "Merkez Mah (kıyan Köyü)",
      "Merkez Mah (kıyıdibi Köyü)",
      "Merkez Mah (kızılören Köyü)",
      "Merkez Mah (kızılsaray Köyü)",
      "Merkez Mah (kirazlı Köyü)",
      "Merkez Mah (kovanlı Köyü)",
      "Merkez Mah (köklüyurt Köyü)",
      "Merkez Mah (köse Köyü)",
      "Merkez Mah (müslimler Köyü)",
      "Merkez Mah (ömersin Köyü)",
      "Merkez Mah (özbel Köyü)",
      "Merkez Mah (pelitören Köyü)",
      "Merkez Mah (pınarören Köyü)",
      "Merkez Mah (recepbey Köyü)",
      "Merkez Mah (saltuklu Köyü)",
      "Merkez Mah (sarıhacı Köyü)",
      "Merkez Mah (sıragömü Köyü)",
      "Merkez Mah (sofcular Köyü)",
      "Merkez Mah (şehrimanlar Köyü)",
      "Merkez Mah (şenyurt Köyü)",
      "Merkez Mah (şiringüney Köyü)",
      "Merkez Mah (taşpınar Köyü)",
      "Merkez Mah (tatlıca Köyü)",
      "Merkez Mah (tavşanlı Köyü)",
      "Merkez Mah (tellikoz Köyü)",
      "Merkez Mah (terke Köyü)",
      "Merkez Mah (tokatlı Köyü)",
      "Merkez Mah (toygaören Köyü)",
      "Merkez Mah (tuzaklı Köyü)",
      "Merkez Mah (uğur Köyü)",
      "Merkez Mah (ulucak Köyü)",
      "Merkez Mah (üçpınar Köyü)",
      "Merkez Mah (yeşilova Köyü)",
      "Merkez Mah (yukarıgüney Köyü)",
      "Merkez Mah (yukarıılıpınar Köyü)",
      "Merkez Mah (yukarıoba Köyü)",
      "Merkez Mah (yukarıyazı Köyü)",
      "Merkez Mah (yurttepe Köyü)",
      "Merkez-çobanoğlu Mah (sarpun Köyü)",
      "Mesutlar Mah (çamaltı Köyü)",
      "Mezra Mah (akıncılar Köyü)",
      "Mezra Mah (karakaya Köyü)",
      "Mezra Mah (kıyan Köyü)",
      "Mezra Mah (taşpınar Köyü)",
      "Mıkcı Mah (ömersin Köyü)",
      "Mırusuttur Mah (avlağıçayırı Köyü)",
      "Mirzek Mah (dereçatı Köyü)",
      "Muhacirler Mah (karaçalar Köyü)",
      "Muhacirler Mah (tatlıca Köyü)",
      "Muratoğlu Mah (çaykaşı Köyü)",
      "Musalar Mah (gemi Köyü)",
      "Müsemler Mah (sofcular Köyü)",
      "Müslüman Mah (çukurpelit Köyü)",
      "Okçular Mah (sofcular Köyü)",
      "Okul Çevresi Mah (güzlük Köyü)",
      "Orta Mah (aşağıçobanözü Köyü)",
      "Orta Mah (bahçecik Köyü)",
      "Orta Mah (huruçören Köyü)",
      "Orta Mah (köklüdere Köyü)",
      "Orta Mah (yukarıoba Köyü)",
      "Oruçbey Mah (celepler Köyü)",
      "Oruşlar Mah (şenyurt Köyü)",
      "Ova Mah (erekli Köyü)",
      "Ova Mah (ihsanlı Köyü)",
      "Ova Mah (tokatlı Köyü)",
      "Ömercin Mah (bektüre Köyü)",
      "Örenaltı Mah (karakaya Köyü)",
      "Ötedoma Mah (çukurpelit Köyü)",
      "Özağzı Mah (müslimler Köyü)",
      "Paşalı Mah (belkavak Köyü)",
      "Pirinç Suyu Yayla Mah (tavşanlı Köyü)",
      "Poyrazlı Mah (yukarıılıpınar Köyü)",
      "Ramazanoğlu Mah (recepbey Köyü)",
      "Samatlar Mah (samatlar Köyü)",
      "Saraçoğlu Mah (bektüre Köyü)",
      "Saray Mah (aktaş Köyü)",
      "Saraycık Mah (ekinözü Köyü)",
      "Sarcılar Mah (sarpun Köyü)",
      "Sarmaşık Mah (tavşanlı Köyü)",
      "Sazak Mah (bahçecik Köyü)",
      "Serdar Mah (serdar Köyü)",
      "Seyran Mah (yenice Köyü)",
      "Sıhlar Mah (recepbey Köyü)",
      "Sofcular Mah (bektüre Köyü)",
      "Sofuoğlu Mah (ulucak Köyü)",
      "Soğandere Mah (çaykaşı Köyü)",
      "Soğuk Su Mah (ekinözü Köyü)",
      "Sokak Mah (doğanpınar Köyü)",
      "Susuz -geriş Mah (susuz Köyü)",
      "Susuz -ıspalar Mah (susuz Köyü)",
      "Susuz Yaylası Mah (susuz Köyü)",
      "Susuz-ahlatçık Mah (susuz Köyü)",
      "Susuz-türbeli Mah (susuz Köyü)",
      "Süngülü Mah (kavacık Köyü)",
      "Şabanlar Mah (çaykaşı Köyü)",
      "Şabanlar Mah (dereçatı Köyü)",
      "Şekerci Mah (taşpınar Köyü)",
      "Şeykemler Yabo Mah (tavşanlı Köyü)",
      "Taşpınar Mah (serdar Köyü)",
      "Tekeren Mah (aşağıikizören Köyü)",
      "Tekke Mah (boğdam Köyü)",
      "Telli Mah (çaykaşı Köyü)",
      "Tepe Mah (çalköy Köyü)",
      "Tepe Mah (çerçiler Köyü)",
      "Topuzoğlu Ova Mah (tavşanlı Köyü)",
      "Tüfekci Mah (ömersin Köyü)",
      "Türkmenoğlu Mah (okçular Köyü)",
      "Uğur Mah (sarıhacı Köyü)",
      "Ulualan Mah (avlacık Köyü)",
      "Uzun Mah (okluk Köyü)",
      "Üvey Mah (kirazlı Köyü)",
      "Varvan Mah (tellikoz Köyü)",
      "Y. İkizören Mah (yukarıikizören Köyü)",
      "Y.sindire Mah (dereçatı Köyü)",
      "Yakacık Mah (yenice Köyü)",
      "Yakupoğlu Mah (belkavak Köyü)",
      "Yalnızoğlu Mah (kıyıdibi Köyü)",
      "Yayla Evleri Mah (sıragömü Köyü)",
      "Yayla Mah (alakaya Köyü)",
      "Yayla Mah (aşağıoba Köyü)",
      "Yayla Mah (aşağıyazı Köyü)",
      "Yayla Mah (doğanpınar Köyü)",
      "Yayla Mah (fındıklı Köyü)",
      "Yayla Mah (gölcük Köyü)",
      "Yayla Mah (hatip Köyü)",
      "Yayla Mah (kirazlı Köyü)",
      "Yayla Mah (oycalı Köyü)",
      "Yeni Mah (gemi Köyü)",
      "Yeni Mah (kayaören Köyü)",
      "Yeni Mah (pınarören Köyü)",
      "Yeni Mah (sarpun Köyü)",
      "Yeni Ova Mah (balçıkhisar Köyü)",
      "Yenice Mah (celepler Köyü)",
      "Yesirler Mah (muratlı Köyü)",
      "Yeşil Mah (kavak Köyü)",
      "Yonca Mah (alınören Köyü)",
      "Yukarı Mah (aşağıçobanözü Köyü)",
      "Yukarı Mah (bahçecik Köyü)",
      "Yukarı Mah (eskiiğdir Köyü)",
      "Yukarı Mah (gökçesu Köyü)",
      "Yukarı Mah (huruçören Köyü)",
      "Yukarı Mah (kavacık Köyü)",
      "Yukarı Mah (kavak Köyü)",
      "Yukarı Mah (kızılsaray Köyü)",
      "Yukarı Mah (köklüdere Köyü)",
      "Yukarı Mah (okçular Köyü)",
      "Yukarı Mah (oycalı Köyü)",
      "Yukarı Mah (toygaören Köyü)",
      "Yukarıören Mah (avlağıçayırı Köyü)",
      "Yusufaklar Mah (muratlı Köyü)",
      "Yuvalca Mah (dereçatı Köyü)",
      "Zaim Mah (çukurpelit Köyü)"
    ],
    "Azdavay": [
      "Bahçelievler Mah",
      "Karşıyaka Mah",
      "Merkez Mah",
      "Yeni Mah",
      "Ağıt Mah (zümrüt Köyü)",
      "Ahmetbey Mah (gümürtler Köyü)",
      "Akcaelma Mah (derelitekke Köyü)",
      "Aktaş Mah (alı Köyü)",
      "Alday Mah (dereyücek Köyü)",
      "Alı Mah (zümrüt Köyü)",
      "Alimoğlu Mah (gümürtler Köyü)",
      "Alipaşa Mah (derelitekke Köyü)",
      "Alnek Mah (sıraköy Köyü)",
      "Altıntaş Mah (başakçay Köyü)",
      "Ambarlı Mah (yeşilköy Köyü)",
      "Arabacı Mah (mehmetçelebi Köyü)",
      "Araboğlu Mah (sada Köyü)",
      "Arapoğlu Mah (gecen Köyü)",
      "Armuteren Mah (tasköy Köyü)",
      "Aşagören Mah (çamlıbük Köyü)",
      "Ayvat Mah (karakuşlu Köyü)",
      "Bal Mah (söğütpınar Köyü)",
      "Balca Mah (derelitekke Köyü)",
      "Ballık Mah (başakçay Köyü)",
      "Baş Mah (maden Köyü)",
      "Başoğlu Mah (arslanca Köyü)",
      "Bayat Mah (kozluören Köyü)",
      "Bayraktar Mah (sabuncular Köyü)",
      "Bekdemir Mah (alı Köyü)",
      "Bilalpaşa Mah (tomrukköy Köyü)",
      "Biteler Mah (samancı Köyü)",
      "Bostancı Mah (üyük Köyü)",
      "Boşnak Mah (maksutköy Köyü)",
      "Boyalca Mah (başören Köyü)",
      "Bozarmut Mah (sarnıçköy Köyü)",
      "Bürümük Mah (sabuncular Köyü)",
      "Cebeci Mah (kırmacı Köyü)",
      "Cebeci Mah (maden Köyü)",
      "Çadırcı Mah (gecen Köyü)",
      "Çadırcı Mah (topuk Köyü)",
      "Çakıldak Mah (kozluören Köyü)",
      "Çalcı Mah (evlek Köyü)",
      "Çalcıören Mah (hıdırlar Köyü)",
      "Çaldibi Mah (karakuşlu Köyü)",
      "Çamlıbük Merkez Mah (çamlıbük Köyü)",
      "Çamlık Mah (kırmacı Köyü)",
      "Çanakçı Mah (evlek Köyü)",
      "Çatak Mah (ahatköy Köyü)",
      "Çay Mah (mehmetçelebi Köyü)",
      "Çelebi Mah (kayabaşı Köyü)",
      "Çertek Mah (evlek Köyü)",
      "Çetinpınar Mah (maden Köyü)",
      "Çıralı Mah (çamlıbük Köyü)",
      "Çiftlik Mah (ahatköy Köyü)",
      "Çiftlik Mah (başakçay Köyü)",
      "Çömez Mah (kırcalar Köyü)",
      "Çuhaderesi Mah (kerpiçlik Köyü)",
      "Çukurharman Mah (çoçukören Köyü)",
      "Daccak Mah (hıdırlar Köyü)",
      "Dağ Mah (kırcalar Köyü)",
      "Dağköy Mah (hıdırlar Köyü)",
      "Değirmenci Mah (sabuncular Köyü)",
      "Demirci Mah (alacık Köyü)",
      "Demirci Mah (topuk Köyü)",
      "Demirciler Mah (kayaoğlu Köyü)",
      "Dere Mah (evlek Köyü)",
      "Dereköy Mah (kerpiçlik Köyü)",
      "Divandağ Mah (kanlıdağ Köyü)",
      "Dolay Mah (tomrukköy Köyü)",
      "Dornuç Mah (yeşilköy Köyü)",
      "Dursun Mah (başakçay Köyü)",
      "Egerciler Mah (yeşilköy Köyü)",
      "Ekşi Mah (dereyücek Köyü)",
      "Elece Mah (tasköy Köyü)",
      "Emre Mah (çamlıbük Köyü)",
      "Esköy Mah (alı Köyü)",
      "Firemük Mah (çamlıbük Köyü)",
      "Geriş Mah (bakırcı Köyü)",
      "Geriş Mah (gültepe Köyü)",
      "Geyiközü Mah (yumacık Köyü)",
      "Gıyas Mah (başakçay Köyü)",
      "Göktaş Mah (başören Köyü)",
      "Göktepe Mah (kolca Köyü)",
      "Güney Mah (çakıroğlu Köyü)",
      "Güney Mah (gültepe Köyü)",
      "Güney Mah (kayabaşı Köyü)",
      "Güney Mah (kerpiçlik Köyü)",
      "Hacı Hasan Mah (alacık Köyü)",
      "Hacı Mah (evlek Köyü)",
      "Hacıbey Mah (topuk Köyü)",
      "Hacılar Mah (sada Köyü)",
      "Hacıoğlu Mah (sabuncular Köyü)",
      "Hacıoğlu Mah (samancı Köyü)",
      "Hacullu Mah (kayabaşı Köyü)",
      "Halaşlı Mah (üyük Köyü)",
      "Halimoğlu Mah (sada Köyü)",
      "Hamzalı Mah (evlek Köyü)",
      "Hanifeoğlu Mah (sada Köyü)",
      "Haramtanaz Mah (kırmacı Köyü)",
      "Harmancık Mah (derelitekke Köyü)",
      "Hasanköyü Mah (sıraköy Köyü)",
      "Hatıp Mah (kırmacı Köyü)",
      "Hecceli Mah (evlek Köyü)",
      "Helvacı Mah (evlek Köyü)",
      "Helvacı Mah (samancı Köyü)",
      "Hırakaramuk Mah (üyük Köyü)",
      "Himmet Mah (maksutköy Köyü)",
      "Hoca Mah (bakırcı Köyü)",
      "Hoca Mah (kurtçular Köyü)",
      "Hodancı Mah (yumacık Köyü)",
      "Horoz Mah (söğütpınar Köyü)",
      "Hovga Mah (yeşilköy Köyü)",
      "Hüseyinbaşoğlu Mah (gecen Köyü)",
      "Irna Mah (tasköy Köyü)",
      "Işıklar Mah (çakıroğlu Köyü)",
      "İbrahim Mah (dereyücek Köyü)",
      "İmam Mah (başakçay Köyü)",
      "İmam Mah (derelitekke Köyü)",
      "İmamoğlu Mah (samancı Köyü)",
      "İsvere Mah (kolca Köyü)",
      "Kaba Mah (sabuncular Köyü)",
      "Kabalar Mah (arslanca Köyü)",
      "Kabalar Mah (başakçay Köyü)",
      "Kadı Mah (evlek Köyü)",
      "Kadı Mah (mehmetçelebi Köyü)",
      "Kadı Mah (topuk Köyü)",
      "Kadıoğlu Mah (sada Köyü)",
      "Kalaşlı Mah (gültepe Köyü)",
      "Kaldır Mah (mehmetçelebi Köyü)",
      "Kale Mah (sıraköy Köyü)",
      "Kanlı Anız Mah (kanlıdağ Köyü)",
      "Karabükler Mah (üyük Köyü)",
      "Karaca Mah (çamlıbük Köyü)",
      "Karaca Mah (zümrüt Köyü)",
      "Karacalar Mah (yumacık Köyü)",
      "Karaçam Mah (çömlektepe Köyü)",
      "Karaçam Mah (sada Köyü)",
      "Karaçay Mah (kayaoğlu Köyü)",
      "Karahüseyin Mah (gümürtler Köyü)",
      "Karamehmetoğlu Mah (kurtçular Köyü)",
      "Karaş Mah (sabuncular Köyü)",
      "Kargalar Mah (dereyücek Köyü)",
      "Kasap Mah (başören Köyü)",
      "Kasım Mah (gümürtler Köyü)",
      "Kavaklı Mah (maden Köyü)",
      "Kaya Mah (kırmacı Köyü)",
      "Kaya Mah (tomrukköy Köyü)",
      "Kayadibi Mah (maden Köyü)",
      "Kayıkçı Mah (söğütpınar Köyü)",
      "Kefeli Mah (kırmacı Köyü)",
      "Kepçe Mah (kayabaşı Köyü)",
      "Keremenler Mah (sarnıçköy Köyü)",
      "Kervansaray Mah (kanlıdağ Köyü)",
      "Keşci Mah (maksutköy Köyü)",
      "Kıraç Mah (bakırcı Köyü)",
      "Kışlacık Mah (kayaoğlu Köyü)",
      "Kıygıncık Mah (sabuncular Köyü)",
      "Kızılcapınar Mah (kerpiçlik Köyü)",
      "Kızılcasu Mah (kayabaşı Köyü)",
      "Kızılcatarla Mah (göktaş Köyü)",
      "Kızıllı Mah (maden Köyü)",
      "Kızkayası Mah (sabuncular Köyü)",
      "Kızkayası Mah (sada Köyü)",
      "Kilim Mah (alacık Köyü)",
      "Kocaağaç Mah (alacık Köyü)",
      "Kocaoğlu Mah (alı Köyü)",
      "Koccuvaz Mah (alı Köyü)",
      "Kocoğlar Mah (başören Köyü)",
      "Köfünoğlu Mah (maden Köyü)",
      "Köle Mah (kurtçular Köyü)",
      "Köle Mah (mehmetçelebi Köyü)",
      "Kölo Mah (üyük Köyü)",
      "Köse Köyü Mah (bakırcı Köyü)",
      "Köse Mah (alı Köyü)",
      "Köse Mah (mehmetçelebi Köyü)",
      "Kumarı Mah (kozluören Köyü)",
      "Kunduru Mah (karakuşlu Köyü)",
      "Kurtlar Mah (maksutköy Köyü)",
      "Kuruoğlu Mah (kırmacı Köyü)",
      "Kuş Mah (çakıroğlu Köyü)",
      "Kuz Mah (başakçay Köyü)",
      "Kuz Mah (dereyücek Köyü)",
      "Kuz Mah (kırmacı Köyü)",
      "Kuz Mah (kurtçular Köyü)",
      "Küçük Göktaş Mah (göktaş Köyü)",
      "Kürküşlü Mah (maksutköy Köyü)",
      "Kürtoğlu Mah (samancı Köyü)",
      "Mantaroğlu Mah (topuk Köyü)",
      "Maruf Mah (kırcalar Köyü)",
      "Memremi Mah (mehmetçelebi Köyü)",
      "Mene Mah (çoçukören Köyü)",
      "Menteş Mah (hocaköy Köyü)",
      "Merkez Mah (ahatköy Köyü)",
      "Merkez Mah (akcaçam Köyü)",
      "Merkez Mah (alacık Köyü)",
      "Merkez Mah (alı Köyü)",
      "Merkez Mah (arslanca Köyü)",
      "Merkez Mah (bakırcı Köyü)",
      "Merkez Mah (başakçay Köyü)",
      "Merkez Mah (başören Köyü)",
      "Merkez Mah (çömlektepe Köyü)",
      "Merkez Mah (derelitekke Köyü)",
      "Merkez Mah (dereyücek Köyü)",
      "Merkez Mah (gecen Köyü)",
      "Merkez Mah (göktaş Köyü)",
      "Merkez Mah (gültepe Köyü)",
      "Merkez Mah (gümürtler Köyü)",
      "Merkez Mah (hıdırlar Köyü)",
      "Merkez Mah (hocaköy Köyü)",
      "Merkez Mah (kanlıdağ Köyü)",
      "Merkez Mah (karahalılılar Köyü)",
      "Merkez Mah (karakuşlu Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kayaoğlu Köyü)",
      "Merkez Mah (kerpiçlik Köyü)",
      "Merkez Mah (kırcalar Köyü)",
      "Merkez Mah (kolca Köyü)",
      "Merkez Mah (kozluören Köyü)",
      "Merkez Mah (kurtçular Köyü)",
      "Merkez Mah (maden Köyü)",
      "Merkez Mah (maksutköy Köyü)",
      "Merkez Mah (sada Köyü)",
      "Merkez Mah (samancı Köyü)",
      "Merkez Mah (sarayköy Köyü)",
      "Merkez Mah (sarnıçköy Köyü)",
      "Merkez Mah (sıraköy Köyü)",
      "Merkez Mah (söğütpınar Köyü)",
      "Merkez Mah (tomrukköy Köyü)",
      "Merkez Mah (topuk Köyü)",
      "Merkez Mah (üyük Köyü)",
      "Merkez Mah (yumacık Köyü)",
      "Meyit Mah (gümürtler Köyü)",
      "Muğlas Mah (evlek Köyü)",
      "Mus Mah (karakuşlu Köyü)",
      "Musa Mah (söğütpınar Köyü)",
      "Musaoğlu Mah (gümürtler Köyü)",
      "Müderris Mah (gecen Köyü)",
      "Müsellim Mah (kayaoğlu Köyü)",
      "Nalbantoğlu Mah (kayabaşı Köyü)",
      "Odabaşı Mah (gecen Köyü)",
      "Okcu Mah (arslanca Köyü)",
      "Oluklu Mah (çamlıbük Köyü)",
      "Ortaca Mah (yeşilköy Köyü)",
      "Ortakçı Mah (kırcalar Köyü)",
      "Ortaköy Mah (çoçukören Köyü)",
      "Oruç Mah (evlek Köyü)",
      "Oruçoğlu Mah (samancı Köyü)",
      "Ömer Mah (çömlektepe Köyü)",
      "Ömerbeyoğlu Mah (sada Köyü)",
      "Ömür Mah (mehmetçelebi Köyü)",
      "Örcün Mah (kozluören Köyü)",
      "Örencik Mah (ahatköy Köyü)",
      "Pelitçe Mah (gültepe Köyü)",
      "Pelitveren Mah (dereyücek Köyü)",
      "Pürtaş Mah (kırmacı Köyü)",
      "Recep Mah (mehmetçelebi Köyü)",
      "Rıdvan Mah (samancı Köyü)",
      "Sağıroğlu Mah (samancı Köyü)",
      "Sakarözü Mah (yumacık Köyü)",
      "Sakızlar Mah (tomrukköy Köyü)",
      "Sakızoğlu Mah (arslanca Köyü)",
      "Sama Mah (kayabaşı Köyü)",
      "Sarıbeyoğlu Mah (kayaoğlu Köyü)",
      "Sarıcaoğlu Mah (karahalılılar Köyü)",
      "Sarıçam Mah (çakıroğlu Köyü)",
      "Sarıkaya Mah (arslanca Köyü)",
      "Sarıkaya Mah (göktaş Köyü)",
      "Sarılar Mah (zümrüt Köyü)",
      "Sarıyakup Mah (üyük Köyü)",
      "Sekçe Mah (tasköy Köyü)",
      "Serke Mah (alı Köyü)",
      "Sıra Mah (sıraköy Köyü)",
      "Softaoğlu Mah (kırcalar Köyü)",
      "Sofular Mah (söğütpınar Köyü)",
      "Sofuoğlu Mah (gümürtler Köyü)",
      "Sofuoğlu Mah (kurtçular Köyü)",
      "Söğütözü Mah (maden Köyü)",
      "Sökü Mah (dereyücek Köyü)",
      "Sökü Mah (göktaş Köyü)",
      "Söküveren Mah (yeşilköy Köyü)",
      "Sövüşler Mah (sarnıçköy Köyü)",
      "Sungurlar Mah (tomrukköy Köyü)",
      "Süller Mah (çoçukören Köyü)",
      "Şaban Fakı Mah (sada Köyü)",
      "Şabanlı Mah (sıraköy Köyü)",
      "Şemşi Mah (alacık Köyü)",
      "Şeyh Mah (mehmetçelebi Köyü)",
      "Şüküroğlu Mah (akcaçam Köyü)",
      "Tabaklı Mah (maksutköy Köyü)",
      "Tasköy Merkez Mah (tasköy Köyü)",
      "Tekke Mah (çoçukören Köyü)",
      "Tekke Mah (derelitekke Köyü)",
      "Tekke Mah (samancı Köyü)",
      "Tepeköy Mah (çamlıbük Köyü)",
      "Tepeüstü Mah (üyük Köyü)",
      "Terzi Mah (topuk Köyü)",
      "Tilki Mah (mehmetçelebi Köyü)",
      "Tülek Mah (yumacık Köyü)",
      "Tütüncü Mah (topuk Köyü)",
      "Uluay Mah (kolca Köyü)",
      "Valisi Mah (göktaş Köyü)",
      "Yahyabaş Mah (kırmacı Köyü)",
      "Yakayer Mah (sıraköy Köyü)",
      "Yaran Mah (maksutköy Köyü)",
      "Yavular Mah (akcaçam Köyü)",
      "Yayla Mah (alacık Köyü)",
      "Yayla Mah (evlek Köyü)",
      "Yayla Mah (hocaköy Köyü)",
      "Yaylagerişi Mah (kayabaşı Köyü)",
      "Yazıcıoğlu Mah (kırmacı Köyü)",
      "Yeliyen Mah (söğütpınar Köyü)",
      "Yeni Mah (gültepe Köyü)",
      "Yeni Mah (sada Köyü)",
      "Yıllatma Mah (göktaş Köyü)",
      "Yokuş Mah (kanlıdağ Köyü)",
      "Yukarıköy Mah (alı Köyü)",
      "Zahna Mah (maden Köyü)",
      "Zeyfe Mah (alacık Köyü)",
      "Zurnacı Mah (üyük Köyü)"
    ],
    "Bozkurt": [
      "Hamza Mah",
      "Merkez Mah",
      "Şen Mah",
      "Yeni Mah",
      "Yüksek Mah",
      "Abdioğlu Mah (keşlik Köyü)",
      "Ahmetler Mah (çiçekyayla Köyü)",
      "Akgüney Mah (ambarcılar Köyü)",
      "Ali Çelebi Mah (ilişi Köyü)",
      "Alikadıoğlu Mah (yaşarlı Köyü)",
      "Anaca Mah (yaşarlı Köyü)",
      "Anbarlı Mah (darsu Köyü)",
      "Armutluyüzü Mah (ambarcılar Köyü)",
      "Arpalıkbaşı Mah (ambarcılar Köyü)",
      "Arza Mah (yaylatepe Köyü)",
      "Arza Yaylası Mah (yaylatepe Köyü)",
      "Asarbaşı Mah (yaylatepe Köyü)",
      "Aşa Kaya Mah (kayalar Köyü)",
      "Aşağı Harman Mah (mamatlar Köyü)",
      "Aşağı Karşı Mah (mamatlar Köyü)",
      "Aşağı Mah (alantepe Köyü)",
      "Aşağı Mah (mamatlar Köyü)",
      "Aşağı Tekdal  Mah (hursu Mah) (günvaktı Köyü)",
      "Aşağıdeğirmenbaşı Mah (kızılcaelma Köyü)",
      "Aşağıkarahasan Mah (bayramgazi Köyü)",
      "Aşaoday Mah (koşmapınar Köyü)",
      "Avu Oltuğu Mah (yaylatepe Köyü)",
      "Aydın Mah (yaylatepe Köyü)",
      "Babakini Mah (çiçekyayla Köyü)",
      "Bakırcıoğlan Yaylası Mah (ortasökü Köyü)",
      "Balyemez Mah (kocaçam Köyü)",
      "Başsökü Mah (yaşarlı Köyü)",
      "Bayraktar Mah (kayalar Köyü)",
      "Bedbaşı Mah (bayramgazi Köyü)",
      "Belen Mah (ilişi Köyü)",
      "Berçi Mah (yaylatepe Köyü)",
      "Boşnak Mah (ilişi Köyü)",
      "Büyükdüz Mah (bayramgazi Köyü)",
      "Cabına Mah (koşmapınar Köyü)",
      "Calay Mah (sakızcılar Köyü)",
      "Cami Yanı Mah (çiçekyayla Köyü)",
      "Cami Yanı Mah (koşmapınar Köyü)",
      "Cami Yanı Mah (ortasökü Köyü)",
      "Cedim Mah (ibrahim Köyü)",
      "Ceviz Mah (şeyhoğlu Köyü)",
      "Cin Mah (ilişi Köyü)",
      "Cufana Mah (sarıçiçek Köyü)",
      "Çalıvo Mah (keşlik Köyü)",
      "Çankaya Mah (görentaş Köyü)",
      "Çarcina Mah (kayalar Köyü)",
      "Çarşı Mah (ilişi Köyü)",
      "Çay Mah (ortasökü Köyü)",
      "Çayır Merkez Mah (kocaçam Köyü)",
      "Çevik Mah (alantepe Köyü)",
      "Çukur Göynüğü Mah (yaylatepe Köyü)",
      "Çukurtarla Mah (ambarcılar Köyü)",
      "Dağ Mah (kutluca Köyü)",
      "Defne Mah (ibrahim Köyü)",
      "Demirci Mah (yaşarlı Köyü)",
      "Derebeyler Mah (çiçekyayla Köyü)",
      "Dereyol Mah (şeyhoğlu Köyü)",
      "Deşdi Elma Mah (koşmapınar Köyü)",
      "Döngel Pınarı Mah (ortasökü Köyü)",
      "Düz Göynük Mah (mamatlar Köyü)",
      "Eğro Mah (dursun Köyü)",
      "Elmedüzü Mah (koşmapınar Köyü)",
      "Erence Mah (mamatlar Köyü)",
      "Esentepe Mah (çiçekyayla Köyü)",
      "Esköy Mah (koşmapınar Köyü)",
      "Fezman Mah (şeyhoğlu Köyü)",
      "Gerçek Mah (dursun Köyü)",
      "Göl Mah (köseali Köyü)",
      "Gübücek Mah (sakızcılar Köyü)",
      "Güdülo Mah (kızılcaelma Köyü)",
      "Güloz Mah (ibrahim Köyü)",
      "Gülübol Mah (yaylatepe Köyü)",
      "Gülübol Yaylası Mah (yaylatepe Köyü)",
      "Güney Mah (bayramgazi Köyü)",
      "Güzlük Mah (kocaçam Köyü)",
      "Hacıhasan Mah (ilişi Köyü)",
      "Hacıköy Mah (şeyhoğlu Köyü)",
      "Harman Kaya Mah (yaylatepe Köyü)",
      "Harmanyazı Mah (koşmapınar Köyü)",
      "Hasmil Mah (darsu Köyü)",
      "Hatıp Mah (kızılcaelma Köyü)",
      "Hatip Mah (koşmapınar Köyü)",
      "Hatipoğlu Mah (yaşarlı Köyü)",
      "Isırganlık Mah (ortasökü Köyü)",
      "İkidam Mah (kızılcaelma Köyü)",
      "İmam Mah (ambarcılar Köyü)",
      "İmamoğlu Mah (yaşarlı Köyü)",
      "İnişdibi Mah (ulu Köyü)",
      "İskeleme Mah (darsu Köyü)",
      "Kadıoğlu Mah (darsu Köyü)",
      "Kamak Mah (yaşarlı Köyü)",
      "Kara Kestane Mah (ortasökü Köyü)",
      "Karaköy Mah (kızılcaelma Köyü)",
      "Karamuk Mah (yaşarlı Köyü)",
      "Karapınar Mah (çiçekyayla Köyü)",
      "Karıvo Mah (keşlik Köyü)",
      "Karşıyaka Mah (ortasökü Köyü)",
      "Kavakça Mah (günvaktı Köyü)",
      "Kayardı Mah (tezcan Köyü)",
      "Kazancı Mah (kutluca Köyü)",
      "Keçeci Hasan Mah (görentaş Köyü)",
      "Keçecioğlu Mah (alantepe Köyü)",
      "Kehyaoğlu Mah (kocaçam Köyü)",
      "Kerimler Mah (sarıçiçek Köyü)",
      "Kesim Mah (ulu Köyü)",
      "Kesne Altı Mah (yaylatepe Köyü)",
      "Kışla Mah (inceyazı Köyü)",
      "Kirazlı Maşa Mah (yaylatepe Köyü)",
      "Koçcuğaz Mah (ulu Köyü)",
      "Körağa Mah (ilişi Köyü)",
      "Köroğlu Mah (darsu Köyü)",
      "Körüstan Yaylası Mah (mamatlar Köyü)",
      "Köyyeri Mah (ambarcılar Köyü)",
      "Kuz Mah (koşmapınar Köyü)",
      "Kuz Mah (yaylatepe Köyü)",
      "Küllüoğlu Mah (şeyhoğlu Köyü)",
      "Maden Mah (şeyhoğlu Köyü)",
      "Mahmut Mah (ilişi Köyü)",
      "Mahmutoğlu Mah (kocaçam Köyü)",
      "Maraz Mah (yaşarlı Köyü)",
      "Merkez Demirci Mah (sakızcılar Köyü)",
      "Merkez Mah (ambarcılar Köyü)",
      "Merkez Mah (bayramgazi Köyü)",
      "Merkez Mah (beldeğirmen Köyü)",
      "Merkez Mah (darsu Köyü)",
      "Merkez Mah (dursun Köyü)",
      "Merkez Mah (güngören Köyü)",
      "Merkez Mah (günvaktı Köyü)",
      "Merkez Mah (ışığan Köyü)",
      "Merkez Mah (inceyazı Köyü)",
      "Merkez Mah (kayalar Köyü)",
      "Merkez Mah (kestanesökü Köyü)",
      "Merkez Mah (keşlik Köyü)",
      "Merkez Mah (kirazsökü Köyü)",
      "Merkez Mah (köseali Köyü)",
      "Merkez Mah (kutluca Köyü)",
      "Merkez Mah (sarıçiçek Köyü)",
      "Merkez Mah (şeyhoğlu Köyü)",
      "Merkez Mah (tezcan Köyü)",
      "Merkez Mah (ulu Köyü)",
      "Meske Mah (sarıçiçek Köyü)",
      "Mollo Mah (sakızcılar Köyü)",
      "Mumlar Mah (ortasökü Köyü)",
      "Musta Göynü Mah (yaylatepe Köyü)",
      "Muşna Mah (bayramgazi Köyü)",
      "Nasıhoğlu  Mah (afetevler Mah) (şeyhoğlu Köyü)",
      "Odurnu Aşa Düz Mah (keşlik Köyü)",
      "Odurnu Yukarı Düz Mah (keşlik Köyü)",
      "Orta Mah (görentaş Köyü)",
      "Orta Mah (mamatlar Köyü)",
      "Öküz Yatağı Mah (mamatlar Köyü)",
      "Pan Ahmet Mah (ortasökü Köyü)",
      "Poyrazlar Mah (darsu Köyü)",
      "Sakızcı Mah (sakızcılar Köyü)",
      "Sakızlı Mah (sarıçiçek Köyü)",
      "Sarıcı Erik Yaylası Mah (ortasökü Köyü)",
      "Sarmaşık Mah (kutluca Köyü)",
      "Sökü Mah (mamatlar Köyü)",
      "Subaşı Mah (ortasökü Köyü)",
      "Taşcı Mah (köseali Köyü)",
      "Tekeci Mah (kestanesökü Köyü)",
      "Tekeroğlu Mah (kestanesökü Köyü)",
      "Tekke Mah (çiçekyayla Köyü)",
      "Topçu Mah (alantepe Köyü)",
      "Torba Mah (inceyazı Köyü)",
      "Turnooğlu Mah (darsu Köyü)",
      "Uzunmustafa Mah (yaşarlı Köyü)",
      "Uzunömer Mah (ilişi Köyü)",
      "Yalnızçam Mah (ambarcılar Köyü)",
      "Yanık Mah (sakızcılar Köyü)",
      "Yardere Mah (bayramgazi Köyü)",
      "Yayla Mah (keşlik Köyü)",
      "Yayla Mah (koşmapınar Köyü)",
      "Yayla Mah (mamatlar Köyü)",
      "Yemişen Mah (kızılcaelma Köyü)",
      "Yeni Mah (kestanesökü Köyü)",
      "Yenice Mah (yaylatepe Köyü)",
      "Yılatma Mah (bayramgazi Köyü)",
      "Yukarı Değirmenbaşı Mah (kızılcaelma Köyü)",
      "Yukarı Mah (dursun Köyü)",
      "Yukarı Ofay Mah (koşmapınar Köyü)",
      "Yukarı Tekdal  Mah (hursu Mah) (günvaktı Köyü)",
      "Yukarı Yayla Mah (yaylatepe Köyü)",
      "Yukarıkarahasan Mah (bayramgazi Köyü)",
      "Yukarıkarşı Mah (mamatlar Köyü)",
      "Yukarıköy-yamak-keseçukur Mah (ilişi Köyü)",
      "Yundoluğu Mah (mamatlar Köyü)",
      "Zonya Mah (ambarcılar Köyü)"
    ],
    "Cide": [
      "Bağyurdu Mah",
      "Cumhuriyet Mah",
      "Ece Mah",
      "Irmak Mah",
      "Kasaba Mah",
      "Kemerli Mah",
      "Kırcı Mah",
      "Kumluca Mah",
      "Memiş Mah",
      "Nasuh Mah",
      "Abbaslar Mah (isaköy Köyü)",
      "Absalan Mah (yıldızalan Köyü)",
      "Adıyüzü Mah (çilekçe Köyü)",
      "Ahmetli Mah (başköy Köyü)",
      "Ahmetli Mah (günebakan Köyü)",
      "Akağaç Mah (çayüstü Köyü)",
      "Akbayır Mah (akbayır Köyü)",
      "Akbulut Mah (karakadı Köyü)",
      "Akça Mah (akça Köyü)",
      "Akdemir Mah (musaköy Köyü)",
      "Alayazı Mah (alayazı Köyü)",
      "Alayüz Mah (alayüz Köyü)",
      "Ali Mah (musaköy Köyü)",
      "Altıntaş Mah (kumköy Köyü)",
      "Arılı Mah (ilyasbey Köyü)",
      "Arpalı Mah (konuklar Köyü)",
      "Aşağı Alaca Mah (pehlivanlı Köyü)",
      "Aşağı Kozak Mah (isaköy Köyü)",
      "Aşağı Köseli Mah (kazanlı Köyü)",
      "Aşağı Mah (çamaltı Köyü)",
      "Aşağı Mah (ishakça Köyü)",
      "Aşağı Mah (kovanören Köyü)",
      "Aşağı Mah (köseli Köyü)",
      "Aşağı Mah (nanepınarı Köyü)",
      "Aşağı Mah (sırakaya Köyü)",
      "Aşağıyayla Mah (yaylaköy Köyü)",
      "Aydın Mah (yenice Köyü)",
      "Aydıncık Mah (aydıncık Köyü)",
      "Bayırlı Mah (gökçeler Köyü)",
      "Beldibi Mah (kumköy Köyü)",
      "Beltepe Mah (beltepe Köyü)",
      "Beyköy Mah (sırakaya Köyü)",
      "Beykuş Mah (günebakan Köyü)",
      "Bilallar Mah (çamdibi Köyü)",
      "Buket Mah (isaköy Köyü)",
      "Cengel Mah (çakırlı Köyü)",
      "Cengel Mah (kıranlıkoz Köyü)",
      "Cumayanı Mah (yaylaköy Köyü)",
      "Çakal Mah (velioğlu Köyü)",
      "Çakırlı Mah (çakırlı Köyü)",
      "Çakmakçı Mah (çamdibi Köyü)",
      "Çalca Mah (ağaçbükü Köyü)",
      "Çalça Mah (abdulkadir Köyü)",
      "Çamdibi Mah (çamdibi Köyü)",
      "Çavuş Mah (akça Köyü)",
      "Çerçi Mah (öveçler Köyü)",
      "Çınarcık Mah (kumköy Köyü)",
      "Çınarlar Mah (yıldızalan Köyü)",
      "Çıtaklı Mah (konuklar Köyü)",
      "Çolak Mah (kethüda Köyü)",
      "Dağ Mah (çukurçal Köyü)",
      "Dahallar Mah (ortaca Köyü)",
      "Danışman Mah (gündoğan Köyü)",
      "Değirmen Çayı Mah (baltacı Köyü)",
      "Delihasan Mah (kethüda Köyü)",
      "Demirci Mah (baltacı Köyü)",
      "Demirci Mah (çamaltı Köyü)",
      "Demirci Mah (kazanlı Köyü)",
      "Demirci Mah (kovanören Köyü)",
      "Denizkonak Mah (denizkonak Köyü)",
      "Develi Mah (olucak Köyü)",
      "Dıran Mah (akça Köyü)",
      "Dilek Mah (gökçeören Köyü)",
      "Doğruca Mah (ovacık Köyü)",
      "Döngelce Mah (döngelce Köyü)",
      "Düzköy Mah (düzköy Köyü)",
      "Eceren Mah (çukurçal Köyü)",
      "Emirler Mah (emirler Köyü)",
      "Erencik Mah (yurtbaşı Köyü)",
      "Ese Mah (isaköy Köyü)",
      "Esence Mah (üçağıl Köyü)",
      "Esenler Mah (musaköy Köyü)",
      "Ferah Mah (kethüda Köyü)",
      "Fettah Mah (çamdibi Köyü)",
      "Gebeş Mah",
      "Gede Mah (baltacı Köyü)",
      "Gedikoğlu Mah (velioğlu Köyü)",
      "Gelünne Mah (yıldızalan Köyü)",
      "Gökçeören Mah (gökçeören Köyü)",
      "Göksu Mah (yenice Köyü)",
      "Gömeren Mah (hamitli Köyü)",
      "Göztepe Mah (kumköy Köyü)",
      "Gülpınar Mah (kuşçu Köyü)",
      "Gümüşsu Mah (akbayır Köyü)",
      "Gündoğdu Mah (derebucağı Köyü)",
      "Güney Mah (musaköy Köyü)",
      "Gürgüne Mah (gündoğan Köyü)",
      "Güvenli Mah (kayaardı Köyü)",
      "Güzel Yayla Mah (güzelyayla Köyü)",
      "Güzelce Mah (çayüstü Köyü)",
      "Hacıahmet Mah (hacıahmet Köyü)",
      "Haktanır Mah (çukurçal Köyü)",
      "Halla Mah (ortaca Köyü)",
      "Hamdioğlu Mah (derebucağı Köyü)",
      "Hamitli Mah (hamitli Köyü)",
      "Hamzalı Mah (kumköy Köyü)",
      "Hıdır Mah (yenice Köyü)",
      "Hıdırlar Mah (kazanlı Köyü)",
      "Himmetbeşe Köyü",
      "Hoca Mah (aydıncık Köyü)",
      "Hoca Mah (gökçeören Köyü)",
      "İlyasbey Mah (ilyasbey Köyü)",
      "İsaklar Mah (akça Köyü)",
      "İskele Mah (gökçeler Köyü)",
      "Kabalaklı Mah (karakadı Köyü)",
      "Kadı Mah (yıldızalan Köyü)",
      "Kadıköy Mah (yalçınköy Köyü)",
      "Kahya Mah (kethüda Köyü)",
      "Kahyalar Mah (yaylaköy Köyü)",
      "Kalafat Mah",
      "Kalaycı Mah (velioğlu Köyü)",
      "Kalaycı-aşağı Mah (sırakaya Köyü)",
      "Kapaklı Mah (doğankaya Köyü)",
      "Karabalçık Mah (karakadı Köyü)",
      "Karabudaklar Mah (olucak Köyü)",
      "Karaca Mah (mencekli Köyü)",
      "Karakadı Mah (karakadı Köyü)",
      "Karaman Mah (kovanören Köyü)",
      "Karasu Mah (kazanlı Köyü)",
      "Kardere Mah (yurtbaşı Köyü)",
      "Kargacak Mah (köseli Köyü)",
      "Kargalar Mah (kethüda Köyü)",
      "Kasım Mah",
      "Kayaardı Köyü",
      "Kayadibi Mah (uğurlu Köyü)",
      "Kazallı Mah (kuşçu Köyü)",
      "Kazanlı Mah (kazanlı Köyü)",
      "Keloğlu Mah (velioğlu Köyü)",
      "Kezağzı Mah (kezağzı Köyü)",
      "Kındıralık Mah (kayaardı Köyü)",
      "Kıran Mah (sakallı Köyü)",
      "Kıranlıkoz Mah (kıranlıkoz Köyü)",
      "Kışla Mah (günebakan Köyü)",
      "Kızılovaz Mah (güzelyayla Köyü)",
      "Kirazdere Mah (döngelce Köyü)",
      "Kiraztarla Mah (çilekçe Köyü)",
      "Kocataş Mah (aydıncık Köyü)",
      "Koçlar Mah (çamdibi Köyü)",
      "Kokurdan Mah (okçular Köyü)",
      "Kolca Mah (hamitli Köyü)",
      "Kolca Mah (toygarlı Köyü)",
      "Konakyanı Mah (gökçeören Köyü)",
      "Konuklar Mah (konuklar Köyü)",
      "Köse Mah (akça Köyü)",
      "Kuşçu Mah (kuşçu Köyü)",
      "Kuzdağ Mah (kezağzı Köyü)",
      "Kuzluk Mah (kethüda Köyü)",
      "Küçük Beltepe Mah (beltepe Köyü)",
      "Küplüce Mah (koçlar Köyü)",
      "Mamaklı Mah (konuklar Köyü)",
      "Menük Mah (menük Köyü)",
      "Merkez Mah (abdulkadir Köyü)",
      "Merkez Mah (ağaçbükü Köyü)",
      "Merkez Mah (baltacı Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (beşevler Köyü)",
      "Merkez Mah (çamaltı Köyü)",
      "Merkez Mah (çamdibi Köyü)",
      "Merkez Mah (çataloluk Köyü)",
      "Merkez Mah (çayüstü Köyü)",
      "Merkez Mah (çayyaka Köyü)",
      "Merkez Mah (çilekçe Köyü)",
      "Merkez Mah (çukurçal Köyü)",
      "Merkez Mah (derebağ Köyü)",
      "Merkez Mah (doğankaya Köyü)",
      "Merkez Mah (gökçeler Köyü)",
      "Merkez Mah (günebakan Köyü)",
      "Merkez Mah (kapısuyu Köyü)",
      "Merkez Mah (koçlar Köyü)",
      "Merkez Mah (kovanören Köyü)",
      "Merkez Mah (kumköy Köyü)",
      "Merkez Mah (kuşkayası Köyü)",
      "Merkez Mah (mencekli Köyü)",
      "Merkez Mah (olucak Köyü)",
      "Merkez Mah (ortaca Köyü)",
      "Merkez Mah (toygarlı Köyü)",
      "Merkez Mah (yalçınköy Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Midilli Mah (kezağzı Köyü)",
      "Midillioğlu Mah (velioğlu Köyü)",
      "Musa Mah (musaköy Köyü)",
      "Mutça Mah (kuşkayası Köyü)",
      "Mutlu Mah (günebakan Köyü)",
      "Müdöron Mah (baltacı Köyü)",
      "Müstecip Mah (emirler Köyü)",
      "Namazlı Mah (ovacık Köyü)",
      "Nassura Mah (başköy Köyü)",
      "Neyip Mah (akça Köyü)",
      "Nosuflar Mah (hacıahmet Köyü)",
      "Oğlakça Mah (akça Köyü)",
      "Okçu Mah (musaköy Köyü)",
      "Okçular Mah (okçular Köyü)",
      "Okluca Mah (doğankaya Köyü)",
      "Onbaşı Mah (üçağıl Köyü)",
      "Orta Mah (derebucağı Köyü)",
      "Orta Mah (köseli Köyü)",
      "Ortamescit Mah (kethüda Köyü)",
      "Ovacık Mah (ovacık Köyü)",
      "Örtülü Mah (alayüz Köyü)",
      "Ötegeçe Mah (gündoğan Köyü)",
      "Ötegeçe Mah (yeniköy Köyü)",
      "Öveçler Mah (öveçler Köyü)",
      "Papuççu Mah (yenice Köyü)",
      "Pehlivanlı Mah (pehlivanlı Köyü)",
      "Pekdemir Mah (musaköy Köyü)",
      "Pire Mah (başköy Köyü)",
      "Sadıklar Mah (akbayır Köyü)",
      "Sakallı Mah (sakallı Köyü)",
      "Samanyolu Mah (gökçeler Köyü)",
      "Sapançayı Mah (gündoğan Köyü)",
      "Sarıçam Mah (şenköy Köyü)",
      "Serdeş Mah (gündoğan Köyü)",
      "Seyrenci Mah (musaköy Köyü)",
      "Sipahi Mah",
      "Sivrice Mah (kethüda Köyü)",
      "Softa Mah (emirler Köyü)",
      "Sofular Mah",
      "Soğucak Mah (soğucak Köyü)",
      "Soğuksu Mah (toygarlı Köyü)",
      "Şaban Mah (olucak Köyü)",
      "Şahnalar Mah (kezağzı Köyü)",
      "Şar Mah (köseli Köyü)",
      "Şenköy Mah (şenköy Köyü)",
      "Tanha Mah (kumköy Köyü)",
      "Tarakçı Mah",
      "Taşoluk Mah (öveçler Köyü)",
      "Taşpınar Mah (çilekçe Köyü)",
      "Tatlısu Mah (üçağıl Köyü)",
      "Tekeveli Mah (velioğlu Köyü)",
      "Tepeyurt Mah (derebağ Köyü)",
      "Toygarlı Mah (toygarlı Köyü)",
      "Uğurlu Mah (uğurlu Köyü)",
      "Ulu Mah (çamaltı Köyü)",
      "Urganlı Mah (gökçeören Köyü)",
      "Üçağıl Mah (üçağıl Köyü)",
      "Velioğlu Mah (velioğlu Köyü)",
      "Yağmurlu Mah (kuşçu Köyü)",
      "Yalı Mah (çayyaka Köyü)",
      "Yalı Mah (sakallı Köyü)",
      "Yarımaga Mah (menük Köyü)",
      "Yazı Mah (musaköy Köyü)",
      "Yegenler Mah (menük Köyü)",
      "Yelce Mah (derebağ Köyü)",
      "Yeni Mah (baltacı Köyü)",
      "Yeni Mah (ishakça Köyü)",
      "Yenidoğan Mah (akbayır Köyü)",
      "Yeşilce Mah (koçlar Köyü)",
      "Yeşilyurt Mah (derebağ Köyü)",
      "Yıldızalan Mah (yıldızalan Köyü)",
      "Yukarı Alaca Mah (pehlivanlı Köyü)",
      "Yukarı Kozak Mah (isaköy Köyü)",
      "Yukarı Köseli Mah (kazanlı Köyü)",
      "Yukarı Mah (ağaçbükü Köyü)",
      "Yukarı Mah (ishakça Köyü)",
      "Yukarı Mah (köseli Köyü)",
      "Yukarı Mah (nanepınarı Köyü)",
      "Yukarı Mah (sırakaya Köyü)",
      "Yukarıyayla Mah (yaylaköy Köyü)",
      "Yurtbaşı Mah (yurtbaşı Köyü)"
    ],
    "Çatalzeytin": [
      "Çelebiler Mah",
      "Merkez Mah",
      "Abdullah Mah (arıca Köyü)",
      "Ablu Mah (çağlar Köyü)",
      "Akgün Mah (kaymazlar Köyü)",
      "Akgün Mah (saraçlar Köyü)",
      "Alahasan Mah (ismail Köyü)",
      "Alı Mah (karacakaya Köyü)",
      "Arka Yaylası Mah (çatak Köyü)",
      "Asmakoz Mah (yukarısökü Köyü)",
      "Aşağı Mah (canlar Köyü)",
      "Aşağı Mah (kuğu Köyü)",
      "Aşağısökü Köyü",
      "At Meydanı Mah (hamidiye Köyü)",
      "Attepe Mah (yunuslar Köyü)",
      "Aybarlar Mah (köklüce Köyü)",
      "Ayı Kovduk Mah (hacıreis Köyü)",
      "Bağlarbaşı Mah (kızılcakaya Köyü)",
      "Balcı Küme Mah (paşalı Köyü)",
      "Bardaklı Mah (celallar Köyü)",
      "Başsökü Mah (duran Köyü)",
      "Bekirler Mah (güneşler Köyü)",
      "Bereket Mah (hacıreis Köyü)",
      "Beşevler Mah (sökü Köyü)",
      "Bostancı Mah (hacıreissökü Köyü)",
      "Butlar Mah (çatak Köyü)",
      "Büyükdüz Mah (ismail Köyü)",
      "Cami Yanı Mah (karacakaya Köyü)",
      "Cebeci Mah (karacakaya Köyü)",
      "Celal Mah (hacıreis Köyü)",
      "Cincioğlu Mah (kavakören Köyü)",
      "Civan Mah (yunuslar Köyü)",
      "Cullar Mah (kayadibi Köyü)",
      "Çamlık Mah (çağlar Köyü)",
      "Çayır Mah (çatak Köyü)",
      "Çerçi Mah (epçeler Köyü)",
      "Çıkışlar Mah (saraçlar Köyü)",
      "Çiftlik Mah (duran Köyü)",
      "Çiftlik Mah (kuğu Köyü)",
      "Çörekçi Mah (hacıreis Köyü)",
      "Çukurca Mah (celallar Köyü)",
      "Çukursökü Mah (sökü Köyü)",
      "Dağköy Köyü",
      "Dangalak Mah (kavakören Köyü)",
      "Değirmen Önü Mah (çatak Köyü)",
      "Demirci Mah (çağlar Köyü)",
      "Demirci Mah (köklüce Köyü)",
      "Demircioğlu Mah (köklüce Köyü)",
      "Demiroğlu Mah (paşalı Köyü)",
      "Doğan Yuvası Mah (kirazlı Köyü)",
      "Dumanlar Mah (kaymazlar Köyü)",
      "Düzköy Mah (kayadibi Köyü)",
      "Düzmamlay Mah (kavakören Köyü)",
      "Emecen Mah (hacıreissökü Köyü)",
      "Emirler Mah (kayadibi Köyü)",
      "Epçeli Mah (çepni Köyü)",
      "Es Köprücek Mah (kavaklı Köyü)",
      "Eski Bostan Mah (kavaklı Köyü)",
      "Fevzioğlu Mah (kavakören Köyü)",
      "Fındıcak Mah (çatak Köyü)",
      "Fitillik Mah (güneşler Köyü)",
      "Gafar Mah (hacıreissökü Köyü)",
      "Gecitli Mah (yunuslar Köyü)",
      "Gedikoğlu Mah (duran Köyü)",
      "Ginolu Mah (konaklı Köyü)",
      "Gölharmanı Mah (kızılcakaya Köyü)",
      "Göller Mah (duran Köyü)",
      "Gümüşoğlu Mah (yemişli Köyü)",
      "Güneşli Mah (celallar Köyü)",
      "Güney Mah (karacakaya Köyü)",
      "Güneyler Mah (sırakonak Köyü)",
      "Güneyoğlu Mah (sırakonak Köyü)",
      "Güneysökü Mah (yenibeyler Köyü)",
      "Güzle Mah (çatak Köyü)",
      "Hasanlar Mah (kızılcakaya Köyü)",
      "Hasanpaşa Mah (karacakaya Köyü)",
      "Hatip Mah (çağlar Köyü)",
      "Hatipoğlu Mah (paşalı Köyü)",
      "Höcek Mah (çatak Köyü)",
      "Hüseyinler Mah (kavakören Köyü)",
      "İtoğlu Mah (hacıreis Köyü)",
      "İtoğlu Yaylası Mah (karacakaya Köyü)",
      "Kabalak Düzü Mah (hamidiye Köyü)",
      "Kadı Mah (ismail Köyü)",
      "Kadıköy Mah (paşalı Köyü)",
      "Kadılar Yaylası Mah (yukarısökü Köyü)",
      "Kadıoğlu Küme Mah (paşalı Köyü)",
      "Kadıoğlu Mah (çatak Köyü)",
      "Kalaç Mah (hacıreissökü Köyü)",
      "Kalafat Mah (arıca Köyü)",
      "Kamburoğlu Mah (karacakaya Köyü)",
      "Kapan Mah (arıca Köyü)",
      "Kapıkaya Mah (samancı Köyü)",
      "Kaplak Mah (kirazlı Köyü)",
      "Kara Sarmaşık Mah (saraçlar Köyü)",
      "Karadağlı Mah (fındıklı Köyü)",
      "Karamanlar Mah (kayadibi Köyü)",
      "Karapınar Mah (konaklı Köyü)",
      "Katip Mah (hamidiye Köyü)",
      "Kaya Mah (karacakaya Köyü)",
      "Kayaaltı Küme Mah (paşalı Köyü)",
      "Kayabaşı Mah (çağlar Köyü)",
      "Kayabaşı Mah (doğan Köyü)",
      "Kayabaşı Mah (epçeler Köyü)",
      "Kayışçıoğlu Mah (çatak Köyü)",
      "Kepek Mah (duran Köyü)",
      "Kesecik Mah (çepni Köyü)",
      "Kesnecioğlu Mah (ismail Köyü)",
      "Kete Mah (çatak Köyü)",
      "Kılavuzlar Mah (epçeler Köyü)",
      "Kırlangıç Mah (hacıreis Köyü)",
      "Kıvıllar Mah (kuzsökü Köyü)",
      "Kızılağaççukuru Mah (arıca Köyü)",
      "Kirazbağı Mah (epçeler Köyü)",
      "Koru Yaylası Mah (çatak Köyü)",
      "Köprücek Mah (kavaklı Köyü)",
      "Köroğlu Mah (saraçlar Köyü)",
      "Kulfallar Köyü",
      "Kuz Mah (sökü Köyü)",
      "Küçükyatak Yaylası Mah (karacakaya Köyü)",
      "Kütükcü Mah (karacakaya Köyü)",
      "Mahmut Mah (sökü Köyü)",
      "Masutlar Mah (yenibeyler Köyü)",
      "Menterek Mah (yunuslar Köyü)",
      "Merkez Mah (celallar Köyü)",
      "Merkez Mah (çubuklu Köyü)",
      "Merkez Mah (doğan Köyü)",
      "Merkez Mah (duran Köyü)",
      "Merkez Mah (epçeler Köyü)",
      "Merkez Mah (fındıklı Köyü)",
      "Merkez Mah (güneşler Köyü)",
      "Merkez Mah (hacıreis Köyü)",
      "Merkez Mah (ismail Köyü)",
      "Merkez Mah (kaşlıca Köyü)",
      "Merkez Mah (kavaklı Köyü)",
      "Merkez Mah (kayadibi Köyü)",
      "Merkez Mah (kaymazlar Köyü)",
      "Merkez Mah (kızılcakaya Köyü)",
      "Merkez Mah (konaklı Köyü)",
      "Merkez Mah (kuzsökü Köyü)",
      "Merkez Mah (samancı Köyü)",
      "Merkez Mah (saraçlar Köyü)",
      "Merkez Mah (sırakonak Köyü)",
      "Merkez Mah (sökü Köyü)",
      "Merkez Mah (yemişli Köyü)",
      "Merkez Mah (yenibeyler Köyü)",
      "Merkez Mah (yukarısökü Köyü)",
      "Merkez Mah (yunuslar Köyü)",
      "Merkez Taşçı Mah (çepni Köyü)",
      "Meydancık Mah (hamidiye Köyü)",
      "Mıdanoğlu Mah (kavakören Köyü)",
      "Mısırlık Mah (çepni Köyü)",
      "Mollahasan Mah (yemişli Köyü)",
      "Murat Mah (karacakaya Köyü)",
      "Murat Mah (kuzsökü Köyü)",
      "Mustafaoğlu Mah (paşalı Köyü)",
      "Obruk Mah (karacakaya Köyü)",
      "Obruk Mah (saraçlar Köyü)",
      "Orta Mah (canlar Köyü)",
      "Orta Mah (çağlar Köyü)",
      "Orta Mah (epçeler Köyü)",
      "Orta Mah (kirazlı Köyü)",
      "Osman Mah (hacıreis Köyü)",
      "Osmanoğlu Mah (çepni Köyü)",
      "Özlü Mah (ismail Köyü)",
      "Paşaoğlu Mah (paşalı Köyü)",
      "Patladun Mah (paşalı Köyü)",
      "Pazar Yeri Mah (kirazlı Köyü)",
      "Pür Mah (piri Köyü)",
      "Saatçi Mah (hacıreissökü Köyü)",
      "Sağ Mah (yemişli Köyü)",
      "Saydaş Mah (piri Köyü)",
      "Sazak Mah (arıca Köyü)",
      "Sifan Mah (çepni Köyü)",
      "Somaylı Yurdu Mah (hacıreis Köyü)",
      "Soyıcak Mah (hacıreis Köyü)",
      "Söğüçler Mah (duran Köyü)",
      "Söğüşler Mah (kavaklı Köyü)",
      "Suçatı Mah (karacakaya Köyü)",
      "Sumaylı Yurdu Mah (hacıreissökü Köyü)",
      "Şaban Mah (piri Köyü)",
      "Şişmanlar Mah (epçeler Köyü)",
      "Tarakçılar Mah (yukarısökü Köyü)",
      "Taşgelik Mah (arıca Köyü)",
      "Tepe Yayla Mah (karacakaya Köyü)",
      "Terziler Mah (kaymazlar Köyü)",
      "Tilhan Mah (kızılcakaya Köyü)",
      "Topcu Mah (yunuslar Köyü)",
      "Topçu Mah (arıca Köyü)",
      "Topçuoğlu Mah (kavakören Köyü)",
      "Toprakçıoğlu Mah (sırakonak Köyü)",
      "Tüccar Mah (karacakaya Köyü)",
      "Tüfekçi Mah (hacıreis Köyü)",
      "Tüğmen Mah (kızılcakaya Köyü)",
      "Tülek Mah (arıca Köyü)",
      "Ulu Mah (çağlar Köyü)",
      "Ulucuk Mah (samancı Köyü)",
      "Ulugüney Mah (çubuklu Köyü)",
      "Urluca Mah (sökü Köyü)",
      "Ustaoğlu Mah (paşalı Köyü)",
      "Uzunoğlu Mah (köklüce Köyü)",
      "Uzunpoyra Mah (arıca Köyü)",
      "Üçevler Mah (kaşlıca Köyü)",
      "Yabu Küme Mah (paşalı Köyü)",
      "Yanık Mah (yunuslar Köyü)",
      "Yayla Gavur Pınarı Mah (sırakonak Köyü)",
      "Yayla Mah (celallar Köyü)",
      "Yaylaoluğu Yaylası Mah (çatak Köyü)",
      "Yazıcıoğlu Mah (sırakonak Köyü)",
      "Yeni Mah (çatak Köyü)",
      "Yeni Mah (köklüce Köyü)",
      "Yeniköy Mah (güneşler Köyü)",
      "Yukarı Mah (canlar Köyü)",
      "Yukarı Mah (kuğu Köyü)",
      "Yukarıgüneysökü Mah (yenibeyler Köyü)",
      "Yumru Mah (köklüce Köyü)",
      "Yusuf Mah (karacakaya Köyü)",
      "Yuvacık Mah (yunuslar Köyü)"
    ],
    "Daday": [
      "Bey Mah",
      "Kalem Mah",
      "Kelebek Mah",
      "Merkez Mah",
      "A.kayacık Mah (karamık Köyü)",
      "Abdioğlu Mah (değirmenözü Köyü)",
      "Afurözü Mah (kızılörencik Köyü)",
      "Ağsar Mah (sorkuncuk Köyü)",
      "Ahatveren Mah (çölmekçiler Köyü)",
      "Ahmetoğlu Mah (kızsini Köyü)",
      "Akbıyık Mah (örencik Köyü)",
      "Akçamehmet Mah (demirce Köyü)",
      "Akçiçek Mah (hasanşeyh Köyü)",
      "Akpınar Mah (koçcuğaz Köyü)",
      "Aleybey Mah (akpınar Köyü)",
      "Alınca Mah (gökören Köyü)",
      "Alıncaaltı Mah (gökören Köyü)",
      "Arabacı Mah (örencik Köyü)",
      "Aşağı Mah (bayır Köyü)",
      "Aşağı Mah (bayramlı Köyü)",
      "Aşağı Mah (çölmekçiler Köyü)",
      "Aşağı Mah (karamık Köyü)",
      "Aşağı Mah (tüfekçi Köyü)",
      "Aşağı Mah (üyükören Köyü)",
      "Aşağı Öden Mah (karaağaç Köyü)",
      "Bahçeli Mah (okluk Köyü)",
      "Baltacı Mah (hasanağa Köyü)",
      "Bayram Mah (fasıllar Köyü)",
      "Bayramoğlu Mah (sarpun Köyü)",
      "Bekir Mah (karacaağaç Köyü)",
      "Beyazlar Mah (bağışlar Köyü)",
      "Bıyıklı Mah (karamık Köyü)",
      "Binbaşıoğlu Mah (ertaş Köyü)",
      "Bitigözü Mah (hasanşeyh Köyü)",
      "Bozcaarmut Mah (boyalıca Köyü)",
      "Budaklar Mah (kayabağı Köyü)",
      "Buzağıveren Mah (akılçalman Köyü)",
      "Büyükdere Mah (çölmekçiler Köyü)",
      "Büyükilit Mah (akılçalman Köyü)",
      "Camii Mah (selalmaz Köyü)",
      "Cebecir Mah (bezirkan Köyü)",
      "Ceşler Mah (karacaören Köyü)",
      "Civ Mah (bağışlar Köyü)",
      "Civler Mah (bolatlar Köyü)",
      "Çakal Mah (örencik Köyü)",
      "Çalca Mah (boyalıca Köyü)",
      "Çalca Mah (çamlıbel Köyü)",
      "Çalca Mah (değirmencik Köyü)",
      "Çalca Mah (sorkuncuk Köyü)",
      "Çamoğlu Mah (çavuşlu Köyü)",
      "Çamoluk Mah (çamkonak Köyü)",
      "Çarşı Mah (beykoz Köyü)",
      "Çentekler Mah (davut Köyü)",
      "Çerçiler Mah (kızılörencik Köyü)",
      "Çerkez Mah (değirmenözü Köyü)",
      "Çıllar Mah (elmayazı Köyü)",
      "Çırdak Mah (çamkonak Köyü)",
      "Çiftlik Mah (inciğez Köyü)",
      "Çimkeler Mah (karamık Köyü)",
      "Çomaklar Mah (çavuşlu Köyü)",
      "Çöpören Mah (çamlıbel Köyü)",
      "Çukur Mah (çavuşlu Köyü)",
      "Çukur Mah (görük Köyü)",
      "Davulcu Mah (çölmekçiler Köyü)",
      "Demirci Mah (fasıllar Köyü)",
      "Demirci Mah (sorkun Köyü)",
      "Demirciler Mah (uzbanlar Köyü)",
      "Demirhan Mah (değirmencik Köyü)",
      "Dere Mah (bolatlar Köyü)",
      "Dere Mah (demirce Köyü)",
      "Dere Mah (kayı Köyü)",
      "Deyirmenci Mah (hasanağa Köyü)",
      "Dikmen Mah (gökören Köyü)",
      "Dörtdeğirmenler Mah (kızılörencik Köyü)",
      "Elmacık Mah (demirce Köyü)",
      "Elveren Mah (boyalıca Köyü)",
      "Ercek Mah (hasanağa Köyü)",
      "Erdemler Mah (kızılörencik Köyü)",
      "Esenler Mah (siyahlar Köyü)",
      "Esgili Mah (bağışlar Köyü)",
      "Eski Köy Mah (demirce Köyü)",
      "Eylek Mah (hasanşeyh Köyü)",
      "Fatmaören Mah (üyükören Köyü)",
      "Ferman Mah (davut Köyü)",
      "Fettah Mah (sorkun Köyü)",
      "Fındıcak Mah (çamkonak Köyü)",
      "Fındıcak Mah (kızsini Köyü)",
      "Fındıcak Mah (sorkuncuk Köyü)",
      "Gaza Mah (bezirkan Köyü)",
      "Gogo Mah (koçcuğaz Köyü)",
      "Göçerler Mah (akpınar Köyü)",
      "Göçerler Mah (dereköy Köyü)",
      "Göçmenler Mah (kayı Köyü)",
      "Gökçebel Mah (çölmekçiler Köyü)",
      "Görükçalı Mah (boyalıca Köyü)",
      "Göynük Mah (çamlıbel Köyü)",
      "Gülyan Mah (kızsini Köyü)",
      "Gümüşlüğü Mah (siyahlar Köyü)",
      "Hacı Mah (bezirkan Köyü)",
      "Hacımangil Mah (koçcuğaz Köyü)",
      "Haco Mah (bayır Köyü)",
      "Hacoğlu Mah (çavuşlu Köyü)",
      "Han Mah (karacaören Köyü)",
      "Hasahşeyh Mah (demirce Köyü)",
      "Hasanbey Mah (budaklı Köyü)",
      "Helveci Mah (sorkun Köyü)",
      "Honcatlar Mah (bayramlı Köyü)",
      "Höbüloğlu Mah (dereözü Köyü)",
      "Hüsema Mah (inciğez Köyü)",
      "Hüseyinçamı Mah (gökören Köyü)",
      "İlyas Mah (karaağaç Köyü)",
      "İlyas Mah (kayı Köyü)",
      "Kadı Mah (akpınar Köyü)",
      "Kahyar Mah (kayabağı Köyü)",
      "Kanlıçayır Mah (demirce Köyü)",
      "Karabeyler Mah (sarpun Köyü)",
      "Karaboğa Mah (çayözü Köyü)",
      "Karacakese Mah (çayözü Köyü)",
      "Karagöz Mah (bayramlı Köyü)",
      "Karalar Mah (beykoz Köyü)",
      "Karaömer Mah (fasıllar Köyü)",
      "Karapınar Mah (fasıllar Köyü)",
      "Karşı Mah (kayabağı Köyü)",
      "Kavaklı Mah (beykoz Köyü)",
      "Kayımoğlu Mah (kapaklı Köyü)",
      "Kazıklar Mah (budaklı Köyü)",
      "Kerpiç Mah (değirmencik Köyü)",
      "Kılıçlar Mah (değirmenözü Köyü)",
      "Kışla Mah (fasıllar Köyü)",
      "Kışlacık Mah (akılçalman Köyü)",
      "Kızılinek Mah (çamlıbel Köyü)",
      "Kiraz Mah (çayözü Köyü)",
      "Kiraz Mah (kapaklı Köyü)",
      "Kiret  Mah (meşeli Mah) (bezirkan Köyü)",
      "Kozdere Mah (uzbanlar Köyü)",
      "Köcekler Mah (fasıllar Köyü)",
      "Köse Mah (karacaağaç Köyü)",
      "Köseler Mah (kızsini Köyü)",
      "Kurudaş Mah (fasıllar Köyü)",
      "Kuz Mah (karacaören Köyü)",
      "Külcüler Mah (demirce Köyü)",
      "Maden Mah (bezirkan Köyü)",
      "Manav Mah (davut Köyü)",
      "Mandıra Mah (karacaören Köyü)",
      "Memeören Mah (beykoz Köyü)",
      "Merkez Mah (akılçalman Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (aktaştekke Köyü)",
      "Merkez Mah (alipaşa Köyü)",
      "Merkez Mah (arabacılar Köyü)",
      "Merkez Mah (bağışlar Köyü)",
      "Merkez Mah (bastak Köyü)",
      "Merkez Mah (bayramlı Köyü)",
      "Merkez Mah (beykoz Köyü)",
      "Merkez Mah (bezirkan Köyü)",
      "Merkez Mah (bolatlar Köyü)",
      "Merkez Mah (boyalıca Köyü)",
      "Merkez Mah (boyalılar Köyü)",
      "Merkez Mah (çamkonak Köyü)",
      "Merkez Mah (çayırlı Köyü)",
      "Merkez Mah (çayözü Köyü)",
      "Merkez Mah (çölmekçiler Köyü)",
      "Merkez Mah (davut Köyü)",
      "Merkez Mah (değirmencik Köyü)",
      "Merkez Mah (demirce Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (dereözü Köyü)",
      "Merkez Mah (elmayazı Köyü)",
      "Merkez Mah (ertaş Köyü)",
      "Merkez Mah (gökören Köyü)",
      "Merkez Mah (görük Köyü)",
      "Merkez Mah (hasanağa Köyü)",
      "Merkez Mah (inciğez Köyü)",
      "Merkez Mah (kapaklı Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (karacaağaç Köyü)",
      "Merkez Mah (karacaören Köyü)",
      "Merkez Mah (kavakyayla Köyü)",
      "Merkez Mah (kayı Köyü)",
      "Merkez Mah (kızılörencik Köyü)",
      "Merkez Mah (kızsini Köyü)",
      "Merkez Mah (koçcuğaz Köyü)",
      "Merkez Mah (köşeler Köyü)",
      "Merkez Mah (küten Köyü)",
      "Merkez Mah (okluk Köyü)",
      "Merkez Mah (sarıçam Köyü)",
      "Merkez Mah (sarpun Köyü)",
      "Merkez Mah (siyahlar Köyü)",
      "Merkez Mah (sorkun Köyü)",
      "Merkez Mah (sorkuncuk Köyü)",
      "Merkez Mah (tüfekçi Köyü)",
      "Merkez Mah (uzbanlar Köyü)",
      "Merkez Mah (yazıcameydan Köyü)",
      "Meydan Mah (yazıcameydan Köyü)",
      "Meyre Mah (aktaştekke Köyü)",
      "Miyat Mah (inciğez Köyü)",
      "Mollaahmet Mah (selalmaz Köyü)",
      "Muratoğlu Mah (kavakyayla Köyü)",
      "Musa Mah (değirmenözü Köyü)",
      "Muso Mah (uzbanlar Köyü)",
      "Neciler Mah (karacaağaç Köyü)",
      "Nergiz Mah (çölmekçiler Köyü)",
      "Okçular Mah (çamkonak Köyü)",
      "Olucak Mah (akılçalman Köyü)",
      "Orta Mah (bayır Köyü)",
      "Orta Mah (bayramlı Köyü)",
      "Orta Mah (fasıllar Köyü)",
      "Orta Mah (kayabağı Köyü)",
      "Orta Mah (üyükören Köyü)",
      "Ortakçı Mah (örencik Köyü)",
      "Ömürbey Mah (bolatlar Köyü)",
      "Ören Mah (kapaklı Köyü)",
      "Örencik Mah (karacaören Köyü)",
      "Örencik Mah (örencik Köyü)",
      "Örhene Mah (örencik Köyü)",
      "Ötekışla Mah (beykoz Köyü)",
      "Pazar Mah (selalmaz Köyü)",
      "Pelitveren Mah (okluk Köyü)",
      "Pirdede Mah (kızsini Köyü)",
      "Sabırlar Mah (uzbanlar Köyü)",
      "Sancı Mah (akpınar Köyü)",
      "Sansar Mah (çayözü Köyü)",
      "Saren  Mah (güllüce Mah) (bezirkan Köyü)",
      "Sarıcı Mah (değirmencik Köyü)",
      "Sarımsakcı Mah (sarıçam Köyü)",
      "Sarnıç Mah (okluk Köyü)",
      "Sarpun Mah (sarpun Köyü)",
      "Selam Mah (gökören Köyü)",
      "Selimoğlu Mah (çayırlı Köyü)",
      "Seydibey Mah (bağışlar Köyü)",
      "Sipahi Mah (tüfekçi Köyü)",
      "Sofular Mah (kavakyayla Köyü)",
      "Söğüdek Mah (çamkonak Köyü)",
      "Sungur Mah (akılçalman Köyü)",
      "Sünnetçi Mah (kızsini Köyü)",
      "Şükür Mah (küten Köyü)",
      "Tabaklar Mah (bolatlar Köyü)",
      "Tapoğlu Mah (kayı Köyü)",
      "Taşçılar Mah (elmayazı Köyü)",
      "Tekke Mah (bolatlar Köyü)",
      "Tekke Mah (hasanşeyh Köyü)",
      "Tembeller Mah (boyalıca Köyü)",
      "Tepe Mah (çavuşlu Köyü)",
      "Tepeharman Mah (akılçalman Köyü)",
      "Tepeköy Mah (karacaağaç Köyü)",
      "Tohumlar Mah (siyahlar Köyü)",
      "Topaloğlu Mah (değirmenözü Köyü)",
      "Turidioğlu Mah (çamlıbel Köyü)",
      "Tuzcu Mah (sorkun Köyü)",
      "Ulu Mah (budaklı Köyü)",
      "Üyucek Mah (ertaş Köyü)",
      "Y. Kayacık Mah (karamık Köyü)",
      "Yakalı Mah (arabacılar Köyü)",
      "Yalakderesi Mah (bağışlar Köyü)",
      "Yalama Mah (gökören Köyü)",
      "Yalnız Mah (çavuşlu Köyü)",
      "Yayla Mah (hasanağa Köyü)",
      "Yaylacık Mah (çamkonak Köyü)",
      "Yaylımkara Mah (demirce Köyü)",
      "Yazı Mah (fasıllar Köyü)",
      "Yeni Mah (bağışlar Köyü)",
      "Yeni Mah (çamlıbel Köyü)",
      "Yesir Mah (inciğez Köyü)",
      "Yeşil Mah (üyükören Köyü)",
      "Yukarı Mah (bayır Köyü)",
      "Yukarı Mah (gökören Köyü)",
      "Yukarı Mah (karamık Köyü)",
      "Yukarı Mah (koçcuğaz Köyü)",
      "Yukarıöden Mah (karaağaç Köyü)",
      "Yumurtacı Mah (görük Köyü)",
      "Zaroğlu Mah (hasanşeyh Köyü)"
    ],
    "Devrekani": [
      "Ahiçelebi Mah",
      "Çayırcık Mah",
      "Etçiler Mah",
      "İsmailbey Mah",
      "Kadirbey Mah",
      "Kurtşeyh Mah",
      "Mütevelli Mah",
      "Sazyaka Mah",
      "Ahalar Mah (inciğez Köyü)",
      "Alageriş Mah (bozarmut Köyü)",
      "Alıççılar  Mah ( Alıççı  Mah) (balabanlar Köyü)",
      "Alıççılar  Mah ( Hacı Mah) (balabanlar Köyü)",
      "Alıççılar  Mah ( Yukarı  Mah) (balabanlar Köyü)",
      "Alınca Mah (sarpunalınca Köyü)",
      "Ali Mah (asarcık Köyü)",
      "Alibeyoğlu Mah (çorbacı Köyü)",
      "Aliustaoğlu Mah (bozkoca Köyü)",
      "Arkutça Mah (kanlıabat Köyü)",
      "Aşağı Hasanefendi Mah (habeşli Köyü)",
      "Aşağı Küpler Mah (sarıyonca Köyü)",
      "Aşağı Mah (kasaplar Köyü)",
      "Aşağı Mah (saraydurak Köyü)",
      "Aşağı Yazıhisar Mah (yazıhisar Köyü)",
      "Aşıklar Mah (akmescit Köyü)",
      "Aydınlar Mah (elmalıtekke Köyü)",
      "Ayvaca Mah (bozarmut Köyü)",
      "Balıbey Mah (kuz Köyü)",
      "Başören Mah (arslanbey Köyü)",
      "Bayramoğlu Mah (alaçay Köyü)",
      "Bayramoğlu Mah (doğuörcünler Köyü)",
      "Bereketli Mah (şenlik Köyü)",
      "Beyler Mah (fakılar Köyü)",
      "Beylik Mah (şeyhbali Köyü)",
      "Biyo Mah (ulamış Köyü)",
      "Bozkocatepe Mah (bozkocatepe Köyü)",
      "Bürümce Mah (saraydurak Köyü)",
      "Cinitci Mah (çontay Köyü)",
      "Cinoğlu Mah (alaçay Köyü)",
      "Çakallar Mah (bozkoca Köyü)",
      "Çakıroğlu Mah (pınarözü Köyü)",
      "Çal Mah (saraydurak Köyü)",
      "Çalca Mah (şeyhbali Köyü)",
      "Çalkaya Mah (tekkekızıllar Köyü)",
      "Çerçi Deresi Mah (fakılar Köyü)",
      "Çeribaşı Mah (sinantekke Köyü)",
      "Çiriş Mah (kurt Köyü)",
      "Davutlar Mah (tekkekızıllar Köyü)",
      "Davutoğlu Mah (kadıoğlu Köyü)",
      "Deli Musa Mah (şenlik Köyü)",
      "Delihaliller Mah (kurt Köyü)",
      "Demirci Mah (çörekçi Köyü)",
      "Demirci Mah (kadıoğlu Köyü)",
      "Demirciler Mah (akmescit Köyü)",
      "Dere Mah (ahlatçık Köyü)",
      "Deresökü Mah (kuz Köyü)",
      "Devrencik Mah (saraydurak Köyü)",
      "Dibeden Mah (alınören Köyü)",
      "Dora Mah (saraydurak Köyü)",
      "Duacı Mah (habeşli Köyü)",
      "Duralı Mah (çavuşlu Köyü)",
      "Dündarlar Mah (sarıyonca Köyü)",
      "Ebrek Mah (başakpınar Köyü)",
      "Eğriç Mah (pınarözü Köyü)",
      "Elmalı Cami Mah (çörekçi Köyü)",
      "Emecen Mah (arslanbey Köyü)",
      "Esentaş Mah (fakılar Köyü)",
      "Gafer Mah (baltacak Köyü)",
      "Gelinoğlu Mah (çorbacı Köyü)",
      "Geriş Mah (kuz Köyü)",
      "Gınakayası Mah (saraydurak Köyü)",
      "Göcen Mah (asarcık Köyü)",
      "Göçerler Mah (yazıhisar Köyü)",
      "Gödeşler Mah (yazıhisar Köyü)",
      "Gubatlar Mah (laçin Köyü)",
      "Gümesini Mah (şenlik Köyü)",
      "Güney Mah (akdoğan Köyü)",
      "Güney Mah (hasırlı Köyü)",
      "Güney Mah (kanlıabat Köyü)",
      "Güneyli Mah (belovacık Köyü)",
      "Haceli Mah (kınık Köyü)",
      "Hacı Ahmet Mah (karayazıcılar Köyü)",
      "Hacı Hasan Mah (bıngıldayık Köyü)",
      "Hacı Köse Mah (saraydurak Köyü)",
      "Hatap Mah (bozarmut Köyü)",
      "Hatipoğlu Mah (ahlatçık Köyü)",
      "Hıdıroğlu Mah (kadıoğlu Köyü)",
      "Hışımlar Mah (tekkekızıllar Köyü)",
      "Isırganlı Mah (erenler Köyü)",
      "İğdir Mah (kınık Köyü)",
      "İncigez Mah (akmescit Köyü)",
      "Kabalar Mah (alaçay Köyü)",
      "Kadı Mah (sarıyonca Köyü)",
      "Kadıoğlu Mah (akmescit Köyü)",
      "Kadıoğlu Mah (örenbaşı Köyü)",
      "Karabakal Mah (yazıhisar Köyü)",
      "Karabeyler Mah (başakpınartepe Köyü)",
      "Karacataş Mah (ahlatçık Köyü)",
      "Karaçam Mah (alınören Köyü)",
      "Karahalil Mah (kadıoğlu Köyü)",
      "Karahüseyin Mah (doğuörcünler Köyü)",
      "Karakum Mah (habeşli Köyü)",
      "Karakum Mah (kanlıabat Köyü)",
      "Karaoğlan Mah (belovacık Köyü)",
      "Karaoluk Mah (pınarözü Köyü)",
      "Karaşaban Mah (çörekçi Köyü)",
      "Karaven Mah (karaçam Köyü)",
      "Kavuncular Mah (bozkocatepe Köyü)",
      "Kaya Çukuru Mah (çörekçi Köyü)",
      "Kaylıca Mah (başakpınar Köyü)",
      "Kaymakçı Mah (belovacık Köyü)",
      "Keles Mah (kurt Köyü)",
      "Kemikler Mah (tekkekızıllar Köyü)",
      "Kepez Mah (bozarmut Köyü)",
      "Keş Mah (baltacak Köyü)",
      "Kılcan Mah (alınören Köyü)",
      "Kırcalar Mah (şenlik Köyü)",
      "Kırıncık Mah (kuz Köyü)",
      "Kızılkese Mah (alaçay Köyü)",
      "Kızıllar Mah (tekkekızıllar Köyü)",
      "Kokurdan Mah (sarpunalınca Köyü)",
      "Köstekçi Mah (akmescit Köyü)",
      "Kulaksızlar Mah (kınık Köyü)",
      "Kurmalar Mah (tekkekızıllar Köyü)",
      "Kurtmahmut Mah (habeşli Köyü)",
      "Kurukavak Mah (bozkocatepe Köyü)",
      "Kutucular Mah (doğuörcünler Köyü)",
      "Kuz Mah (kadıoğlu Köyü)",
      "Kuz Mah (kuz Köyü)",
      "Kuzgeçe Mah (inciğez Köyü)",
      "Kuzsökü Mah (kuz Köyü)",
      "Küllü Mah (arslanbey Köyü)",
      "Küp Mah (çavuşlu Köyü)",
      "Maden Mah (arslanbey Köyü)",
      "Merkez Mah (ahlatçık Köyü)",
      "Merkez Mah (akçapınar Köyü)",
      "Merkez Mah (akdoğan Köyü)",
      "Merkez Mah (akmescit Köyü)",
      "Merkez Mah (alçılar Köyü)",
      "Merkez Mah (alınören Köyü)",
      "Merkez Mah (asarcık Köyü)",
      "Merkez Mah (balabanlar Köyü)",
      "Merkez Mah (baltacak Köyü)",
      "Merkez Mah (başakpınar Köyü)",
      "Merkez Mah (başakpınartepe Köyü)",
      "Merkez Mah (belovacık Köyü)",
      "Merkez Mah (bozarmut Köyü)",
      "Merkez Mah (bozkoca Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çavuşlu Köyü)",
      "Merkez Mah (çontay Köyü)",
      "Merkez Mah (çorbacı Köyü)",
      "Merkez Mah (çörekçi Köyü)",
      "Merkez Mah (elmalıtekke Köyü)",
      "Merkez Mah (erenler Köyü)",
      "Merkez Mah (fakılar Köyü)",
      "Merkez Mah (göynükören Köyü)",
      "Merkez Mah (habeşli Köyü)",
      "Merkez Mah (hasırlı Köyü)",
      "Merkez Mah (inciğez Köyü)",
      "Merkez Mah (kadıoğlu Köyü)",
      "Merkez Mah (kanlıabat Köyü)",
      "Merkez Mah (karayazıcılar Köyü)",
      "Merkez Mah (kasaplar Köyü)",
      "Merkez Mah (kızacık Köyü)",
      "Merkez Mah (kurt Köyü)",
      "Merkez Mah (kuz Köyü)",
      "Merkez Mah (laçin Köyü)",
      "Merkez Mah (örenbaşı Köyü)",
      "Merkez Mah (pınarözü Köyü)",
      "Merkez Mah (sarıyonca Köyü)",
      "Merkez Mah (sarpunalınca Köyü)",
      "Merkez Mah (selhattin Köyü)",
      "Merkez Mah (sinantekke Köyü)",
      "Merkez Mah (şeyhbali Köyü)",
      "Merkez Mah (tekkekızıllar Köyü)",
      "Merkez Mah (ulamış Köyü)",
      "Merkez Mah (yazıbelen Köyü)",
      "Merkez Mah (yazıhisar Köyü)",
      "Molla Mah (pınarözü Köyü)",
      "Müezzin Mah (elmalıtekke Köyü)",
      "Naipoğlu Mah (belovacık Köyü)",
      "Nasıfoğlu Mah (pınarözü Köyü)",
      "Nebioğlu Mah (kurt Köyü)",
      "Oğuz Mah (akdoğan Köyü)",
      "Ortaköy Mah (kızacık Köyü)",
      "Oruç Mah (asarcık Köyü)",
      "Oruç Mah (bıngıldayık Köyü)",
      "Osmanbey Mah (kuz Köyü)",
      "Osmanbey Mah (laçin Köyü)",
      "Osmanoğlu Mah (bozkoca Köyü)",
      "Örcünler Mah (doğuörcünler Köyü)",
      "Örencik Mah (çavuşlu Köyü)",
      "Safdağ Mah (çörekçi Köyü)",
      "Sakallar Mah (kınık Köyü)",
      "Saray Mah (saraydurak Köyü)",
      "Sarı Mah (elmalıtekke Köyü)",
      "Sefer Mah (selhattin Köyü)",
      "Sıpacı Mah (çontay Köyü)",
      "Sıpacı Mah (laçin Köyü)",
      "Sofu Mah (arslanbey Köyü)",
      "Sofuoğlu Mah (kadıoğlu Köyü)",
      "Solaklar Mah (akmescit Köyü)",
      "Sökmen Mah (ulamış Köyü)",
      "Sürücü Ahmet Mah (arslanbey Köyü)",
      "Şabanbeyoğlu Mah (hasırlı Köyü)",
      "Şekerci Mah (saraydurak Köyü)",
      "Şenlik Merkez Mah (karaçam Köyü)",
      "Şenlik Pazaryeri Mah (baltacak Köyü)",
      "Tepe Mah (çatak Köyü)",
      "Terzi Mah (kasaplar Köyü)",
      "Tırkış Mah (akmescit Köyü)",
      "Tomalar Mah (akmescit Köyü)",
      "Topallar Mah (akmescit Köyü)",
      "Topcu Mah (çatak Köyü)",
      "Toplar Mah (doğuörcünler Köyü)",
      "Tuğman Mah (elmalıtekke Köyü)",
      "Tuzcular Mah (habeşli Köyü)",
      "Tüysüz Mah (arslanbey Köyü)",
      "Tüysüz Mah (çörekçi Köyü)",
      "Vefa Mah (bıngıldayık Köyü)",
      "Yağbey Mah (habeşli Köyü)",
      "Yalıkoğlu Mah (kurt Köyü)",
      "Yanık Mah (kızacık Köyü)",
      "Yayla Mah (erenler Köyü)",
      "Yayla Mah (yazıhisar Köyü)",
      "Yazıcı Mah (asarcık Köyü)",
      "Yeni Mah (çörekçi Köyü)",
      "Yeni Mah (habeşli Köyü)",
      "Yenikomşu Mah (habeşli Köyü)",
      "Yolasığmaz Mah (sarıyonca Köyü)",
      "Yukarı Hasanefendi Mah (habeşli Köyü)",
      "Yukarı Karaven Mah (karaçam Köyü)",
      "Yukarı Kınık Mah (kınık Köyü)",
      "Yukarı Kuz Mah (kuz Köyü)",
      "Yukarı Küpler Mah (sarıyonca Köyü)",
      "Yukarı Mah (kızacık Köyü)"
    ],
    "Doğanyurt": [
      "Hocaköyü Mah",
      "Merkez Mah",
      "Akpınar Mah (akçabel Köyü)",
      "Alibey Mah (demirci Köyü)",
      "Armutlu Mah (denizbükü Köyü)",
      "Aşağı Mah (akçabel Köyü)",
      "Aşağı Mah (belyaka Köyü)",
      "Aşağıtorazya Mah (denizgörülen Köyü)",
      "Ballık Mah (boğazcık Köyü)",
      "Çatalanız Mah (aşağımescit Köyü)",
      "Çeldirmez Mah (aşağımescit Köyü)",
      "Çiftlik Mah (haskavak Köyü)",
      "Çökme Mah (taşlıpınar Köyü)",
      "Çukur Mah (akçabel Köyü)",
      "Dere Mah (haskavak Köyü)",
      "Derindere Mah (köfünanbarı Köyü)",
      "Ekecek Mah (düzağaç Köyü)",
      "Erencik Mah (düzağaç Köyü)",
      "Erköz Mah (gözalan Köyü)",
      "Eşekci Köyü Mah (düz Köyü)",
      "Evşen Mah (çakırlı Köyü)",
      "Gölgelik Mah (boğazcık Köyü)",
      "Güzle Mah (akçabel Köyü)",
      "Hatip Mah (gürmüdü Köyü)",
      "Ildız Mah (aşağı Ilday Mah) (düz Köyü)",
      "Isındı Mah (baldıran Köyü)",
      "Işvanlı Mah (kısıklı Mah) (düz Köyü)",
      "Karaçam Mah (taşlıpınar Köyü)",
      "Karaman Mah (danışman Köyü)",
      "Karamanağzı Mah (gökçe Köyü)",
      "Karaşlı Mah (taşlıpınar Köyü)",
      "Karşı Mah (belyaka Köyü)",
      "Kaşaltı Mah (yukarımescit Köyü)",
      "Kayabaşı Mah (küçüktepe Köyü)",
      "Kazıklı Mah (düzağaç Köyü)",
      "Kesecik 1 Mah (küçüktepe Köyü)",
      "Kesecik 2 Mah (küçüktepe Köyü)",
      "Kışla Mah (taşlıpınar Köyü)",
      "Kışlak Mah (gürmüdü Köyü)",
      "Koççukuru Mah (haskavak Köyü)",
      "Köy Yeri Mah (ortaburun Köyü)",
      "Köyaltı Başı Mah (düz Köyü)",
      "Kurt Mah (belyaka Köyü)",
      "Kuyumca Mah (düzağaç Köyü)",
      "Kuz Mah (çakırlı Köyü)",
      "Merkez Mah (akçabel Köyü)",
      "Merkez Mah (aşağımescit Köyü)",
      "Merkez Mah (baldıran Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (boğazcık Köyü)",
      "Merkez Mah (çakırlı Köyü)",
      "Merkez Mah (danışman Köyü)",
      "Merkez Mah (demirci Köyü)",
      "Merkez Mah (denizbükü Köyü)",
      "Merkez Mah (denizgörülen Köyü)",
      "Merkez Mah (düz Köyü)",
      "Merkez Mah (düzağaç Köyü)",
      "Merkez Mah (gökçe Köyü)",
      "Merkez Mah (gözalan Köyü)",
      "Merkez Mah (gürmüdü Köyü)",
      "Merkez Mah (haskavak Köyü)",
      "Merkez Mah (kayran Köyü)",
      "Merkez Mah (köfünanbarı Köyü)",
      "Merkez Mah (küçüktepe Köyü)",
      "Merkez Mah (ortaburun Köyü)",
      "Merkez Mah (şirin Köyü)",
      "Merkez Mah (taşlıpınar Köyü)",
      "Merkez Mah (yassıkışla Köyü)",
      "Mure Mah (demirci Köyü)",
      "Pancarlık Mah (gözalan Köyü)",
      "Sarıçiçek Mah (düzağaç Köyü)",
      "Sık Mah (ortaburun Köyü)",
      "Soğanlık Mah (yukarımescit Köyü)",
      "Uğaz Dibi Mah (yukarımescit Köyü)",
      "Urvana Mah (danışman Köyü)",
      "Uvazlı Mah (küçüktepe Köyü)",
      "Uyumlu Mah (akçabel Köyü)",
      "Yanıkdağ Mah (ortaburun Köyü)",
      "Yayla Mah (ılday Mah) (düz Köyü)",
      "Yayla Yeri Mah (köfünanbarı Köyü)",
      "Yukarı Alibey Mah (yassıkışla Köyü)",
      "Yukarı Mah (belyaka Köyü)",
      "Yukarı Mah (gökçe Köyü)",
      "Yukarı Ortaburun Mah (ortaburun Köyü)",
      "Yukarıtorazya Mah (denizgörülen Köyü)",
      "Yüksek Mah (çakırlı Köyü)",
      "Zeytinçukuru Mah (taşlıpınar Köyü)"
    ],
    "Hanönü": [
      "Gelinbükü Mah",
      "Hanönü Mah",
      "Vakıf Geymene Mah",
      "Abazoğlu Mah (bölükyazı Köyü)",
      "Abdioğlu Mah (demircimüezzin Köyü)",
      "Acısu Mah (demircimüezzin Köyü)",
      "Ağacıklı Mah (çaybaşı Köyü)",
      "Akcasu Merkez Mah (akçasu Köyü)",
      "Akdüzen Mah (sirke Köyü)",
      "Akelma Mah (yeniboyundurcak Köyü)",
      "Alageçe Mah (gökçeağaç Köyü)",
      "Alakaya Mah (gökçeağaç Köyü)",
      "Alıç Mah (kavak Köyü)",
      "Alıç Mah (kayabaşı Köyü)",
      "Arpacıkağzı Mah (kavak Köyü)",
      "Aşağı Akcasu Mah (akçasu Köyü)",
      "Aşağı Çukursökü Mah (yılanlı Köyü)",
      "Aşağı Küreçayı Mah (küreçayı Köyü)",
      "Aşağı Sökü Mah (gökbelen Köyü)",
      "Ayderesi Mah (kavak Köyü)",
      "Ayşeoğlu Mah (hocavakıf Köyü)",
      "Ayva Çukuru Mah (gökbelen Köyü)",
      "Ayvaca Mah (yukarıçakırçay Köyü)",
      "Baloğlu Mah (gökçeağaç Köyü)",
      "Bayamca Mah (bölükyazı Köyü)",
      "Bayamca Mah (sirke Köyü)",
      "Bekirli Mah (gökbelen Köyü)",
      "Beşir Mah (yukarıçakırçay Köyü)",
      "Bilal Mah (çaybaşı Köyü)",
      "Bostancı Mah (yeniköy Köyü)",
      "Bürnük Mah (kavak Köyü)",
      "Cozoğlu Mah (hocavakıf Köyü)",
      "Çakırçay Mah (yukarıçakırçay Köyü)",
      "Çakıroğlu Mah (gökbelen Köyü)",
      "Çalçı Mah (yılanlı Köyü)",
      "Çaltıcak Mah (gökçeağaç Köyü)",
      "Çataloluk Mah (kavak Köyü)",
      "Çay Mah (bölükyazı Köyü)",
      "Çayağazı Mah (bağdere Köyü)",
      "Çayırcık Mah (kavak Köyü)",
      "Çayırcık Mah (yeniköy Köyü)",
      "Çaylı Mah (bağdere Köyü)",
      "Çonsuzlar Mah (çaybaşı Köyü)",
      "Çotuk Mah (sarıalan Köyü)",
      "Damlaca Mah (yenice Köyü)",
      "Danacıoğlu Mah (bölükyazı Köyü)",
      "Dangalak Mah (çakırçay Köyü)",
      "Demirci Mah (demircimüezzin Köyü)",
      "Dere Mah (yenice Köyü)",
      "Dikmen Mah (çaybaşı Köyü)",
      "Donguç Mah (çaybaşı Köyü)",
      "Düvenci Mah (yeniboyundurcak Köyü)",
      "Elmacık Mah (gökbelen Köyü)",
      "Ese Mah (bölükyazı Köyü)",
      "Farkuşa Mah (yeniköy Köyü)",
      "Gavurbaşı Mah (gökçeağaç Köyü)",
      "Gerence Mah (çakırçay Köyü)",
      "Gözsökü Mah (bağdere Köyü)",
      "Gözükara Mah (bölükyazı Köyü)",
      "Hacıalioğlu Mah (gökçeağaç Köyü)",
      "Halkabük Köyü",
      "Hasan Mah (yeniboyundurcak Köyü)",
      "Hatipoğlu Mah (demircimüezzin Köyü)",
      "Hayatönü Mah (kavak Köyü)",
      "Hıdırlı Mah (yenice Köyü)",
      "Hocaoğlu Mah (hocavakıf Köyü)",
      "İfritoğlu Mah (çaybaşı Köyü)",
      "İmamoğlu Mah (yeniboyundurcak Köyü)",
      "İpek Mah (bölükyazı Köyü)",
      "Kaçak Mah (demircimüezzin Köyü)",
      "Kadı Mah (çaybaşı Köyü)",
      "Kapan Mah (yukarıçakırçay Köyü)",
      "Karaali Mah (yeniboyundurcak Köyü)",
      "Karabük Mah (çakırçay Köyü)",
      "Karakoç Mah (kavak Köyü)",
      "Karakoç Yaylası Mah (kavak Köyü)",
      "Karaoluk Mah (hocavakıf Köyü)",
      "Kaşharman Mah (kavak Köyü)",
      "Kavak Mah (gökbelen Köyü)",
      "Kavakaltı Mah (yukarıçakırçay Köyü)",
      "Kayadibi Mah (çaybaşı Köyü)",
      "Kızılcaören Mah (kavak Köyü)",
      "Kirt Mah (demircimüezzin Köyü)",
      "Konacık Mah (demircimüezzin Köyü)",
      "Korkmaz Mah (kayabaşı Köyü)",
      "Korucak Mah (bölükyazı Köyü)",
      "Kuzsökü Madanlar Mah (yılanlı Köyü)",
      "Kuzsökü Mah (yılanlı Köyü)",
      "Küpeli Mah (küreçayı Köyü)",
      "Mahmutoğlu Mah (kayabaşı Köyü)",
      "Melleşler Mah (kayabaşı Köyü)",
      "Mercimecük Mah (yılanlı Köyü)",
      "Merkez Mah (bağdere Köyü)",
      "Merkez Mah (gökbelen Köyü)",
      "Merkez Mah (kavak Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (sarıalan Köyü)",
      "Merkez Mah (sirke Köyü)",
      "Merkez Mah (yenice Köyü)",
      "Müezzin Mah (demircimüezzin Köyü)",
      "Öküzaltı Mah (hocavakıf Köyü)",
      "Safran Mah (çaybaşı Köyü)",
      "Sarıcalı Mah (gökçeağaç Köyü)",
      "Sarısökü Mah (çaybaşı Köyü)",
      "Sarnıç Mah (gökbelen Köyü)",
      "Sekecek Mah (hocavakıf Köyü)",
      "Sepetçi Mah (yeniboyundurcak Köyü)",
      "Serdaroğlu Mah (çaybaşı Köyü)",
      "Sinnözü Mah (kavak Köyü)",
      "Sipahi Mah (sarıalan Köyü)",
      "Soyuk Mah (kavak Köyü)",
      "Sökü Mah (hocavakıf Köyü)",
      "Susuz Mah (kayabaşı Köyü)",
      "Tavukçu Mah (sarıalan Köyü)",
      "Tepe Mah (yenice Köyü)",
      "Tepecik Mah (hocavakıf Köyü)",
      "Tepeköy Mah (kavak Köyü)",
      "Top Mah (yeniboyundurcak Köyü)",
      "Türkmen Mah (yılanlı Köyü)",
      "Uncuoğlu Mah (gökçeağaç Köyü)",
      "Üçkaya Mah (çaybaşı Köyü)",
      "Üyücek Mah (kavak Köyü)",
      "Yalak Deresi Mah (yılanlı Köyü)",
      "Yamalı Mah (kayabaşı Köyü)",
      "Yarkaya Mah (kayabaşı Köyü)",
      "Yayla Evleri Mah (yılanlı Köyü)",
      "Yazlık Mah (kavak Köyü)",
      "Yozlu Mah (bölükyazı Köyü)",
      "Yukarı Çukursökü Mah (yılanlı Köyü)",
      "Yukarı Küreçayı Mah (küreçayı Köyü)",
      "Yukarı Sökü Mah (gökbelen Köyü)",
      "Yumacık Mah (gökçeağaç Köyü)",
      "Yürükören Mah (yeniköy Köyü)",
      "Zeybekoğlu Mah (bölükyazı Köyü)"
    ],
    "İhsangazi": [
      "Afşar Mah",
      "Çay Mah",
      "Elçelebi Mah",
      "İsalar Mah",
      "Kalfat Mah",
      "Kuşçular Mah",
      "Sevindik Mah",
      "Sipahiler Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Ahsap Mah (obruk Köyü)",
      "Akkaya Mah (akkaya Köyü)",
      "Alaca Mah (bozarmut Köyü)",
      "Alçıoğlu Mah (enbiya Köyü)",
      "Alınca Mah (koçcuğaz Köyü)",
      "Anbarcı Mah (görpe Köyü)",
      "Aşağı İmirler Mah (akkaya Köyü)",
      "Aşağı Kavak Mah (kızıleller Köyü)",
      "Aşağı Mah (dağyolu Köyü)",
      "Aşağı Mah (görpe Köyü)",
      "Aşağı Mah (hocahacip Köyü)",
      "Aşağı Mah (sarıpınar Köyü)",
      "Aşağı Sıvar Mah (sünlük Köyü)",
      "Aşağı Sökü Mah (hocahacip Köyü)",
      "Aşağı Sünlük Mah (sünlük Köyü)",
      "Bedo Mah (akkirpi Köyü)",
      "Belençal Mah (belençal Köyü)",
      "Buğdüz Mah (çatalyazı Köyü)",
      "Büyük Köy Mah (bedirgeriş Köyü)",
      "Camiönü Mah (hocahacip Köyü)",
      "Çakıllar Mah (haydarlar Köyü)",
      "Çato Mah (obruk Köyü)",
      "Çavuş Mah (akkirpi Köyü)",
      "Çömen Mah (bozarmut Köyü)",
      "Değirmenbaşı Mah (akkaya Köyü)",
      "Dere Mah (kızıleller Köyü)",
      "Dere Mah (obruk Köyü)",
      "Doruk Yayla Mah (sarıpınar Köyü)",
      "Eceler Mah (belençal Köyü)",
      "Eminefendi Mah (görpe Köyü)",
      "Fatmaoğlu Mah (hocahacip Köyü)",
      "Gamit Mah (belençal Köyü)",
      "Genişçe Orta Mah (bedirgeriş Köyü)",
      "Gökçe Mah (çiçekpınar Köyü)",
      "Göpco Mah (sünlük Köyü)",
      "Güney Mah (haydarlar Köyü)",
      "Halil Mah (bozarmut Köyü)",
      "Hanönü Mah (hocahacip Köyü)",
      "Hasanpaşa Mah (inciğez Köyü)",
      "Hatip Mah (kayapınar Köyü)",
      "Himmet Mah (hocahacip Köyü)",
      "Hoca Mah (haydarlar Köyü)",
      "Hüsemoğlu Mah (sepetçioğlu Köyü)",
      "İmam Mah (çatalyazı Köyü)",
      "İmamoğlu Mah (haydarlar Köyü)",
      "İmirler Mah (akkaya Köyü)",
      "Kadılar Mah (haydarlar Köyü)",
      "Kanlıca Mah (bozarmut Köyü)",
      "Kanlıgöl Mah (dağyolu Köyü)",
      "Karabalta Mah (koçcuğaz Köyü)",
      "Karabiber Mah (kayapınar Köyü)",
      "Karaçalı Mah (enbiya Köyü)",
      "Karayaprak Mah (yarışlar Köyü)",
      "Kaya Mah (çatalyazı Köyü)",
      "Kayalı Mah (akkirpi Köyü)",
      "Kepenek Mah (kayapınar Köyü)",
      "Kırıkoğlu Mah (hocahacip Köyü)",
      "Kışla Mah (obruk Köyü)",
      "Köseler Mah (çatalyazı Köyü)",
      "Köseler Mah (görpe Köyü)",
      "Köseoğlu Mah (akkaya Köyü)",
      "Kuşlar Mah (haydarlar Köyü)",
      "Kutucu Mah (çiçekpınar Köyü)",
      "Kuzgeçe Mah (akkaya Köyü)",
      "Mangaz Mah (inciğez Köyü)",
      "Merkez Mah (akkirpi Köyü)",
      "Merkez Mah (çiçekpınar Köyü)",
      "Merkez Mah (enbiya Köyü)",
      "Merkez Mah (haydarlar Köyü)",
      "Merkez Mah (inciğez Köyü)",
      "Merkez Mah (kapaklı Köyü)",
      "Merkez Mah (kayapınar Köyü)",
      "Merkez Mah (kızıleller Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (sepetçioğlu Köyü)",
      "Merkez Mah (sünlük Köyü)",
      "Merkez Mah (yarışlar Köyü)",
      "Muazzin Mah (hocahacip Köyü)",
      "Mutaf Mah (enbiya Köyü)",
      "Obruk Mah (obruk Köyü)",
      "Okluca Mah (sünlük Köyü)",
      "Olçak Mah (kapaklı Köyü)",
      "Ortaca Mah (koçcuğaz Köyü)",
      "Ortalık Mah (kızıleller Köyü)",
      "Ötegeçe Mah (bozarmut Köyü)",
      "Parlalık Mah (obruk Köyü)",
      "Pelpo Mah (akkirpi Köyü)",
      "Piyal Mah (koçcuğaz Köyü)",
      "Salam Mah (obruk Köyü)",
      "Sekecek Kışlası Mah (belençal Köyü)",
      "Sekecek Mah (belençal Köyü)",
      "Seyranlı Mah (hocahacip Köyü)",
      "Sıklık Mah (obruk Köyü)",
      "Sinderler Mah (çatalyazı Köyü)",
      "Şahinler Mah (örencik Köyü)",
      "Şatır Mah (akkaya Köyü)",
      "Şeyh Mah (çatalyazı Köyü)",
      "Tarakçı Mah (inciğez Köyü)",
      "Tepe Mah (koçcuğaz Köyü)",
      "Terzi Mah (enbiya Köyü)",
      "Tokuroğlu Mah (bozarmut Köyü)",
      "Uzunoğlu Mah (enbiya Köyü)",
      "Yeni Mah (dağyolu Köyü)",
      "Yeni Mah (sarıpınar Köyü)",
      "Yeni Yayla Mah (bedirgeriş Köyü)",
      "Yukarı Bucak Mah (inciğez Köyü)",
      "Yukarı Kavak Mah (kızıleller Köyü)",
      "Yukarı Mah (akkirpi Köyü)",
      "Yukarı Mah (dağyolu Köyü)",
      "Yukarı Mah (koçcuğaz Köyü)",
      "Yukarı Mah (sarıpınar Köyü)",
      "Yukarı Sökü Mah (hocahacip Köyü)",
      "Yukarı Sünlük Mah (sünlük Köyü)",
      "Yukarısival Mah (bozarmut Köyü)",
      "Yusufoğlu Mah (kayapınar Köyü)",
      "Zeybek Mah (görpe Köyü)"
    ],
    "İnebolu": [
      "Aşağıhatipbağı Mah",
      "Avara Mah",
      "Boyran Mah",
      "Camikebir Mah",
      "Cünürye Mah",
      "Çamlıca Mah",
      "Karaca Mah",
      "Karadeniz Mah",
      "Kızılkara Mah",
      "Musa Mah",
      "Yakaboyu Mah",
      "Yeni Mah",
      "Yeşilöz Mah",
      "Yukarıhatipbağı Mah",
      "Ağa Mah (evrenye Köyü)",
      "Aha Mah (keloğlu Köyü)",
      "Akpınar Mah (karabey Köyü)",
      "Aktaş Köyü",
      "Ali Mah (deresökü Köyü)",
      "Ambarcık Mah (çiçekyazı Köyü)",
      "Apti Mah (kabalarsökü Köyü)",
      "Araldı Mah (kabalar Köyü)",
      "Arkutça Mah (karşıyaka Köyü)",
      "Armutça Mah (çamdalı Köyü)",
      "Aşağı Güde Mah (güde Köyü)",
      "Aşağı Mah (aşağıçaylı Köyü)",
      "Aşağı Mah (erenyolu Köyü)",
      "Aşağı Mah (ikiyaka Köyü)",
      "Aşağı Mah (yukarıköy Köyü)",
      "Atatürk Mah (özlüce Köyü)",
      "Ayan Mah (evrenye Köyü)",
      "Ayvaköy Köyü",
      "Bakacak Mah (karşıyaka Köyü)",
      "Bekiroğlu Mah (deliktaş Köyü)",
      "Belence Köyü",
      "Bıçakçılar Mah (dibek Köyü)",
      "Böcököyü Mah (sakalar Köyü)",
      "Börekçi Mah (üçlüce Köyü)",
      "Budak Mah (şeyhömer Köyü)",
      "Büyük Mah (gökbel Köyü)",
      "Celi Mah (kabalarsökü Köyü)",
      "Cevizleryanı Mah (yunusköy Köyü)",
      "Çakal Mah (uluyol Köyü)",
      "Çakıcı Mah (çaydüzü Köyü)",
      "Çanakçı Mah (salıcıoğlu Köyü)",
      "Çandır Mah (çiçekyazı Köyü)",
      "Çayır Mah (ikiyaka Köyü)",
      "Çiloğlu Mah (güde Köyü)",
      "Çorak Mah (atabeyli Köyü)",
      "Çorbacı Mah (korupınar Köyü)",
      "Dağ Mah (deresökü Köyü)",
      "Danaoğlu Mah (hayrioğlu Köyü)",
      "Danya Mah (bayıralan Köyü)",
      "Dayı Mah (şeyhömer Köyü)",
      "Demir Mah (bayıralan Köyü)",
      "Demirci Mah (esenyurt Köyü)",
      "Demirci Mah (keloğlu Köyü)",
      "Dere Mah (soğukpınar Köyü)",
      "Efendioğlu Mah (dibek Köyü)",
      "Eğrioğlu Mah (hacıibrahim Köyü)",
      "Elik Mah (evrenye Köyü)",
      "Ercekoz Mah (şamalı Köyü)",
      "Erikpınarı Mah (hamitköy Köyü)",
      "Erkekarpa Mah (erkekarpa Köyü)",
      "Eyrik Mah (özlüce Köyü)",
      "Fadara Mah (belen Köyü)",
      "Fatırız Mah (hayrioğlu Köyü)",
      "Fidimse Mah (akgüney Köyü)",
      "Geriş Mah (yaztepe Köyü)",
      "Giboru Mah (karşıyaka Köyü)",
      "Göçenoğlu Mah (şamaoğlu Köyü)",
      "Gökçevre Köyü",
      "Göl Mah (deresökü Köyü)",
      "Göller Mah (erkekarpa Köyü)",
      "Gürgenlik Mah (karşıyaka Köyü)",
      "Güzel Yalı Mah (yaztepe Köyü)",
      "Hacı Mah (akçay Köyü)",
      "Hacıefendioğlu Mah (dibek Köyü)",
      "Hamdioğlu Mah (çubuk Köyü)",
      "Hızaryanı Mah (güneşli Köyü)",
      "İmam Mah (şeyhömer Köyü)",
      "İskir Mah (uğrak Köyü)",
      "Kabamdoğlu Mah (üçlüce Köyü)",
      "Kabaoğlu Mah (dibek Köyü)",
      "Kadıoğlum Mah (ayvat Köyü)",
      "Kadırga Mah (köroğlu Köyü)",
      "Kafa Mah (göçkün Köyü)",
      "Kahyaoğlu Mah (şeyhömer Köyü)",
      "Karabaş Mah (evrenye Köyü)",
      "Karacakaya Mah (dikili Köyü)",
      "Karafal Mah (uluköy Köyü)",
      "Karşı Mah (atabeyli Köyü)",
      "Karşı Mah (hacıibrahim Köyü)",
      "Karşı Mah (korupınar Köyü)",
      "Kayaaltı Mah (özbaşı Köyü)",
      "Kayardı Mah (şamaoğlu Köyü)",
      "Kayıkçıoğlu Mah (deliktaş Köyü)",
      "Keleş Mah (üçlüce Köyü)",
      "Keleşoğlu Mah (üçlüce Köyü)",
      "Kireççik Mah (şamaoğlu Köyü)",
      "Kocaoğlu Mah (dibek Köyü)",
      "Kolca Mah (çamdalı Köyü)",
      "Konakyanı Mah (doğanören Köyü)",
      "Kök Mah (kabalar Köyü)",
      "Köle Mah (korupınar Köyü)",
      "Köprülü Mah (bayıralan Köyü)",
      "Köprülü Mah (hacımehmet Köyü)",
      "Köyüstü Mah (hacıibrahim Köyü)",
      "Kurtoğlu Mah (deliktaş Köyü)",
      "Kuş Mah (hacıibrahim Köyü)",
      "Kuşburnu Mah (beyler Köyü)",
      "Küçük Mah (gökbel Köyü)",
      "Küllü Mah (erenyolu Köyü)",
      "Küpoğlu Mah (bayıralan Köyü)",
      "Manastır Mah (ikizler Köyü)",
      "Merkel Mah (şamaoğlu Köyü)",
      "Merkez Mah (akçay Köyü)",
      "Merkez Mah (akgüney Köyü)",
      "Merkez Mah (akkonak Köyü)",
      "Merkez Mah (alaca Köyü)",
      "Merkez Mah (atabeyli Köyü)",
      "Merkez Mah (ayvat Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (bayıralan Köyü)",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (belören Köyü)",
      "Merkez Mah (beyler Köyü)",
      "Merkez Mah (çamdalı Köyü)",
      "Merkez Mah (çaydüzü Köyü)",
      "Merkez Mah (çaykıyı Köyü)",
      "Merkez Mah (çiçekyazı Köyü)",
      "Merkez Mah (çubuk Köyü)",
      "Merkez Mah (deliktaş Köyü)",
      "Merkez Mah (deresökü Köyü)",
      "Merkez Mah (dibek Köyü)",
      "Merkez Mah (dikili Köyü)",
      "Merkez Mah (doğanören Köyü)",
      "Merkez Mah (durupınar Köyü)",
      "Merkez Mah (erkekarpa Köyü)",
      "Merkez Mah (esenyurt Köyü)",
      "Merkez Mah (evrenye Köyü)",
      "Merkez Mah (göçkün Köyü)",
      "Merkez Mah (güneşli Köyü)",
      "Merkez Mah (hacıibrahim Köyü)",
      "Merkez Mah (hacımehmet Köyü)",
      "Merkez Mah (hamitköy Köyü)",
      "Merkez Mah (hayrioğlu Köyü)",
      "Merkez Mah (hürmetli Köyü)",
      "Merkez Mah (ikizler Köyü)",
      "Merkez Mah (kabalar Köyü)",
      "Merkez Mah (kabalarsökü Köyü)",
      "Merkez Mah (karabey Köyü)",
      "Merkez Mah (kayaelması Köyü)",
      "Merkez Mah (keloğlu Köyü)",
      "Merkez Mah (köroğlu Köyü)",
      "Merkez Mah (köseköy Köyü)",
      "Merkez Mah (kuzluk Köyü)",
      "Merkez Mah (örtülü Köyü)",
      "Merkez Mah (özbaşı Köyü)",
      "Merkez Mah (salıcıoğlu Köyü)",
      "Merkez Mah (soğukpınar Köyü)",
      "Merkez Mah (şamalı Köyü)",
      "Merkez Mah (uğrak Köyü)",
      "Merkez Mah (uluköy Köyü)",
      "Merkez Mah (uluyol Köyü)",
      "Merkez Mah (yamaç Köyü)",
      "Merkez Mah (yaztepe Köyü)",
      "Merkez Mah (yukarıköy Köyü)",
      "Merkez Mah (yuvacık Köyü)",
      "Meydan Mah (soğukpınar Köyü)",
      "Mikail Mah (göçkün Köyü)",
      "Molla Ömer Mah (belören Köyü)",
      "Mumra Mah (karabey Köyü)",
      "Musrat Mah (uğrak Köyü)",
      "Müezzin Mah (bayıralan Köyü)",
      "Namazgah Mah (evrenye Köyü)",
      "Orta Mah (aşağıçaylı Köyü)",
      "Orta Mah (korupınar Köyü)",
      "Ortaca Mah (dibek Köyü)",
      "Ortaköyü Mah (sakalar Köyü)",
      "Osmanoğlu Mah (şeyhömer Köyü)",
      "Özlüce Mah (toklukaya Köyü)",
      "Pazen Mah (bayıralan Köyü)",
      "Sağlık Ocağı Mah (özlüce Köyü)",
      "Sakalar Mah (sakalar Köyü)",
      "San Mah (hacımehmet Köyü)",
      "Sarıahmet Mah (deresökü Köyü)",
      "Selam Mah (alaca Köyü)",
      "Selim Mah (beyler Köyü)",
      "Serenli Mah (erenyolu Köyü)",
      "Sırçalık Mah (karşıyaka Köyü)",
      "Softa Mah (şamalı Köyü)",
      "Söğütlü Çeşme Mah (yaztepe Köyü)",
      "Sökü Köyü",
      "Sökücek Mah (uluyol Köyü)",
      "Sömöz Mah (güneşli Köyü)",
      "Sörptarla Mah (yukarıköy Köyü)",
      "Şahne Mah (deresökü Köyü)",
      "Şehit Mehmet Aslan Mah (çubuk Köyü)",
      "Şıh Mah (ikiyaka Köyü)",
      "Şirvan Mah (ayvat Köyü)",
      "Şişman Mah (erenyolu Köyü)",
      "Taşburun Köyü",
      "Taşoluk Köyü",
      "Terelik Mah (yaztepe Köyü)",
      "Terzi Mah (gökbel Köyü)",
      "Tokatlı Mah (üçlüce Köyü)",
      "Toklukaya Mah (toklukaya Köyü)",
      "Topal Mustafaoğlu Mah (çubuk Köyü)",
      "Tozluyurt Mah (örtülü Köyü)",
      "Üçevler Mah (üçevler Köyü)",
      "Yanar Mah (yaztepe Köyü)",
      "Yayla Mah (salıcıoğlu Köyü)",
      "Yele Mah (toklukaya Köyü)",
      "Yeneri Mah (başköy Köyü)",
      "Yolüstü Köyü",
      "Yolüstü Mah (yolüstü Köyü)",
      "Yörecik Mah (çaydüzü Köyü)",
      "Yukarı Güde Mah (güde Köyü)",
      "Yukarı Mah (aşağıçaylı Köyü)",
      "Yukarı Mah (deliktaş Köyü)",
      "Yukarı Mah (durupınar Köyü)",
      "Yukarı Mah (ikiyaka Köyü)",
      "Yukarıçaylı Köyü",
      "Yunusköy Mah (yunusköy Köyü)",
      "Zambak Mah (kuzluk Köyü)",
      "Zehi Mah (yaztepe Köyü)"
    ],
    "Küre": [
      "Camievsat Mah",
      "Camikebir Mah",
      "Müderris Mah",
      "Saman Mah",
      "Abdi Mah (karadonu Köyü)",
      "Abdullah Mah (kozköy Köyü)",
      "Abuda Mah (çat Köyü)",
      "Abut Mah (ikizçiler Köyü)",
      "Ahlatcık Mah (kösreli Köyü)",
      "Akmanoğlu Mah (canbaz Köyü)",
      "Akpınar Mah (afşarimam Köyü)",
      "Alacık Mah (kösreli Köyü)",
      "Ali Ağa Mah (alacık Köyü)",
      "Ali Efendi Mah (kösreli Köyü)",
      "Aliağa Mah (afşarimam Köyü)",
      "Ambarlı Mah (uzunöz Köyü)",
      "Arabacılar Mah (kösreli Köyü)",
      "Argı Mah (afşargüney Köyü)",
      "Aşağı Çatak Mah (çatak Köyü)",
      "Aşağı Güney Mah (afşargüney Köyü)",
      "Aşağı Kışla Mah (beşören Köyü)",
      "Aşağı Sarpun Mah (sarpun Köyü)",
      "Ayazoğlu Mah (uzunöz Köyü)",
      "Battallar Mah (karaman Köyü)",
      "Baydıoğlu Mah (sipahiler Köyü)",
      "Bediroğlu Mah (karaman Köyü)",
      "Bideci Mah (kayadibi Köyü)",
      "Boğaz Mah (beyalan Köyü)",
      "Boyacı Mah (kayadibi Köyü)",
      "Bürüm Yayla Evleri Mah (bürüm Köyü)",
      "Canbazoğlu Mah (uzunöz Köyü)",
      "Cumhuriyet Mah (ersizler Köyü)",
      "Curalar Mah (iğdir Köyü)",
      "Çakal Mah (kayadibi Köyü)",
      "Çakıllı Mah (belören Köyü)",
      "Çal 1 Mah (sipahiler Köyü)",
      "Çal 2 Mah (sipahiler Köyü)",
      "Çayan Mah (beyalan Köyü)",
      "Çelebi Mah (karadonu Köyü)",
      "Çırak Mah (imralı Köyü)",
      "Çolak Mah (alacık Köyü)",
      "Çuha Mah (kayadibi Köyü)",
      "Çukur Mah (ersizler Köyü)",
      "Depeyurt Mah (koyunkırtık Köyü)",
      "Dereköy Mah (iğdir Köyü)",
      "Dıraban Mah (karaman Köyü)",
      "Dibek Mah (canbaz Köyü)",
      "Diprecci Mah (ahmetbeşe Köyü)",
      "Doruk Mah (beyalan Köyü)",
      "Durasanlar Mah (taşpınar Köyü)",
      "Ecevit Mah (uzunöz Köyü)",
      "Eminoğlu Mah (afşarimam Köyü)",
      "Esentepe Mah (camili Köyü)",
      "Eskimeşe Mah (kozköy Köyü)",
      "Geriş Mah (karadonu Köyü)",
      "Gürcü Mah (kozköy Köyü)",
      "Habiboğlu Mah (camili Köyü)",
      "Hacıömer Mah (canbaz Köyü)",
      "Haramlar Mah (kozköy Köyü)",
      "Hatip Mah (afşargüney Köyü)",
      "Hoca Ustaoğlu Mah (topçu Köyü)",
      "Hüsün Mah (taşpınar Köyü)",
      "İlata Mah (güllüce Köyü)",
      "İmam Mah (afşarimam Köyü)",
      "İmam Mah (ersizlerdere Köyü)",
      "İpsinne Mah (ersizlerdere Köyü)",
      "Kabaoğlu Mah (kozköy Köyü)",
      "Kadalı Mah (ikizçiler Köyü)",
      "Kanlıcadere Mah (taşpınar Köyü)",
      "Karaahmet Mah (ersizlerdere Köyü)",
      "Karadere Mah (camili Köyü)",
      "Karagöz Mah (güney Köyü)",
      "Karagürgen Mah (alacık Köyü)",
      "Karaş Mah (ersizlerdere Köyü)",
      "Karşı Mah (camili Köyü)",
      "Kaya Mah (kayadibi Köyü)",
      "Kayaarkası Mah (topçu Köyü)",
      "Kazoğlu Mah (canbaz Köyü)",
      "Kerpiç Mah (karadonu Köyü)",
      "Kervansaray Mah (karadonu Köyü)",
      "Kışla Mah (bürüm Köyü)",
      "Kışla Mah (kozköy Köyü)",
      "Kocaoğlu Mah (sarpun Köyü)",
      "Koçcuğaz Mah (ikizçiler Köyü)",
      "Kör İsmailağa Mah (afşargüney Köyü)",
      "Kubatoğlu Mah (iğdir Köyü)",
      "Kurtoğlu Mah (karadonu Köyü)",
      "Kuş Mah (köstekçiler Köyü)",
      "Kuşca Mah (ikizçiler Köyü)",
      "Kuz Mah (sipahiler Köyü)",
      "Kuztarla Mah (imralı Köyü)",
      "Küme Evleri Mah (karaman Köyü)",
      "Masruf Mah (camili Köyü)",
      "Merkez Mah (afşarimam Köyü)",
      "Merkez Mah (ahmetbeşe Köyü)",
      "Merkez Mah (alacık Köyü)",
      "Merkez Mah (avcıpınarı Köyü)",
      "Merkez Mah (belören Köyü)",
      "Merkez Mah (beşören Köyü)",
      "Merkez Mah (bürüm Köyü)",
      "Merkez Mah (camili Köyü)",
      "Merkez Mah (çat Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çaybükü Köyü)",
      "Merkez Mah (ersizler Köyü)",
      "Merkez Mah (ersizlerdere Köyü)",
      "Merkez Mah (güllüce Köyü)",
      "Merkez Mah (güney Köyü)",
      "Merkez Mah (iğdir Köyü)",
      "Merkez Mah (ikizçiler Köyü)",
      "Merkez Mah (imralı Köyü)",
      "Merkez Mah (karaman Köyü)",
      "Merkez Mah (kesepınar Köyü)",
      "Merkez Mah (koyunkırtık Köyü)",
      "Merkez Mah (kösreli Köyü)",
      "Merkez Mah (köstekçiler Köyü)",
      "Merkez Mah (sarpun Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Merkez Mah (taşpınar Köyü)",
      "Merkez Mah (topçu Köyü)",
      "Mollahasan Mah (koyunkırtık Köyü)",
      "Muratoğlu Mah (afşargüney Köyü)",
      "Nazır Mah (kösreli Köyü)",
      "Ortakçıoğlu Mah (camili Köyü)",
      "Ortaköy Mah (koyunkırtık Köyü)",
      "Ödemiş Mah (sipahiler Köyü)",
      "Öksüzler Mah (karadonu Köyü)",
      "Öteyüz Mah (beyalan Köyü)",
      "Saka Mah (kösreli Köyü)",
      "Samanlıklar Mah (bürüm Köyü)",
      "Samutoğlu Mah (afşarimam Köyü)",
      "Sarköy Mah (ikizçiler Köyü)",
      "Satı Mah (köstekçiler Köyü)",
      "Satıoğlu Mah (uzunöz Köyü)",
      "Sazak Mah (beyalan Köyü)",
      "Sırma Mah (çat Köyü)",
      "Softaoğlu Mah (camili Köyü)",
      "Sofuoğlu Mah (belören Köyü)",
      "Şalgamoğlu Mah (canbaz Köyü)",
      "Şatır Mah (karadonu Köyü)",
      "Şişmanoğlu Mah (camili Köyü)",
      "Taşçanak Mah (çaybükü Köyü)",
      "Tepe Mah (karadonu Köyü)",
      "Tokalak Mah (karadonu Köyü)",
      "Topçu Mah (alacık Köyü)",
      "Tosyalı Mah (iğdir Köyü)",
      "Tulumoğlu Mah (ahmetbeşe Köyü)",
      "Tülüoğlu Mah (camili Köyü)",
      "Ulacık Mah (iğdir Köyü)",
      "Uvaz Mah (çaybükü Köyü)",
      "Uzun Ahmet Mah (kösreli Köyü)",
      "Verziyan Mah (ahmetbeşe Köyü)",
      "Yahya Mah (güney Köyü)",
      "Yayla Evleri Mah (çaybükü Köyü)",
      "Yayla Evleri Mah (karaman Köyü)",
      "Yayla Mah (belören Köyü)",
      "Yayla Mah (çaybükü Köyü)",
      "Yayla Mah (iğdir Köyü)",
      "Yayla Mah (imralı Köyü)",
      "Yayla Mah (uzunöz Köyü)",
      "Yeni Mah (afşarimam Köyü)",
      "Yongacı Mah (uzunöz Köyü)",
      "Yukarı Çatak Mah (çatak Köyü)",
      "Yukarı Güney Mah (afşargüney Köyü)",
      "Yukarı Kışla Mah (beşören Köyü)",
      "Yukarı Mah (kayadibi Köyü)",
      "Yusuf Mah (alacık Köyü)",
      "Zeybek Mah (alacık Köyü)"
    ],
    "Merkez": [
      "Akmescit Mah",
      "Atabeygazi Mah",
      "Hepkebirler Mah",
      "Hisarardı Mah",
      "Honsalar Mah",
      "İsmailbey Mah",
      "Saraçlar Mah",
      "Topçuoğlu Mah",
      "Yavuzselim Mah",
      "Aktekke Mah",
      "Beyçelebi Mah",
      "Cebrail Mah",
      "Esentepe Mah",
      "İsfendiyar Mah",
      "Kırkçeşme Mah",
      "Mehmet Akif Ersoy Mah",
      "Candaroğulları Mah",
      "İnönü Mah",
      "Kuzeykent Mah",
      "A.akcakese Mah (üyücek Köyü)",
      "A.torumlar Mah (gelinören Köyü)",
      "Abasıyanık Mah (gödel Köyü)",
      "Abbas Mah (arız Köyü)",
      "Acabalı Mah (sulusökü Köyü)",
      "Acısu Mah (bahadır Köyü)",
      "Acısu Mah (kırcalar Köyü)",
      "Ademelik Mah (gülef Köyü)",
      "Ağa Mah (karaevli Köyü)",
      "Ahlat Mah (ahlat Köyü)",
      "Ahlatçık Mah (sipahi Köyü)",
      "Ahmetbey Mah (ahmetbey Köyü)",
      "Akca Mah (cebeci Köyü)",
      "Akçakese Mah (akçakese Köyü)",
      "Akçataş Mah (akçataş Köyü)",
      "Akdoğan Mah (akdoğan Köyü)",
      "Akkaya Mah (yaka Köyü)",
      "Akpınar Mah (baltacı Köyü)",
      "Aksinirosb Mah (aksinir Köyü)",
      "Alamaslı Mah (esenli Köyü)",
      "Alayoğlu Mah (kaşçılar Köyü)",
      "Alçıcılar Mah (alçucular Köyü)",
      "Alhanlı Mah (çevreli Köyü)",
      "Alıç Mah (çatören Köyü)",
      "Allar Mah (musallar Köyü)",
      "Allı Mah (yaka Köyü)",
      "Alpagut Mah (alpağut Köyü)",
      "Alpaslan Mah (alparslan Köyü)",
      "Alpı Mah (alpı Köyü)",
      "Ambarcılar Mah (akkaya Bucağı İsmailli Köyü)",
      "Ardıyüksek Mah (sulusökü Köyü)",
      "Arız Mah (arız Köyü)",
      "Arpaç Mah (aşağıakça Köyü)",
      "As Mah (omcular Köyü)",
      "Asarcık Mah (taşlık Köyü)",
      "Aşağı Batak Mah (aşağıbatak Köyü)",
      "Aşağı Elmayakası Mah (elmayakası Köyü)",
      "Aşağı Mah (ahlatçık Köyü)",
      "Aşağı Mah (bayındır Köyü)",
      "Aşağı Mah (cebeci Köyü)",
      "Aşağı Mah (dereberçin Köyü)",
      "Aşağı Mah (hacıyusuf Köyü)",
      "Aşağı Mah (halifekuyucağı Köyü)",
      "Aşağı Mah (hamit Köyü)",
      "Aşağı Mah (kayı Köyü)",
      "Aşağı Mah (kurtkayı Köyü)",
      "Aşağı Mah (merkez Bucağı Kıyık Köyü)",
      "Aşağı Mah (sapaca Köyü)",
      "Aşağı Mah (tarlatepe Köyü)",
      "Aşağı Mah (taşlık Köyü)",
      "Aşağı Mah (tepeharman Köyü)",
      "Aşağı Muhsir Mah (kurtkayı Köyü)",
      "Aşağı Ören Mah (baltacıkuyucağı Köyü)",
      "Aşağı Tüfekçi Mah (bostan Köyü)",
      "Aşağıbuzağıveren Mah (ahlatçık Köyü)",
      "Aşağıelyakut Mah (aşağıelyakut Köyü)",
      "Aşağıtepe Mah (ballık Köyü)",
      "Aşıkkarip Mah (evciler Köyü)",
      "Avan Mah (yaka Köyü)",
      "Avcı Mah (bayındır Köyü)",
      "Ayanoğlu Mah (kırık Köyü)",
      "Aylıca Mah (canbaz Köyü)",
      "Aynacıoğlu Mah (uzunoluk Köyü)",
      "Ayvagülle Mah (darıbükü Köyü)",
      "Ayvalar Mah (ayvalar Köyü)",
      "Ayvat Mah (orta Köyü)",
      "Bacak Mah (kuzyaka Bucağı İsmailli Köyü)",
      "Bademce Mah (alpağut Köyü)",
      "Bahadır Mah (bahadır Köyü)",
      "Bahana Mah (bulacık Köyü)",
      "Balcı Mah (hatipoğlu Köyü)",
      "Ballık Mah (ballık Köyü)",
      "Baltacı Mah (baltacı Köyü)",
      "Başdeğirmenler Mah (kırık Köyü)",
      "Başköy Mah (başköy Köyü)",
      "Baylar Mah (kuzyaka Köyü)",
      "Bayramlı Mah (kuzyaka Bucağı Çavundur Köyü)",
      "Bekiroğlu Mah (köseoğlu Köyü)",
      "Bekiroğlu Mah (saraycık Köyü)",
      "Bekiroğlu Mah (yukarıelyakut Köyü)",
      "Bekri Mah (kuzyaka Bucağı Çavundur Köyü)",
      "Bektaş Mah (kuzyaka Bucağı Emirler Köyü)",
      "Benli Sultan Mah (ahlat Köyü)",
      "Berigeçe Mah (sarıömer Köyü)",
      "Beşahlat Mah (hüseyinli Köyü)",
      "Beşdeğirmenler Mah (ballık Köyü)",
      "Bıyıklı Mah (pehlivan Köyü)",
      "Bodur Mah (eymir Köyü)",
      "Bostan Mah (bostan Köyü)",
      "Bostan Mah (çatören Köyü)",
      "Boyabatlı Mah (çiğil Köyü)",
      "Bozacı Mah (ahlatçık Köyü)",
      "Bozoğlak Mah (bozoğlak Köyü)",
      "Budamış Mah",
      "Bulacık Mah (bulacık Köyü)",
      "Bulamaç Mah (merkez Bucağı Emirler Köyü)",
      "Bükköy Mah (bük Köyü)",
      "Bürme Mah (bürme Köyü)",
      "Bürtük Mah (emir Köyü)",
      "Caferli Mah (burhanlı Köyü)",
      "Calayoğlu Mah (köseoğlu Köyü)",
      "Cambaz Mah (canbaz Köyü)",
      "Cami Önü Mah (karaş Köyü)",
      "Cami Yanı Mah (yürekveren Köyü)",
      "Cebeci Mah (cebeci Köyü)",
      "Cebeci Mah (darıbükü Köyü)",
      "Cımbar Mah (imamköy Köyü)",
      "Cimpiri Mah (yenikavak Köyü)",
      "Civcivler Mah (civciler Köyü)",
      "Civek Mah (kuzyaka Bucağı Kıyık Köyü)",
      "Civelek Camı Yanı Mah (damlaçay Köyü)",
      "Civelek Mah (akçataş Köyü)",
      "Civelek Mah (damlaçay Köyü)",
      "Cöcüllü Mah (akkaya Bucağı İsmailli Köyü)",
      "Çakıllı Mah (çakıllı Köyü)",
      "Çakıroğlu Mah (elmayakası Köyü)",
      "Çal Mah (çakıllı Köyü)",
      "Çandı Mah (karaçomak Köyü)",
      "Çatören Mah (çatören Köyü)",
      "Çavundur Mah (kuzyaka Bucağı Çavundur Köyü)",
      "Çavuşoğlu Mah (hatipoğlu Köyü)",
      "Çavuşoğlu Mah (tarlatepe Köyü)",
      "Çay Mah (alçucular Köyü)",
      "Çayırbaşı Mah (hacımuharrem Köyü)",
      "Çaylayık Mah (konukça Köyü)",
      "Çelebi Mah (yukarıelyakut Köyü)",
      "Çerçi Mah (çerçi Köyü)",
      "Çerkez Mah (küçüksu Köyü)",
      "Çevreli Mah (çevreli Köyü)",
      "Çıban Mah (çıban Köyü)",
      "Çıldır Mah (sada Köyü)",
      "Çıpını Mah (gökçukur Köyü)",
      "Çırak Mah (yürekveren Köyü)",
      "Çırakoğlu Mah (bahadır Köyü)",
      "Çiçek Mah (çıban Köyü)",
      "Çiçekbaşlı Mah (keremli Köyü)",
      "Çiftlik Mah (talipler Köyü)",
      "Çilingir Mah (aşağıyuva Köyü)",
      "Çiller Mah (yılancı Köyü)",
      "Çorak Mah (örenyeri Köyü)",
      "Çörtçü Mah (aşağıakça Köyü)",
      "Çötlek Mah (yenikavak Köyü)",
      "Çubukçu Mah (baltacıkuyucağı Köyü)",
      "Çuhacılar Mah (karaevli Köyü)",
      "Çuhadar Mah (kaşçılar Köyü)",
      "Çukuryurt Mah (akçataş Köyü)",
      "Dağ Mah (ahlatçık Köyü)",
      "Dahallı Mah (kirenli Köyü)",
      "Dalbaz Mah (kirenli Köyü)",
      "Damkaç Mah (çakıllı Köyü)",
      "Darıbükü Mah (darıbükü Köyü)",
      "Davutça Mah (etyemez Köyü)",
      "Dayılar Mah (dayılar Köyü)",
      "Değirmenci Mah (hacımera Mah) (akçakese Köyü)",
      "Değirmenönü Mah (çiğil Köyü)",
      "Deliahmet Mah (hacıyusuf Köyü)",
      "Deliemir Mah (elmayakası Köyü)",
      "Delikocaoğlu Mah (canbaz Köyü)",
      "Demirci Mah (demirci Köyü)",
      "Demirci Mah (hatipli Köyü)",
      "Demirci Mah (hatipoğlu Köyü)",
      "Demirci Mah (karaçomak Köyü)",
      "Demirciler Mah (kaşçılar Köyü)",
      "Demirkapı Mah (hatipoğlu Köyü)",
      "Dengel Mah (ibişler Köyü)",
      "Dere Köy Mah (çerçi Köyü)",
      "Dere Mah (dere Köyü)",
      "Dere Mah (dursunlar Köyü)",
      "Dere Mah (kuzyaka Bucağı Emirler Köyü)",
      "Dere Mah (saraycık Köyü)",
      "Dere Mah (yaka Köyü)",
      "Dere Mah (yenikavak Köyü)",
      "Dere Mah (yürekveren Köyü)",
      "Derviş Mah (pehlivan Köyü)",
      "Derviş Mah (sahip Köyü)",
      "Dıkkıl Mah (yukarıelyakut Köyü)",
      "Dikmen Mah (tepeharman Köyü)",
      "Duracılı Mah (tekke Köyü)",
      "Durak Mah (elmayakası Köyü)",
      "Durmuşoğlu Mah (yunus Köyü)",
      "Dursun Mah (kırcalar Köyü)",
      "Duruca Mah (konukça Köyü)",
      "Eceoğlu Mah (eceoğlu Köyü)",
      "Eğerlik Mah (ibrahimli Köyü)",
      "Elmalı Mah (konukça Köyü)",
      "Elmaoğlu Mah (saraycık Köyü)",
      "Emeksiz Mah (kaşçılar Köyü)",
      "Emir Mah (emir Köyü)",
      "Emirler Mah (kuzyaka Bucağı Emirler Köyü)",
      "Emirli Mah (emirli Köyü)",
      "Emiroğlu Mah (civciler Köyü)",
      "Ericek Mah (başören Köyü)",
      "Erikbeli Mah (karamukmolla Köyü)",
      "Esenler Mah (dursunlar Köyü)",
      "Esenler Mah (esenler Köyü)",
      "Esenler Mah (karaçomak Köyü)",
      "Esenli Mah (esenli Köyü)",
      "Eşen Mah (eşen Köyü)",
      "Etyemez Mah (etyemez Köyü)",
      "Eylence Mah (esenler Köyü)",
      "Eymir Mah (eymir Köyü)",
      "Eynihan Mah (kavak Köyü)",
      "Fırıncık Mah (akçataş Köyü)",
      "Gazipaşa Mah (yürekveren Köyü)",
      "Gelersin Mah (konukça Köyü)",
      "Gelinören Mah (gelinören Köyü)",
      "Genç Ali Mah (alpağut Köyü)",
      "Geriş Mah (hacımuharrem Köyü)",
      "Gevrekli Mah (gömmece Köyü)",
      "Geycek Mah (ahlatçık Köyü)",
      "Geyikli Mah (geyikli Köyü)",
      "Girdallı Mah (girdallı Köyü)",
      "Göbel Mah (yılancı Köyü)",
      "Göcen Mah (göcen Köyü)",
      "Göçmen Mah (taşlık Köyü)",
      "Gökbelen Mah (bürme Köyü)",
      "Gökçekent Mah (gökçekent Köyü)",
      "Gökçetaş Mah (emir Köyü)",
      "Göktaş Mah (karaçomak Köyü)",
      "Göktepe Mah (evciler Köyü)",
      "Göl Arkası Mah (yukarıbatak Köyü)",
      "Göl Mah (kemerler Köyü)",
      "Göl Pazarı Mah (yukarıbatak Köyü)",
      "Gölköy Mah (gölköy Köyü)",
      "Gömeç Mah (gömeç Köyü)",
      "Göncü Mah (gülef Köyü)",
      "Göncüler Mah (darıbükü Köyü)",
      "Göncüler Mah (sapaca Köyü)",
      "Gözecik Mah (bostan Köyü)",
      "Gözlemeci Mah (yunus Köyü)",
      "Gözler Mah (musallar Köyü)",
      "Güğümcü Mah (yolkonak Köyü)",
      "Gülmezler Mah (çatören Köyü)",
      "Gürcüoğlu Mah (hacı Köyü)",
      "Gürleyik Mah (alçucular Köyü)",
      "Habu Mah (kasabaörencik Köyü)",
      "Hacı Mah (eceoğlu Köyü)",
      "Hacı Mah (hacı Köyü)",
      "Hacıbaklar Mah (ahlat Köyü)",
      "Hacıbey Mah (hacıbey Köyü)",
      "Hacıbey Mah (omcular Köyü)",
      "Hacıellez Mah (hacıilyas Köyü)",
      "Hacılar Mah (karaçomak Köyü)",
      "Hacımahmutoğlu Mah (elmayakası Köyü)",
      "Hacıman Mah (küçüksu Köyü)",
      "Hacıoğlu Mah (gödel Köyü)",
      "Hacıosman Mah (çakıllı Köyü)",
      "Hacıömer Mah (gödel Köyü)",
      "Hacıveli Mah (şeyh Köyü)",
      "Hacıyusuf Mah (hacıyusuf Köyü)",
      "Halaçlı Mah (halaçlı Köyü)",
      "Halife Mah (halife Köyü)",
      "Halifeosb Mah (halife Köyü)",
      "Hamit Mah (hamit Köyü)",
      "Hamzalı Mah (burhanlı Köyü)",
      "Harmancık Mah (başören Köyü)",
      "Has Mah (has Köyü)",
      "Hasanoğlu Mah (köseoğlu Köyü)",
      "Hasanpehlivan Mah (darıbükü Köyü)",
      "Hatip Mah (kayı Köyü)",
      "Hatip Mah (terzi Köyü)",
      "Hatipli Mah (hatipli Köyü)",
      "Hatipoğlu Mah (hatipoğlu Köyü)",
      "Hava Alanı Turem Mah (örencik Köyü)",
      "Haylamaz Mah (hatipli Köyü)",
      "Hedenlioğlu Mah (karaş Köyü)",
      "Holding Evleri Mah (örencik Köyü)",
      "Horamşah Mah (terzi Köyü)",
      "Hozmur Mah (aşağıyuva Köyü)",
      "Hüseyinoğlu Mah (hatipoğlu Köyü)",
      "Işıklı Mah (çıban Köyü)",
      "İbeç Mah (imamköy Köyü)",
      "İbişler Mah (gömmece Köyü)",
      "İbişler Mah (ibişler Köyü)",
      "İbrahimli Mah (ibrahimli Köyü)",
      "İmam Mah (civciler Köyü)",
      "İmam Mah (girdallı Köyü)",
      "İmam Mah (imamköy Köyü)",
      "İmam Mah (kaşçılar Köyü)",
      "İmam Mah (kuzyaka Bucağı İsmailli Köyü)",
      "İmam Mah (orta Köyü)",
      "İnce Mah (girdallı Köyü)",
      "İpsiz Mah (çatören Köyü)",
      "İsmailli Kiraz Mah (akkaya Bucağı İsmailli Köyü)",
      "İsmailli Mah (kuzyaka Bucağı İsmailli Köyü)",
      "İzbeli Mah (örencik Köyü)",
      "Kabak Mah (saraycık Köyü)",
      "Kabaktepesi Mah (ahmetbey Köyü)",
      "Kabalar Mah (yukarıelyakut Köyü)",
      "Kabalı Mah (dursunlar Köyü)",
      "Kabul Mah (emir Köyü)",
      "Kadı Mah (ibişler Köyü)",
      "Kadı Mah (kırcalar Köyü)",
      "Kadı Mah (terzi Köyü)",
      "Kadın Sarayı Mah (çerçi Köyü)",
      "Kadıoğlu Mah (geyikli Köyü)",
      "Kadıoğlu Mah (kadıoğlu Köyü)",
      "Kadiroğlu Mah (esenli Köyü)",
      "Kakırdak Mah (sırasöğütler Köyü)",
      "Kamber Mah (dayılar Köyü)",
      "Kantar Mah (elmayakası Köyü)",
      "Kapaklı Mah (kırışoğlu Köyü)",
      "Kapaklı Mah (musallar Köyü)",
      "Kapıcı Mah (yürekveren Köyü)",
      "Kara Hallar Mah (kayı Köyü)",
      "Karabıyık Mah (hacıbey Köyü)",
      "Karaböcü Mah (terzi Köyü)",
      "Karacaören Mah (kırışoğlu Köyü)",
      "Karacılılar Mah (karaş Köyü)",
      "Karaçomak Mah (karaçomak Köyü)",
      "Karadere Mah (akçataş Köyü)",
      "Karaevli Mah (karaevli Köyü)",
      "Karahacılar Mah (ahlatçık Köyü)",
      "Karahacılar Mah (obruk Köyü)",
      "Karahasanoğlu Mah (köseoğlu Köyü)",
      "Karakuz Mah (karakuz Köyü)",
      "Karalar Mah (ibişler Köyü)",
      "Karamuk Mah (çatören Köyü)",
      "Karamukmolla Mah (karamukmolla Köyü)",
      "Karandı Mah (bahadır Köyü)",
      "Karandı Mah (çatalçam Köyü)",
      "Karandı Mah (sahip Köyü)",
      "Karaş Mah (karaş Köyü)",
      "Karayılan Mah (gödel Köyü)",
      "Kargalar Mah (şeyh Köyü)",
      "Kargın Mah (kızılkese Köyü)",
      "Karınca Mah (bahadır Köyü)",
      "Kasaba Mah (kasaba Köyü)",
      "Kasabaörencik Mah (kasabaörencik Köyü)",
      "Kasım Mah (karakuz Köyü)",
      "Kastek Mah (kirenli Köyü)",
      "Kaşçılar Mah (kaşçılar Köyü)",
      "Kavacık Mah (orta Köyü)",
      "Kavacık Mah (örencik Köyü)",
      "Kavacık Mah (yunus Köyü)",
      "Kavak Mah (kavak Köyü)",
      "Kavalca Mah (kavalca Köyü)",
      "Kavun Mah (ümit Köyü)",
      "Kaya Mah (a.kaya Mah) (başören Köyü)",
      "Kaya Mah (eymir Köyü)",
      "Kayabaşı Mah (esenler Köyü)",
      "Kayalı Mah (aksinir Köyü)",
      "Kayalı Mah (kayalı Köyü)",
      "Kayı Mah (kayı Köyü)",
      "Kayıbeli Mah (saraycık Köyü)",
      "Kaypı Mah (baltacıkuyucağı Köyü)",
      "Kayseroğlu Mah (ortaboğaz Köyü)",
      "Kedicik Mah (çakıllı Köyü)",
      "Kel Mah (hatipli Köyü)",
      "Kelek Mah (sipahi Köyü)",
      "Kemerler Mah (kemerler Köyü)",
      "Keremli Mah (keremli Köyü)",
      "Keşkek Mah (girdallı Köyü)",
      "Keşkekli Mah (sırasöğütler Köyü)",
      "Kılıçlı Mah (gelinören Köyü)",
      "Kımız Mah (yolkonak Köyü)",
      "Kınalı Mah (keremli Köyü)",
      "Kıraçlı Mah (kuzyaka Bucağı İsmailli Köyü)",
      "Kırcalar Mah (kırcalar Köyü)",
      "Kırık Mah (kırık Köyü)",
      "Kıyık Mah (kuzyaka Bucağı Kıyık Köyü)",
      "Kıyık Mah (merkez Bucağı Kıyık Köyü)",
      "Kızboncuk Mah (halaçlı Köyü)",
      "Kızılcaören Mah (karamukmolla Köyü)",
      "Kızılkese Mah (kızılkese Köyü)",
      "Kimyoz Mah (akçataş Köyü)",
      "Kireç Mah (gökçukur Köyü)",
      "Kiremit Fabrikası Mah (hacıbey Köyü)",
      "Kirenli Mah (kirenli Köyü)",
      "Kirpi Mah (kadıoğlu Köyü)",
      "Kocaoğlu Mah (sulusökü Köyü)",
      "Konukça Mah (konukça Köyü)",
      "Koparan Mah (yukarıbatak Köyü)",
      "Koru Mah (koru Köyü)",
      "Koşanlar Mah (ayvalar Köyü)",
      "Koşanlı Mah (mescit Köyü)",
      "Koşlu Mah (sarıca Köyü)",
      "Kozkıran Mah (şeyh Köyü)",
      "Kozlu Mah (hacımuharrem Köyü)",
      "Köklü Mah (köklü Köyü)",
      "Köseoğlu Mah (köseoğlu Köyü)",
      "Kuloğlu Mah (civciler Köyü)",
      "Kurnaz Mah (hatipoğlu Köyü)",
      "Kurt Mah (esenler Köyü)",
      "Kurt Mah (hacışaban Köyü)",
      "Kurtça Mah (yunus Köyü)",
      "Kurtdede Mah (akkaya Bucağı İsmailli Köyü)",
      "Kurtgömeç Mah (kurtgömeç Köyü)",
      "Kurtkayı Mah (kurtkayı Köyü)",
      "Kurtluca Mah (yaka Köyü)",
      "Kurucaören Mah (kurucaören Köyü)",
      "Kuruoğlu Mah (çatalçam Köyü)",
      "Kuruoğlu Mah (saraycık Köyü)",
      "Kurusaray Mah (kurusaray Köyü)",
      "Kuskara Mah (kuşkara Köyü)",
      "Kuş Mah (karaş Köyü)",
      "Kuyucak Mah (baltacıkuyucağı Köyü)",
      "Kuzyaka Mah (kuzyaka Köyü)",
      "Kürt Mah (gödel Köyü)",
      "Kütükler Mah (ibişler Köyü)",
      "Kütükoğlu Mah (esenli Köyü)",
      "Manasır Mah (tekke Köyü)",
      "Maşrabacı Mah (bahadır Köyü)",
      "Mavili Mah (sada Köyü)",
      "Mehran Mah (hacımuharrem Köyü)",
      "Merkez Hatip Mah (hatıp Köyü)",
      "Merkez Mah (ahlatçık Köyü)",
      "Merkez Mah (aksinir Köyü)",
      "Merkez Mah (aşağıyuva Köyü)",
      "Merkez Mah (başören Köyü)",
      "Merkez Mah (burhanlı Köyü)",
      "Merkez Mah (çiğil Köyü)",
      "Merkez Mah (çorumlu Köyü)",
      "Merkez Mah (damlaçay Köyü)",
      "Merkez Mah (dokuzkat Köyü)",
      "Merkez Mah (dursunlar Köyü)",
      "Merkez Mah (duruçay Köyü)",
      "Merkez Mah (evciler Köyü)",
      "Merkez Mah (gökçukur Köyü)",
      "Merkez Mah (gömmece Köyü)",
      "Merkez Mah (gülef Köyü)",
      "Merkez Mah (hacıilyas Köyü)",
      "Merkez Mah (hacımuharrem Köyü)",
      "Merkez Mah (hacışaban Köyü)",
      "Merkez Mah (haydarlar Köyü)",
      "Merkez Mah (hoca Köyü)",
      "Merkez Mah (hüseyinli Köyü)",
      "Merkez Mah (inceboğaz Köyü)",
      "Merkez Mah (islam Köyü)",
      "Merkez Mah (kırışoğlu Köyü)",
      "Merkez Mah (küçüksu Köyü)",
      "Merkez Mah (merkez Bucağı Çavundur Köyü)",
      "Merkez Mah (merkez Bucağı Emirler Köyü)",
      "Merkez Mah (molla Köyü)",
      "Merkez Mah (musallar Köyü)",
      "Merkez Mah (obruk Köyü)",
      "Merkez Mah (sarıömer Köyü)",
      "Merkez Mah (sipahi Köyü)",
      "Merkez Mah (talipler Köyü)",
      "Merkez Mah (üyücek Köyü)",
      "Merkez Mah (yukarıkuyucak Köyü)",
      "Mescit Mah (mescit Köyü)",
      "Mesin Mah (karaş Köyü)",
      "Molla Ahmet Mah (baltacıkuyucağı Köyü)",
      "Muhacirler Mah (yenikavak Köyü)",
      "Murat Hacılar Mah (saraycık Köyü)",
      "Musa Mah (gödel Köyü)",
      "Musallar Mah (imamköy Köyü)",
      "Musla Mah (gödel Köyü)",
      "Münevverler Mah (sahip Köyü)",
      "Nalcıkuyucağı Mah (nalcıkuyucağı Köyü)",
      "Nebioğlu Mah (alçucular Köyü)",
      "Numanlar Mah (numanlar Köyü)",
      "Oğul Köyü",
      "Okçulu Mah (yaka Köyü)",
      "Omcular Mah (omcular Köyü)",
      "Orta Mah (alparslan Köyü)",
      "Orta Mah (hacışaban Köyü)",
      "Orta Mah (halifekuyucağı Köyü)",
      "Orta Mah (imamköy Köyü)",
      "Orta Mah (kırcalar Köyü)",
      "Orta Mah (orta Köyü)",
      "Ortaboğaz Mah (ortaboğaz Köyü)",
      "Ortaca Mah (başören Köyü)",
      "Ortaca Mah (kavak Köyü)",
      "Ortakçı Mah (dursunlar Köyü)",
      "Ovacık Mah (sada Köyü)",
      "Ömer Mah (kuzyaka Bucağı İsmailli Köyü)",
      "Ömerli Mah (ömerli Köyü)",
      "Ören Mah (dokuzkat Köyü)",
      "Örencik Mah (haydarlar Köyü)",
      "Örencik Mah (örencik Köyü)",
      "Örencik Mah (talipler Köyü)",
      "Örenyeri Mah (örenyeri Köyü)",
      "Ötageçe Mah (aşağıakça Köyü)",
      "Öte Kavacık Mah (örencik Köyü)",
      "Öte Mah (seremittin Köyü)",
      "Öte Örencik Mah (örencik Köyü)",
      "Özeyli Mah (tekke Köyü)",
      "Parlak Mah (seremittin Köyü)",
      "Parmaklı Türbe Mah (kayı Köyü)",
      "Pehlivan Mah (pehlivan Köyü)",
      "Pelitçik Mah (kırışoğlu Köyü)",
      "Porsukhanı Mah (kurucaören Köyü)",
      "Portakal Mah (sarıca Köyü)",
      "Pürlü Mah (musallar Köyü)",
      "Sade Mah (sada Köyü)",
      "Sağarcık Mah (örenyeri Köyü)",
      "Sağırlar Mah (gelinören Köyü)",
      "Sağıroğlu Mah (imamköy Köyü)",
      "Sahip Mah (sahip Köyü)",
      "Saklar Mah (keremli Köyü)",
      "Saksağanlı Mah (hacı Köyü)",
      "Sapaca Mah (sapaca Köyü)",
      "Saraycık Mah (saraycık Köyü)",
      "Sarı Kadı Mah (kuzyaka Bucağı Kıyık Köyü)",
      "Sarıca Mah (sarıca Köyü)",
      "Sarıkaya Mah (oğul Köyü)",
      "Sarıoğlu Mah (başören Köyü)",
      "Sarıoğlu Mah (esenli Köyü)",
      "Sarmaşoğlu Mah (hamit Köyü)",
      "Saykal Mah (elmayakası Köyü)",
      "Sazcı Mah (sipahi Köyü)",
      "Seremittin Mah (seremittin Köyü)",
      "Serenler Mah (karamukmolla Köyü)",
      "Serti Mah (kayı Köyü)",
      "Sırasögütler Mah (sırasöğütler Köyü)",
      "Sirkeli Mah (gödel Köyü)",
      "Sofranlar Mah (islam Köyü)",
      "Sofular Mah (akdoğan Köyü)",
      "Soğancı Mah (kuzyaka Bucağı Emirler Köyü)",
      "Subaşı Mah (subaşı Köyü)",
      "Subaşı Mah (yürekveren Köyü)",
      "Sulusökü Mah (sulusökü Köyü)",
      "Susuz Mah (dereberçin Köyü)",
      "Susuz Mah (konukça Köyü)",
      "Sütçüler Mah (kemerler Köyü)",
      "Şaban Mah (cebeci Köyü)",
      "Şadı Bey Mah (talipler Köyü)",
      "Şadioğlu Mah (alparslan Köyü)",
      "Şan Mah (obruk Köyü)",
      "Şeker Mah (bük Köyü)",
      "Şeker Mah (merkez Bucağı Emirler Köyü)",
      "Şekerci Mah (çatalçam Köyü)",
      "Şeyh Mah (şeyh Köyü)",
      "Şıhlı Mah (girdallı Köyü)",
      "Tabasak Mah (kuzyaka Bucağı Emirler Köyü)",
      "Tahıllı Mah (çatalçam Köyü)",
      "Tandır Mah (kırık Köyü)",
      "Tasak Mah (duruçay Köyü)",
      "Taşan Mah (kızılkese Köyü)",
      "Taşanlar Mah (eceoğlu Köyü)",
      "Taşlık Mah (taşlık Köyü)",
      "Tekke Mah (halaçlı Köyü)",
      "Tekke Mah (karamukmolla Köyü)",
      "Tekke Mah (küçüksu Köyü)",
      "Tekke Mah (tekke Köyü)",
      "Tellioğlu Mah (geyikli Köyü)",
      "Tepe Mah (demirci Köyü)",
      "Tepe Mah (karaevli Köyü)",
      "Tepe Mah (merkez Bucağı Kıyık Köyü)",
      "Tepe Mah (obruk Köyü)",
      "Tepelce Mah (yarören Köyü)",
      "Tereoğlu Mah (yukarıelyakut Köyü)",
      "Terzi Mah (terzi Köyü)",
      "Terzili Mah (ibrahimli Köyü)",
      "Tığlı Mah (aşağıyuva Köyü)",
      "Tıkış Mah (hatipli Köyü)",
      "Tıkış Mah (köseoğlu Köyü)",
      "Timzan Mah (damlaçay Köyü)",
      "Topçu Mah (canbaz Köyü)",
      "Turhanlı Mah (terzi Köyü)",
      "Tülek Mah (karaş Köyü)",
      "Türkali Mah (keremli Köyü)",
      "Uzunoluk Mah (uzunoluk Köyü)",
      "Ülyan Mah (çatalçam Köyü)",
      "Ümit Mah (ümit Köyü)",
      "Üyük Mah (bük Köyü)",
      "Varsak Mah (gökçekent Köyü)",
      "Vayıslı Mah (kirenli Köyü)",
      "Velioğlu Mah (uzunoluk Köyü)",
      "Vezir Mah (esenler Köyü)",
      "Y.akcakese Mah (üyücek Köyü)",
      "Y.torumlar Mah (gelinören Köyü)",
      "Yağcı Mah (dursunlar Köyü)",
      "Yaka Mah (yaka Köyü)",
      "Yalnız Mah (yukarıkuyucak Köyü)",
      "Yanık Mah (baltacıkuyucağı Köyü)",
      "Yanık Mah (gökçekent Köyü)",
      "Yazı Mah (emirli Köyü)",
      "Yazı Mah (eymir Köyü)",
      "Yemişçi Mah (çorumlu Köyü)",
      "Yeni Mah (bozoğlak Köyü)",
      "Yeni Mah (etyemez Köyü)",
      "Yeni Mah (koru Köyü)",
      "Yeni Mah (obruk Köyü)",
      "Yeniağa Mah (sahip Köyü)",
      "Yenikavak Mah (yenikavak Köyü)",
      "Yeniköy Mah (orta Köyü)",
      "Yerükler Mah (köseoğlu Köyü)",
      "Yeşilkent Mah (örencik Köyü)",
      "Yılancı Mah (yılancı Köyü)",
      "Yk.kaya Mah (başören Köyü)",
      "Yöreci Mah (yürekveren Köyü)",
      "Yukarı Ahlat Mah (ahlat Köyü)",
      "Yukarı Batak Mah (yukarıbatak Köyü)",
      "Yukarı Karakuz Mah (karakuz Köyü)",
      "Yukarı Köy Mah (ortaboğaz Köyü)",
      "Yukarı Mah (ahlatçık Köyü)",
      "Yukarı Mah (bayındır Köyü)",
      "Yukarı Mah (dereberçin Köyü)",
      "Yukarı Mah (halifekuyucağı Köyü)",
      "Yukarı Mah (tarlatepe Köyü)",
      "Yukarı Mah (tepeharman Köyü)",
      "Yukarı Muhsir Mah (kurtkayı Köyü)",
      "Yukarı Tüfekçi Mah (bostan Köyü)",
      "Yukarıbuzağıveren Mah (ahlatçık Köyü)",
      "Yukarıtepe Mah (ballık Köyü)",
      "Yukarıyuva Mah (yolkonak Köyü)",
      "Yukurıelyakut Mah (yukarıelyakut Köyü)",
      "Zalioğlu Mah (darıbükü Köyü)",
      "Zongalar Mah (hacımuharrem Köyü)",
      "Zülen Mah (seremittin Köyü)"
    ],
    "Pınarbaşı": [
      "Abut Mah (urva Köyü)",
      "Afetevleri Mah (yamanlar Köyü)",
      "Ahmat Agası Mah (demirtaş Köyü)",
      "Ahmetoğlu Mah (kayabükü Köyü)",
      "Arma Mah (ılıca Köyü)",
      "Aslanca Mah (kapancı Köyü)",
      "Aşağı Ilıca Mah (ılıca Köyü)",
      "Aşağı Mah (dizdarlı Köyü)",
      "Aşağı Mah (karacaören Köyü)",
      "Aşağı Mah (yamanlar Köyü)",
      "Aşağı Tekke Mah (savaş Köyü)",
      "Aşağı Zelle Mah (dizdarlı Köyü)",
      "Atak Mevkii Mah (çavuşköy Köyü)",
      "Ayazlar Mah (kapancı Köyü)",
      "Aylak Mah (urva Köyü)",
      "Bagla Mah (karafasıl Köyü)",
      "Bakiçelebi Mah (çavuşköy Köyü)",
      "Baltepe Mah (karacaören Köyü)",
      "Bayraktar Mah (boğazkaya Köyü)",
      "Bekdemir Mah (hocalar Köyü)",
      "Bıyık Mah (kerte Köyü)",
      "Boduroğlu Mah (kurtlugelik Köyü)",
      "Bostan Mah (çavuşköy Köyü)",
      "Cebeci Mah (sümenler Köyü)",
      "Çagda Mah (günberi Köyü)",
      "Çalcaören Mah (üyükören Köyü)",
      "Çanakçı Mah (kerte Köyü)",
      "Çangal Mah (hocalar Köyü)",
      "Çavuş Mah (çavuşköy Köyü)",
      "Çekirge Mah (başköy Köyü)",
      "Çengel Mah (çengel Köyü)",
      "Çengelli Mah (esentepe Köyü)",
      "Çiftlik Mah (günberi Köyü)",
      "Çorbacı Mah (muratbaşı Köyü)",
      "Çöme Mah (kalaycı Köyü)",
      "Çömez Mah (mirahor Köyü)",
      "Çötenli Mah (kurtlugelik Köyü)",
      "Dağ Mah (karacaören Köyü)",
      "Damasığmaz Mah (kurtlugelik Köyü)",
      "Defne Mah (kayabükü Köyü)",
      "Deli Hüseyin Mah (boğazkaya Köyü)",
      "Delibalta Mah (demirtaş Köyü)",
      "Demirci Mah (esentepe Köyü)",
      "Dere Mah (başköy Köyü)",
      "Derecik Mah (kalaycı Köyü)",
      "Durmuşlar Mah (kalaycı Köyü)",
      "Elles Mah (kayabükü Köyü)",
      "Esen Mah (ılıca Köyü)",
      "Eski Kapancı Mah (kapancı Köyü)",
      "Eyüpoğlu Mah (kayabükü Köyü)",
      "Fasye Mah (yamanlar Köyü)",
      "Garipler Mah (uzla Köyü)",
      "Gaybulu Mah (kapancı Köyü)",
      "Gedik Mah (kerte Köyü)",
      "Genne Mah (dizdarlı Köyü)",
      "Geriş Mah (ılıca Köyü)",
      "Giyne Mah (yamanlar Köyü)",
      "Gofuroglu Mah (günberi Köyü)",
      "Gökçe Mah (boğazkaya Köyü)",
      "Gökhüseyin Mah (kerte Köyü)",
      "Gölyanı Mah (sümenler Köyü)",
      "Güveloğlu Mah (yukarıaktaş Köyü)",
      "Hacı Ahmet Mah (çengel Köyü)",
      "Hacıoğlu Mah (sümenler Köyü)",
      "Hanazla Mah (esentepe Köyü)",
      "Hatip Mah (urva Köyü)",
      "Hoca Mah (savaş Köyü)",
      "Hüdayet Mah (kurtlugelik Köyü)",
      "Ilıca Merkez Mah (ılıca Köyü)",
      "İbrahim Çelebi Mah (kerte Köyü)",
      "İbrahim Çelebi Mah (mirahor Köyü)",
      "İmam Mah (sümenler Köyü)",
      "İnanlı Mah (çengel Köyü)",
      "Kadıoğlu Mah (başköy Köyü)",
      "Kahveci Mah (yamanlar Köyü)",
      "Kahya Mah (kerte Köyü)",
      "Kalaycı Mah (kalaycı Köyü)",
      "Kancılar Mah (kerte Köyü)",
      "Karacakaya Mah (başköy Köyü)",
      "Karafasıl Mah (karafasıl Köyü)",
      "Karamustafa Mah (kerte Köyü)",
      "Karşı Mah (hocalar Köyü)",
      "Kaval Mah (boğazkaya Köyü)",
      "Kayacık Mah (kayabükü Köyü)",
      "Kayadibi Mah (sümenler Köyü)",
      "Kayalı Mah (kerte Köyü)",
      "Kelem Mah (yamanlar Köyü)",
      "Keti Mah (muratbaşı Köyü)",
      "Kırtı Mah (sümenler Köyü)",
      "Kirpi Mah (kerte Köyü)",
      "Kolca Mah (ılıca Köyü)",
      "Kölcek Mah (ılıca Köyü)",
      "Körşüş Mah (kayabükü Köyü)",
      "Köseköy Mah (kapancı Köyü)",
      "Kum Mah (kapancı Köyü)",
      "Kuyruk Mah (sümenler Köyü)",
      "Lenge Mah (dizdarlı Köyü)",
      "Maşuklu Mah (çavuşköy Köyü)",
      "Menteş Mah (urva Köyü)",
      "Merkez Mah (aşağıaktaş Köyü)",
      "Merkez Mah (demirtaş Köyü)",
      "Merkez Mah (hocalar Köyü)",
      "Merkez Mah (karacaören Köyü)",
      "Merkez Mah (mirahor Köyü)",
      "Merkez Mah (muratbaşı Köyü)",
      "Merkez Mah (sümenler Köyü)",
      "Merkez Mah (uzla Köyü)",
      "Merkez Mah (üyükören Köyü)",
      "Merkez Mah (yukarıaktaş Köyü)",
      "Meyiller Mah (başköy Köyü)",
      "Mildan Mah (muratbaşı Köyü)",
      "Musabaşoğlu Mah (yukarıaktaş Köyü)",
      "Muslu Mah (urva Köyü)",
      "Nebioğlu Mah (çavuşköy Köyü)",
      "Orna Mah (kerte Köyü)",
      "Orta Mah (başköy Köyü)",
      "Orta Mah (dizdarlı Köyü)",
      "Orta Mah (hocalar Köyü)",
      "Orta Mah (sümenler Köyü)",
      "Orta Mah (yamanlar Köyü)",
      "Oruç Mah (sümenler Köyü)",
      "Ovacık Mah (çengel Köyü)",
      "Ören Mah (dizdarlı Köyü)",
      "Örencik Mah (muratbaşı Köyü)",
      "Paşaoğlu Mah (demirtaş Köyü)",
      "Pazar Yeri Mah (demirtaş Köyü)",
      "Pazar Yeri Mah (dizdarlı Köyü)",
      "Pazar Yeri Mah (kapancı Köyü)",
      "Petekler Mah (karacaören Köyü)",
      "Recep Usta Mah (hocalar Köyü)",
      "Recepli Mah (çavuşköy Köyü)",
      "Ruşen Mah (üyükören Köyü)",
      "Sarma Mah (karafasıl Köyü)",
      "Seyhan Mah (kerte Köyü)",
      "Seyisoğlu Mah (mirahor Köyü)",
      "Sorkuncuk Mah (günberi Köyü)",
      "Sömek Mah (yamanlar Köyü)",
      "Subaşı Mah (kapancı Köyü)",
      "Şaban Mah (kayabükü Köyü)",
      "Şabanoğlu Mah (demirtaş Köyü)",
      "Şahanlı Mah (ılıca Köyü)",
      "Şatır Mah (çengel Köyü)",
      "Şeyfo Mah (demirtaş Köyü)",
      "Şıhlı Mah (urva Köyü)",
      "Tarakcı Mah (uzla Köyü)",
      "Terzi Mah (savaş Köyü)",
      "Tısbı Mah (urva Köyü)",
      "Topbaşı Mah (kapancı Köyü)",
      "Tor Mah (kerte Köyü)",
      "Torbıyık Mah (başköy Köyü)",
      "Toygıran Mah (mirahor Köyü)",
      "Ülde Mah (uzla Köyü)",
      "Valla Mah (muratbaşı Köyü)",
      "Yanıklar Mah (başköy Köyü)",
      "Yayla Mah (başköy Köyü)",
      "Yayla Mah (kapancı Köyü)",
      "Yeni Mah (karafasıl Köyü)",
      "Yeni Mah (kurtlugelik Köyü)",
      "Yeniçeri Mah (ılıca Köyü)",
      "Yeşil Mah (kayabükü Köyü)",
      "Yukarı Ilgazlar Mah (hocalar Köyü)",
      "Yukarı Mah (dizdarlı Köyü)",
      "Yukarı Mah (yamanlar Köyü)",
      "Yukarı Zelle Mah (dizdarlı Köyü)",
      "Yumaklı Mah (kerte Köyü)",
      "Yusuflar Mah (boğazkaya Köyü)",
      "Zaim Mah (aşağıaktaş Köyü)",
      "Zaim Mah (çengel Köyü)",
      "Zaimogulları Mah (başköy Köyü)",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Çalkaya Mah",
      "Çamkışla Mah",
      "Fatih Mah",
      "Uzunçam Mah"
    ],
    "Seydiler": [
      "Ali Ağa Mah (kepez Köyü)",
      "Aşağı Şalgam Mah (şalgam Köyü)",
      "Ayrancı Mah (yolyaka Köyü)",
      "Bozarmut Mah (karaçavuş Köyü)",
      "Böcek Mah (şalgam Köyü)",
      "Börekci Mah (karaçavuş Köyü)",
      "Çavuşoğlu Mah (imrenler Köyü)",
      "Çayan Mah (yolyaka Köyü)",
      "Çelebi Mah (sabuncular Köyü)",
      "Çömek Mah (odabaşı Köyü)",
      "Demirci Mah (şalgam Köyü)",
      "Demiroğlu Mah (çiğilerik Köyü)",
      "Dere Mah (çiğilerik Köyü)",
      "Emmi Mah (ercek Köyü)",
      "Gücükler Mah (üyük Köyü)",
      "Hacınesifoğlu Mah (mancılık Köyü)",
      "Halaçoğlu Mah (imrenler Köyü)",
      "Harmanda Mah (çiğilerik Köyü)",
      "Hatıp Mah (çiğilerik Köyü)",
      "Haydarlı Mah (ercek Köyü)",
      "Hoşkunlar Mah (odabaşı Köyü)",
      "Hücüman Mah (çiğilerik Köyü)",
      "Hüsemli Mah (sabuncular Köyü)",
      "Hüseyinağa Mah (çırdak Köyü)",
      "İbicioğlu Mah (ercek Köyü)",
      "İmamoğlu Mah (imrenler Köyü)",
      "Kadıhüseyin Mah (üyük Köyü)",
      "Kadiroğlu Mah (mancılık Köyü)",
      "Kandavurlar Mah (emreler Köyü)",
      "Karaçavuş Merkez Mah (karaçavuş Köyü)",
      "Karahmet Mah (ercek Köyü)",
      "Karakaş Mah (yolyaka Köyü)",
      "Kayalar Mah (imrenler Köyü)",
      "Kuruoğlu Mah (incesu Köyü)",
      "Kuytulu Mah (mancılık Köyü)",
      "Kuyumcular Mah (sabuncular Köyü)",
      "Kürt Mah (karaçavuş Köyü)",
      "Kürto Mah (sabuncular Köyü)",
      "Madanbey Mah (karaçavuş Köyü)",
      "Maşaoğlu Mah (çırdak Köyü)",
      "Mavili Mah (ercek Köyü)",
      "Merkez Mah (çerçiler Köyü)",
      "Merkez Mah (çırdak Köyü)",
      "Merkez Mah (emreler Köyü)",
      "Merkez Mah (ercek Köyü)",
      "Merkez Mah (imrenler Köyü)",
      "Merkez Mah (incesu Köyü)",
      "Merkez Mah (kepez Köyü)",
      "Merkez Mah (mancılık Köyü)",
      "Merkez Mah (odabaşı Köyü)",
      "Merkez Mah (sabuncular Köyü)",
      "Merkez Mah (şalgam Köyü)",
      "Merkez Mah (yolyaka Köyü)",
      "Mustafa Mah (incesu Köyü)",
      "Müco Mah (incesu Köyü)",
      "Ödemiş Pazaryeri Mah (çiğilerik Köyü)",
      "Pantır Mah (yolyaka Köyü)",
      "Saraycık Mah (emreler Köyü)",
      "Sarnıç Mah (yolyaka Köyü)",
      "Selimoğlu Mah (çırdak Köyü)",
      "Sofucak Mah (emreler Köyü)",
      "Süngüler Mah (mancılık Köyü)",
      "Sürmeli Mah (sabuncular Köyü)",
      "Şahbat Mah (mancılık Köyü)",
      "Tepe Köy Mah (çerçiler Köyü)",
      "Üyük Merkez Mah (üyük Köyü)",
      "Yakupoğlu Mah (kepez Köyü)",
      "Yapukçu Mah (ercek Köyü)",
      "Yavsuoğlu Mah (çırdak Köyü)",
      "Aşağıarslanlı Mah",
      "Ayvatlar Mah",
      "Batıörcünler Mah",
      "Delihacılar Mah",
      "Demirciözü Mah",
      "Hacıkayalar Mah",
      "Merkez Mah",
      "Merkez Osb Mah",
      "Yağlar Mah",
      "Yayla Mah",
      "Yukarıarslanlı Mah"
    ],
    "Şenpazar": [
      "Abidinoğlu Mah (salman Köyü)",
      "Ahmet Bey Mah (gürpelit Köyü)",
      "Akca Kese Mah (harmangeriş Köyü)",
      "Ali Yeri Mah (harmangeriş Köyü)",
      "Ardıçalan Mah (küçükmutlu Köyü)",
      "Baş Köy Mah (dördül Köyü)",
      "Çatak Mah (edeler Köyü)",
      "Dede Mah (sefer Köyü)",
      "Değirmenbaşı Mah (gürleyik Köyü)",
      "Değirmenci Mah (gürpelit Köyü)",
      "Demirci Mah (az.kalaycı Köyü)",
      "Demircili Mah (demirkaya Köyü)",
      "Dibekli Mah (küçükmutlu Köyü)",
      "Düzce Mah (gürpelit Köyü)",
      "Gossokü Mah (başçavuş Köyü)",
      "Gücükdibi Mah (sefer Köyü)",
      "Gücüllü Mah (salman Köyü)",
      "Güllü Mah (az.kalaycı Köyü)",
      "Güney Yarımca Mah (yarımca Köyü)",
      "Halı Mah (tepecik Köyü)",
      "Harmancık Mah (yarımca Köyü)",
      "Hatıp Mah (harmangeriş Köyü)",
      "Hıdırlı Mah (harmangeriş Köyü)",
      "Himmetli Mah (tepecik Köyü)",
      "Ilıyazı Mah (az.kalaycı Köyü)",
      "İmam Mah (dağlı Köyü)",
      "Kaya Mah (tepecik Köyü)",
      "Kısık Mah (dağlı Köyü)",
      "Konuklar Mah (dördül Köyü)",
      "Köyceyiz Mah (küçükmutlu Köyü)",
      "Kuzey Yarımca Mah (yarımca Köyü)",
      "Küpcüler Mah (celallı Köyü)",
      "Manav Mah (demirkaya Köyü)",
      "Menteşe Mah (başçavuş Köyü)",
      "Merkez Mah (alancık Köyü)",
      "Merkez Mah (aşıklı Köyü)",
      "Merkez Mah (aybasan Köyü)",
      "Merkez Mah (az.kalaycı Köyü)",
      "Merkez Mah (başçavuş Köyü)",
      "Merkez Mah (büyükmutlu Köyü)",
      "Merkez Mah (celallı Köyü)",
      "Merkez Mah (dağlı Köyü)",
      "Merkez Mah (demirkaya Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (dördül Köyü)",
      "Merkez Mah (edeler Köyü)",
      "Merkez Mah (furuncuk Köyü)",
      "Merkez Mah (gürleyik Köyü)",
      "Merkez Mah (gürpelit Köyü)",
      "Merkez Mah (harmangeriş Köyü)",
      "Merkez Mah (himmet Köyü)",
      "Merkez Mah (küçükmutlu Köyü)",
      "Merkez Mah (salman Köyü)",
      "Merkez Mah (sefer Köyü)",
      "Merkez Mah (tepecik Köyü)",
      "Muhtrem Mah (harmangeriş Köyü)",
      "Orta Mah (aşıklı Köyü)",
      "Örencik Mah (alancık Köyü)",
      "Paşa Mah (harmangeriş Köyü)",
      "Poyracık Mah (gürleyik Köyü)",
      "Tatlıca Mah (celallı Köyü)",
      "Tulek Mah (harmangeriş Köyü)",
      "Uzunyol Köyü",
      "Yakınca Mah (aybasan Köyü)",
      "Yörecik Mah (dereköy Köyü)",
      "Yukarıdağlı Mah (dağlı Köyü)",
      "Zanaltı Mah (az.kalaycı Köyü)",
      "Çevrik Mah",
      "Dibekli Mah",
      "Güneytekke Mah",
      "Karaman Mah",
      "Korucak Mah",
      "Kuztekke Mah",
      "Merkez Mah"
    ],
    "Taşköprü": [
      "Ağnak Mah (bey Köyü)",
      "Ahcıbaşı Mah (taşçılar Köyü)",
      "Ahlatcı Mah (abay Köyü)",
      "Akdoğan Köyü",
      "Akdoğantekke Köyü",
      "Akhasan Mah (kapaklı Köyü)",
      "Akıllıoğlu Mah (karacakaya Köyü)",
      "Akseki Köyü",
      "Alamabatak Köyü",
      "Alasökü Köyü",
      "Alhan Mah (kayapınar Köyü)",
      "Alıççık Mah (badembekdemir Köyü)",
      "Alibey Mah (boyundurcak Köyü)",
      "Alibeygıran Mah (koçanlı Köyü)",
      "Aptal Mah (şahinçatı Köyü)",
      "Aptalgazi Mah (doymuş Köyü)",
      "Arapoğlu Mah (eskioğlu Köyü)",
      "Asarcık Mah (incesu Köyü)",
      "Aşağı Boyalı Mah (akçakese Köyü)",
      "Aşağı Çiftkıran Mah (çiftkıran Köyü)",
      "Aşağı Derekaraagaç Mah (derekaraağaç Köyü)",
      "Aşağı Köseoğlu Mah (çit Köyü)",
      "Aşağı Mah (çetmi Köyü)",
      "Aşağı Mah (köçekli Köyü)",
      "Aşağı Tokaş Mah (tokaş Köyü)",
      "Aşağıçayırcık Köyü",
      "Aşağıçit Köyü",
      "Aşağıtelli Mah (çiftlik Köyü)",
      "Aşıkçı Mah (pirahmetli Köyü)",
      "Avdullar Mah (kapaklı Köyü)",
      "Avdullu Mah (karnıaçık Köyü)",
      "Ayvalca Mah (obrucak Köyü)",
      "Baltacı Mah (samanlıören Köyü)",
      "Bardakçı Mah (çambaşı Köyü)",
      "Başören Mah (incesu Köyü)",
      "Bayam Merkez Mah (badembekdemir Köyü)",
      "Bayırlı Mah (küçüksü Köyü)",
      "Bayram Mah (pirahmetli Köyü)",
      "Bekdemir Mah (badembekdemir Köyü)",
      "Bekir Mah (bekdemirekşi Köyü)",
      "Bektaş Mah (eskioğlu Köyü)",
      "Belençayır Mah (yeniler Köyü)",
      "Birzadeoğlu Mah (armutlu Köyü)",
      "Bodur Mah (çambaşı Köyü)",
      "Boşnaklar Mah (taşçılar Köyü)",
      "Bozarmut Mah (arslanlı Köyü)",
      "Boztepe Mah (imamoğlu Köyü)",
      "Bulak Mah (bozarmut Köyü)",
      "Burhan Mah (çiftlik Köyü)",
      "Bürüm Mah (arslanlı Köyü)",
      "Büyük Sapaca Mah (çaylaklar Köyü)",
      "Calay Mah (obrucak Köyü)",
      "Cebeci Mah (orta Köyü)",
      "Cevizli Mah (armutlu Köyü)",
      "Civelek Mah (kılıçlı Köyü)",
      "Ciyar Mah (çaycevher Köyü)",
      "Curalı Mah (hamzaoğlu Köyü)",
      "Çağa Mah (çit Köyü)",
      "Çakır Mah (bekdemirekşi Köyü)",
      "Çakırekin Mah (pirahmetli Köyü)",
      "Çaloğlu Mah (kuyluş Köyü)",
      "Çamlı Mah (kapaklı Köyü)",
      "Çarıklı Mah (yukarıemerce Köyü)",
      "Çat Deresi Mah (akçakese Köyü)",
      "Çattepe Mah (hamzaoğlu Köyü)",
      "Çavuş Mah (kızılkese Köyü)",
      "Çay Mah (örhen Köyü)",
      "Çiftlik Mah (çiftlik Köyü)",
      "Çiğdemli Mah (erik Köyü)",
      "Çilingir Mah (tepedelik Köyü)",
      "Çimbek Mah (dağbelören Köyü)",
      "Çirpici Mah (masatlar Köyü)",
      "Çoban Mah (paşa Köyü)",
      "Çördü Mah (ortaöz Köyü)",
      "Çünür Mah (kaygınca Köyü)",
      "Davutpaşa Mah (karapürçek Köyü)",
      "Değirmi Mah (çiftkıran Köyü)",
      "Delialişler Mah (armutlu Köyü)",
      "Delibeyoğlu Mah (güneykalınkese Köyü)",
      "Deliimam Mah (dere Köyü)",
      "Delmece Mah (dere Köyü)",
      "Demirci Mah (dağbelören Köyü)",
      "Dere Mah (boyundurcak Köyü)",
      "Dere Mah (çaykirpi Köyü)",
      "Dere Mah (kuzkalınkese Köyü)",
      "Derecik Mah (yavuçkuyucağı Köyü)",
      "Derekoru Mah (kayadibi Köyü)",
      "Derencik Mah (akçakese Köyü)",
      "Dikmen Mah (dere Köyü)",
      "Dikmendibi Mah (aşağışehirören Köyü)",
      "Diller Mah (kabalar Köyü)",
      "Dolay Mah (celep Köyü)",
      "Dolaydere Mah (hamzaoğlu Köyü)",
      "Donaşalar Mah (duruca Köyü)",
      "Dongin Mah (hoca Köyü)",
      "Dopaloğlu Mah (dere Köyü)",
      "Duman Mah (derekaraağaç Köyü)",
      "Duşluk Mah (incesu Köyü)",
      "Düğenözü Mah (dağbelören Köyü)",
      "Ekşioğlu Mah (bekdemirekşi Köyü)",
      "Ellez Mah (tokaş Köyü)",
      "Emir Mah (garipşah Köyü)",
      "Emirler Mah (gündoğdu Köyü)",
      "Erikyatsı Mah (hamzaoğlu Köyü)",
      "Ersil Köyü",
      "Ersizli Mah (yukarışehirören Köyü)",
      "Eselli Mah (kuzkalınkese Köyü)",
      "Esenler Mah (yukarışehirören Köyü)",
      "Eski Mah (bekdemirekşi Köyü)",
      "Eski Mah (sarıkavak Köyü)",
      "Eymür Mah (armutlu Köyü)",
      "Fıçı Mah (kılıçlı Köyü)",
      "Gadı Mah (koçanlı Köyü)",
      "Ganioğlu Mah (donalar Köyü)",
      "Garipoğlu Mah (akçakese Köyü)",
      "Gerze Mah (kayapınar Köyü)",
      "Göç Mah (karacaoğlu Köyü)",
      "Görpe Mah (yavuçkuyucağı Köyü)",
      "Göynük Mah (kayadibi Köyü)",
      "Guz Mah (hoca Köyü)",
      "Guzsökü Mah (bey Köyü)",
      "Güllü Mah (alipaşa Köyü)",
      "Güney Mah (ayvalı Köyü)",
      "Güney Mah (güneykalınkese Köyü)",
      "Güneycük Mah (kayapınar Köyü)",
      "Güzören Mah (köçekli Köyü)",
      "Hacıali Köyü",
      "Hacıali Mah (kornapa Köyü)",
      "Hacılar Mah (vakıfbelören Köyü)",
      "Hacılar Mah (yoğunoluk Köyü)",
      "Haliloğlu Mah (gündoğdu Köyü)",
      "Hallo Mah (uzunkavak Köyü)",
      "Hamdullah Mah (paşa Köyü)",
      "Hataplı Mah (olukbaşı Köyü)",
      "Hatip Mah (garipşah Köyü)",
      "Hatip Mah (kuzkalınkese Köyü)",
      "Hayır Mah (pirahmetli Köyü)",
      "Haznedar Mah (yukarıemerce Köyü)",
      "Hebiloglu Mah (karadedeoğlu Köyü)",
      "İkipınar Mah (bey Köyü)",
      "İkizler Mah (imamoğlu Köyü)",
      "İmam Mah (çaycevher Köyü)",
      "İmam Mah (dağbelören Köyü)",
      "İmamlar Mah (akdeğirmen Köyü)",
      "İmamlar Mah (kirazcık Köyü)",
      "İmirler Mah (paşa Köyü)",
      "İnceöz Mah (çekiç Köyü)",
      "İprim Yaylası Mah (bozarmut Köyü)",
      "Kabala Mah (kirazcık Köyü)",
      "Kabaş Mah (hamzaoğlu Köyü)",
      "Kadı Kızı Mah (taşçılar Köyü)",
      "Kadı Köyü",
      "Kadılar Mah (kirazcık Köyü)",
      "Kadıoğlu Mah (kirazcık Köyü)",
      "Kalaşlı Mah (aşağışehirören Köyü)",
      "Kalaycı Mah (çetmi Köyü)",
      "Kalfalı Mah (kızılcaören Köyü)",
      "Kapanlı Mah (orta Köyü)",
      "Kapucu Mah (şahinçatı Köyü)",
      "Karaağaç Mah (paşa Köyü)",
      "Karaağaç Mah (şahinçatı Köyü)",
      "Karaburun Mah (kayadibi Köyü)",
      "Karaburun Yayla Evi Mah (kayadibi Köyü)",
      "Karaçallık Mah (incesu Köyü)",
      "Karadüren Mah (pirahmetli Köyü)",
      "Karagülle Mah (kızılcaören Köyü)",
      "Karağuz Yaylası Mah (bozarmut Köyü)",
      "Karamahmut Yaylası Mah (bozarmut Köyü)",
      "Karapınar Mah (akçakese Köyü)",
      "Karayılan Mah (aşağışehirören Köyü)",
      "Kargacık Mah (çiftkıran Köyü)",
      "Karşı Bürüm Mah (arslanlı Köyü)",
      "Karşı Köyü",
      "Karşı Mah (erik Köyü)",
      "Kavacı Mah (sarıkavak Köyü)",
      "Kavacık Mah (kapaklı Köyü)",
      "Kavacık Mah (sarıkavak Köyü)",
      "Kavak Mah (incesu Köyü)",
      "Kayabaşı Mah (koçanlı Köyü)",
      "Kel Mah (güneykalınkese Köyü)",
      "Keller Mah (garipşah Köyü)",
      "Kello Mah (bekirli Köyü)",
      "Keloğlu Mah (esenlik Köyü)",
      "Kelönü Mah (hamzaoğlu Köyü)",
      "Kendiroğlu Mah (akdeğirmen Köyü)",
      "Kerimler Mah (çetmi Köyü)",
      "Kerpüc Mah (doymuş Köyü)",
      "Kesercioğlu Mah (kuyluş Köyü)",
      "Ketenler Mah (kirazcık Köyü)",
      "Keyiş Mah (obrucak Köyü)",
      "Kılavuz Mah (dere Köyü)",
      "Kıran Mah (hoca Köyü)",
      "Kıran Mah (kuzkalınkese Köyü)",
      "Kırha Köyü",
      "Kızılcıelma Mah (dere Köyü)",
      "Kirlik Mah (kızılcaörhen Köyü)",
      "Kirpo Mah (çaykirpi Köyü)",
      "Koca Mah (ömerli Köyü)",
      "Koçcuaz Mah (sarpun Köyü)",
      "Kolcu Mah (sarıkavak Köyü)",
      "Kozluca Mah (yeniler Köyü)",
      "Köle Mah (armutlu Köyü)",
      "Köloğlu Mah (arslanlı Köyü)",
      "Köloğlu Mah (karnıaçık Köyü)",
      "Köse Mah (çetmi Köyü)",
      "Köseli Mah (kılıçlı Köyü)",
      "Köyiçi Mah (köçekli Köyü)",
      "Kurdün Mah (hamzaoğlu Köyü)",
      "Kuru Çavuşlar Mah (kapaklı Köyü)",
      "Kuştepe Mah (dilek Köyü)",
      "Kuycak Mah (bey Köyü)",
      "Kuzguncuk 2 Mah (dağbelören Köyü)",
      "Kuzguncuk Mah (dağbelören Köyü)",
      "Küçük Sapaca Mah (çaylaklar Köyü)",
      "Küçükkuyluş Mah (kornapa Köyü)",
      "Kürt Mah (dağbelören Köyü)",
      "Malak Mah (kızılcaörhen Köyü)",
      "Mandıra Mah (doymuş Köyü)",
      "Matır Mah (armutlu Köyü)",
      "Mayhar Mah (bozarmut Köyü)",
      "Mehter Mah (hoca Köyü)",
      "Memioğlu Mah (tekeoğlu Köyü)",
      "Mencügez Mah (yavuçkuyucağı Köyü)",
      "Merkez Mah (abay Köyü)",
      "Merkez Mah (abdalhasan Köyü)",
      "Merkez Mah (afşar Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (alamakayış Köyü)",
      "Merkez Mah (alamaşişli Köyü)",
      "Merkez Mah (alatarla Köyü)",
      "Merkez Mah (alipaşa Köyü)",
      "Merkez Mah (alisaray Köyü)",
      "Merkez Mah (armutlu Köyü)",
      "Merkez Mah (arslanlı Köyü)",
      "Merkez Mah (aşağıemerce Köyü)",
      "Merkez Mah (ayvalı Köyü)",
      "Merkez Mah (bademci Köyü)",
      "Merkez Mah (bekirli Köyü)",
      "Merkez Mah (bey Köyü)",
      "Merkez Mah (boyundurcak Köyü)",
      "Merkez Mah (bozarmut Köyü)",
      "Merkez Mah (böcü Köyü)",
      "Merkez Mah (bük Köyü)",
      "Merkez Mah (celep Köyü)",
      "Merkez Mah (çambaşı Köyü)",
      "Merkez Mah (çaykirpi Köyü)",
      "Merkez Mah (çaylaklar Köyü)",
      "Merkez Mah (çekiç Köyü)",
      "Merkez Mah (çevik Köyü)",
      "Merkez Mah (çiftkıran Köyü)",
      "Merkez Mah (çiftlik Köyü)",
      "Merkez Mah (çit Köyü)",
      "Merkez Mah (çoroğlu Köyü)",
      "Merkez Mah (çördük Köyü)",
      "Merkez Mah (dere Köyü)",
      "Merkez Mah (derebeysibey Köyü)",
      "Merkez Mah (dilek Köyü)",
      "Merkez Mah (donalar Köyü)",
      "Merkez Mah (doymuş Köyü)",
      "Merkez Mah (duruca Köyü)",
      "Merkez Mah (erik Köyü)",
      "Merkez Mah (esenlik Köyü)",
      "Merkez Mah (eskiatça Köyü)",
      "Merkez Mah (eskioğlu Köyü)",
      "Merkez Mah (garipşah Köyü)",
      "Merkez Mah (gündoğdu Köyü)",
      "Merkez Mah (hasanlı Köyü)",
      "Merkez Mah (hoca Köyü)",
      "Merkez Mah (imamoğlu Köyü)",
      "Merkez Mah (incesu Köyü)",
      "Merkez Mah (kabalar Köyü)",
      "Merkez Mah (karacaoğlu Köyü)",
      "Merkez Mah (karadedeoğlu Köyü)",
      "Merkez Mah (karapürçek Köyü)",
      "Merkez Mah (kayadibi Köyü)",
      "Merkez Mah (kayapınar Köyü)",
      "Merkez Mah (kaygınca Köyü)",
      "Merkez Mah (kese Köyü)",
      "Merkez Mah (kılıçlı Köyü)",
      "Merkez Mah (kıran Köyü)",
      "Merkez Mah (kızılcaören Köyü)",
      "Merkez Mah (kızılcaörhen Köyü)",
      "Merkez Mah (kızılkese Köyü)",
      "Merkez Mah (kirazcık Köyü)",
      "Merkez Mah (koçanlı Köyü)",
      "Merkez Mah (kornapa Köyü)",
      "Merkez Mah (küçüksü Köyü)",
      "Merkez Mah (masatlar Köyü)",
      "Merkez Mah (obrucak Köyü)",
      "Merkez Mah (olukbaşı Köyü)",
      "Merkez Mah (orta Köyü)",
      "Merkez Mah (ortaöz Köyü)",
      "Merkez Mah (oymaağaçseki Köyü)",
      "Merkez Mah (ömerli Köyü)",
      "Merkez Mah (örhen Köyü)",
      "Merkez Mah (örhenli Köyü)",
      "Merkez Mah (paşa Köyü)",
      "Merkez Mah (pirahmetli Köyü)",
      "Merkez Mah (samanlıören Köyü)",
      "Merkez Mah (sarıkavak Köyü)",
      "Merkez Mah (sarıseki Köyü)",
      "Merkez Mah (sarpun Köyü)",
      "Merkez Mah (taşçılar Köyü)",
      "Merkez Mah (tavukçuoğlu Köyü)",
      "Merkez Mah (tekeoğlu Köyü)",
      "Merkez Mah (tepedelik Köyü)",
      "Merkez Mah (tokaş Köyü)",
      "Merkez Mah (urgancı Köyü)",
      "Merkez Mah (uzunkavak Köyü)",
      "Merkez Mah (vakıfbelören Köyü)",
      "Merkez Mah (yavuç Köyü)",
      "Merkez Mah (yavuçkuyucağı Köyü)",
      "Merkez Mah (yazıhamit Köyü)",
      "Merkez Mah (yeniler Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Merkez Mah (yukarıçayırcık Köyü)",
      "Merkez Mah (yukarıemerce Köyü)",
      "Merkez Mah (yukarışehirören Köyü)",
      "Meşeli Mah (karacaoğlu Köyü)",
      "Mollaoglu Mah (esenlik Köyü)",
      "Mopak Mah (çördük Köyü)",
      "Murat Mah (pirahmetli Köyü)",
      "Musa Mah (kızılkese Köyü)",
      "Muşurup Yaylası Mah (bozarmut Köyü)",
      "Müseyit Mah (boyundurcak Köyü)",
      "Mütevelli Mah (abay Köyü)",
      "Okcu Mah (şahinçatı Köyü)",
      "Orta Mah (çoroğlu Köyü)",
      "Orta Mah (karacakaya Köyü)",
      "Orta Mah (orta Köyü)",
      "Orta Mah (sarpun Köyü)",
      "Ortaköy Mah (kayadibi Köyü)",
      "Ortatelli Mah (çiftlik Köyü)",
      "Oruçlu Mah (kirazcık Köyü)",
      "Otmanlar Mah (şehirören Köyü)",
      "Oymaağaç Mah (hamzaoğlu Köyü)",
      "Öküzcü Mah (çiftkıran Köyü)",
      "Örencik Mah (karnıaçık Köyü)",
      "Örencik Mah (paşa Köyü)",
      "Öte Mah (çetmi Köyü)",
      "Öte Mah (hamzaoğlu Köyü)",
      "Pazar Mah (güneykalınkese Köyü)",
      "Pazaryeri Mah (köçekli Köyü)",
      "Pircabey Mah (akdeğirmen Köyü)",
      "Pulfalı Mah (karnıaçık Köyü)",
      "Purtul Mah (çördük Köyü)",
      "Puşlu Mah (sarıkavak Köyü)",
      "Rahat Mah (sarıkavak Köyü)",
      "Ramazan Mah (çaycevher Köyü)",
      "Sakız Mah (küçüksü Köyü)",
      "Salihoğlu Mah (karapürçek Köyü)",
      "Salmanlı Mah (kızılcaörhen Köyü)",
      "Saraycık Mah (kapaklı Köyü)",
      "Sarı Mah (yavuçkuyucağı Köyü)",
      "Sarıaoğlu Mah (taşçılar Köyü)",
      "Sarıkavak Mah (sarıkavak Köyü)",
      "Sarılar Mah (hasanlı Köyü)",
      "Sarpun Mah (bozarmut Köyü)",
      "Sergenler Mah (obrucak Köyü)",
      "Sey Mah (bey Köyü)",
      "Seyitler Mah (duruca Köyü)",
      "Sıcak Tarla Mah (celep Köyü)",
      "Sipahi Mah (çiftkıran Köyü)",
      "Softa Mah (dilek Köyü)",
      "Soğanlar Mah (güneykalınkese Köyü)",
      "Sorguncuk Mah (hoca Köyü)",
      "Sökü Mah (kaygınca Köyü)",
      "Söylemez Mah (karapürçek Köyü)",
      "Suluoğlu Mah (abay Köyü)",
      "Süle Mah (sarpun Köyü)",
      "Şaban Mah (erik Köyü)",
      "Şabanbey Mah (armutlu Köyü)",
      "Şabanlar Mah (bekirli Köyü)",
      "Şehirören Mah (şehirören Köyü)",
      "Tahtak Mah (kızılcaörhen Köyü)",
      "Taşkapı Mah (örhenli Köyü)",
      "Tekeoğlu Mah (derekaraağaç Köyü)",
      "Tekev Mah (bük Köyü)",
      "Tekke Mah (kuyluş Köyü)",
      "Tekkeoğlu Mah (pirahmetli Köyü)",
      "Telli Mah (dağbelören Köyü)",
      "Tembel Mah (çoroğlu Köyü)",
      "Temür Mah (kuzkalınkese Köyü)",
      "Tenbeller Mah (yoğunoluk Köyü)",
      "Tepe Arkası Mah (yoğunoluk Köyü)",
      "Tepe Mah (bekdemirekşi Köyü)",
      "Tepe Mah (böcü Köyü)",
      "Tepe Mah (çaycevher Köyü)",
      "Tepe Mah (dilek Köyü)",
      "Tepe Mah (hamzaoğlu Köyü)",
      "Tikendere Mah (hamzaoğlu Köyü)",
      "Topalak Mah (yavuçkuyucağı Köyü)",
      "Topçu Mah (kızılkese Köyü)",
      "Topuzlar Mah (yoğunoluk Köyü)",
      "Toroş Mah (incesu Köyü)",
      "Türkmenler Mah (aşağışehirören Köyü)",
      "Tütenli Mah (kapaklı Köyü)",
      "Üzüktaş Mah (sarıseki Köyü)",
      "Veyselli Mah (şahinçatı Köyü)",
      "Yağanlı Mah (yoğunoluk Köyü)",
      "Yahya Mah (kuzkalınkese Köyü)",
      "Yaka Mah (örhen Köyü)",
      "Yalak Mah (sarıseki Köyü)",
      "Yalak Mah (yeniler Köyü)",
      "Yayla Mah (abdalhasan Köyü)",
      "Yayla Mah (hoca Köyü)",
      "Yazıcıoğlu Mah (çambaşı Köyü)",
      "Yemişenlioğlu Mah (kuyluş Köyü)",
      "Yeni Mah (çetmi Köyü)",
      "Yeni Mah (güneykalınkese Köyü)",
      "Yeni Mah (karapürçek Köyü)",
      "Yeni Mah (kıran Köyü)",
      "Yeniçoroğlu Mah (bekirli Köyü)",
      "Yılanca Mah (celep Köyü)",
      "Yukarı Arslanlı Mah (arslanlı Köyü)",
      "Yukarı Boyalı Mah (akçakese Köyü)",
      "Yukarı Derekaraağaç Mah (derekaraağaç Köyü)",
      "Yukarı Köseoğlu Mah (çit Köyü)",
      "Yukarı Mah (çetmi Köyü)",
      "Yukarı Mah (esenlik Köyü)",
      "Yukarı Mah (karacakaya Köyü)",
      "Yukarı Mah (uzunkavak Köyü)",
      "Yukarı Oba Mah (taşçılar Köyü)",
      "Yukarı Seki Mah (oymaağaçseki Köyü)",
      "Yukarıhatipler Mah (masatlar Köyü)",
      "Yukarıtelli Mah (çiftlik Köyü)",
      "Yunuslu Mah (garipşah Köyü)",
      "Yüzhanlı Mah (ortaöz Köyü)",
      "Zeybek Mah (güneykalınkese Köyü)",
      "Ağcıkişi Mah",
      "Bahçelievler Mah",
      "Camikebir Mah",
      "Ethem Mah",
      "Gizlice Mah",
      "Gökırmak Mah",
      "Harmancık Mah",
      "Karasait Mah",
      "Musalla Mah",
      "Pulcular Mah",
      "Sümer Mah",
      "Tabakhane Mah",
      "Tekke Mah",
      "Üstatlar Mah"
    ],
    "Tosya": [
      "Akdutdibi Mah (kızılca Köyü)",
      "Alamadan Mah (gökomuz Köyü)",
      "Ali Efendi Mah (keçeli Köyü)",
      "Aluç Mah (akbük Köyü)",
      "Aşağı Güney Mah (bürnük Köyü)",
      "Aşağı Mah (musaköy Köyü)",
      "Avşar Mah (dağardı Köyü)",
      "Bey Mah (çevlik Köyü)",
      "Camili Mah (çaybaşı Köyü)",
      "Camili Mah (çeltikçi Köyü)",
      "Camili Yaylası Mah (çaybaşı Köyü)",
      "Çamlıca Mah (musaköy Köyü)",
      "Çay Mah (aşağıkayı Köyü)",
      "Çay Mah (kilkuyu Köyü)",
      "Çiftlik Mah (yukarıkayı Köyü)",
      "Çomaklar Mah (gökçeöz Köyü)",
      "Demirciler Mah (kilkuyu Köyü)",
      "Dere Mah (kilkuyu Köyü)",
      "Devrez Mah (karabey Köyü)",
      "Eceoğlu Mah (akseki Köyü)",
      "Emirhacı Mah (keçeli Köyü)",
      "Erenler Mah (gökçeöz Köyü)",
      "Ermelik Mah (ermelik Köyü)",
      "Esenler Mah (gökomuz Köyü)",
      "Eski Mah (akbük Köyü)",
      "Eski Mah (aşağıdikmen Köyü)",
      "Eski Mah (kuşçular Köyü)",
      "Eski Mah (sapaca Köyü)",
      "Gerenli Mah (çaybaşı Köyü)",
      "Göl Mah (yağcılar Köyü)",
      "Götürge Mah (suluca Köyü)",
      "Guz Mah (ermelik Köyü)",
      "Güvekaşı Mah (incebel Köyü)",
      "Hacı Salih Mah (kilkuyu Köyü)",
      "Hasanlı Mah (musaköy Köyü)",
      "Hatçeler Mah (zincirlikuyu Köyü)",
      "Hatip Mah (kilkuyu Köyü)",
      "K.erenler Mah (gökçeöz Köyü)",
      "Karaköy Köyü",
      "Karapürçek Mah (sofular Köyü)",
      "Karga Dere Mah (keçeli Köyü)",
      "Kayser Mah (ermelik Köyü)",
      "Kayser Mah (gökçeöz Köyü)",
      "Kepçeler Mah (çakırlar Köyü)",
      "Kılıçlı Mah (zincirlikuyu Köyü)",
      "Kıran Mah (çakırlar Köyü)",
      "Kırkaçak Mah (çaybaşı Köyü)",
      "Kızılcaağıl Mah (yağcılar Köyü)",
      "Kızılöz Mah (aşağıkayı Köyü)",
      "Kirenli Mah (ermelik Köyü)",
      "Kocaosman Mah (zincirlikuyu Köyü)",
      "Kuraşlar Mah (zincirlikuyu Köyü)",
      "Kurt Mah (gövrecik Köyü)",
      "Kurtbeli Osb Mah (karasapaça Köyü)",
      "Küleşler Mah (kilkuyu Köyü)",
      "Kürtkondu Mah (kilkuyu Köyü)",
      "Kürüz Mah (kilkuyu Köyü)",
      "M1 Mah (özboyu Köyü)",
      "Manastır Mah (bayat Köyü)",
      "Merkez Mah (ahmetoğlu Köyü)",
      "Merkez Mah (akbük Köyü)",
      "Merkez Mah (akseki Köyü)",
      "Merkez Mah (aşağıberçin Köyü)",
      "Merkez Mah (aşağıdikmen Köyü)",
      "Merkez Mah (bayat Köyü)",
      "Merkez Mah (çakırlar Köyü)",
      "Merkez Mah (çaykapı Köyü)",
      "Merkez Mah (çeltikçi Köyü)",
      "Merkez Mah (çepni Köyü)",
      "Merkez Mah (çevlik Köyü)",
      "Merkez Mah (çifter Köyü)",
      "Merkez Mah (çukurköy Köyü)",
      "Merkez Mah (dağardı Köyü)",
      "Merkez Mah (dağçatağı Köyü)",
      "Merkez Mah (dedem Köyü)",
      "Merkez Mah (ekincik Köyü)",
      "Merkez Mah (gökçeöz Köyü)",
      "Merkez Mah (gökomuz Köyü)",
      "Merkez Mah (gövrecik Köyü)",
      "Merkez Mah (incebel Köyü)",
      "Merkez Mah (karabey Köyü)",
      "Merkez Mah (karasapaça Köyü)",
      "Merkez Mah (kargın Köyü)",
      "Merkez Mah (kayaönü Köyü)",
      "Merkez Mah (keçeli Köyü)",
      "Merkez Mah (kınık Köyü)",
      "Merkez Mah (kızılca Köyü)",
      "Merkez Mah (kilkuyu Köyü)",
      "Merkez Mah (kösen Köyü)",
      "Merkez Mah (küçükkızılca Köyü)",
      "Merkez Mah (küçüksekiler Köyü)",
      "Merkez Mah (mısmılağaç Köyü)",
      "Merkez Mah (musaköy Köyü)",
      "Merkez Mah (özboyu Köyü)",
      "Merkez Mah (sekiler Köyü)",
      "Merkez Mah (sevinçören Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (suluca Köyü)",
      "Merkez Mah (şarakman Köyü)",
      "Merkez Mah (yağcılar Köyü)",
      "Merkez Mah (yenidoğan Köyü)",
      "Merkez Mah (yukarıberçin Köyü)",
      "Merkez Mah (yukarıdikmen Köyü)",
      "Merkez Mah (yukarıkayı Köyü)",
      "Merkez Mah (zincirlikuyu Köyü)",
      "Mezarlık Mah (aşağıkayı Köyü)",
      "Muratlı Mah (kargın Köyü)",
      "Orta Berçin Mah (yukarıberçin Köyü)",
      "Orta Mah (çaybaşı Köyü)",
      "Orta Mah (çeltikçi Köyü)",
      "Orta Yaylası Mah (çaybaşı Köyü)",
      "Ortalıca Köyü",
      "Ova Mah (aşağıkayı Köyü)",
      "Özlen Mah (aşağıkayı Köyü)",
      "Sakıziçi Mah (çepni Köyü)",
      "Sarsuklar Mah (çakırlar Köyü)",
      "Saz Dağı Mah (çakırlar Köyü)",
      "Sinderli Mah (gövrecik Köyü)",
      "Site Mah (bürnük Köyü)",
      "Site Mah (suluca Köyü)",
      "Sivar Mah (bürnük Köyü)",
      "Şahanoğlu Mah (çaybaşı Köyü)",
      "Şemsettin Mah (çakırlar Köyü)",
      "Şıhlar Mah (ahmetoğlu Köyü)",
      "Taşkaynar Mah (bayat Köyü)",
      "Tekeler Mah (gökçeöz Köyü)",
      "Tepe Mah (aşağıkayı Köyü)",
      "Tepearası Mah (kargın Köyü)",
      "Topaloğlu Mah (gökomuz Köyü)",
      "Uğur Mah (suluca Köyü)",
      "Unduk Mah (gövrecik Köyü)",
      "Uzunyazı Mah (aşağıberçin Köyü)",
      "Yamuklar Mah (gökomuz Köyü)",
      "Yazı Mah (incebel Köyü)",
      "Yeni Mah (kuşçular Köyü)",
      "Yeni Mah (sapaca Köyü)",
      "Yeni Mah (sofular Köyü)",
      "Yeni Mah (yukarıberçin Köyü)",
      "Yenidağardı Mah (dağardı Köyü)",
      "Yeşilçayır Mah (sofular Köyü)",
      "Yeşilova Mah (akbük Köyü)",
      "Yukarı Güney Mah (bürnük Köyü)",
      "Yukarı Mah (gökomuz Köyü)",
      "Bahçelievler Mah",
      "Camiatik Mah",
      "Cumhuriyet Mah",
      "Çatma Mah",
      "Dere Mah",
      "Dilküşa Mah",
      "Fevzipaşa Mah",
      "Hacı Kemal Mah",
      "Hacıpir Mah",
      "Harsat Mah",
      "Hocafakı Mah",
      "Hocaimat Mah",
      "İbni Selim Mah",
      "İlyasbey Mah",
      "Kargı Mah",
      "Karşıyaka Mah",
      "Kuzyaka Mah",
      "Mimar Sinan Mah",
      "Pınarbaşı Mah",
      "Şeh Mah",
      "Şehreküstü Mah",
      "Yavuz Selim Mah",
      "Yunus Emre Mah"
    ]
  },
  "Kayseri": {
    "Akkışla": [
      "Akin Mah",
      "Alevkışla Mah",
      "Ganişeyh Mah",
      "Girinci Mah",
      "Gömürgen Mah",
      "Gömürgen Yeni Mah",
      "Gümüşsu Mah",
      "Kululu Mah",
      "Manavuz Mah",
      "Ortaköy Mah",
      "Şen Mah",
      "Uğurlu Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Yukarı Mah"
    ],
    "Bünyan": [
      "Ağcalı Mah",
      "Akçatı Mah",
      "Akmescit Mah",
      "Asmakaya Mah",
      "Bayramlı Mah",
      "Burhaniye Mah",
      "Büyüktuzhisar Mah",
      "Camiicedit Mah",
      "Camiikebir Mah",
      "Cumhuriyet Mah",
      "Dağardı Mah",
      "Dervişağa Mah",
      "Doğanlar Mah",
      "Ekinciler Mah",
      "Elbaşı Mah",
      "Emirören Mah",
      "Fatih Mah",
      "Gergeme Mah",
      "Girveli Mah",
      "Güllüce Mah",
      "Hazarşah Mah",
      "İbrahimbey Mah",
      "İğdecik Mah",
      "Kahveci Mah",
      "Karacaören Mah",
      "Karahıdır Mah",
      "Karakaya Mah",
      "Karatay Mah",
      "Kardeşler Mah",
      "Koyunabdal Mah",
      "Köprübaşı Mah",
      "Kösehacılı Mah",
      "Musaşeyh Mah",
      "Pirahmet Mah",
      "Sağlık Mah",
      "Samağır Mah",
      "Sıvgın Mah",
      "Sultanhanı Mah",
      "Sümer Mah",
      "Topsöğüt Mah",
      "Yağmurbey Mah",
      "Yakutiye Mah",
      "Yavuz Selim Mah",
      "Yeni Süksün Mah",
      "Yenice Mah",
      "Yünören Mah"
    ],
    "Develi": [
      "Abdulbaki Mah",
      "Alpaslan Mah",
      "Aşağıeverek Mah",
      "Aşık Seyrani Mah",
      "Ayşepınar Mah",
      "Ayvazhacı Mah",
      "Bahçebaşı Mah",
      "Bahçelievler Mah",
      "Büyükkünye Mah",
      "Camiicedit Mah",
      "Cumhuriyet Mah",
      "Çadıryeri Mah",
      "Çataloluk Mah",
      "Çayırözü Mah",
      "Çaylıca Mah",
      "Çomaklı Mah",
      "Çöten Mah",
      "Çukuryurt Mah",
      "Derebaşı Mah",
      "Dereşimli Mah",
      "Develi Camikebir Mah",
      "E.camiikebir Mah",
      "Epçe Mah",
      "Eşelik Mah",
      "Fatih Mah",
      "Feneseaşağı Mah",
      "Feneseyukarı Mah",
      "Gazi Mah",
      "Gömedi Mah",
      "Gümüşören Mah",
      "Güneyaşağı Mah",
      "Güneyyukarı Mah",
      "Harman Mah",
      "Havadan Mah",
      "Hoşça Mah",
      "Hüseyinli Mah",
      "İbrahimağa Mah",
      "İncesu Mah",
      "İzmirli Mah",
      "Kabaklı Mah",
      "Kaleköy Mah",
      "Karacaören Mah",
      "Kılıçkaya Mah",
      "Kızık Mah",
      "Kopçullu Mah",
      "Kozluca Mah",
      "Köseler Mah",
      "Kulpak Mah",
      "Küçükkünye Mah",
      "Mehmet Akif Ersoy Mah",
      "Millidere Mah",
      "Mustafa Asım Köksal Mah",
      "Öksüt Mah",
      "Reşadiye Mah",
      "Saraycık Mah",
      "Sarıca Mah",
      "Sarıkaya Mah",
      "Satı Mah",
      "Sindelhöyük Camikebir Mah",
      "Sindelhöyük Fatih Mah",
      "Sindelhöyük Yenice Mah",
      "Soysallı Mah",
      "Şahmelik Mah",
      "Şht.üstğm.hasan Şahan Mah",
      "Şıhlı Mah",
      "Taşcı Bucak Merkezi Mah",
      "Tombak Mah",
      "Yaylacık Mah",
      "Yazıbaşı Mah",
      "Yedek Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenihayat Mah",
      "Yeniköy Mah",
      "Yeşilyurt Mah",
      "Yüzevler Mah",
      "Zile Mah"
    ],
    "Felahiye": [
      "Acırlı Mah",
      "Alparslan Mah",
      "Beyler Mah",
      "Büyüktoraman Hürriyet Mah",
      "Büyüktoraman İstiklal Mah",
      "Cumhuriyet Mah",
      "Darılı Mah",
      "İsabey Mah",
      "Kale Mah",
      "Karaşeyh Mah",
      "Kayapınar Cumhuriyet Mah",
      "Kayapınar Fatih Sultan Mehmet Mah",
      "Kepiç Mah",
      "Kuruhüyük Mah",
      "Menteşe Mah",
      "Silahtar Mah",
      "Yeni Mah"
    ],
    "Hacılar": [
      "Akdam Mah",
      "Akyazı Mah",
      "Aşağı Mah",
      "Beğendik Mah",
      "Erciyes Mah",
      "Orta Mah",
      "Yediağaç Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Hürmetci Mah",
      "Karpuzsekisi Mah",
      "Sakarçiftliği Mah"
    ],
    "İncesu": [
      "Bahçelievler Mah",
      "Bahçesaray Mah",
      "Bulgurcu Mah",
      "Çardaklı Mah",
      "Dokuzpınar Mah",
      "Fırınönü Mah",
      "Garipçe Mah",
      "Gönenkent Mah",
      "Hamurcu Mah",
      "Karahüyük Mah",
      "Karakoyunlu Mah",
      "Karamustafapaşa Mah",
      "Kızılören Aşağı Mah",
      "Kızılören Ötebatan Mah",
      "Kızılören Tabaklı Mah",
      "Küllü Mah",
      "Örenşehir Mah",
      "Saraycık Mah",
      "Sarıkürklü Mah",
      "Semerkent Mah",
      "Subaşı Mah",
      "Sultansazı Osb Mah",
      "Süksün Cumhuriyet Mah",
      "Süksün Hürriyet Mah",
      "Süksün Zafer Mah",
      "Şeyhşaban Mah",
      "Tahirinli Mah",
      "Üçkuyu Mah",
      "Vali İhsan Aras Mah",
      "Yarım Mah",
      "Yeni Camii Mah"
    ],
    "Kocasinan": [
      "Bayramhacı Mah",
      "Beydeğirmeni Mah",
      "Boğazköprü Mah",
      "Düver Mah",
      "Ebiç Mah",
      "Elmalı Mah",
      "Eskiömerler Mah",
      "Hırkaköy Mah",
      "Himmetdede Mah",
      "Kalkancık Mah",
      "Karakimse Mah",
      "Kaşköy Mah",
      "Mahzemin Mah",
      "Molu Mah",
      "Oymaağaç Mah",
      "Saraycık Mah",
      "Yemliha Mah",
      "Yukarıhasinli Mah",
      "Yuvalı Mah",
      "Alsancak Mah",
      "Argıncık Mah",
      "Cırgalan Mah",
      "Fevzioğlu Mah",
      "Kayabaşı Mah",
      "Talatpaşa Mah",
      "Ahi Evran Mah",
      "Beyazşehir Mah",
      "Kocasinan Mah",
      "Yavuz Selim Mah",
      "Camikebir Mah",
      "Ertuğrul Gazi Mah",
      "General Emir Mah",
      "Osmangazi Mah",
      "Akin Mah",
      "Boyacı Mah",
      "Çevril Mah",
      "Dadağı Mah",
      "Emmiler Mah",
      "Erkilet Mah",
      "Hasan Arpa Mah",
      "Kemer Mah",
      "Kuşçu Mah",
      "Taşhan Mah",
      "Yazır Mah",
      "Erciyesevler Mah",
      "Fevzi Çakmak Mah",
      "Mimarsinan Mah",
      "Uğurevler Mah",
      "Yıldızevler Mah",
      "Akcatepe Mah",
      "Amarat Mah",
      "Barsama Mah",
      "Buğdaylı Mah",
      "Doruklu Mah",
      "Eyim Mah",
      "Gömeç Mah",
      "Güneşli Mah",
      "Hasancı Mah",
      "Höbek Mah",
      "Karahöyük Mah",
      "Kızık Mah",
      "Kuşcağız Mah",
      "Mollahacı Mah",
      "Obruk Mah",
      "Salur Mah",
      "Vatan Mah",
      "Yüreğil Mah",
      "Şeker Mah",
      "Gevher Nesibe Mah",
      "Hacı Saki Mah",
      "Sanayi Mah",
      "Sahabiye Mah",
      "Boztepe Mah",
      "Elagöz Mah",
      "Hoca Ahmet Yesevi Mah",
      "Mevlana Mah",
      "Sancaktepe Mah",
      "Saray Bosna Mah",
      "Seyrani Mah",
      "Sümer Mah",
      "Yakut Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Zümrüt Mah",
      "Barbaros Mah",
      "Mithatpaşa Mah",
      "Oruçreis Mah",
      "Turgut Reis Mah",
      "Yavuzlar Mah",
      "Yenidoğan Mah",
      "Yenişehir Mah",
      "Yunus Emre Mah",
      "Ziyagökalp Mah"
    ],
    "Melikgazi": [
      "Battalgazi Mah",
      "Becen Mah",
      "Danişmentgazi Mah",
      "Erenköy Mah",
      "Esenyurt Mah",
      "Osmanlı Mah",
      "Selçuklu Mah",
      "Tacettinveli Mah",
      "19 Mayıs Mah",
      "30 Ağustos Mah",
      "Anafartalar Mah",
      "Anbar Mah",
      "Anbar Sb Mah",
      "Kayseriosb Mah",
      "Keykubat Mah",
      "Kocatepe Mah",
      "Sakarya Mah",
      "Selimiye Mah",
      "Tınaztepe Mah",
      "Cumhuriyet Mah",
      "Bağpınar Mah",
      "Gesi Mah",
      "Güzelköy Mah",
      "Kayabağ Mah",
      "Vekse Mah",
      "Yeşilyurt Mah",
      "Ağırnas Mah",
      "Büyük Bürüngüz Mah",
      "Gürpınar Mah",
      "Küçük Bürüngüz Mah",
      "Sarımsaklı Mah",
      "Subaşı Mah",
      "Turan Mah",
      "Hisarcık Mah",
      "Kıranardı Mah",
      "Altınoluk Mah",
      "Aydınlıkevler Mah",
      "Eğribucak Mah",
      "Gülük Mah",
      "Hürriyet Mah",
      "Yeniköy Mah",
      "Gesi Fatih Mah",
      "İldem Cumhuriyet Mah",
      "Esentepe Mah",
      "Kazımkarabekir Mah",
      "Osman Kavuncu Mah",
      "Alpaslan Mah",
      "Gültepe Mah",
      "Hunat Mah",
      "Kılıçaslan Mah",
      "Köşk Mah",
      "Yıldırım Beyazıt Mah",
      "Bahçelievler Mah",
      "Demokrasi Mah",
      "Fatih Mah",
      "Germir Mah",
      "Gökkent Mah",
      "Mimarsinan Mah",
      "Mimarsinan Osb Mah",
      "Şirintepe Mah",
      "Tavlusun Mah"
    ],
    "Özvatan": [
      "Alparslan Mah",
      "Aşağı Boğaziçi Mah",
      "Bahçeli Evler Mah",
      "Cumhuriyet Mah",
      "Güney Mah",
      "Kale Mah",
      "Kavaklı Mah",
      "Kermelik Mah",
      "Küpeli Mah",
      "Taşlık Mah",
      "Tuğlaşah Mah",
      "Yeni Mah",
      "Yukarı Boğaziçi Mah"
    ],
    "Pınarbaşı": [
      "Akören Mah",
      "Akpınar Mah",
      "Alagazili Mah",
      "Alamescit Mah",
      "Altıkesek Mah",
      "Arslanbeyli Mah",
      "Artmak Mah",
      "Aşağıbeyçayırı Mah",
      "Aşağıborandere Mah",
      "Aşağıkaragöz Mah",
      "Aşağıkızılçevlik Mah",
      "Avşarpotuklu Mah",
      "Aygörmez Mah",
      "Bahçecik Mah",
      "Beserek Mah",
      "Büyükgümüşgün Mah",
      "Büyükgürleğen Mah",
      "Büyükkabaktepe Mah",
      "Büyükkaramanlı Mah",
      "Büyükkaramuklu Mah",
      "Büyükkömarmut Mah",
      "Büyükpotuklu Mah",
      "Cabe Mah",
      "Cinahmet Mah",
      "Cinliören Mah",
      "Çakılkaya Mah",
      "Çaybaşı Mah",
      "Çördüklü Mah",
      "Çukuryurt Mah",
      "Demircili Mah",
      "Demirciören Mah",
      "Devederesi Mah",
      "Dikilitaş Mah",
      "Dilciler Mah",
      "Eğrisöğüt Mah",
      "Elmalı Mah",
      "Emeğil Mah",
      "Esenköy Mah",
      "Eskitekke Mah",
      "Eskiyassıpınar Mah",
      "Fakıekinciliği Mah",
      "Gebelek Mah",
      "Gölcük Mah",
      "Gültepe Mah",
      "Gümüşgün Mah",
      "Güney Mah",
      "Halitbeyören Mah",
      "Han Mah",
      "Hasırcı Mah",
      "Hassa Mah",
      "Hayriye Mah",
      "Hilmiye Mah",
      "Hürriyet Mah",
      "İğdelipayaslı Mah",
      "İnliören Mah",
      "İnönü Mah",
      "Kadılı Mah",
      "Kaftangiyen Mah",
      "Kaman Mah",
      "Karaboğaz Mah",
      "Karahacılı Mah",
      "Karahalka Mah",
      "Karakuyu Mah",
      "Kavakköy Mah",
      "Kavlaklar Mah",
      "Kayaaltı Mah",
      "Kayabaşı Mah",
      "Kayaönü Mah",
      "Kaynar Mah",
      "Kazancık Mah",
      "Kerimoğlu Mah",
      "Kılıçkışla Mah",
      "Kılıçmehmet Mah",
      "Kırkgeçit Mah",
      "Kırkpınar Mah",
      "Kızıldere Mah",
      "Kızılhan Mah",
      "Kızılören Mah",
      "Köşkerli Mah",
      "Kurbağalık Mah",
      "Kurttepe Mah",
      "Kuşçular Mah",
      "Küçükkömarmut Mah",
      "Küçükpotuklu Mah",
      "Malakköy Mah",
      "Melikgazi Mah",
      "Methiye Mah",
      "Olukkaya Mah",
      "Oruçoğlu Mah",
      "Örenşehir Bucak Merkezi Mah",
      "Panlı Mah",
      "Paşalı Mah",
      "Pazarören Mah",
      "Pazarsu Mah",
      "Pulpınar Mah",
      "Saçayağı Mah",
      "Saçlı Mah",
      "Serinyurt Mah",
      "Solaklar Mah",
      "Söğütlü Mah",
      "Şabanlı Mah",
      "Şerefiye Mah",
      "Tahtaköprü Mah",
      "Taşlıgeçit Mah",
      "Taşlıoğlu Mah",
      "Taşoluk Mah",
      "Tersakan Mah",
      "Tözgün Mah",
      "Uzunpınar Mah",
      "Uzunyol Mah",
      "Üçpınar Mah",
      "Yağlıpınar Mah",
      "Yahyabey Mah",
      "Yarımtepe Mah",
      "Yenicami Mah",
      "Yeniocak Mah",
      "Yeregeçen Mah",
      "Yukarıbeyçayırı Mah",
      "Yukarıborandere Mah",
      "Yukarıkaragöz Mah",
      "Yukarıkızılçevlik Mah",
      "Yusuflar Mah"
    ],
    "Sarıoğlan": [
      "Alamettin Mah",
      "Bakarcak Mah",
      "Burunören Mah",
      "Çiftlik Mah",
      "Düzencik Mah",
      "Ebülhayır Mah",
      "Gaziler Mah",
      "Güzelyazı Mah",
      "Ilıca Mah",
      "İğdeli Mah",
      "Kadılı Mah",
      "Kaleköy Mah",
      "Karaözü Mah",
      "Karpınar Mah",
      "Keklikoğlu Mah",
      "Kızılpınar Mah",
      "Muratbeyli Mah",
      "Ömerhacılı Mah",
      "Ömürlü Mah",
      "Palas Mah",
      "Sofumahmut Mah",
      "Şenyurt Mah",
      "Tatılı Mah",
      "Üzerlik Mah",
      "Yahyalı Mah",
      "Yerlikuyu Mah",
      "Yıldırım Mah"
    ],
    "Sarız": [
      "Akoluk Mah",
      "Altısöğüt Mah",
      "Avşarobası Mah",
      "Ayranlık Mah",
      "Bahçeli Mah",
      "Büyük Örtülü Mah",
      "Büyük Söbeçimen Mah",
      "Çağşak Mah",
      "Çatalpınar Mah",
      "Çavdar Mah",
      "Çörekdere Mah",
      "Dallıkavak Mah",
      "Damızlık Mah",
      "Darıdere Mah",
      "Dayoluk Mah",
      "Değirmentaş Mah",
      "Fettahdere Mah",
      "Gümüşali Mah",
      "Günesen Mah",
      "İmirzaağa Mah",
      "İncedere Mah",
      "İncemağara Mah",
      "Karapınar Mah",
      "Karayurt Mah",
      "Kemer Mah",
      "Kırkısrak Mah",
      "Kıskaçlı Mah",
      "Kızılpınar Mah",
      "Kurdini Mah",
      "Kurudere Mah",
      "Kuşçu Mah",
      "Küçük Kabaktepe Mah",
      "Küçük Örtülü Mah",
      "Küçük Söbeçimen Mah",
      "Mollahüseyinler Mah",
      "Oğlakkaya Mah",
      "Ördekli Mah",
      "Sancakağıl Mah",
      "Tavla Mah",
      "Tekneli Mah",
      "Yaylacı Mah",
      "Yedioluk Mah",
      "Yeni Mah",
      "Yeşilkent Mah"
    ],
    "Talas": [
      "Bahçelievler Mah",
      "Han Mah",
      "Harman Mah",
      "Kiçiköy Mah",
      "Mevlana Mah",
      "Tablakaya Mah",
      "Yenidoğan Mah",
      "Yukarı Mah",
      "Akçakaya Mah",
      "Alaybeyli Mah",
      "Ardıç Mah",
      "Başakpınar Mah",
      "Cebir Mah",
      "Çatakdere Mah",
      "Çevlik Mah",
      "Çömlekçi Mah",
      "Endürlük Mah",
      "Kamber Mah",
      "Kepez Mah",
      "Koçcağız Mah",
      "Kuruköprü Mah",
      "Mengücek Mah",
      "Örencik Mah",
      "Reşadiye Mah",
      "Sakaltutan Mah",
      "Sosun Mah",
      "Süleymanlı Mah",
      "Yamaçlı Mah",
      "Yazyurdu Mah",
      "Zincidere Mah"
    ],
    "Tomarza": [
      "Akdere Mah",
      "Akmezar Mah",
      "Arslantaş Mah",
      "Avşarsöğütlü Mah",
      "Bektaş Mah",
      "Bostanlık Mah",
      "Böke Mah",
      "Büyükcanlı Mah",
      "Culha Mah",
      "Cumhuriyet Mah",
      "Cücün Mah",
      "Çanakpınar Mah",
      "Çayinli Mah",
      "Çukurağaç Mah",
      "Dadaloğlu Mah",
      "Dağyurdu Mah",
      "Ekinli Mah",
      "Emiruşağı Mah",
      "Göktepe Mah",
      "Gülveren Mah",
      "Güzelce Mah",
      "Güzelsu Mah",
      "Hacıpaşa Mah",
      "Işıklar Mah",
      "İcadiye Mah",
      "İmamkullu Mah",
      "İncili Mah",
      "Kale Mah",
      "Kapukaya Mah",
      "Karamuklu Mah",
      "Karaören Mah",
      "Kesir Mah",
      "Kevenağıl Mah",
      "Kızılören Mah",
      "Kömür Mah",
      "Köprübaşı Mah",
      "Kurtuluş Mah",
      "Kuşcağız Mah",
      "Küçükcanlı Mah",
      "Melikören Mah",
      "Pusatlı Mah",
      "Sarımehmetli Mah",
      "Söğütlü Mah",
      "Süvegenler Mah",
      "Şıhbarak Mah",
      "Şiraz Mah",
      "Tahtakemer Mah",
      "Tatar Mah",
      "Toklar Mah",
      "Turanlı Mah",
      "Üçkonak Mah",
      "Yavuzselim Mah",
      "Yeni Mah",
      "Yeşilbağ Mah"
    ],
    "Yahyalı": [
      "100.yıl Mah",
      "75.yıl Mah",
      "Ağcaşar Mah",
      "Avlağa Mah",
      "Balcıçakırı Mah",
      "Burhaniye Mah",
      "Büyükçakır Mah",
      "Camikebir Mah",
      "Çamlıca Mah",
      "Çavdaruşağı Mah",
      "Çiğilli Mah",
      "Çubukharmanı Mah",
      "Çubuklu Mah",
      "Delialiuşağı Mah",
      "Denizovası Mah",
      "Derebağ Mah",
      "Dikme Mah",
      "Fetullah Mah",
      "Fevziçakmak Mah",
      "Gazibeyli Mah",
      "İlyaslı Mah",
      "İsmet Mah",
      "Kapuzbaşı Mah",
      "Karaköy Mah",
      "Kavacık Mah",
      "Kirazlı Mah",
      "Kocahacılı Mah",
      "Kopçu Mah",
      "Kuzoluk Mah",
      "Madazı Mah",
      "Mustafabeyli Mah",
      "Sazak Mah",
      "Senirköy Mah",
      "Seydili Mah",
      "Süleymanfakılı Mah",
      "Taşhan Mah",
      "Ulupınar Mah",
      "Yenice Mah",
      "Yerköy Mah",
      "Yeşilköy Mah",
      "Yuları Mah"
    ],
    "Yeşilhisar": [
      "Akköy Mah",
      "Araplı Mah",
      "Başköy Mah",
      "Beyleryukarı Mah",
      "Büget Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Çadırkaya Mah",
      "Derbentbaşı Mah",
      "Doğanlı Mah",
      "Erdemli Mah",
      "Fatih Mah",
      "Fevzioğlu Mah",
      "Gülbayır Mah",
      "Güney Mah",
      "Güzelöz Mah",
      "İçmece Mah",
      "İdris Mah",
      "Kale Mah",
      "Karacabey Mah",
      "Kavak Mah",
      "Kayadibi Mah",
      "Keler Mah",
      "Keşlik Mah",
      "Kovalı Mah",
      "Köşk Mah",
      "Kuşçu Mah",
      "Kuzey Mah",
      "Mahmudiye Mah",
      "Musahacılı Mah",
      "Ovaçiftlik Mah",
      "Soğanlı Mah",
      "Yavuz Selim Mah",
      "Yenişehir Mah",
      "Yeşilova Mah"
    ]
  },
  "Kırklareli": {
    "Babaeski": [
      "Gülbahçe Mah (alpullu Beldesi)",
      "Şeker Mah (alpullu Beldesi)",
      "Yeni Mah (alpullu Beldesi)",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Dindoğru Mah",
      "Fevzi Çakmak Mah",
      "Gazikemal Mah",
      "Gaziosmanpaşa Mah",
      "Hacıhasan Mah",
      "Hamidiye Mah",
      "Kurtuluş Mah",
      "Hatip Mah (büyükmandıra Beldesi)",
      "Hürriyet Mah (büyükmandıra Beldesi)",
      "Paşa Mah (büyükmandıra Beldesi)",
      "Şamdani Mah (büyükmandıra Beldesi)",
      "Birlik Mah (karahalil Beldesi)",
      "Demirkapı Mah (karahalil Beldesi)",
      "Fevzi Çakmak Mah (karahalil Beldesi)",
      "Halilpaşa Mah (karahalil Beldesi)",
      "Kemal Paşa Mah (karahalil Beldesi)",
      "Ağayeri Köyü",
      "Atatürk Mah (sinanlı Köyü)",
      "Cumhuriyet Mah (sinanlı Köyü)",
      "Çavuşköy Köyü",
      "Çengerli Köyü",
      "Çiğdemli Köyü",
      "Düğüncülü Köyü",
      "Erikleryurdu Köyü",
      "Ertuğrulköy Köyü",
      "Hazinedar Köyü",
      "Karabayır Köyü",
      "Karacaoğlan Köyü",
      "Karamesutlu Köyü",
      "Katranca Köyü",
      "Kuleli Köyü",
      "Kumrular Köyü",
      "Kuzuçardağı Köyü",
      "Minnetler Köyü",
      "Mutlu Köyü",
      "Müsellim Köyü",
      "Nacak Köyü",
      "Nadırlı Köyü",
      "Oruçlu Köyü",
      "Osmaniye Köyü",
      "Pancarköy Köyü",
      "Sofuhalil Köyü",
      "Taşağıl Bucak Merkezi Köyü",
      "Taşköprü Köyü",
      "Terzili Köyü",
      "Yeniköy Köyü",
      "Yenimahalle Köyü"
    ],
    "Demirköy": [
      "Hamdibey Mah",
      "Orhaniye Mah",
      "Yeni Mah",
      "Avcılar Köyü",
      "Beğendik Köyü",
      "Deniz Mah (iğneada Beldesi)",
      "Fener Sitesi Mah (limanköy Köyü)",
      "Koru Sitesi Mah (limanköy Köyü)",
      "Limanköy Köyü",
      "Palivor Çiftliği Mah (avcılar Köyü)",
      "Sislioba Köyü",
      "Yeni Mah (iğneada Beldesi)",
      "Armutveren Köyü",
      "Balaban Köyü",
      "Boztaş Köyü",
      "Gökyaka Köyü",
      "Hamdibey Köyü",
      "İncesırt Köyü",
      "Karacadağ Köyü",
      "Karanlık Mah (incesırt Köyü)",
      "Sarpdere Köyü",
      "Sivriler Köyü",
      "Yeşilce Köyü",
      "Yiğitbaşı Köyü"
    ],
    "Kofçaz": [
      "Yeni Mah",
      "Yeşillik Mah",
      "Ahlatlı Köyü",
      "Ahmetler Köyü",
      "Aşağıkanara Köyü",
      "Beyci Köyü",
      "Devletliağaç Köyü",
      "Elmacık Köyü",
      "Karaabalar Köyü",
      "Kocatarla Köyü",
      "Kocayazı Köyü",
      "Kula Köyü",
      "Malkoçlar Köyü",
      "Tastepe Köyü",
      "Tatlıpınar Köyü",
      "Terzidere Köyü",
      "Topçular Köyü",
      "Yukarıkanara Köyü"
    ],
    "Lüleburgaz": [
      "Dere Mah (ahmetbey Beldesi)",
      "Gündoğu Mah (ahmetbey Beldesi)",
      "Karşıyaka Mah (ahmetbey Beldesi)",
      "Fatih Mah (büyükkarıştıran Beldesi)",
      "Küçükkarıştıran Mah (büyükkarıştıran Beldesi)",
      "Yeni Mah (büyükkarıştıran Beldesi)",
      "Yıldırım Mah (büyükkarıştıran Beldesi)",
      "Fatih Mah (evrensekiz Beldesi)",
      "Gündoğu Mah (evrensekiz Beldesi)",
      "Kırcaali Mah (evrensekiz Beldesi)",
      "8 Kasım Mah",
      "Atatürk Mah",
      "Barış Mah",
      "Cumhuriyet Mah",
      "Dere Mah",
      "Durak Mah",
      "Gençlik Mah",
      "Gündoğu Mah",
      "Güneş Mah",
      "Hürriyet Mah",
      "İnönü Mah",
      "İstiklal Mah",
      "Kocasinan Mah",
      "Kurtuluş Mah",
      "Özerler Mah",
      "Sevgi Mah",
      "Siteler Mah",
      "Yeni Mah",
      "Yıldırım Mah",
      "Yıldız Mah",
      "Yılmaz Mah",
      "Zafer Mah",
      "Akçaköy Köyü",
      "Alacaoğlu Köyü",
      "Ayvalı Köyü",
      "Celaliye Köyü",
      "Ceylanköy Köyü",
      "Cumhuriyet Mah (kırıkköy Köyü)",
      "Çengelli Köyü",
      "Çeşmekolu Köyü",
      "Çiftlikköy Köyü",
      "Davutlu Köyü",
      "Düğüncübaşı Köyü",
      "Emirali Köyü",
      "Ertuğrul Köyü",
      "Eskibedir Köyü",
      "Eskitaşlı Köyü",
      "Hamitabat Köyü",
      "Hamzabey Köyü",
      "Hürriyet Mah (kırıkköy Köyü)",
      "Hürriyet Mah (sakızköy Köyü)",
      "Karaağaç Köyü",
      "Karamusul Köyü",
      "Kayabeyli Köyü",
      "Köydışı Mah (hamitabat Köyü)",
      "Merkez Mah (sakızköy Köyü)",
      "Müsellim Köyü",
      "Oklalı Köyü",
      "Ovacık Köyü",
      "Sarıcaali Köyü",
      "Sarımsaklı Mah",
      "Seyitler Köyü",
      "Tatarköy Köyü",
      "Turgutbey Köyü",
      "Umurca Köyü",
      "Yenibedir Köyü",
      "Yenitaşlı Köyü"
    ],
    "Merkez": [
      "Armağan Köyü",
      "Çağalayık Köyü",
      "Dereköy  Bucak Merkezi Köyü",
      "Düzorman Köyü",
      "Geçitağzı Köyü",
      "Kapaklı Köyü",
      "Karadere Köyü",
      "Koruköy Köyü",
      "Şükrüpaşa Köyü",
      "Arizbaba Köyü",
      "Dokuzhüyük Köyü",
      "Dolhan Köyü",
      "Kazımpaşa Mah (inece Beldesi)",
      "Kemalpaşa Mah (inece Beldesi)",
      "Kocahıdır Köyü",
      "Koyunbaba Köyü",
      "Paşayeri Köyü",
      "Ulukonak Mah (inece Beldesi)",
      "Ürünlü Köyü",
      "Yeni Mah (inece Beldesi)",
      "Celaliye Mah (kavaklı Beldesi)",
      "Çarşı Mah (kavaklı Beldesi)",
      "Turist Mah (kavaklı Beldesi)",
      "Yeni Okullar Mah (kavaklı Beldesi)",
      "Akalar Mah",
      "Atatürk Mah",
      "Bademlik Mah",
      "Cumhuriyet Mah",
      "Demirtaş Mah",
      "Doğu Mah",
      "İstasyon Mah",
      "Karacaibrahim Mah",
      "Karahıdır Mah",
      "Karakaş Mah",
      "Kocahıdır Mah",
      "Pınar Mah",
      "Yayla Mah",
      "Ahmetçe Köyü",
      "Asılbeyli Köyü",
      "Bayramdere Köyü",
      "Çayırlı Köyü",
      "Çeşmeköy Köyü",
      "Değirmencik Köyü",
      "Demircihalil Köyü",
      "Deveçatağı Köyü",
      "Erikler Köyü",
      "Eriklice Köyü",
      "Kadıköy Köyü",
      "Karahamza Köyü",
      "Karakoç Köyü",
      "Karıncak Köyü",
      "Kavakdere Köyü",
      "Kayalı Köyü",
      "Kızılcıkdere Köyü",
      "Kızılcıkdereosb Mah (kızılcıkdere Köyü)",
      "Kuzulu Köyü",
      "Yoğuntaş Bucak Merkezi Köyü",
      "Yürükbayırı Köyü",
      "Beypınar Köyü",
      "Cevat Paşa Mah (üsküp Beldesi)",
      "Çukurpınar Köyü",
      "Gündoğdu Mah (üsküp Beldesi)",
      "Kemal Paşa Mah (üsküp Beldesi)",
      "Mehmet Çavuş Mah (üsküp Beldesi)",
      "Üsküpdere Köyü",
      "Yündalan Köyü"
    ],
    "Pehlivanköy": [
      "Akarca Köyü",
      "Doğanca Köyü",
      "Hıdırca Köyü",
      "İmampazarı Köyü",
      "Kumköy Köyü",
      "Kuştepe Köyü",
      "Yeşilova Köyü",
      "Yeşilpınar Köyü",
      "Ergene Mah",
      "Kazımdirik Mah",
      "Kurtuluş Mah"
    ],
    "Pınarhisar": [
      "Akarlar Mah (kaynarca Beldesi)",
      "Işıklar Mah (kaynarca Beldesi)",
      "Yenicamii Mah (kaynarca Beldesi)",
      "Akören Köyü",
      "Ataköy Köyü",
      "Cevizköy Köyü",
      "Cumhuriyet Mah (yenice Köyü)",
      "Çayırdere Köyü",
      "Erenler Köyü",
      "Evciler Köyü",
      "Hacıfakılı Köyü",
      "Hürriyet Mah (yenice Köyü)",
      "İslambeyli Köyü",
      "Kurudere Köyü",
      "Osmancık Köyü",
      "Poyralı Köyü",
      "Sütlüce Köyü",
      "Tozaklı Köyü",
      "Beylik Mah",
      "Camiikebir Mah",
      "Dere Mah",
      "Orta Mah"
    ],
    "Vize": [
      "Cumhuriyet Mah (çakıllı Beldesi)",
      "Hürriyet Mah (çakıllı Beldesi)",
      "Zafer Mah (çakıllı Beldesi)",
      "Cumhuriyet Mah (kıyıköy Beldesi)",
      "Güven Mah (kıyıköy Beldesi)",
      "Kale Mah (kıyıköy Beldesi)",
      "Akıncılar Köyü",
      "Akpınar Köyü",
      "Aksicim Köyü",
      "Balkaya Köyü",
      "Çavuşköy Köyü",
      "Çüvenli Köyü",
      "Develi Köyü",
      "Doğanca Köyü",
      "Düzova Köyü",
      "Evrenli Köyü",
      "Hamidiye Köyü",
      "Hasbuğa Köyü",
      "Kışlacık Köyü",
      "Kızılağaç Köyü",
      "Kömürköy Köyü",
      "Küçükyayla Köyü",
      "Müsellim Köyü",
      "Okçular Köyü",
      "Pazarlı Köyü",
      "Topçuköy Köyü",
      "Evrencik Köyü",
      "Evrencik Mah (evrencik Köyü)",
      "Fevzi Çakmak Mah (sergen Köyü)",
      "Sağlık Mah (sergen Köyü)",
      "Sofular Köyü",
      "Soğucak Köyü",
      "Yeni Cami Mah (sergen Köyü)",
      "Devlet Mah",
      "Evren Mah",
      "Gazi Mah",
      "Kale Mah",
      "Mehmet Akif Mah",
      "Namık Kemal Mah"
    ]
  },
  "Kırşehir": {
    "Akçakent": [
      "Şehricedid Mah",
      "Yenikent Mah",
      "Yeniyapan Mah",
      "Aliefendi Mah (mahsenli Köyü)",
      "Derefakılı Köyü",
      "Güneşli Mah (yetikli Köyü)",
      "Güvemli Mah (yaylaözü Köyü)",
      "Hacıfakılı Köyü",
      "Hasanali Köyü",
      "Karşıyaka Mah (mahsenli Köyü)",
      "Kösefakılı Bucak Merkezi Köyü",
      "Polatlı Köyü",
      "Taşlıoluk Köyü",
      "Tepe Mah (mahsenli Köyü)",
      "Tepefakılı Köyü",
      "Yaylaözü Köyü",
      "Yeşildere Köyü",
      "Yetikli Köyü",
      "Avanoğlu Köyü",
      "Ayvalı Köyü",
      "Çökelek Mah (avanoğlu Köyü)",
      "Dere Mah (ödemişli Köyü)",
      "Güllühüyük Köyü",
      "Hamzabey Köyü",
      "Hatunkara Mah (güllühüyük Köyü)",
      "Kilimli Köyü",
      "Küçükabdiuşağı Köyü",
      "Ödemişli Köyü",
      "Ömeruşağı Köyü",
      "Solakuşağı Köyü"
    ],
    "Akpınar": [
      "Alipaşa Mah",
      "Cumhuriyet Mah",
      "Hacı Hüseyin Efendi Mah",
      "Kaleyazı Mah",
      "Şirinevler Mah",
      "Yenidoğan Mah",
      "Alişar Köyü",
      "Bahçelievler Mah (büyükabdiuşağı Köyü)",
      "Berecik Mah (hanyerisarıkaya Köyü)",
      "Boyalık Köyü",
      "Büyük Dere Mezrası Mah (alişar Köyü)",
      "Cumhuriyet Mah (aşağıhomurlu Köyü)",
      "Çalıburnu Köyü",
      "Çayözü Mah (çayözü Köyü)",
      "Çebişler Köyü",
      "Çelebiuşağı Köyü",
      "Çiftlikmehmetağa Köyü",
      "Çiftliksarıkaya Köyü",
      "Demirci Köyü",
      "Deveci Köyü",
      "Doğancı 2 Mah (hacımirza Köyü)",
      "Doğancı Mah (hacımirza Köyü)",
      "Durmuşlu Köyü",
      "Eldeleklidemirel Köyü",
      "Eldelekliortaoba Köyü",
      "Eşrefli Köyü",
      "Fatih Mah (büyükabdiuşağı Köyü)",
      "Gülveren Köyü",
      "Hacıselimli Köyü",
      "Hanyerisarıkaya Köyü",
      "Himmetuşağı Köyü",
      "Karaova Köyü",
      "Kelismailuşağı Köyü",
      "Kırdök Mah (çayözü Köyü)",
      "Kızılay Mah (köşker Köyü)",
      "Pekmezci Köyü",
      "Seymenli Mah (aşağıhomurlu Köyü)",
      "Sofrazlı Köyü",
      "Şehitler Mah (büyükabdiuşağı Köyü)",
      "Ulukışla Mah (aşağıhomurlu Köyü)",
      "Yayla Mazrası Mah (alişar Köyü)",
      "Yeni Mah (köşker Köyü)",
      "Yüzbaşıoğlu Mah (köşker Köyü)"
    ],
    "Boztepe": [
      "Bağbaşı Mah",
      "Orta Mah",
      "Yeni Mah",
      "Bahçelievler Mah (karacaören Köyü)",
      "Büyükkışla Köyü",
      "Çamalak Köyü",
      "Çevirme Mah (çevirme Köyü)",
      "Çiğdeli Köyü",
      "Çimeli Köyü",
      "Eskidoğanlı Köyü",
      "Harmanaltı Köyü",
      "Hatunoğlu Köyü",
      "Hatunoğlu Yayla Mah (hatunoğlu Köyü)",
      "Hüseyinli Köyü",
      "Külhüyük Köyü",
      "Malya T.i.m. Mah (yenidoğanlı Köyü)",
      "Pınarbaşı Mah (karacaören Köyü)",
      "Şababzade Çiftliği Mah (çevirme Köyü)",
      "Uzunpınar Köyü",
      "Üçkuyu Köyü",
      "Yeni Doğanlı Mah (yenidoğanlı Köyü)",
      "Yeşilyurt Mah (karacaören Köyü)"
    ],
    "Çiçekdağı": [
      "Bağlarbaşı Mah",
      "Boyalık Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Osman Şevki Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Bahçelievler Mah (köseli Beldesi)",
      "Cumhuriyet Mah (köseli Beldesi)",
      "Çiçek Mah (köseli Beldesi)",
      "Çiftlik Mah (köseli Beldesi)",
      "Devreceli Mah (köseli Beldesi)",
      "A Grubu Mah (hacıhasanlı Köyü)",
      "Acıköy Köyü",
      "Akbıyıklı Köyü",
      "Alahacılı Köyü",
      "Alanköy Köyü",
      "Alimpınar Köyü",
      "Armutlu Köyü",
      "Aşağıhacıahmetli Köyü",
      "B Grubu Mah (alanköy Köyü)",
      "B Grubu Mah (alimpınar Köyü)",
      "B Grubu Mah (gölcük Köyü)",
      "B Grubu Mah (hacıhasanlı Köyü)",
      "Bağlarbaşı Mah (boğazevci Köyü)",
      "Bahçepınar Köyü",
      "Baraklı Köyü",
      "Beşikli Köyü",
      "Bozlar Köyü",
      "Bozlarevci Mah (bozlar Köyü)",
      "Büyükteflek Köyü",
      "Camili Kümesi Mah (beşikli Köyü)",
      "Cenderözü Mah (hacıhasanlı Köyü)",
      "Çanakpınar Köyü",
      "Çepni Köyü",
      "Çiçekli Köyü",
      "Çiftlik İşletmesi Mah (tatbekirli Köyü)",
      "Çopraşık Köyü",
      "Çubuktarla Köyü",
      "Demirli Köyü",
      "Doğankaş Köyü",
      "Gölcük Köyü",
      "Güzeltepe Mah (boğazevci Köyü)",
      "Hacıduraklı Köyü",
      "Hacıoğlu Köyü",
      "Halaçlı Köyü",
      "Harmanpınar Köyü",
      "Haydarlı Köyü",
      "Hüseyinli Çiftliği Mah (hacıhasanlı Köyü)",
      "Işıklar Kümesi Mah (beşikli Köyü)",
      "İbikli Köyü",
      "İğdeliöz Mah (hacıhasanlı Köyü)",
      "Kabaklı Köyü",
      "Kaleevci Köyü",
      "Kaletepe Mah (boğazevci Köyü)",
      "Karakızalanı Mah (armutlu Köyü)",
      "Karakuyu Kümesi Mah (aşağıhacıahmetli Köyü)",
      "Karaosman Kümesi Mah (beşikli Köyü)",
      "Kavaklıöz Köyü",
      "Kırdök Köyü",
      "Kızılcalı Köyü",
      "Konurkale Köyü",
      "Küçükteflek Köyü",
      "Küme 2 Mah (aşağıhacıahmetli Köyü)",
      "Küme 3 Mah (aşağıhacıahmetli Köyü)",
      "Mahmutlu Köyü",
      "Mezra Mah (mahmutlu Köyü)",
      "Ortahacıahmetli Köyü",
      "Pöhrenk Köyü",
      "Safalı Köyü",
      "Şahinoğlu Köyü",
      "Tatbekirli Köyü",
      "Tepecik Köyü",
      "Topalali Köyü",
      "Yalnızağaç Köyü",
      "Yeni Mah (boğazevci Köyü)",
      "Yukarıhacıahmetli Köyü"
    ],
    "Kaman": [
      "Bahçelievler Mah",
      "Bahçelievler Mah (çağırkan Köyü)",
      "Cuma Mah",
      "Çiftlikli Mah",
      "Darıözü Mah",
      "Fatih Mah (çağırkan Köyü)",
      "Gaffar Mah",
      "Hacıpınar Mah",
      "Müderris Mah",
      "Orta Mah",
      "Orta Mah (çağırkan Köyü)",
      "Orta Mah (savcılıbüyükoba Köyü)",
      "Sarıuşağı Mah",
      "Sırbeli Mah (savcılıbüyükoba Köyü)",
      "Yeni Mah",
      "Yeni Mah (çağırkan Köyü)",
      "Yeni Mah (savcılıbüyükoba Köyü)",
      "Ziyarettepe Mah",
      "Bahçelievler Mah (kurancılı Beldesi)",
      "Cumhuriyet Mah (kurancılı Beldesi)",
      "Orta Mah (kurancılı Beldesi)",
      "Yeni Mah (kurancılı Beldesi)",
      "Ağapınar Köyü",
      "Ahievran Mah (demirli Köyü)",
      "Aydınlar Köyü",
      "Bağbaşı Mah (isahocalı Köyü)",
      "Bayındır Köyü",
      "Bayramözü Köyü",
      "Benzer Köyü",
      "Büğüz Köyü",
      "Cumhuriyet Mah (başköy Köyü)",
      "Cumhuriyet Mah (hamit Köyü)",
      "Cumhuriyet Mah (isahocalı Köyü)",
      "Cumhuriyet Mah (kargınyenice Köyü)",
      "Cumhuriyet Mah (ömerhacılı Köyü)",
      "Cumhuriyet Mah (yelek Köyü)",
      "Çadırlı Hacıbayram Köyü",
      "Çadırlı Körmehmet Köyü",
      "Çamsarı Mah (hamit Köyü)",
      "Darıözü Köyü",
      "Değirmenözü Köyü",
      "Esentepe Köyü",
      "Fakılı Köyü",
      "Fevzi Çakmak Mah (başköy Köyü)",
      "Gökeşme Köyü",
      "Gültepe Köyü",
      "Hicret Mah (demirli Köyü)",
      "Hirfanlı Barajı Mah (hirfanlı Köyü)",
      "Hirfanlı Köyü",
      "Hürriyet Mah (kargınyenice Köyü)",
      "İbrişim Köyü",
      "İkizler Köyü",
      "İmancı Köyü",
      "İstiklal Mah (yelek Köyü)",
      "Kale Köyü",
      "Karahabalı Köyü",
      "Karakaya Köyü",
      "Karakütük Mah (mollaosmanlar Köyü)",
      "Karkınkızıközü Köyü",
      "Karkınmeşe Köyü",
      "Karkınselimağa Köyü",
      "Kayabaşı Mah (ömerhacılı Köyü)",
      "Kekilliali Köyü",
      "Melemez Mah (ömerkahya Köyü)",
      "Meşeköy Köyü",
      "Mevlana Mah (demirli Köyü)",
      "Mollaosmanlar Köyü",
      "Orta Mah (ömerhacılı Köyü)",
      "Ömerkahya Köyü",
      "Sarıömerli Köyü",
      "Savcılıbağbaşı Köyü",
      "Savcılıebeyit Köyü",
      "Savcılıkışla Köyü",
      "Savcılıkurutlu Köyü",
      "Savcılımeryemkaşı Köyü",
      "Şehit Fedakar Erol Mah (kargınyenice Köyü)",
      "Tatık Köyü",
      "Tepeköy Köyü",
      "Yağmurlu Sarıuşağı Köyü",
      "Yazıyolu Köyü",
      "Yeni Mah (hamit Köyü)",
      "Yeni Mah (isahocalı Köyü)",
      "Yeni Mah (kargınyenice Köyü)",
      "Yeni Mah (ömerhacılı Köyü)",
      "Yeni Mah (yelek Köyü)",
      "Yeniköy Köyü",
      "Yeniyapan Köyü",
      "Yukarı Çiftlik Köyü",
      "Yunus Emre Mah (demirli Köyü)"
    ],
    "Merkez": [
      "Ahievran Mah",
      "Aşıkpaşa Mah",
      "Bağbaşı Mah",
      "Bahçelievler Mah",
      "Çukurçayır Mah",
      "Gölhisar Mah",
      "Güldiken Mah",
      "Güldikenosb Mah",
      "Kayabaşı Mah",
      "Kervansaray Mah",
      "Kındam Mah",
      "Kuşdilli Mah",
      "Medrese Mah",
      "Nasuhdede Mah",
      "Yenice Mah",
      "Akçaağıl Köyü",
      "Aşağı Köy Mah (saraycık Köyü)",
      "Bağderesi Mah (kortulu Köyü)",
      "Boğaziçi Mah (karahıdır Köyü)",
      "Boruklu Mah (karalar Köyü)",
      "Büyükcamii Mah (çayağzı Köyü)",
      "Cumhuriyet Mah (ulupınar Köyü)",
      "Çadırlıhacıyusuf Köyü",
      "Çamlıbel Mah (karahıdır Köyü)",
      "Çuğun Köyü",
      "Davulağıl Mah (sıdıklıbüyükoba Köyü)",
      "Dedeli Köyü",
      "Değirmenkaşı Köyü",
      "Dulkadirlikaraisa Köyü",
      "Ecikağıl Köyü",
      "Göbekkaya Mah (yağmurlukale Köyü)",
      "Göllü Bucak Merkezi Köyü",
      "Güllütarla Mah (yağmurlubüyükoba Köyü)",
      "Güzler Köyü",
      "Hashüyük Köyü",
      "Homurlu Beşler Köyü",
      "Homurlu Üçler Köyü",
      "Hürriyet Mah (toklümen Köyü)",
      "Ilıca Mah (toklümen Köyü)",
      "İnli Murat Mah (dulkadirli Köyü)",
      "İstiklal Mah (ulupınar Köyü)",
      "Kalankaldı Köyü",
      "Karaboğaz Köyü",
      "Karaduraklı Köyü",
      "Karalar Köyü",
      "Karasüleyman Çiftliği Mah (çuğun Köyü)",
      "Karıncalı Köyü",
      "Karşıyaka Mah (dulkadirli Köyü)",
      "Kartalkaya Köyü",
      "Kayabaşı Mah (toklümen Köyü)",
      "Kesikköprü Köyü",
      "Kırkpınar Köyü",
      "Killik Mah (sıdıklıbüyükoba Köyü)",
      "Kocabey Köyü",
      "Kortulu Köyü",
      "Körpınar Köyü",
      "Kulpak Mah (sıdıklıküçükoba Köyü)",
      "Kurtbeliyeniyapan Köyü",
      "Kuruağıl Köyü",
      "Kuytuluk Mah (yağmurlubüyükoba Köyü)",
      "Saraycık Köyü",
      "Sevdiğin Köyü",
      "Seyrekköy Köyü",
      "Sıdıklıbüyükoba Köyü",
      "Sıdıklıdarboğaz Köyü",
      "Sıdıklıikizağıl Köyü",
      "Sıdıklıkumarkaç Köyü",
      "Sıdıklıküçükboğaz Köyü",
      "Sıdıklıküçükoba Köyü",
      "Sıdıklıortaoba Köyü",
      "Şeker Fabrikası Mah (akçaağıl Köyü)",
      "Taburoğlu Köyü",
      "Tatarilyaskışla Köyü",
      "Tatarilyasyayla Köyü",
      "Tepesidelik Köyü",
      "Terziali Mah (çayağzı Köyü)",
      "Tosunburnu Köyü",
      "Uzunaliuşağı Köyü",
      "Yağmurluarmutlu Köyü",
      "Yağmurlubüyükoba Köyü",
      "Yağmurlukale Köyü",
      "Yağmurlusayobası Köyü",
      "Yarımkale Mah (dulkadirli Köyü)",
      "Yayla Mah (karahıdır Köyü)",
      "Yeni Mah (çayağzı Köyü)",
      "Yeraltı Şehri Mah (dulkadirli Köyü)",
      "Yeşilli Köyü",
      "Yeşiloba Köyü",
      "Yukarı Homurlu Köyü",
      "Yunus Emre Mah (ulupınar Köyü)",
      "Helvacılar Mah (özbağ Beldesi)",
      "Karşıyaka Mah (özbağ Beldesi)",
      "Kışlapınar Mah (özbağ Beldesi)",
      "Kızılca Mah (özbağ Beldesi)",
      "Örcün Mah (özbağ Beldesi)",
      "Saraylar Mah (özbağ Beldesi)",
      "Yeni Mah (özbağ Beldesi)"
    ],
    "Mucur": [
      "Aksaklı Köyü",
      "Altınyazı Köyü",
      "Asma Mah (asmakaradam Köyü)",
      "Asmakaradam Köyü",
      "Aşagı Rahmalar Mah (rahmalar Köyü)",
      "Avcıköy Köyü",
      "Aydoğmuş Köyü",
      "Babur Köyü",
      "Bahçecik Mah (dalakçı Köyü)",
      "Bahçelievler Mah (kurugöl Köyü)",
      "Bayramuşağı Köyü",
      "Bazlamaç Köyü",
      "Budak Köyü",
      "Büyükkayapa Köyü",
      "Cavlaklar Mah (yeniköy Köyü)",
      "Çatalarkaç Köyü",
      "Dağçiftliğiköyü Köyü",
      "Dalakçı Köyü",
      "Devepınarı Köyü",
      "Esentepe Mah (kurugöl Köyü)",
      "Geycek Köyü",
      "Gümüşkümbet Köyü",
      "Güzyurdu Köyü",
      "İnaç Köyü",
      "Karaarkaç Köyü",
      "Karacalı Köyü",
      "Karadam Mah (asmakaradam Köyü)",
      "Karakuyu Köyü",
      "Karkın Köyü",
      "Karşıyaka Mah (kurugöl Köyü)",
      "Kepez Köyü",
      "Kılıçlı Köyü",
      "Kıran Köyü",
      "Kızılağıl Köyü",
      "Kızıldağyeniyapan Köyü",
      "Kuşaklı Köyü",
      "Küçük Köpekli Mah (dalakçı Köyü)",
      "Küçükburnağıl Köyü",
      "Küçükkavak Köyü",
      "Küçükkayapa Köyü",
      "Medetsiz Köyü",
      "Obruk Köyü",
      "Orta Mah (kurugöl Köyü)",
      "Palangıç Köyü",
      "Pınarkaya Köyü",
      "Rışvan Mah (karakuyu Köyü)",
      "Seyfe Köyü",
      "Susuz Köyü",
      "Türktur Mantar İşletmesi Mah (asmakaradam Köyü)",
      "Yazıkınık Köyü",
      "Yeğenağa Köyü",
      "Yeni Mah (kurugöl Köyü)",
      "Yeniköy Köyü",
      "Yeniyayla Mah (seyfe Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Rahmalar Mah (rahmalar Köyü)",
      "Yürücek Köyü",
      "Acıöz Mah",
      "Hamidiye Mah",
      "Karşıyaka Mah",
      "Osmangazi Mah",
      "Solaklı Mah",
      "Şatıroğlu Mah",
      "Yenice Mah"
    ]
  },
  "Kocaeli": {
    "Başiskele": [
      "Havuzlubahçe Mah",
      "Kılıçarslan Mah",
      "Şehitekrem Mah",
      "Yeşilkent Mah",
      "Aksığın Mah",
      "Altınkent Mah",
      "Barbaros Mah",
      "Camidüzü Mah",
      "Doğantepe Mah",
      "Döngel Mah",
      "Kazandere Mah",
      "Sahil Mah",
      "Serindere Mah",
      "Servetiye Cami Mah",
      "Servetiye Karşı Mah",
      "Tepecik Mah",
      "Karadenizliler Mah",
      "Kullar Tepecik Mah",
      "Kullar Yakacık Mah",
      "Mahmutpaşa Mah",
      "Mehmetağa Mah",
      "Ovacık Mah",
      "Vezirçiftliği Mah",
      "Yaylacık Mah",
      "Damlar Mah",
      "Karşıyaka Mah",
      "Körfez Mah",
      "Seymen Mah",
      "Atakent Mah",
      "Sepetlipınar Mah",
      "Sepetlipınar Sb Mah",
      "Yeniköy Merkez Mah",
      "Aydınkent Mah",
      "Fatih Mah",
      "Paşadağ Mah",
      "Serdar Mah",
      "Yeşilyurt Mah",
      "Yuvacık Yakacık Mah"
    ],
    "Çayırova": [
      "Akse Mah",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Çayırova Mah",
      "Emek Mah",
      "Gebze Osb2 Mah",
      "İnönü Mah",
      "Özgürlük Mah",
      "Şekerpınar Mah",
      "Tosb Otomotiv  Mah (osb Mah)",
      "Yeni Mah"
    ],
    "Darıca": [
      "Abdi İpekçi Mah",
      "Bağlarbaşı Mah",
      "Bayramoğlu Mah",
      "Cami Mah",
      "Emek Mah",
      "Fevziçakmak Mah",
      "Kazımkarabekir Mah",
      "Nenehatun Mah",
      "Osmangazi Mah",
      "Piri Reis Mah",
      "Sırasöğütler Mah",
      "Yalı Mah",
      "Yeni Mah",
      "Zincirlikuyu Mah"
    ],
    "Derince": [
      "Çavuşlu Mah",
      "Çenedağ Mah",
      "Çınarlı Mah",
      "Deniz Mah",
      "Dumlupınar Mah",
      "Fatih Sultan Mah",
      "Geredeli Mah",
      "İbnisina Mah",
      "Karagöllü Mah",
      "Kaşıkçı Mah",
      "Mersincik Mah",
      "Sırrıpaşa Mah",
      "Tahtalı Mah",
      "Terziler Mah",
      "Toylar Mah",
      "Yavuz Sultan Mah",
      "Yenikent Mah"
    ],
    "Dilovası": [
      "Cumhuriyet Mah",
      "Çerkeşli Mah",
      "Çerkeşliosb Mah",
      "Demirciler Mah",
      "Demircilerosb Mah",
      "Diliskelesi Mah",
      "Dilovasıosb Mah",
      "Fatih Mah",
      "Kayapınar Mah",
      "Kocaeli-gebze Kömürcüler Osb Mah",
      "Köseler Mah",
      "Mimar Sinan Mah",
      "Organize Sanayi Bölgesi Mah",
      "Orhangazi Mah",
      "Tavşancıl Mah",
      "Tepecik Mah",
      "Turgut Özal Mah"
    ],
    "Gebze": [
      "Adem Yavuz Mah",
      "Ahatlı Mah",
      "Arapçeşme Mah",
      "Balçık Mah",
      "Barış Mah",
      "Barış Sb Mah",
      "Beylikbağı Mah",
      "Cumaköy Mah",
      "Cumhuriyet Mah",
      "Denizli Mah",
      "Duraklı Mah",
      "Elbizli Mah",
      "Eskihisar Mah",
      "Gaziler Mah",
      "Gebze Dilovası Osb Mah",
      "Gebze Osb Mah",
      "Güzeller Mah",
      "Hacıhalil Mah",
      "Hatipler Mah",
      "Hürriyet Mah",
      "İnönü Mah",
      "İnönü Mah Gebze Plastikçiler Osb Mah",
      "İnönü Mah.gebze Güzeller Osb Mah",
      "İstasyon Mah",
      "Kadıllı Mah",
      "Kargalı Mah",
      "Kirazpınar Mah",
      "Köşklü Çeşme Mah",
      "Mevlana Mah",
      "Mimar Sinan Mah",
      "Mollafenari Mah",
      "Muallimköy Mah",
      "Mudarlı Mah",
      "Mustafapaşa Mah",
      "Osman Yılmaz Mah",
      "Ovacık Mah",
      "Pelitli Mah",
      "Sultan Orhan Mah",
      "Tatlıkuyu Mah",
      "Tavşanlı Mah",
      "Tepemanayır Mah",
      "Ulus Mah",
      "Yağcılar Mah",
      "Yavuz Selim Mah",
      "Yenikent Mah"
    ],
    "Gölcük": [
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Değirmendere Merkez Mah",
      "Değirmendere Yalı Mah",
      "Halıdere Yalı Mah",
      "Halıdere Yeni Mah",
      "Körfez Mah",
      "Topçular Mah",
      "Ulaşlı Yalı Mah",
      "Ulaşlı Yavuz Sultan Selim Mah",
      "Yukarı Mah",
      "Yüzbaşılar Mah",
      "Ayvazpınarı Mah",
      "Çiftlik Mah",
      "Deniz Evler Mah",
      "Donanma Mah",
      "Dumlupınar Mah",
      "Düzağaç Mah",
      "Eskiferhadiye Mah",
      "Ferhadiye Mah",
      "Hamidiye Mah",
      "Hasaneyn Mah",
      "Hisareyn Merkez Mah",
      "İcadiye Mah",
      "İhsaniye Merkez Mah",
      "İpek Yolu Mah",
      "İrşadiye Mah",
      "Karaköprü Mah",
      "Kavaklı Mah",
      "Lütfiye Mah",
      "Mamuriye Mah",
      "Merkez Mah",
      "Mesruriye Mah",
      "Nimetiye Mah",
      "Nüzhetiye Mah",
      "Örcün Mah",
      "Panayır Mah",
      "Piyalepaşa Mah",
      "Saraylı Mah",
      "Selimiye Mah",
      "Siyretiye Mah",
      "Sofular Mah",
      "Şehitler Mah",
      "Şevketiye Mah",
      "Şirinköy Mah",
      "Ümmiye Mah",
      "Yazlık Merkez Mah",
      "Yazlık Yeni Mah",
      "Yeni Mah",
      "Yunus Emre Mah"
    ],
    "İzmit": [
      "Akarca Mah",
      "Akmeşe Atatürk Mah",
      "Akmeşe Cumhuriyet Mah",
      "Alikahya Atatürk Mah",
      "Alikahya Cumhuriyet Mah",
      "Alikahya Fatih Mah",
      "Alikahya Merkez Mah",
      "Alikahya Osb Mah",
      "Atatürk  Mah (osb Mah)",
      "Fevzi Çakmak Mah",
      "Karadenizliler Mah",
      "Cedit Mah",
      "Çukurbağ Mah",
      "Ömerağa Mah",
      "Terzibayırı Mah",
      "Topçular Mah",
      "28 Haziran Mah",
      "Ayazma Mah",
      "Bekirdere Mah",
      "Erenler Mah",
      "Gündoğdu Mah",
      "Malta Mah",
      "Tavşantepe Mah",
      "Tepeköy Mah",
      "Yeşilova Mah",
      "Akpınar Mah",
      "Ambarcı Mah",
      "Arızlı Mah",
      "Arpalıkihsaniye Mah",
      "Bağlıca Mah",
      "Balören Mah",
      "Bayraktar Mah",
      "Biberoğlu Mah",
      "Böğürgen Mah",
      "Bulduk Mah",
      "Çağırgan Mah",
      "Çavuşoğlu Mah",
      "Çayırköy Mah",
      "Çubuklubala Mah",
      "Çubukluosmaniye Mah",
      "Dağköy Mah",
      "Durhasan Mah",
      "Düğmeciler Mah",
      "Emirhan Mah",
      "Eseler Mah",
      "Fethiye Mah",
      "Gedikli Mah",
      "Gökçeören Mah",
      "Gülbahçe Kadriye Mah",
      "Güvercinlik Mah",
      "Hakaniye Mah",
      "Hasancıklar Mah",
      "Kabaoğlu Mah",
      "Karaabdülbaki Mah",
      "Kaynarca Mah",
      "Kısalar Mah",
      "Kozluca Mah",
      "Kulfallı Mah",
      "Kulmahmut Mah",
      "Kurtdere Mah",
      "Mecidiye Mah",
      "Nebihoca Mah",
      "Orhaniye Mah",
      "Ortaburun Mah",
      "Sapakpınar Mah",
      "Sarışeyh Mah",
      "Sekbanlı Mah",
      "Sepetçi Mah",
      "Sultaniye Mah",
      "Süleymaniye Mah",
      "Süverler Mah",
      "Şahinler Mah",
      "Yassıbağ Mah",
      "Yenice Mah",
      "Zeytinburnu Mah",
      "Karabaş Mah",
      "Körfez Mah",
      "Sanayi Mah",
      "Akçakoca Mah",
      "Hacıhasan Mah",
      "Hacıhızır Mah",
      "Kemalpaşa Mah",
      "Kozluk Mah",
      "Orhan Mah",
      "Tepecik Mah",
      "Turgut Mah",
      "Veliahmet Mah",
      "Cumhuriyet Mah",
      "Doğan Mah",
      "Fatih Mah",
      "Gültepe Mah",
      "Hatipköy Mah",
      "Kocatepe Mah",
      "Kuruçeşme Fatih Mah",
      "Serdar Mah",
      "Şirintepe Mah",
      "Tüysüzler Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Zabıtan Mah",
      "Kadıköy Mah",
      "M.alipaşa Mah",
      "Yahyakaptan Mah",
      "Yenişehir Mah"
    ],
    "Kandıra": [
      "Ağaçağıl Mah",
      "Ahmethacılar Mah",
      "Akbal Mah",
      "Akçabeyli Mah",
      "Akçakese Mah",
      "Akçaova Mah",
      "Akdurak Mah",
      "Akıncı Mah",
      "Alaybey Mah",
      "Alefli Mah",
      "Antaplı Mah",
      "Avdan Mah",
      "Aydınlık Mah",
      "Babaköy Mah",
      "Babalı Mah",
      "Bağırganlı Mah",
      "Balaban Mah",
      "Balcı Mah",
      "Ballar Mah",
      "Beyce Mah",
      "Beylerbeyi Mah",
      "Bolu Mah",
      "Bozburun Mah",
      "Cebeci Mah",
      "Çakırcaali Mah",
      "Çakmaklar Mah",
      "Çalca Mah",
      "Çalköy Mah",
      "Çalyer Mah",
      "Çamkonak Mah",
      "Çarşı Mah",
      "Çerçili Mah",
      "Dalca Mah",
      "Deliveli Mah",
      "Doğancılı Mah",
      "Döngelli Mah",
      "Duraklı Mah",
      "Eğercili Mah",
      "Elmacık Mah",
      "Esentepe Mah",
      "Ferizli Mah",
      "Gebeşler Mah",
      "Goncaaydın Mah",
      "Hacılar Mah",
      "Hacımazlı Mah",
      "Hacışeyh Mah",
      "Hediyeli Mah",
      "Hıdırlar Mah",
      "Hüdaverdiler Mah",
      "İncecik Mah",
      "Kabaağaç Mah",
      "Kanatlar Mah",
      "Karaağaç Mah",
      "Karadivan Mah",
      "Karlı Mah",
      "Kaymaz Erikli Mah",
      "Kaymaz Mah",
      "Kefken Mah",
      "Kerpe Mah",
      "Kırkarmut Mah",
      "Kızılcapınar Mah",
      "Kocakaymas Mah",
      "Kubuzcu Mah",
      "Kurtyeri Mah",
      "Lokmanlı Mah",
      "Mancarlar Mah",
      "Merkez Erikli Mah",
      "Mülküşehsuvar Mah",
      "Nasuhlar Mah",
      "Orhan Mah",
      "Ömerli Mah",
      "Özbey Mah",
      "Pelitpınarı Mah",
      "Pınardüzü Mah",
      "Pınarlı Mah",
      "Pirceler Mah",
      "Safalı Mah",
      "Sarıahmetler Mah",
      "Sarıcaali Mah",
      "Sarıgazi Mah",
      "Sarnıçlar Mah",
      "Selametli Mah",
      "Selimköy Mah",
      "Sepetçi Mah",
      "Seyitaliler Mah",
      "Sinanlıbilallı Mah",
      "Sucuali Mah",
      "Süllü Mah",
      "Şerefsungur Mah",
      "Tatarahmet Mah",
      "Teksen Mah",
      "Terziler Mah",
      "Topluca Mah",
      "Üğümce Mah",
      "Yağcılar Mah",
      "Yusufça Mah"
    ],
    "Karamürsel": [
      "4 Temmuz Mah",
      "Akçat Mah",
      "Akpınar Mah",
      "Avcıköy Mah",
      "Çamçukur Mah",
      "Çamdibi Mah",
      "Dereköy Mah",
      "Ereğli Mah",
      "Fulacık Mah",
      "Hayriye Mah",
      "İhsaniye Mah",
      "İnebeyli Mah",
      "Kadriye Mah",
      "Karaahmetli Mah",
      "Karapınar Mah",
      "Kayacık Mah",
      "Kızderbent Mah",
      "Oluklu Mah",
      "Osmaniye Mah",
      "Pazarköy Mah",
      "Safiye Mah",
      "Semetler Mah",
      "Senaiye Mah",
      "Suludere Mah",
      "Tahtalı Mah",
      "Tepeköy Mah",
      "Yalakdere Mah"
    ],
    "Kartepe": [
      "Arslanbey Mah",
      "Arslanbey Osb Mah",
      "Ataşehir Mah",
      "Rahmiye Mah",
      "Sarımeşe Mah",
      "Şevkatiye Mah",
      "Acısu Mah",
      "Balaban Mah",
      "Derbent Mah",
      "Eşmeahmediye Mah",
      "Havluburun Mah",
      "Karatepe Mah",
      "Ketenciler Mah",
      "Nusretiye Mah",
      "Pazarçayırı Mah",
      "Serinlik Mah",
      "Sultaniye Mah",
      "Şirinsulhiye Mah",
      "Dumlupınar Mah",
      "Fatih Sultan Mehmet Mah",
      "İstasyon Mah",
      "Köseköy Mah",
      "Maşukiye Mah",
      "Çepni Mah",
      "Suadiye Mah",
      "Ataevler Mah",
      "Emekevler Mah",
      "Ertuğrul Gazi Mah",
      "Uzunbey Mah",
      "Uzunçiftlik Mah",
      "Eşme Mah",
      "İbrikdere Mah",
      "Uzuntarla Mah"
    ],
    "Körfez": [
      "17 Ağustos Mah",
      "Agah Ateş Mah",
      "Cumhuriyet Mah",
      "Hacı Akif Mah",
      "Kışladüzü Mah",
      "Şirinyalı Mah",
      "Yukarı Hereke Mah",
      "Alihocalar Mah",
      "Atalar Mah",
      "Barbaros Mah",
      "Belen Mah",
      "Cuma Mah",
      "Çamlıtepe Mah",
      "Çıraklı Mah",
      "Dere Mah",
      "Dikenli Mah",
      "Elmacık Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Güney Mah",
      "Hacı Osman Mah",
      "Himmetli Mah",
      "İlimtepe Mah",
      "Kalburcu Mah",
      "Karayakuplu Mah",
      "Kirazlıyalı Mah",
      "Kutluca Mah",
      "Kuzey Mah",
      "Mimar Sinan Mah",
      "Naip Mah",
      "Osmanlı Mah",
      "Sevindikli Mah",
      "Sipahiler Mah",
      "Şemsettin Mah",
      "Yavuz Sultan Selim Mah",
      "Yeniyalı Mah"
    ]
  },
  "Konya": {
    "Ahırlı": [
      "Aliçerçi Mah",
      "Bademli Mah",
      "Balıklava Mah",
      "Büyüköz Mah",
      "Çiftlik Mah",
      "Çukurbucak Mah",
      "Erdoğan Mah",
      "Hamzalar Mah",
      "Hengeme Mah",
      "Karacakuyu Mah",
      "Kayacık Mah",
      "Kuruçay Mah",
      "Küçüköz Mah",
      "Merkez Mah",
      "Akkise Mah"
    ],
    "Akören": [
      "Ağalar Mah",
      "Ahmediye Mah",
      "Alanköy Mah",
      "Avdan Mah",
      "Belkuyu Mah",
      "Çatören Mah",
      "Dutlu Mah",
      "Hacılar Mah",
      "Karahüyük Mah",
      "Kayasu Mah",
      "Orhaniye Mah",
      "Süleymaniye Mah",
      "Tülce Mah",
      "Yeni Mah"
    ],
    "Akşehir": [
      "Alanyurt Mah",
      "Altuntaş Mah",
      "Bozlağan Mah",
      "Cankurtaran Mah",
      "Çakıllar Mah",
      "Çamlı Mah",
      "Çimendere Mah",
      "Değirmenköy Mah",
      "Doğrugöz Mah",
      "Engili Mah",
      "Gedil Mah",
      "Gölçayır Mah",
      "Gözpınarı Mah",
      "Ilıcak Mah",
      "Karabulut Mah",
      "Karahüyük Mah",
      "Ortaca Mah",
      "Ortaköy Mah",
      "Reis Mah",
      "Saray Mah",
      "Savaş Mah",
      "Sorkun Mah",
      "Söğütlü Mah",
      "Tekkeköy Mah",
      "Tipiköy Mah",
      "Ulupınar Mah",
      "Üçhüyük Mah",
      "Yaşarlar Mah",
      "Yaylabelen Mah",
      "Yazla Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Çay Mah",
      "Gazi Mah",
      "Kızılca Mah",
      "Kileci Mah",
      "Kuruçay Mah",
      "Seyran Mah",
      "Adsız Mah",
      "Ahicelal Mah",
      "Altunkalem Mah",
      "Anıt Mah",
      "Atakent Mah",
      "Çimenli Mah",
      "Eskikale Mah",
      "İstasyon Mah",
      "Kozağaç Mah",
      "Kuşçu Mah",
      "Meydan Mah",
      "Nasreddin Hoca Mah",
      "Selçuk Mah",
      "Tipi Mah",
      "Yarenler Mah",
      "Yeni Mah",
      "Yıldırım Bayezid Mah"
    ],
    "Altınekin": [
      "Akçaşar Mah",
      "Akıncılar Mah",
      "Akköy Mah",
      "Ayışığı Mah",
      "Borukkuyu Mah",
      "Dedeler Mah",
      "Hacınuman Mah",
      "Kale Mah",
      "Karakaya Mah",
      "Koçaş Mah",
      "Koçyaka Mah",
      "Mantar Mah",
      "Oğuzeli Mah",
      "Ölmez Mah",
      "Sarnıç Mah",
      "Topraklık Mah",
      "Yeni Ölmez Mah",
      "Yenice Mah",
      "Yenikuyu Mah",
      "Yeniyayla Mah"
    ],
    "Beyşehir": [
      "Adaköy Mah",
      "Ağılönü Mah",
      "Akburun Mah",
      "Akçabelen Mah",
      "Avdancık Mah",
      "Bademli Mah",
      "Başgöze Mah",
      "Bayat Mah",
      "Bayavşar Mah",
      "Bayındır Mah",
      "Bekdemir Mah",
      "Çiçekler Mah",
      "Çiftlik Mah",
      "Çivril Mah",
      "Çukurağıl Mah",
      "Damlapınar Mah",
      "Doğanbey Mah",
      "Doğancık Mah",
      "Dumanlı Mah",
      "Eğirler Mah",
      "Emen Mah",
      "Esence Mah",
      "Eylikler Mah",
      "Fasıllar Mah",
      "Göçü Mah",
      "Gökçekuyu Mah",
      "Gökçimen Mah",
      "Gölkaşı Mah",
      "Gölyaka Mah",
      "Gönen Mah",
      "Gündoğdu Mah",
      "Huğlu Mah",
      "Hüseyinler Mah",
      "İsaköy Mah",
      "Karaali Mah",
      "Karabayat Mah",
      "Karadiken Mah",
      "Karahisar Mah",
      "Kayabaşı Mah",
      "Kurucuova Mah",
      "Kuşluca Mah",
      "Küçükavşar Mah",
      "Mesutlar Mah",
      "Sadıkhacı Mah",
      "Sarıköy Mah",
      "Sevindik Mah",
      "Şamlar Mah",
      "Üçpınar Mah",
      "Üstünler Mah",
      "Üzümlü Mah",
      "Yazyurdu Mah",
      "Yenidoğan Mah",
      "Yeşildağ Mah",
      "Yukarıesence Mah",
      "Yunuslar Mah",
      "Avşar Mah",
      "Bahçelievler Mah",
      "Beytepe Mah",
      "Dalyan Mah",
      "Esentepe Mah",
      "Evsat Mah",
      "Hacıakif Mah",
      "Hacıarmağan Mah",
      "Hamidiye Mah",
      "İçerişehir Mah",
      "Müftü Mah",
      "Yeni Mah"
    ],
    "Bozkır": [
      "Akçapınar Mah",
      "Armutlu Mah",
      "Arslantaş Mah",
      "Aydınkışla Mah",
      "Ayvalca Mah",
      "Bağyurdu Mah",
      "Baybağan Mah",
      "Bozdam Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Demirasaf Mah",
      "Dereiçi Mah",
      "Dereköy Mah",
      "Elmaağaç Mah",
      "Hacılar Mah",
      "Hacıyunuslar Mah",
      "Hamzalar Mah",
      "Harmanpınar Mah",
      "Hisarlık Mah",
      "Işıklar Mah",
      "Karabayır Mah",
      "Karacaardıç Mah",
      "Karacahisar Mah",
      "Karayahya Mah",
      "Kayacılar Mah",
      "Kayapınar Mah",
      "Kınık Mah",
      "Kızılçakır Mah",
      "Kildere Mah",
      "Kovanlık Mah",
      "Kozağaç Mah",
      "Kuşca Mah",
      "Kuzören Mah",
      "Küçükhisarlık Mah",
      "Pınarcık Mah",
      "Sarıoğlan Mah",
      "Sazlı Mah",
      "Soğucak Mah",
      "Sorkun Mah",
      "Söğüt Mah",
      "Tarlabaşı Mah",
      "Taşbaşı Mah",
      "Tepearası Mah",
      "Tepelice Mah",
      "Ulupınar Mah",
      "Üçpınar Mah",
      "Yalnızca Mah",
      "Yazdamı Mah",
      "Yelbeği Mah",
      "Yeniköy Mah",
      "Yolören Mah",
      "Yukarı Mah"
    ],
    "Cihanbeyli": [
      "Ağabeyli Mah",
      "Ahirigüzel Mah",
      "Beyliova Mah",
      "Böğrüdelik Mah",
      "Bulduk Mah",
      "Büyükbeşkavak Mah",
      "Çimen Mah",
      "Çöl Mah",
      "Damlakuyu Mah",
      "Gemecik Mah",
      "Gölyazı Mah",
      "Günyüzü Mah",
      "Hodoğlu Mah",
      "İnsuyu Mah",
      "Kale Mah",
      "Kandil Mah",
      "Karabağ Mah",
      "Karatepe Mah",
      "Kayı Mah",
      "Kelhasan Mah",
      "Kırkışla Mah",
      "Kocatepe Mah",
      "Korkmazlar Mah",
      "Kuşça Mah",
      "Küçükbeşkavak Mah",
      "Kütükuşağı Mah",
      "Mutlukonak Mah",
      "Pınarbaşı Mah",
      "Sağlık Mah",
      "Sığırcık Mah",
      "Taşpınar Mah",
      "Turanlar Mah",
      "Tüfekçipınar Mah",
      "Uzuncayayla Mah",
      "Üzerliktepe Mah",
      "Yapalı Mah",
      "Yeniyayla Mah",
      "Yünlükuyu Mah",
      "Zaferiye Mah",
      "Atçeken Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Göktepe Mah",
      "Karşıyaka Mah",
      "Köprübaşı Mah",
      "Yeşilöz Mah",
      "Yeniceoba Mah"
    ],
    "Çeltik": [
      "Adakasım Mah",
      "Bahçe Hisar Mah",
      "Bahçe Saray Mah",
      "Bahçelievler Mah",
      "Doğanyurt Mah",
      "Fatih Mah",
      "Gökpınar Mah",
      "Honamlı Mah",
      "İshakuşağı Mah",
      "Karşıyaka Mah",
      "Kaşören Mah",
      "Küçükhasan Mah",
      "Selçuk Mah",
      "Torunlar Mah"
    ],
    "Çumra": [
      "Bağlar Mah",
      "Bakkalbaşı Mah",
      "Baraj Mah",
      "Bardakçı Mah",
      "Cumhuriyet Mah",
      "Çaybaşı Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "İzzetbey Mah",
      "Meydan Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Abditolu Mah",
      "Adakale Mah",
      "Afşar Mah",
      "Alemdar Mah",
      "Alıssa Mah",
      "Alibeyhüyüğü Mah",
      "Apa Mah",
      "Apasaraycık Mah",
      "Arıkören Mah",
      "Avdul Mah",
      "Balçıkhisar Mah",
      "Beylerce Mah",
      "Büyükaşlama Mah",
      "Çiçekköy Mah",
      "Çukurkavak Mah",
      "Dedemoğlu Mah",
      "Dinek Mah",
      "Dineksaray Mah",
      "Dinlendik Mah",
      "Doğanlı Mah",
      "Erentepe Mah",
      "Fethiye Mah",
      "Gökhüyük Mah",
      "Güvercinlik Mah",
      "İnli Mah",
      "İstiklal Osb Mah",
      "Karkın Mah",
      "Kuzucu Mah",
      "Küçükköy Mah",
      "Okçu Mah",
      "Seçme Mah",
      "Sürgüç Mah",
      "Tahtalı Mah",
      "Taşağıl Mah",
      "Türkmencamili Mah",
      "Türkmenkarahüyük Mah",
      "Uzunkuyu Mah",
      "Üçhüyük Mah",
      "Ürünlü Mah",
      "Yenisu Mah",
      "Yörükcamili Mah",
      "İçeriçumra Mah"
    ],
    "Derbent": [
      "Arapözü Mah",
      "Camiikebir Mah",
      "Çiftliközü Mah",
      "Değiş Mah",
      "Derbenttekke Mah",
      "Güney Mah",
      "Güneyköy Mah",
      "Hacı Ahmet Mah",
      "Karalar Mah",
      "Mülayim Mah",
      "Saraypınar Mah",
      "Süleyman Mah",
      "Yukarı Mah"
    ],
    "Derebucak": [
      "Çamlık Mah",
      "Durak Mah",
      "Gencek Mah",
      "Göynem Mah",
      "Kenankuyu Mah",
      "Musalla Mah",
      "Pınarbaşı Mah",
      "Sarayönü Mah",
      "Taşlıpınar Mah",
      "Tepearası Mah",
      "Uğurlu Mah",
      "Yeni Mah"
    ],
    "Doğanhisar": [
      "Başköy Mah",
      "Ağa Mah",
      "Ayaslar Mah",
      "Baş Mah",
      "Cuma Mah",
      "Çınaroba Mah",
      "Deştiğin Mah",
      "Fırınlı Mah",
      "Güvendik Mah",
      "Harman Mah",
      "İlyaslar Mah",
      "Kemer Mah",
      "Koçaş Mah",
      "Konakkale Mah",
      "Kuz Mah",
      "Pazar Mah",
      "Şıh Mah",
      "Tekkeköy Mah",
      "Uncular Mah",
      "Yazır Mah",
      "Yazlıca Mah",
      "Yeğin Mah",
      "Yenice Mah",
      "Karaağa Mah"
    ],
    "Emirgazi": [
      "Akmescit Mah",
      "Besci Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Demirci Mah",
      "Ekizli Mah",
      "Fatih Mah",
      "Gölören Mah",
      "Işıklar Mah",
      "Kale Mah",
      "Karaören Mah",
      "Meşeli Mah",
      "Öbektaş Mah",
      "Türbe Mah",
      "Yamaç Mah",
      "Yeni Mah"
    ],
    "Ereğli": [
      "Acıkuyu Mah",
      "Acıpınar Mah",
      "Adabağ Mah",
      "Akhüyük Mah",
      "Alhan Mah",
      "Aşağıgöndelen Mah",
      "Aşıklar Mah",
      "Aziziye Mah",
      "Bahçeli Mah",
      "Belceağaç Mah",
      "Belkaya Mah",
      "Beyköy Mah",
      "Beyören Mah",
      "Bulgurluk Mah",
      "Burhaniye Mah",
      "Büyükdede Mah",
      "Çakmak Mah",
      "Çayhan Mah",
      "Çiller Mah",
      "Çimencik Mah",
      "Gaybi Mah",
      "Gökçeyazı Mah",
      "Göktöme Mah",
      "Hacımemiş Mah",
      "Hortu Mah",
      "Kamışlıkuyu Mah",
      "Karaburun Mah",
      "Kargacı Mah",
      "Kızılgedik Mah",
      "Kuskuncuk Mah",
      "Kutören Mah",
      "Kuzukuyu Mah",
      "Melicek Mah",
      "Orhaniye Mah",
      "Özgürler Mah",
      "Pınarözü Mah",
      "Sarıca Mah",
      "Sarıtopallı Mah",
      "Servili Mah",
      "Taşağıl Mah",
      "Taşbudak Mah",
      "Tatlıkuyu Mah",
      "Türkmen Mah",
      "Ulumeşe Mah",
      "Yazlık Mah",
      "Yellice Mah",
      "Yeniköy Mah",
      "Yıldızlı Mah",
      "Yukarıgöndelen Mah",
      "Zengen Mah",
      "Atakent Mah",
      "Aydınlar Mah",
      "Barbaros Mah",
      "Batıalagözlü Mah",
      "Cahı Mah",
      "Cinler Mah",
      "Dalmaz Mah",
      "Dogualagözlü Mah",
      "Fatih Mah",
      "Gülbahçe Mah",
      "Hacımutahir Mah",
      "Hamidiye Mah",
      "Hıdırlı Mah",
      "Mehmet Akif Mah",
      "Mimar Sinan Mah",
      "Namık Kemal Mah",
      "Pirömer Mah",
      "Şinasi Mah",
      "Toros Mah",
      "Türbe Mah",
      "Üçgöz Mah",
      "Yenibağlar Mah",
      "Yıldırımbeyazıt Mah",
      "500 Evler Mah",
      "Alpaslan Mah",
      "Boyacıali Mah",
      "Camikebir Mah",
      "Çömlekçi Mah",
      "Eti Mah",
      "Hacımustafa Mah",
      "Kazancı Mah",
      "Orhangazi Mah",
      "Selçuklu Mah",
      "Sümer Mah",
      "Talatpaşa Mah",
      "Yunuslu Mah",
      "Ziya Gökalp Mah"
    ],
    "Güneysınır": [
      "Ağras Mah",
      "Avcıtepe Mah",
      "Aydoğmuş Mah",
      "Bardas Mah",
      "Durayda Mah",
      "Emirhan Mah",
      "Güneybağ Mah",
      "Gürağaç Mah",
      "Habiller Mah",
      "Karasınır Mah",
      "Kayaağzı Mah",
      "Kızılöz Mah",
      "Kurukavak Mah",
      "Mehmet Ali Mah",
      "Mevlana Mah",
      "Ömeroğlu Mah",
      "Örenboyalı Mah",
      "Sarıhacı Mah"
    ],
    "Hadim": [
      "Armağanlar Mah",
      "Aşağı Hadim Mah",
      "Aşağı Mernek Mah",
      "Aşağıeşenler Mah",
      "Bademli Mah",
      "Beyreli Mah",
      "Bolat Mah",
      "Çiftepınar Mah",
      "Dedemli Mah",
      "Dolhanlar Mah",
      "Dülgerler Mah",
      "Eğiste Mah",
      "Fakılar Mah",
      "Gaziler Mah",
      "Gerez Mah",
      "Gezlevi Mah",
      "Göynükkışla Mah",
      "Hocalar Mah",
      "İğdeören Mah",
      "Kalınağıl Mah",
      "Kaplanlı Mah",
      "Küplüce Mah",
      "Mernek Mah",
      "Oduncu Mah",
      "Sarnıç Mah",
      "Selahattin Mah",
      "Taşpınar Mah",
      "Umurlar Mah",
      "Yağcı Mah",
      "Yelmez Mah",
      "Yenikonak Mah",
      "Yukarıeşenler Mah"
    ],
    "Halkapınar": [
      "Bahçelievler Mah",
      "Büyükdoğan Mah",
      "Cumhuriyet Mah",
      "Çakıllar Mah",
      "Dedeli Mah",
      "Delimahmutlu Mah",
      "Eskihisar Mah",
      "İvriz Mah",
      "Karayusuflu Mah",
      "Kayasaray Mah",
      "Körlü Mah",
      "Küsere Mah",
      "Nernek Mah",
      "Osmanköseli Mah",
      "Seydifakılı Mah",
      "Yassıkaya Mah",
      "Yeşilyurt Mah"
    ],
    "Hüyük": [
      "Akdağ Mah",
      "Bahçeli Evler Mah",
      "Başlamış Mah",
      "Budak Mah",
      "Burunsuz Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Çavuş Mah",
      "Çukurkent Mah",
      "Değirmenaltı Mah",
      "Göçeri Mah",
      "Görünmez Mah",
      "İlmen Mah",
      "Köşk Mah",
      "Mutlu Mah",
      "Pınarbaşı Mah",
      "Selki Mah",
      "Suludere Mah",
      "Tolca Mah",
      "Ulupınar Mah",
      "Yenice Mah",
      "İmrenler Mah",
      "Kıreli Mah"
    ],
    "Ilgın": [
      "Argıthanı Mah",
      "Ayvatdede Mah",
      "Behlülbey Mah",
      "Camiiatik Mah",
      "Esentepe Mah",
      "Fahrettin Altay Mah",
      "Fatih Mah",
      "Ilıca Mah",
      "İstasyon Mah",
      "Milli Egemenlik Mah",
      "Sahip Ata Mah",
      "Şıhbedrettin Mah",
      "Şıhcarullah Mah",
      "Ucarı Mah",
      "Çiğil Mah",
      "Dığrak Mah",
      "Gökbudak Mah",
      "Ağalar Mah",
      "Avdan Mah",
      "Balkı Mah",
      "Barakmuslu Mah",
      "Belekler Mah",
      "Beykonak Mah",
      "Boğazkent Mah",
      "Bulcuk Mah",
      "Büyükoba Mah",
      "Çatak Mah",
      "Çavuşçugöl Mah",
      "Çobankaya Mah",
      "Çömlekçi Mah",
      "Dereköy Mah",
      "Düğer Mah",
      "Eldeş Mah",
      "Geçitköy Mah",
      "Gedikören Mah",
      "Gökçeyurt Mah",
      "Gölyaka Mah",
      "Göstere Mah",
      "Güneypınar Mah",
      "Harmanyazı Mah",
      "İhsaniye Mah",
      "Kaleköy Mah",
      "Kapaklı Mah",
      "Karaköy Mah",
      "Mahmuthisar Mah",
      "Mecidiye Mah",
      "Misafirli Mah",
      "Olukpınar Mah",
      "Orhaniye Mah",
      "Ormanözü Mah",
      "Sadıkköy Mah",
      "Sebiller Mah",
      "Tekeler Mah",
      "Yorazlar Mah",
      "Yukarıçiğil Mah",
      "Zaferiye Mah"
    ],
    "Kadınhanı": [
      "Afşarlı Mah",
      "Alabağ Mah",
      "Atlantı Mah",
      "Bakırpınar Mah",
      "Başkuyu Mah",
      "Bayramlı Mah",
      "Beykavağı Mah",
      "Bulgurpınarı Mah",
      "Çavdar Mah",
      "Çeşmecik Mah",
      "Çubuk Mah",
      "Demiroluk Mah",
      "Doğanlar Mah",
      "Güngören Mah",
      "Hacımehmetli Mah",
      "Hacıoflazlar Mah",
      "Hacıpirli Mah",
      "İstiklal Mah",
      "Kabacalı Mah",
      "Kamışlıözü Mah",
      "Karahisarlı Mah",
      "Karakaya Mah",
      "Karakurtlu Mah",
      "Karasevinç Mah",
      "Karayürüklü Mah",
      "Kayabaşı Mah",
      "Kızılkuyu Mah",
      "Kolukısa Beratlı Mah",
      "Kolukısa Mescit Mah",
      "Konurören Mah",
      "Kökez Mah",
      "Köylütolu Mah",
      "Kurthasanlı Mah",
      "Küçükkuyu Mah",
      "Mahmudiye Mah",
      "Meydanlı Mah",
      "Osmancık Mah",
      "Örnek Mah",
      "Pınarbaşı Mah",
      "Pirali Mah",
      "Pusat Mah",
      "Saçıkara Mah",
      "Sarıkaya Mah",
      "Söğütözü Mah",
      "Şahören Mah",
      "Tepebaşı Mah",
      "Tosunoğlu Mah",
      "Turgutlu Mah",
      "Ünveren Mah",
      "Yağlıca Mah",
      "Yaylayaka Mah",
      "Yeni Mah",
      "Zafer Mah"
    ],
    "Karapınar": [
      "Adalet Mah",
      "Akçayazı Mah",
      "Akören Mah",
      "Alaaddin Mah",
      "Apak Mah",
      "Cumhuriyet Mah",
      "Çetmi Mah",
      "Çiğil Mah",
      "Fatih Mah",
      "Fevzi Paşa Mah",
      "Gazi Osman Paşa Mah",
      "Hacı İsa Mah",
      "Hacı Ömerli Mah",
      "Hankapı Mah",
      "Hasanoba Mah",
      "Hotamış Mah",
      "İpekçi Mah",
      "İpekçiosb Mah",
      "İslik Mah",
      "İsmet Paşa Mah",
      "Kale Mah",
      "Karakışla Mah",
      "Kayacık Mah",
      "Kayalı Mah",
      "Kazanhüyüğü Mah",
      "Kesmez Mah",
      "Küçükaşlama Mah",
      "Küllü Mah",
      "Ortaoba Mah",
      "Oymalı Mah",
      "Pınarbaşı Mah",
      "Reşadiye Mah",
      "Sandıklı Mah",
      "Sazlıpınar Mah",
      "Selimiye Mah",
      "Türüdiye Mah",
      "Ulus Mah",
      "Yağmapınar Mah",
      "Yeni Mah",
      "Yenikuyu Mah",
      "Yeşilyurt Mah",
      "Yunus Emre Mah",
      "Zafer Mah"
    ],
    "Karatay": [
      "Akifpaşa Mah",
      "Büyük Sinan Mah",
      "Erenler Mah",
      "Kalenderhane Mah",
      "Karaciğan Mah",
      "Kayacıkaraplar Mah",
      "Keçeciler Mah",
      "Keykubat Mah",
      "Sultan Mesud Mah",
      "Ulubatlıhasan Mah",
      "Yediler Mah",
      "Fevziçakmak Mah",
      "Hacıyusufmescit Mah",
      "Tatlıcak Mah",
      "Acıdort Mah",
      "Ağsaklı Mah",
      "Akbaş Mah",
      "Akörenkışla Mah",
      "Bakırtolu Mah",
      "Başgötüren Mah",
      "Beşağıl Mah",
      "Büyükburnak Mah",
      "Çengilti Mah",
      "Divanlar Mah",
      "Esentepe Mah",
      "Göçü Mah",
      "Hayıroğlu Mah",
      "İpekler Mah",
      "İsmil Mah",
      "Karadona Mah",
      "Karakaya Mah",
      "Katrancı Mah",
      "Kızören Mah",
      "Köseali Mah",
      "Obruk Mah",
      "Ortakonak Mah",
      "Ortakonak Osb Mah",
      "Ovakavağı Mah",
      "Sakyatan Mah",
      "Sürüç Mah",
      "Şatır Mah",
      "Yağlıbayat Mah",
      "Yarma Mah",
      "Yavşankuyu Mah",
      "Yenice Mah",
      "Yenikent Mah",
      "Zincirli Mah",
      "Aziziye Mah",
      "Çelebi Mah",
      "Çimenlik Mah",
      "Emirgazi Mah",
      "Fetih Mah",
      "Hacı Hasan Mah",
      "Hacısadık Mah",
      "Hacıveyiszade Mah",
      "Hasandedemescit Mah",
      "Köprübaşı Mah",
      "Nakipoğlu Mah",
      "Şemsitebrizi Mah",
      "Akabe Mah",
      "Akçeşme Mah",
      "Başak Mah",
      "Çatalhüyük Mah",
      "Çataltömek Mah",
      "Doğuş Mah",
      "Elmacı Mah",
      "Erler Mah",
      "Gaziosmanpaşa Mah",
      "Hacıibalı Mah",
      "Hamzaoğlu Mah",
      "İstiklal Mah",
      "Karaaslandede Mah",
      "Karaaslanüzümcü Mah",
      "Karakulak Mah",
      "Kerim Dede Mah",
      "Kumköprü Mah",
      "Mengene Mah",
      "Orhangazi Mah",
      "Saraçoğlu Mah",
      "Sarıyakup Mah",
      "Selimsultan Mah"
    ],
    "Kulu": [
      "Alparslan Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Fatih Sultan Mehmet Mah",
      "Karşıyaka Mah",
      "Kemaliye Mah",
      "Yeni Mah",
      "Acıkuyu Mah",
      "Altılar Mah",
      "Arşıncı Mah",
      "Bahadırlı Mah",
      "Beşkardeş Mah",
      "Bozan Mah",
      "Burunağıl Mah",
      "Canımana Mah",
      "Celep Mah",
      "Değirmenözü Mah",
      "Dinek Mah",
      "Dipdede Mah",
      "Doğutepe Mah",
      "Fevziye Mah",
      "Gökler Mah",
      "Güzelyayla Mah",
      "Hisarköy Mah",
      "Karacadağ Mah",
      "Karacadere Mah",
      "Karapınar Mah",
      "Kırkkuyu Mah",
      "Kırkpınar Mah",
      "Kozanlı Mah",
      "Kömüşini Mah",
      "Köstengil Mah",
      "Köşker Mah",
      "Mandıra Mah",
      "Sarıyayla Mah",
      "Seyitahmetli Mah",
      "Soğukkuyu Mah",
      "Şerefli Mah",
      "Tavlıören Mah",
      "Tuzyaka Mah",
      "Yaraşlı Mah",
      "Yazıçayır Mah",
      "Yeşiltepe Mah",
      "Yeşilyurt Mah",
      "Zincirlikuyu Mah",
      "Ömeranlı Mah"
    ],
    "Meram": [
      "Aydoğdu Mah",
      "Çaybaşı Mah",
      "Konevi Mah",
      "Pirebi Mah",
      "Sahibata Mah",
      "Çayırbağı Mah",
      "Gödene Mah",
      "Hatıp Mah",
      "Karadiğin Mah",
      "Karadiğinderesi Mah",
      "Pamukcu Mah",
      "Yenibahçe Mah",
      "Ali Ulvi Kurucu Mah",
      "Boruktolu Mah",
      "Boyalı Mah",
      "Çarıklar Mah",
      "Çomaklı Mah",
      "Kaşınhanı Mah",
      "Ateşbaz Veli Mah",
      "Ayanbey Mah",
      "Durunday Mah",
      "Havzan Mah",
      "Karahüyük Mah",
      "Kozağaç Mah",
      "Lalebahçe Mah",
      "Osman Gazi Mah",
      "Bayat Mah",
      "Botsa Mah",
      "Çomaklar Mah",
      "Çukurçimen Mah",
      "Erenkaya Mah",
      "Evliyatekke Mah",
      "Hasanşeyh Mah",
      "Hatunsaray Mah",
      "İkipınar Mah",
      "İnlice Mah",
      "Karaağaç Mah",
      "Kavak Mah",
      "Kayadibi Mah",
      "Kayalı Mah",
      "Kayıhüyük Mah",
      "Kızılören Mah",
      "Kilistra Mah",
      "Kumralı Mah",
      "Sadıklar Mah",
      "Sağlık Mah",
      "Sarıkız Mah",
      "Sefaköy Mah",
      "Yatağan Mah",
      "Yeşildere Mah",
      "Yeşiltekke Mah",
      "Alakova Mah",
      "Alpaslan Mah",
      "Aymanas Mah",
      "Bahçeşehir Mah",
      "Hadimi Mah",
      "Harmancık Mah",
      "Kovanağzı Mah",
      "Uluğbey Mah",
      "Uluırmak Mah",
      "Uzunharmanlar Mah",
      "Yaylapınar Mah",
      "Yenişehir Mah",
      "Alavardı Mah",
      "Aşkan Mah",
      "Dere Mah",
      "Köyceğiz Mah",
      "Melikşah Mah",
      "Yaka Mah"
    ],
    "Sarayönü": [
      "Batı İstasyon Mah",
      "Doğu İstasyon Mah",
      "Fatih Mah",
      "Hatip Mah",
      "İnli Mah",
      "Saraç Mah",
      "Selimiye Mah",
      "Yukarı Mah",
      "Bahçesaray Mah",
      "Başhüyük Mah",
      "Boyalı Mah",
      "Büyükzengi Mah",
      "Çeşmelisebil Mah",
      "Değirmenli Mah",
      "Ertuğrul Mah",
      "Gözlü Mah",
      "Kadıoğlu Mah",
      "Karabıyık Mah",
      "Karatepe Mah",
      "Kayıören Mah",
      "Konar Mah",
      "Kurşunlu Mah",
      "Kuyulusebil Mah",
      "Ladik Mah",
      "Özkent Mah",
      "Yenicekaya Mah"
    ],
    "Selçuklu": [
      "Akıncılar Mah",
      "Aydınlıkevler Mah",
      "Bedir Mah",
      "Erenköy Mah",
      "Hüsamettin Çelebi Mah",
      "Mehmet Akif Mah",
      "Sakarya Mah",
      "Sille Ak Mah",
      "Bosna Hersek Mah",
      "Kosova Mah",
      "Sancak Mah",
      "Aşağıpınarbaşı Mah",
      "Aşağıpınarbaşı Osb Mah",
      "Büyükkayacık Mah",
      "Büyükkayacıkosb Mah",
      "Tömek Mah",
      "Yukarıpınarbaşı Mah",
      "Binkonutlar Mah",
      "Buhara Mah",
      "Cumhuriyet Mah",
      "Dumlupınar Mah",
      "Malazgirt Mah",
      "Şeyh Şamil Mah",
      "Fatih Mah",
      "Feritpaşa Mah",
      "Işıklar Mah",
      "Musalla Bağları Mah",
      "Horozluhan Mah",
      "Horozluhanosb Mah",
      "Akademi Mah",
      "Akşemsettin Mah",
      "Esenler Mah",
      "Hacıkaymak Mah",
      "Hanaybaşı Mah",
      "Hocacihan Mah",
      "Kılınçarslan Mah",
      "Selçuk Mah",
      "Şeker Mah",
      "Ferhuniye Mah",
      "İhsaniye Mah",
      "Nişantaş Mah",
      "Ardıçlı Mah",
      "Bağrıkurt Mah",
      "Başarakavak Mah",
      "Biçer Mah",
      "Bilecik Mah",
      "Çaldere Mah",
      "Çaltı Mah",
      "Çandır Mah",
      "Dağdere Mah",
      "Dokuz Mah",
      "Eğribayat Mah",
      "Güvenç Mah",
      "Kaleköy Mah",
      "Karaömerler Mah",
      "Kervan Mah",
      "Kınık Mah",
      "Kızılcakuyu Mah",
      "Meydanköy Mah",
      "Salahattin Mah",
      "Sarıcalar Mah",
      "Sızma Mah",
      "Tepekent Mah",
      "Yazıbelen Mah",
      "Sille Mah",
      "Akpınar Mah",
      "Küçükmuhsine Mah",
      "Sarayköy Mah",
      "Sulutas Mah",
      "Tatköy Mah",
      "Ulumuhsine Mah",
      "Beyhekim Mah",
      "Parsana Mah",
      "Selahaddini Eyyubi Mah",
      "Yazır Mah"
    ],
    "Seydişehir": [
      "Aktaş Mah",
      "Alaylar Bir Mah",
      "Alaylar İki Mah",
      "Anabağlar Mah",
      "Bahçelievler Mah",
      "Hacıseyitali Mah",
      "Karakavak Mah",
      "Kızılcalar Mah",
      "Saadetler Mah",
      "Akçalar Mah",
      "Aşağıkaraören Mah",
      "Başkaraören Mah",
      "Bostandere Mah",
      "Boyalı Mah",
      "Bükçe Mah",
      "Çat Mah",
      "Çatmakaya Mah",
      "Çavuş Mah",
      "Dikilitaş Mah",
      "Gevrekli Mah",
      "Gökçehüyük Mah",
      "Gökhüyük Mah",
      "Gölyüzü Mah",
      "Irmaklı Mah",
      "İncesu Mah",
      "Karabulak Mah",
      "Karacaören Mah",
      "Kavak Mah",
      "Kesecik Mah",
      "Ketenli Mah",
      "Kızılca Mah",
      "Kozlu Mah",
      "Kumluca Mah",
      "Kuran Mah",
      "Madenli Mah",
      "Mesudiye Mah",
      "Muradiye Mah",
      "Oğlakçı Mah",
      "Ortakaraören Mah",
      "Saraycık Mah",
      "Susuz Mah",
      "Taraşcı Mah",
      "Taşağıl Mah",
      "Tepecik Mah",
      "Tol Mah",
      "Ufacık Mah",
      "Yaylacık Mah",
      "Yenice Mah",
      "Değirmenci Mah",
      "Pınarbaşı Mah",
      "Seyitharun Mah",
      "Sofuhane Mah",
      "Stat Mah",
      "Ulukapı Mah",
      "Yenicami Mah"
    ],
    "Taşkent": [
      "Afşar Tepecik Mah",
      "Afşar Yukarı Mah",
      "Balcılar Orta Mah",
      "Balcılar Veliler Mah",
      "Balcılar Yukarı Mah",
      "Bektaş Mah",
      "Bolay Mah",
      "Çetmi Cömeşpınar Mah",
      "Çetmi Yeni Mah",
      "Hıra Mah",
      "Ilıcapınar Mah",
      "Kecimen Mah",
      "Kongul Mah",
      "Sazak Mah",
      "Şıhlar Mah"
    ],
    "Tuzlukçu": [
      "Aşağı Mah",
      "Çöğürlü Mah",
      "Erdoğdu Mah",
      "Gürsu Mah",
      "Konarı Mah",
      "Koraşı Mah",
      "Köklüce Mah",
      "Kundullu Mah",
      "Mevlütlü Mah",
      "Orta Mah",
      "Pazar Mah",
      "Pazarkaya Mah",
      "Subatan Mah",
      "Tursunlu Mah",
      "Yukarı Mah"
    ],
    "Yalıhüyük": [
      "Arasöğüt Mah",
      "Aşağı Mah",
      "Sarayköy Mah",
      "Yukarı Mah"
    ],
    "Yunak": [
      "Altınöz Mah",
      "Ayrıtepe Mah",
      "Beşışıklı Mah",
      "Böğrüdelik Mah",
      "Cebrail Mah",
      "Çayırbaşı Mah",
      "Eğrikuyu Mah",
      "Esentepe Mah",
      "Eşme Mah",
      "Fatih Mah",
      "Hacıfakılı Mah",
      "Hacıömeroğlu Mah",
      "Harunlar Mah",
      "Hatırlı Mah",
      "Hursunlu Mah",
      "İmamoğlu Mah",
      "Karataş Mah",
      "Karayayla Mah",
      "Kargalı Mah",
      "Kıllar Mah",
      "Koçyazı Mah",
      "Kurtuşağı Mah",
      "Kuyubaşı Mah",
      "Kuzören Mah",
      "Meşelik Mah",
      "Odabaşı Mah",
      "Ortakışla Mah",
      "Özyayla Mah",
      "Piribeyli Mah",
      "Saray Mah",
      "Selçuk Mah",
      "Sertler Mah",
      "Sevinç Mah",
      "Sıram Mah",
      "Sinanlı Mah",
      "Sülüklü Mah",
      "Turgut Mah",
      "Yavaşlı Mah",
      "Yeni Mah",
      "Yeşiloba Mah",
      "Yeşilyayla Mah",
      "Yığar Mah"
    ]
  },
  "Kütahya": {
    "Altıntaş": [
      "Bozbay Mah",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (zafertepeçalköy Köyü)",
      "Hürriyet Mah",
      "Hürriyet Mah (zafertepeçalköy Köyü)",
      "İstiklal Mah",
      "İstiklal Mah (çayırbaşı Köyü)",
      "Yeni Mah",
      "Zafer Mah (çayırbaşı Köyü)",
      "Zafer Mah (zafertepeçalköy Köyü)",
      "Akçaköy Köyü",
      "Alıncık Köyü",
      "Alibey Köyü",
      "Altıntaş Köyü",
      "Aşağı Mah (gökçeler Köyü)",
      "Aydınlar Köyü",
      "Aykırıkçı Köyü",
      "Beşkarış Köyü",
      "Çakırsaz Köyü",
      "Erenköy Köyü",
      "Eymir Köyü",
      "Gecek Köyü",
      "Genişler Köyü",
      "Işıklar Köyü",
      "Karaağaç Köyü",
      "Kuyucak Köyü",
      "Mecidiye Köyü",
      "Murathanlar Köyü",
      "Osmaniye Köyü",
      "Oysu Köyü",
      "Pınarcık Köyü",
      "Pusan Köyü",
      "Sadıkkırı Köyü",
      "Saraycık Köyü",
      "Sevdiğin Köyü",
      "Şanlıyurt Köyü",
      "Üçhüyük Köyü",
      "Yalnızsaray Köyü",
      "Yapılcan Köyü",
      "Yayla Köyü",
      "Yenikaraağaç Köyü",
      "Yeşilyurt Köyü",
      "Yolçatı Köyü",
      "Yukarı Mah (gökçeler Köyü)"
    ],
    "Aslanapa": [
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Pınarbaşı Mah",
      "Yalnızsaray Mah",
      "Abaş Köyü",
      "Ada Köyü",
      "Ahmet Çavuşlar Mah (çömlekçi Köyü)",
      "Altıntaş Mah (nuhören Köyü)",
      "Aslıhanlar Köyü",
      "Ballıbaba Köyü",
      "Bayat Köyü",
      "Bayramşah Köyü",
      "Bezirgan Köyü",
      "Çakmak Köyü",
      "Çal Köyü",
      "Çalköy Yaylası Mah (çal Köyü)",
      "Çamdibi Köyü",
      "Çamırdık Köyü",
      "Çukurca Köyü",
      "Dere Köyü",
      "Emrez Köyü",
      "Esen Köyü",
      "Gölbaşı Köyü",
      "Göynükören Köyü",
      "Haydarlar Köyü",
      "Karadiğin Köyü",
      "Karakaya Mah (bayat Köyü)",
      "Ketenova Mah (emrez Köyü)",
      "Koca Oluk Mah (musa Köyü)",
      "Kureyşler Köyü",
      "Kümbet Mah (nuhören Köyü)",
      "Mevlana Mah (nuhören Köyü)",
      "Musa Köyü",
      "Ortaca Köyü",
      "Osman Çavuşlar Mah (çömlekçi Köyü)",
      "Ören Köyü",
      "Pazarcık Köyü",
      "Saray Köyü",
      "Şenişler Köyü",
      "Şenişler Köyü Ketenova Yaylası",
      "Terziler Köyü",
      "Tokul Köyü",
      "Yağcılar Köyü",
      "Yunus Emre Mah (nuhören Köyü)"
    ],
    "Çavdarhisar": [
      "Cereller Mah",
      "Kemaller Mah",
      "Meydan Mah",
      "Yukarı Mah",
      "Afşar Köyü",
      "Ağarı Köyü",
      "Akpınar Köyü",
      "Barağı Köyü",
      "Camii Kebir Mah (hacıkebir Köyü)",
      "Çamköy Köyü",
      "Çatköy Köyü",
      "Demiroluk Köyü",
      "Doğancılar Köyü",
      "Efeler Köyü",
      "Efendiköprüsü Köyü",
      "Esentepe Mah (hacıkebir Köyü)",
      "Gökağaç Köyü",
      "Gökler Köyü",
      "Hacımahmut Köyü",
      "İlcikören Köyü",
      "Kızık Köyü",
      "Pusatlar Köyü",
      "Susuzkaya Köyü",
      "Tepecik Köyü",
      "Yağdığın Köyü",
      "Yenicearmutcuk Köyü",
      "Yeşildere Köyü",
      "Zobu Köyü"
    ],
    "Domaniç": [
      "Cumhuriyet Mah (çukurca Beldesi)",
      "Ilıcaksu Mah (çukurca Beldesi)",
      "Küçükler Mah (çukurca Beldesi)",
      "Osmanlı Mah (çukurca Beldesi)",
      "Cumhuriyet Mah",
      "Hasantepe Mah",
      "Hisar Mah",
      "Karşıyaka Mah",
      "Akkaya Mah (erikli Köyü)",
      "Aksu Köyü",
      "Bahçelievler Mah (durabey Köyü)",
      "Berçin Köyü",
      "Böçen Köyü",
      "Bükerler Köyü",
      "Çakılköy Köyü",
      "Çamlıca Köyü",
      "Çarşamba Köyü",
      "Çokköy Köyü",
      "Domur Köyü",
      "Durabey Köyü",
      "Erikli Köyü",
      "Fındıcak Köyü",
      "Fıranlar Köyü",
      "Göçemen Mah (erikli Köyü)",
      "Güney Köyü",
      "Karaburun Mah (erikli Köyü)",
      "Karaköy Köyü",
      "Karamanlar Köyü",
      "Kırık Köyü",
      "Kozcağız Köyü",
      "Kozcağız Mah (erikli Köyü)",
      "Kozluca Köyü",
      "Küçükköy Köyü",
      "Muhacirler Köyü",
      "Muratlı Köyü",
      "Ortaca Köyü",
      "Safa Köyü",
      "Sakızlık Mah (kırık Köyü)",
      "Sarıot Köyü",
      "Saruhanlar Köyü",
      "Seydikuzu Köyü",
      "Soğucak Köyü",
      "Tıraz Köyü",
      "Üstübeş Mah (muratlı Köyü)",
      "Yeşilköy Köyü"
    ],
    "Dumlupınar": [
      "Cafergazi Mah",
      "Cumhuriyet Mah",
      "Turgut Özal Mah",
      "Zafer Mah",
      "Ağaç Köyü",
      "Allıören Köyü",
      "Arpalı Köyü",
      "Büyükaslıhanlar Köyü",
      "Eyidemir Köyü",
      "Hamur Köyü",
      "Kızılca Köyü",
      "Küçükaslıhanlar Köyü",
      "Selkisaray Köyü",
      "Yüylük Köyü"
    ],
    "Emet": [
      "Akpınar Mah",
      "Cumhuriyet Mah",
      "Dere Mah",
      "Esentepe Mah",
      "Hamam Mah",
      "Kapaklıca Mah",
      "Kaynarca Mah",
      "Abaş Köyü",
      "Alipaşa Mah (örencik Köyü)",
      "Bahatlar Köyü",
      "Cumhuriyet Mah (aydıncık Köyü)",
      "Cumhuriyet Mah (eğrigöz Köyü)",
      "Çalcağıl Mah",
      "Çamlıca Mah (günlüce Köyü)",
      "Çarşı Mah (örencik Köyü)",
      "Çimenli Mah (günlüce Köyü)",
      "Çimenlik Mah (yenice Köyü)",
      "Dereli Köyü",
      "Doğanlar Köyü",
      "Düşecek Köyü",
      "Esatlar Köyü",
      "Eseler Köyü",
      "Fatih Mah (çerte Köyü)",
      "Gencer Mah (sarıayak Köyü)",
      "Göncek Köyü",
      "Gürpınar Köyü",
      "Işıklı Köyü",
      "İğdeköy Köyü",
      "İkibaşlı Köyü",
      "Kabaklar Köyü",
      "Kalehisar Mah (eğrigöz Köyü)",
      "Kalfalar Köyü",
      "Katrandağı Köyü",
      "Kayı Köyü",
      "Kırgıl Köyü",
      "Konuş Köyü",
      "Köprücek Köyü",
      "Küreci Köyü",
      "Merkez Mah (günlüce Köyü)",
      "Meydan Mah (aydıncık Köyü)",
      "Musalar Köyü",
      "Ömerfakı Köyü",
      "Örüce Mah (yaylayolu Köyü)",
      "Samrık Köyü",
      "Sarıayak Köyü",
      "Subak Köyü",
      "Şehitler Mah (günlüce Köyü)",
      "Umutlu Köyü",
      "Uzunçam Köyü",
      "Yağcık Köyü",
      "Yarış Köyü",
      "Yaylayolu Köyü",
      "Yeni Mah (örencik Köyü)",
      "Yeni Mah (yenice Köyü)",
      "Yeniköy Köyü",
      "Yıldırım Mah (çerte Köyü)"
    ],
    "Gediz": [
      "Akçaalan Mah (eskigediz Beldesi)",
      "Camikebir Mah (eskigediz Beldesi)",
      "Hisar Mah (eskigediz Beldesi)",
      "İsmetpaşa Mah (eskigediz Beldesi)",
      "Kurtuluş Mah (eskigediz Beldesi)",
      "Park Mah (eskigediz Beldesi)",
      "Sabırgazi Mah (eskigediz Beldesi)",
      "Dayınlar Mah",
      "Ergenekon Mah",
      "Gazikemal Mah",
      "Gedizosb Mah",
      "Hacıbaba Mah",
      "Kızıltepe Mah",
      "Kumtaş Mah",
      "Muhipler Mah",
      "Özyurt Mah",
      "Salur Mah",
      "Saygılar Mah",
      "Uluoymak Mah",
      "Umurbey Mah",
      "Güney Mah (gökler Beldesi)",
      "Kuzey Mah (gökler Beldesi)",
      "Abide Köyü",
      "Akkaya Köyü",
      "Aksaklar Mah (aksaklar Köyü)",
      "Aliağa Köyü",
      "Alikahya Köyü",
      "Aşıkpaşa Köyü",
      "Atatürk Mah (kayaköy Köyü)",
      "Çamlık Mah (fırdan Köyü)",
      "Çandır Mah (fırdan Köyü)",
      "Çay Mah (yeşilçay Köyü)",
      "Çiftlik Mah (abide Köyü)",
      "Çimentepe Mah (gürlek Köyü)",
      "Çomaklar Köyü",
      "Çukurören Köyü",
      "Dedeköy Köyü",
      "Değirmenköy Köyü",
      "Deliağa Mah (arıca Köyü)",
      "Dere Mah (arıca Köyü)",
      "Dereköy Köyü",
      "Dörtdeğirmen Köyü",
      "Ece Köyü",
      "Ergenekon Mah (erdoğmuş Köyü)",
      "Eski Mah (çeltikçi Köyü)",
      "Fatih Mah (altınkent Köyü)",
      "Fatih Mah (cebrail Köyü)",
      "Fatih Mah (gümele Köyü)",
      "Fatih Mah (üzümlü Köyü)",
      "Fatih Mah (yunuslar Köyü)",
      "Fatih Sultan Mehmet Mah (kayaköy Köyü)",
      "Gençler Mah (göynükören Köyü)",
      "Göynük Köyü",
      "Göynükören Köyü",
      "Gümüşlü Köyü",
      "Gürsu Mah (gürlek Köyü)",
      "Güzüngülü Köyü",
      "Hacı Zeybekler Mah (kurtçam Köyü)",
      "Hanifecikler Mah (karabacaklar Köyü)",
      "Ilıcasu Köyü",
      "Işıklar Köyü",
      "İkipınar Mah (aksaklar Köyü)",
      "İncesu Mah (abide Köyü)",
      "İncikler Mah (akkaya Köyü)",
      "Karaağaç Köyü",
      "Karabacaklar Köyü",
      "Kaya Düzü Mah (kıran Köyü)",
      "Kayacık Köyü",
      "Kıran Köy",
      "Köpenez Köyü",
      "Kurtçam Köyü",
      "Mandıra Mah (yeşilova Köyü)",
      "Orta Mah (arıca Köyü)",
      "Ova Mah (aksaklar Köyü)",
      "Ova Mah (çeltikçi Köyü)",
      "Özyurt Mah (altınkent Köyü)",
      "Özyurt Mah (üzümlü Köyü)",
      "Pınarbaşı Köyü",
      "Pulat Köyü",
      "Samralar Köyü",
      "Sandıklı Köyü",
      "Saruhanlar Köyü",
      "Saz Köyü",
      "Saz Mah (kıran Köyü)",
      "Sazak Köyü",
      "Soğuksu Köyü",
      "Sumaklı Köyü",
      "Tepepınar Köyü",
      "Uğurluca Köyü",
      "Ülkü Mah (erdoğmuş Köyü)",
      "Vakıf Köyü",
      "Yağmurlar Köyü",
      "Yavuz Mah (gümele Köyü)",
      "Yaylaköy Köyü",
      "Yeğinler Köyü",
      "Yelki Köyü",
      "Yeni Mah (çeltikçi Köyü)",
      "Yeni Mah (üzümlü Köyü)",
      "Yeni Mah (yeşilçay Köyü)",
      "Yenigüney Köyü",
      "Yeşilova Köyü",
      "Yukarıarıca Mah (arıca Köyü)",
      "Yukarısusuz Köyü",
      "Yumrutaş Köyü",
      "Yunusemre Mah (yunuslar Köyü)",
      "Gölcük Mah (yenikent Beldesi)",
      "Hamzabey Mah (yenikent Beldesi)",
      "İbrahimkahya Mah (yenikent Beldesi)",
      "Yeni Mah (yenikent Beldesi)"
    ],
    "Hisarcık": [
      "82.yıl Mah",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (karbasan Köyü)",
      "Karşıyaka Mah",
      "Karşıyaka Mah (karbasan Köyü)",
      "Şehitler Mah",
      "Yenidoğan Mah",
      "Yenidoğan Mah (karbasan Köyü)",
      "Yeşilhisar Mah",
      "Alıdede Mah (şeyhler Köyü)",
      "Alınören Köyü",
      "Aşağı Beyköy Mah (beyköy Köyü)",
      "Aşağıyoncaağaç Köyü",
      "Bahçelievler Mah (hasanlar Köyü)",
      "Bakılar Damları Mah (şeyhçakır Köyü)",
      "Beyköy Köyü",
      "Çatak Köyü",
      "Emirsultan Mah (hasanlar Köyü)",
      "Gazi Mah (dereköy Köyü)",
      "Güldüren Köyü",
      "Haksızhasan Mah (şeyhler Köyü)",
      "Halifeler Köyü",
      "Hamamköy Köyü",
      "Hocalar Köyü",
      "İnkaya Mah (kurtdere Köyü)",
      "Karaağıl Köyü",
      "Kızılçukur Köyü",
      "Kurtdere Köyü",
      "Kutlubeyler Köyü",
      "Kutluhallar Köyü",
      "Örenköy Köyü",
      "Saklar Köyü",
      "Sefaköy Köyü",
      "Şeyhçakır Köyü",
      "Tekke Mah (şeyhler Köyü)",
      "Tokat Köyü",
      "Ulaşlar Köyü",
      "Yenipınar Köyü",
      "Yukarıyoncaağaç Köyü",
      "Yunusemre Mah (dereköy Köyü)"
    ],
    "Merkez": [
      "Alipaşa Mah",
      "Cumhuriyet Mah",
      "Dumlupınar Mah",
      "Fatih Mah",
      "Vefa Mah",
      "Yenidoğan Mah",
      "Yıldırım Beyazıt Mah",
      "Yunusemre Mah",
      "Zafertepe Mah",
      "Balıklı Mah",
      "Börekçiler Mah",
      "Cemalettin Mah",
      "Fuatpaşa Mah",
      "Gaybiefendi Mah",
      "Meydan Mah",
      "Pirler Mah",
      "Servi Mah",
      "100. Yıl Mah",
      "30 Ağustos Mah",
      "75. Yıl Mah",
      "Ağaçköy Mah",
      "Akkent Mah",
      "Alayunt Mah",
      "Andız Mah",
      "Aydoğdu Mah",
      "Bahçelievler Mah",
      "Bölücek Mah",
      "Cedit Mah",
      "Civli Mah",
      "Çalca Mah",
      "Çalca Osb Mah",
      "Enne Mah",
      "Evliya Çelebi Mah",
      "G. Kemal Mah",
      "Geven Mah",
      "Güveççi Mah",
      "Hacıazizler Mah",
      "Hamidiye Mah",
      "Hilalkent Mah",
      "İkizüyük Mah",
      "İnköy Mah",
      "İstiklal Mah",
      "Kırgıllı Mah",
      "Kirazpınar Mah",
      "Kumarı Mah",
      "Lala Hüseyin Paşa Mah",
      "Maltepe Mah",
      "Maruf Mah",
      "Mecidiye Mah",
      "Mehmet Akif Ersoy Mah",
      "Müderris Mah",
      "Ok Meydanı Mah",
      "Okçu Mah",
      "Organize Sanayi Bölgesi Mah",
      "Osmangazi Mah",
      "Parmakören Mah",
      "Paşam Sultan Mah",
      "Perli Mah",
      "Saray Mah",
      "Siner Mah",
      "Sofu Mah",
      "Sultanbağı Mah",
      "Şair Şeyhi Dumlupınar Mah",
      "Yeni Bosna Mah",
      "Yoncalı Mah",
      "Ziğra Mah",
      "Ziraat Mah",
      "Ağaçköy Köyü",
      "Ağızören Köyü",
      "Ahiler Köyü",
      "Ahmetoluğu Köyü",
      "Akçamescit Köyü",
      "Akoluk Köyü",
      "Akpınar Köyü",
      "Aloğlu Köyü",
      "Anasultan Köyü",
      "Arslanlı Köyü",
      "Ayvalı Köyü",
      "Başören Köyü",
      "Bayat Köyü",
      "Bayramşah Köyü",
      "Belkavak Köyü",
      "Beşderirme Çiftliği Mah (ahmetoluğu Köyü)",
      "Büyüksaka Köyü",
      "Cennetoğlu Mah (aloğlu Köyü)",
      "Çavuşçiftliği Köyü",
      "Çayca Köyü",
      "Çifteoluklar Köyü",
      "Çobanlar Köyü",
      "Çöğürler Köyü",
      "Çubukiçi Köyü",
      "Damlalıkaraağaç Köyü",
      "Darıca Köyü",
      "Dedik Köyü",
      "Değirmenönü Mah (gelinkaya Köyü)",
      "Değirmenözü Mah (ihsaniye Köyü)",
      "Demirciören Köyü",
      "Demirözü Köyü",
      "Dereköy Köyü",
      "Doğa Köyü",
      "Doğalar Köyü",
      "Doğarslan Köyü",
      "Elmacık Köyü",
      "Elmalı Köyü",
      "Eski Mah (demirciören Köyü)",
      "Eskiyüreğil Köyü",
      "Eynegazi Köyü",
      "Fatihler Mah (kızılcaören Köyü)",
      "Fındık Köyü",
      "Fincanburnu Köyü",
      "Gedikoğluçiftliği Köyü",
      "Gelinkaya Köyü",
      "Göçeri Köyü",
      "Göynükören Köyü",
      "Göynükören Mah (göynükören Köyü)",
      "Güllüdere Köyü",
      "Gültepe Mah",
      "Gümüşköy Mah (gümüşköy Köyü)",
      "Gürlek Mah (mustafalar Köyü)",
      "Güvem Köyü",
      "Hamidiyekızılcaören Köyü",
      "Haymana Köyü",
      "Işıkkara Köyü",
      "Işıkkara Mah (ışıkkara Köyü)",
      "İhsaniye Köyü",
      "İncik Köyü",
      "İnli Köyü",
      "İnlice Mah (ovacık Köyü)",
      "İshak Seydi Mah",
      "İshakçılar Köyü",
      "İstasyon Mah (çöğürler Köyü)",
      "Kalburcu Çiftliği Mah (sabuncupınar Köyü)",
      "Karaağaç Köyü",
      "Karacaören Köyü",
      "Karaöz Köyü",
      "Karsak Köyü",
      "Kaynarca Köyü",
      "Kepez Köyü",
      "Kınık Köyü",
      "Kıranşeyh Köyü",
      "Kızık Köyü",
      "Kızılcakaya Köyü",
      "Kirazlıyaylası Köyü",
      "Kireç Köyü",
      "Koçak Köyü",
      "Kozluca Köyü",
      "Köprüören Köyü",
      "Körpe Köyü",
      "Körs Köyü",
      "Kumluyurt Köyü",
      "Kuyusinir Köyü",
      "Kükürt Köyü",
      "Lütfiye Köyü",
      "Mahmudiye Köyü",
      "Makasalanı Köyü",
      "Merkez Mah (doğluşah Köyü)",
      "Merkez Mah (soğukçeşme Köyü)",
      "Muhatboğazı Köyü",
      "Mustafalar Köyü",
      "Nusret Köyü",
      "Ortaca Köyü",
      "Ovacık Köyü",
      "Porsuk Çiftliği Mah (göynükören Köyü)",
      "Pullar Köyü",
      "Sabuncupınar Köyü",
      "Sağırlar Köyü",
      "Sakaçiftliği Köyü",
      "Sekiören Köyü",
      "Sekiören Mah (sekiören Köyü)",
      "Seydiköy Köyü",
      "Sırören Köyü",
      "Sobran Köyü",
      "Sofça Köyü",
      "Soğukçeşme Köyü",
      "Söğüt Köyü",
      "Söğütyaylası Köyü",
      "Sökmen Köyü",
      "Sulu Köyü",
      "Sünnetyenice Köyü",
      "Tepeköy Köyü",
      "Teşvikiye Köyü",
      "Turgutlar Köyü",
      "Ulu Köyü",
      "Ürünlüçiftliği Köyü",
      "Yakaca Köyü",
      "Yaylababa Köyü",
      "Yazlıca Köyü",
      "Yeni Mah (demirciören Köyü)",
      "Yeni Mah (sobran Köyü)",
      "Yenice Çiftliği Mah (ahmetoluğu Köyü)",
      "Yenice Köyü",
      "Yenidoğan Mah (kızılcaören Köyü)",
      "Yenikaracaören Köyü",
      "Yenikızılcaören Köyü",
      "Yeşilbayır Köyü",
      "Yeşilyayla Mah (pullar Köyü)",
      "Yumaklı Köyü",
      "Bozcahöyük Mah (seyitömer Beldesi)",
      "Gültepe Mah (seyitömer Beldesi)",
      "Seyitler Mah (seyitömer Beldesi)"
    ],
    "Pazarlar": [
      "Akşinik Köyü",
      "Atatürk Mah (sofular Köyü)",
      "Kepez Mah (sofular Köyü)",
      "Menderes Mah (sofular Köyü)",
      "Orhanlar Köyü",
      "Örey Köyü",
      "Sarayköy Köyü",
      "Tepeköy Köyü",
      "Yapak Mah (örey Köyü)",
      "Yenice Köyü",
      "Adnanmenderes Mah",
      "Atatürk Mah",
      "Ayvalı Mah",
      "Fatih Mah",
      "Hocaahmetyesevi Mah",
      "Turgut Özal Mah",
      "Yakuplar Atatürk Mah",
      "Yakuplar Fatih Mah"
    ],
    "Simav": [
      "Cevizlik Mah (akdağ Beldesi)",
      "Kınık Mah (akdağ Beldesi)",
      "Savcılar Mah (akdağ Beldesi)",
      "Camii Kebir Mah (çitgöl Beldesi)",
      "Cumhuriyet Mah (çitgöl Beldesi)",
      "Çaysimav Mah (demirci Beldesi)",
      "Demirci Mah (demirci Beldesi)",
      "Karacalar Mah (demirci Beldesi)",
      "Öreyler Mah (demirci Beldesi)",
      "Cuma Mah (güney Beldesi)",
      "Fatih Mah (güney Beldesi)",
      "Dere Mah (kuşu Beldesi)",
      "Kadılar Mah (kuşu Beldesi)",
      "Kaya Mah (kuşu Beldesi)",
      "Yeni Mah (kuşu Beldesi)",
      "Ahlatlıçeşme Köyü",
      "Ahmetli Köyü",
      "Akpınar Köyü",
      "Aksaz Köyü",
      "Aksaz-mevki Mah (aksaz Köyü)",
      "Aksaz-oba Mah (aksaz Köyü)",
      "Alan Mah (çınarlıdere Köyü)",
      "Aşağı Mah (yavı Köyü)",
      "Aşağıdolaylar Köyü",
      "Atatürk Mah (bahtıllı Köyü)",
      "Azizler Mah (esenbağ Köyü)",
      "Bademli Köyü",
      "Başkonak Köyü",
      "Beciler Köyü",
      "Bedirler Köyü",
      "Beylikler Mah (beciler Köyü)",
      "Boğazköy Köyü",
      "Büdüz Mah (hasanören Köyü)",
      "Cumhuriyet Mah (bahtıllı Köyü)",
      "Cumhuriyet Mah (beyce Köyü)",
      "Cumhuriyet Mah (gümüşsu Köyü)",
      "Cumhuriyet Mah (yeniköy Köyü)",
      "Çakırlar Köyü",
      "Çamlık Köyü",
      "Çınarlıdere Köyü",
      "Çobanlar Mah (yeniköy Köyü)",
      "Çulhalar Köyü",
      "Darıcı Mah (yeşildere Köyü)",
      "Dereköy Köyü",
      "Dereyüzüdere Köyü",
      "Efedamlar Mah (karakoca Köyü)",
      "Efir Köyü",
      "Eğdemir Köyü",
      "Eğirler Köyü",
      "Esenbağ Köyü",
      "Evciler Köyü",
      "Fatih Mah (kestel Köyü)",
      "Fatih Mah (yeniköy Köyü)",
      "Gazi Mah (kestel Köyü)",
      "Gazi Mah (yaykın Köyü)",
      "Gılmanlar Köyü",
      "Gökçeler Köyü",
      "Gökçepınar Mah (yeşilköy Köyü)",
      "Gölköy Köyü",
      "Gurbetler Mah (çınarlıdere Köyü)",
      "Güney Mah (sudöşeği Köyü)",
      "Güzelyurt Köyü",
      "Hacıhüseyinefendi Köyü",
      "Hasanören Köyü",
      "Hıdırdivanı Köyü",
      "Hisar Mah (karacahisar Köyü)",
      "Hisarbey Mah (hisarbey Köyü)",
      "Hürriyet Mah (beyce Köyü)",
      "Hürriyet Mah (gümüşsu Köyü)",
      "Ihlamur Köyü",
      "İmranlar Köyü",
      "İnkaya Köyü",
      "İnlice Köyü",
      "Kabaşlar Mah (koyunoba Köyü)",
      "Kaili Mah (evciler Köyü)",
      "Kapıkaya Köyü",
      "Karacaören Köyü",
      "Karakoca Köyü",
      "Karapınar Köyü",
      "Kayaışık Köyü",
      "Kayalıdere Köyü",
      "Kızılcık Köyü",
      "Kiçir Köyü",
      "Koyunoba Köyü",
      "Kozanlar Mah (kapıkaya Köyü)",
      "Köseler Köyü",
      "Kurduman Köyü",
      "Kusumlar Köyü",
      "Külcü Köyü",
      "Küplüce Köyü",
      "Maden Köyü",
      "Maden Mah (külcü Köyü)",
      "Mahmutlar Mah (dereyüzüdere Köyü)",
      "Mamak Köyü",
      "Mercanlar Mah (kayalıdere Köyü)",
      "Mevlana Mah (yaykın Köyü)",
      "Mustafaefendi Mah (hacıhüseyinefendi Köyü)",
      "Ortacı Köyü",
      "Ören Mah (karacahisar Köyü)",
      "Örencik Köyü",
      "Örenli Köyü",
      "Özdere Mah (kalkan Köyü)",
      "Pulluca Köyü",
      "Rahimler Mah (şenköy Köyü)",
      "Samat Köyü",
      "Sarıçam Köyü",
      "Sarıkaya Köyü",
      "Sarkatlar Köyü",
      "Saya Mah (hıdırdivanı Köyü)",
      "Söğüt Köyü",
      "Sudöşeği Köyü",
      "Sünnetçiler Köyü",
      "Şenbirlik Mah (şenköy Köyü)",
      "Taşköy Köyü",
      "Taşlık Köyü",
      "Tepebaşı Mah (ıhlamur Köyü)",
      "Toklar Köyü",
      "Toklar Mah (akpınar Köyü)",
      "Yağıllar Köyü",
      "Yağmurlar Köyü",
      "Yassıeynihan Köyü",
      "Yavı Köyü",
      "Yayla Evleri-anıtlı Mah (sudöşeği Köyü)",
      "Yayla Evleri-korucuk Mah (sudöşeği Köyü)",
      "Yeni Mah",
      "Yeni Mah (kalkan Köyü)",
      "Yeni Mah (söğüt Köyü)",
      "Yeni Mah (yemişli Köyü)",
      "Yeni Mah (yeşilköy Köyü)",
      "Yeniler Köyü",
      "Yeşilçam Köyü",
      "Yeşilyayla Köyü",
      "Yeşilyayla Mah (yemişli Köyü)",
      "Yukarı Mah (yavı Köyü)",
      "Yukarıdolaylar Köyü",
      "Cumhuriyet Mah (naşa Beldesi)",
      "Fatih Mah (naşa Beldesi)",
      "Hamzabey Mah (naşa Beldesi)",
      "101 Evler Mah",
      "4 Eylül Mah",
      "Cuma Mah",
      "Çavdır Mah",
      "Değirmenciler Mah",
      "Esenevler Mah",
      "Fatih Mah",
      "Hacıahmetoğlu Mah",
      "Hisarardı Mah",
      "Karakür Mah",
      "Karşıyaka Mah",
      "Kekliktepe Mah",
      "Muradınlar Mah",
      "Sırapayam Mah",
      "Tabakhane Mah",
      "Tepecik Mah",
      "Yeşilova Mah"
    ],
    "Şaphane": [
      "Asmalı Mah (kızılkoltuk Köyü)",
      "Atatürk Mah (üçbaş Köyü)",
      "Ayvacık Köyü",
      "Cumhuriyet Mah (üçbaş Köyü)",
      "Çam Köyü",
      "Çatak Mah (ayvacık Köyü)",
      "Değirmendere Köyü",
      "Doktor Osman Mah (karamanca Köyü)",
      "Gaipler Köyü",
      "Gaziveli Mah (karamanca Köyü)",
      "Gürkuyu Köyü",
      "İnceğiz Köyü",
      "Karakaya Mah (gürkuyu Köyü)",
      "Karakür Köyü",
      "Karamustafalar Köyü",
      "Kayraklı Mah (kızılkoltuk Köyü)",
      "Kızılkoltuk Köyü",
      "Topalahmetler Mah (kızılkoltuk Köyü)",
      "Uğurlugüme Köyü",
      "Yeşilalan Mah (karamanca Köyü)",
      "Hacı Hasanlar Mah",
      "Kalabak Mah",
      "Karaağıl Mah",
      "Karacaderbent Mah",
      "Pazar Mah",
      "Subaşı Mah",
      "Türegün Mah"
    ],
    "Tavşanlı": [
      "Balıköy-çıvgalar Mah (balıköy Beldesi)",
      "Balıköy-kadı Mah (balıköy Beldesi)",
      "Balıköy-karaşehir Mah (balıköy Beldesi)",
      "Balıköy-kışla Mah (balıköy Beldesi)",
      "Balıköy-merkez Mah (balıköy Beldesi)",
      "Soluganlar Mah (balıköy Beldesi)",
      "Kuruçay-güzelyurt Mah (kuruçay Beldesi)",
      "Kuruçay-kocapınar Mah (kuruçay Beldesi)",
      "Kuruçay-ören Mah (kuruçay Beldesi)",
      "1 Mah (çobanlar Köyü)",
      "2 Mah (çaltılı Köyü)",
      "3 Mah (çaltılı Köyü)",
      "4 Mah (çaltılı Köyü)",
      "Ağaköy Köyü",
      "Akçaköy Köyü",
      "Akçaşehir Köyü",
      "Alabarda Köyü",
      "Aliköy-kemalsultan Mah (aliköy Köyü)",
      "Aliköy-zafer Mah (aliköy Köyü)",
      "Alpagut Mah (dudaş Köyü)",
      "Altınova Köyü",
      "Arifler Köyü",
      "Artıranlar Köyü",
      "Avcılar Köyü",
      "Aydınlar Köyü",
      "Ayvalı Köyü",
      "Baraj Kenarı Mah (dudaş Köyü)",
      "Başköy Köyü",
      "Benah Mah (kavaklı Köyü)",
      "Bozbelen Köyü",
      "Burhan Köyü",
      "Cevceller Mah (erikli Köyü)",
      "Çakıllı Köyü",
      "Çaldibi Köyü",
      "Çaltılı Köyü",
      "Çayırköy Köyü",
      "Çayıroluk Köyü",
      "Çıkrıcak Köyü",
      "Çınarcık Köyü",
      "Çobanköy Köyü",
      "Çobanköy Osb Mah (çobanköy Köyü)",
      "Çobanlar Köyü",
      "Çukurca Mah (karakişi Köyü)",
      "Dağdemirli Köyü",
      "Değirmisaz Köyü",
      "Derbent Köyü",
      "Derecik Köyü",
      "Devekayası Köyü",
      "Doğanlar Köyü",
      "Dudaş Köyü",
      "Dulkadir Mah (aliköy Köyü)",
      "Dutlar Köyü",
      "Dümrekhüseyinpaşa Köyü",
      "Dümrekorta Köyü",
      "Dümrekuluköy Köyü",
      "Eğriöz Köyü",
      "Elmaağacı Köyü",
      "Elmalı Köyü",
      "Emirler Köyü",
      "Erikli Köyü",
      "Eşen Köyü",
      "Gazelyakup Köyü",
      "Gevrekler Köyü",
      "Göbel Köyü",
      "Gökçeyurt Köyü",
      "Gölcük Köyü",
      "Gümüşgölcük Köyü",
      "Gümüşyeniköy Köyü",
      "Gürepınar Mah (çobanlar Köyü)",
      "Halil İbrahimler Mah (altınova Köyü)",
      "Haşhaşlık  Mah (çiftlik Mah) (erikli Köyü)",
      "İsaköy Köyü",
      "İstasyon Altı Mah (emirler Köyü)",
      "İstasyon Mah (kızılbük Köyü)",
      "Karaali Mah (kocayeri Köyü)",
      "Karacakaş Köyü",
      "Karakaya Köyü",
      "Karakişi Köyü",
      "Karaköy Köyü",
      "Karapelit Köyü",
      "Karcık Köyü",
      "Kargılı Köyü",
      "Karlı Köyü",
      "Kavaklı Köyü",
      "Kayaarası Köyü",
      "Kayı Köyü",
      "Kırkkavak Köyü",
      "Kışlademirli Köyü",
      "Kızılarman  Mah (tabaklı Mah) (erikli Köyü)",
      "Kızılbük Köyü",
      "Kızılçukur Köyü",
      "Kocayeri Köyü",
      "Kozluca Köyü",
      "Kömür İşletmesi Mah (kızılbük Köyü)",
      "Köprücek Köyü",
      "Köreken Köyü",
      "Köseler Köyü",
      "Madanlar Köyü",
      "Madanlar Mah (üyücek Köyü)",
      "Mehmet Eminler Mah (erikli Köyü)",
      "Nusretler Köyü",
      "Opanözü Köyü",
      "Ovacık Köyü",
      "Öksüzler Köyü",
      "Ören Köyü",
      "Paçasızlar Mah (karlı Köyü)",
      "Samaklı Mah (erikli Köyü)",
      "Sekbandemirli Köyü",
      "Şahin Köyü",
      "Şahmelek Köyü",
      "Şapçı Köyü",
      "Şapçıdede Köyü",
      "Şenlik Köyü",
      "Taşdibi Mah (erikli Köyü)",
      "Topallar Mah (altınova Köyü)",
      "Uluçam Köyü",
      "Üyücek Köyü",
      "Vakıf Köyü",
      "Yağmurlu Köyü",
      "Yataklı Köyü",
      "Yeniköy Köyü",
      "Yörgüç Köyü",
      "Ada Mah",
      "Bağlık Mah",
      "Beyköy Mah",
      "Çardaklı Mah",
      "Çırçırçeşme Mah",
      "Çukurköy Mah",
      "Dağçeşme Mah",
      "Dedeler Mah",
      "Durak Mah",
      "Hanımçeşme Mah",
      "İstasyon Mah",
      "Karakova Mah",
      "Kavaklı Mah",
      "Moymul Mah",
      "Ömerbey Mah",
      "Subaşı Mah",
      "Ulucami Mah",
      "Yeni Mah",
      "Yıldırım Beyazıt Mah",
      "Tepecik-aşağı Mah (tepecik Beldesi)",
      "Tepecik-orta Mah (tepecik Beldesi)",
      "Tepecik-yukarı Mah (tepecik Beldesi)",
      "Gürağaç Cevizli Mah (tunçbilek Beldesi)",
      "Gürağaç Çınar Mah (tunçbilek Beldesi)",
      "Tunçbilek Merkez Mah (tunçbilek Beldesi)",
      "Tunçbilek-çamaltı Mah (tunçbilek Beldesi)",
      "Tunçbilek-demirbilek Mah (tunçbilek Beldesi)",
      "Tunçbilek-hamitabat Mah (tunçbilek Beldesi)",
      "Tunçbilek-ışık Mah (tunçbilek Beldesi)",
      "Tunçbilek-köprübaşı Mah (tunçbilek Beldesi)"
    ]
  },
  "Malatya": {
    "Akçadağ": [
      "Aksaray Mah",
      "Aksüt Mah",
      "Aktepe Mah",
      "Aliçeri Mah",
      "Altunlu Mah",
      "Ancar Mah",
      "Aşağıörükçü Mah",
      "Aydınlar Mah",
      "Bağköy Mah",
      "Bahri Mah",
      "Başpınar Mah",
      "Bayramuşağı Mah",
      "Bekiruşağı Mah",
      "Bölüklü Mah",
      "Büyükçimiş Mah",
      "Büyükköy Mah",
      "Çakıllıpınar Mah",
      "Çatalbahçe Mah",
      "Çevirme Mah",
      "Çobanuşağı Mah",
      "Darıca Mah",
      "Dedeköy Mah",
      "Demirciler Mah",
      "Develi Mah",
      "Doğanlar Mah",
      "Doğantepe Mah",
      "Doğu Mah",
      "Durulova Mah",
      "Dutlu Mah",
      "Dümüklü Mah",
      "Eğin Mah",
      "Esenbey Mah",
      "Esenli Mah",
      "Fatih Mah",
      "Gölpınar Mah",
      "Güneşli Mah",
      "Gürkaynak Mah",
      "Hançerli Mah",
      "Hartut Mah",
      "Harunuşağı Mah",
      "Ilıcak Mah",
      "İkinciler Mah",
      "Kadıibrahim Mah",
      "Kahyalı Mah",
      "Karamağara Mah",
      "Karapınar Mah",
      "Kasımuşağı Mah",
      "Kayadibi Mah",
      "Keklikpınarı Mah",
      "Keller Mah",
      "Kepez Mah",
      "Kolköy Mah",
      "Kotangölü Mah",
      "Kozluca Mah",
      "Kömekavak Mah",
      "Kurtuşağı Mah",
      "Küçükkürne Mah",
      "Kültür Mah",
      "Levent Mah",
      "Mezra Mah",
      "Mihmanlı Mah",
      "Muratlı Mah",
      "Ortaköy Mah",
      "Ören Mah",
      "Resuluşağı Mah",
      "Sahilköy Mah",
      "Sakalıuzun Mah",
      "Sarıhacı Mah",
      "Şeyhler Mah",
      "Taşevler Mah",
      "Taşolar Mah",
      "Tataruşağı Mah",
      "Yağmurlu Mah",
      "Yalınbudak Mah",
      "Yalınkaya Mah",
      "Yaylımlı Mah",
      "Yukarıörükçü Mah"
    ],
    "Arapgir": [
      "Aktaş Mah",
      "Alıçlı Mah",
      "Aşağıçörenge Mah",
      "Aşağıulupınar Mah",
      "Aşağıyenice Mah",
      "Berenge Mah",
      "Boğazlı Mah",
      "Bostancık Mah",
      "Budak Mah",
      "Cömertli Mah",
      "Çakırsu Mah",
      "Çarşı Mah",
      "Çaybaşı Mah",
      "Çiğnir Mah",
      "Çimen Mah",
      "Çobanlı Mah",
      "Deregezen Mah",
      "Düzce Mah",
      "Eğnir Mah",
      "Esikli Mah",
      "Eskiarapgir Mah",
      "Gebeli Mah",
      "Göz Mah",
      "Gözeli Mah",
      "Günyüzü Mah",
      "Hezenek Mah",
      "Hocaali Mah",
      "Kayakesen Mah",
      "Kaynak Mah",
      "Kazanç Mah",
      "Kılıçlı Mah",
      "Konducak Mah",
      "Koru Mah",
      "Köseoğlu Mah",
      "Mehmetakif Mah",
      "Meşeli Mah",
      "Onar Mah",
      "Ormansırtı Mah",
      "Osmanpaşa Mah",
      "Pacalı Mah",
      "Pirali Mah",
      "Sekizsu Mah",
      "Selamlı Mah",
      "Serge Mah",
      "Sinikli Mah",
      "Sipahiuşağı Mah",
      "Suceyin Mah",
      "Sugeçti Mah",
      "Şağıluşağı Mah",
      "Şıhlar Mah",
      "Tarhan Mah",
      "Taşdelen Mah",
      "Taşdibek Mah",
      "Ulaçlı Mah",
      "Yaylacık Mah",
      "Yazılı Mah",
      "Yeni Mah",
      "Yeşilyayla Mah",
      "Yukarıçörenge Mah",
      "Yukarıulupınar Mah",
      "Yukarıyabanlı Mah",
      "Yukarıyenice Mah",
      "Zöhrap Mah"
    ],
    "Arguvan": [
      "Akören Mah",
      "Alhasuşağı Mah",
      "Armutlu Mah",
      "Asar Mah",
      "Asmaca Mah",
      "Aşağısülmenli Mah",
      "Bahçeli Mah",
      "Bahçelievler Mah",
      "Bozan Mah",
      "Çakmak Mah",
      "Çavuşköy Mah",
      "Çayırlı Mah",
      "Çevreli Mah",
      "Çiftlik Mah",
      "Dolaylı Mah",
      "Doydum Mah",
      "Ermişli Mah",
      "Eymir Mah",
      "Göçeruşağı Mah",
      "Gökağaç Mah",
      "Gümüşlü Mah",
      "Güngören Mah",
      "Gürge Mah",
      "Güveçli Mah",
      "Hakverdi Mah",
      "İçmece Mah",
      "İsaköy Mah",
      "Karababa Mah",
      "Karahüyük Mah",
      "Kızık Mah",
      "Kızıluşağı Mah",
      "Koçak Mah",
      "Konakbaşı Mah",
      "Kömürlük Mah",
      "Kuruttaş Mah",
      "Kuyudere Mah",
      "Morhamam Mah",
      "Narmikan Mah",
      "Parçikan Mah",
      "Şotik Mah",
      "Tarlacık Mah",
      "Tatkınık Mah",
      "Tepebağ Mah",
      "Yamaç Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yoncalı Mah",
      "Yukarısülmenli Mah",
      "Yürektaşı Mah"
    ],
    "Battalgazi": [
      "Adagören Mah",
      "Ağılyazı Mah",
      "Alacakapı Mah",
      "Alhanuşağı Mah",
      "Alişar Mah",
      "Aslanbey Mah",
      "Ataköy Mah",
      "B.hüseyinbey Mah",
      "Bağtepe Mah",
      "Bahçelievler Mah",
      "Bahri Mah",
      "Battalgazi Mah",
      "Beylerbaşı Mah",
      "Boran Mah",
      "Bulgurlu Mah",
      "Bulutlu Mah",
      "Cevherizade Mah",
      "Cirikpınar Mah",
      "Çamurlu Mah",
      "Çolaklı Mah",
      "Çolakoğlu Mah",
      "Dolamantepe Mah",
      "Düzyol Mah",
      "Ferhadiye Mah",
      "Fırıncı Mah",
      "Göller Mah",
      "Göztepe Mah",
      "Gülümuşağı Mah",
      "Hacıhaliloğluçiftliği Mah",
      "Hacıyusuflar Mah",
      "Hamidiye Mah",
      "Hasırcılar Mah",
      "Hatunsuyu Mah",
      "Hisartepe Mah",
      "İzzetiye Mah",
      "K.hüseyinbey Mah",
      "Kadıçayırı Mah",
      "Kamıştaş Mah",
      "Kapıkaya Mah",
      "Karabağlar Mah",
      "Karagöz Mah",
      "Karahan Mah",
      "Karakaşçiftliğiköyü Mah",
      "Karaköy Mah",
      "Karatepe Mah",
      "Kemerköprü Mah",
      "Kuluşağı Mah",
      "Merdivenler Mah",
      "Merkez Beydağı Mah",
      "Meydanbaşı Mah",
      "Meydancık Mah",
      "Pelitli Mah",
      "Serintepe Mah",
      "Sevildağ Mah",
      "Şehitfevzi Mah",
      "Şıkşık Mah",
      "Tanışık Mah",
      "Tokluca Mah",
      "Toptaş Mah",
      "Toygar Mah",
      "Uluköy Mah",
      "Üçbağlar Mah",
      "Üniversite Mah",
      "Üzümlü Mah",
      "Yamaç Mah",
      "Yarımcahan Mah",
      "Yaygın Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Beydağı Mah",
      "Çöşnük Mah",
      "Fırat Mah",
      "Akpınar Mah",
      "Dabakhane Mah",
      "Halfettin Mah",
      "İsmetiye Mah",
      "Kavaklıbağ Mah",
      "Kırçuval Mah",
      "Niyazi Mah",
      "Sancaktar Mah",
      "Şifa Mah",
      "Şişman Mah",
      "Yenihamam Mah",
      "Hanımınçiftliği Mah",
      "Selçuklu Mah",
      "Tandoğan Mah",
      "Yıldıztepe Mah",
      "Kernek Mah",
      "Saray Mah",
      "Zafer Mah",
      "Başharık Mah",
      "Hasan Varol Mah",
      "İstiklal Mah",
      "Paşaköşkü Mah",
      "Orduzu Mah",
      "B.mustafa Paşa Mah",
      "Hacı Abdi Mah",
      "K.mustafa Paşa Mah",
      "Nuriye Mah",
      "Hidayet Mah",
      "İskender Mah",
      "Sarıcıoğlu Mah",
      "Taştepe Mah"
    ],
    "Darende": [
      "Ağılbaşı Mah",
      "Ağılyazı Mah",
      "Akbaba Mah",
      "Akçatoprak Mah",
      "Akova Mah",
      "Aşağıulupınar Mah",
      "Ayvalı Mah",
      "Balaban Mah",
      "Barındır Mah",
      "Başkaya Mah",
      "Baytarbağı Mah",
      "Beybağı Mah",
      "Çaybaşı Mah",
      "Çaybaşı Osb Mah",
      "Çınar Mah",
      "Çukurkaya Mah",
      "Gaziköy Mah",
      "Gökçeören Mah",
      "Gökyar Mah",
      "Göllüce Mah",
      "Güdül Mah",
      "Günerli Mah",
      "Günpınar Mah",
      "Hacıderviş Mah",
      "Hacılar Sıragöz Mah",
      "Hacılar Şeyhli Mah",
      "Hacolar Mah",
      "Heyiketeği Mah",
      "Hisarcık Mah",
      "Hisarkale Mah",
      "Ilıca Mah",
      "Irmaklı Mah",
      "İbrahimpaşa Mah",
      "Kaldırım Mah",
      "Karabacak Mah",
      "Karabayır Mah",
      "Karaoğuz Mah",
      "Kavak Mah",
      "Kaynak Mah",
      "Kerimli Mah",
      "Kılıçbağı Mah",
      "Kölükler Mah",
      "Kurudere Mah",
      "Kuzpınar Mah",
      "Medişeyh Mah",
      "Mehmet Paşa Mah",
      "Mollauşağı Mah",
      "Nadir Mah",
      "Nurkuyusu Mah",
      "Ozan Mah",
      "Palanga Mah",
      "Sakarya Mah",
      "Sandıkkaya Mah",
      "Sayfiye Mah",
      "Sungur Mah",
      "Şendere Mah",
      "Şuğul Mah",
      "Uzunhasan Mah",
      "Üçpınar Mah",
      "Yarımca Mah",
      "Yavuzlar Mah",
      "Yazıköy Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yenipınar Mah",
      "Yeşiltaş Mah",
      "Yukarıulupınar Mah",
      "Zaviye Mah"
    ],
    "Doğanşehir": [
      "Altıntop Mah",
      "Beğre Mah",
      "Bıçakçı Mah",
      "Çavuşlu Mah",
      "Çığlık Mah",
      "Çömlekoba Mah",
      "Dedeyazı Mah",
      "Doğu Mah",
      "Elmalı Mah",
      "Erkenek Mah",
      "Esentepe Mah",
      "Eskiköy Mah",
      "Fındık Mah",
      "Gövdeli Mah",
      "Günedoğru Mah",
      "Gürobası Mah",
      "Güzelköy Mah",
      "Hudut Mah",
      "Kadılı Mah",
      "Kapıdere Mah",
      "Karanlıkdere Mah",
      "Karaterzi Mah",
      "Karşıyaka Mah",
      "Kelhalil Mah",
      "Kurucaova Mah",
      "Küçüklü Mah",
      "Örencik Mah",
      "Polat Mah",
      "Polatdere Mah",
      "Reşadiye Mah",
      "Savaklı Mah",
      "Söğüt Mah",
      "Suçatı Mah",
      "Sürgü Mah",
      "Şatıroba Mah",
      "Topraktepe Mah",
      "Yeni Mah",
      "Yolkoru Mah",
      "Yuvalı Mah"
    ],
    "Doğanyol": [
      "Akkent Mah",
      "Behramlı Mah",
      "Burçköy Mah",
      "Çolak Mah",
      "Damlı Mah",
      "Gevheruşağı Mah",
      "Gökçe Mah",
      "Gümüşsu Mah",
      "İsak Mah",
      "Koldere Mah",
      "Konurtay Mah",
      "Mezraa Mah",
      "Poyraz Mah",
      "Ulutaş Mah",
      "Yalınca Mah",
      "Yeşilköy Mah"
    ],
    "Hekimhan": [
      "Akmağara Mah",
      "Aksütlü Mah",
      "Aşağısazlıca Mah",
      "Bağyolu Mah",
      "Bahçedamı Mah",
      "Bahçelievler Mah",
      "Ballıkaya Mah",
      "Basak Mah",
      "Başkavak Mah",
      "Başkınık Mah",
      "Beykent Mah",
      "Boğazgören Mah",
      "Budaklı Mah",
      "Çanakpınar Mah",
      "Çimenlik Mah",
      "Çulhalı Mah",
      "Davulgu Mah",
      "Delihasanyurdu Mah",
      "Dereköy Mah",
      "Deveci Mah",
      "Dikenli Mah",
      "Dikili Mah",
      "Dumlu Mah",
      "Dursunlu Mah",
      "Fatih Mah",
      "Girmana Mah",
      "Güçlü Mah",
      "Güvenç Mah",
      "Güzelyayla Mah",
      "Güzelyurt Mah",
      "Hacılar Mah",
      "Hasançelebi Mah",
      "Haydaroğlu Mah",
      "Işıklı Mah",
      "İğdir Mah",
      "Karadere Mah",
      "Karaköçek Mah",
      "Karapınar Mah",
      "Karslılar Mah",
      "Karşıyaka Mah",
      "Kavacık Mah",
      "Kocaözü Mah",
      "Kozdere Mah",
      "Köprülü Mehmet Paşa Mah",
      "Köylüköyü Mah",
      "Kurşunlu Mah",
      "Mimar Sinan Mah",
      "Mollaibrahim Mah",
      "Salıcık Mah",
      "Saraylı Mah",
      "Sarıkız Mah",
      "Sazlıca Mah",
      "Söğüt Mah",
      "Şehit Mehmet Fethi Akyüz Mah",
      "Taşbaşı Mah",
      "Taşoluk Mah",
      "Turgut Özal Mah",
      "Uğurlu Mah",
      "Yağca Mah",
      "Yayladam Mah",
      "Yeni Mah",
      "Yeşilkale Mah",
      "Yeşilköy Mah",
      "Yeşilpınar Mah",
      "Yukarıselimli Mah"
    ],
    "Kale": [
      "Abuşoğlu Mah",
      "Akça Mah",
      "Akuşağı Mah",
      "Bağlıca Mah",
      "Bentköy Mah",
      "Çanakçı Mah",
      "Darıpınar Mah",
      "Dedeköy Mah",
      "Düztarla Mah",
      "Erdemli Mah",
      "Gülenköy Mah",
      "Güneyce Mah",
      "İkizpınar Mah",
      "Kaleköy Mah",
      "Karaağaç Mah",
      "Karahüseyin Mah",
      "Kıyıcak Mah",
      "Kozluk Mah",
      "Kumluyazı Mah",
      "Mahmut Dursun Mah",
      "Salkımlı Mah",
      "Sarıot Mah",
      "Soğukpınar Mah",
      "Tepebaşı Mah",
      "Uyanık Mah",
      "Uzunhüseyin Mah",
      "Üçdeğirmen Mah",
      "Yenidamlar Mah"
    ],
    "Kuluncak": [
      "Alvar Mah",
      "Aşağıselimli Mah",
      "Bahçelievler Mah",
      "Başören Mah",
      "Bıyıkboğazı Mah",
      "Bicir Mah",
      "Boğaziçi Mah",
      "Ciritbelen Mah",
      "Çayköy Mah",
      "Çörmü Mah",
      "Göğebakan Mah",
      "İlisuluk Mah",
      "İsmetpaşa Mah",
      "İstiklal Mah",
      "Karabük Mah",
      "Karaçayır Mah",
      "Karıncalık Mah",
      "Karlık Mah",
      "Kaynarca Mah",
      "Kızılhisar Mah",
      "Kızılmağara Mah",
      "Konaktepe Mah",
      "Kömüklü Mah",
      "Ortapınar Mah",
      "Sofular Mah",
      "Sultanlı Mah",
      "Temüklü Mah",
      "Yeni Mah"
    ],
    "Pütürge": [
      "Ağalar Mah",
      "Aktarla Mah",
      "Aliçeri Mah",
      "Alihan Mah",
      "Arınlı Mah",
      "Arıtoprak Mah",
      "Arslankent Mah",
      "Bakımlı Mah",
      "Balpınarı Mah",
      "Başmezra Mah",
      "Bayırköy Mah",
      "Belenköy Mah",
      "Bölükkaya Mah",
      "Bölünmez Mah",
      "Büyüköz Mah",
      "Çamlıdere Mah",
      "Çayköy Mah",
      "Çengelli Mah",
      "Çığırlı Mah",
      "Çukuroymağı Mah",
      "Deredüzü Mah",
      "Erdemler Mah",
      "Ersele Mah",
      "Esencik Mah",
      "Esenlik Mah",
      "Gertan Mah",
      "Gözlüce Mah",
      "Gündeğer Mah",
      "Gündüz Mah",
      "Hatip Mah",
      "Karakaya Mah",
      "Karşıyaka Mah",
      "Kavaklıdere Mah",
      "Kayadere Mah",
      "Koçköy Mah",
      "Korucak Mah",
      "Kozluk Mah",
      "Köklükaya Mah",
      "Körme Mah",
      "Köylü Mah",
      "Meşedibi Mah",
      "Nohutlu Mah",
      "Ormaniçi Mah",
      "Örencik Mah",
      "Örmeli Mah",
      "Örnekköy Mah",
      "Pazarcık Mah",
      "Poskıran Mah",
      "Sahilköy Mah",
      "Söğütlü Mah",
      "Şiro Taraksu Mah",
      "Şükan Mah",
      "Taşbaşı Mah",
      "Taşmış Mah",
      "Taştepe Mah",
      "Tatlıcak Mah",
      "Tekederesi Mah",
      "Teluşağı Mah",
      "Tepehan Mah",
      "Ulutaş Mah",
      "Uzunkoru Mah",
      "Uzuntaş Mah",
      "Üçyaka Mah",
      "Yamaç Mah",
      "Yandere Mah",
      "Yazıca Mah",
      "Yediyol Mah",
      "Yeşildere Mah"
    ],
    "Yazıhan": [
      "Akyazı Mah",
      "Alican Mah",
      "Ambarcık Mah",
      "Bahçelievler Mah",
      "Balaban Mah",
      "Bereketli Mah",
      "Boyaca Mah",
      "Boztepe Mah",
      "Böğürtlen Mah",
      "Buzluk Mah",
      "Çavuş Mah",
      "Çivril Mah",
      "Dedekargın Mah",
      "Doğuş Mah",
      "Durucasu Mah",
      "Eğribük Mah",
      "Epreme Mah",
      "Erecek Mah",
      "Fethiye Mah",
      "Gayret Mah",
      "Gövük Mah",
      "Hamidiye Mah",
      "İriağaç Mah",
      "Karaca Mah",
      "Koşar Mah",
      "Kömüşhan Mah",
      "Mısırdere Mah",
      "Sadıklı Mah",
      "Sinanlı Mah",
      "Sürür Mah",
      "Tahtalı Mah",
      "Tecirli Mah",
      "Yeni Mah"
    ],
    "Yeşilyurt": [
      "Bostanbaşı Mah",
      "Çarmuzu Mah",
      "Çavuşoğlu Mah",
      "İnönü Mah",
      "Salköprü Mah",
      "Dilek Mah",
      "Gündüzbey Mah",
      "Karakavak Mah",
      "Aşağı Bağlar Mah",
      "Çilesiz Mah",
      "Özalper Mah",
      "Şeyh Bayram Mah",
      "Tecde Mah",
      "Turgut Özal Mah",
      "Şahnahan Mah",
      "Topsöğüt Mah",
      "Yakınca Mah",
      "Gazi Mah",
      "Seyran Mah",
      "Yeşilkaynak Mah",
      "1.osb Mah",
      "2.osb Mah",
      "Abdulgaffar Mah",
      "Aşağıköy Mah",
      "Atalar Mah",
      "Atatürk Mah",
      "Bahçebaşı Mah",
      "Bentbaşı Mah",
      "Bindal Mah",
      "Cemalgürsel Mah",
      "Cevatpaşa Mah",
      "Cumhuriyet  Mah (yeşilyurt Mah)",
      "Cumhuriyet Mah",
      "Çayırköy Mah",
      "Çukurdere Mah",
      "Duranlar Mah",
      "Duruldu Mah",
      "Fatih Mah",
      "Gedik Mah",
      "Göktarla Mah",
      "Görgü Mah",
      "Gözene Mah",
      "Hamidiye Mah",
      "Hıroğlu Mah",
      "Hoca Ahmet Yesevi Mah",
      "Işıklı Mah",
      "İkizce Mah",
      "İlyas Mah",
      "Kadiruşağı Mah",
      "Karahan Mah",
      "Kaynarca Mah",
      "Kendirli Mah",
      "Kırkpınar Mah",
      "Kırlangıç Mah",
      "Kiltepe Mah",
      "Koşu Mah",
      "Koyunoğlu Mah",
      "Kozluk Mah",
      "Kuşdoğan Mah",
      "Kuyulu Mah",
      "Mahmutlu Mah",
      "Melekbaba Mah",
      "Merkez Fatih Mah",
      "Mullakasım Mah",
      "Oluklu Mah",
      "Ortaköy Mah",
      "Öncü Mah",
      "Özal Mah",
      "Salkonak Mah",
      "Samanköy Mah",
      "Samanlı Mah",
      "Seyituşağı Mah",
      "Su Mah",
      "Suluköy Mah",
      "Sütlüce Mah",
      "Tepeköy Mah",
      "Tohma Mah",
      "Topraktepe Mah",
      "Üçgöze Mah",
      "Yaka Mah",
      "Yalınkaya Mah",
      "Yavuz Selim Mah",
      "Yeni Mah",
      "Zaviye Mah"
    ]
  },
  "Manisa": {
    "Ahmetli": [
      "Alahıdır Mah",
      "Altıeylül Mah",
      "Ataköy Mah",
      "Bahçecik Mah",
      "Barbaros Mah",
      "Cambazlı Mah",
      "Dereköy Mah",
      "Derici Mah",
      "Dibekdere Mah",
      "Güldede Mah",
      "Hacıköseli Mah",
      "Halilkahya Mah",
      "Karaköy Mah",
      "Kargın Mah",
      "Kendirlik Mah",
      "Kestelli Mah",
      "Kurtuluş Mah",
      "Mandallı Mah",
      "Seydiköy Mah",
      "Ulu Cami Mah",
      "Yaraşlı Mah",
      "Zafer Mah",
      "Gökkaya Mah"
    ],
    "Akhisar": [
      "Akçaalan Mah",
      "Akçeşme Mah",
      "Akkocalı Mah",
      "Akselendi Mah",
      "Arabacıbozköy Mah",
      "Aşağıdolma Mah",
      "Atatürk Mah",
      "Ballıca Mah",
      "Başlamış Mah",
      "Bekirler Mah",
      "Beyoba Mah",
      "Boyalılar Mah",
      "Büknüş Mah",
      "Bünyanosmaniye Mah",
      "Cumhuriyet Mah",
      "Çamönü Mah",
      "Çanakçı Mah",
      "Çıtak Mah",
      "Çobanhasan Mah",
      "Çoruk Mah",
      "Dağdere Mah",
      "Dayıoğlu Mah",
      "Dereköy Mah",
      "Dingiller Mah",
      "Doğankaya Mah",
      "Doğuca Mah",
      "Dolmadeğirmen Mah",
      "Durasıl Mah",
      "Efendi Mah",
      "Erdelli Mah",
      "Eroğlu Mah",
      "Evkafteke Mah",
      "Göcek Mah",
      "Gökçeahmet Mah",
      "Gökçeler Mah",
      "Hacı İshak Mah",
      "Hacıibrahimler Mah",
      "Hacıosmanlar Mah",
      "Hamidiye Mah",
      "Hamitköy Mah",
      "Hanpaşa Mah",
      "Harmandalı Mah",
      "Has Hoca Mah",
      "Hasköy Mah",
      "Hürriyet Mah",
      "Işıkköy Mah",
      "İnönü Mah",
      "İsaca Mah",
      "Kabaağaçkıran Mah",
      "Kadıdağı Mah",
      "Kapaklı Mah",
      "Karabörklü Mah",
      "Karaköy Mah",
      "Karayağcı Mah",
      "Kavakalan Mah",
      "Kayalıoğlu Mah",
      "Kayganlı Mah",
      "Kethüda Mah",
      "Kızlaralanı Mah",
      "Kobaşdere Mah",
      "Kocakağan Mah",
      "Kömürcü Mah",
      "Kulaksızlar Mah",
      "Kurtulmuş Mah",
      "Mecidiye Mah",
      "Medar Mah",
      "Moralılar Mah",
      "Musaca Mah",
      "Musalar Mah",
      "Muştullar Mah",
      "Paşa Mah",
      "Pekmezci Mah",
      "Pınarcık Mah",
      "Ragıp Bey Mah",
      "Rahmiye Mah",
      "Reşat Bey Mah",
      "Sabancılar Mah",
      "Sağrakçı Mah",
      "Sakarkaya Mah",
      "Sarıçalı Mah",
      "Sarılar Mah",
      "Sarnıçköy Mah",
      "Sazoba Mah",
      "Seğirdim Mah",
      "Selçikli Mah",
      "Selvili Mah",
      "Seyit Ahmet Mah",
      "Sırtköy Mah",
      "Sindelli Mah",
      "Söğütlü Mah",
      "Süleymanköy Mah",
      "Süleymanlı Mah",
      "Süleymanlı Osb Mah",
      "Sünnetçiler Mah",
      "Şehitler Mah",
      "Şeyhisa Mah",
      "Taşçılar Mah",
      "Topluca Mah",
      "Tütenli Mah",
      "Ulu Camii Mah",
      "Ulupınar Mah",
      "Üçavlu Mah",
      "Yatağan Mah",
      "Yayakırıldık Mah",
      "Yaykın Mah",
      "Yeğenoba Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Zeytinlibağ Mah",
      "Zeytinliova Mah"
    ],
    "Alaşehir": [
      "Akkeçili Mah",
      "Alhan Mah",
      "Aydoğdu Mah",
      "Azıtepe Mah",
      "Badınca Mah",
      "Bahadır Mah",
      "Bahçedere Mah",
      "Bahçeliköy Mah",
      "Baklacı Mah",
      "Barış Mah",
      "Belenyaka Mah",
      "Beşeylül Mah",
      "Caberburhan Mah",
      "Caberfakılı Mah",
      "Caberkamara Mah",
      "Çağlayan Mah",
      "Çakırcaali Mah",
      "Çamlıbel Mah",
      "Çarıkbozdağ Mah",
      "Çarıkkaralar Mah",
      "Çarıktekke Mah",
      "Çeşneli Mah",
      "Dağarlar Mah",
      "Dağhacıyusuf Mah",
      "Delemenler Mah",
      "Erenköy Mah",
      "Esen Tepe Mah",
      "Evrenli Mah",
      "Fatih Mah",
      "Girelli Mah",
      "Göbekli Mah",
      "Gülenyaka Mah",
      "Gülpınar Mah",
      "Gümüşçay Mah",
      "Gürsu Mah",
      "Hacıaliler Mah",
      "Hacıbey Mah",
      "Horzumalayaka Mah",
      "Horzumembelli Mah",
      "Horzumkeserler Mah",
      "Horzumsazdere Mah",
      "Ilgın Mah",
      "Ilıca Mah",
      "Işıklar Mah",
      "İsmailbey Mah",
      "İsmetiye Mah",
      "İstasyon Mah",
      "Karacalar Mah",
      "Karadağ Mah",
      "Kasaplı Mah",
      "Kestanederesi Mah",
      "Kozluca Mah",
      "Kurtuluş Mah",
      "Kurudere Mah",
      "Matarlı Mah",
      "Menderes Mah",
      "Narlıdere Mah",
      "Osmaniye Mah",
      "Örencik Mah",
      "Örnekköy Mah",
      "Sakarya Mah",
      "Sarıpınar Mah",
      "Sarısu Mah",
      "Selce Mah",
      "Serinköy Mah",
      "Serinyayla Mah",
      "Sobran Mah",
      "Soğanlı Mah",
      "Soğuksu Mah",
      "Soğukyurt Mah",
      "Subaşı Mah",
      "Şahyar Mah",
      "Şeyh Sinan Mah",
      "Tepeköy Mah",
      "Toygar Mah",
      "Türkmen Mah",
      "Üzümlü Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yuvacalı Mah",
      "Kavaklıdere Mah",
      "Kemaliye Mah",
      "Killik Mah",
      "Piyadeler Mah",
      "Uluderbent Mah",
      "Yeşilyurt Mah"
    ],
    "Demirci": [
      "Ahatlar Mah",
      "Ahmetler Mah",
      "Akdere Mah",
      "Akıncılar Mah",
      "Alaağaç Mah",
      "Armutlu Mah",
      "Ayvaalan Mah",
      "Azizbey Mah",
      "Bahçeler Mah",
      "Bardakçı Mah",
      "Bayramşah Mah",
      "Beyazıt Mah",
      "Boyacık Mah",
      "Bozçatlı Mah",
      "Bozköy Mah",
      "Büyükkıran Mah",
      "Camii Atik Mah",
      "Cumhuriyet Mah",
      "Çağıllar Mah",
      "Çamköy Mah",
      "Çamlıca Mah",
      "Çanakçı Mah",
      "Çandır Mah",
      "Çardaklı Mah",
      "Çataloluk Mah",
      "Danişmentler Mah",
      "Demirci Mah",
      "Doktor Mehmet Akarsu Mah",
      "Elek Mah",
      "Esenyurt Mah",
      "Eskihisar Mah",
      "Fatih Mah",
      "Gömeçler Mah",
      "Gümele Mah",
      "Gürçeşme Mah",
      "Güveli Mah",
      "Hacıbaba Mah",
      "Hacıhamza Mah",
      "Hacıhasan Mah",
      "Hacıtürbek Mah",
      "Hırkalı Mah",
      "Hoşçalar Mah",
      "Hüdük Mah",
      "Iklıkçı Mah",
      "İcikler Mah",
      "İçhisar Mah",
      "İmceler Mah",
      "İmrenler Mah",
      "İrişler Mah",
      "İsmailler Mah",
      "Karaisalar Mah",
      "Kargınışıklar Mah",
      "Kasımfakı Mah",
      "Kayaköy Mah",
      "Kayranokçular Mah",
      "Kazancı Mah",
      "Kerpiçlik Mah",
      "Kılavuzlar Mah",
      "Kışlak Mah",
      "Kovancı Mah",
      "Köylüce Mah",
      "Kulalar Mah",
      "Kuzeyir Mah",
      "Kuzuköy Mah",
      "Küçükkıran Mah",
      "Küçükoba Mah",
      "Küpeler Mah",
      "Marmaracık Mah",
      "Mezitler Mah",
      "Minnetler Mah",
      "Mithatpaşa Mah",
      "Öksüzlü Mah",
      "Ören Mah",
      "Örücüler Mah",
      "Pazar Mah",
      "Rahmanlar Mah",
      "Sağnıç Mah",
      "Sayık Mah",
      "Secaattin Mah",
      "Serçeler Mah",
      "Sevişler Mah",
      "Sinan Mah",
      "Sofular Mah",
      "Söğütçük Mah",
      "Şehreküstü Mah",
      "Talas Mah",
      "Taşokçular Mah",
      "Tekeler Mah",
      "Teperik Mah",
      "Ulacık Mah",
      "Üşümüş Mah",
      "Yağmur Mah",
      "Yarbasan Mah",
      "Yavaşlar Mah",
      "Yenice Mah",
      "Yeşildere Mah",
      "Yeşiloba Mah",
      "Yiğenler Mah",
      "Yiğitler Mah",
      "Durhasan Mah",
      "Mahmutlar Mah"
    ],
    "Gölmarmara": [
      "Atatürk Mah",
      "Ayanlar Mah",
      "Beyler Mah",
      "Çamköy Mah",
      "Çömlekçi Mah",
      "Değnekler Mah",
      "Eski Camii Mah",
      "Hacıbaştanlar Mah",
      "Hacıveliler Mah",
      "Hıroğlu Mah",
      "İhsaniye Mah",
      "İsmetpaşa Mah",
      "Kayaaltı Mah",
      "Kayapınar Mah",
      "Kılcanlar Mah",
      "Ozanca Mah",
      "Taşkuyucak Mah",
      "Tiyenli Mah",
      "Yeni Camii Mah",
      "Yeniköy Mah",
      "Yunuslar Mah"
    ],
    "Gördes": [
      "Çiçekli Mah",
      "Adnan Menderes Mah",
      "Akpınar Mah",
      "Atatürk Mah",
      "Balıklı Mah",
      "Bayat Mah",
      "Beğel Mah",
      "Beğenler Mah",
      "Benlieli Mah",
      "Beşeylül Mah",
      "Boyalı Mah",
      "Börez Mah",
      "Cuma Mah",
      "Çağlayan Mah",
      "Çatalarmut Mah",
      "Çiğiller Mah",
      "Dalkara Mah",
      "Dargıl Mah",
      "Deliçoban Mah",
      "Dereçiftlik Mah",
      "Dikilitaş Mah",
      "Divan Mah",
      "Doğanpınar Mah",
      "Dutluca Mah",
      "Efendili Mah",
      "Fundacık Mah",
      "Gülpınar Mah",
      "Hüseyni Baba Mah",
      "Kabakoz Mah",
      "Kalemoğlu Mah",
      "Karaağaç Mah",
      "Karakeçili Mah",
      "Karayağcı Mah",
      "Karayakup Mah",
      "Kaşıkçı Mah",
      "Kılcanlar Mah",
      "Kıranköy Mah",
      "Kıymık Mah",
      "Kızıldam Mah",
      "Kobaklar Mah",
      "Korubaşı Mah",
      "Köseler Mah",
      "Kuşlukköy Mah",
      "Kuyucakkarapınar Mah",
      "Kürekçi Mah",
      "Malaz Mah",
      "Malkoca Mah",
      "Nakıpağa Mah",
      "Oğulduruk Mah",
      "Pınarbaşı Mah",
      "Salur Mah",
      "Sarıaliler Mah",
      "Şahinkaya Mah",
      "Şeyhyayla Mah",
      "Tepeköy Mah",
      "Tüpüler Mah",
      "Ulgar Mah",
      "Uzunçam Mah",
      "Yakaköy Mah",
      "Yeniköy Mah",
      "Yeşilyurt Mah",
      "Evciler Mah",
      "Güneşli Mah",
      "Kayacık Mah"
    ],
    "Kırkağaç": [
      "Bakır Mah",
      "Gelenbe Mah",
      "İlyaslar Mah",
      "Karakurt Mah",
      "Alacalar Mah",
      "Alifakı Mah",
      "Bademli Mah",
      "Boduroğlu Mah",
      "Bostancı Mah",
      "Cinosman Mah",
      "Çaltıcak Mah",
      "Çiftlik Mah",
      "Çobanlar Mah",
      "Demirtaş Mah",
      "Dualar Mah",
      "Fırdanlar Mah",
      "Gebeler Mah",
      "Gökçukur Mah",
      "Güvendik Mah",
      "Hacet Mah",
      "Hacıhimmet Mah",
      "Halkahavlu Mah",
      "Hamidiye Mah",
      "Hamitli Mah",
      "Hıdırağa Mah",
      "Işıklar Mah",
      "Kadriye Mah",
      "Karaali Mah",
      "Kayadibi Mah",
      "Kınık Mah",
      "Kocaiskan Mah",
      "Kocamehmetağa Mah",
      "Kuyucak Mah",
      "Küçükyaya Mah",
      "Memiş Mah",
      "Musahoca Mah",
      "Musalar Mah",
      "Öveçli Mah",
      "Sakarlı Mah",
      "Sarıağa Mah",
      "Siledik Mah",
      "Söğütalan Mah",
      "Şair Eşref Mah",
      "Tevfikiye Mah",
      "Yağmurlu Mah",
      "Yeni Mah",
      "Zorağa Mah"
    ],
    "Köprübaşı": [
      "Akçaalan Mah",
      "Alanyolu Mah",
      "Armağan Mah",
      "Arpacı Mah",
      "Atatürk Mah",
      "Azimli Mah",
      "Borlu Mah",
      "Bozburun Mah",
      "Cıcıklı Mah",
      "Çarıklar Mah",
      "Çavullar Mah",
      "Çayköy Mah",
      "Döğüşeren Mah",
      "Esat Mah",
      "Gökveliler Mah",
      "Gölbaşı Mah",
      "Gülpınar Mah",
      "Gündoğdu Mah",
      "İkizkuyu Mah",
      "Karaelmacık Mah",
      "Karyağdı Mah",
      "Kasar Mah",
      "Kavakyeri Mah",
      "Kemhallı Mah",
      "Kıdırcık Mah",
      "Kınık Mah",
      "Kıranşeyh Mah",
      "Killik Mah",
      "Kozaklı Mah",
      "Kulalı Mah",
      "Kurtlar Mah",
      "Mehmet Akif Ersoy Mah",
      "Mestanlı Mah",
      "Namık Kemal Mah",
      "Rağıllar Mah",
      "Saraycık Mah",
      "Sargaç Mah",
      "Selviler Mah",
      "Temrek Mah",
      "Tokmaklı Mah",
      "Uğurlu Mah",
      "Yabacı Mah",
      "Yardere Mah",
      "Yenice Mah",
      "Yeşilköy Mah",
      "Yumuklar Mah"
    ],
    "Kula": [
      "4 Eylül Mah",
      "Ahmetli Mah",
      "Akgün Mah",
      "Aktaş Mah",
      "Ayazören Mah",
      "Ayvatlar Mah",
      "Balıbey Mah",
      "Başıbüyük Mah",
      "Battalmustafa Mah",
      "Bayramşah Mah",
      "Bebekli Mah",
      "Bey Mah",
      "Börtlüce Mah",
      "Camii Cedit Mah",
      "Çarıkballı Mah",
      "Çarıkmahmutlu Mah",
      "Çiftçiibrahim Mah",
      "Dereköy Mah",
      "Emre Mah",
      "Encekler Mah",
      "Erenbağı Mah",
      "Eroğlu Mah",
      "Esenyazı Mah",
      "Evciler Mah",
      "Gökçeören Mah",
      "Gökdere Mah",
      "Gölbaşı Mah",
      "Güvercinlik Mah",
      "Hacıtufan Mah",
      "Hamidiye Mah",
      "Hayalli Mah",
      "İbrahimağa Mah",
      "İncesu Mah",
      "Kalınharman Mah",
      "Karaoba Mah",
      "Kavacık Mah",
      "Kenger Mah",
      "Kızılkaya Mah",
      "Konurca Mah",
      "Körez Mah",
      "Narıncalıpıtrak Mah",
      "Narıncalısüleyman Mah",
      "Ortaköy Mah",
      "Papuçlu Mah",
      "Sandal Mah",
      "Saraçlar Mah",
      "Sarnıç Mah",
      "Seyitali Mah",
      "Söğütdere Mah",
      "Şehitlioğlu Mah",
      "Şeremet Mah",
      "Şeritli Mah",
      "Şıhlı Mah",
      "Tatlıçeşme Mah",
      "Topuzdamları Mah",
      "Yağbastı Mah",
      "Yeniköy Mah",
      "Yeşilyayla Mah",
      "Yurtbaşı Mah",
      "Zaferiye Mah"
    ],
    "Salihli": [
      "Adala Mah",
      "Durasıllı Mah",
      "Akçaköy Mah",
      "Akören Mah",
      "Akyar Mah",
      "Allahdiyen Mah",
      "Bağcılar Mah",
      "Bahçecik Mah",
      "Başlıoğlu Mah",
      "Beylikli Mah",
      "Burhan Mah",
      "Caferbey Mah",
      "Çakaldoğanlar Mah",
      "Çaltılı Mah",
      "Çamurhamamı Mah",
      "Çapaklı Mah",
      "Çavlu Mah",
      "Çayköy Mah",
      "Çaypınar Mah",
      "Çelikli Mah",
      "Çökelek Mah",
      "Çukuroba Mah",
      "Damatlı Mah",
      "Delibaşlı Mah",
      "Derbent Mah",
      "Dombaylı Mah",
      "Eldelek Mah",
      "Eminbey Mah",
      "Emirhacılı Mah",
      "Gökçeköy Mah",
      "Gökeyüp Mah",
      "Gökköy Mah",
      "Hacıbektaşlı Mah",
      "Hacıhıdır Mah",
      "Hacıköseli Mah",
      "Hacılı Mah",
      "Hasalan Mah",
      "İğdecik Mah",
      "Kabazlı Mah",
      "Kale Mah",
      "Kapancı Mah",
      "Kaplan Mah",
      "Karaağaç Mah",
      "Karaoğlanlı Mah",
      "Karapınar Mah",
      "Karasavcı Mah",
      "Karayahşi Mah",
      "Kemer Mah",
      "Kemerdamları Mah",
      "Kırdamları Mah",
      "Kızılhavlu Mah",
      "Kordon Mah",
      "Köseali Mah",
      "Kurttutan Mah",
      "Mamatlı Mah",
      "Mersindere Mah",
      "Mersinli Mah",
      "Mevlutlu Mah",
      "Oraklar Mah",
      "Ortaköy Mah",
      "Pazarköy Mah",
      "Poyraz Mah",
      "Poyrazdamları Mah",
      "Salihli Osb Mah",
      "Sindel Mah",
      "Süleymaniye Mah",
      "Şirinyer Mah",
      "Taytan Mah",
      "Tekelioğlu Mah",
      "Torunlu Mah",
      "Üçtepe Mah",
      "Yağbasan Mah",
      "Yağmurlar Mah",
      "Yeniköy Mah",
      "Yenipazar Mah",
      "Yeşilkavak Mah",
      "Yeşilova Mah",
      "Aksoy Mah",
      "Atatürk Mah",
      "Barış Mah",
      "Beşeylül Mah",
      "Cumhuriyet Mah",
      "Dedetaşı Mah",
      "Eski Cami Mah",
      "Gaffar Okkan Mah",
      "Gaziler Mah",
      "Gümüş Mah",
      "Güneş Mah",
      "Keli Mah",
      "Kırveli Mah",
      "Kocaçeşme Mah",
      "Kurtuluş Mah",
      "Mitatpaşa Mah",
      "Namık Kemal Mah",
      "Özyurt Mah",
      "Sağlık Mah",
      "Sarıpınar Mah",
      "Seyrantepe Mah",
      "Şehitler Mah",
      "Yeşilyurt Mah",
      "Yılmaz Mah",
      "Yörük Mah",
      "Zafer Mah",
      "Sart Mah"
    ],
    "Sarıgöl": [
      "Afşar Mah",
      "Ahmetağa Mah",
      "Alemşahlı Mah",
      "Aşağı Koçaklar Mah",
      "Ayan Mah",
      "Bağlıca Mah",
      "Bahadırlar Mah",
      "Baharlar Mah",
      "Bereketli Mah",
      "Beyharmanı Mah",
      "Cumhuriyet Mah",
      "Çanakçı Mah",
      "Çavuşlar Mah",
      "Çimentepe Mah",
      "Dadağlı Mah",
      "Dindarlı Mah",
      "Doğuşlar Mah",
      "Emcelli Mah",
      "Güneydamları Mah",
      "Günyaka Mah",
      "Kahramanlar Mah",
      "Karacaali Mah",
      "Kızılçukur Mah",
      "Konak Mah",
      "Mimar Sinan Mah",
      "Özpınar Mah",
      "Selimiye Mah",
      "Sığırtmaçlı Mah",
      "Siteler Mah",
      "Şeyhdavutlar Mah",
      "Tırazlar Mah",
      "Yeniköy Mah",
      "Yeşiltepe Mah",
      "Yukarıkoçaklar Mah",
      "Ziyanlar Mah"
    ],
    "Saruhanlı": [
      "Alibeyli Mah",
      "Büyükbelen Mah",
      "Dilek Mah",
      "Gökçeköy Mah",
      "Gümülceli Mah",
      "Hacırahmanlı Mah",
      "Halitpaşa Mah",
      "İshakçelebi Mah",
      "Koldere Mah",
      "Kumkuyucak Mah",
      "Mütevelli Mah",
      "Nuriye Mah",
      "Paşaköy Mah",
      "Adiloba Mah",
      "Apak Mah",
      "Atatürk Mah",
      "Aydınlar Mah",
      "Azimli Mah",
      "Bahadır Mah",
      "Bedeller Mah",
      "Cengiz Topel Mah",
      "Cumhuriyet Mah",
      "Çakmaklı Mah",
      "Çaltepe Mah",
      "Çamlıyurt Mah",
      "Çerkez Osmaniye Mah",
      "Çınaroba Mah",
      "Çullugörece Mah",
      "Develi Mah",
      "Gözlet Mah",
      "Hacımusa Mah",
      "Hatıplar Mah",
      "Heybeli Mah",
      "İstasyon Mah",
      "Kayışlar Mah",
      "Kemiklidere Mah",
      "Kepenekli Mah",
      "Koyuncu Mah",
      "Kurtuluş Mah",
      "Lütfiye Mah",
      "Pınarbaşı Mah",
      "Sarıçam Mah",
      "Sarısığırlı Mah",
      "Saruhan Mah",
      "Seyitoba Mah",
      "Şatırlar Mah",
      "Şehitler Mah",
      "Taşdibi Mah",
      "Tirkeş Mah",
      "Yılmaz Mah"
    ],
    "Selendi": [
      "Akçakertil Mah",
      "Altınköy Mah",
      "Aşağıtefen Mah",
      "Avlaşa Mah",
      "Bekirağalar Mah",
      "Beypınar Mah",
      "Çalıklı Mah",
      "Çamköy Mah",
      "Çamlıca Mah",
      "Çampınar Mah",
      "Çamyayla Mah",
      "Çanşa Mah",
      "Çıkrıkçı Mah",
      "Çinan Mah",
      "Çortak Mah",
      "Dedeler Mah",
      "Dumanlar Mah",
      "Eskicami Mah",
      "Eskin Mah",
      "Fatih Mah",
      "Gölbaşı Mah",
      "Hacıhaliller Mah",
      "Hacılar Mah",
      "Halılar Mah",
      "Havaoğlu Mah",
      "İnnice Mah",
      "Kabaklar Mah",
      "Karabeyler Mah",
      "Karakozan Mah",
      "Karaselendi Mah",
      "Karataşterziler Mah",
      "Karşıova Mah",
      "Kayranlar Mah",
      "Kazıklı Mah",
      "Kınık Mah",
      "Kurşunlu Mah",
      "Kurtuluş Mah",
      "Kürkçü Mah",
      "Mıdıklı Mah",
      "Mollaahmetler Mah",
      "Omurlar Mah",
      "Pınarlar Mah",
      "Rahmanlar Mah",
      "Selmanhacılar Mah",
      "Şehirlioğlu Mah",
      "Şerefiye Mah",
      "Tavak Mah",
      "Tepeynihan Mah",
      "Turpçu Mah",
      "Yağcı Mah",
      "Yenicami Mah",
      "Yenice Mah",
      "Yeşil Mah",
      "Yıldız Mah",
      "Yukarıtefen Mah",
      "Zafer Mah",
      "Zıramanlar Mah"
    ],
    "Soma": [
      "Avdan Mah",
      "Cenkyeri Mah",
      "Adil Mah",
      "Akçaavlu Mah",
      "Atatürk Mah",
      "Bayat Mah",
      "Beyce Mah",
      "Boncuklu Mah",
      "Bozarmut Mah",
      "Büyük Güney Mah",
      "Büyük Işıklar Mah",
      "Cuma Mah",
      "Cumhuriyet Mah",
      "Çatalçam Mah",
      "Çavdır Mah",
      "Çevircek Mah",
      "Darkale Mah",
      "Deniş Mah",
      "Dereköy Mah",
      "Devlethan Mah",
      "Dualar Mah",
      "Duğla Mah",
      "Eğnez Mah",
      "Evciler Mah",
      "Göktaş Mah",
      "Hacıyusuf Mah",
      "Hamidiye  Mah (merkez Mah)",
      "Hamidiye Mah",
      "Hatun Mah",
      "Heciz Mah",
      "Hürriyet Mah",
      "İnönü Mah",
      "İstasyon Mah",
      "Kaplan Mah",
      "Karacahisar Mah",
      "Karacakaş Mah",
      "Karaçam Mah",
      "Karamanlı Mah",
      "Kayrakaltı Mah",
      "Kızılören Mah",
      "Kiraz Mah",
      "Kobaklar Mah",
      "Koyundere Mah",
      "Kozanlı Mah",
      "Kozluören Mah",
      "Kum Mah",
      "Kurtuluş Mah",
      "Küçük Güney Mah",
      "Menteşe Mah",
      "Naldöken Mah",
      "Namazgah Mah",
      "Nihat Danışman Mah",
      "Onüç Eylül Mah",
      "Pirahmet Mah",
      "Samsacı Mah",
      "Sarıkaya Mah",
      "Sevişler Mah",
      "Söğütçük Mah",
      "Sultaniye Mah",
      "Tabanlar Mah",
      "Tekeli Işıklar Mah",
      "Türkali Mah",
      "Türkpiyala Mah",
      "Ularca Mah",
      "Uruzlar Mah",
      "Vakıflı Mah",
      "Yayladalı Mah",
      "Yırca Mah",
      "Zafer Mah",
      "Turgutalp Mah",
      "Yağcılı Mah"
    ],
    "Şehzadeler": [
      "Aşağıçobanisa Mah",
      "1.anafartalar Mah",
      "2.anafartalar Mah",
      "Alaybey Mah",
      "Arda Mah",
      "Dinçer Mah",
      "Nişancıpaşa Mah",
      "Peker Mah",
      "Sakarya Mah",
      "Şehitler Mah",
      "Yarhasanlar Mah",
      "Hacıhaliller Mah",
      "Karaağaçlı Mah",
      "Adakale Mah",
      "Akıncılar Mah",
      "Bayındırlık Mah",
      "Çarşı Mah",
      "Dere Mah",
      "Dilşikar Mah",
      "Ege Mah",
      "Gediz Mah",
      "Göktaşlı Mah",
      "İbrahimçelebi Mah",
      "İshakçelebı Mah",
      "Kocatepe Mah",
      "Mimarsinan Mah",
      "Saruhan Mah",
      "Tunca Mah",
      "Utku Mah",
      "Karaoğlanlı Mah",
      "Adnan Menderes Mah",
      "Ahmet Bedevi Mah",
      "Akpınar Mah",
      "Kazım Karabekir Mah",
      "Kuşlubahçe Mah",
      "Nurlupınar Mah",
      "Turgut Özal Mah",
      "Sancaklıbozköy Mah",
      "Ayvacık Mah",
      "Belenyenice Mah",
      "Çamköy Mah",
      "Çavuşoğlu Mah",
      "Çerkezmahmudiye Mah",
      "Çınarlıkuyu Mah",
      "Gökbel Mah",
      "Güzelköy Mah",
      "Halıtlı Mah",
      "Hamzabeyli Mah",
      "Kağan Mah",
      "Kaleköy Mah",
      "Kalemli Mah",
      "Karayenice Mah",
      "Kırançiftliği Mah",
      "Sancaklıçeşmebaşı Mah",
      "Sancaklıiğdecik Mah",
      "Sancaklıkayadibi Mah",
      "Sancaklıuzunçınar Mah",
      "Sarıalan Mah",
      "Selimşahlar Mah",
      "Tekeliler Mah",
      "Tepecik Mah",
      "Tilkisüleymaniye Mah",
      "Veziroğlu Mah",
      "Yeniharmandalı Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yukarıçobanisa Mah"
    ],
    "Turgutlu": [
      "Derbent Mah",
      "Acarlar Mah",
      "Akçapınar Mah",
      "Akköy Mah",
      "Albayrak Mah",
      "Altay Mah",
      "Aşağıbozkır Mah",
      "Atatürk Mah",
      "Avşar Mah",
      "Ayvacık Mah",
      "Baktırlı Mah",
      "Bozkır Mah",
      "Bozkurt Mah",
      "Cumhuriyet Mah",
      "Çampınar Mah",
      "Çatalköprü Mah",
      "Çepnibektaş Mah",
      "Çepnidere Mah",
      "Çıkrıkçı Mah",
      "Dağyeniköy Mah",
      "Dalbahçe Mah",
      "Ergenekon Mah",
      "Gökgedik Mah",
      "Güney Mah",
      "Hacıisalar Mah",
      "Irlamaz Mah",
      "İstasyonaltı Mah",
      "İstiklal Mah",
      "İzzettin Mah",
      "Kabaçınar Mah",
      "Karaköy Mah",
      "Karaoluk Mah",
      "Kayrak Mah",
      "Kurtuluş Mah",
      "Kurudere Mah",
      "Kuşlar Mah",
      "Musacalı Mah",
      "Musalaryeniköy Mah",
      "Mustafa Kemal Mah",
      "Osmancık Mah",
      "Ören Mah",
      "Özyurt Mah",
      "Sarıbey Mah",
      "Selvilitepe Mah",
      "Selvilitepeosb Mah",
      "Sinirli Mah",
      "Sivrice Mah",
      "Subaşı Mah",
      "Şehitler Mah",
      "Temrek Mah",
      "Turan Mah",
      "Turgutlar Mah",
      "Yakuplar Mah",
      "Yayla Mah",
      "Yedi Eylül Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yıldırım Mah",
      "Yılmazlar Mah",
      "Yiğitler Mah",
      "Yunusdere Mah",
      "Urganlı Mah"
    ],
    "Yunusemre": [
      "50.yıl Mah",
      "Atatürk Mah",
      "Barbaros Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Spil Mah",
      "75. Yıl Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Güzelyurt Mah",
      "Hafsa Sultan Mah",
      "Keçili Köy Mah",
      "Keçiliköyosb Mah",
      "Laleli Mah",
      "Mesir Mah",
      "Uncubozköy Mah",
      "Yeni Mahalle Mah",
      "Muradiye Mah",
      "Ayni Ali Mah",
      "Merkez Efendi Mah",
      "Tevfikiye Mah",
      "Üçpınar Mah",
      "Akçaköy Mah",
      "Akgedik Mah",
      "Akmescit Mah",
      "Asmacık Mah",
      "Avdal Mah",
      "Bağyolu Mah",
      "Beydere Mah",
      "Bostanlar Mah",
      "Büyüksümbüller Mah",
      "Çamlıca Mah",
      "Davutlar Mah",
      "Dazyurt Mah",
      "Demirci Mah",
      "Durasıllı Mah",
      "Düzlen Mah",
      "Emlakdere Mah",
      "Evrenos Mah",
      "Gökçeler Mah",
      "Gülbahçe Mah",
      "Gürle Mah",
      "İlyasçılar Mah",
      "Karaahmetli Mah",
      "Karaali Mah",
      "Karahüseyinli Mah",
      "Karakılıçlı Mah",
      "Karakoca Mah",
      "Karaveliler Mah",
      "Karayağcıhacılar Mah",
      "Kayapınar Mah",
      "Kaynak Mah",
      "Kışlaköy Mah",
      "Kocakoru Mah",
      "Koruköy Mah",
      "Kozaklar Mah",
      "Kuyualan Mah",
      "Küçükbelen Mah",
      "Küçüksümbüller Mah",
      "Lalapaşa Mah",
      "Maldan Mah",
      "Mollasüleymanlı Mah",
      "Mutlu Mah",
      "Müslih Mah",
      "Ortaköy Mah",
      "Osmancalı Mah",
      "Otmanlar Mah",
      "Örencik Mah",
      "Örselli Mah",
      "Pelitalan Mah",
      "Pınarköy Mah",
      "Recepli Mah",
      "Sakallı Mah",
      "Sarıahmetli Mah",
      "Sarınasuhlar Mah",
      "Sarma Mah",
      "Seyitli Mah",
      "Sümbültepe Mah",
      "Süngüllü Mah",
      "Şamar Mah",
      "Topçuasım Mah",
      "Turgutalp Mah",
      "Türkmen Mah",
      "Uzunburun Mah",
      "Uzunlar Mah",
      "Yağcılar Mah",
      "Yaylaköy Mah",
      "Yuntdağıköseler Mah",
      "Yuntdağyenice Mah"
    ]
  },
  "Kahramanmaraş": {
    "Afşin": [
      "Afşinbey Mah",
      "Ağcaşar Mah",
      "Alemdar Mah",
      "Alimpınar Mah",
      "Alpaslan Mah",
      "Altaş Mah",
      "Altınelma Mah",
      "Anzorey Mah",
      "Arıtaş Mah",
      "Armutalan Mah",
      "Bakraç Mah",
      "Başüstü Mah",
      "Berçenek Mah",
      "Beyceğiz Mah",
      "Binboğa Mah",
      "Büget Mah",
      "Büyüksevin Mah",
      "Büyüktatlı Mah",
      "Çağılhan Mah",
      "Çobanbeyli Mah",
      "Çoğulhan Mah",
      "Çomudüz Mah",
      "Çukurpınar Mah",
      "Dağlıca Mah",
      "Dedebaba Mah",
      "Deveboynu Mah",
      "Dokuztay Mah",
      "Efsus Turan Mah",
      "Emirilyas Mah",
      "Emirli Mah",
      "Erçene Mah",
      "Esence Mah",
      "Gaziosmanpaşa Mah",
      "Gerger Mah",
      "Gözpınarı Mah",
      "Haticepınarı Mah",
      "Hurman Mah",
      "Hüyüklü Mah",
      "İğdemlik Mah",
      "İnci Mah",
      "İncirli Mah",
      "Kabaağaç Mah",
      "Kale Mah",
      "Kangal Mah",
      "Karagöz Mah",
      "Kaşanlı Mah",
      "Koçovası Mah",
      "Kötüre Mah",
      "Kuşkayası Mah",
      "Mehre Mah",
      "Nadır Mah",
      "Oğlakkayası Mah",
      "Ördek Mah",
      "Örenderesi Mah",
      "Örenli Mah",
      "Pınarbaşı Mah",
      "Soğucak Mah",
      "Söğütderesi Mah",
      "Tanır Mah",
      "Tatlar Mah",
      "Topaktaş Mah",
      "Türkçayırı Mah",
      "Türksevin Mah",
      "Yazıdere Mah",
      "Yazıköy Mah",
      "Yeşilyurt Mah"
    ],
    "Andırın": [
      "Akçakoyunlu Mah",
      "Akgümüş Mah",
      "Akifiye Mah",
      "Alameşe Mah",
      "Alanlı Mah",
      "Alınoluk Mah",
      "Altınboğa Mah",
      "Altınyayla Mah",
      "Anacık Mah",
      "Arıklar Mah",
      "Başdoğan Mah",
      "Bektaşlı Mah",
      "Beşbucak Mah",
      "Boğazören Mah",
      "Bostanlı Mah",
      "Boynuyoğunlu Mah",
      "Boztopraklı Mah",
      "Bulgurkaya Mah",
      "Camuzluk Mah",
      "Çiçekli Mah",
      "Çuhadarlı Mah",
      "Darıovası Mah",
      "Efirağızlı Mah",
      "Emirler Mah",
      "Erenler Mah",
      "Geben Mah",
      "Gökahmetli Mah",
      "Gökçeli Mah",
      "Gökgedik Mah",
      "Hacıveliuşağı Mah",
      "Kabaağaç Mah",
      "Kabaklar Mah",
      "Kaleboynu Mah",
      "Karapınar Mah",
      "Kargaçayırı Mah",
      "Kıyıkçı Mah",
      "Kızık Mah",
      "Köklü Mah",
      "Köleli Mah",
      "Kumarlı Mah",
      "Kuzgun Mah",
      "Pınarbaşı Mah",
      "Sumaklı Mah",
      "Tatarlı Mah",
      "Torun Mah",
      "Tufan Paşa Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilova Mah",
      "Yeşilyurt Mah",
      "Cambaz Mah",
      "Çiğşar Mah",
      "Çokak Mah",
      "Orhaniye Mah",
      "Osmancık Mah",
      "Rifatiye Mah",
      "Yeşiltepe Mah"
    ],
    "Çağlayancerit": [
      "Akdere Mah",
      "Aksu Mah",
      "Bayırlı Mah",
      "Boylu Mah",
      "Bozlar Mah",
      "Bölükdamlar Mah",
      "Emiruşağı Mah",
      "Engizek Mah",
      "Fatih Mah",
      "Helete Cumhuriyet Mah",
      "Helete Karadağ Mah",
      "Helete Yeşiloba Mah",
      "İstiklal Mah",
      "Kale Mah",
      "Küçükcerit Mah",
      "Küçüküngüt Mah",
      "Oruçpınar Mah",
      "Soğukpınar Mah",
      "Zeynepuşağı Mah"
    ],
    "Dulkadiroğlu": [
      "Divanlı Mah",
      "Ekmekçi Mah",
      "İsa Divanlı Mah",
      "İsmet Paşa Mah",
      "Kurtuluş Mah",
      "Menderes Mah",
      "Sakarya Mah",
      "Turan Mah",
      "Yeni Şehir Mah",
      "Abbaslar Mah",
      "Ağabeyli Mah",
      "Akyar Mah",
      "Alibeyuşağı Mah",
      "Arslanbey Çiftliği Mah",
      "Ayaklıcaoluk Mah",
      "Bahçeli Mah",
      "Başdevrişli Mah",
      "Baydemirli Mah",
      "Beşenli Mah",
      "Boyalı Mah",
      "Budaklı Mah",
      "Bulanık Mah",
      "Çatmayayla Mah",
      "Çınarlı Mah",
      "Çiğli Mah",
      "Çobanlı Mah",
      "Çokyaşar Mah",
      "Demirciler Mah",
      "Denizli Mah",
      "Dereköy Mah",
      "Dereli Mah",
      "Doğanlıkarahasan Mah",
      "Ekberoğlu Mah",
      "Elmalar Mah",
      "Eskinarlı Mah",
      "Gaffarlı Mah",
      "Göllü Mah",
      "Güneşevler Mah",
      "Güzelyurt Mah",
      "Hacıeyüplü Mah",
      "Halkaçayırı Mah",
      "Kabasakal Mah",
      "Kapıçam Mah",
      "Karamanlı Mah",
      "Kartal Mah",
      "Kazanlıpınar Mah",
      "Kemallı Mah",
      "Kılağlı Mah",
      "Kocolar Mah",
      "Kozludere Mah",
      "Kuzucak Mah",
      "Küçüknacar Mah",
      "Küpelikız Mah",
      "Maksutuşağı Mah",
      "Navruzlu Mah",
      "Osmanbey Mah",
      "Öksüzlü Mah",
      "Peynirdere Mah",
      "Sarıkaya Mah",
      "Seyrantepe Mah",
      "Sivricehüyük Mah",
      "Söğütlü Mah",
      "Şerefoğlu Mah",
      "Tevekkelli Mah",
      "Ulutaş Mah",
      "Yenipınar Mah",
      "Yeniyurt Mah",
      "Yusufhacılı Mah",
      "Aksu Mah",
      "Bağlarbaşı Mah",
      "Bahçeli Evler Mah",
      "Dulkadiroğlu Mah",
      "Egemenlik Mah",
      "Erkenez Mah",
      "Eyüp Sultan Mah",
      "Genç Osman Mah",
      "İstasyon Mah",
      "Kanuni Mah",
      "Karacasu Ferhuş Mah",
      "Karacasu Karaziyaret Mah",
      "Karacasu Karşıyaka Mah",
      "Karacasu Kırım Mah",
      "Karacasu Mamaraş Mah",
      "Karataş Mah",
      "Mehmet Akif Mah",
      "Namık Kemal Mah",
      "Sümer Mah",
      "Şeyh Adil Mah",
      "Şeyh Şamil Mah",
      "Yavuz Selim Mah",
      "Aslan Bey Mah",
      "Ballıca Mah",
      "Bayazıtlı Mah",
      "Doğu Kent Mah",
      "Duraklı Mah",
      "Fevzi Paşa Mah",
      "Gazi Paşa Mah",
      "Kayabaşı Mah",
      "Pınarbaşı Mah",
      "Senem Ayşe Mah",
      "Sütçü İmam Mah",
      "Yahya Kemal Mah",
      "Yeşiltepe Mah"
    ],
    "Ekinözü": [
      "Akpınar Mah",
      "Alişar Mah",
      "Altunyaprak Mah",
      "Anbar Mah",
      "Ataköy Mah",
      "Çiftlik Mah",
      "Çiftlikkale Mah",
      "Demirlik Mah",
      "Gaziler Mah",
      "Gözpınar Mah",
      "İçmeler Mah",
      "Kabaktepe Mah",
      "Kandil Mah",
      "Kürtül Mah",
      "Maarif Mah",
      "Ortaören Mah",
      "Öztürk Mah",
      "Soysallı Mah",
      "Türkeli Mah",
      "Türkmenler Mah",
      "Yeniköy Mah"
    ],
    "Elbistan": [
      "Ağlıca Mah",
      "Akarca Mah",
      "Akbayır Mah",
      "Akören Mah",
      "Aksakal Mah",
      "Alembey Mah",
      "Alkayaoğlu Mah",
      "Armutalan Mah",
      "Atmalıkaşanlı Mah",
      "Bahçelievler Mah",
      "Bakış Mah",
      "Balıkçıl Mah",
      "Battalgazi Mah",
      "Beştepe Mah",
      "Beyyurdu Mah",
      "Büyükyapalak Mah",
      "Ceyhan Mah",
      "Cumhuriyet Mah",
      "Çalış Mah",
      "Çatova Mah",
      "Çıtlık Mah",
      "Çiçek Mah",
      "Çiçek Osb Mah",
      "Demircilik Mah",
      "Dervişçimli Mah",
      "Doğan Mah",
      "Eldelek Mah",
      "Elmalı Mah",
      "Esentepe Mah",
      "Evcihüyük Mah",
      "Fakıoğlu Mah",
      "Geçit Mah",
      "Gökçek Mah",
      "Güblüce Mah",
      "Gücük Mah",
      "Gümüşdöven Mah",
      "Günaltı Mah",
      "Gündere Mah",
      "Güneşli Mah",
      "Güvercinlik Mah",
      "Hacıhasanlı Mah",
      "Hasanalili Mah",
      "Hasankendi Mah",
      "Horhor Mah",
      "Izgın Mah",
      "İğde Mah",
      "İkizpınar Mah",
      "İncecik Mah",
      "Kalaycık Mah",
      "Kalealtı Mah",
      "Kangal Mah",
      "Kantarma Mah",
      "Karaelbistan Mah",
      "Karahasanuşağı Mah",
      "Karahüyük Mah",
      "Karamağara Mah",
      "Kavaktepe Mah",
      "Kayageçit Mah",
      "Keçemağara Mah",
      "Kışla Mah",
      "Kızılcaoba Mah",
      "Köprübaşı Mah",
      "Körücek Mah",
      "Köseyahya Mah",
      "Köşk Mah",
      "Küçükyapalak Mah",
      "Kümbet Mah",
      "Orhangazi Mah",
      "Ovacık Mah",
      "Özbek Mah",
      "Özcanlı Mah",
      "Pınarbaşı Mah",
      "Sarıyatak Mah",
      "Sevdilli Mah",
      "Söğütlü Mah",
      "Sünnet Mah",
      "Tapkıran Mah",
      "Tapkırankale Mah",
      "Taşburun Mah",
      "Tepebaşı  Mah (gücük Mah)",
      "Tepebaşı Mah",
      "Topallı Mah",
      "Toprakhisar Mah",
      "Türkören Mah",
      "Uncular Mah",
      "Uzunpınar Mah",
      "Yalak Mah",
      "Yalıntaş Mah",
      "Yapılı Mah",
      "Yapılıpınar Mah",
      "Yapraklı Mah",
      "Yeşilyurt Mah",
      "Yoğunsöğüt Mah",
      "Yunus Emre Mah"
    ],
    "Göksun": [
      "Acıelma Mah",
      "Ahmetcik Mah",
      "Alıçlıbucak Mah",
      "Altınoba Mah",
      "Apıklar Mah",
      "Aslanbeyçiftliği Mah",
      "Bahçelievler Mah",
      "Bozarmut Mah",
      "Bozhüyük Mah",
      "Büyükçamurlu Mah",
      "Büyükkızılcık Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Çamdere Mah",
      "Çardak Mah",
      "Değirmendere Mah",
      "Doğankonak Mah",
      "Elmalı Mah",
      "Ericek Mah",
      "Esenköy Mah",
      "Fındık Mah",
      "Fındıklıkoyak Mah",
      "Gölpınar Mah",
      "Göynük Mah",
      "Gücüksu Mah",
      "Güldağı Mah",
      "Güller Mah",
      "Hacıkodal Mah",
      "Hacımirza Mah",
      "Hacıömer Mah",
      "Harbiye Mah",
      "Huğtaş Mah",
      "Kale Mah",
      "Kaleboynu Mah",
      "Kamışcık Mah",
      "Kanlıkavak Mah",
      "Karaahmet Mah",
      "Karaömer Mah",
      "Karatut Mah",
      "Kavşut Mah",
      "Kayabaşı Mah",
      "Kazandere Mah",
      "Keklikoluk Mah",
      "Kemalpaşa Mah",
      "Kınıkkoz Mah",
      "Kızılöz Mah",
      "Kireç Mah",
      "Korkmaz Mah",
      "Kömür Mah",
      "Köprübaşı Mah",
      "Kurtuluş Mah",
      "Küçükçamurlu Mah",
      "Mahmutbey Mah",
      "Mehmetbey Mah",
      "Mürsel Mah",
      "Ortatepe Mah",
      "Payamburnu Mah",
      "Pınarbaşı Mah",
      "Saraycık Mah",
      "Sırmalı Mah",
      "Soğukpınar Mah",
      "Tahirbey Mah",
      "Taşoluk Mah",
      "Temürağa Mah",
      "Tepebaşı Mah",
      "Tombak Mah",
      "Yağmurlu Mah",
      "Yantepe Mah",
      "Yeni Mah",
      "Yeniyapan Mah",
      "Yeşilköy Mah",
      "Yiricek Mah",
      "Yoğunoluk Mah"
    ],
    "Nurhak": [
      "Ağcaşar Mah",
      "Alçiçek Değirmenkaya Mah",
      "Barış Mah",
      "Biçin Mah",
      "Eskiköy Mah",
      "Gürsel Mah",
      "Hüyük Mah",
      "Karaçar Mah",
      "Karşıyaka Mah",
      "Kıyılar Mah",
      "Kullar Mah",
      "Pınarbaşı Mah",
      "Seyitaliler Mah",
      "Tatlar Mah",
      "Umutlu Mah",
      "Yeni Mah"
    ],
    "Onikişubat": [
      "5 Nisan Mah",
      "Abdülhamid Han Mah",
      "Ağcalı Mah",
      "Akçakoyunlu Mah",
      "Akif İnan Mah",
      "Bin Evler Mah",
      "Boğaziçi Mah",
      "Ceyhan Mah",
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Fatih Mah",
      "Gedemen Mah",
      "Hasancıklı Mah",
      "Haydar Bey Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karamanlı Mah",
      "Kavlaklı Mah",
      "Kazım Karabekir Mah",
      "Kılavuzlu Mah",
      "Maarif Mah",
      "Mağralı Mah",
      "Mercimektepe Mah",
      "Mimar Sinan Mah",
      "Necip Fazıl Mah",
      "Organize Sanayi Bölgesi Mah",
      "Orhangazi Mah",
      "Osman Gazi Mah",
      "Saçaklızade Mah",
      "Selçuklu Mah",
      "Serintepe Mah",
      "Süleymanşah Mah",
      "Şehit Abdullah Çavuş Mah",
      "Şehit Evliya Mah",
      "Tavşan Tepe Mah",
      "Tekerek Mah",
      "Üngüt Mah",
      "Yamaçtepe Mah",
      "Yirmiikigün Mah",
      "Yunus Emre Mah",
      "Yürükselim Mah",
      "Barbaros Mah",
      "Dumlupınar Mah",
      "Ertuğrul Gazi Mah",
      "Gayberli Mah",
      "Hacı Bayram Veli Mah",
      "Hayrullah Mah",
      "Karacaoğlan Mah",
      "Malik Ejder Mah",
      "Mevlana Mah",
      "Molla Gürani Mah",
      "Oruç Reis Mah",
      "Piri Reis Mah",
      "Şazi Bey Mah",
      "Vadi Mah",
      "Yusuflar Mah",
      "Altınova Mah",
      "Avcılar Mah",
      "Avgasır Mah",
      "Avşar Mah",
      "Ayşepınarı Mah",
      "Beşbağlar Mah",
      "Beşen Mah",
      "Bulutoğlu Mah",
      "Büyüksır Mah",
      "Cüceli Mah",
      "Çağırkan Mah",
      "Çağlayan Mah",
      "Çakırdere Mah",
      "Çakırlar Mah",
      "Çamlıbel Mah",
      "Çamlıca Mah",
      "Çevrepınar Mah",
      "Çokran Mah",
      "Çukurhisar Mah",
      "Dadağlı Mah",
      "Demrek Mah",
      "Dereboğazı Mah",
      "Döngel Mah",
      "Döngele Mah",
      "Dönüklü Mah",
      "Fatmalı Mah",
      "Gölpınar Mah",
      "Hacıağlar Mah",
      "Hacıbudak Mah",
      "Hacıibrahimuşağı Mah",
      "Hacılar Mah",
      "Hacımustafa Mah",
      "Hacınınoğlu Mah",
      "Hartlap Mah",
      "Ilıca Mah",
      "İsmailli Mah",
      "Kalakaya Mah",
      "Kale Mah",
      "Kapıkaya Mah",
      "Karadere Mah",
      "Kaynar Mah",
      "Kerimli Mah",
      "Kertmen Mah",
      "Kısıklı Mah",
      "Kızıldamlar Mah",
      "Kızılseki Mah",
      "Kozcağız Mah",
      "Köseli Mah",
      "Köşürge Mah",
      "Kumarlı Mah",
      "Kumaşır Mah",
      "Kurtlar Mah",
      "Kurucaova Mah",
      "Küçüksır Mah",
      "Kümperli Mah",
      "Kürtül Mah",
      "Maksutlu Mah",
      "Muratlı Mah",
      "Önsen Mah",
      "Öşlü Mah",
      "Öztürk Mah",
      "Payamlı Mah",
      "Rahmacılar Mah",
      "Reyhanlı Mah",
      "Sadıklı Mah",
      "Sarıçukur Mah",
      "Sarıgüzel Mah",
      "Sarımollalı Mah",
      "Saygılı Mah",
      "Selimiye Mah",
      "Suçatı Mah",
      "Suluyayla Mah",
      "Süleymanlı Mah",
      "Şahinkayası Mah",
      "Tekir Mah",
      "Topçalı Mah",
      "Yenicekale Mah",
      "Yenidemir Mah",
      "Yeniyapan Mah",
      "Yeşilyurt Mah",
      "Yolyanı Mah",
      "Zeytindere Mah"
    ],
    "Pazarcık": [
      "15 Temmuz Mah",
      "Ahmet Bozdağ Mah",
      "Akcakoyunlu Mah",
      "Akçalar Mah",
      "Akdemir Mah",
      "Armutlu Mah",
      "Aşağımülk Mah",
      "Bağdınısağır Mah",
      "Beşçeşme Mah",
      "Bölükçam Mah",
      "Büyüknacar Fatih Mah",
      "Büyüknacar Kocadere Mah",
      "Büyüknacar Merkez Mah",
      "Cengiz Topel Mah",
      "Cimikanlı Mah",
      "Çamlıca Mah",
      "Çamlıtepe Mah",
      "Çiçek Mah",
      "Çiçekalanı Mah",
      "Çiğdemtepe Mah",
      "Çöçelli Mah",
      "Damlataş Mah",
      "Dedepaşa Mah",
      "Eğlen Mah",
      "Eğrice Mah",
      "Emiroğlu Mah",
      "Evri Pınarbaşı Mah",
      "Evri Taşbiçme Mah",
      "Fatih Mah",
      "Ganidağıketiler Mah",
      "Göçer Mah",
      "Göynük Mah",
      "Hanobası Mah",
      "Harmancık Mah",
      "Hasankoca Mah",
      "Hürriyet Mah",
      "İncirli Mah",
      "Kadıncık Mah",
      "Karaağaç Mah",
      "Karabıyıklı Mah",
      "Karaçay Mah",
      "Karagöl Mah",
      "Karahüyük Mah",
      "Keleş Mah",
      "Kızkapanlı Mah",
      "Kizirli Mah",
      "Kuzeykent Mah",
      "Mehmet Emin Arıkoğlu Mah",
      "Memiş Özdal Mah",
      "Memişkahya Mah",
      "Menderes Mah",
      "Mezere Mah",
      "Musolar Mah",
      "Narlı Bahçelievler Mah",
      "Narlı Cumhuriyet Mah",
      "Narlı İsmetpaşa Mah",
      "Nefsidoğanlı Mah",
      "Osmandede Mah",
      "Ördekdede Mah",
      "Sadakalar Mah",
      "Sakarkaya Mah",
      "Sallıuşağı Mah",
      "Salmanıpak Mah",
      "Salmanlı Mah",
      "Sarıerik Mah",
      "Sarıl Mah",
      "Soku Mah",
      "Sultanlar Mah",
      "Şahintepe Mah",
      "Şehit Nurettin Ademoğlu Mah",
      "Taşdemir Mah",
      "Tetirlik Mah",
      "Tilkiler Mah",
      "Turunçlu Mah",
      "Ufacıklı Mah",
      "Ulubahçe Mah",
      "Yarbaşı Mah",
      "Yeşilkent Mah",
      "Yiğitler Mah",
      "Yolboyu Mah",
      "Yukarıhöcüklü Mah",
      "Yukarımülk Mah",
      "Yumaklıcerit Bağlar Mah",
      "Yumaklıcerit Cumhuriyet Mah"
    ],
    "Türkoğlu": [
      "Akçalı Mah",
      "Avşarlı Mah",
      "Aydınkavak Mah",
      "Bayramgazi Mah",
      "Beyoğlu Mah",
      "Ceceli Mah",
      "Cennetpınarı Mah",
      "Cumhuriyet Mah",
      "Çakallıçullu Mah",
      "Çakallıhasanağa Mah",
      "Çakıroğlu Mah",
      "Çobantepe Mah",
      "Dedeler Mah",
      "Doluca Mah",
      "Fatih Mah",
      "Gaziler Mah",
      "Gaziosmanpaşa Mah",
      "Güllühüyük Mah",
      "Hacıbebek Mah",
      "Hopurlu Mah",
      "İmalı Mah",
      "İstasyon Mah",
      "Kadıoğluçiftliği Mah",
      "Kaledibi Mah",
      "Kelibişler Mah",
      "Kılılı Mah",
      "Kırmakaya Mah",
      "Kızıleniş Mah",
      "Kumçatı Mah",
      "Kuyumcular Mah",
      "Küçükimalı Mah",
      "Minehüyük Mah",
      "Önsenhopuru Mah",
      "Özbek Mah",
      "Pınarhüyük Mah",
      "Şekeroba Mah",
      "Tahtalıdedeler Mah",
      "Türkoğlu Osb Mah",
      "Uzunsöğüt Mah",
      "Yavuzlar Mah",
      "Yeniköy Mah",
      "Yenipınar Mah",
      "Yeşilyöre Mah",
      "Yeşilyurt Mah",
      "Yolderesi Mah"
    ]
  },
  "Mardin": {
    "Artuklu": [
      "Gökçe Mah",
      "Acar Mah",
      "Ahmetli Mah",
      "Akbağ Mah",
      "Akıncı Mah",
      "Alakuş Mah",
      "Alımlı Mah",
      "Ambar Mah",
      "Aran Mah",
      "Arpatepe Mah",
      "Aşağıyeniköy Mah",
      "Avcılar Mah",
      "Aytepe Mah",
      "Bağlıca Mah",
      "Boztepe Mah",
      "Buğday Mah",
      "Cevizlik Mah",
      "Cevizpınarı Mah",
      "Çağlar Mah",
      "Çalışlı Mah",
      "Çatak Mah",
      "Çayırpınar Mah",
      "Çıplaktepe Mah",
      "Çiftlikköy Mah",
      "Çukuryurt Mah",
      "Dara Mah",
      "Dibektaş Mah",
      "Düzlük Mah",
      "Elmabahçe Mah",
      "Eroğlu Mah",
      "Eryeri Mah",
      "Esentepe Mah",
      "Eskikale Mah",
      "Göllü Mah",
      "Güneyli Mah",
      "Gürağaç Mah",
      "Hamzabey Mah",
      "Hatunlu Mah",
      "Haydar Mah",
      "Hüyüklü Mah",
      "İstasyon Mah",
      "Karademir Mah",
      "Konaklı Mah",
      "Kumlu Mah",
      "Kuyulu Mah",
      "Küçükköy Mah",
      "Nur  Mah (akıncı Mah)",
      "Ofis Mah",
      "Ofisosb Mah",
      "Ortaköy Mah",
      "Özlüce Mah",
      "Sakalar Mah",
      "Sulak Mah",
      "Sultanköy Mah",
      "Tandır Mah",
      "Tilkitepe Mah",
      "Tozan Mah",
      "Yalım Mah",
      "Yardere Mah",
      "Yayla Mah",
      "Yaylabaşı Mah",
      "Yaylacık Mah",
      "Yaylı Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yolbaşı Mah",
      "Yukarıaydınlı Mah",
      "Yukarıhatunlu Mah",
      "Yukarıyeniköy Mah",
      "Yüce Mah",
      "Kabala Mah",
      "13 Mart Mah",
      "Nur Mah",
      "Yenişehir Mah",
      "Cumhuriyet Mah",
      "Çabuk Mah",
      "Diyarbakır Kapı Mah",
      "Eminettin Mah",
      "Ensar Mah",
      "Gül Mah",
      "Kayacan Mah",
      "Kotek Mah",
      "Latifiye Mah",
      "Medrese Mah",
      "Necmettin Mah",
      "Saraçoğlu Mah",
      "Savurkapı Mah",
      "Şar Mah",
      "Şehidiye Mah",
      "Teker Mah",
      "Ulucami Mah",
      "Yenikapı Mah"
    ],
    "Dargeçit": [
      "Akçaköy Mah",
      "Akyol Mah",
      "Alayunt Mah",
      "Altınoluk Mah",
      "Altıyol Mah",
      "Bağözü Mah",
      "Bahçebaşı Mah",
      "Batur Mah",
      "Baysun Mah",
      "Beğendi Mah",
      "Belen Mah",
      "Bostanlı Mah",
      "Çatalan Mah",
      "Çatalçam Mah",
      "Çavuşlu Mah",
      "Çelikköy Mah",
      "Çukurdere Mah",
      "Değerli Mah",
      "Gürgen Mah",
      "Gürışık Mah",
      "Ilısu Mah",
      "Karabayır Mah",
      "Kartalkaya Mah",
      "Kılavuz Mah",
      "Kısmetli Mah",
      "Korucu Mah",
      "Kumdere Mah",
      "Kuşluca Mah",
      "Ormaniçi Mah",
      "Safa Mah",
      "Saray Mah",
      "Suçatı Mah",
      "Sümer Mah",
      "Tanyeri Mah",
      "Tavşanlı Mah",
      "Temelli Mah",
      "Tepebaşı Mah",
      "Ulaş Mah",
      "Yanılmaz Mah",
      "Yılmaz Mah",
      "Yoncalı Mah"
    ],
    "Derik": [
      "Adak Mah",
      "Adakent Mah",
      "Ahmetli Mah",
      "Akçay Mah",
      "Akıncılar Mah",
      "Alagöz Mah",
      "Alanlı Mah",
      "Alibey Mah",
      "Ambarlı Mah",
      "Aşağımezra Mah",
      "Atlı Mah",
      "Aydınlar Mah",
      "Bağarası Mah",
      "Bahçelievler Mah",
      "Ballı Mah",
      "Balova Mah",
      "Başaran Mah",
      "Bayırköy Mah",
      "Bayraklı Mah",
      "Beşbudak Mah",
      "Boyaklı Mah",
      "Bozbayır Mah",
      "Bozok Mah",
      "Böğrek Mah",
      "Burçköy Mah",
      "Cevizpınar Mah",
      "Çadırlı Mah",
      "Çağıl Mah",
      "Çataltepe Mah",
      "Çayköy Mah",
      "Çukursu Mah",
      "Dağ Mah",
      "Demirli Mah",
      "Denktaş Mah",
      "Derinsu Mah",
      "Dikmen Mah",
      "Doğancı Mah",
      "Dumanlı Mah",
      "Dumluca Mah",
      "Düztaş Mah",
      "Göktaş Mah",
      "Gölbaşı Mah",
      "Hayırlı Mah",
      "Hisaraltı Mah",
      "Ilıca Mah",
      "Issız Mah",
      "İncesu Mah",
      "Kale Mah",
      "Kanatlı Mah",
      "Karaburun Mah",
      "Karataş Mah",
      "Kayacık Mah",
      "Kocatepe Mah",
      "Koçyiğit Mah",
      "Konak Mah",
      "Konuk Mah",
      "Kovalı Mah",
      "Kovanlı Mah",
      "Köseveli Mah",
      "Kuruçay Mah",
      "Kuşçu Mah",
      "Kutluca Mah",
      "Kuyulu Mah",
      "Küçükpınar Mah",
      "Meşeli Mah",
      "Ortaca Mah",
      "Pınarcık Mah",
      "Pirinçli Mah",
      "Soğukkuyu Mah",
      "Söğütözü Mah",
      "Subaşı Mah",
      "Şahverdi Mah",
      "Şerefli Mah",
      "Taşıt Mah",
      "Tepebağ Mah",
      "Üçkuyu Mah",
      "Üçtepe Mah",
      "Yazıcık Mah",
      "Yukarımezra Mah",
      "Zeytinpınar Mah"
    ],
    "Kızıltepe": [
      "Akalın Mah",
      "Akça Mah",
      "Akçapınar Mah",
      "Akdoğan Mah",
      "Akkoç Mah",
      "Aktepe Mah",
      "Aktulga Mah",
      "Akyazı Mah",
      "Akyüz Mah",
      "Akziyaret Mah",
      "Alakuş Mah",
      "Alemdar Mah",
      "Alipaşa Mah",
      "Altıntoprak Mah",
      "Arakapı Mah",
      "Araköy Mah",
      "Arıklı Mah",
      "Arıtepe Mah",
      "Aslanlı Mah",
      "Aşağıazıklı Mah",
      "Ataköy Mah",
      "Atatürk Mah",
      "Atmaca Mah",
      "Ayaz Mah",
      "Bağrıbütün Mah",
      "Bahçelievler Mah",
      "Barış Mah",
      "Başak Mah",
      "Bektaş Mah",
      "Belli Mah",
      "Beşdeğirmen Mah",
      "Beşevler Mah",
      "Beşik Mah",
      "Bozhöyük Mah",
      "Büyükayrık Mah",
      "Büyükboğaziye Mah",
      "Büyükdere Mah",
      "Büyüktepe Mah",
      "Cantaşı Mah",
      "Cumhuriyet Mah",
      "Çağıl Mah",
      "Çakır Mah",
      "Çamlıca Mah",
      "Çamlıdere Mah",
      "Çanaklı Mah",
      "Çatalca Mah",
      "Çaybaşı Mah",
      "Çetinkaya Mah",
      "Çetinler Mah",
      "Çınarcık Mah",
      "Çıplak Mah",
      "Çimenli Mah",
      "Çitlibağ Mah",
      "Damlalı Mah",
      "Demet Mah",
      "Demirci Mah",
      "Demirkapı Mah",
      "Demirler Mah",
      "Dikmen Mah",
      "Doğanlı Mah",
      "Dora Mah",
      "Doyuran Mah",
      "Dörtyol Mah",
      "Dunaysır Mah",
      "Düğürk Mah",
      "Ekinlik Mah",
      "Elbeyli Mah",
      "Elmalı Mah",
      "Erdem Mah",
      "Erikli Mah",
      "Eroğlu Mah",
      "Ersoylu Mah",
      "Esenli Mah",
      "Eskin Mah",
      "Eşme Mah",
      "Eymirli Mah",
      "Fındıktepe Mah",
      "Fırat Mah",
      "Göllü Mah",
      "Gözlüce Mah",
      "Güçlü Mah",
      "Gümüşdere Mah",
      "Güneştepe Mah",
      "Güngören Mah",
      "Günlüce Mah",
      "Gürmeşe Mah",
      "Hacıhasan Mah",
      "Hacıyusuf Mah",
      "Hakverdi Mah",
      "Halkalı Mah",
      "Harmandüzü Mah",
      "Haznedar Mah",
      "Hocaköy Mah",
      "Ilıcak Mah",
      "Işıklar Mah",
      "Işıkören Mah",
      "İkikuyu Mah",
      "İkizler Mah",
      "İnandı Mah",
      "İpek Mah",
      "Kahraman Mah",
      "Kalaycık Mah",
      "Karabent Mah",
      "Karakulak Mah",
      "Karakuyu Mah",
      "Karaman Mah",
      "Kaşıklı Mah",
      "Katarlı Mah",
      "Kayapınar Mah",
      "Kaynarca Mah",
      "Kengerli Mah",
      "Kılduman Mah",
      "Kırkkuyu Mah",
      "Kilimli Mah",
      "Kocalar Mah",
      "Koçhisar Mah",
      "Koçlu Mah",
      "Konuklu Mah",
      "Köprübaşı Mah",
      "Körsu Mah",
      "Küçükayrık Mah",
      "Küçükboğaziye Mah",
      "Küplüce Mah",
      "Mevlana Mah",
      "Mezopotamya Mah",
      "Odaköy Mah",
      "Ofis Mah",
      "Ortaköy Mah",
      "Otluk Mah",
      "Örencik Mah",
      "Rıhani Mah",
      "Sanayi Mah",
      "Sancarlı Mah",
      "Sandıklı Mah",
      "Sarıca Mah",
      "Saruhan Mah",
      "Selahattin Eyyubi Mah",
      "Sevimli Mah",
      "Soğanlı Mah",
      "Sürekli Mah",
      "Şahkulubey Mah",
      "Şenyurt Mah",
      "Tanrıverdi Mah",
      "Tarlabaşı Mah",
      "Taşlıca Mah",
      "Tatlıca Mah",
      "Tepebaşı Mah",
      "Tıraşlı Mah",
      "Timurçiftliği Mah",
      "Tosunlu Mah",
      "Turgut Özal Mah",
      "Tuzla Mah",
      "Tuzluca Mah",
      "Ulaşlı Mah",
      "Uluköy Mah",
      "Uzunkaya Mah",
      "Üçevler Mah",
      "Ülker Mah",
      "Yalınkılıç Mah",
      "Yamaç Mah",
      "Yamanlar Mah",
      "Yarımca Mah",
      "Yaşarköy Mah",
      "Yayıklı Mah",
      "Yaylım Mah",
      "Yedikardeş Mah",
      "Yeni Mah",
      "Yenikent Mah",
      "Yeşilköy Mah",
      "Yeşiller Mah",
      "Yolaldı Mah",
      "Yoldere Mah",
      "Yolüstü Mah",
      "Yoncalı Mah",
      "Yukarıazıklı Mah",
      "Yukarıazıklı Osb Mah",
      "Yumrutaş Mah",
      "Yumurcak Mah",
      "Yurtderi Mah",
      "Yurtözü Mah",
      "Yüceli Mah",
      "Yüksektepe Mah",
      "Zergan Mah",
      "Ziyaret Mah"
    ],
    "Mazıdağı": [
      "Aksu Mah",
      "Arıköy Mah",
      "Arısu Mah",
      "Aşağıocak Mah",
      "Atalar Mah",
      "Atlıca Mah",
      "Aykut Mah",
      "Bahçecik Mah",
      "Balpınar Mah",
      "Bilge Mah",
      "Çankaya Mah",
      "Çayönü Mah",
      "Derecik Mah",
      "Dikyamaç Mah",
      "Duraklı Mah",
      "Ekinciler Mah",
      "Engin Mah",
      "Erdalı Mah",
      "Evciler Mah",
      "Gümüşpınar Mah",
      "Gümüşyuva Mah",
      "Gündoğan Mah",
      "Gürgöze Mah",
      "Işıkyaka Mah",
      "İkisu Mah",
      "Karaalani Mah",
      "Karataş Mah",
      "Karşıyaka Mah",
      "Kayalar Mah",
      "Kebapçı Mah",
      "Kemerli Mah",
      "Kışlak Mah",
      "Kocakent Mah",
      "Konur Mah",
      "Meşeli Mah",
      "Ortaklı Mah",
      "Ömürlü Mah",
      "Poyraz Mah",
      "Sağmal Mah",
      "Sakızlı Mah",
      "Şanlı Mah",
      "Şenyuva Mah",
      "Tanrıyolu Mah",
      "Tarlacık Mah",
      "Ulutaş Mah",
      "Ürünlü Mah",
      "Yağmur Mah",
      "Yalınağaç Mah",
      "Yeşilköy Mah",
      "Yetkinler Mah",
      "Yukarıkonak Mah",
      "Yukarıocak Mah",
      "Yücebağ Mah"
    ],
    "Midyat": [
      "Akçakaya Mah",
      "Cumhuriyet Mah",
      "Gölcük Mah",
      "Işıklar Mah",
      "Sanayi Mah",
      "Acırlı Mah",
      "Adaklı Mah",
      "Altıntaş Mah",
      "Anıtlı Mah",
      "Bağlar Mah",
      "Bağlarbaşı Mah",
      "Bahçelievler Mah",
      "Bardakçı Mah",
      "Barıştepe Mah",
      "Başyurt Mah",
      "Bethkustan Mah",
      "Budaklı Mah",
      "Çaldere Mah",
      "Çalpınar Mah",
      "Çamyurt Mah",
      "Çandarlı Mah",
      "Çavuşlu Mah",
      "Çayırlı Mah",
      "Danışman Mah",
      "Doğançay Mah",
      "Doğanyazı Mah",
      "Dolunay Mah",
      "Düzgeçit Mah",
      "Düzoba Mah",
      "Eğlence Mah",
      "Elbeğendi Mah",
      "Erişti Mah",
      "Gelinkaya Mah",
      "Gülgöze Mah",
      "Gülveren Mah",
      "Güngören Mah",
      "Güven Mah",
      "Hanlar Mah",
      "Harmanlı Mah",
      "İkizdere Mah",
      "İzbırak Mah",
      "Kayabaşı Mah",
      "Kayalar Mah",
      "Kayalıpınar Mah",
      "Kutlubey Mah",
      "Mercimekli Mah",
      "Narlı Mah",
      "Ortaca Mah",
      "Ortaçarşı Mah",
      "Oyuklu Mah",
      "Pelitli Mah",
      "Sarıkaya Mah",
      "Sarıköy Mah",
      "Seyitler Mah",
      "Sivrice Mah",
      "Söğütlü Mah",
      "Şenköy Mah",
      "Taşlıburç Mah",
      "Tepeli Mah",
      "Toptepe Mah",
      "Tulgalı Mah",
      "Ulucami Mah",
      "Üçağıl Mah",
      "Yayvantepe Mah",
      "Yemişli Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yeşilöz Mah",
      "Yolbaşı Mah",
      "Yunus Emre Mah",
      "Yuvalı Mah",
      "Ziyaret Mah"
    ],
    "Nusaybin": [
      "8 Mart Mah",
      "Abdulkadirpaşa Mah",
      "Açıkköy Mah",
      "Açıkyol Mah",
      "Akağıl Mah",
      "Akarsu Mah",
      "Akçatarla Mah",
      "Bahçebaşı Mah",
      "Bakacık Mah",
      "Balaban Mah",
      "Barış Mah",
      "Beylik Mah",
      "Büyükkardeş Mah",
      "Çağlar Mah",
      "Çalı Mah",
      "Çatalözü Mah",
      "Çiğdem Mah",
      "Çilesiz Mah",
      "Çölova Mah",
      "Dağiçi Mah",
      "Dallıağaç Mah",
      "Değirmencik Mah",
      "Demirtepe Mah",
      "Devrim Mah",
      "Dibek Mah",
      "Dicle Mah",
      "Dirim Mah",
      "Doğanlı Mah",
      "Doğuş Mah",
      "Durakbaşı Mah",
      "Duruca Mah",
      "Düzce Mah",
      "Eskihisar Mah",
      "Eskimağara Mah",
      "Eskiyol Mah",
      "Fırat Mah",
      "Gırnavas Mah",
      "Girmeli Mah",
      "Görentepe Mah",
      "Günebakan Mah",
      "Güneli Mah",
      "Günyurdu Mah",
      "Gürün Mah",
      "Güvenli Mah",
      "Hasantepe Mah",
      "Heybeli Mah",
      "İkiztepe Mah",
      "İlkadım Mah",
      "İpekyolu Mah",
      "Kalecik Mah",
      "Kantar Mah",
      "Karaca Mah",
      "Kayadibi Mah",
      "Kışla Mah",
      "Kocadağ Mah",
      "Kuruköy Mah",
      "Kuyular Mah",
      "Küçükkardeş Mah",
      "Mor-yakup Mah",
      "Nergizli Mah",
      "Odabaşı Mah",
      "Pazar Mah",
      "Selahaddin Eyyubi Mah",
      "Sınırtepe Mah",
      "Söğütlü Mah",
      "Taşköy Mah",
      "Tekağaç Mah",
      "Tepealtı Mah",
      "Tepeören Mah",
      "Tepeüstü Mah",
      "Turgutköy Mah",
      "Üçköy Mah",
      "Üçyol Mah",
      "Yandere Mah",
      "Yavruköy Mah",
      "Yazyurdu Mah",
      "Yenişehir Mah",
      "Yenituran Mah",
      "Yerköy Mah",
      "Yeşilkent Mah",
      "Yolbilen Mah",
      "Yolindi Mah",
      "Zeynelabidin Mah"
    ],
    "Ömerli": [
      "Akyokuş Mah",
      "Alıçlı Mah",
      "Anıttepe Mah",
      "Beşikkaya Mah",
      "Cumhuriyet Mah",
      "Çalışan Mah",
      "Çatalyurt Mah",
      "Çayıralanı Mah",
      "Çınaraltı Mah",
      "Çimenlik Mah",
      "Dönerdere Mah",
      "Duygulu Mah",
      "Fıstıklı Mah",
      "Göllü Mah",
      "Güzelağaç Mah",
      "Harmankaya Mah",
      "Havuzbaşı Mah",
      "Işıkdere Mah",
      "İkipınar Mah",
      "İkitepe Mah",
      "Kayabalı Mah",
      "Kayadere Mah",
      "Kayagöze Mah",
      "Kayaüstü Mah",
      "Kaynakkaya Mah",
      "Kocakuyu Mah",
      "Kocasırt Mah",
      "Kovanlı Mah",
      "Kömürlü Mah",
      "Mutluca Mah",
      "Ovabaşı Mah",
      "Öztaş Mah",
      "Pınarcık Mah",
      "Salihköy Mah",
      "Sivritepe Mah",
      "Sulakdere Mah",
      "Şafak Mah",
      "Taşgedik Mah",
      "Taşlıca Mah",
      "Tavuklu Mah",
      "Tekkuyu Mah",
      "Tokdere Mah",
      "Topağaç Mah",
      "Ünsallı Mah",
      "Yaylatepe Mah",
      "Yeni Mah"
    ],
    "Savur": [
      "Akyürek Mah",
      "Armutalan Mah",
      "Bağyaka Mah",
      "Başağaç Mah",
      "Başkavak Mah",
      "Bengisu Mah",
      "Çınarönü Mah",
      "Dereiçi Mah",
      "Durusu Mah",
      "Erkuran Mah",
      "Gölbaşı Mah",
      "Harmantepe Mah",
      "Hisarkaya Mah",
      "İçören Mah",
      "İşgören Mah",
      "Kaplan Mah",
      "Karaköy Mah",
      "Kayacıklar Mah",
      "Kayatepe Mah",
      "Kırbalı Mah",
      "Kırkdirek Mah",
      "Kocahüyük Mah",
      "Koşuyolu Mah",
      "Köprülü Mah",
      "Ormancık Mah",
      "Pınardere Mah",
      "Safa Mah",
      "Sancaklı Mah",
      "Serenli Mah",
      "Seydin Mah",
      "Soylu Mah",
      "Sürgücü Mah",
      "Şenocak Mah",
      "Taşlık Mah",
      "Tokluca Mah",
      "Üçerli Mah",
      "Üçkavak Mah",
      "Yaylayanı Mah",
      "Yazır Mah",
      "Yenilmez Mah",
      "Yeşilalan Mah"
    ],
    "Yeşilli": [
      "Alıçlı Mah",
      "Bahçebaşı Mah",
      "Bülbül Mah",
      "Dereyanı Mah",
      "Gül Mah",
      "Karşıyaka Mah",
      "Koyunlu Mah",
      "Kütüklü Mah",
      "Ovaköy Mah",
      "Sancar Mah",
      "Şirinevler Mah",
      "Tepebaşı Mah",
      "Uzunköy Mah",
      "Zeytinli Mah"
    ]
  },
  "Muğla": {
    "Bodrum": [
      "Akçaalan Mah",
      "Akyarlar Mah",
      "Bahçelievler Mah",
      "Bahçeyaka Mah",
      "Bitez Mah",
      "Cevat Şakir Mah",
      "Cumhuriyet Mah",
      "Çamarası Mah",
      "Çamlık Mah",
      "Çarşı Mah",
      "Çırkan Mah",
      "Çiftlik Mah",
      "Çömlekçi Mah",
      "Dağbelen Mah",
      "Dereköy Mah",
      "Dirmil Mah",
      "Eskiçeşme Mah",
      "Farilya Mah",
      "Geriş Mah",
      "Gökpınar Mah",
      "Gölbaşı Mah",
      "Gölköy Mah",
      "Gümbet Mah",
      "Gümüşlük Mah",
      "Gündoğan Mah",
      "Gürece Mah",
      "Güvercinlik Mah",
      "İslamhaneleri Mah",
      "Karabağ Mah",
      "Karaova Mah",
      "Kemer Mah",
      "Kızılağaç Mah",
      "Konacık Mah",
      "Koyunbaba Mah",
      "Kumbahçe Mah",
      "Kumköy Mah",
      "Küçükbük Mah",
      "Mazıköy Mah",
      "Mumcular Mah",
      "Müskebi Mah",
      "Peksimet Mah",
      "Pınarlıbelen Mah",
      "Sazköy Mah",
      "Tepecik  Mah (karaova Mah)",
      "Tepecik Mah",
      "Torba Mah",
      "Turgutreis Mah",
      "Türkbükü Mah",
      "Türkkuyusu Mah",
      "Umurca Mah",
      "Yahşi Mah",
      "Yakaköy Mah",
      "Yalıkavak Mah",
      "Yeniköy  Mah (karaova Mah)",
      "Yeniköy Mah",
      "Yokuşbaşı Mah"
    ],
    "Dalaman": [
      "Akçataş Mah",
      "Altıntas Mah",
      "Atakent Mah",
      "Bezkese Mah",
      "Bozbel Mah",
      "Çöğmen Mah",
      "Darıyeri Mah",
      "Ege Mah",
      "Elcik Mah",
      "Gürköy Mah",
      "Gürleyk Mah",
      "Hürriyet Mah",
      "Kapukargın Mah",
      "Karacaağaç Mah",
      "Karaçalı Mah",
      "Kargınkürü Mah",
      "Kavacık Mah",
      "Kayadibi Mah",
      "Kızılkaya Mah",
      "Merkez Mah",
      "Narlı Mah",
      "Sabunlu Mah",
      "Söğütlüyurt Mah",
      "Şerefler Mah",
      "Taşbaşı Mah"
    ],
    "Datça": [
      "Cumalı Mah",
      "Datça Mah",
      "Emecik Mah",
      "Hızırşah Mah",
      "İskele Mah",
      "Karaköy Mah",
      "Kızlan Mah",
      "Mesudiye Mah",
      "Reşadiye Mah",
      "Sındı Mah",
      "Yaka Mah",
      "Yazı Mah"
    ],
    "Fethiye": [
      "Akarca Mah",
      "Babataşı Mah",
      "Bozyer Mah",
      "Cami Mah",
      "Cumhuriyet Mah",
      "Çamköy Mah",
      "Çatalarık Mah",
      "Çenger Mah",
      "Çiftlik Mah",
      "Eldirek Mah",
      "Esenköy Mah",
      "Faralya Mah",
      "Foça Mah",
      "Göcek Mah",
      "Gökben Mah",
      "Gökçeovacık Mah",
      "İncirköy Mah",
      "İnlice Mah",
      "Karaağaç Mah",
      "Karacaören Mah",
      "Karaçulha Mah",
      "Karagedik Mah",
      "Karagözler Mah",
      "Karakeçililer Mah",
      "Kargı Mah",
      "Kayaköy Mah",
      "Kesikkapı Mah",
      "Kızılbel Mah",
      "Koruköy Mah",
      "Menteşeoğlu Mah",
      "Nif Mah",
      "Ölüdeniz Mah",
      "Patlangıç Mah",
      "Pazaryeri Mah",
      "Söğütlü Mah",
      "Taşyaka Mah",
      "Tuzla Mah",
      "Yakacık Mah",
      "Yanıklar Mah",
      "Yeni Mah",
      "Yeşilüzümlü Mah"
    ],
    "Kavaklıdere": [
      "Bakırcılar Mah",
      "Cumhuriyet Mah",
      "Çamlıbel Mah",
      "Çamlıyurt Mah",
      "Çatak Mah",
      "Çavdır Mah",
      "Çayboyu Mah",
      "Derebağ Mah",
      "Kurucuova Mah",
      "Menteşe Mah",
      "Nebiler Mah",
      "Ortaköy Mah",
      "Salkım Mah",
      "Yeni Mah",
      "Yeşilköy Mah"
    ],
    "Köyceğiz": [
      "Akköprü Mah",
      "Balcılar Mah",
      "Beyobası Mah",
      "Çandır Mah",
      "Çayhisar Mah",
      "Döğüşbelen Mah",
      "Ekincik Mah",
      "Gelişim Mah",
      "Gülpınar Mah",
      "Hamitköy Mah",
      "Karaçam Mah",
      "Kavakarası Mah",
      "Köyceğiz Mah",
      "Otmanlar Mah",
      "Pınar Mah",
      "Sazak Mah",
      "Sultaniye Mah",
      "Toparlar Mah",
      "Ulucami Mah",
      "Yangı Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yeşilköy Mah",
      "Zaferler Mah",
      "Zeytinalanı Mah"
    ],
    "Marmaris": [
      "Adaköy Mah",
      "Armutalan Mah",
      "Bayır Mah",
      "Beldibi Mah",
      "Bozburun Mah",
      "Çamdibi Mah",
      "Çamlı Mah",
      "Çetibeli Mah",
      "Çıldır Mah",
      "Hatipirimi Mah",
      "Hisarönü Mah",
      "İçmeler Mah",
      "Karaca Mah",
      "Kemeraltı Mah",
      "Orhaniye Mah",
      "Osmaniye Mah",
      "Sarıana Mah",
      "Selimiye Mah",
      "Siteler Mah",
      "Söğüt Mah",
      "Taşlıca Mah",
      "Tepe Mah",
      "Turgut Mah",
      "Turunç Mah",
      "Yeşilbelde Mah"
    ],
    "Menteşe": [
      "Akçaova Mah",
      "Akkaya Mah",
      "Akyer Mah",
      "Algı Mah",
      "Avcılar Mah",
      "Bağyaka Mah",
      "Balıbey Mah",
      "Bayır Mah",
      "Bozyer Mah",
      "Camikebir Mah",
      "Çakmak Mah",
      "Çamoluk Mah",
      "Çaybükü Mah",
      "Çırpı Mah",
      "Çiftlik Mah",
      "Dağdibi Mah",
      "Dağpınar Mah",
      "Denizova Mah",
      "Derinkuyu Mah",
      "Doğan Mah",
      "Dokuzçam Mah",
      "Düğerek Mah",
      "Emirbeyazıt Mah",
      "Esençay Mah",
      "Fadıl Mah",
      "Gazeller Mah",
      "Göktepe Mah",
      "Gülağzı Mah",
      "Günlüce Mah",
      "Hacırüstem Mah",
      "İkizce Mah",
      "Kafaca Mah",
      "Karacaören Mah",
      "Karamehmet Mah",
      "Karşıyaka Mah",
      "Kıran Mah",
      "Kiramettin Mah",
      "Kozağaç Mah",
      "Kötekli Mah",
      "Kuyucak Mah",
      "Kuzluk Mah",
      "Meke Mah",
      "Muratlar Mah",
      "Muslihittin Mah",
      "Müştakbey Mah",
      "Orhaniye Mah",
      "Orta Mah",
      "Ortaköy Mah",
      "Özlüce Mah",
      "Paşapınarı Mah",
      "Salihpaşalar Mah",
      "Sarnıç Mah",
      "Sungur Mah",
      "Şenyayla Mah",
      "Şeyh Mah",
      "Taşlı Mah",
      "Yaraş Mah",
      "Yemişendere Mah",
      "Yenibağyaka Mah",
      "Yenice Mah",
      "Yeniköy  Mah (yerkesik Mah)",
      "Yeniköy Mah",
      "Yerkesik Mah",
      "Yeşilyurt Mah",
      "Yörükoğlu Mah",
      "Zeytin Mah"
    ],
    "Milas": [
      "Ağaçlıhüyük Mah",
      "Ahmetçavuş-hayıtlı Mah",
      "Akçakaya Mah",
      "Akçalı Mah",
      "Akkovanlık Mah",
      "Akyol Mah",
      "Alaçam Mah",
      "Alatepe Mah",
      "Aslanyaka Mah",
      "Avşar Mah",
      "Aydınlıkevler Mah",
      "Bafa Mah",
      "Bağdamları Mah",
      "Baharlı Mah",
      "Bahçe Mah",
      "Bahçeburun Mah",
      "Balcılar Mah",
      "Bayır Mah",
      "Beçin Mah",
      "Beyciler Mah",
      "Boğaziçi Mah",
      "Bozalan Mah",
      "Bozbük Mah",
      "Burgaz Mah",
      "Cumhuriyet Mah",
      "Çakıralan Mah",
      "Çallı Mah",
      "Çamköy Mah",
      "Çamlıbelen Mah",
      "Çamlıca Mah",
      "Çamlıyurt Mah",
      "Çamovalı Mah",
      "Çandır Mah",
      "Çınarlı Mah",
      "Çiftlik Mah",
      "Çomakdağkızılağaç Mah",
      "Çökertme Mah",
      "Çukur Mah",
      "Damlıboğaz Mah",
      "Danişment Mah",
      "Demirciler Mah",
      "Dere Mah",
      "Derince Mah",
      "Dibekdere Mah",
      "Dörttepe Mah",
      "Eğridere Mah",
      "Ekinanbarı Mah",
      "Ekindere Mah",
      "Ekizköy Mah",
      "Ekiztaş Mah",
      "Emek Mah",
      "Epçe Mah",
      "Etrenli Mah",
      "Fesleğen Mah",
      "Firuzpaşa-gazipaşa Mah",
      "Gökbel Mah",
      "Gökçeler Mah",
      "Göldere Mah",
      "Gölyaka Mah",
      "Güllük Mah",
      "Gümüşlük Mah",
      "Güneş Mah",
      "Günlük Mah",
      "Gürceğiz Mah",
      "Gürçamlar Mah",
      "Hacı İlyas Mah",
      "Hacıabti Mah",
      "Hacıahmetler Mah",
      "Hasanlar Mah",
      "Hisarbaşı-hoca Bedrettin Mah",
      "Hisarcık Mah",
      "Hüsamlar Mah",
      "İçme Mah",
      "İsmet Paşa Mah",
      "Kafaca Mah",
      "Kalem Mah",
      "Kalınağıl Mah",
      "Kandak Mah",
      "Kapıkırı Mah",
      "Karacaağaç Mah",
      "Karacahisar Mah",
      "Karahayıt Mah",
      "Karakuyu Mah",
      "Karapınar Mah",
      "Kargıcak Mah",
      "Karşıyaka Mah",
      "Kayabaşı Mah",
      "Kayabükü Mah",
      "Kayadere Mah",
      "Kazıklı Mah",
      "Kemikler Mah",
      "Ketendere Mah",
      "Kılavuz Mah",
      "Kırcağız Mah",
      "Kısırlar Mah",
      "Kıyıkışlacık Mah",
      "Kızılağaç Mah",
      "Kızılcakuyu Mah",
      "Kızılcayıkık Mah",
      "Konak Mah",
      "Koru Mah",
      "Korucuk Mah",
      "Köşk Mah",
      "Kultak Mah",
      "Kurudere Mah",
      "Kuzyaka Mah",
      "Küçükdibekdere Mah",
      "Menteş Mah",
      "Meşelik Mah",
      "Narhisar Mah",
      "Olukbaşı Mah",
      "Ortaköy Mah",
      "Ovakışlacık Mah",
      "Ören Mah",
      "Pınararası Mah",
      "Pınarcık Mah",
      "Pinar Mah",
      "Sakarkaya Mah",
      "Sarıkaya Mah",
      "Savran Mah",
      "Sek Mah",
      "Selimiye Mah",
      "Söğütçük Mah",
      "Şenköy Mah",
      "Şevketiye Mah",
      "Tuzabat Mah",
      "Türkevleri Mah",
      "Ulaş Mah",
      "Yaka Mah",
      "Yaşyer Mah",
      "Yoğunoluk Mah",
      "Yusufca Mah"
    ],
    "Ortaca": [
      "Akıncı Mah",
      "Arıkbaşı Mah",
      "Atatürk Mah",
      "Bahçelievler Mah",
      "Beşköprü Mah",
      "Cumhuriyet Mah",
      "Çaylı Mah",
      "Dalaklı Mah",
      "Dalyan Mah",
      "Dereköy Mah",
      "Dikmekavak Mah",
      "Ekşiliyurt Mah",
      "Eskiköy Mah",
      "Fevziye Mah",
      "Gökbel Mah",
      "Gölbaşı Mah",
      "Güzelyurt Mah",
      "Karaburun Mah",
      "Karadonlar Mah",
      "Kemaliye Mah",
      "Mergenli Mah",
      "Okçular Mah",
      "Sarıgerme Mah",
      "Tepearası Mah",
      "Terzialiler Mah",
      "Yerbelen Mah",
      "Yeşilyurt Mah"
    ],
    "Seydikemer": [
      "Alaçat Mah",
      "Arifler Mah",
      "Arsaköy Mah",
      "Atlıdere Mah",
      "Bağlıağaç Mah",
      "Bayırköy Mah",
      "Bekçiler Mah",
      "Belen Mah",
      "Boğalar Mah",
      "Boğaziçi Mah",
      "Ceylan Mah",
      "Cumhuriyet Mah",
      "Çaltılar Mah",
      "Çaltıözü Mah",
      "Çamurköy Mah",
      "Çatak Mah",
      "Çayan Mah",
      "Çaykenarı Mah",
      "Çobanisa Mah",
      "Çobanlar Mah",
      "Çökek Mah",
      "Çukurincir Mah",
      "Demirler Mah",
      "Dereköy Mah",
      "Dodurga Mah",
      "Doğanlar Mah",
      "Dont Mah",
      "Döğer Mah",
      "Eşen Mah",
      "Gerişburnu Mah",
      "Girmeler Mah",
      "Gölbent Mah",
      "Güneşli Mah",
      "Hacıosmanlar Mah",
      "İzzettinköy Mah",
      "Kabaağaç Mah",
      "Kadıköy Mah",
      "Karadere Mah",
      "Karaköy Mah",
      "Kayabaşı Mah",
      "Kayacık Mah",
      "Kayadibi Mah",
      "Kıncılar Mah",
      "Kınık Mah",
      "Korubükü Mah",
      "Kumluova Mah",
      "Menekşe Mah",
      "Minare Mah",
      "Ortaköy Mah",
      "Ören Mah",
      "Paşalı Mah",
      "Sahilceylan Mah",
      "Sarıyer Mah",
      "Seki Mah",
      "Seydiler Mah",
      "Söğütlüdere Mah",
      "Temel Mah",
      "Uğurlu Mah",
      "Yakabağ Mah",
      "Yakaköy Mah",
      "Yayla Eldirek Mah",
      "Yayla Gökben Mah",
      "Yayla Karaçulha Mah",
      "Yaylapatlangıç Mah",
      "Zorlar Mah"
    ],
    "Ula": [
      "Akçapınar Mah",
      "Akyaka Mah",
      "Alparslan Mah",
      "Arıcılar Mah",
      "Armutcuk Mah",
      "Ataköy Mah",
      "Ayazkıyı Mah",
      "Çıtlık Mah",
      "Çiçekli Mah",
      "Çörüş Mah",
      "Demirtaş Mah",
      "Elmalı Mah",
      "Esentepe Mah",
      "Gökçe Mah",
      "Gökova Mah",
      "Gölcük Mah",
      "Karabörtlen Mah",
      "Kavakçalı Mah",
      "Kıra Mah",
      "Kızılağaç Mah",
      "Kızılyaka Mah",
      "Köprübaşı Mah",
      "Örnekköy Mah",
      "Portakallık Mah",
      "Sarayyanı Mah",
      "Şirinköy Mah",
      "Turgut Mah",
      "Yaylasöğüt Mah",
      "Yeşilçam Mah",
      "Yeşilova Mah"
    ],
    "Yatağan": [
      "Akgedik Mah",
      "Akyol Mah",
      "Alaşar Mah",
      "Atatürk Mah",
      "Bağyaka Mah",
      "Bahçeyaka Mah",
      "Bencik Mah",
      "Bozarmut Mah",
      "Bozüyük Mah",
      "Cazkırlar Mah",
      "Cumhuriyet Mah",
      "Çakırlar Mah",
      "Çamlıca Mah",
      "Çukuröz Mah",
      "Dere Mah",
      "Deştin Mah",
      "Doğanköy Mah",
      "Elmacık Mah",
      "Esenköy Mah",
      "Eskihisar Mah",
      "Gökgedik Mah",
      "Gökpınar Mah",
      "Hacıbayramlar Mah",
      "Hacıveliler Mah",
      "Hisarardı Mah",
      "Kadıköy Mah",
      "Kafacakaplancık Mah",
      "Kapubağ Mah",
      "Katrancı Mah",
      "Kavak Mah",
      "Kırıkköy Mah",
      "Konak Mah",
      "Kozağaç Mah",
      "Köklük Mah",
      "Madenler Mah",
      "Mesken Mah",
      "Nebiköy Mah",
      "Şahinler Mah",
      "Şeref Mah",
      "Turgut Mah",
      "Turgutlar Mah",
      "Yava Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yenikarakuyu Mah",
      "Yeniköy Mah",
      "Yeşilbağcılar Mah",
      "Yeşilköy Mah",
      "Yukarıyayla Mah",
      "Zeytinköy Mah"
    ]
  },
  "Muş": {
    "Bulanık": [
      "Bahçelievler Mah",
      "Güllüova Mah",
      "İnönü Mah",
      "Kültür Mah",
      "Mescitli Mah",
      "Şehitlik Mah",
      "Yeni Mah",
      "Zafer Mah",
      "Cumhuriyet Mah (elmakaya Beldesi)",
      "Karşıyaka Mah (elmakaya Beldesi)",
      "Akçaarmut Köyü",
      "Aşağıbüklü Köyü",
      "Biniciler Mezrası Mah (esenlik Köyü)",
      "Büngüldek Köyü",
      "Cankurtaran Köyü",
      "Çataklı Köyü",
      "Dizboyu Mah (dokuzpınar Köyü)",
      "Dokuzpınar Köyü",
      "Esenlik Köyü",
      "Fatih Mah (erentepe Beldesi)",
      "Gazi Mah (erentepe Beldesi)",
      "Gülçimen Köyü",
      "Günbatmaz Köyü",
      "Güveç Mah (çataklı Köyü)",
      "Halit Mezrası Mah (esenlik Köyü)",
      "Hoşgeldi Köyü",
      "İkipınar Mah (dokuzpınar Köyü)",
      "Kale Mah (erentepe Beldesi)",
      "Karakaya Mah (cankurtaran Köyü)",
      "Kelehoşk Mah (hoşgeldi Köyü)",
      "Molladavut Köyü",
      "Oğlakkaya Köyü",
      "Okçular Köyü",
      "Olurdere Köyü",
      "Pınarbaşı Mah (mollakent Köyü)",
      "Sarıaltun Mah (dokuzpınar Köyü)",
      "Soman Mah (olurdere Köyü)",
      "Şıhmirza Mah (dokuzpınar Köyü)",
      "Tepecik Mah (akçaarmut Köyü)",
      "Yeşilova Mah (yokuşbaşı Köyü)",
      "Yeşilyurt Mah (mollakent Köyü)",
      "Yokuşbaşı Köyü",
      "Yukarıbüklü Mah (aşağıbüklü Köyü)",
      "Ziyaret Mah (dokuzpınar Köyü)",
      "Adıvar Köyü",
      "Akçakaynak Köyü",
      "Altınoluk Köyü",
      "Arakonak Köyü",
      "Ardıç Mah (eskiyol Köyü)",
      "Bahçelievler Mah (yemişen Köyü)",
      "Balotu Köyü",
      "Bayramlı Mah (eskiyol Köyü)",
      "Beşevler Mah (meşeiçi Köyü)",
      "Bostancılar Köyü",
      "Boztaş Mah (sultanlı Köyü)",
      "Cumhuriyet Mah",
      "Çaygeldi Mah (çaygeldi Köyü)",
      "Çiçekli Mah (seçme Köyü)",
      "Çilçile Mah (seçme Köyü)",
      "Değirmensuyu Köyü",
      "Demirkapı Köyü",
      "Dere Mah (altınoluk Köyü)",
      "Doğantepe Köyü",
      "Düzalan Mah (sultanlı Köyü)",
      "Ericek Köyü",
      "Eskiyol Köyü",
      "Fatih Mah (yemişen Köyü)",
      "Gölyanı Köyü",
      "Göztepe Köyü",
      "Gümüşpınar Köyü",
      "Gündüzü Köyü",
      "Günyurdu Köyü",
      "Han Köyü",
      "Horbızan Mah (altınoluk Köyü)",
      "İbrahim Kuşhan Mezrası Mah (arakonak Köyü)",
      "Karaburun Köyü",
      "Karacaören Köyü",
      "Kılındor Mezrası Mah (yazbaşı Köyü)",
      "Kırkgöze Köyü",
      "Kırmızıtaş Mezrası Mah (yazbaşı Köyü)",
      "Kom Mezrası Mah (kotanlı Köyü)",
      "Kortagül Mezrası Mah (yazbaşı Köyü)",
      "Kotanlı Köyü",
      "Koyunağılı Köyü",
      "Köprüyolu Köyü",
      "Kurganlı Köyü",
      "Kuzulu Mah (günyurdu Köyü)",
      "Memetler Mah (seçme Köyü)",
      "Meşeiçi Köyü",
      "Murat Mah (karaağıl Köyü)",
      "Örenkent Köyü",
      "Pınarcık Mah (samanyolu Köyü)",
      "Saliha Mah (seçme Köyü)",
      "Samanyolu Köyü",
      "Saray Mah (yemişen Köyü)",
      "Seçme Köyü",
      "Sıradere Köyü",
      "Söğütlü Köyü",
      "Sultanlı Köyü",
      "Sütlüce Mah (seçme Köyü)",
      "Şatırlar Köyü",
      "Şehittahir Köyü",
      "Şehitveren Köyü",
      "Toklular Köyü",
      "Topağaç Mah (seçme Köyü)",
      "Uğur Mahhalesi Mah (karaağıl Köyü)",
      "Üçtepe Köyü",
      "Ürünlü Mah (meşeiçi Köyü)",
      "Vangesor Mezrası Mah (gölyanı Köyü)",
      "Yazbaşı Köyü",
      "Yeniköy Mah (demirkapı Köyü)",
      "Yeşil Yayla Mezrası Mah (arakonak Köyü)",
      "Yılandere Mah (şatırlar Köyü)",
      "Yıldız Mah (karaağıl Köyü)",
      "Bağlar Mah (rüstemgedik Beldesi)",
      "Hanedan Mah (rüstemgedik Beldesi)",
      "İnönü Mah (rüstemgedik Beldesi)",
      "Zafer Mah (rüstemgedik Beldesi)",
      "Çimen Mah (sarıpınar Beldesi)",
      "Pınar Mah (sarıpınar Beldesi)",
      "Sinan Mah (sarıpınar Beldesi)",
      "Abdalbeyazıt Mah (uzgörür Beldesi)",
      "Alagez Mah (uzgörür Beldesi)",
      "Arı Mah (uzgörür Beldesi)",
      "Fatih Mah (uzgörür Beldesi)",
      "Gazi Mah (uzgörür Beldesi)",
      "Cumhuriyet Mah (yoncalı Beldesi)",
      "Hürriyet Mah (yoncalı Beldesi)",
      "Yeni Mah (yoncalı Beldesi)"
    ],
    "Hasköy": [
      "Bahçelievler Mah (düzkışla Beldesi)",
      "Kültür Mah (düzkışla Beldesi)",
      "Yeni Mah (düzkışla Beldesi)",
      "Kültür Mah",
      "Sayanlar Mah",
      "Sunay Mah",
      "15 Temmuz Mah",
      "Aşağıüçdam Köyü",
      "Azıklı Köyü",
      "Bahçelievler Mah",
      "Böğürdelen Köyü",
      "Büvetli Köyü",
      "Cotik Mah (yarkaya Köyü)",
      "Dağdibi Köyü",
      "Elmabulak Köyü",
      "Eşmepınar Köyü",
      "Gökyazı Köyü",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karakütük Köyü",
      "Koç Köyü",
      "Koğuktaş Köyü",
      "Ortanca Köyü",
      "Otaç Köyü",
      "Sarıbahçe Köyü",
      "Umurca Köyü",
      "Vatan Mah",
      "Yapraklı Mah (yarkaya Köyü)",
      "Yarkaya Köyü",
      "Yeşildere Mah (yarkaya Köyü)",
      "Yukarıüçdam Köyü",
      "Zafer Mah"
    ],
    "Korkut": [
      "Aydınlar Mah (altınova Beldesi)",
      "Bahçelievler Mah (altınova Beldesi)",
      "Merkez Mah (altınova Beldesi)",
      "Yeni Mah (altınova Beldesi)",
      "Bahçelievler Mah",
      "Kültür Mah",
      "Şehitler Mah",
      "Akyıldız Köyü",
      "Aladino Mah (içboğaz Köyü)",
      "Alazlı Köyü",
      "Balkır Köyü",
      "Çakırlı Mah (çınarardı Köyü)",
      "Çalaplı Köyü",
      "Çınarardı Köyü",
      "Değirmitaş Köyü",
      "Demirci Köyü",
      "Dereiçi Köyü",
      "Doğular Mah (demirci Köyü)",
      "Durucak Köyü",
      "Düzova Köyü",
      "Gelirli Mah (pınarüstü Köyü)",
      "Gültepe Mah (gültepe Köyü)",
      "Güneyik Köyü",
      "Güven Köyü",
      "İçboğaz Köyü",
      "Kapılı Köyü",
      "Kaşdibi Mah (değirmitaş Köyü)",
      "Kaval Mah (demirci Köyü)",
      "Kıryaka Köyü",
      "Kocatarla Köyü",
      "Konakdüzü Köyü",
      "Merkez Mah (karakale Köyü)",
      "Mollababa Köyü",
      "Oğulbalı Köyü",
      "Onevler Mah (yolgözler Köyü)",
      "Pınarüstü Köyü",
      "Sarmaşık Köyü",
      "Sazlıkbaşı Köyü",
      "Su Döndü Mah (demirci Köyü)",
      "Tan Köyü",
      "Taşlıca Köyü",
      "Yedipınar Köyü",
      "Yolgözler Köyü",
      "Yünören Köyü",
      "Yürekli Köyü"
    ],
    "Malazgirt": [
      "1 Mah (ağılbaşı Köyü)",
      "2 Mah (ağılbaşı Köyü)",
      "Bademözü Köyü",
      "Balkaya Köyü",
      "Beşdam Köyü",
      "Beypınar Köyü",
      "Bezirhane Mah (güzelbaba Köyü)",
      "Bilala Köyü",
      "Boyçapkın Köyü",
      "Çat Mah (balkaya Köyü)",
      "Çiçekveren Köyü",
      "Dedeağaç Mah (kazgöl Köyü)",
      "Dövenciler Mah (karıncalı Köyü)",
      "Erence Köyü",
      "Fenek Köyü",
      "Güzelbaba Köyü",
      "Hacılar Mah (karakoç Köyü)",
      "İyikomşu Köyü",
      "Kadıköy Köyü",
      "Karadera Mah (güzelbaba Köyü)",
      "Karakoç Köyü",
      "Kardeşler Köyü",
      "Karıncalı Köyü",
      "Kazgöl Köyü",
      "Kuruca Köyü",
      "Sırtdüzü Köyü",
      "Tıkızlı Köyü",
      "Ulusu Köyü",
      "Uyanık Köyü",
      "Yapraklı Köyü",
      "Yıldız Mah (çiçekveren Köyü)",
      "Yolgözler Köyü",
      "Yurtseven Köyü",
      "Adaksu Köyü",
      "Akören Köyü",
      "Bekirhan Mah (karaali Köyü)",
      "Boyundere Köyü",
      "Karaali Köyü",
      "Karahasan Köyü",
      "Kızılyusuf Köyü",
      "Kulcak Köyü",
      "Mağalcık Köyü",
      "Molladerman Köyü",
      "Odaköy Köyü",
      "Oğuzhan Köyü",
      "Örenşar Köyü",
      "Sarıdavut Köyü",
      "Şekerova Mah (oğuzhan Köyü)",
      "Tatargazi Köyü",
      "Yaramış Köyü",
      "Atatürk Mah (konakkuran Beldesi)",
      "Murat Mah (konakkuran Beldesi)",
      "Yeni Mah (konakkuran Beldesi)",
      "Ziyaret Mah (konakkuran Beldesi)",
      "Adalar Mah",
      "Afşin Mah",
      "Aksungur Mah",
      "Alişan Mah",
      "Altuntaş Mah",
      "Danışmentgazi Mah",
      "Mengüçgazi Mah",
      "Murat Mah",
      "Saftekingazi Mah",
      "Saltukgazi Mah",
      "Selçuklu Mah",
      "Şekerbulak Mah",
      "Alınca Mah (mezraaköy Köyü)",
      "Alyar Köyü",
      "Aradere Köyü",
      "Aynalıhoca Köyü",
      "Beşçatak Köyü",
      "Bilgin Mah (gülkoru Köyü)",
      "Bostankaya Köyü",
      "Çayırdere Köyü",
      "Dolabaş Köyü",
      "Eyyubi Mah (gülkoru Köyü)",
      "Güleç Köyü",
      "Hanoğlu Köyü",
      "Hasretpınar Köyü",
      "Karakaya Köyü",
      "Kılıççı Köyü",
      "Mezraaköy Köyü",
      "Mollabaki Köyü",
      "Muratkolu Köyü",
      "Okçuhan Köyü",
      "Selekutu Köyü",
      "Seydagil Mah (gülkoru Köyü)",
      "Tatlıca Köyü",
      "1 Mah (bahçe Köyü)",
      "2 Mah (bahçe Köyü)",
      "Akalan Köyü",
      "Alikalkan Köyü",
      "Arslankaya Köyü",
      "Aşağıkıcık Köyü",
      "Dirimpınar Köyü",
      "Doğantaş Köyü",
      "Gölağılı Köyü",
      "Hancağız Köyü",
      "Hasanpaşa Köyü",
      "Koçali Köyü",
      "Laladağı Köyü",
      "Nurettin Köyü",
      "Söğütlü Köyü",
      "Taşlıçeşme Mah (nurettin Köyü)",
      "Yukarıkıcık Köyü"
    ],
    "Merkez": [
      "Bağlar Mah (karaağaçlı Beldesi)",
      "Çubuklu Mah (karaağaçlı Beldesi)",
      "Kültür Mah (karaağaçlı Beldesi)",
      "Bahçelievler Mah (kırköy Beldesi)",
      "Düz Mah (kırköy Beldesi)",
      "Kültür Mah (kırköy Beldesi)",
      "Yeni Mah (kırköy Beldesi)",
      "Fetullahağa Mah (kızılağaç Beldesi)",
      "Kültür Mah (kızılağaç Beldesi)",
      "Yeşilyurt Mah (kızılağaç Beldesi)",
      "Körpeağaç Mah (konukbekler Beldesi)",
      "Minare Mah (konukbekler Beldesi)",
      "Osb Mah (konukbekler Beldesi)",
      "Şirinevler Mah (konukbekler Beldesi)",
      "Yeroluk Mah (konukbekler Beldesi)",
      "Dere Mah",
      "Hürriyet Mah",
      "Kale Mah",
      "Kültür Mah",
      "Minare Mah",
      "Muratpaşa Mah",
      "Saray Mah",
      "Sunay Mah",
      "Yeşilce Mah",
      "Yeşilyurt Mah",
      "Zafer Mah",
      "15 Temmuz Milli İrade Mah",
      "Ağaçlık Mah (ağaçlık Köyü)",
      "Ağartı Köyü",
      "Ağıllı Köyü",
      "Ağıztadı Mah (derecik Köyü)",
      "Akkonak Köyü",
      "Akpınar Köyü",
      "Alagün Köyü",
      "Alaniçi Köyü",
      "Alican Köyü",
      "Aligedik Köyü",
      "Altıkardeş Mah (inardı Köyü)",
      "Ambarmevkii Mah (cevizlidere Köyü)",
      "Arıköy Köyü",
      "Arpayazı Köyü",
      "Askar Mah (köşk Köyü)",
      "Aşağı Halat Mah (ulukaya Köyü)",
      "Aşağı Perzing Mah (derecik Köyü)",
      "Aşağısızma Köyü",
      "Aşağısoğuksu Mah (beşparmak Köyü)",
      "Aşağıyongalı Köyü",
      "Aydoğan Köyü",
      "Aydoğdu Mah (ulukaya Köyü)",
      "Ayrancı Mah (karabey Köyü)",
      "Ayranlı Mah (alican Köyü)",
      "Bağlar Mah",
      "Bağraç Mah (derecik Köyü)",
      "Bahar Mah (sarıdal Köyü)",
      "Bahçeköy Köyü",
      "Balcılar Köyü",
      "Balözü Mah (derecik Köyü)",
      "Başak Mah (suluca Köyü)",
      "Berbermevkii Mah (cevizlidere Köyü)",
      "Beşparmak Köyü",
      "Bilek Köyü",
      "Bostankent Mah (bostankent Köyü)",
      "Boyuncuk Köyü",
      "Bozbulut Köyü",
      "Buğdaylı Mah (kayalısu Köyü)",
      "Büyükler Mah (kayalısu Köyü)",
      "Cafer Mah (bozbulut Köyü)",
      "Çakmak Mah (karabey Köyü)",
      "Çatbaşı Köyü",
      "Çetinler Mah (bahçeköy Köyü)",
      "Çevirme Mah (arpayazı Köyü)",
      "Çiçekli Köyü",
      "Çöğürlü Mah (çöğürlü Köyü)",
      "Çukurbağ Köyü",
      "Dahal Mah (cevizlidere Köyü)",
      "Danacık Mah (inardı Köyü)",
      "Darboğaz Mah (derecik Köyü)",
      "Demler Mah (karlıdere Köyü)",
      "Depomevkii Mah (cevizlidere Köyü)",
      "Dere Mah (güdümlü Köyü)",
      "Derecik Köyü",
      "Dereiçi Mah (balcılar Köyü)",
      "Derekarabey Mah (karabey Köyü)",
      "Dereyurt Köyü",
      "Dilimli Köyü",
      "Donatım Mah (donatım Köyü)",
      "Dumlusu Köyü",
      "Dursunlu Mah (ağartı Köyü)",
      "Durugöze Köyü",
      "Düzkarabey Mah (karabey Köyü)",
      "Eğirmeç Köyü",
      "Ekinci Mah (ılıca Köyü)",
      "Ekindüzü Köyü",
      "Elçiler Köyü",
      "Emekmezraası Mah (derecik Köyü)",
      "Eralanı Köyü",
      "Erencik Köyü",
      "Erkan Mah (taşoluk Köyü)",
      "Eşme Mah (gölköy Köyü)",
      "Fındıklı Mah (aligedik Köyü)",
      "Gökçeli Mah (ekindüzü Köyü)",
      "Gölköy Köyü",
      "Gümüşali Köyü",
      "Gündoğan Köyü",
      "Gürgüre Mah (eralanı Köyü)",
      "Güvendik Mah (inardı Köyü)",
      "Güzeltepe Mah",
      "Hacı Şükrü Mah (kıyıbaşı Köyü)",
      "Halitbey Mah (ağartı Köyü)",
      "Harıpşanmezrası Mah (cevizlidere Köyü)",
      "Harman Köyü",
      "Hasalan Mah (cevizlidere Köyü)",
      "Haşikmezrası Mah (cevizlidere Köyü)",
      "Hişan Mah (karlıdere Köyü)",
      "Hozan Mah (derecik Köyü)",
      "Ilıca Köyü",
      "Incesu Mah (ılıca Köyü)",
      "Işıklı Mah (erencik Köyü)",
      "İnardı Köyü",
      "Kalecik Köyü",
      "Kamış Mah (karabey Köyü)",
      "Kamışlı Mah (ağartı Köyü)",
      "Karaağaç Mah (mescitli Köyü)",
      "Karabey Köyü",
      "Karaköprü Mah (karaköprü Köyü)",
      "Karakuyu Mah (karakuyu Köyü)",
      "Karameşe Köyü",
      "Kardeşler Mah (inardı Köyü)",
      "Karlıdere Köyü",
      "Karnı Mah (ağaçlık Köyü)",
      "Karşıyaka Mah",
      "Kayalısu Köyü",
      "Kayaşık Köyü",
      "Keçidere Köyü",
      "Kepenek Köyü",
      "Kırık Mah (inardı Köyü)",
      "Kıyıbaşı Köyü",
      "Kıyık Mah (kıyık Köyü)",
      "Kilaroz Mah (derecik Köyü)",
      "Kilismevkii Mah (cevizlidere Köyü)",
      "Konak Mah (inardı Köyü)",
      "Köşk Köyü",
      "Kumluca Köyü",
      "Kurtuluş Mah (eralanı Köyü)",
      "Kurtuluşmezraa Mah (güdümlü Köyü)",
      "Kutkan Mah (karlıdere Köyü)",
      "Kutlugün Köyü",
      "Mercimekkale Köyü",
      "Merganmezrası Mah (cevizlidere Köyü)",
      "Mergi Mah (karlıdere Köyü)",
      "Merkezmah Mah (güdümlü Köyü)",
      "Mescitli Köyü",
      "Meşecik Köyü",
      "Mudevirmezrası Mah (cevizlidere Köyü)",
      "Muratgören Köyü",
      "Nadaslık Köyü",
      "Ortakent Köyü",
      "Oymataş Köyü",
      "Örencik Mah (keçidere Köyü)",
      "Örtülü Mah (kayalısu Köyü)",
      "Özdemir Mah (savaşçılar Köyü)",
      "Özdilek Köyü",
      "Özgürevler Mah (kıyık Köyü)",
      "Perşembe Mah (ağartı Köyü)",
      "Recelanmezraası Mah (cevizlidere Köyü)",
      "Sağlık Köyü",
      "Sarıdal Köyü",
      "Savaşçılar Köyü",
      "Selim Mah (derecik Köyü)",
      "Soğucak Mah (soğucak Köyü)",
      "Soğukpınar Mah (balcılar Köyü)",
      "Soğuksu Mah (beşparmak Köyü)",
      "Sönmezler Mah (kalecik Köyü)",
      "Spikanmezrası Mah (karlıdere Köyü)",
      "Suboyu Köyü",
      "Sudurağı Köyü",
      "Suluca Köyü",
      "Suvaran Mah (suvaran Köyü)",
      "Sürügüden Köyü",
      "Sütlüce Mah",
      "Şenoba Köyü",
      "Şenyayla Mah (yamaç Köyü)",
      "Tabanlı Köyü",
      "Tandoğan Mah (tandoğan Köyü)",
      "Taşoluk Köyü",
      "Tekyol Köyü",
      "Tete Mah (derecik Köyü)",
      "Toprakkale Köyü",
      "Tosunlu Mah (ılıca Köyü)",
      "Tüten Köyü",
      "Tütünlü Mah (derecik Köyü)",
      "Ulukaya Köyü",
      "Üçdere Mah (üçdere Köyü)",
      "Üçevler Köyü",
      "Üçsırt Köyü",
      "Varlık Mah (derecik Köyü)",
      "Yamaç Köyü",
      "Yamaçlı Mah (gümüşali Köyü)",
      "Yarpuzlu Köyü",
      "Yazla Köyü",
      "Yelalan Köyü",
      "Yeni Mah",
      "Yeşil Mah (ağartı Köyü)",
      "Yıldızlı Mah (arıköy Köyü)",
      "Yılmazlı Mah (kayalısu Köyü)",
      "Yoncalıöz Köyü",
      "Yörecik Köyü",
      "Yukarı Halat Mah (ulukaya Köyü)",
      "Yukarımezraa Mah (güdümlü Köyü)",
      "Yukarısızma Köyü",
      "Yukarısoğuksu Mah (beşparmak Köyü)",
      "Yukarıyongalı Köyü",
      "Yücetepe Köyü",
      "Ziyaret Köyü",
      "Aydıngün Mah (serinova Beldesi)",
      "Bakırcılar Mah (serinova Beldesi)",
      "Çağdaş Mah (serinova Beldesi)",
      "Hürriyet Mah (serinova Beldesi)",
      "Karşıyaka Mah (serinova Beldesi)",
      "Bahçelievler Mah (sungu Beldesi)",
      "Hürriyet Mah (sungu Beldesi)",
      "Kültür Mah (sungu Beldesi)",
      "Şehit Naim Çiftçi Mah (sungu Beldesi)",
      "Şehit Yücel Kurtoğlu Mah (sungu Beldesi)",
      "Bahçelievler Mah (yaygın Beldesi)",
      "Dagarası Mah (yaygın Beldesi)",
      "Kardesler Mah (yaygın Beldesi)",
      "Karsıyaka Mah (yaygın Beldesi)",
      "Merkez Mah (yaygın Beldesi)",
      "Yeni Mah (yaygın Beldesi)",
      "Bahçelievler Mah (yeşilova Beldesi)",
      "Kültür Mah (yeşilova Beldesi)",
      "Yeni Mah (yeşilova Beldesi)"
    ],
    "Varto": [
      "Abbas Mah (kartaldere Köyü)",
      "Alabalık Köyü",
      "Ali Mah (köprücük Köyü)",
      "Armutkaşı Köyü",
      "Beşikkaya Köyü",
      "Beşikkaya Yaylası Mah (beşikkaya Köyü)",
      "Çağlayan Mah (kartaldere Köyü)",
      "Çağlek Mah (küçüktepe Köyü)",
      "Çalıdere Köyü",
      "Çallıca Mah (taşlıyayla Köyü)",
      "Çaylar Köyü",
      "Çiçekli Mah (güzeldere Köyü)",
      "Çukurlu Mah (kartaldere Köyü)",
      "Dağcılar Köyü",
      "Doğanca Köyü",
      "Doğanca Mah (güzeldere Köyü)",
      "Erenler Mah (çalıdere Köyü)",
      "Eryurdu Köyü",
      "Gölyayla Köyü",
      "Güzeldere Köyü",
      "Güzelkent Köyü",
      "İçmeler Köyü",
      "Kartaldere Köyü",
      "Kele Mah (dağcılar Köyü)",
      "Köprücük Köyü",
      "Kuşburnu Mah (taşlıyayla Köyü)",
      "Küçüktepe Köyü",
      "Onpınar Köyü",
      "Özkonak Köyü",
      "Pınarlı Mah (dağcılar Köyü)",
      "Taşlıyayla Köyü",
      "Teknedüzü Köyü",
      "Tescilsiz Aşağı Mezra Mah (dağcılar Köyü)",
      "Tescilsiz Kılıç Mah (eryurdu Köyü)",
      "Tescilsiz Midi Mah (teknedüzü Köyü)",
      "Tescilsiz Ozankent Mah (tuzlu Köyü)",
      "Tuzlu Köyü",
      "Üçbulak Köyü",
      "Veli Mah (köprücük Köyü)",
      "Yeşildal Köyü",
      "Yeşiltepe Mah (beşikkaya Köyü)",
      "Acarkent Köyü",
      "Ada Mevkii Mah (zorabat Köyü)",
      "Ağaçaltı Köyü",
      "Ağaçkorur Köyü",
      "Akballar Mah (kaygıntaş Köyü)",
      "Akçatepe Köyü",
      "Anlıaçık Köyü",
      "Aşağı Alagöz Köyü",
      "Aşağı Hacıbey Köyü",
      "Aşağı Kalecik Mah (haksever Köyü)",
      "Bağiçi Köyü",
      "Baltaş Köyü",
      "Başkent Köyü",
      "Bayram Mah (ocaklı Köyü)",
      "Benzer Mah (başkent Köyü)",
      "Boyalı Köyü",
      "Boylu Köyü",
      "Buzlugöze Köyü",
      "Çaltılı Köyü",
      "Çavuşlu Mah (yeşilpınar Köyü)",
      "Çayçatı Köyü",
      "Çayırlı Mah (ünaldı Köyü)",
      "Çayıryolu Köyü",
      "Çayönü Köyü",
      "Çelebi Mah (ocaklı Köyü)",
      "Çobandağı Köyü",
      "Çukurlu Mah (kayalıdere Köyü)",
      "Dağmahale Mah (dallıöz Köyü)",
      "Dallıöz Köyü",
      "Değerli Köyü",
      "Derince Köyü",
      "Diktepeler Köyü",
      "Dönertaş Köyü",
      "Durucabulak Köyü",
      "Dutözü Köyü",
      "Erdoğan Köyü",
      "Esenler Köyü",
      "Gelintaşı Köyü",
      "Göltepe Köyü",
      "Görgü Köyü",
      "Güllüce Mah (çayçatı Köyü)",
      "Hacı Arif Mah (yukarı Hacıbey Köyü)",
      "Haksever Köyü",
      "Hüseyinoğlu Köyü",
      "İlbey Köyü",
      "Kalecik Köyü",
      "Karaç Mah (seki Köyü)",
      "Karaköy Köyü",
      "Karameşe Köyü",
      "Karapınar Köyü",
      "Karataş Mah (ocaklı Köyü)",
      "Kayadelen Köyü",
      "Kayalıdere Köyü",
      "Kayalık Köyü",
      "Kayalıkale Köyü",
      "Kaygıntaş Köyü",
      "Kaynarca Köyü",
      "Koçyatağı Köyü",
      "Kolan Köyü",
      "Konaklı Mah (yeşilpınar Köyü)",
      "Kumlukıyı Köyü",
      "Kuşluk Köyü",
      "Leylek Köyü",
      "Ocaklı Köyü",
      "Oğlakçı Köyü",
      "Omcalı Köyü",
      "Onbaşı Mah (yurttutan Köyü)",
      "Ölçekli Köyü",
      "Özenç Köyü",
      "Sağlıcak Köyü",
      "Sanlıca Köyü",
      "Sazlıca Köyü",
      "Seki Köyü",
      "Taşçı Köyü",
      "Taşdibek Köyü",
      "Tepe Köyü",
      "Tescilsiz Bingöl Mah (dallıöz Köyü)",
      "Tescilsiz Doğdap Mah (tepe Köyü)",
      "Tescilsiz Yıldızlar Mah (buzlugöze Köyü)",
      "Tescilsiz Ziyaret Mah (buzlugöze Köyü)",
      "Toklu Mah (yurttutan Köyü)",
      "Ulusırt Köyü",
      "Ünaldı Köyü",
      "Yamaç Mah (ağaçaltı Köyü)",
      "Yarlısu Köyü",
      "Yayıklı Köyü",
      "Yayla Köyü",
      "Yedikavak Köyü",
      "Yekmal Mah (görgü Köyü)",
      "Yeşilpınar Köyü",
      "Yılanlı Köyü",
      "Yukarı Hacıbey Köyü",
      "Yukarı Kalecik Mah (haksever Köyü)",
      "Yurttutan Köyü",
      "Yuvalı Mah (erdoğan Köyü)",
      "Zorabat Köyü",
      "Alagöz Mah",
      "Bahçelievler Mah",
      "Gümgüm Mah",
      "Hürriyet Mah",
      "İnönü Mah",
      "Kültür Mah",
      "Yeni Mah"
    ]
  },
  "Nevşehir": {
    "Acıgöl": [
      "Bahçeli Mah",
      "Cumhuriyet Mah",
      "Çayırlık Mah",
      "Organize Sanayi Bölgesi Mah",
      "Yukarı Mah",
      "Bahçeli Evler Mah (karapınar Beldesi)",
      "Mustafapaşa Mah (karapınar Beldesi)",
      "1 Küme Mah (ağıllı Köyü)",
      "1 Küme Mah (topaç Köyü)",
      "1 Mah (yuva Köyü)",
      "2 Küme Mah (ağıllı Köyü)",
      "2 Küme Mah (topaç Köyü)",
      "2 Mah (tepeköy Köyü)",
      "2 Mah (yuva Köyü)",
      "3 Küme Mah (ağıllı Köyü)",
      "3 Küme Mah (topaç Köyü)",
      "3 Mah (tepeköy Köyü)",
      "3 Mah (yuva Köyü)",
      "4 Küme Mah (ağıllı Köyü)",
      "4 Küme Mah (topaç Köyü)",
      "Acıgöl-nevşehir Mah (karacaören Köyü)",
      "Acısu Yolu Mah (karacaören Köyü)",
      "Aşağı Mah (kurugöl Köyü)",
      "Bağlıca Köyü",
      "Cumhuriyet Mah (inallı Köyü)",
      "Çullar Köyü",
      "Dere Yatağı Mah (karacaören Köyü)",
      "Karacaören Köyü",
      "Kozluca Köyü",
      "Köy İçi Mah (karacaören Köyü)",
      "Nevşehir Mah (karacaören Köyü)",
      "Tepeköy Köyü",
      "Yeni Mah (inallı Köyü)",
      "Yukarı Mah (kurugöl Köyü)",
      "Ballık Mah (tatlarin Beldesi)",
      "Kale Mah (tatlarin Beldesi)"
    ],
    "Avanos": [
      "Alaaddin Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Karaseki Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Aşağı Mah (çalış Beldesi)",
      "Orta Mah",
      "Orta Mah (çalış Beldesi)",
      "Yukarı Mah (çalış Beldesi)",
      "50.yıl Mah (kalaba Beldesi)",
      "Bahçelievler Mah (göynük Köyü)",
      "Gözenekli Mah (göynük Köyü)",
      "Hürriyet Mah (kalaba Beldesi)",
      "Karayusuf Mah (kalaba Beldesi)",
      "Yeni Mah (göynük Köyü)",
      "Yeni Mah (kalaba Beldesi)",
      "1.küme Mah (çavuşin Köyü)",
      "1.küme Mah (üçkuyu Köyü)",
      "2.küme Mah (çavuşin Köyü)",
      "2.küme Mah (üçkuyu Köyü)",
      "3.küme Mah (çavuşin Köyü)",
      "3.küme Mah (üçkuyu Köyü)",
      "Afet Evleri Kümesi Mah (bozca Köyü)",
      "Aktepe Köyü",
      "Altıpınar Köyü",
      "Bağlarbaşı Mah (mahmat Köyü)",
      "Bağlarbaşı Mah (topaklı Köyü)",
      "Bahçelievler Mah (mahmat Köyü)",
      "Burunkaya Kümesi Mah (bozca Köyü)",
      "Dere Kümesi Mah (bozca Köyü)",
      "Fatih Mah (akarca Köyü)",
      "Hürriyet Mah (akarca Köyü)",
      "Karacauşağı Köyü",
      "Köşe Kümesi Mah (bozca Köyü)",
      "Kuyulukışla Köyü",
      "Orta Küme Mah (bozca Köyü)",
      "Orta Mah (mahmat Köyü)",
      "Orta Mah (topaklı Köyü)",
      "Paşalı Köyü",
      "Yeni Mah (topaklı Köyü)",
      "Aşağı Küme Mah (küçükayhan Köyü)",
      "Bozdağ Kümesi Mah (büyükayhan Köyü)",
      "Cami Kümesi Mah (iğdelikışla Köyü)",
      "Camicedit Mah (özkonak Beldesi)",
      "Cami-kebir Mah (özkonak Beldesi)",
      "Harım Kümesi Mah (büyükayhan Köyü)",
      "Kale Küme Mah (küçükayhan Köyü)",
      "Kayabaşı Kümesi Mah (küçükayhan Köyü)",
      "Kuzuluk Kümesi Mah (büyükayhan Köyü)",
      "Muradiye Mah (sarılar Köyü)",
      "Orta Küme Mah (büyükayhan Köyü)",
      "Orta Mah (özkonak Beldesi)",
      "Ortaokul Kümesi Mah (iğdelikışla Köyü)",
      "Yavuz Sultan Selim Mah (sarılar Köyü)",
      "Yenisoy Mah (sarılar Köyü)"
    ],
    "Derinkuyu": [
      "Baş Mah",
      "Bayramlı Mah",
      "Cumhuriyet Mah",
      "Demirci Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Namık Kemal Mah",
      "Yeni Mah",
      "Aşağı Mah (çakıllı Köyü)",
      "Aşağı Mah (doğala Köyü)",
      "Aşağı Mah (til Köyü)",
      "Çakmak Mah (doğala Köyü)",
      "Çay Mah (doğala Köyü)",
      "Erzurum Mah (çakıllı Köyü)",
      "Göl Mah (kuyulutatlar Köyü)",
      "Güneyce Köyü",
      "Kale Mah (kuyulutatlar Köyü)",
      "Kale Mah (suvermez Köyü)",
      "Kaymaklı Yolu Mah (özlüce Köyü)",
      "Okul Mah (özlüce Köyü)",
      "Orta Mah (doğala Köyü)",
      "Orta Mah (kuyulutatlar Köyü)",
      "Orta Mah (til Köyü)",
      "Uzunsay Mah (til Köyü)",
      "Yeni Mah (kuyulutatlar Köyü)",
      "Yeni Mah (suvermez Köyü)",
      "Yenicami Mah (özlüce Köyü)",
      "Yenidoğan Mah (özlüce Köyü)",
      "Yukarı Mah (çakıllı Köyü)",
      "Yukarı Mah (til Köyü)",
      "Alparslan Mah (yazıhüyük Beldesi)",
      "Bozkır Mah (yazıhüyük Beldesi)",
      "Göktürk Mah (yazıhüyük Beldesi)",
      "Polatkan Mah (yazıhüyük Beldesi)"
    ],
    "Gülşehir": [
      "Açıksaray Mah",
      "Cumhuriyet Mah",
      "Çalışanlar Mah",
      "Çayır Mah",
      "Erol Ünlüsoy Mah",
      "Fatih Mah",
      "Karacaşar Mah",
      "Karavezir Mah",
      "Oruçreis Mah",
      "Tuzköyü Mah",
      "100.yıl Mah (abuuşağı Köyü)",
      "Alemli Köyü",
      "Alkan Köyü",
      "Aşağı Mah (yeşilli Köyü)",
      "Atatürk Mah (dadağı Köyü)",
      "Atatürk Mah (terlemez Köyü)",
      "Bahçelievler Mah (civelek Köyü)",
      "Bölükören Köyü",
      "Cumhuriyet Mah (gümüşkent Köyü)",
      "Cumhuriyet Mah (ovaören Köyü)",
      "Cumhuriyet Mah (yeşilöz Köyü)",
      "Eğrikuyu Köyü",
      "Esen Mah (dadağı Köyü)",
      "Fakıuşağı Köyü",
      "Fatih Mah (emmiler Köyü)",
      "Fevziçakmak Mah (abuuşağı Köyü)",
      "Fevziçakmak Mah (ovaören Köyü)",
      "Gazi Mah (ovaören Köyü)",
      "Gökçetoprak Köyü",
      "Gülpınar Köyü",
      "Güzelevler Mah (civelek Köyü)",
      "Hacılar Köyü",
      "Hamzalı Köyü",
      "Hürriyet Mah (yeşilöz Köyü)",
      "İsmailuşağı Mah (eskiyaylacık Köyü)",
      "Karahüyük Köyü",
      "Karşıyaka Mah (gümüşkent Köyü)",
      "Karşıyaka Mah (terlemez Köyü)",
      "Kazım Karabekir Mah (dadağı Köyü)",
      "Kışla Mah (eskiyaylacık Köyü)",
      "Kızılkaya Köyü",
      "Koyak Mah (yeşilli Köyü)",
      "Körler Mah (gümüşyazı Köyü)",
      "Köyiçi Mah (eskiyaylacık Köyü)",
      "Köyiçi Mah (hacıhalilli Köyü)",
      "Mezarlık Mah (yeşilöz Köyü)",
      "Mezra Mah (hacıhalilli Köyü)",
      "Oğulkaya Köyü",
      "Orta Mah (emmiler Köyü)",
      "Orta Mah (yeşilli Köyü)",
      "Orta Mah (yeşilöz Köyü)",
      "Ötegeçe Mah (gümüşyazı Köyü)",
      "Şahinler Köyü",
      "Yakatarla Köyü",
      "Yalıntaş Köyü",
      "Yamalı Köyü",
      "Yeni Mah (abuuşağı Köyü)",
      "Yeni Mah (emmiler Köyü)",
      "Yeni Mah (gümüşkent Köyü)",
      "Yeniyaylacık Köyü",
      "Yeşilyurt Köyü",
      "Yüksekli Köyü"
    ],
    "Hacıbektaş": [
      "Bala Mah",
      "Savat Mah",
      "Zir Mah",
      "Akçataş Köyü",
      "Anapınar Köyü",
      "Aşağıbarak Köyü",
      "Aşıklar Köyü",
      "Avuç Köyü",
      "Bahçelievler Mah (karaburna Köyü)",
      "Bahçelievler Mah (kızılağıl Köyü)",
      "Başköy Köyü",
      "Belbarak Köyü",
      "Büyükburunağıl Köyü",
      "Büyükkışla Köyü",
      "Cumhuriyet Mah (kızılağıl Köyü)",
      "Çiğdem Köyü",
      "Çivril Köyü",
      "Hasanlar Köyü",
      "Hıdırlar Köyü",
      "Hırkatepesidelik Köyü",
      "İlicek Köyü",
      "Karaburç Köyü",
      "Karaova Köyü",
      "Kayaaltı Köyü",
      "Kayı Köyü",
      "Killik Köyü",
      "Kisecik Köyü",
      "Köşektaş Köyü",
      "Kütükçü Köyü",
      "Mikail Köyü",
      "Sadık Köyü",
      "Yeni Mah (karaburna Köyü)",
      "Yenice Köyü",
      "Yeniyapan Köyü",
      "Yurtyeri Köyü"
    ],
    "Kozaklı": [
      "Altunsu Mah",
      "Bağlıca Mah",
      "Bahçelievler Mah",
      "Buruncuk Mah",
      "Emek Mah",
      "Hamamorta Mah",
      "Hoca Ahmet Yesevi Mah",
      "Kızılkoyunlu Mah",
      "Yabanlı Mah",
      "Yeni Mah",
      "Abdi Köyü",
      "Akpınar Köyü",
      "Altınova Mah (karasenir Köyü)",
      "Aşağı Mah (kalecik Köyü)",
      "Aylı Köyü",
      "Bahçeli Mah (karasenir Köyü)",
      "Belekli Köyü",
      "Boğaziçi Köyü",
      "Büyükyağlı Köyü",
      "Cağşak Köyü",
      "Camikebir Mah (karahasanlı Köyü)",
      "Çayiçi Köyü",
      "Doyduk Köyü",
      "Dörtyol Köyü",
      "Gerce Köyü",
      "Gültepe Mah (kanlıca Köyü)",
      "Hacıfakılı Köyü",
      "Hızıruşağı Köyü",
      "İmran Köyü",
      "İstasyon Mah (kanlıca Köyü)",
      "Kapaklı Köyü",
      "Karşı Mah (karahasanlı Köyü)",
      "Kaşkışla Köyü",
      "Kuruağıl Köyü",
      "Küçükyağlı Köyü",
      "Küllüce Köyü",
      "Merdanali Köyü",
      "Orta Mah (kalecik Köyü)",
      "Orta Mah (karahasanlı Köyü)",
      "Orta Mah (karasenir Köyü)",
      "Özce Köyü",
      "Sadıkali Mah (karahasanlı Köyü)",
      "Taşlıhüyük Köyü",
      "Yassıca Köyü",
      "Yeni Mah (kanlıca Köyü)",
      "Yeşilova Mah (kanlıca Köyü)",
      "Yukarı Mah (kalecik Köyü)",
      "Yukarı Mah (karasenir Köyü)"
    ],
    "Merkez": [
      "Bahçelievler Mah",
      "Camicedit Mah",
      "Emek Mah",
      "Raşitbey Mah",
      "15 Temmuz Mah",
      "20 Temmuz Mah",
      "2000 Evler Mah",
      "350 Evler Mah",
      "Bekdik Mah",
      "Cevher Dudayev Mah",
      "Esentepe Mah",
      "Fatih Sultan Mehmet Mah",
      "Güzelyurt Mah",
      "Hacırüştü Mah",
      "Herikli Mah",
      "İbrahimpaşa Mah",
      "Kapucubaşı Mah",
      "Karasoku Mah",
      "Kıratlıoğlu Mah",
      "M.akif Ersoy Mah",
      "Sümer Mah",
      "Yeni Mah",
      "15 Temmuz Mah (çat Beldesi)",
      "Cumhuriyet Mah (çat Beldesi)",
      "İstiklal Mah (çat Beldesi)",
      "Afetevleri Mah (göre Beldesi)",
      "Kasapoğlu Mah (göre Beldesi)",
      "Aydınlı-orta Mah (göreme Beldesi)",
      "İsali-gaferli-avcılar Mah (göreme Beldesi)",
      "Aşağı Mah (kavak Beldesi)",
      "Yukarı Mah (kavak Beldesi)",
      "Bekirağa Mah (kaymaklı Beldesi)",
      "Camikebir Mah (kaymaklı Beldesi)",
      "Hatipoğlu Mah (kaymaklı Beldesi)",
      "Acıgöl Yolu Mah (boğaz Köyü)",
      "Alacaşar Köyü",
      "Aşağı Mah (çardak Köyü)",
      "Aşağı Mah (güvercinlik Köyü)",
      "Aşağı Mah (özyayla Köyü)",
      "Bahçelievler Mah (çardak Köyü)",
      "Balcın Köyü",
      "Basansarnıç Köyü",
      "Boğaz Köyü",
      "Çay Mah (çardak Köyü)",
      "Çay Mah (güvercinlik Köyü)",
      "Çiftlikköy Köyü",
      "Ertaş Mah (icik Köyü)",
      "Harım Mah (güvercinlik Köyü)",
      "Hicim Baba Mah (icik Köyü)",
      "Karşı Mah (güvercinlik Köyü)",
      "Karşı Mah (icik Köyü)",
      "Orta Mah (çardak Köyü)",
      "Seray Mah (çardak Köyü)",
      "Şahintepesi Mah (çardak Köyü)",
      "Tepe Mah (icik Köyü)",
      "Tepecik Mah (özyayla Köyü)",
      "Yeni Mah (çardak Köyü)",
      "Yeni Mah (özyayla Köyü)",
      "Yukarı Mah (güvercinlik Köyü)",
      "Yukarı Mah (icik Köyü)",
      "Yukarı Mah (özyayla Köyü)",
      "Aşağı Mah (nar Beldesi)",
      "Baş Mah (nar Beldesi)",
      "Orta Mah (nar Beldesi)",
      "Yeni Mah (nar Beldesi)",
      "Cumhuriyet Mah (sulusaray Beldesi)",
      "Sultan Aladdin Mah (sulusaray Beldesi)",
      "Yeni Mah (sulusaray Beldesi)",
      "Aşağı Mah (uçhisar Beldesi)",
      "Tekelli Mah (uçhisar Beldesi)",
      "Yukarı Mah (uçhisar Beldesi)"
    ],
    "Ürgüp": [
      "Akçaören Köyü",
      "Akköy Köyü",
      "Ayvalı Köyü",
      "Bahçeli Köyü",
      "Boyalı Köyü",
      "Cemil Köyü",
      "Çökek Köyü",
      "Davutlu Mah (mustafapaşa Köyü)",
      "Demirtaş Köyü",
      "Eyüplü Mah (başdere Köyü)",
      "İbrahimpaşa Köyü",
      "İltaş Köyü",
      "Karacaören Köyü",
      "Karain Köyü",
      "Karakaya Köyü",
      "Karlık Köyü",
      "Mazı Köyü",
      "Orta Mah (başdere Köyü)",
      "Sarıhıdır Köyü",
      "Sofular Köyü",
      "Sultanım Mah (başdere Köyü)",
      "Şahinefendi Köyü",
      "Taşkınpaşa Köyü",
      "Ulaşlı Köyü",
      "Yeni Mah (başdere Köyü)",
      "Yeni Mah (mustafapaşa Köyü)",
      "Yeşilöz Köyü",
      "Yukarı Mah (mustafapaşa Köyü)",
      "Bahçelievler Mah (ortahisar Beldesi)",
      "Esentepe Mah (ortahisar Beldesi)",
      "Eski Mah (ortahisar Beldesi)",
      "Yeni Mah (ortahisar Beldesi)",
      "15 Temmuz Mah",
      "Aksalur Ağcaşar Mah",
      "Aksalur Salur Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Duayeri Mah",
      "Evka Mah",
      "Fatih Mah",
      "Kavaklıönü Mah",
      "Temenni Mah"
    ]
  },
  "Niğde": {
    "Altunhisar": [
      "Aşağı Mah",
      "İstiklal Mah",
      "Orta Mah",
      "Sağlık Mah",
      "Uluören Köyü",
      "Yukarı Mah",
      "Cumhuriyet Mah (karakapı Beldesi)",
      "Yaka Mah (karakapı Beldesi)",
      "Yeni Mah (karakapı Beldesi)",
      "Cumhuriyet Mah (keçikalesi Beldesi)",
      "Erenler Mah (keçikalesi Beldesi)",
      "Selçuk Mah (keçikalesi Beldesi)",
      "Cumhuriyet Mah (akçaören Köyü)",
      "Cumhuriyet Mah (çömlekçi Köyü)",
      "Cumhuriyet Mah (ulukışla Köyü)",
      "Cumhuriyet Mah (yakacık Köyü)",
      "Hürriyet Mah (çömlekçi Köyü)",
      "Hürriyet Mah (ulukışla Köyü)",
      "İstiklal Mah (akçaören Köyü)",
      "Kale Mah (yeşilyurt Köyü)",
      "Köşk Mah (yeşilyurt Köyü)",
      "Kurtuluş Mah (çömlekçi Köyü)",
      "Kurtuluş Mah (ulukışla Köyü)",
      "Şafak Mah (akçaören Köyü)",
      "Şafak Mah (yakacık Köyü)",
      "Yakacık Mah (yakacık Köyü)",
      "Yukarı Asmaz Mah (yeşilyurt Köyü)",
      "Zafer Mah (akçaören Köyü)"
    ],
    "Bor": [
      "Cumhuriyet Mah (bahçeli Beldesi)",
      "Saray Mah (bahçeli Beldesi)",
      "Şeker Mah (bahçeli Beldesi)",
      "Zafer Mah (bahçeli Beldesi)",
      "Acıgöl Mah",
      "Ahmet Kuddusi Mah",
      "Armutlu Mah",
      "Bağdüz Mah",
      "Başpınar Mah",
      "Cığızoğlu Osman Efendi Mah",
      "Cumhuriyet Mah",
      "Dink Mah",
      "Fatih Mah",
      "Harım Mah",
      "Kale Mah",
      "Karaca Uğurlu Mah",
      "Mehmetçik Mah",
      "Organize Sanayi Bölgesi Mah",
      "Orta Mah",
      "Saltuk Mah",
      "Sıra Söğütler Mah",
      "Sokubaşı Mah",
      "Şeker Mah",
      "Toplu Konut Mah",
      "Yenigöçmen Mah",
      "Bektik Mah (çukurkuyu Beldesi)",
      "Türkmen Yurdu Mah (çukurkuyu Beldesi)",
      "Cami Mah (kemerhisar Beldesi)",
      "Cumhuriyet Mah (kemerhisar Beldesi)",
      "Çayır Mah (kemerhisar Beldesi)",
      "Han Mah (kemerhisar Beldesi)",
      "Kemer Mah (kemerhisar Beldesi)",
      "Tepe Mah (kemerhisar Beldesi)",
      "Akbaş Mah (balcı Köyü)",
      "Altınova Mah (tepeköy Köyü)",
      "Azizler Mah (kızılca Köyü)",
      "Badak Köyü",
      "Balcı Mah (balcı Köyü)",
      "Bayat Köyü",
      "Bereke Köyü",
      "Cami Mah (kızılca Köyü)",
      "Cumhuriyet Mah (karanlıkdere Köyü)",
      "Emen Köyü",
      "Esendere Mah (karanlıkdere Köyü)",
      "Gayret Mah (balcı Köyü)",
      "Gökbez Köyü",
      "Halaç Köyü",
      "Havuzlu Köyü",
      "Karacaören Köyü",
      "Karamahmutlu Köyü",
      "Karşıyaka Mah (karanlıkdere Köyü)",
      "Kavuklu Köyü",
      "Kayı Köyü",
      "Kaynarca Köyü",
      "Kılavuz Köyü",
      "Kınıkovası Mah (tepeköy Köyü)",
      "Kızılkapı Köyü",
      "Kürkçü Köyü",
      "Obruk Köyü",
      "Okçu Köyü",
      "Okullar Mah (kızılca Köyü)",
      "Postallı Köyü",
      "Seslikaya Köyü",
      "Tepeköy Köyü"
    ],
    "Çamardı": [
      "Bereketli Mah",
      "Maden Mah",
      "Yeni Çarşı Mah",
      "Yunus Emre Mah",
      "Bademli Mah (bademdere Köyü)",
      "Bahçeli Mah (bademdere Köyü)",
      "Bekçili Köyü",
      "Beyazkışlakçı Köyü",
      "Boğaziçi Mah (bademdere Köyü)",
      "Camız Keleri Mah (üçkapılı Köyü)",
      "Celaller Köyü",
      "Cumhuriyet Mah (burç Köyü)",
      "Çardacık Köyü",
      "Çukurbağ Köyü",
      "Demirkazık Köyü",
      "Elekgölü Köyü",
      "Eynelli Köyü",
      "Kale Mah (üçkapılı Köyü)",
      "Kavaklıgöl Köyü",
      "Kavlaktepe Köyü",
      "Kocapınar Köyü",
      "Mahmatlı Köyü",
      "Orhaniye Köyü",
      "Ören Köyü",
      "Pınarbaşı Köyü",
      "Sulucaova Köyü",
      "Üçkapılı Köyü",
      "Yelatan Köyü",
      "Yeni Mah (burç Köyü)",
      "Yeniköy Köyü"
    ],
    "Çiftlik": [
      "Çayır Mah (azatlı Beldesi)",
      "Küllüce Mah (azatlı Beldesi)",
      "Sağırgöl Mah (azatlı Beldesi)",
      "Yeni Mah (azatlı Beldesi)",
      "Yeşilkent Mah (azatlı Beldesi)",
      "Yenice Mah (bozköy Beldesi)",
      "Yenikent Mah (bozköy Beldesi)",
      "Yeşilyurt Mah (bozköy Beldesi)",
      "Alpaslan Mah (divarlı Beldesi)",
      "Fatih Mah (divarlı Beldesi)",
      "Yeni Mah (divarlı Beldesi)",
      "1.ci Küme Mah (çardak Köyü)",
      "2.ci Küme Mah (çardak Köyü)",
      "3.ci Küme Mah (çardak Köyü)",
      "Alışlı Mah (çınarlı Köyü)",
      "Aşağı Mevki Mah (şeyhler Köyü)",
      "Bahçe Mah (kula Köyü)",
      "Bekiroğlu Mah (kula Köyü)",
      "Çakıl İçi Mevki Mah (şeyhler Köyü)",
      "Çardak Köyü",
      "Çarşı Mah (kitreli Köyü)",
      "Çınarlı Köyü",
      "Köprübaşı Mah (kitreli Köyü)",
      "Köyaltı Mah (kula Köyü)",
      "Mahmutlu Köyü",
      "Mezaraltı Mah (kula Köyü)",
      "Murtazaköy Köyü",
      "Ovalıbağ Köyü",
      "Sultanpınarı Köyü",
      "Ulucami Mah (kitreli Köyü)",
      "Yeni Mah (kitreli Köyü)",
      "Yeni Mevki Mah (şeyhler Köyü)",
      "Yukarı Mevki Mah (kula Köyü)",
      "Yukarı Mevki Mah (şeyhler Köyü)",
      "Asmasız Mah",
      "Çarşı Mah",
      "Çiftçi Mah",
      "Yeni Mah"
    ],
    "Merkez": [
      "Alaaddin Mah",
      "Aşağı Kayabaşı Mah",
      "Dere Mah",
      "Efendibey Mah",
      "İnönü Mah",
      "Şehitler Mah",
      "Yenice Mah",
      "Yukarı Kayabaşı Mah",
      "Cumhuriyet Mah (aktaş Beldesi)",
      "Devlet Mah (aktaş Beldesi)",
      "Yeni Mah (aktaş Beldesi)",
      "Cumhuriyet Mah (alay Beldesi)",
      "Hürriyet Mah (alay Beldesi)",
      "Milliyet Mah (alay Beldesi)",
      "Cumhuriyet Mah (bağlama Beldesi)",
      "Hürriyet Mah (bağlama Beldesi)",
      "Aşağı Mah (değirmenli Beldesi)",
      "Orta Mah (değirmenli Beldesi)",
      "Yukarı Mah (değirmenli Beldesi)",
      "Cumhuriyet Mah (dündarlı Beldesi)",
      "Fatih Mah (dündarlı Beldesi)",
      "Yenice Mah (dündarlı Beldesi)",
      "Zafer Mah (dündarlı Beldesi)",
      "Cumhuriyet Mah (edikli Beldesi)",
      "Fevzipaşa Mah (edikli Beldesi)",
      "Hürriyet Mah (edikli Beldesi)",
      "Yeni Mah (edikli Beldesi)",
      "Eski Gümüş Mah (gümüşler Beldesi)",
      "Yeni Gümüş Mah (gümüşler Beldesi)",
      "Boğaziçi Mah (hacıabdullah Beldesi)",
      "Yeni Mah (hacıabdullah Beldesi)",
      "Dumlupınar Mah (karaatlı Beldesi)",
      "Fatih Mah (karaatlı Beldesi)",
      "Zafer Mah (karaatlı Beldesi)",
      "Cumhuriyet Mah (kiledere Beldesi)",
      "Hürriyet Mah (kiledere Beldesi)",
      "Cumhuriyet Mah (konaklı Beldesi)",
      "Hürriyet Mah (konaklı Beldesi)",
      "Hüyük Mah (konaklı Beldesi)",
      "Ağcaşar Köyü",
      "Aşağı Mah (koyunlu Köyü)",
      "Aşağı Mah (ovacık Köyü)",
      "Aşlama Köyü",
      "Bağlar Mah (çavdarlı Köyü)",
      "Bahçelievler Mah (içmeli Köyü)",
      "Bahçelievler Mah (koyunlu Köyü)",
      "Bahçelievlerosb Mah (koyunlu Köyü)",
      "Ballı Köyü",
      "Cevizler Mah (kayırlı Köyü)",
      "Cumhuriyet Mah (elmalı Köyü)",
      "Cumhuriyet Mah (hacıbeyli Köyü)",
      "Cumhuriyet Mah (ovacık Köyü)",
      "Çarıklı Köyü",
      "Çarşı Mah (dikilitaş Köyü)",
      "Çayır Mah (çayırlı Köyü)",
      "Fertek Mah",
      "Fesleğen Köyü",
      "Gösterli Köyü",
      "Güllüce Köyü",
      "Güzelyurt Mah (içmeli Köyü)",
      "Hamamlı Mah",
      "Hançerli Köyü",
      "Hasaköy Köyü",
      "Himmetli Köyü",
      "Hürriyet Mah (hacıbeyli Köyü)",
      "İnönü Mah (kayırlı Köyü)",
      "Kale Mah (dikilitaş Köyü)",
      "Kale Mah (elmalı Köyü)",
      "Karamustafa Mah (kayırlı Köyü)",
      "Karşıyaka Mah (çavdarlı Köyü)",
      "Karşıyaka Mah (elmalı Köyü)",
      "Kayalıpınar Mah (çayırlı Köyü)",
      "Kırkpınar Köyü",
      "Kızılören Köyü",
      "Kömürcü Köyü",
      "Kumluca Mah",
      "Küçükköy Köyü",
      "Menderes Mah (elmalı Köyü)",
      "Merkez Mah (çavdarlı Köyü)",
      "Narköy Köyü",
      "Orta Mah (koyunlu Köyü)",
      "Özyurt Köyü",
      "Pınarcık Köyü",
      "Pınarcık Mah (kayırlı Köyü)",
      "Serinevler Mah (içmeli Köyü)",
      "Taşlıca Köyü",
      "Tepeköy Köyü",
      "Terazi Mah (ovacık Köyü)",
      "Tırhan Köyü",
      "Uluağaç Köyü",
      "Yarhisar Köyü",
      "Yaylayolu Köyü",
      "Yeni Mah (çayırlı Köyü)",
      "Yeni Mah (hacıbeyli Köyü)",
      "Yeşilburç Köyü",
      "Yeşilova Köyü",
      "Yukarı Mah (dikilitaş Köyü)",
      "Yukarı Mah (koyunlu Köyü)",
      "Fatih Mah (orhanlı Beldesi)",
      "Yavuz Mah (orhanlı Beldesi)",
      "Aşağı Mah (sazlıca Beldesi)",
      "Yeni Mah (sazlıca Beldesi)",
      "Yukarı Mah (sazlıca Beldesi)",
      "Ahipaşa Mah",
      "Balhasan Mah",
      "Burhan Mah",
      "Çayır Mah",
      "Esenbey Mah",
      "Eskisaray Mah",
      "İlhanlı Mah",
      "Kale Mah",
      "Nar Mah",
      "Saruhan Mah",
      "Selçuk Mah",
      "Sırali Mah",
      "Songur Mah",
      "Şahinali Mah",
      "Şahsüleyman Mah",
      "Aşağı Mah (yeşilgölcük Beldesi)",
      "Cumhuriyet Mah (yeşilgölcük Beldesi)",
      "Hürriyet Mah (yeşilgölcük Beldesi)",
      "Yeni Mah (yeşilgölcük Beldesi)",
      "Yukarı Mah (yeşilgölcük Beldesi)",
      "Bahçelievler Mah (yıldıztepe Beldesi)",
      "Yeni Mah (yıldıztepe Beldesi)"
    ],
    "Ulukışla": [
      "Ardıçlı Köyü",
      "Atatürk Mah (darboğaz Köyü)",
      "Atatürk Mah (yeniyıldız Köyü)",
      "Azdın Mah (koçak Köyü)",
      "Bahçelievler Mah (darboğaz Köyü)",
      "Cumhuriyet Mah (çiftehan Köyü)",
      "Cumhuriyet Mah (darboğaz Köyü)",
      "Cumhuriyet Mah (yeniyıldız Köyü)",
      "Çanakçı Köyü",
      "Elmalı Köyü",
      "Emirler Köyü",
      "Evren Mah (çiftehan Köyü)",
      "Fatih Mah (kılan Köyü)",
      "Gedelli Köyü",
      "Hacıbekirli Köyü",
      "Handere Köyü",
      "Horoz Köyü",
      "İlhanköy Köyü",
      "İmrahor Köyü",
      "Kalederesi Mah (koçak Köyü)",
      "Karacaören Köyü",
      "Kolsuz Köyü",
      "Kozluca Köyü",
      "Köşkönü Köyü",
      "Kurtuluş Mah (yeniyıldız Köyü)",
      "Küme1 Mah (altay Köyü)",
      "Küme1 Mah (başmakçı Köyü)",
      "Küme1 Mah (bayağıl Köyü)",
      "Küme1 Mah (çifteköy Köyü)",
      "Küme1 Mah (eminlik Köyü)",
      "Küme1 Mah (emirler Köyü)",
      "Küme1 Mah (gedelli Köyü)",
      "Küme1 Mah (gümüşköy Köyü)",
      "Küme1 Mah (güney Köyü)",
      "Küme1 Mah (hacıbekirli Köyü)",
      "Küme1 Mah (hasangazi Köyü)",
      "Küme1 Mah (hüsniye Köyü)",
      "Küme1 Mah (koçak Köyü)",
      "Küme1 Mah (ovacık Köyü)",
      "Küme1 Mah (porsuk Köyü)",
      "Küme1 Mah (şeyhömerli Köyü)",
      "Küme1 Mah (tekneçukur Köyü)",
      "Küme1 Mah (ünlüyaka Köyü)",
      "Küme2 Mah (altay Köyü)",
      "Küme2 Mah (başmakçı Köyü)",
      "Küme2 Mah (bayağıl Köyü)",
      "Küme2 Mah (eminlik Köyü)",
      "Küme2 Mah (emirler Köyü)",
      "Küme2 Mah (gedelli Köyü)",
      "Küme2 Mah (gümüşköy Köyü)",
      "Küme2 Mah (güney Köyü)",
      "Küme2 Mah (hacıbekirli Köyü)",
      "Küme2 Mah (hasangazi Köyü)",
      "Küme2 Mah (hüsniye Köyü)",
      "Küme2 Mah (ovacık Köyü)",
      "Küme2 Mah (porsuk Köyü)",
      "Küme2 Mah (şeyhömerli Köyü)",
      "Küme2 Mah (tabaklı Köyü)",
      "Küme2 Mah (tekneçukur Köyü)",
      "Küme3 Mah (bayağıl Köyü)",
      "Küme3 Mah (emirler Köyü)",
      "Küme3 Mah (gümüşköy Köyü)",
      "Küme3 Mah (hasangazi Köyü)",
      "Küme3 Mah (ilemin Kümesi Mah) (koçak Köyü)",
      "Küme3 Mah (porsuk Köyü)",
      "Küme3 Mah (şeyhömerli Köyü)",
      "Küme3 Mah (tabaklı Köyü)",
      "Küme4 Mah (emirler Köyü)",
      "Küme4 Mah (gümüşköy Köyü)",
      "Küme4 Mah (hasangazi Köyü)",
      "Küme5 Mah (aşağıöz Mah) (koçak Köyü)",
      "Küme5 Mah (gümüşköy Köyü)",
      "Küme6 Mah (gümüşköy Köyü)",
      "Küme6 Mah (yukarıöz Mah) (koçak Köyü)",
      "Küme7 Mah (gümüşköy Köyü)",
      "Küme7 Mah (seydiahmet Mah) (koçak Köyü)",
      "Küme8 Mah (akyar Mah) (koçak Köyü)",
      "Kümea Mah (alihoca Köyü)",
      "Kümeb Mah (alihoca Köyü)",
      "Madenköy Köyü",
      "Tabaklı Köyü",
      "Tekneçukur Köyü",
      "Tepeköy Köyü",
      "Toraman Köyü",
      "Tosunali Mah (koçak Köyü)",
      "Ünlüyaka Köyü",
      "Zafer Mah (darboğaz Köyü)",
      "Zafer Mah (kılan Köyü)",
      "Alpağut Mah",
      "Ballık Mah",
      "Çövek Mah",
      "Doğu Mah",
      "Kadılar Mah",
      "Kemalpaşa Mah",
      "Mehmetpaşa Mah",
      "Mısırlı Mah"
    ]
  },
  "Ordu": {
    "Akkuş": [
      "Akpınar Mah",
      "Alan Mah",
      "Ambargürgen Mah",
      "Ceyhanlı Mah",
      "Çaldere Mah",
      "Çamalan Mah",
      "Çamlıca Mah",
      "Çavdar Mah",
      "Çayıralan Mah",
      "Çökek Mah",
      "Çukurköy Mah",
      "Dağyolu Mah",
      "Damyeri Mah",
      "Düğencili Mah",
      "Esentepe Mah",
      "Gedikli Mah",
      "Gökçebayır Mah",
      "Gürgenliyatak Mah",
      "Haliluşağı Mah",
      "Karaçal Mah",
      "Kargı Mah",
      "Kemikgeriş Mah",
      "Ketendere Mah",
      "Kızılelma Mah",
      "Koçcuvaz Mah",
      "Kurtboğaz Mah",
      "Kuşçulu Mah",
      "Külekçili Mah",
      "Merkez Mah",
      "Meyvalı Mah",
      "Muratlı Mah",
      "Ormancık Mah",
      "Ortabölme Mah",
      "Salman Mah",
      "Seferli Mah",
      "Subaşı Mah",
      "Şahinköy Mah",
      "Tuzakköy Mah",
      "Yazlıkbelen Mah",
      "Yeni Mah",
      "Yeşilgüneycik Mah",
      "Yeşilköy Mah",
      "Yolbaşı Mah",
      "Yukarıdüğencili Mah"
    ],
    "Altınordu": [
      "Akyazı Mah",
      "Bahçelievler Mah",
      "Bucak Mah",
      "Cumhuriyet Mah",
      "Durugöl Mah",
      "Karapınar Mah",
      "Karapınarosb Mah",
      "Karşıyaka Mah",
      "Subaşı Mah",
      "Şahincili Mah",
      "Şirinevler Mah",
      "Yeni Mah",
      "Aziziye Mah",
      "Düz Mah",
      "Güzelyalı Mah",
      "Kirazlimanı Mah",
      "Kumbaşı Mah",
      "Nizamettin Mah",
      "Saray Mah",
      "Selimiye Mah",
      "Şarkiye Mah",
      "Taşbaşı Mah",
      "Zaferimilli Mah",
      "Akçatepe Mah",
      "Akkise Mah",
      "Alembey Mah",
      "Alınca Mah",
      "Alisayvan Mah",
      "Altunyurt Mah",
      "Arpaköy Mah",
      "Artıklı Mah",
      "Ataköy Mah",
      "Aydınlık Mah",
      "Bahariye Mah",
      "Bayadı Mah",
      "Bayramlı Mah",
      "Boztepe Mah",
      "Burhanettinköy Mah",
      "Cumhuriyet  Mah (köy Mah)",
      "Çavuşlar Mah",
      "Dedeli Mah",
      "Delikkaya Mah",
      "Dikence Mah",
      "Düzköy Mah",
      "Emen Mah",
      "Erenli Mah",
      "Eskipazar Mah",
      "Eyüplü Mah",
      "Gerce Mah",
      "Gökömer Mah",
      "Gümüşköy Mah",
      "Günören Mah",
      "Güzelyalı  Mah (uzunisa Mah)",
      "Hacılar Mah",
      "Hatipli Mah",
      "Hürriyet Mah",
      "Işıklı Mah",
      "Karaağaç Mah",
      "Karacaömer Mah",
      "Karaoluk Mah",
      "Kayabaşı Mah",
      "Kayadibi Mah",
      "Kısacık Mah",
      "Kızılhisar Mah",
      "Kovancı Mah",
      "Kökenli Mah",
      "Kurtulmuş Mah",
      "Kuylu Mah",
      "Mubarek Mah",
      "Oğmaca Mah",
      "Orhaniye Mah",
      "Ortaköy Mah",
      "Osmaniye Mah",
      "Öceli Mah",
      "Örencik Mah",
      "Övündük Mah",
      "Pelitli Mah",
      "Sağırlı Mah",
      "Saraycık Mah",
      "Şenköy Mah",
      "Şenocak Mah",
      "Terzili Mah",
      "Teyneli Mah",
      "Topluca Mah",
      "Uzunisa Mah",
      "Uzunmusa Mah",
      "Yağızlı Mah",
      "Yaraşlı Mah",
      "Yemişli Mah",
      "Yeşilköy Mah",
      "Yıldızlı Mah",
      "Yukarıtepe Mah",
      "Zafer Mah"
    ],
    "Aybastı": [
      "Alacalar Mah",
      "Armutlu Mah",
      "Beştam Mah",
      "Çakırlı Mah",
      "Çukur Mah",
      "Esenli Mah",
      "Fatih Mah",
      "Hisarcık Mah",
      "Karamanlı Mah",
      "Kayabaşı Mah",
      "Koyunculu Mah",
      "Kutlular Mah",
      "Küçükyaka Mah",
      "Ortaköy Mah",
      "Pelitözü Mah",
      "Sağlık Mah",
      "Sarıyar Mah",
      "Sefalık Mah",
      "Toygar Mah",
      "Uzundere Mah",
      "Zaferimilli Mah"
    ],
    "Çamaş": [
      "Akköy Mah",
      "Akpınar Mah",
      "Budak Mah",
      "Burhan Güneyi Mah",
      "Çavuşbaşı Mah",
      "Danışman Mah",
      "Edirli Mah",
      "Giden Mah",
      "Gümüşlü Mah",
      "Hisarbey Mah",
      "Kemal Paşa Mah",
      "Kestaneyokuşu Mah",
      "Kocaman Mah",
      "Örmeli Mah",
      "Sakargeriş Mah",
      "Sarıyakup Mah",
      "Söken Mah",
      "Sucuali Mah",
      "Taşoluk Mah",
      "Tepeli Mah",
      "Uzunali Mah",
      "Yeni Mah",
      "Yeşilvadi Mah"
    ],
    "Çatalpınar": [
      "Akkaya Mah",
      "Dere Mah",
      "Elmaköy Mah",
      "Göller Mah",
      "Gündoğdu Mah",
      "Güney Mah",
      "Güneyce Mah",
      "Haşal Mah",
      "Hatipler Mah",
      "İncirli Mah",
      "Karahamza Mah",
      "Karahasan Mah",
      "Karşıyaka Mah",
      "Kayatepe Mah",
      "Keçili Mah",
      "Kıran Mah",
      "Madenköy Mah",
      "Merkez Mah",
      "Ortaköy Mah",
      "Sayacatürk Mah",
      "Şirinköy Mah",
      "Terimli Mah",
      "Yeni Mah"
    ],
    "Çaybaşı": [
      "Akbaba Mah",
      "Aşıklı Çakıllı Mah",
      "Boras Mah",
      "Cemallı Mah",
      "Cevizliyatak Mah",
      "Çağlayan Mah",
      "Çandır Mah",
      "Çay Mah",
      "Çayır Mah",
      "Çınar Mah",
      "Eğribel Mah",
      "Göksu Mah",
      "Gürcek Mah",
      "Hacıali Mah",
      "İçeribükü Mah",
      "İlküvez Mah",
      "Kapılı Mah",
      "Kargalı Mah",
      "Köklük Mah",
      "Kurudere Mah",
      "Kuşlu Mah",
      "Mollalı Mah",
      "Namazlı Mah",
      "Taşkesiği Mah",
      "Tekke Mah",
      "Yenicuma Mah"
    ],
    "Fatsa": [
      "Ahmetler Mah",
      "Arpalık Mah",
      "Aslancami Mah",
      "Aşağıardıç Mah",
      "Aşağıtepe Mah",
      "Aşağıyavaş Mah",
      "Ayazlı Mah",
      "Bacanak Mah",
      "Bağlarca Mah",
      "Bahçeler Mah",
      "Başköy Mah",
      "Beyceli Mah",
      "Bolaman Mah",
      "Bozdağı Mah",
      "Bucaklı Mah",
      "Buhari Mah",
      "Bülbül Mah",
      "Büyükkoç Mah",
      "Çömlekli Mah",
      "Çötelü Mah",
      "Demirci Mah",
      "Dereyurt Mah",
      "Dolunay Mah",
      "Duayeri Mah",
      "Dumlupınar Mah",
      "Düğünlük Mah",
      "Eskiordu Mah",
      "Evkaf Mah",
      "Fatih Mah",
      "Fatsa Osb Mah",
      "Geyikçeli Mah",
      "Gölköy Mah",
      "Güvercinlik Mah",
      "Hacıköy Mah",
      "Hamlık Mah",
      "Hatipli Mah",
      "Hıdırbeyli Mah",
      "Hoylu Mah",
      "Ilıca Mah",
      "İnönü Mah",
      "İslamdağ Mah",
      "Kabakdağı Mah",
      "Kaleönü Mah",
      "Karataş Mah",
      "Kargucak Mah",
      "Karşıyaka Mah",
      "Kavraz Mah",
      "Kayaca Mah",
      "Kayaköy Akçakese Mah",
      "Kılavuzömer Mah",
      "Kılıçlı Mah",
      "Konakbaşı Mah",
      "Kösebucağı Mah",
      "Kulak Mah",
      "Kurtuluş Mah",
      "Küçükkoç Mah",
      "Küpdüşen Mah",
      "Mehmetakif Mah",
      "Meşebükü Mah",
      "Mustafakemalpaşa Mah",
      "Oluklu Mah",
      "Örencik Mah",
      "Palazlı Kömürlük Mah",
      "Sakarya Mah",
      "Salihli Mah",
      "Saraytepe Mah",
      "Sazcılar Mah",
      "Sefaköy Mah",
      "Sudere Mah",
      "Şerefiye Mah",
      "Tahtabaş Mah",
      "Taşlıca Mah",
      "Tayalı Mah",
      "Tepecik Mah",
      "Uzundere Mah",
      "Yalıköy Mah",
      "Yapraklı Mah",
      "Yassıbahçe Mah",
      "Yassıtaş Mah",
      "Yavaş Mah",
      "Yenidoğan Mah",
      "Yenikent Mah",
      "Yenipazar Mah",
      "Yeniyurt Mah",
      "Yeşilköy Mah",
      "Yeşiltepe Mah",
      "Yukarıardıç Mah",
      "Yukarıbahçeler Mah",
      "Yukarıtepe Mah",
      "Yusuflu Mah"
    ],
    "Gölköy": [
      "Ahmetli Mah",
      "Akçalı Mah",
      "Alanyurt Mah",
      "Aydoğan Mah",
      "Bayıralan Mah",
      "Bulut Mah",
      "Cihadiye Mah",
      "Çatak Mah",
      "Çetilli Mah",
      "Damarlı Mah",
      "Direkli Mah",
      "Düzyayla Mah",
      "Emirler Mah",
      "Gölköy Mah",
      "Güzelyayla Mah",
      "Güzelyurt Mah",
      "Haruniye Mah",
      "Hürriyet Mah",
      "İçyaka Mah",
      "Kale Mah",
      "Karagöz Mah",
      "Karahasan Mah",
      "Konak Mah",
      "Kozören Mah",
      "Kuşluvan Mah",
      "Özlü Mah",
      "Paşapınar Mah",
      "Sarıca Mah",
      "Süleymaniye Mah",
      "Yuvapınar Mah"
    ],
    "Gülyalı": [
      "Alibey Mah",
      "Ambarcılı Mah",
      "Ayrılık Mah",
      "Gülistan Mah",
      "Hoşköy Mah",
      "Kestane Mah",
      "Mustafalı Mah",
      "Sayaca Mah",
      "Taşlıçay Mah",
      "Tepealtı Mah",
      "Turnasuyu Mah",
      "Ürümbey Mah",
      "Yeniköy Mah"
    ],
    "Gürgentepe": [
      "Ağızlar Mah",
      "Akmescit Mah",
      "Akören Mah",
      "Akyurt Mah",
      "Alaseher Mah",
      "Bahtiyarlar Mah",
      "Cumhuriyet Mah",
      "Çatalağaç Mah",
      "Döşek Mah",
      "Eskiköy Mah",
      "Göller Mah",
      "Gülbelen Mah",
      "Gültepe Mah",
      "Hasancık Mah",
      "Işıktepe Mah",
      "Kirazgüneyi Mah",
      "Muratçık Mah",
      "Okçabel Mah",
      "Şirinköy Mah",
      "Tepeköy Mah",
      "Tikenlice Mah",
      "Tuzla Mah",
      "Yurtseven Mah"
    ],
    "İkizce": [
      "Ağcaalan Mah",
      "Aşağı Karlıtepe Mah",
      "Aşağı Kaynartaş Mah",
      "Başönü Mah",
      "Beylerce Mah",
      "Bolluk Mah",
      "Derebaşı Mah",
      "Devecik Mah",
      "Diyek Mah",
      "Dumantepe Mah",
      "Düzmeşe Mah",
      "Düzpelit Mah",
      "Enağızlı Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Gaziler Mah",
      "Kale Mah",
      "Kervansaray Mah",
      "Kiraztepe Mah",
      "Kocaman Mah",
      "Kurtköy Mah",
      "Kurtluca Mah",
      "Merkez Mah",
      "Özpınar Mah",
      "Seymenli Mah",
      "Şentepe Mah",
      "Tombaşlı Mah",
      "Yenice Mah",
      "Yoğunoluk Mah",
      "Yukarı Karlıtepe Mah",
      "Yukarı Kaynartaş Mah",
      "Yunuskırığı Mah"
    ],
    "Kabadüz": [
      "Akgüney Mah",
      "Başköy Mah",
      "Derinçay Mah",
      "Dişkaya Mah",
      "Esenyurt Mah",
      "Gelinkaya Mah",
      "Gülpınar Mah",
      "Gümüşdere Mah",
      "Harami Mah",
      "Kabadüz Mah",
      "Karakiraz Mah",
      "Kirazdere Mah",
      "Musakırık Mah",
      "Özlükent Mah",
      "Turnalık Mah",
      "Yeşilada Mah",
      "Yeşilyurt Mah",
      "Yokuşdibi Mah",
      "Yukarı Kirazdere Mah"
    ],
    "Kabataş": [
      "Alanbaşı Mah",
      "Alankent Mah",
      "Ardıç Mah",
      "Belen Mah",
      "Beylerli Mah",
      "Çukurcak Mah",
      "Düz Mah",
      "Eceli Mah",
      "Elbeyi Mah",
      "Hoşkadem Mah",
      "Ilıcak Mah",
      "Kabataş Yeni Mah",
      "Kayıncık Mah",
      "Kuzköy Mah",
      "Merkez Mah",
      "Şifa Suyu Mah",
      "Yakacık Mah",
      "Yeniceli Mah"
    ],
    "Korgan": [
      "Aşağıkozpınar Mah",
      "Aşağıyaylacık Mah",
      "Belalan Mah",
      "Beypınarı Mah",
      "Büyükakçakese Mah",
      "Çamlı Mah",
      "Çayırkent Mah",
      "Çiftlik Mah",
      "Çitlice Mah",
      "Dip Mah",
      "Durali Mah",
      "Karakışla Mah",
      "Karakoyunlu Mah",
      "Koçcuğaz Mah",
      "Sarıalıç Mah",
      "Soğukpınar Mah",
      "Tatarcık Mah",
      "Tepe Mah",
      "Tepealan Mah",
      "Terzili Mah",
      "Yazıcı Mah",
      "Yazlık Mah",
      "Yeniköy Mah",
      "Yenipınar Mah",
      "Yeşilalan Mah",
      "Yeşildere Mah",
      "Yeşilyurt Mah",
      "Yukarıkozpınar Mah",
      "Yukarıyaylacık Mah"
    ],
    "Kumru": [
      "Ağcaalantürk Mah",
      "Akçadere Mah",
      "Avdullu Mah",
      "Ayvalı Mah",
      "Balı Mah",
      "Ballık Mah",
      "Çatılı Mah",
      "Demircili Mah",
      "Derbent Mah",
      "Dereköy Mah",
      "Divanıtürk Mah",
      "Duman Mah",
      "Ergentürk Mah",
      "Erikçeli Mah",
      "Esence Mah",
      "Eskiçokdeğirmen Mah",
      "Fatih Mah",
      "Fizme Mah",
      "Gökçeli Mah",
      "Güneycik Mah",
      "Kadıncık Mah",
      "Karaağaç Mah",
      "Karacalar Mah",
      "Karacalı Mah",
      "Kayabaşı Mah",
      "Konaklı Mah",
      "Kovancılı Mah",
      "Kurtuluş Mah",
      "Küçükakçakese Mah",
      "Ortaca Mah",
      "Ortaçokdeğirmen Mah",
      "Samur Mah",
      "Şenyurt Mah",
      "Tekkeköy Mah",
      "Yalnızdam Mah",
      "Yemişken Mah",
      "Yeniakçaalan Mah",
      "Yenidivan Mah",
      "Yeniergen Mah",
      "Yukarıdamlalı Mah"
    ],
    "Mesudiye": [
      "Abdili Mah",
      "Akkırık Mah",
      "Akpınar Mah",
      "Alan Mah",
      "Arıcılar Mah",
      "Arıkmusa Mah",
      "Armutkolu Mah",
      "Arpaalan Mah",
      "Aşağıgökçe Mah",
      "Aşıklı Mah",
      "Bahçe Mah",
      "Balıklı Mah",
      "Bayırköy Mah",
      "Bayraklı Mah",
      "Beşpınar Mah",
      "Beyağaç Mah",
      "Beyseki Mah",
      "Birebir Mah",
      "Celal Mah",
      "Çaltepe Mah",
      "Çardaklı Mah",
      "Çavdar Mah",
      "Çerçi Mah",
      "Çitliksarıca Mah",
      "Çukuralan Mah",
      "Darıcabaşı Mah",
      "Dayılı Mah",
      "Derebaşı Mah",
      "Doğançam Mah",
      "Dursunlu Mah",
      "Erikköy Mah",
      "Esatlı Mah",
      "Göçbeyi Mah",
      "Gölbaşı Mah",
      "Gülpınar Mah",
      "Güneyce Mah",
      "Güvenli Mah",
      "Güzelce Mah",
      "Güzle Mah",
      "Hamzalı Mah",
      "Herközü Mah",
      "Ilışar Mah",
      "Kale Mah",
      "Karabayır Mah",
      "Karacaören Mah",
      "Kavaklıdere Mah",
      "Kayadibi Mah",
      "Kışlacık Mah",
      "Konacık Mah",
      "Köşe Mah",
      "Mahmudiye Mah",
      "Maksutalan Mah",
      "Merkez Mah",
      "Musalı Mah",
      "Müslüm Sarıca Mah",
      "Pınarlı Mah",
      "Sarıca Mah",
      "Sarıyayla Mah",
      "Topçam Mah",
      "Türkköyü Mah",
      "Üçyol Mah",
      "Yağmurlar Mah",
      "Yardere Mah",
      "Yavşan Mah",
      "Yenimahalle Mah",
      "Yeşilce Mah",
      "Yeşilçit Mah",
      "Yeveli Mah",
      "Yukarıgökçe Mah",
      "Yuvalı Mah"
    ],
    "Perşembe": [
      "Alınca Mah",
      "Anaç Mah",
      "Aziziye Mah",
      "Babalı Mah",
      "Bekirli Mah",
      "Beyli Mah",
      "Boğazcık Mah",
      "Bolatlı Mah",
      "Çamarası Mah",
      "Çandır Mah",
      "Çaytepe Mah",
      "Çerli Mah",
      "Çınar Mah",
      "Dereiçi Mah",
      "Doğan Mah",
      "Düz Mah",
      "Efirli Mah",
      "Ekinciler Mah",
      "Gündoğdu Mah",
      "Güzelyurt Mah",
      "Hacılar Mah",
      "Hamidiye Mah",
      "İmeçli Mah",
      "İstanbulboğazı Mah",
      "Kacalı Mah",
      "Kaleyaka Mah",
      "Kazancılı Mah",
      "Kırlı Mah",
      "Kovanlı Mah",
      "Kozağzı Mah",
      "Kurtuluş Mah",
      "Kutluca Mah",
      "Kuyluca Mah",
      "Medreseönü Mah",
      "Mersin Mah",
      "Neneli Mah",
      "Okçulu Mah",
      "Ortatepe Mah",
      "Ramazan Mah",
      "Saray Mah",
      "Selimiye Mah",
      "Sırakovancı Mah",
      "Soğukpınar Mah",
      "Şenyurt Mah",
      "Tarlacık Mah",
      "Tepecik Mah",
      "Tepeköy Mah",
      "Töngeldüzü Mah",
      "Yarlı Mah",
      "Yazlık Mah",
      "Yeniköy Mah",
      "Yeniöz Mah",
      "Yeşilköy Mah",
      "Yumrutaş Mah"
    ],
    "Ulubey": [
      "Akoluk Mah",
      "Akpınar Mah",
      "Aydınlar Mah",
      "Başçardak Mah",
      "Belenyurt Mah",
      "Cevizlik Mah",
      "Çağlayan Mah",
      "Çatallı Mah",
      "Çubuklu Mah",
      "Çukur Mah",
      "Doğlu Mah",
      "Durak Mah",
      "Elmaçukur Mah",
      "Eymür Mah",
      "Fındıklı Mah",
      "Gündüzlü Mah",
      "Güvenköy Mah",
      "Güvenyurt Mah",
      "Güzelyurt Mah",
      "Hocaoğlu Mah",
      "Kadıncık Mah",
      "Kalıcak Mah",
      "Karakoca Mah",
      "Kardeşler Mah",
      "Kıranyağmur Mah",
      "Kirazlık Mah",
      "Koşaca Mah",
      "Kumanlar Mah",
      "Kumrulu Mah",
      "Ohtamış Mah",
      "Oyumgürgen Mah",
      "Ören Mah",
      "Refahiye Mah",
      "Şahinkaya Mah",
      "Şekeroluk Mah",
      "Şıhlar Mah",
      "Uzunmahmut Mah",
      "Yenimahalle Mah",
      "Yenisayaca Mah",
      "Yolbaşı Mah",
      "Yukarıkızılen Mah"
    ],
    "Ünye": [
      "Ağıdere Mah",
      "Ataköy Mah",
      "Atatürk Mah",
      "Aydıntepe Mah",
      "Başköy Mah",
      "Bayramca Mah",
      "Beylerce Mah",
      "Burunucu Mah",
      "Cevizdere Mah",
      "Çakmak Mah",
      "Çamurlu Mah",
      "Çatak Mah",
      "Çatalpınar Mah",
      "Çataltepe Mah",
      "Çınarcık Mah",
      "Çınarlık Mah",
      "Çiğdem Mah",
      "Denizbükü Mah",
      "Dereköy Mah",
      "Dizdar Mah",
      "Döşemedibi Mah",
      "Düzköy Mah",
      "Düzsaylan Mah",
      "Elmalık Mah",
      "Erenyurt Mah",
      "Esenkale Mah",
      "Eskikızılcakese Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Göbü Mah",
      "Gölcüğez Mah",
      "Gölevi Mah",
      "Günpınarı Mah",
      "Gürecülü Mah",
      "Güzelkale Mah",
      "Güzelyalı Mah",
      "Hamidiye Mah",
      "Hanyanı Mah",
      "Hızabaşıgünlük Mah",
      "Hızarbaşıkumarlı Mah",
      "İnkur Mah",
      "İpekyolu Mah",
      "Kadılar Mah",
      "Kale Mah",
      "Kaledere Mah",
      "Kaledibi Mah",
      "Karşıyaka Mah",
      "Keş Mah",
      "Killik Mah",
      "Kocuklu Mah",
      "Kuşçulu Mah",
      "Kuşdoğan Mah",
      "Liseler Mah",
      "Nadırlı Mah",
      "Nurettin Mah",
      "Nuriye Mah",
      "Orta Yılmazlar Mah",
      "Ortaköy Mah",
      "Pelitliyatak Mah",
      "Pınarbaşı Mah",
      "Sahilköy Mah",
      "Saraçlı Mah",
      "Saraycık Mah",
      "Sarıhalil Mah",
      "Saylan Mah",
      "Sofutepesi Mah",
      "Şenyurt Mah",
      "Taflancık Mah",
      "Taşça Mah",
      "Tekkiraz Mah",
      "Tepeköy Mah",
      "Uğurlu Mah",
      "Üçpınar Mah",
      "Yavı Mah",
      "Yaycı Mah",
      "Yaylalı Mah",
      "Yazkonağı Mah",
      "Yenikent Mah",
      "Yenikızılcakese Mah",
      "Yeniköy Mah",
      "Yeşilada Mah",
      "Yeşilkent Mah",
      "Yiğitler Mah",
      "Yunus Emre Mah",
      "Yüceler Mah"
    ]
  },
  "Rize": {
    "Ardeşen": [
      "Bahar Mah",
      "Barış Mah",
      "Baş Mah",
      "Cami Mah",
      "Cumhuriyet Mah",
      "Çiftekavak Mah",
      "Deniz Mah",
      "Düz Mah",
      "Elmalık Mah",
      "Fatih Mah",
      "Fırtına Mah",
      "Kahveciler Mah",
      "Kavaklıdere Mah",
      "Kuzey Mah",
      "Merkez Mah",
      "Müftü Mah",
      "Şentepe Mah",
      "Taşbaşı Mah",
      "Yavuz Selim Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Açıkmeşe Mah (çıraklar Köyü)",
      "Akarsu Mah (güney Köyü)",
      "Akpınar Mah (akdere Köyü)",
      "Ali Efendi Mah (ortaalan Köyü)",
      "Alt Mah (manganez Köyü)",
      "Alt Mah (pınarlı Köyü)",
      "Arıcılar Köyü",
      "Arka Mah (şenyurt Köyü)",
      "Aşağı Mah (ortaalan Köyü)",
      "Aşağı Mah (şendere Köyü)",
      "Aşıklar Mah (armağan Köyü)",
      "Bağukuçhe Mah (ortaalan Köyü)",
      "Bahar Mah (pınarlı Köyü)",
      "Bahar Mah (yavuz Köyü)",
      "Baş Mah (seslikaya Köyü)",
      "Baş Mah (şenyamaç Köyü)",
      "Berha Mah (gündoğan Köyü)",
      "Büyük Mah (yukarıdurak Köyü)",
      "Cami Altı Mah (şehitlik Köyü)",
      "Cami Mah (bayırcık Köyü)",
      "Cami Mah (duygulu Köyü)",
      "Cami Mah (küçükköy Köyü)",
      "Cami Mah (pınarlı Köyü)",
      "Cami Mah (seslikaya Köyü)",
      "Cami Mah (şenyamaç Köyü)",
      "Cami Mah (yamaçdere Köyü)",
      "Cami Mah (yavuz Köyü)",
      "Cami Mah (yeniköy Köyü)",
      "Cami Üstü Mah (şehitlik Köyü)",
      "Cami Ve Çevre Mah (akkaya Köyü)",
      "Canca Mah (yamaçdere Köyü)",
      "Cennet Mah (ortaalan Köyü)",
      "Cinizeni Mah (özgür Köyü)",
      "Çamlık Mah (yurtsever Köyü)",
      "Çelikler Mah (gündoğan Köyü)",
      "Çıraklar Mah (çıraklar Köyü)",
      "Çıraklar Mah (doğanay Köyü)",
      "Çirihinci Mah (aşağıdurak Köyü)",
      "Çukurlar Mah (güney Köyü)",
      "Demirata Mah (yeniköy Köyü)",
      "Deniz Mah (yeniyol Köyü)",
      "Denizli Mah (çıraklar Köyü)",
      "Dere Mah (bayırcık Köyü)",
      "Dere Mah (şehitlik Köyü)",
      "Dere Mah (şenyamaç Köyü)",
      "Dere Mah (yavuz Köyü)",
      "Dere Yeşil Mah (sinan Köyü)",
      "Dereiçi Mah (kaçkar Köyü)",
      "Deremezra Köyü",
      "Dobira Mah (bayırcık Köyü)",
      "Duatepe-altıntepe Mah (armağan Köyü)",
      "Düz Mah (akkaya Köyü)",
      "Düz Mah (aşağıdurak Köyü)",
      "Düz Mah (beyazkaya Köyü)",
      "Düz Mah (güney Köyü)",
      "Düz Mah (manganez Köyü)",
      "Düz Mah (pirinçlik Köyü)",
      "Düz Mah (seslikaya Köyü)",
      "Düz Mah (yamaçdere Köyü)",
      "Esentepe Mah (ortaalan Köyü)",
      "Eskiarmutluk Köyü",
      "Gençler Mah (gündoğan Köyü)",
      "Gulivat Mah (köprüköy Köyü)",
      "Güneli Mah (küçükköy Köyü)",
      "Güney Mah (yurtsever Köyü)",
      "Haşimoğlu Mah (pirinçlik Köyü)",
      "Hoşdere Köyü",
      "Ilıca Mah (eskiarmutluk Köyü)",
      "Işıklı Mah",
      "İncirdip Mah (küçükköy Köyü)",
      "İsina Mah (özgür Köyü)",
      "İslamoğlu Mah (doğanay Köyü)",
      "İsmailoğlu Mah (doğanay Köyü)",
      "Kaçkar Köyü",
      "Kalayizeni Mah (köprüköy Köyü)",
      "Kanoğlu Mah (gündoğan Köyü)",
      "Karşı Mah (yeşiltepe Köyü)",
      "Karşıyaka Mah (güney Köyü)",
      "Kayabaşı Mah (önder Köyü)",
      "Kırazlık Mah (eskiarmutluk Köyü)",
      "Kibaroğlu Mah (doğanay Köyü)",
      "Kirazlık Köyü",
      "Koçoğlu Mah (armağan Köyü)",
      "Koda Mah (pirinçlik Köyü)",
      "Konaktepe Mah",
      "Korzati Mah (ortaalan Köyü)",
      "Köprübaşı Mah (köprüköy Köyü)",
      "Kulaberler Mah (pirinçlik Köyü)",
      "Kuleciler Mah (gündoğan Köyü)",
      "Kurtgözlü Mah (yamaçdere Köyü)",
      "Kurtuluş Köyü",
      "Merkez Mah (akdere Köyü)",
      "Merkez Mah (armağan Köyü)",
      "Merkez Mah (aşağıdurak Köyü)",
      "Merkez Mah (doğanay Köyü)",
      "Merkez Mah (köprüköy Köyü)",
      "Merkez Mah (küçükköy Köyü)",
      "Merkez Mah (ortaalan Köyü)",
      "Merkez Mah (özgür Köyü)",
      "Merkez Mah (pınarlı Köyü)",
      "Merkez Mah (seslikaya Köyü)",
      "Merkez Mah (sinan Köyü)",
      "Merkez Mah (şenyurt Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Merkez Mah (yeşiltepe Köyü)",
      "Merkez Mah (yurtsever Köyü)",
      "Mezra Mah (yeşiltepe Köyü)",
      "Navdarlar Mah (doğanay Köyü)",
      "Nızamoğlu Mah (özgür Köyü)",
      "Oğuzlar Mah (gündoğan Köyü)",
      "Okumuşlar Mah (yurtsever Köyü)",
      "Orta Mah (akkaya Köyü)",
      "Orta Mah (doğanay Köyü)",
      "Orta Mah (seslikaya Köyü)",
      "Orta Mah (şendere Köyü)",
      "Orta Mah (yamaçdere Köyü)",
      "Orta Mah (yavuz Köyü)",
      "Orta Mah (yeşiltepe Köyü)",
      "Ortamahalle Mah (armağan Köyü)",
      "Sahil Mah (şenyurt Köyü)",
      "Serindere Köyü",
      "Shemrona Mah (ortaalan Köyü)",
      "Sırt Mah (akkaya Köyü)",
      "Sırt Mah (aşağıdurak Köyü)",
      "Sırt Mah (güney Köyü)",
      "Sırt Mah (özgür Köyü)",
      "Sırt Mah (pirinçlik Köyü)",
      "Suluzeni Mah (ortaalan Köyü)",
      "Şefkibey Mah (yeniyol Köyü)",
      "Taş Kapı Mah (armağan Köyü)",
      "Tercümanlar Mah (duygulu Köyü)",
      "Topaloğlu Mah (duygulu Köyü)",
      "Trambona Mah (bayırcık Köyü)",
      "Tutan Mah (yeniköy Köyü)",
      "Türbe Mah (seslikaya Köyü)",
      "Üst Mah (manganez Köyü)",
      "Üst Mah (pınarlı Köyü)",
      "Üst Mah (yeniköy Köyü)",
      "Yeni Mah (küçükköy Köyü)",
      "Yeni Mah (şenyamaç Köyü)",
      "Yeşilyurt Mah (armağan Köyü)",
      "Yıldızlar Mah (gündoğan Köyü)",
      "Yukarı Cami Mah (beyazkaya Köyü)",
      "Yukarı Mah (akkaya Köyü)",
      "Yukarı Mah (ortaalan Köyü)",
      "Yukarı Mah (şendere Köyü)",
      "Yukarki Mah (yeniyol Köyü)",
      "Yüksek Mah (akdere Köyü)",
      "Zeytinlik Köyü",
      "Zumadi Mah (gündoğan Köyü)",
      "Ada Mah (tunca Beldesi)",
      "Düz Mah (tunca Beldesi)",
      "Esentepe Mah (tunca Beldesi)",
      "Konak Mah (tunca Beldesi)",
      "Merkez Mah (tunca Beldesi)",
      "Orta Mah (tunca Beldesi)",
      "Şenyuva Mah (tunca Beldesi)"
    ],
    "Çamlıhemşin": [
      "Aşağıçamlıca Mah",
      "Aşağışimşirli Mah",
      "Kadıköy Mah",
      "Kaplıca Mah",
      "Kavak Mah",
      "Konaklar Mah",
      "Merkez Mah",
      "Sırt Mah",
      "Yağmurlu Mah",
      "Yukarıçamlıca Mah",
      "Armağan Mah (meydanköy Köyü)",
      "Aşağı Mah (köprübaşı Köyü)",
      "Aşağı Mah (yolkıyı Köyü)",
      "Aydınoğlu Mah (topluca Köyü)",
      "Başçayır Mah (kale Köyü)",
      "Başyayla Mah (yazlık Köyü)",
      "Behice Köyü",
      "Belsu Mah (mollaveyis Köyü)",
      "Beşevler Mah (kale Köyü)",
      "Büyükdüz Mah (kale Köyü)",
      "Cami Mah (mollaveyis Köyü)",
      "Çat Merkez Mah (çatköy Köyü)",
      "Çatdüzü Mah (çatköy Köyü)",
      "Çay Mah (dikkaya Köyü)",
      "Çayırdüzü Köyü",
      "Çiçekli Mah (kale Köyü)",
      "Dervişli Mah (kale Köyü)",
      "Doğancı Mah (mollaveyis Köyü)",
      "Düz Mah (dikkaya Köyü)",
      "Düz Mah (meydanköy Köyü)",
      "Düz Mah (topluca Köyü)",
      "Elmacık Mah (topluca Köyü)",
      "Enginler Mah (topluca Köyü)",
      "Esentepe Mah (topluca Köyü)",
      "Eskiokul Mah (topluca Köyü)",
      "Faiklı Mah (kale Köyü)",
      "Geyik Mah (dikkaya Köyü)",
      "Güllüköy Köyü",
      "Güroluk Köyü",
      "Haçinçur Mah (sıraköy Köyü)",
      "Hocva Mah (dikkaya Köyü)",
      "Kale Köyü",
      "Kale Mah (kale Köyü)",
      "Karşı Mah (mollaveyis Köyü)",
      "Kavak Dibi Mah (köprübaşı Köyü)",
      "Kestioğlu Mah (topluca Köyü)",
      "Kıbrıs Mah (komilo Köyü)",
      "Kinya Mah (dikkaya Köyü)",
      "Komilo Köyü",
      "Kovanlık Mah (topluca Köyü)",
      "Kuzey Bayır Mah (komilo Köyü)",
      "Lakubar Mah (çatköy Köyü)",
      "Maden Mah (komilo Köyü)",
      "Maden Mah (topluca Köyü)",
      "Maselevat Mah (topluca Köyü)",
      "Merkez Mah (dikkaya Köyü)",
      "Merkez Mah (komilo Köyü)",
      "Merkez Mah (köprübaşı Köyü)",
      "Merkez Mah (meydanköy Köyü)",
      "Merkez Mah (topluca Köyü)",
      "Merkez Mah (yolkıyı Köyü)",
      "Müftüoğlu Mah (köprübaşı Köyü)",
      "Orta Mah (köprübaşı Köyü)",
      "Ortaklar Köyü",
      "Ortanköy Köyü",
      "Ortasırt Mah (kale Köyü)",
      "Ortayayla Köyü",
      "Ovaklı Mah (boğaziçi Köyü)",
      "Pogina Mah (boğaziçi Köyü)",
      "Pul Mah (meydanköy Köyü)",
      "Sıraköy Köyü",
      "Şenköy Köyü",
      "Şenyuva Köyü",
      "Taşkıran Mah (topluca Köyü)",
      "Tepecik Mah (komilo Köyü)",
      "Tomaslı Mah (boğaziçi Köyü)",
      "Üskürt Mah (mollaveyis Köyü)",
      "Üzümlü Mah (köprübaşı Köyü)",
      "Varoş Mah (kale Köyü)",
      "Yayla Köşk Mah (meydanköy Köyü)",
      "Yaylaköy Köyü",
      "Yazlık Köyü",
      "Yemişli Mah (yolkıyı Köyü)",
      "Yıldız Mah (dikkaya Köyü)",
      "Yukarışimşirli Köyü",
      "Zilkale Köyü"
    ],
    "Çayeli": [
      "Aloğlu Mah (karaağaç Köyü)",
      "Altıntaş Mah (büyükköy Beldesi)",
      "Arıcılar Mah (derecik Köyü)",
      "Arkadere Mah (büyükköy Beldesi)",
      "Aşağı Sırt Mah (karaağaç Köyü)",
      "Aydınlar Mah (gürgenli Köyü)",
      "Balcılar Mah (derecik Köyü)",
      "Balcıoğlu Mah (çeşmeli Köyü)",
      "Bekirli Mah (yıldızeli Köyü)",
      "Bekiroğlu Mah (gürgenli Köyü)",
      "Boğazlar Mah (karaağaç Köyü)",
      "Cumhuriyet Mah (gürgenli Köyü)",
      "Çavuşlu Mah (büyükköy Beldesi)",
      "Çaycılar Mah (büyükköy Beldesi)",
      "Çaydahor Mah (karaağaç Köyü)",
      "Çukurlu Mah (çeşmeli Köyü)",
      "Dalaklı Mah (karaağaç Köyü)",
      "Demirciler Mah (büyükköy Beldesi)",
      "Demirciler Mah (karaağaç Köyü)",
      "Dere Mah (yıldızeli Köyü)",
      "Dikilitaş Mah (gürgenli Köyü)",
      "Ehkartepe Mah (gürgenli Köyü)",
      "Gümüştaş Mah (büyükköy Beldesi)",
      "Güneşli Mah (derecik Köyü)",
      "Güneşli Mah (gürgenli Köyü)",
      "Güneştepe Mah (gürgenli Köyü)",
      "Hanlar Mah (derecik Köyü)",
      "Hastaş Mah (çeşmeli Köyü)",
      "Hoşarlı Mah (beşikçiler Köyü)",
      "Hüşütler Mah (derecik Köyü)",
      "İmrut Mah (karaağaç Köyü)",
      "İniş Mah (karaağaç Köyü)",
      "İstiklal Mah (gürgenli Köyü)",
      "Kakşili Mah (beşikçiler Köyü)",
      "Kalyoncular Mah (gürgenli Köyü)",
      "Kalyoncular Mah (yıldızeli Köyü)",
      "Karaoğlu Mah (çeşmeli Köyü)",
      "Kayadibi Mah (çeşmeli Köyü)",
      "Kirazlı Mah (derecik Köyü)",
      "Leventli Mah (beşikçiler Köyü)",
      "Malipos Mah (çeşmeli Köyü)",
      "Merkez Kakşioğlu Mah (beşikçiler Köyü)",
      "Merkez Mah (armutlu Köyü)",
      "Merkez Mah (büyükköy Beldesi)",
      "Merkez Mah (çeşmeli Köyü)",
      "Merkez Mah (gürgenli Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Milok Mah (karaağaç Köyü)",
      "Momişli Mah (karaağaç Köyü)",
      "Morgüller Mah (armutlu Köyü)",
      "Muhli Mah (yıldızeli Köyü)",
      "Müreli Mah (derecik Köyü)",
      "Okullar Mah (çeşmeli Köyü)",
      "Orta Mah (çeşmeli Köyü)",
      "Ortaköy Mah (çeşmeli Köyü)",
      "Öksüzler Mah (karaağaç Köyü)",
      "Pehlivanlı Mah (armutlu Köyü)",
      "Saladop Mah (çeşmeli Köyü)",
      "Serinırmak Mah (yıldızeli Köyü)",
      "Seyrantepe Mah (yeşilköy Köyü)",
      "Soğuksu Mah (büyükköy Beldesi)",
      "Şehit Muhammet Yüce Mah (karaağaç Köyü)",
      "Tepe Mah (armutlu Köyü)",
      "Tepe Mah (derecik Köyü)",
      "Tepeler Mah (çeşmeli Köyü)",
      "Tepeli Mah (çeşmeli Köyü)",
      "Tohumluk Mah (beşikçiler Köyü)",
      "Topaloğlu Mah (gürgenli Köyü)",
      "Topçular Mah (karaağaç Köyü)",
      "Veripos Mah (karaağaç Köyü)",
      "Yeni Mah (gürgenli Köyü)",
      "Yıldırımlar Mah (armutlu Köyü)",
      "Adalar Mah",
      "Büyükcaferpaşa Mah",
      "Büyüktaşhane Mah",
      "Çataklıhoca Mah",
      "Eskipazar Mah",
      "Hassadıklar Mah",
      "Kesmetaş Mah",
      "Küçükcaferpaşa Mah",
      "Küçüktaşhane Mah",
      "Limanköy Mah",
      "Sabuncular Mah",
      "Şairler Mah",
      "Taşhane Mah",
      "Yaka Mah",
      "Yalı Mah",
      "Yenicami Mah",
      "Yenipazar Mah",
      "Aloğlu Mah (madenli Beldesi)",
      "Çamlıca Mah (madenli Beldesi)",
      "Gürçam Mah (madenli Beldesi)",
      "Habiboğlu Mah (madenli Beldesi)",
      "Kazancılar Mah (madenli Beldesi)",
      "Maden Mah (madenli Beldesi)",
      "Merkez Mah (madenli Beldesi)",
      "Topkaya Mah (madenli Beldesi)",
      "Yazıcılar Mah (madenli Beldesi)",
      "Yeni Mah (madenli Beldesi)",
      "Alıcanlar Mah (beyazsu Köyü)",
      "Alt Mah (başköy Köyü)",
      "Alt Mah (köprübaşı Köyü)",
      "Alt Mah (latifli Köyü)",
      "Alt Mah (uzundere Köyü)",
      "Alt Mah (yeşiltepe Köyü)",
      "Alt Mah (zafer Köyü)",
      "Altveis Mah (haremtepe Köyü)",
      "Arekner Mah (çukurluhoca Köyü)",
      "Aşağı Cordanlar Mah (haremtepe Köyü)",
      "Aşağı Mah (aşıklar Köyü)",
      "Aşağı Mah (kemerköy Köyü)",
      "Ayanı Mah (selimiye Köyü)",
      "Aydınlar Mah (çataldere Köyü)",
      "Aydoğdu Mah (çukurluhoca Köyü)",
      "Ayışığı Mah (çukurluhoca Köyü)",
      "Aykırı Filiztepe Mah (haremtepe Köyü)",
      "Ayvalık Mah (gürpınar Köyü)",
      "Azarlı Mah (çataldere Köyü)",
      "Balıkçı Mah (yeşiltepe Köyü)",
      "Balıkçıoğlu Mah (yeşiltepe Köyü)",
      "Başaran Mah (kaptanpaşa Köyü)",
      "Başköy Mah (başköy Köyü)",
      "Bayraktarlar Mah (güzeltepe Köyü)",
      "Bekiroğlu Mah (beyazsu Köyü)",
      "Bilginler Mah (yeşiltepe Köyü)",
      "Bilginler Mezra Mah (yeşiltepe Köyü)",
      "Boğaziçi Mah (yeşiltepe Köyü)",
      "Boşnaklı Mah (seslidere Köyü)",
      "Bozkurtlar Mah (kaptanpaşa Köyü)",
      "Boztepe Mah (kaptanpaşa Köyü)",
      "Bucak Mah (erenler Köyü)",
      "Büyüğün Ev Ve Çobanlar Mah (uzundere Köyü)",
      "Caferoğlu Mah (kemerköy Köyü)",
      "Cağak Mah (uzundere Köyü)",
      "Cami Mah (kestanelik Köyü)",
      "Cami Mah (zafer Köyü)",
      "Cami Yanı Mah (yamaç Köyü)",
      "Camialtı Mah (demirhisar Köyü)",
      "Canıbeyaz Mah (kaptanpaşa Köyü)",
      "Cemak Mah (yeşiltepe Köyü)",
      "Cevitli Mah (çataldere Köyü)",
      "Cimoroç Mah (incesu Köyü)",
      "Cumhuriyet Mah (yenice Köyü)",
      "Çahçuri Mah (kemerköy Köyü)",
      "Çakırlı Mah (yenitepe Köyü)",
      "Çakıroğlu Mah (sarısu Köyü)",
      "Çelikler Ve Sandıkçılar Mah (latifli Köyü)",
      "Çevre Mah (maltepe Köyü)",
      "Çınartepe Köyü",
      "Çil Mah (abdullahhoca Köyü)",
      "Çolaklı Mah (güzeltepe Köyü)",
      "Darboğaz Mah (beyazsu Köyü)",
      "Demirciler Mah (çilingir Köyü)",
      "Dere Mah (beyazsu Köyü)",
      "Dere Mah (kaçkar Köyü)",
      "Dere Mah (kemerköy Köyü)",
      "Dereiçi Mah (güzeltepe Köyü)",
      "Düz Mah (kaptanpaşa Köyü)",
      "Düzgeçit Köyü",
      "Enesoğlu Mah (beyazsu Köyü)",
      "Erdemli Köyü",
      "Esendağ Köyü",
      "Eyupoğlu Mah (abdullahhoca Köyü)",
      "Fenaçi Mah (yanıkdağ Köyü)",
      "Gagauzlar Mah (kaptanpaşa Köyü)",
      "Gelincik 1 Mah (kaptanpaşa Köyü)",
      "Gelincik 2 Mah (kaptanpaşa Köyü)",
      "Gemiciler Köyü",
      "Geyikli Mah (yenice Köyü)",
      "Gobocit Mah (uzundere Köyü)",
      "Gölcük Mah (demirhisar Köyü)",
      "Gülova Mah (selimiye Köyü)",
      "Gümüşler Mah (kaptanpaşa Köyü)",
      "Gümüşpınar Mah (buzlupınar Köyü)",
      "Güneli Mah (yeşiltepe Köyü)",
      "Hanifli Mah (güzeltepe Köyü)",
      "Hasançavuş Mah (yamaç Köyü)",
      "Haşafı Mah (seslidere Köyü)",
      "Hervenik Mah (yanıkdağ Köyü)",
      "Hürremli Mah (sırtköy Köyü)",
      "İnceler Mah (güzeltepe Köyü)",
      "İncesırt Köyü",
      "İncesu Köyü",
      "İrfanoğulları Mah (beyazsu Köyü)",
      "İstaponoz Mah (buzlupınar Köyü)",
      "Kadıoğlu Mah (kemerköy Köyü)",
      "Kalenderli Mah (yamaç Köyü)",
      "Kamilli Mah (sırtköy Köyü)",
      "Kamiloğlu Mah (köprübaşı Köyü)",
      "Karakaşlı Mah (çataldere Köyü)",
      "Karali Ve Güneştepe Mah (abdullahhoca Köyü)",
      "Karaloğlu Mah (kaptanpaşa Köyü)",
      "Karanlık Mah (yanıkdağ Köyü)",
      "Karşı Mah (kestanelik Köyü)",
      "Karşıyaka Mah (maltepe Köyü)",
      "Kasapoğlu Mah (kemerköy Köyü)",
      "Katılya Mah (kemerköy Köyü)",
      "Kavala Mah (selimiye Köyü)",
      "Kaymaklı Mah (çataldere Köyü)",
      "Kayna Mah (kemerköy Köyü)",
      "Kestanelik Mah (haremtepe Köyü)",
      "Kısırlar Mah (sefalı Köyü)",
      "Kireçhane Mah (maltepe Köyü)",
      "Kodana Mah (demirhisar Köyü)",
      "Korkapos Mah (uzundere Köyü)",
      "Kömürcüler Ve Aptiefendiler Mah (abdullahhoca Köyü)",
      "Köprübaşı Mah (kaçkar Köyü)",
      "Köse Mah (uzundere Köyü)",
      "Köseler Mah (beyazsu Köyü)",
      "Köseoğlu Mah (yanıkdağ Köyü)",
      "Kuremeli Mah (güzeltepe Köyü)",
      "Kurtuluş Mah (demirhisar Köyü)",
      "Kurular Mah (kaçkar Köyü)",
      "Kuyubaşı Mah (gürpınar Köyü)",
      "Küçükmustafalı Mah (yamaç Köyü)",
      "Maden Mah (kemerköy Köyü)",
      "Mahmutoğlu Mah (ormancık Köyü)",
      "Makraş Mah (ortaköy Köyü)",
      "Maloza Mah (güzeltepe Köyü)",
      "Maşalar Mah (güzeltepe Köyü)",
      "Mehelle Mah (sarısu Köyü)",
      "Mergolar Mah (güzeltepe Köyü)",
      "Merkez 1 Mah (sefalı Köyü)",
      "Merkez 2 Mah (sefalı Köyü)",
      "Merkez Mah (aşıklar Köyü)",
      "Merkez Mah (beyazsu Köyü)",
      "Merkez Mah (çataldere Köyü)",
      "Merkez Mah (çukurluhoca Köyü)",
      "Merkez Mah (erenler Köyü)",
      "Merkez Mah (gürpınar Köyü)",
      "Merkez Mah (haremtepe Köyü)",
      "Merkez Mah (kaptanpaşa Köyü)",
      "Merkez Mah (kemerköy Köyü)",
      "Merkez Mah (kestanelik Köyü)",
      "Merkez Mah (maltepe Köyü)",
      "Merkez Mah (ormancık Köyü)",
      "Merkez Mah (seslidere Köyü)",
      "Merkez Mah (yamaç Köyü)",
      "Mesavli Mah (yanıkdağ Köyü)",
      "Meydanlı Mah (kemerköy Köyü)",
      "Mezra Mah (çilingir Köyü)",
      "Mezra Mah (yeşiltepe Köyü)",
      "Musadağı Köyü",
      "Mutidüzü Mah (haremtepe Köyü)",
      "Okumuş Çay Mah (abdullahhoca Köyü)",
      "Orta Mah (aşıklar Köyü)",
      "Orta Mah (başköy Köyü)",
      "Orta Mah (beyazsu Köyü)",
      "Orta Mah (çilingir Köyü)",
      "Orta Mah (kaptanpaşa Köyü)",
      "Orta Mah (kemerköy Köyü)",
      "Orta Mah (sefalı Köyü)",
      "Orta Mah (seslidere Köyü)",
      "Orta Mah (uzundere Köyü)",
      "Orta Mah (yamaç Köyü)",
      "Orta Mah (yeşiltepe Köyü)",
      "Ortasırt Mah (yenice Köyü)",
      "Özdemirler Mah (sefalı Köyü)",
      "Paşana Mah (beyazsu Köyü)",
      "Perikoma Mah (güzeltepe Köyü)",
      "Puşuli Mah (yanıkdağ Köyü)",
      "Reyhanlı Mah (çataldere Köyü)",
      "Saralı Mah (sırtköy Köyü)",
      "Sarbeni Mah (seslidere Köyü)",
      "Sarıahmetler Mah (sarısu Köyü)",
      "Sarılar Mah (kemerköy Köyü)",
      "Sastan Mah (seslidere Köyü)",
      "Sazlıklar Mah (sarısu Köyü)",
      "Sırt Mah (aşıklar Köyü)",
      "Sırt Mah (çataldere Köyü)",
      "Sırt Mah (çilingir Köyü)",
      "Sırt Mah (erenler Köyü)",
      "Sırt Mah (yenice Köyü)",
      "Sırt Mah (zafer Köyü)",
      "Siranlık Mah (köprübaşı Köyü)",
      "Soğuksu Mah (ortaköy Köyü)",
      "Songurler Mah (kaçkar Köyü)",
      "Suiçmezler Mah (latifli Köyü)",
      "Suiçmezler Mah (sarısu Köyü)",
      "Şalambarlı Mah (haremtepe Köyü)",
      "Şen Mah (kaptanpaşa Köyü)",
      "Şimşirli Mah (buzlupınar Köyü)",
      "Şirinköy Köyü",
      "Taş Mah (haremtepe Köyü)",
      "Taşdemirler Mah (yanıkdağ Köyü)",
      "Taşlık Mah (demirhisar Köyü)",
      "Tepe Mah (kemerköy Köyü)",
      "Tepe Mah (yenitepe Köyü)",
      "Tepeboyu Mah (selimiye Köyü)",
      "Tepeler Mah (latifli Köyü)",
      "Tepeler Mah (sarısu Köyü)",
      "Tepeli Mah (uzundere Köyü)",
      "Türkgeldi Mah (demirhisar Köyü)",
      "Ulaş Mah (ormancık Köyü)",
      "Üst Mah (köprübaşı Köyü)",
      "Üst Mah (seslidere Köyü)",
      "Üst Mah (uzundere Köyü)",
      "Üstveis Mah (haremtepe Köyü)",
      "Veripos Mah (seslidere Köyü)",
      "Veritağ Mah (gürpınar Köyü)",
      "Verüt Mah (seslidere Köyü)",
      "Voyna Mah (ortaköy Köyü)",
      "Yalçınlar Mah (buzlupınar Köyü)",
      "Yavuzlar Köyü",
      "Yenihisar Köyü",
      "Yeşilırmak Köyü",
      "Yılmayanlar Mah (kemerköy Köyü)",
      "Yukarı Cordanlar Mah (haremtepe Köyü)",
      "Yükselen Mah (kaptanpaşa Köyü)"
    ],
    "Derepazarı": [
      "Çalışkanlar Mah",
      "Eriklimanı Mah",
      "Fıçıcılar Mah",
      "Merkez Mah",
      "Sarıyer Mah",
      "Subaşı Mah",
      "Tersane Mah",
      "Bahattinpaşa Köyü",
      "Bürücek Köyü",
      "Çakmakçılar Köyü",
      "Çeşme Köyü",
      "Çukurlu Köyü",
      "Esentepe Köyü",
      "Kirazdağı Köyü",
      "Maltepe Köyü",
      "Sandıktaş Köyü",
      "Uzunkaya Köyü",
      "Yanıktaş Köyü"
    ],
    "Fındıklı": [
      "Aksu Mah",
      "Hürriyet Mah",
      "Ilıca Mah",
      "Liman Mah",
      "Merkez Mah",
      "Sahil Mah",
      "Tatlısu Mah",
      "Yeni Mah",
      "Abdoğlu Mah (cennet Köyü)",
      "Aile Mah (meyvalı Köyü)",
      "Akıncılar Mah (gürsu Köyü)",
      "Armağan Mah (çınarlı Köyü)",
      "Armoni Mah (derbent Köyü)",
      "Aydınlık Mah (yaylacılar Köyü)",
      "Ayle Mah (arılı Köyü)",
      "Bahar Mah (saatköy Köyü)",
      "Balaban Mah (çağlayan Köyü)",
      "Baş Mah (aslandere Köyü)",
      "Baş Mah (ıhlamurlu Köyü)",
      "Başköy Mah (gürsu Köyü)",
      "Beyazsu Mah (meyvalı Köyü)",
      "Bulak Mah (arılı Köyü)",
      "Bulutlu Mah (beydere Köyü)",
      "Cengizler Mah (hara Köyü)",
      "Cevizlik Mah (meyvalı Köyü)",
      "Çavuşlu Mah (sulak Köyü)",
      "Çeşmeli Mah (yeniköy Köyü)",
      "Çiçekli Mah (doğanay Köyü)",
      "Derbent 1 Mah (derbent Köyü)",
      "Dere Mah (ıhlamurlu Köyü)",
      "Dere Mah (yaylacılar Köyü)",
      "Dereiçi Mah (çınarlı Köyü)",
      "Devran Mah (yeniköy Köyü)",
      "Dörtyol Mah (ıhlamurlu Köyü)",
      "Düz Mah (arılı Köyü)",
      "Düz Mah (cennet Köyü)",
      "Düz Mah (hara Köyü)",
      "Düz Mah (ıhlamurlu Köyü)",
      "Düz Mah (tepecik Köyü)",
      "Düzköy Köyü",
      "Eminoğlu Mah (çağlayan Köyü)",
      "Esentepe Mah (beydere Köyü)",
      "Gökçetaş Mah (avcılar Köyü)",
      "Gurupit Mah (yeniköy Köyü)",
      "Gülbahar Mah (sulak Köyü)",
      "Gültepe Mah (sulak Köyü)",
      "Güneşli Mah (meyvalı Köyü)",
      "Güngören Mah (sümer Köyü)",
      "Gürgeni Mah (arılı Köyü)",
      "Gürkanlar Mah (çağlayan Köyü)",
      "Güzelyalı Mah (kıyıcık Köyü)",
      "Güzelyalı-üst Mah (kıyıcık Köyü)",
      "Hacılar Mah (ıhlamurlu Köyü)",
      "Hazara Mah (sümer Köyü)",
      "Hemşin Mah (yeniköy Köyü)",
      "Hürriyet Mah (derbent Köyü)",
      "Kalınlar Mah (çınarlı Köyü)",
      "Kalkancılar Mah (ıhlamurlu Köyü)",
      "Kanca Mah (gürsu Köyü)",
      "Karaali Köyü",
      "Karşıyaka Mah (aslandere Köyü)",
      "Karşıyaka Mah (beydere Köyü)",
      "Kilittepe Mah (avcılar Köyü)",
      "Kirazlık Mah (çınarlı Köyü)",
      "Kozmağa Mah (hara Köyü)",
      "Köprübaşı Mah (arılı Köyü)",
      "Köprübaşı Mah (meyvalı Köyü)",
      "Köseoğlu Mah (hara Köyü)",
      "Kvakçe Mah (tepecik Köyü)",
      "Merkez Mah (arılı Köyü)",
      "Merkez Mah (beydere Köyü)",
      "Merkez Mah (cennet Köyü)",
      "Merkez Mah (çağlayan Köyü)",
      "Merkez Mah (derbent Köyü)",
      "Merkez Mah (ıhlamurlu Köyü)",
      "Merkez Mah (kıyıcık Köyü)",
      "Merkez Mah (saatköy Köyü)",
      "Merkez Mah (sümer Köyü)",
      "Merkez-lavaşa Mah (çağlayan Köyü)",
      "Meşedüzü Mah (aslandere Köyü)",
      "Muhtar Cavit Civelek Mah (doğanay Köyü)",
      "Nane Mah (çağlayan Köyü)",
      "Necippaşa Mah (aslandere Köyü)",
      "Nomaiki Mah (sümer Köyü)",
      "Okul Mah (yaylacılar Köyü)",
      "Okura Mah (ıhlamurlu Köyü)",
      "Orta Mah (aslandere Köyü)",
      "Orta Mah (çağlayan Köyü)",
      "Orta Mah (derbent Köyü)",
      "Orta Mah (meyvalı Köyü)",
      "Orta Mah (sümer Köyü)",
      "Osmanlı Mah (yenişehitlik Köyü)",
      "Özerler Mah (çağlayan Köyü)",
      "Özgüvenler Mah (çınarlı Köyü)",
      "Pazine Mah (arılı Köyü)",
      "Sarıkavak Mah (ıhlamurlu Köyü)",
      "Sarıkaya Mah (çınarlı Köyü)",
      "Savaş Mah (aslandere Köyü)",
      "Sırt Mah (yaylacılar Köyü)",
      "Sırt Mah (yenişehitlik Köyü)",
      "Sümer Yalı Mah (sümer Köyü)",
      "Şenocak Mah (ıhlamurlu Köyü)",
      "Şentepe Mah (sulak Köyü)",
      "Şenyurt Mah (beydere Köyü)",
      "Taşkesik Mah (çağlayan Köyü)",
      "Taşköprü Mah (çağlayan Köyü)",
      "Taşköprü Mah (derbent Köyü)",
      "Tepe Mah (doğanay Köyü)",
      "Tohumlu Mah (saatköy Köyü)",
      "Tüfekçiler Mah (hara Köyü)",
      "Üst Mah (çınarlı Köyü)",
      "Üst Mah (doğanay Köyü)",
      "Yazıcılar Mah (sümer Köyü)",
      "Yeşilay Mah (sulak Köyü)",
      "Yıldızlar Mah (cennet Köyü)",
      "Yukarıderbent Mah (derbent Köyü)",
      "Zanna Mah (arılı Köyü)",
      "Zebelit Mah (tepecik Köyü)"
    ],
    "Güneysu": [
      "Adacami Mah",
      "Aşağı Kiremit Mah",
      "Başaran Mah",
      "Birlik Mah",
      "Eskicami Mah",
      "Küçükcamii Mah",
      "Merkez Mah",
      "Ulucamii Mah",
      "Ada Mah (islahiye Köyü)",
      "Alicik  Mah (1 Mah) (gürgen Köyü)",
      "Alicik  Mah (2 Mah) (gürgen Köyü)",
      "Alikica Mevkii Mah (çamlıca Köyü)",
      "Altınkaya 1 Mah (başköy Köyü)",
      "Altınkaya Mah (başköy Köyü)",
      "Asmalıırmak Köyü",
      "Ballıdere Köyü",
      "Bulutlu Köyü",
      "Çamlıca Köyü",
      "Çamlık Mah (gürgen Köyü)",
      "Derebaşı Mah (yukarıislahiye Köyü)",
      "Dumankaya Köyü",
      "Esentepe Mah (yenicami Köyü)",
      "Esentepe Mah (yukarıislahiye Köyü)",
      "Güneli Köyü",
      "Halkolim Mah (gürgen Köyü)",
      "Ilıca Mah (çamlıca Köyü)",
      "İslahiye Köyü",
      "Kangeldibi Mah (gürgen Köyü)",
      "Kırlangıç Mah (kıbledağı Köyü)",
      "Kireçli Mah (gürgen Köyü)",
      "Kiremit Köyü",
      "Mağara Mevki Mah (selamet Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (kıbledağı Köyü)",
      "Merkez Mah (yenicami Köyü)",
      "Mısırlı Mah (kıbledağı Köyü)",
      "Omereva Mah (yeşilköy Köyü)",
      "Orta Meşe Mah (ballıdere Köyü)",
      "Ortaköy Köyü",
      "Örnek Mevkii Mah (selamet Köyü)",
      "Selamet Köyü",
      "Sırt Mah (kıbledağı Köyü)",
      "Taşköprü Mevkii Mah (islahiye Köyü)",
      "Tatlısu Mah (ballıdere Köyü)",
      "Tepebaşı Köyü",
      "Topçular Mah (selamet Köyü)",
      "Tuğla Mevki Mah (selamet Köyü)",
      "Yarımada Köyü",
      "Yenicami Köyü",
      "Yeniköy Köyü",
      "Yenimescit Mah (kıbledağı Köyü)",
      "Yeşilköy Köyü",
      "Yeşilyaprak Mah (gürgen Köyü)",
      "Yeşilyurt Köyü",
      "Yıldız Mah (başköy Köyü)",
      "Yukarıislahiye Köyü",
      "Yusuf Hoca Mah (kıbledağı Köyü)",
      "Yüksekköy Köyü"
    ],
    "Hemşin": [
      "Bahar Mah",
      "Mutlu Mah",
      "Ortaköy Mah",
      "Yeniköy Mah",
      "Akyamaç Köyü",
      "Bilenköy Köyü",
      "Çamlıtepe Köyü",
      "Hilal Köyü",
      "Kantarlı Köyü",
      "Leventköy Köyü",
      "Nurluca Köyü",
      "Yaltkaya Köyü"
    ],
    "İkizdere": [
      "Çağrankaya Mah",
      "Çarşı Mah",
      "Gündoğdu Mah",
      "Güney Mah",
      "Kirazlı Mah",
      "Yeşilyurt Mah",
      "Zafer Mah",
      "Ahmetli Mah (diktaş Köyü)",
      "Allar Mah (çifteköprü Köyü)",
      "Aprojli Mah (ballıköy Köyü)",
      "Arkanet Mah (diktaş Köyü)",
      "Aşağı Mah (gürdere Köyü)",
      "Aşağı Mah (şimşirli Köyü)",
      "Aylaç Mah (tozköy Köyü)",
      "Ayvalık Köyü",
      "Ayvazlı Mah (diktaş Köyü)",
      "Başköy Köyü",
      "Bayırköy Köyü",
      "Bektaşlar Mah (çifteköprü Köyü)",
      "Büyük Cami Mah (ılıcaköy Köyü)",
      "Cevizlik Köyü",
      "Çakat Mah (diktaş Köyü)",
      "Çamçavuş Mah (bayırköy Köyü)",
      "Çamlıkköy Köyü",
      "Çarşı Mah (güneyce Köyü)",
      "Çataltepe Köyü",
      "Çifteköprü Köyü",
      "Demirkapı Köyü",
      "Demirli Mah (diktaş Köyü)",
      "Dereköy Köyü",
      "Dikmetaş Mah (diktaş Köyü)",
      "Emekçiler Mah (çifteköprü Köyü)",
      "Eskice Köyü",
      "Gölyayla Köyü",
      "Gudurlu Mah (çiçekli Köyü)",
      "Güvenköy Köyü",
      "Hamurlu Mah (ballıköy Köyü)",
      "Hıça Mah (tozköy Köyü)",
      "Hındrakol Mah (ballıköy Köyü)",
      "Ihlamur Köyü",
      "Ilıcaköy Köyü",
      "Ilıcalar Mah (ılıcaköy Köyü)",
      "İmamlar Mah (ılıcaköy Köyü)",
      "İşkencedere Mah (gürdere Köyü)",
      "Kama Köyü",
      "Kamadibi Mah (tozköy Köyü)",
      "Kancalı Mah (diktaş Köyü)",
      "Karagözlü Mah (ballıköy Köyü)",
      "Karali Mah (ballıköy Köyü)",
      "Kastamonu Mah (tozköy Köyü)",
      "Kestane Mah (şimşirli Köyü)",
      "Kızıltepe Mah (güneyce Köyü)",
      "Köprübaşı Mah (güneyce Köyü)",
      "Köseli Mah (çiçekli Köyü)",
      "Köyiçi Mah (çifteköprü Köyü)",
      "Kumluk Mah (gürdere Köyü)",
      "Kurdoğlu Mah (ballıköy Köyü)",
      "Kurtuluş Mah (güneyce Köyü)",
      "Kuturlu Mah (ballıköy Köyü)",
      "Mahiller Mah (çifteköprü Köyü)",
      "Mehmetali Mah (diktaş Köyü)",
      "Meşeköy Köyü",
      "Muçolar Mah (ılıcaköy Köyü)",
      "Orta Mah (gürdere Köyü)",
      "Orta Mah (şimşirli Köyü)",
      "Ortaköy Köyü",
      "Otel Mah (dereköy Köyü)",
      "Pazaraltı Mah (çiçekli Köyü)",
      "Pendazlı Mah (diktaş Köyü)",
      "Rüzgarlı Köyü",
      "Sakandoz Mah (tozköy Köyü)",
      "Saray Mah (dereköy Köyü)",
      "Sarmanlı Mah (ballıköy Köyü)",
      "Savayıllar Mah (gürdere Köyü)",
      "Sırt Mah (dereköy Köyü)",
      "Sırt Mah (tozköy Köyü)",
      "Sırtlar Mah (gürdere Köyü)",
      "Sırtlar Mah (ılıcaköy Köyü)",
      "Sivrikaya Köyü",
      "Tulumpınar Köyü",
      "Turahlı Mah (tozköy Köyü)",
      "Tuzikolar Mah (çifteköprü Köyü)",
      "Yağcılar Köyü",
      "Yeni Mah (dereköy Köyü)",
      "Yerelma Köyü",
      "Yeşiltepe Mah (güneyce Köyü)",
      "Yukarı Mah (gürdere Köyü)",
      "Yukarı Mah (şimşirli Köyü)",
      "Zanetli Mah (çiçekli Köyü)"
    ],
    "İyidere": [
      "Çanakçeşme Mah",
      "Fethiye Mah",
      "Fıçıtaşı Mah",
      "Hazar Mah",
      "Merkez Mah",
      "Sarayköy Mah",
      "Üstüpiler Mah",
      "Yalıköy Mah",
      "Yapraklar Mah",
      "Büyükçiftlikköyü Köyü",
      "Çiftlik Köyü",
      "Denizgören Köyü",
      "Kalecik Köyü",
      "Köşklü Köyü",
      "Taşhane Köyü",
      "Yaylacılar Köyü"
    ],
    "Kalkandere": [
      "Adalar Mah",
      "Aksu Mah",
      "Aşağı Tatlısu Mah",
      "Cevizlik Mah",
      "Dağdibi Mah",
      "Kızıltoprak Mah",
      "Kuruköy Mah",
      "Medrese Mah",
      "Soğuksu Mah",
      "Taşçılar Mah",
      "Yeni Mah",
      "Yukarı Tatlısu Mah",
      "Aksu Osb Mah",
      "Armutlu Mah (yolbaşı Köyü)",
      "Aşağı Mah (yeşilköy Köyü)",
      "Babadağı Mah (fındıklı Köyü)",
      "Bayraktarlar Mah (ünalan Köyü)",
      "Binamlar Mah (ünalan Köyü)",
      "Camii Mah (yolbaşı Köyü)",
      "Cumhuriyet Mah (yolbaşı Köyü)",
      "Çağlayan Köyü",
      "Çayırlı Köyü",
      "Dereiçi Mah (fındıklı Köyü)",
      "Durmuşlar Mah (ünalan Köyü)",
      "Dülgerli Köyü",
      "Düz Mah (yolbaşı Köyü)",
      "Esendere Köyü",
      "Esentepe Köyü",
      "Geçitli Köyü",
      "Hurmalık Köyü",
      "Hüseyinhoca Köyü",
      "İnci Köyü",
      "Kayabaşı Köyü",
      "Kayalık Mah (ünalan Köyü)",
      "Kofolar Mah (ünalan Köyü)",
      "Merkez Mah (ünalan Köyü)",
      "Merkez Mah (yolbaşı Köyü)",
      "Musluoğlu Mah (fındıklı Köyü)",
      "Ormanlı Köyü",
      "Orta Mah (yeşilköy Köyü)",
      "Pınarköy Köyü",
      "Reşitler Mah (ünalan Köyü)",
      "Sandıkçıoğlu Mah (fındıklı Köyü)",
      "Seyrantepe Köyü",
      "Sırt Mah (fındıklı Köyü)",
      "Sırt Mah (yolbaşı Köyü)",
      "Soğuksu Köyü",
      "Şendere Mah (yeşilköy Köyü)",
      "Voyunta Mah (ünalan Köyü)",
      "Yamaç Mah (yeşilköy Köyü)",
      "Yenigeçitli Köyü",
      "Yeniköy Köyü",
      "Yeşildere Mah (yeşilköy Köyü)",
      "Yıldırımlar Mah (fındıklı Köyü)",
      "Yokuşlu Köyü",
      "Yukarı Mah (yeşilköy Köyü)",
      "Yumurtatepe Köyü",
      "Yusuflar Orta Mah (ünalan Köyü)"
    ],
    "Merkez": [
      "Akarsu Köyü",
      "Akarsu Mah (akarsu Köyü)",
      "Ardına Mah (balıkçılar Köyü)",
      "Aşağı Mah (balıkçılar Köyü)",
      "Aşağı Mah (pekmezli Köyü)",
      "Aşağı Mah (söğütlü Köyü)",
      "Aşağı Mah (veliköy Köyü)",
      "Aşağı Mah (yenikale Köyü)",
      "Azina Mah (akpınar Köyü)",
      "Balcılar  Mah (şafaklar Mah) (ketenli Köyü)",
      "Çelikler Mah (veliköy Köyü)",
      "Dağ Deresi Mah (balıkçılar Köyü)",
      "Düz Mah (yenikale Köyü)",
      "Eminoğulları Mah (balıkçılar Köyü)",
      "Esentepe Mah (akpınar Köyü)",
      "Esentepe Mah (taşpınar Köyü)",
      "Eski Mah (boğaz Köyü)",
      "Göltepe Mah (akpınar Köyü)",
      "Hazavite Mah (akpınar Köyü)",
      "İslamoğlu Mah (aktaş Köyü)",
      "Karaaliler Mah (veliköy Köyü)",
      "Karoğulları Mah (ketenli Köyü)",
      "Koşkoşlar Mah (ketenli Köyü)",
      "Kurtuluş Köyü",
      "Meraller Mah (veliköy Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (veliköy Köyü)",
      "Mezra Mah (söğütlü Köyü)",
      "Mollaahmetoğlu Mah (aktaş Köyü)",
      "Orsidi Mah (ketenli Köyü)",
      "Orta Mah (balıkçılar Köyü)",
      "Orta Mah (pekmezli Köyü)",
      "Orta Mah (söğütlü Köyü)",
      "Orta Mah (taşpınar Köyü)",
      "Orta Mah (veliköy Köyü)",
      "Pandırlar Mah (balıkçılar Köyü)",
      "Pınarbaşı Köyü",
      "Sırt Mah (yenikale Köyü)",
      "Şairler Mah (akpınar Köyü)",
      "Şairtepe Mah (akpınar Köyü)",
      "Şentepe Mah (taşpınar Köyü)",
      "Taşlık Köyü",
      "Timena Mah (yenikale Köyü)",
      "Üst Mah (boğaz Köyü)",
      "Yazıcılar  Mah (merkez Mah) (ketenli Köyü)",
      "Yazıcılar Mah (ketenli Köyü)",
      "Yeşilırmak Mah (taşpınar Köyü)",
      "Yukarı Karşı Mah (söğütlü Köyü)",
      "Yukarı Mah (balıkçılar Köyü)",
      "Yukarı Mah (söğütlü Köyü)",
      "Asmalık Mah (kendirli Beldesi)",
      "Düz Mah (kendirli Beldesi)",
      "Halaslar Mah (kendirli Beldesi)",
      "Orta Mah (kendirli Beldesi)",
      "Sırt Mah (kendirli Beldesi)",
      "Akıncılar Mah (elmalı Köyü)",
      "Aktepe Mah (pazarköy Köyü)",
      "Alik Mah (güzelyurt Köyü)",
      "Alişör Mah (karasu Köyü)",
      "Alt Mah (küçükçayır Köyü)",
      "Alt Mah (tuğlalı Köyü)",
      "Ardin Mah (taşköprü Köyü)",
      "Arnault Mah (pazarköy Köyü)",
      "Asgoroz Mah (küçükçayır Köyü)",
      "Aşağı Mah (küçükköy Köyü)",
      "Aşağı Mah (topkaya Köyü)",
      "Ayane Köyü",
      "Ayvalı Mah (sütlüce Köyü)",
      "Azaklılar Mah (ambarlık Köyü)",
      "Baş Mah (taşköprü Köyü)",
      "Bayındırlar Mah (ambarlık Köyü)",
      "Beştepe Köyü",
      "Bıçakcılar Mah (üçkaya Köyü)",
      "Bıldırcınköy Köyü",
      "Camiönü-güneşli-merkez Güzelyurt Mah (yeşildere Köyü)",
      "Cevizlik Mah (camidağı Köyü)",
      "Cingöz Mah (karasu Köyü)",
      "Çalıklar Mah (melek Köyü)",
      "Çaplar Mah (elmalı Köyü)",
      "Çavuşoğlu Mah (elmalı Köyü)",
      "Çaycılar Köyü",
      "Çelikler Mah (üçkaya Köyü)",
      "Çetinkayalar Mah (üçkaya Köyü)",
      "Çiyanda Mah (çaybaşı Köyü)",
      "Delallar Mah (küçükçayır Köyü)",
      "Demircioğlu Alt Mah (çimenli Köyü)",
      "Demircioğlu Üst Mah (çimenli Köyü)",
      "Dere Başı Mah (elmalı Köyü)",
      "Dere Boyu Mah (elmalı Köyü)",
      "Dere Mah (küçükçayır Köyü)",
      "Dere Mah (taşköprü Köyü)",
      "Devranlar Mah (derebaşı Köyü)",
      "Dörtyol Köyü",
      "Düzköy Köyü",
      "Eğitmen Tevfik Uzun Mah (yemişlik Köyü)",
      "Eminoğlu  Mah (eminuka Mah) (derebaşı Köyü)",
      "Erenköy Köyü",
      "Erenler Mah (karayemiş Köyü)",
      "Esendere-güven-yeşilova Mah (yeşildere Köyü)",
      "Esentepe Mah (elmalı Köyü)",
      "Esenyurt Mah (elmalı Köyü)",
      "Eser Mah (melek Köyü)",
      "Fındıklar Mah (derebaşı Köyü)",
      "Godol Mah (karasu Köyü)",
      "Gölgeli-1 Mah (gölgeli Köyü)",
      "Gölgeli-2 Mah (gölgeli Köyü)",
      "Gültepe Mah (derebaşı Köyü)",
      "Güneli Mah (zincirliköprü Köyü)",
      "Güneyler Mah (karasu Köyü)",
      "Güven Mah (karayemiş Köyü)",
      "Güzeltepe Mah (pazarköy Köyü)",
      "Güzelyurt Mah (elmalı Köyü)",
      "Güzelyurt Mah (köprülü Köyü)",
      "Hamçayır Mah (camidağı Köyü)",
      "Hamçayır Mah (derebaşı Köyü)",
      "Havger Mah (güzelyurt Köyü)",
      "Hev Mah (karasu Köyü)",
      "Hur Mah (camidağı Köyü)",
      "İçmeler Mah (küçükçayır Köyü)",
      "İsmailoğlu Mah (ambarlık Köyü)",
      "İşyarlar Mah (elmalı Köyü)",
      "Kadıbaşlar Mah (derebaşı Köyü)",
      "Kamaraş Mah (ambarlık Köyü)",
      "Karaırmak Mah (derebaşı Köyü)",
      "Karşı Mah (köprülü Köyü)",
      "Karşıyaka Mah (elmalı Köyü)",
      "Kartaltepe Mah (pazarköy Köyü)",
      "Katıla Mah (derebaşı Köyü)",
      "Kayadibi Mah (karasu Köyü)",
      "Kayalık Mah (karayemiş Köyü)",
      "Kirazlık Mah (elmalı Köyü)",
      "Kocatepe Köyü",
      "Koçallar Mah (ambarlık Köyü)",
      "Konaklar Mah (ambarlık Köyü)",
      "Kop Mah (karasu Köyü)",
      "Korutürk Mah (kırklartepesi Köyü)",
      "Koseler Mah (ambarlık Köyü)",
      "Kostanlar Mah (derebaşı Köyü)",
      "Kotos Mah (karayemiş Köyü)",
      "Köseler Mah (camidağı Köyü)",
      "Köseler Mah (derebaşı Köyü)",
      "Kurs'tan İtibaren Mah (güzelköy Köyü)",
      "Kutlular Mah (azaklıhoca Köyü)",
      "Manavlar Mah (yenikasarcılar Köyü)",
      "Menderes Mah (karayemiş Köyü)",
      "Merkez Mah (ambarlık Köyü)",
      "Merkez Mah (çaybaşı Köyü)",
      "Merkez Mah (derebaşı Köyü)",
      "Merkez Mah (elmalı Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (karasu Köyü)",
      "Merkez Mah (karayemiş Köyü)",
      "Merkez Mah (kırklartepesi Köyü)",
      "Merkez Mah (köprülü Köyü)",
      "Merkez Mah (melek Köyü)",
      "Merkez Mah (pazarköy Köyü)",
      "Merkez Mah (sütlüce Köyü)",
      "Merkez Mah (taşköprü Köyü)",
      "Merkez Mah (yemişlik Köyü)",
      "Merkez Mah (yenikasarcılar Köyü)",
      "Merkez-aşağı Mah (karasu Köyü)",
      "Mezra Mah (üçkaya Köyü)",
      "Orta Mah (azaklıhoca Köyü)",
      "Orta Mah (camidağı Köyü)",
      "Orta Mah (çaybaşı Köyü)",
      "Orta Mah (kırklartepesi Köyü)",
      "Orta Mah (küçükköy Köyü)",
      "Orta Mah (taşköprü Köyü)",
      "Orta Mah (üçkaya Köyü)",
      "Orta Mah (yemişlik Köyü)",
      "Ortapazar Köyü",
      "Öksüzler Mah (sütlüce Köyü)",
      "Örnek Köyü",
      "Sadıklar Mah (camidağı Köyü)",
      "Selimiye Köyü",
      "Seyrantepe Mah (elmalı Köyü)",
      "Sırt Mah (çaybaşı Köyü)",
      "Sırt Mah (elmalı Köyü)",
      "Sırt Mah (karasu Köyü)",
      "Silyanlı Mah (güzelköy Köyü)",
      "Soğukçeşme Köyü",
      "Soğuksu Mah (melek Köyü)",
      "Sukas Mah (çimenli Köyü)",
      "Şahintepe Mah (ambarlık Köyü)",
      "Şehit Mah (ambarlık Köyü)",
      "Şöz Mah (zincirliköprü Köyü)",
      "Taşerek Mah (sütlüce Köyü)",
      "Tekke Köyü",
      "Tepe Üstü Mah (sütlüce Köyü)",
      "Topçular Mah (elmalı Köyü)",
      "Türütler Mah (ambarlık Köyü)",
      "Uzunköy Köyü",
      "Uzunlar Mah (yemişlik Köyü)",
      "Üst Mah (küçükçayır Köyü)",
      "Üst Mah (topkaya Köyü)",
      "Üst Mah (tuğlalı Köyü)",
      "Üst Mah (üçkaya Köyü)",
      "Yağlıtaş Mah (melek Köyü)",
      "Yeni Mah (yemişlik Köyü)",
      "Yeni Melek Mah (melek Köyü)",
      "Yenigüzelköy Köyü",
      "Yeniköy Mah (azaklıhoca Köyü)",
      "Yeniselimiye Köyü",
      "Yeşilyurt Mah (elmalı Köyü)",
      "Yıldıztepe Mah (ambarlık Köyü)",
      "Yıldıztepe-güzeldere Mah (yeşildere Köyü)",
      "Yolüstü Köyü",
      "Yolveren Köyü",
      "Yukarı Mah (küçükköy Köyü)",
      "Yukarı Mah (topkaya Köyü)",
      "Kömürcüler Mah (muradiye Beldesi)",
      "Köprübaşı Mah (muradiye Beldesi)",
      "Mesudiye Mah (muradiye Beldesi)",
      "Orta Muradiye Mah (muradiye Beldesi)",
      "Soğuksu Mah (muradiye Beldesi)",
      "Yeşildere Mah (muradiye Beldesi)",
      "Alipaşa Mah",
      "Atmeydanı Mah",
      "Bağdatlı Mah",
      "Balcılar Mah (yenidoğan Köyü)",
      "Balsu Mah",
      "Boğaz Mah",
      "Bozkale Mah",
      "Camiönü Mah",
      "Canpolat Mah",
      "Çamlıbel Mah",
      "Çarşı Mah",
      "Çiftekavak Mah",
      "Çorapçılar Mah",
      "Dağınıksu Mah",
      "Dağsu Mah",
      "Değirmendere Mah",
      "Dereüstü Mah",
      "Ekmekçiler Mah",
      "Ekrem Orhon Mah",
      "Eminettin Mah",
      "Engindere Mah",
      "Engindere Sb Mah",
      "Fatih Mah",
      "Fener Mah",
      "Gülbahar Mah",
      "Gümüşler Mah (yenidoğan Köyü)",
      "Hacıalioğlu Mah (yenidoğan Köyü)",
      "Halatçılar Mah",
      "Hamidiye Mah",
      "Hamzabey Mah",
      "Hayrat Mah",
      "İslampaşa Mah",
      "Kale Mah",
      "Kanbursırt Mah",
      "Kaplıca Mah",
      "Kavaklı Mah",
      "Mermerdelen Mah",
      "Mezra Mah",
      "Müftü Mah",
      "Paşakuyu Mah",
      "Pehlivan Mah",
      "Pehlivantaşı Mah",
      "Pilavdağı Mah",
      "Piriçelebi Mah",
      "Portakallık Mah",
      "Reşadiye Mah",
      "Taşlıdere Mah",
      "Tophane Mah",
      "Yağlıtaş Mah",
      "Yeniköy Mah",
      "Güneşli Mah (salarha Beldesi)",
      "Güneştepe Mah (salarha Beldesi)",
      "Kasarcılar Mah (salarha Beldesi)",
      "Kireçhane Mah (salarha Beldesi)",
      "Kokulukaya Mah (salarha Beldesi)",
      "Müderrisler Mah (salarha Beldesi)",
      "Sırt Kasarcılar Mah (salarha Beldesi)",
      "Üzümlü Mah (salarha Beldesi)",
      "Yeşilılıca Mah (salarha Beldesi)"
    ],
    "Pazar": [
      "Akbucak Köyü",
      "Akmescit Köyü",
      "Aktepe Köyü",
      "Alım Yeri Ve Okumuşlar Mevki Mah (hamidiye Köyü)",
      "Alt Mevki Mah (şehitlik Köyü)",
      "Ana Yol Altı Mevki Mah (kuzayca Köyü)",
      "Arka Dere Mevki Mah (yücehisar Köyü)",
      "Aşağı Mevki Mah (sahilköy Köyü)",
      "Avcılar Mevkii Mah (örnek Köyü)",
      "Aygüneş-yıldız-altun Mevki Mah (handağı Köyü)",
      "Babuçoğlu-devrişoğlu Mevki Mah (handağı Köyü)",
      "Badialva Mevki Mah (alçılı Köyü)",
      "Balaban Mevki Mah (merdivenli Köyü)",
      "Baş Mevki Mah (sahilköy Köyü)",
      "Başköy Köyü",
      "Bilaloğlu Mevki Mah (handağı Köyü)",
      "Biliciler Mevki Mah (hisarlı Köyü)",
      "Birinciler Mevki Mah (hisarlı Köyü)",
      "Boğazlı Köyü",
      "Büyük Cami Mevki Mah (güney Köyü)",
      "Cami Mevki Mah (bucak Köyü)",
      "Cami Mevki Mah (ortayol Köyü)",
      "Cami Mevki Mah (sivritepe Köyü)",
      "Cami Mevki Mah (şehitlik Köyü)",
      "Cami Mevki Mah (yemişli Köyü)",
      "Cevherler Mah (handağı Köyü)",
      "Cihanlı Mevki Mah (uğrak Köyü)",
      "Çiçekören Mevki Mah (aktaş Köyü)",
      "Dağdibi Köyü",
      "Darılı Köyü",
      "Dere Mevki Mah (alçılı Köyü)",
      "Dere Mevki Mah (bucak Köyü)",
      "Dere Mevki Mah (uğrak Köyü)",
      "Dere Mevkii Mah (ortayol Köyü)",
      "Derebaşı Köyü",
      "Dernek Köyü",
      "Dışkapı Mevki Mah (suçatı Köyü)",
      "Dumina Mevki Mah (balıkçı Köyü)",
      "Düzler Mevki Mah (şehitlik Köyü)",
      "Elmalık Köyü",
      "Geçitler Mevki Mah (başköy Köyü)",
      "Haberal Mevki Mah (subaşı Köyü)",
      "Hamidiye Mah (hamidiye Köyü)",
      "Harvat Mevkii Mah (ortayol Köyü)",
      "Hasköy Köyü",
      "Haşıoğlu Mevkii Mah (ortayol Köyü)",
      "Hazine Mevki Mah (suçatı Köyü)",
      "Hoçoti Mevki Mah (derinsu Köyü)",
      "Hopa Mevki Mah (ortayol Köyü)",
      "Hukanoğlu Mevki Mah (handağı Köyü)",
      "Irmak Köyü",
      "Irmakyeniköy Köyü",
      "İnce Mevki Mah (aktaş Köyü)",
      "İskele Mevki Mah (suçatı Köyü)",
      "Kale Mevki Mah (yemişli Köyü)",
      "Kanlı Mevki Mah (başköy Köyü)",
      "Karşı Mevki Mah (sivritepe Köyü)",
      "Karşı Mevki Mah (yemişli Köyü)",
      "Kasapoğlu Mevki Mah (sahilköy Köyü)",
      "Kayağantaş Köyü",
      "Kesikköprü Köyü",
      "Kesimal Mevki Mah (handağı Köyü)",
      "Kocaköprü Mah",
      "Koçanlı Mevki Mah (uğrak Köyü)",
      "Koçoğlu Ve Çebiler Mevki Mah (hamidiye Köyü)",
      "Korkmazlar Mevki Mah (tektaş Köyü)",
      "Kösoğlu Ve Kolsuzoğlu Mevki Mah (tektaş Köyü)",
      "Küçük Cami Mevki Mah (güney Köyü)",
      "Liman Mevki Mah (balıkçı Köyü)",
      "Memoğlu Mevki Mah (sahilköy Köyü)",
      "Merdivenli Köyü",
      "Merkez Cami Eski Pazaryolu Mevki Mah (hamidiye Köyü)",
      "Merkez Cami Mevki Mah (alçılı Köyü)",
      "Merkez Mevki Mah (balıkçı Köyü)",
      "Merkez Mevki Mah (derinsu Köyü)",
      "Morçut Mevki Mah (uğrak Köyü)",
      "Ocak Mah",
      "Ocaozon Mevki Mah (bucak Köyü)",
      "Okul Mevki Mah (güney Köyü)",
      "Okul Mevki Mah (yemişli Köyü)",
      "Okul Mevkii Mah (alçılı Köyü)",
      "Okul Ve Cami Mevkii Mah (örnek Köyü)",
      "Omohale Ve Mezralar Mevki Mah (kuzayca Köyü)",
      "Orta Mah. Yolu Ve İslamoğlu Mevki Mah (hamidiye Köyü)",
      "Orta Mah.yolu Ve Aytemizler Mevki Mah (hamidiye Köyü)",
      "Orta Mevki Mah (yemişli Köyü)",
      "Orta Mevki Mah (yücehisar Köyü)",
      "Orta Mevkii Mah (sivritepe Köyü)",
      "Ortaırmak Köyü",
      "Ortayol Mevki Mah (yücehisar Köyü)",
      "Papatya Köyü",
      "Paşakinalar Mevki Mah (ortayol Köyü)",
      "Pehlivanlar Mevki Mah (güney Köyü)",
      "Pirimoğlu Mah (ortayol Köyü)",
      "Piyastoni Mevki Mah (kuzayca Köyü)",
      "Radar Mevki Mah (hisarlı Köyü)",
      "Sağlık Ocağı  Yolu Ve Çevresi Mevki Mah (hamidiye Köyü)",
      "Sahil Mevki Mah (balıkçı Köyü)",
      "Sahilköy Mah (sahilköy Köyü)",
      "Sapanca Mevki Mah (başköy Köyü)",
      "Sarışı Mevki Mah (örnek Köyü)",
      "Satoğlu Mevki Mah (yeşilköy Köyü)",
      "Semtet Mevki Mah (suçatı Köyü)",
      "Sessizdere Köyü",
      "Sırt Mevki Mah (sivritepe Köyü)",
      "Sırt Mevki Mah (suçatı Köyü)",
      "Sırt Mevki Mah (yemişli Köyü)",
      "Sivrikale Köyü",
      "Sivritepe Köyü",
      "Soğuksu Mevki Mah (aktaş Köyü)",
      "Subaşı Köyü",
      "Sulak Köyü",
      "Şabanoğlu Mevki Mah (tektaş Köyü)",
      "Şendere Köyü",
      "Şentepe Köyü",
      "Şentepe Mevki Mah (şehitlik Köyü)",
      "Tapsihon Yol Üstü Ve Köyiçi Mevki Mah (kuzayca Köyü)",
      "Tasu Mevki Mah (bucak Köyü)",
      "Tepe Mevki Mah (merdivenli Köyü)",
      "Topluca Köyü",
      "Tuna Mevki Mah (alçılı Köyü)",
      "Tutoğlu Mevki Mah (başköy Köyü)",
      "Tütüncüler Köyü",
      "Uçanoğlu Mevki Mah (yeşilköy Köyü)",
      "Ürünlü Doro Mevki Mah (yücehisar Köyü)",
      "Ürünlü Mevki Mah (yücehisar Köyü)",
      "Üst Mevki Mah (şehitlik Köyü)",
      "Y.karşı Mevki Mah (subaşı Köyü)",
      "Yarbaşı Ve Kızılhanlar Mevki Mah (hamidiye Köyü)",
      "Yavuz Köyü",
      "Yeni Mevki Mah (güney Köyü)",
      "Yeni Mevki Mah (tektaş Köyü)",
      "Yıldızlar Mevki Mah (handağı Köyü)",
      "Yukarı Mevki Mah (bucak Köyü)",
      "Yukarı Mevki Mah (yemişli Köyü)",
      "Beyaztaş Mah",
      "Cumhuriyet Mah",
      "Gazi Mah",
      "Güzelyalı Mah",
      "İkiztepe Mah",
      "Kirazlık Mah",
      "Pazar Mah",
      "Soğuksu Mah",
      "Yukarı Soğuksu Mah",
      "Zafer Mah"
    ]
  },
  "Sakarya": {
    "Adapazarı": [
      "Abalı Mah",
      "Acıelmalık Mah",
      "Akıncılar Mah",
      "Alandüzü Mah",
      "Aşırlar Mah",
      "Bağlar Mah",
      "Bayraktar Mah",
      "Bileciler Mah",
      "Budaklar Mah",
      "Büyükhataplı Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Çaltıcak Mah",
      "Çamyolu Mah",
      "Çelebiler Mah",
      "Çerçiler Mah",
      "Çökekler Mah",
      "Çukurahmediye Mah",
      "Dağdibi Mah",
      "Demirbey Mah",
      "Doğancılar Mah",
      "Elmalı Mah",
      "Evrenköy Mah",
      "Göktepe Mah",
      "Güllük Mah",
      "Güneşler Merkez Mah",
      "Güneşler Yeni Mah",
      "Hacılar Mah",
      "Hacıramazanlar Mah",
      "Harmantepe Mah",
      "Hızırtepe Mah",
      "Işıklar Mah",
      "İkizce Müslim Mah",
      "İkizce Osmaniye Mah",
      "İlyaslar Mah",
      "İstiklal Mah",
      "Karadavutlu Mah",
      "Karadere Mah",
      "Karakamış Mah",
      "Karaköy Mah",
      "Karaosman Mah",
      "Karapınar Mah",
      "Kasımlar Mah",
      "Kavaklıorman Mah",
      "Kayrancık Mah",
      "Kışla Mah",
      "Kömürlük Mah",
      "Köprübaşı Mah",
      "Kurtbeyler Mah",
      "Kurtuluş Mah",
      "Küçükhataplı Mah",
      "Mahmudiye Mah",
      "Maltepe Mah",
      "Mithatpaşa Mah",
      "Nasuhlar Mah",
      "Orta Mah",
      "Ozanlar Mah",
      "Örentepe Mah",
      "Papuççular Mah",
      "Poyrazlar Mah",
      "Rüstemler Mah",
      "Sakarya Mah",
      "Salmanlı Mah",
      "Semerciler Mah",
      "Solaklar Mah",
      "Süleymanbey Mah",
      "Şeker Mah",
      "Şirinevler Mah",
      "Taşkısığı Mah",
      "Taşlık Mah",
      "Tekeler Mah",
      "Tepekum Mah",
      "Tığcılar Mah",
      "Turnadere Mah",
      "Tuzla Mah",
      "Yağcılar Mah",
      "Yahyalar Mah",
      "Yenicami Mah",
      "Yenidoğan Mah",
      "Yenigün Mah",
      "Yeşilyurt Mah",
      "15 Temmuz Camili Mah",
      "Karaman Mah",
      "Korucuk Mah"
    ],
    "Akyazı": [
      "Akbalık Mah",
      "Alaağaç Mah",
      "Altındere Cumhuriyet Mah",
      "Altındere Gündoğan Mah",
      "Altındere Osmanağa Mah",
      "Ballıkaya Mah",
      "Batakköy Mah",
      "Bedil Kazancı Mah",
      "Bedilkadırbey Mah",
      "Bediltahirbey Mah",
      "Beldibi Mah",
      "Bıçkıdere Mah",
      "Boztepe Mah",
      "Buğdaylı Mah",
      "Cumhuriyet Mah",
      "Çakıroğlu Mah",
      "Çatalköprü Mah",
      "Çıldırlar Mah",
      "Dedeler Mah",
      "Dokurcun Mah",
      "Durmuşlar Mah",
      "Düzyazı Mah",
      "Erdoğdu Mah",
      "Eskibedil Mah",
      "Fatih Mah",
      "Gazi Süleyman Paşa Mah",
      "Gebeş Mah",
      "Gökçeler Mah",
      "Güvençler Mah",
      "Güzlek Mah",
      "Hanyatak Mah",
      "Harunusta Mah",
      "Hasanbey Mah",
      "Hastahane Mah",
      "Haydarlar Mah",
      "İnönü Mah",
      "Kabakulak Mah",
      "Karaçalılık Mah",
      "Kepekli Mah",
      "Kızılcıkorman Mah",
      "Konuralp Mah",
      "Kumköprü Mah",
      "Kuzuluk Ortamahalle Mah",
      "Kuzuluk Topçusırtı Mah",
      "Küçücek Cumhuriyet Mah",
      "Küçücek İstiklal Mah",
      "Madenler Mah",
      "Mansurlar Mah",
      "Merkezyeniköy Mah",
      "Osmanbey Mah",
      "Ömercikler Mah",
      "Pazarköy Mah",
      "Reşadiye Mah",
      "Salihiye Mah",
      "Seyfeler Mah",
      "Sukenarı Mah",
      "Şerefiye Mah",
      "Taşağıl Mah",
      "Taşburun Mah",
      "Taşyatak Mah",
      "Topağaç Mah",
      "Türkormanköy Mah",
      "Uzunçınar Mah",
      "Vakıf Mah",
      "Yağcılar Mah",
      "Yahyalı Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yeniorman Mah",
      "Yongalık Mah",
      "Yörükyeri Mah",
      "Yunus Emre Mah",
      "Yuvalak Mah"
    ],
    "Arifiye": [
      "Adliye Mah",
      "Ahmediye Mah",
      "Arifbey Mah",
      "Aşağı Kirazca Mah",
      "Boğazköy Mah",
      "Cumhuriyet Mah",
      "Çaybaşı Fuadiye Mah",
      "Çınardibi Mah",
      "Fatih Mah",
      "Hacıköy Mah",
      "Hanlı Merkez Mah",
      "Hanlı Sakarya Mah",
      "Hanlıköy Mah",
      "Karaaptiler Mah",
      "Karaçomaklar Mah",
      "Kemaliye Mah",
      "Kışlaçay Mah",
      "Kirazca Mah",
      "Kumbaşı Mah",
      "Mollaköy Mah",
      "Neviye Mah",
      "Sakarya I.organize Sanayi Bölgesi Mah",
      "Semerciler Mah",
      "Türkçaybaşı Mah",
      "Yukarıkirazca Mah"
    ],
    "Erenler": [
      "Alancuma Mah",
      "Bağlar Mah",
      "Bekirpaşa Mah",
      "Büyükesence Mah",
      "Çaybaşıyeniköy Mah",
      "Çaykışla Mah",
      "Değirmendere Mah",
      "Dilmen Mah",
      "Ekinli Mah",
      "Emirler Mah",
      "Epçeller Mah",
      "Erenler Mah",
      "Hacıoğlu Mah",
      "Hasanbey Mah",
      "Horozlar Mah",
      "Hürriyet Mah",
      "Kamışlı Mah",
      "Kayalarmemduhiye Mah",
      "Kayalarreşitbey Mah",
      "Kozluk Mah",
      "Küçükesence Mah",
      "Küpçüler Mah",
      "Nakışlar Mah",
      "Pirahmetler Mah",
      "Sarıcalar Mah",
      "Şeyhköy Mah",
      "Şükriye Mah",
      "Tabakhane Mah",
      "Tepe Mah",
      "Tuapsalar Mah",
      "Yazılı Mah",
      "Yeni Mah",
      "Yeşiltepe Mah"
    ],
    "Ferizli": [
      "Abdürrezzak Mah",
      "Ağacık Mah",
      "Akçukur Mah",
      "Bakırlı Mah",
      "Ceylandere Mah",
      "Damlık Mah",
      "Değirmencik Mah",
      "Devlet Mah",
      "Doğancı Mah",
      "Ferizliosb Mah",
      "Gölkent Mah",
      "Hocaoğlu Mah",
      "İnönü Mah",
      "İstiklal Mah",
      "Karadiken Mah",
      "Kemalpaşa Mah",
      "Kusca Mah",
      "Nalköy Mah",
      "Osmanağa Çiftliği Mah",
      "Sarıahmetler Mah",
      "Seyifler Mah",
      "Sinanoğlu Mah",
      "Teberik Mah",
      "Tokat Mah",
      "Yeni Mah"
    ],
    "Geyve": [
      "Ahibaba Mah",
      "Akdoğan Mah",
      "Akıncı Mah",
      "Akkaya Mah",
      "Alıplar Mah",
      "Alifuatpaşa Mah",
      "Aydınlar Mah",
      "Bağcaz Mah",
      "Bağlarbaşı Mah",
      "Bayat Mah",
      "Belpınar Mah",
      "Bozören Mah",
      "Burhaniye Mah",
      "Camikebir Mah",
      "Ceceler Mah",
      "Çamlık Mah",
      "Çayköy Mah",
      "Çeltikler Mah",
      "Çengel Mah",
      "Çine Mah",
      "Çukurköy Mah",
      "Demirler Mah",
      "Dereköy Mah",
      "Doğancıl Mah",
      "Doğançay Mah",
      "Doğantepe Mah",
      "Düzakçaşehir Mah",
      "Epçeler Mah",
      "Esenköy Mah",
      "Eşme Mah",
      "Fındıksuyu Mah",
      "Gazi Süleyman Paşa Mah",
      "Güney Mah",
      "Günhoşlar Mah",
      "Hacılar Mah",
      "Hacıosmanlar Mah",
      "Halidiye Mah",
      "Hırka Mah",
      "Hisarlık Mah",
      "Ilıca Mah",
      "İhsaniye Mah",
      "İlimbey Mah",
      "İnciksuyu Mah",
      "Kamışlı Mah",
      "Karacaören Mah",
      "Karaçam Mah",
      "Kızılkaya Mah",
      "Koru Mah",
      "Kozan Mah",
      "Köprübaşı Mah",
      "Kulfallar Mah",
      "Maksudiye Mah",
      "Melekşeoruç Mah",
      "Melekşesolak Mah",
      "Nuruosmaniye Mah",
      "Orhaniye Mah",
      "Örencik Mah",
      "Poydular Mah",
      "Sabırlar Mah",
      "Safibey Mah",
      "Saraçlı Mah",
      "Sarıgazi Mah",
      "Sekiharman Mah",
      "Setçe Mah",
      "Suçatı Mah",
      "Sütalan Mah",
      "Şehren Mah",
      "Şerefiye Mah",
      "Taşoluk Mah",
      "Tepecikler Mah",
      "Umurbey Mah",
      "Yaylak Mah",
      "Yörükler Mah"
    ],
    "Hendek": [
      "Akarca Mah",
      "Akçayır Mah",
      "Akova Mah",
      "Akpınar Mah",
      "Aksu Mah",
      "Aktefek Mah",
      "Aşağıçalıca Mah",
      "Bakacak Mah",
      "Balıklıihsaniye Mah",
      "Başpınar Mah",
      "Bayraktepe Mah",
      "Beyköy Mah",
      "Beylice Mah",
      "Bıçkıatik Mah",
      "Büyükdere Mah",
      "Çağlayan Mah",
      "Çakallık Mah",
      "Çamlıca Mah",
      "Çayırbaşı Mah",
      "Çiftlik Mah",
      "Çobanyatak Mah",
      "Çukurhan Mah",
      "Dereboğazı Mah",
      "Dereköy Mah",
      "Dikmen Mah",
      "Esentepe Mah",
      "Eskibıçkı Mah",
      "Göksu Mah",
      "Güldibi Mah",
      "Gündoğan Mah",
      "Güney Mah",
      "Hacıkışla Mah",
      "Hacimbey Mah",
      "Halaç Mah",
      "Hamitli Mah",
      "Harmantepe Mah",
      "Hicriye Mah",
      "Hüseyinşeyh Mah",
      "İkbaliye Mah",
      "İkramiye Mah",
      "Kadifekale Mah",
      "Kahraman Mah",
      "Kalayık Mah",
      "Karadere Mah",
      "Karatoprak Mah",
      "Kargalı Hanbaba Mah",
      "Kargalı Hanbabaosb Mah",
      "Kargalıyeniköy Mah",
      "Kazımiye Mah",
      "Kemaliye Mah",
      "Kırktepe Mah",
      "Kızanlık Mah",
      "Kocaahmetler Mah",
      "Kocatöngel Mah",
      "Köprübaşı Mah",
      "Kurtköy Mah",
      "Kurtuluş Mah",
      "Lütfiyeköşk Mah",
      "Mahmutbey Mah",
      "Martinler Mah",
      "Muradiye Mah",
      "Nuriye Mah",
      "Paşaköy Mah",
      "Pınarlı Mah",
      "Puna Ortaköy Mah",
      "Rasimpaşa Mah",
      "Sarıdede Mah",
      "Sarıyer Mah",
      "Servetiye Mah",
      "Sivritepe Mah",
      "Sofular Mah",
      "Soğuksu Mah",
      "Sukenarı Mah",
      "Süleymaniye Mah",
      "Sümbüllü Mah",
      "Şeyhler Mah",
      "Turanlar Mah",
      "Tuzak Mah",
      "Türbe Mah",
      "Uzuncaorman Mah",
      "Uzunçarşı Mah",
      "Yağbasan Mah",
      "Yarıca Mah",
      "Yayalar Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeniyayla Mah",
      "Yeşilköy Mah",
      "Yeşilvadi Mah",
      "Yeşilyurt Mah",
      "Yukarıçalıca Mah",
      "Yukarıhüseyinşeyh Mah"
    ],
    "Karapürçek": [
      "Ahmediye Mah",
      "Ahmetler Mah",
      "Cumhuriyet Mah",
      "Çeşmebaşı Mah",
      "Hocaköy Mah",
      "İnönü Mah",
      "Kanlıçay Mah",
      "Kızılbayır Mah",
      "Küçükkarapürçek Mah",
      "Mecidiye Mah",
      "Mesudiye Mah",
      "Meşepınarı Mah",
      "Yazılıgürgen Mah",
      "Yüksel Mah"
    ],
    "Karasu": [
      "Adatepe Mah",
      "Akkum Mah",
      "Ardıçbeli Mah",
      "Aziziye Mah",
      "Camitepe Mah",
      "Çatalövez Mah",
      "Darıçayırı Mah",
      "Denizköy Mah",
      "Gölköprü Mah",
      "Hürriyet Mah",
      "İhsaniye Mah",
      "İncilli Mah",
      "Kabakoz Mah",
      "Kabakoz Osb Mah",
      "Kancalar Mah",
      "Karamüezzinler Mah",
      "Karanlıkdere Mah",
      "Karapınar Mah",
      "Karasu Mah",
      "Kızılcık Mah",
      "Konacık Mah",
      "Kurudere Mah",
      "Kurumeşe Mah",
      "Kuyumcullu Mah",
      "Kuzuluk Mah",
      "Limandere Mah",
      "Manavpınarı Mah",
      "Ortaköy Mah",
      "Paralı Mah",
      "Resuller Mah",
      "Subatağı Mah",
      "Taşlıgeçit Mah",
      "Tepetarla Mah",
      "Tuzla Mah",
      "Üçoluk Mah",
      "Yalı Mah",
      "Yassıgeçit Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yeşilköy Mah",
      "Yuvalıdere Mah"
    ],
    "Kaynarca": [
      "Akbaşlı Mah",
      "Arifağa Mah",
      "Başoğlu Mah",
      "Birlik Mah",
      "Büyükyanık Mah",
      "Cebek Mah",
      "Duduköy Mah",
      "Eğrioğlu Mah",
      "Gaziler Mah",
      "Gölce Mah",
      "Gürpınar Mah",
      "Güven Mah",
      "Hatipler Mah",
      "İmamlar Mah",
      "İşaret Mah",
      "Kalburcu Mah",
      "Karaçalı Mah",
      "Karamanlar Mah",
      "Kayacık Mah",
      "Kertil Mah",
      "Kırktepe Mah",
      "Kızılcaali Mah",
      "Konak Mah",
      "Kulaklı Mah",
      "Küçükkaynarca Mah",
      "Küçükkışla Mah",
      "Merkez Mah",
      "Müezzinler Mah",
      "Okçular Mah",
      "Orta Mah",
      "Ortaköy Mah",
      "Osmanlı Mah",
      "Ömerağa Mah",
      "Sabırlı Mah",
      "Sarıbeyli Mah",
      "Şeyhtımarı Mah",
      "Taşoluk Mah",
      "Topçu Mah",
      "Turnalı Mah",
      "Uğurlu Mah",
      "Uzakkışla Mah",
      "Uzunalan Mah",
      "Yeniçam Mah",
      "Yeşilova Mah",
      "Ziahmet Mah"
    ],
    "Kocaali": [
      "Açmabaşı Mah",
      "Ağalar Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Alandere Mah",
      "Aydoğan Mah",
      "Beyler Mah",
      "Bezirgan Mah",
      "Caferiye Mah",
      "Çakmaklı Mah",
      "Çukurköy Mah",
      "Demiraçma Mah",
      "Görele Mah",
      "Gümüşoluk Mah",
      "Hızar Mah",
      "Kadıköy Mah",
      "Karalar Mah",
      "Karapelit Mah",
      "Karşı Mah",
      "Kestanepınarı Mah",
      "Kızılüzüm Mah",
      "Kirazlı Mah",
      "Koğutpelit Mah",
      "Kozluk Mah",
      "Köyyeri Mah",
      "Küplük Mah",
      "Melen Mah",
      "Merkez Mah",
      "Selahiye Mah",
      "Süngüt Mah",
      "Şerbetpınar Mah",
      "Yalı Mah",
      "Yalpankaya Mah",
      "Yanıksayvant Mah",
      "Yayla Mah",
      "Yeni Mah"
    ],
    "Pamukova": [
      "Ağaççılar Mah",
      "Ahılar Mah",
      "Akçakaya Mah",
      "Bacıköy Mah",
      "Bakacak Mah",
      "Bayırakçaşehir Mah",
      "Cihadiye Mah",
      "Cumhuriyet Mah",
      "Çardak Mah",
      "Çilekli Mah",
      "Eğriçay Mah",
      "Elperek Mah",
      "Eskiyayla Mah",
      "Fevziye Mah",
      "Gonca Mah",
      "Gökgöz Mah",
      "Hayrettin Mah",
      "Hüseyinli Mah",
      "İsabalı Mah",
      "Kadıköy Mah",
      "Karapınar Mah",
      "Kazımiye Mah",
      "Kemaliye Mah",
      "Mekece Mah",
      "Oruçlu Mah",
      "Özbek Mah",
      "Paşalar Mah",
      "Pınarlı Mah",
      "Şahmelek Mah",
      "Şeyhvarmaz Mah",
      "Teşvikiye Mah",
      "Turgutlu Mah",
      "Yenice Mah"
    ],
    "Sapanca": [
      "Akçay Mah",
      "Balkaya Mah",
      "Camicedit Mah",
      "Çayiçi Mah",
      "Fevziye Mah",
      "Gazipaşa Mah",
      "Göl Mah",
      "Güldibi Mah",
      "Hacımercan Mah",
      "İkramiye Mah",
      "İlmiye Mah",
      "İstanbuldere Mah",
      "Kırkpınar Hasanpaşa Mah",
      "Kırkpınar Soğuksu Mah",
      "Kırkpınar Tepebaşı Mah",
      "Kurtköy Dibektaş Mah",
      "Kurtköy Fatih Mah",
      "Kurtköy Yavuzselim Mah",
      "Kuruçeşme Mah",
      "Mahmudiye Mah",
      "Memnuniye Mah",
      "Muradiye Mah",
      "Nailiye Mah",
      "Rüstempaşa Mah",
      "Şükriye Mah",
      "Uzunkum Mah",
      "Ünlüce Mah",
      "Yanık Mah",
      "Yeni Mah"
    ],
    "Serdivan": [
      "Arabacıalanı Mah",
      "Aralık Mah",
      "Aşağıdereköy Mah",
      "Bahçelievler Mah",
      "Beşevler Mah",
      "Beşköprü Mah",
      "Çubuklu Mah",
      "Dağyoncalı Mah",
      "Esentepe Mah",
      "Hamitabat Mah",
      "İstiklal Mah",
      "Kazımpaşa Mah",
      "Kemalpaşa Mah",
      "Kızılcıklı Mah",
      "Kuruçeşme Mah",
      "Meşeli Mah",
      "Otuziki Evler Mah",
      "Reşadiye Mah",
      "Selahiye Mah",
      "Uzunköy Mah",
      "Yukarıdereköy Mah",
      "Köprübaşı Mah",
      "Vatan Mah",
      "Yazlık Mah"
    ],
    "Söğütlü": [
      "Akarca Mah",
      "Akçakamış Mah",
      "Akgöl Mah",
      "Beşdeğirmen Mah",
      "Cami Cedit Mah",
      "Fındıklı Mah",
      "Gündoğan Mah",
      "Hasanfakı Mah",
      "İmamlar Mah",
      "Kantar Mah",
      "Karateke Mah",
      "Kurudil Mah",
      "Küçük Söğütlü Mah",
      "Levent Mah",
      "Mağara Mah",
      "Maksudiye Mah",
      "Orta Mah",
      "Rüstemler Mah",
      "Sıraköy Mah",
      "Soğucak Mah",
      "Soğucakosb Mah",
      "Tokmaklıdere Mah",
      "Türkbeylikkışla Mah",
      "Yeniköy Mah"
    ],
    "Taraklı": [
      "Akçapınar Mah",
      "Aksu Mah",
      "Alballar Mah",
      "Avdan Mah",
      "Çamtepe Mah",
      "Dışdedeler Mah",
      "Duman Mah",
      "Esenyurt Mah",
      "Hacıaliler Mah",
      "Hacımurat Mah",
      "Hacıyakup Mah",
      "Harkköy Mah",
      "İçdedeler Mah",
      "Kemaller Mah",
      "Mahdumlar Mah",
      "Pirler Mah",
      "Tuzla Mah",
      "Uğurlu Mah",
      "Ulucamii Mah",
      "Yenidoğan Mah",
      "Yeniköy Mah",
      "Yusufbey Mah"
    ]
  },
  "Samsun": {
    "19 Mayıs": [
      "Aydınpınar Mah",
      "Bahçelievler Mah",
      "Ballıca Mah",
      "Beylik Mah",
      "Cerekli Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Çandır Mah",
      "Çepinler Mah",
      "Çetirlipınar Mah",
      "Çiftlikköy Mah",
      "Dağköy Mah",
      "Dereköy Mah",
      "Düzköy Mah",
      "Engiz Mah",
      "Esentepe Mah",
      "Esenyer Mah",
      "Fındıklı Mah",
      "Hibe Mah",
      "İstiklal Mah",
      "Karacaoğlu Mah",
      "Karagöl Mah",
      "Karşıyaka Mah",
      "Kertme Mah",
      "Kösedik Mah",
      "Kumcağız Mah",
      "Kuşkayası Mah",
      "Mimar Sinan Mah",
      "Ormancık Mah",
      "Pazar Mah",
      "Tepeköy Mah",
      "Yeni Mah",
      "Yeşilköy Mah",
      "Yeşilova Mah",
      "Yeşilyurt Mah",
      "Yörükler Mah",
      "Yukarıengiz Mah",
      "Yükseliş Mah"
    ],
    "Alaçam": [
      "Akbulut Mah",
      "Akgüney Mah",
      "Alidedebölmesi Mah",
      "Alparslan Mah",
      "Aşağı Akgüney Mah",
      "Aşağıısırganlı Mah",
      "Aşağıkoçlu Mah",
      "Bahşioymağı Mah",
      "Bekiroğlu Mah",
      "Çeşme Mah",
      "Demircideresi Mah",
      "Doğankent Mah",
      "Doyran Mah",
      "Esentepe Mah",
      "Etyemez Mah",
      "Fatih Mah",
      "Göçkün Mah",
      "Gökçeağaçoymağı Mah",
      "Gökçeboğaz Mah",
      "Gülkaya Mah",
      "Gültepe Mah",
      "Gümüşova Mah",
      "Güvenli Mah",
      "Habilli Mah",
      "Harmancık Mah",
      "İncirli Mah",
      "Kadıköy Mah",
      "Kalıkdemirci Mah",
      "Kapaklı Mah",
      "Karaçukur Mah",
      "Karahüseyinli Mah",
      "Karlı Mah",
      "Karşıyaka Mah",
      "Kışlakonak Mah",
      "Kızlan Mah",
      "Killik Mah",
      "Köseköy Mah",
      "Madenler Mah",
      "Ortaköy Mah",
      "Örenli Mah",
      "Pelitbükü Mah",
      "Pelitbüküsekecek Mah",
      "Sancar Mah",
      "Sarılık Mah",
      "Soğukçam Mah",
      "Şirinköy Mah",
      "Taşkelik Mah",
      "Tefekli Mah",
      "Tepebölmesi Mah",
      "Terskırık Mah",
      "Toplu Mah",
      "Umutlu Mah",
      "Uzunkıraç Mah",
      "Vicikler Mah",
      "Yakacık Mah",
      "Yenicami Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yeşilköy Mah",
      "Yoğunpelit Mah",
      "Yukarıelma Mah",
      "Yukarıısırganlı Mah",
      "Yukarıkoçlu Mah",
      "Yukarısoğukçam Mah",
      "Zeytin Mah"
    ],
    "Asarcık": [
      "Acısu Mah",
      "Akyazı Mah",
      "Alan Mah",
      "Alişar Mah",
      "Arıcak Mah",
      "Armutlu Mah",
      "Aşuru Mah",
      "Atatürk Mah",
      "Ayaklıalan Mah",
      "Aydınköy Mah",
      "Biçincik Mah",
      "Çulhaoğlu Mah",
      "Dağcılar Mah",
      "Emirmusa Mah",
      "Esentepe Mah",
      "Gökgöl Mah",
      "Gülveren Mah",
      "Gündoğdu Mah",
      "Hisariye Mah",
      "İmamlı Mah",
      "Kesealan Mah",
      "Kılavuzlu Mah",
      "Koşaca Mah",
      "Kuyumcuoğlu Mah",
      "Musaağa Mah",
      "Sakızlık Mah",
      "Uluköy Mah",
      "Yarımca Mah",
      "Yaylaköy Mah",
      "Yeniömerli Mah",
      "Yeşildere Mah",
      "Yeşilköy Mah"
    ],
    "Atakum": [
      "Akalan Mah",
      "Aksu Mah",
      "Alanlı Mah",
      "Aslandamı Mah",
      "Atatepe Mah",
      "Ayvalı Mah",
      "Balaç Mah",
      "Beypınar Mah",
      "Büyükkolpınar Mah",
      "Camii Mah",
      "Cumhurıyet Mah",
      "Çakırlar Yalı Mah",
      "Çamlıyazı Mah",
      "Çatmaoluk Mah",
      "Çobanlı Mah",
      "Çobanözü Mah",
      "Denizevleri Mah",
      "Elmaçukuru Mah",
      "Erikli Mah",
      "Esenevler Mah",
      "Güneyköy Mah",
      "İstiklal Mah",
      "Kabadüz Mah",
      "Kamalı Mah",
      "Karakavuk Mah",
      "Karaoyumca Mah",
      "Kasnakcımermer Mah",
      "Kayagüney Mah",
      "Kesili Mah",
      "Köseli Mah",
      "Kulacadağ Mah",
      "Kurugökçe Mah",
      "Küçükkolpınar Mah",
      "Mevlana Mah",
      "Meyvalı Mah",
      "Mimarsinan Mah",
      "Özören Mah",
      "Sarayköy Mah",
      "Sarıışık Mah",
      "Sarıtaş Mah",
      "Sarıyusuf Mah",
      "Şenyurt Mah",
      "Taflan Merkez Mah",
      "Yeşildere Mah",
      "Yeşiltepe Mah",
      "Yukarıaksu Mah",
      "Büyükoyumca Mah",
      "Çakırlar Mah",
      "Güzelyalı Mah",
      "Güzelyurt Mah",
      "İncesu Mah",
      "İncesu Yalı Mah",
      "Körfez Mah",
      "Yalı Mah",
      "Yenimahalle Mah",
      "Yeşilyurt Mah"
    ],
    "Ayvacık": [
      "Ardıç Mah",
      "Başalan Mah",
      "Çamalan Mah",
      "Çamlıkale Mah",
      "Çarşıköy Mah",
      "Çökekli Mah",
      "Döngel Mah",
      "Döngelyatak Mah",
      "Esenyurt Mah",
      "Eynel Mah",
      "Eyüpsultan Mah",
      "Fatih Sultan Mehmet Mah",
      "Gülpınar Mah",
      "Gültepe Mah",
      "Gürçam Mah",
      "Güzelyurt Mah",
      "Kabaklık Mah",
      "Kapıkaya Mah",
      "Karaağaç Mah",
      "Karşıdöngel Mah",
      "Kazancılı Mah",
      "Keskinoğlu Mah",
      "Koçyurdu Mah",
      "Meşelidüz Mah",
      "Orhangazi Mah",
      "Orta Mah",
      "Ortaköy Mah",
      "Osmanlı Mah",
      "Örencik Mah",
      "Sahilköy Mah",
      "Söğütpınar Mah",
      "Şenpınar Mah",
      "Tepealtı Mah",
      "Terice Mah",
      "Tiryakioğlu Mah",
      "Uğurlu Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yeşilçam Mah",
      "Yeşildere Mah",
      "Yeşilpınar Mah",
      "Yunus Emre Mah",
      "Zafer Mah"
    ],
    "Bafra": [
      "Adaköy Mah",
      "Ağcaalan Mah",
      "Ağıllar Mah",
      "Akalan Mah",
      "Aktekke Mah",
      "Alaçam Mah",
      "Alparslan Mah",
      "Altınay Mah",
      "Altınkaya Mah",
      "Altınova Mah",
      "Altınyaprak Mah",
      "Asar Mah",
      "Asmaçam Mah",
      "Azay Mah",
      "Bahçeler Mah",
      "Bakırpınarı Mah",
      "Balıklar Mah",
      "Barış Mah",
      "Başaran Mah",
      "Başkaya Mah",
      "Bengü Mah",
      "Boğazkaya Mah",
      "Burunca Mah",
      "Büyükcami Mah",
      "Cumhuriyet Mah",
      "Çalköy Mah",
      "Çamaltı Mah",
      "Çatak Mah",
      "Çataltepe Mah",
      "Çetinkaya Mah",
      "Çilhane Mah",
      "Çulhakoca Mah",
      "Darboğaz Mah",
      "Dededağı Mah",
      "Dedeli Mah",
      "Derbent Mah",
      "Dereler Mah",
      "Dikencik Mah",
      "Doğanca Mah",
      "Doğankaya Mah",
      "Düzköy Mah",
      "Elalan Mah",
      "Eldavut Mah",
      "Elifli Mah",
      "Emenli Mah",
      "Emirefendi Mah",
      "Esençay Mah",
      "Evrenuşağı Mah",
      "Eynegazi Mah",
      "Fatih Mah",
      "Fener Mah",
      "Fevzi Çakmak Mah",
      "Gazibeyli Mah",
      "Gaziosmanpaşa Mah",
      "Gazipaşa Mah",
      "Gerzeliler Mah",
      "Gökalan Mah",
      "Gökçeağaç Mah",
      "Gökçekent Mah",
      "Gökçesu Mah",
      "Göltepe Mah",
      "Gümüşyaprak Mah",
      "Hacınabi Mah",
      "Hacıoğlu Mah",
      "Harız Mah",
      "Hıdırellez Mah",
      "Hüseyinbeyli Mah",
      "İğdir Mah",
      "İkizpınar Mah",
      "İkiztepe Mah",
      "İlyaslı Mah",
      "İnözükoşaca Mah",
      "İshaklı Mah",
      "İsmetpaşa Mah",
      "Kahraman Mah",
      "Kalaycılı Mah",
      "Kamberli Mah",
      "Kanlıgüney Mah",
      "Kapıkaya Mah",
      "Karaburç Mah",
      "Karakütük Mah",
      "Karıncak Mah",
      "Karpuzlu Mah",
      "Kavakpınar Mah",
      "Kaygusuz Mah",
      "Kelikler Mah",
      "Kemalpaşa Mah",
      "Keresteci Mah",
      "Kızılırmak Mah",
      "Kolay Mah",
      "Komşupınar Mah",
      "Koruluk Mah",
      "Koşu Mah",
      "Kozağzı Mah",
      "Köseli Mah",
      "Kuşçular Mah",
      "Kuşluğan Mah",
      "Kuzalan Mah",
      "Küçükkavakpınar Mah",
      "Lengerli Mah",
      "Meşelitürkmenler Mah",
      "Mevlana Mah",
      "Müstecep Mah",
      "Ortadurak Mah",
      "Osmanbeyli Mah",
      "Ozan Mah",
      "Örencik Mah",
      "Paşaşeyh Mah",
      "Sahilkent Mah",
      "Sarıçevre Mah",
      "Sarıkaya Mah",
      "Sarıköy Mah",
      "Sarpın Mah",
      "Selemelik Mah",
      "Sürmeli Mah",
      "Şahinkaya Mah",
      "Şeyhören Mah",
      "Şeyhulaş Mah",
      "Şirinköy Mah",
      "Tabakhane Mah",
      "Taşköprü Mah",
      "Tepebaşı Mah",
      "Tepecik Mah",
      "Terzili Mah",
      "Türbe Mah",
      "Türkköyü Mah",
      "Tütüncüler Mah",
      "Uluağaç Mah",
      "Üçpınar Mah",
      "Yağmurca Mah",
      "Yaka Mah",
      "Yakıntaş Mah",
      "Yenialan Mah",
      "Yeniköy Mah",
      "Yeraltı Mah",
      "Yeşilköy Mah",
      "Yeşilyazı Mah",
      "Yiğitalan Mah",
      "Yörgüç Mah"
    ],
    "Canik": [
      "Adatepe Mah",
      "Alibeyli Mah",
      "Ambarpınar Mah",
      "Atatürk Mah",
      "Avluca Mah",
      "Başalan Mah",
      "Başkonak Mah",
      "Belediye Evleri Mah",
      "Çağlayan Mah",
      "Çamalan Mah",
      "Demirci Mah",
      "Dereler Mah",
      "Devgeriş Mah",
      "Düvecik Mah",
      "Düzardıç Mah",
      "Düzören Mah",
      "Fındıcak Mah",
      "Gaziosmanpaşa Mah",
      "Gecehan Mah",
      "Gödekli Mah",
      "Gökçepınar Mah",
      "Gölalan Mah",
      "Gültepe Mah",
      "Gürgenyatak Mah",
      "Hacı İsmail Mah",
      "Hacınaipli Mah",
      "Hasköy Mah",
      "Hilaltepe Mah",
      "İkiyüz Evler Mah",
      "İmamlar Mah",
      "Kaleboğazı Mah",
      "Karşıyaka Mah",
      "Kaşyayla Mah",
      "Kestanepınar Mah",
      "Kızıloğlak Mah",
      "Kozlu Mah",
      "Kuzey Yıldızı Mah",
      "Muratlı Mah",
      "Sarıbıyık Mah",
      "Soğuksu Mah",
      "Tekkiraz Mah",
      "Teknepınar Mah",
      "Toptepe Mah",
      "Toygar Mah",
      "Tuzaklı Mah",
      "Uluçayır Mah",
      "Uludağ Mah",
      "Üçpınar Mah",
      "Yavuz Selim Mah",
      "Yayla Mah",
      "Yeniköy Mah",
      "Yenimahalle Mah",
      "Yeşilpınar Mah"
    ],
    "Çarşamba": [
      "Acıklı Mah",
      "Ağcagüney Mah",
      "Ahubaba Mah",
      "Akçaltı Mah",
      "Akçatarla Mah",
      "Akkuzulu Mah",
      "Ali Fuat Başgil Mah",
      "Alibeyli Mah",
      "Allı Mah",
      "Arım Köseli Mah",
      "Aşağı Dikencik Mah",
      "Aşağı Donurlu Mah",
      "Aşağı Esenli Mah",
      "Aşağı Kavacık Mah",
      "Aşağı Musalla Mah",
      "Aşağı Turgutlu Mah",
      "Aşıklı Mah",
      "Ataköy Mah",
      "Bafracalı Mah",
      "Bahçelievler Mah",
      "Bayramlı Mah",
      "Beylerce Mah",
      "Beyyenice Mah",
      "Bezirgan Mah",
      "Boyacılı Mah",
      "Bölmeçayır Mah",
      "Canlı Mah",
      "Cumhuriyet Mah",
      "Çaltı Mah",
      "Çamlıca Mah",
      "Çatak Mah",
      "Çay Mah",
      "Çayvar Mah",
      "Çelikli Mah",
      "Çerçiler Mah",
      "Çınarlık Mah",
      "Dalbahçe Mah",
      "Damlataş Mah",
      "Demiraslan Mah",
      "Demircili Mah",
      "Demirli Mah",
      "Denizler Mah",
      "Deyincek Mah",
      "Dikbıyık Mah",
      "Durakbaşı Mah",
      "Durusu Mah",
      "Eğercili Mah",
      "Eğridere Mah",
      "Eğrikum Mah",
      "Epçeli Mah",
      "Esençay Mah",
      "Esentepe Mah",
      "Gazi Mah",
      "Gökçeçakmak Mah",
      "Gökçeli Mah",
      "Güldere Mah",
      "Gülören Mah",
      "Gülyazı Mah",
      "Güneşli Mah",
      "Güzpınar Mah",
      "Hacılıçay Mah",
      "Hasbahçe Mah",
      "Helvacalı Mah",
      "Hürriyet Mah",
      "Irmaksırtı Mah",
      "İstiklal Mah",
      "Kabaceviz Mah",
      "Karaağaç Mah",
      "Karabahçe Mah",
      "Karacalı Mah",
      "Karakaya Mah",
      "Karakulak Mah",
      "Karamustafalı Mah",
      "Kaydan Mah",
      "Kemer Mah",
      "Kestanepınar Mah",
      "Kızılot Mah",
      "Kirazbucağı Mah",
      "Kirazlıkçay Mah",
      "Kocakavak Mah",
      "Koldere Mah",
      "Konukluk Mah",
      "Köklük Mah",
      "Köroğlu Mah",
      "Kumköy Mah",
      "Kumtepe Mah",
      "Kurtahmetli Mah",
      "Kurtuluş Mah",
      "Kuşçulu Mah",
      "Kuşhane Mah",
      "Kürtün Mah",
      "Mahmutlu Mah",
      "Melik Mah",
      "Musçalı Mah",
      "Namazlı Mah",
      "Ordu Mah",
      "Ordubaşı Mah",
      "Orta Mah",
      "Otluk Mah",
      "Ovacık Mah",
      "Oymalı Mah",
      "Ömerli Mah",
      "Paşayazı Mah",
      "Porsuk Mah",
      "Sahil Mah",
      "Saraçlı Mah",
      "Sarıcalı Mah",
      "Sefalı Mah",
      "Selimiye Mah",
      "Sığırtmaç Mah",
      "Soğucak Mah",
      "Suğluca Mah",
      "Sungurlu Mah",
      "Şenyurt Mah",
      "Şeyhgüven Mah",
      "Şeyhhabil Mah",
      "Taşdemir Mah",
      "Tatarlı Mah",
      "Tilkili Mah",
      "Turgutlu Mah",
      "Uluköy Mah",
      "Ulupınar Mah",
      "Umut Mah",
      "Ustacalı Mah",
      "Uzunlu Mah",
      "Üçköprü Mah",
      "Vakıfköprü Mah",
      "Yalı Mah",
      "Yamanlı Mah",
      "Yaycılar Mah",
      "Yeni Karacalı Mah",
      "Yeni Kışla Mah",
      "Yeni Köseli Mah",
      "Yeşildere Mah",
      "Yeşilırmak Mah",
      "Yeşilova Mah",
      "Yukarı Ağcagüney Mah",
      "Yukarı Dikencik Mah",
      "Yukarı Donurlu Mah",
      "Yukarı Esenli Mah",
      "Yukarı Karabahçe Mah",
      "Yukarı Kavacık Mah",
      "Zümrüt Mah"
    ],
    "Havza": [
      "19 Mayıs Mah",
      "25 Mayıs Mah",
      "Ağcamahmut Mah",
      "Ağdırhasan Mah",
      "Arslançayırı Mah",
      "Aşağı Yavucak Mah",
      "Aşağısusuz Mah",
      "Bahçelievler Mah",
      "Başpelit Mah",
      "Bekdiğin Mah",
      "Belalan Mah",
      "Beyköy Mah",
      "Beyören Mah",
      "Boyalı Mah",
      "Boyalıca Mah",
      "Celil Mah",
      "Cevizlik Mah",
      "Çakıralan Mah",
      "Çamyatağı Mah",
      "Çay Mah",
      "Çayırözü Mah",
      "Çelikalan Mah",
      "Çeltek Mah",
      "Çiftlikköy Mah",
      "Değirmenüstü Mah",
      "Demiryurt Mah",
      "Dereköy Mah",
      "Doğançayır Mah",
      "Dündarlı Mah",
      "Ekinpınarı Mah",
      "Elmacık Mah",
      "Ereli Mah",
      "Erikbelen Mah",
      "Ersandık Mah",
      "Esenbey Mah",
      "Eymir Mah",
      "Gelincik Mah",
      "Gidirli Mah",
      "Göçmenler Mah",
      "Güvercinlik Mah",
      "Hacıbattal Mah",
      "Hacıdede Mah",
      "Hecinli Mah",
      "Hilmiye Mah",
      "Ilıca Mah",
      "İcadiye Mah",
      "İmaret Mah",
      "İmircik Mah",
      "İnönü Mah",
      "Kaleköy Mah",
      "Kamlık Mah",
      "Karabük Mah",
      "Karageçmiş Mah",
      "Karahalil Mah",
      "Karameşe Mah",
      "Karga Mah",
      "Karşıyaka Mah",
      "Kayabaşı Mah",
      "Kayacık Mah",
      "Kemaliye Mah",
      "Kıroğlu Mah",
      "Kirenlik Mah",
      "Kocaoğlu Mah",
      "Kocapınar Mah",
      "Kuşkonağı Mah",
      "Küflek Mah",
      "Medrese Mah",
      "Memduhiye Mah",
      "Meryemdere Mah",
      "Mesudiye Mah",
      "Mısmılağaç Mah",
      "Mürsel Mah",
      "Orhaniye Mah",
      "Ortaklar Mah",
      "Paşapınarı Mah",
      "Pınarçay Mah",
      "Sivrikese Mah",
      "Sofular Mah",
      "Sondaj Mah",
      "Şerifali Mah",
      "Şeyhali Mah",
      "Şeyhkoyun Mah",
      "Şeyhler Mah",
      "Şeyhsafi Mah",
      "Taşkaracaören Mah",
      "Tekkeköy Mah",
      "Tuzla Mah",
      "Uluçal Mah",
      "Üniversite Mah",
      "Yağcımahmut Mah",
      "Yaylaçatı Mah",
      "Yazıkışla Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenimescit Mah",
      "Yeşilalan Mah",
      "Yukarısusuz Mah",
      "Yukarıyavucak Mah"
    ],
    "İlkadım": [
      "Bahçelievler Mah",
      "Yenidoğan Mah",
      "Adalet Mah",
      "Çay Mah",
      "Çiftlik Mah",
      "Derebahçe Mah",
      "Güzeldere Mah",
      "İstasyon Mah",
      "Karadeniz Mah",
      "Kılıçdede Mah",
      "Zafer Mah",
      "Anadolu Mah",
      "Çatalarmut Mah",
      "Kadıköy Mah",
      "Zeytinlik Mah",
      "Hürriyet Mah",
      "Kale Mah",
      "Saitbey Mah",
      "Ulugazi Mah",
      "Baruthane Mah",
      "Cedit Mah",
      "Kadifekale Mah",
      "Karasamsun Mah",
      "Liman Mah",
      "Selahiye Mah",
      "Fatih Mah",
      "İlyasköy Mah",
      "Kışla Mah",
      "Rasathane Mah",
      "Reşadiye Mah",
      "Yaşardoğu Mah",
      "19 Mayıs Mah",
      "Akgöl Mah",
      "Aşağıavdan Mah",
      "Avdan Mah",
      "Bilmece Mah",
      "Çanakçı Mah",
      "Çandır Mah",
      "Çelikalan Mah",
      "Çivril Mah",
      "Fevzi Çakmak Mah",
      "Gürgendağ Mah",
      "Hançerli Mah",
      "Hastane Mah",
      "Kadamut Mah",
      "Kalkancı Mah",
      "Kapaklı Mah",
      "Kazım Karabekir Mah",
      "Kökçüoğlu Mah",
      "Liman Sb Mah",
      "Pazar Mah",
      "Toybelen Mah",
      "Unkapanı Mah",
      "Yeşiltepe Mah",
      "Ahulu Mah",
      "Ataköy Mah",
      "Derecik Mah",
      "Kavacık Mah",
      "Kıran Mah",
      "Kusçulu Mah",
      "Tepecik Mah",
      "Uzgur Mah"
    ],
    "Kavak": [
      "19 Mayıs Mah",
      "Ağcakise Mah",
      "Ahurlu Mah",
      "Akbelen Mah",
      "Alaçam Mah",
      "Alagömlek Mah",
      "Aşağıçirişli Mah",
      "Atayurt Mah",
      "Azaklı Mah",
      "Bahçelievler Mah",
      "Başalan Mah",
      "Bayındır Mah",
      "Bayraklı Mah",
      "Bekdemir Mah",
      "Belalan Mah",
      "Beybesli Mah",
      "Beyköy Mah",
      "Boğaziçi Mah",
      "Bükceğiz Mah",
      "Büyükçukur Mah",
      "Celallı Mah",
      "Çakallı Mah",
      "Çalbaşı Mah",
      "Çarıklıbaşı Mah",
      "Çataltepe Mah",
      "Çayırlı Mah",
      "Çiçekyazı Mah",
      "Çiğdem Mah",
      "Çivril Mah",
      "Çukurbük Mah",
      "Değirmencili Mah",
      "Demirci Mah",
      "Dereköy Mah",
      "Divanbaşı Mah",
      "Doruk Mah",
      "Duman Mah",
      "Dura Mah",
      "Emirli Mah",
      "Germiyan Mah",
      "Göçebe Mah",
      "Güneyce Mah",
      "Hacılı Mah",
      "Ilıcaköy Mah",
      "İdrisli Mah",
      "İkizdere Mah",
      "Kapuhayat Mah",
      "Karaaslan Mah",
      "Karacalar Mah",
      "Karadağ Mah",
      "Karantu Mah",
      "Karapınar Mah",
      "Karayusuflu Mah",
      "Karlı Mah",
      "Kartepe Mah",
      "Kayabaşı Mah",
      "Kayaköy Mah",
      "Kazancı Mah",
      "Kethüda Mah",
      "Kozansıkı Mah",
      "Köseli Mah",
      "Kurşunlu Mah",
      "Kuzalan Mah",
      "Küçükçukur Mah",
      "Mahmutbeyli Mah",
      "Mahmutlu Mah",
      "Mehmetpaşa Mah",
      "Mert Mah",
      "Muhsinli Mah",
      "Muratbeyli Mah",
      "Ortaköy Mah",
      "Saralan Mah",
      "Seyitali Mah",
      "Sıralı Mah",
      "Soğuksu Mah",
      "Susuz Mah",
      "Şeyhli Mah",
      "Şeyhresul Mah",
      "Tabaklı Mah",
      "Talışman Mah",
      "Tatarmuslu Mah",
      "Tekkeköy Mah",
      "Tepecik Mah",
      "Toptepe Mah",
      "Üçhanlar Mah",
      "Yaşar Doğu Mah",
      "Yeni Cami Osb Mah",
      "Yenicami Mah",
      "Yenigün Mah",
      "Yeralan Mah",
      "Yosunlu Mah",
      "Yukarı Dereköy Mah",
      "Yukarıçirişli Mah"
    ],
    "Ladik": [
      "Ağcakaya Mah",
      "Ahmetsaray Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Akyar Mah",
      "Alayurt Mah",
      "Alıçlı Mah",
      "Arslantaş Mah",
      "Aşağıgölyazı Mah",
      "Ayvalı Mah",
      "Ayvalısokağı Mah",
      "Bahşi Mah",
      "Başlamış Mah",
      "Bolat Mah",
      "Budakdere Mah",
      "Büyükalan Mah",
      "Büyükkızoğlu Mah",
      "Cüce Mah",
      "Çadırkaya Mah",
      "Çakırgümüş Mah",
      "Çamlıköy Mah",
      "Daldere Mah",
      "Deliahmetoğlu Mah",
      "Derinöz Mah",
      "Doğankaş Mah",
      "Eynekaraca Mah",
      "Günkoru Mah",
      "Gürün Mah",
      "Güvenli Mah",
      "Hacıalipınar Mah",
      "Hamamayağı Mah",
      "Hamitköy Mah",
      "Hasırcı Mah",
      "Hızarbaşı Mah",
      "İbi Mah",
      "İsasofta Mah",
      "İskaniye Mah",
      "Kabacagöz Mah",
      "Karaabdal Mah",
      "Kıranboğaz Mah",
      "Kızılsini Mah",
      "Kirazpınar Mah",
      "Koğa Mah",
      "Köseoğlu Mah",
      "Kuyucak Mah",
      "Küçükkızoğlu Mah",
      "Küpecik Mah",
      "Mazlumoğlu Mah",
      "Meşepınarı Mah",
      "Nusratlı Mah",
      "Oymapınar Mah",
      "Salur Mah",
      "Sanayi Mah",
      "Saray Mah",
      "Sarıgazel Mah",
      "Sarıksızoğlu Mah",
      "Soğanlı Mah",
      "Söğütlü Mah",
      "Şehreküstü Mah",
      "Şıhlı Mah",
      "Tatlıcak Mah",
      "Teberoğlu Mah",
      "Tüfekçidere Mah",
      "Yenicami Mah",
      "Yukarıgölyazı Mah",
      "Yumaklı Mah",
      "Yuvacık Mah"
    ],
    "Salıpazarı": [
      "Alan Mah",
      "Alanyaykın Mah",
      "Albak Mah",
      "Avut Mah",
      "Bereket Mah",
      "Biçme Mah",
      "Cevizli Mah",
      "Çağlayan Mah",
      "Çiçekli Mah",
      "Dikencik Mah",
      "Düzköy Mah",
      "Esatçiftliği Mah",
      "Fatsalılar Mah",
      "Fındıklı Mah",
      "Fidancık Mah",
      "Gökçebaşı Mah",
      "Gökçeli Mah",
      "Güzelvatan Mah",
      "Kalfalı Mah",
      "Karacalar Mah",
      "Karacaören Mah",
      "Karadere Mah",
      "Karaman Mah",
      "Karayonca Mah",
      "Kırgıl Mah",
      "Kızılot Mah",
      "Kocalar Mah",
      "Konakören Mah",
      "Kuşcuğaz Mah",
      "Merkez Kocalar Mah",
      "Mumlu Mah",
      "Muslubey Mah",
      "Orta Mah",
      "Sarıhasan Mah",
      "Suluca Mah",
      "Tacalan Mah",
      "Tahnal Mah",
      "Tepealtı Mah",
      "Yavaşbey Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yeşil Mah",
      "Yukarıkestanepınar Mah"
    ],
    "Tekkeköy": [
      "Yavuzlar Mah",
      "Cumhuriyet Mah",
      "İstiklal Mah",
      "19 Mayıs Mah",
      "Altınkaya Mah",
      "Asarağaç Mah",
      "Çırakman Mah",
      "Kerimbey Mah",
      "Kirazlık Mah",
      "Şabanoğlu Mah",
      "19 Mayısosb Mah",
      "23 Nisan Mah",
      "Akbaşlar Mah",
      "Antyeri Mah",
      "Bakacak Mah",
      "Balcalı Mah",
      "Başköy Mah",
      "Beyoğlu Mah",
      "Büyüklü Mah",
      "Çay Mah",
      "Çayırçökek Mah",
      "Çayleyik Mah",
      "Çınaralan Mah",
      "Çiftlik Mah",
      "Çiftlikosb Mah",
      "Çimenli Mah",
      "Çinik Mah",
      "Erenköy Mah",
      "Gökçe Mah",
      "Gökçedere Mah",
      "Gölceğiz Mah",
      "Güzelyurt Mah",
      "Hamzalı Mah",
      "Hürriyet Mah",
      "Kababürük Mah",
      "Kahyalı Mah",
      "Karaoğlan Mah",
      "Karaperçin Mah",
      "Kargılı Mah",
      "Karışlar Mah",
      "Kerimbeyosb Mah",
      "Kerpiçli Mah",
      "Kışla Mah",
      "Kibarlar Mah",
      "Köprübaşı Mah",
      "Kurtuluş Mah",
      "Kutlukent Mah",
      "Ovabaşı Mah",
      "Pınar Mah",
      "Sanayi Mah",
      "Sarıyurt Mah",
      "Selyeri Mah",
      "Seymenler Mah",
      "Sıtmasuyu Mah",
      "Şabanoğluosb Mah",
      "Yağbasan Mah",
      "Yaylageriş Mah",
      "Yazılar Mah",
      "Yeni Büyüklü Mah",
      "Yenidoğan Mah",
      "Yeniköy Mah",
      "Yeşilalan Mah",
      "Yeşildere Mah",
      "Yeşilyurt Mah",
      "Yukarıçinik Mah",
      "Zafer Mah"
    ],
    "Terme": [
      "Ahmetbey Mah",
      "Akbucak Mah",
      "Akçagün Mah",
      "Akçay Mah",
      "Akçaykaracalı Mah",
      "Altunlu Mah",
      "Ambartepe Mah",
      "Aybeder Mah",
      "Bafracalı Mah",
      "Bağsaray Mah",
      "Bahçelievler Mah",
      "Bazlamaç Mah",
      "Beşikli Mah",
      "Cılar Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Çamlıca Mah",
      "Çanaklı Mah",
      "Çangallar Mah",
      "Çardak Mah",
      "Çay Mah",
      "Dağdıralı Mah",
      "Dereyol Mah",
      "Dibekli Mah",
      "Dutluk Mah",
      "Eğercili Mah",
      "Elmaköy Mah",
      "Elmalık Mah",
      "Emiryusuf Mah",
      "Erenköy Mah",
      "Etyemezli Mah",
      "Evci Mah",
      "Fatih Mah",
      "Fenk Mah",
      "Geçmiş Mah",
      "Gökçeağaç Mah",
      "Gölyazı Mah",
      "Gündoğdu Mah",
      "Hüseyinmescit Mah",
      "İlimdağ Mah",
      "İmanalisi Mah",
      "Karacaköy Mah",
      "Karacalı Mah",
      "Karamahmut Mah",
      "Karkucak Mah",
      "Kazımkarabekirpaşa Mah",
      "Kesikkaya Mah",
      "Kocaman Mah",
      "Kocamanbaşı Mah",
      "Kozluk Mah",
      "Köybucağı Mah",
      "Kumcığaz Mah",
      "Kuşca Mah",
      "Kuşculu Mah",
      "Mescitli Mah",
      "Meşeyazı Mah",
      "Muratlı Mah",
      "Oğuzlu Mah",
      "Ortasöğütlü Mah",
      "Örencik Mah",
      "Özyurt Mah",
      "Sakarlı Mah",
      "Sancaklı Mah",
      "Sarayköy Mah",
      "Sivaslılar Mah",
      "Söğütlü Mah",
      "Sütözü Mah",
      "Şeyhli Mah",
      "Şuayip Mah",
      "Taşlık Mah",
      "Taşpınar Mah",
      "Uludere Mah",
      "Uzungazi Mah",
      "Yalı Mah",
      "Yeni Mah",
      "Yenicami Mah",
      "Yenidoğan Mah",
      "Yerli Mah",
      "Yukarısöğütlü Mah",
      "Yukarıtaşpınar Mah",
      "Yunus Emre Mah",
      "Yüksekyayla Mah"
    ],
    "Vezirköprü": [
      "Özgüney Mah",
      "Saraylı Mah",
      "Abdulgani Mah",
      "Adatepe Mah",
      "Ağcaalan Mah",
      "Ağcayazı Mah",
      "Ahmetbaba Mah",
      "Akören Mah",
      "Alan Mah",
      "Alanbaşı Mah",
      "Alancık Mah",
      "Alanşeyhi Mah",
      "Altınkaya Mah",
      "Arıca Mah",
      "Atatürk Mah",
      "Avdan Mah",
      "Aydınlı Mah",
      "Aydoğdu Mah",
      "Ayvalı Mah",
      "Bahçekonak Mah",
      "Bahçelievler Mah",
      "Bahçesaray Mah",
      "Bakla Mah",
      "Başalan Mah",
      "Başfakı Mah",
      "Bayram Mah",
      "Bektaş Mah",
      "Belalan Mah",
      "Beşpınar Mah",
      "Boğa Mah",
      "Boğazkoru Mah",
      "Boruk Mah",
      "Burhaniye Mah",
      "Büyükkale Mah",
      "Cebeli Mah",
      "Cumhuriyet Mah",
      "Çakırtaş Mah",
      "Çal Mah",
      "Çalman Mah",
      "Çaltu Mah",
      "Çamlıca Mah",
      "Çamlıdere Mah",
      "Çamlıkonak Mah",
      "Çanaklı Mah",
      "Çayırbaşı Mah",
      "Çekalan Mah",
      "Çekmeden Mah",
      "Çeltek Mah",
      "Çorakdere Mah",
      "Darıçay Mah",
      "Darıçayalanı Mah",
      "Değirmenbaşı Mah",
      "Devalan Mah",
      "Doyran Mah",
      "Duruçay Mah",
      "Elaldı Mah",
      "Elbeği Mah",
      "Elmalı Mah",
      "Esen Mah",
      "Esentepe Mah",
      "Esenyurt Mah",
      "Fazıl Ahmet Paşa Mah",
      "Göl Mah",
      "Göl Yeni Mah",
      "Göllüalan Mah",
      "Gömlekhisar Mah",
      "Güder Mah",
      "Güldere Mah",
      "Habibfakı Mah",
      "Hacılı Mah",
      "Halilbaba Mah",
      "Halkahavlı Mah",
      "Hayranlı Mah",
      "Hıdırlık Mah",
      "İmircik Mah",
      "İncesu Mah",
      "İnkaya Mah",
      "Kabalı Mah",
      "Kadıçayırı Mah",
      "Kadıoğlu Mah",
      "Kapaklı Mah",
      "Kapaklıeşme Mah",
      "Kaplancık Mah",
      "Karabük Mah",
      "Karacaören Mah",
      "Karadoruk Mah",
      "Karaköy Mah",
      "Karanar Mah",
      "Karapınar Mah",
      "Karkucak Mah",
      "Karlı Mah",
      "Kavakpınarı Mah",
      "Kılıçgüney Mah",
      "Kıranalan Mah",
      "Kıratbükü Mah",
      "Kırma Mah",
      "Kızılcakoru Mah",
      "Kızılcaören Mah",
      "Kızılkese Mah",
      "Kocakaya Mah",
      "Kovalı Mah",
      "Köprübaşı Mah",
      "Kumral Mah",
      "Kuruçay Mah",
      "Kuşcular Mah",
      "Kuyaş Mah",
      "Kuyumcu Mah",
      "Küçükkale Mah",
      "Kületek Mah",
      "Mahmatlı Mah",
      "Mehmet Paşa Mah",
      "Melikli Mah",
      "Meşeli Mah",
      "Mezraa Mah",
      "Nalbantlı Mah",
      "Narlısaray Mah",
      "Orta Mah",
      "Ortacami Mah",
      "Oruç Mah",
      "Ovacık Mah",
      "Oymaağaç Mah",
      "Öğürlü Mah",
      "Örencik Mah",
      "Özesentepe Mah",
      "Özkuruçay Mah",
      "Özyörük Mah",
      "Paşa Mah",
      "Pazarcı Mah",
      "Samukalan Mah",
      "Samur Mah",
      "Saraycık Mah",
      "Sarıalan Mah",
      "Sarıdibek Mah",
      "Sarıyar Mah",
      "Sırbaşmak Mah",
      "Sofular Mah",
      "Soğucak Mah",
      "Susuz Mah",
      "Şentepe Mah",
      "Tabakhane Mah",
      "Tahtaköprü Mah",
      "Taşkale Mah",
      "Taşlıyük Mah",
      "Tatarkale Mah",
      "Teberük Mah",
      "Tekkekıran Mah",
      "Tepeören Mah",
      "Tikenli Mah",
      "Türkmen Mah",
      "Yağcı Mah",
      "Yağınözü Mah",
      "Yarbaşı Mah",
      "Yeni Mah",
      "Yeniçelik Mah",
      "Yenidüzce Mah",
      "Yeşilada Mah",
      "Yeşiltepe Mah",
      "Yolpınar Mah",
      "Yukarınarlı Mah",
      "Yurtdağı Mah",
      "Yürükçal Mah"
    ],
    "Yakakent": [
      "Asmapınar Mah",
      "Büyükkırık Mah",
      "Çamalan Mah",
      "Çepni Mah",
      "Gündüzlü Mah",
      "Karaaba Mah",
      "Kayalı Mah",
      "Kozköy Mah",
      "Kuzören Mah",
      "Küplüağzı Mah",
      "Kürüz Mah",
      "Liman Mah",
      "Merkez Mah",
      "Mutaflı Mah",
      "Sarıgöl Mah",
      "Yassıdağ Mah",
      "Yeşilköy Mah"
    ]
  },
  "Siirt": {
    "Baykan": [
      "Atabağı Mah (atabağı Beldesi)",
      "Cefan Mah",
      "Havel Mah",
      "İnönü Mah",
      "Karşıyaka Mah",
      "Yenidoğan Mah",
      "Adakale Köyü",
      "Ayranlı Mah (narlıyurt Köyü)",
      "Çevrimtepe Köyü",
      "Dilektepe Köyü",
      "Dokuzçavuş Köyü",
      "Engin Köyü",
      "Gündoğdu Köyü",
      "İkizler Köyü",
      "Kasımlı Köyü",
      "Kumluca Mah (çevrimtepe Köyü)",
      "Narlıyurt Köyü",
      "Oymaklı Mah (çevrimtepe Köyü)",
      "Sarıdana Köyü",
      "Sıralı Mah (narlıyurt Köyü)",
      "Topraklı Mah (adakale Köyü)",
      "Toptepe Mah (adakale Köyü)",
      "Uğurlu Mah (narlıyurt Köyü)",
      "Ulaştı Köyü",
      "Ulukapı Mah (çevrimtepe Köyü)",
      "Uzunkavak Mah (narlıyurt Köyü)",
      "Akbudak Mah (obalı Köyü)",
      "Akdiken Mah (obalı Köyü)",
      "Ardıçdalı Köyü",
      "Aşağı Tütenocak Mah (tütenocak Köyü)",
      "Bardaklı Mah (çaykaya Köyü)",
      "Binegöl Mah (yeşilçevre Köyü)",
      "Çamtaşı Köyü",
      "Çaykaya Köyü",
      "Çelikli Köyü",
      "Çukurca Köyü",
      "Çukurtaş Mah (yeşilçevre Köyü)",
      "Dedebakırı Köyü",
      "Demirışık Köyü",
      "Derince Mah (derince Köyü)",
      "Dumanlı Mah (ünlüce Köyü)",
      "Eğri Mah (yeşilçevre Köyü)",
      "Eğridere Mah (karakaya Köyü)",
      "Geçit Mah (çaykaya Köyü)",
      "Goraşa Mah (çaykaya Köyü)",
      "Gümüşkaş Köyü",
      "Günbuldu Köyü",
      "Karakaya Köyü",
      "Karataş Mah (çaykaya Köyü)",
      "Kılıçlı Mah (obalı Köyü)",
      "Köklü Mah (obalı Köyü)",
      "Meşelik Köyü",
      "Obalı Köyü",
      "Ocaklı Mah (obalı Köyü)",
      "Ormanpınar Köyü",
      "Sarısalkım Köyü",
      "Sarıyurt Mah (yarımca Köyü)",
      "Tütenocak Köyü",
      "Ünlüce Köyü",
      "Yarımca Köyü",
      "Atatürk Mah (veyselkarani Beldesi)",
      "Çay Mah (veyselkarani Beldesi)",
      "Şeyhosman Mah (veyselkarani Beldesi)"
    ],
    "Eruh": [
      "Aydoğmuş Mah (gönülaldı Köyü)",
      "Bağgöze Köyü",
      "Ballıkavak Köyü",
      "Bingöl Köyü",
      "Bozatlı Köyü",
      "Bozkuş Köyü",
      "Çeltiksuyu Köyü",
      "Çimencik Köyü",
      "Dağdöşü Köyü",
      "Dikboğaz Köyü",
      "Direkli Mah (kekliktepe Köyü)",
      "Dönerdöver Köyü",
      "Duaf Mah (kekliktepe Köyü)",
      "Duygulu Mah (kekliktepe Köyü)",
      "Ekinyolu Köyü",
      "Erenkaya Köyü",
      "Gönülaldı Köyü",
      "Gülburnu Köyü",
      "Ilıca Mah (yelkesen Köyü)",
      "Karabıyık Mah (yelkesen Köyü)",
      "Karadayılar Köyü",
      "Kaşıkyayla Köyü",
      "Kekliktepe Köyü",
      "Kılıçkaya Köyü",
      "Milan Mah (kılıçkaya Köyü)",
      "Narlıdere Köyü",
      "Özlüpelit Köyü",
      "Salkımbağlar Köyü",
      "Savaş Köyü",
      "Sevindik Mah (ekinyolu Köyü)",
      "Tünekpınar Köyü",
      "Yelkesen Köyü",
      "Yerliçoban Köyü",
      "Yokuşlu Köyü",
      "Dih Mah",
      "Fatih Mah",
      "Sarıgül Mah",
      "Akdiken Köyü",
      "Akmeşe Köyü",
      "Bayıryüzü Köyü",
      "Bayramlı Köyü",
      "Bilgili Köyü",
      "Bölüklü Köyü",
      "Budamış Köyü",
      "Cintepe Köyü",
      "Çayırlı Mah (bilgili Köyü)",
      "Çetinkol Köyü",
      "Çırpılı Köyü",
      "Çizmeli Köyü",
      "Dadaklı Köyü",
      "Dalkorur Köyü",
      "Demirciler Mah (bilgili Köyü)",
      "Demiremek Köyü",
      "Gedikaşar Köyü",
      "Gelenkardeş Köyü",
      "Gölgelikonak Köyü",
      "Görendoruk Köyü",
      "Kavakgölü Köyü",
      "Kohan Mah (çırpılı Köyü)",
      "Kuşdalı Köyü",
      "Okçular Köyü",
      "Oymakılıç Köyü",
      "Payamlı Köyü",
      "Şetrük Mah (payamlı Köyü)",
      "Tatlıpınar Mah (kuşdalı Köyü)",
      "Ufaca Köyü",
      "Ulaşlar Mah (ortaklı Köyü)",
      "Üzümlük Köyü",
      "Yanıkses Köyü",
      "Yanılmaz Köyü",
      "Yediyaprak Köyü",
      "Yeşilören Köyü"
    ],
    "Kurtalan": [
      "Bağlar Mah (kayabağlar Beldesi)",
      "Çeşme Mah (kayabağlar Beldesi)",
      "Kayalı Mah (kayabağlar Beldesi)",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Dicle Mah",
      "Fırat Mah",
      "Garzan Mah",
      "Güney Mah",
      "Kültür Mah",
      "Seyrantepe Mah",
      "Sümer Mah",
      "Tekel Mah",
      "Yayıkdere Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Ağaçlıpınar Köyü",
      "Akbulut Mah (tulumtaş Köyü)",
      "Akçagedik Köyü",
      "Akçalı Köyü",
      "Akdem Köyü",
      "Akdoğan Mah (akdem Köyü)",
      "Aksöğüt Köyü",
      "Aktepe Mah (aksöğüt Köyü)",
      "Aşağı Bişer Mah (üçpınar Köyü)",
      "Aşağı Dibekli Mah (bağlıca Köyü)",
      "Atalay Köyü",
      "Avcılar Köyü",
      "Aydemir Köyü",
      "Aydıncık Mah (tütün Köyü)",
      "Azıklı Köyü",
      "Bağlıca Köyü",
      "Bahçeli Mah (saipbeyli Köyü)",
      "Balıklı Mah (çeltikbaşı Köyü)",
      "Ballıkaya Köyü",
      "Beşler Köyü",
      "Beykent Köyü",
      "Birke Mah (gürgöze Köyü)",
      "Bozdoğan Mah (yuvalı Köyü)",
      "Bozhüyük Köyü",
      "Bölüktepe Köyü",
      "Çakıllı Köyü",
      "Çalıdüzü Köyü",
      "Çattepe Köyü",
      "Çay Mah (tütün Köyü)",
      "Çayırlı Köyü",
      "Çeltikbaşı Köyü",
      "Çeşmeli Mah (bölüktepe Köyü)",
      "Çukurlu Mah (tulumtaş Köyü)",
      "Demirbaşı Mah (güzeldere Köyü)",
      "Demirkuyu Köyü",
      "Derince Köyü",
      "Doğanlı Mah (tosunbağı Köyü)",
      "Ekinli Köyü",
      "Erdurağı Köyü",
      "Ergüven Mah (çeltikbaşı Köyü)",
      "Evciler Mah (tulumtaş Köyü)",
      "Gökdoğan Köyü",
      "Göztepe Mah (saipbeyli Köyü)",
      "Gültepe Mah (erdurağı Köyü)",
      "Gültepe Mah (kılıçlı Köyü)",
      "Gümüşsuyu Mah (uluköy Köyü)",
      "Gürgöze Köyü",
      "Güzeldere Köyü",
      "Huzur Mah (gözpınar Köyü)",
      "İğdeli Köyü",
      "İncirlik Köyü",
      "Kanikarvana Mah (kılıçlı Köyü)",
      "Kapıkaya Köyü",
      "Karabağ Köyü",
      "Kargılı Mah (üçpınar Köyü)",
      "Kayalısu Köyü",
      "Kaynaklı Mah (erdurağı Köyü)",
      "Kılıçlı Köyü",
      "Kısmet Mah (gözpınar Köyü)",
      "Konakpınar Köyü",
      "Kuyucuk Mah (gürgöze Köyü)",
      "Kuyulu Mah (şenköy Köyü)",
      "Mağaralı Mah (yürekveren Köyü)",
      "Pınarlı Mah (bölüktepe Köyü)",
      "Saipbeyli Köyü",
      "Seyrantepe Mah (gözpınar Köyü)",
      "Sıcaksu Mah (erdurağı Köyü)",
      "Soğuksu Mah (yuvalı Köyü)",
      "Şenköy Köyü",
      "Taşoluk Köyü",
      "Tatlı Köyü",
      "Tepecik Mah (tütün Köyü)",
      "Teylan Köyü",
      "Tosunbağı Köyü",
      "Toytepe Köyü",
      "Tulumtaş Köyü",
      "Tuzla Mah (toytepe Köyü)",
      "Tütün Köyü",
      "Uluağaç Mah (kılıçlı Köyü)",
      "Uluköy Köyü",
      "Üçpınar Köyü",
      "Y.dibekli Mah (bağlıca Köyü)",
      "Yakıttepe Köyü",
      "Yanarsu Köyü",
      "Yapılar Mah (tütün Köyü)",
      "Yayıklı Köyü",
      "Yazılı Mah (iğdeli Köyü)",
      "Yellice Köyü",
      "Yeniköprü Köyü",
      "Yeniköy Mah (şenköy Köyü)",
      "Yeşilkonak Köyü",
      "Yolboyu Mah (incirlik Köyü)",
      "Yoldurağı Köyü",
      "Yunuslar Mah (gökdoğan Köyü)",
      "Yuvalı Köyü",
      "Yuvalı Mah (ballıkaya Köyü)",
      "Yuvalı Mah (gökdoğan Köyü)",
      "Yürekveren Köyü"
    ],
    "Merkez": [
      "Bağlar Mah (gökçebağ Beldesi)",
      "Koçpınar Mah (gökçebağ Beldesi)",
      "Yeni Mah (gökçebağ Beldesi)",
      "Akarsu Mah (demirkaya Köyü)",
      "Akdoğmuş Köyü",
      "Akıncılar Mah (pınarca Köyü)",
      "Aktaş Köyü",
      "Akyamaç Köyü",
      "Aydoğan Mah (inkapı Köyü)",
      "Bağlıca Köyü",
      "Bakırt Mah (aktaş Köyü)",
      "Bayraktepe Köyü",
      "Beşyol Köyü",
      "Bostancık Köyü",
      "Çağbaşı Köyü",
      "Çevre Mah (tuzkuyusu Köyü)",
      "Çiçekli Mah (konacık Köyü)",
      "Demirkapı Mah (konacık Köyü)",
      "Doluharman Köyü",
      "Düzlüce Mah (aktaş Köyü)",
      "Eğlence Köyü",
      "Ekinli Mah (tuzkuyusu Köyü)",
      "Ekmekçiler Köyü",
      "Erdoğdu Mah (kemerli Köyü)",
      "İnkapı Köyü",
      "Kalender Köyü",
      "Karakuyu Mah (sarıtepe Köyü)",
      "Kavaközü Köyü",
      "Kayaboğaz Köyü",
      "Kayacık Mah (sarıtepe Köyü)",
      "Kemerli Köyü",
      "Kışlacık Köyü",
      "Koçlu Köyü",
      "Konacık Köyü",
      "Konaklı Mah (aktaş Köyü)",
      "Köprübaşı Köyü",
      "Kutluca Mah (inkapı Köyü)",
      "Meşelidere Köyü",
      "Meydandere Köyü",
      "Oğulcak Mah (yağmurtepe Köyü)",
      "Organize Sanayi Bölgesi Mah (doluharman Köyü)",
      "Ormanardı Köyü",
      "Pınarca Köyü",
      "Pınarova Köyü",
      "Sağırsu Köyü",
      "Sağlarca Köyü",
      "Sarıtepe Köyü",
      "Söğüt Mah (köprübaşı Köyü)",
      "Sütlüce Mah (kışlacık Köyü)",
      "Taraklı Mah (sarıtepe Köyü)",
      "Tepe Mah (tuzkuyusu Köyü)",
      "Tuzkuyusu Köyü",
      "Yağmurtepe Köyü",
      "Yazlıca Köyü",
      "Yerlibahçe Köyü",
      "Yığınlı Mah (yokuşbağları Köyü)",
      "Yokuşbağları Köyü",
      "Yolbuldu Mah (inkapı Köyü)",
      "Yurt Mah (tuzkuyusu Köyü)",
      "Yüklüce Mah (yağmurtepe Köyü)",
      "Zorkaya Köyü",
      "Afetevleri Mah",
      "Alan Mah",
      "Algül Mah",
      "Bahçelievler Mah",
      "Barış Mah",
      "Batı Mah",
      "Conkbayır Mah",
      "Çal Mah",
      "Doğan Mah",
      "Dumlupınar Mah",
      "Halenze Mah",
      "İnönü Mah",
      "Karakol Mah",
      "Kooperatif Mah",
      "Sakarya Mah",
      "Tınaztepe Mah",
      "Ulus Mah",
      "Ülkü Mah",
      "Veysel Karani Mah",
      "Yeni Mah"
    ],
    "Pervari": [
      "Gazi Mah (beğendik Beldesi)",
      "Kale Mah (beğendik Beldesi)",
      "Aşağıayvalıbağ Mah (ayvalıbağ Köyü)",
      "Aşağıbalcılar Köyü",
      "Ayvalıbağ Köyü",
      "Belenoluk Köyü",
      "Bentköy Köyü",
      "Berkevir Mah (karşıkaya Köyü)",
      "Beşan Mah (tuzcular Köyü)",
      "Çatköy Köyü",
      "Çavuşlu Köyü",
      "Çobanören Köyü",
      "Çukurköy Köyü",
      "Doğanca Köyü",
      "Doğanköy Köyü",
      "Dolusalkım Köyü",
      "Düğüncüler Köyü",
      "Ekindüzü Köyü",
      "Erkent Köyü",
      "Gökbel Mah (gökçekoru Köyü)",
      "Gökbudak Köyü",
      "Gökçekoru Köyü",
      "Gölgeli Köyü",
      "Gölköy Mah (gökçekoru Köyü)",
      "Gözlükuyu Mah (karşıkaya Köyü)",
      "Gözlükuyu Mah (yapraktepe Köyü)",
      "Güleçler Köyü",
      "Gümüşören Köyü",
      "Güzelbağ Mah (yapraktepe Köyü)",
      "Karadayı Mah (sarıyaprak Köyü)",
      "Karamik Mah (doğanköy Köyü)",
      "Karasungur Köyü",
      "Karşıkaya  Mah (köy Merkezi Mah) (karşıkaya Köyü)",
      "Keskin Köyü",
      "Kışlacık Köyü",
      "Kiverik Mah (köprüçay Köyü)",
      "Kocaçavuş Köyü",
      "Köprüçay Köyü",
      "Kubik Mah (gökçekoru Köyü)",
      "Narsuyu Köyü",
      "Nurs Mah (dolusalkım Köyü)",
      "Ormancık Mah (düğüncüler Köyü)",
      "Ormandalı Köyü",
      "Palamutlu Köyü",
      "Pınarbaşı Mah (güleçler Köyü)",
      "Sarı Çıçek Mah (gümüşören Köyü)",
      "Sarıdam Köyü",
      "Sarıyaprak Köyü",
      "Sığırlı Mah (doğanca Köyü)",
      "Sığırlı Mah (erkent Köyü)",
      "Söğütönü Köyü",
      "Sökmen Mah (sarıdam Köyü)",
      "Taşdibek Köyü",
      "Tosuntarla Köyü",
      "Tuzcular Köyü",
      "Ulupınar Mah (gümüşören Köyü)",
      "Umurlu Mah (palamutlu Köyü)",
      "Üçoyuk Köyü",
      "Yapraktepe Köyü",
      "Yazıcık Mah (palamutlu Köyü)",
      "Yeniaydın Köyü",
      "Yukarıayvalıbağ Mah (ayvalıbağ Köyü)",
      "Yukarıbalcılar Köyü",
      "Yukarıekindüzü Mah (ekindüzü Köyü)",
      "Aydın Mah",
      "Şakiran Mah"
    ],
    "Şirvan": [
      "Aktaş Mah (yamaçlı Köyü)",
      "Ayn Kebir Mah (kesmetaş Köyü)",
      "Bindal Mah (kesmetaş Köyü)",
      "Bistan Mah (kesmetaş Köyü)",
      "Bombat Mah (cevizlik Köyü)",
      "Cevizlik Mah (cevizlik Köyü)",
      "Elmadalı Köyü",
      "Evsel Mah (cevizlik Köyü)",
      "Halenze Mah (yamaçlı Köyü)",
      "Hatti Mah (cevizlik Köyü)",
      "Hıdran Mah (cevizlik Köyü)",
      "Kale Mah (kesmetaş Köyü)",
      "Kayahisar Köyü",
      "Kayalı Mah (kayahisar Köyü)",
      "Kesmetaş Köyü",
      "Merkez Mah (kayahisar Köyü)",
      "Oya Köyü",
      "Yamaçlı Köyü",
      "Akçayar Köyü",
      "Akgeçit Köyü",
      "Akyokuş Köyü",
      "Atmaca Mah (nallıkaya Köyü)",
      "Ayranlı Mah (boylu Köyü)",
      "Bayındır Köyü",
      "Boylu Köyü",
      "Cüm Mah (akgeçit Köyü)",
      "Çayağzı Mah (ikizler Köyü)",
      "Çeltikyolu Köyü",
      "Çöğürlü Mah (ormanlı Köyü)",
      "Damlı Mah (damlı Köyü)",
      "Demirkapı Köyü",
      "Derinçay Köyü",
      "Dilecik Mah (derinçay Köyü)",
      "Gözlüce Köyü",
      "Hörgüç Mah (boylu Köyü)",
      "Hürmüz Köyü",
      "İkizler Köyü",
      "Karaca Köyü",
      "Karayel Mah (boylu Köyü)",
      "Kasımlı Köyü",
      "Kirazlı Köyü",
      "Kömürlü Köyü",
      "Kumlu Mah (boylu Köyü)",
      "Madenköy Köyü",
      "Merkez Mah (incekaya Köyü)",
      "Merkez Mah (soğanlı Köyü)",
      "Merkez Mah (taşlı Köyü)",
      "Meşecik Köyü",
      "Nallıkaya Köyü",
      "Nergizli Mah (ikizler Köyü)",
      "Ormanbağı Köyü",
      "Ormanlı Köyü",
      "Otluk Köyü",
      "Ördekli Mah (taşlı Köyü)",
      "Sivrikavak Mah (kasımlı Köyü)",
      "Söbetaş Mah (taşlı Köyü)",
      "Suludere Köyü",
      "Suluyazı Köyü",
      "Taşyaka Köyü",
      "Tatlıpayam Köyü",
      "Turgutlu Mah (nallıkaya Köyü)",
      "Tüylüce Mah (nallıkaya Köyü)",
      "Yarımtepe Köyü",
      "Yatağan Mah (taşlı Köyü)",
      "Yelken Mah (kömürlü Köyü)",
      "Yok  Mah (kale Mah) (incekaya Köyü)",
      "Yok Mah (köşk Mah) (incekaya Köyü)",
      "Yok Mah (orta Mah) (incekaya Köyü)",
      "Zinihari Mah (incekaya Köyü)",
      "Adıgüzel Köyü",
      "Asmalıdere Mah (yağcılar Köyü)",
      "Başçavuş Mah (yedikapı Köyü)",
      "Belençay Köyü",
      "Çınarlı Köyü",
      "Daltepe Köyü",
      "Derecik Mah (belençay Köyü)",
      "Dişlinar Köyü",
      "Doğruca Köyü",
      "Gümüş Köyü",
      "Hilki Mah (yağcılar Köyü)",
      "İnecik Mah (belençay Köyü)",
      "Kalkancık Köyü",
      "Kapılı Mah (kapılı Köyü)",
      "Kısraklı Mah (pirinçli Köyü)",
      "Merkez Mah (durankaya Köyü)",
      "Merkez Mah (pirinçli Köyü)",
      "Mülki Mah (yağcılar Köyü)",
      "Özpınar Köyü",
      "Sarıdana Köyü",
      "Serinpınar Mah (pirinçli Köyü)",
      "Serinpınar Mah (yaylacı Köyü)",
      "Sevincik Mah (durankaya Köyü)",
      "Sevindik Mah (durankaya Köyü)",
      "Sırçalı Köyü",
      "Soğuksu Köyü",
      "Ümranlı Mah (yedikapı Köyü)",
      "Yağcılar Köyü",
      "Yalkaya Köyü",
      "Yaylacı Köyü",
      "Yayladağ Köyü",
      "Yedikapı Köyü",
      "Yolbaşı Köyü",
      "Bağcılar Mah",
      "Fatih Mah",
      "Kırtepe Mah",
      "Küfre Mah",
      "Sit Mah"
    ],
    "Tillo": [
      "Fakirullah Mah",
      "Mücahit Mah",
      "Saydanlar Mah",
      "Akyayla Köyü",
      "Aynsuç Mah (fersaf Köyü)",
      "Erenler Mah (hatrant Köyü)",
      "Fersaf Köyü",
      "Hatrant Köyü",
      "İkizbağlar Köyü",
      "Kargacık Mah (akyayla Köyü)",
      "Kurşun Mah (hatrant Köyü)",
      "Sinep Köyü",
      "Taşbalta Köyü"
    ]
  },
  "Sinop": {
    "Ayancık": [
      "Beşiktaş Mah",
      "Cevizli Mah",
      "Çayiçi Mah",
      "Denizciler Mah",
      "Yalı Mah",
      "Abazalar Mah (yenice Köyü)",
      "Abdullahoğlu Mah (kozcuğaz Köyü)",
      "Akbıyık Mah (yenice Köyü)",
      "Akpınar Mah (yenigüler Köyü)",
      "Aksu Mah (bakırlı Köyü)",
      "Aksu Mah (kozsökü Köyü)",
      "Aktaş Mah (mestan Köyü)",
      "Alayürek Mah (hacıoğlu Köyü)",
      "Ali Geyşi Mah (doğanlı Köyü)",
      "Alideğirmen Mah (hacılı Köyü)",
      "Armutça Mah (dibekli Köyü)",
      "Aşağı Işığan Mah (hatip Köyü)",
      "Aşağı Mah (armutluyazı Köyü)",
      "Aşağıköy Mah (kaldırayak Köyü)",
      "Aşağıtarakçı Mah (tarakçı Köyü)",
      "Atbaşı Mah (göldağı Köyü)",
      "Avdıçlı Mah (tevfikiye Köyü)",
      "Ayıp Mah (babaçay Köyü)",
      "Bağma Mah (büyükdüz Köyü)",
      "Bakla Mah (tevfikiye Köyü)",
      "Balca Mah (bakırlı Köyü)",
      "Balçukuru Mah (hatip Köyü)",
      "Baloğlu Mah (hacılı Köyü)",
      "Başgelik Mah (karakestane Köyü)",
      "Bekiroğlu Mah (kozcuğaz Köyü)",
      "Berigüney Mah (aygördü Köyü)",
      "Bestile Mah (dereköy Köyü)",
      "Beşpınar Mah (çamyayla Köyü)",
      "Bıçakçı Mah (hacılı Köyü)",
      "Bıdaklar Mah (kaldırayak Köyü)",
      "Bozat Mah (hacılı Köyü)",
      "Börkücek Mah (akören Köyü)",
      "Büyük Çukir Mah (kurtköy Köyü)",
      "Büyükdüz Mah (babaköy Köyü)",
      "Büyükpınar Mah (büyükpınar Köyü)",
      "Cebeli Mah (davutlu Köyü)",
      "Ceni Mah (hacıoğlu Köyü)",
      "Cevizli Mah (söküçayırı Köyü)",
      "Cimbiloğlu Mah (tevfikiye Köyü)",
      "Civreyil Mah (bakırlızaviye Köyü)",
      "Ciyer Mah (mustafakemalpaşa Köyü)",
      "Cöcü Mah (kaldırayak Köyü)",
      "Curoğlu Mah (dibekli Köyü)",
      "Çalı Mah (türkmen Köyü)",
      "Çamcuğaz Mah (bakırlızaviye Köyü)",
      "Çamcuvaz Mah (hacılı Köyü)",
      "Çangal Mah (erikli Köyü)",
      "Çay Mah (çamyayla Köyü)",
      "Çay Mah (zaviye Köyü)",
      "Çayır Mah (söküçayırı Köyü)",
      "Çayır Mah (yenice Köyü)",
      "Çayiçi Mah (kurtköy Köyü)",
      "Çayiçi Mah (topağaç Köyü)",
      "Çıtak Mah (yemişen Köyü)",
      "Çukur Mah (erikli Köyü)",
      "Çukur Mah (hüseyinbey Köyü)",
      "Dağ Mah (mestan Köyü)",
      "Dalıp Mah (akören Köyü)",
      "Dalmancu Mah (sulusökü Köyü)",
      "Davut Merkez Mah (davutlu Köyü)",
      "Davutoğlu Mah (kozcuğaz Köyü)",
      "Demirci Mah (gölköy Köyü)",
      "Dere Köy Mah (çaybaşı Köyü)",
      "Dere Mah (belpınar Köyü)",
      "Devrent Mah (bahçeli Köyü)",
      "Dibekli Mah (dibekli Köyü)",
      "Dogalaşa Mah (akören Köyü)",
      "Doğacı Mah (aygördü Köyü)",
      "Dolamay Mah (ortalık Köyü)",
      "Dolayısökü Mah (mustafakemalpaşa Köyü)",
      "Dugarsökü Mah (bakırlı Köyü)",
      "Duraklı Mah (uzunçam Köyü)",
      "Düdüklük Mah (erdemli Köyü)",
      "Ebce Mah (çaybaşı Köyü)",
      "Ecek Mah (gürsökü Köyü)",
      "Ecek Mah (kurtköy Köyü)",
      "Eğrigöz Mah (maden Köyü)",
      "Elemin Mah (bakırlı Köyü)",
      "Eleminbaşı Mah (hatip Köyü)",
      "Ellez Mah (kurtköy Köyü)",
      "Ese Mah (hacıoğlu Köyü)",
      "Fasıllık Mah (kaldırayak Köyü)",
      "Fırıncık Mah (babaçay Köyü)",
      "Fidan Mah (hüseyinbey Köyü)",
      "Fiye Mah (dedeağaç Köyü)",
      "Furunçukuru Mah (zaviye Köyü)",
      "Gebelit Mah (tarakçı Köyü)",
      "Gelecek Mah (babaköy Köyü)",
      "Gemre Mah (akçakese Köyü)",
      "Genze Mah (dereköy Köyü)",
      "Gerdan Mah (mustafakemalpaşa Köyü)",
      "Gödenoğlu Mah (kozcuğaz Köyü)",
      "Güney Mah (belpınar Köyü)",
      "Güney Mah (söküçayırı Köyü)",
      "Güneyci Mah (uzunçam Köyü)",
      "Gürpınar Köyü",
      "Güzeren Mah (göldağı Köyü)",
      "Hacı Köyü Mah (çaybaşı Köyü)",
      "Hacı Mah (erdemli Köyü)",
      "Hacıbaka Mah (karakestane Köyü)",
      "Hacıoğlu Mah (bakırlı Köyü)",
      "Hacıoğlu Mah (yenice Köyü)",
      "Hamdi Mah (sofu Köyü)",
      "Hamzaçay Mah (inaltı Köyü)",
      "Harmanlar Mah (doğanlı Köyü)",
      "Harzana Mah (ağaçlı Köyü)",
      "Hasançe Mah (belpınar Köyü)",
      "Hatlı Mah (babaçay Köyü)",
      "Hebir Mah (türkmen Köyü)",
      "Hoca Yakası Mah (köseyakası Köyü)",
      "Hökol Oğlu Mah (çaybaşı Köyü)",
      "Hulu Mah (ünlüce Köyü)",
      "Hümer Mah (doğanlı Köyü)",
      "Hüseyin Usta Mah (gürsökü Köyü)",
      "Işıklar Mah (gürsökü Köyü)",
      "İklama Mah (dolay Köyü)",
      "İmamoğlu Mah (gürsökü Köyü)",
      "İnaltı Mah (inaltı Köyü)",
      "İnaltı Orman Mah (bakırlı Köyü)",
      "Kacak Mah (göldağı Köyü)",
      "Kadir Mah (abdülkadirköy Köyü)",
      "Kalaba Mah (tepecik Köyü)",
      "Kalender Mah (türkmen Köyü)",
      "Kapandibi Mah (ömerdüz Köyü)",
      "Kapı Mah (sofu Köyü)",
      "Karacaağaç Mezikgüney Mah (davutlu Köyü)",
      "Karaculha Mah (davutlu Köyü)",
      "Karancı Mah (dibekli Köyü)",
      "Karataş Mah (dibekli Köyü)",
      "Karşılüvep Mah (davutlu Köyü)",
      "Kaş Üstü Mah (kestanelik Köyü)",
      "Kayım Mah (kozsökü Köyü)",
      "Kepez Mah (çaybaşı Köyü)",
      "Kesecik Mah (babaçay Köyü)",
      "Kestaneyanı Mah (uzunçam Köyü)",
      "Keş Mah (kütükköy Köyü)",
      "Kıran Mah (abdülkadirköy Köyü)",
      "Kıran Mah (dereköy Köyü)",
      "Kıran Mah (mestan Köyü)",
      "Kıranardı Mah (inaltı Köyü)",
      "Kırındı Mah (babaçay Köyü)",
      "Kıvan Mah (tevfikiye Köyü)",
      "Kızılcaelma Mah (babaköy Köyü)",
      "Kızılcaelma Mah (büyükpınar Köyü)",
      "Kızılcakaya Köyü",
      "Kızılot Mah (tarakçı Köyü)",
      "Kibaroğlu Mah (babaçay Köyü)",
      "Koçvaz Mah (pazarcık Köyü)",
      "Kolca Mah (dibekli Köyü)",
      "Koloğlu Mah (kozcuğaz Köyü)",
      "Konak Mah (hacılı Köyü)",
      "Kovanlık Mah (akören Köyü)",
      "Köklen Mah (inaltı Köyü)",
      "Köprübaşı Mah (uzunçam Köyü)",
      "Köse Mah (kaldırayak Köyü)",
      "Köseler Mah (otmanlı Köyü)",
      "Köycüğez Mah (karakestane Köyü)",
      "Köyyeri Mah (bakırlı Köyü)",
      "Kumanı Mah (köseyakası Köyü)",
      "Kumluk Mah (gürsökü Köyü)",
      "Kuşlar Mah (karapınar Köyü)",
      "Kuz Mah (çaybaşı Köyü)",
      "Kuzdağı Mah (bakırlızaviye Köyü)",
      "Kuzguncuk Mah (davutlu Köyü)",
      "Kuzluk Mah (tarakçı Köyü)",
      "Küçük Çokir Mah (kurtköy Köyü)",
      "Küçüklefken Mah (çamyayla Köyü)",
      "Kürt Düzü Aşağı Mah (çaylıoğlu Köyü)",
      "Kürt Düzü Yukarı Mah (çaylıoğlu Köyü)",
      "Kürükoğlu Mah (hacılı Köyü)",
      "Lazlar Mah (yenice Köyü)",
      "Maden Mah (belpınar Köyü)",
      "Makas Mah (babaçay Köyü)",
      "Malı Mah (dolay Köyü)",
      "Mazi Mah (gürsökü Köyü)",
      "Merkez Aşağı Mah (karakestane Köyü)",
      "Merkez Mah (ağaçlı Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (akören Köyü)",
      "Merkez Mah (aliköy Köyü)",
      "Merkez Mah (armutluyazı Köyü)",
      "Merkez Mah (aşağıköy Köyü)",
      "Merkez Mah (avdullu Köyü)",
      "Merkez Mah (aygördü Köyü)",
      "Merkez Mah (babaköy Köyü)",
      "Merkez Mah (bahçeli Köyü)",
      "Merkez Mah (bakırlı Köyü)",
      "Merkez Mah (bakırlızaviye Köyü)",
      "Merkez Mah (büyükdüz Köyü)",
      "Merkez Mah (çaylıoğlu Köyü)",
      "Merkez Mah (dedeağaç Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (erdemli Köyü)",
      "Merkez Mah (erikli Köyü)",
      "Merkez Mah (fındıklı Köyü)",
      "Merkez Mah (göldağı Köyü)",
      "Merkez Mah (gölköy Köyü)",
      "Merkez Mah (gürsökü Köyü)",
      "Merkez Mah (hatip Köyü)",
      "Merkez Mah (karapınar Köyü)",
      "Merkez Mah (kestanelik Köyü)",
      "Merkez Mah (kozsökü Köyü)",
      "Merkez Mah (köseyakası Köyü)",
      "Merkez Mah (kurtköy Köyü)",
      "Merkez Mah (kütükköy Köyü)",
      "Merkez Mah (mestan Köyü)",
      "Merkez Mah (mustafakemalpaşa Köyü)",
      "Merkez Mah (ortalık Köyü)",
      "Merkez Mah (otmanlı Köyü)",
      "Merkez Mah (ömerdüz Köyü)",
      "Merkez Mah (pazarcık Köyü)",
      "Merkez Mah (sofu Köyü)",
      "Merkez Mah (tepecik Köyü)",
      "Merkez Mah (türkmen Köyü)",
      "Merkez Mah (uzunçam Köyü)",
      "Merkez Mah (ünlüce Köyü)",
      "Merkez Mah (yarenler Köyü)",
      "Merkez Mah (yemişen Köyü)",
      "Merkez Mah (yenigüler Köyü)",
      "Merkez Yukarı Mah (karakestane Köyü)",
      "Modu Mah (topağaç Köyü)",
      "Mudan Mah (maden Köyü)",
      "Nolut Mah (topağaç Köyü)",
      "Obruk Mah (hacılı Köyü)",
      "Ocuk Mah (söküçayırı Köyü)",
      "Okçular Mah (zaviye Köyü)",
      "Olucak Mah (kozsökü Köyü)",
      "Omuryeri Mah (erikli Köyü)",
      "Onortak Mah (büyükdüz Köyü)",
      "Orta 1 Mah (sulusökü Köyü)",
      "Orta 2 Mah (sulusökü Köyü)",
      "Orta Mah (doğanlı Köyü)",
      "Otmanlı Mah (otmanlı Köyü)",
      "Ödür Mah (sofu Köyü)",
      "Ömer Mah (sofu Köyü)",
      "Örense Mah (pazarcık Köyü)",
      "Ötegüney Mah (aygördü Köyü)",
      "Pazar Yeri Mah (dedeağaç Köyü)",
      "Pazarcık Mah (pazarcık Köyü)",
      "Pelitcik Mah (yarenler Köyü)",
      "Pınarı Mah (tepecik Köyü)",
      "Pir Mah (akçakese Köyü)",
      "Sağ Mah (avdullu Köyü)",
      "Sansar Mah (büyükpınar Köyü)",
      "Saraycık Mah (davutlu Köyü)",
      "Sarnıç Mah (babaçay Köyü)",
      "Sarp Mah (ortalık Köyü)",
      "Sekecek Mah (kozcuğaz Köyü)",
      "Sekicek Mah (bakırlı Köyü)",
      "Serçebacak Mah (belpınar Köyü)",
      "Sevinç Mah (çaybaşı Köyü)",
      "Sırcalı Mah (kozsökü Köyü)",
      "Sofu Mah (karapınar Köyü)",
      "Soğucaksu Mah (maden Köyü)",
      "Sökü Mah (söküçayırı Köyü)",
      "Sökübele Mah (çamyayla Köyü)",
      "Susan Mah (yarenler Köyü)",
      "Süleymanpınarı Mah (tarakçı Köyü)",
      "Süngür Mah (bakırlı Köyü)",
      "Şabanoğlu Mah (armutluyazı Köyü)",
      "Şalı Mah (yemişen Köyü)",
      "Şerbetçi Mah (ağaçlı Köyü)",
      "Şeyhköy Mah (türkmen Köyü)",
      "Şıh Mah (sulusökü Köyü)",
      "Şıhlar Mah (erikli Köyü)",
      "Şıhlar Mah (gölköy Köyü)",
      "Tanışman Mah (pazarcık Köyü)",
      "Tarakçı Mah (tarakçı Köyü)",
      "Taşdibek Mah (kütükköy Köyü)",
      "Taşman Mah (avdullu Köyü)",
      "Tatarcık Mah (tevfikiye Köyü)",
      "Tekfur Mah (hacıoğlu Köyü)",
      "Tekke Mah (zaviye Köyü)",
      "Tenetür Mah (topağaç Köyü)",
      "Tepecik Mah (topağaç Köyü)",
      "Terze Mah (hüseyinbey Köyü)",
      "Tıglıoğlu Mah (söküçayırı Köyü)",
      "Tığna Mah (hacılı Köyü)",
      "Torma Oğlu Mah (hacılı Köyü)",
      "Tünek Mah (davutlu Köyü)",
      "Türkköy Mah (hacılı Köyü)",
      "Ulaş Mah (dedeağaç Köyü)",
      "Urgangeriş Mah (armutluyazı Köyü)",
      "Uzunağa Mah (tarakçı Köyü)",
      "Velet Mah (gölköy Köyü)",
      "Yalı Mah (çaylıoğlu Köyü)",
      "Yalı Mah (ünlüce Köyü)",
      "Yavı Mah (kozsökü Köyü)",
      "Yaylayanı Mah (dibekli Köyü)",
      "Yemişli Mah (büyükpınar Köyü)",
      "Yemişli Orman İşletme Mah (büyükpınar Köyü)",
      "Yenicealtı Mah (karakestane Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Işığan Mah (hatip Köyü)",
      "Yukarı Kuzdağı Mah (bakırlızaviye Köyü)",
      "Yukarı Mah (armutluyazı Köyü)",
      "Yukarı Mah (aşağıköy Köyü)",
      "Yukarı Mah (dolay Köyü)",
      "Yukarı Mah (kestanelik Köyü)",
      "Yukarı Mah (söküçayırı Köyü)",
      "Yukarı Mah (sulusökü Köyü)",
      "Yukarıköy Mah (kaldırayak Köyü)",
      "Yunus Mah (abdülkadirköy Köyü)",
      "Zindan Mah (davutlu Köyü)"
    ],
    "Boyabat": [
      "Camiikebir Mah",
      "Çamlıca Mah",
      "Esentepe Mah",
      "Gökdere Mah",
      "Kumluk Mah",
      "Yeni Mah",
      "Yıldız Mah",
      "Zincirlikuyu Mah",
      "Acamlar Mah (curkuşlar Köyü)",
      "Adnan Menderes  Mah (daylı Köyü)",
      "Ahlatlı Yaylası Mah (şıhlar Köyü)",
      "Akkaya Mah (akçakese Köyü)",
      "Alaman Merkez Mah (yeniköy Köyü)",
      "Alıçatı Mah (düzkaraağaç Köyü)",
      "Ali Yazıcı Mah (ardıç Köyü)",
      "Aluccuk Mah (curkuşlar Köyü)",
      "Aluç Mah (akçakese Köyü)",
      "Aluç Mah (akyürük Köyü)",
      "Aluç Mah (karamusalı Köyü)",
      "Anayurt Mah (göve Köyü)",
      "Asar Mah (kozkule Köyü)",
      "Asar Yaylası Mah (binerli Köyü)",
      "Aşağı Mah (dodurga Köyü)",
      "Aşağı Mah (paşalıoğlu Köyü)",
      "Aşağıköprücek Mah (köprücek Köyü)",
      "Aşağıseyricek Köyü",
      "Avlouç Mah (edil Köyü)",
      "Avlu Mah (gökçukur Köyü)",
      "Avuca Mah (gökçukur Köyü)",
      "Avzarağı Mah (dağtabaklı Köyü)",
      "Aydınlı Mah (çukurhan Köyü)",
      "Aydınlı Mah (ekinören Köyü)",
      "Ayı Kayası Mah (paşalıoğlu Köyü)",
      "Bağlarbaşı Mah (sarıağaççayı Köyü)",
      "Balcıoğlu Mah (günpınar Köyü)",
      "Balıca Mah (kavacık Köyü)",
      "Balıca Mah (köprücek Köyü)",
      "Başkesen Mah (kozanlı Köyü)",
      "Bekirli Mah (taşhanlı Köyü)",
      "Bektaş Köyü",
      "Bengübelen Köyü",
      "Benişli Köyü",
      "Beşevler Mah (alibeyli Köyü)",
      "Beyazıt Mah (salar Köyü)",
      "Beyzade Mah (yeşilyurt Köyü)",
      "Bıçakçılı Mah (emiroğlu Köyü)",
      "Bozyazı Mah (uzunçay Köyü)",
      "Bölüklü Köyü",
      "Börüklü Mah (arıoğlu Köyü)",
      "Bürnük Mah (akçakese Köyü)",
      "Büyük Karasaklı Mah (muratlı Köyü)",
      "Büyükkaraağaç Köyü",
      "Caba Mah (gökçeağaçsakızı Köyü)",
      "Camili Mah (isaoğlu Köyü)",
      "Camili Mah (kovaçayır Köyü)",
      "Cedimoğlu Mah (çeşnigir Köyü)",
      "Cemalettinköy Köyü",
      "Cepmi Mah (yaylacık Köyü)",
      "Cepmi Yaylası Mah (yaylacık Köyü)",
      "Cıkcıklı Mah (çeşnigir Köyü)",
      "Çakıllı Yay Mah (çattepe Köyü)",
      "Çal Mah (dodurga Köyü)",
      "Çal Mah (doğuca Köyü)",
      "Çal Mah (salar Köyü)",
      "Çalış Mah (günpınar Köyü)",
      "Çalışkan Mah (alibeyli Köyü)",
      "Çamlıca Mah (akçakese Köyü)",
      "Çamlıca Mah (kayaboğazı Köyü)",
      "Çamlık Mah (ardıç Köyü)",
      "Çardakpınarı Yay Mah (çattepe Köyü)",
      "Çayır Mah (kozkule Köyü)",
      "Çekiç Köy Mah (kurusaray Köyü)",
      "Çekiç Mah (akyürük Köyü)",
      "Çene Mah (köprücek Köyü)",
      "Çerkezler Mah (marufalınca Köyü)",
      "Çorak Köyü",
      "Çökecik Mah (çulhalı Köyü)",
      "Dağ Mah (gökçukur Köyü)",
      "Daluoğlu Mah (paşalıoğlu Köyü)",
      "Damali Mah (bağlıca Köyü)",
      "Damlaca Mah (imamlı Köyü)",
      "Daylı Köyü",
      "Dedeli Mah (hamzalı Köyü)",
      "Dere Köy Mah (hamzalı Köyü)",
      "Dere Mah (bürüm Köyü)",
      "Dere Mah (çulhalı Köyü)",
      "Dereçatı Köyü",
      "Dinlenecek Mah (kılıçlı Köyü)",
      "Doğaçamyay Mah (çattepe Köyü)",
      "Doğanburnu Mah (çulhalı Köyü)",
      "Doğrul-yemişli Mah (doğuca Köyü)",
      "Dumanoğlu Mah (kozanlı Köyü)",
      "Durhacılı Mah (karamusalı Köyü)",
      "Durmelikli Yay Mah (çattepe Köyü)",
      "Dülükler Mah (yeşilyurt Köyü)",
      "Düzen Mah (uzunçay Köyü)",
      "Elekkozu Mah (esentepe Köyü)",
      "Elif Deresi Mah (uzunçay Köyü)",
      "Elmacık Mah (kartaloğlu Köyü)",
      "Elmacık Mah (osmanköy Köyü)",
      "Elmacuk Mah (darıözü Köyü)",
      "Emirli Yaylası Mah (kuyucakpınar Köyü)",
      "Erenler Mah (hamzalı Köyü)",
      "Evkul Mah (çeşnigir Köyü)",
      "Fahra Mah (gazideretabaklı Köyü)",
      "Fergülü Mah (karamusalı Köyü)",
      "Fındıcak Mah (doğrul Köyü)",
      "Fildanlar Mah (curkuşlar Köyü)",
      "Gencek Mah (çeşnigir Köyü)",
      "Gımız Mah (akçakese Köyü)",
      "Gökdere Mah (gökçukur Köyü)",
      "Göllü Mah (darıözü Köyü)",
      "Gövez Mah (boyalı Köyü)",
      "Gülbet Mah (mahmutlu Köyü)",
      "Güney Mah (çaybaşı Köyü)",
      "Gürgenağıl Mah (ekinören Köyü)",
      "Güzköy Mah (kılıçlı Köyü)",
      "Hacıbaba Mah (çarşak Köyü)",
      "Hacıbayram Mah (sarıağaççayı Köyü)",
      "Hacıyahya Mah (doğuca Köyü)",
      "Hatipoğlu Mah (çeşnigir Köyü)",
      "Helimoğlu Mah (günpınar Köyü)",
      "Hıbıyarlı Mah (isaoğlu Köyü)",
      "Hıdırlı Mah (kuyucakpınar Köyü)",
      "Himmetoğlu Mah (kozanlı Köyü)",
      "Hocalı Mah (emiroğlu Köyü)",
      "Hürremşah Mah (kavak Köyü)",
      "Ilıcaköy Köyü",
      "İmamlı Köyü",
      "İnebeyli Mah (çarşak Köyü)",
      "İspiroğlu Mah (koçak Köyü)",
      "Kabaelma Mah (düzkaraağaç Köyü)",
      "Kadılar Mah (esengazili Köyü)",
      "Karaburun Mah (akyürük Köyü)",
      "Karaçayır Mah (hamzalı Köyü)",
      "Karaçomak Mah (hamzalı Köyü)",
      "Karaçukur Mah (yeniköy Köyü)",
      "Karandu Mah (engilekin Köyü)",
      "Karaoluk Mah (akyürük Köyü)",
      "Karapürcek Mah (hacıahmetli Köyü)",
      "Karasokak Mah (isaoğlu Köyü)",
      "Karayaprak Mah (kartaloğlu Köyü)",
      "Karşı Mah (engilekin Köyü)",
      "Karşı Mah (tırnalı Köyü)",
      "Kartaloğlu Köyü",
      "Kaş Mah (göve Köyü)",
      "Kaşbaşı Mah (oğlakçılar Köyü)",
      "Kavak Çayırı Mah (uzunçay Köyü)",
      "Kaya Dibi Mah (uzunçay Köyü)",
      "Kayabaşı Mah (ardıç Köyü)",
      "Kayabaşı Mah (yeşilyurt Köyü)",
      "Kayadibi Mah (kılıçlı Köyü)",
      "Kayadibi Mah (sarıağaççayı Köyü)",
      "Kayaönü Mah (gökçeağaçsakızı Köyü)",
      "Kaymakcı Deresi Mah (uzunçay Köyü)",
      "Kaymaloğlu Mah (arıoğlu Köyü)",
      "Keklik Tepe Mah (sarıağaççayı Köyü)",
      "Kemaloğlu Mah (arıoğlu Köyü)",
      "Keseköyyaylası Mah (keseköy Köyü)",
      "Kıraç Mah (bürüm Köyü)",
      "Kıran Mah (bayamca Köyü)",
      "Kışla Mah (kurusaray Köyü)",
      "Kızıltepe Mah (çukurhan Köyü)",
      "Kızlar Kayası Mah (kozkule Köyü)",
      "Kızlarkayası Yaylası Mah (kozkule Köyü)",
      "Kirenlice Mah (ardıç Köyü)",
      "Kozkule Köyü",
      "Kozluca Mah (doğrul Köyü)",
      "Köprübaşı Mah (çatpınar Köyü)",
      "Kurtlu Köyü",
      "Kuyudibi Mah (günpınar Köyü)",
      "Kuzveren Köyü",
      "Küçük Mah (çaybaşı Köyü)",
      "Küçükkarasaklı Mah (muratlı Köyü)",
      "Manişler Mah (yeşilçam Köyü)",
      "Mantardüzü Yaylası Mah (binerli Köyü)",
      "Martlı Mah (ardıç Köyü)",
      "Martlı Mah (çaltu Köyü)",
      "Maruf Köyü",
      "Maşalı Mah (emiroğlu Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (akyürük Köyü)",
      "Merkez Mah (alibeyli Köyü)",
      "Merkez Mah (ardıç Köyü)",
      "Merkez Mah (arıoğlu Köyü)",
      "Merkez Mah (aşıklı Köyü)",
      "Merkez Mah (aydoğan Köyü)",
      "Merkez Mah (bağlıca Köyü)",
      "Merkez Mah (bayamca Köyü)",
      "Merkez Mah (binerli Köyü)",
      "Merkez Mah (boyalı Köyü)",
      "Merkez Mah (bürüm Köyü)",
      "Merkez Mah (curkuşlar Köyü)",
      "Merkez Mah (çaltu Köyü)",
      "Merkez Mah (çarşak Köyü)",
      "Merkez Mah (çatpınar Köyü)",
      "Merkez Mah (çattepe Köyü)",
      "Merkez Mah (çaybaşı Köyü)",
      "Merkez Mah (çeşnigir Köyü)",
      "Merkez Mah (çulhalı Köyü)",
      "Merkez Mah (dağtabaklı Köyü)",
      "Merkez Mah (darıözü Köyü)",
      "Merkez Mah (dodurga Köyü)",
      "Merkez Mah (doğrul Köyü)",
      "Merkez Mah (doğuca Köyü)",
      "Merkez Mah (düzkaraağaç Köyü)",
      "Merkez Mah (edil Köyü)",
      "Merkez Mah (eğlence Köyü)",
      "Merkez Mah (ekinören Köyü)",
      "Merkez Mah (emiroğlu Köyü)",
      "Merkez Mah (engilekin Köyü)",
      "Merkez Mah (erkeç Köyü)",
      "Merkez Mah (esengazili Köyü)",
      "Merkez Mah (esentepe Köyü)",
      "Merkez Mah (gazideresi Köyü)",
      "Merkez Mah (gazideretabaklı Köyü)",
      "Merkez Mah (gökçeağaçsakızı Köyü)",
      "Merkez Mah (göve Köyü)",
      "Merkez Mah (günpınar Köyü)",
      "Merkez Mah (hacıahmetli Köyü)",
      "Merkez Mah (hamzalı Köyü)",
      "Merkez Mah (isaoğlu Köyü)",
      "Merkez Mah (kadınlı Köyü)",
      "Merkez Mah (karacaören Köyü)",
      "Merkez Mah (karamusalı Köyü)",
      "Merkez Mah (kavacık Köyü)",
      "Merkez Mah (kavak Köyü)",
      "Merkez Mah (kayaboğazı Köyü)",
      "Merkez Mah (keseköy Köyü)",
      "Merkez Mah (kılıçlı Köyü)",
      "Merkez Mah (killik Köyü)",
      "Merkez Mah (koçak Köyü)",
      "Merkez Mah (kozanlı Köyü)",
      "Merkez Mah (köprücek Köyü)",
      "Merkez Mah (kurusaray Köyü)",
      "Merkez Mah (kuyucakpınar Köyü)",
      "Merkez Mah (mahmutlu Köyü)",
      "Merkez Mah (marufalınca Köyü)",
      "Merkez Mah (muratlı Köyü)",
      "Merkez Mah (oğlakçılar Köyü)",
      "Merkez Mah (osmanköy Köyü)",
      "Merkez Mah (ören Köyü)",
      "Merkez Mah (paşalıoğlu Köyü)",
      "Merkez Mah (salar Köyü)",
      "Merkez Mah (sarıyer Köyü)",
      "Merkez Mah (şıhlı Köyü)",
      "Merkez Mah (taşhanlı Köyü)",
      "Merkez Mah (tırnalı Köyü)",
      "Merkez Mah (uzunçay Köyü)",
      "Merkez Mah (yaylacık Köyü)",
      "Merkez Mah (yenicamili Köyü)",
      "Merkez Mah (yenikayalı Köyü)",
      "Merkez Mah (yeşilçam Köyü)",
      "Meytülü Mah (çattepe Köyü)",
      "Millibey Mah (sarıağaççayı Köyü)",
      "Mumunlu Mah (engilekin Köyü)",
      "Musa Mah (esentepe Köyü)",
      "Muşlu Mah (şıhlı Köyü)",
      "Obalı Mah (ardıç Köyü)",
      "Ogulkadın Mah (kavacık Köyü)",
      "Oğlakçı Yaylası Mah (oğlakçılar Köyü)",
      "Okçu Mah (oğlakçılar Köyü)",
      "Okçumehmetli Köyü",
      "Oluk Kıyı Mah (düzkaraağaç Köyü)",
      "Organize Sanayi Bölgesi Mah (maruf Köyü)",
      "Orta Mah (çukurhan Köyü)",
      "Orta Mah (kılıçlı Köyü)",
      "Osmanköy Kümeevler Mah (osmanköy Köyü)",
      "Ova Mah (çukurhan Köyü)",
      "Ova Mah (tırnalı Köyü)",
      "Ömerköy Köyü",
      "Ören Mah (çeşnigir Köyü)",
      "Pelitçik Mah (binerli Köyü)",
      "Percincik Mah (sarıyer Köyü)",
      "Pirefendideresi Köyü",
      "Sakız Mah (çatpınar Köyü)",
      "Sarıağaççayı Köyü",
      "Sarıağaççayı Mah (sarıağaççayı Köyü)",
      "Sefa Mah",
      "Seferoğlu Mah (kovaçayır Köyü)",
      "Seme Mah (kılıçlı Köyü)",
      "Sökü Mah (ardıç Köyü)",
      "Sökü Mah (çukurhan Köyü)",
      "Sökü Mah (çulhalı Köyü)",
      "Sucuoğlu Mah (esentepe Köyü)",
      "Susuz Mah (aşıklı Köyü)",
      "Susuz Mah (kılıçlı Köyü)",
      "Süyeme Mah (darıözü Köyü)",
      "Şadılı Mah (esengazili Köyü)",
      "Şadırlı Mah (karamusalı Köyü)",
      "Şederek Mah (sarıağaççayı Köyü)",
      "Şeyhler Yaylası Mah (şıhlar Köyü)",
      "Şıhlar Köyü",
      "Tabakderesi Mah (yeşilyurt Köyü)",
      "Tangıloğ Mah (paşalıoğlu Köyü)",
      "Taşlı Yayla Mah (akyürük Köyü)",
      "Tekke Köyü",
      "Tekke Mah (kovaçayır Köyü)",
      "Tekkeli Mah (boyalı Köyü)",
      "Tenheli Mah (keseköy Köyü)",
      "Tepe Mah (kovaçayır Köyü)",
      "Tepedelik Mah (yeşilyurt Köyü)",
      "Terzi Ahmetli Mah (killik Köyü)",
      "Toklar Mah (taşhanlı Köyü)",
      "Tokuşoğlu Mah (bürüm Köyü)",
      "Urluca Mah (gökçeağaçsakızı Köyü)",
      "Uysal Mah (çeşnigir Köyü)",
      "Üzümlü Mah (akçakese Köyü)",
      "Yabanlı Köyü",
      "Yaka Mah (yeniköy Köyü)",
      "Yayla Mah (aydoğan Köyü)",
      "Yayla Mah (boyalı Köyü)",
      "Yayla Mah (çukurhan Köyü)",
      "Yaylacık Yaylası Mah (yaylacık Köyü)",
      "Yazıköy Köyü",
      "Yenimehmetli Köyü",
      "Yeşilköy Köyü",
      "Yızı Mah (isaoğlu Köyü)",
      "Yolçalı Yay Mah (kuyucakpınar Köyü)",
      "Yörük Mah (pehlivanlar Köyü)",
      "Yörükoğlu Yay Mah (çattepe Köyü)",
      "Yukarı Erkeç Mah (erkeç Köyü)",
      "Yukarı Sarıyar Mah (sarıyer Köyü)",
      "Yukarımah Mah (ören Köyü)",
      "Yukarıseyricek Köyü",
      "Yurt Mah (akçakese Köyü)",
      "Yusuflu Mah (çulhalı Köyü)",
      "Yürükderesi Mah (koçak Köyü)",
      "Zincirlikuyu Mah (kozkule Köyü)"
    ],
    "Dikmen": [
      "Babalıoğlu Mah",
      "Çorak Mah",
      "Kırçal Mah",
      "Ağacalı Mah (kadıköy Köyü)",
      "Ağcaalan Mah (bucak Köyü)",
      "Ahmetkovanlığı Mah (karakoyun Köyü)",
      "Ahmetli Kışla Mah (yakuplu Köyü)",
      "Ahmetli Yayla Mah (yakuplu Köyü)",
      "Ahmetoğlu Mah (kerim Köyü)",
      "Alancık Mah (üçpınar Köyü)",
      "Araplı Mah (büyükkızık Köyü)",
      "Aşağı Mah (yaykın Köyü)",
      "Aşağı Saray Mah (saray Köyü)",
      "Aşağıçekmez Mah (küplüce Köyü)",
      "Aşağımah. (kuzalan Köyü)",
      "Ayva Mah (çukurcaalan Köyü)",
      "Balaban Mah (karaağaç Köyü)",
      "Banaz Mah (saray Köyü)",
      "Başköy Mah (büyükkızık Köyü)",
      "Bekiro Mah (göllü Köyü)",
      "Bıyık Mah (üçpınar Köyü)",
      "Boldaç Mah (kerim Köyü)",
      "Buzalağı Mah (üçpınar Köyü)",
      "Camiyanı Mah (görümcek Köyü)",
      "Cilim Mah (küplüce Köyü)",
      "Cindo Mah (büyükdağ Köyü)",
      "Çal Yaylası Mah (karakoyun Köyü)",
      "Çandağı Yaylası Mah (karakoyun Köyü)",
      "Çatacık Mah (dudaş Köyü)",
      "Çatak Mah (göllü Köyü)",
      "Çatakdüzü Mah (göllü Köyü)",
      "Çayağzı Mah (kerim Köyü)",
      "Çeldiremez Mah (akçakese Köyü)",
      "Çıralıkalık Mah (üçpınar Köyü)",
      "Çotuklar Mah (kadıköy Köyü)",
      "Çukurcaalan Yaylası Mah (çukurcaalan Köyü)",
      "Darısu Mah (yaykın Köyü)",
      "Delihasan Mah (küplüce Köyü)",
      "Demirci Mah (büyükkızık Köyü)",
      "Demirci Mah (şeyhhüseyin Köyü)",
      "Dere Mah (çanakçı Köyü)",
      "Dereköy Mah (büyükdağ Köyü)",
      "Dereköy Mah (göllü Köyü)",
      "Derelop Mah (bucak Köyü)",
      "Durak Mah (kerim Köyü)",
      "Edilli Mah (şeyhhüseyin Köyü)",
      "Ellezi Mah (üçpınar Köyü)",
      "Emir Mah (yukarıçekmez Köyü)",
      "Epçeli Mah (saray Köyü)",
      "Erencik Mah (karaağaç Köyü)",
      "Eskicuma Mah (kerim Köyü)",
      "Feti Mah (kadıköy Köyü)",
      "Geves Mah (karaağaç Köyü)",
      "Gıyas Mah (yeniköy Köyü)",
      "Gonurçayı Mah (üçpınar Köyü)",
      "Gödenli Mah (saray Köyü)",
      "Göldiren Mah (üçpınar Köyü)",
      "Guz Mah (şeyhhüseyin Köyü)",
      "Güplüce Mah (yeniköy Köyü)",
      "Güzelceçay Mah (karaağaç Köyü)",
      "Güzelceçay Mah (kerim Köyü)",
      "Hacı Mah (dumanlı Köyü)",
      "Hacıköy Mah (üçpınar Köyü)",
      "Halitli Mah (saray Köyü)",
      "Hatip Mah (kerim Köyü)",
      "Havzoroğlu Mah (yeniköy Köyü)",
      "Hebi Mah (dumanlı Köyü)",
      "Hebilli Mah (dağköy Köyü)",
      "Hemişoğlu Mah (dumanlı Köyü)",
      "Hıdır Mah (şeyhhüseyin Köyü)",
      "Hırlı Mah (büyükkızık Köyü)",
      "İçmesuyu Mah (karakoyun Köyü)",
      "İmam Mah (yeniköy Köyü)",
      "İshak Mah (yeniköy Köyü)",
      "Kadıkışlası Mah (çevikli Köyü)",
      "Kadıköyü Mah (kadıköy Köyü)",
      "Kadıoğlu Mah (şeyhhüseyin Köyü)",
      "Kafar Mah (karaağaç Köyü)",
      "Kahya Mah (küplüce Köyü)",
      "Kalaç Mah (küplüce Köyü)",
      "Kalafat Mah (yeniköy Köyü)",
      "Kalaycı Mah (büyükkızık Köyü)",
      "Kalıkçı Mah (çanakçı Köyü)",
      "Kanlıkalık Mah (üçpınar Köyü)",
      "Karaağaç Mah (yeniköy Köyü)",
      "Karaahmet Mah (küplüce Köyü)",
      "Karacık Kışla Mah (yakuplu Köyü)",
      "Karayaplu Mah (yakuplu Köyü)",
      "Katırcı Mah (yukarıçekmez Köyü)",
      "Kavacık Mah (bucak Köyü)",
      "Kavşak Yaylası Mah (karakoyun Köyü)",
      "Kavuzoğlu Mah (yaykın Köyü)",
      "Kaymaçardağı Mah (yaykın Köyü)",
      "Kestane Mah (yukarıçekmez Köyü)",
      "Kırıklı Mah (çanakçı Köyü)",
      "Kırışoğlu Mah (dumanlı Köyü)",
      "Kışla Mah (kadıköy Köyü)",
      "Kışla Mah (üçpınar Köyü)",
      "Kızakyolu Mah (çevikli Köyü)",
      "Kobolan Mah (büyükkızık Köyü)",
      "Konarı Mah (kadıköy Köyü)",
      "Kölekalığı Mah (şeyhhüseyin Köyü)",
      "Köseağıl Mah (akçakese Köyü)",
      "Köseli Mah (bucak Köyü)",
      "Kuzfındık Mah (kadıköy Köyü)",
      "Macıkışlası Mah (çevikli Köyü)",
      "Mebişo Mah (yakuplu Köyü)",
      "Meğlemoğlu Mah (saray Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (bucak Köyü)",
      "Merkez Mah (büyükdağ Köyü)",
      "Merkez Mah (çanakçı Köyü)",
      "Merkez Mah (çevikli Köyü)",
      "Merkez Mah (çukurcaalan Köyü)",
      "Merkez Mah (dağköy Köyü)",
      "Merkez Mah (dudaş Köyü)",
      "Merkez Mah (dumanlı Köyü)",
      "Merkez Mah (göllü Köyü)",
      "Merkez Mah (görümcek Köyü)",
      "Merkez Mah (kadıköy Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (karakoyun Köyü)",
      "Merkez Mah (kerim Köyü)",
      "Merkez Mah (küçükkızık Köyü)",
      "Merkez Mah (saray Köyü)",
      "Merkez Mah (üçpınar Köyü)",
      "Merkez Mah (yaykın Köyü)",
      "Merkez Mah (yaylabeyi Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Merkez Mah (yukarıçekmez Köyü)",
      "Merkez Mah (yumaklı Köyü)",
      "Müsellim Mah (büyükkızık Köyü)",
      "Omurlu Mah (şeyhhüseyin Köyü)",
      "Orta Köy Mah (göllü Köyü)",
      "Ören Mah (şeyhhüseyin Köyü)",
      "Ören Mah (üçpınar Köyü)",
      "Örencik Mah (kadıköy Köyü)",
      "Örenyanı Mah (büyükdağ Köyü)",
      "Pamukçu Mah (yukarıçekmez Köyü)",
      "Paşalı Mah (saray Köyü)",
      "Sakallı Mah (bucak Köyü)",
      "Sarıyer Mah (karakoyun Köyü)",
      "Sekecek Mah (dumanlı Köyü)",
      "Sekecek Mah (göllü Köyü)",
      "Sepetçioğlu Mah (kerim Köyü)",
      "Softoğlu Mah (saray Köyü)",
      "Şef Mah (dumanlı Köyü)",
      "Şehlioğlu Mah (büyükdağ Köyü)",
      "Tepe Mah (karaağaç Köyü)",
      "Tereli Mah (büyükdağ Köyü)",
      "Tıygarlar Mah (çevikli Köyü)",
      "Tongullar Mah (üçpınar Köyü)",
      "Ustaoğlu Mah (görümcek Köyü)",
      "Uzun Mah (küplüce Köyü)",
      "Yakaköyü Mah (kadıköy Köyü)",
      "Yayla Mah (yakuplu Köyü)",
      "Yortan Mah (şeyhhüseyin Köyü)",
      "Yukarımah. (kuzalan Köyü)",
      "Yummat Mah (kadıköy Köyü)"
    ],
    "Durağan": [
      "Altınkaya Mah",
      "Buzluk Mah",
      "Gökırmak Mah",
      "Merkez Mah",
      "Yeşilyurt Mah",
      "Ağcakaya Mah (boyabükü Köyü)",
      "Akbelçayı Mah (aşağıkaracaören Köyü)",
      "Akıska Mah (uzunöz Köyü)",
      "Alan Mah (çöve Köyü)",
      "Alan Mah (yağbasan Köyü)",
      "Alınca Mah (sarnıkalıncası Köyü)",
      "Ambargerişi Mah (emirtolu Köyü)",
      "Asarcık Mah (kızılcapelit Köyü)",
      "Aşağıakbel Mah (akbel Köyü)",
      "Aşağıakçabük Mah (akçabük Köyü)",
      "Aşağıbayat Mah (bayat Köyü)",
      "Ayvacık Köyü",
      "Ayvatlı Mah (çampaşasakızı Köyü)",
      "Bahçecik Mah (kızılcapelit Köyü)",
      "Bostanderesi Mah (emirtolu Köyü)",
      "Boyalıca Köyü",
      "Bürbük Mah (erduası Köyü)",
      "Büyükgeçe Mah (olucak Köyü)",
      "Büyükkozluca Mah (sarıyar Köyü)",
      "Büyükkozluca Yaylası Mah (sarıyar Köyü)",
      "Cevizlibağ Köyü",
      "Cincon Deresi Mah (akçaalan Köyü)",
      "Çadırcıoğlu Mah (dağdelen Köyü)",
      "Çakmaklık Mah (emirtolu Köyü)",
      "Çaltucak Köyü",
      "Çandağı Köyü",
      "Çaşır Mah (kuzuluk Köyü)",
      "Çatak Mah (kirencik Köyü)",
      "Çatak Mah (ortaköy Köyü)",
      "Çayağzı Köyü",
      "Çiğdemci Mah (aşağıalınca Köyü)",
      "Çobanderesi Mah (çöve Köyü)",
      "Çöllenderesi Mah (alpuğan Köyü)",
      "Dedegerişi Mah (alpuğan Köyü)",
      "Dedeli Mah (sarnıkalıncası Köyü)",
      "Dere Mah (karataş Köyü)",
      "Edilli Mah (alpaşalı Köyü)",
      "Erenköy Köyü",
      "Ericek Mah (beyardıç Köyü)",
      "Eskidağ Mevkii Mah (karataş Köyü)",
      "Gökçebelen Köyü",
      "Gölyeri Mah (kirencik Köyü)",
      "Gömürgen Deresi Mah (başağaç Köyü)",
      "Güney Mah (kirencik Köyü)",
      "Güngören Köyü",
      "Hacılar Mah (erduası Köyü)",
      "Hacımahmutlu Köyü",
      "Hallo Mah (alpuğan Köyü)",
      "Harmancukuru Mah (köseli Köyü)",
      "Hasan Çavuşlar Mah (yukarıkaracaören Köyü)",
      "Hasanoğlu Mah (alpuğan Köyü)",
      "Isırganlım Mah (emirtolu Köyü)",
      "İncir Köyü",
      "Kabakçılar Mah (gökdoğan Köyü)",
      "Kabut Mah (dağdelen Köyü)",
      "Karabey Mah (çöve Köyü)",
      "Karaçamgerişi Mah (alpuğan Köyü)",
      "Karaçukur Mah (gölalan Köyü)",
      "Karaçukur Mah (kirencik Köyü)",
      "Karadeğin Mah (beybükü Köyü)",
      "Karagüney Köyü",
      "Karaköy Mah (köklen Köyü)",
      "Karamatlı Mah (çerçiler Köyü)",
      "Karandu Mevkii Mah (karataş Köyü)",
      "Kavacık Mah (akçaalan Köyü)",
      "Kavak Mah (uzunöz Köyü)",
      "Kavaklı Köyü",
      "Kayabaşı Mah (köseli Köyü)",
      "Kayaçiftliği Mah (hacıoğlan Köyü)",
      "Kemerbahçe Köyü",
      "Kerpiç Mah (kızılcapelit Köyü)",
      "Kırıkla Mah (başağaç Köyü)",
      "Kışla Mah (sofular Köyü)",
      "Kirencik Mah (çerçiler Köyü)",
      "Kirencikovası Mah (gölalan Köyü)",
      "Kirlik Mah (emirtolu Köyü)",
      "Kisekaşı Mah (çöve Köyü)",
      "Kozluca Mah (uzunöz Köyü)",
      "Kökçelik Mah (köklen Köyü)",
      "Köyalan Mah (gölgerişi Köyü)",
      "Kunduz Mah (akpınar Köyü)",
      "Kurthasan Mah (beybükü Köyü)",
      "Kusguncuk Mah (emirtolu Köyü)",
      "Kuz Köyü",
      "Kuz Mevkii Mah (karataş Köyü)",
      "Küçükkozluca Mah (sarıyar Köyü)",
      "Kürtler Mah (olucak Köyü)",
      "Kütükler Mah (olucak Köyü)",
      "Merkez Mah (akbel Köyü)",
      "Merkez Mah (akçaalan Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (alpaşalı Köyü)",
      "Merkez Mah (alpuğan Köyü)",
      "Merkez Mah (aşağıalınca Köyü)",
      "Merkez Mah (aşağıkaracaören Köyü)",
      "Merkez Mah (başağaç Köyü)",
      "Merkez Mah (beyardıç Köyü)",
      "Merkez Mah (beybükü Köyü)",
      "Merkez Mah (boyabükü Köyü)",
      "Merkez Mah (çamlıca Köyü)",
      "Merkez Mah (çampaşasakızı Köyü)",
      "Merkez Mah (çerçiler Köyü)",
      "Merkez Mah (çorakyüzü Köyü)",
      "Merkez Mah (çöve Köyü)",
      "Merkez Mah (dağdelen Köyü)",
      "Merkez Mah (dereli Köyü)",
      "Merkez Mah (emirtolu Köyü)",
      "Merkez Mah (erduası Köyü)",
      "Merkez Mah (gökdoğan Köyü)",
      "Merkez Mah (gölalan Köyü)",
      "Merkez Mah (gölgerişi Köyü)",
      "Merkez Mah (gürpınar Köyü)",
      "Merkez Mah (hacıoğlan Köyü)",
      "Merkez Mah (kaplangı Köyü)",
      "Merkez Mah (karataş Köyü)",
      "Merkez Mah (kılıçaslan Köyü)",
      "Merkez Mah (kızılcapelit Köyü)",
      "Merkez Mah (kirencik Köyü)",
      "Merkez Mah (köklen Köyü)",
      "Merkez Mah (köseli Köyü)",
      "Merkez Mah (kuzuluk Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (sarıkadı Köyü)",
      "Merkez Mah (sarıyar Köyü)",
      "Merkez Mah (sarnıkalıncası Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (uzunöz Köyü)",
      "Merkez Mah (yağbasan Köyü)",
      "Merkez Mah (yassıalan Köyü)",
      "Merkez Mah (yukarıkaracaören Köyü)",
      "Merkezortabayat Mah (bayat Köyü)",
      "Nurhancık Mah (kirencik Köyü)",
      "Okcular Mah (gürpınar Köyü)",
      "Olukbaşı Köyü",
      "Ortatepe Mah (sarnıkalıncası Köyü)",
      "Sakızcık Mah (dereli Köyü)",
      "Sakızcık Mah (kızılcapelit Köyü)",
      "Salarkolu Köyü",
      "Sarıköseler Mah (olucak Köyü)",
      "Sarıoğlu Mah (yassıalan Köyü)",
      "Sarıtaş Mah (aşağıalınca Köyü)",
      "Sarnıç Mah (sarıkadı Köyü)",
      "Sarpın Mah (kaplangı Köyü)",
      "Sökü Mah (bayat Köyü)",
      "Suluçukur Mah (kirencik Köyü)",
      "Şehitli Mah (kaplangı Köyü)",
      "Tantır Mah (kuzuluk Köyü)",
      "Tatlısu Mah (uzunöz Köyü)",
      "Tavşanlı Mah (gölalan Köyü)",
      "Tekeoynağı Mah (çamlıca Köyü)",
      "Tekiryaylası Mah (alpuğan Köyü)",
      "Ulupınar Köyü",
      "Yalnızkavak Köyü",
      "Yanalak Köyü",
      "Yandak Mah",
      "Yapraklı Tarla Mah (akçaalan Köyü)",
      "Yemişen Köyü",
      "Yeniköy Köyü",
      "Yeşilkent Köyü",
      "Yeşilyurt Köyü",
      "Yörük Mah (dağdelen Köyü)",
      "Yukarı Kuguncuk Mah (emirtolu Köyü)",
      "Yukarı Mah (gökdoğan Köyü)",
      "Yukarıakçabük Mah (akçabük Köyü)",
      "Yürek Mah (çöve Köyü)",
      "Zıpıroğlu Mah (yukarıkaracaören Köyü)"
    ],
    "Erfelek": [
      "Kınık Mah",
      "Merkez Mah",
      "Salavat Mah",
      "A.doğan Yuvası Mah (aydınlar Köyü)",
      "Abidinoğlu Mah (hamidiye Köyü)",
      "Acısu Mah (gökçebel Köyü)",
      "Açma Mah (başaran Köyü)",
      "Ağarmut Mah (mescitdüzü Köyü)",
      "Ağıt Mah (abdurrahmanpaşa Köyü)",
      "Ahat Mah (soğucalı Köyü)",
      "Ahatlı Mah (hasandere Köyü)",
      "Akpınar Mah (dereköy Köyü)",
      "Alakoca Mah (kazmasökü Köyü)",
      "Andır Mah (avlağasökü Köyü)",
      "Arabadurağı Mah (incirpınarı Köyü)",
      "Arap Hoca Mah (tatlıca Köyü)",
      "Arap Mah (ormantepe Köyü)",
      "Aşa Mah (sarıboğa Köyü)",
      "Aşağı Gidik Mah (kurcalı Köyü)",
      "Aşağı Karabağ Mah (tekke Köyü)",
      "Aşağı Salur Mah (kirazlık Köyü)",
      "Aşağı Tekke Mah (tekke Köyü)",
      "Aşağısökü Mah (sarıboğa Köyü)",
      "Aşçoğlu Mah (gümüşsuyu Köyü)",
      "Atbakı Mah (abdurrahmanpaşa Köyü)",
      "Avcıoluk Mah (gökçebel Köyü)",
      "Aydın Mah (hacılar Köyü)",
      "Bal Mah (şerefiye Köyü)",
      "Balcı Mah (abdurrahmanpaşa Köyü)",
      "Batı Mah (sorgun Köyü)",
      "Baykadın Mah (akcasöğüt Köyü)",
      "Bayramlı Mah (akcaçam Köyü)",
      "Bektaş Mah (akcaçam Köyü)",
      "Belen Mah (akcasöğüt Köyü)",
      "Belencik Mah (horzum Köyü)",
      "Bıçakcı Mah (inesökü Köyü)",
      "Bıyıklıoğlu Mah (selbeyi Köyü)",
      "Büyükdüz Mah (incirpınarı Köyü)",
      "Çakır Mah (şerefiye Köyü)",
      "Çakmaklı Mah (inesökü Köyü)",
      "Çakmaklı Mah (veysel Köyü)",
      "Çal Mah (himmetoğlu Köyü)",
      "Çardaklı Mah (abdurrahmanpaşa Köyü)",
      "Çatak Mah (aydınlar Köyü)",
      "Çavuşağa Mah (incirpınarı Köyü)",
      "Çaykaşı Mah (hasandere Köyü)",
      "Çelen Mah (kurcalı Köyü)",
      "Çelik Mah (avlağasökü Köyü)",
      "Çiceli Mah (gümüşsuyu Köyü)",
      "Çobanoğlu Mah (şerefiye Köyü)",
      "Çukur Mah (balıfakı Köyü)",
      "Daccaoğlu Mah (himmetoğlu Köyü)",
      "Dağlar Mah (hasandere Köyü)",
      "Darlık Mah (mescitdüzü Köyü)",
      "Davutçu Mah (horzum Köyü)",
      "Dede Mah (çayırköy Köyü)",
      "Değirmenbaşı Mah (abdurrahmanpaşa Köyü)",
      "Demirci Mah (selbeyi Köyü)",
      "Demirci Mah (yeniköy Köyü)",
      "Denizgöl Mah (kirazlık Köyü)",
      "Dere Mah (balıfakı Köyü)",
      "Dere Mah (emirhalil Köyü)",
      "Dilber Mah (kazmasökü Köyü)",
      "Doğandağ Mah (abdurrahmanpaşa Köyü)",
      "Düzler Mah (gümüşsuyu Köyü)",
      "Emine Mah (ahmetmuhipdıranas Köyü)",
      "Emirali Mah (hamidiye Köyü)",
      "Erol Mah (salı Köyü)",
      "Erpelek Mah (mescitdüzü Köyü)",
      "Eskici Mah (akcasöğüt Köyü)",
      "Ete Mah (sarıboğa Köyü)",
      "Ganioğlu Mah (himmetoğlu Köyü)",
      "Gazi Mah (himmetoğlu Köyü)",
      "Gebegüneyi Mah (sorgun Köyü)",
      "Goğuz Mah (kızılcaelma Köyü)",
      "Gospara Mah (tombul Köyü)",
      "Göcük Mah (avlağasökü Köyü)",
      "Göçeri Mah (balıfakı Köyü)",
      "Göçgün Mah (kızılcaot Köyü)",
      "Gökçam Mah (hürremşah Köyü)",
      "Göktepe Mah (hürremşah Köyü)",
      "Gölaltı Mah (meydan Köyü)",
      "Göller Mah (akcasöğüt Köyü)",
      "Gülistan Mah (kızılcaot Köyü)",
      "Gülyan Mah (yeniçam Köyü)",
      "Güney Mah (akcaçam Köyü)",
      "Güney Mah (çayırköy Köyü)",
      "Güney Mah (kaldırayak Köyü)",
      "Güney Mah (tombul Köyü)",
      "Günyama Mah (hamidiye Köyü)",
      "Gürcüler Mah (emirhalil Köyü)",
      "Güvendik Mah (kirazlık Köyü)",
      "Hacıbey Mah (hacılar Köyü)",
      "Hacılar Mah (emirhalil Köyü)",
      "Halil Ustaoğlu Mah (kurcalı Köyü)",
      "Hamzaoğlu Mah (balıfakı Köyü)",
      "Hasanağa Mah (incirpınarı Köyü)",
      "Haytasuyu Mah (tekke Köyü)",
      "Hıdıroğlu Mah (ormantepe Köyü)",
      "Hodul Mah (meydan Köyü)",
      "Hopaçoğlu Mah (himmetoğlu Köyü)",
      "İğner Mah (dereköy Köyü)",
      "İkitce Mah (gökçebel Köyü)",
      "İncekara Mah (akcaçam Köyü)",
      "İncemeydan Mah (değirmencili Köyü)",
      "İncemeydan Mah (inesökü Köyü)",
      "Kabalı Mah (emirhalil Köyü)",
      "Kadem Çavuş Mah (veysel Köyü)",
      "Kalaycı Mah (dereköy Köyü)",
      "Kaldırayak Mah (kaldırayak Köyü)",
      "Kanadoğlu Mah (yeniçam Köyü)",
      "Kanlıca Mah (karacaköy Köyü)",
      "Kapandüzü Mah (kazmasökü Köyü)",
      "Kapuz Mah (gökçebel Köyü)",
      "Kara İbrahim Mah (kirazlık Köyü)",
      "Kara Köy Mah (mescitdüzü Köyü)",
      "Karabacak Mah (ormantepe Köyü)",
      "Karabağ Mah (başaran Köyü)",
      "Karabağ Mah (tekke Köyü)",
      "Karabağı Mah (gümüşsuyu Köyü)",
      "Karabey Mah (abdurrahmanpaşa Köyü)",
      "Karacaağaç Mah (aydınlar Köyü)",
      "Karaçayır Mah (ormantepe Köyü)",
      "Kaşbaş Mah (selbeyi Köyü)",
      "Kaşbaşı Mah (gümüşsuyu Köyü)",
      "Kaya Başı Mah (avlağasökü Köyü)",
      "Kayaaltı Mah (gökçebel Köyü)",
      "Kayalı Mah (çayırköy Köyü)",
      "Kemerli Mah (gümüşsuyu Köyü)",
      "Kenar Mah (balıfakı Köyü)",
      "Kıralı Mah (sarıboğa Köyü)",
      "Kıran Mah (kurcalı Köyü)",
      "Kıran Mah (soğucalı Köyü)",
      "Kıran Mah (tombul Köyü)",
      "Kırayol Mah (yeniköy Köyü)",
      "Kırık Ömer Mah (dereköy Köyü)",
      "Kışla Mah (kirazlık Köyü)",
      "Kirazlı Mah (hasandere Köyü)",
      "Kocaoğlu Mah (ormantepe Köyü)",
      "Koçcuvaz Mah (horzum Köyü)",
      "Konak Mah (ormantepe Köyü)",
      "Kozak Mah (dereköy Köyü)",
      "Köle Mah (avlağasökü Köyü)",
      "Köleç Mah (avlağasökü Köyü)",
      "Kömeç Mah (hacılar Köyü)",
      "Körkuyu Mah (veysel Köyü)",
      "Kurada Mah (akcaçam Köyü)",
      "Kurt Mah (balıfakı Köyü)",
      "Kusuri Mah (yeniçam Köyü)",
      "Kuz Mah (avlağasökü Köyü)",
      "Kuz Mah (kaldırayak Köyü)",
      "Kuzlu Mah (hamidiye Köyü)",
      "Kümes Mah (horzum Köyü)",
      "Künekli Mah (güven Köyü)",
      "Kürtkonağı Mah (yeniköy Köyü)",
      "Madenoğlu Mah (gümüşsuyu Köyü)",
      "Merkez Mah (ahmetmuhipdıranas Köyü)",
      "Merkez Mah (akcasöğüt Köyü)",
      "Merkez Mah (balıfakı Köyü)",
      "Merkez Mah (başaran Köyü)",
      "Merkez Mah (çayırköy Köyü)",
      "Merkez Mah (dağyeri Köyü)",
      "Merkez Mah (değirmencili Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Merkez Mah (emirhalil Köyü)",
      "Merkez Mah (gökçebel Köyü)",
      "Merkez Mah (güven Köyü)",
      "Merkez Mah (hasandere Köyü)",
      "Merkez Mah (horzum Köyü)",
      "Merkez Mah (hürremşah Köyü)",
      "Merkez Mah (incirpınarı Köyü)",
      "Merkez Mah (inesökü Köyü)",
      "Merkez Mah (kazmasökü Köyü)",
      "Merkez Mah (kızılcaot Köyü)",
      "Merkez Mah (kurcalı Köyü)",
      "Merkez Mah (meydan Köyü)",
      "Merkez Mah (ormantepe Köyü)",
      "Merkez Mah (salı Köyü)",
      "Merkez Mah (sarıboğa Köyü)",
      "Merkez Mah (soğucalı Köyü)",
      "Merkez Mah (sorgun Köyü)",
      "Merkez Mah (yeniçam Köyü)",
      "Merkez Soğukcasu Mah (abdurrahmanpaşa Köyü)",
      "Mestan Mah (şerefiye Köyü)",
      "Meydan Mah (selbeyi Köyü)",
      "Miyet Mah (çayırköy Köyü)",
      "Molla Mah (himmetoğlu Köyü)",
      "Morgül Mah (veysel Köyü)",
      "Musaoğlu Mah (ormantepe Köyü)",
      "Mustafa Paşa Mah (selbeyi Köyü)",
      "Müezzinoğlu Mah (ormantepe Köyü)",
      "Nazar Mah (dereköy Köyü)",
      "Obruk Mah (abdurrahmanpaşa Köyü)",
      "Olukaltı Mah (abdurrahmanpaşa Köyü)",
      "Omur Mah (tekke Köyü)",
      "Oraklı Mah (horzum Köyü)",
      "Ordulular Mah (balıfakı Köyü)",
      "Ornamaz Mah (gökçebel Köyü)",
      "Orta Mah (kızılcaelma Köyü)",
      "Oymataş Mah (yeniköy Köyü)",
      "Ozan Mah (başaran Köyü)",
      "Öküz Köyü Mah (mescitdüzü Köyü)",
      "Ötegeçe Mah (kızılcaelma Köyü)",
      "Ram Mah (kirazlık Köyü)",
      "Ramlı Mah (hasandere Köyü)",
      "Saboğlu Mah (hamidiye Köyü)",
      "Sakaoğlu Mah (veysel Köyü)",
      "Sakul Mah (salı Köyü)",
      "Salbat Mah (hamidiye Köyü)",
      "Samçooğlu Mah (selbeyi Köyü)",
      "Saptuhan Mah (himmetoğlu Köyü)",
      "Savuçcu Mah (mescitdüzü Köyü)",
      "Selçek Mah (yeniköy Köyü)",
      "Sıpkın Mah (hürremşah Köyü)",
      "Sökü Mah (kaldırayak Köyü)",
      "Sökü Mah (salı Köyü)",
      "Sökü Mah (tekke Köyü)",
      "Şamı Mah (tatlıca Köyü)",
      "Şamlıoğlu Mah (incirpınarı Köyü)",
      "Şefoğlu Mah (selbeyi Köyü)",
      "Şerefloğlu Mah (gümüşsuyu Köyü)",
      "Şevit Mah (tatlıca Köyü)",
      "Şıflar Mah (sarıboğa Köyü)",
      "Tafana Mah (gümüşsuyu Köyü)",
      "Taşkirişi Mah (dereköy Köyü)",
      "Taştepe Mah (tekke Köyü)",
      "Tatur Mah (selbeyi Köyü)",
      "Tavşan Mah (karacaköy Köyü)",
      "Tekke Mah (kızılcaelma Köyü)",
      "Tekne Mah (kızılcaelma Köyü)",
      "Tepe Mah (selbeyi Köyü)",
      "Terziyeri Mah (gökçebel Köyü)",
      "Tombul Mah (tombul Köyü)",
      "Topcu Mah (başaran Köyü)",
      "Toruş Mah (şerefiye Köyü)",
      "Ufacık Ağaç Mah (başaran Köyü)",
      "Ufacıkağaç Mah (incirpınarı Köyü)",
      "Umut Mah (çayırköy Köyü)",
      "Usta Mah (karacaköy Köyü)",
      "Y.doğan Yuvası Mah (aydınlar Köyü)",
      "Yağcı Mah (yeniköy Köyü)",
      "Yaka Mah (mescitdüzü Köyü)",
      "Yeni Köy Mah (veysel Köyü)",
      "Yeni Mah (kızılcaot Köyü)",
      "Yeni Mah (tekke Köyü)",
      "Yeşiloğlu Mah (başaran Köyü)",
      "Yıldız Mah (selbeyi Köyü)",
      "Yoğurcu Mah (sarıboğa Köyü)",
      "Yortan Mah (hacılar Köyü)",
      "Yozgonat Mah (mescitdüzü Köyü)",
      "Yukarı Gidik Mah (kurcalı Köyü)",
      "Yukarı Mah (sarıboğa Köyü)",
      "Yukarı Salur Mah (kirazlık Köyü)",
      "Yukarı Tekke Mah (kızılcaot Köyü)"
    ],
    "Gerze": [
      "19 Mayıs Mah",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Hamidiye Mah",
      "Köşk Mah",
      "Yeni Mah",
      "Abdaloğlu Mah (abdaloğlu Köyü)",
      "Ağustoslu Mah (altınyayla Köyü)",
      "Ahmetoğlu Mah (abdaloğlu Köyü)",
      "Akbaş Mah (sarnıç Köyü)",
      "Akçakese Mah (gürsökü Köyü)",
      "Akçaören Mah (sazak Köyü)",
      "Akkıraç Köyü",
      "Akmanlı Mah (boyalıca Köyü)",
      "Alıçlı Mah (sarımsak Köyü)",
      "Ali Yazıcı Mah (yaykıl Köyü)",
      "Alibey Mah (belören Köyü)",
      "Aloğlu Mah (sorkun Köyü)",
      "Aşa Mah (gürsökü Köyü)",
      "Aşağı Akgüney Mah (akgüney Köyü)",
      "Aşağı Mah (acısu Köyü)",
      "Aşağı Şahinoğlu Mah (türkmenlioğlu Köyü)",
      "Aşağı Yamacık Mah (yamacık Köyü)",
      "Avlağısökü Mah (kirençukuru Köyü)",
      "Avlanlı Mah (kahramaneli Köyü)",
      "Avlo Sökü Kooperatifi Mah (abdaloğlu Köyü)",
      "Ayvatlı Mah (kahramaneli Köyü)",
      "Bağşılı Mah (pirahmet Köyü)",
      "Bahçe Mah (şeyhli Köyü)",
      "Bakaoğlu Mah (sazak Köyü)",
      "Baratoğlu Mah (sazak Köyü)",
      "Bayraktar Mah (sarnıç Köyü)",
      "Bayram Kalfa Mah (çakallı Köyü)",
      "Beceoğlu Mah (karlı Köyü)",
      "Behramoğlu Mah (mahmuttırı Köyü)",
      "Bektaşoğlu Mah (abdaloğlu Köyü)",
      "Beyni Mah (başsökü Köyü)",
      "Boduroğlu Mah (şeyhli Köyü)",
      "Borgan Mah (tatlıcak Köyü)",
      "Boypınar Mah (yenikent Köyü)",
      "Buruncuk Mah (bolalı Köyü)",
      "Büyüksünoğlu Mah (sarıyer Köyü)",
      "Cilaz Mah (sorkun Köyü)",
      "Cingiloğlu Mah (çırnık Köyü)",
      "Conguroğlu Mah (yaykıl Köyü)",
      "Coroğlu Mah (yaykıl Köyü)",
      "Çakıllı Mah (pirahmet Köyü)",
      "Çalboğaz Mah (yenikent Köyü)",
      "Çalık Mah (sarnıç Köyü)",
      "Çallı Mah (kirençukuru Köyü)",
      "Çavdar Mah (çırnık Köyü)",
      "Çeçe Mah (yenikent Köyü)",
      "Çelebi Mah (şeyhli Köyü)",
      "Çerkezli Mah (güzelyurt Köyü)",
      "Çeşler Mah (sarnıç Köyü)",
      "Çiftçi Mah (hacıselli Köyü)",
      "Çomoğlu Mah (karlı Köyü)",
      "Çotoğlu Mah (yaykıl Köyü)",
      "Çörekçi Mah (belören Köyü)",
      "Daylı Mah (hacıselli Köyü)",
      "Değirmencilli Mah (kuzsökü Köyü)",
      "Değirmençi Mah (sarnıç Köyü)",
      "Dellooğlu Mah (çırnık Köyü)",
      "Demir Mah (sorkun Köyü)",
      "Demirci Mah (sorkun Köyü)",
      "Demirci Mah (yaykıl Köyü)",
      "Demircioğlu Mah (yaykıl Köyü)",
      "Denizçukuru Mah (hacıselli Köyü)",
      "Dere Köy Mah (gürsökü Köyü)",
      "Dere Mah (boyalıca Köyü)",
      "Dere Mah (çırnık Köyü)",
      "Dereağlı Mah (hacıselli Köyü)",
      "Dereli Mah (karlı Köyü)",
      "Devret Mah (belören Köyü)",
      "Dırasıllı Mah (hıdırlı Köyü)",
      "Divlioğlu Mah (altınyayla Köyü)",
      "Domuz Damı Mah (çakallı Köyü)",
      "Doraman Mah (yaykıl Köyü)",
      "Doro Mah (yaykıl Köyü)",
      "Dranaz Mah (kahramaneli Köyü)",
      "Düzdeğirmen Mah (akgüney Köyü)",
      "Edüllü Mah (sarımsak Köyü)",
      "Ekşioğlu Mah (yakadibi Köyü)",
      "Eltiyeeri Mah (çağlayan Köyü)",
      "Eminçavuş Mah (abdaloğlu Köyü)",
      "Eminkahya Mah (kabanlar Köyü)",
      "Emir Mah (pirahmet Köyü)",
      "Erce Mah (sorkun Köyü)",
      "Esbeli Mah (başsökü Köyü)",
      "Eynedül Mah (tepealtı Köyü)",
      "Falcıoğlu Mah (belören Köyü)",
      "Ferhatlı Mah (hıdırlı Köyü)",
      "Gacer Mah (yamacık Köyü)",
      "Gaffar Mah (boyalıca Köyü)",
      "Galaç Mah (abdaloğlu Köyü)",
      "Gavlanpınarı Mah (hizarçayı Köyü)",
      "Gerdeme Mah (çakallı Köyü)",
      "Gono Mah (belören Köyü)",
      "Gölü Mah (tepealtı Köyü)",
      "Gözsökü Mah (hıdırlı Köyü)",
      "Gübroğlu Mah (sarıyer Köyü)",
      "Gürlük Mah (yuvalı Köyü)",
      "Hacı Mah (abdaloğlu Köyü)",
      "Hacı Mah (sarnıç Köyü)",
      "Hacılar Mah (kuzsökü Köyü)",
      "Hacılar Mah (sorkun Köyü)",
      "Hacıosman Mah (türkmenlioğlu Köyü)",
      "Hamitkahya Mah (sarıyer Köyü)",
      "Hançer Mah (sarnıç Köyü)",
      "Hasanoğlu Mah (yakadibi Köyü)",
      "Hatipler Mah (karlı Köyü)",
      "Hatipoğlu Mah (hacıselli Köyü)",
      "Hocalı Mah (sarımsak Köyü)",
      "İbrahimli Mah (kahramaneli Köyü)",
      "İdemli Mah (yamacık Köyü)",
      "İmamlı Mah (sarımsak Köyü)",
      "İmamoğlu Mah (abdaloğlu Köyü)",
      "İmamoğlu Mah (altınyayla Köyü)",
      "İslamoğlu Mah (sarnıç Köyü)",
      "Kabaağaç Mah (çağlayan Köyü)",
      "Kaçak Mah (altınyayla Köyü)",
      "Kadağlu Mah (karlı Köyü)",
      "Kadı Mah (belören Köyü)",
      "Kadı Mah (gürsökü Köyü)",
      "Kadı Mah (kahramaneli Köyü)",
      "Kadılar Mah (yaykıl Köyü)",
      "Kadıoğlu Mah (sarnıç Köyü)",
      "Kalaşlı Mah (güzelyurt Köyü)",
      "Kaptan Mah (kabanlar Köyü)",
      "Karabayram Mah (abdaloğlu Köyü)",
      "Karabicoğlu Mah (abdaloğlu Köyü)",
      "Karacakaya Mah (sarımsak Köyü)",
      "Karacoroğlu Mah (yaykıl Köyü)",
      "Karaçayır Mah (hıdırlı Köyü)",
      "Karaderbent Mah (bolalı Köyü)",
      "Karagöl Mah (tepealtı Köyü)",
      "Karahasan Mah (şeyhli Köyü)",
      "Karakaya Mah (karlı Köyü)",
      "Karakütük Mah (yuvalı Köyü)",
      "Karalı Mah (pirahmet Köyü)",
      "Karamanlı Mah (güzelyurt Köyü)",
      "Karanlık Mah (çakallı Köyü)",
      "Karat Mah (kahramaneli Köyü)",
      "Karboğ Mah (pirahmet Köyü)",
      "Karevli Mah (yamacık Köyü)",
      "Karslıoğlu Mah (çırnık Köyü)",
      "Karşı Mah (acısu Köyü)",
      "Katırcılar Mah (karlı Köyü)",
      "Kavacık Mah (kızılcalı Köyü)",
      "Kavgacılı Mah (güzelyurt Köyü)",
      "Kaya Mah (boyalıca Köyü)",
      "Kayabaşı Mah (sarnıç Köyü)",
      "Kayıbucağı Mah (sazak Köyü)",
      "Keklooğlu Mah (çırnık Köyü)",
      "Kelleşoğlu Mah (çırnık Köyü)",
      "Kemer Mah (tepealtı Köyü)",
      "Kemerli Mah (şeyhli Köyü)",
      "Kılavuz Mah (tokuşlar Köyü)",
      "Kıran Mah (çırnık Köyü)",
      "Kırdıllı Mah (kuzsökü Köyü)",
      "Kırıklı Mah (karlı Köyü)",
      "Kışla Mah (tatlıcak Köyü)",
      "Kızılcalı Mah (abdaloğlu Köyü)",
      "Kiren Mah (abdaloğlu Köyü)",
      "Kirenli Mah (sarnıç Köyü)",
      "Koruz Mah (sorkun Köyü)",
      "Körüklü Mah (bolalı Köyü)",
      "Köselli Mah (abdaloğlu Köyü)",
      "Köseoğlu Mah (sazak Köyü)",
      "Kuloğlu Mah (kabanlar Köyü)",
      "Kumandan Mah (yaykıl Köyü)",
      "Kurtini Mah (şeyhli Köyü)",
      "Kuş Mah (boyalıca Köyü)",
      "Kuşça Mah (şeyhli Köyü)",
      "Kuz Mah (kızılcalı Köyü)",
      "Küçükoğlu Mah (yakadibi Köyü)",
      "Kürtoğlu Mah (sarıyer Köyü)",
      "Kütoğlu Mah (sorkun Köyü)",
      "Mahmutoğlu Mah (karlı Köyü)",
      "Memi Mah (tatlıcak Köyü)",
      "Menoğlu Mah (kabanlar Köyü)",
      "Merkez Mah (abdaloğlu Köyü)",
      "Merkez Mah (akgüney Köyü)",
      "Merkez Mah (altınyayla Köyü)",
      "Merkez Mah (başsökü Köyü)",
      "Merkez Mah (bolalı Köyü)",
      "Merkez Mah (boyalı Köyü)",
      "Merkez Mah (çağlayan Köyü)",
      "Merkez Mah (çakallı Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (hacıselli Köyü)",
      "Merkez Mah (hıdırlı Köyü)",
      "Merkez Mah (hizarçayı Köyü)",
      "Merkez Mah (kabanlar Köyü)",
      "Merkez Mah (karlı Köyü)",
      "Merkez Mah (kızılcalı Köyü)",
      "Merkez Mah (kirençukuru Köyü)",
      "Merkez Mah (kuzsökü Köyü)",
      "Merkez Mah (pirahmet Köyü)",
      "Merkez Mah (sarımsak Köyü)",
      "Merkez Mah (sorkun Köyü)",
      "Merkez Mah (tatlıcak Köyü)",
      "Merkez Mah (tepealtı Köyü)",
      "Merkez Mah (tokuşlar Köyü)",
      "Merkez Mah (türkmen Köyü)",
      "Merkez Mah (türkmenlioğlu Köyü)",
      "Merkez Mah (yuvalı Köyü)",
      "Meşelik Mah (belören Köyü)",
      "Mıtrız Mah (belören Köyü)",
      "Mızraklı Mah (karlı Köyü)",
      "Mızralı Mah (sarıyer Köyü)",
      "Mutatlar Mah (sarıyer Köyü)",
      "Mülçü Mah (tokuşlar Köyü)",
      "Noğumlu Mah (hacıselli Köyü)",
      "Orta Mah (mahmuttırı Köyü)",
      "Orta Yamacık Mah (yamacık Köyü)",
      "Öksüzoğlu Mah (sarnıç Köyü)",
      "Ömeroğlu Mah (sazak Köyü)",
      "Ranlı Mah (kuzsökü Köyü)",
      "Resuloğlu Mah (yaykıl Köyü)",
      "Reşlolu Mah (sarnıç Köyü)",
      "Sağırkahya Mah (sarıyer Köyü)",
      "Sağıroğlu Mah (abdaloğlu Köyü)",
      "Sağıroğlu Mah (altınyayla Köyü)",
      "Sağıroğlu Mah (sarnıç Köyü)",
      "Salar Mah (gürsökü Köyü)",
      "Saraçlı Mah (yamacık Köyü)",
      "Sarı Mah (gürsökü Köyü)",
      "Sarnıç Mah (bolalı Köyü)",
      "Sazaklıoğlu Mah (türkmenlioğlu Köyü)",
      "Serdar Mah (yamacık Köyü)",
      "Sevincer Mah (kuzsökü Köyü)",
      "Seymenli Mah (şeyhli Köyü)",
      "Sindeli Mah (kızılcalı Köyü)",
      "Sofuoğlu Mah (abdaloğlu Köyü)",
      "Soğuksu Mah (belören Köyü)",
      "Soğuksu Mah (şeyhli Köyü)",
      "Sucafus Mah (tatlıcak Köyü)",
      "Sünetçi Mah (belören Köyü)",
      "Sütcülü Mah (tatlıcak Köyü)",
      "Şahinoğlu Mah (türkmenlioğlu Köyü)",
      "Şarapçıoğlu Mah (sarıyer Köyü)",
      "Şerbetli Mah (türkmen Köyü)",
      "Şeyh Mah (kirençukuru Köyü)",
      "Şeyhli Mah (şeyhli Köyü)",
      "Şıhlı Mah (sarnıç Köyü)",
      "Tanga Mah (sazak Köyü)",
      "Tangaloğlu Mah (kabanlar Köyü)",
      "Taşçıoğlu Mah (mahmuttırı Köyü)",
      "Taşlı Mah (yaykıl Köyü)",
      "Taşlıoğlu Mah (mahmuttırı Köyü)",
      "Tazıoğlu Mah (karlı Köyü)",
      "Tekasanoğlu Mah (yaykıl Köyü)",
      "Tekke Mah (yakadibi Köyü)",
      "Telbisoğlu Mah (mahmuttırı Köyü)",
      "Tepe Mah (kirençukuru Köyü)",
      "Tıyır Mah (çakallı Köyü)",
      "Tilkilik Altı Mah (acısu Köyü)",
      "Tiryaki Mah (yaykıl Köyü)",
      "Tongelsokağı Mah (hacıselli Köyü)",
      "Topaloğlu Mah (yakadibi Köyü)",
      "Tüketli Mah (yamacık Köyü)",
      "Tülo Mah (gürsökü Köyü)",
      "Ustaoğlu Mah (belören Köyü)",
      "Uzunmusa Mah (belören Köyü)",
      "Yangıç Mah (pirahmet Köyü)",
      "Yanıç Mah (yamacık Köyü)",
      "Yayaoğlu Mah (belören Köyü)",
      "Yayla Mah (sarımsak Köyü)",
      "Yelhasan Mah (pirahmet Köyü)",
      "Yemişen Mah (sarnıç Köyü)",
      "Yeni Mah (çırnık Köyü)",
      "Yeymiş Mah (kuzsökü Köyü)",
      "Yoroğlu Mah (çırnık Köyü)",
      "Yukarı Akgüney Mah (akgüney Köyü)",
      "Yukarı Mah (acısu Köyü)",
      "Yukarı Mah (gürsökü Köyü)",
      "Yukarı Mah (yuvalı Köyü)",
      "Yukarı Yamacık Mah (yamacık Köyü)",
      "Yusufoğlu Mah (hizarçayı Köyü)",
      "Yusufoğlu Mah (karlı Köyü)",
      "Yusufoğlu Mah (yakadibi Köyü)"
    ],
    "Merkez": [
      "Abazalar Mah (erikli Köyü)",
      "Afet Evleri Konutları Mah (yalı Köyü)",
      "Agcelli Mah (çiftlik Köyü)",
      "Ahlatçık Mah (eymir Köyü)",
      "Ahmatlı Mah (taypaklı Köyü)",
      "Ahmedül Mah (göller Köyü)",
      "Ahutoğlu Mah (tangaloğlu Köyü)",
      "Akkuşlar Mah (çiftlik Köyü)",
      "Aklıman Mah (dibekli Köyü)",
      "Akliman Mah (abalı Köyü)",
      "Akyamaç Mah (sinecan Köyü)",
      "Alagöz Mah (abalı Köyü)",
      "Alaylı Mah (aloğlu Köyü)",
      "Alibaşoğlu Mah (kabalı Köyü)",
      "Alibaşoğlu Mah (oğuzeli Köyü)",
      "Alibeyli Mah (karapınar Köyü)",
      "Aliköyü Mah (tıngıroğlu Köyü)",
      "Altınoğlu Mah (lala Köyü)",
      "Ambarlık Mah (akbaş Köyü)",
      "Arap Mah (bektaşağa Köyü)",
      "Arzaoğlu Mah (kabalı Köyü)",
      "Aşağı Asarcık Mah (kirençukuru Köyü)",
      "Aşağı Karapınar Mah (karapınar Köyü)",
      "Aşağı Mah (ahmetyeri Köyü)",
      "Aşağı Mah (hacıoğlu Köyü)",
      "Aşağı Mah (mertoğlu Köyü)",
      "Aşağı Mah (sazlı Köyü)",
      "Aşağı Mah (tıngıroğlu Köyü)",
      "Atabey Mah (karapınar Köyü)",
      "Aydın Mah (tıngıroğlu Köyü)",
      "Azaklı Mah (göller Köyü)",
      "Bagılar Mah (karapınar Köyü)",
      "Balcılar Mah (fidanlık Köyü)",
      "Bayraktaroğlu Mah (kozcuğaz Köyü)",
      "Bedeller Mah (erikli Köyü)",
      "Behramoğlu Mah (dizdaroğlu Köyü)",
      "Bekiroğlu Mah (erikli Köyü)",
      "Bostancı Mah (kozcuğaz Köyü)",
      "Bozlu Mah (eymir Köyü)",
      "Cabbaroğlu Mah (melikşah Köyü)",
      "Cambazoğlu Mah (göllü Köyü)",
      "Cami Altı Mah (erikli Köyü)",
      "Cami Yanı Mah (erikli Köyü)",
      "Camiyanı Mah (karapınar Köyü)",
      "Canik Mah (çiftlik Köyü)",
      "Coroğlu Mah (alasökü Köyü)",
      "Çalı Mah (kozcuğaz Köyü)",
      "Çavdaroğlu Mah (sinecan Köyü)",
      "Çayharmanı Mah (çakıldak Köyü)",
      "Çıraklar Mah (aloğlu Köyü)",
      "Çilingiroğlu Mah (dizdaroğlu Köyü)",
      "Çoban Mah (fidanlık Köyü)",
      "Dağlar Mah (bektaşağa Köyü)",
      "Dedeoğlu Mah (melikşah Köyü)",
      "Deliler Mah (yalı Köyü)",
      "Demirci Mah (karapınar Köyü)",
      "Demirciköyosb Mah (demirci Köyü)",
      "Demirciler Mah (göllü Köyü)",
      "Devrant Mah (tangaloğlu Köyü)",
      "Dıranaz Mah (akbaş Köyü)",
      "Dikenli Mah (abalı Köyü)",
      "Dolaysökü Mah (oğuzeli Köyü)",
      "Düz Eymür Mah (eymir Köyü)",
      "Düzpara Mah (lala Köyü)",
      "Düzyazı Mah (aloğlu Köyü)",
      "Ekşeoğlu Mah (kabalı Köyü)",
      "Ekşioğlu Mah (şamlıoğlu Köyü)",
      "Eldeviz Mah (demirci Köyü)",
      "Emin Mah (dizdaroğlu Köyü)",
      "Eras Mah (eymir Köyü)",
      "Eski Dibekli Mah (dibekli Köyü)",
      "Fenerci Mah (kabalı Köyü)",
      "Fındıcak Mah (sazlı Köyü)",
      "Fındık Pınarı Mah (erikli Köyü)",
      "Frenk Mah (lala Köyü)",
      "Gaybı Mah (hacıoğlu Köyü)",
      "Gedi Mah (çakıldak Köyü)",
      "Gedioğlu Mah (sinecan Köyü)",
      "Gökmenoğlu Mah (sinecan Köyü)",
      "Göller Mah (göller Köyü)",
      "Gözören Mah (kirençukuru Köyü)",
      "Güncüllü Mah (eymir Köyü)",
      "Güvendik Mah (çakıldak Köyü)",
      "Hacılar Mah (avdan Köyü)",
      "Hacılar Mah (erikli Köyü)",
      "Hacıoğlum Mah (melikşah Köyü)",
      "Hacıosman Mah (göllü Köyü)",
      "Hamallar Mah (kozcuğaz Köyü)",
      "Harmanlar Mah (hacıoğlu Köyü)",
      "Hasan Koca Mah (fidanlık Köyü)",
      "Hatun Mah (çobanlar Köyü)",
      "Hotonoğlu Mah (dizdaroğlu Köyü)",
      "Hümmeli Mah (akbaş Köyü)",
      "Hüseyin Ustalar Mah (karapınar Köyü)",
      "Hüseyinbey Mah (sinecan Köyü)",
      "İmam Mah (aloğlu Köyü)",
      "İmamoğlu Mah (şamlıoğlu Köyü)",
      "İpekci Mah (dibekli Köyü)",
      "İslamoğlu Mah (kabalı Köyü)",
      "İslamoğlu Mah (kozcuğaz Köyü)",
      "Kadıoğlu Mah (taşmanlı Köyü)",
      "Kahramanoğlu Mah (kabalı Köyü)",
      "Kahyaoğlu Mah (yalı Köyü)",
      "Kalaşlı Mah (göller Köyü)",
      "Karacalar Mah (kirençukuru Köyü)",
      "Karadayı Mah (aloğlu Köyü)",
      "Karagülle Mah (lala Köyü)",
      "Karahacı Mah (göller Köyü)",
      "Karpuz Mah (dibekli Köyü)",
      "Karşı Mah (çakıldak Köyü)",
      "Karşıköy Mah (kabalı Köyü)",
      "Kasımağa Mah (kabalı Köyü)",
      "Kavaklı Mah (melikşah Köyü)",
      "Kayabaşı Mah (taypaklı Köyü)",
      "Kayadibi Mah (sazlı Köyü)",
      "Kaybı Mah (kılıçlı Köyü)",
      "Kaz Mah (dibekli Köyü)",
      "Kazlı Mah (eymir Köyü)",
      "Keçioğlu Mah (yalı Köyü)",
      "Keleköyü Mah (tıngıroğlu Köyü)",
      "Keremperoğlu Mah (kabalı Köyü)",
      "Keser Mah (mertoğlu Köyü)",
      "Kışla Mah (dibekli Köyü)",
      "Kirazcıoğlu Mah (avdan Köyü)",
      "Kirenlik Mah (lala Köyü)",
      "Kirenpara Mah (sazlı Köyü)",
      "Konat Mah (kirençukuru Köyü)",
      "Konutlar Mah (taypaklı Köyü)",
      "Kovukbaş Mah (dibekli Köyü)",
      "Köle Mah (uzungürgen Köyü)",
      "Köseli Mah (alasökü Köyü)",
      "Köseli Mah (karapınar Köyü)",
      "Köseoğlu Mah (taşmanlı Köyü)",
      "Köseönü Mah (karapınar Köyü)",
      "Kunmat Mah (demirci Köyü)",
      "Kurtça Mah (oğuzeli Köyü)",
      "Kurtkuyusu Mah (abalı Köyü)",
      "Kuzoluk Mah (çakıldak Köyü)",
      "Küllüzoğlu Mah (sinecan Köyü)",
      "Kümes Mah (demirci Köyü)",
      "Kündeşoğlu Mah (lala Köyü)",
      "Maciller Mah (çiftlik Köyü)",
      "Marul Mah (karapınar Köyü)",
      "Mecit Yanı Mah (göller Köyü)",
      "Mehmetbeyoğlu Mah (lala Köyü)",
      "Melezin Mah (taypaklı Köyü)",
      "Melikoğlu Mah (avdan Köyü)",
      "Merkez Mah (abalı Köyü)",
      "Merkez Mah (ahmetyeri Köyü)",
      "Merkez Mah (akbaş Köyü)",
      "Merkez Mah (alasökü Köyü)",
      "Merkez Mah (bektaşağa Köyü)",
      "Merkez Mah (çakıldak Köyü)",
      "Merkez Mah (çiftlik Köyü)",
      "Merkez Mah (çobanlar Köyü)",
      "Merkez Mah (demirci Köyü)",
      "Merkez Mah (fidanlık Köyü)",
      "Merkez Mah (hacıoğlu Köyü)",
      "Merkez Mah (kabalı Köyü)",
      "Merkez Mah (kılıçlı Köyü)",
      "Merkez Mah (şamlıoğlu Köyü)",
      "Merkez Mah (tangaloğlu Köyü)",
      "Merkez Mah (taşmanlı Köyü)",
      "Merkez Mah (taypaklı Köyü)",
      "Merkez Mah (uzungürgen Köyü)",
      "Molla Mah (aloğlu Köyü)",
      "Mollooğlu Mah (alasökü Köyü)",
      "Mollooğlu Mah (melikşah Köyü)",
      "Muhsunlu Mah (çobanlar Köyü)",
      "Muhtaroğlu Mah (avdan Köyü)",
      "Musa Mah (eymir Köyü)",
      "Musa Mah (sinecan Köyü)",
      "Orta Mah (dibekli Köyü)",
      "Ova Mah (uzungürgen Köyü)",
      "Ömerbaşoğlu Mah (kozcuğaz Köyü)",
      "Öseli Mah (alasökü Köyü)",
      "Rumeli Mah (tangaloğlu Köyü)",
      "Sağır Mah (kozcuğaz Köyü)",
      "Sahilkent Mah (lala Köyü)",
      "Sakça Mah (kozcuğaz Köyü)",
      "Salamoğlu Mah (sazlı Köyü)",
      "Sancıoğlu Mah (lala Köyü)",
      "Sapı Mah (kozcuğaz Köyü)",
      "Saraycık Mah (abalı Köyü)",
      "Sarıdüz Mah (avdan Köyü)",
      "Sarıkum Köyü",
      "Sarısökü Mah (çakıldak Köyü)",
      "Sarsı Mah (abalı Köyü)",
      "Softaoğlu Mah (uzungürgen Köyü)",
      "Softooğlu Mah (melikşah Köyü)",
      "Soğuksu Mah (sazlı Köyü)",
      "Soğulcak Mah (abalı Köyü)",
      "Süleymanoğlu Mah (kabalı Köyü)",
      "Sülükgölü Mah (göllü Köyü)",
      "Şahin Mah (eymir Köyü)",
      "Şanlı Mah (çiftlik Köyü)",
      "Şehit Hasan Yılmaz Mah (kabalı Köyü)",
      "Şekerli Mah (göller Köyü)",
      "Şekerli Mah (taşmanlı Köyü)",
      "Şerbetçi Mah (göller Köyü)",
      "Tabanoğlu Mah (taşmanlı Köyü)",
      "Takaoğlu Mah (tangaloğlu Köyü)",
      "Tangaloğlu Mah (tangaloğlu Köyü)",
      "Taşlıca Mah (dibekli Köyü)",
      "Tavukçu Mah (lala Köyü)",
      "Tekneoğlu Mah (lala Köyü)",
      "Tepe Mah (dibekli Köyü)",
      "Tepe Mah (lala Köyü)",
      "Tepecik Mah (erikli Köyü)",
      "Teresu Mah (aloğlu Köyü)",
      "Tığlıoğlu Mah (avdan Köyü)",
      "Tıngırlar Mah (taypaklı Köyü)",
      "Tırmık Mah (taşmanlı Köyü)",
      "Tunustoğlu Mah (taypaklı Köyü)",
      "Ulu Mah (melikşah Köyü)",
      "Yagcı Mah (dibekli Köyü)",
      "Yaka Mah (kılıçlı Köyü)",
      "Yaka Mah (mertoğlu Köyü)",
      "Yalıboyu  Mah (heyamola Mah) (çiftlik Köyü)",
      "Yeni Mah (bektaşağa Köyü)",
      "Yerli Mah (hacıoğlu Köyü)",
      "Yeşilpınar Mah (karapınar Köyü)",
      "Yetimoğlu Mah (sinecan Köyü)",
      "Yörüklü Mah (göller Köyü)",
      "Yukarı Asarcık Mah (kirençukuru Köyü)",
      "Yukarı Mah (hacıoğlu Köyü)",
      "Yukarı Mah (mertoğlu Köyü)",
      "Yukarı Mah (sazlı Köyü)",
      "Yukarıkarapınar Mah (karapınar Köyü)",
      "Yukarıköy Mah (tıngıroğlu Köyü)",
      "Yürekli Mah (akbaş Köyü)",
      "Zarflı Mah (dizdaroğlu Köyü)",
      "Zenginoğlu Mah (melikşah Köyü)",
      "Ada Mah",
      "Bostancılı Mah",
      "Camikebir Mah",
      "Gelincik Mah",
      "İncedayı Mah",
      "Kaleyazısı Mah",
      "Kefevi Mah",
      "Korucuk Mah",
      "Meydankapı Mah",
      "Ordu Mah",
      "Osmaniye Mah",
      "Yeni Mah",
      "Zeytinlik Mah"
    ],
    "Saraydüzü": [
      "Akbelen Köyü",
      "Aluç Mah (avluca Köyü)",
      "Asarcıkcamili Köyü",
      "Asarcıkhacıköy Köyü",
      "Asarcıkkazaklı Köyü",
      "Aşağı Mah (bahşaşlı Köyü)",
      "Aşağı Mah (karaçaygöleti Köyü)",
      "Aşağıakpınar Köyü",
      "Avluca Köyü",
      "Balcılar Mah (çalpınar Köyü)",
      "Bürüm Mah (zaimköy Köyü)",
      "Cumaköy Köyü",
      "Cumatabaklı Köyü",
      "Çalaplı Mah (bahçeköy Köyü)",
      "Çalca Mah (yaylacılı Köyü)",
      "Çampaşalı Köyü",
      "Çobanlı Mah (asarcıkkayalı Köyü)",
      "Dere Mah (başekin Köyü)",
      "Dimbiloglu Mah (cumakayalı Köyü)",
      "Elicek Mah (yaylacılı Köyü)",
      "Göynükören Köyü",
      "Gülören Mah (yenice Köyü)",
      "Güney Mah (çalpınar Köyü)",
      "Gür Pınar Mah (çalpınar Köyü)",
      "Gürlen Mah (cumakayalı Köyü)",
      "Hacıçay Köyü",
      "Hanoğlu Köyü",
      "Hemitli Mah (çorman Köyü)",
      "Kadıoğlu Mah (bahçeköy Köyü)",
      "Kendirli Mah (bahçeköy Köyü)",
      "Kışla Mah (fakılı Köyü)",
      "Korucuk Köyü",
      "Koruk Mah (yukarıakpınar Köyü)",
      "Kozluca Mah (zaimköy Köyü)",
      "Köçbeyendi Mah (tepeköy Köyü)",
      "Merkez Mah (arım Köyü)",
      "Merkez Mah (asarcıkkayalı Köyü)",
      "Merkez Mah (bahçeköy Köyü)",
      "Merkez Mah (başekin Köyü)",
      "Merkez Mah (cumakayalı Köyü)",
      "Merkez Mah (çalpınar Köyü)",
      "Merkez Mah (çorman Köyü)",
      "Merkez Mah (fakılı Köyü)",
      "Merkez Mah (karaçaygöleti Köyü)",
      "Merkez Mah (tepeköy Köyü)",
      "Merkez Mah (yalmansaray Köyü)",
      "Merkez Mah (yaylacılı Köyü)",
      "Merkez Mah (yenice Köyü)",
      "Merkez Mah (yukarıakpınar Köyü)",
      "Merkez Mah (zaimköy Köyü)",
      "Orta Mah (arım Köyü)",
      "Orta Mah (başekin Köyü)",
      "Salmanlı Mah (başekin Köyü)",
      "Sögütlü Mah (cumakayalı Köyü)",
      "Şıh Mah (yenice Köyü)",
      "Uluköy Köyü",
      "Yonca Mah (zaimköy Köyü)",
      "Yukarı Elicek Mah (yaylacılı Köyü)",
      "Yukarı Mah (bahşaşlı Köyü)",
      "Yukarıarım Köyü",
      "Zeyve Mah (bahşaşlı Köyü)",
      "Merkez Mah"
    ],
    "Türkeli": [
      "Abaza Mah (direkli Köyü)",
      "Aca Mah (düz Köyü)",
      "Ağa Mah (ayaz Köyü)",
      "Akbudak Mah (taşgüney Köyü)",
      "Aktaş Mah (taşgüney Köyü)",
      "Apdi Mah (turhan Köyü)",
      "Araplar Mah (çatakgüney Köyü)",
      "Arpatarlası Mah (çatakgeriş Köyü)",
      "Aşağı Mah (ışıklı Köyü)",
      "Aşağı Marbel Mah (akçabük Köyü)",
      "Aşağı Tarla Mah (ışıklı Köyü)",
      "Aşpişen Mah (sazkışla Köyü)",
      "Ayan Çeşme Mah (yusuflu Köyü)",
      "Aydağlar Mah (çatakörencik Köyü)",
      "Aydınoğlu Mah (sarmaşık Köyü)",
      "Balaycık Mah (yusuflu Köyü)",
      "Baş Cible Mah (gökçealan Köyü)",
      "Başocak Mah (düzler Köyü)",
      "Bekiroğlu Mah (sarmaşık Köyü)",
      "Bilgili Mah (alagöz Köyü)",
      "Birnit Mah (turhan Köyü)",
      "Cami Yanı Mah (gökçealan Köyü)",
      "Cayla Mah (düz Köyü)",
      "Celaller Mah (çatakörencik Köyü)",
      "Cizmeci Mah (gökçealan Köyü)",
      "Cöve Mah (düz Köyü)",
      "Çağlayan Mah (oymayaka Köyü)",
      "Çarşamba Mah (karabey Köyü)",
      "Çatakdüzü Mah (karabey Köyü)",
      "Çay Mah (ayaz Köyü)",
      "Çay Mah (çatakgüney Köyü)",
      "Çay Mah (turhan Köyü)",
      "Çayağzı Mah (gencek Köyü)",
      "Çayırlar Mah (hamamlı Köyü)",
      "Çayla Mah (çatakgeriş Köyü)",
      "Çeşmeli Mah (düzler Köyü)",
      "Çınar Mah (satı Köyü)",
      "Çolaklar Mah (ışıklı Köyü)",
      "Çolakoğlu Mah (sarmaşık Köyü)",
      "Çömez Mah (kuşçular Köyü)",
      "Dayı Mah (yazıcı Köyü)",
      "De Mah (direkli Köyü)",
      "Değirmenönü Mah (ışıklı Köyü)",
      "Demirci Mah (akçabük Köyü)",
      "Demirci Mah (turhan Köyü)",
      "Demirkapı Mah (kuz Köyü)",
      "Dibek Yanı Mah (yazıcı Köyü)",
      "Düre Mah (hacı Köyü)",
      "Düz Tarla Mah (yazıcı Köyü)",
      "Ebe Mah (sarmaşık Köyü)",
      "Ekse Mah (gökçealan Köyü)",
      "Emrelli Mah (yusuflu Köyü)",
      "Erdoğdu Mah (taşgüney Köyü)",
      "Eski Ayadon Mah (direkli Köyü)",
      "Eyrek Mah (gökçealan Köyü)",
      "Fakıoğlu Mah (ayaz Köyü)",
      "Gedoy Mah (turhan Köyü)",
      "Gergü Mah (çatakgüney Köyü)",
      "Geriş Harman Mah (çatakgüney Köyü)",
      "Geriş Mah (gündoğdu Köyü)",
      "Gölgeci Mah (gökçealan Köyü)",
      "Görköy Mah (kayabaşı Köyü)",
      "Güllü Su Mah (oymayaka Köyü)",
      "Gültepe Mah (kuz Köyü)",
      "Gümle Mah (çatakgeriş Köyü)",
      "Güney Mah (turhan Köyü)",
      "Gürcüler Mah (yapraklı Köyü)",
      "Hacılar Mah (gündoğdu Köyü)",
      "Hamuzlar Mah (çatakgeriş Köyü)",
      "Harmanyanı Mah (düzler Köyü)",
      "Hasan Dağı Mah (kuz Köyü)",
      "Hatip Mah (çatakgüney Köyü)",
      "Hatip Mah (taşgüney Köyü)",
      "Hocaköy Mah (düzler Köyü)",
      "Hösgüden Mah (gencek Köyü)",
      "Kabaoğlu Mah (gökçealan Köyü)",
      "Kabbez Mah (ışıklı Köyü)",
      "Kalaycı Mah (yapraklı Köyü)",
      "Kapan Mah (taçahmet Köyü)",
      "Karaşlar Mah (yazıcı Köyü)",
      "Karşı Mah (düz Köyü)",
      "Karşı Mah (taçahmet Köyü)",
      "Karşı Mah (yazıcı Köyü)",
      "Kaya Mah (akçabük Köyü)",
      "Kayadibi Mah (kayabaşı Köyü)",
      "Kayracı Mah (kuşçular Köyü)",
      "Kestanecik Mah (çatakgüney Köyü)",
      "Keş Köyü",
      "Kıran Mah (turhan Köyü)",
      "Kışla Mah (sazkışla Köyü)",
      "Kilise Arkası Mah (direkli Köyü)",
      "Koca Mah (düz Köyü)",
      "Kocadüzü Mah (taçahmet Köyü)",
      "Koz Sökü Mah (kuşçular Köyü)",
      "Köseköy Mah (çatakgeriş Köyü)",
      "Köseoğlu Mah (gökçealan Köyü)",
      "Köseretaşı Mah (hacı Köyü)",
      "Kurtköy Mah (yeşiloba Köyü)",
      "Kurvana Mah (yeşiloba Köyü)",
      "Kuz Mah (gökçealan Köyü)",
      "Kuzgeçe Mah (çatakörencik Köyü)",
      "Kütülep Mah (çatakgeriş Köyü)",
      "Manav Mah (yapraklı Köyü)",
      "Mantarlık Mah (kuz Köyü)",
      "Memiş Mah (yapraklı Köyü)",
      "Merkez Mah (akçabük Köyü)",
      "Merkez Mah (alagöz Köyü)",
      "Merkez Mah (ayaz Köyü)",
      "Merkez Mah (çatakgeriş Köyü)",
      "Merkez Mah (çatakgüney Köyü)",
      "Merkez Mah (çatakörencik Köyü)",
      "Merkez Mah (direkli Köyü)",
      "Merkez Mah (düz Köyü)",
      "Merkez Mah (düzler Köyü)",
      "Merkez Mah (gaziler Köyü)",
      "Merkez Mah (gencek Köyü)",
      "Merkez Mah (gökçealan Köyü)",
      "Merkez Mah (gündoğdu Köyü)",
      "Merkez Mah (güzelkent Köyü)",
      "Merkez Mah (hacı Köyü)",
      "Merkez Mah (hamamlı Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kuşçular Köyü)",
      "Merkez Mah (kuz Köyü)",
      "Merkez Mah (oymayaka Köyü)",
      "Merkez Mah (satı Köyü)",
      "Merkez Mah (taçahmet Köyü)",
      "Merkez Mah (taşgüney Köyü)",
      "Merkez Mah (turhan Köyü)",
      "Merkez Mah (yapraklı Köyü)",
      "Merkez Mah (yazıcı Köyü)",
      "Merkez Mah (yusuflu Köyü)",
      "Mita Mah (gökçealan Köyü)",
      "Okul Mah (ışıklı Köyü)",
      "Orta Mah (gündoğdu Köyü)",
      "Osmançayırı Mah (çatakgeriş Köyü)",
      "Otca Mah (çatakgeriş Köyü)",
      "Ovanaz Mah (kayabaşı Köyü)",
      "Örenler Mah (kayabaşı Köyü)",
      "Örey Mah (hacı Köyü)",
      "Öte Mah (gündoğdu Köyü)",
      "Öteköy Mah (yapraklı Köyü)",
      "Palamar Mah (karabey Köyü)",
      "Pazaryeri Mah (yeşiloba Köyü)",
      "Reyfez Mah (yeşiloba Köyü)",
      "Safranlı Mah (karabey Köyü)",
      "Sahilkent Mah (ışıklı Köyü)",
      "Salah Mah (çatakörencik Köyü)",
      "Sancaktaroğlu Mah (akçabük Köyü)",
      "Sarpaca Mah (yeşiloba Köyü)",
      "Satı Mah (satı Köyü)",
      "Sazak Mah (sazkışla Köyü)",
      "Semiye Mah (turhan Köyü)",
      "Silahcı Mah (taçahmet Köyü)",
      "Siyem Mah (düz Köyü)",
      "Soğu Mah (yeşiloba Köyü)",
      "Sökü Mah (çatakgeriş Köyü)",
      "Sökü Mah (yeşiloba Köyü)",
      "Suluçukur Mah (sazkışla Köyü)",
      "Şavşat Mah (sazkışla Köyü)",
      "Tavaca Mah (gökçealan Köyü)",
      "Teciroğlu Mah (çatakörencik Köyü)",
      "Tümen Mah (ışıklı Köyü)",
      "Yalı Mah (gündoğdu Köyü)",
      "Yamayol Mah (oymayaka Köyü)",
      "Yayla Mah (gökçealan Köyü)",
      "Yazyurdu Mah (gencek Köyü)",
      "Yeni Mah (çatakgeriş Köyü)",
      "Yenice Mah (kuz Köyü)",
      "Yılanlık Mah (düzler Köyü)",
      "Yıldırım Mah (yusuflu Köyü)",
      "Yorgancıoğlu Mah (kuşçular Köyü)",
      "Yukarı Güney Mah (çatakgüney Köyü)",
      "Yukarı Mah (gündoğdu Köyü)",
      "Yukarı Mah (ışıklı Köyü)",
      "Yukarı Marbel Mah (akçabük Köyü)",
      "Yukarı Usva Mah (satı Köyü)",
      "Gemiyanı Mah",
      "Güzelyurt Mah",
      "Tümerkan Mah"
    ]
  },
  "Sivas": {
    "Akıncılar": [
      "Altıntepe Mah",
      "Cumhuriyet Mah",
      "Gönen Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yeşilyazı Mah",
      "Yukarı Mah",
      "Abdurrahman Köyü",
      "Aşağıyeniköy Köyü",
      "Avşar Köyü",
      "Balçık Köyü",
      "Ballıdere Köyü",
      "Bulak Mah (ballıdere Köyü)",
      "Çiçekli Köyü",
      "Çörengeç Mah (balçık Köyü)",
      "Derecik Köyü",
      "Doğantepe Köyü",
      "Dündar Köyü",
      "Ekenek Köyü",
      "Elibüyük Köyü",
      "Eskibağ Köyü",
      "Geyikpınar Köyü",
      "Göllüce Köyü",
      "Haremuşağı Mah (aşağıyeniköy Köyü)",
      "İkizyurt Mah",
      "Kavak Köyü",
      "Kayı Köyü",
      "Kılıç Köyü",
      "Onarı Köyü",
      "Ortaköy Köyü",
      "Sapanlı Köyü",
      "Sevindik Köyü",
      "Sıyrındı Köyü",
      "Şenbağlar Köyü",
      "Tırçik Mah (ballıdere Köyü)",
      "Uğrunca Köyü",
      "Üzengi Köyü",
      "Yağlıçayır Köyü",
      "Yukarısarıca Köyü",
      "Yusufşeyh Köyü",
      "Yünlüce Köyü"
    ],
    "Altınyayla": [
      "Aydın Mah",
      "Kale Mah",
      "Rıfat Öçten Mah",
      "Şafak Mah",
      "Başören Mah (deliilyas Beldesi)",
      "Gaziosmanpaşa Mah (deliilyas Beldesi)",
      "Merkez Mah (deliilyas Beldesi)",
      "Serinyayla Mah (deliilyas Beldesi)",
      "Yassıpınar Mah (deliilyas Beldesi)",
      "Yeşilyurt Mah (deliilyas Beldesi)",
      "Altınyurt Mah",
      "Başyayla Köyü",
      "Bayındır Mah (bayındır Köyü)",
      "Doğupınar Köyü",
      "Gümüşdiğin Köyü",
      "Güzeloğlan Mah",
      "Harmandalı Köyü",
      "Kızılhüyük Köyü",
      "Mutubey Köyü",
      "Paşaköy Köyü",
      "Tahyurt Köyü",
      "Taşlıhüyük Köyü"
    ],
    "Divriği": [
      "Abuçimen Mah",
      "Ahmetpaşa Mah",
      "Arhusu Mah",
      "Aşağıhamam Mah",
      "Ceditpaşa Mah",
      "Demirdağ Mah",
      "Dillioğlu Mah",
      "Gökçecamii Mah",
      "Güllübağ Mah",
      "Hacıkumru Mah",
      "Hacıosmanmescidi Mah",
      "İmamoğlu Mah",
      "Kale Mah",
      "Kalealtı Mah",
      "Karamahmut Mah",
      "Karayusuf Mah",
      "Kemenkeş Mah",
      "Kocapaşa Mah",
      "Küçük Hüseyin Mah",
      "Kültürlü Mah",
      "Maden Mah",
      "Mercantepe Mah",
      "Süleymanağa Mah",
      "Turabali Mah",
      "Ulucamii Mah",
      "Zeliha Hatun Mah",
      "Acıgöz Mah (tepehan Köyü)",
      "Adatepe Köyü",
      "Ağaçlıgöl Köyü",
      "Ağcadam Mah (bayırlı Köyü)",
      "Ahi Mah (güneyevler Köyü)",
      "Ahmetler Mah (susuzlar Köyü)",
      "Ahmetören Mah (incirlipınar Köyü)",
      "Akağıl Mah (kırkgöz Köyü)",
      "Akbaba Köyü",
      "Akmeşe Köyü",
      "Akpelit Köyü",
      "Apsal Mah (karakale Köyü)",
      "Arıkbaşı Köyü",
      "Atmalıoğlu Köyü",
      "Avşarcık Köyü",
      "Bahçeli Köyü",
      "Bahtiyar Köyü",
      "Balova Köyü",
      "Başmuhtar Mah (bayırlı Köyü)",
      "Başören Köyü",
      "Bayırlı Köyü",
      "Bayırüstü Köyü",
      "Beldibi Köyü",
      "Beyköy Köyü",
      "Burmahan Mah (duruköy Köyü)",
      "Çakırağa Köyü",
      "Çakırtarla Köyü",
      "Çakmakdüzü Köyü",
      "Çaltı Mah (çobandurağı Köyü)",
      "Çamlık Köyü",
      "Çamurlu Köyü",
      "Çartıl Mah (güvenkaya Köyü)",
      "Çatılı Mah (çamlık Köyü)",
      "Çayören Köyü",
      "Çayözü Köyü",
      "Çevirme Mah (mursal Köyü)",
      "Çiğdemli Köyü",
      "Çitme Köyü",
      "Çobandurağı Köyü",
      "Çobanlı Mah (üçpınar Köyü)",
      "Çokmeşat Mah (mursal Köyü)",
      "Çukuröz Köyü",
      "Dam Mah (kaledibi Köyü)",
      "Dazlak Mah (çiğdemli Köyü)",
      "Derekaya Mah (susuzlar Köyü)",
      "Derimli Köyü",
      "Dikmeçay Köyü",
      "Diktaş Köyü",
      "Dişbudak Köyü",
      "Dişler Mah (mursal Köyü)",
      "Doğan Mah (çamlık Köyü)",
      "Doğancık Mah (uzunbağ Köyü)",
      "Dolaçayı Mah (çayözü Köyü)",
      "Dumluca Köyü",
      "Duruköy Köyü",
      "Eğrisu Köyü",
      "Ekinbaşı Köyü",
      "Erikli Köyü",
      "Eskibeyli Köyü",
      "Gedikbaşı Köyü",
      "Gezey Köyü",
      "Gökçebel Köyü",
      "Gökçeharman Köyü",
      "Gölören Köyü",
      "Göndüren Köyü",
      "Görgüren Mah (karakale Köyü)",
      "Gözecik (merkez Bucağı) Köyü",
      "Gözecik (sincan Bucağı) Köyü",
      "Güçlü Mah (yeşilyol Köyü)",
      "Güdge Mah (eskibeyli Köyü)",
      "Güllüce Köyü",
      "Günbahçe Köyü",
      "Güneş Köyü",
      "Güneştepe Mah (susuzlar Köyü)",
      "Güneyevler Köyü",
      "Güresin Köyü",
      "Gürpınar Köyü",
      "Güvenkaya Köyü",
      "Güvenli Mah (gedikbaşı Köyü)",
      "Hacıboşlar Mah (yeşilyol Köyü)",
      "Halilbey Mah (güllüce Köyü)",
      "Hamuçimen Mah (çayözü Köyü)",
      "Handere Köyü",
      "Hıdırlık Mah (karakuzulu Köyü)",
      "Höbek Köyü",
      "Ilıca Mah (susuzlar Köyü)",
      "İkizbaşak Köyü",
      "İmirhan Köyü",
      "İnanlı Köyü",
      "İnanlı Mah (yalnızsöğüt Köyü)",
      "İncirlipınar Köyü",
      "İstasyon Mah (güneş Köyü)",
      "Kahramanlar Mah (çayözü Köyü)",
      "Kalederesi Mah (çayözü Köyü)",
      "Kaledibi Köyü",
      "Karaağaçlı Köyü",
      "Karaali Mah (maltepe Köyü)",
      "Karakale Köyü",
      "Karakaya Mah (mursal Köyü)",
      "Karakuzulu Köyü",
      "Karaman Köyü",
      "Karasar Köyü",
      "Karasarbeli Mah (karasar Köyü)",
      "Karşıkonak Köyü",
      "Karyağan Mah (tepehan Köyü)",
      "Kavaklısu Köyü",
      "Kayaburun Köyü",
      "Kayacık Mah",
      "Kaygısız Mah (gölören Köyü)",
      "Keçikaya Köyü",
      "Keklikpınar Mah (gökçeharman Köyü)",
      "Kekliktepe Köyü",
      "Kesme Köyü",
      "Kımıllar Mah (susuzlar Köyü)",
      "Kırkgöz Köyü",
      "Kızılcaören Köyü",
      "Konak Mah (beldibi Köyü)",
      "Kozlu Mah (erikli Köyü)",
      "Kozluca Mah (çayözü Köyü)",
      "Körküsü Mah (derimli Köyü)",
      "Kuluncak Köyü",
      "Kutlu Mah (maltepe Köyü)",
      "Madenli Köyü",
      "Maltepe Köyü",
      "Mikail Mah (mursal Köyü)",
      "Mursal Köyü",
      "Oğulbey Köyü",
      "Olukman Köyü",
      "Ortaköy Köyü",
      "Ovacık Köyü",
      "Oyuktepe Köyü",
      "Ödek Köyü",
      "Ölçekli Köyü",
      "Ömerli Mah (madenli Köyü)",
      "Özbağı Köyü",
      "Özlüce Mah (ölçekli Köyü)",
      "Paşa Mah (çayözü Köyü)",
      "Purunsur Mah",
      "Sağırtaş Mah (çayözü Köyü)",
      "Sağlık Mah (kaledibi Köyü)",
      "Sarpan Mah (yuva Köyü)",
      "Selimoğlu Köyü",
      "Seyfedamı Mah (kaledibi Köyü)",
      "Sırçalı Köyü",
      "Sincan Köyü",
      "Soğucak Köyü",
      "Susuzlar Köyü",
      "Susuzören Köyü",
      "Sütlüce Mah (kavaklısu Köyü)",
      "Şahinköy Köyü",
      "Tekke Mah (güneş Köyü)",
      "Tepehan Köyü",
      "Tipik Mah (kaledibi Köyü)",
      "Tirollar Mah (susuzlar Köyü)",
      "Topluca Mah (çamlık Köyü)",
      "Tortu Mah (sincan Köyü)",
      "Tötük Mah (imirhan Köyü)",
      "Türkali Mah (ödek Köyü)",
      "Uluçayır Köyü",
      "Uzunbağ Köyü",
      "Uzunkaya Köyü",
      "Üçpınar Köyü",
      "Ürük Köyü",
      "Yağbasan Köyü",
      "Yalnızsöğüt Köyü",
      "Yazı Köyü",
      "Yerliçay Köyü",
      "Yeşilköy Mah (çobandurağı Köyü)",
      "Yeşilyayla Köyü",
      "Yeşilyol Köyü",
      "Yılan Mah (güvenkaya Köyü)",
      "Yusufşeyh Köyü",
      "Yuva Köyü",
      "Yuva Mah (mursal Köyü)",
      "Yünlüce Mah (kızılcaören Köyü)",
      "Zeynikler Mah (çobandurağı Köyü)"
    ],
    "Doğanşar": [
      "Camikebir Mah",
      "Cinci Mah",
      "Çay Mah",
      "Devrişağa Mah",
      "Kale Mah",
      "Ömerağa Mah",
      "Alan Köyü",
      "Alazlı Köyü",
      "Aslantaş Köyü",
      "Aşağı Mah (başekin Köyü)",
      "Avcıçayı Köyü",
      "Bağderesi Mezrası Mah (ekinciler Köyü)",
      "Başekin Köyü",
      "Beşağaç Mah (beşağaç Köyü)",
      "Boyalı Köyü",
      "Buruncuk Mah (beşağaç Köyü)",
      "Çalıcı Köyü",
      "Çatpınar Köyü",
      "Darıkol Köyü",
      "Dere Mah (kozlu Köyü)",
      "Deveci Mezrası Mah (söbüler Köyü)",
      "Dönedere Mezrası Mah (ekinciler Köyü)",
      "Ekinciler Köyü",
      "Eskiköy Köyü",
      "Göçüköy Köyü",
      "Gülşehir Mezrası Mah (yavşancık Köyü)",
      "Hamam Mah (kozlu Köyü)",
      "İçdere Köyü",
      "Karacaali Mah (beşağaç Köyü)",
      "Karacakaya 1 Mah (karkın Köyü)",
      "Karacakaya 2 Mah (karkın Köyü)",
      "Karkın Mah (karkın Köyü)",
      "Kelosmangil Mah (başekin Köyü)",
      "Kıpcak Köyü",
      "Kozağaç Köyü",
      "Kozlu Köyü",
      "Okculu Köyü",
      "Orta Mezra Mah (söbüler Köyü)",
      "Ortaköy Köyü",
      "Sarısuvat Köyü",
      "Söbüler Köyü",
      "Tavza Köyü",
      "Ütük Köyü",
      "Yavşancık Köyü",
      "Yeşilçukur Köyü"
    ],
    "Gemerek": [
      "Alaybey Mah (çepni Beldesi)",
      "Ş.binbaşı Mehmet Aras Mah (çepni Beldesi)",
      "Uğur Mumcu Mah (çepni Beldesi)",
      "Bahçelievler Mah (eğerci Köyü)",
      "Göksu Mah (eğerci Köyü)",
      "Karşıyaka Mah (eğerci Köyü)",
      "Ali Kemali Efendi Mah",
      "Alperen Mah",
      "Bahçeli Mah",
      "Fevziçakmak Mah",
      "Horuk Mah",
      "Yukarı Mah",
      "Bağlarbaşı Mah (inkışla Köyü)",
      "Bahçelievler Mah (inkışla Köyü)",
      "Abdurrahmanlar Mezrası Mah (öziçi Köyü)",
      "Ademin Yaylası Mah (çat Köyü)",
      "Akçaşar Köyü",
      "Aligillerin Yaylası Mah (çat Köyü)",
      "Aşağı Kazaklı Mezrası Mah (öziçi Köyü)",
      "Baştepeler Köyü",
      "Bulhasan Köyü",
      "Burhan Köyü",
      "Cesurlar Köyü",
      "Cevizcik Mah (cesurlar Köyü)",
      "Çat Köyü",
      "Çiçekoğlu Köyü",
      "Dendil Köyü",
      "Durgunsu Köyü",
      "Ebiller Mah (öziçi Köyü)",
      "Ekizce Köyü",
      "Eskiçubuk Köyü",
      "Eskiyurt Köyü",
      "Eşikli Köyü",
      "Hacıyusuf Köyü",
      "Hatabalanı Yaylası Mah (çat Köyü)",
      "Kabaktepe Mah (köseli Köyü)",
      "Karaağıl Köyü",
      "Karaerkek Köyü",
      "Karagöl Köyü",
      "Kartalkaya Köyü",
      "Keklicek Köyü",
      "Kilisealan Yaylası Mah (çat Köyü)",
      "Kocaoğlu Köyü",
      "Köseli Köyü",
      "Kuşkayası Mah (talazoğlu Köyü)",
      "Küçüktuzhisar Köyü",
      "Kümeören Köyü",
      "Neciplerin Yaylası Mah (çat Köyü)",
      "Osmanuşağı Köyü",
      "Ömerçavuş Yaylası Mah (çat Köyü)",
      "Örenyurt Köyü",
      "Öziçi Köyü",
      "Sarıkaya Mah (cesurlar Köyü)",
      "Seydinali Köyü",
      "Sıyırmalı Mah (öziçi Köyü)",
      "Talazoğlu Köyü",
      "Tatlıpınar Köyü",
      "Tekmen Köyü",
      "Üçaıl Mezrası Mah (durgunsu Köyü)",
      "Yayla Evi Mah (çat Köyü)",
      "Yeniköy Köyü",
      "Yeşilöz Köyü",
      "Yukarı Kazaklı Mezrası Mah (öziçi Köyü)",
      "Arpaözü Mah (sızır Beldesi)",
      "Kalebaşı Mah (sızır Beldesi)",
      "Köprübaşı Mah (sızır Beldesi)",
      "Subaşı Mah (sızır Beldesi)",
      "Yeni Mah (sızır Beldesi)",
      "Gaziosmanpaşa Mah",
      "Karacalar Mah",
      "Muhsin Yazıcıoğlu Mah",
      "Yenidoğan Mah",
      "Yenihayat Mah"
    ],
    "Gölova": [
      "A.camii Mah",
      "Alsancak Mah",
      "Çalkaya Mah",
      "Fevzi Çakmak Mah",
      "Akçataş Köyü",
      "Arslanca Köyü",
      "Aşagı Mah (yukarıtepecik Köyü)",
      "Aşağıtepecik Köyü",
      "Aydoğdu Köyü",
      "Bezgin Mah (yuvacık Köyü)",
      "Boğazköy Köyü",
      "Bozat Köyü",
      "Canköy Köyü",
      "Çakırşeyh Köyü",
      "Çataklı Köyü",
      "Çevrecik Köyü",
      "Çobanlı Köyü",
      "Çubuk Mah (karayakup Köyü)",
      "Çukuryurt Köyü",
      "Demirkonak Köyü",
      "Dikköy Köyü",
      "Gedik Mah (yaylaçayı Köyü)",
      "Gözlüce Köyü",
      "Gözüküçük Köyü",
      "Günalan Köyü",
      "Güzören Köyü",
      "İlyasköy Köyü",
      "Karaca Köyü",
      "Karayakup Köyü",
      "Kayaoğlu Mah (aydoğdu Köyü)",
      "Kolbaşı Mah (yaylaçayı Köyü)",
      "Okçaören Köyü",
      "Ödemiş Mah (gözlüce Köyü)",
      "Sarıçiçek Mah (çevrecik Köyü)",
      "Sarıyusuf Köyü",
      "Soğuksu Köyü",
      "Subaşı Köyü",
      "Uluçukur Köyü",
      "Yaylaçayı Köyü",
      "Yukarı Dik Mah (dikköy Köyü)",
      "Yukarıtepecik Köyü",
      "Yuvacık Köyü"
    ],
    "Gürün": [
      "Aksu Mah",
      "Boğaziçi Mah",
      "Burçevi Mah",
      "Çayboyu Mah",
      "Çörten Mah",
      "Gökpınar Mah",
      "Hacılar Mah",
      "Işıtan Mah",
      "Karatepe Mah",
      "Karayar Mah",
      "Karşıyaka Mah",
      "Ketençayır Mah",
      "Kirazlık Mah",
      "Kurultay Mah",
      "Pınarönü Mah",
      "Şuğul Mah",
      "Yassıcatepe Mah",
      "Yeni Mah",
      "Yeşilyurt Mah",
      "Ağpınar Mezrası Mah (çamlıca Köyü)",
      "Akdere Köyü",
      "Akpınar Köyü",
      "Algın Mezrası Mah (mahkenli Köyü)",
      "Arpaçukuru Mezrası Mah (bozhüyük Köyü)",
      "Aşağı Çatkara Mezrası Mah (karadoruk Köyü)",
      "Aşağı Kürkçü Mezrası Mah (koyunlu Köyü)",
      "Aşağı Yaylacık Mezrası Mah (yaylacık Köyü)",
      "Avgun Mezrası Mah (mahkenli Köyü)",
      "Ayranca Mezrası Mah (eskihamal Köyü)",
      "Ayvalı Köyü",
      "Bağlıçay Köyü",
      "Bahçeiçi Köyü",
      "Başören Köyü",
      "Başpınar Mezrası Mah (karahisar Köyü)",
      "Behram Mezrası Mah (konakpınar Köyü)",
      "Beypınar Köyü",
      "Bozhüyük Köyü",
      "Boztaş Mezrası Mah (konakpınar Köyü)",
      "Böğrüdelik Köyü",
      "Camiliyurt Köyü",
      "Cırıkpınarı Mezrası Mah (çamlıca Köyü)",
      "Cıvcık Mezrası Mah (çamlıca Köyü)",
      "Çamlıca Köyü",
      "Çapak Mezrası Mah (sarıca Köyü)",
      "Çevirme Mah (konakpınar Köyü)",
      "Çevirme Mezrası Mah (mahkenli Köyü)",
      "Çiçekyurt Köyü",
      "Çöplü Mezrası Mah (karadoruk Köyü)",
      "Davulhüyük Köyü",
      "Dayakpınar Köyü",
      "Deveçayırı Köyü",
      "Dırışlar Mezrası Mah (eskihamal Köyü)",
      "Düğünyurdu Mezrası Mah (karadoruk Köyü)",
      "Dürmepınar Köyü",
      "Erdoğan Köyü",
      "Ergeç Mezrası Mah (kavakköy Köyü)",
      "Eskibektaşlı Köyü",
      "Eskihamal Köyü",
      "Fatmaderviş Mezrası Mah (yelken Köyü)",
      "Gelincik Mezrası Mah (başören Köyü)",
      "Göbekören Köyü",
      "Gökçeyazı Köyü",
      "Gübünören Mezrası Mah (çamlıca Köyü)",
      "Güldede Köyü",
      "Güllübucak Köyü",
      "Gülpınar Mezrası Mah (güllübucak Köyü)",
      "Güneş Köyü",
      "Hüyüklüyurt Köyü",
      "İncesu Köyü",
      "Kafile Çayırı Mezrası Mah (çamlıca Köyü)",
      "Kaledere Köyü",
      "Kaloyak Yaylası Mah (çamlıca Köyü)",
      "Karadoruk Köyü",
      "Karahisar Köyü",
      "Karakuyu Köyü",
      "Karaören Köyü",
      "Karapınar Köyü",
      "Karayolu Üzeri Mah (konakpınar Köyü)",
      "Kaşköy Köyü",
      "Kavakköy Köyü",
      "Kayalar Köyü",
      "Kaynarca Köyü",
      "Kılıçdoğan Köyü",
      "Kındıralık Köyü",
      "Kışla Mezrası Mah (osmandede Köyü)",
      "Kızılburun Köyü",
      "Kızılören Köyü",
      "Kızılpınar Köyü",
      "Konakgörmez Mezrası Mah (mahkenli Köyü)",
      "Konakpınar Köyü",
      "Kovalıpınar Mezrası Mah (tepecik Köyü)",
      "Koyunlu Köyü",
      "Koyunlukoca Mezrası Mah (eskihamal Köyü)",
      "Kozakmağara Mezrası Mah (eskihamal Köyü)",
      "Körpınar Mezrası Mah (çamlıca Köyü)",
      "Kötüköy Mezrası Mah (incesu Köyü)",
      "Kuşkayası Mezrası Mah (çamlıca Köyü)",
      "Kuz Mezrası Mah (karadoruk Köyü)",
      "Kuzuluk Mezrası Mah (kavakköy Köyü)",
      "Külahlı Köyü",
      "Kürkcü Köyü",
      "Mağara Köyü",
      "Mahkenli Köyü",
      "Mudafar Mezrası Mah (çamlıca Köyü)",
      "Orta Çatkara Mezrası Mah (eskibektaşlı Köyü)",
      "Osmandede Köyü",
      "Reşadiye Köyü",
      "Sakaltutan Mezrası Mah (böğrüdelik Köyü)",
      "Sarıca Köyü",
      "Sarıören Mezrası Mah (güllübucak Köyü)",
      "Sularbaşı Köyü",
      "Sümbüllüyurt Mezrası Mah (karadoruk Köyü)",
      "Şıklar Yaylası Mah (çamlıca Köyü)",
      "Taşlıhüyük Mezrası Mah (yılanhüyük Köyü)",
      "Tepecik Köyü",
      "Tiken Ağası Mezrası Mah (çamlıca Köyü)",
      "Tökler Mezrası Mah (sarıca Köyü)",
      "Ulupınar Mezrası Mah (tepecik Köyü)",
      "Yaylacık Köyü",
      "Yazyurdu Köyü",
      "Yelken Köyü",
      "Yenibektaşlı Köyü",
      "Yeşildere Köyü",
      "Yeşilyurt Mezrası Mah (karahisar Köyü)",
      "Yılanhüyük Köyü",
      "Yolgeçen Köyü",
      "Yukarı Çakkara Mezrası Mah (karadoruk Köyü)",
      "Yuva Köyü"
    ],
    "Hafik": [
      "Çay Mah",
      "Fatih Mah",
      "Günyamaç Mah",
      "Koç Mah",
      "Tepe Mah",
      "Yeni Mah",
      "Acıpınar Köyü",
      "Adamlı Köyü",
      "Ahmetuşağı Mah (çimenyenice Köyü)",
      "Akkaya Köyü",
      "Aktaş Köyü",
      "Alanyurt Köyü",
      "Alçıören Köyü",
      "Alibeyli Köyü",
      "Aşağı Çaltılı Mah (çaltılı Köyü)",
      "Aylıoğlu Köyü",
      "Bahçecik Köyü",
      "Bakımlı Köyü",
      "Barcın Mah (kızılcaören Köyü)",
      "Bayıraltı Köyü",
      "Bayramtepe Köyü",
      "Benlikaya Köyü",
      "Besinli Köyü",
      "Beydili Köyü",
      "Beykonağı Köyü",
      "Celalli Köyü",
      "Çakmak Köyü",
      "Çaltılı Köyü",
      "Çatma Mah (beykonağı Köyü)",
      "Çınarlı Köyü",
      "Çimenyenice Köyü",
      "Çömlekli Köyü",
      "Çukurtarla Mah (bayıraltı Köyü)",
      "Değirmenboğazı Köyü",
      "Değirmenseki Köyü",
      "Demircilik Köyü",
      "Derince Köyü",
      "Dışkapı Köyü",
      "Dosturoğlu Mah (gölcük Köyü)",
      "Durulmuş Köyü",
      "Düğer Köyü",
      "Dündar Köyü",
      "Düzyayla Köyü",
      "Ekingölü Köyü",
      "Emrahınağılı Mah (yarhisar Köyü)",
      "Emre Köyü",
      "Esenli Köyü",
      "Esentepe Köyü",
      "Eskiheze Mah (bayramtepe Köyü)",
      "Eskiköy Mah (düğer Köyü)",
      "Evci Köyü",
      "Eymir Köyü",
      "Gedikçayırı Köyü",
      "Gölcük Köyü",
      "Göydün Köyü",
      "Günyamaç Köyü",
      "Hıdıruşağı Mah (çimenyenice Köyü)",
      "Hoplamaz Mah (bakımlı Köyü)",
      "İnandık Köyü",
      "İnköy Köyü",
      "İsmailhanı Mah (pirhüseyin Köyü)",
      "Kabalı Köyü",
      "Kamışköy Köyü",
      "Karapınar Mah (düğer Köyü)",
      "Karapınar Mah (gölcük Köyü)",
      "Karayaprak Köyü",
      "Karlı Köyü",
      "Kavak Mah (beykonağı Köyü)",
      "Kavakderesi Mah (düğer Köyü)",
      "Kaytarmış Köyü",
      "Keklicek Mah (beydili Köyü)",
      "Keleş Mah (besinli Köyü)",
      "Kızılcaören Köyü",
      "Kızılören Köyü",
      "Koçali Mah (düğer Köyü)",
      "Koşutdere Köyü",
      "Kozağacı Mah (celalli Köyü)",
      "Kurtini Mah (kızılcaören Köyü)",
      "Kurugöl Köyü",
      "Küpecik Köyü",
      "Maden Köyü",
      "Mansurlu Köyü",
      "Mercimek Deresi Mah (düğer Köyü)",
      "Molla Mah (kızılören Köyü)",
      "Olukbaşı Köyü",
      "Otmanalan Köyü",
      "Oymadere Köyü",
      "Öreğil Köyü",
      "Özen Köyü",
      "Pirhüseyin Köyü",
      "Pusat Köyü",
      "Saray Mah (kızılcaören Köyü)",
      "Sarıköy Mah (düğer Köyü)",
      "Sarımsak Mah (kızılcaören Köyü)",
      "Sofular Köyü",
      "Soğuk Pınar Mah (tuzhisar Köyü)",
      "Süleymaniye Köyü",
      "Şahin Köyü",
      "Tavşanlı Köyü",
      "Terekli Mah (gedikçayırı Köyü)",
      "Topçuyeniköy Köyü",
      "Tuzhisar Köyü",
      "Uzamış Mah (düğer Köyü)",
      "Üzeyir Köyü",
      "Veliışık Mah (düğer Köyü)",
      "Yağcılar Mah (beydili Köyü)",
      "Yakaboyu Köyü",
      "Yalıncak Köyü",
      "Yalnızağıl Köyü",
      "Yarhisar Köyü",
      "Yazlıkyurdu Mah (beydili Köyü)",
      "Yellice Mah (kızılcaören Köyü)",
      "Yeni Günyamaç Mah (günyamaç Köyü)",
      "Yeniköy Köyü",
      "Yukarıoba Mah (beykonağı Köyü)",
      "Yuva Mah (karlı Köyü)"
    ],
    "İmranlı": [
      "Çarşıbaşı Mah",
      "Durcan Mah",
      "Karatekin Mah",
      "Karşıyaka Mah",
      "Kızılırmak Mah",
      "Valituncel Mah",
      "Yaylacık Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Akçakale Köyü",
      "Akkaya Köyü",
      "Alacahacı Köyü",
      "Alanyurt Mah (eskidere Köyü)",
      "Altınca Köyü",
      "Araplar Mah (taşlıca Köyü)",
      "Ardıçalan Köyü",
      "Arık Köyü",
      "Aşağıboğaz Köyü",
      "Aşağıculha Köyü",
      "Aşağışeyhli Köyü",
      "Atlıca Köyü",
      "Avşar Köyü",
      "Aydın Köyü",
      "Aydoğan Köyü",
      "Ayrancı Mah (yürektaşı Köyü)",
      "Bağyazı Köyü",
      "Bahadun Köyü",
      "Bahtiyar Köyü",
      "Balkaya Mah (yozyatağı Köyü)",
      "Bandıra Mah (arık Köyü)",
      "Bardaklı Köyü",
      "Başlıca Köyü",
      "Becek Köyü",
      "Beğendik Köyü",
      "Boğanak Köyü",
      "Boğazören Köyü",
      "Borular Köyü",
      "Bulgurluk Köyü",
      "Celaldamı Köyü",
      "Cerit Köyü",
      "Çalıyurdu Mah (yoncabayırı Köyü)",
      "Çalıyurt Köyü",
      "Çatma Mah (koruköy Köyü)",
      "Çavuşdere Mah (koruköy Köyü)",
      "Çimen Mah (yoncabayırı Köyü)",
      "Çukuryurt Köyü",
      "Dağyurdu Köyü",
      "Darıseki Köyü",
      "Değirmendere Mah (ortaköy Köyü)",
      "Deli Mahmut Mah (gökçebel Köyü)",
      "Delice Köyü",
      "Demirtaş Köyü",
      "Dereköy Köyü",
      "Doğançal Köyü",
      "Ekincik Köyü",
      "Elmaseki Mah (yünören Köyü)",
      "Erdemşah Köyü",
      "Eskidere Köyü",
      "Eskikapımahmut Köyü",
      "Eskikeşlik Köyü",
      "Gelenli Köyü",
      "Gelintarla Köyü",
      "Gökçebel Köyü",
      "Gökdere Köyü",
      "Gölağıl Mah (yozyatağı Köyü)",
      "Görünmezkale Köyü",
      "Gül Mustafa Mezrası Mah (koyunkaya Köyü)",
      "Gürgen Mah (koruköy Köyü)",
      "Güven Köyü",
      "Haliller Köyü",
      "Hallas Mah (yünören Köyü)",
      "Handere Mah (yozyatağı Köyü)",
      "Hanköy Mah (kılıçköy Köyü)",
      "Hasköy Mah (demirtaş Köyü)",
      "Hemolar Mah (yazıkavak Köyü)",
      "Hüseyin Onbaşı Mah (kapıkaya Köyü)",
      "Kapıkaya Köyü",
      "Kapumahmut Köyü",
      "Karaboğaz Köyü",
      "Karacahisar Köyü",
      "Karacaören Köyü",
      "Karaçayır Köyü",
      "Karahüseyin Köyü",
      "Karapınar Köyü",
      "Karataş Köyü",
      "Karlık Köyü",
      "Karşiki Mah (koruköy Köyü)",
      "Kasaplar Köyü",
      "Kavaklıdere Mah (kapumahmut Köyü)",
      "Kavalcık Köyü",
      "Kelek Mah (bulgurluk Köyü)",
      "Kemreli Köyü",
      "Kepez Mah (eskidere Köyü)",
      "Kerimoğlu Köyü",
      "Kevenli Köyü",
      "Kılıçköy Köyü",
      "Kılıçlar Köyü",
      "Kızılmezra Köyü",
      "Kızıloluk Mah (çalıyurt Köyü)",
      "Kızıltepe Köyü",
      "Koçgediği Köyü",
      "Koruköy Köyü",
      "Koyunkaya Köyü",
      "Körabbas Köyü",
      "Körhemo Mah (demirtaş Köyü)",
      "Kuzköy Köyü",
      "Maden Köyü",
      "Maden Mezrası Mah (maden Köyü)",
      "Melekler Mah (cerit Köyü)",
      "Melekler Mezrası Mah (kapumahmut Köyü)",
      "Ortakdaracık Köyü",
      "Ortaköy Köyü",
      "Ortaköy Mah (yozyatağı Köyü)",
      "Palanga Mah (gelintarla Köyü)",
      "Perçemli Mah (yoncabayırı Köyü)",
      "Piredede Köyü",
      "Pur Mah (haliller Köyü)",
      "Pür Mah (gelenli Köyü)",
      "Refik Köyü",
      "Sandal Köyü",
      "Sıddıklar Mah (atlıca Köyü)",
      "Sinek Köyü",
      "Söğütlü Köyü",
      "Söğütlü-gelenli Mah (gelenli Köyü)",
      "Şahbaz Mah (koruköy Köyü)",
      "Şıhlar Mah (koruköy Köyü)",
      "Taşdelen Köyü",
      "Taşlıca Köyü",
      "Taşlıca Mah (yürektaşı Köyü)",
      "Toklucak Köyü",
      "Topallar Köyü",
      "Toptaş Köyü",
      "Tuzözü Köyü",
      "Türkkeşlik Köyü",
      "Türkyenice Köyü",
      "Uyanık Köyü",
      "Uzuntemur Köyü",
      "Yakayeri Köyü",
      "Yapraklıpınar Köyü",
      "Yayla Evleri Mah (karataş Köyü)",
      "Yazıkavak Köyü",
      "Yazılı Köyü",
      "Yenikent Köyü",
      "Yeniköy Köyü",
      "Yenimahalle Mah (karapınar Köyü)",
      "Yoncabayırı Köyü",
      "Yozyatağı Köyü",
      "Yukarıboğaz Köyü",
      "Yukarıculha Köyü",
      "Yünören Köyü",
      "Yürektaşı Köyü"
    ],
    "Kangal": [
      "Göze Mah",
      "Gürsel Mah",
      "Hürriyet Mah",
      "Karşıyaka Mah",
      "Reşadiye Mah",
      "Sularbaşı Mah",
      "Yeni Mah",
      "Zafer Mah",
      "Akçakale Köyü",
      "Akçamağara Köyü",
      "Akçaşehir Köyü",
      "Akdere Köyü",
      "Akgedik Köyü",
      "Akgedik Mah (yeşilkale Köyü)",
      "Akpınar Köyü",
      "Aktepe Köyü",
      "Alacahan Yeniköy Köyü",
      "Armağan Köyü",
      "Arpalı Köyü",
      "Aşağıhüyük Köyü",
      "Atatürk Mah (havuz Köyü)",
      "Avşarören Köyü",
      "Bahçeliyurt Köyü",
      "Bayındır Mah (sultanpınarı Köyü)",
      "Bayındır Mah (yeşilkale Köyü)",
      "Bektaşköy Köyü",
      "Beyyurdu Köyü",
      "Boğaz Köyü",
      "Bozarmut Köyü",
      "Bulak Köyü",
      "Cevizköy Köyü",
      "Cumhuriyet Mah (alacahan Köyü)",
      "Cumhuriyet Mah (çetinkaya Köyü)",
      "Cumhuriyet Mah (havuz Köyü)",
      "Çağlıcaören Köyü",
      "Çakırın Köyü Mah (mühürkulak Köyü)",
      "Çakırınköy Mah (hatunçayırı Köyü)",
      "Çakırınköyü Mah (hatunçayırı Köyü)",
      "Çalözü Mah (kuşkayası Köyü)",
      "Çamlık Mah (dereköy Köyü)",
      "Çamurlu Köyü",
      "Çarşıbaşı Mah (alacahan Köyü)",
      "Çatalağıl Mah (onaran Köyü)",
      "Çatköy Köyü",
      "Çayırova Köyü",
      "Çiftlikören Köyü",
      "Çipil Köyü",
      "Çukurçayır Mah (arpalı Köyü)",
      "Dabanözü Mah (çetinkaya Köyü)",
      "Dağönü Köyü",
      "Davulbaz Köyü",
      "Davutoğlu Mah (pınargözü Köyü)",
      "Dayılı Köyü",
      "Değirmen Dere Mah (bektaşköy Köyü)",
      "Deli Hacı Mah (kavak Köyü)",
      "Deligazili Köyü",
      "Deliktaş Köyü",
      "Delioğlanderesi Köyü",
      "Dereköy Köyü",
      "Dışlık Köyü",
      "Dipoğlu Mah (killik Köyü)",
      "Düzce Köyü",
      "Eğricek Köyü",
      "Ekizce Mah (külekli Köyü)",
      "Elalibey Köyü",
      "Elkondu Köyü",
      "Etyemez Köyü",
      "Eymir Köyü",
      "Fatih Mah (çetinkaya Köyü)",
      "Fatih Mah (havuz Köyü)",
      "Gebelikatran Köyü",
      "Gelincik Kayası Mah (bektaşköy Köyü)",
      "Gemalmaz Mah (kavak Köyü)",
      "Gençali Köyü",
      "Göktaş Mah (karacaören Köyü)",
      "Göller Mah (külekli Köyü)",
      "Güneypınar Köyü",
      "Günlice Mah (elalibey Köyü)",
      "Gürsel Mah (çetinkaya Köyü)",
      "Gürükbekir Köyü",
      "Hacı Hasanlar Mah (yeşildere Köyü)",
      "Hamal Köyü",
      "Hamzabey Köyü",
      "Humarlı Köyü",
      "Hürriyet Mah (alacahan Köyü)",
      "Hüyüklüyurt Köyü",
      "Irmaç Köyü",
      "İğdeli Köyü",
      "İğdelidere Köyü",
      "İlyasın Ağılı Mah (çipil Köyü)",
      "İmamınköyü Köyü",
      "Kabakçevliği Köyü",
      "Kabakyazı Mah (bektaşköy Köyü)",
      "Kalkım Köyü",
      "Kangaltekkesi Köyü",
      "Kapçıl Mah (kavak Mescit Köyü)",
      "Karaabdi Mah (akçamağara Köyü)",
      "Karacaören Köyü",
      "Karagücük Köyü",
      "Karamehmetli Köyü",
      "Karanlık Köyü",
      "Karasüver Köyü",
      "Kargakalesi Mah (kuşkayası Köyü)",
      "Karşıyaka Mah (çetinkaya Köyü)",
      "Kavak Köyü",
      "Kavak Mah (kavak Köyü)",
      "Kavak Mescit Köyü",
      "Kayapınar Mah (kalkım Köyü)",
      "Keçeci Mah (çağlıcaören Köyü)",
      "Kervansaray Mah (alacahan Köyü)",
      "Keşpınar Mah (akçakale Köyü)",
      "Kılıçdere Mah (onaran Köyü)",
      "Kınalar Mah (kalkım Köyü)",
      "Kırkpınar Köyü",
      "Kırlangıç Mah (elalibey Köyü)",
      "Kızıldikme Köyü",
      "Kızıleniş Köyü",
      "Killik Köyü",
      "Kocakurt Köyü",
      "Koçköprü Köyü",
      "Kuruayşe Köyü",
      "Kuşkayası Köyü",
      "Külekli Köyü",
      "Kürkçü Köyü",
      "Maksutlu Köyü",
      "Mancılık Köyü",
      "Mescit Köyü",
      "Mısırören Köyü",
      "Minarekaya Köyü",
      "Mühürkulak Köyü",
      "Mürsel Köyü",
      "Oğlaklı Köyü",
      "Onaran Köyü",
      "Ortaköy Mah (cevizköy Köyü)",
      "Örencik Köyü",
      "Paşamçayırı Köyü",
      "Pınargözü Köyü",
      "Sacayağı Köyü",
      "Sarıkadı Köyü",
      "Sarıpınar Köyü",
      "Satıören Mah (akçakale Köyü)",
      "Seçenyurdu Köyü",
      "Sekiliyurt Mah (sarıpınar Köyü)",
      "Sipahi Mah (sipahi Köyü)",
      "Soğukpınar Köyü",
      "Sultanpınarı Köyü",
      "Sutaşı Köyü",
      "Sülükgölü Mah (killik Köyü)",
      "Şekerpınar Köyü",
      "Şıhlar Mah (killik Köyü)",
      "Tahtalı Köyü",
      "Taşgeçit Mah (pınargözü Köyü)",
      "Taşlı Köyü",
      "Taşlık Köyü",
      "Tatlıpınar Köyü",
      "Temurun Köyü Mah (kavak Köyü)",
      "Tersekan Mah (hamal Köyü)",
      "Tilkihüyük Köyü",
      "Topardıç Köyü",
      "Turnalı Köyü",
      "Ufacıkören Mah (yellice Köyü)",
      "Yakıngebeli Mah (gebelikatran Köyü)",
      "Yarhisar Köyü",
      "Yaylacık Köyü",
      "Yellice Köyü",
      "Yeşildere Köyü",
      "Yeşilkale Köyü",
      "Yeşilvadi Köyü",
      "Yeşilyurt Köyü",
      "Yukarıhüyük Köyü",
      "Zaal Mah (eymir Köyü)",
      "Zafer Mah (havuz Köyü)",
      "Zerk Köyü"
    ],
    "Koyulhisar": [
      "Aşağıkale Mah",
      "Camiikebir Mah",
      "Orta Mah",
      "Subaşı Mah",
      "Şeyhler Mah",
      "Tuğladağı Mah",
      "Yukarıkale Mah",
      "A.söğütlü Mah (kadife Köyü)",
      "Acıdere Mah (güzelyurt Köyü)",
      "Ağca Taş Mah (karaçam Köyü)",
      "Ağcahisar Mah (kalebaşı Köyü)",
      "Ağılyazı Mah (dilekli Köyü)",
      "Akbulut Mah (kadife Köyü)",
      "Akçabel Yaylası Mah (güzelyurt Köyü)",
      "Akseki Köyü",
      "Aksu Köyü",
      "Alaçam Mah (gümüşlü Köyü)",
      "Ardıçalan Mah (kalebaşı Köyü)",
      "Ardıçalan Mevkii Mah (kalebaşı Köyü)",
      "Asarcık Mah (kızılelma Köyü)",
      "Aşağı Mah (kalebaşı Köyü)",
      "Aydınlar Köyü",
      "Aydınlı Mah (gökdere Köyü)",
      "Bağlıca Mah (güzelyurt Köyü)",
      "Bağlıyurt Mah (ortaseki Köyü)",
      "Bahçe Köyü",
      "Ballıca Başyayla Mah (ballıca Köyü)",
      "Ballıca Büyükdüz Mah (ballıca Köyü)",
      "Ballıca Evelikli Mah (ballıca Köyü)",
      "Ballıca Köyü",
      "Baş Mah (aksu Köyü)",
      "Başalan Yaylası Mah (güzelyurt Köyü)",
      "Beşoluk Mah (ekinözü Köyü)",
      "Beyderesi Mah (karaçam Köyü)",
      "Bostanderesi Mah (ortaseki Köyü)",
      "Boyalı Köyü",
      "Bozkuş Köyü",
      "Bozkuş Mah (bozkuş Köyü)",
      "Bozkuş Tekiralan Mah (bozkuş Köyü)",
      "Budama Mah (güzelyurt Köyü)",
      "Cevizli Mah (kayaören Köyü)",
      "Çalışkanlar Mah (kadife Köyü)",
      "Çalova Yaylası Mah (kızılelma Köyü)",
      "Çandır Köyü",
      "Çaylı İlefolu Mah (çaylı Köyü)",
      "Çaylı Köyü",
      "Çicek Kayası Mah (kadife Köyü)",
      "Çiçeközü Köyü",
      "Çiftlik  Mah (eskiköy Mah) (ortaköy Köyü)",
      "Çiğseli Mah (ortaköy Köyü)",
      "Çimenli Mah (ortaseki Köyü)",
      "Çukuroba Köyü",
      "Çulhasamanlığı Mah (ballıca Köyü)",
      "Dağönü Mah (sugözü Köyü)",
      "Damatlar Mah (ortaköy Köyü)",
      "Danışmanlı Mah (gümüşlü Köyü)",
      "Değirmentaş Köyü",
      "Demirasar Mah (ortaköy Köyü)",
      "Dere Mah (kadife Köyü)",
      "Dere Tarla Mah (ballıca Köyü)",
      "Derekıyısı Mah (gümüşlü Köyü)",
      "Deryapınarı Mah (sarıharman Köyü)",
      "Dilekli Köyü",
      "Dipsizgöl Mah (çiçeközü Köyü)",
      "Direkli Mah (ortaseki Köyü)",
      "Direkli Mh. (ortaseki Köyü)",
      "Doluca Mah (ballıca Köyü)",
      "Düzpelit Mah (akseki Köyü)",
      "Ecek Mah (aksu Köyü)",
      "Ekinözü Köyü",
      "Elmaalan Mah (güzelyurt Köyü)",
      "Elmalı Mah (iskenderşeyh Köyü)",
      "Elmalı Mah (kadife Köyü)",
      "Eski Köy Mah (aksu Köyü)",
      "Eski Mah (gümüşlü Köyü)",
      "Eskiköy Mah (kavacık Köyü)",
      "Evelikli Mah (aksu Köyü)",
      "Fındıklı Mah (boyalı Köyü)",
      "Fındıklı Mah (karaçam Köyü)",
      "Gesteliç Mah (ballıca Köyü)",
      "Gödük Deresi Mah (çandır Köyü)",
      "Gökdere Köyü",
      "Gölcük Handüzü Mah (gölcük Köyü)",
      "Gölcük Köyü",
      "Gölcük Sazak Mah (gölcük Köyü)",
      "Gümüşcek Mah (ballıca Köyü)",
      "Gümüşlü Çakmaklı Mah (gümüşlü Köyü)",
      "Gümüşlü Köyü",
      "Gümüşlü Şabdaş Mah (gümüşlü Köyü)",
      "Günışık Karabayır Mah (günışık Köyü)",
      "Günışık Köyü",
      "Günışık Sultan Yazısı Mah (günışık Köyü)",
      "Güvendik Mah (kadife Köyü)",
      "Hacıilyas Arpacık Mah (hacıilyas Köyü)",
      "Hacıilyas Köyü",
      "Halaçkaşı Mah (çandır Köyü)",
      "Hasan Tamı Mah (çandır Köyü)",
      "Havzul Mah (çandır Köyü)",
      "Horozalan Mah (ortaköy Köyü)",
      "Hoşgadem Yaylası Mah (kızılelma Köyü)",
      "İkizyaka Kengercik Mah (ikizyaka Köyü)",
      "İkizyaka Köyü",
      "İlyaslı Mah (çandır Köyü)",
      "İskenderşeyh Köyü",
      "Kabaoğlu Mah (aksu Köyü)",
      "Kalebaşı Köyü",
      "Kalın Pınar Mah (kayaören Köyü)",
      "Kalınpınar Mah (yalnıztepe Köyü)",
      "Karaca Ali Mah (boyalı Köyü)",
      "Karaçam Köyü",
      "Karaçay Mah (bahçe Köyü)",
      "Karakum Mah (akseki Köyü)",
      "Karanlıca Yaylası Mah (çandır Köyü)",
      "Karşı Mah (ballıca Köyü)",
      "Kartallı Mah (yalnıztepe Köyü)",
      "Kavacık Köyü",
      "Kayaören Köyü",
      "Kecini Mah (güzelyurt Köyü)",
      "Kılıçpınarı Köyü",
      "Kır Yayla Mah (çandır Köyü)",
      "Kızıl Kaya Mah (çandır Köyü)",
      "Kızılcalar Çiftliği Mah (kalebaşı Köyü)",
      "Kızılçukur Mah (kalebaşı Köyü)",
      "Kızılelma Mah (kızılelma Köyü)",
      "Koça Bahçesi Çifliği Mah (boyalı Köyü)",
      "Koçalı Mah (ortaseki Köyü)",
      "Koncalan Mah (ortaseki Köyü)",
      "Kozalağan Mah (bahçe Köyü)",
      "Köle Tarlası Mah (kalebaşı Köyü)",
      "Körce Tuzla Mah (aydınlar Köyü)",
      "Kösedağ  Mah (eskiyayla Mah) (ekinözü Köyü)",
      "Kösedağ Mah (aydınlar Köyü)",
      "Kurşunlu Çakmaklı Mah (kurşunlu Köyü)",
      "Kurşunlu Köyü",
      "Kurşunlu Maden Mah (kurşunlu Köyü)",
      "Kurşunlu Şabtaş Mah (kurşunlu Köyü)",
      "Kuruseki Mah (kadife Köyü)",
      "Kümbet Mah (yeşilyurt Köyü)",
      "Küplüce Köyü",
      "Leykün Mah (çandır Köyü)",
      "Maden Fabrikası Mah (çandır Köyü)",
      "Medrese Mah (çandır Köyü)",
      "Mekan Mah (ortaseki Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (kadife Köyü)",
      "Mimli Mah (kalebaşı Köyü)",
      "Orta Mah (ortaköy Köyü)",
      "Ortaköy Köyü",
      "Ortaseki Köyü",
      "Öküz Uçuran Mah (aydınlar Köyü)",
      "Paşapınar Mah (kalebaşı Köyü)",
      "Pınarlıyurt Mah (aksu Köyü)",
      "Sarı Çiçek Mah (ortaseki Köyü)",
      "Sarıalan Mah (ortaköy Köyü)",
      "Sarıçiçek Yaylası Mah (boyalı Köyü)",
      "Sarıharman Köyü",
      "Sarıkaya Köyü",
      "Sarıkaya Yaylası Mah (sarıkaya Köyü)",
      "Sayderesi Mah (güzelyurt Köyü)",
      "Seyfettin Yaylası Mah (kavacık Köyü)",
      "Sırganlı Mah (iskenderşeyh Köyü)",
      "Soğanlı Mah (akseki Köyü)",
      "Sorhun Mah (sugözü Köyü)",
      "Sugözü Köyü",
      "Suludere Mah (güzelyurt Köyü)",
      "Sulupara Mah (gümüşlü Köyü)",
      "Sütlüce Köyü",
      "Sütlüce Yaylası Mah (sütlüce Köyü)",
      "Şapkama Mah (gümüşlü Köyü)",
      "Tarlabaşı Mah (kadife Köyü)",
      "Taşpınar Arpacık Mah (taşpınar Köyü)",
      "Taşpınar Koşoluk Mah (taşpınar Köyü)",
      "Taşpınar Köyü",
      "Terekeme Mah (sarıharman Köyü)",
      "Topalağan Mah (ortaseki Köyü)",
      "Torunlar Mah (çandır Köyü)",
      "Turhu Mah (karaçam Köyü)",
      "Üçmerek Mah (bahçe Köyü)",
      "Y.söğütlü Mah (kadife Köyü)",
      "Yağcılar Köyü",
      "Yağcılar Yaylası Mah (yağcılar Köyü)",
      "Yağlıca Mah (aksu Köyü)",
      "Yağmurlu Mah (yalnıztepe Köyü)",
      "Yalnıztepe Köyü",
      "Yanıkağıl Mah (ballıca Köyü)",
      "Yanıkyurt Mah (kalebaşı Köyü)",
      "Yapı Mh. (yolüstü Köyü)",
      "Yazı Mah (kadife Köyü)",
      "Yemişli Mah (yalnıztepe Köyü)",
      "Yeni Mah (gümüşlü Köyü)",
      "Yeni Yayla Mah (kızılelma Köyü)",
      "Yeniarslan Köyü",
      "Yeniaslan Yaylası Mah (yeniarslan Köyü)",
      "Yenice Köyü",
      "Yenice Yaylası Mah (yenice Köyü)",
      "Yeşilyurt Köyü",
      "Yetimler Mah (ortaköy Köyü)",
      "Yokuşdibi Mah (dilekli Köyü)",
      "Yolüstü Köyü",
      "Yukarı Ağıllar Mah (akseki Köyü)",
      "Yukarı Mah (akseki Köyü)",
      "Yukarı Mah (kalebaşı Köyü)"
    ],
    "Merkez": [
      "Abdulvahabigazi Mah",
      "Alibaba Mah",
      "Bahtiyarbostan Mah",
      "Dedebalı Mah",
      "Gökçebostan Mah",
      "Gülyurt Mah",
      "İnönü Mah",
      "Kılavuz Mah",
      "Küçükminare Mah",
      "Mısmılırmak Mah",
      "Orhangazi Mah",
      "Seyrantepe Mah",
      "Yiğitler Mah",
      "Akdeğirmen Mah",
      "Aydoğan Mah",
      "Çayyurt Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "Mehmetpaşa Mah",
      "Meraküm Mah",
      "Mevlana Mah",
      "Yenidoğan Mah",
      "Yunusemre Mah",
      "Yüceyurt Mah",
      "Cami-i Kebir Mah",
      "Çarşıbaşı Mah",
      "Demircilerardı Mah",
      "Eskikale Mah",
      "Ferhatbostan Mah",
      "Gökmedrese Mah",
      "Kaleardı Mah",
      "Örtülüpınar Mah",
      "Paşabey Mah",
      "Pulur Mah",
      "Sularbaşı Mah",
      "Üçlerbey Mah",
      "Yahyabey Mah",
      "Altuntabak Mah",
      "Çiçekli Mah",
      "Diriliş Mah",
      "Dörteylül Mah",
      "Ece Mah",
      "Emek Mah",
      "Gültepe Mah",
      "Halil Rıfatpaşa Mah",
      "İstiklal Mah",
      "Kadı Burhanettin Mah",
      "Kümbet Mah",
      "Mimar Sinan Mah",
      "Selçuklu Mah",
      "Tuzlugöl Mah",
      "Yeni Mah",
      "Abdallar Mah (karayün Köyü)",
      "Acıdere Köyü",
      "Acıpınar Köyü",
      "Ağılkaya Köyü",
      "Ağıllar Mah (yassıcabel Köyü)",
      "Ahmet Turangazi Mah",
      "Ahmetturangazi Osb Mah",
      "Akçahan Köyü",
      "Akçainiş Köyü",
      "Akçamescit Köyü",
      "Akkoç Köyü",
      "Akkuzulu Köyü",
      "Akören Köyü",
      "Akpınar Köyü",
      "Akseki Mah (yağmurluseki Köyü)",
      "Alahacı Köyü",
      "Apa Köyü",
      "Arabınyazısı Mah (tokuş Köyü)",
      "Armutlu Köyü",
      "Arpayazı Köyü",
      "Asarcık Köyü",
      "Aşağıyıldızlı Köyü",
      "Aydoğmuş Köyü",
      "Aylı Köyü",
      "Bademkaya Köyü",
      "Bahçeli Mah (yavu Köyü)",
      "Bahçelievler Mah (kurtlapa Köyü)",
      "Barcın Köyü",
      "Başıbüyük Köyü",
      "Başsöğüt Köyü",
      "Battalağılı Mah (demiryazı Köyü)",
      "Bedirli Köyü",
      "Beşpınar Köyü",
      "Beştepe Köyü",
      "Beypınarı Köyü",
      "Bingöl Köyü",
      "Bostancık Köyü",
      "Boynuzözü Mah (karayün Köyü)",
      "Budaklı Köyü",
      "Cumhuriyet Mah (yakupoğlan Köyü)",
      "Çallı Köyü",
      "Çatalkaya Köyü",
      "Çayboyu Mah",
      "Çaygören Köyü",
      "Çaypınar Köyü",
      "Çelebiler Köyü",
      "Çeltek Köyü",
      "Çerçideresi Köyü",
      "Çevrim Çayır Mah (akpınar Köyü)",
      "Çiftlik Mah (köklüce Köyü)",
      "Çongar Köyü",
      "Çöken Mah (kumyurt Köyü)",
      "Çukurbelen Köyü",
      "Damılı Köyü",
      "Damlacık Köyü",
      "Danişmentgazi Mah",
      "Dayı Deresi Mah (eskiboğazkesen Köyü)",
      "Demiryazı Köyü",
      "Dervent Mah (akpınar Köyü)",
      "Dikmencik Köyü",
      "Doğanca Köyü",
      "Doğanca Osb Mah (doğanca Köyü)",
      "Dörteylül Köyü",
      "Durdulu Köyü",
      "Dursunoğlu Mah (örencik Köyü)",
      "Düzova Köyü",
      "Ebuhan Köyü",
      "Eğribucak Köyü",
      "Esenyurt Mah",
      "Eskiapardı Köyü",
      "Eskiboğazkesen Köyü",
      "Eskiköy Köyü",
      "Fatih Mah (yakupoğlan Köyü)",
      "Gazibey Köyü",
      "Gaziköy Köyü",
      "Göğüsağılı Mah (akpınar Köyü)",
      "Gökkuşağı Mah (kumyurt Köyü)",
      "Gözmen Köyü",
      "Gözpınar Mah (çatalkaya Köyü)",
      "Güllüce Köyü",
      "Güllük Köyü",
      "Gülpınar Köyü",
      "Gümüşova Mah (gümüşdere Köyü)",
      "Gündüzköy Köyü",
      "Günece Köyü",
      "Güneli Köyü",
      "Güney Köyü",
      "Günören Köyü",
      "Hacıali Köyü",
      "Hanlı Köyü",
      "Harmancık Köyü",
      "Harmanyeri Mah (çatalkaya Köyü)",
      "Hasbey Köyü",
      "Haydarlı Köyü",
      "Hayırbey Köyü",
      "Hayranlı Köyü",
      "Herekli Köyü",
      "Hıdırnalı Köyü",
      "Himmetfakı Köyü",
      "Hocabey Köyü",
      "Huykesen Mah (çelebiler Köyü)",
      "Hüseyin Ağa Mah (akkoç Köyü)",
      "Irmak Üstü Mah (emirhan Köyü)",
      "İlkindi Köyü",
      "İnceağa Köyü",
      "İncesu Mah (köklüce Köyü)",
      "İnceyol Köyü",
      "İsmailbeyçiftliği Köyü",
      "İşhanı Köyü",
      "Kabasakal Köyü",
      "Kaçak Mah (kervansaray Köyü)",
      "Kadiroğulları Mah (zengi Köyü)",
      "Kahyalı Köyü",
      "Kalın İstasyonu Mah (damlacık Köyü)",
      "Karabalçık Köyü",
      "Karacaören Köyü",
      "Karaçayır Köyü",
      "Karagömlek Köyü",
      "Karalar Köyü",
      "Karalı Köyü",
      "Karamehmetoğlu Köyü",
      "Karapınar Köyü",
      "Karataş Mah (çatalkaya Köyü)",
      "Karayün Köyü",
      "Karşıyaka Mah",
      "Karşıyaka Mah (gümüşdere Köyü)",
      "Karşıyaka Mah (kurtlapa Köyü)",
      "Kartalca Köyü",
      "Kavlak Köyü",
      "Kayadibi Köyü",
      "Keçili Köyü",
      "Kervansaray Köyü",
      "Kızılalan Köyü",
      "Kızılca Köyü",
      "Kızılcakışla Köyü",
      "Kızılkavraz Köyü",
      "Kızılova Köyü",
      "Kızılöz Köyü",
      "Kızkapan Köyü",
      "Kolluca Köyü",
      "Koyuncu Köyü",
      "Köklüce Köyü",
      "Köprübaşı Mah (karabalçık Köyü)",
      "Kör İsmail Mah (akkoç Köyü)",
      "Körhasan Mah (akkoç Köyü)",
      "Körtuzla Köyü",
      "Kösrelik Mah (porsuk Köyü)",
      "Kulyusuf Köyü",
      "Kumyurt Köyü",
      "Kuşlu Köyü",
      "Kuzköy Mah (güneli Köyü)",
      "Kuzören Köyü",
      "Menşurlu Köyü",
      "Mermer Köyü",
      "Mescitli Köyü",
      "Oğuzlar Mah (gazibey Köyü)",
      "Olukman Köyü",
      "Onbaşılar Köyü",
      "Ovacık Köyü",
      "Ozmuş Köyü",
      "Örencik Köyü",
      "Pınarca Köyü",
      "Pınarlı Mah (karaçayır Köyü)",
      "Pintipınar Mah (tokuş Köyü)",
      "Porsuk Köyü",
      "Saklı Köyü",
      "Sarıdemir Köyü",
      "Sarıhasan Mah (akçahan Köyü)",
      "Savcun Köyü",
      "Serpincik Köyü",
      "Sırıklı Mah (güney Köyü)",
      "Sivritepe Köyü",
      "Soğuk Çermik Mah (kızılca Köyü)",
      "Sorkuncuk Köyü",
      "Söğütcük Köyü",
      "Şaban Köyü",
      "Şahbey Köyü",
      "Şehitler Mah (gümüşdere Köyü)",
      "Şehristan Mah (işhanı Köyü)",
      "Tahdit Mah (doğanca Köyü)",
      "Tahtıkement Köyü",
      "Taşlıdere Mah (mescitli Köyü)",
      "Tatlıcak Köyü",
      "Tatlıcak Mah (karayün Köyü)",
      "Tepe Mah (aşağıyıldızlı Köyü)",
      "Tepeönü Köyü",
      "Tokuş Köyü",
      "Törnük Köyü",
      "Tutmaç Köyü",
      "Ulukapı Köyü",
      "Uzuntepe Mah",
      "Üçtepe Köyü",
      "Yağmurluseki Köyü",
      "Yanalak Köyü",
      "Yaramış Köyü",
      "Yassıcabel Köyü",
      "Yavu Köyü",
      "Yazıbaşı Köyü",
      "Yeni Mah (yakupoğlan Köyü)",
      "Yeniapardı Köyü",
      "Yeniboğazkesen Köyü",
      "Yenice Köyü",
      "Yenikervansaray Köyü",
      "Yenikızılcakışla Köyü",
      "Yeniköy Mah (akpınar Köyü)",
      "Yukarı Mah (tokuş Köyü)",
      "Yukarıyıldızlı Köyü",
      "Yüceyayla Mah (beşpınar Köyü)",
      "Zengi Köyü",
      "Eğriköprü Mah",
      "Huzur Mah",
      "Kardeşler Mah",
      "Kızılırmak Mah",
      "Mehmet Akif Ersoy Mah",
      "Şeyh Şamil Mah",
      "Şeyh Şamil Osb Mah",
      "Yenişehir Mah",
      "Yeşilyurt Mah",
      "Fatih Mah (yıldız Beldesi)",
      "Fevziçakmak Mah (yıldız Beldesi)",
      "Şehitömeryıldırım Mah (yıldız Beldesi)"
    ],
    "Suşehri": [
      "Abbas Mah (türkmenler Köyü)",
      "Abdiler Mah (kekeç Köyü)",
      "Ağıl Mah (taklak Köyü)",
      "Akçaağıl Köyü",
      "Akıncı Köyü",
      "Aksu Köyü",
      "Akşar Köyü",
      "Arpacı Köyü",
      "Arpayazı Köyü",
      "Aşağıakören Köyü",
      "Aşağıçitlice Mah (çitlice Köyü)",
      "Aşağısarıca Köyü",
      "Aydınlar Mah (karalar Köyü)",
      "Bağderesi Mah (sökün Köyü)",
      "Bağlar Mah (hödücek Köyü)",
      "Bakacak Mah (çataloluk Köyü)",
      "Balkara Köyü",
      "Bayır Mah (eskitoprak Köyü)",
      "Bedilli Mah (balkara Köyü)",
      "Beydeğirmeni Köyü",
      "Bileğli Mah (kızıltaş Köyü)",
      "Bostancık Köyü",
      "Boyalıca Köyü",
      "Buğdaylık Mah (kiziryurdu Köyü)",
      "Büyükgüzel Köyü",
      "Camili Köyü",
      "Cevizli Köyü",
      "Çakırlı Köyü",
      "Çamlıca Mah (karalar Köyü)",
      "Çamlıdere Köyü",
      "Çavuşlu Mah (kale Köyü)",
      "Çiftçili Mah (tatar Köyü)",
      "Çitlice Köyü",
      "Çokrak Köyü",
      "Çoraklık Mah (karalar Köyü)",
      "Dikilitaş Mah (karalar Köyü)",
      "Elmaseki Köyü",
      "Erence Köyü",
      "Esenyaka Köyü",
      "Eskiköy Mah (taklak Köyü)",
      "Eskimeşe Köyü",
      "Eskişar Köyü",
      "Eskitoprak Köyü",
      "Gelengeç Köyü",
      "Gökçekaş Köyü",
      "Gökçekent Karaağaç Köyü",
      "Gökçekent Köyü",
      "Göynük Mah (kale Köyü)",
      "Gözköy Köyü",
      "Güdeli Köyü",
      "Gümüştaş Köyü",
      "Güneyli Köyü",
      "Güngören Köyü",
      "Günlüce Köyü",
      "Hamam Mah (kekeç Köyü)",
      "Hödücek Köyü",
      "Işıklar Mah (tatar Köyü)",
      "İsaklı Mah (kale Köyü)",
      "Kale Köyü",
      "Karaağaç Köyü",
      "Karacaören Köyü",
      "Karalar Köyü",
      "Karataş Mah (karacaören Köyü)",
      "Kargın Mah (sökün Köyü)",
      "Katırcı Mah (tatar Köyü)",
      "Kavşut Köyü",
      "Kayadelen Köyü",
      "Kekeç Köyü",
      "Kemallı Köyü",
      "Kesikkaş Köyü",
      "Kılıçlar Mah (çataloluk Köyü)",
      "Kızıltaş Köyü",
      "Kiziryurdu Köyü",
      "Konak Mah (karalar Köyü)",
      "Kozçukur Köyü",
      "Kurugöl Köyü",
      "Kuzdere Köyü",
      "Küçükgüzel Köyü",
      "Mafadar Mah (yelkesen Köyü)",
      "Menekşeli Mah (kale Köyü)",
      "Merkez Mah (çataloluk Köyü)",
      "Molla Osman Mah (sökün Köyü)",
      "Olucak Köyü",
      "Oyuk Mah (elmaseki Köyü)",
      "Peçene Mah (taklak Köyü)",
      "Polat Köyü",
      "Sağpazar Köyü",
      "Saraycık Köyü",
      "Selimler Mah (camili Köyü)",
      "Selpinti Mah (çataloluk Köyü)",
      "Solak Köyü",
      "Sökün Köyü",
      "Sülüklü Mah (kozçukur Köyü)",
      "Şarköy Köyü",
      "Taklak Köyü",
      "Tandırcık Mah (elmaseki Köyü)",
      "Tapançifliği Mah (türkmenler Köyü)",
      "Taşbayır Köyü",
      "Tatar Köyü",
      "Tepe Mah (karaağaç Köyü)",
      "Türkmenler Köyü",
      "Üzümlü Köyü",
      "Yamaç Köyü",
      "Yaygınsöğüt Köyü",
      "Yelkesen Köyü",
      "Yeniköy Mah (solak Köyü)",
      "Yeşilyayla Köyü",
      "Yoncalı Köyü",
      "Yukarıakören Köyü",
      "Yürekli Köyü",
      "Avculu Mah",
      "Camiiorta Mah",
      "Cumhuriyet Mah",
      "Göllüköy Mah",
      "Gönüloğlu Mah",
      "Karşıyaka Mah",
      "Kemalpaşa Mah",
      "Kışlalar Mah",
      "Öksülü Mah",
      "Taşköprü Mah",
      "Tepeardı Mah",
      "Yalnızbağlar Mah",
      "Yeni Mah"
    ],
    "Şarkışla": [
      "Bahçelievler Mah (cemel Beldesi)",
      "Karşıyaka Mah (cemel Beldesi)",
      "Yeni Mah (cemel Beldesi)",
      "Çiçekli Mah (gürçayır Beldesi)",
      "Doğu Mah (gürçayır Beldesi)",
      "Yeni Mah (gürçayır Beldesi)",
      "Abdallı Köyü",
      "Adamkaya Mah (bahçealan Köyü)",
      "Ahmetli Köyü",
      "Akçasu Köyü",
      "Akkaya Mah (yahyalı Köyü)",
      "Alaçayır Köyü",
      "Alaman Köyü",
      "Alıçlı Mah (kazancık Köyü)",
      "Alıkören Köyü",
      "Arıklar Köyü",
      "Aşağı Mah (dökmetaş Köyü)",
      "Aşağı Mah (sarıçiçek Köyü)",
      "Bağlama Mah (samankaya Köyü)",
      "Bağlararası Köyü",
      "Bahçealan Köyü",
      "Baltalar Köyü",
      "Başağaç Köyü",
      "Başören Köyü",
      "Benlihasan Köyü",
      "Beyyurdu Köyü",
      "Bozkurt Köyü",
      "Burnukara Köyü",
      "Büyüktopaç Köyü",
      "Büyükyüreğil Köyü",
      "Canabdal Köyü",
      "Çamlıca Köyü",
      "Çanakçı Köyü",
      "Çatalyol Köyü",
      "Çaykara Mah (mengensofular Köyü)",
      "Çekem Köyü",
      "Çiçekliyurt Köyü",
      "Demirboğa Köyü",
      "Demirköprü Köyü",
      "Dikili Köyü",
      "Döllük Köyü",
      "Elmalı Köyü",
      "Emlakkaracaören Köyü",
      "Fakılı Köyü",
      "Faraşderesi Köyü",
      "Fatih Mah (kızılcakışla Köyü)",
      "Gaziköy Köyü",
      "Göçmen Mah (kayapınar Köyü)",
      "Gücük Köyü",
      "Güdül Mah (canabdal Köyü)",
      "Gülören Köyü",
      "Hardal Köyü",
      "Harunköy Köyü",
      "Hocabey Köyü",
      "Hüyükköy Köyü",
      "İğdecik Köyü",
      "İğdeliören Köyü",
      "İğecik Köyü",
      "İlyashacı Köyü",
      "İsmetpaşa Mah (akçakışla Köyü)",
      "Kadılı Mah (kızılcakışla Köyü)",
      "Kahvepınar Köyü",
      "Kalecik Köyü",
      "Kaleköy Köyü",
      "Kapaklıpınar Köyü",
      "Karacaören Köyü",
      "Karakuz Köyü",
      "Karşıyaka Mah (akçakışla Köyü)",
      "Kavak Köyü",
      "Kayapınar Köyü",
      "Kaymak Köyü",
      "Kazancık Köyü",
      "Kevenlik Köyü",
      "Kılıççı Köyü",
      "Kışlaköy Köyü",
      "Konakyazı Köyü",
      "Konalga Köyü",
      "Kömürkaya Köyü",
      "Köseli Beli Mah (samankaya Köyü)",
      "Küçük Karakuz Mah (karakuz Köyü)",
      "Küçüktopaç Köyü",
      "Küçükyüreğil Köyü",
      "Kümbet Köyü",
      "Maksutlu Köyü",
      "Menderes Mah (akçakışla Köyü)",
      "Mengensofular Köyü",
      "Mescitli Köyü",
      "Mezraa Köyü",
      "Muhacir Mah (gümüştepe Köyü)",
      "Oluktaş Köyü",
      "Ortaköy Köyü",
      "Ortatopaç Köyü",
      "Osmanfazılpolat Mah (kızılcakışla Köyü)",
      "Osmanpınarı Köyü",
      "Otluk Köyü",
      "Örtülü Köyü",
      "Polatpaşa Köyü",
      "Samankaya Köyü",
      "Saraç Köyü",
      "Sarıkavak Köyü",
      "Sarıkaya Köyü",
      "Sarıtekke Köyü",
      "Sivrialan Köyü",
      "Sultan Köyü",
      "Tavladere Köyü",
      "Temecik Köyü",
      "Uçuk Köyü",
      "Üyük Köyü",
      "Yahyalı Köyü",
      "Yalanı Köyü",
      "Yapracık Köyü",
      "Yeniyapan Köyü",
      "Yerli Mah (gümüştepe Köyü)",
      "Yukarı Mah (dökmetaş Köyü)",
      "Yukarı Mah (sarıçiçek Köyü)",
      "Yunusören Köyü",
      "Yükselen Köyü",
      "Zihni Mah (kazancık Köyü)",
      "Damlaca Mah",
      "Esentepe Mah",
      "Gültekin Mah",
      "İstiklal Mah",
      "Kale Mah",
      "Kandemir Mah",
      "Kayalıyokuş Mah",
      "Pınarönü Mah",
      "Sağır Mah",
      "Sağırosb Mah",
      "Yeni Mah",
      "Yıldırım Mah",
      "Yukarı Mah"
    ],
    "Ulaş": [
      "Acıyurt Köyü",
      "Ağıl Mah (karaşar Köyü)",
      "Akkaya Köyü",
      "Aşağı Demircilik Mah (demircilik Köyü)",
      "Aşağıada Köyü",
      "Başçayır Köyü",
      "Beşevler Mah (örenlice Köyü)",
      "Boğazdere Köyü",
      "Bostankaya Köyü",
      "Çakılpınar Mah (ovacık Köyü)",
      "Çavdar Köyü",
      "Çevirme Köyü",
      "Çifteağıl Mah (akkaya Köyü)",
      "Demircilik Köyü",
      "Ekincioğlu Köyü",
      "Eskikarahisar Köyü",
      "Ezentere Köyü",
      "Fatih Mah (baharözü Köyü)",
      "Gülbahçe Mah (karaşar Köyü)",
      "Gümüşpınar Köyü",
      "Güneşli Köyü",
      "Gürpınar Köyü",
      "Hacımirza Köyü",
      "Halilağa Çiftliği Mah (başçayır Köyü)",
      "Kadir Ağa Mah (eskikarahisar Köyü)",
      "Kapukaya Köyü",
      "Karacalar Köyü",
      "Karagöl Köyü",
      "Karaşar Köyü",
      "Karataş Köyü",
      "Kayapınar Köyü",
      "Kazanpınar Köyü",
      "Kertmekaracaören Köyü",
      "Korubaşı Köyü",
      "Kovalı Köyü",
      "Kötüyurt Mah (kurtoğlu Köyü)",
      "Kurtlukaya Köyü",
      "Kurtoğlu Köyü",
      "Küçükyapalı Mah (yapalı Köyü)",
      "Küpeli Köyü",
      "Ovacık Köyü",
      "Ömer Ağa Mah (kayapınar Köyü)",
      "Ören Mah (karacalar Köyü)",
      "Örenlice Köyü",
      "Paşaçiftliği Mah (başçayır Köyü)",
      "Şenyurt Köyü",
      "Taş Ocağı  A Mah (kayapınar Köyü)",
      "Taş Ocağı B Mah (kayapınar Köyü)",
      "Taş Ocağı Mah (kayapınar Köyü)",
      "Tecer Köyü",
      "Üç Evler Mah (karataş Köyü)",
      "Yağdonduran Köyü",
      "Yapalı Köyü",
      "Yazıcık Köyü",
      "Yeni Mah (baharözü Köyü)",
      "Yeşildiyar Mah (kapukaya Köyü)",
      "Yeşilyurt Mah (eskikarahisar Köyü)",
      "Yukarıada Köyü",
      "Esentepe Mah",
      "Hürriyet Mah",
      "Yenikarahisar Mah",
      "Yeşilyurt Mah"
    ],
    "Yıldızeli": [
      "Aydın Mah (güneykaya Beldesi)",
      "Kargın Mah (güneykaya Beldesi)",
      "Yenicamii Mah (güneykaya Beldesi)",
      "Yeşilyurt Mah (güneykaya Beldesi)",
      "Akçakale Köyü",
      "Akçalı Köyü",
      "Akkoca Köyü",
      "Akören Köyü",
      "Akpınar Köyü",
      "Akpınarbeleni Köyü",
      "Alaca Köyü",
      "Altınoluk Köyü",
      "Arslandoğmuş Köyü",
      "Aşağı Navruz Mah (nevruz Köyü)",
      "Aşağıçakmak Köyü",
      "Aşağıekecik Köyü",
      "Avcıpınarı Köyü",
      "Bakırcıoğlu Köyü",
      "Banaz Köyü",
      "Başköy Köyü",
      "Bayat Köyü",
      "Bedel Köyü",
      "Belcik Köyü",
      "Buğdayören Köyü",
      "Büyükakören Köyü",
      "Camii Mah (kalın Köyü)",
      "Cizözü Köyü",
      "Cumhuriyet Köyü",
      "Cumhuriyet Mah (kümbet Köyü)",
      "Çağlayan Köyü",
      "Çırçır Köyü",
      "Çobansaray Köyü",
      "Çöte Köyü",
      "Çubuk Köyü",
      "Çukursaray Köyü",
      "Danaören Köyü",
      "Danişment Köyü",
      "Davulalan Köyü",
      "Delikkaya Köyü",
      "Demircilik Köyü",
      "Demiroluk Köyü",
      "Demirözü Köyü",
      "Dereköy Köyü",
      "Dikilitaş Köyü",
      "Direkli Köyü",
      "Direkli Sarıkaya Köyü",
      "Doğanlı Köyü",
      "Emirler Köyü",
      "Erenler Köyü",
      "Erikli Mah (buğdayören Köyü)",
      "Esençay Köyü",
      "Eşmebaşı Köyü",
      "Fatih Mah (kavak Köyü)",
      "Fatih Mah (kümbet Köyü)",
      "Fatih Mah (şeyhhalil Köyü)",
      "Fındıcak Köyü",
      "Geynik Köyü",
      "Gökçeli Köyü",
      "Gökkaya Köyü",
      "Halkaçayır Köyü",
      "Hamzaşeyh Köyü",
      "Ilıca Köyü",
      "İğdecikler Köyü",
      "İğnebey Köyü",
      "İncetaş Köyü",
      "İslim Köyü",
      "Kadıköy Köyü",
      "Kadılı Köyü",
      "Kale Mah (kümbet Köyü)",
      "Kaleköy Köyü",
      "Kaman Köyü",
      "Kapaklıkaya Köyü",
      "Kapı Köyü",
      "Karacaören Köyü",
      "Karakaya Köyü",
      "Karakoç Köyü",
      "Karalar Köyü",
      "Karaleylek Köyü",
      "Kavakdere Köyü",
      "Kayalıpınar Köyü",
      "Kerimmümin Köyü",
      "Kıldır Köyü",
      "Kırkpınar Köyü",
      "Kıvşak Köyü",
      "Kızılköy Köyü",
      "Killik Köyü",
      "Kiremitli Köyü",
      "Konaközü Köyü",
      "Küçükakören Köyü",
      "Mehmetakifersoy Mah (kavak Köyü)",
      "Menteşe Köyü",
      "Merkez Sarıkaya Köyü",
      "Merkezyeniköy Köyü",
      "Mumcuçiftliği Köyü",
      "Nallı Köyü",
      "Nevruz Köyü",
      "Nevruzyaylası Köyü",
      "Ortaçakmak Köyü",
      "Ortaklar Köyü",
      "Sandal Köyü",
      "Sarıçal Köyü",
      "Sarıyar Köyü",
      "Selçuklu Mah (şeyhhalil Köyü)",
      "Seren Köyü",
      "Söğütpınar Köyü",
      "Subaşı Köyü",
      "Şehitler Mah (şeyhhalil Köyü)",
      "Şehitnadirbekar Mah (kavak Köyü)",
      "Şehitosman Mah (kalın Köyü)",
      "Tahtaköprü Mah (menteşe Köyü)",
      "Tatköy Köyü",
      "Tayalan Köyü",
      "Termal Mah (kalın Köyü)",
      "Topulyurdu Köyü",
      "Töngel Köyü",
      "Üyük Köyü",
      "Üyükyaylası Köyü",
      "Yağlıdere Köyü",
      "Yakacıkçavuşlu Köyü",
      "Yakupköy Köyü",
      "Yassıkara Köyü",
      "Yaylagöze Köyü",
      "Yeniyapan Köyü",
      "Yeşilalan Köyü",
      "Yılanlıkaya Köyü",
      "Yiğitler Köyü",
      "Yolkaya Köyü",
      "Yukarıçakmak Köyü",
      "Yukarıekecik Köyü",
      "Yusufoğlan Köyü",
      "Yuvalıçayır Köyü",
      "Yücebaca Köyü",
      "Zafer Mah (kalın Köyü)",
      "Camii Mah",
      "Camii Mah (yavu Köyü)",
      "Cumhuriyet Mah",
      "Çamlıbel Mah",
      "Fatihsultanmehmet Mah",
      "Fatihsultanmehmet Mah (yavu Köyü)",
      "Fevzi Çakmak Mah",
      "Karşıyaka Mah",
      "Mehmetakifersoy Mah",
      "Reşadiye Mah",
      "Salihiye Mah",
      "Selamet Mah",
      "Yeni Mah (yavu Köyü)"
    ],
    "Zara": [
      "Adamfakı Köyü",
      "Ağılönü Mah (korkut Köyü)",
      "Ağkaya Mah (yapak Köyü)",
      "Ağlıkçay Köyü",
      "Ahmethacı Köyü",
      "Akdede Köyü",
      "Akdeğirmen Köyü",
      "Akkogil Mah (iğdir Köyü)",
      "Akmaşad Mah (kaplan Köyü)",
      "Akören Köyü",
      "Aksu Mah (yukarımescit Köyü)",
      "Aktaş Mah (beypınarı Köyü)",
      "Aktaş Mah (yıkılgan Köyü)",
      "Akyazı Köyü",
      "Alınpınar Mah (yoğunpelit Köyü)",
      "Alibazağılı Mah (müslümabat Köyü)",
      "Aliefendi Mah (aluçlubel Köyü)",
      "Alipınar Mah (iğdir Köyü)",
      "Alişanağılı Köyü",
      "Alişir Köyü",
      "Aluç Mah (yarağıl Köyü)",
      "Aluçlubel Köyü",
      "Aluçluseki Köyü",
      "Arapça Mah (avşar Köyü)",
      "Araplar Mah (büyükkaya Köyü)",
      "Araplar Mah (söğütlüağıl Köyü)",
      "Arduçlu Mah (cemal Köyü)",
      "Arkan Mah (atkıran Köyü)",
      "Armutçayırı Köyü",
      "Armutlu Mah (kardere Köyü)",
      "Armutlu Mah (yapak Köyü)",
      "Asımbey Mah (aluçlubel Köyü)",
      "Aşağı Adamfakı Mah (adamfakı Köyü)",
      "Aşağı Mah (çaylıca Köyü)",
      "Aşağı Mah (iğdeli Köyü)",
      "Aşağı Mah (tepeköy Köyü)",
      "Aşağı Sedille Mah (sedille Köyü)",
      "Aşağıçamözü Köyü",
      "Aşağıçamurcu Köyü",
      "Aşağıekinli Mah (ekinli Köyü)",
      "Aşağıkovacık Köyü",
      "Aşağıkürünlü Mah (kürünlü Köyü)",
      "Aşağımescit Köyü",
      "Aşağıpeynik Mah (yayıközü Köyü)",
      "Atalan Köyü",
      "Atatürk Mah (şerefiye Köyü)",
      "Atgeçmez Köyü",
      "Atkıran Köyü",
      "Avşar Köyü",
      "Ayanoğlu Mah (korkut Köyü)",
      "Aylayüz Mah (gümüşçevre Köyü)",
      "Azizağa Mah (taşgöze Köyü)",
      "Bağlama Köyü",
      "Baharşeyh Köyü",
      "Bahçe Mah (bozkır Köyü)",
      "Bahçeli Mah (girit Köyü)",
      "Ballıklar Köyü",
      "Barhana Mah (alişanağılı Köyü)",
      "Başyurt Çiftliği Mah (baharşeyh Köyü)",
      "Başyurt Mah (ağlıkçay Köyü)",
      "Bayramlı Mah (tuzlagözü Köyü)",
      "Baytarlar Mah (dilekpınarı Köyü)",
      "Becekli Köyü",
      "Becekli Mah (beypınarı Köyü)",
      "Bedirören Köyü",
      "Bektaş Köyü",
      "Belentarla Köyü",
      "Beygelen Mah (ağlıkçay Köyü)",
      "Beypınarı Köyü",
      "Boğaz Mah (aşağımescit Köyü)",
      "Bolucan Köyü",
      "Bozbel Mah (zoğallı Köyü)",
      "Bozkır Köyü",
      "Bozo Mah (atkıran Köyü)",
      "Bozok Mah (korkut Köyü)",
      "Bölükler Mah (sancakkale Köyü)",
      "Buğdaylı  Mah (şahin Çavuşlar Mah) (avşar Köyü)",
      "Burhaniye Köyü",
      "Büyükgüney Köyü",
      "Büyükkaya Köyü",
      "Büyükköy Köyü",
      "Canberkli Mah (mahmutağaçiftliği Köyü)",
      "Canova Köyü",
      "Cefolar Mah (yukarıçamözü Köyü)",
      "Cemal Köyü",
      "Culhalı Köyü",
      "Çamlıkale Mah (çevirmehan Köyü)",
      "Çamlıkayak Mah (yapak Köyü)",
      "Çandır Köyü",
      "Çatak Mah (gümüşçevre Köyü)",
      "Çatak Mah (yapak Köyü)",
      "Çatören Köyü",
      "Çayköy Mah (nasır Köyü)",
      "Çaylı Köyü",
      "Çaylıca Köyü",
      "Çaypınar Köyü",
      "Çekemler Mah (nasır Köyü)",
      "Çelikler Mah (aluçlubel Köyü)",
      "Çevirme Mah (atkıran Köyü)",
      "Çevirmehan Köyü",
      "Çırıklı Mah (karacahisar Köyü)",
      "Çoğu Mah (bolucan Köyü)",
      "Çorağındere Mah (atalan Köyü)",
      "Çorak Köyü",
      "Çorak Mah (tuzlagözü Köyü)",
      "Çotuklar Mah (kaplan Köyü)",
      "Çukur  Mah (yeşilovo Mah) (beypınarı Köyü)",
      "Danışık Köyü",
      "Davut Mah (belentarla Köyü)",
      "Deliktaş Mah (kaplan Köyü)",
      "Derbent Köyü",
      "Deredam Köyü",
      "Dereköy Köyü",
      "Dereköy Mah (kaplan Köyü)",
      "Dereköy Mah (karacahisar Köyü)",
      "Derenin Ağılları Mah (nasır Köyü)",
      "Derviş Mah (ağlıkçay Köyü)",
      "Dikilitaş Mah (korkut Köyü)",
      "Dilekpınarı Köyü",
      "Dipsizgöl Köyü",
      "Doktorunağılı Mah (tuzlagözü Köyü)",
      "Düzceli Köyü",
      "Ekinli Köyü",
      "Elmabeli Mah (karacahisar Köyü)",
      "Emirhan Köyü",
      "Epsileyurdu Mah (ılıca Köyü)",
      "Esenler Köyü",
      "Esenyurt Mah (nasır Köyü)",
      "Etolar Mah (taşgöze Köyü)",
      "Evelikli Mah (ütükyurdu Köyü)",
      "Evrencik Köyü",
      "Eymir Köyü",
      "Fatih Mah (şerefiye Köyü)",
      "Geçibeli Mah (ağlıkçay Köyü)",
      "Gencikler Mah (beypınarı Köyü)",
      "Gençali Mah (beypınarı Köyü)",
      "Geyikbaba Mah (büyükköy Köyü)",
      "Gilgil Mah (aşağıçamurcu Köyü)",
      "Girit Köyü",
      "Göhertaş Köyü",
      "Gökdere Mah (beypınarı Köyü)",
      "Göktepe Köyü",
      "Gölbaşı Köyü",
      "Göller Mah (beypınarı Köyü)",
      "Göller Mah (yukarıçamurcu Köyü)",
      "Gölyayla Mah (kızık Köyü)",
      "Gözel Mah (düzceli Köyü)",
      "Gücükali Mah (ütük Köyü)",
      "Gücükburun Mah (bozkır Köyü)",
      "Gülabi Mah (yukarıçamözü Köyü)",
      "Gülabi Mah (yukarımescit Köyü)",
      "Gülabiler Mah (aluçluseki Köyü)",
      "Güller Mah (atkıran Köyü)",
      "Güllüali Köyü",
      "Gümüşçevre Köyü",
      "Günçaldı Mah (gümüşçevre Köyü)",
      "Gürgen Mah (beypınarı Köyü)",
      "Gürlevik Mah (yeşimli Köyü)",
      "Haçyurt Mah (şafaklı Köyü)",
      "Hamo Tuzlası Mah (kardere Köyü)",
      "Handeresi Mah (aluçluseki Köyü)",
      "Harami Mah (avşar Köyü)",
      "Hasağıl Mah (kardere Köyü)",
      "Hasanağa Mah (taşgöze Köyü)",
      "Hasanağılı Mah (müslümabat Köyü)",
      "Hıdır Mah (bektaş Köyü)",
      "Horundere Mah (iğdir Köyü)",
      "Hüseyin Mah (bağlama Köyü)",
      "Hüzol Mah (evrencik Köyü)",
      "Ilıca Köyü",
      "İbo Mah (çaylıca Köyü)",
      "İğdir Köyü",
      "İkideğirmen Köyü",
      "İmirhan Mah (tuzlagözü Köyü)",
      "İnönü Mah (tuzlagözü Köyü)",
      "İnönü Mah (yeşilköy Köyü)",
      "Kabaktepeler Köyü",
      "Kabalaklı Mah (ütükyurdu Köyü)",
      "Kadriye Köyü",
      "Kalacık Mah (aluçlubel Köyü)",
      "Kanlıçayır Köyü",
      "Kanlıdere Mah (beypınarı Köyü)",
      "Kaplan Köyü",
      "Karaali Mah (girit Köyü)",
      "Karacahisar Köyü",
      "Karacaova Mah (tuzlagözü Köyü)",
      "Karaçam Mah (gölbaşı Köyü)",
      "Karaçamurluk Mah (ılıca Köyü)",
      "Karaçayır Köyü",
      "Karagöz Mah (karacahisar Köyü)",
      "Karahasan Köyü",
      "Karakaya Mah (gümüşçevre Köyü)",
      "Karakuş Mah (gümüşçevre Köyü)",
      "Karaman  Mah (hasan Yıldız Mah) (beypınarı Köyü)",
      "Karaman Köyü",
      "Karaoluk Mah (aşağıçamözü Köyü)",
      "Karapınar Mah (yolören Köyü)",
      "Karataş Mah (göhertaş Köyü)",
      "Karataş Mah (taşgöze Köyü)",
      "Kardere Köyü",
      "Karındibi Mah (yapak Köyü)",
      "Karslılar Köyü",
      "Karşıyaka Mah (şerefiye Köyü)",
      "Karşıyurt Mah (yapak Köyü)",
      "Kasapoğlu Mah (kürünlü Köyü)",
      "Kavak Mah (ütük Köyü)",
      "Kavasbaşı Köyü",
      "Kayabaşı Köyü",
      "Kayadibi Köyü",
      "Kaylukaya Köyü",
      "Kazelören Mah (ütükyurdu Köyü)",
      "Kazıklıçayır Mah (ılıca Köyü)",
      "Keçeyurdu Köyü",
      "Kelenter Mah (yukarıçamurcu Köyü)",
      "Keleşler Mah (yukarıçamurcu Köyü)",
      "Kelhasan Köyü",
      "Keloş Mah (pazarcık Köyü)",
      "Kemkine Mah (tuzlagözü Köyü)",
      "Kevenli Köyü",
      "Kıraç Mah (avşar Köyü)",
      "Kırdağ Mah (korkut Köyü)",
      "Kırıklı Mah (tödürge Köyü)",
      "Kısık Köyü",
      "Kızık Köyü",
      "Kızıldere Mah (karaçayır Köyü)",
      "Kızıldikme Mah (yapak Köyü)",
      "Kızılkale Köyü",
      "Kızıltarla Mah (karacahisar Köyü)",
      "Kisolar Mah (çaylıca Köyü)",
      "Kocaali Mah (aluçlubel Köyü)",
      "Koç Mah (karslılar Köyü)",
      "Koççukuru Mah (korkut Köyü)",
      "Korkut Köyü",
      "Kovaloğlu Mah (karslılar Köyü)",
      "Köndül Mah (taşgöze Köyü)",
      "Köprübaşı Mah (kaplan Köyü)",
      "Körgetuzla Mah (evrencik Köyü)",
      "Körpınar Köyü",
      "Körpınar Mah (kaplan Köyü)",
      "Kösedağ Mah (ütükyurdu Köyü)",
      "Kulaksız Mah (yukarıçamurcu Köyü)",
      "Kumoğlu Köyü",
      "Kurnaslı Mah (yapak Köyü)",
      "Kurucaabat Köyü",
      "Kuruköprü Köyü",
      "Kuşcapınar Mah (yapak Köyü)",
      "Kuşcu Köyü",
      "Kuşkaya Mah (beypınarı Köyü)",
      "Küçük Sorhun Mah (sorkun Köyü)",
      "Küçükçat Mah (yapak Köyü)",
      "Küllük Mah (taşgöze Köyü)",
      "Kümbet Köyü",
      "Kürünlü Köyü",
      "Kütüklü Mah (ılıca Köyü)",
      "Laluklar Mah (tuzlagözü Köyü)",
      "Mahmutağaçiftliği Köyü",
      "Mahmutçavuş Mah (atkıran Köyü)",
      "Mail Mah (bektaş Köyü)",
      "Marabali  Mah (şenyurt Mah) (beypınarı Köyü)",
      "Mehmet Çavuş  Mah (şıh Mah) (beypınarı Köyü)",
      "Mehmetağa Mah (beypınarı Köyü)",
      "Mestanlar Mah (kürünlü Köyü)",
      "Mıhlıağaç Mah (ağlıkçay Köyü)",
      "Molla Süleyman Mah (beypınarı Köyü)",
      "Moloklar Mah (büyükköy Köyü)",
      "Mudolar Mah (yeşildere Köyü)",
      "Muhtarali Mah (beypınarı Köyü)",
      "Murtazaoğlu Mah (aluçlubel Köyü)",
      "Müslümabat Köyü",
      "Nasır Köyü",
      "Nuzla Mah (karslılar Köyü)",
      "Okul Mah (ağlıkçay Köyü)",
      "Orta Mah (çaylıca Köyü)",
      "Orta Mah (tepeköy Köyü)",
      "Ortayurt Mah (nasır Köyü)",
      "Osman Hoca Mah (yayıközü Köyü)",
      "Osmaniye Köyü",
      "Ömerinyurdu Mah (kaplan Köyü)",
      "Özcan Mah (atkıran Köyü)",
      "Palabıyık Mah (belentarla Köyü)",
      "Palanga Mah (tuzlagözü Köyü)",
      "Pazarbeleni Köyü",
      "Pazarcık Köyü",
      "Purolar Mah (yoğunpelit Köyü)",
      "Saçlı Mah (iğdir Köyü)",
      "Salmahan Mah (sedille Köyü)",
      "Sancakkale Köyü",
      "Sarıyusuf Köyü",
      "Sedille Köyü",
      "Selimiye Köyü",
      "Seten Köyü",
      "Sırımlı Mah (korkut Köyü)",
      "Soğukpınar Mah (büyükköy Köyü)",
      "Solmazlar Mah (ağlıkçay Köyü)",
      "Sorkun Köyü",
      "Söğütbeli Mah (ikideğirmen Köyü)",
      "Söğütlü Köyü",
      "Söğütlü Mah (beypınarı Köyü)",
      "Söğütlüağıl Köyü",
      "Söğütözü Köyü",
      "Sucak Köyü",
      "Sugözü Mah (karacahisar Köyü)",
      "Sungur Mah (yapak Köyü)",
      "Sülükgölü Mah (bozkır Köyü)",
      "Şafaklı Köyü",
      "Şahin Mah (karaman Köyü)",
      "Şengüller Mah (dipsizgöl Köyü)",
      "Şenyayla Köyü",
      "Şirolar Mah (büyükköy Köyü)",
      "Tahirağa Mah (kürünlü Köyü)",
      "Taşgöze Köyü",
      "Taşlık Mah (ahmethacı Köyü)",
      "Taşlıkayağı Mah (ahmethacı Köyü)",
      "Taşyayla Mah (ılıca Köyü)",
      "Tekeli Mah (sedille Köyü)",
      "Tekkebuyu  Mah (haydos Mah) (müslümabat Köyü)",
      "Temolar Mah (aşağımescit Köyü)",
      "Temolar Mah (taşgöze Köyü)",
      "Topaktaş Köyü",
      "Topdoruk Mah (kızılkale Köyü)",
      "Tödürge Gölü Mah (tödürge Köyü)",
      "Tödürge Köyü",
      "Tuzla Mah (büyükköy Köyü)",
      "Tuzla Mah (korkut Köyü)",
      "Tuzlagözü Köyü",
      "Türkoğlu Mah (büyükköy Köyü)",
      "Ulaşoğlu Mah (ılıca Köyü)",
      "Urmutluyurt Mah (ılıca Köyü)",
      "Uzungöze Mah (büyükgüney Köyü)",
      "Uzunoğlan Mah (korkut Köyü)",
      "Üçarmut Mah (gümüşçevre Köyü)",
      "Üçoluk Mah (bağlama Köyü)",
      "Üngür Köyü",
      "Ütük Köyü",
      "Ütükyurdu Köyü",
      "Veyisler Mah (yoğunpelit Köyü)",
      "Veyselağa Mah (karslılar Köyü)",
      "Yağlılar Mah (aşağıçamözü Köyü)",
      "Yanalak Mah (karacahisar Köyü)",
      "Yanık Mah (gümüşçevre Köyü)",
      "Yanık Mah (söğütözü Köyü)",
      "Yanyayla Mah (gümüşçevre Köyü)",
      "Yapak Köyü",
      "Yarağıl Köyü",
      "Yarımkaya Köyü",
      "Yayıközü Köyü",
      "Yayla Mah (müslümabat Köyü)",
      "Yeğer Mah (aşağıçamurcu Köyü)",
      "Yesali Mah (kaplan Köyü)",
      "Yeşildere Köyü",
      "Yeşildere Mah (karaman Köyü)",
      "Yeşilköy Köyü",
      "Yeşimli Köyü",
      "Yıkılgan Köyü",
      "Yıldız Mah (karaman Köyü)",
      "Yoğunpelit Köyü",
      "Yolarası Mah (ılıca Köyü)",
      "Yolören Köyü",
      "Yukarı Kevenli Mah (kevenli Köyü)",
      "Yukarı Mah (çaylıca Köyü)",
      "Yukarı Mah (iğdeli Köyü)",
      "Yukarı Mah (tepeköy Köyü)",
      "Yukarı Mah (yukarıçamurcu Köyü)",
      "Yukarı Seten Mah (seten Köyü)",
      "Yukarıçamözü Köyü",
      "Yukarıçamurcu Köyü",
      "Yukarımescit Köyü",
      "Yuva Mah (tuzlagözü Köyü)",
      "Yuvaca Mah (evrencik Köyü)",
      "Zazalar Mah (baharşeyh Köyü)",
      "Ziyaret Mah (beypınarı Köyü)",
      "Zoğallı Köyü",
      "Ahmetbaşyurt Mah",
      "Çarşıbaşı Mah",
      "Hatip Mah",
      "Karşıyaka Mah",
      "Kızılırmak Mah",
      "Reşitpaşa Mah",
      "Şehitler Mah",
      "Şeyhmerzuban Mah",
      "Yenicamii Mah"
    ]
  },
  "Tekirdağ": {
    "Çerkezköy": [
      "Bağlık Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Fevzi Paşa Mah",
      "Gazi Mustafa Kemal Paşa Osb Mah",
      "Gazi Mustafa Kemalpaşa Mah",
      "Gazi Osman Paşa Mah",
      "Gazi Osman Paşa Osb Mah",
      "İstasyon Mah",
      "Kızılpınar Atatürk Mah",
      "Kızılpınar Gültepe Mah",
      "Kızılpınar Namık Kemal Mah",
      "Veliköy Mah",
      "Veliköy Osb Mah",
      "Veliköy-yalıboyu Osb Mah",
      "Yıldırım Beyazıt Mah",
      "Yıldırım Beyazıt Osb Mah"
    ],
    "Çorlu": [
      "Alipaşa Mah",
      "Cumhuriyet Mah",
      "Çobançeşme Mah",
      "Deregündüzlü Mah",
      "Esentepe Mah",
      "Havuzlar Mah",
      "Hıdırağa Mah",
      "Hürriyet Mah",
      "Maksutlu Mah",
      "Muhittin Mah",
      "Önerler Mah",
      "Reşadiye Mah",
      "Rumeli Mah",
      "Sarılar Mah",
      "Seymen Mah",
      "Şahpaz Mah",
      "Şeyhsinan Mah",
      "Türkgücü Mah",
      "Türkgücü Osb Mah",
      "Yenice Mah",
      "Zafer Mah",
      "Cemaliye Mah",
      "Hatip Mah",
      "Kazımiye Mah",
      "Kemalettin Mah",
      "Nusratiye Mah",
      "Silahtarağa Mah"
    ],
    "Ergene": [
      "Ahimehmet Mah",
      "Bakırca Mah",
      "Cumhuriyet Mah",
      "Esenler Mah",
      "İğneler Mah",
      "Karamehmet Mah",
      "Kırkgöz Mah",
      "Marmaracık Mah",
      "Marmaracıkosb Mah",
      "Misinli Mah",
      "Paşaköy Mah",
      "Pınarbaşı Mah",
      "Sağlık Mah",
      "Ulaş Mah",
      "Ulaş Osb Mah",
      "Vakıflar Mah",
      "Vakıflar Osb Mah",
      "Velimeşe Mah",
      "Velimeşe Osb Mah",
      "Yeşiltepe Mah",
      "Yulaflı Mah"
    ],
    "Hayrabolu": [
      "Ataköy Mah",
      "Avluobası Mah",
      "Aydınevler Mah",
      "Aydınlar Mah",
      "Bayramşah Mah",
      "Buzağcı Mah",
      "Büyükkarakarlı Mah",
      "Cambazdere Mah",
      "Canhıdır Mah",
      "Çene Mah",
      "Çerkezmüsellim Mah",
      "Çıkrıkçı Mah",
      "Dambaslar Mah",
      "Danişment Mah",
      "Delibedir Mah",
      "Duğcalı Mah",
      "Emiryakup Mah",
      "Fahrioğlu Mah",
      "Hacıllı Mah",
      "Hasköy Mah",
      "Hayraboluosb Mah",
      "Hedeyli Mah",
      "Hisar Mah",
      "İlyas Mah",
      "İsmailli Mah",
      "Kabahöyük Mah",
      "Kadriye Mah",
      "Kahya Mah",
      "Kandamış Mah",
      "Karababa Mah",
      "Karabürçek Mah",
      "Karakavak Mah",
      "Karayahşi Mah",
      "Kemallar Mah",
      "Kılıçlar Mah",
      "Kurtdere Mah",
      "Kutlugün Mah",
      "Küçükkarakarlı Mah",
      "Lahna Mah",
      "Muzruplu Mah",
      "Örey Mah",
      "Övenler Mah",
      "Parmaksız Mah",
      "Soylu Mah",
      "Subaşı Mah",
      "Susuzmüsellim Mah",
      "Şalgamlı Mah",
      "Tatarlı Mah",
      "Temrezli Mah",
      "Umurbey Mah",
      "Umurçu Mah",
      "Yörgüç Mah",
      "Yörükler Mah"
    ],
    "Kapaklı": [
      "Atatürk Mah",
      "Bahçeağıl Mah",
      "Bahçelievler Mah",
      "Bahçelievlerosb Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "İnönü Mah",
      "İsmet Paşa Mah",
      "İsmetpaşaosb Mah",
      "Karaağaç Mah",
      "Karaağaç Osb Mah",
      "Karlı Mah",
      "Kazım Karabekir Mah",
      "Mimar Sinan Mah",
      "Pınarca Mah",
      "Uzunhacı Mah",
      "Yanıkağıl Mah"
    ],
    "Malkara": [
      "Ahievren Mah",
      "Ahmetpaşa Mah",
      "Aksakal Mah",
      "Alaybey Mah",
      "Allıışık Mah",
      "Bağpınarı Mah",
      "Balabancık Mah",
      "Ballı Mah",
      "Ballısüle Mah",
      "Batkın Mah",
      "Bayramtepe Mah",
      "Cami Atik Mah",
      "Çavuşköy Mah",
      "Çınaraltı Mah",
      "Çınarlıdere Mah",
      "Çimendere Mah",
      "Danişment Mah",
      "Davuteli Mah",
      "Deliller Mah",
      "Demircili Mah",
      "Dereköy Mah",
      "Deveci Mah",
      "Develi Mah",
      "Doğanköy Mah",
      "Dolu Mah",
      "Elmalı Mah",
      "Emirali Mah",
      "Esendik Mah",
      "Evrenbey Mah",
      "Gazibey Mah",
      "Gönence Mah",
      "Gözsüz Mah",
      "Güneşli Mah",
      "Hacıevhat Mah",
      "Hacısungur Mah",
      "Halıç Mah",
      "Hasköy Mah",
      "Hemit Mah",
      "Hereke Mah",
      "Izgar Mah",
      "İbribey Mah",
      "İbrice Mah",
      "İshakça Mah",
      "Kadıköy Mah",
      "Kalaycı Mah",
      "Karacagür Mah",
      "Karacahalil Mah",
      "Karaiğdemir Mah",
      "Karamurat Mah",
      "Kavakçeşme Mah",
      "Kermeyan Mah",
      "Kırıkali Mah",
      "Kiremitlik Mah",
      "Kozyörük Mah",
      "Kuyucu Mah",
      "Küçükhıdır Mah",
      "Kürtüllü Mah",
      "Mestanlar Mah",
      "Müstecep Mah",
      "Pirinççeşme Mah",
      "Sağlamtaş Mah",
      "Sarıpolat Mah",
      "Sarıyar Mah",
      "Sarnıç Mah",
      "Sırtbey Mah",
      "Şahin Mah",
      "Tekkeköy Mah",
      "Teteköy Mah",
      "Vakıfiğdemir Mah",
      "Yaylagöne Mah",
      "Yaylaköy Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Yenidibek Mah",
      "Yılanlı Mah",
      "Yörücek Mah",
      "Yörük Mah"
    ],
    "Marmaraereğlisi": [
      "Bahçelievler Mah",
      "Cedit Ali Paşa Mah",
      "Çeşmeli Mah",
      "Dereağzı Mah",
      "Kamaradere Mah",
      "Mustafa Kemal Paşa Mah",
      "Sultanköy Mah",
      "Türkmenli Mah",
      "Yakuplu Mah",
      "Yeniçiftlik Mah"
    ],
    "Muratlı": [
      "Arzulu Mah",
      "Aşağısevindikli Mah",
      "Aydınköy Mah",
      "Balabanlı Mah",
      "Ballıhoca Mah",
      "Çevrimkaya Mah",
      "Fatih Mah",
      "Hanoğlu Mah",
      "İnanlı Mah",
      "İstiklal-kurtpınar Mah",
      "İstiklalkurtpınar Osb Mah",
      "Kazım Dirik-turan Mah",
      "Kepenekli Mah",
      "Kırkkepenekli Mah",
      "Muradiye Mah",
      "Müsellim Mah",
      "Yavaşça Mah",
      "Yeşilsırt Mah",
      "Yukarısevindikli Mah",
      "Yukarısırt Mah",
      "Yurtbekler Mah"
    ],
    "Saray": [
      "Atatürk Mah",
      "Ayaspaşa Mah",
      "Ayvacık Mah",
      "Aziziye Mah",
      "Bahçedere Mah",
      "Bahçeköy Mah",
      "Beyazköy Mah",
      "Bozoba Mah",
      "Büyükyoncalı Merkez Mah",
      "Cumhuriyet Mah",
      "Çayla Mah",
      "Çukuryurt Mah",
      "Demirler Mah",
      "Edirköy Mah",
      "Göçerler Mah",
      "Güngörmez Mah",
      "Kadıköy Mah",
      "Karabürçek Mah",
      "Kavacık Mah",
      "Kemalpaşa Mah",
      "Kurtdere Mah",
      "Küçükyoncalı Mah",
      "Osmanlı Mah",
      "Pazarcık Mah",
      "Sefaalan Mah",
      "Sinanlı Mah",
      "Sofular Mah",
      "Yeni Mah",
      "Yuvalı Mah"
    ],
    "Süleymanpaşa": [
      "100. Yıl Mah",
      "Altınova Mah",
      "Ertuğrul Mah",
      "Topağaç Mah",
      "Vatan Mah",
      "Yavuz Mah",
      "Aydoğdu Mah",
      "Çınarlı Mah",
      "Karadeniz Mah",
      "Zafer Mah",
      "Atatürk Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Çiftlikönü Mah",
      "Değirmenaltı Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Namık Kemal Mah",
      "Ortacami Mah",
      "Barbaros Mah",
      "Kumbağ Mah",
      "Ahmedikli Mah",
      "Ahmetçe Mah",
      "Akçahalil Mah",
      "Araphacı Mah",
      "Aşağıkılıçlı Mah",
      "Avşar Mah",
      "Banarlı Mah",
      "Bıyıkali Mah",
      "Çanakçı Mah",
      "Dedecik Mah",
      "Demirli Mah",
      "Doğrukaracamurat Mah",
      "Evciler Mah",
      "Ferhadanlı Mah",
      "Gazioğlu Mah",
      "Generli Mah",
      "Gündüzlü Mah",
      "Güveçli Mah",
      "Hacıköy Mah",
      "Husunlu Mah",
      "Işıklar Mah",
      "İnecik Mah",
      "Karabezirgan Mah",
      "Karacakılavuz Mah",
      "Karaçalı Mah",
      "Karaevli Mah",
      "Karahalil Mah",
      "Karahisarlı Mah",
      "Karansıllı Mah",
      "Kaşıkçı Mah",
      "Kayı Mah",
      "Kazandere Mah",
      "Kılavuzlu Mah",
      "Kınıklar Mah",
      "Köseilyas Mah",
      "Mahramlı Mah",
      "Naipköy Mah",
      "Nusratfakı Mah",
      "Nusratlı Mah",
      "Oğuzlu Mah",
      "Ormanlı Mah",
      "Ortaca Mah",
      "Oruçbeyli Mah",
      "Osmanlı Mah",
      "Otmanlı Mah",
      "Selçuk Mah",
      "Semetli Mah",
      "Seymenli Mah",
      "Taşumurca Mah",
      "Tatarlı Mah",
      "Yağcı Mah",
      "Yayabaşı Mah",
      "Yazır Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yukarıkılıçlı Mah",
      "Yuva Mah"
    ],
    "Şarköy": [
      "Aşağıkalamış Mah",
      "Beyoğlu Mah",
      "Bulgur Mah",
      "Camikebir Mah",
      "Cumhuriyet Mah",
      "Çengelli Mah",
      "Çınarlı Mah",
      "Eriklice Mah",
      "Gaziköy Mah",
      "Gölcük Mah",
      "Güzelköy Mah",
      "Hoşköy Mah",
      "İğdebağları Mah",
      "İshaklı Mah",
      "İstiklal Mah",
      "Kızılcaterzi Mah",
      "Kirazlı Mah",
      "Kocaali Mah",
      "Mursallı Mah",
      "Mürefte Mah",
      "Palamut Mah",
      "Sofuköy Mah",
      "Şenköy Mah",
      "Tepeköy Mah",
      "Uçmakdere Mah",
      "Ulaman Mah",
      "Yayaağaç Mah",
      "Yayaköy Mah",
      "Yeniköy Mah",
      "Yörgüç Mah",
      "Yukarıkalamış Mah"
    ]
  },
  "Tokat": {
    "Almus": [
      "Akarçay Armutalan Mah (akarçay Görümlü Beldesi)",
      "Akarçay İstiklal Mah (akarçay Görümlü Beldesi)",
      "Akarçay Şehit Turan Yıldız Mah (akarçay Görümlü Beldesi)",
      "Akarçay Şenyurt Mah (akarçay Görümlü Beldesi)",
      "Atatürk Mah (akarçay Görümlü Beldesi)",
      "Cumhuriyet Mah (akarçay Görümlü Beldesi)",
      "İnönü Mah (akarçay Görümlü Beldesi)",
      "Şehit Tuncay Çoban Mah (akarçay Görümlü Beldesi)",
      "Erek Mah",
      "Esentepe Mah",
      "İstiklal Mah",
      "Kurtuluş Mah",
      "Ötükent Mah",
      "Siteler Mah",
      "Ata Mah (ataköy Beldesi)",
      "Bahçeköy Mah (ataköy Beldesi)",
      "Çambulak Mah (ataköy Beldesi)",
      "Katranlık Mah (ataköy Beldesi)",
      "Kuruseki Mah (ataköy Beldesi)",
      "Sağırlar Mah (ataköy Beldesi)",
      "Yeni Mah (ataköy Beldesi)",
      "Aydınlar Mah (çevreli Beldesi)",
      "Birlik Mah (çevreli Beldesi)",
      "Hürriyet Mah (çevreli Beldesi)",
      "Atatürk Mah (gölgeli Beldesi)",
      "Cumhuriyet Mah (gölgeli Beldesi)",
      "Hürriyet Mah (gölgeli Beldesi)",
      "Salkavak Mah (gölgeli Beldesi)",
      "Cumhuriyet Mah (kınık Beldesi)",
      "Gevrek Mah (kınık Beldesi)",
      "Hürriyet Mah (kınık Beldesi)",
      "Kurtuluş Mah (kınık Beldesi)",
      "Yuvaköy Mah (kınık Beldesi)",
      "Afet Evler Mah (alanköy Köyü)",
      "Ahmet Kahyagil Mah (hubyar Köyü)",
      "Alibeğgil Mah (hubyar Köyü)",
      "Altıtam Mahlesi Mah (arısu Köyü)",
      "Aşagı Alan Kolu Mah (alanköy Köyü)",
      "Aşağı Alan Mah (alanköy Köyü)",
      "Aşağı Bahtuman Mah (çiftlik Köyü)",
      "Aşağı Kamışçık Mah (çiftlik Köyü)",
      "Aşağı Mah (mescitköy Köyü)",
      "Aynacılar Mah (çiftlik Köyü)",
      "Babaköy Köyü",
      "Bağlıca Mah (çamköy Köyü)",
      "Bakımlı Köyü",
      "Barbaros Mah (ormandibi Köyü)",
      "Başaklar Mah (cihet Köyü)",
      "Başalan Mah (babaköy Köyü)",
      "Bayramgazi Mah (babaköy Köyü)",
      "Bekülü Mah (hubyar Köyü)",
      "Bentaltı Mah (bağtaşı Köyü)",
      "Budaklı Mah (çamköy Köyü)",
      "Çamdalı Köyü",
      "Çatak Mah (çiftlik Köyü)",
      "Çatak Mah (hubyar Köyü)",
      "Çavuşgiller Mah (çiftlik Köyü)",
      "Çayırlı Mahlesi Mah (arısu Köyü)",
      "Çaykaya Köyü",
      "Çaykıyı Köyü",
      "Çaykıyı Yaylası Mah (çaykıyı Köyü)",
      "Çilehane Köyü",
      "Değeryer Köyü",
      "Deli Ahmetgil Mah (hubyar Köyü)",
      "Derebaşı Mah (cihet Köyü)",
      "Dereköy Köyü",
      "Dervişali Mah (cihet Köyü)",
      "Durudere Köyü",
      "Fatih Mah (ormandibi Köyü)",
      "Garibgil-emicegil Mah (hubyar Köyü)",
      "Gebeli Köyü",
      "Gebeli Yayla Evleri Mah (gebeli Köyü)",
      "Göltepe Köyü",
      "Gümeleönü Köyü",
      "Güngörmez Mah (babaköy Köyü)",
      "Güven Mah (alanköy Köyü)",
      "Hacıgil Mah (çiftlik Köyü)",
      "Hamzalar Mah (çiftlik Köyü)",
      "Hasangil Mah (hubyar Köyü)",
      "Hokurdak Yaylası Mah (kapıcı Köyü)",
      "Hubyar Köyü",
      "Hüsnügil Mah (hubyar Köyü)",
      "Kamışcek Mah (hubyar Köyü)",
      "Kanlıdere Mah (babaköy Köyü)",
      "Kapıcı Köyü",
      "Karaahmetoğlu Mah (cihet Köyü)",
      "Karadere Köyü",
      "Karagözgil Mah (hubyar Köyü)",
      "Karşıyaka Mah (dikili Köyü)",
      "Kayalı Mah (kızılelma Köyü)",
      "Kendirlik Mah (babaköy Köyü)",
      "Kızıl Armut Mah (hubyar Köyü)",
      "Kol Mah (bağtaşı Köyü)",
      "Kolköy Köyü",
      "Kore Mah (babaköy Köyü)",
      "Koruçoluk Mevkii Mah (çamdalı Köyü)",
      "Köroğlu Mah (hubyar Köyü)",
      "Kurban Suyu Mah (babaköy Köyü)",
      "Kürtler Mah (kızılelma Köyü)",
      "Merkez Mah (çamköy Köyü)",
      "Merkez Mah (kızılelma Köyü)",
      "Oğulbey Köyü",
      "Orta Mah (mescitköy Köyü)",
      "Pelitli Burun Mah (babaköy Köyü)",
      "Sahilköy Köyü",
      "Sarıören Köyü",
      "Sarıören Yaylası Mah (sarıören Köyü)",
      "Serince Köyü",
      "Sorkun Mah (babaköy Köyü)",
      "Şht.mustafa Yeter Mah (dikili Köyü)",
      "Taşlıtarla Mah (alanköy Köyü)",
      "Teke Tamı Mah (hubyar Köyü)",
      "Tekkelioğlu Mah (kızılelma Köyü)",
      "Teknecik Köyü",
      "Tepe Mezrası Mah (çaykıyı Köyü)",
      "Uğurlu Mah (çamköy Köyü)",
      "Üçgöl Köyü",
      "Üsikgil Mah (kızılelma Köyü)",
      "Yavuz Mah (dikili Köyü)",
      "Yavuz Mah (ormandibi Köyü)",
      "Yayla Evleri Mah (bakımlı Köyü)",
      "Yayla Evleri Mah (değeryer Köyü)",
      "Yayla Evleri Mah (durudere Köyü)",
      "Yayla Evleri Mah (hubyar Köyü)",
      "Yayla Köy Dernek Evi Mah (çamdalı Köyü)",
      "Yayla Mah (arısu Köyü)",
      "Yayla Mah (kolköy Köyü)",
      "Yeni Mah (bağtaşı Köyü)",
      "Yeni Mah (hubyar Köyü)",
      "Yukarı Alan Mah (alanköy Köyü)",
      "Yukarı Bahtuma Mah (çiftlik Köyü)",
      "Yukarı Kamışcık Mah (çiftlik Köyü)",
      "Yukarı Mah (mescitköy Köyü)"
    ],
    "Artova": [
      "Alpaslan Mah",
      "Altınova Mah",
      "Gaziosmanpaşa Mah",
      "İstasyon Mah",
      "Kızılca Mah",
      "A.danışment Mezra Mah (ahmetdanişment Köyü)",
      "Ağmusa Köyü",
      "Ahmetdanişment Köyü",
      "Aktaş Köyü",
      "Aktaş Mezra Mah (aktaş Köyü)",
      "Aşağıgüçlü Köyü",
      "Bayırlı Köyü",
      "Bebekderesi Köyü",
      "Boyunpınar Köyü",
      "Çelikli Mah",
      "Devecikargın Köyü",
      "Evlideresi Köyü",
      "Gazipınarı Köyü",
      "Gümüşyurt Köyü",
      "Gürardıç Köyü",
      "İğdir Mah",
      "Karakuş Yaylası Mah (yukarıgüçlü Köyü)",
      "Kayaönü Köyü",
      "Kunduz Köyü",
      "Kunduzağılı Köyü",
      "Mertekli Köyü",
      "Poyrazalan Köyü",
      "Sağlıca Köyü",
      "Salur Köyü",
      "Söğütlü Yaylası Mah (yukarıgüçlü Köyü)",
      "Tanyeli Köyü",
      "Taşpınar Köyü",
      "Tuzla Köyü",
      "Ulusulu Köyü",
      "Yağcımusa Köyü",
      "Yenice Köyü",
      "Yukarıgüçlü Köyü"
    ],
    "Başçiftlik": [
      "Cumhuriyet Mah",
      "Gençosman Mah",
      "Karacaören Alibaba Mah",
      "Karacaören Aşıroğlu Mah",
      "Karacaören Gaziosmanpaşa Mah",
      "Sinanpaşa Mah",
      "Cumhuriyet Mah (hatipli Beldesi)",
      "Fatih Mah (hatipli Beldesi)",
      "Gençosman Mah (hatipli Beldesi)",
      "Alan Mah (alan Köyü)",
      "Alan Yaylası Mah (alan Köyü)",
      "Aydoğmuş Köyü",
      "Bürücek Yaylası Mah (alan Köyü)",
      "Dağüstü Mah (dağüstü Köyü)",
      "Düden Mah (dağüstü Köyü)",
      "Erikçayırı Mah (alan Köyü)",
      "Erikçayırı Yaylası Mah (alan Köyü)",
      "Karşıbağlar Mah (erikbelen Köyü)",
      "Kaynar Mah (alan Köyü)",
      "Kuştanlar Mah (erikbelen Köyü)",
      "Orta Mah (erikbelen Köyü)",
      "Sarıağıl Köyü",
      "Şahnaalan Köyü",
      "Şahnaalan Yaylası Mah (şahnaalan Köyü)",
      "Teknepınar Mah (erikbelen Köyü)",
      "Yeni Mah (erikbelen Köyü)",
      "Yukarı Mah (erikbelen Köyü)"
    ],
    "Erbaa": [
      "Ahmet Yesevi Mah",
      "Alacabal Mah",
      "Cumhuriyet Mah",
      "Erek Mah",
      "Ertuğrulgazi Mah",
      "Evyaba Mah",
      "Fatihsultanmehmet Mah",
      "Fevzipaşa Mah",
      "Fevzipaşa Mah (değirmenli Köyü)",
      "Fevzipaşa Mah (koçak Köyü)",
      "Gaziosmanpaşa Mah",
      "Gazipaşa Mah",
      "Gazipaşa Mah (değirmenli Köyü)",
      "Gündoğdu Mah",
      "İsmetpaşa Mah",
      "İsmetpaşa Mah (değirmenli Köyü)",
      "İsmetpaşa Mah (koçak Köyü)",
      "Karşıyaka Mah",
      "Kelkit Mah",
      "Kelkit Osb Mah",
      "Kuruçay Mah",
      "Mehmet Akif Mah",
      "Mevlana Mah",
      "Mimarsinan Mah",
      "Osmangazi Mah",
      "Yavuzsultanselim Mah",
      "Yeni Mah",
      "Yeşilyurt Mah",
      "Yeşilyurt Mah (koçak Köyü)",
      "Yıldırımbeyazıt Mah",
      "Yunusemre Mah",
      "Ziyagökalp Mah",
      "Alparslan Mah (gökal Beldesi)",
      "Çermik Kaplıca Mah (gökal Beldesi)",
      "Fatih Sultan Mehmet Mah (gökal Beldesi)",
      "Gazi Osman Paşa Mah (gökal Beldesi)",
      "Güldere Mah (gökal Beldesi)",
      "Karşıyaka Mah (gökal Beldesi)",
      "Sütlüce Mah (gökal Beldesi)",
      "Yavuz Sultan Selim Mah (gökal Beldesi)",
      "Yeşilyurt Mah (gökal Beldesi)",
      "Ağacalan Mah (erdemli Köyü)",
      "Akseki Mah (narlıdere Köyü)",
      "Alan Mah (alan Köyü)",
      "Alçakbel Mah (ortaköy Köyü)",
      "Aslanlar Mah (çatalan Köyü)",
      "Atatürk Mah (üzümlü Köyü)",
      "Bahçelievler Mah (karayaka Beldesi)",
      "Ballıbağ Köyü",
      "Batak Mah (dokuzçam Köyü)",
      "Billor Mah (çatalan Köyü)",
      "Büyran Mah (şükür Köyü)",
      "Çamlıgeniş Mah (ortaköy Köyü)",
      "Çampınarı Mah (erdemli Köyü)",
      "Çerçe Mah (alan Köyü)",
      "Çoğşur Mah (beykaya Köyü)",
      "Darılık Mah (beykaya Köyü)",
      "Değirmencebük Mah (beykaya Köyü)",
      "Dere Mah (ortaköy Köyü)",
      "Esentepe Mah (ortaköy Köyü)",
      "Farklar Mah (alan Köyü)",
      "Fatih Sultan Mehmet Mah (üzümlü Köyü)",
      "Gazi Osman Paşa Mah (üzümlü Köyü)",
      "Gedirgen Mah (kırıkgüney Köyü)",
      "Gemibaşı Mah (kale Köyü)",
      "Geriş Yazı Mah (ortaköy Köyü)",
      "Gölağıl Mah (beykaya Köyü)",
      "Gölbelen Mah (erdemli Köyü)",
      "Gültepe Mah (çatalan Köyü)",
      "Güney Mah (şükür Köyü)",
      "Hasan Alan Mah (kırıkgüney Köyü)",
      "Hayat Deresi Mah (şükür Köyü)",
      "Hürmüzlü Mah (karayaka Beldesi)",
      "İfsi Mah (erdemli Köyü)",
      "İmbolu Mah (kırıkgüney Köyü)",
      "Kabaklıbelen Mah (alan Köyü)",
      "Kale Köyü",
      "Karesi Mah (narlıdere Köyü)",
      "Karımca Mah (ortaköy Köyü)",
      "Karşı Mah (dokuzçam Köyü)",
      "Kavlağandere Mah (dokuzçam Köyü)",
      "Kavlağandere Yayla Evleri Mah (dokuzçam Köyü)",
      "Kavlandere Mah (çatalan Köyü)",
      "Kayaardı Mah (erdemli Köyü)",
      "Kayabaşı Mah (erdemli Köyü)",
      "Kestane Mah (ortaköy Köyü)",
      "Kırık Mah (kırıkgüney Köyü)",
      "Kısıktaş Mah (şükür Köyü)",
      "Kısıranız Mah (alan Köyü)",
      "Kışla Mah (narlıdere Köyü)",
      "Kışla Mah (ortaköy Köyü)",
      "Kışla Mah (şükür Köyü)",
      "Kızılcaalan Mah (çatalan Köyü)",
      "Kızılçukur Mah (şükür Köyü)",
      "Kızılotlu Mah (çatalan Köyü)",
      "Kirazdere Mah (narlıdere Köyü)",
      "Kuşçu Mah (beykaya Köyü)",
      "Kuz Alan Mah (erdemli Köyü)",
      "Kuzalan Mah (çatalan Köyü)",
      "Kuzköy Mah (şükür Köyü)",
      "Kuzyatak Mah (kırıkgüney Köyü)",
      "Lale Mah (kırıkgüney Köyü)",
      "Mercimek Mah (erdemli Köyü)",
      "Merkez Mah (çatalan Köyü)",
      "Merkez Mah (dokuzçam Köyü)",
      "Merkez Mah (erdemli Köyü)",
      "Merkez Mah (kırıkgüney Köyü)",
      "Merkez Mah (narlıdere Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (şükür Köyü)",
      "Meşelik Mah (beykaya Köyü)",
      "Orta Mah (karayaka Beldesi)",
      "Otlucak Mah (ortaköy Köyü)",
      "Salkımören Köyü",
      "Sekiyazı Mah (ballıbağ Köyü)",
      "Sele Mah (narlıdere Köyü)",
      "Sırt Mah (ortaköy Köyü)",
      "Taşlıman Mah (ballıbağ Köyü)",
      "Tepe Mah (karayaka Beldesi)",
      "Tombuldüz Mah (erdemli Köyü)",
      "Topdoruk Mah (kırıkgüney Köyü)",
      "Türkfındıcak Köyü",
      "Uluçukur Mah (alan Köyü)",
      "Üç Samanlık Mah (erdemli Köyü)",
      "Üçyüz Mah (ortaköy Köyü)",
      "Yabalı Mah (beykaya Köyü)",
      "Yatak Mah (narlıdere Köyü)",
      "Yayla Mah (çatalan Köyü)",
      "Yayla Mah (dokuzçam Köyü)",
      "Yayla Mah (kırıkgüney Köyü)",
      "Yayla Mah (salkımören Köyü)",
      "Yaylacık Köyü",
      "Yeşilyurt Mah (kale Köyü)",
      "Yukarı Mah (karayaka Beldesi)",
      "Ağcaalan Köyü",
      "Ağcakeçi Köyü",
      "Ahret Mah (akgün Köyü)",
      "Alan Mah (pınarbeyli Köyü)",
      "Alpaslan Mah (akça Köyü)",
      "Aşağıçandır Köyü",
      "Aşağıköy Mah (ustamehmet Köyü)",
      "Ayan Köyü",
      "Aydınsofu Köyü",
      "Ayyeri Mah (ikizce Köyü)",
      "Bağpınar Köyü",
      "Barak Mah (madenli Köyü)",
      "Benevü Mah (engelli Köyü)",
      "Benli Köyü",
      "Beşevler Mah (ikizce Köyü)",
      "Canbolat Köyü",
      "Cevizlik Mah (yurdalan Köyü)",
      "Cibril Köyü",
      "Çakır Köyü",
      "Çakırlar Mah (akgün Köyü)",
      "Çalkara Köyü",
      "Çamdibi Köyü",
      "Çayır Mah (ustamehmet Köyü)",
      "Çerkezfındıcak Köyü",
      "Çeşmeli Köyü",
      "Çevresu Köyü",
      "Çınarlı Mah (kuz Köyü)",
      "Çındırlı Mah (engelli Köyü)",
      "Çiddibi Mah (eryaba Köyü)",
      "Çirpi Dağ Mah (ustamehmet Köyü)",
      "Çizene Mah (tandırlı Köyü)",
      "Değirmen Yanı Mah (ustamehmet Köyü)",
      "Demirtaş Köyü",
      "Dere Tarla Mah (benli Köyü)",
      "Dereçiflik Mah (endikpınar Köyü)",
      "Dibek Mah (akgün Köyü)",
      "Dildos Mah (engelli Köyü)",
      "Doğanyurt Köyü",
      "Domuzdamı Mah (kuz Köyü)",
      "Dur Yayla Mah (benli Köyü)",
      "Endikpınar Köyü",
      "Eriklik Mah (yurdalan Köyü)",
      "Ermeydanı Köyü",
      "Evciler Köyü",
      "Ezebağı Köyü",
      "Geriş Mah (madenli Köyü)",
      "Göçahmet Mah (yurdalan Köyü)",
      "Göçahmetler Mah (yurdalan Köyü)",
      "Göllü Geriş Mah (madenli Köyü)",
      "Gölönü Köyü",
      "Gümüşalan Köyü",
      "Günise Mah (doğanyurt Köyü)",
      "Hacıali Köyü",
      "Hacıbükü Köyü",
      "Hacıpazar Köyü",
      "Hatun Pınarı Mah (benli Köyü)",
      "Haydarlı Mah (kuz Köyü)",
      "Hıdırlı Mah (akgün Köyü)",
      "Höngezli Mah (engelli Köyü)",
      "Irmak Kenarı Mah (engelli Köyü)",
      "İbilo Mah (engelli Köyü)",
      "İmamgil Mah (ikizce Köyü)",
      "İvaza Mah (yurdalan Köyü)",
      "İverönü Köyü",
      "Kağnıkdüzü Mah (yurdalan Köyü)",
      "Kaleboynu Mah (akgün Köyü)",
      "Kaleyazısı Mah (güveçli Köyü)",
      "Kamışlı Mah (cibril Köyü)",
      "Karaağaç Köyü",
      "Karakişi Mah (engelli Köyü)",
      "Karavu Mah (ustamehmet Köyü)",
      "Kartosman Köyü",
      "Kavalcık Köyü",
      "Keçeci Köyü",
      "Kelkaya Mah (akgün Köyü)",
      "Kervesevi Mah (engelli Köyü)",
      "Kestanelik Mah (yurdalan Köyü)",
      "Kılıçalan Mah (akgün Köyü)",
      "Kızılbük Mah (yurdalan Köyü)",
      "Kızılçubuk Köyü",
      "Kocatarla Mah (akgün Köyü)",
      "Kozlu Köyü",
      "Köroğlu Mah (güveçli Köyü)",
      "Köyyeri Mah (ustamehmet Köyü)",
      "Kundakçıgil Mah (ikizce Köyü)",
      "Kurtuluş Köyü",
      "Küplüce Köyü",
      "Menderes Mah (akça Köyü)",
      "Merkez Mah (akgün Köyü)",
      "Merkez Mah (eryaba Köyü)",
      "Merkez Mah (ikizce Köyü)",
      "Merkez Mah (kuz Köyü)",
      "Merkez Mah (tandırlı Köyü)",
      "Merkez Mah (tepekışla Köyü)",
      "Meydandüzü Köyü",
      "Mundar Yazı Mah (madenli Köyü)",
      "Ocakbaşı Köyü",
      "Oğlakçı Köyü",
      "Orta Mah (güveçli Köyü)",
      "Ömerpaşa Mah (akça Köyü)",
      "Ötegeçe Mah (eryaba Köyü)",
      "Öteköy Mah (akgün Köyü)",
      "Pınarbeyli Köyü",
      "Sakarçal Mah (yurdalan Köyü)",
      "Sancar Mah (ikizce Köyü)",
      "Sokutaş Köyü",
      "Sülük Gölü Mah (yurdalan Köyü)",
      "Şahinbaşı Mah (kuz Köyü)",
      "Şimşirlik Mah (engelli Köyü)",
      "Şükürevi Mah (akgün Köyü)",
      "Teveklal Mah (ustamehmet Köyü)",
      "Tombaşlar Mah (yurdalan Köyü)",
      "Tosunlar Köyü",
      "Yaylalı Köyü",
      "Yazarbaşı Mah (engelli Köyü)",
      "Yeni Mah (tepekışla Köyü)",
      "Yeşilyurt Mah (akça Köyü)",
      "Yolağacı Mah (madenli Köyü)",
      "Yoldere Köyü",
      "Yukarıçandır Köyü",
      "Yukarıköy Mah (ustamehmet Köyü)",
      "Zoğallıçukur Köyü",
      "Akkoç Mah (tanoba Beldesi)",
      "Bahçelievler Mah (tanoba Beldesi)",
      "Çankaya Mah (tanoba Beldesi)",
      "Fevzipaşa Mah (tanoba Beldesi)",
      "Gürpınar Mah (tanoba Beldesi)"
    ],
    "Merkez": [
      "Akın Mah (çamlıbel Beldesi)",
      "Aktepe Mah (çamlıbel Beldesi)",
      "Behram Mah (çamlıbel Beldesi)",
      "Çekerek Mah (çamlıbel Beldesi)",
      "Karasu Mah (çamlıbel Beldesi)",
      "Yunusemre Mah (çamlıbel Beldesi)",
      "Cumhuriyet Mah (çat Beldesi)",
      "Karşıyaka Mah (çat Beldesi)",
      "Merkez Mah (çat Beldesi)",
      "Bahçelievler Mah (emirseyit Beldesi)",
      "Bozatalan Mah (emirseyit Beldesi)",
      "Güneşli Mah (emirseyit Beldesi)",
      "Akdeğirmen Mah",
      "Alipaşa Mah",
      "Altıyüzevler Mah",
      "Bahçelievler Mah",
      "Bedestenlioğlu Mah",
      "Bedestenlioğluosb Mah",
      "Büyük Beybağı Mah",
      "Camiikebir Mah",
      "Cemalettin Mah",
      "Çay Mah",
      "Derbent Mah",
      "Devegörmez Mah",
      "Doğancıbağları Mah",
      "Doğukent Mah",
      "Erenler Mah",
      "Esentepe Mah",
      "Geyras Mah",
      "Gezirlik Mah",
      "Gülbaharhatun Mah",
      "Güneşli Mah",
      "Hocaahmet Mah",
      "Kabe-i Mescid Mah",
      "Kaleardı Mah",
      "Kaşıkcıbağları Mah",
      "Kemer Mah",
      "Küçükbey Bağı Mah",
      "Kümbet Mah",
      "Mahmutpaşa Mah",
      "Mehmetpaşa Mah",
      "Oğulbey Mah",
      "Örtmeliönü Mah",
      "Perakende Mah",
      "Semerkant Mah",
      "Seyitnecmettin Mah",
      "Soğukpınar Mah",
      "Topçam Mah",
      "Topçubağı Mah",
      "Yarahmet Mah",
      "Yeni Mah",
      "Yeniyurt Mah",
      "Yeşilırmak Mah",
      "Yeşilova Mah",
      "Acıpınar Köyü",
      "Binecek Köyü",
      "Boyalı Köyü",
      "Cumhuriyet Mah (yağmurlu Köyü)",
      "Çamağzı Köyü",
      "Çamlık Köyü",
      "Çökelikkışla Köyü",
      "Dere Mevki Mah (yakacık Köyü)",
      "Derekışla Köyü",
      "Efe Köyü",
      "Ekincilik Köyü",
      "Eze Mah (eze Köyü)",
      "Fatih Mah (akbelen Köyü)",
      "Gökçeyol Mah (gökçeyol Köyü)",
      "Gökdere Köyü",
      "Gölcük Köyü",
      "Gözova Köyü",
      "Kabakboğazı Köyü",
      "Karakaya Köyü",
      "Karşıyaka Mah (yağmurlu Köyü)",
      "Kurtuluş Mah (yağmurlu Köyü)",
      "Merkez Mah (yakacık Köyü)",
      "Musalla Mah (akbelen Köyü)",
      "Musullu Köyü",
      "Mülk Köyü",
      "Ormanbeyli Köyü",
      "Orta Mah (avlunlar Köyü)",
      "Şehitler Köyü",
      "Yaylaevleri Mah (yakacık Köyü)",
      "Yazıbaşı Köyü",
      "Yeni Mah (akbelen Köyü)",
      "Yenice Köyü",
      "Ali Yücel Mah (güryıldız Beldesi)",
      "Bahçelievler Mah (güryıldız Beldesi)",
      "Kanalaltı Mah (güryıldız Beldesi)",
      "Küçükyıldız Mah (güryıldız Beldesi)",
      "Şht.abdullah Özer Mah (güryıldız Beldesi)",
      "Karşıyaka Mah",
      "Ahmetalan Köyü",
      "Akyamaç Köyü",
      "Akyurt Köyü",
      "Alan Köyü",
      "Alaybey Çiftliği Mah (dereyaka Köyü)",
      "Altuntaş Köyü",
      "Aluç Köyü",
      "Aşağıfırındere Köyü",
      "Atatürk Mah (kemalpaşa Köyü)",
      "Avşarağzı Köyü",
      "Aydınca Mah (aydınca Köyü)",
      "Aydoğdu Köyü",
      "Aydoğdu Mah (güzelce Köyü)",
      "Bağbaşı Köyü",
      "Bahçelievler Mah (büyükyıldız Köyü)",
      "Bakışlı Köyü",
      "Bakışlı Mah (bakışlı Köyü)",
      "Balıbey Yaylası Mah (kızık Köyü)",
      "Ballıdere Köyü",
      "Batmantaş Köyü",
      "Bedirkale Köyü",
      "Beşören Köyü",
      "Bula Köyü",
      "Büyükbağlar Köyü",
      "Cumhuriyet Mah (kemalpaşa Köyü)",
      "Çamaltı Köyü",
      "Çamdere Köyü",
      "Çaputsuyu Mah (tahtuba Köyü)",
      "Çatalkaya Köyü",
      "Çayören Köyü",
      "Çerçi Köyü",
      "Çerdiğin Köyü",
      "Çördük Köyü",
      "Çöreğibüyük Köyü",
      "Çubuklu Köyü",
      "Daylıhacı Köyü",
      "Dedeli Merkez Mah (dedeli Köyü)",
      "Dereağzı Köyü",
      "Dodurga Köyü",
      "Döllük Köyü",
      "Eski Köyü",
      "Gaziosmanpaşa Köyü",
      "Gaziosmanpaşa Üniversitesi Kampüsü Mah (taşlıçiftlik Köyü)",
      "Gökçe Köyü",
      "Güğümlü Merkez Mah (güğünlü Köyü)",
      "Gülpınar Köyü",
      "Gültepe Mah (büyükyıldız Köyü)",
      "Gümenek Köyü",
      "Günevi Köyü",
      "Günevi Mah (günevi Köyü)",
      "Güzeldere Köyü",
      "Hanpınar Köyü",
      "Hasanbaba Köyü",
      "Hasanbaba Mah (hasanbaba Köyü)",
      "İhsaniye Köyü",
      "İnanlı Mah (küçükbağlar Köyü)",
      "İnönü Mah (kemalpaşa Köyü)",
      "Kadıvakfı Köyü",
      "Kahvepınarı Mah (tahtuba Köyü)",
      "Karkın Köyü",
      "Karkıncık Köyü",
      "Kervansaray Köyü",
      "Keşlik Köyü",
      "Kılıçlı Mah (gümenek Köyü)",
      "Kışla Mah (kızık Köyü)",
      "Kızılkaya Köyü",
      "Kızılköy Köyü",
      "Kızılöz Köyü",
      "Kızılyazı Mah (tahtuba Köyü)",
      "Killik Köyü",
      "Kocacık Köyü",
      "Kocapınar Mah (tahtuba Köyü)",
      "Kömeç Köyü",
      "Köyünkendisi Mah (halilalan Köyü)",
      "Madas Köyü",
      "Merkez Mah (aydınca Köyü)",
      "Merkez Mah (dereyaka Köyü)",
      "Merkez Mah (günçalı Köyü)",
      "Merkez Mah (güzelce Köyü)",
      "Merkez Mah (kızık Köyü)",
      "Merkez Mah (küçükbağlar Köyü)",
      "Merkez Mah (tahtuba Köyü)",
      "Merkez Mah (taşlıçiftlik Köyü)",
      "Merkez Mah (yelpe Köyü)",
      "Nebi Köyü",
      "Ortaören Köyü",
      "Pınarlı Köyü",
      "Saltık Mah (çördük Köyü)",
      "Sarıtarla Köyü",
      "Semerci Köyü",
      "Sevindik Köyü",
      "Sırçalı Köyü",
      "Söngüt Köyü",
      "Sündüs Çiftliği Mah (dereyaka Köyü)",
      "Şenköy Köyü",
      "Tayyar Şahin Çiftliği Mah (dereyaka Köyü)",
      "Tekneli Köyü",
      "Uğrak Köyü",
      "Ulaş Köyü",
      "Ulaş Mah (ulaş Köyü)",
      "Yatmış Köyü",
      "Yayla Evleri Mah (aydınca Köyü)",
      "Yayla Evleri Mah (dedeli Köyü)",
      "Yayla Evleri Mah (yelpe Köyü)",
      "Yayladalı Mah (yayladalı Köyü)",
      "Yayladalı Merkez Mah (yayladalı Köyü)",
      "Yayladalı Yaylası Mah (yayladalı Köyü)",
      "Yaylaevleri Mah (günçalı Köyü)",
      "Yeşilırmak Mah (büyükyıldız Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Çiftlik Mah (güğünlü Köyü)"
    ],
    "Niksar": [
      "Bahçelievler Mah (gökçeli Beldesi)",
      "Ballıca Mah (gökçeli Beldesi)",
      "Bayraktepe Köyü",
      "Gözpınar Mah (gökçeli Beldesi)",
      "Günlüce Köyü",
      "İncirli Mah (kümbetli Köyü)",
      "Kavaklı Mah (oluklu Köyü)",
      "Kömüşlük Mah (sorhun Köyü)",
      "Kümbetli Mah (kümbetli Köyü)",
      "Merkez Mah (eryaba Köyü)",
      "Oluklu Mah (oluklu Köyü)",
      "Sorhun Mah (sorhun Köyü)",
      "Teknealan Köyü",
      "Tepeyatak Köyü",
      "Yakınca Mah (gökçeli Beldesi)",
      "Yeni Mah (gökçeli Beldesi)",
      "Yukarı Mah (eryaba Köyü)",
      "Buz Mah (gürçeşme Beldesi)",
      "Eskidir Mah (gürçeşme Beldesi)",
      "Gazi Osman Paşa Mah (gürçeşme Beldesi)",
      "Niksar Osb Mah (gürçeşme Beldesi)",
      "Yapraklı Mah (gürçeşme Beldesi)",
      "Ağdırkolu Mah (yeşilhisar Köyü)",
      "Ağıl Mah (akıncı Köyü)",
      "Araköy Köyü",
      "Arıpınar Köyü",
      "Armağanlı Mah (çatak Köyü)",
      "Asar Köyü",
      "Asi Gözü Mah (ayvalı Köyü)",
      "Aşağı Mah (arpaören Köyü)",
      "Aşağı Mah (şıhlar Köyü)",
      "Atatürk Mah (kuyucak Köyü)",
      "Avcıoğlu Mah (kapıağzı Köyü)",
      "Ayvalı Mah (ayvalı Köyü)",
      "Ayvaz Mah (güvenli Köyü)",
      "Basroğul Mah (çalca Köyü)",
      "Beyçayırı Köyü",
      "Boyluca Köyü",
      "Bozcaarmut Köyü",
      "Budaklı Köyü",
      "Bük Mah (arpaören Köyü)",
      "Camidere Köyü",
      "Cumhuriyet Mah (kuyucak Köyü)",
      "Çakırlar Mah (pelitli Köyü)",
      "Çakmak Mah (kapıağzı Köyü)",
      "Çakmak Mah (özveren Köyü)",
      "Çatak Mah (çatak Köyü)",
      "Çiçekli Köyü",
      "Çimenözü Köyü",
      "Çolaklar Mah (gökçeoluk Köyü)",
      "Dalkaya Köyü",
      "Değirmen Mah (köklüce Köyü)",
      "Derindere Köyü",
      "Derlen Mah (kapıağzı Köyü)",
      "Dönekse Mah",
      "Edilli Köyü",
      "Efkerit Mah (direkli Köyü)",
      "Elmabükü Mah (çalca Köyü)",
      "Esence Köyü",
      "Eskiköy Mah (kapıağzı Köyü)",
      "Eyneağzı Köyü",
      "Fakir Damı Mah (gülebi Köyü)",
      "Gazi Osman Paşa Mah (özalan Köyü)",
      "Gerit Köyü",
      "Geyikgölü Köyü",
      "Göl Arkası Mah (gülebi Köyü)",
      "Güdüklü Köyü",
      "Gülbayır Köyü",
      "Gültepe Köyü",
      "Güzelyayla Köyü",
      "Hacılı Köyü",
      "Hasanköy Mah (hanyeri Köyü)",
      "Hayderbey Mah",
      "Hüseyingazi Köyü",
      "Ilıcak Mah (gökçeoluk Köyü)",
      "Ilıcak Mah (terzioğlu Köyü)",
      "Irmak Mah (büyükyurt Köyü)",
      "Irmak Mah (kaşıkcı Köyü)",
      "Kambur Mah (gülbayır Köyü)",
      "Karaağaç Mah (akgüney Köyü)",
      "Karabayır Mah (ışıklı Köyü)",
      "Karabodur Köyü",
      "Karakaş Köyü",
      "Karakese Mah (bilgili Köyü)",
      "Keçiyatağı Mah (çalca Köyü)",
      "Kilise Mah (ardıçlı Köyü)",
      "Kiracı Köyü",
      "Koçgan Mah (kapıağzı Köyü)",
      "Koçu Mah (cerköy Köyü)",
      "Korulu Köyü",
      "Köklüce Mah (köklüce Köyü)",
      "Kumçiftlik Mah",
      "Kurudere Mah (köklüce Köyü)",
      "Kürtlerderesi Mah (ışıklı Köyü)",
      "Madiller Mah (kapıağzı Köyü)",
      "Mahmudiye Köyü",
      "Mecirif Mah (çay Köyü)",
      "Mercimekdüzü Köyü",
      "Merkez Mah (akgüney Köyü)",
      "Merkez Mah (akıncı Köyü)",
      "Merkez Mah (ardıçlı Köyü)",
      "Merkez Mah (bilgili Köyü)",
      "Merkez Mah (büyükyurt Köyü)",
      "Merkez Mah (cerköy Köyü)",
      "Merkez Mah (çalca Köyü)",
      "Merkez Mah (çay Köyü)",
      "Merkez Mah (direkli Köyü)",
      "Merkez Mah (gökçeoluk Köyü)",
      "Merkez Mah (güvenli Köyü)",
      "Merkez Mah (hanyeri Köyü)",
      "Merkez Mah (kapıağzı Köyü)",
      "Merkez Mah (kaşıkcı Köyü)",
      "Merkez Mah (terzioğlu Köyü)",
      "Merkez Mah (yeşilhisar Köyü)",
      "Mezra Köyü",
      "Muhtardüzü Köyü",
      "Musapınarı Köyü",
      "Mutluca Köyü",
      "Olukalan Mah (özalan Köyü)",
      "Ormancık Köyü",
      "Osmaniye Köyü",
      "Örenler Köyü",
      "Özdemir Mah (gülebi Köyü)",
      "Özveren Köyü",
      "Pelitlik Mah (çiçekli Köyü)",
      "Pelitlik Mah (pelitli Köyü)",
      "Porsuk Mah (kapıağzı Köyü)",
      "Recepdere Mah (akıncı Köyü)",
      "Sarıyazı Mah (sarıyazı Köyü)",
      "Sulugöl Köyü",
      "Şahinli Köyü",
      "Tahtalı Köyü",
      "Tenevli Mah (ışıklı Köyü)",
      "Topkara Mah (yeşilhisar Köyü)",
      "Ulusuluk Mah (çalca Köyü)",
      "Ulusuluk Mah (çatak Köyü)",
      "Umurlu Köyü",
      "Ustahasan Köyü",
      "Uzunoğlu Mah (kapıağzı Köyü)",
      "Yağan Mah (sarıyazı Köyü)",
      "Yalıköy Köyü",
      "Yarbaşı Köyü",
      "Yelmük Mah (çatak Köyü)",
      "Yeşilkaya Köyü",
      "Yeşilköy Köyü",
      "Yeşilyurt Köyü",
      "Yetimoğlu Mah (kuyucak Köyü)",
      "Yukarı Mah (arpaören Köyü)",
      "Yukarı Mah (şıhlar Köyü)",
      "50.yıl Mah",
      "Akpınar Mah",
      "Akpınar Mah (günebakan Köyü)",
      "Aydınlıkevler Mah",
      "Ayvaz Mah",
      "Bağlar Mah",
      "Bahçelievler Mah",
      "Bengiler Mah",
      "Cedit Mah",
      "Cepnibey Mah",
      "Çengelli Mah",
      "Fatih Mah",
      "Fatih Mah (günebakan Köyü)",
      "G.osmanpaşa Mah",
      "Gaziahmet Mah",
      "Hamidiye Mah",
      "İsmetpaşa Mah",
      "Kayapaşa Mah",
      "Kılıçarslan Mah",
      "Kırkkızlar Mah",
      "Kültür Mah",
      "Melikgazi Mah",
      "Şair Emrah Mah",
      "Yeni Mah (günebakan Köyü)",
      "Yusufşah Mah",
      "Ayvaköy Mah (serenli Beldesi)",
      "Beyazıt Mah (serenli Beldesi)",
      "Fatih Mah (serenli Beldesi)",
      "Gazi Osman Paşa Mah (serenli Beldesi)",
      "Tamlar Mah (serenli Beldesi)",
      "Kültür Mah (yazıcık Beldesi)",
      "Şafak Mah (yazıcık Beldesi)",
      "Yeni Mah (yazıcık Beldesi)",
      "Yeşilçam Mah (yazıcık Beldesi)",
      "Hasyer Mah (yolkonak Beldesi)",
      "Katipgölü Mah (yolkonak Beldesi)",
      "Merkez Mah (yolkonak Beldesi)",
      "Yeşilyurt Mah (yolkonak Beldesi)"
    ],
    "Pazar": [
      "Ballıca Köyü",
      "Beşevler Köyü",
      "Çayköy Köyü",
      "Çaylak Mah (bağlarbaşı Köyü)",
      "Çiftlikköy Köyü",
      "Dereçaylı Köyü",
      "Doğancalı Köyü",
      "Kaledere Köyü",
      "Manastır Mah (kaledere Köyü)",
      "Menteşe Köyü",
      "Merkez Mah (bağlarbaşı Köyü)",
      "Merkez Mah (dereköy Köyü)",
      "Ocaklı Köyü",
      "Ovacık Köyü",
      "Ovayurt Köyü",
      "Taşlık Köyü",
      "Tatarköy Köyü",
      "Tepeçaylı Köyü",
      "Yukarı Mah (tepeçaylı Köyü)",
      "Erkilet Mah",
      "Esentepe Mah",
      "Merkez Mah",
      "Seyitali Mah",
      "Sinanpaşa Mah",
      "Tekke Mah",
      "Fatih Mah (üzümören Beldesi)",
      "Gazi Osman Paşa Mah (üzümören Beldesi)",
      "Kazova Mah (üzümören Beldesi)",
      "Mehmet Akif Ersoy Mah (üzümören Beldesi)",
      "Mrş.fevzi Çakmak Mah (üzümören Beldesi)",
      "Yeşildere Mah (üzümören Beldesi)"
    ],
    "Reşadiye": [
      "Gökcesüleymanlı Mah (baydarlı Beldesi)",
      "Gündoğdu Mah (baydarlı Beldesi)",
      "Medrese Mah (baydarlı Beldesi)",
      "Merkez Mah (baydarlı Beldesi)",
      "Yükseliş Mah (baydarlı Beldesi)",
      "Çakraz Mah (bereketli Beldesi)",
      "Elmacık Köyü",
      "Elmacık Mah (elmacık Köyü)",
      "Eskituraç Mah (bereketli Beldesi)",
      "Güzeldere Köyü",
      "Güzeldere Yaylası Mah (güzeldere Köyü)",
      "Hebüllü Mah (bereketli Beldesi)",
      "Kadılı Mah (taşlıca Köyü)",
      "Kayalık Mah (bereketli Beldesi)",
      "Orta Mah (bereketli Beldesi)",
      "Taşlıca Köyü",
      "Toklar Köyü",
      "Yaylası Mah (taşlıca Köyü)",
      "Yeni Mah (bereketli Beldesi)",
      "Gerdengeç Mah (bozçalı Beldesi)",
      "Hacı Abidin Mah (bozçalı Beldesi)",
      "Işıklar Mah (bozçalı Beldesi)",
      "Nizam Mah (bozçalı Beldesi)",
      "Orta Mah (bozçalı Beldesi)",
      "Zafer Mah (bozçalı Beldesi)",
      "Alpler Mah (cimitekke Beldesi)",
      "Cimisadi Mah (cimitekke Beldesi)",
      "Çamlık Mah (cimitekke Beldesi)",
      "Erenler Mah (cimitekke Beldesi)",
      "Halaçlı Mah (cimitekke Beldesi)",
      "Kavaklıdere Mah (cimitekke Beldesi)",
      "Keteniği Mah (cimitekke Beldesi)",
      "Gündoğan Mah (hasanşeyh Beldesi)",
      "Gürpınar Mah (hasanşeyh Beldesi)",
      "Hasangazi Mah (hasanşeyh Beldesi)",
      "Keçiköy Mah (hasanşeyh Beldesi)",
      "Şeyhlioğlu Mah (hasanşeyh Beldesi)",
      "Tahirbey Mah (hasanşeyh Beldesi)",
      "Uluköy Mah (hasanşeyh Beldesi)",
      "Abdurrahmanlı Köyü",
      "Acemli Mah (tozanlıfındıcak Köyü)",
      "Adatepe Mah (çayırpınar Köyü)",
      "Ağcalar Mah (ismailiye Köyü)",
      "Ağılyanı Mah (kızılcaören Köyü)",
      "Akdoğmuş Köyü",
      "Akkaya Mah (dalpınar Köyü)",
      "Akpınar Mevki Yaylası Mah (akdoğmuş Köyü)",
      "Aksu Mah (umurca Köyü)",
      "Alıcık Mah (saraykışla Köyü)",
      "Alibey Mah (güneygölcük Köyü)",
      "Altıparmak Mah",
      "Annakkaya Mah (güneygölcük Köyü)",
      "Arzalan Mah (sazak Köyü)",
      "Arzupınar Mah (demircili Köyü)",
      "Askerağa Mah (darıdere Köyü)",
      "Atatürk Mah (çevrecik Köyü)",
      "Atatürk Mah (kızılcaören Köyü)",
      "Aydınlar Mah (ismailiye Köyü)",
      "Bağdatlı Köyü",
      "Batmış Mah (çamlıkaya Köyü)",
      "Bayırbaşı Köyü",
      "Bayramaltı Mah (ismailiye Köyü)",
      "Bayramaltı Mah (karşıkent Köyü)",
      "Bostankolu Deresi Mah (bostankolu Köyü)",
      "Buloğlu Mah (göllüköy Köyü)",
      "Bük Mah (çayırpınar Köyü)",
      "Büyükbeşdere Mah (beşdere Köyü)",
      "Büyükbük Mah (köklü Köyü)",
      "Cafaroğlu Mah (nebişeyh Köyü)",
      "Cemel Mah (cemel Köyü)",
      "Coşkunlar Mah (ismailiye Köyü)",
      "Cumhuriyet Mah (büşürüm Köyü)",
      "Cumhuriyet Mah (çevrecik Köyü)",
      "Cumhuriyet Mah (kızılcaören Köyü)",
      "Cumhuriyet Mah (soğukpınar Köyü)",
      "Çakır Mah (uğurlu Köyü)",
      "Çakırlı Köyü",
      "Çakırlı Yaylası Mah (çakırlı Köyü)",
      "Çakmak Köyü",
      "Çambalı Köyü",
      "Çat Köyü",
      "Çatak Mah (dalpınar Köyü)",
      "Çavuşbeyli Köyü",
      "Çidemlik Mah (karacaağaç Köyü)",
      "Çukur Mah (gülburnu Köyü)",
      "Damatlar Mah (dalpınar Köyü)",
      "Danişment Köyü",
      "Deveciler Mah (sazak Köyü)",
      "Dip Mah (esenköy Köyü)",
      "Dip Mah (karacaağaç Köyü)",
      "Doğantepe Köyü",
      "Dolay Köyü",
      "Donbey Mah (tozanlıfındıcak Köyü)",
      "Dutdibi Köyü",
      "Elmadibi Mah (güneygölcük Köyü)",
      "Emirşeyh Mah (nebişeyh Köyü)",
      "Erdemler Mah (ismailiye Köyü)",
      "Erdemler Yaylası Mah (ismailiye Köyü)",
      "Eymür Köyü",
      "Eyüp Köyü",
      "Gedik Mah (çamlıkaya Köyü)",
      "Gökçe Pınar Mah (umurca Köyü)",
      "Gölayağı Mah (çayırpınar Köyü)",
      "Gurbetli Köyü",
      "Gülebili Mah (güneygölcük Köyü)",
      "Gülkonak Köyü",
      "Gülkonak Yaylası Mah (gülkonak Köyü)",
      "Güllüce Köyü",
      "Güllüce Mah (güllüce Köyü)",
      "Güvendik Köyü",
      "Güvendik Yaylası Mah (güvendik Köyü)",
      "Hacı Murat Mah (yuvacık Köyü)",
      "Halaç Mah (darıdere Köyü)",
      "Hamzalı Mah (çınarcık Köyü)",
      "Hasanlı Mah (beşdere Köyü)",
      "Haydarlar Mah (sazak Köyü)",
      "Hündüllü Mah (ismailiye Köyü)",
      "Hürriyet Mah (nebişeyh Köyü)",
      "Hürriyet Mah (soğukpınar Köyü)",
      "Irmak Mah (çavuşbeyli Köyü)",
      "Irmak Mah (kabalı Köyü)",
      "Irmak Mah (karlıyayla Köyü)",
      "İbrahimşeyh Köyü",
      "İbrahimşeyh Yaylası Mah (ibrahimşeyh Köyü)",
      "İdirin Bükü Mah (köklü Köyü)",
      "İdris Mah (darıdere Köyü)",
      "İnek Alan Yaylası Mah (eymür Köyü)",
      "İnönü Mah (çevrecik Köyü)",
      "İslamlı Köyü",
      "Kale Mah (kuzbağı Köyü)",
      "Kale Mah (yolüstü Köyü)",
      "Kamışlık Mah (tozanlıfındıcak Köyü)",
      "Kapaklı Köyü",
      "Karaali Mah (güneygölcük Köyü)",
      "Karataş Köyü",
      "Kargı Deresi Mah (bostankolu Köyü)",
      "Kargı Mah (bostankolu Köyü)",
      "Karlıyayla Mah (karlıyayla Köyü)",
      "Kasımlar Mah (yoğunpelit Köyü)",
      "Kaşpınar Köyü",
      "Katı Yaylası Mah (islamlı Köyü)",
      "Katırcıoğlu Mah (darıdere Köyü)",
      "Kayabaşı Mah (çamlıkaya Köyü)",
      "Keçeli Mah (özlüce Köyü)",
      "Keltekne Mah (karacaağaç Köyü)",
      "Kendirlik Mah (sazak Köyü)",
      "Keşlik Mah (gökköy Köyü)",
      "Keti Mah (göllüköy Köyü)",
      "Keti Mah (kabalı Köyü)",
      "Keti Mah (sarıyayla Köyü)",
      "Keti Yaylası Mah (çambalı Köyü)",
      "Keti Yaylası Mah (muratkaya Köyü)",
      "Kılıçlı Mah (yenituraç Köyü)",
      "Kırık Mah (sazak Köyü)",
      "Kışlaoğlu Mah (yuvacık Köyü)",
      "Kiraz Alanı Yaylası Mah (çambalı Köyü)",
      "Kiren Parası Mah (karşıkent Köyü)",
      "Konak Köyü",
      "Kösamar Mah (akdoğmuş Köyü)",
      "Köseler Mah (gülburnu Köyü)",
      "Köy Deresi Mah (karşıkent Köyü)",
      "Kurtuluş Mah (demircili Köyü)",
      "Kustam Mah (uğurlu Köyü)",
      "Kuyucak Köyü",
      "Kuzgölcük Köyü",
      "Küçükbeşdere Mah (beşdere Köyü)",
      "Küçükbük Mah (köklü Köyü)",
      "Mahmutlu Mah (muratkaya Köyü)",
      "Mandallı Önü Mah (ismailiye Köyü)",
      "Mere Mah (çayırpınar Köyü)",
      "Merkez Mah (bostankolu Köyü)",
      "Merkez Mah (büşürüm Köyü)",
      "Merkez Mah (çamlıkaya Köyü)",
      "Merkez Mah (çınarcık Köyü)",
      "Merkez Mah (dalpınar Köyü)",
      "Merkez Mah (döllük Köyü)",
      "Merkez Mah (esenköy Köyü)",
      "Merkez Mah (gökköy Köyü)",
      "Merkez Mah (göllüköy Köyü)",
      "Merkez Mah (gülburnu Köyü)",
      "Merkez Mah (kabalı Köyü)",
      "Merkez Mah (karlıyayla Köyü)",
      "Merkez Mah (karşıkent Köyü)",
      "Merkez Mah (köklü Köyü)",
      "Merkez Mah (muratkaya Köyü)",
      "Merkez Mah (saraykışla Köyü)",
      "Merkez Mah (soğukpınar Köyü)",
      "Merkez Mah (uğurlu Köyü)",
      "Merkez Mah (umurca Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Merkez Mah (yoğunpelit Köyü)",
      "Merkez Mah (yolüstü Köyü)",
      "Merkez Mah (yuvacık Köyü)",
      "Mollaoğlu Mah (özlüce Köyü)",
      "Mürseloğlu Mah (döllük Köyü)",
      "Ömer Paşa Mah (kuzbağı Köyü)",
      "Özen Köyü",
      "Özlüce Mah (özlüce Köyü)",
      "Sarıyayla Köyü",
      "Sergütepesi Mah (karacaağaç Köyü)",
      "Şifli Kırık Mah (sazak Köyü)",
      "Tahta Mah (ismailiye Köyü)",
      "Temirağa Mah (göllüköy Köyü)",
      "Tepe Mah (muratkaya Köyü)",
      "Tepebaşı Mah (esenköy Köyü)",
      "Tosunlu Mah (karacaağaç Köyü)",
      "Uçarlar Mah (ismailiye Köyü)",
      "Uğurlu Yaylası Mah (uğurlu Köyü)",
      "Yağsiyan Köyü",
      "Yavuzselim Mah (demircili Köyü)",
      "Yaylası Mah (saraykışla Köyü)",
      "Yazı Mah (tozanlıfındıcak Köyü)",
      "Yeni Darıderesi Köyü",
      "Yeni Mah (çayırpınar Köyü)",
      "Yenikent Mah (sazak Köyü)",
      "Yeniköy Mah (sazak Köyü)",
      "Yenituraç Köyü",
      "Yerlice Mah (sazak Köyü)",
      "Yeşilvadi Mah (büşürüm Köyü)",
      "Yoğurtluca Mah (yeşilyurt Köyü)",
      "Yolbilen Mah (çınarcık Köyü)",
      "Yolyaka Mah (çayırpınar Köyü)",
      "Yumurcaktaş Mah (yeşilyurt Köyü)",
      "Yüceler Mah (ismailiye Köyü)",
      "Zinav Mah (yolüstü Köyü)",
      "Akçakolay Mah",
      "Çamlıca Mah",
      "Çermik Mah",
      "Emirşeyhyakup Mah",
      "Kayalık Mah",
      "Kurtuluş Mah",
      "Osmaniye Mah"
    ],
    "Sulusaray": [
      "Alanyurt Köyü",
      "Alpudere Köyü",
      "Arpacıkaraçay Köyü",
      "Balıkhisar Köyü",
      "Ballıkaya Köyü",
      "Bayazıt Köyü",
      "Belpınar Köyü",
      "Buğdaylı Köyü",
      "Çime Köyü",
      "Ilıcak Köyü",
      "Malum Seyit Tekke Mah",
      "Merkez Mah (sarıyaprak Köyü)",
      "Selimiye Köyü",
      "Tekkeyeni Köyü",
      "Uylubağı Köyü",
      "Fatih Mah",
      "Gaziosmanpaşa Mah",
      "Menderes Mah"
    ],
    "Turhal": [
      "Ağcaşar Köyü",
      "Ağlamış Mah (çivril Köyü)",
      "Akbuğday Köyü",
      "Akçatarla Köyü",
      "Arapören Köyü",
      "Arzupınar Köyü",
      "Aşağı Mah (bahçebaşı Köyü)",
      "Aşağı Mah (tatlıcak Köyü)",
      "Ataköy Köyü",
      "Atatürk Mah (yenisu Köyü)",
      "Ayranpınar Köyü",
      "Bağlarpınarı Köyü",
      "Bayat Yeri Mah (akçatarla Köyü)",
      "Beşevler Mah (necip Köyü)",
      "Bilim Mah (ulutepe Köyü)",
      "Buzluk Köyü",
      "Büyükçaylı Mah (çaylı Köyü)",
      "Ciftlik Mah (kızkayası Köyü)",
      "Cumhuriyet Mah (kat Köyü)",
      "Cumhuriyet Mah (yazıtepe Köyü)",
      "Cumhuriyet Mah (yenisu Köyü)",
      "Çalılık Mah (kat Köyü)",
      "Çamlıca Köyü",
      "Çarıksız Köyü",
      "Çay Mah (kat Köyü)",
      "Çay Mah (yazıtepe Köyü)",
      "Çayıraltı Köyü",
      "Çaylar Mevki Mah (hasanlı Köyü)",
      "Çevlikler Mah",
      "Çiflik Mah (kızkayası Köyü)",
      "Çubuklu Mah (akçatarla Köyü)",
      "Dalmışlar Mah (gökdere Köyü)",
      "Dazya Köyü",
      "Değirmen Mah (eriklitekke Köyü)",
      "Demirkale Mah (akçatarla Köyü)",
      "Derbentçi Köyü",
      "Dereyayla Mah (eriklitekke Köyü)",
      "Doğanlı Mah (necip Köyü)",
      "Dolaplar Mevkii Mah (samurçay Köyü)",
      "Dökmetepe Köyü",
      "Dumlu Mah (üçyol Köyü)",
      "Elalmış Köyü",
      "Erenli Köyü",
      "Eriklitekke Köyü",
      "Eskıkoy Mah (yeniceler Köyü)",
      "Güzelyurt Mah (yazıtepe Köyü)",
      "Hamide Köyü",
      "Harmanlı Mah (ormanözü Köyü)",
      "Hasanlı Köyü",
      "İğdeli Mah (kazancı Köyü)",
      "İnönü Mah (yenisu Köyü)",
      "Kalaycık Köyü",
      "Kamalı Köyü",
      "Karataş Deresi Mah (ormanözü Köyü)",
      "Karkın Köyü",
      "Karşı Mah (gökdere Köyü)",
      "Kazancı Köyü",
      "Kazova Mah (çaylı Köyü)",
      "Kımıza Mah (akçatarla Köyü)",
      "Kışla Mah (hasanlı Köyü)",
      "Kızkayası Köyü",
      "Kmah Mah (dazya Köyü)",
      "Koruluk Köyü",
      "Kuşoturağı Köyü",
      "Kuşpınar Mah (ormanözü Köyü)",
      "Kuytul Köyü",
      "Kuzalan Köyü",
      "Kültür Mah (ulutepe Köyü)",
      "Küpçeşme Mah (çaylı Köyü)",
      "Kütüklüğün Dere Mah (samurçay Köyü)",
      "Merkez Mah (ormanözü Köyü)",
      "Meydan Mah (yazıtepe Köyü)",
      "Orta Mah (çivril Köyü)",
      "Orta Mah (gökdere Köyü)",
      "Ortaköy Mah (hasanlı Köyü)",
      "Pazaryeri Mah (necip Köyü)",
      "Pazlı Mah (üçyol Köyü)",
      "Samurçay Köyü",
      "Sanat Mah (ulutepe Köyü)",
      "Sarı Mah (sarıkaya Köyü)",
      "Sarıçiçek Köyü",
      "Sarıkaya Köyü",
      "Soğulcak Mah (hasanlı Köyü)",
      "Suludede Mah (çivril Köyü)",
      "Sütlüce Köyü",
      "Şatroba Köyü",
      "Taşlıhöyük Köyü",
      "Uluöz Köyü",
      "Uzunyurt Mah (kat Köyü)",
      "Yağlıalan Köyü",
      "Yayla Evleri Mah (çivril Köyü)",
      "Yazı Mah (ormanözü Köyü)",
      "Yeniceler Köyü",
      "Yeniköy Köyü",
      "Yeşilalan Köyü",
      "Yukarı Mah (bahçebaşı Köyü)",
      "Yukarı Mah (çivril Köyü)",
      "Yukarı Mah (tatlıcak Köyü)",
      "Yukarıteke Mah (eriklitekke Köyü)",
      "Zontu Mah (kızkayası Köyü)",
      "Asarcık Mah (şenyurt Beldesi)",
      "Karaevli Mah (şenyurt Beldesi)",
      "Ortaköy Mah (şenyurt Beldesi)",
      "Üçgözen Mah (şenyurt Beldesi)",
      "Bahar Mah",
      "Borsa Mah",
      "Boyacılar Mah",
      "Camikebir Mah",
      "Celal Mah",
      "Cumhuriyet Mah",
      "Emek Mah",
      "Fatih Mah",
      "Gazi Osman Paşa Mah",
      "Gündoğdu Mah",
      "Güneş Mah",
      "Gürsel Mah",
      "Hacılar Mah",
      "Hamam Mah",
      "Kayacık Mah",
      "Kazım Karabekir Mah",
      "Kova Mah",
      "Maraşal Fevzi Çakmak Mah",
      "Mevlana Mah",
      "Meydan Mah",
      "Mimar Sinan Mah",
      "Müftü Mah",
      "Nurkavak Mah",
      "Organize Sanayi Bölgesi Mah",
      "Osmangazi Mah",
      "Pazar Mah",
      "Ray Mah",
      "Varvara Mah",
      "Yavuz Selim Mah",
      "Yeşilırmak Mah",
      "Yunus Emre Mah"
    ],
    "Yeşilyurt": [
      "Bahçebaşı Köyü",
      "Büğet Köyü",
      "Çerkez Danişment Köyü",
      "Çıkrık Mah",
      "Çırdak Mah",
      "Damlalı Köyü",
      "Doğlacık Köyü",
      "Ekinli Köyü",
      "Gündoğan Köyü",
      "Karacaören Köyü",
      "Karadere Mah (karagözgöllüalan Köyü)",
      "Karagözgöllüalan Köyü",
      "Karaoluk Köyü",
      "Karşıyaka Mah (kuşçu Köyü)",
      "Kavunluk Köyü",
      "Sekücek Köyü",
      "Sivri Köyü",
      "Şehitler Mah (kuşçu Köyü)",
      "Yağmur Köyü",
      "Yeni Mah (kuşçu Köyü)",
      "Yeniköy Köyü",
      "100. Yıl Mah",
      "Gaziosmanpaşa Mah",
      "Şehitler Mah",
      "Türkmenler Mah"
    ],
    "Zile": [
      "Acıpınar Köyü",
      "Ağcakeçili Köyü",
      "Ağılcık Köyü",
      "Akağaç Mah (kuzalan Köyü)",
      "Akdoğan Köyü",
      "Akgüller Köyü",
      "Akkılıç Köyü",
      "Alayurt Köyü",
      "Alıçözü Köyü",
      "Alibağı Köyü",
      "Alihoca Köyü",
      "Alparslan Mah (evrenköy Köyü)",
      "Armutalan Köyü",
      "Aşağı Mah (acısu Köyü)",
      "Aşağı Mah (belkaya Köyü)",
      "Aşağı Mah (derebaşı Köyü)",
      "Aşağı Mah (kervansaray Köyü)",
      "Aydınlar Mah (yalınyazı Köyü)",
      "Ayvalı Köyü",
      "Bahçelievler Mah (güzelbeyli Köyü)",
      "Bayır Köyü",
      "Belpınar Köyü",
      "Binbaşıoğlu Köyü",
      "Boldacı Köyü",
      "Büyükaköz Köyü",
      "Büyükkarayün Köyü",
      "Büyükkozluca Köyü",
      "Büyüközlü Köyü",
      "Cumhuriyet Mah (yalınyazı Köyü)",
      "Çakırcalı Köyü",
      "Çamdere Köyü",
      "Çapak Köyü",
      "Çayır Köyü",
      "Çayıroluğu Köyü",
      "Çeltek Köyü",
      "Çiçekpınarı Köyü",
      "Çiftlik Köyü",
      "Deredibi Mezrası Mah (saraç Köyü)",
      "Donaşa Mah (kireçli Köyü)",
      "Ede Köyü",
      "Elmacık Köyü",
      "Emirören Köyü",
      "Esertepe Mah (acısu Köyü)",
      "Eskidağiçi Köyü",
      "Eskiderbent Köyü",
      "Fatih Köyü",
      "Fırtıman Mezrası Mah (saraç Köyü)",
      "Göçenli Köyü",
      "Gölcük Köyü",
      "Güblüce Köyü",
      "Gümüşkaş Köyü",
      "Güngörmez Köyü",
      "Hacılar Köyü",
      "Haramikışla Köyü",
      "Hasanağa Köyü",
      "Hatippınarı Köyü",
      "Hürriyet Mah (yalınyazı Köyü)",
      "İğdir Köyü",
      "İmirtolu Köyü",
      "İsmetpaşa Mah (güzelbeyli Köyü)",
      "Kamuçyük Mah (kireçli Köyü)",
      "Kara Deve Mezrası Mah (derebaşı Köyü)",
      "Karabalçık Köyü",
      "Karacaören Köyü",
      "Karakaya Köyü",
      "Karakuzu Köyü",
      "Karaşeyh Köyü",
      "Karşı Mah (derebaşı Köyü)",
      "Karşıpınar Köyü",
      "Karşıyaka Köyü",
      "Kazıklı Köyü",
      "Keh Mah (kireçli Köyü)",
      "Kepez Köyü",
      "Kırlar Köyü",
      "Kızılca Köyü",
      "Kızılüzüm Mah (ede Köyü)",
      "Kireçli Köyü",
      "Koçaş Köyü",
      "Korucuk Köyü",
      "Kozdere Köyü",
      "Köylüünürü Köyü",
      "Kurşunlu Köyü",
      "Kuruçay Köyü",
      "Kurupınar Köyü",
      "Kuzalan Köyü",
      "Küçükaköz Köyü",
      "Küçükkarayün Köyü",
      "Küçükkozluca Köyü",
      "Küçüközlü Köyü",
      "Mezra Mah (yapalak Köyü)",
      "Narlıkışla Köyü",
      "Olukman Köyü",
      "Orta Mah (kervansaray Köyü)",
      "Osmanpınarı Köyü",
      "Özyurt Köyü",
      "Palanlı Köyü",
      "Reşadiye Köyü",
      "Salur Köyü",
      "Saraç Köyü",
      "Saray Mah (yıldıztepe Köyü)",
      "Savcu Köyü",
      "Sekikışla Köyü",
      "Selamet Köyü",
      "Silis Mah (güzelbeyli Köyü)",
      "Sofular Köyü",
      "Söğütözü Köyü",
      "Süleymaniye Köyü",
      "Şeyhköy Köyü",
      "Şeyhnusrettin Köyü",
      "Taşkıran Köyü",
      "Temecük Köyü",
      "Turgutalp Köyü",
      "Uğurluören Köyü",
      "Uzunköy Köyü",
      "Uzunöz Köyü",
      "Üçkaya Köyü",
      "Üçköy Köyü",
      "Ütük Köyü",
      "Üyük Köyü",
      "Yalnızköy Köyü",
      "Yapalak Köyü",
      "Yaraş Köyü",
      "Yayla Evleri Mah (derebaşı Köyü)",
      "Yaylakent Köyü",
      "Yaylayolu Köyü",
      "Yeni Mah (yıldıztepe Köyü)",
      "Yenidağiçi Köyü",
      "Yeniderbent Köyü",
      "Yeniköy Köyü",
      "Yeşilce Köyü",
      "Yeşilyurt Mah (evrenköy Köyü)",
      "Yukarı Mah (acısu Köyü)",
      "Yukarı Mah (derebaşı Köyü)",
      "Yukarı Mah (kervansaray Köyü)",
      "Yukarı Mah (yapalak Köyü)",
      "Yurtyeri Mah (saraç Köyü)",
      "Yücepınar Köyü",
      "Yünlü Köyü",
      "Zile Osb Mah (hacılar Köyü)",
      "Alacamescitzir Mah",
      "Alamescitbala Mah",
      "Alikadı Mah",
      "Bahçelievler Mah",
      "Cedit Mah",
      "Dinçerler Mah",
      "Dutlupınar Mah",
      "Hacımehmet Mah",
      "İstasyon Mah",
      "Kahya Mah",
      "Kislik Mah",
      "Minareikebir Mah",
      "Minareisağır Mah",
      "Nakkaş Mah",
      "Orta Mah",
      "Şeyhali Mah",
      "Şeyhkolu Mah",
      "Yunusemre Mah",
      "Zincirli Ülya Mah",
      "Zincirlisüfla Mah"
    ]
  },
  "Trabzon": {
    "Akçaabat": [
      "Acısu Mah",
      "Adacık Mah",
      "Ağaçlı Mah",
      "Akçakale Mah",
      "Akçaköy Mah",
      "Akdamar Mah",
      "Akören Mah",
      "Akpınar Mah",
      "Alsancak Mah",
      "Ambarcık Mah",
      "Arpacılı Mah",
      "Aydınköy Mah",
      "Bozdoğan Mah",
      "Cevizli Mah",
      "Cevizlik Mah",
      "Çamlıca Mah",
      "Çamlıdere Mah",
      "Çınarlık Mah",
      "Çiçeklidüz Mah",
      "Çilekli Mah",
      "Çolaklı Mah",
      "Çukurca Mah",
      "Darıca Mah",
      "Demirci Mah",
      "Demirkapı Mah",
      "Demirtaş Mah",
      "Derecik Mah",
      "Doğanköy Mah",
      "Dörtyol Mah",
      "Dürbinar Mah",
      "Esentepe Mah",
      "Eskiköy Mah",
      "Fındıklı Mah",
      "Fıstıklı Mah",
      "Gümüşlü Mah",
      "Helvacı Mah",
      "Işıklar Mah",
      "Kaleönü Mah",
      "Karaçayır Mah",
      "Karpınar Mah",
      "Kavaklı Mah",
      "Kayalar Mah",
      "Kemaliye Mah",
      "Kirazlık Mah",
      "Koçlu Mah",
      "Kuruçam Mah",
      "Maden Mah",
      "Mersin Mah",
      "Meşeli Mah",
      "Meydankaya Mah",
      "Nefsipulathane Mah",
      "Orta Mah",
      "Ortaalan Mah",
      "Ortaköy Mah",
      "Osmanbaba Mah",
      "Özakdamar Mah",
      "Özdemirci Mah",
      "Salacık Mah",
      "Sarıca Mah",
      "Sarıtaş Mah",
      "Sertkaya Mah",
      "Söğütlü Mah",
      "Şinik Mah",
      "Şinik Osb Mah",
      "Tatlısu Mah",
      "Tütüncüler Mah",
      "Uçarsu Mah",
      "Yaylacık Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşiltepe Mah",
      "Yeşilyurt Mah",
      "Yıldızlı Mah",
      "Zaferli Mah"
    ],
    "Araklı": [
      "Aytaş Mah",
      "Ayvadere Mah",
      "Bahçecik Mah",
      "Bereketli Mah",
      "Birlik Mah",
      "Buzluca Mah",
      "Çamlıca Mah",
      "Çamlıktepe Mah",
      "Çankaya Mah",
      "Çiftepınar Mah",
      "Çukurçayır Mah",
      "Değirmencik Mah",
      "Erenler Mah",
      "Erikli Mah",
      "Halilli Mah",
      "Hasköy Mah",
      "Hürriyet Mah",
      "İyisu Mah",
      "Kalecik Mah",
      "Karatepe Mah",
      "Karşıyaka Mah",
      "Kayacık Mah",
      "Kayaiçi Mah",
      "Kaymaklı Mah",
      "Kestanelik Mah",
      "Köprüüstü Mah",
      "Kükürtlü Mah",
      "Merkez Mah",
      "Merkezköy Mah",
      "Ortaköy Mah",
      "Özgen Mah",
      "Pervane Mah",
      "Sulakyurt Mah",
      "Sularbaşı Mah",
      "Taşgeçit Mah",
      "Taşönü Mah",
      "Taştepe Mah",
      "Turnalı Mah",
      "Türkeli Mah",
      "Yalıboyu Mah",
      "Yassıkaya Mah",
      "Yeniköy Mah",
      "Yeşilce Mah",
      "Yeşilköy Mah",
      "Yeşilyurt Mah",
      "Yıldızlı Mah",
      "Yiğitözü Mah",
      "Yolgören Mah",
      "Yoncalı Mah",
      "Yüceyurt Mah"
    ],
    "Arsin": [
      "Atayurt Mah",
      "Başdurak Mah",
      "Cudibey Mah",
      "Cumhuriyet Mah",
      "Çardaklı Mah",
      "Çiçekli Mah",
      "Çubuklu Mah",
      "Dilek Mah",
      "Elmaalan Mah",
      "Fatih Mah",
      "Fındıklı Mah",
      "Gölcük Mah",
      "Gölgelik Mah",
      "Güneyce Mah",
      "Güzelyalı Mah",
      "Harmanlı Mah",
      "Işıklı Mah",
      "İşhan Mah",
      "Karaca Mah",
      "Konak Mah",
      "Kuzguncuk Mah",
      "Nuroğlu Mah",
      "Oğuz Mah",
      "Örnek Mah",
      "Özlü Mah",
      "Şenkaya Mah",
      "Üçpınar Mah",
      "Yalı Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yeşilce Mah",
      "Yeşilköy Mah",
      "Yeşiltepe Mah",
      "Yeşilyalı Mah",
      "Yolaç Mah",
      "Yolüstü Mah"
    ],
    "Beşikdüzü": [
      "Adacık Mah",
      "Ağaçlı Mah",
      "Akkese Mah",
      "Aksaklı Mah",
      "Anbarlı Mah",
      "Ardıçatak Mah",
      "Bayırköy Mah",
      "Beşikdağ Mah",
      "Bozlu Mah",
      "Cumhuriyet Mah",
      "Çakırlı Mah",
      "Çeşmeönü Mah",
      "Çıtlaklı Mah",
      "Dağlıca Mah",
      "Denizli Mah",
      "Dolanlı Mah",
      "Duygulu Mah",
      "Fatih Mah",
      "Gürgenli Mah",
      "Hünerli Mah",
      "Kalegüney Mah",
      "Korkuthan Mah",
      "Kutluca Mah",
      "Nefsişarlı Mah",
      "Oğuz Mah",
      "Resullü Mah",
      "Sayvancık Mah",
      "Seyitahmet Mah",
      "Şahmelik Mah",
      "Takazlı Mah",
      "Vardallı Mah",
      "Yenicami Mah",
      "Yeşilköy Mah",
      "Zemberek Mah"
    ],
    "Çarşıbaşı": [
      "Burunbaşı Mah",
      "Büyükdere Mah",
      "Çallı Mah",
      "Erenköy Mah",
      "Fenerköy Mah",
      "Gülbahçe Mah",
      "Kadıköy Mah",
      "Kaleköy Mah",
      "Kavaklı Mah",
      "Kerem Mah",
      "Kovanlı Mah",
      "Küçükköy Mah",
      "Merkez Mah",
      "Pınarlı Mah",
      "Salova Mah",
      "Samsun Mah",
      "Serpilköy Mah",
      "Şahinli Mah",
      "Taşlıtepe Mah",
      "Veliköy Mah",
      "Yavuz Mah",
      "Yeniköy Mah",
      "Zeytinlik Mah"
    ],
    "Çaykara": [
      "Akdoğan Mah",
      "Arpaözü Mah",
      "Aşağıkumlu Mah",
      "Ataköy Mah",
      "Baltacılı Mah",
      "Çambaşı Mah",
      "Çamlıbel Mah",
      "Çayıroba Mah",
      "Demirkapı Mah",
      "Demirli Mah",
      "Derindere Mah",
      "Eğridere Mah",
      "Işıklı Mah",
      "Kabataş Mah",
      "Karaçam Mah",
      "Kayran Mah",
      "Koldere Mah",
      "Köknar Mah",
      "Köseli Mah",
      "Maraşlı Mah",
      "Soğanlı Mah",
      "Şahinkaya Mah",
      "Şekersu Mah",
      "Taşkıran Mah",
      "Taşlıgedik Mah",
      "Taşören Mah",
      "Ulucami Mah",
      "Uzungöl Mah",
      "Uzuntarla Mah",
      "Yaylaönü Mah",
      "Yeşilalan Mah",
      "Yukarıkumlu Mah"
    ],
    "Dernekpazarı": [
      "Akköse Mah",
      "Çalışanlar Mah",
      "Çayırbaşı Mah",
      "Gülen Mah",
      "Günebakan Mah",
      "Güney Mah",
      "Kondu Mah",
      "Merkez Mah",
      "Ormancık Mah",
      "Taşçılar Mah",
      "Tüfekçi Mah",
      "Yenicami Mah",
      "Yenice Mah",
      "Zincirlitaş Mah"
    ],
    "Düzköy": [
      "Alazlı Mah",
      "Aykut Mah",
      "Büyük Mah",
      "Cevizlik Mah",
      "Çal Camili Mah",
      "Çal Çeşmeler Mah",
      "Çal Orta Mah",
      "Çayırbağı Doğankaya Mah",
      "Çayırbağı Gülcana Mah",
      "Çayırbağı Orta Mah",
      "Çayırbağı Yusuflu Mah",
      "Çayırbağı Zeliha Mah",
      "Çiğdemli Mah",
      "Düzalan Mah",
      "Gökçeler Mah",
      "Gürgendağ Mah",
      "Küçüktepeköy Mah",
      "Orta Mah",
      "Taşocağı Mah",
      "Tepecik Mah",
      "Yeni Mah",
      "Yerlice Mah"
    ],
    "Hayrat": [
      "Ağaçlı Düz Mah",
      "Balaban Mah",
      "Balaban Merkez Mah",
      "Cumhuriyet Mah",
      "Çağlayan Mah",
      "Çamlıtepe Mah",
      "Çaycılar Mah",
      "Dağönü Mah",
      "Dereyurt Mah",
      "Fatih Mah",
      "Geçitli Mah",
      "Göksel Mah",
      "Görgülü Mah",
      "Gülderen Fatih Mah",
      "Gülderen Merkez Mah",
      "Hürriyet Mah",
      "Kılavuz Mah",
      "Köyceğiz Mah",
      "Kurtuluş Mah",
      "Merkez Mah",
      "Meydanlı Mah",
      "Onur Mah",
      "Pazarönü Mah",
      "Pınarca Mah",
      "Sarmaşık Mah",
      "Şehitli Mah",
      "Şişli Mah",
      "Taflancık Mah",
      "Topaklı Mah",
      "Yarlı Mah",
      "Yeni Mah",
      "Yeniköy Mah",
      "Yıldırımlar Mah",
      "Yırca Mah"
    ],
    "Köprübaşı": [
      "Akpınar Mah",
      "Arpalı Mah",
      "Beşköy Mah",
      "Büyükdoğanlı Mah",
      "Çifteköprü Mah",
      "Fidanlı Mah",
      "Gündoğan Mah",
      "Güneşli Mah",
      "Pınarbaşı Mah",
      "Yağmurlu Mah"
    ],
    "Maçka": [
      "Akarsu Mah",
      "Akmescit Mah",
      "Alaçam Mah",
      "Alataş Mah",
      "Altındere Mah",
      "Anayurt Mah",
      "Ardıçlıyayla Mah",
      "Armağan Mah",
      "Atasu Mah",
      "Bağışlı Mah",
      "Bahçekaya Mah",
      "Bakımlı Mah",
      "Bakırcılar Mah",
      "Barışlı Mah",
      "Başar Mah",
      "Coşandere Mah",
      "Çamlıdüz Mah",
      "Çatak Mah",
      "Çayırlar Mah",
      "Çeşmeler Mah",
      "Çıralı Mah",
      "Dikkaya Mah",
      "Erginköy Mah",
      "Esiroğlu Mah",
      "Fatih Mah",
      "Gayretli Mah",
      "Günay Mah",
      "Güney Mah",
      "Gürgenağaç Mah",
      "Güzelce Mah",
      "Güzelyayla Mah",
      "Hamsiköy Mah",
      "Hızarlı Mah",
      "Kapuköy Mah",
      "Kaynarca Mah",
      "Kırantaş Mah",
      "Kiremitli Mah",
      "Konak Mah",
      "Kozağaç Mah",
      "Köprüyanı Mah",
      "Kuşçu Mah",
      "Mataracı Mah",
      "Merkez Mah",
      "Ocaklı Mah",
      "Oğulağaç Mah",
      "Ormaniçi Mah",
      "Ormanüstü Mah",
      "Ortaköy Mah",
      "Öğütlü Mah",
      "Örnekalan Mah",
      "Reşadiye Mah",
      "Sevinç Mah",
      "Sındıran Mah",
      "Sukenarı Mah",
      "Şimşirli Mah",
      "Temelli Mah",
      "Üçgedik Mah",
      "Yaylabaşı Mah",
      "Yazılıtaş Mah",
      "Yazlık Mah",
      "Yeniköy Mah",
      "Yeşiltepe Mah",
      "Yeşilyurt Mah",
      "Yukarıköy Mah",
      "Yüzüncüyıl Mah",
      "Zaferli Mah"
    ],
    "Of": [
      "Ağaçbaşı Mah",
      "Ağaçseven Mah",
      "Aşağıkışlacık Mah",
      "Ballıca Mah",
      "Barış Mah",
      "Başköy Mah",
      "Bayırca Mah",
      "Birlik Mah",
      "Bölümlü Mah",
      "Cumapazarı Mah",
      "Cumhuriyet Mah",
      "Çaltılı Mah",
      "Çamlı Mah",
      "Çamlıtepe Mah",
      "Çataldere Mah",
      "Çatalsöğüt Mah",
      "Çukurova Mah",
      "Dağalan Mah",
      "Darılı Mah",
      "Dereköy Mah",
      "Doğançay Mah",
      "Dumlusu Mah",
      "Erenköy Mah",
      "Esenköy Mah",
      "Eskipazar Mah",
      "Fındıkoba Mah",
      "Gökçeoba Mah",
      "Gümüşören Mah",
      "Güresen Mah",
      "Gürpınar Mah",
      "İkidere Mah",
      "İrfanlı Mah",
      "Kaban Mah",
      "Karabudak Mah",
      "Kavakpınar Mah",
      "Kazançlı Mah",
      "Keler Mah",
      "Kıyıboyu Mah",
      "Kıyıcık Mah",
      "Kiraz Mah",
      "Kireçli Mah",
      "Korkut Mah",
      "Korucuk Mah",
      "Kumludere Mah",
      "Ovacık Mah",
      "Örtülü Mah",
      "Pınaraltı Mah",
      "Saraçlı Mah",
      "Sarayköy Mah",
      "Sarıbey Mah",
      "Sarıkaya Mah",
      "Sefaköy Mah",
      "Serince Mah",
      "Sıraağaç Mah",
      "Sivrice Mah",
      "Soğukpınar Mah",
      "Söğütlü Mah",
      "Sugeldi Mah",
      "Sulaklı Mah",
      "Tavşanlı Mah",
      "Tekoba Mah",
      "Uğurlu Mah",
      "Uluağaç Mah",
      "Yanıktaş Mah",
      "Yazlık Mah",
      "Yemişalan Mah",
      "Yeni Mah",
      "Yukarı Kışlacık Mah"
    ],
    "Ortahisar": [
      "1 Nolu Beşirli Mah",
      "2 Nolu Beşirli Mah",
      "Ağıllı Mah",
      "Aktoprak Mah",
      "Akyazı Mah",
      "Aydınlıkevler Mah",
      "Ayvalı Mah",
      "Bengisu Mah",
      "Doğançay Mah",
      "Fatih Mah",
      "Fatih Sultan Mah",
      "Gündoğdu Mah",
      "Gürbulak Mah",
      "İnönü Mah",
      "Karakaya Mah",
      "Karşıyaka Mah",
      "Kurtuluş Mah",
      "Toklu Mah",
      "Uğurlu Mah",
      "Yeniköy Mah",
      "Yenimahalle Mah",
      "Yeşilhisar Mah",
      "Yeşilova Mah",
      "Yeşiltepe Mah",
      "1 Nolu Bostancı Mah",
      "2 Nolu Bostancı Mah",
      "Akoluk Mah",
      "Bulak Mah",
      "Çilekli Mah",
      "Çimenli Mah",
      "Dolaylı Mah",
      "Esenyurt Mah",
      "İncesu Mah",
      "Kalkınma Mah",
      "Kanuni Mah",
      "Kavala Mah",
      "Konaklar Mah",
      "Kozluca Mah",
      "Okçular Mah",
      "Özbirlik Mah",
      "Pelitli Mah",
      "Pınaraltı Mah",
      "Sayvan Mah",
      "Sevimli Mah",
      "Üniversite Mah",
      "Yalıncak Mah",
      "Yeşilbük Mah",
      "Yeşilvadi Mah",
      "Yeşilyurt Mah",
      "Akkaya Mah",
      "Beştaş Mah",
      "Boztepe Mah",
      "Çağlayan Mah",
      "Çamoba Mah",
      "Çömlekçi Mah",
      "Çömlekçi Sb Mah",
      "Çukurçayır Mah",
      "Değirmendere Mah",
      "Düzyurt Mah",
      "Esentepe Mah",
      "Geçit Mah",
      "Gölçayır Mah",
      "Gözalan Mah",
      "İskenderpaşa Mah",
      "Karlık Mah",
      "Kaymaklı Mah",
      "Kireçhane Mah",
      "Kutlugün Mah",
      "Sanayi Mah",
      "Subaşı Mah",
      "Tosköy Mah",
      "Yenicuma Mah",
      "Cumhuriyet Mah",
      "Çarşı Mah",
      "Gazipaşa Mah",
      "Kemerkaya Mah",
      "Ortahisar Mah",
      "Pazarkapı Mah",
      "Zafer Mah",
      "1 Nolu Erdoğdu Mah",
      "2 Nolu Erdoğdu Mah",
      "3 Nolu Erdoğdu Mah",
      "Bahçecik Mah",
      "Gülbaharhatun Mah",
      "Hızırbey Mah",
      "Soğuksu Mah",
      "Yalı Mah"
    ],
    "Sürmene": [
      "Aksu Mah",
      "Armutlu Mah",
      "Aşağıovalı Mah",
      "Balıklı Mah",
      "Birlik Mah",
      "Çamburnu Mah",
      "Çamlıca Mah",
      "Çarşı Mah",
      "Çavuşlu Mah",
      "Çiftesu Mah",
      "Çimenli Mah",
      "Dirlik Mah",
      "Fındıcak Mah",
      "Gültepe Mah",
      "Güneyköy Mah",
      "Kahraman Mah",
      "Karacakaya Mah",
      "Konak Mah",
      "Koyuncular Mah",
      "Küçükdere Mah",
      "Muratlı Mah",
      "Ormanseven Mah",
      "Orta Mah",
      "Ortaköy Mah",
      "Oylum Mah",
      "Petekli Mah",
      "Soğuksu Mah",
      "Üstündal Mah",
      "Üzümlü Mah",
      "Yazıoba Mah",
      "Yemişli Mah",
      "Yeniay Mah",
      "Yeşilköy Mah",
      "Yokuşbaşı Mah",
      "Yukarıçavuşlu Mah",
      "Yukarıovalı Mah",
      "Zeytinli Mah"
    ],
    "Şalpazarı": [
      "Ağırtaş Mah",
      "Akçiriş Mah",
      "Çamkiriş Mah",
      "Çamlıca Mah",
      "Çarlaklı Mah",
      "Çetrik Mah",
      "Dereköy Mah",
      "Doğancı Mah",
      "Dorukkiriş Mah",
      "Düzköy Mah",
      "Fidanbaşı Mah",
      "Geyikli Mah",
      "Gökçeköy Mah",
      "Gölkiriş Mah",
      "Güdün Mah",
      "Kabasakal Mah",
      "Kalecik Mah",
      "Karakaya Mah",
      "Kasımağzı Mah",
      "Kireç Mah",
      "Kuzuluk Mah",
      "Pelitçik Mah",
      "Sayvançatak Mah",
      "Simenli Mah",
      "Sinlice Mah",
      "Sugören Mah",
      "Sütpınar Mah",
      "Tepeağzı Mah",
      "Turalıuşağı Mah",
      "Üzümözü Mah"
    ],
    "Tonya": [
      "Biçinlik Mah",
      "Büyük Mah",
      "Çamlı Mah",
      "Çayıriçi Mah",
      "Hoşarlı Mah",
      "İskenderli Mah",
      "Kalemli Mah",
      "Kaleönü Mah",
      "Kalınçam Mah",
      "Karaağaçlı Mah",
      "Karasu Mah",
      "Karşular Mah",
      "Kayacan Mah",
      "Kozluca Mah",
      "Kösecik Mah",
      "Melikşah Mah",
      "Orta Mah",
      "Sağrı Mah",
      "Sayraç Mah",
      "Turalı Mah",
      "Yakçukur Mah",
      "Yeni Mah"
    ],
    "Vakfıkebir": [
      "Açıkalan Mah",
      "Akköy Mah",
      "Aydoğdu Mah",
      "Bahadırlı Mah",
      "Ballı Mah",
      "Bozalan Mah",
      "Büyükliman Mah",
      "Caferli Mah",
      "Cumhuriyet Mah",
      "Çamlık Mah",
      "Çamlık Sahil Mah",
      "Çarşı Mah",
      "Çavuşlu Mah",
      "Demirci Mah",
      "Deregözü Mah",
      "Düzlük Mah",
      "Esentepe Mah",
      "Fethiye Mah",
      "Fevziye Mah",
      "Güneyköy Mah",
      "Güneysu Mah",
      "Hacıköy Mah",
      "Hamzalı Mah",
      "Hürriyet Mah",
      "İlyaslı Mah",
      "İshaklı Mah",
      "Karatepe Mah",
      "Kemaliye Mah",
      "Kıranköy Mah",
      "Kirazlık Mah",
      "Kirazlıkyeni Mah",
      "Köprücek Mah",
      "Körez Mah",
      "Küçükdere Mah",
      "Mahmutlu Mah",
      "Mısırlı Mah",
      "Ortaköy Mah",
      "Rıdvanlı Mah",
      "Sekmenli Mah",
      "Sinanlı Mah",
      "Soğuksu Mah",
      "Şenocak Mah",
      "Tarlacık Mah",
      "Yalıköy Mah",
      "Yaylacık Mah",
      "Yıldız Mah"
    ],
    "Yomra": [
      "Çamlıca Mah",
      "Çamlıyurt Mah",
      "Çınarlı Mah",
      "Demirciler Mah",
      "Gülyurdu Mah",
      "Gürsel Mah",
      "İkisu Mah",
      "Kaşüstü Mah",
      "Kayabaşı Mah",
      "Kılıçlı Mah",
      "Kıratlı Mah",
      "Kömürcü Mah",
      "Maden Mah",
      "Namıkkemal Mah",
      "Ocak Mah",
      "Oymalı Mah",
      "Özdil Mah",
      "Pınarlı Mah",
      "Sancak Mah",
      "Şanlı Mah",
      "Tandırlı Mah",
      "Taşdelen Mah",
      "Tepeköy Mah",
      "Yenice Mah",
      "Yokuşlu Mah"
    ]
  },
  "Tunceli": {
    "Çemişgezek": [
      "Çukur Mah",
      "Hacı Cami Mah",
      "Hamamatik Mah",
      "Kale Mah",
      "Mescit Mah",
      "Tepebaşı Mah",
      "Yenimahalle Mah",
      "Akçapınar Köyü",
      "Akçayunt Mah (akçayunt Köyü)",
      "Alakuş Köyü",
      "Alçılı Mah (gedikler Köyü)",
      "Anıl Köyü",
      "Ardige Mah (anıl Köyü)",
      "Arpaderen Köyü",
      "Aşağı Peydere Mah (ulukale Köyü)",
      "Aşağı Savuk Mah (büyükörence Köyü)",
      "Aşağıbudak Köyü",
      "Aşağıdemirbük Köyü",
      "Bağsuyu Köyü",
      "Bozağaç Köyü",
      "Buğdaylı Mah (paşacık Köyü)",
      "Büyükörence Köyü",
      "Cebe Köyü",
      "Cihangir Köyü",
      "Çizmeli Mah (tekeli Köyü)",
      "Dedebeyli Köyü",
      "Doğan Köyü",
      "Doğanalan Köyü",
      "Doruk Mah (arpaderen Köyü)",
      "Ergenler Mah (gedikler Köyü)",
      "Erkalkan Köyü",
      "Gedikler Köyü",
      "Gözlüçayır Köyü",
      "Gülbahçe Köyü",
      "Güneybaşı Köyü",
      "Hastek Mah (akçapınar Köyü)",
      "Karagedik Mah (toratlı Köyü)",
      "Karasar Köyü",
      "Keçeli Mah (gedikler Köyü)",
      "Kıraçlar Köyü",
      "Kızıl Evler Mah (anıl Köyü)",
      "Kineli Mah (gözlüçayır Köyü)",
      "Koyunardı Mah (akçapınar Köyü)",
      "Köçek Mah (payamdüzü Köyü)",
      "Müştak Mah (cebe Köyü)",
      "Paşacık Köyü",
      "Payamdüzü Köyü",
      "Sakyol Köyü",
      "Sarıbalta Köyü",
      "Taşlık Mah (tekeli Köyü)",
      "Tekeli Köyü",
      "Toratlı Köyü",
      "Ulukale Köyü",
      "Uzungöl Köyü",
      "Varlıkonak Mah (gedikler Köyü)",
      "Vişneli Köyü",
      "Yemişdere Köyü",
      "Yukarı Savuk Mah (büyükörence Köyü)",
      "Yukarıbudak Köyü",
      "Yukarıdemirbük Mah (gedikler Köyü)",
      "Yünbüken Köyü"
    ],
    "Hozat": [
      "Diyap Ağa Mah",
      "Fikripaşa Mah",
      "Köprübaşı Mah",
      "Yeni Mah",
      "Ağırbaşak Mah (yüceldi Köyü)",
      "Ağmezra Mah (karabakır Köyü)",
      "Akbulut Mah (dalören Köyü)",
      "Akören Mah (sarısaltık Köyü)",
      "Akpınar Köyü",
      "Akpınar Mah (türktaner Köyü)",
      "Akseki Mah (sarısaltık Köyü)",
      "Akveysi Mah (çaytaşı Köyü)",
      "Alancık Köyü",
      "Altınçevre Köyü",
      "Amaçlı Mah (sarısaltık Köyü)",
      "Aşağı Buzlupınar Mah (buzlupınar Köyü)",
      "Aşağı Kardelen Mah (kardelen Köyü)",
      "Balkaynar Köyü",
      "Balolar Mah (balkaynar Köyü)",
      "Başatlı Mah (doluçeşme Mah) (çığırlı Köyü)",
      "Beşelma Köyü",
      "Bılanık Mah (karaca Köyü)",
      "Bilekli Köyü",
      "Bilikan Mah (karaçavuş Köyü)",
      "Boyalı Mah (taşıtlı Köyü)",
      "Boydaş Köyü",
      "Bulgurlu Mah (uzundal Köyü)",
      "Buzlupınar Köyü",
      "Çağlarca Köyü",
      "Çakmaklı Mah (dalören Köyü)",
      "Çam Yazı Mah (taşıtlı Köyü)",
      "Çaytaşı Köyü",
      "Çığırlı Köyü",
      "Dalören Köyü",
      "Darıkolu Mah (beşelma Köyü)",
      "Deliktaş Mah (çaytaşı Köyü)",
      "Dervişcemal Köyü",
      "Erenler Mah (çağlarca Köyü)",
      "Esenli Mah (geçimli Köyü)",
      "Faruklar Mah (dalören Köyü)",
      "Geçimli Köyü",
      "Gökçen-yeşilsegedik Mah (kalecik Köyü)",
      "Gözerek Mah (karaçavuş Köyü)",
      "Gülenler Mah (balkaynar Köyü)",
      "Gümüşsuyu Mah (altınçevre Köyü)",
      "Hadişar-bayram Mah (kalecik Köyü)",
      "Halilağa Mah (karabakır Köyü)",
      "Hıdırdamı Mah (karabakır Köyü)",
      "Hopağaç Mah (çağlarca Köyü)",
      "İbrahim Taner Mah (çaytaşı Köyü)",
      "İn Köyü",
      "Kalankoz Mah (yenidoğdu Köyü)",
      "Kalecik Köyü",
      "Karabakır Köyü",
      "Karaca Köyü",
      "Karaçavuş Köyü",
      "Karataş Mah (kalecik Köyü)",
      "Kardelen Köyü",
      "Karsel Mah (karaçavuş Köyü)",
      "Kavuktepe Köyü",
      "Kayabağı Mah (çığırlı Köyü)",
      "Kızıl Kom Mah (taşıtlı Köyü)",
      "Koru Köyü",
      "Kozluca Köyü",
      "Köybaşı Mah (sarısaltık Köyü)",
      "Kurukafalar Mah (balkaynar Köyü)",
      "Kurukaymak Köyü",
      "Kuzuluk Mah (akpınar Köyü)",
      "Küçük Dalören Mah (dalören Köyü)",
      "Külünk Mah (kavuktepe Köyü)",
      "Merecik Mah (türktaner Köyü)",
      "Merk Mah (balkaynar Köyü)",
      "Meşedibi Mah (çığırlı Köyü)",
      "Meşeli Mah (geçimli Köyü)",
      "Nişangah Mah (çığırlı Köyü)",
      "Ödemiş Mah (türktaner Köyü)",
      "Potin Mah (yenidoğdu Köyü)",
      "Salkımlı Mah (sarısaltık Köyü)",
      "Sarısaltık Köyü",
      "Segedik-karamansegedik Mah (kalecik Köyü)",
      "Seyit Memetler Mah (balkaynar Köyü)",
      "Sorpiyan Mah (yenidoğdu Köyü)",
      "Sütlüce Mah (çağlarca Köyü)",
      "Taşıtlı Köyü",
      "Türktaner Köyü",
      "Uzunçayır Mah (karabakır Köyü)",
      "Uzundal Köyü",
      "Üzümlü Mah (çağlarca Köyü)",
      "Venk Mah (geçimli Köyü)",
      "Yazı Mah (geçimli Köyü)",
      "Yenidoğdu Köyü",
      "Yeşilyurt Mah (akpınar Köyü)",
      "Yoğun Toprak Mah (alancık Köyü)",
      "Yorganlı Mah (kavuktepe Köyü)",
      "Yüceldi Köyü"
    ],
    "Mazgirt": [
      "Çarşıbaşı Mah (akpazar Beldesi)",
      "Elmalık Mah (akpazar Beldesi)",
      "Güneşdere Mah (akpazar Beldesi)",
      "Güneyharman Mah (akpazar Beldesi)",
      "Karabulut Mah (akpazar Beldesi)",
      "Kepektaşı Mah (akpazar Beldesi)",
      "Kuşçu Mah (akpazar Beldesi)",
      "Örs Mah (akpazar Beldesi)",
      "Eltihatun Mah",
      "Yeni Mah",
      "Ağaçardı Köyü",
      "Akdüven Köyü",
      "Akkavak Köyü",
      "Aktarla Köyü",
      "Akyünlü Köyü",
      "Alanyazı Köyü",
      "Alhan Köyü",
      "Alidost Mah (ibimahmut Köyü)",
      "Anıtçınar Köyü",
      "Aslanyurdu Köyü",
      "Aşağıçanakcı Mah (aslanyurdu Köyü)",
      "Aşağıoyumca Köyü",
      "Aşağıtarlacık Köyü",
      "Atalay Mah (akkavak Köyü)",
      "Avunca Köyü",
      "Aydınlar Mah (kale Köyü)",
      "Aydınlık Köyü",
      "Ayvatlı Köyü",
      "Bahşiş Mah (ortadurak Köyü)",
      "Balkan Köyü",
      "Bazınali Mah (ibimahmut Köyü)",
      "Beroç Mah (anıtçınar Köyü)",
      "Beroç Mah (dallıbel Köyü)",
      "Beroç Mah (dayılar Köyü)",
      "Beşoluk Köyü",
      "Beylermezrası Köyü",
      "Biçer Mah (karayusuf Köyü)",
      "Birik Mah (dayılar Köyü)",
      "Bulgurcular Köyü",
      "Bütünlü Mah (yaşaroğlu Köyü)",
      "Cefkan Mah (geçitveren Köyü)",
      "Çalosur Mah (doğanlı Köyü)",
      "Çangal Mah (balkan Köyü)",
      "Çatköy Köyü",
      "Çobanlı Mah (sökücek Köyü)",
      "Çobanlı Mah (sülüntaş Köyü)",
      "Dalamer Mah (doğanlı Köyü)",
      "Dalbahçe Mah (yaşaroğlu Köyü)",
      "Danaburan Köyü",
      "Dayılar Köyü",
      "Dazkaya Köyü",
      "Demirci Köyü",
      "Demirkazık Köyü",
      "Derik Mah (ataçınar Köyü)",
      "Dervişan Mah (ibimahmut Köyü)",
      "Doğanlı Köyü",
      "Doğucak Köyü",
      "Dostar Mah (kızılkale Köyü)",
      "Fevzi Mah (sülüntaş Köyü)",
      "Gaz Mah (doğucak Köyü)",
      "Geçitveren Köyü",
      "Gedik Mah (obuzbaşı Köyü)",
      "Gelincik Köyü",
      "Gelinpınar Köyü",
      "Gomikaraç Mah (güleç Köyü)",
      "Göktepe Köyü",
      "Gölek Mah (koyunuşağı Köyü)",
      "Görcan Mah (ismailli Köyü)",
      "Güleç Köyü",
      "Gümüşgün Köyü",
      "Hacı Yusuf Mah (doğucak Köyü)",
      "Hıdyan Mah (sülüntaş Köyü)",
      "Hopik Mah (ataçınar Köyü)",
      "Hüseyin Ağa Mah (koçkuyusu Köyü)",
      "İlanlı Mah (demirkazık Köyü)",
      "İsmailli Köyü",
      "Kalali Mah (sarıkoç Köyü)",
      "Kalaycı Köyü",
      "Kale Köyü",
      "Kale Mah (dallıbel Köyü)",
      "Kamışlı Mah (ataçınar Köyü)",
      "Kamkamik Mah (gümüşgün Köyü)",
      "Karataş Mah (ataçınar Köyü)",
      "Karayazı Mah (avunca Köyü)",
      "Karayusuf Köyü",
      "Karsan Köyü",
      "Karşıkonak Köyü",
      "Kartutan Köyü",
      "Kavaktepe Köyü",
      "Kayacı Köyü",
      "Kepur Mah (ataçınar Köyü)",
      "Kızılcık Köyü",
      "Kızılkale Köyü",
      "Koçkuyusu Köyü",
      "Kom Mah (doğanlı Köyü)",
      "Koman Mah (gümüşgün Köyü)",
      "Koyunuşağı Köyü",
      "Köprü Mah (aslanyurdu Köyü)",
      "Köprü Mah (karsan Köyü)",
      "Körtelaçin Mah (dayılar Köyü)",
      "Köseoğlu Mah (aşağıoyumca Köyü)",
      "Kuşaklı Köyü",
      "Kuşhane Köyü",
      "Kuşhane Mah (otlukaya Köyü)",
      "Lemper Mah (obuzbaşı Köyü)",
      "Loto Mah (ortaharman Köyü)",
      "Merkez Mah (ibimahmut Köyü)",
      "Meşelik Mah (dallıbel Köyü)",
      "Mezra Mah (ibimahmut Köyü)",
      "Mustafa Uçar Mah (kuşaklı Köyü)",
      "Mürüt Mah (karsan Köyü)",
      "Nişange Mah (doğanlı Köyü)",
      "Obrukkaşı Köyü",
      "Obuzbaşı Köyü",
      "Okul Mah (gelincik Köyü)",
      "Ortadurak Köyü",
      "Ortaharman Köyü",
      "Oruç Mah (dallıbel Köyü)",
      "Otlukaya Köyü",
      "Oymadal Köyü",
      "Öreniçi Köyü",
      "Özdek Köyü",
      "Panan Mah (ibimahmut Köyü)",
      "Polatlar Mah (gelincik Köyü)",
      "Salarar Mah (ortadurak Köyü)",
      "Samsor Mah (gümüşgün Köyü)",
      "Sarıkoç Köyü",
      "Sedikan Mah (gelincik Köyü)",
      "Sevikan Mah (doğanlı Köyü)",
      "Sivgili Mah (güleç Köyü)",
      "Sivrice Mah (kızılkale Köyü)",
      "Solhan Mah (oymadal Köyü)",
      "Sökücek Köyü",
      "Subaşı Mah (yaşaroğlu Köyü)",
      "Sülüntaş Köyü",
      "Şükür Köm Mah (demirci Köyü)",
      "Temürtaht Köyü",
      "Teni Komu Mah (karayusuf Köyü)",
      "Turan Mah (darıkent Köyü)",
      "Tütiyan Mah (güleç Köyü)",
      "Uğurlu Mah (dallıbel Köyü)",
      "Uzunyol Mah (sökücek Köyü)",
      "Uzunyol Mah (sülüntaş Köyü)",
      "Velişih Mah (gelinpınar Köyü)",
      "Veliyan Mah (ataçınar Köyü)",
      "Yarış Mah (dallıbel Köyü)",
      "Yaşaroğlu Köyü",
      "Yazeli Köyü",
      "Yeldeğen Köyü",
      "Yenibudak Köyü",
      "Yılmaz Mah (kızılkale Köyü)",
      "Yukarıçakankcı Mah (aslanyurdu Köyü)",
      "Yukarıoyumca Köyü",
      "Yusufağa Mah (aşağıtarlacık Köyü)",
      "Zimmak Mah (akkavak Köyü)"
    ],
    "Merkez": [
      "Ağaçlı Mz Mah (doluküp Köyü)",
      "Akoluk Mz Mah (buğulu Köyü)",
      "Alacık Köyü",
      "Ali Deresi Mz Mah (çıralı Köyü)",
      "Alibaba Mz Mah (çukur Köyü)",
      "Alikaraman Mah (kocakoç Köyü)",
      "Altınyüzük Köyü",
      "Anafatma Mah (yoncalı  Mah)mz (suvat Köyü)",
      "Anbar Köyü",
      "Andıgak  Mah (yoğurtlu  Mah) Mz (suvat Köyü)",
      "Arıcık Mah (köklüce Köyü)",
      "Aşagı Bor Mz Mah (çıralı Köyü)",
      "Aşağı Başakçı Mz Mah (başakçı Köyü)",
      "Aşağı Dere Mz Mah (güleç Köyü)",
      "Aşağı Kavehek Mz Mah (anbar Köyü)",
      "Aşağı Tarlacık Mz Mah (buğulu Köyü)",
      "Aşağı Teşnik Mah (kocakoç Köyü)",
      "Atadoğdu Köyü",
      "Atalar Mz Mah (gömemiş Köyü)",
      "Atlantı Köyü",
      "Atlanttı Mz Mah (sinan Köyü)",
      "Avcılar Mah (düzpelit Köyü)",
      "Ayderesi Mz Mah (gömemiş Köyü)",
      "Aydoğdu Mz Mah (çukur Köyü)",
      "Ayranlı Mz Mah (sarıtaş Köyü)",
      "Babaocağı Köyü",
      "Bağlarbaşı Mz Mah (güleç Köyü)",
      "Baldan Köyü",
      "Bardak Kale Mz Mah (erdoğdu Köyü)",
      "Bardaklı Mz Mah (erdoğdu Köyü)",
      "Başakçı Köyü",
      "Batman Köyü",
      "Baylık Köyü",
      "Beyaz Pınar Mz Mah (kopuzlar Köyü)",
      "Bilgili Mz Mah (gömemiş Köyü)",
      "Birman  Mah (kurulu  Mah) Mz (anbar Köyü)",
      "Boz Dere Mz Mah (alacık Köyü)",
      "Bozdere Mah (taht Köyü)",
      "Bozdere Mz Mah (çukur Köyü)",
      "Böğürtlen Köyü",
      "Bölmeli Mz Mah (buğulu Köyü)",
      "Buğulu Köyü",
      "Burmageçit Köyü",
      "Cerme Mz Mah (kocakoç Köyü)",
      "Cılga Köyü",
      "Çalkıran Köyü",
      "Çatderesi Mz Mah (çıralı Köyü)",
      "Çayır Mz Mah (altınyüzük Köyü)",
      "Çaylı Mz Mah (yeşilkaya Köyü)",
      "Çemçeli Köyü",
      "Çevlik Mz Mah (cılga Köyü)",
      "Çıralı Köyü",
      "Çırtan Mz Mah (alacık Köyü)",
      "Çimenli Köyü",
      "Çukur Köyü",
      "Çukurbağ Mz Mah (çimenli Köyü)",
      "Dağ Mz Mah (cılga Köyü)",
      "Dalik Mz Mah (dikenli Köyü)",
      "Dallı Mz Mah (buğulu Köyü)",
      "Darlıhan Mz Mah (güleç Köyü)",
      "Dedeağaç Köyü",
      "Delap Mz Mah (gürbüzler Köyü)",
      "Demirkapı Köyü",
      "Demirlibahçe Mz Mah (baylık Köyü)",
      "Dere Mz Mah (eğriyamaç Köyü)",
      "Dere Mz Mah (kuyluca Köyü)",
      "Deregöl Mz Mah (demirkapı Köyü)",
      "Deyirmen Dere Mz Mah (eğriyamaç Köyü)",
      "Dikenli Köyü",
      "Dikilitaş Mz Mah (altınyüzük Köyü)",
      "Dilek Köyü",
      "Doğancık Mz Boş Mah (buğulu Köyü)",
      "Doludizgin Köyü",
      "Doluküp Köyü",
      "Durak Mah (batman Köyü)",
      "Dut Tepe Mz Mah (atlantı Köyü)",
      "Düzpelit Kom Mah (düzpelit Köyü)",
      "Düzpelit Köyü",
      "Eğriyamaç Köyü",
      "Ekinci Mah (sarıtaş Köyü)",
      "Erdemli Mz Mah (güleç Köyü)",
      "Erdoğdu Köyü",
      "Erler Mah (batman Köyü)",
      "Esenyurt Mz Mah (cılga Köyü)",
      "Feran Mz Mah (kocakoç Köyü)",
      "Galbasan Mz Mah (alacık Köyü)",
      "Galbusan Mah (çalkıran Köyü)",
      "Geçimli Mah (batman Köyü)",
      "Geçit Mah (batman Köyü)",
      "Gedizli Mz Mah (atlantı Köyü)",
      "Gelincik Mah (baylık Köyü)",
      "Geyiksuyu Köyü",
      "Gini Mz Mah (doluküp Köyü)",
      "Gökçek Köyü",
      "Gömemiş Köyü",
      "Göz Mah (haceri Köyü)",
      "Gözen Köyü",
      "Güçlü Mz Mah (çukur Köyü)",
      "Güleç Köyü",
      "Güllü Mah (buğulu Köyü)",
      "Gülüce Mz Mah (kocakoç Köyü)",
      "Gümüşkapı Mz Mah (baldan Köyü)",
      "Güneşli Mz Mah (altınyüzük Köyü)",
      "Güneşli Mz Mah (tüllük Köyü)",
      "Gürbüzler Köyü",
      "Haceri Köyü",
      "Hacılar Kom Mz Mah (buğulu Köyü)",
      "Hagu Mz Mah (kocakoç Köyü)",
      "Halitpınar Mah (çemçeli Köyü)",
      "Han Komu Mz Mah (güleç Köyü)",
      "Haydari Mah (batman Köyü)",
      "Hırsızdüzü Mz Mah (demirkapı Köyü)",
      "Hopik Mz Mah (eğriyamaç Köyü)",
      "Huzan Mz Mah (kopuzlar Köyü)",
      "Işıklar Mz Mah (yeşilkaya Köyü)",
      "İstiran Mz Boş Mah (pınar Köyü)",
      "Kale Mz Mah (kocakoç Köyü)",
      "Kalemdüzü Mz Mah (buğulu Köyü)",
      "Kalkar Mz Mah (çimenli Köyü)",
      "Kamışlık Mz Mah (atadoğdu Köyü)",
      "Kanoğlu Köyü",
      "Kapılı Mz Mah (kuyluca Köyü)",
      "Karapınar Mz Mah (böğürtlen Köyü)",
      "Karataş Mz Mah (kocakoç Köyü)",
      "Karayusufan Mz Mah (baylık Köyü)",
      "Karşılar Köyü",
      "Karyemez Mz Mah (kopuzlar Köyü)",
      "Kavacık Mz Mah (gömemiş Köyü)",
      "Kavaktepe Mz Mah (tüllük Köyü)",
      "Kayabaşı Mah (batman Köyü)",
      "Kemer Mz Mah (gürbüzler Köyü)",
      "Kemer Mz Mah (tüllük Köyü)",
      "Kırım Mz Mah (kuyluca Köyü)",
      "Kırmızıgül Mz Mah (gürbüzler Köyü)",
      "Kocakoç Köyü",
      "Kocalar Köyü",
      "Kom Mz Mah (sinan Köyü)",
      "Komokar Mz. Mah (düzpelit Köyü)",
      "Konaklı Mz Mah (çukur Köyü)",
      "Kopuzlar Köyü",
      "Köklü Mz Mah (baylık Köyü)",
      "Köklüce Köyü",
      "Köklüce Mz Mah (alacık Köyü)",
      "Köyaltı Mz Mah (çukur Köyü)",
      "Kur Mz Mah (alacık Köyü)",
      "Kurutlu Mz. Mah (buğulu Köyü)",
      "Kuyluca Köyü",
      "Maman Mz Mah (kocakoç Köyü)",
      "Mehmet Mz Mah (dikenli Köyü)",
      "Meşeyolu Köyü",
      "Metirisler Mah (geyiksuyu Köyü)",
      "Mezre Mz Mah (alacık Köyü)",
      "Mirzali Mz Mah (kocakoç Köyü)",
      "Mutlu Mz Mah (kocalar Köyü)",
      "Okullu Mz Mah (atlantı Köyü)",
      "Okurlar Köyü",
      "Örencik Mz Mah (meşeyolu Köyü)",
      "Örtülü Mah (çemçeli Köyü)",
      "Pınar Köyü",
      "Pirgiç Mz Mah (çalkıran Köyü)",
      "Pirtarla Mah (tüllük Köyü)",
      "Puluçayır Mz Mah (kopuzlar Köyü)",
      "Ramadan Mz Mah (alacık Köyü)",
      "Rengül Mz Mah (eğriyamaç Köyü)",
      "Sağ Mah (batman Köyü)",
      "Sağlık Mz Mah (alacık Köyü)",
      "Samanlı Mz Mah (uzuntarla Köyü)",
      "Sandaldere Mz Mah (atlantı Köyü)",
      "Sarıçiçek Mz Mah (atlantı Köyü)",
      "Sarıtaş Köyü",
      "Seyit Bey Mz Mah (kocakoç Köyü)",
      "Seypertek Mz Mah (atadoğdu Köyü)",
      "Sin Mz. Mah (geyiksuyu Köyü)",
      "Sinan Köyü",
      "Sinan Mz Mah (güleç Köyü)",
      "Su Başı Mz Mah (alacık Köyü)",
      "Subaşı Mz Mah (buğulu Köyü)",
      "Suvat Köyü",
      "Şemilkan Mz Mah (atlantı Köyü)",
      "Tabyan Mz Mah (haceri Köyü)",
      "Taht Köyü",
      "Tahtamemiş Mz Mah (buğulu Köyü)",
      "Tarlabaşı Mah (uzuntarla Köyü)",
      "Taşburnu Mz Mah (kuyluca Köyü)",
      "Taşoluk Mz Mah (çukur Köyü)",
      "Taşpınar Mz Mah (doluküp Köyü)",
      "Tepecik Mz Mah (güleç Köyü)",
      "Tikanlı Tarla  Mz Mah (eğriyamaç Köyü)",
      "Tosuncuk Mah (buğulu Köyü)",
      "Tosunlu Mz Mah (yeşilkaya Köyü)",
      "Turan Taht Mz Mah (gömemiş Köyü)",
      "Tüllük Köyü",
      "Uzuntarla Köyü",
      "Varlık Mz Mah (kopuzlar Köyü)",
      "Venk Mz Mah (karşılar Köyü)",
      "Yalnızçam Mz Mah (gürbüzler Köyü)",
      "Yanık Kom Mz Mah (alacık Köyü)",
      "Yapraklı  Mah (şağlan Mah) Mz (doludizgin Köyü)",
      "Yapraklı Mz Mah (demirkapı Köyü)",
      "Yapraklı Mz Mah (uzuntarla Köyü)",
      "Yayalar Mz Mah (demirkapı Köyü)",
      "Yeşilce Mah (erdoğdu Köyü)",
      "Yeşilkaya Köyü",
      "Yolkonak Köyü",
      "Yukarı Bor Mz Mah (çıralı Köyü)",
      "Yukarı Böğürtlen Mz Mah (böğürtlen Köyü)",
      "Yukarı Dere Mz Mah (güleç Köyü)",
      "Yukarı Haceri Mah (haceri Köyü)",
      "Yukarı Kavehek Mz Mah (anbar Köyü)",
      "Yukarı Mz Mah (altınyüzük Köyü)",
      "Yukarı Mz Mah (gömemiş Köyü)",
      "Yukarı Suvat Mz Mah (suvat Köyü)",
      "Yukarı Taht Mz Mah (gömemiş Köyü)",
      "Yukarı Teşnik Mah (kocakoç Köyü)",
      "Yukarı Tüllük Mz Mah (babaocağı Köyü)",
      "Yukarıtarlacık Mz Mah (buğulu Köyü)",
      "Yuvacık Mz Mah (kocalar Köyü)",
      "Zeynikan Mah (dikenli Köyü)",
      "Zime Mz Mah (tüllük Köyü)",
      "Aktuluk Mah",
      "Alibaba Mah",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Esentepe Mah",
      "İsmet İnönü Mah",
      "İsmet İnönü Osb Mah",
      "Moğultay Mah",
      "Yeni Mah"
    ],
    "Nazımiye": [
      "Ahurdere Mah (kılköy Köyü)",
      "Akçalı Mah (yazgeldi Köyü)",
      "Aksu Mah (dallıbahçe Köyü)",
      "Aktepe Mah (günlüce Köyü)",
      "Alaca Mah (geriş Köyü)",
      "Alicik Mah (sapköy Köyü)",
      "Alman Mah (kılköy Köyü)",
      "Altın Mah (bostanlı Köyü)",
      "Aslanlı Mah (aşağıdoluca Köyü)",
      "Aşağıdoluca Köyü",
      "Ayranlı Köyü",
      "Ayranlı Mah (yukarıdoluca Köyü)",
      "Bal Mah (çevrecik Köyü)",
      "Balık Mah (sarıyayla Köyü)",
      "Ballıca Köyü",
      "Ballıdere Mah (ballıca Köyü)",
      "Baştarla Mah (aşağıdoluca Köyü)",
      "Bayındır Mah (geriş Köyü)",
      "Bayır Mah (aşağıdoluca Köyü)",
      "Bayramlı Mah (yayıkağıl Köyü)",
      "Beşağaç Mah (yazgeldi Köyü)",
      "Beşik Mah (ballıca Köyü)",
      "Beytaşı Köyü",
      "Bezik Mah (dereova Köyü)",
      "Bıçkılı Mah (turnayolu Köyü)",
      "Boncuk Mah (turnayolu Köyü)",
      "Bostanlı Köyü",
      "Boyalı Mah (güzelpınar Köyü)",
      "Bucaklı Mah (bostanlı Köyü)",
      "Bulak Mah (yukarıdoluca Köyü)",
      "Büyükyurt Köyü",
      "Çayağzı Mah (aşağıdoluca Köyü)",
      "Çayırhatun Mah (aşağıdoluca Köyü)",
      "Çelik Mah (dallıbahçe Köyü)",
      "Çetan Mah (yayıkağıl Köyü)",
      "Çevrecik Köyü",
      "Çığılı Mah (yayıkağıl Köyü)",
      "Dağdibi Mah (yayıkağıl Köyü)",
      "Dal Mah (yukarıdoluca Köyü)",
      "Dalik Mah (geriş Köyü)",
      "Dallıbahçe Köyü",
      "Daylan Mah (aşağıdoluca Köyü)",
      "Değirmendere Mah (sapköy Köyü)",
      "Dem Mah (ayranlı Köyü)",
      "Demirce Köyü",
      "Demirci Mah (ayranlı Köyü)",
      "Dereova Köyü",
      "Dikilitaş Mah (büyükyurt Köyü)",
      "Dilek Mah (geriş Köyü)",
      "Doğancık Mah (büyükyurt Köyü)",
      "Doğantaş Köyü",
      "Dutağacı Mah (geriş Köyü)",
      "Eğribelen Mah (dereova Köyü)",
      "Ekinbaşı Mah (sapköy Köyü)",
      "Ekinli Mah (güzelpınar Köyü)",
      "Elmacık Mah (aşağıdoluca Köyü)",
      "Esenli Mah (güzelpınar Köyü)",
      "Geçitli Mah (güzelpınar Köyü)",
      "Geriş Köyü",
      "Geriş Mah (aşağıdoluca Köyü)",
      "Geyrek Mah (ramazan Köyü)",
      "Golan Mah (güneycik Köyü)",
      "Gölükhan Mah (yayıkağıl Köyü)",
      "Gülbudak Mah (ayranlı Köyü)",
      "Gülek Mah (yukarıdoluca Köyü)",
      "Güllüce Mah (dallıbahçe Köyü)",
      "Güneycik Köyü",
      "Günlüce Köyü",
      "Güzelpınar Köyü",
      "Han Mah (büyükyurt Köyü)",
      "Ilısu Mah (dallıbahçe Köyü)",
      "Kabaklı Mah (kılköy Köyü)",
      "Kale Mah (aşağıdoluca Köyü)",
      "Kapıbaşı Köyü",
      "Karaca Mah (aşağıdoluca Köyü)",
      "Karakaya Mah (beytaşı Köyü)",
      "Kargılı Mah (yazgeldi Köyü)",
      "Kayalı Mah (ramazan Köyü)",
      "Kılköy Köyü",
      "Kırmızı Mah (günlüce Köyü)",
      "Koç Mah (aşağıdoluca Köyü)",
      "Koçlar Mah (sapköy Köyü)",
      "Konak Mah (beytaşı Köyü)",
      "Konuksever Mah (ballıca Köyü)",
      "Koyuncu Mah (dereova Köyü)",
      "Köprülü Mah (geriş Köyü)",
      "Kurna Mah (kılköy Köyü)",
      "Kuşkondu Mah (yazgeldi Köyü)",
      "Kuyucuk Mah (yazgeldi Köyü)",
      "Kuyulu Mah (yayıkağıl Köyü)",
      "Kuzukonak Mah (sarıyayla Köyü)",
      "Kürekli Mah (yukarıdoluca Köyü)",
      "Malkoç Mah (büyükyurt Köyü)",
      "Mürer Mah (kılköy Köyü)",
      "Oğlakcık Mah (dereova Köyü)",
      "Oğlakçı Mah (ayranlı Köyü)",
      "Oğullar Mah (büyükyurt Köyü)",
      "Olgunlar Mah (dallıbahçe Köyü)",
      "Ramazan Köyü",
      "Sakam Mah (kılköy Köyü)",
      "Sapköy Köyü",
      "Sarhoş Mah (güneycik Köyü)",
      "Sarıca Mah (çevrecik Köyü)",
      "Sarıyayla Köyü",
      "Seyban Mah (demirce Köyü)",
      "Seyitgazi Mah (sarıyayla Köyü)",
      "Soğukmeşe Mah (demirce Köyü)",
      "Sögütlük Mah (dallıbahçe Köyü)",
      "Sult Mah (yiğitler Köyü)",
      "Süleyman Kom Mah (kılköy Köyü)",
      "Süleyman Mah (yiğitler Köyü)",
      "Şirin Mah (yayıkağıl Köyü)",
      "Taht Mah (ayranlı Köyü)",
      "Taht Mah (dereova Köyü)",
      "Taht Mah (yukarıdoluca Köyü)",
      "Tanrıverdi Mah (geriş Köyü)",
      "Tavukçu Mah (demirce Köyü)",
      "Tekecik Mah (güzelpınar Köyü)",
      "Tokaçlı Mah (yukarıdoluca Köyü)",
      "Toruk Mah (kılköy Köyü)",
      "Turnayolu Köyü",
      "Usan Mah (geriş Köyü)",
      "Ustalar Mah (aşağıdoluca Köyü)",
      "Varoş Mah (güneycik Köyü)",
      "Yakacık Mah (büyükyurt Köyü)",
      "Yayıkağıl Köyü",
      "Yaylacık Mah (sarıyayla Köyü)",
      "Yazgeldi Köyü",
      "Yeni Mezra Mah (ramazan Köyü)",
      "Yiğitler Köyü",
      "Yoncalı Mah (turnayolu Köyü)",
      "Yukarıdoluca Köyü",
      "Merkez Mah"
    ],
    "Ovacık": [
      "Ada Köyü",
      "Ağaçpınar Köyü",
      "Aktaş Köyü",
      "Akyayık Köyü",
      "Arslandoğmuş Köyü",
      "Arzular Mah (havuzlu Köyü)",
      "Aşağı Meşedibi Mah (çakmaklı Köyü)",
      "Aşağı Uluça Mah (çakmaklı Köyü)",
      "Aşağıtorunoba Köyü",
      "Aşlıca Köyü",
      "Aydınlar Mah (topuzlu Köyü)",
      "Babular Mah (yazıören Köyü)",
      "Balveren Mah (çambulak Köyü)",
      "Beşevler Mah (akyayık Köyü)",
      "Bilgeç Köyü",
      "Bozkıra Mah (eğripınar Köyü)",
      "Burnak Köyü",
      "Buvarlılar Mah (mollaaliler Köyü)",
      "Buzlutepe Köyü",
      "Bük Mah (sarıtosun Köyü)",
      "Büyükköy Köyü",
      "Cevizli Mah (yenikonak Köyü)",
      "Cevizlidere Köyü",
      "Çakmaklı Köyü",
      "Çambulak Köyü",
      "Çat Köyü",
      "Çavuşlu Mah (yaylagünü Köyü)",
      "Çayır Mah (gözeler Köyü)",
      "Çayırdüzü Mah (yaylagünü Köyü)",
      "Çayüstü Köyü",
      "Çemberlitaş Köyü",
      "Çöğürlük Köyü",
      "Dağgeçe Mah (ada Köyü)",
      "Değirmendere Mah (yenisöğüt Köyü)",
      "Dereiçi  Mah (tem Mah) (otlubahçe Köyü)",
      "Doludibek Köyü",
      "Dumantepe Mah (aşağıtorunoba Köyü)",
      "Eğimli Köyü",
      "Eğrikavak Köyü",
      "Eğripınar Köyü",
      "Elgazi Köyü",
      "Esenler Mah (hanuşağı Köyü)",
      "Eskigedik Köyü",
      "Garipuşağı Köyü",
      "Gözeler Köyü",
      "Güneşli Mah (eğripınar Köyü)",
      "Güneykonak Köyü",
      "Haliller Mah (yenikonak Köyü)",
      "Halitpınar Köyü",
      "Hanuşağı Köyü",
      "Havuzlu Köyü",
      "Hopik Mah (sarıtosun Köyü)",
      "Isıtma Köyü",
      "Işıkvuran Köyü",
      "İkizler Mah (akyayık Köyü)",
      "Karaoğlan Köyü",
      "Karataş Köyü",
      "Karayonca Köyü",
      "Kazanç Mah (yaylagünü Köyü)",
      "Kel Hasan Mah (yaylagünü Köyü)",
      "Kızık Köyü",
      "Kızılören Mah (hanuşağı Köyü)",
      "Konaklar Köyü",
      "Koyungölü Köyü",
      "Kozluca Köyü",
      "Köseler Köyü",
      "Kuşluca Köyü",
      "Kürederesi Mah (kızık Köyü)",
      "Mahmutlar Mah (yenikonak Köyü)",
      "Marteli Mah (güneykonak Köyü)",
      "Meşedibi Mah (çakmaklı Köyü)",
      "Mollaaliler Köyü",
      "Otlubahçe Köyü",
      "Öğütlü Mah (çemberlitaş Köyü)",
      "Öveçler Köyü",
      "Paşadüzü Köyü",
      "Romikler Mah (hanuşağı Köyü)",
      "Saçaklı Mah (ziyaret Köyü)",
      "Sağlık Mah (aşağıtorunoba Köyü)",
      "Sarıtosun Köyü",
      "Söğüt Mah (aşağıtorunoba Köyü)",
      "Söğütlü Köyü",
      "Suağzı Mah (yenikonak Köyü)",
      "Şahverdi Köyü",
      "Tağtaci Mah (tatuşağı Köyü)",
      "Tanzi Mah (köseler Köyü)",
      "Tap Mah (burnak Köyü)",
      "Tatuşağı Köyü",
      "Tepsili Köyü",
      "Topuzlu Köyü",
      "Torişi Mah (burnak Köyü)",
      "Tumardı Mah (koyungölü Köyü)",
      "Tuzluca Mah (topuzlu Köyü)",
      "Yağışlı Mah (aşlıca Köyü)",
      "Yağmurlu Mah (çemberlitaş Köyü)",
      "Yakatarla Köyü",
      "Yalmanlar Köyü",
      "Yarımkaya Köyü",
      "Yaylagünü Köyü",
      "Yazıören Köyü",
      "Yenikonak Köyü",
      "Yeniköy Mah (gözeler Köyü)",
      "Yenisöğüt Köyü",
      "Yeşilyazı Köyü",
      "Yılanlı Mah (gözeler Köyü)",
      "Yoğunçam Köyü",
      "Yoncalı Köyü",
      "Yukarı Uluça Mah (çakmaklı Köyü)",
      "Ziyaret Köyü",
      "94 Mahallesi Mah",
      "Kandolar Mah",
      "Pulur Mah"
    ],
    "Pertek": [
      "Akbayır Mah (yeniköy Köyü)",
      "Akdarı Mah (ardıç Köyü)",
      "Akdemir Köyü",
      "Akmezra Mah (koçpınar Köyü)",
      "Altın Küp Mah (demirsaban Köyü)",
      "Ardıç Köyü",
      "Arpalı Köyü",
      "Aşağı Kacar Mah (kaçarlar Köyü)",
      "Aşağıgülbahçe Köyü",
      "Aşağıyakabaşı Mah (çataksu Köyü)",
      "Ayazpınar Köyü",
      "Bağören Mah (kolankaya Köyü)",
      "Bakırlı Köyü",
      "Balan Mah (geçityaka Köyü)",
      "Ballıdut Köyü",
      "Baltagirmez Mah (pınarlar Köyü)",
      "Bayırlı Mah (yukarıgülbahçe Köyü)",
      "Beydamı Köyü",
      "Biçmekaya Köyü",
      "Bozdoğan Mah (kayabağ Köyü)",
      "Bölmeli Mah (yukarıyakabaşı Köyü)",
      "Bulgurtepe Köyü",
      "Cayiran Mah (dere Köyü)",
      "Çakırbahçe Köyü",
      "Çalıözü Köyü",
      "Çamurluk Mah (yalınkaya Köyü)",
      "Çataksu Köyü",
      "Çevirme Mah (günboğazı Köyü)",
      "Çıkınlı Mah (sağman Köyü)",
      "Çukur Mah (yamaçoba Köyü)",
      "Çukurca Köyü",
      "Dalıvartı Mah (ardıç Köyü)",
      "Dalik Mah (pirinççi Köyü)",
      "Damlapınar Mah (kolankaya Köyü)",
      "Demirsaban Köyü",
      "Demürek Mah (geçityaka Köyü)",
      "Dere Köyü",
      "Dereli Köyü",
      "Dillice Mah (sağman Köyü)",
      "Dolamaç Mah (çalıözü Köyü)",
      "Dorutay Köyü",
      "Edincik Mah (kolankaya Köyü)",
      "Elecik Mah (kayabağ Köyü)",
      "Elmakaşı Köyü",
      "Eşeler Mah (ardıç Köyü)",
      "Fındıklı Mah (ardıç Köyü)",
      "Geçityaka Köyü",
      "Gölbaşı Mah (dorutay Köyü)",
      "Gövdeli Köyü",
      "Göztepe Mah (pınarlar Köyü)",
      "Günboğazı Köyü",
      "Günyüzü Mah (çataksu Köyü)",
      "Güzeltepe Mah (pınarlar Köyü)",
      "Hasir Mah (geçityaka Köyü)",
      "Havuz Mah (yamaçoba Köyü)",
      "Hıdolar Mah (mercimek Köyü)",
      "Hoplar Mah (akdemir Köyü)",
      "Hüseyin Baba Mah (ulupınar Köyü)",
      "Işıklar Mah (kolankaya Köyü)",
      "Kaballı Mah (sağman Köyü)",
      "Kabasakal Mah (kolankaya Köyü)",
      "Kaçarlar Köyü",
      "Kalender Mah (karagüney Köyü)",
      "Karabulut Mah (dere Köyü)",
      "Karadere Mah (çakırbahçe Köyü)",
      "Karagüney Köyü",
      "Karakuş Mah (dereli Köyü)",
      "Karaman Mah (konurat Köyü)",
      "Karavelu Mah (yalınkaya Köyü)",
      "Karşıkibağ Mah (ardıç Köyü)",
      "Kayabağ Köyü",
      "Kazılı Köyü",
      "Kesmetaş Mah (ulupınar Köyü)",
      "Koçpınar Köyü",
      "Kolankaya Köyü",
      "Komlar Mah (dorutay Köyü)",
      "Komşuluk Mah (koçpınar Köyü)",
      "Konaklar Köyü",
      "Konaklar Mah (pınarlar Köyü)",
      "Konurat Köyü",
      "Korluca Köyü",
      "Köçekler Mah (çataksu Köyü)",
      "Köyiçi Mah (pınarlar Köyü)",
      "Mercimek Köyü",
      "Merkez Mah (sağman Köyü)",
      "Munzurlar Mah (yukarıgülbahçe Köyü)",
      "Nacar Mah (bakırlı Köyü)",
      "Ozsolar Mah (dereli Köyü)",
      "Peşpınar Mah (yeniköy Köyü)",
      "Pirinççi Köyü",
      "Salimker Mah (biçmekaya Köyü)",
      "Sorhumbağı Mah (sağman Köyü)",
      "Söğütlütepe Köyü",
      "Sumak Köyü",
      "Sürgüç Köyü",
      "Şamlı Mah (karagüney Köyü)",
      "Taht Mah (yamaçoba Köyü)",
      "Tezikan Mah (konurat Köyü)",
      "Tozkoparan Köyü",
      "Ulupınar Köyü",
      "Yalınkaya Köyü",
      "Yamaçoba Köyü",
      "Yaycılar Mah (arpalı Köyü)",
      "Yayla Mah (yamaçoba Köyü)",
      "Yeniköy Köyü",
      "Yeşilyurt Mah (elmakaşı Köyü)",
      "Yukarı Çay Mah (dere Köyü)",
      "Yukarıgülbahçe Köyü",
      "Yukarıyakabaşı Köyü",
      "Zeynonun Mah (mercimek Köyü)",
      "Camikebir Mah",
      "Derebaşı Mah",
      "İstiklal Mah",
      "Kaledibi Mah",
      "Soğukpınar Mah"
    ],
    "Pülümür": [
      "Ağaşenlik Köyü",
      "Akdik Köyü",
      "Aktekin Mah (yarbaşı Köyü)",
      "Algılı Mah (süleymanuşağı Köyü)",
      "Allahverdi Mah (salkımözü Köyü)",
      "Altınhüseyin Köyü",
      "Ardıçlı Köyü",
      "Armağan Mah (dağyolu Köyü)",
      "Armut Düzü Mah (bozağakaraderbent Köyü)",
      "Armutlu Mah (dereköy Köyü)",
      "Aşağı Bostan Yurdu Mah (kırdım Köyü)",
      "Aşağıkayır Mah (kayırlar Köyü)",
      "Aydınlar Mah (çobanyıldızı Köyü)",
      "Ayranlı Mah (altınhüseyin Köyü)",
      "Bahçe Mah (altınhüseyin Köyü)",
      "Bardakçı Köyü",
      "Barışlı Mah (yarbaşı Köyü)",
      "Başeğmez Mah (altınhüseyin Köyü)",
      "Başkalecik Köyü",
      "Bayraklı Mah (hasangazi Köyü)",
      "Beğendik Mah (mezraa Köyü)",
      "Beyaz Pınar Mah (kırdım Köyü)",
      "Boğalı Köyü",
      "Bozağakaraderbent Köyü",
      "Bulut Mah (boğalı Köyü)",
      "Bük Mah (doğanpınar Köyü)",
      "Büvük Mah (kırdım Köyü)",
      "Çağlayan Köyü",
      "Çağlayan Mah (bozağakaraderbent Köyü)",
      "Çakırkaya Köyü",
      "Çalgan Mah (süleymanuşağı Köyü)",
      "Çardak Mah (senek Köyü)",
      "Çatalyaka Mah (mezraa Köyü)",
      "Çay Mah (elmalı Köyü)",
      "Çay Mah (kuzulca Köyü)",
      "Çay Mah (üçdam Köyü)",
      "Çelik Mezrası Mah (dereköy Köyü)",
      "Çevlik Mah (taşlık Köyü)",
      "Çobanyıldızı Köyü",
      "Dağbek Köyü",
      "Dağyolu Mah (dağyolu Köyü)",
      "Değirmendere Mah (dağyolu Köyü)",
      "Değirmendere Mah (kuzulca Köyü)",
      "Dereboyu Köyü",
      "Dereköy Köyü",
      "Derindere Köyü",
      "Devriş Dere Mezrası Mah (dereköy Köyü)",
      "Doğanpınar Köyü",
      "Efeağılı Köyü",
      "Eğribük Mah (dağyolu Köyü)",
      "Elif Hatun Mah (elmalı Köyü)",
      "Elmalı Köyü",
      "Evcik Mah (taşlık Köyü)",
      "Gevrik Mah (üçdam Köyü)",
      "Göcenek Köyü",
      "Göğebakan Mah (kırdım Köyü)",
      "Gökçekonak Köyü",
      "Göl Mah (dağyolu Köyü)",
      "Göneli Mah (başkalecik Köyü)",
      "Guller Mezrası Mah (dereköy Köyü)",
      "Hacılı Köyü",
      "Haçan Mah (bozağakaraderbent Köyü)",
      "Haraba Mah (kuzulca Köyü)",
      "Hasangazi Köyü",
      "Heybeli Mah (süleymanuşağı Köyü)",
      "Hırava Mah (üçdam Köyü)",
      "Kabadal Köyü",
      "Kamışlar Mah (kabadal Köyü)",
      "Kangallı Köyü",
      "Karagöz Köyü",
      "Karkan Mah (elmalı Köyü)",
      "Kaymaztepe Merkez Mah (kaymaztepe Köyü)",
      "Keçi Kıran Mah (süleymanuşağı Köyü)",
      "Kerikan Mah (başkalecik Köyü)",
      "Kırdım Deresi Mah (kırdım Köyü)",
      "Kırdım Köyü",
      "Kırklar Köyü",
      "Kırkmeşe Köyü",
      "Kızılbel Mah (kırdım Köyü)",
      "Kocatepe Köyü",
      "Kovuklu Köyü",
      "Köl Mah (salkımözü Köyü)",
      "Körtemt Mah (yarbaşı Köyü)",
      "Közlüce Köyü",
      "Kuşhane Mah (dağyolu Köyü)",
      "Kuzulca Köyü",
      "Küllü Mah (elmalı Köyü)",
      "Mezraa Köyü",
      "Muhtar Komu Mah (kırdım Köyü)",
      "Mutu Mah (doğanpınar Köyü)",
      "Mürova Mah (kırdım Köyü)",
      "Nohutlu Köyü",
      "Orta Dereköy Keleş Mah (dereköy Köyü)",
      "Ortakayır Mah (kayırlar Köyü)",
      "Sağlamtaş Köyü",
      "Sahnezer Mah (bardakçı Köyü)",
      "Salkımözü Köyü",
      "Salördek Mah (mezraa Köyü)",
      "Sarıgül Köyü",
      "Senek Köyü",
      "Süleymanuşağı Köyü",
      "Şampaşakaraderbent Köyü",
      "Tanrıverdi Mah (kızılmescit Köyü)",
      "Taşyuva Mah (yarbaşı Köyü)",
      "Turnadere Köyü",
      "Uzunevler Mah (mezraa Köyü)",
      "Üçdam Köyü",
      "Ünveren Köyü",
      "Yarbaşı Köyü",
      "Yayla Mah (kabadal Köyü)",
      "Yibo Mah (turnadere Köyü)",
      "Yoncadere Mah (kuzulca Köyü)",
      "Yukarı Bostan Yurdu Mah (kırdım Köyü)",
      "Yukarıkayır Mah (kayırlar Köyü)",
      "Atatürk Mah",
      "Ecevit Mah",
      "Hiver Mah",
      "Merkez Mah",
      "Meydanlar Mah"
    ]
  },
  "Şanlıurfa": {
    "Akçakale": [
      "Acıkuyu Mah",
      "Adnan Menderes Mah",
      "Akbilek Mah",
      "Akçaköy Mah",
      "Akçalı Mah",
      "Akdiken Mah",
      "Akkeçi Mah",
      "Aksahrınç Mah",
      "Alatlar Mah",
      "Alıncık Mah",
      "Arıcan Mah",
      "Aslanlı Mah",
      "Aşağıbeydaş Mah",
      "Aşağıçinpolat Mah",
      "Aşağıderen Mah",
      "Atatürk Mah",
      "Aydınlı Mah",
      "Ayranlı Mah",
      "Ayyıldız Mah",
      "Baykuş Mah",
      "Bilece Mah",
      "Bolatlar Mah",
      "Boybeyi Mah",
      "Buket Mah",
      "Bulutlu Mah",
      "Büyücek Mah",
      "Büyüknaneli Mah",
      "Büyüktaş Mah",
      "Büyüktokaç Mah",
      "Cevher Mah",
      "Ceylanlı Mah",
      "Çakırlar Mah",
      "Çokalan Mah",
      "Çömlekçi Mah",
      "Çukurca Mah",
      "Deniz Mah",
      "Dibek Mah",
      "Donandı Mah",
      "Dorumali Mah",
      "Düzce Mah",
      "Edebey Mah",
      "Eke Mah",
      "Ekinyazı Mah",
      "Erdemler Mah",
      "Erecek Mah",
      "Fatih Sultan Mehmet Mah",
      "Fevzi Çakmak Mah",
      "Fişenge Mah",
      "Geçittepe Mah",
      "Gölbaşı Mah",
      "Gülveren Mah",
      "Gündaş Mah",
      "Güneren Mah",
      "Güvenç Mah",
      "Hacıekber Mah",
      "Hürriyet Mah",
      "İkizce Mah",
      "İncedere Mah",
      "Karatepe Mah",
      "Kayaca Mah",
      "Kayalık Mah",
      "Keçili Mah",
      "Kelebek Mah",
      "Kepezli Mah",
      "Kılıçlı Mah",
      "Kırmıtlı Mah",
      "Koruklu Mah",
      "Köseören Mah",
      "Kurudere Mah",
      "Küçük Hacıekber Mah",
      "Mavitaş Mah",
      "Menzil Mah",
      "Mermer Mah",
      "Mil Mah",
      "Narlıova Mah",
      "Nimet Mah",
      "Nusretiye Mah",
      "Ohali Mah",
      "Okaylar Mah",
      "Onortak Mah",
      "Ortaderen Mah",
      "Ortaören Mah",
      "Osmanlı Mah",
      "Öncül Mah",
      "Pekmezli Mah",
      "Sakça Mah",
      "Salihler Mah",
      "Sevimli Mah",
      "Seyrantepe Mah",
      "Sınırgören Mah",
      "Süleymanşah Mah",
      "Şahinler Mah",
      "Şahinsoylu Mah",
      "Şanlı Mah",
      "Şefkat Mah",
      "Şehitnusretbey Mah",
      "Taşkınlar Mah",
      "Tatlıca Mah",
      "Topçu Mah",
      "Turgut Özal Mah",
      "Tuzluca Mah",
      "Uğraklı Mah",
      "Uğurhan Mah",
      "Uğurtaş Mah",
      "Vize Mah",
      "Yağmuralan Mah",
      "Yalınlı Mah",
      "Yazlıca Mah",
      "Yediyol Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Yeşerti Mah",
      "Yukarı Çukurca Mah",
      "Yukarıbeydaş Mah",
      "Yukarıçinpolat Mah",
      "Yukarıderen Mah",
      "Yusufbey Mah",
      "Zenginova Mah",
      "Zeytindalı Mah",
      "Zorlu Mah"
    ],
    "Birecik": [
      "Abdallı Mah",
      "Akarçay Mah",
      "Akpınar Mah",
      "Almaşar Mah",
      "Altınova Mah",
      "Arslanlı Mah",
      "Aşağı Fatmacık Mah",
      "Aşağı Habip Mah",
      "Aşağı Karkutlu Mah",
      "Aşağı Kuyucak Mah",
      "Aşağıalmaşar Mah",
      "Aşağıeşme Mah",
      "Ayran Mah",
      "Bağlarbaşı Mah",
      "Bahçeönü Mah",
      "Bentbahçesi Mah",
      "Bozdere Mah",
      "Boztepe Mah",
      "Böğürtlen Mah",
      "Cibinören Mah",
      "Cumhuriyet Mah",
      "Çiçekalan Mah",
      "Çiftlik Mah",
      "Çoğan Mah",
      "Dağören Mah",
      "Dalocak Mah",
      "Damlıca Mah",
      "Dışlık Mah",
      "Diktepe Mah",
      "Divriği Mah",
      "Dorucak Mah",
      "Duyduk Mah",
      "Düzlüce Mah",
      "Ekenek Mah",
      "Geçittepe Mah",
      "Göktepe Mah",
      "Günışığı Mah",
      "Güvenir Mah",
      "Güzelyurt Mah",
      "Han Mah",
      "Haydarahmet Mah",
      "Hoca Şerif Mah",
      "Ilgar Mah",
      "İnceler Mah",
      "İncirli Mah",
      "İncirlidere Mah",
      "İnnaplı Mah",
      "Karababa Mah",
      "Karşıyaka Mah",
      "Keskince Mah",
      "Kocaali Mah",
      "Konak Mah",
      "Kömağıl Mah",
      "Kural Mah",
      "Kurtuluş Mah",
      "Kurucahöyük Mah",
      "Mengelli Mah",
      "Merkez Mah",
      "Meteler Mah",
      "Meyanca Mah",
      "Meydan Mah",
      "Mezra Mah",
      "Orta Fatmacık Mah",
      "Özveren Mah",
      "Saha Mah",
      "Sancak Mah",
      "Sekili Mah",
      "Söğürtlen Mah",
      "Sumaklı Mah",
      "Surtepe Mah",
      "Şekerköy Mah",
      "Tüten Mah",
      "Uğurcuk Mah",
      "Ünsal Mah",
      "Yaylacık Mah",
      "Yeniakpınar Mah",
      "Yılmaz Mah",
      "Yukarı Karabaş Mah",
      "Yukarıhabib Mah",
      "Yukarıincirli Mah",
      "Yukarıyeniçağ Mah",
      "Yuvacık Mah",
      "Ziyaret Mah"
    ],
    "Bozova": [
      "Çatak Mah",
      "Gölbaşı Mah",
      "Kevik Mah",
      "Kırmızıpınar Mah",
      "Norçin Mah",
      "75.yıl Mah",
      "Akmağara Mah",
      "Altınlı Mah",
      "Argıncık Mah",
      "Arıkök Mah",
      "Arpalı Mah",
      "Avlak Mah",
      "Aylan Mah",
      "Bağlıca Mah",
      "Baltaş Mah",
      "Binekli Mah",
      "Biris Mah",
      "Boztepe Mah",
      "Budaklı Mah",
      "Buğluca Mah",
      "Bulancak Mah",
      "Büyükhan Mah",
      "Çakmaklı Mah",
      "Deliler Mah",
      "Denizbacı Mah",
      "Dutluca Mah",
      "Dutluk Mah",
      "Eskin Mah",
      "Fevzi Çakmak Mah",
      "Gerdek Mah",
      "Gökören Mah",
      "Göynik Mah",
      "Gözenek Mah",
      "Hacıköy Mah",
      "Hacılar Mah",
      "Hisarlar Mah",
      "İkizköy Mah",
      "İncirli Mah",
      "Kabacık Mah",
      "Karaca Mah",
      "Karacaören Mah",
      "Karakaş Mah",
      "Karapınar Mah",
      "Kargılı Mah",
      "Kepirce Mah",
      "Kesmetaş Mah",
      "Kılçık Mah",
      "Kılıçören Mah",
      "Kındırali Mah",
      "Kırağılı Mah",
      "Kızlar Mah",
      "Killik Mah",
      "Koçhisar Mah",
      "Koçveran Mah",
      "Konuksever Mah",
      "Köseşahin Mah",
      "Küpeli Mah",
      "Maşuk Mah",
      "Mülkören Mah",
      "Narsait Mah",
      "Ortaören Mah",
      "Ortatepe Mah",
      "Örgülü Mah",
      "Özgören Mah",
      "Pirhalil Mah",
      "Sağırlı Mah",
      "Saluc Mah",
      "Seyitören Mah",
      "Sığırcık Mah",
      "Sızan Mah",
      "Soğukkuyu Mah",
      "Söğütlü Mah",
      "Şanlıavşar Mah",
      "Şıhlar Mah",
      "Taşan Mah",
      "Tatarhüyük Mah",
      "Tozluca Mah",
      "Tunalı Mah",
      "Türkmenören Mah",
      "Uzunburç Mah",
      "Üçdirek Mah",
      "Ürünlü Mah",
      "Yalıntaş Mah",
      "Yaslıca Mah",
      "Yavuz Selim Mah",
      "Yaylak Mah",
      "Yeşil Ova Mah",
      "Zivanlı Mah"
    ],
    "Ceylanpınar": [
      "15 Temmuz Mah",
      "Adnan Menderes Mah",
      "Akbulut Mah",
      "Aktepe Mah",
      "Alaca Mah",
      "Altınköy Mah",
      "Aşağıdoruklu Mah",
      "Aşağıdurmuş Mah",
      "Aşağıkarataş Mah",
      "Avcılı Mah",
      "Aydın Mah",
      "Aydoğdu Mah",
      "Bahçelievler Mah",
      "Boğalı Mah",
      "Büyükçaylı Mah",
      "Büyükyenice Mah",
      "Büyükyıldız Mah",
      "Ceylan Mah",
      "Cumhuriyet Mah",
      "Damlacık Mah",
      "Dikili Mah",
      "Düzova Mah",
      "Ensar Mah",
      "Fatih Sultan Mehmet Mah",
      "Gellegöç Mah",
      "Gültepe Mah",
      "Gümüş Mah",
      "Han Mah",
      "Işıklar Mah",
      "Maden Mah",
      "Mehmet Akif Ersoy Mah",
      "Mevlana Mah",
      "Muratlı Mah",
      "Özbek Mah",
      "Saraççeşme Mah",
      "Selahaddin Eyyübi Mah",
      "Seydo Atilla Mah",
      "Sufra Mah",
      "Tekinler Mah",
      "Turgut Özal Mah",
      "Ulucami Mah",
      "Yalçınkaya Mah",
      "Yeniköy Mah",
      "Yenişehir Mah",
      "Yeşiltepe Mah",
      "Yoncalı Mah",
      "Yukarıdoruklu Mah",
      "Yukarıdurmuş Mah",
      "Yukarıesence Mah",
      "Yukarıkarataş Mah",
      "Yukarıtaşlıdere Mah",
      "Yüksektepe Mah"
    ],
    "Eyyübiye": [
      "15 Temmuz Mah",
      "Beykapusu Mah",
      "Bıçakçı Mah",
      "Camikebir Mah",
      "Göl Mah",
      "Gümüşkuşak Mah",
      "Hakimdede Mah",
      "Kadıoğlu Mah",
      "Kendirci Mah",
      "Kurtuluş Mah",
      "Pınarbaşı Mah",
      "Türkmeydanı Mah",
      "Yeni Mah",
      "Yusufpaşa Mah",
      "Abdurrahmandede Mah",
      "Açmalı Mah",
      "Akabe Mah",
      "Akçamescit Mah",
      "Akdilek Mah",
      "Akmağara Mah",
      "Akmeşhet Mah",
      "Akören Mah",
      "Akşemsettin Mah",
      "Alkanlı Mah",
      "Altın Mah",
      "Altınbaşak Mah",
      "Altıntepe Mah",
      "Ambartepe Mah",
      "Apalı Mah",
      "Asya Mah",
      "Aşağıhemedan Mah",
      "Aşağıkoçlu Mah",
      "Aşağıyazıcı Mah",
      "Atlıkonak Mah",
      "Ayrancı Mah",
      "Bağış Mah",
      "Bakırtaş Mah",
      "Bakışlar Mah",
      "Banarlı Mah",
      "Başgök Mah",
      "Başgöze Mah",
      "Başören Mah",
      "Batıkent Mah",
      "Bayraklı Mah",
      "Beşat Mah",
      "Beyazyaprak Mah",
      "Bildim Mah",
      "Bozhöyük Mah",
      "Buhara Mah",
      "Bulduk Mah",
      "Büyükdüzlük Mah",
      "Büyükhan Mah",
      "Büyükhancağız Mah",
      "Büyükotluca Mah",
      "Çalışkanlar Mah",
      "Çamurlu Mah",
      "Dedeosman Mah",
      "Dernek Mah",
      "Dilimli Mah",
      "Direkli Mah",
      "Dolutepe Mah",
      "Duruca Mah",
      "Eyüpkent Mah",
      "Eyyübiye Mah",
      "Eyyüp Nebi Mah",
      "Gelincik Mah",
      "Göldere Mah",
      "Görenler Mah",
      "Gözeller Mah",
      "Gümüşören Mah",
      "Günbalı Mah",
      "Güneş Mah",
      "Güngören Mah",
      "Güzelkuyu Mah",
      "Hacıbayram Mah",
      "Hacılar Mah",
      "Haleplibahçe Mah",
      "Hamzababa Mah",
      "Hancığaz Mah",
      "Hayati Harrani Mah",
      "Horozköy Mah",
      "İkizce Mah",
      "Kadıkendi Mah",
      "Kap Mah",
      "Kaplanköy Mah",
      "Karaali Mah",
      "Karahisar Mah",
      "Karakoyunlu Mah",
      "Karaman Mah",
      "Keberli Mah",
      "Keçikıran Mah",
      "Keserdede Mah",
      "Keskin Mah",
      "Kınalı Mah",
      "Kırçiçeği Mah",
      "Kırkmağara Mah",
      "Kızılkuyu Mah",
      "Koçören Mah",
      "Köprülük Mah",
      "Kubacık Mah",
      "Kurucuk Mah",
      "Küçük Çamurlu Mah",
      "Küçükdüzlük Mah",
      "Küçükhan Mah",
      "Külünçe Mah",
      "Küpeli Mah",
      "Mance Mah",
      "Mihraplı Mah",
      "Muradiye Mah",
      "Mutlukaya Mah",
      "Nadire Mah",
      "Olgunlar Mah",
      "Olukyanı Mah",
      "Onikiler Mah",
      "Ortahemedan Mah",
      "Osmanlı Mah",
      "Ovabeyli Mah",
      "Ozanlar Mah",
      "Örenli Mah",
      "Özlü Mah",
      "Payamlı Mah",
      "Ruha Mah",
      "Sağlık Mah",
      "Seksenören Mah",
      "Selçuklu Mah",
      "Selman Mah",
      "Sultantepe Mah",
      "Süleymanşah Mah",
      "Şahinalan Mah",
      "Şahinler Mah",
      "Şıh Maksut Mah",
      "Tarlabaşı Mah",
      "Taşlıca Mah",
      "Tekyamaç Mah",
      "Tepe Mah",
      "Topdağı Mah",
      "Turluk Mah",
      "Tuzluca Mah",
      "Uğurlu Mah",
      "Ulak Mah",
      "Ulucanlar Mah",
      "Uluköy Mah",
      "Umuroba Mah",
      "Üzerlik Mah",
      "Vergili Mah",
      "Yağmurlu Mah",
      "Yakubiye Mah",
      "Yamaçaltı Mah",
      "Yanıkçöğür Mah",
      "Yardımcı Mah",
      "Yaşar Mah",
      "Yaykılıç Mah",
      "Yediyol Mah",
      "Yenice Mah",
      "Yeşildere Mah",
      "Yolbaşı Mah",
      "Yolbilir Mah",
      "Yukarıçaykuyu Mah",
      "Yukarıhemedan Mah",
      "Yukarıkoçlu Mah",
      "Yukarıyazıcı Mah",
      "Yusuf Mah",
      "Zeynepköy Mah"
    ],
    "Halfeti": [
      "Altınova Mah",
      "Argaç Mah",
      "Argıl Mah",
      "Aşağı Göklü Mah",
      "Balaban Mah",
      "Beyburcu Mah",
      "Bitek Mah",
      "Bozyazı Mah",
      "Bulaklı Mah",
      "Cumhuriyet Mah",
      "Çakallı Mah",
      "Çebekoğlu Mah",
      "Dergili Mah",
      "Durak Mah",
      "Dutluca Mah",
      "Erikli Mah",
      "Fırat Mah",
      "Fıstıközü Mah",
      "Gözeli Mah",
      "Gülaçan Mah",
      "Günece Mah",
      "Gürkuyu Mah",
      "Gürlüce Mah",
      "Hilalli Mah",
      "Kalkan Mah",
      "Kantarma Mah",
      "Karaotlak Mah",
      "Kavaklıca Mah",
      "Kayalar Mah",
      "Kınık Mah",
      "Kurugöl Mah",
      "Macunlu Mah",
      "Narlık Mah",
      "Ortayol Mah",
      "Ömerli Mah",
      "Özmüş Mah",
      "Rüştiye Mah",
      "Salmanlı Mah",
      "Savaşan Mah",
      "Saylakkaya Mah",
      "Seldek Mah",
      "Sırataşlar Mah",
      "Siyahgül Mah",
      "Sütveren Mah",
      "Şimaliye Mah",
      "Tavşanören Mah",
      "Yeni Mah",
      "Yeşilözen Mah",
      "Yukarıgöklü Mah"
    ],
    "Haliliye": [
      "Acaryurt Mah",
      "Açıkyazı Mah",
      "Ahmet Yesevi Mah",
      "Akçalı Mah",
      "Akdoğan Mah",
      "Akpınar Mah",
      "Aktaş Mah",
      "Altındamla Mah",
      "Altıntepe Mah",
      "Anaz Mah",
      "Aslanlı Mah",
      "Asri Mah",
      "Aşağı İçkara Mah",
      "Aşağıakören Mah",
      "Aşağıkoymat Mah",
      "Aşağıvarlıca Mah",
      "Ayazca Mah",
      "Bağlar Mah",
      "Bağlarbaşı Mah",
      "Bakımlı Mah",
      "Balkatan Mah",
      "Ballıca Mah",
      "Boncuk Mah",
      "Boydere Mah",
      "Büyükmirdesi Mah",
      "Çamlıdere Mah",
      "Çanakçı Mah",
      "Çatallı Mah",
      "Çekçek Mah",
      "Çiçekli Mah",
      "Çiçektepesi Mah",
      "Çukurdoruç Mah",
      "Dağeteği Mah",
      "Dağyanı Mah",
      "Dalbaşı Mah",
      "Denizci Mah",
      "Derinkuyu Mah",
      "Derman Mah",
      "Devteyşti Mah",
      "Dikme Mah",
      "Diktaş Mah",
      "Diphisar Mah",
      "Eğerkıran Mah",
      "Emirler Mah",
      "Ernebi Mah",
      "Esenyayla Mah",
      "Göktepe Mah",
      "Güçlü Mah",
      "Gülveren Mah",
      "Gümüştaş Mah",
      "Gürpınar Mah",
      "Güvenli Mah",
      "Güzelköy Mah",
      "Güzelyurt Mah",
      "Halime Mah",
      "Havşanlı Mah",
      "İbrik Mah",
      "İkiağız Mah",
      "İnci Mah",
      "İncirağacı Mah",
      "İncirli Mah",
      "İpekyol Mah",
      "İrice Mah",
      "Kahraman Mah",
      "Kalecik Mah",
      "Kalınbayat Mah",
      "Kanatlı Mah",
      "Kanoğlu Mah",
      "Kapaklı Mah",
      "Karatepe Mah",
      "Kargalı Mah",
      "Karpuzlu Mah",
      "Karsıyaka Mah",
      "Kavakbaşı Mah",
      "Kayalı Mah",
      "Kaygılı Mah",
      "Kaynaklı Mah",
      "Keçili Mah",
      "Kengerli Mah",
      "Kepez Mah",
      "Kepirli Mah",
      "Keremli Mah",
      "Kesme Mah",
      "Kısas Mah",
      "Kızılpınar Mah",
      "Koçak Mah",
      "Konaç Mah",
      "Konak Mah",
      "Konuklu Mah",
      "Körkuyu Mah",
      "Kösecik Mah",
      "Köseköy Mah",
      "Küçüksenemağara Mah",
      "Mağaracık Mah",
      "Mamuca Mah",
      "Mehmetçik Mah",
      "Mil Mah",
      "Mutluca Mah",
      "Nokta Mah",
      "Oğulbey Mah",
      "Ortaören Mah",
      "Osmanbey Mah",
      "Örencik Mah",
      "Parmakkapı Mah",
      "Payamlı Mah",
      "Perşembe Mah",
      "Sarışeyh Mah",
      "Sarıtaş Mah",
      "Sarpdere Mah",
      "Sefalı Mah",
      "Sendebelen Mah",
      "Seyrantepe Mah",
      "Sırrın Mah",
      "Sultan Fatih Mah",
      "Sumaklı Mah",
      "Susuz Mah",
      "Süleymaniye Mah",
      "Şenocak Mah",
      "Şeyhçoban Mah",
      "Taşlıca Mah",
      "Tekerli Mah",
      "Tepedibi Mah",
      "Tepeköy Mah",
      "Terzi Mah",
      "Topraklı Mah",
      "Ulubağ Mah",
      "Uluhan Mah",
      "Umut Mah",
      "Uzunköy Mah",
      "Üçgöze Mah",
      "Üçkonak Mah",
      "Üçkuyu Mah",
      "Üzümkara Mah",
      "Yarımsu Mah",
      "Yavuz Selim Mah",
      "Yazılıkavak Mah",
      "Yedikuyu Mah",
      "Yenice Mah",
      "Yeniköy Mah",
      "Yenisu Mah",
      "Yeroluk Mah",
      "Yeşilköy Mah",
      "Yeşiltepe Mah",
      "Yeşilyurt Mah",
      "Yıldız Mah",
      "Yolyazı Mah",
      "Yukarıakören Mah",
      "Yukarıkoymat Mah",
      "Atatürk Mah",
      "Bahçelievler Mah",
      "Cengiz Topel Mah",
      "Hızmalı Mah",
      "Mimar Sinan Mah",
      "Şair Şevket Mah",
      "Şehitlik Mah",
      "Bamyasuyu Mah",
      "İmam Bakır Mah",
      "Kamberiye Mah",
      "Paşabağı Mah",
      "Sancaktar Mah",
      "Şair Nabi Mah",
      "Ertuğrul Gazi Mah",
      "Hamidiye Mah",
      "Osman Gazi Mah",
      "Refahiye Mah",
      "Selahaddin Eyyübi Mah",
      "Ulubatlı Mah",
      "Veysel Karani Mah",
      "Yenişehir Mah",
      "Yeşildirek Mah"
    ],
    "Harran": [
      "15 Temmuz Mah",
      "Ağcıl Mah",
      "Ahmetkara Mah",
      "Akkuş Mah",
      "Alacalı Mah",
      "Algılı Mah",
      "Altılı Mah",
      "Aralı Mah",
      "Arın Mah",
      "Aslankuyusu Mah",
      "Aşağı Yeşilova Mah",
      "Aşağıkesmekaya Mah",
      "Aşağıyakınyol Mah",
      "Aşağıyarımca Mah",
      "Avlak Mah",
      "Aydıncık Mah",
      "Aydınlar Mah",
      "Aydüştü Mah",
      "Balkat Mah",
      "Balkır Mah",
      "Başkaragöz Mah",
      "Batıkonacık Mah",
      "Bellitaş Mah",
      "Bilgili Mah",
      "Binekli Mah",
      "Bozceylan Mah",
      "Bozyazı Mah",
      "Buğdaytepe Mah",
      "Buldum Mah",
      "Bulgurlu Mah",
      "Bükdere Mah",
      "Büyüktaşlıca Mah",
      "Büyüktürbe Mah",
      "Cevizli Mah",
      "Ceylangözü Mah",
      "Cumhuriyet Mah",
      "Çağbaşı Mah",
      "Çaltılı Mah",
      "Çatalhurma Mah",
      "Çepkenli Mah",
      "Çiçek Mah",
      "Çiftçiler Mah",
      "Çolpan Mah",
      "Damlasu Mah",
      "Dayanıklı Mah",
      "Demirli Mah",
      "Diriliş Mah",
      "Doğukesmekaya Mah",
      "Doğukonacık Mah",
      "Doruç Mah",
      "Duran Mah",
      "Emekli Mah",
      "Eskiharran Mah",
      "Gazlıkuyu Mah",
      "Giyimli Mah",
      "Gögeç Mah",
      "Gökçe Mah",
      "Göktaş Mah",
      "Gözcü Mah",
      "Gürgelen Mah",
      "Hazreti İmambakır Mah",
      "Huzurlu Mah",
      "Hz. Yakup Mah",
      "İbni Teymiye Mah",
      "İmambakır  Mah (merkez Mah)",
      "Kabataş Mah",
      "Karataş Mah",
      "Kaymaklı Mah",
      "Kılıçlı Mah",
      "Kırmıtlı Mah",
      "Koyunluca Mah",
      "Kökenli Mah",
      "Kuruyer Mah",
      "Küçük Ekinli Mah",
      "Küçükminare Mah",
      "Küçükyıldız Mah",
      "Küplüce Mah",
      "Kütüklü Mah",
      "Meydankapı Mah",
      "Minare Mah",
      "Miyanlı Mah",
      "Oğulcuk Mah",
      "Ortakonacık Mah",
      "Öncüler Mah",
      "Özlüce Mah",
      "Öztaş Mah",
      "Parapara Mah",
      "Saide Mah",
      "Savacık Mah",
      "Seferköy Mah",
      "Sehrince Mah",
      "Selalmaz Mah",
      "Soylu Mah",
      "Sugeldi Mah",
      "Süleyman Demirel Mah",
      "Sütlüce Mah",
      "Şeyh Hayati Harrani Mah",
      "Şuayipşehri Mah",
      "Şükürali Mah",
      "Tahılalan Mah",
      "Tanınmış Mah",
      "Tantana Mah",
      "Taylıca Mah",
      "Tekdal Mah",
      "Tekneli Mah",
      "Toytepe Mah",
      "Tozluca Mah",
      "Tüccariye Mah",
      "Türkoğlu Mah",
      "Uluağaç Mah",
      "Uzunyol Mah",
      "Ünlü Mah",
      "Varlıalan Mah",
      "Yakacık Mah",
      "Yardımlı Mah",
      "Yaygılı Mah",
      "Yayvandoruk Mah",
      "Yenice Mah",
      "Yenidoğan Mah",
      "Yeşilova Mah",
      "Yolgider Mah",
      "Yukarıkesmekaya Mah",
      "Yukarıyakınyol Mah",
      "Yukarıyarımca Mah",
      "Yünlüce Mah",
      "Zeytindalı Mah"
    ],
    "Hilvan": [
      "Ağılmus Mah",
      "Ağveren Mah",
      "Akçakebir Mah",
      "Akçaören Mah",
      "Alpı Mah",
      "Arabuk Mah",
      "Arıca Mah",
      "Arınık Mah",
      "Arpalı Mah",
      "Aslanlı Mah",
      "Aşağıçatak Mah",
      "Aşağıekece Mah",
      "Aşağıkamış Mah",
      "Aşağıkülünçe Mah",
      "Aydınlı Mah",
      "Bağlar Mah",
      "Bahçecik Mah",
      "Bahçelievler Mah",
      "Balkı Mah",
      "Barğaç Mah",
      "Bölükbaşı Mah",
      "Buğur Mah",
      "Çağıllı Mah",
      "Çakmak Mah",
      "Çat Mah",
      "Çimdeli Mah",
      "Doğrular Mah",
      "Faik Mah",
      "Gelenek Mah",
      "Göktepe Mah",
      "Gölcük Mah",
      "Gölebakan Mah",
      "Gülaldı Mah",
      "Güluşağı Mah",
      "Gürgür Mah",
      "Hanmağara Mah",
      "Hayrat Mah",
      "Hoşin Mah",
      "İncirli Mah",
      "Kadıkent Mah",
      "Karaburç Mah",
      "Karacurun Mah",
      "Karakucak Mah",
      "Karapınar Mah",
      "Kavalık Mah",
      "Kepirhisar Mah",
      "Kepirkucak Mah",
      "Kırbaşı Mah",
      "Korgun Mah",
      "Kovancı Mah",
      "Kuskunlu Mah",
      "Küçükgölcük Mah",
      "Malören Mah",
      "Mantarlı Mah",
      "Orgız Mah",
      "Ovacık Mah",
      "Oymaağaç Mah",
      "Ömerli Mah",
      "Özbaş Mah",
      "Özveren Mah",
      "Saluca Mah",
      "Söğütlü Mah",
      "Sucuhan Mah",
      "Ustahasan Mah",
      "Uzuncuk Mah",
      "Üçüzler Mah",
      "Yakınyurt Mah",
      "Yeni Mah",
      "Yeşerdi Mah",
      "Yuvacalı Mah"
    ],
    "Karaköprü": [
      "Ağılcık Mah",
      "Ağızhan Mah",
      "Akbayır Mah",
      "Akçahisar Mah",
      "Akıncı Mah",
      "Akpınar Mah",
      "Akpıyar Mah",
      "Ali Baba Mah",
      "Apaydın Mah",
      "Aşağıçiftlik Mah",
      "Aşıkköy Mah",
      "Atakent Mah",
      "Ayanlar Mah",
      "Bahçeli Mah",
      "Başören Mah",
      "Batıkent Mah",
      "Bezirci Mah",
      "Bozköy Mah",
      "Bölücek Mah",
      "Buğdayhüyük Mah",
      "Büyük Akziyaret Mah",
      "Büyükalanlı Mah",
      "Büyükçömlekçi Mah",
      "Büyükkargılı Mah",
      "Büyükördek Mah",
      "Büyüksalkım Mah",
      "Cemal Mah",
      "Çakmak Mah",
      "Çamlıyayla Mah",
      "Çankaya Mah",
      "Çıralı Mah",
      "Çiftekemer Mah",
      "Demircik Mah",
      "Doğukent Mah",
      "Dolunay Mah",
      "Doyumlu Mah",
      "Düğer Mah",
      "Ergünköy Mah",
      "Esemkulu Mah",
      "Esentepe Mah",
      "Estağfurullah Mah",
      "Gazibey Mah",
      "Geçitköy Mah",
      "Gelibolu Mah",
      "Göbekli Mah",
      "Gölgen Mah",
      "Gölpınar Mah",
      "Güllübağ Mah",
      "Günışık Mah",
      "Hamurkesen Mah",
      "Horzum Mah",
      "Hüyüklü Mah",
      "İlhan Mah",
      "İsaören Mah",
      "Karataş Mah",
      "Karşıyaka Mah",
      "Kasımkuyu Mah",
      "Kırkpınar Mah",
      "Kızılburç Mah",
      "Kızlar Mah",
      "Korukezen Mah",
      "Köksüren Mah",
      "Kuşluca Mah",
      "Kuyucak Mah",
      "Küçük Akziyaret Mah",
      "Küçükalanlı Mah",
      "Küçüktülmen Mah",
      "Külaflı Mah",
      "Lüleci Mah",
      "Maşuk Mah",
      "Mehmetçik Mah",
      "Millisaray Mah",
      "Mustafacık Mah",
      "Narlıkuyu Mah",
      "Otlukalan Mah",
      "Öğütçü Mah",
      "Örcünlü Mah",
      "Överler Mah",
      "Özgedik Mah",
      "Pınarbaşı Mah",
      "Sakça Mah",
      "Sancak Mah",
      "Sarım Mah",
      "Seyrantepe Mah",
      "Şahin Mah",
      "Şeker Mah",
      "Şenevler Mah",
      "Şeyhzeliha Mah",
      "Tatburcu Mah",
      "Tülmen Mah",
      "Türkmen Mah",
      "Uzuncuk Mah",
      "Yarımtepe Mah",
      "Yaylacık Mah",
      "Yedikuyu Mah",
      "Yemişli Mah",
      "Yığınak Mah",
      "Yoğunburç Mah",
      "Yukarıkoşma Mah",
      "Yusufkuyu Mah"
    ],
    "Siverek": [
      "Abdalağa Mah",
      "Alagün Mah",
      "Alanyurt Mah",
      "Altaylı Mah",
      "Altınahır Mah",
      "Altınlı Mah",
      "Altınpınar Mah",
      "Anacak Mah",
      "Armağanlı Mah",
      "Aşağıalınca Mah",
      "Aşağıkarabahçe Mah",
      "Aşağıkaracaören Mah",
      "Aşağıyalankoz Mah",
      "Aşlıca Mah",
      "Atmaca Mah",
      "Avurtepe Mah",
      "Ayrancı Mah",
      "Ayvanat Mah",
      "Azıklı Mah",
      "Bağcı Mah",
      "Bağlar Mah",
      "Bahçe Mah",
      "Bahçelievler Mah",
      "Bakırca Mah",
      "Baki Mah",
      "Bakmaç Mah",
      "Bardakçı Mah",
      "Başbük Mah",
      "Başdeğirmen Mah",
      "Batı Mah",
      "Bayırözü Mah",
      "Benek Mah",
      "Beyali Mah",
      "Beybaba Mah",
      "Beyçeri Mah",
      "Beydeş Mah",
      "Bozkuyu Mah",
      "Bozlak Mah",
      "Böğürtlen Mah",
      "Bürüncek Mah",
      "Büyükgöl Mah",
      "Büyükkazanlı Mah",
      "Büyükoba Mah",
      "Büyüktepe Mah",
      "Büyükyakıtlı Mah",
      "Camikebir Mah",
      "Canpolat Mah",
      "Cinhisar Mah",
      "Çağa Mah",
      "Çağdaş Mah",
      "Çanakçı Mah",
      "Çatlı Mah",
      "Çavuşlu Mah",
      "Çaylarbaşı Mah",
      "Çeltik Mah",
      "Çepni Mah",
      "Çevirme Mah",
      "Çiftçibaşı Mah",
      "Çubuklu Mah",
      "Dağbaşı Mah",
      "Damlıca Mah",
      "Dardağan Mah",
      "Darıcalı Mah",
      "Deliktaş Mah",
      "Dicle Mah",
      "Dilekli Mah",
      "Direkli Mah",
      "Divan Mah",
      "Doğukent Mah",
      "Dönemeç Mah",
      "Düğerin Mah",
      "Ediz Mah",
      "Eğriçay Mah",
      "Endarlı Mah",
      "Erbey Mah",
      "Ergen Mah",
      "Erkonağı Mah",
      "Ertem Mah",
      "Eskihan Mah",
      "Esmer Çayı Mah",
      "Fırat Mah",
      "Fırın Mah",
      "Gaziköy Mah",
      "Gedik Mah",
      "Gerçek Mah",
      "Göğerçin Mah",
      "Gözcek Mah",
      "Gözelek Mah",
      "Gözeli Mah",
      "Gülabibey Mah",
      "Güllice Mah",
      "Gülpınar Mah",
      "Güney Karabahçe Mah",
      "Güney Mah",
      "Gürakar Mah",
      "Güvenli Mah",
      "Güvercin Mah",
      "Güzelpınar Mah",
      "Hacı Ömer Mah",
      "Haliliye Mah",
      "Hamamören Mah",
      "Hamidiye Mah",
      "Hasan Çelebi Mah",
      "Hasırlı Mah",
      "Hayriye Mah",
      "İleri Mah",
      "İnanlı Mah",
      "Kale Mah",
      "Kalemli Mah",
      "Kalınağaç Mah",
      "Kamışlı Mah",
      "Kapıkaya Mah",
      "Karabahçe Mah",
      "Karacadağ Mah",
      "Karadibek Mah",
      "Karahisar Mah",
      "Karakeçi Mah",
      "Karakoyun Mah",
      "Kargalı Mah",
      "Karkaşı Mah",
      "Karpuzcu Mah",
      "Kavaklıdere Mah",
      "Kavalık Mah",
      "Kayalı Mah",
      "Kayseri Mah",
      "Keçiburcu Mah",
      "Keçikıran Mah",
      "Kesmekaya Mah",
      "Keş Mah",
      "Kıvançlı Mah",
      "Konurtepe Mah",
      "Kulaksız Mah",
      "Kurbağalı Mah",
      "Kuşlugöl Mah",
      "Küçükgöl Mah",
      "Küptepe Mah",
      "Mezra Mah",
      "Narlıkaya Mah",
      "Nohut Mah",
      "Ofis Mah",
      "Oluklu Mah",
      "Onar Mah",
      "Ortanca Mah",
      "Oyman Mah",
      "Oyuktaş Mah",
      "Önder Mah",
      "Örgülü Mah",
      "Peynirci Mah",
      "Sabancı Mah",
      "Salor Mah",
      "Sarıdam Mah",
      "Sarıkaya Mah",
      "Sarıören Mah",
      "Savucak Mah",
      "Selim Pınar Mah",
      "Sislice Mah",
      "Soydan Mah",
      "Söylemez Mah",
      "Sumaklı Mah",
      "Şair İbrahim Rafet Mah",
      "Şekerli Mah",
      "Şirinkuyu Mah",
      "Tanrıverdi Mah",
      "Taşağıl Mah",
      "Taşhan Mah",
      "Taşıkara Mah",
      "Taşlı Mah",
      "Turna Mah",
      "Uzunpınar Mah",
      "Uzunziyaret Mah",
      "Ülkülü Mah",
      "Üstüntaş Mah",
      "Yeleken Mah",
      "Yeniceli Mah",
      "Yenişehir Mah",
      "Yoğunca Mah",
      "Yumrutepe Mah",
      "Yuvar Mah",
      "Yücelen Mah",
      "Zincirliçay Mah"
    ],
    "Suruç": [
      "Ağırtaş Mah",
      "Akören Mah",
      "Alanyurt Mah",
      "Aligör Mah",
      "Aşağıkarıncalı Mah",
      "Aşağıoylum Mah",
      "Aybastı Mah",
      "Aydın Mah",
      "Ayhan Mah",
      "Balaban Mah",
      "Barış Mah",
      "Bellik Mah",
      "Bilge Mah",
      "Binatlı Mah",
      "Boztepe Mah",
      "Bozyokuş Mah",
      "Büyükağacı Mah",
      "Büyüksergen Mah",
      "Büyükziyaret Mah",
      "Cumhuriyet Mah",
      "Çanakçı Mah",
      "Çaykara Mah",
      "Çengelli Mah",
      "Çomak Mah",
      "Demokrasi Mah",
      "Dikili Mah",
      "Dinlence Mah",
      "Dumlukuyu Mah",
      "Ekili Mah",
      "Eskice Mah",
      "Eskiören Mah",
      "Ezgil Mah",
      "Fıstıklı Mah",
      "Göleç Mah",
      "Gölen Mah",
      "Günebakan Mah",
      "Hacılı Mah",
      "Harmanalan Mah",
      "Hürriyet Mah",
      "Hüyükyanı Mah",
      "İzci Mah",
      "Kalkanlı Mah",
      "Kapucu Mah",
      "Kara Mah",
      "Karaca Mah",
      "Karadut Mah",
      "Karahüyük Mah",
      "Karakuyu Mah",
      "Karataş Mah",
      "Keberli Mah",
      "Kesmecik Mah",
      "Kırmıt Mah",
      "Kızılhüyük Mah",
      "Köseler Mah",
      "Köseveli Mah",
      "Kurutepe Mah",
      "Küçükköprü Mah",
      "Küçükova Mah",
      "Küçüksergen Mah",
      "Küçükziyaret Mah",
      "Mertismail Mah",
      "Mollahamza Mah",
      "Mürşitpınar Mah",
      "Orta Bostancı Mah",
      "Oymaklı Mah",
      "Ölçektepe Mah",
      "Özgören Mah",
      "Özlüce Mah",
      "Sarayaltı Mah",
      "Saygın Mah",
      "Taşlıkuyu Mah",
      "Tavşanköy Mah",
      "Tokçalı Mah",
      "Topçular Mah",
      "Uludüz Mah",
      "Uysallı Mah",
      "Üçpınar Mah",
      "Ürkütlü Mah",
      "Üveçli Mah",
      "Yağışlı Mah",
      "Yalınca Mah",
      "Yalpı Mah",
      "Yanaloba Mah",
      "Yatırtepe Mah",
      "Yaylatepe Mah",
      "Yazıköy Mah",
      "Yeğen Mah",
      "Yenişehir Mah",
      "Yıldırım Mah",
      "Yıldız Mah",
      "Yönlü Mah",
      "Yukarıbostancı Mah",
      "Yumurtalık Mah",
      "Yurtçiçeği Mah",
      "Zeyrek Mah"
    ],
    "Viranşehir": [
      "Abalar Mah",
      "Adaköy Mah",
      "Akçataş Mah",
      "Akkese Mah",
      "Alakonak Mah",
      "Altınbaşak Mah",
      "Anıt Mah",
      "Arısu Mah",
      "Arıtır Mah",
      "Aslanbaba Mah",
      "Aşağıtınaz Mah",
      "Atatürk Mah",
      "Atıcılar Mah",
      "Ayaklı Mah",
      "Ayrıdüşen Mah",
      "Azadi Mah",
      "Bahçelievler Mah",
      "Bakımlı Mah",
      "Ballıca Mah",
      "Başaran Mah",
      "Başköy Mah",
      "Beğrük Mah",
      "Binekli Mah",
      "Bozca Mah",
      "Burç Mah",
      "Büyükbardakçı Mah",
      "Büyükçavuş Mah",
      "Büyükgörümlü Mah",
      "Büyükmutlu Mah",
      "Ceylan Mah",
      "Cumhuriyet Mah",
      "Çalıcık Mah",
      "Çamurlu Mah",
      "Çiftçiler Mah",
      "Çiftekuyu Mah",
      "Çokran Mah",
      "Dedeköy Mah",
      "Defterdar Mah",
      "Değim Mah",
      "Demirci Mah",
      "Dikili Mah",
      "Dinçer Mah",
      "Dinçkök Mah",
      "Ekinciler Mah",
      "Ekindöver Mah",
      "Elbeğendi Mah",
      "Elgün Mah",
      "Emiroğlu Mah",
      "Engelli Mah",
      "Eser Mah",
      "Eskikale Mah",
      "Esvetoğlu Mah",
      "Eşkin Mah",
      "Evcimen Mah",
      "Eyyüpnebi Mah",
      "Germen Mah",
      "Göğerli Mah",
      "Göktepe Mah",
      "Gölbaşı Mah",
      "Gölcük Mah",
      "Gömülü Mah",
      "Gönüllü Mah",
      "Gözeli Mah",
      "Gözler Mah",
      "Güleryüz Mah",
      "Gürpınar Mah",
      "Güzlek Mah",
      "Hürriyet Mah",
      "Işıldar Mah",
      "İncirli Mah",
      "İsa Harabesi Mah",
      "Kadıköy Mah",
      "Kale Mah",
      "Karakuzu Mah",
      "Karataş Mah",
      "Karatepe Mah",
      "Kargalı Mah",
      "Karınca Mah",
      "Kavurga Mah",
      "Keçeli Mah",
      "Kemerli Mah",
      "Kervansarayı Mah",
      "Kınalıtepe Mah",
      "Kırbalı Mah",
      "Kırkgöz Mah",
      "Kışla Mah",
      "Kızlarsarayı Mah",
      "Kolağası Mah",
      "Konakyeri Mah",
      "Koşulu Mah",
      "Kucak Mah",
      "Kumçeşme Mah",
      "Kurtulmuş Mah",
      "Küçükmutlu Mah",
      "Küçüktopça Mah",
      "Malta Mah",
      "Mehmetçik Mah",
      "Nergizli Mah",
      "Oğlakçı Mah",
      "Övüncük Mah",
      "Özal Mah",
      "Pınarlar Mah",
      "Reyhanlı Mah",
      "Sağırtaş Mah",
      "Sağlamlar Mah",
      "Sakalar Mah",
      "Samanlı Mah",
      "Sarıbal Mah",
      "Satıcık Mah",
      "Sayoba Mah",
      "Selahaddin Eyyubi Mah",
      "Sepetli Mah",
      "Sergen Mah",
      "Sevgili Mah",
      "Sözeri Mah",
      "Süleymaniye Mah",
      "Şahinli Mah",
      "Şarkpınar Mah",
      "Şehit Mah",
      "Şırnak Mah",
      "Tanyeli Mah",
      "Taşönü Mah",
      "Taşyaka Mah",
      "Tekke Mah",
      "Tekneli Mah",
      "Tepedüzü Mah",
      "Toklu Mah",
      "Tunçbilek Mah",
      "Türkeli Mah",
      "Uğurlu Mah",
      "Ulaklı Mah",
      "Üçgül Mah",
      "Yaban Mah",
      "Yağızlar Mah",
      "Yarpuz Mah",
      "Yayık Mah",
      "Yazgüneşi Mah",
      "Yeni Mah",
      "Yenişehir Mah",
      "Yeşilalıç Mah",
      "Yeşildurak Mah",
      "Yıldız Mah",
      "Yolbilen Mah",
      "Yollarbaşı Mah",
      "Yukarıbağ Mah",
      "Yukarıdilimli Mah",
      "Yukarışölenli Mah",
      "Yüceler Mah"
    ]
  },
  "Uşak": {
    "Banaz": [
      "31 Ağustos Mah",
      "Cumhuriyet Mah",
      "Dilek Mah",
      "İslam Mah",
      "Şehitler Mah",
      "Barış Mah (kızılcasöğüt Beldesi)",
      "Cumhuriyet Mah (kızılcasöğüt Beldesi)",
      "Emek Mah (kızılcasöğüt Beldesi)",
      "Ahat Köyü",
      "Alaba Köyü",
      "Asfalt Mah (kaplangı Köyü)",
      "Aşağı Mah (derbent Köyü)",
      "Aşağı Mah (hatıplar Köyü)",
      "Aşağı Mah (kızılhisar Köyü)",
      "Avgan Mah (yazıtepe Köyü)",
      "Ayrancı Köyü",
      "Bağkonak Köyü",
      "Bahadır Köyü",
      "Balcıdamı Köyü",
      "Baltalı Köyü",
      "Banaz Köyü",
      "Boduçdamı Mah (ulupınar Köyü)",
      "Burhaniye Köyü",
      "Corum Köyü",
      "Çamlar Mah (kızılhisar Köyü)",
      "Çamsu Köyü",
      "Çiftlik Köyü",
      "Çöğürlü Köyü",
      "Danaoğlu Mah (kızılhisar Köyü)",
      "Depremevleri Mah (dümenler Köyü)",
      "Depremevleri Mah (halaçlar Köyü)",
      "Dere Mah (bahadır Köyü)",
      "Dere Mah (düzlüce Köyü)",
      "Dere Mah. (yeşilyurt Köyü)",
      "Düzkışla Köyü",
      "Düzlüce Köyü",
      "Fakıdamı Mah (ulupınar Köyü)",
      "Gebekavak Mah (derbent Köyü)",
      "Gedikler Köyü",
      "Güllüçam Köyü",
      "Gürlek Köyü",
      "Halaçlar Köyü",
      "Halıyazı Mah (hatıplar Köyü)",
      "Hamamboğazı Mah",
      "Hanönü Mah (derbent Köyü)",
      "Hasanköy Köyü",
      "İmrez Köyü",
      "Kaplangı Köyü",
      "Karacahisar Köyü",
      "Karaköse Köyü",
      "Kavacık Köyü",
      "Kayaardı Mah (gürlek Köyü)",
      "Kayılı Köyü",
      "Kızılcaören Köyü",
      "Kozviran Mah (büyükoturak Köyü)",
      "Küçükler Köyü",
      "Küçükoturak Köyü",
      "Kükürt Mah (kuşdemir Köyü)",
      "Merkez Mah (büyükoturak Köyü)",
      "Merkez Mah (dümenler Köyü)",
      "Merkez Mah (kuşdemir Köyü)",
      "Merkez Mah (yazıtepe Köyü)",
      "Mıstıkdamları Mah (kuşdemir Köyü)",
      "Muratlı Köyü",
      "Nohutova Mah (derbent Köyü)",
      "Okul Mah (derbent Köyü)",
      "Ovacık Köyü",
      "Öksüz Köyü",
      "Paşacık Köyü",
      "Reşadiye Köyü",
      "Sarıyazı Mah (hatıplar Köyü)",
      "Susuz Köyü",
      "Şaban Köyü",
      "Şirindere Mah (kaplangı Köyü)",
      "Ulupınar Köyü",
      "Yeni Mah (gürlek Köyü)",
      "Yeni Mah (yeşilyurt Köyü)",
      "Yeni Mahalle (yazıtepe Köyü)",
      "Yenicami Mah (kızılhisar Köyü)",
      "Yenice Köyü",
      "Yenimahalle Mah (kızılhisar Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Mah (derbent Köyü)",
      "Yukarı Mah (hatıplar Köyü)",
      "Yukarı Mah (kızılhisar Köyü)"
    ],
    "Eşme": [
      "Cumhuriyet Mah",
      "Elvanlar Mah",
      "İstasyon Mah",
      "Kemer Mah",
      "Şehitalibey Mah",
      "Üçeylül Mah",
      "Abacılar Mah (dereköy Köyü)",
      "Abdil Çavuş Mah (narıncalı Köyü)",
      "Abdurrahmanlı Mah (saraycık Köyü)",
      "Ağabey Köyü",
      "Ahmet Çavuşlar Mah (eşmeli Köyü)",
      "Akçaköy Köyü",
      "Alahabalı Köyü",
      "Alıçlı Köyü",
      "Aliağalar Mah (davutlar Köyü)",
      "Aliağalar Mah (günyaka Köyü)",
      "Alibeyli Mah (bozlar Köyü)",
      "Amcalar Mah (davutlar Köyü)",
      "Araplar Köyü",
      "Arıklı Mah (alahabalı Köyü)",
      "Armutlu Köyü",
      "Arzular Mah (günyaka Köyü)",
      "Aşağı Mah (karabacaklı Köyü)",
      "Aşılık Mah (çaykışla Köyü)",
      "Aydınlı Köyü",
      "Aydınlı Mah (eşmeli Köyü)",
      "Aydoğanlar Mah (oymalı Köyü)",
      "Bahçe Mah (takmak Köyü)",
      "Balabancı Köyü",
      "Bayerler Mah (armutlu Köyü)",
      "Bekir Damları Mah (günyaka Köyü)",
      "Bekişli Köyü",
      "Beterler Mah (ağabey Köyü)",
      "Bozlar Köyü",
      "Bozlar Merkez Mah (bozlar Köyü)",
      "Caberler Köyü",
      "Camili Köyü",
      "Cemal Mah (cemalçavuş Köyü)",
      "Cemalçavuş Köyü",
      "Cevizli Köyü",
      "Coşlu Mah (köseler Köyü)",
      "Çabar Damı Mah (takmak Köyü)",
      "Çakırlar Mah (eşmeli Köyü)",
      "Çatal Mah (hamamdere Köyü)",
      "Çavuşlu Mah (alahabalı Köyü)",
      "Çavuşlu Mah (köseler Köyü)",
      "Çaykışla Köyü",
      "Çobanlar Mah (kolankaya Köyü)",
      "Çolaklar Mah (saraycık Köyü)",
      "Çöneler Mah (poslu Köyü)",
      "Çürükler Mah (eşmeli Köyü)",
      "Dağdelen Mah (takmak Köyü)",
      "Delibaşlı Köyü",
      "Dere Mah (kocabey Köyü)",
      "Dere Mah (manavlı Köyü)",
      "Derebeyler Mah (ağabey Köyü)",
      "Dereköy Köyü",
      "Dereli Köyü",
      "Dervişli Köyü",
      "Devecioğlu Mah (eşmeli Köyü)",
      "Dıyılılar Mah (dervişli Köyü)",
      "Doğular Mah (bozlar Köyü)",
      "Dumanlar Mah (takmak Köyü)",
      "Düdükçü Mah (kocabey Köyü)",
      "Düzköy Mah (aydınlı Köyü)",
      "Efeler Mah (cemalçavuş Köyü)",
      "Ekerli Mah (bozlar Köyü)",
      "Elma Gediği Mah (eşmeli Köyü)",
      "Emirli Köyü",
      "Eski Köy Mah (çaykışla Köyü)",
      "Eşeli Mah (köseler Köyü)",
      "Eşmetaş Köyü",
      "Faraşatlar Mah (davutlar Köyü)",
      "Farsakdere Mah (delibaşlı Köyü)",
      "Fırtınalar Mah (delibaşlı Köyü)",
      "Gedik Tavukçuluk Mah (aydınlı Köyü)",
      "Gedikler Mah (oymalı Köyü)",
      "Gençler-1 Mah (narıncalı Köyü)",
      "Gençler-2 Mah (narıncalı Köyü)",
      "Gerali Mah (dereköy Köyü)",
      "Gökbel Mah (hamamdere Köyü)",
      "Gökçukur Köyü",
      "Güllübağ Köyü",
      "Güney Köyü",
      "Güzel Ahmetler Mah (eşmeli Köyü)",
      "Güzel Köy Mah (karacaömerli Köyü)",
      "Hacı Hüseyinli Mah (dervişli Köyü)",
      "Hacı İsmailler Mah (davutlar Köyü)",
      "Hacı Kırlar Mah (ağabey Köyü)",
      "Hacı Yeşiller Mah (davutlar Köyü)",
      "Hacı Yeşiller Mah (narıncalı Köyü)",
      "Hacıbekirli Mah (ağabey Köyü)",
      "Hacıbekirli Mah (saraycık Köyü)",
      "Hacıbiller Mah (oymalı Köyü)",
      "Hacıkadirli Mah (kolankaya Köyü)",
      "Hacılar Mah (bozlar Köyü)",
      "Hacımahmutlu Mah (bozlar Köyü)",
      "Hacışerifli Mah (bozlar Köyü)",
      "Hakkı Hocalar Mah (davutlar Köyü)",
      "Halillikler Mah (armutlu Köyü)",
      "Hamamdere Köyü",
      "Hameli Mah (kocabey Köyü)",
      "Hardallı Köyü",
      "Harmandalı Mah (çaykışla Köyü)",
      "Hazırlar Mah (ağabey Köyü)",
      "Helimli Mah (dervişli Köyü)",
      "Hemitli Mah (günyaka Köyü)",
      "Hıdırlar Mah (eşmeli Köyü)",
      "Hocalar Mah (karabacaklı Köyü)",
      "İbrahim Mah (günyaka Köyü)",
      "İlikli Mah (günyaka Köyü)",
      "İsahocalar Mah (köylüoğlu Köyü)",
      "İsalar Köyü",
      "İstasyon Mah (ahmetler Köyü)",
      "İstasyon Mah (güney Köyü)",
      "Kadılar Mah (saraycık Köyü)",
      "Kandemirler Köyü",
      "Kara İmamlar Mah (eşmeli Köyü)",
      "Kara Musalar Mah (ağabey Köyü)",
      "Karaahmetli Köyü",
      "Karacaömerli Köyü",
      "Karakuyu Mah (güllü Köyü)",
      "Karamahmutlu Mah (çaykışla Köyü)",
      "Karapınar Mah (katrancılar Köyü)",
      "Katrancılar Köyü",
      "Kayadamları Mah (cemalçavuş Köyü)",
      "Kayalı Köyü",
      "Kayapınar Köyü",
      "Kazaklar Köyü",
      "Keklikli Köyü",
      "Keleş Ali Mah (narıncalı Köyü)",
      "Kestelli Mah (çaykışla Köyü)",
      "Kılıçlı Mah (saraycık Köyü)",
      "Kıranköy Köyü",
      "Kırlar Mah (narıncalı Köyü)",
      "Kıyalar Mah (çaykışla Köyü)",
      "Koca Ahmetler Mah (dereköy Köyü)",
      "Kocahüseyinler Mah (alahabalı Köyü)",
      "Kolankaya Köyü",
      "Konak Köyü",
      "Kozaklar Mah (eşmeli Köyü)",
      "Köprü Mah (narıncalı Köyü)",
      "Köseler Köyü",
      "Köylüoğlu Köyü",
      "Kuşlular Mah (çaykışla Köyü)",
      "Kuzyaka Mah (karaahmetli Köyü)",
      "Manavlı Köyü",
      "Memili Mah (eşmeli Köyü)",
      "Merkez Mah (ahmetler Köyü)",
      "Merkez Mah (davutlar Köyü)",
      "Merkez Mah (karabacaklı Köyü)",
      "Meryem Oğlu Mah (eşmeli Köyü)",
      "Mestanlar Mah (ağabey Köyü)",
      "Mestanlar Mah (keklikli Köyü)",
      "Mestanlı Mah (delibaşlı Köyü)",
      "Mıçıklı Mah (çaykışla Köyü)",
      "Molla Osmanlı Mah (dereköy Köyü)",
      "Molla Süleymanlı Mah (dervişli Köyü)",
      "Mollahalil Mah (oymalı Köyü)",
      "Musalar Mah (eşmeli Köyü)",
      "Musalar Mah (günyaka Köyü)",
      "Müdürlü Mah (oymalı Köyü)",
      "Narlı Köyü",
      "Nazlı Mah (günyaka Köyü)",
      "Neslihanlar Mah (armutlu Köyü)",
      "Notular Mah (bozlar Köyü)",
      "Orta Mah (günyaka Köyü)",
      "Orta Mahalle (ağabey Köyü)",
      "Osmanoğlu Mah (davutlar Köyü)",
      "Oymalı Köyü",
      "Ömer Ağalar Mah (günyaka Köyü)",
      "Ömerler Mah (armutlu Köyü)",
      "Palalı Mah (alahabalı Köyü)",
      "Piştavlı Mah (oymalı Köyü)",
      "Poslu Köyü",
      "Recepler Mah (eşmeli Köyü)",
      "Sandal Mah (ağabey Köyü)",
      "Saraçlar Mah (davutlar Köyü)",
      "Saraycık Köyü",
      "Sarıahmetli Mah (köseler Köyü)",
      "Sarıhasan Mah (köylüoğlu Köyü)",
      "Sarılar Mah (çaykışla Köyü)",
      "Sepetler Mah (eşmeli Köyü)",
      "Sihirbazlı Mah (aydınlı Köyü)",
      "Süleyman Hocalar Mah (davutlar Köyü)",
      "Şalvarlı Mah (oymalı Köyü)",
      "Şehitli Köyü",
      "Şerif Damları Mah (günyaka Köyü)",
      "Takmak Köyü",
      "Taş Mah (güllü Köyü)",
      "Taşçılar Mah (manavlı Köyü)",
      "Taşdibi Mah (çaykışla Köyü)",
      "Taşköy Mah (bozlar Köyü)",
      "Tatlar Mah (eşmeli Köyü)",
      "Tepe Damları Mah (davutlar Köyü)",
      "Tepe Mah (kocabey Köyü)",
      "Tepeli Mah (köseler Köyü)",
      "Tomlu Mah (oymalı Köyü)",
      "Topallar/uzun Tarla Mah (davutlar Köyü)",
      "Topuzlu Mah (köylüoğlu Köyü)",
      "Tozlutepe Mah (oymalı Köyü)",
      "Tülüler Mah (armutlu Köyü)",
      "Uluyayla Köyü",
      "Uzunlu Mah (bozlar Köyü)",
      "Ünallı Mah (çaykışla Köyü)",
      "Velibeyler Mah (davutlar Köyü)",
      "Yağcılar Mah (keklikli Köyü)",
      "Yahyalar Mah (dervişli Köyü)",
      "Yaylaköy Köyü",
      "Yeni Şehitli Mah (şehitli Köyü)",
      "Yeniköy Köyü",
      "Yeniköy Mah (bozlar Köyü)",
      "Yeşilkavak Köyü",
      "Yörük Koç Mah (karabacaklı Köyü)",
      "Zabdiyeli Mah (oymalı Köyü)",
      "Hürriyet Mah (yeleğen Beldesi)",
      "İstiklal Mah (yeleğen Beldesi)",
      "Yıldırımlar Mah (yeleğen Beldesi)"
    ],
    "Karahallı": [
      "Boğaz Mah",
      "Buğdaylı Mah",
      "Dere Mah",
      "Karbasan Mah",
      "Konak Mah",
      "Konak Osb Mah",
      "Yeni Mah",
      "Alfaklar Köyü",
      "Beki Köyü",
      "Coğuplu Köyü",
      "Çokaklı Köyü",
      "Delihıdırlı Köyü",
      "Dere Mah (paşalar Köyü)",
      "Derincik Mah (coğuplu Köyü)",
      "Dumanlı Köyü",
      "Duraklı Köyü",
      "Karayakuplu Köyü",
      "Kavaklı Köyü",
      "Kaykıllı Köyü",
      "Kırkyaren Köyü",
      "Külköy Köyü",
      "Paşalar Köyü",
      "Pınar Mah (alfaklar Köyü)",
      "Yedideğirmen Mah (duraklı Köyü)"
    ],
    "Merkez": [
      "Atatürk Mah",
      "Aybey Mah",
      "Bozkurt Mah",
      "Cumhuriyet Mah",
      "Dikilitaş Mah",
      "Durak Mah",
      "Elmalıdere Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Işık Mah",
      "İslice Mah",
      "Karaağaç Mah",
      "Kemalöz Mah",
      "Köme Mah",
      "Kurtuluş Mah",
      "Mehmet Akif Ersoy Mah",
      "Ovademirler Mah",
      "Özdemir Mah",
      "Sarayaltı Mah",
      "Ünalan Mah",
      "Yeşil Karaağaç Mah",
      "Abdallar Mah (sorkun Köyü)",
      "Abdiler Mah (karakuyu Köyü)",
      "Abdiller Mah (zahman Köyü)",
      "Ada Mah (eynihan Köyü)",
      "Adıyalar Mah (üçkuyular Köyü)",
      "Akbıyıkoğlu Mah (çamyazı Köyü)",
      "Akkaya Mah (paçacılar Köyü)",
      "Aktaş Köyü",
      "Aktaş Mah (örencik Köyü)",
      "Alibey Mah (koyunbeyli Köyü)",
      "Alicikler Mah (dışkaya Köyü)",
      "Alicikler Mah (mollamusa Köyü)",
      "Alişanlar Mah (paçacılar Köyü)",
      "Alişanlar Mah (sorkun Köyü)",
      "Alişanlar Mah (yeniköy Köyü)",
      "Altınbaşak Mah (koyunbeyli Köyü)",
      "Altıntaş Köyü",
      "Arafat Mah (akbulak Köyü)",
      "Araplar Mah (ciğerdede Köyü)",
      "Ardıçtepe Mah (buğdaylı Köyü)",
      "Aşağı Mah (mende Köyü)",
      "Aşağı Mah (mesudiye Köyü)",
      "Babacanlar Mah (paçacılar Köyü)",
      "Bağbaşı Köyü",
      "Bağrı Açıklar Mah (akbulak Köyü)",
      "Baldıran Mah (çatalbayır Köyü)",
      "Baştarla Mah (gökçedal Köyü)",
      "Başyiğitler Mah (mende Köyü)",
      "Belkaya Köyü",
      "Beylerhan Köyü",
      "Beylerhan Mah (beylerhan Köyü)",
      "Boyalı Köyü",
      "Bozköy Köyü",
      "Bozkuş Köyü",
      "Bozkuş Mah (bozkuş Köyü)",
      "Bozlar Mah (karakuyu Köyü)",
      "Celangöz Mah (bozkuş Köyü)",
      "Ciğerdede Mah (ciğerdede Köyü)",
      "Çakırlar Köy Merkezi Mah (ciğerdede Köyü)",
      "Çalıkhasan Köyü",
      "Çallılar Mah (ciğerdede Köyü)",
      "Çam Mah (derbent Köyü)",
      "Çam Mah (eynihan Köyü)",
      "Çambırak Mah (karaköse Köyü)",
      "Çamdibi Mah (çamyazı Köyü)",
      "Çamyuva Köyü",
      "Çangaloğlu Mah (ciğerdede Köyü)",
      "Çarık Köyü",
      "Çarık Mah (çarık Köyü)",
      "Çay Kenarı Mah (ulucak Köyü)",
      "Çerçidamları Mah (mollamusa Köyü)",
      "Çevre Mah",
      "Çınarcık Köyü",
      "Çınarcık Mah (çınarcık Köyü)",
      "Çırganlar Bağ Evi Mah (dağdemirler Köyü)",
      "Çuhadarlar Mah (selvioğlu Köyü)",
      "Çukurağıl Köyü",
      "Dağyenice Köyü",
      "Dedeler Mah (paçacılar Köyü)",
      "Delihacılar Mah (ortabağ Köyü)",
      "Demirören Köyü",
      "Dere Mah (kayağıl Köyü)",
      "Dere Mah (üçkuyular Köyü)",
      "Dere Mah (yavi Köyü)",
      "Dikmenler Mah (üçkuyular Köyü)",
      "Dolayköy Mah (selvioğlu Köyü)",
      "Dumanlar Mah (yeniköy Köyü)",
      "Duraklar Mah (paçacılar Köyü)",
      "Durhoca Mah (taşkonak Köyü)",
      "Dünek Mah (selvioğlu Köyü)",
      "Efeler Mah (mollamusa Köyü)",
      "Eğridere Mah (eskisaray Köyü)",
      "Elifcikler Mah (sarıdere Köyü)",
      "Elmacık Köyü",
      "Eminoğlu Mah (üçkuyular Köyü)",
      "Ersöğüt Bağ Evleri Mah (dağdemirler Köyü)",
      "Eseler Mah (gökçedal Köyü)",
      "Eski Köy Mah (eğlence Köyü)",
      "Eskigüney Köyü",
      "Eskisaray Köyü",
      "Eskisaray Mah (eskisaray Köyü)",
      "Eynehan Köy Merkezi Mah (eynihan Köyü)",
      "Fakılı Köyü",
      "Gacarlar Mah (üçkuyular Köyü)",
      "Gazahmet Deresi Mah (ciğerdede Köyü)",
      "Geyikler Mah (çatalbayır Köyü)",
      "Göçük Mah (eğlence Köyü)",
      "Göçükler Mah (üçkuyular Köyü)",
      "Göğem Köyü",
      "Gökçetepe Köyü",
      "Gökdere Mah (gökçedal Köyü)",
      "Göl Mah (göğem Köyü)",
      "Gücer Köyü",
      "Gücer Mah (gücer Köyü)",
      "Güldezler Mah (bozköy Köyü)",
      "Güneli Köyü",
      "Hacı Aptiler Mah (akbulak Köyü)",
      "Hacı Hüseyinler Mah (selvioğlu Köyü)",
      "Hacı İmamlar Mah (ciğerdede Köyü)",
      "Hacı Muslular Mah (derbent Köyü)",
      "Hacı Şerifler Mah (köprübaşı Köyü)",
      "Hacıaliler Mah (yeniköy Köyü)",
      "Hacıbekirler Mah (sorkun Köyü)",
      "Hacıkadem Mah",
      "Hacılar Mah (zahman Köyü)",
      "Hacıömerli Mah (ortabağ Köyü)",
      "Halilefendiçiftliği Köyü",
      "Hamam Mah (emirfakı Köyü)",
      "Hasanlar Mah (selvioğlu Köyü)",
      "Hastallar Mah (yeniköy Köyü)",
      "Hediler Mah (selvioğlu Köyü)",
      "Hıdırlar Mah (selvioğlu Köyü)",
      "Hisar Köyü",
      "Hocalar Köyü",
      "Horozcular Mah (paçacılar Köyü)",
      "İkisaray Mah",
      "İstasyon Mah (demirören Köyü)",
      "İstiklal Mah (ilyaslı Köyü)",
      "Kabaklar Köyü",
      "Kadılar Mah (paçacılar Köyü)",
      "Kadılar Mah (üçkuyular Köyü)",
      "Kale Mah (sarıdere Köyü)",
      "Kalfa Mah",
      "Kapancık Köyü",
      "Karabacaklar Mah (mrk Mah) (selvioğlu Köyü)",
      "Karabol Mah (kayağıl Köyü)",
      "Karacahisar Köyü",
      "Karaçorlar Mah (mollamusa Köyü)",
      "Karahasan Köyü",
      "Karahasanlar Mah (karakuyu Köyü)",
      "Karakaya Mah (derbent Köyü)",
      "Karaköse Köyü",
      "Karakuyu Mah",
      "Karaöksüzler Mah (mollamusa Köyü)",
      "Karatırnak Mah (paçacılar Köyü)",
      "Kargılar Mah (kısık Köyü)",
      "Karlık Köyü",
      "Karma Osb Mah",
      "Karşı Mah (sirge Köyü)",
      "Kaşbelen Mah (mende Köyü)",
      "Kayağıl Mah (kayağıl Köyü)",
      "Kaygısız Damları Mah (çatalbayır Köyü)",
      "Kediyünü Köyü",
      "Kelbatmaz Mah (çatalbayır Köyü)",
      "Kesik Mah (dağdemirler Köyü)",
      "Kılcan Köyü",
      "Kılcan Mah (kılcan Köyü)",
      "Kıran Mah (köprübaşı Köyü)",
      "Kırhallar Mah (araplar Mah) (karakuyu Köyü)",
      "Kırka Köyü",
      "Kısık Köyü",
      "Kiremitciler  2 Mah (emirfakı Köyü)",
      "Kiremitciler 1 Mah (emirfakı Köyü)",
      "Kitapcılar Mah (üçkuyular Köyü)",
      "Koca Çukur Mah (selvioğlu Köyü)",
      "Kocadüz Mah (gökçedal Köyü)",
      "Koyunbeyli Köyü",
      "Kozburun Mah (boyalı Köyü)",
      "Körler Mah (ciğerdede Köyü)",
      "Köy Bağlı Evleri Mah (gökçedal Köyü)",
      "Köy Merkezi  Mah ( Hacınasıflar Mah) (mollamusa Köyü)",
      "Köy Merkezi  Mah ( Sarılar  Mah) (köprübaşı Köyü)",
      "Köy Merkezi  Mah (karaçayır Mah) (paçacılar Köyü)",
      "Köy Merkezi Mah (akbulak Köyü)",
      "Köy Merkezi Mah (buğdaylı Köyü)",
      "Köy Merkezi Mah (çamyazı Köyü)",
      "Köy Merkezi Mah (çatalbayır Köyü)",
      "Köy Merkezi Mah (dağdemirler Köyü)",
      "Köy Merkezi Mah (derbent Köyü)",
      "Köy Merkezi Mah (dışkaya Köyü)",
      "Köy Merkezi Mah (eğlence Köyü)",
      "Köy Merkezi Mah (emirfakı Köyü)",
      "Köy Merkezi Mah (imamlar Mah) (üçkuyular Köyü)",
      "Köy Merkezi Mah (karabeyli Köyü)",
      "Köy Merkezi Mah (karakuyu Köyü)",
      "Köy Merkezi Mah (ortabağ Köyü)",
      "Köy Merkezi Mah (örencik Köyü)",
      "Köy Merkezi Mah (sarıdere Köyü)",
      "Köy Merkezi Mah (sirge Köyü)",
      "Köy Merkezi Mah (taşkonak Köyü)",
      "Köy Merkezi Mah (yavi Köyü)",
      "Kundaklar Mah (dışkaya Köyü)",
      "Kurşunluk Mah",
      "Kurugedik Mah (mollamusa Köyü)",
      "Kuşoğlanlar Mah (mende Köyü)",
      "Kuyucak Mah",
      "Kuzanlar Mah (taşkonak Köyü)",
      "Küçük Derbent Mah (derbent Köyü)",
      "Küplemezler Mah (ciğerdede Köyü)",
      "Küplemezler Mah (eynihan Köyü)",
      "Mende Köyü",
      "Merkez Mah (güre Köyü)",
      "Merkez Mah.  Mah (nadara Mah) (gökçedal Köyü)",
      "Mermerdirek Mah (çatalbayır Köyü)",
      "Mezarderesi Mah (gökçedal Köyü)",
      "Muharremşah Mah",
      "Musalar Mah (üçkuyular Köyü)",
      "Musluoğlu Mah (derbent Köyü)",
      "Ormandamı Köyü",
      "Orta Mah (çamyazı Köyü)",
      "Ortaburun Mah (derbent Köyü)",
      "Ortaköy Köyü",
      "Ömerli Mah (dışkaya Köyü)",
      "Örencik Termal Tesisleri Mah (örencik Köyü)",
      "Payamlı Mah (derbent Köyü)",
      "Pırtılar Mah (ciğerdede Köyü)",
      "Ramazanlar Mah (karabeyli Köyü)",
      "Sarmaşık Mah (paçacılar Köyü)",
      "Sayalar Mah (üçkuyular Köyü)",
      "Selikler Köyü",
      "Selviler Köyü",
      "Sorkun Köyü",
      "Susuzören Köyü",
      "Süloderesi Mah (yenişehir Köyü)",
      "Sümenli Mah (dışkaya Köyü)",
      "Şekerli Mah (dağdemirler Köyü)",
      "Şıhhasan Mah (çamyuva Köyü)",
      "Şükraniye Köyü",
      "Taşavlu Mah (gökçedal Köyü)",
      "Tatlıpınar Mah (paçacılar Köyü)",
      "Tavşanlar Mah (taşkonak Köyü)",
      "Tekstil Osb Mah",
      "Tepe Damları Mah (eskisaray Köyü)",
      "Tepe Mah (dışkaya Köyü)",
      "Tilkiler Mah (paçacılar Köyü)",
      "Topallar Mah (yeniköy Köyü)",
      "Tosbıyık Mah (paçacılar Köyü)",
      "Ulucak Köyü",
      "Ustalar Mah (üçkuyular Köyü)",
      "Uzun Çağıllı Mah (derbent Köyü)",
      "Ülfetler Mah (üçkuyular Köyü)",
      "Ürün Köyü",
      "Ürün Mah (ürün Köyü)",
      "Velibeyler Mah (köprübaşı Köyü)",
      "Velikahyalar Mah (üçkuyular Köyü)",
      "Vezirler Mah (ciğerdede Köyü)",
      "Yapağılar Köyü",
      "Yapağılar Mah (yapağılar Köyü)",
      "Yaşamışlar Köyü",
      "Yeni Mah (hisar Köyü)",
      "Yeniköy Köyü",
      "Yenimahalle Mah (yapağılar Köyü)",
      "Yenişehir Köyü",
      "Yeşildere Köyü",
      "Yeşilyurt Mah (ilyaslı Köyü)",
      "Yibo Mah (yenişehir Köyü)",
      "Yol Kenarı Sanayi Mah (yenişehir Köyü)",
      "Yoncalı Köyü",
      "Yukarı Mah (mesudiye Köyü)",
      "Yukarı Mah (yeni Mah) (üçkuyular Köyü)",
      "Zahman Köyü",
      "Zepderesi Mah (mesudiye Köyü)"
    ],
    "Sivaslı": [
      "Akarca Köyü",
      "Aktepe Mah (azizler Köyü)",
      "Bahçelievler Mah (yayalar Köyü)",
      "Bahçesaray Mah (erice Köyü)",
      "Budaklar Köyü",
      "Cinoğlan Köyü",
      "Çubuk Mah (karaboyalık Köyü)",
      "Eldeniz Köyü",
      "Eroğlu Mah (ketenlik Köyü)",
      "Gazelle Mah (özbeyli Köyü)",
      "Gültepe Mah (yayalar Köyü)",
      "Hacim Köyü",
      "Horzumlar Mah (ketenlik Köyü)",
      "Karşı Mah (ketenlik Köyü)",
      "Kaylan Mah (sazak Köyü)",
      "Kökez Köyü",
      "Kömürcü Mah (ketenlik Köyü)",
      "Merkez Mah (azizler Köyü)",
      "Merkez Mah (erice Köyü)",
      "Merkez Mah (hanoğlu Köyü)",
      "Merkez Mah (karaboyalık Köyü)",
      "Merkez Mah (ketenlik Köyü)",
      "Merkez Mah (sazak Köyü)",
      "Merkez Mah (yenierice Köyü)",
      "Mestan Tepesi Mah (özbeyli Köyü)",
      "Oklu Dere Mah (özbeyli Köyü)",
      "Pınarcı Mah (hanoğlu Köyü)",
      "Salmanlar Köyü",
      "Samatlar Köyü",
      "Sindelli Mah (azizler Köyü)",
      "Tekeli Mah (ketenlik Köyü)",
      "Tülüce Mah (hanoğlu Köyü)",
      "Yeni Yerleşim Alanı Mah (yenierice Köyü)",
      "Fatih Mah (pınarbaşı Beldesi)",
      "Pınar Mah (pınarbaşı Beldesi)",
      "Gülbey Mah (selçikler Beldesi)",
      "Yıldıztepe Mah (selçikler Beldesi)",
      "Akıncılar Mah",
      "Akıncılar Mah (ağaçbeyli Köyü)",
      "Atatürk Mah",
      "Atatürk Mah (ağaçbeyli Köyü)",
      "Evrenli Mah",
      "Gölbahçe Mah",
      "Gürsel Mah (ağaçbeyli Köyü)",
      "Konak Mah",
      "Atatürk Mah (tatar Beldesi)",
      "Dedeballar Mah (tatar Beldesi)",
      "Fevzi Çakmak Mah (tatar Beldesi)"
    ],
    "Ulubey": [
      "Akkeçili Köyü",
      "Aksaz Köyü",
      "Aksaz Mah (aksaz Köyü)",
      "Atatürk Mah (hasköy Köyü)",
      "Avgan Mah",
      "Bekdemir Köyü",
      "Büyükkayalı Köyü",
      "Çamdere Köyü",
      "Çamiçi Mah (kurudere Köyü)",
      "Çamlıbel Köyü",
      "Çardak Köyü",
      "Çırpıcılar Köyü",
      "Deredam Mah (inay Köyü)",
      "Dört Değirmen Mah (sülümenli Köyü)",
      "Dutluca Köyü",
      "Gedikler Köyü",
      "Gümüşkol Köyü",
      "Hacı Hasanlar Mah (gedikler Köyü)",
      "Hanyeri Köyü",
      "İnay Köyü",
      "İshaklar Köyü",
      "İsmet Paşa Mah (hasköy Köyü)",
      "İstasyon Mah (inay Köyü)",
      "Karacaahmet Köyü",
      "Kıran Köyü",
      "Köseler Köyü",
      "Kurudere Köyü",
      "Küçükilyaslı Köyü",
      "Küçükkayalı Köyü",
      "Külçen Köyü",
      "Merdivenli Mah (inay Köyü)",
      "Merkez Mah (kışla Köyü)",
      "Merkez Mah (omurca Köyü)",
      "Ören Mah (söğütlü Köyü)",
      "Sevindikler Mah (köseler Köyü)",
      "Söğütlü Köyü",
      "Sülümenli Köyü",
      "Yenice Mah (ishaklar Köyü)",
      "Aşağı Mah",
      "Camikebir Mah",
      "Dilaver Mah",
      "Emirler Mah",
      "Gölbaşı Mah",
      "Üyükbaşı Mah"
    ]
  },
  "Van": {
    "Bahçesaray": [
      "Akyayla Mah",
      "Altındere Mah",
      "Altıntas Mah",
      "Arvas Mah",
      "Bağcılar Mah",
      "Cevizlibelen Mah",
      "Çatbayır Mah",
      "Çiçekli Mah",
      "Çömlekçi Mah",
      "Elmayaka Mah",
      "Fekiye Teyran Mah",
      "Güneyyamaç Mah",
      "İslam Mah",
      "Kaşıkçılar Mah",
      "Paşaköy Mah",
      "Şişli Mah",
      "Ulubeyli Mah",
      "Ünlüce Mah",
      "Yaşlıkavak Mah",
      "Yaylakonak Mah"
    ],
    "Başkale": [
      "Açıkağıl Mah",
      "Akçalı Mah",
      "Albayrak Mah",
      "Aşağıküme Mah",
      "Aşalan Mah",
      "Atlılar Mah",
      "Aydemir Mah",
      "Azıklı Mah",
      "Barış Mah",
      "Belencik Mah",
      "Beşocak Mah",
      "Bilgeç Mah",
      "Böğrüpek Mah",
      "Bölekli Mah",
      "Büklümdere Mah",
      "Çakırdoğan Mah",
      "Çaldıran Mah",
      "Dereiçi Mah",
      "Deringeçit Mah",
      "Ekecek Mah",
      "Erek Mah",
      "Erkonağı Mah",
      "Esenyamaç Mah",
      "Eşmepınar Mah",
      "Evbakan Mah",
      "Gedikbaşı Mah",
      "Gelenler Mah",
      "Güleçler Mah",
      "Güroluk Mah",
      "Güvendik Mah",
      "Hafiziye Mah",
      "Hasanbey Mah",
      "Ilıcak Mah",
      "Işıklı Mah",
      "Kaşkol Mah",
      "Kavurgalı Mah",
      "Keçilioba Mah",
      "Kızılca Mah",
      "Kocaköy Mah",
      "Koçdağı Mah",
      "Konuksayar Mah",
      "Kovalıpınar Mah",
      "Köprüağzı Mah",
      "Mahmutabat Mah",
      "Oğulveren Mah",
      "Ortayazı Mah",
      "Ortayol Mah",
      "Ömerdağı Mah",
      "Öncüler Mah",
      "Örencik Mah",
      "Örenkale Mah",
      "Örmetaş Mah",
      "Özpınar Mah",
      "Saçan Mah",
      "Sallıdere Mah",
      "Savaşköy Mah",
      "Sualtı Mah",
      "Tahıl Mah",
      "Tepebaşı Mah",
      "Tınazlı Mah",
      "Uğurlu Mah",
      "Yanal Mah",
      "Yavuzlar Mah",
      "Yeni Mah",
      "Yolmaçayır Mah",
      "Yukarıdallı Mah",
      "Yukarıdarıca Mah",
      "Yukarıdikmen Mah",
      "Yurttepe Mah"
    ],
    "Çaldıran": [
      "Akbaşak Mah",
      "Alakaya Mah",
      "Alikelle Mah",
      "Altıyol Mah",
      "Aşağıçanak Mah",
      "Aşağıdikme Mah",
      "Aşağıgülderen Mah",
      "Aşağıkuyucak Mah",
      "Aşağımutlu Mah",
      "Aşağıyanıktaş Mah",
      "Avcıbaşı Mah",
      "Ayrancılar Mah",
      "Başeğmez Mah",
      "Beyazıt Mah",
      "Beydoğan Mah",
      "Bezirhane Mah",
      "Buğulukaynak Mah",
      "Burçakalan Mah",
      "Cumhuriyet Mah",
      "Çayırköy Mah",
      "Çubuklu Mah",
      "Demircik Mah",
      "Direkli Mah",
      "Doyumalan Mah",
      "Erginler Mah",
      "Evciler Mah",
      "Fatih Sultan Mehmet Mah",
      "Gülyolu Mah",
      "Güngören Mah",
      "Hangediği Mah",
      "Hanköy Mah",
      "İncealan Mah",
      "İsmailbaba Mah",
      "Kalkandelen Mah",
      "Karadulda Mah",
      "Kaşım Mah",
      "Kılavuz Mah",
      "Kilimli Mah",
      "Koçovası Mah",
      "Kurtoğlan Mah",
      "Kuskunkıran Mah",
      "Osmanlı Mah",
      "Recep Tayyip Erdoğan Mah",
      "Salahane Mah",
      "Sarıçimen Mah",
      "Sarıharman Mah",
      "Sellik Mah",
      "Serpmetaş Mah",
      "Soğuksu Mah",
      "Sungur Mah",
      "Şehit Jandarma Binbaşı Kıvanç Cesur Mah",
      "Tekindere Mah",
      "Temrenli Mah",
      "Toprakseven Mah",
      "Umuttepe Mah",
      "Yağıbasan Mah",
      "Yassıtepe Mah",
      "Yavuz Selim Mah",
      "Yaykılıç Mah",
      "Yeniyaka Mah",
      "Yukarıçanak Mah",
      "Yukarıdikme Mah",
      "Yukarıgülderen Mah",
      "Yukarıkuyucak Mah",
      "Yukarımutlu Mah",
      "Yukarısağmallı Mah",
      "Yukarıyanıktaş Mah",
      "Yuvacık Mah",
      "Yücelen Mah",
      "Zülfibulak Mah"
    ],
    "Çatak": [
      "Adnan Menderes Mah",
      "Ağaçlık Mah",
      "Akçabük Mah",
      "Alacayar Mah",
      "Aşağınarlıca Mah",
      "Atlıhan Mah",
      "Bahçelievler Mah",
      "Bilgi Mah",
      "Boyunpınar Mah",
      "Cumhuriyet Mah",
      "Çılga Mah",
      "Dalbastı Mah",
      "Derebaşı Mah",
      "Dokuzdam Mah",
      "Eliaçık Mah",
      "Görentaş Mah",
      "Hacıosman Mah",
      "Işınlı Mah",
      "Kaçıt Mah",
      "Karşıyaka Mah",
      "Konalga Mah",
      "Korulu Mah",
      "Narlı Mah",
      "Onağıl Mah",
      "Övecek Mah",
      "Selçuklu Mah",
      "Sırmalı Mah",
      "Sözveren Mah",
      "Sugeldi Mah",
      "Teknecik Mah",
      "Toyga Mah",
      "Uzuntekne Mah",
      "Yukarınarlıca Mah"
    ],
    "Edremit": [
      "Elmalık Mah",
      "Erdemkent Mah",
      "Erenkent Mah",
      "Eski Cami Mah",
      "Yeni Cami Mah",
      "Yeni Mah",
      "Akın Mah",
      "Andaç Mah",
      "Ayazpınar Mah",
      "Bakacık Mah",
      "Bakımlı Mah",
      "Çayırbaşı Mah",
      "Dilkaya Mah",
      "Doğanlar Mah",
      "Dönemeç Mah",
      "Eminpaşa Mah",
      "Enginsu Mah",
      "Esentepe Mah",
      "Gölkaşı Mah",
      "Kavurma Mah",
      "Kıyıcak Mah",
      "Köklü Mah",
      "Köprüler Mah",
      "Köşkköy Mah",
      "Kurubaş Mah",
      "Mülk Mah",
      "Selahattin Eyyubi Mah",
      "Süphan Mah",
      "Şabaniye Mah",
      "Taşkonak Mah"
    ],
    "Erciş": [
      "Abdalmezrası Mah",
      "Adnan Menderes Mah",
      "Ağaçören Mah",
      "Ağırkaya Mah",
      "Akbaş Mah",
      "Akçayuva Mah",
      "Aksakal Mah",
      "Alkanat Mah",
      "Aşağıakçagedik Mah",
      "Aşağıçökek Mah",
      "Aşağıgöze Mah",
      "Aşağıışıklı Mah",
      "Aşağıkozluca Mah",
      "Bayramlı Mah",
      "Beyazıt Mah",
      "Bozyaka Mah",
      "Bucakönü Mah",
      "Camiikebir Mah",
      "Çakırbey Mah",
      "Çatakdibi Mah",
      "Çataltepe Mah",
      "Çelebibağı Mah",
      "Çetintaş Mah",
      "Çınarlı Mah",
      "Çimen Mah",
      "Çobandüzü Mah",
      "Çubuklu Mah",
      "Deliçay Mah",
      "Derekent Mah",
      "Derimevi Mah",
      "Dinlence Mah",
      "Doğancı Mah",
      "Doluca Mah",
      "Duracak Mah",
      "Düvenci Mah",
      "Ekiciler Mah",
      "Ergücü Mah",
      "Evbeyli Mah",
      "Gedikdibi Mah",
      "Gergili Mah",
      "Gökoğlan Mah",
      "Gölağzı Mah",
      "Görüşlü Mah",
      "Gözütok Mah",
      "Gültepe Mah",
      "Gümüşoluk Mah",
      "Hacıkaş Mah",
      "Hasanabdal Mah",
      "Haydarbey Mah",
      "Hocaali Mah",
      "İkizçalı Mah",
      "İşbaşı Mah",
      "Kadirasker Mah",
      "Karatavuk Mah",
      "Kardoğan Mah",
      "Karlıyayla Mah",
      "Kasımbağı Mah",
      "Kayaboyun Mah",
      "Kekiksırtı Mah",
      "Keklikova Mah",
      "Kırkdeğirmen Mah",
      "Kırkpınar Mah",
      "Kışla Mah",
      "Kızılören Mah",
      "Kocapınar Mah",
      "Koçköprü Mah",
      "Köycük Mah",
      "Latifiye Mah",
      "Mağara Mah",
      "Nişancı Mah",
      "Ortayayla Mah",
      "Oyalı Mah",
      "Örene Mah",
      "Payköy Mah",
      "Pınarlı Mah",
      "Sabanbüken Mah",
      "Sahil Kent Mah",
      "Salihiye Mah",
      "Salmanağa Mah",
      "Söğütlü Mah",
      "Şehirpazar Mah",
      "Şerefli Mah",
      "Taşevler Mah",
      "Taşkapı Mah",
      "Taşlıçay Mah",
      "Tekevler Mah",
      "Tekler Mah",
      "Topraklı Mah",
      "Ulupamir Mah",
      "Uncular Mah",
      "Vanyolu Mah",
      "Yalındam Mah",
      "Yankıtepe Mah",
      "Yeşilova Mah",
      "Yetişen Mah",
      "Yılanlı Mah",
      "Yoldere Mah",
      "Yöreli Mah",
      "Yukarıakçagedik Mah",
      "Yukarıışıklı Mah",
      "Yünören Mah"
    ],
    "Gevaş": [
      "Abalı Mah",
      "Aladüz Mah",
      "Altınsaç Mah",
      "Anaköy Mah",
      "Atalan Mah",
      "Aydınocak Mah",
      "Bağlama Mah",
      "Bahçelievler Mah",
      "Barışık Mah",
      "Dağyöre Mah",
      "Daldere Mah",
      "Değirmitaş Mah",
      "Dereağzı Mah",
      "Dilmetaş Mah",
      "Dokuzağaç Mah",
      "Elmalı Mah",
      "Göründü Mah",
      "Gündoğan Mah",
      "Güzelkonak Mah",
      "Hasbey Mah",
      "Hişet Mah",
      "İkizler Mah",
      "İnköy Mah",
      "Karşıyaka Mah",
      "Kayalar Mah",
      "Kazanç Mah",
      "Kızıltaş Mah",
      "Koçak Mah",
      "Kurultu Mah",
      "Kuşluk Mah",
      "Orta Mah",
      "Pınarbaşı Mah",
      "Selimiye Mah",
      "Timar Mah",
      "Töreli Mah",
      "Uğurveren Mah",
      "Uysal Mah",
      "Yanıkçay Mah",
      "Yemişlik Mah",
      "Yoldöndü Mah",
      "Yuva Mah"
    ],
    "Gürpınar": [
      "Akbulut Mah",
      "Akdoğu Mah",
      "Akpınar Mah",
      "Alnıak Mah",
      "Arındı Mah",
      "Aşağıkaymaz Mah",
      "Bağrıyanık Mah",
      "Beşbudak Mah",
      "Bozyiğit Mah",
      "Bölmeçalı Mah",
      "Bükeç Mah",
      "Cevizalan Mah",
      "Cumhuriyet Mah",
      "Çakınlı Mah",
      "Çatakdibi Mah",
      "Çavuştepe Mah",
      "Çepkenli Mah",
      "Çörekli Mah",
      "Dağseven Mah",
      "Değirmendüzü Mah",
      "Dikbıyık Mah",
      "Dolaylı Mah",
      "Doluçıkın Mah",
      "Elaçmaz Mah",
      "Erkaldı Mah",
      "Geçerli Mah",
      "Geziyurt Mah",
      "Giyimli Mah",
      "Gölardı Mah",
      "Güleçler Mah",
      "Günbaşı Mah",
      "Hacıköy Mah",
      "Hoşab Mah",
      "Işıkpınar Mah",
      "Kalkanlı Mah",
      "Kapçık Mah",
      "Karakoç Mah",
      "Kılıçtutan Mah",
      "Kırkgeçit Mah",
      "Koçgüden Mah",
      "Koyunyatağı Mah",
      "Kuşdağı Mah",
      "Mollahüseyin Mah",
      "Murataldı Mah",
      "Oğuldamı Mah",
      "Ongun Mah",
      "Ortaköy Mah",
      "Otbiçer Mah",
      "Örmeli Mah",
      "Öveçli Mah",
      "Özlüce Mah",
      "Parmakkapı Mah",
      "Sakalar Mah",
      "Sapakonak Mah",
      "Savacık Mah",
      "Sevindik Mah",
      "Sıcaksu Mah",
      "Sütlüce Mah",
      "Taşdöndüren Mah",
      "Taşlıyazı Mah",
      "Tepegören Mah",
      "Topçudeğirmeni Mah",
      "Topsakal Mah",
      "Topyıldız Mah",
      "Tutak Mah",
      "Tutmaç Mah",
      "Umut Mah",
      "Uzungedik Mah",
      "Üçdoğan Mah",
      "Üçgen Mah",
      "Yalınca Mah",
      "Yaramış Mah",
      "Yatağan Mah",
      "Yedisalkım Mah",
      "Yolaşan Mah",
      "Yoldüştü Mah",
      "Yukarıkaymaz Mah",
      "Yurtbaşı Mah",
      "Zernek Mah"
    ],
    "İpekyolu": [
      "Ağzıkara Mah",
      "Aktaş Mah",
      "Erçek Mah",
      "Alipaşa Mah",
      "Arıtoprak Mah",
      "Aşağıçitli Mah",
      "Aşağıgölalan Mah",
      "Bahçıvan Mah",
      "Baklatepe Mah",
      "Bakraçlı Mah",
      "Beşçatak Mah",
      "Bostaniçi Mah",
      "Buzhane Mah",
      "Cevdet Paşa Mah",
      "Cumhuriyet Mah",
      "Çalımlı Mah",
      "Değirmenarkı Mah",
      "Değirmenköy Mah",
      "Dereüstü Mah",
      "Dibekli Mah",
      "Esenler Mah",
      "Gövelek Mah",
      "Hacıbekir Mah",
      "Hafiziye Mah",
      "Halilağa Mah",
      "Hatuniye Mah",
      "Ilıkaynak Mah",
      "Irgat Mah",
      "Karagündüz Mah",
      "Karakoç Mah",
      "Karpuzalanı Mah",
      "Karşıyaka Mah",
      "Kavuncu Mah",
      "Kaymaklı Mah",
      "Kevenli Mah",
      "Kıratlı Mah",
      "Köşebaşı Mah",
      "Ortanca Mah",
      "Sarmaç Mah",
      "Selimbey Mah",
      "Serhat Mah",
      "Seyit Fehim Arvasi Mah",
      "Şerefiye Mah",
      "Vali Mithat Bey Mah",
      "Yalı Mah",
      "Yalınağaç Mah",
      "Yatıksırt Mah",
      "Yeni Mah",
      "Yukarıgölalan Mah",
      "Yukarıgüneyce Mah"
    ],
    "Muradiye": [
      "Açıkyol Mah",
      "Adaklı Mah",
      "Akbulak Mah",
      "Akçaçay Mah",
      "Alkasnak Mah",
      "Aşağıargıt Mah",
      "Babacan Mah",
      "Balaklı Mah",
      "Beşparmak Mah",
      "Beydağı Mah",
      "Çakmak Mah",
      "Çiçekli Mah",
      "Dağören Mah",
      "Devetaş Mah",
      "Doğangün Mah",
      "Dürükkaş Mah",
      "Erişen Mah",
      "Esenkoç Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Gönderme Mah",
      "Görecek Mah",
      "Güllüçimen Mah",
      "Gültepe Mah",
      "Gümüştepe Mah",
      "Kandahar Mah",
      "Karahan Mah",
      "Karaoğlan Mah",
      "Keçikıran Mah",
      "Kemerköprü Mah",
      "Kocasaban Mah",
      "Köşk Mah",
      "Kuşçu Mah",
      "Otlakbaşı Mah",
      "Ovapınar Mah",
      "Sarımemet Mah",
      "Sürüyolu Mah",
      "Şehitmehmetbey Mah",
      "Tansu Mah",
      "Topuzarpa Mah",
      "Uluşar Mah",
      "Ünseli Mah",
      "Yakıncak Mah",
      "Yalındüz Mah",
      "Yavuzselim Mah",
      "Yenişehir Mah",
      "Yukarıargıt Mah",
      "Yumaklı Mah"
    ],
    "Özalp": [
      "Aksorguç Mah",
      "Altınboğa Mah",
      "Aşağıakçagül Mah",
      "Aşağıbalçıklı Mah",
      "Aşağıkoçkıran Mah",
      "Aşağımollahasan Mah",
      "Aşağıtulgalı Mah",
      "Aşağıyorganlı Mah",
      "Bağrıaçık Mah",
      "Bodurağaç Mah",
      "Boğazkesen Mah",
      "Boyaldı Mah",
      "Cumhuriyet Mah",
      "Çamurlu Mah",
      "Çavuşlar Mah",
      "Çırakköy Mah",
      "Çubuklu Mah",
      "Dağdeviren Mah",
      "Damlacık Mah",
      "Dorutay Mah",
      "Dönerdere Mah",
      "Eğribelen Mah",
      "Emek Mah",
      "Eski Emek Mah",
      "Gözdeğmez Mah",
      "Gültepe Mah",
      "Günyüzlü Mah",
      "Hacıali Mah",
      "Hacıkışlak Mah",
      "Hazine Mah",
      "İstasyon Mah",
      "Kalecik Mah",
      "Kargalı Mah",
      "Karlıyamaç Mah",
      "Kaşıkara Mah",
      "Kırkçalı Mah",
      "Mahmudiye Mah",
      "Mehmetalan Mah",
      "Mollatopuz Mah",
      "Oymaklı Mah",
      "Sağmalı Mah",
      "Sarıköy Mah",
      "Savatlı Mah",
      "Seydibey Mah",
      "Sugeçer Mah",
      "Şehittepe Mah",
      "Şemsettin Mah",
      "Tepedam Mah",
      "Yarımkaya Mah",
      "Yavuzlar Mah",
      "Yukarıayazca Mah",
      "Yukarıbalçıklı Mah",
      "Yukarıçavdarlık Mah",
      "Yukarımollahasan Mah",
      "Yukarıtulgalı Mah",
      "Yukarıyorganlı Mah",
      "Yumruklu Mah",
      "Yünkuşak Mah"
    ],
    "Saray": [
      "Atatürk Mah",
      "Bakışık Mah",
      "Baltepe Mah",
      "Beyarslan Mah",
      "Çakmakköy Mah",
      "Çartak Mah",
      "Çaybağı Mah",
      "Değirmigöl Mah",
      "Dolutaş Mah",
      "Feritmelen Mah",
      "Kapıköy Mah",
      "Karahisar Mah",
      "Kargalı Mah",
      "Kazımpaşa Mah",
      "Kazlıgöl Mah",
      "Keçikayası Mah",
      "Kekikdüzü Mah",
      "Kepir Mah",
      "Koçbaşı Mah",
      "Kurucan Mah",
      "Mahmudiye Mah",
      "Örenburç Mah",
      "Sırımlı Mah",
      "Turanköy Mah",
      "Yamanyurt Mah",
      "Yeşilağaç Mah",
      "Zincirkıran Mah"
    ],
    "Tuşba": [
      "Abdurrahman Gazi Mah",
      "Adıgüzel Mah",
      "Akçaören Mah",
      "Akçift Mah",
      "Alabayır Mah",
      "Alaköy Mah",
      "Altıntepe Mah",
      "Arısu Mah",
      "Aşıt Mah",
      "Atmaca Mah",
      "Ayanıs Mah",
      "Bağdaşan Mah",
      "Bardakçı Mah",
      "Beyüzümü Mah",
      "Çakırbey Mah",
      "Çitören Mah",
      "Çobanoğlu Mah",
      "Çolpan Mah",
      "Çomaklı Mah",
      "Dağönü Mah",
      "Değirmenözü Mah",
      "Derebey Mah",
      "Dibekdüzü Mah",
      "Dilimli Mah",
      "Ermişler Mah",
      "Esenpınar Mah",
      "Gedelova Mah",
      "Gedikbulak Mah",
      "Göllü Mah",
      "Gölyazı Mah",
      "Gülsünler Mah",
      "Güvençli Mah",
      "Halkalı Mah",
      "Hıdırköy Mah",
      "İskele Mah",
      "Kalecik Mah",
      "Karaağaç Mah",
      "Kasımoğlu Mah",
      "Kelle Mah",
      "Koçköy Mah",
      "Kolsatan Mah",
      "Kozluca Mah",
      "Kumluca Mah",
      "Meydancık Mah",
      "Mollakasım Mah",
      "Ocaklı Mah",
      "Otluca Mah",
      "Özkaynak Mah",
      "Özyurt Mah",
      "Pirgarip Mah",
      "Sağlamtaş Mah",
      "Satıbey Mah",
      "Seyrantepe Mah",
      "Şahgeldi Mah",
      "Şemsibey Mah",
      "Şemsibeyosb Mah",
      "Tabanlı Mah",
      "Tevekli Mah",
      "Topaktaş Mah",
      "Yalnızağaç Mah",
      "Yaylıyaka Mah",
      "Yemlice Mah",
      "Yeniköşk Mah",
      "Yeşilköy Mah",
      "Yeşilsu Mah",
      "Yumrutepe Mah",
      "Akköprü Mah",
      "İstasyon Mah"
    ]
  },
  "Yozgat": {
    "Akdağmadeni": [
      "Ahishavi Mah",
      "Çamlık Mah",
      "Emek Mah",
      "Gültepe Mah",
      "Güneyli Mah",
      "İbrahim Ağa Mah",
      "İstanbulluoğlu Mah",
      "Seyrantepe Mah",
      "Yeni Mah",
      "Yeşildere Mah",
      "Yeşiltepe Mah",
      "Merkez Mah (belekçahan Beldesi)",
      "Abdurrahmanlı Köyü",
      "Ağaçlı Köyü",
      "Akbaş Köyü",
      "Akçakışla Köyü",
      "Akçakoyunlu Köyü",
      "Alicik Köyü",
      "Altılı Köyü",
      "Ardıçalanı Köyü",
      "Arpalık Köyü",
      "Arslanlı Köyü",
      "Aşağıçulhalı Köyü",
      "Bahçecik Köyü",
      "Başçatak Köyü",
      "Boğazköy Köyü",
      "Boyalık Köyü",
      "Bozhüyük Köyü",
      "Bulgurlu Köyü",
      "Çağlayan Köyü",
      "Çampınar Köyü",
      "Çardak Köyü",
      "Çaypınar Köyü",
      "Çerçialanı Köyü",
      "Davulbaz Köyü",
      "Davutlu Köyü",
      "Dayılı Köyü",
      "Dereyurt Köyü",
      "Dokuz Köyü",
      "Dolak Köyü",
      "Evci Köyü",
      "Eynelli Köyü",
      "Gökdere Köyü",
      "Güllük Köyü",
      "Gümüşdibek Köyü",
      "Gündüzler Köyü",
      "Hacıfakılı Köyü",
      "Halhacı Köyü",
      "Hayran Köyü",
      "Hüyüklüalanı Köyü",
      "İbrahimağaçiftliği Köyü",
      "Karaalikaçağı Köyü",
      "Karabuğra Mah (arslanlı Köyü)",
      "Karacaören Köyü",
      "Karadikmen Köyü",
      "Karapir Köyü",
      "Kartal Köyü",
      "Kayabaşı Köyü",
      "Kayakışla Köyü",
      "Kılınçlı Köyü",
      "Kırlar Köyü",
      "Kızılcaova Köyü",
      "Kızıldağ Köyü",
      "Kirsinkavağı Köyü",
      "Körük Köyü",
      "Kuşlukaçağı Köyü",
      "Melikli Köyü",
      "Muşalikalesi Köyü",
      "Okçulu Köyü",
      "Ortaköy Köyü",
      "Örenkale Köyü",
      "Özer Köyü",
      "Paşabey Köyü",
      "Pazarcık Köyü",
      "Sağıroğlu Köyü",
      "Sarıgüney Köyü",
      "Sazlıdere Köyü",
      "Sekikaşı Köyü",
      "Şahnaderesi Köyü",
      "Tarhana Köyü",
      "Taspınar Köyü",
      "Tekkegüneyi Köyü",
      "Temurşeyh Köyü",
      "Uzakçay Köyü",
      "Üçkaraağaç Köyü",
      "Veziralanı Köyü",
      "Yazılıtaş Köyü",
      "Yedişehri Köyü",
      "Yeniyapan Köyü",
      "Yukarıçulhalı Köyü",
      "Yünalanı Köyü",
      "Konacı Mah (oluközü Beldesi)",
      "Merkez Mah (oluközü Beldesi)",
      "Kale Mah (umutlu Beldesi)",
      "Karaçokrak Mah (umutlu Beldesi)",
      "Karahisartatlısı Mah (umutlu Beldesi)",
      "Olucak Mah (umutlu Beldesi)",
      "Umut Mah (umutlu Beldesi)"
    ],
    "Aydıncık": [
      "Baştürk Mah",
      "Danlıdağ Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Merkez Mah (baydiğin Beldesi)",
      "Ağıllı Köyü",
      "Aşağıkuyucak Köyü",
      "Aydınlık Mah (kazankaya Köyü)",
      "Bakırboğazı Köyü",
      "Benlioğlu Köyü",
      "Bentbaşı Mah (kazankaya Köyü)",
      "Boğazkaya Köyü",
      "Büyüktoraman Köyü",
      "Dereçiftlik Köyü",
      "Güroğlu Köyü",
      "Hacıilyas Köyü",
      "Kırımoluk Köyü",
      "Kıyıkışla Köyü",
      "Kızılcakışla Köyü",
      "Kocabekir Köyü",
      "Kuşsaray Köyü",
      "Kuyu Köyü",
      "Küçüktoraman Köyü",
      "Mercimekören Köyü",
      "Merkez Mah (kösrelik Köyü)",
      "Mollaismail Köyü",
      "Sakızlık Köyü",
      "Üzümlük Köyü"
    ],
    "Boğazlıyan": [
      "Aşağı Karakoç Mah",
      "Aşağı Mah",
      "Bağlarbaşı Mah",
      "Bahçeler Mah",
      "Çarşı Mah",
      "Kaymakam Kemal Bey Mah",
      "Kemaliye Mah",
      "Mevlana Mah",
      "Yenidoğan Mah",
      "Yukarı Karakoç Mah",
      "Yukarı Mah",
      "Abdilli Köyü",
      "Bahariye Köyü",
      "Başhoroz Köyü",
      "Belören Köyü",
      "Cumhuriyet Mah (çakmak Köyü)",
      "Dereçepni Köyü",
      "Esentepe Köyü",
      "Fetih Mah (özler Köyü)",
      "Göl Mah (bahariye Köyü)",
      "Gövdecili Köyü",
      "Güveçli Köyü",
      "Hürriyet Mah (devecipınar Köyü)",
      "İnönü Mah (çalapverdi Köyü)",
      "İrşad Mah (özler Köyü)",
      "Karakuyu Köyü",
      "Kaymakam Kemal Bey Mah (çalapverdi Köyü)",
      "Kazım Karabekir Mah (devecipınar Köyü)",
      "Müftükışla Köyü",
      "Namık Kemal Mah (devecipınar Köyü)",
      "Oğulcuk Köyü",
      "Poyrazlı Köyü",
      "Yapalak Köyü",
      "Yazıçepni Köyü",
      "Yazıkışla Köyü",
      "Yenikışla Köyü",
      "Yeşilhisar Köyü",
      "Yoğunhisar Köyü",
      "Aşağıhasinli Mah (ovakent Beldesi)",
      "Camii Kebir Mah (ovakent Beldesi)",
      "Mevlana Mah (ovakent Beldesi)",
      "Namık Kemal Mah (ovakent Beldesi)",
      "Fatih Mah (sırçalı Beldesi)",
      "Mevlana Mah (sırçalı Beldesi)",
      "Bahçelievler Mah (uzunlu Beldesi)",
      "Esentepe Mah (uzunlu Beldesi)",
      "Kemaliye Mah (uzunlu Beldesi)",
      "Koç Mah (uzunlu Beldesi)",
      "Yenidoğan Mah (uzunlu Beldesi)",
      "Yeni Mah (yamaçlı Beldesi)",
      "Yeşil Mah (yamaçlı Beldesi)",
      "Zafer Mah (yamaçlı Beldesi)",
      "Aşağısarıkaya Mah (yenipazar Beldesi)",
      "Eğlence Mah (yenipazar Beldesi)",
      "Karşıyaka Mah (yenipazar Beldesi)",
      "Ömerli Mah (yenipazar Beldesi)",
      "Selanik Mah (yenipazar Beldesi)",
      "Yaraş Mah (yenipazar Beldesi)"
    ],
    "Çandır": [
      "Abdullah Efendi Mah",
      "Atatürk Mah",
      "Bahçelievler Mah",
      "Barboros Mah",
      "Cumhuriyet Mah",
      "Eşrefpaşa Mah",
      "Kılıçlar Mah",
      "Nabioğlu Mah",
      "Şah Sultan Mah",
      "Yenimeydan Mah",
      "Gülpınar Köyü",
      "İğdeli Köyü",
      "Karşıyaka Mah (büyükkışla Köyü)",
      "Kozan Köyü",
      "Tandoğan Mah (büyükkışla Köyü)",
      "Zafer Mah (büyükkışla Köyü)"
    ],
    "Çayıralan": [
      "Avcılar Mah",
      "Bağlarbaşı Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "İshaklı Mah",
      "Yeni Mah",
      "Fatih Mah (konuklar Beldesi)",
      "Yavuz Sultan Selim Mah (konuklar Beldesi)",
      "Yıldırım Beyazıt Mah (konuklar Beldesi)",
      "Alidemirci Köyü",
      "Aşağıtekke Köyü",
      "Aşağıyahyasaray Köyü",
      "Avşaralanı Köyü",
      "Çokradan Mah",
      "Çukurören Köyü",
      "Derekemal Köyü",
      "Elçi Köyü",
      "Esentepe Mah (curali Köyü)",
      "Evciler Köyü",
      "Fahralı Köyü",
      "Gülderesi Köyü",
      "Günyayla Köyü",
      "Güzelyayla Köyü",
      "İnönü Köyü",
      "Kaletepe Köyü",
      "Karaazap Köyü",
      "Karakışla Köyü",
      "Külekçi Köyü",
      "Menteşe Köyü",
      "Söbeçimen Köyü",
      "Turluhan Köyü",
      "Yeşilyurt Mah (curali Köyü)",
      "Yukarıtekke Köyü",
      "Yukarıyahyasaray Köyü"
    ],
    "Çekerek": [
      "Bağlarbaşı Mah",
      "Bahçelievler Mah",
      "Mevlana Mah",
      "Seyit Ahmet Mah",
      "Yeniyol Mah",
      "Yunus Emre Mah",
      "Alıçlı Köyü",
      "Arpaç Köyü",
      "Başalan Köyü",
      "Başpınar Köyü",
      "Cemaloğlu Köyü",
      "Çakır Köyü",
      "Çandır Köyü",
      "Çayırözü Köyü",
      "Çeltek Köyü",
      "Demircialan Köyü",
      "Doğanoğlu Köyü",
      "Ekizce Köyü",
      "Elemin Köyü",
      "Esentepe Mah (bayındırhüyük Köyü)",
      "Fakıdağı Köyü",
      "Fuadiye Köyü",
      "Gökdere Köyü",
      "Gönülyurdu Köyü",
      "Gülveren Mah (bazlambaç Köyü)",
      "Hamzalı Köyü",
      "İlbeyli Köyü",
      "İsaklı Köyü",
      "Kahyalı Mah (arpaç Köyü)",
      "Kalederesi Köyü",
      "Kamışcık Köyü",
      "Kavakalanı Köyü",
      "Kayalar Köyü",
      "Kırkdilim Köyü",
      "Koyunculu Köyü",
      "Körpınar Köyü",
      "Kurtağılı Köyü",
      "Kuruçay Köyü",
      "Kuzgun Köyü",
      "Mehmetli Köyü",
      "Mercan Mah (bazlambaç Köyü)",
      "Merkez Mah (beyyurdu Köyü)",
      "Ortaoba Köyü",
      "Özören Köyü",
      "Sarıkaya Mah (kalederesi Köyü)",
      "Sarıköy Köyü",
      "Tipideresi Köyü",
      "Yukarıkarahacılı Köyü",
      "Yukarıkarakaya Köyü",
      "Yukarıoba Köyü",
      "Zafer Mah (bayındırhüyük Köyü)",
      "Bağlarbaşı Mah (özükavak Beldesi)",
      "Gültepe Mah (özükavak Beldesi)"
    ],
    "Kadışehri": [
      "Akçakale Mah (halıköy Beldesi)",
      "Bahçeli Evler Mah (halıköy Beldesi)",
      "Fatih Mah (halıköy Beldesi)",
      "Yoncalık Mah (halıköy Beldesi)",
      "Yukarıkızılöz Mah (halıköy Beldesi)",
      "Çaypınar Mah",
      "Gümüşdiğin Mah",
      "Kadıoğlu Mah",
      "Lütfullah Kayalar Mah",
      "Üçağaç Mah",
      "Vasfıbey Mah",
      "Yeni Mah",
      "Aşağıkızılöz Köyü",
      "Belören Köyü",
      "Buzluk Köyü",
      "Çamsaray Köyü",
      "Derbent Köyü",
      "Dikmesöğüt Köyü",
      "Elmalı Köyü",
      "Elmalıçiftliği Köyü",
      "Elmalıütüğü Köyü",
      "Gümüşsu Köyü",
      "Hanözü Köyü",
      "Kabalı Köyü",
      "Kemalli Köyü",
      "Kıyılı Köyü",
      "Ovacık Köyü",
      "Örencik Köyü",
      "Seyhan Köyü",
      "Yakacık Mah",
      "Yangı Mah",
      "Yanık Köyü",
      "Yavuhasan Köyü",
      "Yelten Köyü"
    ],
    "Merkez": [
      "Aktaş Köyü",
      "Akyamaç Köyü",
      "Alemdar Köyü",
      "Araplıçiftliği Mah (dayılı Köyü)",
      "Aydoğan Köyü",
      "Azizli Köyü",
      "Azizlibağları Mah",
      "Bacılı Köyü",
      "Bahçecik Köyü",
      "Bahçelievler Mah (esenli Köyü)",
      "Başıbüyüklü Köyü",
      "Başınayayla Köyü",
      "Battal Köyü",
      "Bayatören Köyü",
      "Beyvelioğlu Köyü",
      "Bozlar Köyü",
      "Buzağcıoğlu Köyü",
      "Büyükincirli Köyü",
      "Büyükmahal Köyü",
      "Büyüknefes Köyü",
      "Cami Mah (osmanpaşa Köyü)",
      "Cihanpaşa Köyü",
      "Çağlayan Köyü",
      "Çalatlı Köyü",
      "Çalılı Köyü",
      "Çay Mah (esenli Köyü)",
      "Çıraderesi Mah (derbent Köyü)",
      "Çorak Köyü",
      "Dağyenicesi Köyü",
      "Dambasan Köyü",
      "Darıcı Köyü",
      "Delihasanlı Köyü",
      "Dereboymul Köyü",
      "Derekışla Köyü",
      "Deremahal Köyü",
      "Deremumlu Köyü",
      "Divanlı Mah",
      "Dönederesi Mah (türkmensarılar Köyü)",
      "Erkekli Köyü",
      "Evci Köyü",
      "Fakıbeyli Köyü",
      "Gelingüllü Mah (esenli Köyü)",
      "Gevrek Köyü",
      "Gökçekışla Köyü",
      "Görpeli Köyü",
      "Güdülelmahacılı Köyü",
      "Güllük Köyü",
      "Güllüoluk Köyü",
      "Güneşli Köyü",
      "Hamzalı Köyü",
      "Haydarbeyli Köyü",
      "İnceçayır Köyü",
      "İşleğen Köyü",
      "Kababel Köyü",
      "Kale Köyü",
      "Kalınbük Mah (bişek Köyü)",
      "Karabıyık Köyü",
      "Karacalar Köyü",
      "Karalar Köyü",
      "Karalar Mah (çadırardıç Köyü)",
      "Karşıyaka Mah (esenli Köyü)",
      "Kaşkışla Köyü",
      "Kavurgalı Köyü",
      "Kırıksoku Köyü",
      "Kışla Köyü",
      "Kızıltepe Köyü",
      "Killik Mah (gülyayla Köyü)",
      "Kolanlı Köyü",
      "Koyunculu Köyü",
      "Köçekkömü Köyü",
      "Köçeklioğlu Köyü",
      "Köklü Mah (baltasarılar Köyü)",
      "Köseyusuflu Köyü",
      "Kuşcu Köyü",
      "Kuyumcu Köyü",
      "Lök Köyü",
      "Merkez Mah (baltasarılar Köyü)",
      "Merkez Mah (bişek Köyü)",
      "Merkez Mah (çadırardıç Köyü)",
      "Merkez Mah (çatma Köyü)",
      "Merkez Mah (dayılı Köyü)",
      "Merkez Mah (derbent Köyü)",
      "Merkez Mah (gülyayla Köyü)",
      "Merkez Mah (kırım Köyü)",
      "Merkez Mah (türkmensarılar Köyü)",
      "Mezraa Köyü",
      "Mollahasan Mah (kırım Köyü)",
      "Musabeyli Köyü",
      "Musabeyliboğazı Köyü",
      "Örencik Köyü",
      "Özlüce Köyü",
      "Penbecik Köyü",
      "Recepli Köyü",
      "Sağlık Köyü",
      "Salmanfakılı Köyü",
      "Sarıfatma Köyü",
      "Sarıhacılı Mah",
      "Sarımbey Köyü",
      "Sarınınören Köyü",
      "Söğütlüyayla Köyü",
      "Şehitler Mah (osmanpaşa Köyü)",
      "Şeyh Ahmet Efendi Mah",
      "Tayfur Köyü",
      "Tayıp Köyü",
      "Tekke Mah (osmanpaşa Köyü)",
      "Tekkeyenicesi Köyü",
      "Topaç Köyü",
      "Topcu Köyü",
      "Türkmen Köyü",
      "Yassıhüyük Köyü",
      "Yazpınar Köyü",
      "Yeşilova Köyü",
      "Yudan Köyü",
      "Yukarı Çatma Mah (çatma Köyü)",
      "Agahefendi Mah",
      "Aşağı Çatak Mah",
      "Aşağınohutlu Mah",
      "Bahçeşehir Mah",
      "Bilal Şahin Mah",
      "Çapanoğlu Mah",
      "Develik Mah",
      "Erdoğan Akdağ Mah",
      "Eskipazar Mah",
      "Fatih Mah",
      "İstanbulluoğlu Mah",
      "Karatepe Mah",
      "Köseoğlu Mah",
      "Medrese Mah",
      "Mehmet Hulusi Efendi Mah",
      "Mutafoğlu Mah",
      "Şeyhosman Mah",
      "Taşköprü Mah",
      "Tekke Mah",
      "Tuzkaya Mah",
      "Yenicami Mah",
      "Yukarıçatak Mah",
      "Yukarınohutlu Mah"
    ],
    "Saraykent": [
      "Balkaya Mah (dedefakılı Beldesi)",
      "Dedefakılı Merkez Mah (dedefakılı Beldesi)",
      "Altınsu Köyü",
      "Başpınar Köyü",
      "Benli Köyü",
      "Beşkavak Köyü",
      "Çiçeklihüyüğü Köyü",
      "İzibüyük Köyü",
      "Kamberli Köyü",
      "Karapınar Köyü",
      "Kesikköprü Köyü",
      "Kösealili Köyü",
      "Merkez Mah (çiçekli Köyü)",
      "Parmaksız Köyü",
      "Sarayözü Köyü",
      "Söğütlü Köyü",
      "Cumhuriyet Mah (ozan Beldesi)",
      "Merkez Mah (ozan Beldesi)",
      "Büyük Camii Mah",
      "Divanlı Mah",
      "Fatih Sultan Mehmet Mah",
      "Güldibi Mah",
      "Karşıyaka Mah",
      "M.fevzi Çakmak Mah",
      "Saray Mah",
      "Yeni Mah"
    ],
    "Sarıkaya": [
      "Çıkrıkçı Mah (karayakup Beldesi)",
      "Karayakup Mah (karayakup Beldesi)",
      "Terzili Mah (karayakup Beldesi)",
      "Akbenli Köyü",
      "Akbucak Köyü",
      "Akçadam Köyü",
      "Alembey Köyü",
      "Alifakılı Köyü",
      "Arpalık Köyü",
      "Azapbaşılı Köyü",
      "Bağlarbaşı Mah (babayağmur Köyü)",
      "Bağlıca Köyü",
      "Bahçelievler Mah (babayağmur Köyü)",
      "Baraklı Köyü",
      "Bebekköy Köyü",
      "Boyalık Köyü",
      "Burunkışla Köyü",
      "Büyükçalağıl Köyü",
      "Çatak Köyü",
      "Çokumeşme Köyü",
      "Deredoğan Köyü",
      "Derekaplancı Köyü",
      "Doğansaray Köyü",
      "Emirbey Köyü",
      "Erbek Köyü",
      "Fatih Mah (yukarısarıkaya Köyü)",
      "Gülpınar Köyü",
      "Gündüzlü Köyü",
      "Hasbek Köyü",
      "Hisarbey Köyü",
      "Ilısu Köyü",
      "İnevi Köyü",
      "İnkışla Celalhüyüğü Köyü",
      "Kadıgüllü Köyü",
      "Kadılı Köyü",
      "Karabacak Köyü",
      "Karacalar Köyü",
      "Karaelli Köyü",
      "Karahallı Köyü",
      "Kargalık Köyü",
      "Karşıyaka Mah (babayağmur Köyü)",
      "Kemallı Köyü",
      "Kerpiçcik Köyü",
      "Koçak Köyü",
      "Koçcağız Köyü",
      "Konurlu Köyü",
      "Köprücek Mah",
      "Küçükçalağıl Köyü",
      "Kürkcü Köyü",
      "Mescitli Köyü",
      "Pınarkaya Köyü",
      "Ramadanlı Köyü",
      "Selimli Köyü",
      "Söylemez Köyü",
      "Tepedoğan Köyü",
      "Tomarcahüyüğü Köyü",
      "Topaktaş Köyü",
      "Toprakpınar Köyü",
      "Turgut Özal Mah (yukarısarıkaya Köyü)",
      "Ürkütlü Köyü",
      "Yahyalı Köyü",
      "Yaylagül Köyü",
      "Yazıkaplancı Köyü",
      "Yeni Mah (babayağmur Köyü)",
      "Bahçelievler Mah",
      "Battalgazi Mah",
      "Beyazıt Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Kaplıca Mah",
      "Karşıyaka Mah",
      "Kayapınar Mah",
      "Kazım Karabekir Mah",
      "Osman Gazi Mah",
      "Şekerpınar Mah",
      "Yenidoğan Mah"
    ],
    "Sorgun": [
      "Güzel Yurt Mah (araplı Beldesi)",
      "Merkez Mah (araplı Beldesi)",
      "Yaycılar Mah (araplı Beldesi)",
      "Aydınlar Mah (bahadın Beldesi)",
      "Gümüşkavak Mah (bahadın Beldesi)",
      "Hürriyet Mah (bahadın Beldesi)",
      "Mülazım Mah (bahadın Beldesi)",
      "Salur Mah (bahadın Beldesi)",
      "Sorgun Tatlısı Mah (bahadın Beldesi)",
      "Sungur Mah (bahadın Beldesi)",
      "Burunören Mah (çiğdemli Beldesi)",
      "Camiikebir Mah (çiğdemli Beldesi)",
      "Duralidayılı Mah (çiğdemli Beldesi)",
      "Gülveren Mah (çiğdemli Beldesi)",
      "İsmailhacılı Mah (çiğdemli Beldesi)",
      "Kale Mah (çiğdemli Beldesi)",
      "Karşıyaka Mah (çiğdemli Beldesi)",
      "Aksaray Mah (doğankent Beldesi)",
      "Çavuşlu Mah (doğankent Beldesi)",
      "Kayabaşı Mah (doğankent Beldesi)",
      "Mahmatlı Mah (doğankent Beldesi)",
      "Yeni Mah (doğankent Beldesi)",
      "Akocak Mah (eymir Beldesi)",
      "Çarşıbaşı Mah (eymir Beldesi)",
      "Çay Mah (eymir Beldesi)",
      "Karşıyaka Mah (eymir Beldesi)",
      "Kayakışla Mah (eymir Beldesi)",
      "Musu Baba Mah (eymir Beldesi)",
      "Çötelli Mah (gülşehri Beldesi)",
      "Faraşlı Mah (gülşehri Beldesi)",
      "Hoşumlu Mah (gülşehri Beldesi)",
      "Keser Mah (gülşehri Beldesi)",
      "Ağcın Köyü",
      "Akoluk Köyü",
      "Alcı Köyü",
      "Alişar Köyü",
      "Aşağıcumafakılı Köyü",
      "Aşağıemirler Köyü",
      "Aşağıkarahacılı Köyü",
      "Aşağıkarakaya Köyü",
      "Ayrıdam Köyü",
      "Ayrıdam Yozgat Yolu Mevki Mah (ayrıdam Köyü)",
      "Babalı Köyü",
      "Bağlarbaşı Köyü",
      "Boğazcumafakılı Köyü",
      "Büyükeynelli Köyü",
      "Büyükkışla Köyü",
      "Büyükören Köyü",
      "Büyüktaşlık Köyü",
      "Caferli Köyü",
      "Cihanşarlı Köyü",
      "Çakırhacılı Köyü",
      "Çamurlu Köyü",
      "Çavuşköyü Köyü",
      "Çayözü Köyü",
      "Dişli Köyü",
      "Doğanlı Köyü",
      "Emirhan Köyü",
      "Emirler Köyü",
      "Erkekli Köyü",
      "Garipler Köyü",
      "Gevrek Köyü",
      "Gökiniş Köyü",
      "Gököz Köyü",
      "Gözbaba Köyü",
      "Güngören Köyü",
      "Günpınar Köyü",
      "Günyazı Köyü",
      "Halilfakılı Köyü",
      "İdrisli Köyü",
      "İkikara Köyü",
      "İncesu Köyü",
      "İsafakılı Köyü",
      "Kapaklı Köyü",
      "Karabalı Köyü",
      "Karaburun Köyü",
      "Karakocaoğlu Köyü",
      "Karalık Köyü",
      "Karaveli Köyü",
      "Karlık Ayvalık Köyü",
      "Kepirce Köyü",
      "Kodallı Köyü",
      "Kodallıçiftliği Köyü",
      "Küçükeynelli Köyü",
      "Küçükköhne Köyü",
      "Küçüktaşlık Köyü",
      "Külhüyük Köyü",
      "Mansuroğlu Köyü",
      "Mehmetbeyli Köyü",
      "Merkez Mah (belencumafakılı Köyü)",
      "Merkez Mah (gedikhasanlı Köyü)",
      "Mirahor Köyü",
      "Muğallı Köyü",
      "Ocaklı Köyü",
      "Osmaniye Köyü",
      "Peyniryemez Köyü",
      "Sarıhacılı Köyü",
      "Sarıhamzalı Köyü",
      "Sivri Köyü",
      "Şahmuratlı Köyü",
      "Taşpınar Köyü",
      "Temrezli Köyü",
      "Tiftik Köyü",
      "Tulum Köyü",
      "Tuzlacık Köyü",
      "Veliöldük Köyü",
      "Yazılıtaş Köyü",
      "Agahefendi Mah",
      "Ahmetefendi Mah",
      "Aydınlıkevler Mah",
      "Bahçelievler Mah",
      "Bedirbaba Mah",
      "Çay Mah",
      "Güzelyurt Mah",
      "Hanbaşı Mah",
      "Karşıyaka Mah",
      "Mükremin Mah",
      "Osmançavuş Mah",
      "Yazlak Mah",
      "Yeni Mah",
      "Yenidoğan Mah",
      "Yeşilöz Mah",
      "Ahmetfakılı Mah (yeniyer Beldesi)",
      "Karakız Mah (yeniyer Beldesi)"
    ],
    "Şefaatli": [
      "Akcami Köyü",
      "Akçakoyunlu Köyü",
      "Alifakılı Köyü",
      "Altındağ Mah (sarıkent Köyü)",
      "Arife Köyü",
      "Armağan Köyü",
      "Bahçelievler Mah (paşaköy Köyü)",
      "Başköy Köyü",
      "Caferli Köyü",
      "Cankılı Köyü",
      "Cıcıklar Köyü",
      "Cumhuriyet Mah (sarıkent Köyü)",
      "Çaydoğan Köyü",
      "Dedeli Köyü",
      "Ekinciuşağı Köyü",
      "Gözelli Köyü",
      "Gülistan Köyü",
      "Gülpınar Köyü",
      "Halaçlı Köyü",
      "Hamzalı Köyü",
      "Hasanpaşa Mah (paşaköy Köyü)",
      "Hüyükkışla Köyü",
      "İbrahimhacılı Köyü",
      "İstasyon Mah (sarıkent Köyü)",
      "Kabacaoğlu Köyü",
      "Kabakini Köyü",
      "Karakaya Köyü",
      "Karalar Mah",
      "Kaykılı Köyü",
      "Kazlıuşağı Köyü",
      "Kızılkoca Köyü",
      "Kızılyar Köyü",
      "Koçköy Köyü",
      "Konaklı Mah",
      "Kumkuyu Köyü",
      "Küçükincirli Köyü",
      "Osmanlı Köyü",
      "Rızvan Köyü",
      "Saatli Köyü",
      "Saçlı Köyü",
      "Seydiyar Köyü",
      "Şerefoğlu Köyü",
      "Tahiroğlu Köyü",
      "Temlik Köyü",
      "Türüdüler Köyü",
      "Yenicami Mah (paşaköy Köyü)",
      "Bağlarbaşı Mah",
      "Bahçelievler Mah",
      "Bahçelievler Mah (kuzayca Köyü)",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (kuzayca Köyü)",
      "Fatih Mah",
      "H.bayram Karabulut Mah",
      "İnceşehir Mah",
      "Kale Mah",
      "Savaştepe Mah (kuzayca Köyü)",
      "Yaylapınar Mah",
      "Yeni Mah"
    ],
    "Yenifakılı": [
      "Başağa Mah (bektaşlı Köyü)",
      "Başpınar Köyü",
      "Camikebir Mah (bektaşlı Köyü)",
      "Çöplüçiftliği Köyü",
      "Eskiören Köyü",
      "Fehimli Köyü",
      "Üçobalar Köyü",
      "Yenicamii Mah (bektaşlı Köyü)",
      "Yiğitler Köyü",
      "Zafer Mah (bektaşlı Köyü)",
      "Altındağ Mah",
      "Cankurtaran Mah",
      "Mehmet Akif Ersoy Mah",
      "Yazlak Mah",
      "Yeni Mah"
    ],
    "Yerköy": [
      "Abdallar Mah (delice Köyü)",
      "Akpınar Köyü",
      "Arifeoğlu Köyü",
      "Arslanhacılı Köyü",
      "Aşağıeğerci Köyü",
      "Aşağıelmahacılı Köyü",
      "Aydıngün Köyü",
      "Belkavak Köyü",
      "Beserek Köyü",
      "Bicikler Köyü",
      "Buruncuk Köyü",
      "Cakcak Köyü",
      "Cumhuriyet Mah (saray Köyü)",
      "Çakırhacılı Köyü",
      "Çakırlar Köyü",
      "Çalıklı Köyü",
      "Çamdibi Köyü",
      "Çamlıbel Köyü",
      "Çayköy Köyü",
      "Delice Köyü",
      "Derebağı Köyü",
      "Derecik Köyü",
      "Durak Mah (cakcak Köyü)",
      "Fatih Mah (saray Köyü)",
      "Göçerli Köyü",
      "Gündoğdu Köyü",
      "Hacıçeşmesi Köyü",
      "Hacılı Köyü",
      "Hacımusalı Köyü",
      "Hacıosmanlı Köyü",
      "Hacıuşağı Köyü",
      "Hargaşan Köyü",
      "Hatip Köyü",
      "İğdecik Köyü",
      "Kahyaköy Köyü",
      "Karacaağaç Köyü",
      "Karacaahmetli Köyü",
      "Karaosmanoğlu Köyü",
      "Karlı Köyü",
      "Kayadibi Köyü",
      "Kızıl Gedik Fabrika Sahası Mah (akpınar Köyü)",
      "Kocaoğlu Köyü",
      "Kömüşören Köyü",
      "Kördeve Köyü",
      "Köycü Köyü",
      "Kumluca Köyü",
      "Küçükçalıklı Köyü",
      "Küçüknefes Köyü",
      "Organize Sanayi Bölgesi Mah (saray Köyü)",
      "Orhan Köyü",
      "Poyraz Köyü",
      "Sağlık Mah (sekili Köyü)",
      "Salihli Köyü",
      "Sarıyaprak Köyü",
      "Sedir Köyü",
      "Susuz Köyü",
      "Süleymanlı Köyü",
      "Terzili Köyü",
      "Topaç Köyü",
      "Varlık Mah (sekili Köyü)",
      "Yakuplu Köyü",
      "Yaylaevleri Mah (arslanhacılı Köyü)",
      "Yerköy Köyü",
      "Yukarıeğerci Köyü",
      "Yukarıelmahacılı Köyü",
      "Yukarıihsangazili Köyü",
      "Zencir Köyü",
      "100.yıl Mah",
      "Ali Galip Gençoğlu Mah",
      "Altmış Evler Mah",
      "Ayanoğlu Mah",
      "Bağlarbaşı Mah",
      "Erzurum Mah",
      "Gültepe Mah",
      "Haşim Kılıç Mah",
      "Hüyük Mah",
      "Kale Mah",
      "Karacaşar Mah",
      "Selçuk Mah",
      "Şentepe Mah",
      "Vefi Pandır Mah"
    ]
  },
  "Zonguldak": {
    "Alaplı": [
      "Merkez Mah",
      "Tepeköy Mah",
      "Yeni Siteler Mah",
      "Yenimahalle Mah",
      "Erenköy Mah (gümeli Beldesi)",
      "Fındıklı Ağılı Mah (gümeli Beldesi)",
      "Kale Mah (gümeli Beldesi)",
      "Merkez Mah (gümeli Beldesi)",
      "Abacılar Mah (çamcılar Köyü)",
      "Ahiler Mah (alioğlu Köyü)",
      "Alaplıbölücek Köyü",
      "Aşağıdağ Mah (aşağıdağ Köyü)",
      "Aşağıdoğancılar Mah (aşağıdoğancılar Köyü)",
      "Aşağıtekke Köyü",
      "Aydınlı Mah (alioğlu Köyü)",
      "Büyükilyaslı Mah (yenidoğanlar Köyü)",
      "Büyüktekke Köyü",
      "Cinler Mah (bektaşlı Köyü)",
      "Çamcılar Köyü",
      "Çamcılar Mah (çamcılar Köyü)",
      "Çamlık Mah (küçüktekke Köyü)",
      "Çanakçı Mah (aşağıdağ Köyü)",
      "Çandırlı Mah (osmanlı Köyü)",
      "Çobanlar Mah (gürpınar Köyü)",
      "Çöngelli Mah (kasımlı Köyü)",
      "Davutlar Mah (kasımlı Köyü)",
      "Değirmendere Mah (belen Köyü)",
      "Demirciler Köyü",
      "Dereli Mah (kabalar Köyü)",
      "Doğancılar Köyü",
      "Doruklu Mah (alioğlu Köyü)",
      "Dorukoğlu Mah (çamcılar Köyü)",
      "Dumanlar Mah (alaplıömerli Köyü)",
      "Durabeyli Mah (isafakılı Köyü)",
      "Durular Mah (musabeyli Köyü)",
      "Dürgelli Mah (ahiler Köyü)",
      "Esentepe Mah (kürkükler Köyü)",
      "Eteklioğlu Mah (çatak Köyü)",
      "Geçmiş Altı Mah (aydınyayla Köyü)",
      "Gökçeler Mah (alaplıömerli Köyü)",
      "Güncüoğlu Mah (çamcılar Köyü)",
      "Güney Mah (hacıhasan Köyü)",
      "Hacıhasan Mah (yeşilyurt Köyü)",
      "Hacılar Mah (kürkükler Köyü)",
      "Hallı Köyü",
      "Harman Mah (kılçak Köyü)",
      "Haydarlar Mah (çiçekli Köyü)",
      "Hıdırlar Mah (alioğlu Köyü)",
      "Hıdırlar Mah (aşağıdağ Köyü)",
      "Huzurkent Mah (kılçak Köyü)",
      "Hüseyinli Köyü",
      "İkisu Mah (fındıklı Köyü)",
      "İmzeli Mah (kasımlı Köyü)",
      "İncivezaltı Mah (küçüktekke Köyü)",
      "Kadıoğlu Mah (alaplıkocaali Köyü)",
      "Karabakal Mah (sabırlı Köyü)",
      "Karadoruk Mah (aydınyayla Köyü)",
      "Karşıyaka Mah",
      "Karşıyaka Mah (belen Köyü)",
      "Kasırgalı Mah (bektaşlı Köyü)",
      "Katırcıoğlu Mah (alioğlu Köyü)",
      "Kavakbelen Mah (hacıhasan Köyü)",
      "Kavukkavla Mah (kıran Köyü)",
      "Kılçak Mah (kılçak Köyü)",
      "Kocaman Köyü",
      "Kufallar Mah (alioğlu Köyü)",
      "Kurtlar Mah (kürkükler Köyü)",
      "Küçükilyaslı Mah (yenidoğanlar Köyü)",
      "Leller Mah (kabalar Köyü)",
      "Makas Mah (aşağıdağ Köyü)",
      "Marmar Mah (musabeyli Köyü)",
      "Merkez Değirmenciler Mah (alioğlu Köyü)",
      "Merkez Mah (ahatlı Köyü)",
      "Merkez Mah (ahiler Köyü)",
      "Merkez Mah (alaplıkocaali Köyü)",
      "Merkez Mah (alaplıortacı Köyü)",
      "Merkez Mah (aşağıdoğancılar Köyü)",
      "Merkez Mah (aydınyayla Köyü)",
      "Merkez Mah (bektaşlı Köyü)",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (canbazlı Köyü)",
      "Merkez Mah (çamlıbel Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çayköy Köyü)",
      "Merkez Mah (çengelli Köyü)",
      "Merkez Mah (çiçekli Köyü)",
      "Merkez Mah (durhanlı Köyü)",
      "Merkez Mah (fındıklı Köyü)",
      "Merkez Mah (gökhasan Köyü)",
      "Merkez Mah (gürpınar Köyü)",
      "Merkez Mah (hasanlı Köyü)",
      "Merkez Mah (isafakılı Köyü)",
      "Merkez Mah (kabalar Köyü)",
      "Merkez Mah (kasımlı Köyü)",
      "Merkez Mah (kılçak Köyü)",
      "Merkez Mah (kıran Köyü)",
      "Merkez Mah (küçükkaymaz Köyü)",
      "Merkez Mah (küçüktekke Köyü)",
      "Merkez Mah (kürkükler Köyü)",
      "Merkez Mah (musabeyli Köyü)",
      "Merkez Mah (okçular Köyü)",
      "Merkez Mah (osmanlı Köyü)",
      "Merkez Mah (sabırlı Köyü)",
      "Merkez Mah (yenidoğanlar Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Mollabey Köyü",
      "Muratlı Mah (çatak Köyü)",
      "Nusratlı Mah (hasanlı Köyü)",
      "Okuf Mah (kürkükler Köyü)",
      "Onurlu Köyü",
      "Ölüce Mah (kasımlı Köyü)",
      "Pazaryeri Mah (alaplıkocaali Köyü)",
      "Pazaryeri Mah (aşağıdağ Köyü)",
      "Pircioğlu Mah (alioğlu Köyü)",
      "Sarıkadı Köyü",
      "Seferoğlu Mah (küçükkaymaz Köyü)",
      "Sıhlar Mah (alioğlu Köyü)",
      "Sinanlı Mah (alioğlu Köyü)",
      "Sindelli Mah (çengelli Köyü)",
      "Sofullu Köyü",
      "Sucallı Mah (sabırlı Köyü)",
      "Şahbaz Mah (hacıhasan Köyü)",
      "Şahlar Mah (canbazlı Köyü)",
      "Tekke Mah (aşağıdoğancılar Köyü)",
      "Terzioğlu Mah (alaplıkocaali Köyü)",
      "Toşmanlı Mah (alaplıortacı Köyü)",
      "Toşmanlı Mah (durhanlı Köyü)",
      "Ulaşlı Mah (osmanlı Köyü)",
      "Varahlı Mah (kasımlı Köyü)",
      "Yağışlı Mah (ahiler Köyü)",
      "Yazıllı Mah (kürkükler Köyü)",
      "Yazlık Mah (okçular Köyü)",
      "Yedigelli Köyü",
      "Yeniköy Köyü",
      "Yukarı Değirmenciler Mah (alioğlu Köyü)",
      "Yukarıdağ Mah (aşağıdağ Köyü)",
      "Yusufköy Mah (okçular Köyü)"
    ],
    "Çaycuma": [
      "Çay Mah",
      "Gemiciler Mah",
      "İstasyon Mah",
      "Karalar Mah",
      "Pehlivanlar Mah",
      "Sofular Mah",
      "Velioğlu Mah",
      "Velioğluosb Mah",
      "Yeni Mah",
      "Yeşiltepe Mah",
      "Abacık Mah (filyos Beldesi)",
      "Akpınar Köyü",
      "Çayköy Köyü",
      "Derecikören Mah (derecikören Köyü)",
      "Esenyurt Köyü",
      "Geriş Mah (filyos Beldesi)",
      "Gökçeler Köyü",
      "Hisarönü Mah (filyos Beldesi)",
      "Kocaali Mah (filyos Beldesi)",
      "Merkez Mah (yukarıgöynük Köyü)",
      "Orta Mah (çömlekçi Köyü)",
      "Öteyüz Mah (çömlekçi Köyü)",
      "Öteyüz Mah (filyos Beldesi)",
      "Peyenli Mah (yukarıgöynük Köyü)",
      "Salmanlar Mah (yukarıgöynük Köyü)",
      "Sefercik Mah (filyos Beldesi)",
      "Temenler Köyü",
      "Yukarı Mah (çömlekçi Köyü)",
      "Aşağı Çukur Mah (karapınar Beldesi)",
      "Durmuşlar Mah (karapınar Beldesi)",
      "Merkez Mah (karapınar Beldesi)",
      "Tilkiler Mah (karapınar Beldesi)",
      "Torlaklar Mah (karapınar Beldesi)",
      "Yukarı Çukur Mah (karapınar Beldesi)",
      "Akçaköy Mah (güzelyurt Köyü)",
      "Arıcıoğlu Mah (kayıkçılar Köyü)",
      "Aşağı Mah (erenköy Köyü)",
      "Aşağı Mah (yukarıdere Köyü)",
      "Aşağıtaşçılı Mah (taşçılı Köyü)",
      "Ayıcıoğlu Mah (çayır Köyü)",
      "Ayılar Mah (torlaklar Köyü)",
      "Bahçeodası Mah (akyamaç Köyü)",
      "Baklacıoğlu Mah (muhsinler Köyü)",
      "Başkancı Mah (çayır Köyü)",
      "Başörenler Mah (yolgeçen Köyü)",
      "Bostancılar Mah (yukarıdere Köyü)",
      "Budaklar Mah (güzelyurt Köyü)",
      "Bürümcek Mah (dağüstü Köyü)",
      "Cina Mah (kayıkçılar Köyü)",
      "Çakıllar Mah (muhsinler Köyü)",
      "Çakmakçıoğlu Mah (muhsinler Köyü)",
      "Çay Mah (esenlik Köyü)",
      "Çay Mah (geriş Köyü)",
      "Çay Mah (kayabaşı Köyü)",
      "Çay Mah (şeyhoğlu Köyü)",
      "Çelenler Mah (akyamaç Köyü)",
      "Çitmeciler Mah (kadıoğlu Köyü)",
      "Çobanhasanlar Mah (kadıoğlu Köyü)",
      "Çomranlı Köyü",
      "Danabaşlar Mah (dereköseler Köyü)",
      "Demirciler Mah (güzelyurt Köyü)",
      "Dereli Köyü",
      "Dombaycıoğlu Mah (aliköy Köyü)",
      "Durduoğlu Mah (geriş Köyü)",
      "Düz Mah (dağüstü Köyü)",
      "Elbisi Mah (güzelyurt Köyü)",
      "Ellezli Mah (ahatlı Köyü)",
      "Esentepe Köyü",
      "Eymür Mah (güdüllü Köyü)",
      "Gebeşler Mah (güzelyaka Köyü)",
      "Gebeşler Mah (şeyhoğlu Köyü)",
      "Gemeçler Mah (ahatlı Köyü)",
      "Göçler Mah (çayır Köyü)",
      "Gülşenler Mah (yolgeçen Köyü)",
      "Güneller Mah (torlaklar Köyü)",
      "Günyüzü Mah (kayabaşı Köyü)",
      "Hacı Mah (kayıkçılar Köyü)",
      "Halaşlı Mah (kayabaşı Köyü)",
      "Hatıplar Mah (torlaklar Köyü)",
      "Hatipler Mah (dağüstü Köyü)",
      "Hatipoğlu Mah (aliköy Köyü)",
      "Horcinaz Mah (dağüstü Köyü)",
      "İmamlar Mah (aliköy Köyü)",
      "İmamlar Mah (kışla Köyü)",
      "Kabakçılar Mah (akyamaç Köyü)",
      "Kadılar Mah (dereköseler Köyü)",
      "Kalaycıoğlu Köyü",
      "Kalembaşı Mah (uluköy Köyü)",
      "Kamberoğlu Mah (muhsinler Köyü)",
      "Kamiloğlu Mah (muhsinler Köyü)",
      "Kanoğlu Mah (dereköseler Köyü)",
      "Karagözler Mah (yakademirciler Köyü)",
      "Karamusa Mah",
      "Karşı Mah (uluköy Köyü)",
      "Katırcılar Mah (akyamaç Köyü)",
      "Katırcılar Mah (kayıkçılar Köyü)",
      "Kavarıcılar Mah (sipahiler Köyü)",
      "Kayım Mah (kalafatlı Köyü)",
      "Kıran Mah (uluköy Köyü)",
      "Kırklar Mah (kışla Köyü)",
      "Kocamehmetoğlu Mah (dereköseler Köyü)",
      "Köse Mah (dereköseler Köyü)",
      "Mansurkadıoğlu Mah (kayıkçılar Köyü)",
      "Merkez Mah (ahatlı Köyü)",
      "Merkez Mah (aliköy Köyü)",
      "Merkez Mah (ayvazlar Köyü)",
      "Merkez Mah (burunkaya Köyü)",
      "Merkez Mah (çayır Köyü)",
      "Merkez Mah (esenlik Köyü)",
      "Merkez Mah (güdüllü Köyü)",
      "Merkez Mah (kadıoğlu Köyü)",
      "Merkez Mah (kalafatlı Köyü)",
      "Merkez Mah (karamusa Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kışla Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Merkez Mah (şeyhoğlu Köyü)",
      "Merkez Mah (yolgeçen Köyü)",
      "Miyesseler Mah (veliköy Köyü)",
      "Muslubey Mah (sipahiler Köyü)",
      "Odabaşoğlu Mah (güzelyaka Köyü)",
      "Orta Mah (geriş Köyü)",
      "Orta Mah (uluköy Köyü)",
      "Orta Mah (yukarıdere Köyü)",
      "Oruçlar Mah (güzelyaka Köyü)",
      "Oruçoğlu Mah (dereköseler Köyü)",
      "Öceboğlu Mah (muhsinler Köyü)",
      "Pirahmet Mah (ayvazlar Köyü)",
      "Recepoğlu Mah (geriş Köyü)",
      "Sakallıoğlu Mah (dereköseler Köyü)",
      "Salihler Mah (yakademirciler Köyü)",
      "Salihoğlu Mah (geriş Köyü)",
      "Sivriovaz Mah (muhsinler Köyü)",
      "Sünnetçioğlu Mah (yakademirciler Köyü)",
      "Şabanoğlu Mah (geriş Köyü)",
      "Şahnalar Mah (veliköy Köyü)",
      "Tabaklar Mah (muhsinler Köyü)",
      "Yanıklar Mah (kalaycıoğlu Köyü)",
      "Yeni  Mah (ayvazlar Köyü)",
      "Yeni Mah (akyamaç Köyü)",
      "Yeni Mah (ayvazlar Köyü)",
      "Yeşilyurt Köyü",
      "Yukarı Mah (erenköy Köyü)",
      "Yukarı Mah (güdüllü Köyü)",
      "Yukarı Mah (yukarıdere Köyü)",
      "Yukarıtaşcılı Mah (taşçılı Köyü)",
      "Yusufhanlı Mah (taşçılı Köyü)",
      "Zobalaklar Mah (güzelyaka Köyü)",
      "Karaevligeriş Mah (nebioğlu Beldesi)",
      "Terziler Mah (nebioğlu Beldesi)",
      "Yeni Pazar Mah (nebioğlu Beldesi)",
      "Yeşilyurt Mah (nebioğlu Beldesi)",
      "Ağalar Mah (madenler Köyü)",
      "Ahmet Beyoğlu Mah (şehler Köyü)",
      "Ahmetbaşaoğlu Mah (helvacılar Köyü)",
      "Ahmetoğlu Mah (madenler Köyü)",
      "Akçalar Mah (hacıosmanlar Köyü)",
      "Alagözler Mah (şehler Köyü)",
      "Andıoğlu Mah (kerimler Köyü)",
      "Arıkoğlu Mah (emirşah Köyü)",
      "Aşağıkıyı Mah (helvacılar Köyü)",
      "Baloğlu Mah (hacıibadi Köyü)",
      "Bıçakcıoğlu Mah (adaköy Köyü)",
      "Boyacıoğlu Mah (kerimler Köyü)",
      "Camili Mah (akçahatipler Köyü)",
      "Cıvaklar Mah (koramanlar Köyü)",
      "Çiller Mah (kızılbel Köyü)",
      "Çubukçu Mah (hacıibadi Köyü)",
      "Çürükçüoğlu Mah (dursunlar Köyü)",
      "Değirmen Yanı Mah (koramanlar Köyü)",
      "Demirciler Mah (yazıbaşı Köyü)",
      "Dervişoğlu Mah (karaahmetler Köyü)",
      "Ebeşler Mah (sandallar Köyü)",
      "Emirler Mah (emirşah Köyü)",
      "Emiroğlu Mah (madenler Köyü)",
      "Epçeloğlu Mah (basat Köyü)",
      "Eserler Mah (emirşah Köyü)",
      "Hacı Kadı Mah (perşembe Beldesi)",
      "Hacı Muharremoğlu Mah (şehler Köyü)",
      "Hamdiloğlu Mah (hacıibadi Köyü)",
      "Hamzaoğlu Mah (şenköy Köyü)",
      "Hasanbeyler Mah (helvacılar Köyü)",
      "Hatipler Mah (dursunlar Köyü)",
      "Helvacılar Mah (musausta Köyü)",
      "Hotoğlu Mah (emirşah Köyü)",
      "İbadioğlu Mah (adaköy Köyü)",
      "İmamoğlu Mah (basat Köyü)",
      "İnceahmetler Mah (şenköy Köyü)",
      "Kadıeli Mah (basat Köyü)",
      "Kadıeli Mah (kızılbel Köyü)",
      "Kadıoğlu Mah (dursunlar Köyü)",
      "Kadir Efendioğlu Mah (sandallar Köyü)",
      "Kaptanlar Mah (hacıibadi Köyü)",
      "Karacaoğlu Mah (basat Köyü)",
      "Katırcıoğlu Mah (şenköy Köyü)",
      "Keçecioğlu Mah (perşembe Beldesi)",
      "Keçecioğluosb Mah (perşembe Beldesi)",
      "Kekeş Mah (hacıosmanlar Köyü)",
      "Kılçallar Mah (koramanlar Köyü)",
      "Kocabasat Mah (basat Köyü)",
      "Kocamanlar Mah (yazıbaşı Köyü)",
      "Kozlar Mah (hacıibadi Köyü)",
      "Kozoğlu Mah (hacıibadi Köyü)",
      "Köloğlu Mah (karaahmetler Köyü)",
      "Kurumsalar Mah (helvacılar Köyü)",
      "Kuyumcuoğlu Mah (muharremşah Köyü)",
      "Kürtler Mah (basat Köyü)",
      "Kütükçüoğlu Mah (sandallar Köyü)",
      "Macarlar Mah (yazıbaşı Köyü)",
      "Mahmutoğlu Mah (kızılbel Köyü)",
      "Mangırlar Mah (muharremşah Köyü)",
      "Mantarcıoğlu Mah (helvacılar Köyü)",
      "Masmaslar Mah (kızılbel Köyü)",
      "Merkez Mah (adaköy Köyü)",
      "Merkez Mah (akçahatipler Köyü)",
      "Merkez Mah (hacıibadi Köyü)",
      "Merkez Mah (hacıosmanlar Köyü)",
      "Merkez Mah (kızılbel Köyü)",
      "Merkez Mah (koramanlar Köyü)",
      "Merkez Mah (madenler Köyü)",
      "Merkez Mah (muharremşah Köyü)",
      "Merkez Mah (musausta Köyü)",
      "Merkez Mah (perşembe Beldesi)",
      "Merkez Mah (şehler Köyü)",
      "Merkez Mah (yazıbaşı Köyü)",
      "Muslubaşoğlu Mah (dursunlar Köyü)",
      "Palazoğlu Mah (şenköy Köyü)",
      "Paşa Kahya Mah (musausta Köyü)",
      "Pazarlıoğlu Mah (madenler Köyü)",
      "Pirkadı Mah (şehler Köyü)",
      "Rahmetoğlu Mah (kerimler Köyü)",
      "Ramazankadı Mah (şehler Köyü)",
      "Sağırlar Mah (kızılbel Köyü)",
      "Sağıroğlu Mah (kerimler Köyü)",
      "Sakaoğlu Mah (karaahmetler Köyü)",
      "Sancıoğlu Mah (kerimler Köyü)",
      "Sarı Kadı Mah (perşembe Beldesi)",
      "Sarıözler Mah (helvacılar Köyü)",
      "Seferler Mah (kızılbel Köyü)",
      "Severler Mah (muharremşah Köyü)",
      "Sinanlar Mah (helvacılar Köyü)",
      "Şabanoğlu Mah (helvacılar Köyü)",
      "Şehler Mah (koramanlar Köyü)",
      "Tabaklar Mah (basat Köyü)",
      "Teceller - Bacaklar Mah (koramanlar Köyü)",
      "Ünsallar Mah (helvacılar Köyü)",
      "Yahyabaşıoğlu Mah (sandallar Köyü)",
      "Yanıklar Mah (dursunlar Köyü)",
      "Yazıköy Köyü",
      "Yeni Mah (basat Köyü)",
      "Yörübaş Mah (muharremşah Köyü)",
      "Acarlar Mah (hacılar Köyü)",
      "Ahmetler Mah (aşağısarmaşık Köyü)",
      "Alibeyoğlu Mah (coburlar Köyü)",
      "Arapoğlu Mah (hacılar Köyü)",
      "Aşağı Mah (hacılar Köyü)",
      "Bedekler Mah (sarmaşık Köyü)",
      "Bıçakçıoğlu Mah (ihsanoğlu Köyü)",
      "Boduklar Mah (ramazanoğlu Köyü)",
      "Bostancıoğlu Mah (ihsanoğlu Köyü)",
      "Çamlık Köyü",
      "Çavuşlar Mah (kahvecioğlu Köyü)",
      "Çorak Köyü",
      "Çökelezler Mah (güzeloğlu Köyü)",
      "Demircioğlu Mah (ihsanoğlu Köyü)",
      "Durcanlar Mah (hacılar Köyü)",
      "Düz Mah (saltukova Beldesi)",
      "Engel Mah (coburlar Köyü)",
      "Eysanlar Mah (ihsanoğlu Köyü)",
      "Fındık Eneti Mah (aşağıihsaniye Köyü)",
      "Gebelli Mah (başaran Köyü)",
      "Geriş Mah (ihsanoğlu Köyü)",
      "Hacı Karısı Mah (güzeloğlu Köyü)",
      "Hacı Kıramanlar Mah (ihsanoğlu Köyü)",
      "Hatipoğlu Mah (güzeloğlu Köyü)",
      "Helimler Mah (gökçetabaklar Köyü)",
      "Hocaoğlu Mah (karakoç Köyü)",
      "Hüseyin Kaptanlar Mah (sarmaşık Köyü)",
      "Kalafatlar Mah (ihsanoğlu Köyü)",
      "Kara Hasan Paşa Mah (ramazanoğlu Köyü)",
      "Karboğaz Mah (saltukova Beldesi)",
      "Kartallar Mah (aşağısarmaşık Köyü)",
      "Kaşıkçılar Mah (yukarıihsaniye Köyü)",
      "Kavakpınarı Mah (coburlar Köyü)",
      "Kavukoğlu Mah (hacılar Köyü)",
      "Kışla Mah (aşağıihsaniye Köyü)",
      "Kirazoğlu Mah (kahvecioğlu Köyü)",
      "Kokaksu Mah (saltukova Beldesi)",
      "Köstebekler Mah (gökçetabaklar Köyü)",
      "Kuloğlu Mah (karakoç Köyü)",
      "Kuyu Mah (ihsanoğlu Köyü)",
      "Lazlar Mah (karakoç Köyü)",
      "Mantıklar Mah (başaran Köyü)",
      "Marangeli Mah (karakoç Köyü)",
      "Merkez Mah (aşağıihsaniye Köyü)",
      "Merkez Mah (coburlar Köyü)",
      "Merkez Mah (gökçetabaklar Köyü)",
      "Merkez Mah (ihsanoğlu Köyü)",
      "Merkez Mah (kahvecioğlu Köyü)",
      "Merkez Mah (karakoç Köyü)",
      "Merkez Mah (serdaroğlu Köyü)",
      "Merkez Mah (yukarıihsaniye Köyü)",
      "Ocakçıoğlu Mah (karakoç Köyü)",
      "Parpacıoğlu Mah (başaran Köyü)",
      "Pazar Yeri Mah (ihsanoğlu Köyü)",
      "Sarıkadıoğlu Mah (serdaroğlu Köyü)",
      "Sarıkum Mah (hacılar Köyü)",
      "Sarıkum Mah (saltukova Beldesi)",
      "Sazköy Köyü",
      "Şenköy Mah (yukarıihsaniye Köyü)",
      "Tetikler Mah (başaran Köyü)",
      "Yeni Mah (aşağısarmaşık Köyü)",
      "Yeni Mah (kahvecioğlu Köyü)",
      "Yeniköy Köyü",
      "Yeşilköy Köyü",
      "Yeşilyayla Köyü",
      "Yolcuoğlu Mah (aşağısarmaşık Köyü)",
      "Yukarı Mah (hacılar Köyü)",
      "Yukarı Mah (yukarıihsaniye Köyü)",
      "Yumuklar Mah (serdaroğlu Köyü)"
    ],
    "Devrek": [
      "Çay Mah (çaydeğirmeni Beldesi)",
      "Himmetoğlu Mah (çaydeğirmeni Beldesi)",
      "Kemerler Mah (çaydeğirmeni Beldesi)",
      "Merkez Mah (çaydeğirmeni Beldesi)",
      "Recep Tayyip Erdoğan Mah (çaydeğirmeni Beldesi)",
      "Yeni Mah (çaydeğirmeni Beldesi)",
      "Ağalar Mah",
      "Eski Mah",
      "İsmet Paşa Mah",
      "Yeni Mah",
      "Abdibaşoğlu Mah (taşkesen Köyü)",
      "Adıbeyler Mah (adatepe Köyü)",
      "Ahatoğlu Mah (taşkesen Köyü)",
      "Alagazlar Mah (kurudere Köyü)",
      "Aşağı Gedernek Mah (eveyikli Köyü)",
      "Ayaşlıoğlu Mah (yağmurca Köyü)",
      "Başaksu Mah (aksu Köyü)",
      "Bayramoğlu Mah (eveyikli Köyü)",
      "Bayramusta Mah (kozlukadı Köyü)",
      "Belen Mah (akçabey Köyü)",
      "Beyazıtoğlu Mah (kozlugüney Köyü)",
      "Çalca Mah (adatepe Köyü)",
      "Çay Mah (yazıcık Köyü)",
      "Çelelioğlu Mah (serdaroğlu Köyü)",
      "Çeribaşoğlu Mah (kurudere Köyü)",
      "Çıplaklar Mah (yağmurca Köyü)",
      "Çöpçüoğlu Mah (sipahiler Köyü)",
      "Enseküzü Mah (yazıcık Köyü)",
      "Gücükler Mah (özyurt Köyü)",
      "Güney Mah (aksu Köyü)",
      "Güneyler Mah (durupınar Köyü)",
      "Hacıoğlu Mah (aksu Köyü)",
      "Hacıoğlu Mah (kozlukadı Köyü)",
      "Hamitler Mah (durupınar Köyü)",
      "Hatlar Mah (aksu Köyü)",
      "İsmelcioğlu Mah (serdaroğlu Köyü)",
      "Kadıoğlu Mah (kozlugüney Köyü)",
      "Kadıoğlu Mah (purtuloğlu Köyü)",
      "Karacalar Mah (kurudere Köyü)",
      "Karşıyaka Mah (eğerci Köyü)",
      "Karşıyaka Mah (taşkesen Köyü)",
      "Karşıyaka Mah (yazıcık Köyü)",
      "Kayaarkası Mah (yağmurca Köyü)",
      "Kaypaklar Mah (purtuloğlu Köyü)",
      "Kenanoğlu Mah (eveyikli Köyü)",
      "Kıcımanlar Mah (yeşilada Köyü)",
      "Kınıklar Mah (durupınar Köyü)",
      "Kıyılar Mah (yeşilada Köyü)",
      "Kocalar Mah (akçabey Köyü)",
      "Koçbaşlar Mah (eveyikli Köyü)",
      "Kösekadıoğlu Mah (kurudere Köyü)",
      "Kuluzoğlu Mah (yeşilada Köyü)",
      "Memişler Mah (yeşilada Köyü)",
      "Merkez Mah (akçabey Köyü)",
      "Merkez Mah (durupınar Köyü)",
      "Merkez Mah (eğerci Köyü)",
      "Merkez Mah (kuzca Köyü)",
      "Merkez Mah (özyurt Köyü)",
      "Merkez Mah (pelitli Köyü)",
      "Merkez Mah (purtuloğlu Köyü)",
      "Merkez Mah (serdaroğlu Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Merkez Mah (taşkesen Köyü)",
      "Merkez Mah (yağmurca Köyü)",
      "Merkez Mah (yazıcık Köyü)",
      "Merkez Mah (yeşilöz Köyü)",
      "Mısırlıoğlu Mah (yağmurca Köyü)",
      "Nadiroğlu Mah (purtuloğlu Köyü)",
      "Oğmanlar Mah (sipahiler Köyü)",
      "Orman İşletmesi Mah (yazıcık Köyü)",
      "Pelitveren Mah (yazıcık Köyü)",
      "Pürcüoğlu Mah (serdaroğlu Köyü)",
      "Pürköyü Mah (kurudere Köyü)",
      "Rahmanoğlu Mah (pelitli Köyü)",
      "Safallar Mah (yazıcık Köyü)",
      "Şıhlar Mah (aksu Köyü)",
      "Tırkızlar Mah (durupınar Köyü)",
      "Topallar Mah (yazıcık Köyü)",
      "Topaloğlu Mah (pelitli Köyü)",
      "Topçuoğlu Mah (adatepe Köyü)",
      "Yaplar Mah (kozlukadı Köyü)",
      "Yayalar Mah (yağmurca Köyü)",
      "Yeni Mah (akçabey Köyü)",
      "Yeni Mah (kuzca Köyü)",
      "Yukarı Gedernek Mah (eveyikli Köyü)",
      "Yürükoğlu Mah (kozlukadı Köyü)",
      "Abacıoğlu Mah (karacaören Köyü)",
      "Abalıoğlu Mah (tabaklar Köyü)",
      "Adalıoğlu Mah (karabaşlı Köyü)",
      "Ağalar Mah (mahmutoğlu Köyü)",
      "Ahatoğlu Mah (bölücek Köyü)",
      "Ahmetbeyler Mah (velibeyler Köyü)",
      "Ahmetçioğlu Mah (yassıören Köyü)",
      "Ahmetler Mah (pınarönü Köyü)",
      "Ahmetoğlu Mah (akçasu Köyü)",
      "Akbaldır Mah (alparslan Köyü)",
      "Akbıyık Mah (alparslan Köyü)",
      "Akifbeyler Mah (pınarönü Köyü)",
      "Alagözler Mah (gümüşpınar Köyü)",
      "Alazlar Mah (tabaklar Köyü)",
      "Aldıbaşoğlu Mah (güzelyurt Köyü)",
      "Alibeyoğlu Mah (alparslan Köyü)",
      "Altuvaklar Mah (osmanbeyler Köyü)",
      "Arapoğlu Mah (çolakpehlivan Köyü)",
      "Arıklar Mah (sabunlar Köyü)",
      "Arslanoğlu Mah (müfettişler Köyü)",
      "Aşağı Mah (akçasu Köyü)",
      "Aşağıören Mah (mahmutoğlu Köyü)",
      "Atamanlar Mah (bükköy Köyü)",
      "Aydınlar Mah (başlarkadı Köyü)",
      "Aygün Mah (bölücek Köyü)",
      "Ayoğlu Mah (yeşilyurt Köyü)",
      "Ayvatlar Mah (sabunlar Köyü)",
      "Azizoğlu Mah (tabaklar Köyü)",
      "Bakioğlu Mah (müfettişler Köyü)",
      "Baraklar Mah (ermekoğlu Köyü)",
      "Barutcuoğlu Mah (yılanlıca Köyü)",
      "Bayraklı Mah (bükköy Köyü)",
      "Bayramoğlu Mah (hatipler Köyü)",
      "Bekçioğlu Mah (yazıcıoğlu Köyü)",
      "Bekiroğlu Mah (burhanoğlu Köyü)",
      "Bekmezcioğlu Mah (karakoçlu Köyü)",
      "Bektaşi Mah (islamköy Köyü)",
      "Belen Mah (bılık Köyü)",
      "Berberler Mah (çorak Köyü)",
      "Berberoğlu Mah (bölücek Köyü)",
      "Beşiroğlu Mah (pınarönü Köyü)",
      "Bodurlur Mah (tabaklar Köyü)",
      "Boduroğlu Mah (nizamlar Köyü)",
      "Boncukoğlu Mah (çolakpehlivan Köyü)",
      "Bozcuoğlu Mah (yeniköy Köyü)",
      "Bozoğlu Mah (tabaklar Köyü)",
      "Bozoğlu Mah (yazıcıoğlu Köyü)",
      "Böcekoğlu Mah (yeniköy Köyü)",
      "Budak Mah (gürbüzler Köyü)",
      "Candaroğulları Mah (çorak Köyü)",
      "Cebecioğlu Mah (yeşilyurt Köyü)",
      "Celler Mah (velibeyler Köyü)",
      "Cepcioğlu Mah (yılanlıcakuz Köyü)",
      "Cereller Çay Mah (bılık Köyü)",
      "Cereller Mah (bılık Köyü)",
      "Cicibaşoğlu Mah (isabeyli Köyü)",
      "Cinbiroğlu Mah (mahmutoğlu Köyü)",
      "Cinibrahimler Mah (nizamlar Köyü)",
      "Cinler Mah (çorak Köyü)",
      "Cinömeroğlu Mah (çolakpehlivan Köyü)",
      "Civaklar Mah (tabaklar Köyü)",
      "Civakoğlu Mah (bükköy Köyü)",
      "Curuklar Mah (yılanlıcakuz Köyü)",
      "Curukoğlu Mah (karakoçlu Köyü)",
      "Çakaloğlu Mah (yılanlıcakuz Köyü)",
      "Çakmaklıoğlu Mah (bölücek Köyü)",
      "Çalgamoğlu Mah (güzelyurt Köyü)",
      "Çantıoğlu Mah (oğuzhan Köyü)",
      "Çavuşoğlu Mah (isabeyli Köyü)",
      "Çay Mah (bakırcılar Köyü)",
      "Çay Mah (gürbüzler Köyü)",
      "Çay Mah (güzelyurt Köyü)",
      "Çay Mah (halilbeyoğlu Köyü)",
      "Çay Mah (komşular Köyü)",
      "Çay Mah (özpınar Köyü)",
      "Çay Mah (sofular Köyü)",
      "Çay Mah (yılanlıca Köyü)",
      "Çayırbaşı Mah (kabaca Köyü)",
      "Çekirdekçioğlu Mah (komşular Köyü)",
      "Çengere Mah (sofular Köyü)",
      "Çiftlik Mah (sofular Köyü)",
      "Çiğbasmazoğlu Mah (gürbüzler Köyü)",
      "Çilhasanoğlu Mah (çolakpehlivan Köyü)",
      "Çilleroğlu Mah (oğuzhan Köyü)",
      "Çobanpınarı Mah (karacaören Köyü)",
      "Çolak Vermiş Mah (sabunlar Köyü)",
      "Çomu Mah (gürbüzler Köyü)",
      "Çökelezler Mah (mahmutoğlu Köyü)",
      "Çubukçuoğlu Mah (yazıcıoğlu Köyü)",
      "Dalkıçoğlu Mah (komşular Köyü)",
      "Dankazlar Mah (ahmetoğlu Köyü)",
      "Davulcuoğlu Mah (yeşilyurt Köyü)",
      "Değirmenciler Mah (yılanlıca Köyü)",
      "Deliacılar Mah (dedeoğlu Köyü)",
      "Demirciler Mah (gürbüzler Köyü)",
      "Demirciler Mah (sabunlar Köyü)",
      "Dereköy Mah (kabaca Köyü)",
      "Derinler Mah (hatipler Köyü)",
      "Deveciören Mah (tellioğlu Köyü)",
      "Dibekoğlu Mah (yazıcıoğlu Köyü)",
      "Doruk Mah (türkmenoğlu Köyü)",
      "Döngeller Mah (yılanlıca Köyü)",
      "Durnaoğlu Mah (yılanlıca Köyü)",
      "Ebekaya Mah (sofular Köyü)",
      "Elikoğlu Mah (özpınar Köyü)",
      "Eminçavuşlar Mah (yılanlıcakuz Köyü)",
      "Emirler Mah (yılanlıca Köyü)",
      "Ermek Mah (ermekoğlu Köyü)",
      "Esürük Mah (başlarkadı Köyü)",
      "Eynebioğlu Mah (yeşilyurt Köyü)",
      "Eyüpler Mah (bakırcılar Köyü)",
      "Fazlıoğlu Mah (komşular Köyü)",
      "Gebedekoğlu Mah (bükköy Köyü)",
      "Gedikoğlu Mah (bakırcılar Köyü)",
      "Gedikoğlu Mah (oğuzhan Köyü)",
      "Gedikoğlu Mah (türkmenoğlu Köyü)",
      "Gemeoğlu Mah (oğuzhan Köyü)",
      "Geriş Mah (karacaören Köyü)",
      "Geriş Mah (sabunlar Köyü)",
      "Gökmenoğlu Mah (bakırcılar Köyü)",
      "Gökmenoğlu Mah (bölücek Köyü)",
      "Göktepe Mah (ahmetoğlu Köyü)",
      "Göllü Mah (bölücek Köyü)",
      "Güllüoğlu Mah (bölücek Köyü)",
      "Güney Mah (karakoçlu Köyü)",
      "Güney Mah (yeşilköy Köyü)",
      "Habiboğlu Mah (karacaören Köyü)",
      "Hacı Haliloğlu Mah (isabeyli Köyü)",
      "Hacıibrahimoğlu Mah (çorak Köyü)",
      "Hacıimamoğlu Mah (burhanoğlu Köyü)",
      "Hacılar Mah (hüseyinçavuşoğlu Köyü)",
      "Hacıoğlu Mah (seyisoğlu Köyü)",
      "Hacıoğlu Mah (yeşilyurt Köyü)",
      "Hacıömeroğlu Mah (karabaşlı Köyü)",
      "Halilefendioğlu Mah (çolakpehlivan Köyü)",
      "Hatıpoğlu Mah (karabaşlı Köyü)",
      "Hatipler Mah (tabaklar Köyü)",
      "Hatipoğlu Mah (müfettişler Köyü)",
      "Haznedaroğlu Mah (çorak Köyü)",
      "Hebiloğlu Mah (türkmenoğlu Köyü)",
      "Hıdırlar Mah (gümüşpınar Köyü)",
      "Hırabaşoğlu Mah (dedeoğlu Köyü)",
      "Hırçaoğlu Mah (mumcuoğlu Köyü)",
      "Hışırlar Mah (hışıroğlu Köyü)",
      "Hocaoğlu Mah (ataköy Köyü)",
      "Isbahlar Mah (başlarkadı Köyü)",
      "Islaklar Mah (çorak Köyü)",
      "İbişoğlu Mah (karakoçlu Köyü)",
      "İbrahimbeyler Mah (hışıroğlu Köyü)",
      "İbrahimçavuşlar Mah (velibeyler Köyü)",
      "İbrahimoğlu Mah (burhanoğlu Köyü)",
      "İmamlar Mah (karabaşlı Köyü)",
      "İnamlar Mah (pınarönü Köyü)",
      "İncebacaklar Mah (yılanlıcakuz Köyü)",
      "İnceler Mah (çorak Köyü)",
      "İncircioğlu Mah (isabeyli Köyü)",
      "İvle Mah (derebulaca Köyü)",
      "Kabaca Mah (bölücek Köyü)",
      "Kabasakallar Mah (oğuzhan Köyü)",
      "Kademler Mah (pınarönü Köyü)",
      "Kademler Mah (seyisoğlu Köyü)",
      "Kademoğlu Mah (hışıroğlu Köyü)",
      "Kadıköy Mah (başlarkadı Köyü)",
      "Kadıköyü Mah (oğuzhan Köyü)",
      "Kadılar Mah (gürbüzler Köyü)",
      "Kadımehmetoğlu Mah (nizamlar Köyü)",
      "Kadıoğlu Mah (karakoçlu Köyü)",
      "Kadıoğlu Mah (yılanlıcakuz Köyü)",
      "Kafadaroğlu Mah (yeniköy Köyü)",
      "Kafaroğlu Mah (ermekoğlu Köyü)",
      "Kahyaoğlu Mah (bölücek Köyü)",
      "Kalazoğlu Mah (çağlar Köyü)",
      "Kalıncılar Mah (halilbeyoğlu Köyü)",
      "Kamburoğlu Mah (hışıroğlu Köyü)",
      "Kanlıkaya Mah (isabeyli Köyü)",
      "Kapçıoğlu Mah (yeşilköy Köyü)",
      "Kapucuoğlu Mah (velibeyler Köyü)",
      "Kapucuoğlu Mah (yassıören Köyü)",
      "Kara Kahyaoğlu Mah (yeşilyurt Köyü)",
      "Karacaoğlu Mah (seyisoğlu Köyü)",
      "Karadere Mah (tohumlar Köyü)",
      "Karagülmezler Mah (halilbeyoğlu Köyü)",
      "Karahüseyinoğlu Mah (yılanlıca Köyü)",
      "Kargalar Mah (nizamlar Köyü)",
      "Kargaoğlu Mah (yeniköy Köyü)",
      "Karşıyaka Mah",
      "Kartoğlu Mah (bakırcılar Köyü)",
      "Kasafetoğlu Mah (yeniköy Köyü)",
      "Kavuncuoğlu Mah (özpınar Köyü)",
      "Kaymakçıoğlu Mah (burhanoğlu Köyü)",
      "Kazkondu Mah (halilbeyoğlu Köyü)",
      "Kedioğlu Mah (tellioğlu Köyü)",
      "Keklikoğlu Mah (seyisoğlu Köyü)",
      "Keleşoğlu Mah (pınarönü Köyü)",
      "Keloğlu Mah (sofular Köyü)",
      "Kevkeroğlu Mah (pınarönü Köyü)",
      "Kılıçoğlu Mah (mumcuoğlu Köyü)",
      "Kışla Mah (halilbeyoğlu Köyü)",
      "Km 18 Mah (ataköy Köyü)",
      "Kocabacaklar Mah (ahmetoğlu Köyü)",
      "Kocabaşoğlu Mah (dedeoğlu Köyü)",
      "Kocabıçaklar Mah (başlarkadı Köyü)",
      "Kocabıçaklar Mah (halilbeyoğlu Köyü)",
      "Kocadayıoğlu Mah (karabaşlı Köyü)",
      "Kocaihsanoğlu Mah (çorak Köyü)",
      "Kocaoğlu Mah (hışıroğlu Köyü)",
      "Koçak Mah (akçasu Köyü)",
      "Kodamanoğlu Mah (başlarkadı Köyü)",
      "Kolcakoğlu Mah (karabaşlı Köyü)",
      "Komşuoğlu Mah (yılanlıca Köyü)",
      "Konaklar Mah (çomaklar Köyü)",
      "Kontoroğlu Mah (bükköy Köyü)",
      "Korasanlı Mah (erenler Köyü)",
      "Kozluçay Köyü",
      "Köleoğlu Mah (karabaşlı Köyü)",
      "Köprübaşı Mah (burhanoğlu Köyü)",
      "Köprübaşı Mah (erenler Köyü)",
      "Köroğlu Mah (yassıören Köyü)",
      "Köseler Mah (karacaören Köyü)",
      "Köseler Mah (sabunlar Köyü)",
      "Köseoğlu Mah (akçasu Köyü)",
      "Köseoğlu Mah (hatipler Köyü)",
      "Köseoğlu Mah (sabunlar Köyü)",
      "Köşeler Mah (çorak Köyü)",
      "Kurdoğlu Mah (oğuzhan Köyü)",
      "Kurmalı Mah (yazıcıoğlu Köyü)",
      "Kurnalı Mah (yazıcıoğlu Köyü)",
      "Kuz Mah (çağlar Köyü)",
      "Kuzluoğlu Mah (pınarönü Köyü)",
      "Küloğlu Mah (alparslan Köyü)",
      "Lülecioğlu Mah (tabaklar Köyü)",
      "Madencioğlu Köyü",
      "Mahmutoğlu Mah (bılık Köyü)",
      "Mahmutoğlu Mah (tellioğlu Köyü)",
      "Maloğlu Mah (yılanlıcakuz Köyü)",
      "Malya Mah (tosunlar Köyü)",
      "Manavoğlu Mah (burhanoğlu Köyü)",
      "Mandıracıoğlu Mah (ermekoğlu Köyü)",
      "Mantaroğlu Mah (velibeyler Köyü)",
      "Mehallemoğlu Mah (ataköy Köyü)",
      "Mendeller Mah (sabunlar Köyü)",
      "Merdivanoğlu Mah (erenler Köyü)",
      "Merkez Mah (ahmetoğlu Köyü)",
      "Merkez Mah (akçasu Köyü)",
      "Merkez Mah (alparslan Köyü)",
      "Merkez Mah (bılık Köyü)",
      "Merkez Mah (burhanoğlu Köyü)",
      "Merkez Mah (çağlar Köyü)",
      "Merkez Mah (dedeoğlu Köyü)",
      "Merkez Mah (derebulaca Köyü)",
      "Merkez Mah (ermekoğlu Köyü)",
      "Merkez Mah (gümüşpınar Köyü)",
      "Merkez Mah (gürçeşme Köyü)",
      "Merkez Mah (hüseyinçavuşoğlu Köyü)",
      "Merkez Mah (islamköy Köyü)",
      "Merkez Mah (kabaca Köyü)",
      "Merkez Mah (karabaşlı Köyü)",
      "Merkez Mah (karakoçlu Köyü)",
      "Merkez Mah (komşular Köyü)",
      "Merkez Mah (mahmutoğlu Köyü)",
      "Merkez Mah (mekekler Köyü)",
      "Merkez Mah (mumcuoğlu Köyü)",
      "Merkez Mah (müfettişler Köyü)",
      "Merkez Mah (müstakimler Köyü)",
      "Merkez Mah (nizamlar Köyü)",
      "Merkez Mah (osmanbeyler Köyü)",
      "Merkez Mah (özbağı Köyü)",
      "Merkez Mah (pınarönü Köyü)",
      "Merkez Mah (sabunlar Köyü)",
      "Merkez Mah (sarnaz Köyü)",
      "Merkez Mah (seyisoğlu Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (tabaklar Köyü)",
      "Merkez Mah (tellioğlu Köyü)",
      "Merkez Mah (tosunlar Köyü)",
      "Merkez Mah (türkmenoğlu Köyü)",
      "Merkez Mah (velibeyler Köyü)",
      "Merkez Mah (yassıören Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Merkez Mah (yeşilyurt Köyü)",
      "Merkez Mah (yılanlıcakuz Köyü)",
      "Mestanoğlu Mah (ataköy Köyü)",
      "Mıdıkoğlu Mah (yılanlıcakuz Köyü)",
      "Mumlar Mah (hüseyinçavuşoğlu Köyü)",
      "Muratlar Mah (dedeoğlu Köyü)",
      "Muratoğlu Mah (burhanoğlu Köyü)",
      "Mustafa Başoğlu Mah (nizamlar Köyü)",
      "Mut Mah (karakoçlu Köyü)",
      "Mutaflar Mah (sofular Köyü)",
      "Nebioğlu Mah (başlarkadı Köyü)",
      "Odabaşoğlu Mah (ahmetoğlu Köyü)",
      "Ornaköy Mah (çağlar Köyü)",
      "Oruçoğlu Mah (sarnaz Köyü)",
      "Oruzlar Mah (sofular Köyü)",
      "Osmanali Mah (sabunlar Köyü)",
      "Osmanbeyler Mah (özpınar Köyü)",
      "Osmanlar Mah (hışıroğlu Köyü)",
      "Ömercioğlu Mah (alparslan Köyü)",
      "Ömerçavuşlar Mah (oğuzhan Köyü)",
      "Ömeroğlu Mah (burhanoğlu Köyü)",
      "Öteköy Mah (karacaören Köyü)",
      "Parmaksızoğlu Mah (kabaca Köyü)",
      "Rahmanoğlu Mah (yılanlıcakuz Köyü)",
      "Resuller Mah (ataköy Köyü)",
      "Safiyeoğlu Mah (alparslan Köyü)",
      "Sağıroğlu Mah (tabaklar Köyü)",
      "Salbaşlar Mah (oğuzhan Köyü)",
      "Saracık Mah (pınarönü Köyü)",
      "Saraçoğlu Mah (bılık Köyü)",
      "Sarı Hüseyinoğlu Mah (pınarönü Köyü)",
      "Sarıoğlu Mah (halilbeyoğlu Köyü)",
      "Sarnuç Mah (güzelyurt Köyü)",
      "Sarsıklar Mah (hüseyinçavuşoğlu Köyü)",
      "Sarsıkoğlu Mah (bölücek Köyü)",
      "Sayılıoğlu Mah (oğuzhan Köyü)",
      "Seferler Mah (sabunlar Köyü)",
      "Seyrekbasanoğlu Mah (nizamlar Köyü)",
      "Sirkecioğlu Mah (oğuzhan Köyü)",
      "Söbelekler Mah (ataköy Köyü)",
      "Şabanoğlu Mah (yassıören Köyü)",
      "Şefoğlu Mah (bükköy Köyü)",
      "Şimşekler Mah (çolakpehlivan Köyü)",
      "Şişmanoğlu Çay Mah (bılık Köyü)",
      "Şüküroğlu Mah (burhanoğlu Köyü)",
      "Tabaklı Mah (bölücek Köyü)",
      "Taslaklar Mah (dedeoğlu Köyü)",
      "Taşcıoğlu Mah (müfettişler Köyü)",
      "Taşçılar Mah (yazıcıoğlu Köyü)",
      "Tazıcıoğlu Mah (komşular Köyü)",
      "Tekeler Mah (hüseyinçavuşoğlu Köyü)",
      "Telbisoğlu Mah (gürbüzler Köyü)",
      "Terzioğlu Mah (komşular Köyü)",
      "Terzioğlu Mah (müfettişler Köyü)",
      "Tığlar Mah (oğuzhan Köyü)",
      "Tığoğlu Mah (bakırcılar Köyü)",
      "Tohumlar Köyü",
      "Topal Ahmetoğlu Mah (isabeyli Köyü)",
      "Topçayı Mah (bölücek Köyü)",
      "Turgutoğlu Mah (burhanoğlu Köyü)",
      "Tümenoğlu Mah (erenler Köyü)",
      "Türdüoğlu Mah (çomaklar Köyü)",
      "Ulukoz Mah (halilbeyoğlu Köyü)",
      "Uzun Alioğlu Mah (hışıroğlu Köyü)",
      "Uzunseller Mah (tabaklar Köyü)",
      "Vakıf Mah (başlarkadı Köyü)",
      "Yalılıoğlu Mah (karacaören Köyü)",
      "Yanazoğlu Mah (hışıroğlu Köyü)",
      "Yaplar Mah (yılanlıcakuz Köyü)",
      "Yaprakoğlu Mah (isabeyli Köyü)",
      "Yayalar Mah (gümüşpınar Köyü)",
      "Yayalar Mah (nizamlar Köyü)",
      "Yazıcıoğlu Mah (yazıcıoğlu Köyü)",
      "Yeni Hocaoğlu Mah (ataköy Köyü)",
      "Yeni Mah (burhanoğlu Köyü)",
      "Yeni Mah (gürbüzler Köyü)",
      "Yeni Mah (yeniköy Köyü)",
      "Yeniköy Mah (mekekler Köyü)",
      "Yokarıbaş Mah (halilbeyoğlu Köyü)",
      "Yukarıköy Mah (velibeyler Köyü)",
      "Yusufoğlu Mah (güzelyurt Köyü)"
    ],
    "Ereğli": [
      "Bekyeri Mah (gülüç Beldesi)",
      "Çengel Mah (gülüç Beldesi)",
      "Merkez Mah (gülüç Beldesi)",
      "Örencik Mah (gülüç Beldesi)",
      "Armutçuk Mah (kandilli Beldesi)",
      "Geyikbeli Mah (kandilli Beldesi)",
      "Gökçeler Mah (kandilli Beldesi)",
      "Şehitlik Mah (kandilli Beldesi)",
      "Yeni Mah (kandilli Beldesi)",
      "Akarca Mah",
      "Bağlık Mah",
      "Balı Mah",
      "Belen Mah",
      "Belenyeni Mah",
      "Bölücek Mah",
      "Dağlar Mah",
      "Elma Tepe Mah",
      "Göktepe Mah",
      "Güldere Mah",
      "Hamzafakılı Mah",
      "Kavaklık Mah",
      "Kepez Mah",
      "Kestaneci Mah",
      "Kırmacı Mah",
      "Kışla Mah",
      "Kıyıcak Mah",
      "Kirmanlı Mah",
      "Kocaali Mah",
      "Korubaşı Mah",
      "Köseler Mah",
      "Murtaza Mah",
      "Müftü Mah",
      "Orhanlar Mah",
      "Ömerli Mah",
      "Ören Mah",
      "Sarıkokmaz Mah",
      "Süleymanlar Mah",
      "Topçalı Mah",
      "Uzunçayır Mah",
      "Uzunmehmet Mah",
      "Ahmetli Bakımevi Mah (cemaller Köyü)",
      "Akıllı Mah (aşağıkayalıdere Köyü)",
      "Akköy Mah (uludağ Köyü)",
      "Akyazı Mah (şamlar Köyü)",
      "Armutlucuma Mah (aydın Köyü)",
      "Asarlı Köyü",
      "Aşağı Mah (akkaya Köyü)",
      "Aşağı Mah (kızılca Köyü)",
      "Aşağı Mah (soğanlıyörük Köyü)",
      "Aşağıhocalar Köyü",
      "Aşıklı Mah (abdi Köyü)",
      "Azizbeyler Mah (yazıcılar Köyü)",
      "Bagıllar Mah (yunuslu Köyü)",
      "Bakırlık Köyü",
      "Balaban Mah (cemaller Köyü)",
      "Bereketler Mah (dedeler Köyü)",
      "Burgucu Mah (yazıcılar Köyü)",
      "Buruncuk Mah (keşkek Köyü)",
      "Cariyeli Mah (ketenciler Köyü)",
      "Cebeci Mah (bayat Köyü)",
      "Çakalovası Mah (dedeler Köyü)",
      "Çalca Mah (tepeören Köyü)",
      "Çataklı Mah (pembeciler Köyü)",
      "Çatalçam Mah (yunuslu Köyü)",
      "Çavuşlar Mah (külah Köyü)",
      "Çayırbaşı Mah (davutlar Köyü)",
      "Çevlik Köyü",
      "Çobanlar Mah (soğanlıyörük Köyü)",
      "Çollar Mah (ortaköy Köyü)",
      "Çölemen Mah (yenidoğancılar Köyü)",
      "Çömezoğlu Mah (soğanlıyörük Köyü)",
      "Çubuklu Mah (güllük Köyü)",
      "Delihakkı Mah (soğanlıyörük Köyü)",
      "Demirciler Mah (pınarcık Köyü)",
      "Dere Mah (akkaya Köyü)",
      "Dereköy Mah (elmacı Köyü)",
      "Doğuşlar Mah (yunuslu Köyü)",
      "Esentepe Mah (kızılca Köyü)",
      "Esentepe Mah (sücüllü Köyü)",
      "Esentepe Mah (şamlar Köyü)",
      "Göleviç Mah (süleymanbeyler Köyü)",
      "Güllük Mah (merkez Mah) (güllük Köyü)",
      "Gülyalı Mah (abdi Köyü)",
      "Güneşli Köyü",
      "Güzelyurt Köyü",
      "Hacıgil Mah (akkaya Köyü)",
      "Hacıosmanlar Köyü",
      "Hacıuslu Köyü",
      "Hacullu Mah (süleymanbeyler Köyü)",
      "Hamitli Mah (kurtlar Köyü)",
      "Hasbeyler Mah (ortaköy Köyü)",
      "Hatibler Mah (ortaköy Köyü)",
      "Hatipler Mah (yunuslu Köyü)",
      "Hoballar Mah (ballıca Köyü)",
      "Hobröyler Mah (elmacı Köyü)",
      "İsa Mah (şamlar Köyü)",
      "Kabaklar Mah (şamlar Köyü)",
      "Kabakoz Mah (aydın Köyü)",
      "Kadı Mah (yazıcılar Köyü)",
      "Kahyalar Mah (ketenciler Köyü)",
      "Kalaycılar Mah (halaşlı Köyü)",
      "Kalaycılar Mah (osmanlar Köyü)",
      "Kapançatı Mah (alacabük Köyü)",
      "Karalar Mah (abdi Köyü)",
      "Karaosmanlar Mah (bayat Köyü)",
      "Kargalar Mah (abdi Köyü)",
      "Kasımlı Mah (külah Köyü)",
      "Katırcıoğlu Mah (külah Köyü)",
      "Kayabaşı Mah (esenköy Köyü)",
      "Kaymakçılar Mah (külah Köyü)",
      "Kemer Mah (uludağ Köyü)",
      "Kestanetarlası Mah (cemaller Köyü)",
      "Kışla Mah (aydın Köyü)",
      "Kızılca Mah (bayat Köyü)",
      "Kirencik Mah (kirencik Köyü)",
      "Kocabelen Mah (aydınlar Köyü)",
      "Kocalar Mah (çaylıoğlu Köyü)",
      "Koyunlu Mah (halaşlı Köyü)",
      "Kömürcüler Mah (kızılca Köyü)",
      "Köseler Mah (ortaköy Köyü)",
      "Köyistan Mah (soğanlıyörük Köyü)",
      "Kuşlar Mah (danişmentli Köyü)",
      "Manaşlı Mah (şamlar Köyü)",
      "Merkez Mah (abdi Köyü)",
      "Merkez Mah (alacabük Köyü)",
      "Merkez Mah (aşağı Mah) (danişmentli Köyü)",
      "Merkez Mah (aşağıkayalıdere Köyü)",
      "Merkez Mah (aydın Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (ballıca Köyü)",
      "Merkez Mah (bayat Köyü)",
      "Merkez Mah (cemaller Köyü)",
      "Merkez Mah (çamlıbel Köyü)",
      "Merkez Mah (çayırlı Köyü)",
      "Merkez Mah (çaylıoğlu Köyü)",
      "Merkez Mah (dağlıca Köyü)",
      "Merkez Mah (davutlar Köyü)",
      "Merkez Mah (dedeler Köyü)",
      "Merkez Mah (düzpelit Köyü)",
      "Merkez Mah (elmacı Köyü)",
      "Merkez Mah (esenköy Köyü)",
      "Merkez Mah (gebe Köyü)",
      "Merkez Mah (halaşlı Köyü)",
      "Merkez Mah (hasbeyler Köyü)",
      "Merkez Mah (ışıklı Köyü)",
      "Merkez Mah (imranlar Köyü)",
      "Merkez Mah (iskenderli Köyü)",
      "Merkez Mah (keşkek Köyü)",
      "Merkez Mah (ketenciler Köyü)",
      "Merkez Mah (kurtlar Köyü)",
      "Merkez Mah (külah Köyü)",
      "Merkez Mah (osmanlar Köyü)",
      "Merkez Mah (öğberler Köyü)",
      "Merkez Mah (pembeciler Köyü)",
      "Merkez Mah (pınarcık Köyü)",
      "Merkez Mah (ramazanlı Köyü)",
      "Merkez Mah (rüşanlar Köyü)",
      "Merkez Mah (sakallar Köyü)",
      "Merkez Mah (saltuklu Köyü)",
      "Merkez Mah (sücüllü Köyü)",
      "Merkez Mah (süleymanbeyler Köyü)",
      "Merkez Mah (şamlar Köyü)",
      "Merkez Mah (tepeören Köyü)",
      "Merkez Mah (uludağ Köyü)",
      "Merkez Mah (üçköy Köyü)",
      "Merkez Mah (vakıf Köyü)",
      "Merkez Mah (velidağ Köyü)",
      "Merkez Mah (yalnızçam Köyü)",
      "Merkez Mah (yaraşlıyörük Köyü)",
      "Merkez Mah (yazıören Köyü)",
      "Merkez Mah (yenidoğancılar Köyü)",
      "Merkez Mah (yukarıhocalar Köyü)",
      "Merkez Mah (yunuslu Köyü)",
      "Merkez Mah (zındancılar Köyü)",
      "Minatlı Mah (abdi Köyü)",
      "Nusratlı Mah (ışıklı Köyü)",
      "Okulyanı Mah (abdi Köyü)",
      "Okuşlar Mah (yenidoğancılar Köyü)",
      "Orta Mah (kızılca Köyü)",
      "Orta Mah (yazıcılar Köyü)",
      "Örencik Mah (aydınlar Köyü)",
      "Pazarpınar Mah (yeni Pazar Mah) (kurtlar Köyü)",
      "Piller Mah (esenler Köyü)",
      "Saka Mah (aydın Köyü)",
      "Sakalar Mah (esenler Köyü)",
      "Saltuklu Mah (ballıca Köyü)",
      "Sandalcılar Mah (pınarcık Köyü)",
      "Sarıhamzalı Mah (yukarıhocalar Köyü)",
      "Serdaroğlu Mah (süleymanbeyler Köyü)",
      "Subaşı Mah (süleymanbeyler Köyü)",
      "Sütlüce Köyü",
      "Tabaklar Mah (abdi Köyü)",
      "Taklar Mah (zındancılar Köyü)",
      "Tantanlar Mah (imranlar Köyü)",
      "Terzi Köyü",
      "Tingiller Mah (bayat Köyü)",
      "Topyeri Mah (keşkek Köyü)",
      "Torunlu Mah (yazıören Köyü)",
      "Ulaşlar Mah (halaşlı Köyü)",
      "Yakalar Mah (yunuslu Köyü)",
      "Yaslar Mah (pınarcık Köyü)",
      "Yavuzlar Mah (zındancılar Köyü)",
      "Yeni Mah (çayırlı Köyü)",
      "Yeni Mah (hasbeyler Köyü)",
      "Yeni Mah (ortaköy Köyü)",
      "Yeniköy Mah (yeniköy Köyü)",
      "Yörük Mah (soğanlıyörük Köyü)",
      "Yörük Mah (yaraşlıyörük Köyü)",
      "Yukarı Mah (akkaya Köyü)",
      "Yukarı Mah (soğanlıyörük Köyü)",
      "Zoroğlu Mah (ramazanlı Köyü)",
      "A.sofular Mah (hasankahyalar Köyü)",
      "Ahmetli Mah (çiğdemli Köyü)",
      "Ahmetpaşalar Mah (sarıkaya Köyü)",
      "Alacalar Mah (yeşilköy Köyü)",
      "Aşağı Mah (karakavuz Köyü)",
      "Aşağı Mah (ormanlı Ormanlı Köyü)",
      "Aylar Mah (kızılcapınar Köyü)",
      "Ballı Mah (sarıkaya Köyü)",
      "Burunören Mah (ortacı Köyü)",
      "Camgözler Mah (çiğdemli Köyü)",
      "Çamlar Mah (üveyikli Köyü)",
      "Çankızı Mah (fındıklı Köyü)",
      "Çiftlik Mah (emirali Köyü)",
      "Çiller Mah (sofular Köyü)",
      "Çomaklar Mah (yeşilköy Köyü)",
      "Dal Mah (ortacı Köyü)",
      "Daldabanlar Mah (çiğdemli Köyü)",
      "Danışmantlı Mah (emirali Köyü)",
      "Doplar Mah (başören Köyü)",
      "Erdelli Mah (başören Köyü)",
      "Eskiler Mah (sarıkaya Köyü)",
      "Firenkler Mah (toyfanlı Köyü)",
      "Fodlar Mah (sofular Köyü)",
      "Göliçi Mah (ormanlı Ormanlı Köyü)",
      "Hacullu Mah (kaymaklar Köyü)",
      "Halı Mah (ortacı Köyü)",
      "Hoca Mah (kaymaklar Köyü)",
      "Ilgayır Mah (başörendoğancılar Köyü)",
      "İbrahimci Mah (akköy Köyü)",
      "İlyaslı Mah (başörendoğancılar Köyü)",
      "Kadılar Mah (sarıkaya Köyü)",
      "Karabalçık Mah (karakavuz Köyü)",
      "Karacakayalar Mah (başören Köyü)",
      "Karcılar Mah (ortacı Köyü)",
      "Kavaklık Mah (karakavuz Köyü)",
      "Kayalar Mah (çiğdemli Köyü)",
      "Kayıplar Mah (artıklar Köyü)",
      "Kerimbeyler Mah (başören Köyü)",
      "Kınca Mah (emirali Köyü)",
      "Kışla Mah (ortacı Köyü)",
      "Kirazağılı Mah (karakavuz Köyü)",
      "Köseler Mah (çiğdemli Köyü)",
      "Kureşler Mah (emirali Köyü)",
      "Kuytak Mah (ormanlı Ormanlı Köyü)",
      "Kuyumcular Mah (sofular Köyü)",
      "Küpeşler Mah (çiğdemli Köyü)",
      "Mehemli Mah (serintepe Köyü)",
      "Mektep Mah (topallı Köyü)",
      "Merkez  Mah (emsaller Mah) (yeşilköy Köyü)",
      "Merkez Mah (akköy Köyü)",
      "Merkez Mah (alaplısofular Köyü)",
      "Merkez Mah (artıklar Köyü)",
      "Merkez Mah (başören Köyü)",
      "Merkez Mah (başörendoğancılar Köyü)",
      "Merkez Mah (çömlekçi Köyü)",
      "Merkez Mah (emirali Köyü)",
      "Merkez Mah (fındıklı Köyü)",
      "Merkez Mah (gana Mah) (sofular Köyü)",
      "Merkez Mah (hasankahyalar Köyü)",
      "Merkez Mah (karakavuz Köyü)",
      "Merkez Mah (kaymaklar Köyü)",
      "Merkez Mah (kızılcapınar Köyü)",
      "Merkez Mah (ormanlı Beldesi)",
      "Merkez Mah (ova Köyü)",
      "Merkez Mah (topallı Köyü)",
      "Merkez Mah (toyfanlı Köyü)",
      "Merkez Mah (üveyikli Köyü)",
      "Mudahlı Mah (sarıkaya Köyü)",
      "Muhallı Mah (üveyikli Köyü)",
      "Mursallı Mah (kaymaklar Köyü)",
      "Obruklar Mah (başören Köyü)",
      "Resullü Mah (hasankahyalar Köyü)",
      "Sanayi Mah (toyfanlı Köyü)",
      "Sarıahmetler Mah (sarıkaya Köyü)",
      "Sarıca Mah (ortacı Köyü)",
      "Sarıkaya Mah (ormanlı Beldesi)",
      "Sekeli Mah (yeşilköy Köyü)",
      "Seyit Ahmetli Mah (ormanlı Beldesi)",
      "Sinitli Mah (ormanlı Beldesi)",
      "Sucahlı Mah (sarıkaya Köyü)",
      "Şıhlar Mah (sarıkaya Köyü)",
      "Tepeköy Mah (fındıklı Köyü)",
      "Tepeköy Mah (karakavuz Köyü)",
      "Terzi Mah (emirali Köyü)",
      "Yeni Mah (kızılcapınar Köyü)"
    ],
    "Gökçebey": [
      "Kadıoğlu Mah (bakacakkadı Beldesi)",
      "Merkez Mah (bakacakkadı Beldesi)",
      "Satıbeyler Mah (bakacakkadı Beldesi)",
      "Çarşı Mah",
      "Çay Mah",
      "İstasyon Mah",
      "Onmayıs Mah",
      "Üçburgu Mah",
      "Yeni Mah",
      "Abasızoğlu Mah (bakiler Köyü)",
      "Abdibeyoğlu Mah (gaziler Köyü)",
      "Aksakaloğlu Mah (aktarla Köyü)",
      "Alaoğlu Mah (bodaç Köyü)",
      "Alibeyoğlu Mah (bakiler Köyü)",
      "Alimler Mah (namazgah Köyü)",
      "Aliusta Mah (uzunahmetler Köyü)",
      "Bakıllar Mah (bakiler Köyü)",
      "Bayraktar Mah (örmeci Köyü)",
      "Bekirbaşoğlu Mah (bakiler Köyü)",
      "Bekiroğlu Mah (muharremler Köyü)",
      "Boduroğlu Mah (aktarla Köyü)",
      "Carioğlu Mah (bodaç Köyü)",
      "Cebeciler Mah (hacımusa Köyü)",
      "Civelekler Mah (duhancılar Köyü)",
      "Çapcıoğlu Mah (bakiler Köyü)",
      "Çay Mah (örmeci Köyü)",
      "Çay Mah (uzunahmetler Köyü)",
      "Çayır Mah (aktarla Köyü)",
      "Çukur Mah",
      "Dağköyü Mah (karahatipler Köyü)",
      "Dervişler Mah (aydınlar Köyü)",
      "Emiroğlu Mah (örmeci Köyü)",
      "Enbioğlu Mah (veyisoğlu Köyü)",
      "Erenler Mah (örmeci Köyü)",
      "Etcioğlu Mah (bakiler Köyü)",
      "Etcioğlu Mah (yeşilköy Köyü)",
      "Gedikler Mah (aydınlar Köyü)",
      "Gegekoğlu Mah (duhancılar Köyü)",
      "Günbeller Mah (karapınar Köyü)",
      "Hacımusa Mah (hacımusa Köyü)",
      "Hacıoğlu Mah (veyisoğlu Köyü)",
      "Hatipler Mah (karapınar Köyü)",
      "Haylamazlar Mah (aydınlar Köyü)",
      "Helme Mah (aliusta Köyü)",
      "Herkime Mah (hacımusa Köyü)",
      "Hüseyinbeyoğlu Mah (karahatipler Köyü)",
      "İbadiçelebioğlu Mah (uzunahmetler Köyü)",
      "İbrahimbeyoğlu Mah (veyisoğlu Köyü)",
      "İmamlar Mah (aydınlar Köyü)",
      "İncemehmetler Mah (gaziler Köyü)",
      "Karahatipler Mah (karahatipler Köyü)",
      "Karanlıkoğlu Mah (gaziler Köyü)",
      "Karşıyaka Mah (aliusta Köyü)",
      "Kelezoğlu Mah (veyisoğlu Köyü)",
      "Kellecioğlu Mah (duhancılar Köyü)",
      "Köprübaşı Mah (gaziler Köyü)",
      "Köseoğlu Mah (veyisoğlu Köyü)",
      "Kurtdamı Mah (bodaç Köyü)",
      "Kütükcüoğlu Mah (yeşilköy Köyü)",
      "Kütükoğlu Mah (karahatipler Köyü)",
      "Mankıroğlu Mah (muharremler Köyü)",
      "Merkez Mah (aktarla Köyü)",
      "Merkez Mah (aliusta Köyü)",
      "Merkez Mah (bodaç Köyü)",
      "Merkez Mah (dağdemirciler Köyü)",
      "Merkez Mah (pazarlıoğlu Köyü)",
      "Muratlar Mah (aydınlar Köyü)",
      "Musabeyoğlu Mah (karahatipler Köyü)",
      "Müsebeyoğlu Mah (gaziler Köyü)",
      "Oluklar Mah (aktarla Köyü)",
      "Osmanbaşoğlu Mah (veyisoğlu Köyü)",
      "Partlakoğlu Mah (uzunahmetler Köyü)",
      "Paşabeyoğlu Mah (gaziler Köyü)",
      "Sakalar Mah (muharremler Köyü)",
      "Salmanlar Mah (örmeci Köyü)",
      "Saraçlar Köyü",
      "Satuklar Mah (karapınar Köyü)",
      "Simitcioğlu Mah (örmeci Köyü)",
      "Soğuksu Mah (aliusta Köyü)",
      "Süleyman Çelebioğlu Mah (uzunahmetler Köyü)",
      "Şıhlar Mah (uzunahmetler Köyü)",
      "Tavukçuoğlu Mah (örmeci Köyü)",
      "Tepeköy Mah (bakiler Köyü)",
      "Tepeköy Mah (bodaç Köyü)",
      "Tütüncüoğlu Mah (duhancılar Köyü)",
      "Uzuneller Mah (örmeci Köyü)",
      "Varatoğlu Mah (veyisoğlu Köyü)",
      "Veyisoğlu Mah (veyisoğlu Köyü)",
      "Yaboğlu Mah (örmeci Köyü)",
      "Yardibi Mah (uzunahmetler Köyü)",
      "Yeni Mah (uzunahmetler Köyü)",
      "Yeşilköy Köyü",
      "Yolcuoğlu Mah (aktarla Köyü)",
      "Yukarı Mah (aliusta Köyü)",
      "Zaimoğlu Mah (namazgah Köyü)"
    ],
    "Kilimli": [
      "Cuma Yanı Mah (çatalağzı Beldesi)",
      "Doğancılar Mah (çatalağzı Beldesi)",
      "Hacıoğlu Mah (çatalağzı Beldesi)",
      "Kırımsa Mah (çatalağzı Beldesi)",
      "Kokurdan Mah (çatalağzı Beldesi)",
      "Kuzyaka Mah (çatalağzı Beldesi)",
      "Merkez Mah (çatalağzı Beldesi)",
      "Ayiçi Mah (gelik Beldesi)",
      "Ayiçi Merkez Mah (gelik Beldesi)",
      "Esen Mah (gelik Beldesi)",
      "Gelik Merkez Mah (gelik Beldesi)",
      "Kırat Mah (gelik Beldesi)",
      "Belediye Sitesi Mah",
      "Bölüm Mah",
      "Çamlık Mah",
      "Damarlı Mah",
      "Güney Mah",
      "Hisar Arkası Mah",
      "Karadon Mah",
      "Merkez Mah",
      "Subatan Mah",
      "Aşağı Mah (göbü Köyü)",
      "Başköy Mah (türkali Köyü)",
      "Çalca Mah (şirinköy Köyü)",
      "Haliller Mah (göbü Köyü)",
      "Hatipler Mah (türkali Köyü)",
      "Karşı Mah (göbü Köyü)",
      "Karşıköy Mah (türkali Köyü)",
      "Merkez Mah (kurtköy Köyü)",
      "Merkez Mah (şirinköy Köyü)",
      "Merkez Mah (türkali Köyü)",
      "Mustakiller Mah (türkali Köyü)",
      "Oruçlar Mah (göbü Köyü)",
      "Yeniköy Mah (kurtköy Köyü)",
      "Yukarıdere Mah (türkali Köyü)",
      "Cumhuriyet Mah (muslu Beldesi)",
      "Emirler Mah (muslu Beldesi)",
      "Merkez Mah (muslu Beldesi)"
    ],
    "Kozlu": [
      "19 Mayıs Mah",
      "Esenköy Mah",
      "Fatih Mah",
      "Güney Mah",
      "İhsaniye Mah",
      "Kılıç Mah",
      "Merkez Mah",
      "Taşbaca Mah",
      "Yahma Mah",
      "Abacıoğlu Mah (üçköy Köyü)",
      "Ardınç Mah (sakaköy Köyü)",
      "Aşağı Mah (uzungüney Köyü)",
      "Aşağıçayır Köyü",
      "Balçıklı Köyü",
      "Ceyüp Mah (gücek Köyü)",
      "Çamköy Köyü",
      "Çardaş Köyü",
      "Çengelli Mah (sakaköy Köyü)",
      "Dağköy Köyü",
      "Değirmen Çayı Mah (seyfetler Köyü)",
      "Demirciler Mah (kargalar Köyü)",
      "Futa Köyü",
      "Hamyon Mah (sakaköy Köyü)",
      "Hasanbaşoğlu Mah (dereköy Köyü)",
      "Hemdüller Mah (uzungüney Köyü)",
      "Ilıcakyüzü Mah (köserecik Köyü)",
      "Ilıksu Mah (sakaköy Köyü)",
      "Kahyalar Mah (uzungüney Köyü)",
      "Karşı Mah (akşeyh Köyü)",
      "Katırlı Mah (bozca Köyü)",
      "Kayadibi Mah (uzungüney Köyü)",
      "Makalar Mah (çırgan Köyü)",
      "Manaşlar Mah (enseköy Köyü)",
      "Merkez Mah (akşeyh Köyü)",
      "Merkez Mah (bozca Köyü)",
      "Merkez Mah (çırgan Köyü)",
      "Merkez Mah (ebegümeci Köyü)",
      "Merkez Mah (enseköy Köyü)",
      "Merkez Mah (gücek Köyü)",
      "Merkez Mah (kargalar Köyü)",
      "Merkez Mah (kızılcakese Köyü)",
      "Merkez Mah (kozluköy Köyü)",
      "Merkez Mah (köserecik Köyü)",
      "Merkez Mah (örencik Köyü)",
      "Merkez Mah (sakaköy Köyü)",
      "Merkez Mah (seyfetler Köyü)",
      "Merkez Mah (sivriler Köyü)",
      "Merkez Mah (üçköy Köyü)",
      "Muratlar Mah (dereköy Köyü)",
      "Orta Mah (uzungüney Köyü)",
      "Tepe Mah (seyfetler Köyü)",
      "Toptaşı Mah (kızılcakese Köyü)",
      "Yaylacık Mah (ebegümeci Köyü)",
      "Yeni Mah (örencik Köyü)",
      "Yukarı İhsaniye Mah (kozluköy Köyü)",
      "Yukarı Mah (akşeyh Köyü)",
      "Yukarı Mah (çırgan Köyü)",
      "Yukarı Mah (uzungüney Köyü)"
    ],
    "Merkez": [
      "Ahmetler Mah (himmetoğlu Köyü)",
      "Ali Velioğlu Mah (hacıali Köyü)",
      "Alibüyük Mah (osmanlı Köyü)",
      "Arabancı Mah (saraycık Köyü)",
      "Arslanoğlu Mah (karadere Köyü)",
      "Asmacı Mah (karadere Köyü)",
      "Aşağı Mah (kaleoğlu Köyü)",
      "Ayınlı Mah (himmetoğlu Köyü)",
      "Başoğlu Mah (korucak Köyü)",
      "Başören Mah (kumtarla Köyü)",
      "Belevrek Mah (ayvatlar Köyü)",
      "Beyler Mah (korucak Köyü)",
      "Beytepe Mah (beycuma Beldesi)",
      "Birlik Mah (beycuma Beldesi)",
      "Bozcaoğlu Mah (çukurören Köyü)",
      "Bölüçek Mah (ayvatlar Köyü)",
      "Çakallar Mah (kaleoğlu Köyü)",
      "Çamlık Mah (beycuma Beldesi)",
      "Çavuşlar Mah (keller Köyü)",
      "Çay Mah (eceler Köyü)",
      "Çay Mah (hacıali Köyü)",
      "Çay Mah (kaleoğlu Köyü)",
      "Çuruklar Mah (hacıali Köyü)",
      "Davullar Mah (hacıali Köyü)",
      "Dereli Mah (korucak Köyü)",
      "Ebeler Mah (kaleoğlu Köyü)",
      "Eskiten Mah (karapınar Köyü)",
      "Etler Mah (korucak Köyü)",
      "Eyvazoğlu Mah (korucak Köyü)",
      "Gökçebel Mah (taşçılar Köyü)",
      "Güney Mah (kaleoğlu Köyü)",
      "Hacılar Mah (eceler Köyü)",
      "Hasanlar Mah (ayvatlar Köyü)",
      "Hatıplar Mah (karapınar Köyü)",
      "İmamlar Mah (karadere Köyü)",
      "Kabalaklı Köyü",
      "Karşıyaka Mah (himmetoğlu Köyü)",
      "Karşıyaka Mah (korucak Köyü)",
      "Kasımlar Mah (beycuma Beldesi)",
      "Kılavlar Mah (kaleoğlu Köyü)",
      "Kıymetoğlu Mah (hacıali Köyü)",
      "Kirazlı Mah (kumtarla Köyü)",
      "Kuzca Mah (saraycık Köyü)",
      "Madenler Mah (kumtarla Köyü)",
      "Merkez Gerdek Mah (himmetoğlu Köyü)",
      "Merkez Keller Mah (keller Köyü)",
      "Merkez Mah (ayvatlar Köyü)",
      "Merkez Mah (beycuma Beldesi)",
      "Merkez Mah (çukurören Köyü)",
      "Merkez Mah (eceler Köyü)",
      "Merkez Mah (hacıali Köyü)",
      "Merkez Mah (kaleoğlu Köyü)",
      "Merkez Mah (kumtarla Köyü)",
      "Merkez Mah (osmanlı Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (taşçılar Köyü)",
      "Mudaroğlu Mah (karadere Köyü)",
      "Muratlı Mah (beycuma Beldesi)",
      "Musunlu Mah (çukurören Köyü)",
      "Orta Mah (karapınar Köyü)",
      "Ömeroğlu Mah (osmanlı Köyü)",
      "Pazarcık Mah (osmanlı Köyü)",
      "Rahmanlı Mah (korucak Köyü)",
      "Recepoğlu Mah (hacıali Köyü)",
      "Saray Mah (hacıali Köyü)",
      "Sarı Osmanlar Mah (kaleoğlu Köyü)",
      "Sayılılar Mah (kaleoğlu Köyü)",
      "Semercioğlu Mah (çukurören Köyü)",
      "Tahtacı Mah (karadere Köyü)",
      "Taşağıl Mah (karapınar Köyü)",
      "Tatoğlu Mah (kaleoğlu Köyü)",
      "Torlaklar Mah (kaleoğlu Köyü)",
      "Uzunlar Mah (karapınar Köyü)",
      "Veliköy Mah (karadere Köyü)",
      "Yallıoğlu Mah (hacıali Köyü)",
      "Yayla Mah (himmetoğlu Köyü)",
      "Yeni Mah (beycuma Beldesi)",
      "Yeni Mah (karapınar Köyü)",
      "Yukarı Mah (karapınar Köyü)",
      "Yusufoğlu Mah (himmetoğlu Köyü)",
      "Celepçioğlu Mah (elvanpazarcık Beldesi)",
      "Cumhuriyet Mah (elvanpazarcık Beldesi)",
      "Çalca Mah (elvanpazarcık Beldesi)",
      "Elvan Mah (elvanpazarcık Beldesi)",
      "Hayat Mah (elvanpazarcık Beldesi)",
      "Merkez Mah (elvanpazarcık Beldesi)",
      "Tasmacı Mah (elvanpazarcık Beldesi)",
      "Kadı Mah (karaman Beldesi)",
      "Karamanlar Mah (karaman Beldesi)",
      "Merkez Mah (karaman Beldesi)",
      "Satıklı Mah (karaman Beldesi)",
      "Yeni Mah (karaman Beldesi)",
      "Alaca Mah (kardeşler Köyü)",
      "Aşağı Mah (olukyanı Köyü)",
      "Aşağıköy Mah (sarımsak Köyü)",
      "Dere Mah (sofular Köyü)",
      "Dikimçe Mah (çağlı Köyü)",
      "İmamlar Mah (olukyanı Köyü)",
      "Karşı Mah (sarımsak Köyü)",
      "Kireç Mah (çağlı Köyü)",
      "Kokaksu Mah (kardeşler Köyü)",
      "Köroğlu Mah (köroğlu Köyü)",
      "Marıkpınar Mah (kardeşler Köyü)",
      "Merkez Çağlı Mah (çağlı Köyü)",
      "Merkez Çayırcık Mah (çağlı Köyü)",
      "Merkez Mah (alancık Köyü)",
      "Merkez Mah (kardeşler Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Mezarlık Mah (sarımsak Köyü)",
      "Orta Mah (olukyanı Köyü)",
      "Recep Harman Mah (sarımsak Köyü)",
      "Sapça Mah (sapça Köyü)",
      "Yukarı Mah (olukyanı Köyü)",
      "Zeytin 1 Mah (alancık Köyü)",
      "Zeytin 2 Mah (alancık Köyü)",
      "Asma Mah",
      "Bağlık Mah",
      "Bahçelievler Mah",
      "Baştarla Mah",
      "Birlik Mah",
      "Çaydamar Mah",
      "Çınartepe Mah",
      "Dilaver Mah",
      "İnağzı Mah",
      "İncivez Mah",
      "Karaelmas Mah",
      "Meşrutiyet Mah",
      "Mithatpaşa Mah",
      "On Temmuz Mah",
      "Tepebaşı Mah",
      "Terakki Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yeşil Mah"
    ]
  },
  "Aksaray": {
    "Ağaçören": [
      "Gümüştepe Mah",
      "Kale Mah",
      "Yeni Mah",
      "Yenişabanlı Mah",
      "Yurtsever Mah",
      "Zafer Mah",
      "Abalı Köyü",
      "Abdiuşağı Köyü",
      "Ahırlı Köyü",
      "Avşar Köyü",
      "Camili Köyü",
      "Çatalçeşme Köyü",
      "Dadılar Köyü",
      "Demircili Köyü",
      "Göllü Köyü",
      "Göynük Köyü",
      "Güzelöz Köyü",
      "Hacıahmetlidavutlu Köyü",
      "Hacıahmetlitepeköy Köyü",
      "Hacıismailli Köyü",
      "Hüsrevköy Köyü",
      "İydeli Mah (yağmurhüyüğü Köyü)",
      "Karapınar Mah (yağmurhüyüğü Köyü)",
      "Kaşıçalıklar Köyü",
      "Kederli Köyü",
      "Kılıçlı Köyü",
      "Kırımini Köyü",
      "Kurtini Köyü",
      "Kütüklü Köyü",
      "Oymaağaç Köyü",
      "Sarıağıl Köyü",
      "Sarıhasanlı Köyü",
      "Sofular Köyü",
      "Yağmurhüyüğü Köyü",
      "Yenice Köyü"
    ],
    "Eskil": [
      "Aydınlık Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Karşıyaka Mah",
      "Merkez Mah",
      "Mimar Sinan Mah",
      "Yıldırım Mah",
      "Zafer Mah",
      "Camikebir Mah (eşmekaya Beldesi)",
      "Kayacık Mah (eşmekaya Beldesi)",
      "Yeni Mah (eşmekaya Beldesi)",
      "Yeşilyurt Mah (eşmekaya Beldesi)",
      "Başaran Köyü",
      "Bayramdüğün Kümesi Mah (bayramdüğün Köyü)",
      "Bezirci Yaylası Mah (güneşli Köyü)",
      "Butacı Yaylası Mah (başaran Köyü)",
      "Büğet Köyü",
      "Celil Kümesi Mah (celil Köyü)",
      "Çağlak Yaylası Mah (güneşli Köyü)",
      "Çimyayla Mah (büğet Köyü)",
      "Çukuryurt Kümesi Mah (çukuryurt Köyü)",
      "Çulfa Mah",
      "Dere Yaylası Mah (güneşli Köyü)",
      "Filikçi Köyü",
      "Gedik Yaylası Mah (güneşli Köyü)",
      "Gözerli Yaylası Mah (güneşli Köyü)",
      "Güllüdere Yaylası Mah (güneşli Köyü)",
      "Gümüşdüğün Köyü",
      "Güneşli Köyü",
      "Hoca Yaylası Mah (büğet Köyü)",
      "Karaburun Yaylası Mah (güneşli Köyü)",
      "Katrancı Kümesi Mah (katrancı Köyü)",
      "Kökez Köyü",
      "Sağsak Kümesi Mah (sağsak Köyü)",
      "Şavvel Yaylası Mah (büğet Köyü)",
      "Yavuz Sultan Selim Mah",
      "Yukarıbezirci Yaylası Mah (güneşli Köyü)"
    ],
    "Gülağaç": [
      "Eskicami Mah (demirci Beldesi)",
      "Kalealtı Mah (demirci Beldesi)",
      "Kurtuluş Mah (demirci Beldesi)",
      "Yenipazar Mah (demirci Beldesi)",
      "Atatürk Mah",
      "Fatih Mah",
      "Hürriyet Mah",
      "Yeni Mah",
      "Cumhuriyet Mah (gülpınar Beldesi)",
      "Fatih Mah (gülpınar Beldesi)",
      "Koyunlu Mah (gülpınar Beldesi)",
      "Pınarbaşı Mah (gülpınar Beldesi)",
      "Tuzla Mah (gülpınar Beldesi)",
      "Akmezar Köyü",
      "Camiliören Köyü",
      "Cumhuriyet Mah (bekarlar Köyü)",
      "Çatalsu Köyü",
      "Fatih Mah (sofular Köyü)",
      "Fevzi Çakmak Mah (sofular Köyü)",
      "Hürriyet Mah (bekarlar Köyü)",
      "İstiklal Mah",
      "Kayabaşı Mah (bekarlar Köyü)",
      "Kızılkaya Köyü",
      "Meydan Mah",
      "Osmanlı Köyü",
      "Pınarbaşı Köyü",
      "Süleymanhüyüğü Köyü",
      "Yavuz Selim Mah (sofular Köyü)",
      "Cumhuriyet Mah (saratlı Beldesi)",
      "İstiklal Mah (saratlı Beldesi)",
      "Karşıyaka Mah (saratlı Beldesi)",
      "Meydan Mah (saratlı Beldesi)",
      "Zafer Mah (saratlı Beldesi)"
    ],
    "Güzelyurt": [
      "Akyamaç Mah",
      "Aşağı Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Akpınar Mah (ıhlara Beldesi)",
      "Harmanlık Mah (ıhlara Beldesi)",
      "Karşıyaka Mah (ıhlara Beldesi)",
      "Kayaardı Mah (ıhlara Beldesi)",
      "Alanyurt Köyü",
      "Belisırma Köyü",
      "Bozcayurt Köyü",
      "Gaziemir Köyü",
      "Meydan Mah (ılısu Köyü)",
      "Sivrihisar Köyü",
      "Uzunkaya Köyü",
      "Yaprakhisar Köyü",
      "Yeni Mah (ılısu Köyü)",
      "Kayaaltı Mah (selime Beldesi)",
      "Köprübaşı Mah (selime Beldesi)",
      "Yeni Mah (selime Beldesi)"
    ],
    "Merkez": [
      "Boğaziçi Mah (bağlıkaya Beldesi)",
      "Çimeli Mah (bağlıkaya Beldesi)",
      "Kurtuluş Mah (bağlıkaya Beldesi)",
      "Yenimahalle Mah (bağlıkaya Beldesi)",
      "Aratol Bahçeli Mah",
      "Aratol İstiklal Mah",
      "Bahçeli Mah",
      "Bahçesaray Mah",
      "Coğlaki Mah",
      "Dere Mah",
      "Ereğlikapı Mah",
      "Fatih Mah",
      "Hacıhasanlı Mah",
      "Hacılar Harmanı Mah",
      "Hamidiye Mah",
      "Hürriyet Mah",
      "İstiklal Mah",
      "Kalanlar Mah",
      "Kılıçaslan Mah",
      "Kırımlı Mah",
      "Laleli Mah",
      "Mehmet Akif Ersoy Mah",
      "Minarecik Mah",
      "Muhsin Çelebi Mah",
      "Paşacık Mah",
      "Pınar Mah",
      "Selçuklu Mah",
      "Sofular Mah",
      "Taşpazar Mah",
      "Yavuz Sultan Selim Mah",
      "Yunus Emre Mah",
      "Zincirli Mah",
      "Aydınlar Mah (helvadere Beldesi)",
      "Cumhuriyet Mah (helvadere Beldesi)",
      "Kirazlı Mah (helvadere Beldesi)",
      "Zafer Mah (helvadere Beldesi)",
      "1.küme Mah (hırkatol Köyü)",
      "2.küme Mah (hırkatol Köyü)",
      "3.küme Mah (hırkatol Köyü)",
      "Ağzıkarahan Köyü",
      "Akhisar Köyü",
      "Akin Köyü",
      "Alayhan Mezrası Mah (alayhanı Köyü)",
      "Alayhanı Köyü",
      "Ataköy Köyü",
      "Atatürk Mah (karaören Köyü)",
      "Atatürk Mah (kutlu Köyü)",
      "Babakonağı Köyü",
      "Bağ Yolu Mah (tatlıca Köyü)",
      "Bağlı Köyü",
      "Bahçelievler Mah (acıpınar Köyü)",
      "Bahçelievler Mah (yuva Köyü)",
      "Bayındır Köyü",
      "Baymış Köyü",
      "Bebek Köyü",
      "Beyazsaray Mah (sarayhan Köyü)",
      "Birlik Mah (altınkaya Köyü)",
      "Borucu Köyü",
      "Bostanlık Köyü",
      "Boyalı Köyü",
      "Bozcatepe Köyü",
      "Büyükgüve Köyü",
      "Büyükpörnekler Köyü",
      "Camii Mah (tatlıca Köyü)",
      "Cankıllı Köyü",
      "Ceran Köyü",
      "Cerit Köyü",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (yuva Köyü)",
      "Çağlayan Köyü",
      "Çavdarlılar Köyü",
      "Çekiçler Köyü",
      "Çeltek Köyü",
      "Çimeliyeni Köyü",
      "Çitçir Yolu Mah (tatlıca Köyü)",
      "Çolaknebi Köyü",
      "Ekecikgödeler Köyü",
      "Ekeciktol Köyü",
      "Ekecikyeni Köyü",
      "Fatih Mah (acıpınar Köyü)",
      "Fatih Mah (kutlu Köyü)",
      "Fatih Mah (sevinçli Köyü)",
      "Fatmauşağı Köyü",
      "Gençosman Köyü",
      "Gökçe Köyü",
      "Göksügüzel Köyü",
      "Gücünkaya Köyü",
      "Gültepe Köyü",
      "Hanobası Köyü",
      "Hatipoğlutolu Köyü",
      "İsmailağatolu Köyü",
      "Kale Mah (altınkaya Köyü)",
      "Kalebalta Köyü",
      "Karaçayır Köyü",
      "Karakova Köyü",
      "Karakuyu Köyü",
      "Karataş Köyü",
      "Kazıcık Köyü",
      "Kocatepe Mah (doğantarla Köyü)",
      "Koyak Köyü",
      "Kurtuluş Mah",
      "Kurtuluş Mah (doğantarla Köyü)",
      "Küçükgüve Köyü",
      "Küçükpörnekler Köyü",
      "Macarlı Köyü",
      "Nurgöz Köyü",
      "Öz Mevkii Mah (gökçe Köyü)",
      "Peçenek Mah (büyükgüve Köyü)",
      "Salmanlı Köyü",
      "Sanayi Caddesi Mah (tatlıca Köyü)",
      "Sapmaz Köyü",
      "Sarıağıl Köyü",
      "Seleciköse Köyü",
      "Siyek Mevkii Mah (gökçe Köyü)",
      "Susadı Köyü",
      "Şahinler Mah (altınkaya Köyü)",
      "Şeyhler Köyü",
      "Taptuk Emre Köyü",
      "Tatlıca Köyü",
      "Ulukışlatolu Köyü",
      "Viranşehir Ve Dölek Mevki Mah (gökçe Köyü)",
      "Yağan Köyü",
      "Yalman Köyü",
      "Yalnızceviz Köyü",
      "Yanyurt Köyü",
      "Yapılcan Köyü",
      "Yeni Mah (altınkaya Köyü)",
      "Yeni Mah (doğantarla Köyü)",
      "Yeni Mah (sevinçli Köyü)",
      "Yenimahalle Mah",
      "Yeşilyur Mah (sapmaz Köyü)",
      "Zafer Mah",
      "Divanoğlu Mah (sağlık Beldesi)",
      "Fatih Mah (sağlık Beldesi)",
      "Yenimahalle Mah (sağlık Beldesi)",
      "Bayrambaba Mah",
      "Bedir Muhtar Mah",
      "Büyük Bölcek Mah",
      "Çerdiğin Mah",
      "Çiftlik Mah",
      "Hasas Mah",
      "Küçük Bölcek Mah",
      "Meydan Mah",
      "Nakkaş Mah",
      "Pamucak Mah",
      "Sanayi Mah",
      "Somuncu Baba Mah",
      "Şamlı Mah",
      "Şeyhhamit Mah",
      "Şifahane Mah",
      "Tacin Mah",
      "1.küme Mah (yenipınar Köyü)",
      "2.küme Mah (yenipınar Köyü)",
      "3.küme Mah (yenipınar Köyü)",
      "4.küme Mah (yenipınar Köyü)",
      "5.küme Mah (yenipınar Köyü)",
      "6.küme Mah (yenipınar Köyü)",
      "Akseki Mah (incesu Köyü)",
      "Camikebir Mah (incesu Köyü)",
      "Cumhuriyet Mah (karkın Köyü)",
      "Dikmen Köyü",
      "Elmacık Köyü",
      "Erenler Mah (taşpınar Beldesi)",
      "Erenler Osb Mah (taşpınar Beldesi)",
      "Genç Osman Mah (armutlu Köyü)",
      "Gözlükuyu Köyü",
      "Hürriyet Mah (akçakent Köyü)",
      "Karacaören Köyü",
      "Karşıyaka Mah (incesu Köyü)",
      "Kırımlı Osb Mah",
      "Koçpınar Köyü",
      "Vatan Mah (karkın Köyü)",
      "Yavuz Selim Mah (armutlu Köyü)",
      "Yavuz Selim Mah (taşpınar Beldesi)",
      "Yeni Cami Mah (taşpınar Beldesi)",
      "Yenikent Mah (akçakent Köyü)",
      "Yenipınar Köyü",
      "Fatih Mah (topakkaya Beldesi)",
      "Gülhane Mah (topakkaya Beldesi)",
      "Medeni Mah (topakkaya Beldesi)",
      "Yeşilçam Mah (topakkaya Beldesi)",
      "Gazi Mah (yenikent Beldesi)",
      "İstiklal Mah (yenikent Beldesi)",
      "Zafer Mah (yenikent Beldesi)",
      "Alasakallı Mah (yeşilova Beldesi)",
      "Darıhüyük Köyü",
      "Fatih Mah (ulukışla Köyü)",
      "Köseli Mah (yeşilova Beldesi)",
      "Parabaşlı Mah (yeşilova Beldesi)",
      "Yavuz Mah (ulukışla Köyü)",
      "Çalışkan Mah (yeşiltepe Beldesi)",
      "Fatih Mah (yeşiltepe Beldesi)",
      "Hürriyet Mah (yeşiltepe Beldesi)",
      "Zafer Mah (yeşiltepe Beldesi)"
    ],
    "Ortaköy": [
      "Aşağı Küme Mah (çatin Köyü)",
      "Aşağı Mah (ozancık Köyü)",
      "Bağ Kümesi Mah (çatin Köyü)",
      "Balcı Mah",
      "Caber Kümesi Mah (çatin Köyü)",
      "Ceceli Köyü",
      "Cumali Köyü",
      "Çatin Köyü",
      "Çetinkaya  Kümesi Mah (çatin Köyü)",
      "Durhasanlı Köyü",
      "Ekincioğlu Mah (sarıkaraman Köyü)",
      "Karamanoğlu Mah (sarıkaraman Köyü)",
      "Karşı Küme Mah (çatin Köyü)",
      "Karşı Mah (ozancık Köyü)",
      "Koceli Kümesi Mah (çatin Köyü)",
      "Kümbet Köyü",
      "Musalla Kümesi Mah (çatin Köyü)",
      "Orta Küme Mah (çatin Köyü)",
      "Pirli Köyü",
      "Reşadiye Köyü",
      "Salarıgödeler Köyü",
      "Satansarı Köyü",
      "Şener Kümesi Mah (çatin Köyü)",
      "Yeşilyurt Mah (sarıkaraman Köyü)",
      "Yukarı Mah (ozancık Köyü)",
      "Yunus Emre Mah (sarıkaraman Köyü)",
      "1. Küme Mah (akpınar Köyü)",
      "2.küme Mah (akpınar Köyü)",
      "2.küme Mah (seksenuşağı Köyü)",
      "3.küme Mah (akpınar Köyü)",
      "4.küme Mah (akpınar Köyü)",
      "Camızlık Yayla Mah (camuzluk Köyü)",
      "Camuzluk Köyü",
      "Cumhuriyet Mah (bozkır Köyü)",
      "Çokyatan Mah (hacımahmutuşağı Köyü)",
      "Gökkaya Köyü",
      "Gökler Köyü",
      "Gökler Mah (gökler Köyü)",
      "Hacıibrahimuşağı Köyü",
      "Hacımahmutuşağı Köyü",
      "Hıdırlı Köyü",
      "Hocabeyli Köyü",
      "Hürriyet Mah (harmandalı Köyü)",
      "İ.karapınar Mah (karapınar Köyü)",
      "Karapınar Köyü",
      "Karşıyaka Mah (harmandalı Köyü)",
      "Küme 1 Mah (seksenuşağı Köyü)",
      "Namlıkışla Köyü",
      "Oğuzlar 2 Mah (oğuzlar Köyü)",
      "Oğuzlar1 Mah (oğuzlar Köyü)",
      "Pınarbaşı Köyü",
      "Salarıalaca Köyü",
      "Seksenuşağı Köyü",
      "Şehit Ersoy Mah (çiftevi Köyü)",
      "Şehit Mehmet Ali Mah (çiftevi Köyü)",
      "Şht.yzb.bahtiyar Er Mah (devedamı Köyü)",
      "Yeşilyurt Mah (harmandalı Köyü)",
      "Yıldırımlar Köyü",
      "Yiğitler Mah (devedamı Köyü)",
      "Zafer Mah (bozkır Köyü)",
      "Zafer Mah (çiftevi Köyü)",
      "Çankaya Mah",
      "Esentepe Mah",
      "Fatih Mah",
      "İstiklal Mah",
      "Karşı Mah",
      "Kızılay Mah",
      "Maltepe Mah",
      "Mehmet Akif Ersoy Mah",
      "Plevne Mah",
      "Yeni Mah",
      "Zafer Mah"
    ],
    "Sarıyahşi": [
      "15 Temmuz Mah",
      "Bekdik Köyü",
      "Boğaziçi Mah (boğazköy Köyü)",
      "Demirciobası Köyü",
      "Kurtuluş Mah (boğazköy Köyü)",
      "Sipahiler Köyü",
      "Yaylak Mah (yaylak Köyü)",
      "Yeni Mah (boğazköy Köyü)",
      "Yenitorunobası Köyü",
      "Fatih Mah",
      "Karşıyaka Mah",
      "Kızılırmak Mah",
      "Kurtuluş Mah",
      "Özal Mah",
      "Şafaktepe Mah",
      "Yenidoğan Mah"
    ],
    "Sultanhanı": [
      "Cumhuriyet Mah",
      "Gazi Mah",
      "İstikamet Mah",
      "Koyuncu Mah",
      "Selçuk Mah",
      "Türkistan Mah",
      "Yeşiltömek Köyü",
      "Zafer Mah"
    ]
  },
  "Bayburt": {
    "Aydıntepe": [
      "Ahmet Yesevi Mah",
      "Aydıntepe Yaylası Mah",
      "Hacı Ali Efendi Mah",
      "Kale Mah",
      "Yakudiye Mah",
      "Akbulut Köyü",
      "Alaca Köyü",
      "Aşağıkırzı Köyü",
      "Başpınar Köyü",
      "Çatıksu Köyü",
      "Çayırköprü Köyü",
      "Çemçül Yayla Mah (kılıçkaya Köyü)",
      "Çiğdemlik Köyü",
      "Dumlu Köyü",
      "Erikdibi Köyü",
      "Gümüşdamla Mah (gümüşdamla Köyü)",
      "Günbuldu Köyü",
      "İncili Köyü",
      "Kavlatan Köyü",
      "Koşmer Mah (gümüşdamla Köyü)",
      "Merkez Mah (gümüşdamla Köyü)",
      "Merkez Mah (kılıçkaya Köyü)",
      "Pınargözü Köyü",
      "Sırataşlar Köyü",
      "Sorkunlu Köyü",
      "Suludere Köyü",
      "Şalcılar Köyü",
      "Yanoba Köyü",
      "Yapracık Köyü",
      "Yazlık Köyü",
      "Yukarıkırzı Köyü"
    ],
    "Demirözü": [
      "Çiftetaş Mah",
      "Esentepe Mah",
      "Güneşli Mah",
      "Şirin Mah",
      "Karşıyaka Mah (gökçedere Beldesi)",
      "Pınarbaşı Mah (gökçedere Beldesi)",
      "Yeşilyurt Mah (gökçedere Beldesi)",
      "Akyaka Köyü",
      "Bayrampaşa Köyü",
      "Çağıllı Köyü",
      "Çakırözü Köyü",
      "Çatalçeşme Köyü",
      "Çimentepe Köyü",
      "Damlıca Köyü",
      "Devetaşı Köyü",
      "Dikmetaş Köyü",
      "Elmalı Köyü",
      "Esenyurt Mah (beşpınar Köyü)",
      "Eymür Köyü",
      "Güçlü Köyü",
      "Güvercindere Köyü",
      "Işıkova Köyü",
      "Kalecik Köyü",
      "Karayaşmak Köyü",
      "Kavaklı Köyü",
      "Otlukbeli Köyü",
      "Petekli Köyü",
      "Pınarcık Köyü",
      "Serenli Köyü",
      "Yakupabdal Köyü",
      "Yazıbaşı Köyü",
      "Yelpınar Köyü",
      "Yeşilyurt Mah (beşpınar Köyü)",
      "Yukarıpınarlı Köyü"
    ],
    "Merkez": [
      "Cumhuriyet Mah (arpalı Beldesi)",
      "Çiçekli Mah (arpalı Beldesi)",
      "Hürriyet Mah (arpalı Beldesi)",
      "Camiikebir Mah",
      "Esentepe Mah",
      "Gençosman Mah",
      "Halfikale  Mah (kaleardı Mah)",
      "Kadızade Mah",
      "Karasakal Mah",
      "Mehmet Çelebi Mah",
      "Şeyhhayran Mah",
      "Şingah Mah",
      "Tuzcuzade Mah",
      "Uzungazi Mah",
      "Velişaban Mah",
      "Veysel Mah",
      "Zahit Mah",
      "A.gençosman Mah (gençosman Köyü)",
      "A.örence Hanları Mah (örence Köyü)",
      "Ağören Köyü",
      "Akduran Köyü",
      "Aşağı Gez Mah (gez Köyü)",
      "Aşağı Kıratlı Mah (kıratlı Köyü)",
      "Çalıdere Hanları Mah (çalıdere Köyü)",
      "Demirkaş Köyü",
      "Dereçımağıl Mah (başçımağıl Köyü)",
      "Durusu Mah (yaylapınar Köyü)",
      "Helva Köyü",
      "Iğdır Köyü",
      "Kaleboynu Mah (örence Köyü)",
      "Kuzular Mah (yaylapınar Köyü)",
      "Maden Köyü",
      "Merkez Mah (aşağıçımağıl Köyü)",
      "Merkez Mah (başçımağıl Köyü)",
      "Merkez Mah (çalıdere Köyü)",
      "Merkez Mah (gençosman Köyü)",
      "Merkez Mah (kıratlı Köyü)",
      "Merkez Mah (kop Köyü)",
      "Merkez Mah (masat Köyü)",
      "Merkez Mah (örence Köyü)",
      "Merkez Mah (yaylapınar Köyü)",
      "Ortaçımağıl Köyü",
      "Ortakop Mah (kop Köyü)",
      "Petekkaya Köyü",
      "Sığırcı Köyü",
      "Şehitlik Mah (kop Köyü)",
      "Taşçılar Köyü",
      "Taşın Dibi Mah (aşağıçımağıl Köyü)",
      "Taşın Dibi Mah (örence Köyü)",
      "Yukarı Gez Mah (gez Köyü)",
      "Yukarı Kop Mah (kop Köyü)",
      "Yukarı Masat Mah (masat Köyü)",
      "Adabaşı Köyü",
      "Akçakuzu Köyü",
      "Aksaçlı Köyü",
      "Alapelit Köyü",
      "Alıçlık Köyü",
      "Ardıçgöze Köyü",
      "Armutlu Köyü",
      "Arslandede Köyü",
      "Aşağı Gümüşsu Mah (gümüşsu Köyü)",
      "Aşağı Taşocağı Mah (taşocağı Köyü)",
      "Aşağı Yoncalı Mah (yoncalı Köyü)",
      "Aşağıkışlak Köyü",
      "Aşağıpınarlı Köyü",
      "Aydıncık Köyü",
      "Balca Köyü",
      "Balkaynak Köyü",
      "Ballıkaya Köyü",
      "Bayırtepe Köyü",
      "Bayraktar Köyü",
      "Buğdaylı Köyü",
      "Çakırbağ Köyü",
      "Çamdere Köyü",
      "Çamlıkoz Köyü",
      "Çatılar Mah (sancaktepe Köyü)",
      "Çayırözü Köyü",
      "Çiğdemtepe Köyü",
      "Çorak Köyü",
      "Dağçatı Köyü",
      "Dağtarla Köyü",
      "Danişment Köyü",
      "Değirmencik Köyü",
      "Demirışık Köyü",
      "Dikmetaş Köyü",
      "Dövmekaya Köyü",
      "Erenler Mah (güneydere Köyü)",
      "Erenli Köyü",
      "Esentepe Mah (akşar Köyü)",
      "Fatih Mah (konursu Köyü)",
      "Gökçeli Köyü",
      "Gökler Köyü",
      "Gökpınar Köyü",
      "Göldere Köyü",
      "Güder Köyü",
      "Güllüce Köyü",
      "Gültepe Mah (akşar Köyü)",
      "Günlüce Mah (uluçayır Köyü)",
      "Güzelce Köyü",
      "Hacıoğlu Köyü",
      "Harmanözü Köyü",
      "Heybetepe Köyü",
      "Kabaçayır Köyü",
      "Karlıca Köyü",
      "Karşıgeçit Köyü",
      "Karşıyaka Mah (nişantaşı Köyü)",
      "Kavacık Köyü",
      "Kavakyanı Köyü",
      "Kemertaş Köyü",
      "Kırkpınar Köyü",
      "Kızılcaören Mah (yerlice Köyü)",
      "Koçbayır Köyü",
      "Kopuz Köyü",
      "Kozluk Köyü",
      "Kurbanpınar Köyü",
      "Kurcakol Mah (yeşilyurt Köyü)",
      "Kurugüney Köyü",
      "Kutlubey Mah (çayıryolu Köyü)",
      "Manas Köyü",
      "Merkez Mah (çerçi Köyü)",
      "Merkez Mah (darıca Köyü)",
      "Merkez Mah (göloba Köyü)",
      "Merkez Mah (gümüşsu Köyü)",
      "Merkez Mah (güneydere Köyü)",
      "Merkez Mah (kitre Köyü)",
      "Merkez Mah (nişantaşı Köyü)",
      "Merkez Mah (sancaktepe Köyü)",
      "Merkez Mah (taşocağı Köyü)",
      "Merkez Mah (uğrak Köyü)",
      "Merkez Mah (uluçayır Köyü)",
      "Merkez Mah (üzengili Köyü)",
      "Merkez Mah (yazyurdu Köyü)",
      "Merkez Mah (yerlice Köyü)",
      "Merkez Mah (yoncalı Köyü)",
      "Mutlu Köyü",
      "Oruçbeyli Köyü",
      "Ozansu Köyü",
      "Pamuktaş Köyü",
      "Pelitli Köyü",
      "Polatlı Köyü",
      "Rüştü Köyü",
      "Sakızlı Köyü",
      "Salkımsu Köyü",
      "Saraycık Köyü",
      "Sarıhan Köyü",
      "Sarımeşe Köyü",
      "Seydiyakup Köyü",
      "Sırakayalar Köyü",
      "Soğukgöze Köyü",
      "Söğütlü Köyü",
      "Şehit Mete Mah (çayıryolu Köyü)",
      "Taht Köyü",
      "Taşburun Köyü",
      "Taşkesen Köyü",
      "Tepetarla Köyü",
      "Tomlacık Köyü",
      "Uğur Mah (kitre Köyü)",
      "Uğurgeldi Köyü",
      "Y.çerçi Mah (çerçi Köyü)",
      "Yamalı Yaylası Mah (yazyurdu Köyü)",
      "Yanıkçam Köyü",
      "Yavuz Mah (konursu Köyü)",
      "Yayla Evleri Mah (göloba Köyü)",
      "Yayla Evleri Mah (üzengili Köyü)",
      "Yaylalar Köyü",
      "Yedigöze Köyü",
      "Yeniköy Köyü",
      "Yeşilyurt Köyü",
      "Yolaltı Köyü",
      "Yolaltı Osb Mah (yolaltı Köyü)",
      "Yukarı Darıca Mah (darıca Köyü)",
      "Yukarı Uğrak Mah (uğrak Köyü)",
      "Yukarıkışlak Köyü"
    ]
  },
  "Karaman": {
    "Ayrancı": [
      "Dede Mah",
      "Musa Mah",
      "Ulu Mah",
      "Yeni Mah",
      "Ağızboğaz Köyü",
      "Akoluk Mah (berendi Köyü)",
      "Akpınar Köyü",
      "Ambar Köyü",
      "Andıkara Mah (akpınar Köyü)",
      "Aşağı Kıramanoğlu Mah (berendi Köyü)",
      "Başçayır Mah (kavaközü Köyü)",
      "Berendi Köyü",
      "Böğecik Köyü",
      "Buğdaylı Köyü",
      "Büyükkoraş Köyü",
      "Çatköy Köyü",
      "Divle Köyü",
      "Dokuzyol Köyü",
      "Elfetin Mah (kavaközü Köyü)",
      "Güneydağı Mah (divle Köyü)",
      "Hüyükburun Köyü",
      "Kaleköy Köyü",
      "Karaağaç Köyü",
      "Kavaközü Köyü",
      "Kavuklar Köyü",
      "Kayaönü Köyü",
      "Keşir Mah (berendi Köyü)",
      "Kıraman Köyü",
      "Kıramanoğlu Mah (berendi Köyü)",
      "Küçükkoraş Köyü",
      "Melikli Köyü",
      "Pınarkaya Köyü",
      "Sarayköy Köyü",
      "Sarıkaya Mah (berendi Köyü)",
      "Savran Mah (böğecik Köyü)",
      "Yarıkkuyu Köyü"
    ],
    "Başyayla": [
      "Başköy Mah",
      "Göztepe Mah",
      "Kirazlıyayla Mah",
      "Şirindere Mah",
      "Yenimahalle Mah",
      "Bozyaka Köyü",
      "Büyükkarapınar Köyü",
      "Kışlaköy Köyü",
      "Söğütlü Mah (üzümlü Köyü)",
      "Üzümlü Köyü",
      "Yenice Mah (kışlaköy Köyü)"
    ],
    "Ermenek": [
      "Akcamescit Mah",
      "Başpınar Mah",
      "Çınarlısu Mah",
      "Değirmenlik Mah",
      "Güllük Mah",
      "Gülpazar Mah",
      "Karalar Mah",
      "Kebendibi Mah",
      "Keçipazar Mah",
      "Keşillik Mah",
      "Meydan Mah",
      "Orta Mah",
      "Sandıklı Mah",
      "Seyran Mah",
      "Susaklı Mah",
      "Taşbaşı Mah",
      "Aralık Mah (güneyyurt Beldesi)",
      "Cami Mah (güneyyurt Beldesi)",
      "Habib Mah (güneyyurt Beldesi)",
      "Kışlacık Mah (güneyyurt Beldesi)",
      "Oda Mah (güneyyurt Beldesi)",
      "Orta Mah (güneyyurt Beldesi)",
      "Pınargözü Mah (güneyyurt Beldesi)",
      "Yenimahalle Mah (güneyyurt Beldesi)",
      "Aşağı Mah (sarıvadi Köyü)",
      "Beliçekkoz Mah (ikizçınar Köyü)",
      "Bucak Mah (kazancı Beldesi)",
      "Çatalbadem Mah (kazancı Beldesi)",
      "Değirmen Mah (ardıçkaya Köyü)",
      "Gökceler Mah (kazancı Beldesi)",
      "Gökçekent Köyü",
      "Havuz Merkez Mah (ikizçınar Köyü)",
      "Merkez Mah (kazancı Beldesi)",
      "Tepecik Mah (kazancı Beldesi)",
      "Türbeseki Mah (kazancı Beldesi)",
      "Uluköy Mah (kazancı Beldesi)",
      "Yaylapazarı Köyü",
      "Yeşilköy Köyü",
      "Yukarı Mah (kazancı Beldesi)",
      "Yukarı Mah (sarıvadi Köyü)",
      "Ağaççatı Köyü",
      "Aşağıçağlar Köyü",
      "Avcılar Mah (evsin Köyü)",
      "Balkusan Köyü",
      "Belen Mah (gökceseki Köyü)",
      "Belen Mah (yalındal Köyü)",
      "Boyalık Köyü",
      "Bozyaka Mah (elmayurdu Köyü)",
      "Çamlıca Köyü",
      "Çarıklı Mah (görmeli Köyü)",
      "Çatalarmut Mah (görmeli Köyü)",
      "Çavuş Köyü",
      "Çayırlıalan Mah (görmeli Köyü)",
      "Eskice Köyü",
      "Evsin Köyü",
      "Göbette Mah (görmeli Köyü)",
      "Gökceseki Köyü",
      "Güneri Mah (yalındal Köyü)",
      "Güney Mah (aşağıçağlar Köyü)",
      "Harmanbağı Mah (aşağıçağlar Köyü)",
      "Hatilla Mah (elmayurdu Köyü)",
      "İğdeyakası Mah (yalındal Köyü)",
      "Katranlı Köyü",
      "Kayaönü Köyü",
      "Kışla Mah (görmeli Köyü)",
      "Kızılalan Mah (gökceseki Köyü)",
      "Köprübaşı Mah (görmeli Köyü)",
      "Köprübaşı Mah (kayaönü Köyü)",
      "Köyyakası Mah (görmeli Köyü)",
      "Kumyaka Mah (elmayurdu Köyü)",
      "Mezarlıalan Mah (görmeli Köyü)",
      "Nisa Mah (görmeli Köyü)",
      "Olukpınar Köyü",
      "Pamuklu Köyü",
      "Pınarönü Köyü",
      "Şahinler Mah (yerbağ Köyü)",
      "Taştekne Mah (tepebaşı Köyü)",
      "Tekke Mah (görmeli Köyü)",
      "Tepebaşı Köyü",
      "Ülüğer Mah (pamuklu Köyü)",
      "Yerbağ Köyü",
      "Yolçatı Mah (elmayurdu Köyü)",
      "Yukarıçağlar Köyü"
    ],
    "Kazımkarabekir": [
      "Boyacı Mah",
      "Eminettin Mah",
      "Emsalhayat Mah",
      "Oba Mah",
      "Pazar Mah",
      "Selçuklu Mah",
      "Subaşı Mah",
      "Timsal Mah",
      "Akarköy Köyü",
      "Karalgazi Köyü",
      "Kızılkuyu Köyü",
      "Mecidiye Köyü",
      "Özyurt Köyü",
      "Sinci Köyü"
    ],
    "Merkez": [
      "Atatürk Mah",
      "Atatürk Mah (akçaşehir Beldesi)",
      "Fatih Mah",
      "Fatih Mah (akçaşehir Beldesi)",
      "Gazi Mah (akçaşehir Beldesi)",
      "Hürriyet Mah",
      "Hürriyet Mah (akçaşehir Beldesi)",
      "Abbas Mah",
      "Ahmet Yesevi Mah",
      "Beyazkent Mah",
      "Çeltek Mah",
      "Elmaşehir Mah",
      "Gazidükkan Mah",
      "Gevher Hatun Mah",
      "Hisar Mah",
      "İbrahim Hakkı Konyalı Mah",
      "İmaret Mah",
      "Karamanoğlu Mehmet Bey Mah",
      "Kırbağı Mah",
      "Koçakdede Mah",
      "Mansurdede Mah",
      "Mehmet Akif Ersoy Mah",
      "Mümine Hatun Mah",
      "Osmangazi Mah",
      "Sakabaşı Mah",
      "Sekiçeşme Mah",
      "Siyahser Mah",
      "Şeyh Edebali Mah",
      "Tabduk Emre Mah",
      "Topucak Mah",
      "Urgan Mah",
      "Yeşilada Mah",
      "Yunus Emre Mah",
      "Yunuskent Mah",
      "Zembilli Ali Efendi Mah",
      "Ziya Gökalp Mah",
      "Ada Köyü",
      "Adaysız Mah (cerit Köyü)",
      "Ağaçlı Mah (erenkavak Köyü)",
      "Ağaçyurdu Köyü",
      "Ağılönü Köyü",
      "Akçaalan Köyü",
      "Akpınar Köyü",
      "Alaçatı Köyü",
      "Aliağa Mah (taşkale Köyü)",
      "Araköy Mah (cerit Köyü)",
      "Arnavut Mah (kozlubucak Köyü)",
      "Aşağı Mah (burhan Köyü)",
      "Aşağı Mah (ihsaniye Köyü)",
      "Aşağı Mah (paşabağı Köyü)",
      "Aşağı Yayla Mah (ortaoba Köyü)",
      "Aşağıakın Köyü",
      "Aşağıkızılca Köyü",
      "Atatürk Mah (kılbasan Köyü)",
      "Atatürk Mah (kisecik Köyü)",
      "Atatürk Mah (taşkale Köyü)",
      "Aybastı Köyü",
      "Bademli Köyü",
      "Bağdat Mah (akçaalan Köyü)",
      "Bağlıbük Mah (elmadağı Köyü)",
      "Bağlık Mah (burhan Köyü)",
      "Bahçelievler Mah (pınarbaşı Köyü)",
      "Barutkavuran Köyü",
      "Başkışla Köyü",
      "Bayır Köyü",
      "Belvaryolu Mah (burhan Köyü)",
      "Beydili Köyü",
      "Bostanözü Köyü",
      "Boyacı Mah (kılbasan Köyü)",
      "Boyalı Köyü",
      "Bozkandak Köyü",
      "Bölükyazı Köyü",
      "Bucakkışla Köyü",
      "Camikebir Mah (yollarbaşı Köyü)",
      "Cumhuriyet Mah (kisecik Köyü)",
      "Cumhuriyet Mah (süleymanhacı Köyü)",
      "Çakırbağ Köyü",
      "Çakırdağ Mah (burunoba Köyü)",
      "Çamlık Mah (burhan Köyü)",
      "Çarşı Mah (kılbasan Köyü)",
      "Çatak Köyü",
      "Çavuşpınarı Köyü",
      "Çıkmaz Mah (burhan Köyü)",
      "Çiğdemli Köyü",
      "Çimen Mah (narlıdere Köyü)",
      "Çimenkuyu Köyü",
      "Çoğlu Köyü",
      "Çukur Köyü",
      "Çukurbağ Köyü",
      "Dağkonak Köyü",
      "Damlapınar Köyü",
      "Değirmenbaşı Köyü",
      "Demiryurt Köyü",
      "Denircik Mah (yeşildere Köyü)",
      "Dere Köyü",
      "Develi Mah (elmadağı Köyü)",
      "Dinek Köyü",
      "Duma Mah (morcalı Köyü)",
      "Düz Mah (kameni Köyü)",
      "Eğilmez Köyü",
      "Eminler Köyü",
      "Esentepe Mah (çakırbağ Köyü)",
      "Eskiköy Mah (aybastı Köyü)",
      "Göçer Köyü",
      "Gökçe Köyü",
      "Gökçepınar Mah (bayır Köyü)",
      "Göztepe Köyü",
      "Güçler Köyü",
      "Güldere Köyü",
      "Gülkaya Köyü",
      "Gümüşkuyu Mah (özdemir Köyü)",
      "Habacı Mah (çukurbağ Köyü)",
      "Hacı İlyas Mah (yeşildere Köyü)",
      "Hacı İlyas Mah (yollarbaşı Köyü)",
      "Hacıbayram Mah (yeşildere Köyü)",
      "Hamidiye Köyü",
      "Harman Mah (burhan Köyü)",
      "Hinsar Mah (burhan Köyü)",
      "İbrahim Fakı Mah (yollarbaşı Köyü)",
      "İmamlar Mah (kılbasan Köyü)",
      "İmamoğlu Mah (kılbasan Köyü)",
      "İslihisar Köyü",
      "İstasyon Mah (burhan Köyü)",
      "İstasyon Mah (demiryurt Köyü)",
      "Kalaba Köyü",
      "Kameni Köyü",
      "Karacaören Köyü",
      "Karamanoğlu Mehmet Bey Mah (kılbasan Köyü)",
      "Kasım Mescit Mah (taşkale Köyü)",
      "Kaşıkçı Mah (cerit Köyü)",
      "Kaşoba Köyü",
      "Kayaönü Mah (yeşildere Köyü)",
      "Kayapınar Mah (göçer Köyü)",
      "Kaynar Mah (lale Köyü)",
      "Kır Mah (burhan Köyü)",
      "Kızık Köyü",
      "Kızıllarağını Köyü",
      "Kızılyaka Köyü",
      "Kovalıöz Mah (değirmenbaşı Köyü)",
      "Kozlubucak Köyü",
      "Kumoba Mah (çoğlu Köyü)",
      "Kurtderesi Köyü",
      "Kurucabel Köyü",
      "Lale Köyü",
      "Madenşehri Köyü",
      "Maşat Mah (cerit Köyü)",
      "Medreselik Köyü",
      "Merkez Mah (burunoba Köyü)",
      "Merkez Mah (cerit Köyü)",
      "Merkez Mah (dere Köyü)",
      "Merkez Mah (ekinözü Köyü)",
      "Merkez Mah (elmadağı Köyü)",
      "Merkez Mah (erenkavak Köyü)",
      "Merkez Mah (ortaoba Köyü)",
      "Merkez Mah (üçkuyu Köyü)",
      "Mesudiye Köyü",
      "Morcalı Köyü",
      "Muratdede Köyü",
      "Musalla Mah (burhan Köyü)",
      "Narlıdere Köyü",
      "Nunu Mah (çatak Köyü)",
      "Ortacami Mah (taşkale Köyü)",
      "Osmaniye Köyü",
      "Otuk Yayla Mah (kalaba Köyü)",
      "Özalan Mah (lale Köyü)",
      "Özdemir Köyü",
      "Pamukdere Mah (göçer Köyü)",
      "Paşabağı Köyü",
      "Pelitli Mah (özdemir Köyü)",
      "Perenti Mah (ekinözü Köyü)",
      "Pınarbaşı Köyü",
      "Salur Köyü",
      "Sarıkaya Köyü",
      "Sarnıç Mah (göçer Köyü)",
      "Sazlıyaka Köyü",
      "Seyithasan Köyü",
      "Sorgun Mah (yılangömü Köyü)",
      "Süleymanhacı Köyü",
      "Şahinbükü Mah (çatak Köyü)",
      "Şeyhler Köyü",
      "Tabanlı Mah (aybastı Köyü)",
      "Tarlaören Köyü",
      "Taşmescit Mah (taşkale Köyü)",
      "Tavşanlı Köyü",
      "Topalhacı Ciftliği Mah (ihsaniye Köyü)",
      "Tutlutepe Mah (çavuşpınarı Köyü)",
      "Ulupınar Mah (kisecik Köyü)",
      "Uzunkuyu Mah (çoğlu Köyü)",
      "Uzunkuyu Mah (kameni Köyü)",
      "Üçbaş Köyü",
      "Üzümlü Mah (aybastı Köyü)",
      "Yassı Tepe Mah (üçkuyu Köyü)",
      "Yayladede Mah (başkışla Köyü)",
      "Yazılı Köyü",
      "Yedipınar Mah (dere Köyü)",
      "Yemişli Mah (aybastı Köyü)",
      "Yeşildere Toki Yunus Emre Mah (yeşildere Köyü)",
      "Yılangömü Köyü",
      "Yörükler Mah (başkışla Köyü)",
      "Yukarı Mah (ihsaniye Köyü)",
      "Yukarı Yayla Mah (ortaoba Köyü)",
      "Yukarıakın Köyü",
      "Yukarıkızılca Köyü",
      "Yunus Mah (dere Köyü)",
      "Yuvatepe Köyü",
      "Zengen Köyü",
      "Bahçelievler Mah",
      "Bahçelievler Mah (sudurağı Beldesi)",
      "Cumhuriyet Mah",
      "Cumhuriyet Mah (sudurağı Beldesi)",
      "Ketenci Mah (sudurağı Beldesi)",
      "Ahiosman Mah",
      "Alacasuluk Mah",
      "Alişahane Mah",
      "Başakşehir Mah",
      "Cedit Mah",
      "Fenari Mah",
      "Hacıcelal Mah",
      "Hamidiye Mah",
      "Kazım Karabekir Paşa Mah",
      "Kirişçi Mah",
      "Külhan Mah",
      "Larende Mah",
      "Mahmudiye Mah",
      "Nefise Sultan Mah",
      "Organize Sanayii Bölgesi Mah",
      "Pirireis Mah",
      "Rauf Denktaş Mah",
      "Sümer Mah",
      "Şeyh Şamil Mah",
      "Tahsin Ünal Mah",
      "Üniversite Mah",
      "Valide Sultan Mah",
      "Yenimahalle Mah",
      "Yenişehir Mah"
    ],
    "Sarıveliler": [
      "Boyunağıl Mah (uğurlu Köyü)",
      "Cumhuriyet Mah (göktepe Beldesi)",
      "Çetince Önü Mah (uğurlu Köyü)",
      "Çevlik Başı Mah (uğurlu Köyü)",
      "Çukurbağ Mah (göktepe Beldesi)",
      "Dikenli Mah (dumlugöze Köyü)",
      "Esentepe Mah (göktepe Beldesi)",
      "Gezirail Mah (uğurlu Köyü)",
      "Göksu Mah (göktepe Beldesi)",
      "Gülpazar Mah (göktepe Beldesi)",
      "Günder Mah (göktepe Beldesi)",
      "Hesbek Mah (uğurlu Köyü)",
      "Kale Döşeği Mah (uğurlu Köyü)",
      "Merkez Mah (koçaşlı Köyü)",
      "Pireli/aşakbel-geven-dikenli-ormanlı-çukur-çetincy Mah (dumlugöze Köyü)",
      "Sıtma Pınarı Mah (uğurlu Köyü)",
      "Yeşilyurt Mah (göktepe Beldesi)",
      "Yıldız Mah (göktepe Beldesi)",
      "Civandere Köyü",
      "Civler Köyü",
      "Çulhalar-kızılçukur-aşağı Süvari-yukarı-sivarı-ala Mah (dumlugöze Köyü)",
      "Daran Köyü",
      "Dumlugöze Köyü",
      "Göksu Mah (koçaşlı Köyü)",
      "Işıklı Köyü",
      "Kaynarca Mah (uğurlu Köyü)",
      "Manastır Mah (uğurlu Köyü)",
      "Nacı Ali Yurdu Mah (uğurlu Köyü)",
      "Pireli/aşakbel Mah (dumlugöze Köyü)",
      "Uğurlu Köyü",
      "Yayla Evleri Mah (koçaşlı Köyü)",
      "Yaylalar Mah (daran Köyü)",
      "Adiller Mah",
      "Baş Mah",
      "Çakıllar Mah",
      "Karakaya Mah",
      "Küçük Karapınar Mah",
      "Mençek Mah",
      "Merkez Mah",
      "Ortaköy Mah",
      "Turcalar Mah",
      "Ulucami Mah",
      "Yeşilyurt Mah"
    ]
  },
  "Kırıkkale": {
    "Bahşılı": [
      "Atadönmez Mah",
      "Doğanay Mah",
      "Halim Şenses Mah",
      "Hidayet Doğruer Mah",
      "Hüseyin Onbaşı Mah",
      "Bağevleri Mah (çamlıca Köyü)",
      "Bahçelievler Mah (karaahmetli Köyü)",
      "Çamlıca Köyü",
      "Denizli Ercanlar Mah (küreboğazı Köyü)",
      "Esentepe Mah (karaahmetli Köyü)",
      "Küçüksarıkayalar Köyü",
      "Küreboğazı Köyü",
      "Sarıkayalar Köyü",
      "Yayla Evleri Mah (küreboğazı Köyü)",
      "Yaylaevi Mah (çamlıca Köyü)",
      "Yeşil Konak Mah (karaahmetli Köyü)"
    ],
    "Balışeyh": [
      "Ballı Mah",
      "Oba Mah",
      "Toki Mah",
      "Yeni Mah",
      "Akçakavak Köyü",
      "Aşağıkarakısık Köyü",
      "Aydınşıh Köyü",
      "Ayvaderesi Mah (kenanoba Köyü)",
      "Azgın Yaylası Mah (kenanoba Köyü)",
      "Bağlarbaşı Mah (koçubaba Köyü)",
      "Bahçelievler Mah (koçubaba Köyü)",
      "Battaloba Köyü",
      "Beşbıçak Köyü",
      "Beyobası Köyü",
      "Bıyıkaydın Köyü",
      "Dikmen Köyü",
      "Dostlar Mah (koçubaba Köyü)",
      "Eldelek Köyü",
      "Eldelek Mah (beyobası Köyü)",
      "Esentepe Mah (mehmetbeyobası Köyü)",
      "Fatih Mah (kulaksız Köyü)",
      "Gazi Mah (kulaksız Köyü)",
      "Hıdırşıh Köyü",
      "Hüseyinoba Köyü",
      "Işıklar Köyü",
      "İzzettin Köyü",
      "Karahocalı Mah (kılevli Köyü)",
      "Karalı Köyü",
      "Kargın Köyü",
      "Kenanoba Köyü",
      "Kılevli Köyü",
      "Kırlangıç Köyü",
      "Kösedurak Köyü",
      "Kuşburnu Mah (mehmetbeyobası Köyü)",
      "Mehmetbeyobası Köyü",
      "Mevki Mah (izzettin Köyü)",
      "Selamlı Köyü",
      "Ufuk Mah (kulaksız Köyü)",
      "Ulaklı Köyü",
      "Uzunlar Köyü",
      "Yassıbağ Mah (kenanoba Köyü)",
      "Yenice Köyü",
      "Yenilli Köyü",
      "Yukarıkarakısık Köyü"
    ],
    "Çelebi": [
      "Barbaros Mah",
      "Fatih Mah",
      "Gülveren Mah",
      "Yeni Mah",
      "Alıcıyeniyapan Köyü",
      "Hacıyusuflu Köyü",
      "Halildede Köyü",
      "İğdebeli Köyü",
      "Kaldırım Köyü",
      "Karaağaç Köyü",
      "Karaağıl Köyü",
      "Karabucak Köyü",
      "Karahacılı Köyü",
      "Karayakup Köyü",
      "Kepirli Köyü",
      "Tilkili Köyü",
      "Yukarışıh Köyü"
    ],
    "Delice": [
      "Gökçebel Mah (çerikli Beldesi)",
      "Merkez Mah (çerikli Beldesi)",
      "Sakarya Mah (çerikli Beldesi)",
      "Yeni Mah (çerikli Beldesi)",
      "Yerlikent Mah (çerikli Beldesi)",
      "Aktepe Mah",
      "Cumhuriyet Mah",
      "Fatih Mah",
      "Fevzi Çakmak Mah",
      "Gündüz Mah",
      "Hürriyet Mah",
      "Karabekir Mah",
      "Mimar Sinan Mah",
      "Akboğaz Köyü",
      "Alcılı Köyü",
      "Arbişli Köyü",
      "Aşağıihsangazili Köyü",
      "Avşar Mah (büyükafşar Köyü)",
      "Aydınlar Mah (büyükyağlı Köyü)",
      "Bahçelievler Mah (büyükafşar Köyü)",
      "Bahçelievler Mah (büyükyağlı Köyü)",
      "Baraklı Köyü",
      "Boğaziçi Mah (büyükafşar Köyü)",
      "Bozköy Köyü",
      "Coğul Köyü",
      "Cumhuriyet Mah (büyükyağlı Köyü)",
      "Çatallı Köyü",
      "Çatallıkarakoyunlu Köyü",
      "Çongar Köyü",
      "Dağobası Köyü",
      "Derekışla Köyü",
      "Doğanören Köyü",
      "Elmalı Köyü",
      "Evliyalı Köyü",
      "Fadılobası Köyü",
      "Gözükızıllı Köyü",
      "Hacıobası Köyü",
      "Halitli Köyü",
      "Herekli Köyü",
      "İmirli Köyü",
      "Karaköseli Köyü",
      "Karpuz Köyü",
      "Karşıyaka Mah (büyükafşar Köyü)",
      "Kavakköy Köyü",
      "Kocabaş Köyü",
      "Kurtoğlu Köyü",
      "Kuzayyurt Köyü",
      "Küçükafşar Köyü",
      "Meşeyayla Köyü",
      "Ocakbaşı Köyü",
      "Sarıyaka Köyü",
      "Şahcalı Köyü",
      "Taşyazı Köyü",
      "Tatlıcak Köyü",
      "Tavaözü Köyü",
      "Tekkeköy Köyü",
      "Yaylayurt Köyü",
      "Yeni Mah (büyükafşar Köyü)",
      "Yeni Mah (büyükyağlı Köyü)",
      "Yeniyapan Köyü",
      "Yıldız Mah (büyükyağlı Köyü)"
    ],
    "Karakeçili": [
      "Fatih Sultan Mehmet Mah",
      "Hoca Ahmet Yesevi Mah",
      "Karşıyaka Mah",
      "Kurtuluş Mah",
      "Mareşal Fevzi Çakmak Mah",
      "Yavuz Sultan Selim Mah",
      "Yeşilevler Mah",
      "Zafer Mah",
      "Akkoşan Köyü",
      "Sulubük Köyü"
    ],
    "Keskin": [
      "Altuntaş Mah",
      "Bozkurt Mah",
      "Gündoğdu Mah",
      "Maden Mah",
      "Yeni Mah",
      "Yenice Mah",
      "Acıçiftliği Mah (ceritobası Köyü)",
      "Armutlu Köyü",
      "Aşağı Olunlu Mah (olunlu Köyü)",
      "Aşağışıh Köyü",
      "Bahçelievler Mah (konur Köyü)",
      "Barak Köyü",
      "Barakobası Köyü",
      "Beşler Köyü",
      "Büyükceceli Köyü",
      "Cabatobası Köyü",
      "Cankurtaran Köyü",
      "Cebrailli Köyü",
      "Ceritkale Köyü",
      "Ceritobası Köyü",
      "Cinali Köyü",
      "Çalış Köyü",
      "Çamurabatmaz Köyü",
      "Çipideresi Köyü",
      "Dağsolaklısı Köyü",
      "Danacıobası Köyü",
      "Efendiköy Köyü",
      "Elifoğlu Mah (barakobası Köyü)",
      "Eminefendi Köyü",
      "Eroğlu Köyü",
      "Esatmüminli Köyü",
      "Eskialibudak Köyü",
      "Fatih Mah (köprüköy Köyü)",
      "Gazibeyli Köyü",
      "Göçbeyli Köyü",
      "Göktaş Köyü",
      "Gülkonak Köyü",
      "Güneş Mah (ceritmüminli Köyü)",
      "Güzelyaka Mah (konur Köyü)",
      "Hacıaliobası Köyü",
      "Hacıömersolaklısı Köyü",
      "Hamit Mevki Mah (cinali Köyü)",
      "Haydardede Köyü",
      "İnziloğlu Köyü",
      "Kaçakköy Köyü",
      "Karafakılı Köyü",
      "Karşıyaka Mah (konur Köyü)",
      "Karşıyaka Mah (köprüköy Köyü)",
      "Kasımağa Köyü",
      "Kavlak Köyü",
      "Kavurgalı Köyü",
      "Kayalaksolaklısı Köyü",
      "Keskinkayalar Mah (çipideresi Köyü)",
      "Kevenli Köyü",
      "Konurhacıobası Köyü",
      "Köşker Mah (büyükceceli Köyü)",
      "Kurşunkaya Köyü",
      "Kuzugüdenli Köyü",
      "Kürek Mah (çipideresi Köyü)",
      "Müsellim Köyü",
      "Olunlu Köyü",
      "Organize Sanayi Bölgesi Mah (cankurtaran Köyü)",
      "Ortasöken Köyü",
      "Ömerin Mah (barakobası Köyü)",
      "Polatyurdu Köyü",
      "Seyfli Köyü",
      "Takazlı Köyü",
      "Tandoğan Mah (ceritmüminli Köyü)",
      "Taşlık Mah (barakobası Köyü)",
      "Topallar Mah (çipideresi Köyü)",
      "Turhanlı Köyü",
      "Ufuk Mah (ceritmüminli Köyü)",
      "Üçevler Köyü",
      "Üçkuyu Köyü",
      "Yeni Mah (köprüköy Köyü)",
      "Yenialibudak Köyü",
      "Yenimerden Mah (ceritobası Köyü)",
      "Yeniyapan Köyü",
      "Yeşiltaş Mah (konur Köyü)",
      "Yoncalı Köyü"
    ],
    "Merkez": [
      "Aşağımahmutlar Mah",
      "Çalılıöz Mah",
      "Çullu Mah",
      "Fabrikalar Mah",
      "Yaylacık Mah",
      "Yenimahalle Mah",
      "Altınova Mah (hacılar Beldesi)",
      "Hacıbey Mah (hacılar Beldesi)",
      "Sağlık Mah (hacılar Beldesi)",
      "Bağlar Mah (hasandede Köyü)",
      "Bahçelievler Mah (hasandede Köyü)",
      "Dağevi Köyü",
      "Gülevler Mah (hasandede Köyü)",
      "Gündoğdu Mah (hasandede Köyü)",
      "Karacaali Köyü",
      "Kazmaca Köyü",
      "Kızıldere Köyü",
      "Ömerli Mah (ahılı Köyü)",
      "Pazarcık Köyü",
      "Pınarbaşı Mah (ahılı Köyü)",
      "Tekke Mah (ahılı Köyü)",
      "Ulaş Köyü",
      "Yukarımahmutlar Köyü",
      "Akşemsettin Mah",
      "Bağlarbaşı Mah",
      "Etiler Mah",
      "Fatih Mah",
      "Gündoğdu Mah",
      "Kaletepe Mah",
      "Kırıkköyü Mah",
      "Osmangazi Mah",
      "Sanayi Mah",
      "Gürler Mah",
      "Güzeltepe Mah",
      "Hüseyin Kahya Mah",
      "Kurtuluş Mah",
      "Ovacık Mah",
      "Tepebaşı Mah",
      "Yenidoğan Mah",
      "Bahçelievler Mah",
      "Karşıyaka Mah",
      "Kızılırmak Mah",
      "Kimeski Mah",
      "Selim Özer Mah",
      "Yuva Mah"
    ],
    "Sulakyurt": [
      "Ağaylı Köyü",
      "Akkuyu Köyü",
      "Alişeyhli Köyü",
      "Ambardere Köyü",
      "Ayvatlı Köyü",
      "Barış Mah (hamzalı Köyü)",
      "Cumhuriyet Mah (hamzalı Köyü)",
      "Çayoba Köyü",
      "Çevrimli Köyü",
      "Danacı Köyü",
      "Deredüzü Köyü",
      "Esenpınar Köyü",
      "Faraşlı Köyü",
      "Fatih Mah (güzelyurt Köyü)",
      "Hürriyet Mah (hamzalı Köyü)",
      "İmamoğluçeşmesi Köyü",
      "Kalekışla Köyü",
      "Kıyıhalilinceli Köyü",
      "Kıyıkavurgalı Köyü",
      "Koruköy Köyü",
      "Körkuyu Mah (sofularçiftliği Köyü)",
      "Kurtuluş Mah (güzelyurt Köyü)",
      "Mevlana Mah (güzelyurt Köyü)",
      "Ortaköy Köyü",
      "Sarıkızlı Köyü",
      "Sarımbey Köyü",
      "Sofularçiftliği Köyü",
      "Yağbasan Köyü",
      "Yeniceli Köyü",
      "Yeşilli Köyü",
      "Yeşilyazı Köyü",
      "Yunus Emre Mah (güzelyurt Köyü)",
      "Cumhuriyet Mah",
      "Yayla Mah",
      "Yeni Mah",
      "Yenihayat Mah",
      "Yeşilyurt Mah",
      "Yıldız Mah",
      "Yükselen Mah"
    ],
    "Yahşihan": [
      "Aktaşlar Yaylası Mah (mahmutlar Köyü)",
      "Bahçelievler Mah (kılıçlar Köyü)",
      "Battalgazi Mah (ırmak Köyü)",
      "Bayraktepe Mah",
      "Bedesten Köyü",
      "Boğaziçi Mah (ırmak Köyü)",
      "Çiftlik Mah (hisarköy Köyü)",
      "Enver Paşa Mah (kılıçlar Köyü)",
      "Fatih Mah (ırmak Köyü)",
      "Gedikardı Mah (hisarköy Köyü)",
      "Güllük Çiftliği Mah (keçili Köyü)",
      "Güzeren Mah (mahmutlar Köyü)",
      "Hacıbalı Köyü",
      "Hacıbalıosb Mah (hacıbalı Köyü)",
      "Hacıbey Mah",
      "Hisarköy Köyü",
      "Kalecik Karadağ Mevkii Mah (mahmutlar Köyü)",
      "Keçili Köyü",
      "Köyönü Mevkii Mah (hacıbalı Köyü)",
      "Kütüklü Mah (mahmutlar Köyü)",
      "Mahmutlar Köyü",
      "Seyitali Mah (kılıçlar Köyü)",
      "Seyrantepe Mah",
      "Seyrantepe Mah (ırmak Köyü)",
      "Şehit Türker Mah (kılıçlar Köyü)",
      "Üzümlü Mah (bedesten Köyü)",
      "Üzümlü Mevkii Mah (bedesten Köyü)",
      "Vakağın Tepesi Mah (keçili Köyü)",
      "Yazı Mevkii Mah (hacıbalı Köyü)",
      "Yeşilöz Mah (ırmak Köyü)",
      "Alaaddin Mah",
      "Doğanlık Mah",
      "Emirler Mah",
      "Erenler Mah",
      "Kadıoğlu Mah",
      "Yenişehir Mah",
      "Yeşil Vadi Mah"
    ]
  },
  "Batman": {
    "Beşiri": [
      "Bağdu Mah",
      "Behrem Yoğun Mah",
      "Cumhuriyet Mah",
      "Kobin Mah",
      "Mehmet Yatkın Mah",
      "Milli Egemenlik Mah",
      "Karaduman Mah (ikiköprü Beldesi)",
      "Kıyanç Mah (ikiköprü Beldesi)",
      "Turgut Özal Mah (ikiköprü Beldesi)",
      "Ağılcık Mah (örmegöze Köyü)",
      "Aktaş Mah (kaşüstü Köyü)",
      "Alaca Köyü",
      "Alıçlı Mah (inpınar Köyü)",
      "Ali Bey Mah (durucak Köyü)",
      "Arılı Mah (kayatepe Köyü)",
      "Asmadere Köyü",
      "Aşağı Kürsü Mah (otluca Köyü)",
      "Aşağı Ürünlü Mah (durucak Köyü)",
      "Atbağı Köyü",
      "Ayışığı Mah (esence Köyü)",
      "Ayrancı Köyü",
      "Bahçeli Köyü",
      "Başarı Köyü",
      "Başlamış Mah (ılıca Köyü)",
      "Bayramlı Mah (eskihamur Köyü)",
      "Beşpınar Köyü",
      "Beyçayırı Köyü",
      "Bıgevra Mah (eskihamur Köyü)",
      "Bilek Köyü",
      "Çakıllı Köyü",
      "Çavuşbayırı Köyü",
      "Çay Kenarı Mah (samanlı Köyü)",
      "Çaykenarı Mah (durucak Köyü)",
      "Çığırlı Köyü",
      "Dağyolu Köyü",
      "Danacı Mah (kaşüstü Köyü)",
      "Danalı Köyü",
      "Dayılar Köyü",
      "Değirmenüstü Köyü",
      "Demirdöven Mah (ışıkveren Köyü)",
      "Deveboynu Köyü",
      "Doğankavak Köyü",
      "Doğanpazarı Köyü",
      "Doruklu Mah (beşpınar Köyü)",
      "Döşeme Mah (eskihamur Köyü)",
      "Durucak Köyü",
      "Ekinciler Mah (kuşçukuru Köyü)",
      "Esence Köyü",
      "Eskihamur Köyü",
      "Gedikli Mah (yazıhan Köyü)",
      "Göktaş Mah (doğanpazarı Köyü)",
      "Güvercinlik Köyü",
      "Hanlı Mah (kumçay Köyü)",
      "Ilıca Köyü",
      "Işıkveren Köyü",
      "İkiyaka Köyü",
      "İnpınar Köyü",
      "İslam Mah (eskihamur Köyü)",
      "İslamköy Mah (durucak Köyü)",
      "Kale Mah (yalınkavak Köyü)",
      "Kapaklı Mah (bahçeli Köyü)",
      "Karataş Mah (kaşüstü Köyü)",
      "Karatepe Köyü",
      "Kaşüstü Köyü",
      "Kayatepe Köyü",
      "Kesiktaş Mah (alaca Köyü)",
      "Kezik Mah (eskihamur Köyü)",
      "Kışlacık Mah (oğuz Köyü)",
      "Kökebi Mah (eskihamur Köyü)",
      "Kumçay Köyü",
      "Kumgeçit Köyü",
      "Kumrulu Mah (kütüklü Köyü)",
      "Kurukavak Köyü",
      "Kuşçukuru Köyü",
      "Kütüklü Köyü",
      "Meydancık Mah (kumgeçit Köyü)",
      "Mezelkan Mah (kuşçukuru Köyü)",
      "Nejan Mah (eskihamur Köyü)",
      "Nurettin Mah (bilek Köyü)",
      "Oğuz Köyü",
      "Onbaşı Mah (oğuz Köyü)",
      "Organize Sanayi Bölgesi Mah (danalı Köyü)",
      "Organize Sanayi Bölgesi Mah (örmegöze Köyü)",
      "Ortaalan Mah (kurukavak Köyü)",
      "Otluca Köyü",
      "Örmegöze Köyü",
      "Pirinçlik Mah (ılıca Köyü)",
      "Pompalı Mah (ışıkveren Köyü)",
      "Remikan Mah (bilek Köyü)",
      "Samanlı Köyü",
      "Sapanlı Mah (yalınca Köyü)",
      "Sütlüce Mah (beşpınar Köyü)",
      "Tekağaç Köyü",
      "Tepecik Köyü",
      "Uğurca Köyü",
      "Üçkuyular Köyü",
      "Yağlıca Mah (çakıllı Köyü)",
      "Yakacık Köyü",
      "Yalınca Köyü",
      "Yalınkavak Köyü",
      "Yarımtaş Köyü",
      "Yavuz Mah (oğuz Köyü)",
      "Yazıhan Köyü",
      "Yazyurdu Mah (bahçeli Köyü)",
      "Yeni Mah (inpınar Köyü)",
      "Yenipınar Köyü",
      "Yeniyol Köyü",
      "Yeşiloba Köyü",
      "Yolboyu Mah (durucak Köyü)",
      "Yolkonak Köyü",
      "Yontukyazı Köyü",
      "Yukarı Bayramlı Mah (eskihamur Köyü)",
      "Yukarı Kürsü Mah (otluca Köyü)",
      "Yukarı Ürünlü Mah (durucak Köyü)",
      "Yumrukaya Mah (ikiyaka Köyü)"
    ],
    "Gercüş": [
      "Bağlarbaşı Mah",
      "Çukurçeşme Mah",
      "Pınarbaşı Mah",
      "Pınarbaşı Mah (kayapınar Beldesi)",
      "Yeşilyurt Mah (kayapınar Beldesi)",
      "Akarca Mah (ardıçlı Köyü)",
      "Akbaş Mah (ardıçlı Köyü)",
      "Akburç Köyü",
      "Akça Mah (boğazköy Köyü)",
      "Akyar Köyü",
      "Ardıç Köyü",
      "Ardıçlı Köyü",
      "Arıca Köyü",
      "Arık Mah (bağözü Köyü)",
      "Aydınca Köyü",
      "Aydınlı Köyü",
      "Babnir Köyü",
      "Bağlıca Köyü",
      "Bağözü Köyü",
      "Başarköy Köyü",
      "Başova Köyü",
      "Becirman Köyü",
      "Boğazköy Köyü",
      "Cevizli Köyü",
      "Çalışkan Köyü",
      "Çiçekli Köyü",
      "Çukuryurt Köyü",
      "Derei Mah (yayladüzü Köyü)",
      "Dereiçi Köyü",
      "Dereli Köyü",
      "Direkli Mah (ardıçlı Köyü)",
      "Doruk Köyü",
      "Düzmeşe Köyü",
      "Esentepe Mah (karalan Köyü)",
      "Eymir Köyü",
      "Geçit Köyü",
      "Gökçe Köyü",
      "Gökçepınar Köyü",
      "Gönüllü Köyü",
      "Gürbüz Köyü",
      "Güzelöz Köyü",
      "Hanik Mah (ardıçlı Köyü)",
      "Haydarpaşa Mah (ardıçlı Köyü)",
      "Hisarmerkez Mah (hisar Köyü)",
      "Kaniya Delava Mah (yakıtlı Köyü)",
      "Kantar Köyü",
      "Karalan Köyü",
      "Kayalar Köyü",
      "Kaynarca Mah (güzelöz Köyü)",
      "Kelan Mah (ardıçlı Köyü)",
      "Kesiksu Köyü",
      "Kırkat Köyü",
      "Kışlak Köyü",
      "Koçak Köyü",
      "Konak Mah (kırkat Köyü)",
      "Koyunlu Köyü",
      "Kozlu Köyü",
      "Kömürcü Köyü",
      "Kutlu Köyü",
      "Mağaralı Mah (aydınlı Köyü)",
      "Muratlı Mah (ardıçlı Köyü)",
      "Nurlu Köyü",
      "Otlu Mah (doruk Köyü)",
      "Öteyaka Mah (kırkat Köyü)",
      "Özler Köyü",
      "Poyraz Köyü",
      "Rüzgarlı Köyü",
      "Sargın Köyü",
      "Seki Köyü",
      "Serinköy Köyü",
      "Seyrantepe Mah (ardıçlı Köyü)",
      "Taşçı Köyü",
      "Tepecik Köyü",
      "Tutumlu Mah (çukuryurt Köyü)",
      "Ulaş Köyü",
      "Yakıtlı Köyü",
      "Yamanlar Köyü",
      "Yassıca Köyü",
      "Yayladüzü Köyü",
      "Yemişli Köyü",
      "Yenice Köyü",
      "Yolağzı Mah",
      "Yüceköy Köyü"
    ],
    "Hasankeyf": [
      "Bahçelievler Mah",
      "Kale Mah",
      "Akalın Köyü",
      "Aksu Köyü",
      "Atlıhan Mah (kumluca Köyü)",
      "Bayırlı Köyü",
      "Büyükdere Köyü",
      "Çardaklı Köyü",
      "Dicle Mah",
      "Eyyubi Mah",
      "Güneşli Köyü",
      "Irmak Köyü",
      "İncirli Köyü",
      "Karaköy Köyü",
      "Kavacık Mah (ırmak Köyü)",
      "Kavak Mah (üçyol Köyü)",
      "Kayıklı Köyü",
      "Kelekçi Köyü",
      "Kumluca Köyü",
      "Kültür Mah",
      "Öğütlü Köyü",
      "Palamut Köyü",
      "Raman Mah",
      "Saklı Köyü",
      "Soğucak Köyü",
      "Tepebaşı Köyü",
      "Uzundere Köyü",
      "Üçyol Köyü",
      "Yakaköy Köyü",
      "Yolüstü Köyü"
    ],
    "Kozluk": [
      "Adnan Menderes Mah (bekirhan Beldesi)",
      "Gülpınar Mah (bekirhan Beldesi)",
      "Ortaçay Mah (bekirhan Beldesi)",
      "Turgut Özal Mah (bekirhan Beldesi)",
      "Yapraklı Mah (bekirhan Beldesi)",
      "Aşağıgüneşli Mah",
      "Çaybaşı Mah",
      "Değirmendere Mah",
      "Hamam Mah",
      "İslambey Mah",
      "Kale Mah",
      "Komando Mah",
      "Köprübaşı Mah",
      "Selahaddini Eyyübi Mah",
      "Şemdinağa Mah",
      "Tepecik Mah",
      "Yamaçlı Mah",
      "Yeni Mah",
      "Yukarı Güneşli Mah",
      "Ağaçlık Mah",
      "Ağılbaş Mah (beşkonak Köyü)",
      "Ağlemk Mah (koçaklı Köyü)",
      "Akağaç Mah (kamışlı Köyü)",
      "Akçakışla Köyü",
      "Akçalı Köyü",
      "Aksaray Mah (uzunçayır Köyü)",
      "Alaca Mah (yenidoğan Ase Köyü)",
      "Alıçlı Köyü",
      "Arıkaya Köyü",
      "Arıkbaşı Mah (yazılı Köyü)",
      "Armutlu Köyü",
      "Aslan Köy Mah (kumlupınar Köyü)",
      "Aslanlı Mah (danagözü Köyü)",
      "Aşağıkıratlı Köyü",
      "Atalar Mah (akçakışla Köyü)",
      "Ava Mah (dere Köyü)",
      "Bacak Mah (yeniçağlar Köyü)",
      "Bahçeli Mah",
      "Başeymez Mah (uzunçayır Köyü)",
      "Bekirhan Yenidoğan Köyü",
      "Beşevler Mah",
      "Beybağı Köyü",
      "Bölükkonak Köyü",
      "Budaklı Mah (akçalı Köyü)",
      "Bulgurlu Mah (uzunçayır Köyü)",
      "Camili Mah (ulaşlı Köyü)",
      "Cemalo Mah (inişli Köyü)",
      "Cindo Mah (kayadibi Köyü)",
      "Çakırlar Mah (çayönü Köyü)",
      "Çamlıca Köyü",
      "Çavuşlu Mah (yanıkkaya Köyü)",
      "Çay Kenarı Mah (çayönü Köyü)",
      "Çay Mah (danagözü Köyü)",
      "Çay Mah (derince Köyü)",
      "Çaygeçit Köyü",
      "Çayhan Köyü",
      "Çayönü Köyü",
      "Çayönü Mah (ziyaret Köyü)",
      "Çevrecik Köyü",
      "Damarlı Mah (akçakışla Köyü)",
      "Danagözü Köyü",
      "Delava Mah (beybağı Köyü)",
      "Dere Köyü",
      "Derince Köyü",
      "Dikbayır Mah (arıkaya Köyü)",
      "Dikenli Mah (güllüce Köyü)",
      "Dilimli Mah (çayönü Köyü)",
      "Doğancık Mah (taşlıdere Köyü)",
      "Dövecik Köyü",
      "Dutluca Mah (akçakışla Köyü)",
      "Duygulu Köyü",
      "Esentepe Mah (uzunçayır Köyü)",
      "Eshabe Mah (uzunçayır Köyü)",
      "Esinlik Mah (beşkonak Köyü)",
      "Eskice Köyü",
      "Geçitaltı Köyü",
      "Gelşe Mah (geçitaltı Köyü)",
      "Gertavi Mah (yanıkkaya Köyü)",
      "Geyikli Köyü",
      "Golazeng Mah (uzunçayır Köyü)",
      "Gökbudak Mah (arıkaya Köyü)",
      "Güllüce Köyü",
      "Gülovası Mah (uzunçayır Köyü)",
      "Gültepe Mah (gürpınar Köyü)",
      "Gümüşörgü Köyü",
      "Gündüzlü Köyü",
      "Günyayla Köyü",
      "Gürpınar Köyü",
      "Güveçli Mah (koçaklı Köyü)",
      "Handelu Mah (taşlık Köyü)",
      "Hasköy Mah (uzunçayır Köyü)",
      "Hazari Mah (konaklı Köyü)",
      "Irmak Mah (arıkaya Köyü)",
      "İkipınar Mah (geçitaltı Köyü)",
      "İnanlı Mah (kaletepe Köyü)",
      "İncili Mah (çayönü Köyü)",
      "İncirlik Mah (tosunpınar Köyü)",
      "İnişli Köyü",
      "Kahveci Köyü",
      "Kale Mah (ulaşlı Köyü)",
      "Kale Mah (yıldızlı Köyü)",
      "Kaletepe Köyü",
      "Kalkancık Mah (gündüzlü Köyü)",
      "Kamışlı Köyü",
      "Kaniyebine Mah (ortaca Köyü)",
      "Karaoğlak Köyü",
      "Karpuzlu Köyü",
      "Karpuzlu Mah",
      "Karser Mah (akçalı Köyü)",
      "Karşıyaka Köyü",
      "Kavakdibi Köyü",
      "Kavaklı Mah",
      "Kayadibi Köyü",
      "Keklikpınar Mah (ulaşlı Köyü)",
      "Kemalpaşa Mah",
      "Keseli Mah (yazılı Köyü)",
      "Kettı Mah (koçaklı Köyü)",
      "Kocabey Mah (kumlupınar Köyü)",
      "Koçaklı Köyü",
      "Konaklı Köyü",
      "Koyuncular Mah (ünsaldı Köyü)",
      "Kömk Mah (akçalı Köyü)",
      "Kömürlü Mah (örensu Köyü)",
      "Köseler Mah (yazılı Köyü)",
      "Kulludere Köyü",
      "Kumlupınar Köyü",
      "Kurşunlu Mah (çayönü Köyü)",
      "Mercan Mah (uzunçayır Köyü)",
      "Merce Mah (karaoğlak Köyü)",
      "Mergedere Mah (geyikli Köyü)",
      "Metinga Mah (duygulu Köyü)",
      "Navala Mah (yukarıkıratlı Köyü)",
      "Okçular Mah (yayalar Köyü)",
      "Orta Mah (kavakdibi Köyü)",
      "Orta Mah (ziyaret Köyü)",
      "Ortaca Köyü",
      "Oyuktaş Köyü",
      "Örensu Köyü",
      "Örnek Mah (tuzlagözü Köyü)",
      "Parmakkapı Köyü",
      "Pınarbaşı Mah",
      "Pınarhisar Köyü",
      "Salihli Mah (kavakdibi Köyü)",
      "Samanyolu Köyü",
      "Sarıda Mah (armutlu Köyü)",
      "Sarıkuş Mah (yanıkkaya Köyü)",
      "Satı Mah (eskice Köyü)",
      "Seyhan Mah (uzunçayır Köyü)",
      "Seyitler Köyü",
      "Seyitler Mah (eskice Köyü)",
      "Seymenler Mah (uzunyazı Köyü)",
      "Seyrantepe Köyü",
      "Seyrantepe Mah (yenidoğan Ase Köyü)",
      "Soğukpınar Mah (kavakdibi Köyü)",
      "Sork Mah (yenidoğan Ase Köyü)",
      "Soylu Mah (dere Köyü)",
      "Soylu Mah (yayalar Köyü)",
      "Sugesiye Mah (geçitaltı Köyü)",
      "Süleymana Mah (güllüce Köyü)",
      "Süleymanlar Mah (beşkonak Köyü)",
      "Şakuli Mah (taşlık Köyü)",
      "Şerikan Mah (beşkonak Köyü)",
      "Şöpir Mah (yenidoğan Ase Köyü)",
      "Taava Mah (dere Köyü)",
      "Taşlıdere Köyü",
      "Taşlık Köyü",
      "Taşoluk Mah (danagözü Köyü)",
      "Tekeli Mah (dere Köyü)",
      "Tepecik Mah (yenidoğan Ase Köyü)",
      "Tepeli Mah (inişli Köyü)",
      "Tepeüstü Mah",
      "Tomurcak Mah (ulaşlı Köyü)",
      "Toptaş Mah (kumlupınar Köyü)",
      "Tosunpınar Köyü",
      "Tunçbilek Mah (inişli Köyü)",
      "Tuzlagözü Köyü",
      "Uğurlu Mah (uzunyazı Köyü)",
      "Ulaşlı Köyü",
      "Ulucanlar Mah (gürpınar Köyü)",
      "Uzunçayır Köyü",
      "Uzunyayla Mah (uzunçayır Köyü)",
      "Uzunyazı Köyü",
      "Üçyol Mah (karpuzlu Köyü)",
      "Ünsaldı Köyü",
      "Üzümlü Mah (uzunçayır Köyü)",
      "Yanıkkaya Köyü",
      "Yankılı Köyü",
      "Yapaklı Köyü",
      "Yayalar Köyü",
      "Yazılı Köyü",
      "Yazpınar Köyü",
      "Yedibölük Köyü",
      "Yemişlik Mah (arıkaya Köyü)",
      "Yeni Mah (dere Köyü)",
      "Yeniçağlar Köyü",
      "Yenidoğan Ase Köyü",
      "Yeniköy Mah (çayönü Köyü)",
      "Yeşilköy Mah (uzunçayır Köyü)",
      "Yeşilöz Mah (kaletepe Köyü)",
      "Yeşiltepe Mah",
      "Yeşiltepe Mah (koçaklı Köyü)",
      "Yeşiltepe Mah (pınarhisar Köyü)",
      "Yeşilyurt Mah (oyuktaş Köyü)",
      "Yıldızlı Köyü",
      "Yokuş Mah (tuzlagözü Köyü)",
      "Yolaltı Mah",
      "Yolbaşı Mah (duygulu Köyü)",
      "Yolkenarı Mah (çayönü Köyü)",
      "Yolüstü Mah",
      "Yukarı Şat Mah (tosunpınar Köyü)",
      "Yukarı Ziyaret Mah (ziyaret Köyü)",
      "Yukarıkıratlı Köyü",
      "Yuvacık Mah (taşlıdere Köyü)",
      "Ziyaret Köyü",
      "Zorluca Mah (ulaşlı Köyü)"
    ],
    "Merkez": [
      "Segirkan Mah (balpınar Beldesi)",
      "Seyrantepe Mah (balpınar Beldesi)",
      "Yeniköy Mah (balpınar Beldesi)",
      "Yenimahalle Mah (balpınar Beldesi)",
      "19 Mayıs Mah",
      "Aydınlıkevler Mah",
      "Beşevler Mah",
      "Çarşı Mah",
      "Çay Mah",
      "Huzur Mah",
      "İluh Mah",
      "Kısmet Mah",
      "Meydan Mah",
      "Yeni Mah",
      "Yeşiltepe Mah",
      "Bahçelievler Mah",
      "Bayındır Mah",
      "Belde Mah",
      "Cudi Mah",
      "Cumhuriyet Mah",
      "Çamlıtepe Mah",
      "Fatih Mah",
      "Gap Mah",
      "Gültepe Mah",
      "Korik Mah",
      "Şafak Mah",
      "Şirinevler Mah",
      "Tilmerc Mah",
      "Bağlar Mah",
      "Girbereşik Mah",
      "Hilal Mah",
      "Kültür Mah",
      "Pazaryeri Mah",
      "Pınarbaşı Mah",
      "Raman Mah",
      "Sağlık Mah",
      "Ziyagökalp Mah",
      "Akça Köyü",
      "Akoba Köyü",
      "Aziziye Mah (yaylıca Köyü)",
      "Badelen Mah (kayabağı Köyü)",
      "Ballıtepe Mah (bıçakçı Köyü)",
      "Bayraklı Köyü",
      "Belikli Mah (güneşli Köyü)",
      "Bıçakçı Köyü",
      "Binatlı Köyü",
      "Çarıklı Köyü",
      "Çayeli Mah (demirlipınar Köyü)",
      "Çayüstü Köyü",
      "Çeşmebaşı Köyü",
      "Çevrimova Köyü",
      "Demirbilek Köyü",
      "Demirci Mah (akoba Köyü)",
      "Demirlipınar Köyü",
      "Diktepe Köyü",
      "Doluca Köyü",
      "Esentepe Mah (doluca Köyü)",
      "Everci Mah (kuyubaşı Köyü)",
      "Gölbaşı Mah (diktepe Köyü)",
      "Güneşli Köyü",
      "Güvercin Köyü",
      "Hacı Ömer Mah (çayüstü Köyü)",
      "Hanlı Mah (binatlı Köyü)",
      "Karayün Köyü",
      "Kardelen Mah",
      "Kayabağı Köyü",
      "Kesmeköprü Köyü",
      "Kılıç Köyü",
      "Kırmataş Mah (kayabağı Köyü)",
      "Kocalar Köyü",
      "Kolbaşı Mah (binatlı Köyü)",
      "Kösetarla Köyü",
      "Kumtepe Mah (kösetarla Köyü)",
      "Kuyubaşı Köyü",
      "Neval Mah (güneşli Köyü)",
      "Okçu Mah (karayün Köyü)",
      "Oluklu Mah (yaylıca Köyü)",
      "Oymataş Köyü",
      "Ödemiş Mah (çarıklı Köyü)",
      "Recepler Köyü",
      "Reyhan Mah (güneşli Köyü)",
      "Salkımlı Mah (çayüstü Köyü)",
      "Selamet Mah (bayraklı Köyü)",
      "Sincanlı Mah (oymataş Köyü)",
      "Soğuksu Mah (oymataş Köyü)",
      "Suçeken Köyü",
      "Şerbet Mah (yaylıca Köyü)",
      "Şeyhçoban Mah (oymataş Köyü)",
      "Uğrak Mah (yağmurlu Köyü)",
      "Urganlı Köyü",
      "Üçtepe Mah (güneşli Köyü)",
      "Ünlüce Mah (oymataş Köyü)",
      "Yağmurlu Köyü",
      "Yakıtlı Köyü",
      "Yaylıca Köyü",
      "Yediyol Köyü",
      "Yeni Köy Mah (diktepe Köyü)",
      "Yenişehir Mah",
      "Yeşilöz Köyü",
      "Yoğurtlu Mah (bayraklı Köyü)",
      "Yolağzı Köyü",
      "Yolveren Köyü",
      "Yüksektepe Mah (demirlipınar Köyü)",
      "Akyürek Mah",
      "Çamlıca Mah",
      "Güneykent Mah",
      "Hürriyet Mah",
      "İrmi Mah",
      "Karşıyaka Mah",
      "Petrol Mah",
      "Petrolkent Mah",
      "Seyitler Mah",
      "Site Mah"
    ],
    "Sason": [
      "Acar Köyü",
      "Ağakünük Mah (dörtbölük Köyü)",
      "Ahkar Mezra Mah (derince Köyü)",
      "Akbelen Mah (heybeli Köyü)",
      "Altındere Köyü",
      "Ambarlı Mezra Mah (dörtbölük Köyü)",
      "Arkök Mah (yakabağ Köyü)",
      "Arpacık Mezra Mah (çakırpınar Köyü)",
      "Aşağı Çayırlı Mah (çayırlı Köyü)",
      "Aykonak Mah (bayramlar Köyü)",
      "Bakihisar Mah (yakabağ Köyü)",
      "Balbaşı Köyü",
      "Bayramlar Köyü",
      "Bergazi Mah (heybeli Köyü)",
      "Beypsiye Mah (soğanlı Köyü)",
      "Binöni Mezra Mah (kelhasan Köyü)",
      "Boğazkapı Köyü",
      "Bozdoğan Mezra Mah (dörtbölük Köyü)",
      "Cevizli Köyü",
      "Çadırkent Mah (acar Köyü)",
      "Çağlı Köyü",
      "Çakırpınar Köyü",
      "Çakmaklı Mezra Mah (derince Köyü)",
      "Çalışırlar Köyü",
      "Çayırlı Köyü",
      "Çemeşeşo Mezra Mah (ergünü Köyü)",
      "Çemeşevke Mah (karameşe Köyü)",
      "Çınarlı Köyü",
      "Çukurca Mah (örenağıl Köyü)",
      "Dağçatı Köyü",
      "Dağlıca Mezra Mah (çakırpınar Köyü)",
      "Deliktaş Mezra Mah (çakırpınar Köyü)",
      "Dereiçi Köyü",
      "Dereköy Köyü",
      "Derince Köyü",
      "Dibek Mah (dörtbölük Köyü)",
      "Dikbayır Köyü",
      "Dikmetaş Mah (bayramlar Köyü)",
      "Dörtbölük Köyü",
      "Ekinlik Mezra Mah (ekinlik Köyü)",
      "Elagöz Mah (sarıyayla Köyü)",
      "Ellibren Mah (çakırpınar Köyü)",
      "Elmapınar Mezra Mah (kaşyayla Köyü)",
      "Ergünü Köyü",
      "Erikli Köyü",
      "Geçitli Köyü",
      "Gençler Köyü",
      "Girasur Mah (çayırlı Köyü)",
      "Giribani Mezra Mah (kaleyolu Köyü)",
      "Goman Mezra Mah (dörtbölük Köyü)",
      "Gortir Mezra Mah (taşyuva Köyü)",
      "Gölbaşı Mah (cevizli Köyü)",
      "Gölbaşı Mah (heybeli Köyü)",
      "Görtil Mah (çakırpınar Köyü)",
      "Göşek Mezra Mah (dereköy Köyü)",
      "Güleç Mah (meşeli Köyü)",
      "Gündoğdu Mezra Mah (çağlı Köyü)",
      "Güneşli Mah (heybeli Köyü)",
      "Güneşli Mezra Mah (acar Köyü)",
      "Günyecik Mezra Mah (kaşyayla Köyü)",
      "Gürgenli Köyü",
      "Güvenç Mezra Mah (gürgenli Köyü)",
      "Güvercinlik Köyü",
      "Hasanbey Mah (cevizli Köyü)",
      "Hasanlar Mezra Mah (acar Köyü)",
      "Haydar Mah (umurlu Köyü)",
      "Hazzank Mah (taşyuva Köyü)",
      "Heybeli Köyü",
      "Hılınsur Mah (sarıyayla Köyü)",
      "Hopir Mezra Mah (taşyuva Köyü)",
      "İncesu Köyü",
      "Kaleyolu Köyü",
      "Kaman Mah (yakabağ Köyü)",
      "Karaağaç Mah (karayün Köyü)",
      "Karameşe Köyü",
      "Kaşyayla Köyü",
      "Kavaklı Köyü",
      "Kayadibi Mah (cevizli Köyü)",
      "Kayadibi Mah (örenağıl Köyü)",
      "Kayadüzü Köyü",
      "Keçeli Mah (yuvalar Köyü)",
      "Keçiler Mah (örenağıl Köyü)",
      "Kelhasan Köyü",
      "Kınalı Köyü",
      "Kısrak Mah (soğanlı Köyü)",
      "Kilis Köyü",
      "Kocanlar Mezra Mah (kavaklı Köyü)",
      "Konaklı Mezra Mah (çakırpınar Köyü)",
      "Kömürdür Mah (örenağıl Köyü)",
      "Köprübaşı Köyü",
      "Kulaksız Köyü",
      "Kurt Mah (yuvalar Köyü)",
      "Kuzkoncuk Mah (çağlı Köyü)",
      "Merge Mah (umurlu Köyü)",
      "Merkez Mah (karayün Köyü)",
      "Meşeli Köyü",
      "Ordu Mezra Mah (çağlı Köyü)",
      "Osmanik Mah (çakırpınar Köyü)",
      "Örenağıl Köyü",
      "Özlüce Mezra Mah (derince Köyü)",
      "Pazarcık Mezra Mah (balbaşı Köyü)",
      "Pıjunik Mah (örenağıl Köyü)",
      "Pivank Mah (meşeli Köyü)",
      "Sarıkız Mah (yuvalar Köyü)",
      "Sarıyayla Köyü",
      "Sarigan Mezra Mah (kaleyolu Köyü)",
      "Sinemerg Mezra Mah (kelhasan Köyü)",
      "Soğanlı Köyü",
      "Soğe Mah (umurlu Köyü)",
      "Suarkı Mah (dağçatı Köyü)",
      "Şahinli Mezra Mah (dereköy Köyü)",
      "Şehan Mezra Mah (kaleyolu Köyü)",
      "Şengirik Mezra Mah (dörtbölük Köyü)",
      "Şımdank Mah (kaşyayla Köyü)",
      "Şilfo Mezra Mah (dörtbölük Köyü)",
      "Tahtika Mezra Mah (balbaşı Köyü)",
      "Taşburun Mah (turnalı Köyü)",
      "Taşlıca Mah (örenağıl Köyü)",
      "Taşyuva Köyü",
      "Taşyuva Mah (kaşyayla Köyü)",
      "Tepecik Mezra Mah (kavaklı Köyü)",
      "Tire Mah (karameşe Köyü)",
      "Topluca Köyü",
      "Turnalı Köyü",
      "Umurlu Köyü",
      "Üçdirek Mah (yuvalar Köyü)",
      "Üçevler Mah (sarıyayla Köyü)",
      "Yakabağ Köyü",
      "Yamanlı Mezra Mah (kaleyolu Köyü)",
      "Yayarlı Mah (kaşyayla Köyü)",
      "Yedigöz Mah (örenağıl Köyü)",
      "Yelek Mez Mah (sarıyayla Köyü)",
      "Yeniköy Köyü",
      "Yeniyurt Mah (heybeli Köyü)",
      "Yıldızkaya Mah (sarıyayla Köyü)",
      "Yiğitler Köyü",
      "Yiğitli Mezra Mah (yiğitler Köyü)",
      "Yollaç Mah (sarıyayla Köyü)",
      "Yolüstü Köyü",
      "Yoncadüzü Mah (kilimli Köyü)",
      "Yoncalı Mezra Mah (derince Köyü)",
      "Yukarı Ergünü Mah (ergünü Köyü)",
      "Yukarı Ergünü Mah (kayadüzü Köyü)",
      "Yuvalar Köyü",
      "Yuvalıçay Köyü",
      "Yürekli Köyü",
      "Ziyaret Köyü",
      "Zornik Mezra Mah (taşyuva Köyü)",
      "Aşağı Mah",
      "Aykut Ozan Mah",
      "Beşevler Mah",
      "Demetevler Mah",
      "Dumlupınar Mah",
      "Emek Mah",
      "Erdemli Mah",
      "Gürpınar Mah",
      "Haydar Mah",
      "Karşıyaka Mah",
      "Kayabaşı Mah",
      "Kurtuluş Mah",
      "Mehmet Akif Mah",
      "Orta Mah",
      "Pınarbaşı Mah",
      "Sevek Mah",
      "Şirinevler Mah",
      "Tekevler Mah",
      "Tekinler Mah",
      "Yaylatepe Mah",
      "Yeni Mah",
      "Yeşilevler Mah",
      "Yeşiller Mah",
      "Yeşilova Mah",
      "Yeşiltepe Mah",
      "Yıldız Mah",
      "Yukarı Mah",
      "Zafer Mah",
      "Aydınlık Mah (yücebağ Beldesi)",
      "Barış Mah (yücebağ Beldesi)",
      "Binekli Mah (yücebağ Beldesi)",
      "Günlüce Mah (yücebağ Beldesi)",
      "Karşıyaka Mah (yücebağ Beldesi)",
      "Koçkaya Mah (yücebağ Beldesi)",
      "Tepe Mah (yücebağ Beldesi)",
      "Yıldız Mah (yücebağ Beldesi)"
    ]
  },
  "Şırnak": {
    "Beytüşşebap": [
      "Aliçavuş Mah",
      "Elki Mah",
      "Karşıyaka Mah",
      "Pınarbaşı Mah",
      "Akarsu Köyü",
      "Akçayol Köyü",
      "Aşağıdere Köyü",
      "Ayvalık Köyü",
      "Başaran Köyü",
      "Beşağaç Köyü",
      "Boğazören Köyü",
      "Bolağaç Köyü",
      "Bölücek Köyü",
      "Cevizağacı Köyü",
      "Çığlıca Köyü",
      "Dağaltı Köyü",
      "Doğanyol Köyü",
      "Gökçe Köyü",
      "Güneyyaka Köyü",
      "Günyüzü Köyü",
      "Ilıcak Köyü",
      "Koyunoba Köyü",
      "Mutluca Köyü",
      "Okul Mah (mezra Köyü)",
      "Ortalı Köyü",
      "Oymakaya Köyü",
      "Pirinçli Köyü",
      "Söğütce Köyü",
      "Taşkıran Mah (mezra Köyü)",
      "Timur Mah (mezra Köyü)",
      "Toptepe Mah (toptepe Köyü)",
      "Yeşilöz Köyü"
    ],
    "Cizre": [
      "Ali Bey Mah",
      "Cizre Osb Mah",
      "Cudi Mah",
      "Dağ Kapı Mah",
      "Dicle Mah",
      "Kale Mah",
      "Konak Mah",
      "Nur Mah",
      "Sur Mah",
      "Şah Mah",
      "Yafes Mah",
      "Aşağıçeşme Mah (aşağıçeşme Köyü)",
      "Aşağıkonak Köyü",
      "Bağlarbaşı Köyü",
      "Bozalan Köyü",
      "Çağıl Merkez Mah (çağıl Köyü)",
      "Çatal Köyü",
      "Çavuş Köyü",
      "Dirsekli Köyü",
      "Düzova Köyü",
      "Erdem Köyü",
      "Girikova Mah (bozalan Köyü)",
      "Güçlü Köyü",
      "Gürsu Köyü",
      "Havuzlu Köyü",
      "İnci Mah (bozalan Köyü)",
      "İsağa Mah (dirsekli Köyü)",
      "Katran Köyü",
      "Kaya Köyü",
      "Kebeli Köyü",
      "Keruh Köyü",
      "Kiriş Mah (bozalan Köyü)",
      "Kocapınar Köyü",
      "Koçtepe Köyü",
      "Kolgezer Mah (güçlü Köyü)",
      "Konutlar Mah (dirsekli Köyü)",
      "Korucu Köyü",
      "Kurtuluş Merkez Mah (kurtuluş Köyü)",
      "Kuştepe Köyü",
      "Mirhasen Mah (çatal Köyü)",
      "Örencik Mah (korucu Köyü)",
      "Reşmil Mah (kaya Köyü)",
      "Seyrantepe Mah (bozalan Köyü)",
      "Siyahtepe Mah (korucu Köyü)",
      "Sulak Köyü",
      "Şabani Mah (koçtepe Köyü)",
      "Taşhöyük Köyü",
      "Tepeönü Köyü",
      "Uğur Köyü",
      "Ulaş Köyü",
      "Varlık Köyü",
      "Yakacık Köyü",
      "Yakacık Mah (yakacık Köyü)",
      "Yalıntepe Köyü",
      "Yeşilyurt Köyü",
      "Yukarıçeşme Mezrası Mah (yeşilyurt Köyü)",
      "Yukarıkonak Mah (bozalan Köyü)",
      "Zuran Mah (dirsekli Köyü)"
    ],
    "Güçlükonak": [
      "Bahçelievler Mah (fındık Beldesi)",
      "Cumhuriyet Mah (fındık Beldesi)",
      "Gümüşyazı Mah (fındık Beldesi)",
      "Karşıyaka Mah (fındık Beldesi)",
      "Bağlar Mah",
      "Yeni Mah",
      "Ağaçyurdu Köyü",
      "Akçakuşak Köyü",
      "Akdizgin Köyü",
      "Boyuncuk Köyü",
      "Bulmuşlar Köyü",
      "Çetinkaya Köyü",
      "Çevrimli Köyü",
      "Çobankazanı Köyü",
      "Dağyeli Köyü",
      "Damlabaşı Köyü",
      "Damlarca Köyü",
      "Demirboğaz Köyü",
      "Düğünyurdu Köyü",
      "Koçtepe Köyü",
      "Koçyurdu Mah (koçtepe Köyü)",
      "Ormaniçi Mah (ormaniçi Köyü)",
      "Sağkol Köyü",
      "Soğucak Mah (çobankazanı Köyü)",
      "Taşkonak Köyü",
      "Yağızoymak Köyü",
      "Yağmurkuyusu Köyü",
      "Yatağankaya Köyü",
      "Yenimah. (dağyeli Köyü)"
    ],
    "İdil": [
      "Aşağı Mah",
      "Atakent Mah",
      "Turgut Özal Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Şamil Mah (karalar Beldesi)",
      "Temel Mah (karalar Beldesi)",
      "Açma Köyü",
      "Ağaçlı Mah (çukurlu Köyü)",
      "Akdağ Köyü",
      "Akkoyunlu Köyü",
      "Aksoy Köyü",
      "Alakamış Köyü",
      "Alataş Mah (güzelova Köyü)",
      "Babet Mah (alakamış Köyü)",
      "Başakköy Köyü",
      "Bereketli Köyü",
      "Bozburun Köyü",
      "Bozkır Köyü",
      "Camili Mah (yuvalı Köyü)",
      "Çalketehti Mah (çukurlu Köyü)",
      "Çayırlı Mah (duruköy Köyü)",
      "Çığır Köyü",
      "Çınarlı Köyü",
      "Çukurlu Köyü",
      "Dera Mah (topraklı Köyü)",
      "Dirsekli Köyü",
      "Doğancık Mah (yavşan Köyü)",
      "Dumanlı Köyü",
      "Duruköy Köyü",
      "Elcani Mah (sulak Köyü)",
      "Gedik Köyü",
      "Gırbaraz Mah (özbek Köyü)",
      "Gültepe Mah (çığır Köyü)",
      "Güzelova Köyü",
      "Haberli Köyü",
      "Hendekköy Köyü",
      "Işık Köyü",
      "Kaşıkçı Köyü",
      "Kayalı Köyü",
      "Kayı Köyü",
      "Kentli Köyü",
      "Kırca Köyü",
      "Kozluca Köyü",
      "Köşklü Mah (oymak Köyü)",
      "Köyceğiz Köyü",
      "Kurtuluş Köyü",
      "Kuyulu Köyü",
      "Mağaraköy Köyü",
      "Ocaklı Köyü",
      "Okçu Köyü",
      "Ortaca Köyü",
      "Ortaköy Köyü",
      "Oyalı Köyü",
      "Oymak Köyü",
      "Öğündük Köyü",
      "Özbek Köyü",
      "Özen Köyü",
      "Peçenek Köyü",
      "Pınarbaşı Köyü",
      "Sarıköy Köyü",
      "Sulak Köyü",
      "Şeker Mah (köyceğiz Köyü)",
      "Tekeköy Köyü",
      "Telzip Mah (uğrak Köyü)",
      "Tepecik Köyü",
      "Tepeköy Köyü",
      "Tepeli Mah (kuyulu Köyü)",
      "Toklu Köyü",
      "Topraklı Köyü",
      "Uçarlı Köyü",
      "Uğrak Köyü",
      "Ulak Köyü",
      "Üçok Köyü",
      "Varımlı Köyü",
      "Yağmurca Köyü",
      "Yalaz Köyü",
      "Yarbaşı Köyü",
      "Yavşan Köyü",
      "Yayalar Köyü",
      "Yazman Köyü",
      "Yeni Köy Mah (çığır Köyü)",
      "Yeşilce Mah (kozluca Köyü)",
      "Yokuşlu Mah (kentli Köyü)",
      "Yolaçan Köyü",
      "Yörük Köyü",
      "Yukarı Aksoy Mah (aksoy Köyü)",
      "Yukarı Yavşan Mah (yavşan Köyü)",
      "Yuvalı Köyü",
      "Yüksekköy Köyü",
      "Zirincan Mah (kurtuluş Köyü)",
      "Dicle Mah (sırtköy Beldesi)",
      "Fırat Mah (sırtköy Beldesi)"
    ],
    "Merkez": [
      "Aydınlar Mah (balveren Beldesi)",
      "Hatipler Mah (balveren Beldesi)",
      "Şafak Mah (balveren Beldesi)",
      "Yayla Mah (balveren Beldesi)",
      "Bahçelievler Mah (kasrik Beldesi)",
      "Boğaz Mah (kasrik Beldesi)",
      "Yeni Mah (kasrik Beldesi)",
      "Aşağı Mah (kumçatı Beldesi)",
      "Atatürk Mah (kumçatı Beldesi)",
      "Çadırlı Mah (kumçatı Beldesi)",
      "Çavuşhan Mah (kumçatı Beldesi)",
      "Nasırhan Mah (kumçatı Beldesi)",
      "Akçay Köyü",
      "Araköy Köyü",
      "Atbaşı Köyü",
      "Başağaç Köyü",
      "Belkis Mah (atbaşı Köyü)",
      "Cevizdüzü Köyü",
      "Çanaklı Mah (bağpınar Köyü)",
      "Çavuşdede Mah (ikizce Köyü)",
      "Dağkonak Köyü",
      "Geçitboyu Köyü",
      "Gözlüce Mah (yoğurtçular Köyü)",
      "Güneyce Köyü",
      "Güneyçam Köyü",
      "İkizce Köyü",
      "Kavuncu Köyü",
      "Kayaboyun Köyü",
      "Kaymakamçeşmesi Mah (yeniaslanbaşar Köyü)",
      "Kızılsu Köyü",
      "Koçbeyi Köyü",
      "Körüklükaya Köyü",
      "Özveren Mah (yoğurtçular Köyü)",
      "Sucular Mah (kırkkuyu Köyü)",
      "Toptepe Köyü",
      "Yeniaslanbaşar Köyü",
      "Yoğurtçular Köyü",
      "Atatürk Mah",
      "Aydınlıkevler Mah",
      "Bahçelievler Mah",
      "Cumhuriyet Mah",
      "Dicle Mah",
      "Gazi Paşa Mah",
      "Gündoğdu Mah",
      "İsmet Paşa Mah",
      "Şehrinuh Mah",
      "Vakıfkent Mah",
      "Yeni Mah",
      "Yeşilyurt Mah"
    ],
    "Silopi": [
      "Cumhuriyet Mah (başverimli Beldesi)",
      "Köprübaşı Mah (başverimli Beldesi)",
      "Atatürk Mah (çalışkan Beldesi)",
      "Cumhuriyet Mah (çalışkan Beldesi)",
      "Fatih Mah (çalışkan Beldesi)",
      "Vatan Mah (çalışkan Beldesi)",
      "Boğaz Mah (görümlü Beldesi)",
      "Yeni Mah (görümlü Beldesi)",
      "Yolağızı Mah (görümlü Beldesi)",
      "Aksu Köyü",
      "Aktepe Köyü",
      "Akyıldız Köyü",
      "Başgören Mah (yolağzı Köyü)",
      "Başvan Mah (pınarönü Köyü)",
      "Birlikköy Köyü",
      "Bostancı Köyü",
      "Buğdaylı Köyü",
      "Ceylan Mah (yeniköy Köyü)",
      "Çardaklı Köyü",
      "Çiçekli Mah (çardaklı Köyü)",
      "Çiftlikköy Köyü",
      "Çukurca Mah (yeniköy Köyü)",
      "Damlaca Köyü",
      "Dedeler Köyü",
      "Doruklu Köyü",
      "Eğrikonak Mah (birlikköy Köyü)",
      "Esenli Köyü",
      "Güven Mah (bostancı Köyü)",
      "Ilıcalar Mah (çiftlikköy Köyü)",
      "Kapılı Köyü",
      "Kavaközü Köyü",
      "Kavallı Köyü",
      "Kösreli Köyü",
      "Mahmutlu Köyü",
      "Ortaköy Köyü",
      "Otludere Mah (mahmutlu Köyü)",
      "Ovaköy Köyü",
      "Özgen Köyü",
      "Pınarönü Köyü",
      "Rihani Mah (bostancı Köyü)",
      "Selçik Köyü",
      "Seyrantepe Mah (kavaközü Köyü)",
      "Sisli Mah (çardaklı Köyü)",
      "Şemalbeg Mah (üçağaç Köyü)",
      "Taşlıca Mah (üçağaç Köyü)",
      "Üçağaç Köyü",
      "Yamaç Mah (çardaklı Köyü)",
      "Yankale Mah (bostancı Köyü)",
      "Yeniköy Köyü",
      "Yeşilyurt Mah (kavaközü Köyü)",
      "Yolağzı Köyü",
      "Barbaros Mah",
      "Başak Köyü",
      "Başak Mah",
      "Cudi Mah",
      "Cumhuriyet Mah",
      "Dicle Mah",
      "Karşıyaka Mah",
      "Nuh Mah",
      "Ofis Mah",
      "Şht. Harun Boy Mah",
      "Yenişehir Mah",
      "Yeşiltepe Mah"
    ],
    "Uludere": [
      "Güneşli Mah (hilal Beldesi)",
      "Şehan Mah (hilal Beldesi)",
      "Yıldız Mah (hilal Beldesi)",
      "Andaç Köyü",
      "Aslanlı Mah (andaç Köyü)",
      "Bağlı Köyü",
      "Bağlıca Köyü",
      "Ballı Köyü",
      "Bulakbaşı Mah",
      "Dağdibi Köyü",
      "Gülyazı Köyü",
      "Işıkveren Köyü",
      "İnceler Köyü",
      "Ortabağ Köyü",
      "Ortaköy Köyü",
      "Ortasu Köyü",
      "Taşdelen Köyü",
      "Yemişli Köyü",
      "Ayyıldız Mah (şenoba Beldesi)",
      "Başkaya Mah (şenoba Beldesi)",
      "Cumhuriyet Mah (şenoba Beldesi)",
      "Gazi Mah (şenoba Beldesi)",
      "Gündoğdu Mah",
      "Kılaban Mah",
      "Küçükçay Mah",
      "Ödül Mah",
      "Özelli Mah",
      "Yeşilyova Mah",
      "Ayyıldız Mah (uzungeçit Beldesi)",
      "Pınarbaşı Mah (uzungeçit Beldesi)",
      "Tanin Mah (uzungeçit Beldesi)",
      "Yenişehir Mah (uzungeçit Beldesi)"
    ]
  },
  "Bartın": {
    "Amasra": [
      "Boztepe Mah",
      "Fatih Mah",
      "Kaleiçi Mah",
      "Kaleşah Mah",
      "Kum Mah",
      "Abbas Mah (makaracı Köyü)",
      "Aferen Mah (kocaköy Köyü)",
      "Ağ Mah (göçkün Köyü)",
      "Ahmetler Mah (çanakçılar Köyü)",
      "Akkonak Köyü",
      "Ankular Mah (çanakçılar Köyü)",
      "Aşağı Mah (ahatlar Köyü)",
      "Aşağı Mah (saraydüzü Köyü)",
      "Aşağı Meydan Mah (gömü Köyü)",
      "Azimler Mah (inciğez Köyü)",
      "Baldıran Mah (göçkündemirci Köyü)",
      "Beşirler Mah (acarlar Köyü)",
      "Bostanlar Köyü",
      "Cami Önü Mah (inciğez Köyü)",
      "Cavcav Mah (gömü Köyü)",
      "Çamcı Mah (yahyayazıcılar Köyü)",
      "Çapak Mevkii Mah (gömü Köyü)",
      "Çınar Yolu Mah (gömü Köyü)",
      "Dada Mah (esenler Köyü)",
      "Dağ Mah (yukarısal Köyü)",
      "Dede Mah (göçkündemirci Köyü)",
      "Demirciler Mah (kazpınarı Köyü)",
      "Demirciler Mah (yukarısal Köyü)",
      "Deredibi Mah (kocaköy Köyü)",
      "Deremescit Mah (kocaköy Köyü)",
      "Dindar Mah (hatipler Köyü)",
      "Doğancı Mah (cumayanı Köyü)",
      "Düz Mah (makaracı Köyü)",
      "Eskiler Mah (gömü Köyü)",
      "Fer Mah (esenler Köyü)",
      "Göynük Mah (aliobası Köyü)",
      "İnpiri Köyü",
      "Kadı Mah (kalaycı Köyü)",
      "Kara Yusuflar Mah (kazpınarı Köyü)",
      "Karşı Mah (şenyurt Köyü)",
      "Kayran Başı Mah (gömü Köyü)",
      "Kecinler Mah (acarlar Köyü)",
      "Kestanelik Mah (çanakçılar Köyü)",
      "Konaklar Mah (cumayanı Köyü)",
      "Konuklar Mah (karakaçak Köyü)",
      "Kökyol Mah (makaracı Köyü)",
      "Kökyol Mah (saraydüzü Köyü)",
      "Köprübaşı Mah (şenyurt Köyü)",
      "Köy Ortası Mah (gömü Köyü)",
      "Köy Ortası Mah (saraydüzü Köyü)",
      "Kuyupınar Mah (çakrazboz Köyü)",
      "Küçükören Mah (topallar Köyü)",
      "Merkez Mah (acarlar Köyü)",
      "Merkez Mah (aliobası Köyü)",
      "Merkez Mah (cumayanı Köyü)",
      "Merkez Mah (çakrazboz Köyü)",
      "Merkez Mah (çakrazova Köyü)",
      "Merkez Mah (çakrazşeyhler Köyü)",
      "Merkez Mah (çanakçılar Köyü)",
      "Merkez Mah (esenler Köyü)",
      "Merkez Mah (göçkün Köyü)",
      "Merkez Mah (göçkündemirci Köyü)",
      "Merkez Mah (hatipler Köyü)",
      "Merkez Mah (kalaycı Köyü)",
      "Merkez Mah (karakaçak Köyü)",
      "Merkez Mah (kazpınarı Köyü)",
      "Merkez Mah (kocaköy Köyü)",
      "Merkez Mah (makaracı Köyü)",
      "Merkez Mah (topallar Köyü)",
      "Merkez Mah (yahyayazıcılar Köyü)",
      "Merkez Mah (yukarısal Köyü)",
      "Meşeli Mah (çanakçılar Köyü)",
      "Meydan Mah (inciğez Köyü)",
      "Meydan Mah (kocaköy Köyü)",
      "Meydan2 Mah (kocaköy Köyü)",
      "Okullar Mah (çakrazşeyhler Köyü)",
      "Orta Köyü Mah (inciğez Köyü)",
      "Orta Mah (çakrazşeyhler Köyü)",
      "Orta Mah (şenyurt Köyü)",
      "Ovacık Mah (karakaçak Köyü)",
      "Öteköy Mah (saraydüzü Köyü)",
      "Sarı Ahmetler Mah (kazpınarı Köyü)",
      "Sazaklar Mah (inciğez Köyü)",
      "Serenli Mah (makaracı Köyü)",
      "Şükürler Köyü",
      "Tarlaağzı Köyü",
      "Taşlık Mah (saraydüzü Köyü)",
      "Topderesi Köyü",
      "Yerköy Mah (çakrazova Köyü)",
      "Yesirler Mah (kocaköy Köyü)",
      "Yörükler Mah (yahyayazıcılar Köyü)",
      "Yukarı Mah (ahatlar Köyü)",
      "Yukarı Mah (gömü Köyü)",
      "Yukarı Mah (saraydüzü Köyü)",
      "Yukarı Mah (şenyurt Köyü)",
      "Zica Mah (yahyayazıcılar Köyü)"
    ],
    "Kurucaşile": [
      "Kargacak Mah",
      "Liman Mah",
      "Ömerler Mah",
      "Şile Mah",
      "Akçabelen Mah (sarıderesi Köyü)",
      "Alapınar Köyü",
      "Atakdibi Mah (kömeç Köyü)",
      "Curunlu Köyü",
      "Çayaltı Köyü",
      "Çayırlı Mah (elvanlar Köyü)",
      "Çengelli Mah (meydan Köyü)",
      "Çukurköy Mah (sarıderesi Köyü)",
      "Danişment Köyü",
      "Datça Mah (dizlermezeci Köyü)",
      "Demirci Köyü",
      "Dere Mah (aydoğmuş Köyü)",
      "Dip Mah (ilyasgeçidi Köyü)",
      "Dizler Mah (dizlermezeci Köyü)",
      "Esentepe Mah (paşalılar Köyü)",
      "Gürgenlik Mah (paşalılar Köyü)",
      "Gürgenlik Mah (sarıderesi Köyü)",
      "Hacıköy Köyü",
      "Hasanlar Mah (karaman Köyü)",
      "Hisarköy Köyü",
      "Hüseyin Paşa Mah (paşalılar Köyü)",
      "Kaleköy Köyü",
      "Kanatlı Köyü",
      "Kapısuyu Köyü",
      "Karşıgeçe Mah (başköy Köyü)",
      "Kaşaltı Mah (karaman Köyü)",
      "Kavaklı Köyü",
      "Kayalı Mah (kömeç Köyü)",
      "Kirlikmüslimhoca Köyü",
      "Merkez Mah (aydoğmuş Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (elvanlar Köyü)",
      "Merkez Mah (ilyasgeçidi Köyü)",
      "Merkez Mah (karaman Köyü)",
      "Merkez Mah (kömeç Köyü)",
      "Merkez Mah (meydan Köyü)",
      "Merkez Mah (ziyaretköy Köyü)",
      "Meryemler Mah (başköy Köyü)",
      "Mezeci Mah (dizlermezeci Köyü)",
      "Ovatekkeönü Köyü",
      "Ömerler Köyü",
      "Sarıderesi Köyü",
      "Şabanlar Mah (paşalılar Köyü)",
      "Şeyhler Köyü",
      "Şimşirdere Mah (ziyaretköy Köyü)",
      "Uğurlu Köyü",
      "Yakacı Mah (dizlermezeci Köyü)",
      "Yalı Mah (karaman Köyü)",
      "Yaylacık Mah (paşalılar Köyü)",
      "Yenice Mah (meydan Köyü)",
      "Yeniköy Köyü"
    ],
    "Merkez": [
      "Ağdacı Mah",
      "Demirciler Mah",
      "Gecen Mah",
      "Gölbucağı Mah",
      "Hürriyet Mah",
      "Karaçay Mah",
      "Kemer Köprü Mah",
      "Kırtepe Mah",
      "Köyortası Mah",
      "Okulak Mah",
      "Orduyeri Mah",
      "Orta Mah",
      "Şiremirçavuş Mah",
      "Tuna Mah",
      "Gerişli Mah (hasankadı Beldesi)",
      "Merkez Mah (hasankadı Beldesi)",
      "Şabankadı Mah (hasankadı Beldesi)",
      "Tüloğlu Mah (hasankadı Beldesi)",
      "Abdullahoğlu Mah (köyyeri Köyü)",
      "Abdullahoğlu Mah (mamak Köyü)",
      "Ağbaşı Mah (akbaş Köyü)",
      "Aşağı Mah (akağaç Köyü)",
      "Aşağı Mah (aşağıdere Köyü)",
      "Aşağı Mah (bedil Köyü)",
      "Aşağı Mah (karacaoğlu Köyü)",
      "Aşağı Mah (sülek Köyü)",
      "Aşağı Mah (sütlüce Köyü)",
      "Aşağı Mah (uluköy Köyü)",
      "Aşağı Mah (yeğenli Köyü)",
      "Aşıklar Mah (ustaoğlu Köyü)",
      "Bezirciler Mah (akıncılar Köyü)",
      "Bodra Mah (barkaçboz Köyü)",
      "Boğaz Mah (şarköy Köyü)",
      "Börekçi Mah (çaybükü Köyü)",
      "Canlar Mah (ecikler Köyü)",
      "Cıddımoğlu Mah (akbaş Köyü)",
      "Çakılaltı Mah (özbaşı Köyü)",
      "Çakırlar Mah (ellibaş Köyü)",
      "Çakmacık Mah (barkaçboz Köyü)",
      "Çapruzlar Mah (eskiemirler Köyü)",
      "Çay Mah (hocaoğlu Köyü)",
      "Çay Mah (köyyeri Köyü)",
      "Çay Mah (özbaşı Köyü)",
      "Çayırlardibi Mah (hocaoğlu Köyü)",
      "Çaylık Mah (hasanefendi Köyü)",
      "Çelikler Mah (celilbeyoğlu Köyü)",
      "Çiftçiler Mah (ellibaş Köyü)",
      "Çimkeoğlu Mah (eskiemirler Köyü)",
      "Çit Mah (yeğenli Köyü)",
      "Çobanoğlu Mah (sülek Köyü)",
      "Çolaklar Mah (sülek Köyü)",
      "Çolakoğlu Mah (hıdırlar Köyü)",
      "Çoluklar Mah (bedil Köyü)",
      "Çömlekler Mah (yeşilyurt Köyü)",
      "Çubukçu Deresi Mah (hanyeri Köyü)",
      "Davutlar Mah (çaybükü Köyü)",
      "Değirmenci Mah (kozcağız Beldesi)",
      "Deliktaş Mah (eyüpoğlu Köyü)",
      "Demirci Ahmetler Mah (kozcağız Beldesi)",
      "Demirci Mah (tasmacı Köyü)",
      "Dırazlar Mah (dırazlar Köyü)",
      "Doroğlu Mah (hanyeri Köyü)",
      "Düz Mah (akıncılar Köyü)",
      "Elmacı Mah (eskiemirler Köyü)",
      "Emiroğlu Mah (ecikler Köyü)",
      "Eseler Mah (celilbeyoğlu Köyü)",
      "Eseler Mah (dırazlar Köyü)",
      "Esenler Mah (karşıyaka Köyü)",
      "Fatih Mah (dırazlar Köyü)",
      "Fırdan Mah (akbaş Köyü)",
      "Gartosmanlar Mah (akbaş Köyü)",
      "Geciksuyu Mah (hasanefendi Köyü)",
      "Gofuroğlu Mah (tasmacı Köyü)",
      "Göcü Mah (akağaç Köyü)",
      "Göçmenler Mah (eskiemirler Köyü)",
      "Gümmeller Mah (akbaş Köyü)",
      "Hacı Hasan Dere Mah (yenihamidiye Köyü)",
      "Hacı İbrahim Mah (ecikler Köyü)",
      "Hacılar Mah (sütlüce Köyü)",
      "Hacırasul Mah (akçamescit Köyü)",
      "Hatipler Mah (karşıyaka Köyü)",
      "Hepler Mah (özbaşı Köyü)",
      "Kahya Mah (akıncılar Köyü)",
      "Kapucuoğlu Mah (şarköy Köyü)",
      "Karamanlar Mah (akıncılar Köyü)",
      "Karaotlu Mah (akbaş Köyü)",
      "Karga Mah (akçamescit Köyü)",
      "Karşı Mah (bedil Köyü)",
      "Karşı Mah (yeğenli Köyü)",
      "Karşıbakraç Mah (bakioğlu Köyü)",
      "Kavlaklık Mah (kozcağız Beldesi)",
      "Kayımlar Mah (akçamescit Köyü)",
      "Kerimoğlu Mah (ecikler Köyü)",
      "Kerpiçlik Mah (mamak Köyü)",
      "Kesmüklü Mah (ecikler Köyü)",
      "Kıran Mah (eskiemirler Köyü)",
      "Kıran Mah (ustaoğlu Köyü)",
      "Kıranpazarı Mah (ecikler Köyü)",
      "Kıranpazarı Mah (ustaoğlu Köyü)",
      "Kışla Mah (akbaş Köyü)",
      "Kiremli Mah (özbaşı Köyü)",
      "Kocaoğlu Mah (karayakup Köyü)",
      "Köseler Mah (karacaoğlu Köyü)",
      "Köstekçioğlu Mah (bedil Köyü)",
      "Kulaklar Mah (ecikler Köyü)",
      "Kuzyaka Mah (akıncılar Köyü)",
      "Lazlar Mah (akağaç Köyü)",
      "Lazlar Mah (bakioğlu Köyü)",
      "Lazoğlu Mah (mamak Köyü)",
      "Maskarlar Mah (ellibaş Köyü)",
      "Merkez Mah (akıncılar Köyü)",
      "Merkez Mah (avgölü Köyü)",
      "Merkez Mah (bakioğlu Köyü)",
      "Merkez Mah (başoğlu Köyü)",
      "Merkez Mah (celilbeyoğlu Köyü)",
      "Merkez Mah (çaybükü Köyü)",
      "Merkez Mah (ecikler Köyü)",
      "Merkez Mah (eskihamidiye Köyü)",
      "Merkez Mah (eyüpoğlu Köyü)",
      "Merkez Mah (hanyeri Köyü)",
      "Merkez Mah (hasanefendi Köyü)",
      "Merkez Mah (hıdırlar Köyü)",
      "Merkez Mah (karayakup Köyü)",
      "Merkez Mah (karşıyaka Köyü)",
      "Merkez Mah (kozcağız Beldesi)",
      "Merkez Mah (köyyeri Köyü)",
      "Merkez Mah (mamak Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (şabankadı Köyü)",
      "Merkez Mah (tasmacı Köyü)",
      "Merkez Mah (yeğenli Köyü)",
      "Merkez Mah (yenihamidiye Köyü)",
      "Meryemoğlu Mah (sütlüce Köyü)",
      "Musaoğlu Mah (hasanefendi Köyü)",
      "Muzafferler Mah (hocaoğlu Köyü)",
      "Neziroğlu Mah (hasanefendi Köyü)",
      "Orta Mah (aşağıdere Köyü)",
      "Orta Mah (çaybükü Köyü)",
      "Orta Mah (sütlüce Köyü)",
      "Orta Mah (şabankadı Köyü)",
      "Orta Mah (uluköy Köyü)",
      "Ortaçay Mah (hasanefendi Köyü)",
      "Oruçlar Mah (bakioğlu Köyü)",
      "Osmanbeyoğlu Mah (akbaş Köyü)",
      "Ölçekoğlu Mah (tasmacı Köyü)",
      "Ömerler Mah (ecikler Köyü)",
      "Özcanlar Mah (hocaoğlu Köyü)",
      "Saraçlar Mah (celilbeyoğlu Köyü)",
      "Satılmışoğlu Mah (bakioğlu Köyü)",
      "Sazlık Mah (akbaş Köyü)",
      "Solganlar Mah (dırazlar Köyü)",
      "Subaşı Mah (hocaoğlu Köyü)",
      "Şanlılar Mah (hocaoğlu Köyü)",
      "Şıvgılar Mah (ecikler Köyü)",
      "Şirinköy Köyü",
      "Tekke Mah (akçamescit Köyü)",
      "Tepeyanı Mah (hıdırlar Köyü)",
      "Terezoğlu Mah (bakioğlu Köyü)",
      "Tıra Mah (ecikler Köyü)",
      "Tokluoğlu Mah (akbaş Köyü)",
      "Topal Ali Mah (akçamescit Köyü)",
      "Topallar Mah (karşıyaka Köyü)",
      "Topallar Mah (yeşilyurt Köyü)",
      "Toroğlu Mah (ecikler Köyü)",
      "Turuplar Mah (ustaoğlu Köyü)",
      "Uslular Mah (akağaç Köyü)",
      "Yeni Mah (bedil Köyü)",
      "Yeni Mah (ustaoğlu Köyü)",
      "Yenişar Mah (kozcağız Beldesi)",
      "Yılmazlar Mah (hocaoğlu Köyü)",
      "Yukarı Ali Osmanlar Mah (özbaşı Köyü)",
      "Yukarı Mah (akağaç Köyü)",
      "Yukarı Mah (aşağıdere Köyü)",
      "Yukarı Mah (ellibaş Köyü)",
      "Yukarı Mah (karacaoğlu Köyü)",
      "Yukarı Mah (özbaşı Köyü)",
      "Yukarı Mah (sülek Köyü)",
      "Yukarı Mah (uluköy Köyü)",
      "Yukarı Mahelle Merkez Tosyanı Mah (özbaşı Köyü)",
      "Yukarı Yabalar Mah (özbaşı Köyü)",
      "Zoroğlu Mah (bedil Köyü)",
      "Ahatlar Mah (bayıryüzü Köyü)",
      "Ahatlı Mah (ulugeçitkadı Köyü)",
      "Ahcıoğlu Mah (beşköprü Köyü)",
      "Ahmetler Mah (kayadibikavlak Köyü)",
      "Akçaköy Mah (şahne Köyü)",
      "Akgöz Köyü",
      "Alaçam Mah (gençali Köyü)",
      "Aldırak Mah (kışlaköy Köyü)",
      "Alibaş Köyü",
      "Aliefendi Mah (çeştepe Köyü)",
      "Arabacı Mah (akçalı Köyü)",
      "Aşağı 1 Mah (geriş Köyü)",
      "Aşağı 2 Mah (geriş Köyü)",
      "Aşağı Kışla Mah (kışlaköy Köyü)",
      "Aşağı Mah (akçalı Köyü)",
      "Aşağı Mah (çayır Köyü)",
      "Aşağı Mah (epçiler Köyü)",
      "Aşağı Mah (gerişkatırcı Köyü)",
      "Aşağı Mah (karahüseyinli Köyü)",
      "Aşağı Mah (karamazak Köyü)",
      "Ayazlar Mah (kayacılar Köyü)",
      "Aydınlar Mah (beşköprü Köyü)",
      "Aydınlar Mah (kızılelma Köyü)",
      "Aygıroğlu Mah (arıönü Köyü)",
      "Bacaklar Mah (terkehatipler Köyü)",
      "Bakacak Mah (güzelcehisar Köyü)",
      "Bakla Mah (akpınar Köyü)",
      "Baklacıoğlu Mah (çiftlikköy Köyü)",
      "Balat Köyü",
      "Bayramoğlu Mah (bayıryüzü Köyü)",
      "Bekirler Mah (büyükkıran Köyü)",
      "Berberoğlu Mah (karamazak Köyü)",
      "Beyoğlu Mah (küçükkızılkum Köyü)",
      "Bilallar Mah (esenyurt Köyü)",
      "Bodurlar Mah (şahin Köyü)",
      "Boğaz Mah (karasu Köyü)",
      "Boğaz Mah (topluca Köyü)",
      "Bozacıoğlu Mah (küçükkızılkum Köyü)",
      "Canköyü Mah (epçilerkadı Köyü)",
      "Cebeci Mah (akpınar Köyü)",
      "Condur Mah (akpınar Köyü)",
      "Conkurlar Mah (serdar Köyü)",
      "Cöcü Köyü",
      "Cumayanı Mah (kaşbaşı Köyü)",
      "Çakırlar Mah (dallıca Köyü)",
      "Çalıkoğlu Mah (budakdüzü Köyü)",
      "Çalıkoğlu Mah (kutlubeydemirci Köyü)",
      "Çamlık Mah (çamlık Köyü)",
      "Çamlık Mah (uğurlar Köyü)",
      "Çapkınlar Mah (saraylı Köyü)",
      "Çavuş Mah (ulugeçitambarcı Köyü)",
      "Çavuşlar Mah (serdar Köyü)",
      "Çayır Mah (beşköprü Köyü)",
      "Çelebioğlu Mah (çakırdemirci Köyü)",
      "Çetme Mah (darıören Köyü)",
      "Çıvgınlar Mah (kızılelma Köyü)",
      "Çimke Mah (derbent Köyü)",
      "Çitoğlu Mah (akbaba Köyü)",
      "Çivaklar Mah (kümesler Köyü)",
      "Çobanlar Mah (akmanlar Köyü)",
      "Çorak Mah (kumaçorak Köyü)",
      "Çömlekçi Mah (epçiler Köyü)",
      "Çöpbey Köyü",
      "Dağ Mah (yeniköy Köyü)",
      "Dağdibi Mah (akmanlar Köyü)",
      "Dağlı Mah (kayadibi Köyü)",
      "Demirciler Mah (çiftlikköy Köyü)",
      "Dere Mah (gökçekıran Köyü)",
      "Dere Mah (gürpınar Köyü)",
      "Deredibi Mah (gökçekıran Köyü)",
      "Deveciler Mah (kışlaköy Köyü)",
      "Devşeyli Mah (akmanlar Köyü)",
      "Dırazlar Mah (hacıhatipoğlu Köyü)",
      "Dibektaş Mah (gençali Köyü)",
      "Direkler Mah (aydınlar Köyü)",
      "Dolaşıklar Mah (akmanlar Köyü)",
      "Dörtkol Mah (tuzcular Köyü)",
      "Dürükler Mah (çukurbük Köyü)",
      "Düzmevki Mah (büyükkıran Köyü)",
      "Ebişler Mah (aydınlar Köyü)",
      "Ebzen Mah (çukurbük Köyü)",
      "Ecikler Mah (kışlaköy Köyü)",
      "Edey Mah (epçilerkadı Köyü)",
      "Ela Mah (hatipler Köyü)",
      "Elmalık Mah (kışlaköy Köyü)",
      "Emri Mah (tabanözü Köyü)",
      "Ersanlar Mah (kutlubeyyazıcılar Köyü)",
      "Esenler Mah (ulugeçitambarcı Köyü)",
      "Esenpınar Mah (topluca Köyü)",
      "Fermüt Mah (dallıca Köyü)",
      "Fırınlı Köyü",
      "Gaffar Mah (gürpınar Köyü)",
      "Gaffar Mah (kaşbaşı Köyü)",
      "Gagiller Mah (kocareis Köyü)",
      "Galaygöz Mah (gençali Köyü)",
      "Gangahu Mah (yanaz Köyü)",
      "Genevir Mah (kabagöz Köyü)",
      "Gökçe Musa Mah (kutlubeydemirci Köyü)",
      "Gökler Mah (kışlaköy Köyü)",
      "Gökmenler Mah (şahin Köyü)",
      "Güneydağı Mah (karaköyşeyhler Köyü)",
      "Gürcüler Mah (küçükkızılkum Köyü)",
      "Gürgenpınarı Köyü",
      "Hacı Güllü Mah (çakırömerağa Köyü)",
      "Hacı Mah (akpınar Köyü)",
      "Hacı Mah (imamlar Köyü)",
      "Hacı Mah (kayadibikavlak Köyü)",
      "Hacıçavuşlar Mah (serdar Köyü)",
      "Hacıkadı Mah (büyükkıran Köyü)",
      "Hacıkıramoğlu Mah (kızılelma Köyü)",
      "Hacıoğlu Mah (büyükkıran Köyü)",
      "Hacıoğlu Mah (çakırkadı Köyü)",
      "Hacıosmanoğlu Mah (serdar Köyü)",
      "Haliller Mah (terkehaliller Köyü)",
      "Haliller Mah (yıldız Köyü)",
      "Halilpaşa Mah (yeşilkaya Köyü)",
      "Halim Mah (kayadibiçavuş Köyü)",
      "Hamamcı Mah (budakdüzü Köyü)",
      "Hamza Mah (imamlar Köyü)",
      "Hancılar Mah (çayır Köyü)",
      "Has Mah (kabagöz Köyü)",
      "Hasançavuş Mah (hatipler Köyü)",
      "Hasanlar Mah (hasanlar Köyü)",
      "Hasanlar Mah (serdar Köyü)",
      "Hasaşlar Mah (aydınlar Köyü)",
      "Hatipler Mah (çukurbük Köyü)",
      "Hatipler Mah (hatipler Köyü)",
      "Hatipler Mah (kumaçorak Köyü)",
      "Hatipler Mah (mekeçler Köyü)",
      "Haydeli Mah (esbey Köyü)",
      "Heyelli Mah (doğaşı Köyü)",
      "Hisar Mah (güzelcehisar Köyü)",
      "Hoca Mah (yeşilkaya Köyü)",
      "Horna Mah (tabanözü Köyü)",
      "Horoz Mah (yeşilkaya Köyü)",
      "Hoşköy Mah (kumaçorak Köyü)",
      "Hüseyinpaşaoğlu Mah (çakırkadı Köyü)",
      "Icak Mah (doğaşı Köyü)",
      "Ihlamur Mah (kayadibi Köyü)",
      "Ispala Mah (şiremirtabaklar Köyü)",
      "İlyaslar Mah (kurt Köyü)",
      "İmamlar Mah (esenyurt Köyü)",
      "İmamoğlu Mah (karamazak Köyü)",
      "İnkum İskele Mah (karasu Köyü)",
      "İnkum Yeni Mah (güzelcehisar Köyü)",
      "Kabaşlar Mah (bayıryüzü Köyü)",
      "Kadı Mah (epçilerkadı Köyü)",
      "Kadı Mah (gökçekıran Köyü)",
      "Kadı Mah (kutlubeydemirci Köyü)",
      "Kadıköy Mah (kayacılar Köyü)",
      "Kadıoğlu Mah (çakırkadı Köyü)",
      "Kalafatoğlu Mah (arıönü Köyü)",
      "Kalaycı Mah (kayadibi Köyü)",
      "Kalaycıoğlu Mah (esenyurt Köyü)",
      "Kaldırım Mah (darıören Köyü)",
      "Kanberler Mah (kumaçorak Köyü)",
      "Kanbur Mah (yeşilkaya Köyü)",
      "Kanıç Mah (kayadibikavlak Köyü)",
      "Karaalioğlu Mah (ahmetpaşa Köyü)",
      "Karacaoğlu Mah (hatipler Köyü)",
      "Karaçay Mah (uzunöz Köyü)",
      "Karadağlıoğlu Mah (küçükkızılkum Köyü)",
      "Karadut Mah (karainler Köyü)",
      "Karahasan Mah (kızılelma Köyü)",
      "Karahüseyinler Mah (epçilerkadı Köyü)",
      "Karakadı Mah (ahmetpaşa Köyü)",
      "Karakız Mah (karamazak Köyü)",
      "Karalar Burgucu Mah (kümesler Köyü)",
      "Karamustafa  Mah (gaziler Mah) (çeştepe Köyü)",
      "Karşı Köy Mah (karamazak Köyü)",
      "Karşı Mah (kışlaköy Köyü)",
      "Karteli Mah (karahüseyinli Köyü)",
      "Kasapoğlu Mah (kutlubeydemirci Köyü)",
      "Kaşıkçı Mah (çukurbük Köyü)",
      "Kavlak Mah (kayadibikavlak Köyü)",
      "Kavlak Mah (kocareis Köyü)",
      "Kaya Arkası Mah (darıören Köyü)",
      "Kaya Arkası Mah (kayadibikavlak Köyü)",
      "Kayadibi Merkez Mah (kayadibi Köyü)",
      "Kaypaklar Mah (kurt Köyü)",
      "Keller Mah (bayıryüzü Köyü)",
      "Kınalıoğlu Mah (ahmetpaşa Köyü)",
      "Kıraç Mah (büyükkızılkum Köyü)",
      "Kırma Mah (kayadibikavlak Köyü)",
      "Kirenciler Mah (mekeçler Köyü)",
      "K-kıran Mah (ahmetpaşa Köyü)",
      "Kocabeyoğlu Mah (kutlubeytabaklar Köyü)",
      "Kocikuzu Mah (kayadibikavlak Köyü)",
      "Kolçaklar Mah (çiftlikköy Köyü)",
      "Köseoğlu Mah (kutlubeydemirci Köyü)",
      "Köyortası Mah (serdar Köyü)",
      "Kula Mah (derbent Köyü)",
      "Kulaksız Mah (saraylı Köyü)",
      "Kurt Mah (kayadibiçavuş Köyü)",
      "Kutlubey Mah (tuzcular Köyü)",
      "Kuyu Mah (terkehaliller Köyü)",
      "Kuyumcu Mah (tuzcular Köyü)",
      "Külcüler Mah (muratbey Köyü)",
      "Külükoğlu Mah (terkehaliller Köyü)",
      "Lazlar Mah (esenyurt Köyü)",
      "Lazlar Mah (gürpınar Köyü)",
      "Macırlar Mah (büyükkıran Köyü)",
      "Maden Mah (okçular Köyü)",
      "Mahmutoğlu Mah (terkehaliller Köyü)",
      "Manaç Mah (serdar Köyü)",
      "Manoğlu Mah (tuzcular Köyü)",
      "Maruzlar Mah (hasanlar Köyü)",
      "Mazmoğlu Mah (akbaba Köyü)",
      "Mehmetbeyoğlu Mah (esenyurt Köyü)",
      "Mekeç Mah (mekeçler Köyü)",
      "Mellioğlu Mah (tuzcular Köyü)",
      "Memoğlu Mah (bayıryüzü Köyü)",
      "Menci Mah (akçalı Köyü)",
      "Menteşler Mah (hacıhatipoğlu Köyü)",
      "Menteşpiri Mah (arıt Köyü)",
      "Merkez  Mah (kapaklı Mah) (güzelcehisar Köyü)",
      "Merkez Mah (ahmetpaşa Köyü)",
      "Merkez Mah (akbaba Köyü)",
      "Merkez Mah (akmanlar Köyü)",
      "Merkez Mah (akpınar Köyü)",
      "Merkez Mah (arıönü Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (beşköprü Köyü)",
      "Merkez Mah (budakdüzü Köyü)",
      "Merkez Mah (büyükkıran Köyü)",
      "Merkez Mah (büyükkızılkum Köyü)",
      "Merkez Mah (çamaltı Köyü)",
      "Merkez Mah (çeştepe Köyü)",
      "Merkez Mah (çiftlikköy Köyü)",
      "Merkez Mah (çukurbük Köyü)",
      "Merkez Mah (darıören Köyü)",
      "Merkez Mah (derbent Köyü)",
      "Merkez Mah (doğaşı Köyü)",
      "Merkez Mah (epçiler Köyü)",
      "Merkez Mah (esbey Köyü)",
      "Merkez Mah (gençali Köyü)",
      "Merkez Mah (gökçekıran Köyü)",
      "Merkez Mah (gözpınar Köyü)",
      "Merkez Mah (hacıhatipoğlu Köyü)",
      "Merkez Mah (hacıosmanoğlu Köyü)",
      "Merkez Mah (imamlar Köyü)",
      "Merkez Mah (kabagöz Köyü)",
      "Merkez Mah (kaman Köyü)",
      "Merkez Mah (karainler Köyü)",
      "Merkez Mah (karaköyşeyhler Köyü)",
      "Merkez Mah (karasu Köyü)",
      "Merkez Mah (kaşbaşı Köyü)",
      "Merkez Mah (kayacılar Köyü)",
      "Merkez Mah (kayadibiçavuş Köyü)",
      "Merkez Mah (kızılelma Köyü)",
      "Merkez Mah (kocareis Köyü)",
      "Merkez Mah (kurt Köyü)",
      "Merkez Mah (kutlubeytabaklar Köyü)",
      "Merkez Mah (kümesler Köyü)",
      "Merkez Mah (muratbey Köyü)",
      "Merkez Mah (okçular Köyü)",
      "Merkez Mah (ören Köyü)",
      "Merkez Mah (saraylı Köyü)",
      "Merkez Mah (söğütlü Köyü)",
      "Merkez Mah (şahne Köyü)",
      "Merkez Mah (terkehatipler Köyü)",
      "Merkez Mah (topluca Köyü)",
      "Merkez Mah (tuzcular Köyü)",
      "Merkez Mah (uğurlar Köyü)",
      "Merkez Mah (ulugeçitambarcı Köyü)",
      "Merkez Mah (ulugeçitkadı Köyü)",
      "Merkez Mah (uzunöz Köyü)",
      "Merkez Mah (yanaz Köyü)",
      "Merkez Mah (yeniköy Köyü)",
      "Merkez Mah (yeşilkaya Köyü)",
      "Merkez Mah (yıldız Köyü)",
      "Meydan Mah (darıören Köyü)",
      "Meydan Mah (doğaşı Köyü)",
      "Meydan Mah (şahin Köyü)",
      "Molla Mah (ulugeçitambarcı Köyü)",
      "Molla Osman Mah (topluca Köyü)",
      "Mollabekir Mah (geriş Köyü)",
      "Mugada Mah (arıönü Köyü)",
      "Mugada Sahil Mah (arıönü Köyü)",
      "Muhacirler Mah (topluca Köyü)",
      "Musakalfaoglu Mah (ulugeçitkadı Köyü)",
      "Mutaf Mah (terkehaliller Köyü)",
      "Nane Mah (çeştepe Köyü)",
      "Nasuh Mah (tabanözü Köyü)",
      "Odamehmetoğlu Mah (çakırdemirci Köyü)",
      "Okçular Mah (kayacılar Köyü)",
      "Organize Sanayi Bölgesi Mah (yanaz Köyü)",
      "Ormanoğlu Mah (akmanlar Köyü)",
      "Orta Mah (akpınar Köyü)",
      "Orta Mah (çayır Köyü)",
      "Orta Mah (gerişkatırcı Köyü)",
      "Orta Mah (gökçekıran Köyü)",
      "Orta Mah (kümesler Köyü)",
      "Orta Mah (mekeçler Köyü)",
      "Ortaköy Mah (akçalı Köyü)",
      "Osman Mah (akbaba Köyü)",
      "Osman Mah (kayadibikavlak Köyü)",
      "Osmanbaşoğlu Mah (hacıosmanoğlu Köyü)",
      "Ovazlar Mah (karaköyşeyhler Köyü)",
      "Ömerköy Mah (akçalı Köyü)",
      "Ömerler Mah (karamazak Köyü)",
      "Örencik Mah (kayadibikavlak Köyü)",
      "Öteyüz Mah (büyükkızılkum Köyü)",
      "Pirnallar Mah (bayıryüzü Köyü)",
      "Postal Mah (gürpınar Köyü)",
      "Recepoğlu Mah (çakırdemirci Köyü)",
      "Receppaşa Mah (kurt Köyü)",
      "Sakaoğlu Mah (çakırkadı Köyü)",
      "Sakaoğlu Mah (ulugeçitkadı Köyü)",
      "Sarımsakçıoğlu Mah (küçükkızılkum Köyü)",
      "Seferler Mah (akmanlar Köyü)",
      "Sıralı Mah (ören Köyü)",
      "Sinoplu Mah (şiremirtabaklar Köyü)",
      "Sipahiler Köyü",
      "Sofular Mah (kutlubeyyazıcılar Köyü)",
      "Sucuoğlu Mah (karamazak Köyü)",
      "Şabanlar Mah (kutlubeyyazıcılar Köyü)",
      "Şahin Mah (şahin Köyü)",
      "Şahin Paşa Mah (mekeçler Köyü)",
      "Şahne Mah (doğaşı Köyü)",
      "Şehit Furkan Yılmaz Mah (büyükkızılkum Köyü)",
      "Şıpben Mah (çamaltı Köyü)",
      "Şişman Mah (gençali Köyü)",
      "Tabaklar Mah (ulugeçitkadı Köyü)",
      "Tabaklı Mah (çakırömerağa Köyü)",
      "Tabakoğlu Mah (kutlubeytabaklar Köyü)",
      "Taş Köprü Mah (uğurlar Köyü)",
      "Tataroğlu Mah (esenyurt Köyü)",
      "Tekke Mah (akbaba Köyü)",
      "Tellioğlu Mah (kutlubeyyazıcılar Köyü)",
      "Terke Mah (terkehaliller Köyü)",
      "Terkeli Mah (okçular Köyü)",
      "Tomaç Mah (dallıca Köyü)",
      "Topalcıoğlu Mah (karahüseyinli Köyü)",
      "Topallar Mah (ulugeçitambarcı Köyü)",
      "Topsakal Mah (arıönü Köyü)",
      "Turanlar Köyü",
      "Tüfenkçioğlu Mah (esenyurt Köyü)",
      "Türbeci Mah (epçilerkadı Köyü)",
      "Türdü Mah (akpınar Köyü)",
      "Uçarı Mah (aydınlar Köyü)",
      "Uzunlar Mah (çayır Köyü)",
      "Uzunlar Mah (ulugeçitkadı Köyü)",
      "Üçkurnalı Mah (kaman Köyü)",
      "Yağcı Mah (terkehatipler Köyü)",
      "Yanık Mah (kaman Köyü)",
      "Yayalar Mah (gerişkatırcı Köyü)",
      "Yaylacık Mah (güzelcehisar Köyü)",
      "Yazıcılar Mah (kutlubeyyazıcılar Köyü)",
      "Yazıcılar Mah (söğütlü Köyü)",
      "Yemenici Mah (şiremirtabaklar Köyü)",
      "Yeni Mah (akpınar Köyü)",
      "Yeni Mah (gökçekıran Köyü)",
      "Yeni Mah (kutlubeyyazıcılar Köyü)",
      "Yeni Mah (mekeçler Köyü)",
      "Yeniev Mah (büyükkızılkum Köyü)",
      "Yılancılar Mah (bayıryüzü Köyü)",
      "Yukarı Mah (çayır Köyü)",
      "Yukarı Mah (epçilerkadı Köyü)",
      "Yukarı Mah (geriş Köyü)",
      "Yukarı Mah (karahüseyinli Köyü)",
      "Yukarıköy Mah (akçalı Köyü)",
      "Yukarışeyhler Köyü",
      "Yumuşaklar Mah (kurt Köyü)",
      "Yusufbaşoglu Mah (hacıosmanoğlu Köyü)",
      "Yusufoğlu Mah (arıönü Köyü)",
      "Zeybekler Mah (esenyurt Köyü)",
      "Zotlar Mah (esenyurt Köyü)",
      "Aladağ Mah",
      "Cumhuriyet Mah",
      "Çaydüzü Mah",
      "Esentepe Mah",
      "Karaköy Mah"
    ],
    "Ulus": [
      "Derecik Mah (abdipaşa Beldesi)",
      "Kadıoğlu Mah (abdipaşa Beldesi)",
      "Karadiken Mah (abdipaşa Beldesi)",
      "Ulupınar Mah (abdipaşa Beldesi)",
      "Yeşilpazar Mah (abdipaşa Beldesi)",
      "Abdaloğlu Mah (zafer Köyü)",
      "Ahmet Sofuoğlu Mah (konak Köyü)",
      "Aksaray Mah (akörensöküler Köyü)",
      "Alaköy Mah (çubuklu Köyü)",
      "Alaoğlu Mah (uluköy Köyü)",
      "Ali Efendioğlu Mah (akörensöküler Köyü)",
      "Ali Kadıoğlu Mah (hisarköy Köyü)",
      "Aşağı Mah (kıyıklar Köyü)",
      "Aşağı Mah (kirsinler Köyü)",
      "Azgın Mah (uluköy Köyü)",
      "Bayırlar Mah (akörensöküler Köyü)",
      "Bayıslar Mah (akörensöküler Köyü)",
      "Bayraktaroğlu Mah (yılanlar Köyü)",
      "Bayramoğlu Mah (ceyüpler Köyü)",
      "Boğaz Mah (kirsinler Köyü)",
      "Camuşoğlu Mah (doğanköy Köyü)",
      "Ceyüpler Mah (ceyüpler Köyü)",
      "Cumadüzü Mah (kıyıklar Köyü)",
      "Çandırlar Mah (hisarköy Köyü)",
      "Çaytarla Mah (zafer Köyü)",
      "Çengelli Mah (kızıllar Köyü)",
      "Çukurtarla Mah (yenikışla Köyü)",
      "Dağlar Mah (döngeller Köyü)",
      "Dedeoğlu Mah (ceyüpler Köyü)",
      "Değirmenyanı Mah (hisarköy Köyü)",
      "Değirmenyanı Mah (yenikışla Köyü)",
      "Değirmenyanı Mah (zafer Köyü)",
      "Dengezler Mah (döngeller Köyü)",
      "Dere Mah (yılanlar Köyü)",
      "Derecami Mah (konak Köyü)",
      "Doğankızı Mah (akörensöküler Köyü)",
      "Düzağaç Mah (akörensöküler Köyü)",
      "Düzyer Mah (akörensöküler Köyü)",
      "Ekmekçioğlu Mah (çubuklu Köyü)",
      "Eseoğlu Mah (yılanlar Köyü)",
      "Esmir Mah (üçsaray Köyü)",
      "Fabrikayanı Mah (zafer Köyü)",
      "Fazlıoğlu Mah (zafer Köyü)",
      "Furuncuoğlu Mah (ceyüpler Köyü)",
      "Galleşoğlu Mah (hisarköy Köyü)",
      "Geriş Mah (ceyüpler Köyü)",
      "Gökdere Mah (yılanlar Köyü)",
      "Gökmenoğlu Mah (çubuklu Köyü)",
      "Güvendik Mah (konuklu Köyü)",
      "Hacıkadıoğlu Mah (hisarköy Köyü)",
      "Haplıoğlu Mah (akörensöküler Köyü)",
      "Hızarcıoğlu Mah (doğanköy Köyü)",
      "Hisar Mah (hisarköy Köyü)",
      "Hocaoğlu Mah (hisarköy Köyü)",
      "Hocaoğlu Mah (öncüler Köyü)",
      "İmamlar Mah (üçsaray Köyü)",
      "İncirler Mah (keçideresi Köyü)",
      "İnebey Mah (uluköy Köyü)",
      "Kabasakaloğlu Mah (zafer Köyü)",
      "Kadıoğlu Mah (bağdatlı Köyü)",
      "Kadıoğlu Mah (üçsaray Köyü)",
      "Kahyaoğlu Mah (döngeller Köyü)",
      "Kanatoğlu Mah (kıyıklar Köyü)",
      "Karabacak Mah (uluköy Köyü)",
      "Karakaşoğlu Mah (akörensöküler Köyü)",
      "Karavelioğlu Mah (zafer Köyü)",
      "Kavaklıkaldırım Mah (kumluca Beldesi)",
      "Kazaskeroğlu Mah (zafer Köyü)",
      "Keloğlu Mah (zafer Köyü)",
      "Kızılovaz Mah (akörensöküler Köyü)",
      "Kocakahya Mah (kıyıklar Köyü)",
      "Konutevler Mah (çubuklu Köyü)",
      "Köhünler Mah (konak Köyü)",
      "Köse Mah (zafer Köyü)",
      "Köseoğlu Mah (yılanlar Köyü)",
      "Kulaklar Mah (öncüler Köyü)",
      "Kulaksızoğlu Mah (uluköy Köyü)",
      "Kütükoğlu Mah (hisarköy Köyü)",
      "Maksadoğlu Mah (çubuklu Köyü)",
      "Marazoğlu Mah (doğanköy Köyü)",
      "Merkez Mah (bağdatlı Köyü)",
      "Merkez Mah (çubuklu Köyü)",
      "Merkez Mah (dibektaş Köyü)",
      "Merkez Mah (döngeller Köyü)",
      "Merkez Mah (keçideresi Köyü)",
      "Merkez Mah (kıyıklar Köyü)",
      "Merkez Mah (kızıllar Köyü)",
      "Merkez Mah (konak Köyü)",
      "Merkez Mah (konuklu Köyü)",
      "Merkez Mah (kumluca Beldesi)",
      "Merkez Mah (yenikışla Köyü)",
      "Merkez Mah (yılanlar Köyü)",
      "Milne Mah (üçsaray Köyü)",
      "Müyesseroğlu Mah (hisarköy Köyü)",
      "Orta Mah (yenikışla Köyü)",
      "Ömerağa Mah (uluköy Köyü)",
      "Ören Mah (kızıllar Köyü)",
      "Seferoğlu Mah (doğanköy Köyü)",
      "Serdaroğlu Mah (konuklu Köyü)",
      "Sofuoğlu Mah (çubuklu Köyü)",
      "Söküler Mah (akörensöküler Köyü)",
      "Şahabettin Mah (uluköy Köyü)",
      "Tabaklar Mah (öncüler Köyü)",
      "Ulu Mah (uluköy Köyü)",
      "Üçpınar Mah (zafer Köyü)",
      "Yamaklar Mah (kıyıklar Köyü)",
      "Yeni Mah (ceyüpler Köyü)",
      "Yeni Mah (kumluca Beldesi)",
      "Yeni Mah (uluköy Köyü)",
      "Yeni Mah (yılanlar Köyü)",
      "Yirmibeşoğlu Mah (uluköy Köyü)",
      "Yukarı Mah (kirsinler Köyü)",
      "Zaroğlu Mah (hisarköy Köyü)",
      "Ahmet Mah (aşağıdere Köyü)",
      "Ahmetçelebi Mah (kozanlı Köyü)",
      "Akmeşeyanı Mah (dodurga Köyü)",
      "Aktaş Mah (aktaş Köyü)",
      "Aktoprak Mah (hasanören Köyü)",
      "Alaoğlu Mah (güneyören Köyü)",
      "Ali Mah (ağaköy Köyü)",
      "Aliçelebi Mah (kayabaşı Köyü)",
      "Alnek Mah (karakışla Köyü)",
      "Andız Mah (yeniköy Köyü)",
      "Araçlar Mah (hocaköy Köyü)",
      "Aslancı Mah (dodurga Köyü)",
      "Aşağı Mah (aşağıçerçi Köyü)",
      "Aşağı Mah (balıcak Köyü)",
      "Aşağı Mah (çerde Köyü)",
      "Aşağı Mah (çubukbeli Köyü)",
      "Aşağı Mah (karahasan Köyü)",
      "Aşağı Mah (sarnıç Köyü)",
      "Aşağıavlu Mah (şirinler Köyü)",
      "Aşağıdere Mah (aşağıköy Köyü)",
      "Aşağıdoruca Mah (dorucaşahinci Köyü)",
      "Ayaklı Mah (eldeş Köyü)",
      "Bakışoğlu Mah (hocaköy Köyü)",
      "Balderesi Mah (kayabaşı Köyü)",
      "Baraka Mah (güneyören Köyü)",
      "Bayrambaşoğlu Mah (iğneciler Köyü)",
      "Bekir Mah (aşağıdere Köyü)",
      "Belensarnıç Mah (güneyören Köyü)",
      "Bıyıklı Mah (ağaköy Köyü)",
      "Börekçiler Mah (kayabaşı Köyü)",
      "Budamış Mah (ulukaya Köyü)",
      "Camiyanı Merkez Mah (gökpınar Köyü)",
      "Cebeci Mah (balıcak Köyü)",
      "Cebeci Mah (eseler Köyü)",
      "Cüceoğlu Mah (kalecik Köyü)",
      "Çamçı Mah (balıcak Köyü)",
      "Çamdibi Mah (alıçlı Köyü)",
      "Çavuşoğlu Mah (çavuşköy Köyü)",
      "Çayırlıoğlu Mah (dorucaşahinci Köyü)",
      "Çıraklar Mah (alıçlı Köyü)",
      "Çitoğlu Mah (abdurrahman Köyü)",
      "Danagölü Mah (şirinler Köyü)",
      "Davutlar Mah (dodurga Köyü)",
      "Değirmencik Mah (elmacık Köyü)",
      "Değirmenyanı Mah (eldeş Köyü)",
      "Değirmenyanı Mah (inceçam Köyü)",
      "Demirci Mah (hocaköy Köyü)",
      "Demirci Mah (inceçam Köyü)",
      "Demirci Mah (kalecik Köyü)",
      "Demirciler Mah (abdurrahman Köyü)",
      "Demirciler Mah (sarnıç Köyü)",
      "Demiren Mah (dorucaşahinci Köyü)",
      "Dere Mah (arpacık Köyü)",
      "Dere Mah (güneyören Köyü)",
      "Dere Mah (kirazcık Köyü)",
      "Dereli Mah (sarıfasıl Köyü)",
      "Doruk Mah (ibrahimderesi Köyü)",
      "Dutlu Mah (köklü Köyü)",
      "Düz Mah (aşağıemirce Köyü)",
      "Düz Mah (buğurlar Köyü)",
      "Düz Mah (çubukbeli Köyü)",
      "Düz Mah (eldeş Köyü)",
      "Ediler Mah (dodurga Köyü)",
      "Elmalık Mah (eseler Köyü)",
      "Emir Mah (aşağıdere Köyü)",
      "Emirtaş Mah (eldeş Köyü)",
      "Ese Mah (eseler Köyü)",
      "Eskioğlu Mah (gökpınar Köyü)",
      "Esköy Mah (sarnıç Köyü)",
      "Fışkın Mah (küllü Köyü)",
      "Gedikler Mah (eseler Köyü)",
      "Gegen Mah (çerde Köyü)",
      "Göksu Mah (yukarıdere Köyü)",
      "Gürgencami Mah (kadıköy Köyü)",
      "Hacı Mah (aktaş Köyü)",
      "Hacı Mah (küllü Köyü)",
      "Hatipler Mah (çubukbeli Köyü)",
      "Hendek Mah (sarıfasıl Köyü)",
      "Hıradüzü Mah (aşağıemirce Köyü)",
      "Himmetoğlu Mah (yeniköy Köyü)",
      "Hoca Mah (hocaköy Köyü)",
      "Hüseyin Mah (aşağıdere Köyü)",
      "Ilavıç Mah (arpacık Köyü)",
      "Isırganlı Köyü",
      "İmamoğlu Mah (aktaş Köyü)",
      "İnciller Mah (dörekler Köyü)",
      "İslamlar Mah (kadıköy Köyü)",
      "İsmailağa Mah (inceçam Köyü)",
      "Kabaoğlu Mah (iğneciler Köyü)",
      "Kadı Mah (aktaş Köyü)",
      "Kadı Mah (inceçam Köyü)",
      "Kadirağa Mah (gökpınar Köyü)",
      "Kalfalar Mah (dereli Köyü)",
      "Kanavaka Mah (hocaköy Köyü)",
      "Kanburoğlu Mah (dereli Köyü)",
      "Karaboyunoğlu Mah (abdurrahman Köyü)",
      "Karadayılar Mah (gökpınar Köyü)",
      "Karagöl Mah (aşağıemirce Köyü)",
      "Karakaçoğlu Mah (abdurrahman Köyü)",
      "Karakuz Mah (güneyören Köyü)",
      "Karamadanoğlu Mah (kadıköy Köyü)",
      "Karamanoğlu Mah (dodurga Köyü)",
      "Karasa Mah (düzköy Köyü)",
      "Kargacak Mah (eldeş Köyü)",
      "Kaşaltı Mah (kalecik Köyü)",
      "Kavlakdibi Mah (bahçecik Köyü)",
      "Kayacılar Mah (iğneciler Köyü)",
      "Kayıcılar Mah (karakışla Köyü)",
      "Kayraltı Mah (buğurlar Köyü)",
      "Kayrançı Mah (hocaköy Köyü)",
      "Kemerli Mah (aşağıçamlı Köyü)",
      "Kerpiçli Mah (yukarıdere Köyü)",
      "Kestane Mah (eldeş Köyü)",
      "Kınakayası Mah (hocaköy Köyü)",
      "Kıraharmanı Mah (iğneciler Köyü)",
      "Kıranüzeri Mah (kalecik Köyü)",
      "Kızılelma Mah (kalecik Köyü)",
      "Koçak Mah (aşağıçamlı Köyü)",
      "Koçali Mah (çubukbeli Köyü)",
      "Kuruoğlu Mah (düzköy Köyü)",
      "Kuzören Mah (buğurlar Köyü)",
      "Kürtoğlu Mah (güneyören Köyü)",
      "Lafazanlar Mah (gökpınar Köyü)",
      "Madenoğlu Mah (eseler Köyü)",
      "Merkez Mah (ağaköy Köyü)",
      "Merkez Mah (alpı Köyü)",
      "Merkez Mah (arpacık Köyü)",
      "Merkez Mah (aşağıçamlı Köyü)",
      "Merkez Mah (aşağıdere Köyü)",
      "Merkez Mah (aşağıemirce Köyü)",
      "Merkez Mah (bahçecik Köyü)",
      "Merkez Mah (buğurlar Köyü)",
      "Merkez Mah (dereli Köyü)",
      "Merkez Mah (dodurga Köyü)",
      "Merkez Mah (dörekler Köyü)",
      "Merkez Mah (düzköy Köyü)",
      "Merkez Mah (elmacık Köyü)",
      "Merkez Mah (güneyören Köyü)",
      "Merkez Mah (hasanören Köyü)",
      "Merkez Mah (ibrahimderesi Köyü)",
      "Merkez Mah (kadıköy Köyü)",
      "Merkez Mah (kalecik Köyü)",
      "Merkez Mah (karakışla Köyü)",
      "Merkez Mah (kayabaşı Köyü)",
      "Merkez Mah (kirazcık Köyü)",
      "Merkez Mah (kozanlı Köyü)",
      "Merkez Mah (köklü Köyü)",
      "Merkez Mah (küllü Köyü)",
      "Merkez Mah (sarıfasıl Köyü)",
      "Merkez Mah (şirinler Köyü)",
      "Merkez Mah (ulukaya Köyü)",
      "Merkez Mah (yukarıdere Köyü)",
      "Molla Mah (inceçam Köyü)",
      "Ocaklı Mah (ağaköy Köyü)",
      "Onaç Mah (bahçecik Köyü)",
      "Orta Mah (aşağıköy Köyü)",
      "Orta Mah (çavuşköy Köyü)",
      "Orta Mah (kalecik Köyü)",
      "Orta Mah (karahasan Köyü)",
      "Orta Mah (sarnıç Köyü)",
      "Oyrak Mah (eseler Köyü)",
      "Ozan Mah (eldeş Köyü)",
      "Ömeroğlu Mah (alıçlı Köyü)",
      "Ömeroğlu Mah (kadıköy Köyü)",
      "Ören Mah (bahçecik Köyü)",
      "Ören Mah (eldeş Köyü)",
      "Paşalı Mah (aşağıçamlı Köyü)",
      "Pazar Mah (eldeş Köyü)",
      "Pazar Mah (kozanlı Köyü)",
      "Pınarönü Mah (eldeş Köyü)",
      "Rumluoğlu Mah (güneyören Köyü)",
      "Samatlı Mah (kozanlı Köyü)",
      "Sap Mah (dörekler Köyü)",
      "Sarıcaağaç Mah (küllü Köyü)",
      "Seferler Mah (inceçam Köyü)",
      "Sofular Mah (hocaköy Köyü)",
      "Somullu Mah (elmacık Köyü)",
      "Sorguncuk Mah (yeniköy Köyü)",
      "Şahinoğlu Mah (ağaköy Köyü)",
      "Şükrüoğlu Mah (yeniköy Köyü)",
      "Tahtabaşoğlu Mah (abdurrahman Köyü)",
      "Tanışman Mah (eseler Köyü)",
      "Taşçıoğlu Mah (düzköy Köyü)",
      "Tekmenoğlu Mah (kadıköy Köyü)",
      "Tombooğlu Mah (çavuşköy Köyü)",
      "Üçpınar Mah (balıcak Köyü)",
      "Vildanlar Mah (eseler Köyü)",
      "Yalvaç Mah (hocaköy Köyü)",
      "Yeni Mah (bahçecik Köyü)",
      "Yeni Mah (dereli Köyü)",
      "Yeni Mah (hasanören Köyü)",
      "Yeni Mah (sarnıç Köyü)",
      "Yenice Mah (aşağıdere Köyü)",
      "Yukarı Mah (aşağıçerçi Köyü)",
      "Yukarı Mah (aşağıemirce Köyü)",
      "Yukarı Mah (aşağıköy Köyü)",
      "Yukarı Mah (balıcak Köyü)",
      "Yukarı Mah (çerde Köyü)",
      "Yukarı Mah (çubukbeli Köyü)",
      "Yukarı Mah (karahasan Köyü)",
      "Yukarıavlu Mah (şirinler Köyü)",
      "Yukarıdoruca Mah (dorucaşahinci Köyü)",
      "Zopunoğlu Mah (abdurrahman Köyü)",
      "Kaldırım Mah",
      "Kasımlar Mah",
      "Mezgeller Mah",
      "Samat Mah",
      "Saz Mah"
    ]
  },
  "Ardahan": {
    "Çıldır": [
      "Aşıkşenlik Mah",
      "Çankaya Mah",
      "Çay Mah",
      "Dedekorkut Mah",
      "Suhara Mah",
      "Ufuktepe Mah",
      "Yakınsu Mah",
      "Yeni Mah",
      "Yıldırımtepe Mah",
      "Ağıllı Köyü",
      "Akçakale Köyü",
      "Akçıl Köyü",
      "Akdarı Köyü",
      "Akkiraz Köyü",
      "Aşağıcambaz Köyü",
      "Baltalı Köyü",
      "Başköy Köyü",
      "Damlıca Köyü",
      "Dirsekkaya Köyü",
      "Doğankaya Köyü",
      "Eskibeyrehatun Köyü",
      "Eşmepınar Köyü",
      "Gölbelen Köyü",
      "Gölebakan Köyü",
      "Güvenocak Köyü",
      "Horozöttü Mah (kenardere Köyü)",
      "Karakale Köyü",
      "Kaşlıkaya Köyü",
      "Kayabeyi Köyü",
      "Kenarbel Köyü",
      "Kotanlı Köyü",
      "Kotanlı Yayla Evleri Mah (kotanlı Köyü)",
      "Kurtkale Köyü",
      "Kuzukaya Köyü",
      "Merkez Mah (kenardere Köyü)",
      "Meryemköy Köyü",
      "Öncül Köyü",
      "Övündü Köyü",
      "Sabaholdu Köyü",
      "Saymalı Köyü",
      "Sazlısu Köyü",
      "Semihaşakir Köyü",
      "Taşdeğirmen Köyü",
      "Yenibeyrehatun Köyü",
      "Yukarıcambaz Köyü"
    ],
    "Damal": [
      "Ata Mah",
      "Cumhuriyet Mah",
      "Çaybaşı Mah",
      "İnönü Mah",
      "Kalender Mah",
      "Konuk Sever Mah",
      "Mustafa Kemal Mah",
      "Serhat Mah",
      "Burmadere Köyü",
      "Dereköy Köyü",
      "Dereköy Köyü Yayla Evleri",
      "Eskikılıç Köyü",
      "Eskikılıç Köyü Yayla Evleri",
      "İkizdere Köyü",
      "İkizdere Köyü Yayla Evleri",
      "Otağlı Köyü",
      "Seyitören Köyü",
      "Tepeköy Köyü Merkez",
      "Tepeköy Yayla Evleri Mah (tepeköy Köyü)"
    ],
    "Göle": [
      "Fevzi Çakmak Mah",
      "Kazım Karabekir Mah",
      "Kubilay Bey Mah",
      "Salim Bey Mah",
      "Dedeşen Mah (köprülü Beldesi)",
      "Durançam Mah (köprülü Beldesi)",
      "Köprülü Merkez Mah (köprülü Beldesi)",
      "Kuzupınarı Mah (köprülü Beldesi)",
      "Arpaşen Köyü",
      "Balçeşme Köyü",
      "Bellitepe Köyü",
      "Budaklı Köyü",
      "Büyükaltınbulak Köyü",
      "Çakıldere Köyü",
      "Çakırüzüm Köyü",
      "Çalıdere Köyü",
      "Çardaklı Köyü",
      "Çayırbaşı Köyü",
      "Çullu Köyü",
      "Damlasu Köyü",
      "Dedekılıcı Köyü",
      "Dengeli Köyü",
      "Dereyolu Köyü",
      "Dölekçayır Köyü",
      "Esenboğaz Köyü",
      "Esenyayla Köyü",
      "Eskidemirkapı Köyü",
      "Filizli Köyü",
      "Gedik Köyü",
      "Gevrik Mah (büyükaltınbulak Köyü)",
      "Gülçeşme Mah (çobanköy Köyü)",
      "Güldere Mah (çobanköy Köyü)",
      "Gülistan Köyü",
      "Günorta Köyü",
      "Hoşdülbent Köyü",
      "Kalecik Köyü",
      "Karlıyazı Köyü",
      "Kayaaltı Köyü",
      "Kore Mah (durucasu Köyü)",
      "Koyunlu Köyü",
      "Köprübaşı Mah (dedekılıcı Köyü)",
      "Kuytuca Köyü",
      "Küçükaltınbulak Köyü",
      "Mollahasan Köyü",
      "Okçu Köyü",
      "Samandöken Köyü",
      "Senemoğlu Köyü",
      "Serinçayır Köyü",
      "Sürügüden Köyü",
      "Tahtakıran Köyü",
      "Tellioğlu Köyü",
      "Toptaş Köyü",
      "Uğurtaşı Köyü",
      "Yağmuroğlu Köyü",
      "Yanatlı Köyü",
      "Yavuzlar Köyü",
      "Yeleçli Köyü",
      "Yenidemirkapı Köyü",
      "Yeniköy Köyü",
      "Yiğitkonağı Köyü"
    ],
    "Hanak": [
      "Alaçam Mah",
      "Atalar Mah",
      "Avcılar Mah",
      "Hürriyet Mah",
      "Ortakent Merkez Mah",
      "Selam Verdi Mah",
      "Altınemek Köyü",
      "Arıkonak Köyü",
      "Aşağı Çat Mah (çatköy Köyü)",
      "Aşağıaydere Köyü",
      "Baştoklu Köyü",
      "Binbaşak Köyü",
      "Börk Köyü",
      "Çavdarlı Köyü",
      "Çayağzı Köyü",
      "Çiçeklidağ Köyü",
      "Çimliçayır Köyü",
      "Dilekdere Köyü",
      "Geç Köyü",
      "Güneşgören Köyü",
      "İncedere Köyü",
      "Karakale Köyü",
      "Karşı Mah (çimliçayır Köyü)",
      "Kırkpınar Mah (koyunpınarı Köyü)",
      "Kireçhane Mah (koyunpınarı Köyü)",
      "Koyunpınarı Köyü",
      "Oğuzyolu Köyü",
      "Sazlıçayır Köyü",
      "Serinkuyu Köyü",
      "Serinkuyu Yaylası Mah (serinkuyu Köyü)",
      "Sevimli Köyü",
      "Sevimli Yayla Evleri Mah (sevimli Köyü)",
      "Sulakçayır Köyü",
      "Yamaçyolu Köyü",
      "Yamçılı Köyü",
      "Yayla Evleri Mah (çatköy Köyü)",
      "Yayla Evleri Mah (çimliçayır Köyü)",
      "Yayla Evleri Mah (güneşgören Köyü)",
      "Yayla Mah (çayağzı Köyü)",
      "Yayla Mah (çiçeklidağ Köyü)",
      "Yayla Mah (incedere Köyü)",
      "Yukarı Çat Mah (çatköy Köyü)",
      "Yukarıaydere Köyü",
      "Yünbüken Köyü"
    ],
    "Merkez": [
      "Atatürk Mah",
      "Gürçayır Mah",
      "Halilefendi Mah",
      "İnönü Mah",
      "Kaptanpaşa Mah",
      "Karagöl Mah",
      "Yeni Mah",
      "Ağaçlı Köyü",
      "Aşağı Mah (çağlayık Köyü)",
      "Aşağı Mah (ömerağa Köyü)",
      "Aşağı Mah (samanbeyli Köyü)",
      "Aşağıkurtoğlu Köyü",
      "Bayramoğlu Köyü",
      "Beşiktaş Köyü",
      "Binbaşar Köyü",
      "Çalabaş Köyü",
      "Dağcı Köyü",
      "Değirmen Mah (nebioğlu Köyü)",
      "Eski Mah (taşlıdere Köyü)",
      "Giriş Mah (nebioğlu Köyü)",
      "Hacıali Köyü",
      "Höçvan Bucağı Hasköy Köyü",
      "Köprübaşı Mah (höçvan Bucağı Hasköy Köyü)",
      "Köprücük Köyü",
      "Lehimli Köyü",
      "Merkez Mah (çağlayık Köyü)",
      "Mezra Mah (çağlayık Köyü)",
      "Orta Mah (nebioğlu Köyü)",
      "Otbiçen Köyü",
      "Taşlıdere Köyü",
      "Tazeköy Köyü",
      "Tunçoluk Köyü",
      "Yeni Mah (taşlıdere Köyü)",
      "Yukarı Mah (ömerağa Köyü)",
      "Yukarı Mah (samanbeyli Köyü)",
      "Yukarıkurtoğlu Köyü",
      "Ağzıpek Köyü",
      "Alagöz Köyü",
      "Altaş Köyü",
      "Aşağı Mah (açıkyazı Köyü)",
      "Aşağı Mah (kocaköy Köyü)",
      "Balıkçılar Köyü",
      "Büyüksütlüce Köyü",
      "Çamlıçatak Köyü",
      "Çamlıçatak Mah (çamlıçatak Köyü)",
      "Çataldere Köyü",
      "Çerme Mah (ölçek Köyü)",
      "Çiftlik Mah (büyüksütlüce Köyü)",
      "Değirmenli Köyü",
      "Dere Mah (ölçek Köyü)",
      "Gölgeli Köyü",
      "Güzçimeni Köyü",
      "Güzelyurt Köyü",
      "Kartalpınar Köyü",
      "Kartalpınarosb Mah (kartalpınar Köyü)",
      "Kazlıköy Köyü",
      "Kızılkilise Mah (güzelyurt Köyü)",
      "Küçüksütlüce Köyü",
      "Meşedibi Köyü",
      "Ortageçit Köyü",
      "Ortageçit Mah (ortageçit Köyü)",
      "Ovapınar Köyü",
      "Sarıyamaç Köyü",
      "Sugöze Köyü",
      "Sulakyurt Köyü",
      "Sulakyurt Mah (sulakyurt Köyü)",
      "Şehiryolu Mah (tepesuyu Köyü)",
      "Tepesuyu Köyü",
      "Tulumba Mah (ölçek Köyü)",
      "Yaylacık Köyü",
      "Yaylacık Mah (gölgeli Köyü)",
      "Yaylacık Mah (yaylacık Köyü)",
      "Yokuşdibi Köyü",
      "Yukarı Mah (açıkyazı Köyü)",
      "Yukarı Mah (kocaköy Köyü)",
      "Akyaka Köyü",
      "Ardıçdere Köyü",
      "Bağdaşen Köyü",
      "Çatalköprü Köyü",
      "Çeğilli Köyü",
      "Çetinsu Köyü",
      "Çimenkaya Köyü",
      "Dağevi Köyü",
      "Dedegül Köyü",
      "Derindere Köyü",
      "Edegül Köyü",
      "Hasköy Köyü",
      "Kıraç Köyü",
      "Tepeler Köyü",
      "Uzunova Köyü",
      "Yanlızçam Köyü"
    ],
    "Posof": [
      "Akballı Köyü",
      "Alabalık Köyü",
      "Alköy Köyü",
      "Arılı Köyü",
      "Armutveren Köy Yaylası",
      "Armutveren Köyü",
      "Asmakonak Köyü",
      "Aşağı Mah (demirdöver Köyü)",
      "Aşağı Mah (günlüce Köyü)",
      "Aşıküzeyir Köyü",
      "Aşıkzülali Köyü",
      "Balgöze Köyü",
      "Binbaşıeminbey Köyü",
      "Binbaşıeminbey Köyü Yayla Evleri",
      "Cadeze Mah (günlüce Köyü)",
      "Cami Mah (kolköy Köyü)",
      "Cumatel Mah (baykent Köyü)",
      "Çakırkoç Köyü",
      "Çambeli Köyü",
      "Çamyazı Köyü",
      "Çayırçimen Köyü",
      "Damala Mah (kırköy Köyü)",
      "Derindere Köyü",
      "Derinsu Mah (binbaşıeminbey Köyü)",
      "Erim Köyü",
      "Gönülaçan Köyü",
      "Gönülaçan Köyü Yaylası",
      "Gümüşkavak Köyü",
      "Günbatan Köyü",
      "Gürarmut Köyü",
      "Hurgeşen Mah (demirdöver Köyü)",
      "İncedere Köyü",
      "Kaleönü Köyü",
      "Kaleönü Köyü Yaylaları",
      "Kalkankaya Köyü",
      "Kapan Mah (gürarmut Köyü)",
      "Kayadibi Mah (kolköy Köyü)",
      "Kayınlı Köyü",
      "Kır Mah (kırköy Köyü)",
      "Kısa Mah (kolköy Köyü)",
      "Kışla Yaylası Mah (akballı Köyü)",
      "Kopuzlu Köyü",
      "Kumlukoz Köyü",
      "Kurşunçavuş Köyü",
      "Marzolat Mah (arılı Köyü)",
      "Merkez Mah (baykent Köyü)",
      "Orta Mah (kolköy Köyü)",
      "Özbaşı Köyü",
      "Sarıçiçek Köyü",
      "Sarıdarı Köyü",
      "Savaşır Köyü",
      "Sekene Mah (kolköy Köyü)",
      "Söğütlükaya Köyü",
      "Söğütlükaya Köyü Yaylaları",
      "Süngülü Köyü",
      "Sütoluk Köyü",
      "Sütoluk Yayla Evleri Mah (sütoluk Köyü)",
      "Taşkıran Köyü",
      "Tikas Mah (demirdöver Köyü)",
      "Türkgözü Köyü",
      "Türkgözü Mah (türkgözü Köyü)",
      "Uğurca Köy Yaylaları",
      "Uğurca Köyü",
      "Uluçam Köyü",
      "Yayla Evi Mah (baykent Köyü)",
      "Yayla Evleri Mah (derindere Köyü)",
      "Yayla Evleri Mah (kolköy Köyü)",
      "Yayla Evleri Mah (kopuzlu Köyü)",
      "Yayla Evleri Mah (kurşunçavuş Köyü)",
      "Yayla Evleri Mah (savaşır Köyü)",
      "Yayla Evleri Mah (süngülü Köyü)",
      "Yayla Evleri Mah (taşkıran Köyü)",
      "Yayla Mah (aşıkzülali Köyü)",
      "Yayla Mah (gümüşkavak Köyü)",
      "Yayla Mah (incedere Köyü)",
      "Yayla Mah (kumlukoz Köyü)",
      "Yayla Mah (yaylaaltı Köyü)",
      "Yayla Mah (yolağzı Köyü)",
      "Yaylaaltı Köyü",
      "Yeniköy Köyü",
      "Yolağzı Köyü",
      "Yukarı Mah (baykent Köyü)",
      "Yukarı Mah (demirdöver Köyü)",
      "Yukarı Mah (günlüce Köyü)",
      "Yurtbaşı Köyü",
      "Yurtbekler Köyü",
      "Doğrular Mah",
      "Merkez Mah"
    ]
  },
  "Iğdır": {
    "Aralık": [
      "Aras Mah",
      "Karasu Mah",
      "Karşıyaka Mah",
      "Köprüler Mah",
      "Ortaköy Mah",
      "Adetli Köyü",
      "Aşağıaratan Köyü",
      "Aşağıçamurlu Köyü",
      "Aşağıçiftlik Köyü",
      "Aşağıtopraklı Köyü",
      "Babacan Köyü",
      "Emince Köyü",
      "Esenkaya Mah (karahacılı Köyü)",
      "Gödekli Köyü",
      "Hacıağa Köyü",
      "Hasanhan Köyü",
      "Hıdırlı Mah (adetli Köyü)",
      "Karahacılı Köyü",
      "Kırçiçeği Köyü",
      "Kolikent Köyü",
      "Ortalar Mah (aşağıçamurlu Köyü)",
      "Ramazankent Köyü",
      "Saraçlı Köyü",
      "Tarlabaşı Köyü",
      "Tazeköy Köyü",
      "Tigem Mah (emince Köyü)",
      "Yenidoğan Köyü",
      "Yukarıaratan Köyü",
      "Yukarıçamurlu Köyü",
      "Yukarıçiftlik Köyü",
      "Yukarıtopraklı Köyü"
    ],
    "Karakoyunlu": [
      "Ergenekon Mah",
      "Fatih Mah",
      "Aktaş Köyü",
      "Aşağıalican Köyü",
      "Bayatdoğanşalı Köyü",
      "Bekirhanlı Köyü",
      "Bulakbaşı Köyü",
      "Cennetabat Köyü",
      "Gökçeli Köyü",
      "Gölköy Mah (gölköy Köyü)",
      "İslamköy Köyü",
      "Kacardoğanşalı Köyü",
      "Kerimbeyli Köyü",
      "Koçkıran Köyü",
      "Merkez Mah (taşburun Köyü)",
      "Mürşitali Köyü",
      "Orta Alican Köyü",
      "Seferkulu Mah (şıracı Köyü)",
      "Şıracı Köyü",
      "Yazlık Köyü",
      "Yukarıalican Köyü",
      "Zülfikarköy Köyü"
    ],
    "Merkez": [
      "Bahçelievler Mah (halfeli Beldesi)",
      "Özvatan Mah (halfeli Beldesi)",
      "Said Nursi Mah (halfeli Beldesi)",
      "Turgut Özal Mah (halfeli Beldesi)",
      "Yunus Emre Mah (halfeli Beldesi)",
      "Faruktoka Mah (hoşhaber Beldesi)",
      "Yeni Mah (hoşhaber Beldesi)",
      "14 Kasım Mah",
      "Ali Kamerli Mah",
      "Atatürk Mah",
      "Bağlar Mah",
      "Cumhuriyet Mah",
      "Emek Mah",
      "Hakveyis Mah",
      "Karaağaç Mah",
      "Konaklı Mah",
      "Özgür Mah",
      "Pir Sultan Abdal Mah",
      "Söğütlü Mah",
      "Topçular Mah",
      "Yeni Mah",
      "Karabağ Mah (melekli Beldesi)",
      "Mehmet Akif Ersoy Mah (melekli Beldesi)",
      "Namık Kemal Mah (melekli Beldesi)",
      "Ağaver Köyü",
      "Akyumak Köyü",
      "Ali Köçek Mah (zor Köyü)",
      "Alibeyköy Köyü",
      "Asma Köyü",
      "Aşağıçarıkçı Köyü",
      "Aşağıerhacı Köyü",
      "Bayraktutan Köyü",
      "Belalak Mah (kavaktepe Köyü)",
      "Bendemurat Köyü",
      "Bezirhane Mah (çilli Köyü)",
      "Çakırtaş Köyü",
      "Çalpala Köyü",
      "Çalpalaosb Mah (çalpala Köyü)",
      "Çiko Mah (çilli Köyü)",
      "Çilli Köyü",
      "Elmagöl Köyü",
      "Enginalan Köyü",
      "Evci Köyü",
      "Gülpınar Köyü",
      "Güngörmez Köyü",
      "Hakmehmet Köyü",
      "Harmandöven Köyü",
      "Kadıkışlak Köyü",
      "Kanal Yolu Mah (enginalan Köyü)",
      "Karagüney Köyü",
      "Karahisar Mah (taşlıca Köyü)",
      "Karakuyu Köyü",
      "Kasımcan Köyü",
      "Kavaktepe Köyü",
      "Kazancı Köyü",
      "Kervansaray Mah (harmandöven Köyü)",
      "Kızılkule Mah (güngörmez Köyü)",
      "Korhan Mah (suveren Köyü)",
      "Köprüköy Mah (çilli Köyü)",
      "Kuç Mah (mezraa Köyü)",
      "Kuzugüden Köyü",
      "Küllük Köyü",
      "Mezraa Köyü",
      "Mirza Mah (kavaktepe Köyü)",
      "Necefali Köyü",
      "Nişankaya Köyü",
      "Obaköy Köyü",
      "Örüşmüş Köyü",
      "Panik Köyü",
      "Pınarbaşı Köyü",
      "Sarıçoban Köyü",
      "Suveren Köyü",
      "Şanlımırza Mah (suveren Köyü)",
      "Tacirli Köyü",
      "Taşlıca Köyü",
      "Yaycı Köyü",
      "Yukarıçarıkcı Köyü",
      "Yukarıerhacı Mah (aşağıerhacı Köyü)",
      "Yüzbaşılar Köyü",
      "Zor Köyü"
    ],
    "Tuzluca": [
      "Abbasgöl Köyü",
      "Adalet Mah (canderviş Köyü)",
      "Afet Konutları Mah (kula Köyü)",
      "Ağabey Köyü",
      "Akdeğirmen Köyü",
      "Akdiz Köyü",
      "Akoluk Köyü",
      "Alçalı Mah (kayaören Köyü)",
      "Alhanlı Köyü",
      "Aliköse Köyü",
      "Arslanlı Köyü",
      "Aşağı Çıyrıklı Köyü",
      "Aşağıaktaş Köyü",
      "Aşağıcivanlı Köyü",
      "Aşağıkatırlı Köyü",
      "Aşağısutaşı Köyü",
      "Aşık Hüseyin Mah (aşağıkatırlı Köyü)",
      "Badilli Köyü",
      "Bağlan Köyü",
      "Bahçecik Köyü",
      "Bahçelimeydan Köyü",
      "Başsinek Mah (ombulak Köyü)",
      "Beyoğlu Köyü",
      "Bostanlı Köyü",
      "Boyluca Mah (yağlı Köyü)",
      "Buruksu Köyü",
      "Canderviş Köyü",
      "Çıraklı Köyü",
      "Çiçekli Köyü",
      "Değirmen Mah (sürmeli Köyü)",
      "Dipsiz Mah (bahçecik Köyü)",
      "Doğanyurt Köyü",
      "Eğrekdere Köyü",
      "Elmalık Köyü",
      "Gaziler Köyü",
      "Gedikli Köyü",
      "Göktaş Köyü",
      "Gülahmet Mah (yağlı Köyü)",
      "Güllüce Köyü",
      "Gültepe Mah (güllüce Köyü)",
      "Güzeldere Köyü",
      "Hadımlı Köyü",
      "Hamurkesen Köyü",
      "Hasankent Köyü",
      "İnce Köyü",
      "İncesu Köyü",
      "Kalaça Köyü",
      "Kamışlı Köyü",
      "Kandilli Köyü",
      "Karabulak Köyü",
      "Karacören Köyü",
      "Karagüney Mah (doğanyurt Köyü)",
      "Karakoyun Köyü",
      "Karanlık Köyü",
      "Karataş Köyü",
      "Kayakışlak Köyü",
      "Kayaören Köyü",
      "Kazkoparan Köyü",
      "Kelekli Köyü",
      "Kılıçlı Köyü",
      "Kırkbulak Köyü",
      "Kızıldüz Mah (hadımlı Köyü)",
      "Kızılkelefe Mah (yağlı Köyü)",
      "Kıznefer Köyü",
      "Koçbaşı Mah (taşuçan Köyü)",
      "Konaklı Mah (ombulak Köyü)",
      "Köprübaşı Köyü",
      "Kula Köyü",
      "Kumbulak Köyü",
      "Kuruağaç Köyü",
      "Küçükova Köyü",
      "Laleli Köyü",
      "Lebi Mah (kalaça Köyü)",
      "Mollakamer Köyü",
      "Nahırkıran Köyü",
      "Ombulak Köyü",
      "Ortabucak Köyü",
      "Osmanköy Köyü",
      "Pınar Mah (abbasgöl Köyü)",
      "Pirdemir Köyü",
      "Pirli Mah (sürmeli Köyü)",
      "Rağbet Mah (bahçecik Köyü)",
      "Sarıabdal Köyü",
      "Sarıbulak Köyü",
      "Soğukbulak Köyü",
      "Söğütlü Köyü",
      "Sürmeli Köyü",
      "Taşköprü Mah (kandilli Köyü)",
      "Taşuçan Köyü",
      "Tezekçi Köyü",
      "Turabi Köyü",
      "Tutak Köyü",
      "Uğruca Köyü",
      "Üçkaya Köyü",
      "Ünlendi Köyü",
      "Yağlı Köyü",
      "Yassıbulak Köyü",
      "Yaylacık Köyü",
      "Yeniköy Mah (göktaş Köyü)",
      "Yeniköy Mah (ombulak Köyü)",
      "Yukarı Sutaşı Mah (aşağısutaşı Köyü)",
      "Yukarıaktaş Köyü",
      "Yukarıcivanlı Köyü",
      "Yukarıçıyrıklı Mah (aşağı Çıyrıklı Köyü)",
      "Yüceotak Köyü",
      "Zarifhane Mah (ombulak Köyü)",
      "Aşağı Mah",
      "Cumhuriyet Mah",
      "Orta Mah",
      "Yeni Mah",
      "Yukarı Mah"
    ]
  },
  "Yalova": {
    "Altınova": [
      "Cumhuriyet Mah",
      "Hersek Mah",
      "Hürriyet Mah",
      "Merkez Mah (kaytazdere Beldesi)",
      "Ahmediye Köyü",
      "Aktoprak Köyü",
      "Çavuş Köyü",
      "Devletyolu Altı Mah (çavuşçiftliği Köyü)",
      "Devletyolu Üstü Mah (çavuşçiftliği Köyü)",
      "Fevziye Köyü",
      "Geyikdere Köyü",
      "Havuzdere Köyü",
      "Karadere Köyü",
      "Köy Altı Mah (tokmak Köyü)",
      "Köy İçi Mah (tokmak Köyü)",
      "Örencik Köyü",
      "Sermayecik Köyü",
      "Soğuksu Köyü",
      "Altınkent Mah (subaşı Beldesi)",
      "Denizgören Mah (subaşı Beldesi)",
      "Merkez Mah (subaşı Beldesi)",
      "Fatih Mah (tavşanlı Beldesi)",
      "Şehitlik Mah (tavşanlı Beldesi)"
    ],
    "Armutlu": [
      "50. Yıl Mah",
      "Bayır Mah",
      "Karşıyaka Mah",
      "Hayriye Merkez Mah (hayriye Köyü)",
      "İhsaniye Mah (mecidiye Köyü)",
      "Köy Merkezi Mah (fıstıklı Köyü)",
      "Köy Merkezi Mah (kapaklı Köyü)",
      "Köy Merkezi Mah (mecidiye Köyü)",
      "Köy Merkezi Mah (selimiye Köyü)",
      "Yalı Mah (fıstıklı Köyü)"
    ],
    "Çınarcık": [
      "Çamlık Mah",
      "Harmanlar Mah",
      "Hasanbaba Mah",
      "Karpuzdere Mah",
      "Taşliman Mah",
      "Aliye Hanım Mah (esenköy Beldesi)",
      "Liman Mah (esenköy Beldesi)",
      "Atakent Mah (koru Beldesi)",
      "Cumhuriyet Mah (koru Beldesi)",
      "Hürriyet Mah (koru Beldesi)",
      "Köy İçi Mah (şenköy Köyü)",
      "Merkez Mah (çalıca Köyü)",
      "Merkez Mah (kocadere Köyü)",
      "Merkez Mah (ortaburun Köyü)",
      "Yalı Mah (kocadere Köyü)",
      "Cumhuriyet Mah (teşvikiye Beldesi)",
      "İstiklal Mah (teşvikiye Beldesi)",
      "Karşıyaka Mah (teşvikiye Beldesi)"
    ],
    "Çiftlikköy": [
      "500 Evler Mah",
      "Çiftlik Mah",
      "Mehmet Akif Ersoy Mah",
      "Sahil Mah",
      "Siteler Mah",
      "Sultaniye Mah",
      "Burhaniye Köyü",
      "Dereköy Köyü",
      "Gacık Mah (gacık Köyü)",
      "Göllü Mah (gacık Köyü)",
      "Kılıç Merkez Mah (kılıç Köyü)",
      "Merkez Mah (çukurköy Köyü)",
      "Merkez Mah (ilyasköy Köyü)",
      "Merkez Mah (laledere Köyü)",
      "Yalova İzmit Karayolu Mah (kılıç Köyü)",
      "Yukarı Mah (çukurköy Köyü)",
      "Yukarı Mah (ilyasköy Köyü)",
      "Kabaklı Köyü",
      "Merkez Mah (denizçalı Köyü)",
      "Merkez Mah (kabaklı Köyü)",
      "Taşköprü Merkez Mah (taşköprü Beldesi)",
      "Taşköprü Yeni Mah (taşköprü Beldesi)"
    ],
    "Merkez": [
      "Adnan Menderes Mah",
      "Bağlarbaşı Mah",
      "Bahçelievler Mah",
      "Bayraktepe Mah",
      "Dere Mah",
      "Fevzi Çakmak Mah",
      "Gazi Osman Paşa Mah",
      "İsmet Paşa Mah",
      "Kazım Karabekir Mah",
      "Mustafa Kemal Paşa Mah",
      "Paşakent Mah",
      "Rüstem Paşa Mah",
      "Süleyman Bey Mah",
      "Merkez Mah (kadıköy Beldesi)",
      "Özden Mah (kadıköy Beldesi)",
      "Güneyköy Mah (güneyköy Köyü)",
      "Merkez Mah (elmalık Köyü)",
      "Merkez Mah (esadiye Köyü)",
      "Merkez Mah (güneyköy Köyü)",
      "Merkez Mah (hacımehmet Köyü)",
      "Merkez Mah (kazımiye Köyü)",
      "Merkez Mah (kirazlı Köyü)",
      "Merkez Mah (kurtköy Köyü)",
      "Merkez Mah (safran Köyü)",
      "Merkez Mah (samanlı Köyü)",
      "Merkez Mah (soğucak Köyü)",
      "Merkez Mah (sugören Köyü)",
      "Sanayi Mah (kirazlı Köyü)",
      "Seyrantepe Mah",
      "Sugören Mah (sugören Köyü)",
      "Süpürgelik Mah (sugören Köyü)"
    ],
    "Termal": [
      "Köyiçi Mah (akköy Köyü)",
      "Köyiçi Mah (yenimahalle Köyü)",
      "Gökçedere Mah",
      "Üvezpınar Mah"
    ]
  },
  "Karabük": {
    "Eflani": [
      "Candaroğulları Mah",
      "Çalışlar Mah",
      "Çelebiler Mah",
      "Kayadibi Mah",
      "Tabaklar Mah",
      "Yalacık Mah",
      "Ahatlar Mah (güngören Köyü)",
      "Ahmetci Mah (akçakese Köyü)",
      "Akbaş Mah (osmanlar Köyü)",
      "Alhanlar Mah (çengeller Köyü)",
      "Alifakoğlu Mah (bostancılar Köyü)",
      "Aloğlu Mah (koltucak Köyü)",
      "Alt Mah (gelicek Köyü)",
      "Aslanlar Mah (afşar Köyü)",
      "Aşağı Mah (alaçat Köyü)",
      "Aşağı Mah (hacıağaç Köyü)",
      "Aşağı Mah (yağlıca Köyü)",
      "Aşağı Mülayim Mah (mülayim Köyü)",
      "Aşağıkonak Mah (çengeller Köyü)",
      "Avdal Mah (bostancı Köyü)",
      "Bahçeli Mah (koltucak Köyü)",
      "Bakacak Mah (hacışaban Köyü)",
      "Bakacak Mah (karataş Köyü)",
      "Baraj Yanı Mah (bostancılar Köyü)",
      "Başiğdir Köyü",
      "Başören Mah (günlüce Köyü)",
      "Berberoğlu Mah (afşar Köyü)",
      "Beyazıtoğlu Mah (çengeller Köyü)",
      "Bezikler Mah (afşar Köyü)",
      "Bicco Mah (bakırcılar Köyü)",
      "Boduroğlu Mah (pınarözü Köyü)",
      "Bostancı Mah (akçakese Köyü)",
      "Bozarmut Mah (saraycık Köyü)",
      "Bürüncek Mah (çukurören Köyü)",
      "Celepoğlu Mah (kocacık Köyü)",
      "Cevizli Mah (çavuşlu Köyü)",
      "Cilver Mah (bostancı Köyü)",
      "Cingöz Mah (halkevli Köyü)",
      "Cortlar Mah (yağlıca Köyü)",
      "Cücey Mah (soğucak Köyü)",
      "Çakırosmanlar Mah (ovaşeyhler Köyü)",
      "Çalıkahvesi Mah (osmanlar Köyü)",
      "Çalıkoğlu Mah (soğucak Köyü)",
      "Çalış Mah (ovaçalış Köyü)",
      "Çaloğlu Mah (ovaşeyhler Köyü)",
      "Çay Mah (karataş Köyü)",
      "Çelebioğlu Mah (bağlıca Köyü)",
      "Çeltekler Mah (bağlıca Köyü)",
      "Çeşmeli Mah (koltucak Köyü)",
      "Çıraklar Mah (yağlıca Köyü)",
      "Çıraklı Mah (aday Köyü)",
      "Çiftçiler Mah (bostancı Köyü)",
      "Çiftlik Mah (ovaşeyhler Köyü)",
      "Çilekoğlu Mah (çamyurt Köyü)",
      "Çirişler Mah (kocacık Köyü)",
      "Çömeç Mah (halkevli Köyü)",
      "Çömlekler Mah (bağlıca Köyü)",
      "Çörekli Mah (ovaçalış Köyü)",
      "Çukurca Mah (göller Köyü)",
      "Dağcıoğlu Mah (hacıağaç Köyü)",
      "Danaşoğlu Mah (kavak Köyü)",
      "Dayılar Mah (gökgöz Köyü)",
      "Deccaller Mah (müftüler Köyü)",
      "Dele Mah (gökgöz Köyü)",
      "Demircioğlu Mah (karataş Köyü)",
      "Demircioğlu Mah (kocacık Köyü)",
      "Dere Mah (osmanlar Köyü)",
      "Dereköy Mah (akçakese Köyü)",
      "Derler Mah (çemçi Köyü)",
      "Durallar Mah (pınarözü Köyü)",
      "Ekmekçioğlu Mah (soğucak Köyü)",
      "Ekşioğlu Mah (abakolu Köyü)",
      "Esenoğlu Mah (yağlıca Köyü)",
      "Eyüpoğlu Mah (saçak Köyü)",
      "Fidikler Mah (ovaşeyhler Köyü)",
      "Gemicioğlu Mah (ovaşeyhler Köyü)",
      "Gencoğlu Mah (bedil Köyü)",
      "Gocaoğlu Mah (karlı Köyü)",
      "Gökceoğlu Mah (hacıağaç Köyü)",
      "Gülabi Mah (esencik Köyü)",
      "Hacıoğlu Mah (karataş Köyü)",
      "Hacıosman Mah (ulugeçit Köyü)",
      "Haciz Oğlu Mah (pınarözü Köyü)",
      "Halaşlar Mah (mülayim Köyü)",
      "Haliloğlu Mah (bostancılar Köyü)",
      "Hasanlar Mah (kutluören Köyü)",
      "Hekimli Mah (çamyurt Köyü)",
      "Hereşabanlar Mah (yağlıca Köyü)",
      "Heslemoğlu Mah (bağlıca Köyü)",
      "Hıdırlı Mah (alpagut Köyü)",
      "Hünkerler Mah (mülayim Köyü)",
      "İmamoğlu Mah (bostancılar Köyü)",
      "İmamoğlu Mah (kocacık Köyü)",
      "İnallar Mah (çengeller Köyü)",
      "İnciğez Mah (demirli Köyü)",
      "Kabalar Mah (seferler Köyü)",
      "Kabaoğlu Mah (ovaçalış Köyü)",
      "Kadı Mah (koltucak Köyü)",
      "Kadıoğlu Mah (çörekli Köyü)",
      "Kadıoğlu Mah (emirler Köyü)",
      "Kadıoğlu Mah (karacapınar Köyü)",
      "Kadıoğlu Mah (ovaşeyhler Köyü)",
      "Kahyaoğlu Mah (bağlıca Köyü)",
      "Kapso Mah (çörekli Köyü)",
      "Karabacak Mah (bakırcılar Köyü)",
      "Karacabey Mah (hacıağaç Köyü)",
      "Karacaoğlu Mah (bedil Köyü)",
      "Karagöz Mah (bostancı Köyü)",
      "Karamehmetoğlu Mah (ovaşeyhler Köyü)",
      "Karani Mah (ovaşeyhler Köyü)",
      "Karapınar Mah (alaçat Köyü)",
      "Karasadık Mah (hacışaban Köyü)",
      "Kartallar Mah (kutluören Köyü)",
      "Karyağdılar Mah (ulugeçit Köyü)",
      "Kavaloğlu Mah (günlüce Köyü)",
      "Kavutoğlu Mah (soğucak Köyü)",
      "Kaya Mah (karlı Köyü)",
      "Kayabaşı Mah (gökgöz Köyü)",
      "Kayalar Mah (akören Köyü)",
      "Kaykıoğlu Mah (bakırcılar Köyü)",
      "Kaymakcı Mah (bedil Köyü)",
      "Keço Mah (saçak Köyü)",
      "Kelekoğlu Mah (kutluören Köyü)",
      "Kemerler Mah (müftüler Köyü)",
      "Kenanlar Mah (bağlıca Köyü)",
      "Kızılcalar Mah (bostancılar Köyü)",
      "Kızılgelik Mah (çal Köyü)",
      "Konak Mah (afşar Köyü)",
      "Köçek Mah (kavak Köyü)",
      "Köle Mah (bedil Köyü)",
      "Kuloğlu Mah (abakolu Köyü)",
      "Kurtçular Mah (bostancılar Köyü)",
      "Küre Mah (demirli Köyü)",
      "Kürt Mah (koltucak Köyü)",
      "Mahmutlar Mah (güngören Köyü)",
      "Makmara Mah (soğucak Köyü)",
      "Malakcıoğlu Mah (hacışaban Köyü)",
      "Maylat Mah (güngören Köyü)",
      "Mazlumlar Mah (seferler Köyü)",
      "Merkez Mah (abakolu Köyü)",
      "Merkez Mah (aday Köyü)",
      "Merkez Mah (akçakese Köyü)",
      "Merkez Mah (akören Köyü)",
      "Merkez Mah (alaçat Köyü)",
      "Merkez Mah (alpagut Köyü)",
      "Merkez Mah (bağlıca Köyü)",
      "Merkez Mah (bakırcılar Köyü)",
      "Merkez Mah (bedil Köyü)",
      "Merkez Mah (bostancılar Köyü)",
      "Merkez Mah (çal Köyü)",
      "Merkez Mah (çamyurt Köyü)",
      "Merkez Mah (çavuşlu Köyü)",
      "Merkez Mah (çemçi Köyü)",
      "Merkez Mah (çengeller Köyü)",
      "Merkez Mah (çörekli Köyü)",
      "Merkez Mah (çukurgelik Köyü)",
      "Merkez Mah (çukurören Köyü)",
      "Merkez Mah (demirli Köyü)",
      "Merkez Mah (esencik Köyü)",
      "Merkez Mah (gökgöz Köyü)",
      "Merkez Mah (göller Köyü)",
      "Merkez Mah (günlüce Köyü)",
      "Merkez Mah (hacışaban Köyü)",
      "Merkez Mah (halkevli Köyü)",
      "Merkez Mah (karacapınar Köyü)",
      "Merkez Mah (karataş Köyü)",
      "Merkez Mah (karlı Köyü)",
      "Merkez Mah (kavak Köyü)",
      "Merkez Mah (kıran Köyü)",
      "Merkez Mah (koltucak Köyü)",
      "Merkez Mah (kutluören Köyü)",
      "Merkez Mah (müftüler Köyü)",
      "Merkez Mah (mülayim Köyü)",
      "Merkez Mah (osmanlar Köyü)",
      "Merkez Mah (ovaçalış Köyü)",
      "Merkez Mah (paşabey Köyü)",
      "Merkez Mah (pınarözü Köyü)",
      "Merkez Mah (saçak Köyü)",
      "Merkez Mah (saraycık Köyü)",
      "Merkez Mah (seferler Köyü)",
      "Merkez Mah (soğucak Köyü)",
      "Merkez Mah (şenyurt Köyü)",
      "Merkez Mah (ulugeçit Köyü)",
      "Merkez Mah (yağlıca Köyü)",
      "Molla Halil Mah (çemçi Köyü)",
      "Mollaoğlu Mah (müftüler Köyü)",
      "Murat Mah (saçak Köyü)",
      "Musluoğlu Mah (yağlıca Köyü)",
      "Müsekoğlu Mah (kocacık Köyü)",
      "Namazcıoğlu Mah (emirler Köyü)",
      "Nuhoğlu Mah (şenyurt Köyü)",
      "Numanoğlu Mah (akören Köyü)",
      "Ortakcı Mah (halkevli Köyü)",
      "Oruçlar Mah (bağlıca Köyü)",
      "Ovacık Mah (demirli Köyü)",
      "Ömeroğlu Mah (osmanlar Köyü)",
      "Ömüroğlu Mah (günlüce Köyü)",
      "Örencik Mah (abakolu Köyü)",
      "Örencik Mah (ovaşeyhler Köyü)",
      "Parmaksızlar Mah (hacıağaç Köyü)",
      "Pınarlar Mah (güngören Köyü)",
      "Ponooğlu Mah (bakırcılar Köyü)",
      "Rahmanlar Mah (bağlıca Köyü)",
      "Rahmanlar Mah (ulugeçit Köyü)",
      "Rahmanoğlu Mah (çemçi Köyü)",
      "Sağıroğlu Mah (bakırcılar Köyü)",
      "Sağıroğlu Mah (bostancılar Köyü)",
      "Sakalar Mah (bedil Köyü)",
      "Sarıkayaaltı Mah (aday Köyü)",
      "Sarıoğlu Mah (kutluören Köyü)",
      "Seferbeyoğlu Mah (kıran Köyü)",
      "Sıtlıkoğlu Mah (ovaşeyhler Köyü)",
      "Sinitler Mah (çukurören Köyü)",
      "Siyamoğlu Mah (ovaşeyhler Köyü)",
      "Sofuoğlu Mah (soğucak Köyü)",
      "Şeyhoğlu Mah (güngören Köyü)",
      "Şeyhoğlu Mah (hacıağaç Köyü)",
      "Şükürşük Mah (aday Köyü)",
      "Tamiş Mah (kutluören Köyü)",
      "Tepe Mah (çukurören Köyü)",
      "Tepe Mah (ovaçalış Köyü)",
      "Terke Mah (çavuşlu Köyü)",
      "Terzioğlu Mah (kutluören Köyü)",
      "Topuz Mah (kocacık Köyü)",
      "Topuzlu Mah (gökgöz Köyü)",
      "Türbelioğlu Mah (osmanlar Köyü)",
      "Üst Mah (gelicek Köyü)",
      "Velifakir Mah (emirler Köyü)",
      "Velişıhlar Mah (akören Köyü)",
      "Yantiri Mah (koltucak Köyü)",
      "Yayalar Mah (pınarözü Köyü)",
      "Yazıcıoğlu Mah (bedil Köyü)",
      "Yeni Mah (osmanlar Köyü)",
      "Yeniköprü Mah (osmanlar Köyü)",
      "Yukarı Karlı Mah (karlı Köyü)",
      "Yukarı Mah (yağlıca Köyü)"
    ],
    "Eskipazar": [
      "Bahçepınar Mah",
      "İstasyon Mah",
      "Kıranköy Mah",
      "Merkez Mah",
      "Mermer Mah",
      "Yamanlar Mah",
      "Yeni Mah",
      "Acemler Mah (doğancılar Köyü)",
      "Adiller Yayla Evleri Mah (adiller Köyü)",
      "Ağırtaş Mah (arslanlar Köyü)",
      "Akpınar Mah (haslı Köyü)",
      "Aksu Mah (gözlü Köyü)",
      "Alan Yaylası Mah (kabaarmut Köyü)",
      "Aşağı Bulduk Mah (bulduk Köyü)",
      "Aşağı Karahasanlar Mah (karahasanlar Köyü)",
      "Aşağı Kazlar Mah (haslı Köyü)",
      "Aşağı Keçeler Mah (yazıkavak Köyü)",
      "Aşağı Saray Mah (karahasanlar Köyü)",
      "Baldanlar Mah (budaklar Köyü)",
      "Bayındır Köyü",
      "Bekir Mah (yürecik Köyü)",
      "Beye Mah (kapaklı Köyü)",
      "Beytarla Yaylası Mah (beytarla Köyü)",
      "Bölme Mah (adiller Köyü)",
      "Bürnük Mah (hamzalar Köyü)",
      "Büyüktarla Mah (doğancılar Köyü)",
      "Cumaderesi Mah (yeşiller Köyü)",
      "Çatacık Mah (yürecik Köyü)",
      "Çavuşlar Mah (köyceğiz Köyü)",
      "Çay Mah (karaören Köyü)",
      "Çekiçler Mah (beytarla Köyü)",
      "Çetiören Mah (ova Köyü)",
      "Çötler Mah (büyükyayalar Köyü)",
      "Dağcıoğlu Mah (belen Köyü)",
      "Değirmenbaşı Mah (deresemail Köyü)",
      "Demirci Mah (kulat Köyü)",
      "Demirciler Mah (karaören Köyü)",
      "Demirciler Mah (şevkiler Köyü)",
      "Dere Mah (deresoblan Köyü)",
      "Dereağıl Mah (haslı Köyü)",
      "Dereköy Mah (sofular Köyü)",
      "Doğanlar Mah (doğlacık Köyü)",
      "Doğucular Mah (söbüçimen Köyü)",
      "Domi Mah (gözlü Köyü)",
      "Doruklar Mah (topçalı Köyü)",
      "Durallar Mah (gözlü Köyü)",
      "Durmuşlar Mah (büyükyayalar Köyü)",
      "Eleler Mah (budaklar Köyü)",
      "Emirler Mah (kabaarmut Köyü)",
      "Emiroğlu Mah (tamışlar Köyü)",
      "Ericek Mah (karaören Köyü)",
      "Eserler Mah (yürecik Köyü)",
      "Gevrekler Mah (arslanlar Köyü)",
      "Gölet Mah (deresemail Köyü)",
      "Gövez Mah (çaylı Köyü)",
      "Gözyeri Mah (deresoblan Köyü)",
      "Güney Mah (deresoblan Köyü)",
      "Hacı Ahmetler Mah (budaklar Köyü)",
      "Hacılar Mah (başpınar Köyü)",
      "Hasanlar Köyü",
      "Hatipler Mah (doğlacık Köyü)",
      "Haydarlar Mah (çömlekçiler Köyü)",
      "İmamlar Mah (sofular Köyü)",
      "İmanlar Köyü",
      "İmciler Mah (şevkiler Köyü)",
      "İsmetpaşa Mah (hamamlı Köyü)",
      "İstasyon Mah (arslanlar Köyü)",
      "Kabaca Mah (bölükören Köyü)",
      "Kadıllar Mah (gözlü Köyü)",
      "Kapucular Köyü",
      "Karaköy Mah (sofular Köyü)",
      "Karapınar Mah (deresoblan Köyü)",
      "Karasu Mah (yeşiller Köyü)",
      "Kargın Mah (boncuklar Köyü)",
      "Karşı Mah (hamzalar Köyü)",
      "Kartak Mah (babalar Köyü)",
      "Kısaç Mah (sadeyaka Köyü)",
      "Kızılcaören Mah (çömlekçiler Köyü)",
      "Kızılcapınar Mah (tamışlar Köyü)",
      "Kirazgil Mah (kabaarmut Köyü)",
      "Kirazlar Mah (sofular Köyü)",
      "Kurukavak Mah (başpınar Köyü)",
      "Kuruözü Mah (başpınar Köyü)",
      "Kuzdere Mah (sofular Köyü)",
      "Kuzören Köyü",
      "Kuzyaka Mah (doğancılar Köyü)",
      "Küplü Mah (ova Köyü)",
      "Mahmutlar Mah (boncuklar Köyü)",
      "Merkez Mah (adiller Köyü)",
      "Merkez Mah (arslanlar Köyü)",
      "Merkez Mah (babalar Köyü)",
      "Merkez Mah (başpınar Köyü)",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (beytarla Köyü)",
      "Merkez Mah (boncuklar Köyü)",
      "Merkez Mah (bölükören Köyü)",
      "Merkez Mah (budaklar Köyü)",
      "Merkez Mah (büyükyayalar Köyü)",
      "Merkez Mah (çandırlar Köyü)",
      "Merkez Mah (çaylı Köyü)",
      "Merkez Mah (çömlekçiler Köyü)",
      "Merkez Mah (deresemail Köyü)",
      "Merkez Mah (doğancılar Köyü)",
      "Merkez Mah (doğlacık Köyü)",
      "Merkez Mah (hamamlı Köyü)",
      "Merkez Mah (hamzalar Köyü)",
      "Merkez Mah (hanköy Köyü)",
      "Merkez Mah (haslı Köyü)",
      "Merkez Mah (inceboğaz Köyü)",
      "Merkez Mah (kabaarmut Köyü)",
      "Merkez Mah (kapaklı Köyü)",
      "Merkez Mah (karaören Köyü)",
      "Merkez Mah (köyceğiz Köyü)",
      "Merkez Mah (kulat Köyü)",
      "Merkez Mah (ortaköy Köyü)",
      "Merkez Mah (ova Köyü)",
      "Merkez Mah (ozanköy Köyü)",
      "Merkez Mah (sadeyaka Köyü)",
      "Merkez Mah (sallar Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (söbüçimen Köyü)",
      "Merkez Mah (şevkiler Köyü)",
      "Merkez Mah (tamışlar Köyü)",
      "Merkez Mah (topçalı Köyü)",
      "Merkez Mah (yazıboy Köyü)",
      "Merkez Mah (yazıkavak Köyü)",
      "Merkez Mah (yeşiller Köyü)",
      "Merkez Mah (yürecik Köyü)",
      "Meşecik Mah (yürecik Köyü)",
      "Musabaşoğlu Mah (kabaarmut Köyü)",
      "Musallar Mah (yürecik Köyü)",
      "Mutaflar Mah (bölükören Köyü)",
      "Omurlar Mah (ova Köyü)",
      "Orta Mah (belen Köyü)",
      "Oruçlar Mah (şevkiler Köyü)",
      "Ören Mah (gözlü Köyü)",
      "Ören Mah (sofular Köyü)",
      "Örencik Mah (deresoblan Köyü)",
      "Pelitcik Mah (boncuklar Köyü)",
      "Pilavcılar Mah (ortaköy Köyü)",
      "Salmanlar Mah (sofular Köyü)",
      "Saraycık Mah (sadeyaka Köyü)",
      "Sarıahmetler Mah (arslanlar Köyü)",
      "Semerciler Mah (kapaklı Köyü)",
      "Seviller Mah (hamzalar Köyü)",
      "Sinangil Mah (kabaarmut Köyü)",
      "Soblan Mah (deresoblan Köyü)",
      "Softalar Mah (başpınar Köyü)",
      "Söğütlüçeşme Mah (gözlü Köyü)",
      "Şıhlar Mah (sadeyaka Köyü)",
      "Şıhlar Mah (yazıboy Köyü)",
      "Taşlık Mah (deresoblan Köyü)",
      "Taşlık Mah (köyceğiz Köyü)",
      "Taşmanlar Mah (ortaköy Köyü)",
      "Taşmanlar Mah (yazıboy Köyü)",
      "Tefen Mah (ortaköy Köyü)",
      "Tepeköy Mah (ortaköy Köyü)",
      "Terzi Mah (kulat Köyü)",
      "Tetikler Mah (inceboğaz Köyü)",
      "Tiryakioğlu Mah (hamzalar Köyü)",
      "Tokmakoğlu Mah (kapaklı Köyü)",
      "Türkmenler Mah (şevkiler Köyü)",
      "Üçevler Köyü",
      "Yahyalar Mah (boncuklar Köyü)",
      "Yaka Mah (topçalı Köyü)",
      "Yaplan Mah (haslı Köyü)",
      "Yayalar Mah (babalar Köyü)",
      "Yemişler Mah (tamışlar Köyü)",
      "Yeni Mah (ortaköy Köyü)",
      "Yeni Mah (söbüçimen Köyü)",
      "Yenice Mah (sallar Köyü)",
      "Yukarı Bulduk Mah (bulduk Köyü)",
      "Yukarı Göne Mah (topçalı Köyü)",
      "Yukarı Karahasanlar Mah (karahasanlar Köyü)",
      "Yukarı Kazlar Mah (haslı Köyü)",
      "Yukarı Keçeler Mah (yazıkavak Köyü)",
      "Yukarı Saray Mah (karahasanlar Köyü)",
      "Yunisler Mah (doğlacık Köyü)"
    ],
    "Merkez": [
      "100.yıl Mah",
      "Kılavuzlar Mah",
      "Üniversite Mah",
      "Atatürk Mah",
      "Bayır Mah",
      "Fatih Mah",
      "Kartaltepe Mah",
      "Namık Kemal Mah",
      "Soğuksu Mah",
      "Yeni Mah",
      "5000 Evler 75.yıl Mah",
      "5000 Evler Bahçelievler Mah",
      "5000 Evler Cumhuriyet Mah",
      "Aydınlıkevler Mah",
      "Belenköy Mah",
      "Çerçiler Mah",
      "Fevzi Çakmak Mah",
      "Hürriyet Mah",
      "Kapullu Mah",
      "Karabük Mah",
      "Kayabaşı Mah",
      "Öğlebeli Mah",
      "Abdi Mah (ortaca Köyü)",
      "Afet Evleri Mah (kahyalar Köyü)",
      "Akçabük Mah (zopran Köyü)",
      "Akyol Mah (bulak Köyü)",
      "Aşağı Aktaş Mah (kamış Köyü)",
      "Aşağı Mah (arıcak Köyü)",
      "Aşağı Mah (bulak Köyü)",
      "Aşağı Yaka Mah (kamış Köyü)",
      "Aşağıköy Mah (karaağaç Köyü)",
      "Ayvaz Mah (ortaca Köyü)",
      "Bedirler Mah (kadı Köyü)",
      "Belen Mah (sipahiler Köyü)",
      "Beşirağa Mah (kadı Köyü)",
      "Cami Sokak Mah (yeşilköy Köyü)",
      "Camiönü Mah (bulak Köyü)",
      "Cemelovası Mah (cemaller Köyü)",
      "Cildekısık Mah (çukurca Köyü)",
      "Cobu Mah (çukurca Köyü)",
      "Cumayanı Köyü",
      "Çakıllar Mah (kahyalar Köyü)",
      "Çamlık Mah (aşağı Kızılcaören Köyü)",
      "Çandırlar Mah (burunsuz Köyü)",
      "Çay Mah (acıöz Köyü)",
      "Çay Mah (burunsuz Köyü)",
      "Çay Mah (ortaca Köyü)",
      "Çiğdemler Mah (saitler Köyü)",
      "Değirmenönü Mah (cemaller Köyü)",
      "Demirciler Mah (bürnük Köyü)",
      "Dere Mah (çukurca Köyü)",
      "Dere Mah (kayı Köyü)",
      "Dibek Mah (bulak Köyü)",
      "Durhanlar Mah (kahyalar Köyü)",
      "Düzköy Mah (yukarı Kızılcaören Köyü)",
      "Elezler Mah (kale Köyü)",
      "Erikler Mah (bürnük Köyü)",
      "Eskiköy Mah (kale Köyü)",
      "Göklen Mah (zopran Köyü)",
      "Gözür Mah (saitler Köyü)",
      "Güllüce Mah (kadı Köyü)",
      "Gülveren Mah (sipahiler Köyü)",
      "Güney Mah (davutlar Köyü)",
      "Güney Mah (kale Köyü)",
      "Güney Mah (ortaca Köyü)",
      "Güney Mah (saitler Köyü)",
      "Güney Mah (üçbaş Köyü)",
      "Hacılar Mah (davutlar Köyü)",
      "Hamzalar Mah (zopran Köyü)",
      "Harmanlar Mah (bulak Köyü)",
      "Hasanköy Mah (tandır Köyü)",
      "Hatipoğlu Mah (mehterler Köyü)",
      "Heredağ Mah (ortaca Köyü)",
      "Horozlar Mah (saitler Köyü)",
      "Kabaoğlu Mah (kahyalar Köyü)",
      "Kadıoğlu Mah (tandır Köyü)",
      "Kado Mah (davutlar Köyü)",
      "Kalafatlar Mah (bürnük Köyü)",
      "Karaağaç Mah (üçbaş Köyü)",
      "Karadaş Mah (yeşiltepe Köyü)",
      "Karaseyitler Mah (yukarı Kızılcaören Köyü)",
      "Karşı Mah (tandır Köyü)",
      "Kayadibi Mah (bürnük Köyü)",
      "Kemaloyman Büyük Sanayi Sitesi Mah (kale Köyü)",
      "Kemaloyman Mah (kale Köyü)",
      "Kemikler Mah (bürnük Köyü)",
      "Kıran Mah (mehterler Köyü)",
      "Kışburuncuk Mah (karaşar Köyü)",
      "Kışla Mah (cemaller Köyü)",
      "Köseler Mah (gölören Köyü)",
      "Kumluk Mah (bulak Köyü)",
      "Kuzey Mah (üçbaş Köyü)",
      "Merkez  Mah (aşağı Kızılcaören Köyü)",
      "Merkez Mah (acıöz Köyü)",
      "Merkez Mah (aşağı Kızılcaören Köyü)",
      "Merkez Mah (başköy Köyü)",
      "Merkez Mah (bolkuş Köyü)",
      "Merkez Mah (burunsuz Köyü)",
      "Merkez Mah (çukurca Köyü)",
      "Merkez Mah (davutlar Köyü)",
      "Merkez Mah (demirciler Köyü)",
      "Merkez Mah (düzçam Köyü)",
      "Merkez Mah (gölören Köyü)",
      "Merkez Mah (güneşli Köyü)",
      "Merkez Mah (kadı Köyü)",
      "Merkez Mah (kahyalar Köyü)",
      "Merkez Mah (kale Köyü)",
      "Merkez Mah (kamış Köyü)",
      "Merkez Mah (kapaklı Köyü)",
      "Merkez Mah (karaağaç Köyü)",
      "Merkez Mah (karaşar Köyü)",
      "Merkez Mah (kayı Köyü)",
      "Merkez Mah (mehterler Köyü)",
      "Merkez Mah (ortaca Köyü)",
      "Merkez Mah (ödemiş Köyü)",
      "Merkez Mah (saitler Köyü)",
      "Merkez Mah (salmanlar Köyü)",
      "Merkez Mah (sipahiler Köyü)",
      "Merkez Mah (şenler Köyü)",
      "Merkez Mah (yeşiltepe Köyü)",
      "Merkez Mah (zopran Köyü)",
      "Meşelik Mah (arıcak Köyü)",
      "Musalla Mah (bulak Köyü)",
      "Müsellima Mah (tandır Köyü)",
      "Nizamyesir Mah (mehterler Köyü)",
      "Ocasak Mah (çukurca Köyü)",
      "Okçular Mah (mehterler Köyü)",
      "Okul Sokak Mah (yeşilköy Köyü)",
      "Organize Sanayi Bölgesi Mah (kale Köyü)",
      "Orman Mah (yukarı Kızılcaören Köyü)",
      "Orta Mah (ortaca Köyü)",
      "Orta Mah (salmanlar Köyü)",
      "Ortaköy Mah (başköy Köyü)",
      "Örenköy Mah (sipahiler Köyü)",
      "Paşa Mah (kale Köyü)",
      "Pirinçlik Mah (kahyalar Köyü)",
      "Saray Mah (bulak Köyü)",
      "Sarıkonak Mah (kale Köyü)",
      "Selima Mah (tandır Köyü)",
      "Seyitler Mah (bürnük Köyü)",
      "Sofular Mah (davutlar Köyü)",
      "Sökü Mah (başköy Köyü)",
      "Sündeller Mah (kadı Köyü)",
      "Şıhlar Mah (kadı Köyü)",
      "Tepe Mah (yukarı Kızılcaören Köyü)",
      "Yalnızca Mah (bolkuş Köyü)",
      "Yavaşlar Mah (şenler Köyü)",
      "Yayla Evleri Mah (cemaller Köyü)",
      "Yazıcılar Mah (bürnük Köyü)",
      "Yedi Evler Mah (başköy Köyü)",
      "Yeni Mah (aşağı Kızılcaören Köyü)",
      "Yeşilköy Mah (yeşilköy Köyü)",
      "Yılmazlar Mah (acıöz Köyü)",
      "Yukarı Aktaş Mah (kamış Köyü)",
      "Yukarı Mah (arıcak Köyü)",
      "Yukarı Mah (çukurca Köyü)",
      "Yukarı Mah (salmanlar Köyü)",
      "Yukarı Tandır Mah (tandır Köyü)",
      "Adatepe Mah",
      "Ergenekon Mah",
      "Kurtuluş Mah",
      "Şirinevler Mah",
      "Yenişehir Mah",
      "Yeşil Mah"
    ],
    "Ovacık": [
      "Akbıyık Mah (gökçedüz Köyü)",
      "Akcapınar Mah (abdullar Köyü)",
      "Akhisar Mah (taşoğlu Köyü)",
      "Alınca Köyü",
      "Ali Bey Mah (belen Köyü)",
      "Alizayim Mah (dudaş Köyü)",
      "Alkısırak Mah (yığınot Köyü)",
      "Aşağı Asarcık Mah (ambarözü Köyü)",
      "Aşağı Mah (ambarözü Köyü)",
      "Aşağı Mah (soğanlı Köyü)",
      "Aydınlar Mah (ahmetler Köyü)",
      "Bakırcılar Mah (yeniören Köyü)",
      "Bakırcıoğlu Mah (ahmetler Köyü)",
      "Bediller Mah (imanlar Köyü)",
      "Beşirağa Mah (boduroğlu Köyü)",
      "Bicikler Mah (çukur Köyü)",
      "Cevre Mah (ambarözü Köyü)",
      "Cingiller Mah (kışla Köyü)",
      "Çataklıoğlu Mah (dudaş Köyü)",
      "Çay Mah (dudaş Köyü)",
      "Çolakoğlu Mah (ahmetler Köyü)",
      "Dabaz Ali Mah (belen Köyü)",
      "Dağdibi Mah (dudaş Köyü)",
      "Dere Mah (sülük Köyü)",
      "Deveci Mah (boduroğlu Köyü)",
      "Dodan Mah (dudaş Köyü)",
      "Doruk Mah (hatipoğlu Köyü)",
      "Dökük Mah (erkeç Köyü)",
      "Eğerciler Mah (çukur Köyü)",
      "Emirler Mah (avlağıkaya Köyü)",
      "Erdegöl Mah (taşoğlu Köyü)",
      "Esenler Mah (ekincik Köyü)",
      "Esköy Mah (yığınot Köyü)",
      "Eyberler Mah (erkeç Köyü)",
      "Eyberler Mah (imanlar Köyü)",
      "Ganioğlu Mah (ahmetler Köyü)",
      "Göcek Mah (sülük Köyü)",
      "Gövez Mah (dudaş Köyü)",
      "Gülefler Mah (abdullar Köyü)",
      "Güneşler Mah (yaka Köyü)",
      "Güney Mah (güneysaz Köyü)",
      "Hatip Mah (hatipoğlu Köyü)",
      "Hatipoğlu Mah (pürçükören Köyü)",
      "Hatlar Mah (boyalı Köyü)",
      "Hatlar Mah (küçüksu Köyü)",
      "Hoca Mah (avlağıkaya Köyü)",
      "Hocaoğlu Köprüsü Mah (boyalı Köyü)",
      "İlyaslar Mah (yeniören Köyü)",
      "İnceoğlu Mah (ekincik Köyü)",
      "Kadı Mah (ekincik Köyü)",
      "Kahveci Mah (kışla Köyü)",
      "Karaağaç Mah (çatak Köyü)",
      "Karagöl Mah (küçüksu Köyü)",
      "Karakoyunlu Mah (pürçükören Köyü)",
      "Kargalı Mah (kavaklar Köyü)",
      "Karşı Mah (avlağıkaya Köyü)",
      "Karşı Mah (koltuk Köyü)",
      "Kayalar Mah (dudaş Köyü)",
      "Keçiler Mah (ganibeyler Köyü)",
      "Kızık Mah (boduroğlu Köyü)",
      "Kızılelma Mah (dudaş Köyü)",
      "Köseler Mah (boyalı Köyü)",
      "Kuzgun Mah (erkeç Köyü)",
      "Mehmetoğlu Mah (sülük Köyü)",
      "Merkez Mah (abdullar Köyü)",
      "Merkez Mah (ambarözü Köyü)",
      "Merkez Mah (avlağıkaya Köyü)",
      "Merkez Mah (başboyunduruk Köyü)",
      "Merkez Mah (belen Köyü)",
      "Merkez Mah (beydili Köyü)",
      "Merkez Mah (beydini Köyü)",
      "Merkez Mah (boduroğlu Köyü)",
      "Merkez Mah (boyalı Köyü)",
      "Merkez Mah (bölükören Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çukur Köyü)",
      "Merkez Mah (doğanlar Köyü)",
      "Merkez Mah (dökecek Köyü)",
      "Merkez Mah (erkeç Köyü)",
      "Merkez Mah (ganibeyler Köyü)",
      "Merkez Mah (gökçedüz Köyü)",
      "Merkez Mah (gümelik Köyü)",
      "Merkez Mah (imanlar Köyü)",
      "Merkez Mah (kavaklar Köyü)",
      "Merkez Mah (kışla Köyü)",
      "Merkez Mah (koltuk Köyü)",
      "Merkez Mah (küçüksu Köyü)",
      "Merkez Mah (pürçükören Köyü)",
      "Merkez Mah (sarılar Köyü)",
      "Merkez Mah (sofuoğlu Köyü)",
      "Merkez Mah (soğanlı Köyü)",
      "Merkez Mah (sülük Köyü)",
      "Merkez Mah (şamlar Köyü)",
      "Merkez Mah (taşoğlu Köyü)",
      "Merkez Mah (yaka Köyü)",
      "Merkez Mah (yaylacılar Köyü)",
      "Merkez Mah (yeniören Köyü)",
      "Mıcık Mah (dudaş Köyü)",
      "Muradoğlu Mah (yaka Köyü)",
      "Musallar Mah (başboyunduruk Köyü)",
      "Musatlar Mah (ahmetler Köyü)",
      "Mustafa Ağa Mah (çukur Köyü)",
      "Orta Mah (hatipoğlu Köyü)",
      "Orta Mah (şamlar Köyü)",
      "Ortaca Mah (bölükören Köyü)",
      "Osmancık Mah (yeniören Köyü)",
      "Ömerler Mah (imanlar Köyü)",
      "Öte Gövez Mah (dudaş Köyü)",
      "Pazaryeri Mah (kışla Köyü)",
      "Pehlivanoğlu Mah (ekincik Köyü)",
      "Pelitçik Köyü",
      "Sağıroğlu Mah (dökecek Köyü)",
      "Saitler Mah (abdullar Köyü)",
      "Sarıoğlu Mah (sofuoğlu Köyü)",
      "Saz Mah (güneysaz Köyü)",
      "Sindire Mah (gümelik Köyü)",
      "Sofular Mah (ahmetler Köyü)",
      "Sonya Mah (sarılar Köyü)",
      "Söğütçü Mah (sülük Köyü)",
      "Süller Mah (küçüksu Köyü)",
      "Sütcü Mah (gümelik Köyü)",
      "Şamlı Mah (erkeç Köyü)",
      "Şaylar Mah (şamlar Köyü)",
      "Tepe Mah (pürçükören Köyü)",
      "Terzi Mah (yaka Köyü)",
      "Toklar Mah (gümelik Köyü)",
      "Üzümcük Mah (soğanlı Köyü)",
      "Yahyalar Mah (ambarözü Köyü)",
      "Yayalar Mah (ekincik Köyü)",
      "Yayaoğlu Mah (beydili Köyü)",
      "Yayaoğlu Mah (taşoğlu Köyü)",
      "Yiğitler Mah (doğanlar Köyü)",
      "Yukarı Asarcık Mah (ambarözü Köyü)",
      "Yukarı Kayalar Mah (dudaş Köyü)",
      "Yukarı Mah (ahmetler Köyü)",
      "Yukarı Mah (yığınot Köyü)",
      "Yunuslar Mah (sarılar Köyü)",
      "Yuvalar Mah (dudaş Köyü)",
      "Yürekören Köyü",
      "Merkez Mah"
    ],
    "Safranbolu": [
      "Abdioğlu Mah (inceçay Köyü)",
      "Adalar Mah (bostanbükü Köyü)",
      "Ağabey Mah (kehler Köyü)",
      "Ahmet Usta Mah (inceçay Köyü)",
      "Akkışla Köyü",
      "Akören Köyü",
      "Alabaş Mah (nebioğlu Köyü)",
      "Alabaşoğlu Mah (nebioğlu Köyü)",
      "Alibeyoğlu Mah (kehler Köyü)",
      "Alifaki Mah (tayyip Köyü)",
      "Aşağı Mah (çerçen Köyü)",
      "Aşağı Mah (sırçalı Köyü)",
      "Aşağı Mah (tokatlı Köyü)",
      "Aşağı Mah (yazıköy Köyü)",
      "Aşağıkuz Mah (nebioğlu Köyü)",
      "Aşcıoğlu Mah (çerçen Köyü)",
      "Aynuz Mah (aşağıdana Köyü)",
      "Bağcılar Mah (kadıbükü Köyü)",
      "Bağlıca Mah (üçbölük Köyü)",
      "Bahçelievler Mah (bostanbükü Köyü)",
      "Belderler Mah (sine Köyü)",
      "Belengur Mah (nebioğlu Köyü)",
      "Bulamaç Mah (kehler Köyü)",
      "Cabbar Köyü",
      "Cabbaroğlu Mah (dere Köyü)",
      "Camcıoğlu Mah (nebioğlu Köyü)",
      "Cebeci Mah (nebioğlu Köyü)",
      "Cemaller Mah (örencik Köyü)",
      "Çakıl Mah (tayyip Köyü)",
      "Çatacık Mah (dere Köyü)",
      "Çatak Köyü",
      "Çay Mah (çerçen Köyü)",
      "Çay Mah (kuzyakaöte Köyü)",
      "Çaydüzü Mah (davutobası Köyü)",
      "Çengeloğlu Mah (bağcığaz Köyü)",
      "Çevrik Köprü Mah (konarı Köyü)",
      "Çiftlik Mah (nebioğlu Köyü)",
      "Çilekli Mah (örencik Köyü)",
      "Çoban Mah (yazıköy Köyü)",
      "Çomakören Mah (yolbaşı Köyü)",
      "Danişment Köyü",
      "Değirmencioğlu Mah (inceçay Köyü)",
      "Demirciler Mah (yolbaşı Köyü)",
      "Dere Mah (dere Köyü)",
      "Derler Mah (toprakcuma Köyü)",
      "Düz Mah (ovacuma Köyü)",
      "Düz Mah (tayyip Köyü)",
      "Emillahlı Mah (inceçay Köyü)",
      "Emirler Mah (cücahlı Köyü)",
      "Eyciler Mah (çavuşlar Köyü)",
      "Fazlıoğlu Mah (dere Köyü)",
      "Ferhatlar Mah (konarı Köyü)",
      "Gayza Köyü",
      "Geren Köyü",
      "Giriş Mah (düzce Köyü)",
      "Gölyanı Mah (konarı Köyü)",
      "Göveren Mah (kırıklar Köyü)",
      "Gülüstanoğlu Mah (inceçay Köyü)",
      "Gündoğan Köyü",
      "Habiller Mah (ağaçkese Köyü)",
      "Hacıhasan Köyü",
      "Hanlar Mah (dere Köyü)",
      "Harmanlar Mah (bostanbükü Köyü)",
      "Hatırlık Köy Tarlası Mah (kadıbükü Köyü)",
      "Hisar Mah (yazıköy Köyü)",
      "Hoşafcıoğlu Mah (inceçay Köyü)",
      "İnönü Mah (yazıköy Köyü)",
      "İrezli Mah (çerçen Köyü)",
      "Kabakçıoğlu Mah (çavuşlar Köyü)",
      "Kadıoğlu Mah (kehler Köyü)",
      "Karaevli Mah (kırıklar Köyü)",
      "Karaşer Mah (üçbölük Köyü)",
      "Karataş Mah (çerçen Köyü)",
      "Karavelioğlu Mah (inceçay Köyü)",
      "Karıt Köyü",
      "Karıt Mah (karıt Köyü)",
      "Karşı Mah (düzce Köyü)",
      "Karşı Mah (konarı Köyü)",
      "Karşıyaka Mah (bostanbükü Köyü)",
      "Kasapoğlu Mah (aşağıdana Köyü)",
      "Kavacık Mah (gökpınar Köyü)",
      "Keller Mah (nebioğlu Köyü)",
      "Keten Mah (yukarıçiftlik Köyü)",
      "Kılıçlar Mah (değirmencik Köyü)",
      "Kırıkoğlu Mah (kehler Köyü)",
      "Kooparatif Evleri Mah (konarı Köyü)",
      "Kozcağız Mah (düzce Köyü)",
      "Köprübaşı Mah (çavuşlar Köyü)",
      "Köprübaşı Mah (davutobası Köyü)",
      "Kurttepesi Mah (aşağıçiftlik Köyü)",
      "Kuşbaş Mah (nebioğlu Köyü)",
      "Mahmutoğlu Mah (tayyip Köyü)",
      "Merkez Mah (ağaçkese Köyü)",
      "Merkez Mah (alören Köyü)",
      "Merkez Mah (aşağıçiftlik Köyü)",
      "Merkez Mah (aşağıdana Köyü)",
      "Merkez Mah (aşağıgüney Köyü)",
      "Merkez Mah (bağcığaz Köyü)",
      "Merkez Mah (bostanbükü Köyü)",
      "Merkez Mah (cücahlı Köyü)",
      "Merkez Mah (çavuşlar Köyü)",
      "Merkez Mah (çerçen Köyü)",
      "Merkez Mah (çıraklar Köyü)",
      "Merkez Mah (davutobası Köyü)",
      "Merkez Mah (değirmencik Köyü)",
      "Merkez Mah (gökpınar Köyü)",
      "Merkez Mah (hacılarobası Köyü)",
      "Merkez Mah (harmancık Köyü)",
      "Merkez Mah (kadıbükü Köyü)",
      "Merkez Mah (karacatepe Köyü)",
      "Merkez Mah (karapınar Köyü)",
      "Merkez Mah (kırıklar Köyü)",
      "Merkez Mah (kuzyakahacılar Köyü)",
      "Merkez Mah (kuzyakaköseler Köyü)",
      "Merkez Mah (kuzyakaöte Köyü)",
      "Merkez Mah (navsaklar Köyü)",
      "Merkez Mah (pelitören Köyü)",
      "Merkez Mah (sakaralan Köyü)",
      "Merkez Mah (sat Köyü)",
      "Merkez Mah (sine Köyü)",
      "Merkez Mah (tayyip Köyü)",
      "Merkez Mah (tokatlı Köyü)",
      "Merkez Mah (toprakcuma Köyü)",
      "Merkez Mah (üçbölük Köyü)",
      "Merkez Mah (yolbaşı Köyü)",
      "Merkez Mah (yukarıçiftlik Köyü)",
      "Merkez Mah (yukarıdana Köyü)",
      "Müstekler Mah (sine Köyü)",
      "Oğulören Köyü",
      "Okuyucular Mah (karapınar Köyü)",
      "Orta Mah (düzce Köyü)",
      "Orta Mah (konarı Köyü)",
      "Orta Mah (örencik Köyü)",
      "Orta Mah (yazıköy Köyü)",
      "Ortaköy Mah (inceçay Köyü)",
      "Osmansökü Mah (örencik Köyü)",
      "Ovaköseler Köyü",
      "Ömersofu Mah (karacatepe Köyü)",
      "Örencik Mah (tayyip Köyü)",
      "Öte Mah (sırçalı Köyü)",
      "Pazarkese Mah (tayyip Köyü)",
      "Pirce Mah (yazıköy Köyü)",
      "Rahmanoğlu Mah (bağcığaz Köyü)",
      "Sabuncular Mah (ağaçkese Köyü)",
      "Sabuncular Mah (alören Köyü)",
      "Sakalar Mah (alören Köyü)",
      "Sallar Mah (hacılarobası Köyü)",
      "Sandalcıoğlu Mah (nebioğlu Köyü)",
      "Sarıahmetli Köyü",
      "Sarıoğlu Mah (cücahlı Köyü)",
      "Sarpın Mah (nebioğlu Köyü)",
      "Seyitler Mah (ağaçkese Köyü)",
      "Sofuoğlu Mah (inceçay Köyü)",
      "Sorguncuk Mah (sırçalı Köyü)",
      "Susunduk Mah (yukarıdana Köyü)",
      "Sülükgölü Mah (aşağıdana Köyü)",
      "Şabanlar Mah (inceçay Köyü)",
      "Şamlar Mah (harmancık Köyü)",
      "Tayyip Altı Mah (tayyip Köyü)",
      "Tintin Köyü",
      "Tuzaklı Mah (inceçay Köyü)",
      "Yağcı Mah (sakaralan Köyü)",
      "Yağmurlu Mah (kehler Köyü)",
      "Yanık Mah (gökpınar Köyü)",
      "Yayalar Mah (ağaçkese Köyü)",
      "Yayla Mah (kadıbükü Köyü)",
      "Yayla Mah (navsaklar Köyü)",
      "Yörük Köyü",
      "Yukarı Çavuşlar Mah (çavuşlar Köyü)",
      "Yukarı Mah (çerçen Köyü)",
      "Yukarı Mah (çıraklar Köyü)",
      "Yukarı Mah (değirmencik Köyü)",
      "Yukarı Mah (kadıbükü Köyü)",
      "Yukarı Mah (kuzyakahacılar Köyü)",
      "Yukarı Mah (kuzyakaköseler Köyü)",
      "Yukarı Mah (örencik Köyü)",
      "Yukarı Mah (pelitören Köyü)",
      "Yukarı Mah (sırçalı Köyü)",
      "Yukarı Mah (yazıköy Köyü)",
      "Yusufbaşoğlu Mah (kehler Köyü)",
      "15 Temmuz Mah",
      "Akçasu Mah",
      "Aşağı Tokatlı Mah",
      "Atatürk Mah",
      "Babasultan Mah",
      "Bağlarbaşı Mah",
      "Barış Mah",
      "Camikebir Mah",
      "Cemalcaymaz Mah",
      "Çavuş Mah",
      "Çeşme Mah",
      "Emek Mah",
      "Esentepe Mah",
      "Hacıhalil Mah",
      "Hüseyinçelebi Mah",
      "İsmetpaşa Mah",
      "İzzetpaşa Mah",
      "Karaali Mah",
      "Kirkille Mah",
      "Musalla Mah",
      "Yenimahalle Mah"
    ],
    "Yenice": [
      "Ada Mah (kayadibi Köyü)",
      "Ahatlar Düzü Mah (kadıköy Köyü)",
      "Ahatlar Mah (kadıköy Köyü)",
      "Ahçılar Mah (yazıköy Köyü)",
      "Akbıyıklar Mah (güney Köyü)",
      "Akgüloğlu Mah (kuzdağ Köyü)",
      "Akmanlar-1 Mah (akmanlar Köyü)",
      "Alagözler Mah (değirmenyanı Köyü)",
      "Altıparmaklar Mah (hüseyinbeyoğlu Köyü)",
      "Arslanlar Mah (güney Köyü)",
      "Aşağı Mah (çamlı Köyü)",
      "Aşağı Mah (yamaçköy Köyü)",
      "Ateşler Mah (şirinköy Köyü)",
      "Ayanlar -1 Mah (tir Köyü)",
      "Ayanlar Mah (ıbrıcak Köyü)",
      "Badıran Mah (abdullahoğlu Köyü)",
      "Bakibeyoğlu Mah (tir Köyü)",
      "Balıkısık Mah (satuk Köyü)",
      "Bektaşlar Mah (yeniköy Köyü)",
      "Belen Mah (cihanbey Köyü)",
      "Bezirciler Mah (keyfallar Köyü)",
      "Bostancılar Mah (değirmenyanı Köyü)",
      "Boşnaklar Mah (yamaçköy Köyü)",
      "Bölükler Mah (satuk Köyü)",
      "Camiyanı Mah (tir Köyü)",
      "Cemberk Mah (cihanbey Köyü)",
      "Cıbırlar Mah (bağbaşı Köyü)",
      "Cinkavuklar Mah (saray Köyü)",
      "Çakıllı Mah (hüseyinbeyoğlu Köyü)",
      "Çakırlar Mah (hisar Köyü)",
      "Çakıroğlu Mah (kuzdağ Köyü)",
      "Çalıklar Mah (bağbaşı Köyü)",
      "Çamlar Altı Mah (kayaarkası Köyü)",
      "Çatallar Mah (keyfallar Köyü)",
      "Çay Mah (esenköy Köyü)",
      "Çay Mah (kayadibi Köyü)",
      "Çay Mah (yazıköy Köyü)",
      "Çay Mah (yeniköy Köyü)",
      "Çayıroğlu Mah (kayadibi Köyü)",
      "Çenesizler Mah (güney Köyü)",
      "Çengeller Mah (yeniköy Köyü)",
      "Çobanlar Mah (yazıköy Köyü)",
      "Çolaklar Mah (abdullahoğlu Köyü)",
      "Çötüroğlu Mah (keyfallar Köyü)",
      "Çözler Mah (şirinköy Köyü)",
      "Çumuryanı Mah (yeniköy Köyü)",
      "Dabazlar Mah (bağbaşı Köyü)",
      "Demirciler Mah (hisar Köyü)",
      "Demirciler Mah (yeşilköy Köyü)",
      "Dere Mah (çeltik Köyü)",
      "Dere Mah (satuk Köyü)",
      "Derebaşı Köyü",
      "Doğancılar Mah (bağbaşı Köyü)",
      "Düzyer Mah (ıbrıcak Köyü)",
      "Ekmekçiler Mah (saray Köyü)",
      "Elbiyi Mah (güney Köyü)",
      "Erfeyli Mah (değirmenyanı Köyü)",
      "Erikciler Mah (abdullahoğlu Köyü)",
      "Hacı İsmailoğlu Mah (saray Köyü)",
      "Hacı Ömerler Mah (gökbel Köyü)",
      "Hacıbeyler Mah (yazıköy Köyü)",
      "Hacıbeyler Mah (yeniköy Köyü)",
      "Halamanoğlu Mah (kayaarkası Köyü)",
      "Hamitoğlu Mah (gökbel Köyü)",
      "Hasanbeyler Mah (yazıköy Köyü)",
      "Hatıplar Mah (yazıköy Köyü)",
      "Hatipler Mah (ıbrıcak Köyü)",
      "Hatipoğlu Mah (ören Köyü)",
      "Hatipoğlu Mah (yamaçköy Köyü)",
      "Havsalar Mah (tir Köyü)",
      "İbrahimbeyler Mah (yazıköy Köyü)",
      "İncebacaklar Mah (yazıköy Köyü)",
      "İstasyon Mah (kayaarkası Köyü)",
      "İyioğlu Mah (nodullar Köyü)",
      "Kadı Değirmendüzü Mah (güney Köyü)",
      "Kadı Mezarlığı Mah (ıbrıcak Köyü)",
      "Kadıoğlu Mah (değirmenyanı Köyü)",
      "Kahyalar Mah (hisar Köyü)",
      "Kapan Çukuru Mah (güney Köyü)",
      "Kaptanlar Mah (hisar Köyü)",
      "Karagözler Mah (hisar Köyü)",
      "Karagüller Mah (kadıköy Köyü)",
      "Karagüller Mah (satuk Köyü)",
      "Karakavuz Mah (yeşilköy Köyü)",
      "Karaman Güneyi Mah (yeniköy Köyü)",
      "Karapınar Mah (cihanbey Köyü)",
      "Karaşlar Mah (akmanlar Köyü)",
      "Karşı Kadıköyü Mah (hüseyinbeyoğlu Köyü)",
      "Kazancılar Mah (yirmibeşoğlu Köyü)",
      "Kestane Mah (çamlı Köyü)",
      "Kıraçlar Mah (satuk Köyü)",
      "Kıran Mah (çamlı Köyü)",
      "Kırışlar Mah (gökbel Köyü)",
      "Kışla Mah (saray Köyü)",
      "Kızıltoprak Mah (akmanlar Köyü)",
      "Kirazlar Mah (akmanlar Köyü)",
      "Kocamuratlar Mah (çeltik Köyü)",
      "Kocaoğlu Mah (bağbaşı Köyü)",
      "Koymatlar Mah (bağbaşı Köyü)",
      "Kölemen Mah (saray Köyü)",
      "Köyiçi Mah (hisar Köyü)",
      "Kurtlar Mah (güney Köyü)",
      "Kuru Osmanlar Mah (çeltik Köyü)",
      "Kürtoğlu Mah (tir Köyü)",
      "Manavlar Mah (çakıllar Köyü)",
      "Merkez Mah (abdullahoğlu Köyü)",
      "Merkez Mah (çakıllar Köyü)",
      "Merkez Mah (değirmenyanı Köyü)",
      "Merkez Mah (esenköy Köyü)",
      "Merkez Mah (hüseyinbeyoğlu Köyü)",
      "Merkez Mah (ıbrıcak Köyü)",
      "Merkez Mah (kadıköy Köyü)",
      "Merkez Mah (kale Köyü)",
      "Merkez Mah (karahasanlar Köyü)",
      "Merkez Mah (keyfallar Köyü)",
      "Merkez Mah (kuzdağ Köyü)",
      "Merkez Mah (nodullar Köyü)",
      "Merkez Mah (ören Köyü)",
      "Merkez Mah (şenköy Köyü)",
      "Merkez Mah (şirinköy Köyü)",
      "Merkez Mah (yirmibeşoğlu Köyü)",
      "Muratlar Mah (yamaçköy Köyü)",
      "Onanlar Mah (güney Köyü)",
      "Orta Mah (kayaarkası Köyü)",
      "Orta Mah (yamaçköy Köyü)",
      "Osmanustaoğlu Mah (kadıköy Köyü)",
      "Ömerbaşı Mah (şirinköy Köyü)",
      "Ömeroğlu Mah (kayaarkası Köyü)",
      "Özgünler Mah (hisar Köyü)",
      "Recepbeyoğlu Mah (tir Köyü)",
      "Saraydüzü Mah (saray Köyü)",
      "Sarıoğlu Mah (keyfallar Köyü)",
      "Serdengeçtiler Mah (çeltik Köyü)",
      "Seyisoğlu Mah (abdullahoğlu Köyü)",
      "Softalar Mah (bağbaşı Köyü)",
      "Sofuoğlu Mah (tir Köyü)",
      "Soğuk Su Mah (akmanlar Köyü)",
      "Şeker Mah (kuzdağ Köyü)",
      "Tabaklar Mah (ıbrıcak Köyü)",
      "Tabaklar Mah (satuk Köyü)",
      "Taciller Mah (güney Köyü)",
      "Taşlıoğlu Mah (tir Köyü)",
      "Tefenlioğlu Mah (tir Köyü)",
      "Tırpolu Mah (şenköy Köyü)",
      "Torhun Mah (esenköy Köyü)",
      "Tunuslar Mah (kuzdağ Köyü)",
      "Tükenmezler Mah (akmanlar Köyü)",
      "Ustaoğlu Mah (gökbel Köyü)",
      "Uzunçam Mah (gökbel Köyü)",
      "Uzunkum Mah (satuk Köyü)",
      "Uzunlar Mah (çakıllar Köyü)",
      "Uzunlar Mah (hüseyinbeyoğlu Köyü)",
      "Yağbasan Mah (yeniköy Köyü)",
      "Yahyalar Mah (bağbaşı Köyü)",
      "Yardibi Mah (hüseyinbeyoğlu Köyü)",
      "Yardibi Mah (tir Köyü)",
      "Yassıören Mah (yazıköy Köyü)",
      "Yeni Kocaoğlu Mah (bağbaşı Köyü)",
      "Yeni Mah (tir Köyü)",
      "Yılanlar Mah (bağbaşı Köyü)",
      "Yukarı Mah (çamlı Köyü)",
      "Yukarı Mah (yamaçköy Köyü)",
      "Yusufbeyoğlu Mah (satuk Köyü)",
      "Zaimindoruk Mah (hisar Köyü)",
      "Atatürk Mah",
      "Fatih Mah",
      "İsmetpaşa Mah",
      "Kalaycılar Mah",
      "Karakırıklar Mah",
      "Karşıyaka Mah",
      "Menderes Mah",
      "Merkez Mah",
      "Özal Mah",
      "Yirmibeşler Mah",
      "Atatürk Mah (yortan Beldesi)",
      "Çengeller Mah (yortan Beldesi)",
      "Dere Mah (yortan Beldesi)",
      "Döngeller Mah (yortan Beldesi)",
      "Karaömerler Mah (yortan Beldesi)",
      "Merkez Mah (yortan Beldesi)",
      "Sipahiler Mah (yortan Beldesi)"
    ]
  },
  "Kilis": {
    "Elbeyli": [
      "Hürriyet Mah",
      "İnönü Mah",
      "Necmettin Erbakan Mah",
      "Yalçın Nane Mah",
      "Akçağıl Köyü",
      "Alahan Köyü",
      "Aşağıbeylerbeyi Köyü",
      "Aynafar Mah (yağızköy Köyü)",
      "Beşiriye Köyü",
      "Buldum Mah (geçerli Köyü)",
      "Ciris Mah (taşlıbakar Köyü)",
      "Çangallı Köyü",
      "Çardak Mah (akçağıl Köyü)",
      "Çıldıroba Köyü",
      "Çiftlik Mah (akçağıl Köyü)",
      "Delhemi Mah (yağızköy Köyü)",
      "Erikliyayla Köyü",
      "Geçerli Köyü",
      "Göktepe Mah (geçerli Köyü)",
      "Günece Köyü",
      "Güvendik Köyü",
      "Hacı Şakir Çiftliği Mah (aşağıbeylerbeyi Köyü)",
      "Havuzluçam Köyü",
      "İkizkaya Mah (kalbursait Köyü)",
      "Kalbursait Köyü",
      "Kaplanlar Mah (havuzluçam Köyü)",
      "Karacurun Köyü",
      "Karaçağıl Köyü",
      "Kesmelik Mah (akçağıl Köyü)",
      "Kılcan Köyü",
      "Kumsurun Mah (geçerli Köyü)",
      "Küçükbıykır Mah (çıldıroba Köyü)",
      "Mahliören Mah (turanlı Köyü)",
      "Mercanlı Köyü",
      "Özkanlar Mah (yağızköy Köyü)",
      "Sağlıcak Köyü",
      "Salhan Mah (alahan Köyü)",
      "Sarıevler Mah (havuzluçam Köyü)",
      "Sekizler Mah (güvendik Köyü)",
      "Selmincik Köyü",
      "Solak Mah (erikliyayla Köyü)",
      "Taşlıbakar Köyü",
      "Tilkip Mah (karaçağıl Köyü)",
      "Turanlı Köyü",
      "Uğurlar Köyü",
      "Uzunali Mah (alahan Köyü)",
      "Yağızköy Köyü",
      "Yazılıbahar Mah (havuzluçam Köyü)",
      "Yenideğirmen Köyü",
      "Yeşilyurt Mah (akçağıl Köyü)",
      "Yılanlı Mah (kalbursait Köyü)"
    ],
    "Merkez": [
      "Abdioymağı Mah",
      "Akpınar Mah",
      "Albay İbrahim Karaoğlanoğlu Mah",
      "Altınüzüm Mah",
      "Aslan Mah",
      "Aşıt Mah",
      "Atatürk Mah",
      "Barış Mah",
      "Bilali Habeş Mah",
      "Bölük Mah",
      "Büyükkütah Mah",
      "Canpolat Paşa Mah",
      "Cumhuriyet Mah",
      "Çaylak Mah",
      "Demirciler Mah",
      "Deveciler Mah",
      "Doğan Güreş Paşa Mah",
      "Ebulüle Mah",
      "Ekrem Çetin Mah",
      "Fatih Sultan Mehmet Mah",
      "Gaziler Mah",
      "Hacı Gümüş Mah",
      "Hacı İlyas Mah",
      "Hakverdi Mah",
      "Hasan Kamil Demirbaş Mah",
      "Helvacıoğlu Mah",
      "Hindioğlu Mah",
      "Hürriyet Mah",
      "İnnaplı Kütah Mah",
      "İslambey Mah",
      "İsmet Paşa Mah",
      "Kanuni Sultan Süleyman Mah",
      "Karaali Mah",
      "Kartalbey Mah",
      "Kazım Karabekir Mah",
      "Ketenciler Mah",
      "Maraşal Fevzi Çakmak Mah",
      "Mehmet Abdi Bulut Mah",
      "Mehmet Rıfat Kazancıoğlu Mah",
      "Mehmet Sanlı Mah",
      "Mercidabık Mah",
      "Meşetlik Mah",
      "Mıhali Mah",
      "Muallim Rıfat Bilge Mah",
      "Mullahamit Mah",
      "Mücahitler Mah",
      "Müslümanbey Mah",
      "Nacaroğlu Mah",
      "Namık Kemal Mah",
      "Namık Ünler Paşa Mah",
      "Necmettin Erbakan Mah",
      "Nedim Ökmen Mah",
      "Nurettin Mah",
      "Okçular Mah",
      "Organize Sanayi Bölgesi Mah",
      "Osman Gazi Mah",
      "Oylum Mah",
      "Öncü Pınar Mah",
      "Polat Paşa Mah",
      "Saraç Mehmet Çavuş Mah",
      "Şehit Sakıp Mah",
      "Şehitler Mah",
      "Şıh Abdullah Mah",
      "Şıh Ahmet Mah",
      "Şıh Mehmet Mah",
      "Şıhlar Mah",
      "Şörhabil Mah",
      "Tabakhane Mah",
      "Tekye Mah",
      "Tırıklı Mah",
      "Tosyalı Mah",
      "Vaiz Mah",
      "Yaşar Aktürk Mah",
      "Yavuz Sultan Selim Mah",
      "Yedi Aralık Mah",
      "Yeni Mah",
      "Zeytinli Mah",
      "Acar Köyü",
      "Acar Mah (acar Köyü)",
      "Akçabağlar Köyü",
      "Akdilek Mah (duruca Köyü)",
      "Akıncı Köyü",
      "Alatepe Köyü",
      "Ali Gün Mah (yavuzlu Köyü)",
      "Arpakesmez Köyü",
      "Aybastı Mah (duruca Köyü)",
      "Başmağara Köyü",
      "Bayramlı Mah (çörten Köyü)",
      "Beşenli Köyü",
      "Beşikkaya Köyü",
      "Bilal Habeşi Mah (yavuzlu Köyü)",
      "Bozcayazı Köyü",
      "Buğdaylı Mah (güneşli Köyü)",
      "Bulamaçlı Köyü",
      "Büyükkonak Köyü",
      "Ceritler Köyü",
      "Çakkallıpınar Köyü",
      "Çalkaya Köyü",
      "Çerçili Köyü",
      "Çilorlar Mah (çerçili Köyü)",
      "Çörten Köyü",
      "Çukuroba Köyü",
      "Deliçay Köyü",
      "Deliosman Köyü",
      "Demirciler Köyü",
      "Demirışık Köyü",
      "Doğançay Köyü",
      "Doğanlı Mah (bozcayazı Köyü)",
      "Dölek Köyü",
      "Duruca Köyü",
      "Elberen Mah (karaçavuş Köyü)",
      "Gençtepe Mah (karamelik Köyü)",
      "Göktaş Köyü",
      "Gözkaya Köyü",
      "Gülbaba Köyü",
      "Gümüşsuyu Köyü",
      "Güneşli Köyü",
      "Güvenli Köyü",
      "Hapse Mah (yavuzlu Köyü)",
      "Hıcıpoğlu Köyü",
      "Hisar Köyü",
      "Hizolar Mah (narlıca Köyü)",
      "Hüyüklü Mah (güvenli Köyü)",
      "İnanlı Köyü",
      "Kapdeğirmeni Köyü",
      "Karacaören Köyü",
      "Karaçavuş Köyü",
      "Karakoyunlu Mah (dölek Köyü)",
      "Karamelik Köyü",
      "Kilolar Mah (çerçili Köyü)",
      "Kocabeyli Köyü",
      "Kuskunkıran Köyü",
      "Kuzuini Köyü",
      "Küçük Mısırcık Mah (mısırcık Köyü)",
      "Küçükkonak Köyü",
      "Küçükmaya Mah (çukuroba Köyü)",
      "Küplüce Köyü",
      "Kürtüncü Mah (güvenli Köyü)",
      "Mağaracık Köyü",
      "Mehmetali Köyü",
      "Mısırcık Köyü",
      "Narlıca Köyü",
      "Oruçlu Mah (küplüce Köyü)",
      "Otluca Mah (saatli Köyü)",
      "Saatli Köyü",
      "Sapkanlı Mah (gülbaba Köyü)",
      "Sinan Paşa Mah (yavuzlu Köyü)",
      "Süngütepe Köyü",
      "Tahtalı Köyü",
      "Tanbıralı Köyü",
      "Taşpınar Mah (çalkaya Köyü)",
      "Topdağı Köyü",
      "Uzunlu Köyü",
      "Yamaç Beşenli Mah (beşenli Köyü)",
      "Yavuz Mah (yavuzlu Köyü)",
      "Yukarı Beşenli Mah (beşenli Köyü)"
    ],
    "Musabeyli": [
      "Ağcakent Köyü",
      "Aşağıbademli Köyü",
      "Aşağıkalecik Köyü",
      "Balıklı Köyü",
      "Belentepe Köyü",
      "Bogazkirim Mah (dorucak Köyü)",
      "Bozkaya Köyü",
      "Çakmak Mah (körahmethüyüğü Köyü)",
      "Çayıraltı Köyü",
      "Çınarköy Köyü",
      "Dorucak Köyü",
      "Dutluca Köyü",
      "Fericek Köyü",
      "Fırlaklı Köyü",
      "Geçitboyu Köyü",
      "Gökmusa Köyü",
      "Gövceli Mah (aşağıbademli Köyü)",
      "Gözlüce Köyü",
      "Gündeğer Köyü",
      "Hacılar Köyü",
      "Hasancalı Köyü",
      "Haydarlar Köyü",
      "Hüseyinoğlu Köyü",
      "Karadut Köyü",
      "Karbeyaz Köyü",
      "Kayapınar Köyü",
      "Kaynaklı Köyü",
      "Kızılkent Köyü",
      "Kocalar Mah (körahmethüyüğü Köyü)",
      "Koçcağız Köyü",
      "Kolpınar Köyü",
      "Kozlubağ Köyü",
      "Körahmethüyüğü Köyü",
      "Kurtaran Köyü",
      "Kürtüncü Köyü",
      "Madenyolu Köyü",
      "Ortaoba Mah (kızılkent Köyü)",
      "Ötekioba Mah (kızılkent Köyü)",
      "Sabanlı Köyü",
      "Seydolar Mah (fırlaklı Köyü)",
      "Şenlikçe Köyü",
      "Tahtalıkaradut Köyü",
      "Tat Gemrigi Mah (fericek Köyü)",
      "Tokaçgemriği Köyü",
      "Topallar Köyü",
      "Ugurca Mah (uğurtepe Köyü)",
      "Uğurtepe Köyü",
      "Üçevler Mah (hasancalı Köyü)",
      "Üçpınar Köyü",
      "Yastıca Köyü",
      "Yatağan Mah (gündeğer Köyü)",
      "Yedigöz Köyü",
      "Yeşiloba Köyü",
      "Yukarı Madenyolu Mah (madenyolu Köyü)",
      "Yukarıbademli Köyü",
      "Yukarıkalecik Köyü",
      "Yuvabaşı Köyü",
      "Zeytinbağı Köyü",
      "Cumhuriyet Mah",
      "Murathüyüğü Mah",
      "Pınar Mah"
    ],
    "Polateli": [
      "Bağarası Köyü",
      "Bektaşoğlu Köyü",
      "Belenözü Köyü",
      "Bozkaya Mah (yeniyapan Köyü)",
      "Çelik Mah (ömeroğlu Köyü)",
      "Dümbüllü Köyü",
      "Eğlen Köyü",
      "Evrentepe Mah (yeniyapan Köyü)",
      "Evrentepe Yolu Mah (yeniyapan Köyü)",
      "Karacurun Mah (yeniyurt Köyü)",
      "Karapınar Mah (yılanca Köyü)",
      "Kızılgöl Köyü",
      "Koçlar Mah (yeniyapan Köyü)",
      "Ömercik Köyü",
      "Ömeroğlu Köyü",
      "Polatbey Köyü",
      "Söğütlü Köyü",
      "Taşlıalan Köyü",
      "Tekdam Mah (dümbüllü Köyü)",
      "Ürünlü Köyü",
      "Yeniköy Mah (dümbüllü Köyü)",
      "Yeniyapan Köyü",
      "Yeniyapan Mah (dümbüllü Köyü)",
      "Yeniyurt Köyü",
      "Yeşilpınar Köyü",
      "Yılanca Köyü",
      "Atatürk Mah",
      "Cumhuriyet Mah",
      "Ekrem Çetin Mah",
      "Kaymakam Kürşat Ağca Mah",
      "Sosyal Konutlar Mah",
      "Şehit Ali Mah"
    ]
  },
  "Osmaniye": {
    "Bahçe": [
      "Aslanlı Mah",
      "Bahçeli Evler Mah",
      "Cumhuriyet Mah",
      "Çamlıca Mah",
      "Esentepe Mah",
      "İslam Mah",
      "İstiklal Mah",
      "Kale Mah",
      "Karşıyaka Mah",
      "Yenı Mah",
      "Yeşil Yurt Mah",
      "Altunlar Kümesi Mah (yukarıkardere Köyü)",
      "Aşağıkaradere Köyü",
      "Aygır Mah (savranlı Köyü)",
      "Ayran Kümesi Mah (aşağıarıcaklı Köyü)",
      "Balinkaşı Kümesi Mah (yukarıkardere Köyü)",
      "Basamaklı Mah (bekdemir Köyü)",
      "Bekdemir Köyü",
      "Buğdaycık Mah (arıklıkaş Köyü)",
      "Çelikler Mah (bekdemir Köyü)",
      "Çiçekli Kümesi Mah (yukarıkardere Köyü)",
      "Demirlik Kümesi Mah (yukarıkardere Köyü)",
      "Dutlu Mah (bekdemir Köyü)",
      "Gazi Kümesi Mah (yukarıkardere Köyü)",
      "Gökmustafalı Köyü",
      "Hamisler Kümesi Mah (yukarıkardere Köyü)",
      "Hayvalık Kümesi Mah (yukarıkardere Köyü)",
      "İbişler Mah (arıcaklı Köyü)",
      "Kaman Köyü",
      "Karşıyaka Kümesi Mah (kızlaç Köyü)",
      "Keller Mah (bekdemir Köyü)",
      "Kelosmanlar Mah (örencik Köyü)",
      "Kıraçlı Mah (bekdemir Köyü)",
      "Kirazlı Mah (bekdemir Köyü)",
      "Köleler Mah (aşağıkaradere Köyü)",
      "Köybaşı Mah (aşağıkaradere Köyü)",
      "Kuzgeçe Kümesi Mah (yukarıkardere Köyü)",
      "Mandal Kümesi Mah (yukarıkardere Köyü)",
      "Mercanlar Mah (arıklıkaş Köyü)",
      "Mercanlı Mah (bekdemir Köyü)",
      "Merkez Kümesi Mah (kızlaç Köyü)",
      "Merkez Mah (arıcaklı Köyü)",
      "Merkez Mah (arıklıkaş Köyü)",
      "Merkez Mah (burgaçlı Köyü)",
      "Merkez Mah (inderesi Köyü)",
      "Nohut Köyü",
      "Örencik Köyü",
      "Savranlı Köyü",
      "Selamlar Mah (burgaçlı Köyü)",
      "Soğukpınar Mah (aşağıarıcaklı Köyü)",
      "Taşoluk Mah (arıklıkaş Köyü)",
      "Yaylalık Köyü",
      "Yeni Kümesi Mah (yukarıkardere Köyü)",
      "Yukarı Kümesi Mah (kızlaç Köyü)",
      "Yukarıoba Mah (savranlı Köyü)"
    ],
    "Düziçi": [
      "Çukuroba Mah (atalan Beldesi)",
      "Katobası Mah (atalan Beldesi)",
      "Merkez Mah (atalan Beldesi)",
      "Şehit Hüseyin Sarı Mah (atalan Beldesi)",
      "Boyalı Mah (böcekli Beldesi)",
      "Celiller Mah (böcekli Beldesi)",
      "Demirciler Mah (böcekli Beldesi)",
      "Dümbürdek Mah (böcekli Beldesi)",
      "Kürt Mahmutlar Mah (böcekli Beldesi)",
      "Yeşil Yurt Mah (böcekli Beldesi)",
      "Boğaziçi Mah",
      "Cumhuriyet Mah",
      "Çiftlik Mah",
      "Hürriyet Mah",
      "İrfanlı Mah",
      "İstiklal Mah",
      "Karacaoğlan Mah",
      "Karkın Mah",
      "Karlıca Mah",
      "Karşıyaka Mah",
      "Kurtbeyoğlu Mah",
      "Kurtuluş Mah",
      "Merkez Mah",
      "Şehit Asker Kemal Keskin Mah",
      "Uzun Banı Mah",
      "Üzümlü Mah",
      "Yenice Haruniye Mah",
      "Yeşilova Mah",
      "Yukarı Hacılar Mah",
      "Aydınlar Mah (ellek Beldesi)",
      "Çevlik Mah (ellek Beldesi)",
      "Çiraz Mah (ellek Beldesi)",
      "Ellek Mah (ellek Beldesi)",
      "Gökyıldız Mah (ellek Beldesi)",
      "Peçenek Mah (ellek Beldesi)",
      "Soylar Mah (ellek Beldesi)",
      "Şehit Ali Gökçe Mah (ellek Beldesi)",
      "Abacı Mah (gümüş Köyü)",
      "Adaca Mah (kuşcu Köyü)",
      "Ağalar Mah (yeşildere Köyü)",
      "Ahrazlar Mah (güzelyurt Köyü)",
      "Akçakoyunlu Köyü",
      "Aksaylar Mah (karagedik Köyü)",
      "Arpaçukuru Mah (gökçayır Köyü)",
      "Aydınlı Mah (akçakoyunlu Köyü)",
      "Ayşeler Mah (yazlamazlı Köyü)",
      "Boşnak Mah (pirsultanlı Köyü)",
      "Çamiçi Mah",
      "Çamkonuşu Mah (çatak Köyü)",
      "Çatal Mah (elbeyli Köyü)",
      "Çirişlikaş Mah (gümüş Köyü)",
      "Çömezler Mah (gökçayır Köyü)",
      "Delihaliller Mah (çerçioğlu Köyü)",
      "Demirciler Mah (gökçayır Köyü)",
      "Derealibozlusu Mah (alibozlu Köyü)",
      "Doruklar Mah (bostanlar Köyü)",
      "E.u.a.ş. Mah (gökçayır Köyü)",
      "Eğrelti Mah (yeşildere Köyü)",
      "Ekizler Mah (gökçayır Köyü)",
      "Ellezli Mah (elbeyli Köyü)",
      "Emirkara Mah (pirsultanlı Köyü)",
      "Farsak Köyü",
      "Fındık Mah (yenifarsak Köyü)",
      "Göllüler Mah (bostanlar Köyü)",
      "Hacıibişler Mah (bostanlar Köyü)",
      "Hartlap Mah (elbeyli Köyü)",
      "Hemenler Mah (alibozlu Köyü)",
      "Hıdırlı Mah (çerçioğlu Köyü)",
      "Hodu Mah (yenifarsak Köyü)",
      "Horozlar Mah (gökçayır Köyü)",
      "Höbür Mah (yazlamazlı Köyü)",
      "Hökelekler Mah (gökçayır Köyü)",
      "İbişler Mah (bayındırlı Köyü)",
      "İkizler Mah (karagedik Köyü)",
      "Kadirler Mah (gökçayır Köyü)",
      "Karaisa Mah (çitli Köyü)",
      "Karakuyu Mah (çerçioğlu Köyü)",
      "Karanıdere Mah (selverler Köyü)",
      "Karanlıkdere Mah (karagedik Köyü)",
      "Karayusuflar Mah (çerçioğlu Köyü)",
      "Kaş Mah (bostanlar Köyü)",
      "Kaş Mah (pirsultanlı Köyü)",
      "Kazıklı Mah (oluklu Köyü)",
      "Keller Mah (elbeyli Köyü)",
      "Kışla Mah (gümüş Köyü)",
      "Kızılali Mah (çotlu Köyü)",
      "Koyuntaş Mah (oluklu Köyü)",
      "Köşkerler Mah (gökçayır Köyü)",
      "Köşkerli Mah (yeşilköy Köyü)",
      "Manlar Mah (bayındırlı Köyü)",
      "Mehmetoğluyeri Mah (kuşcu Köyü)",
      "Merkez Mah (alibozlu Köyü)",
      "Merkez Mah (bayındırlı Köyü)",
      "Merkez Mah (bostanlar Köyü)",
      "Merkez Mah (çatak Köyü)",
      "Merkez Mah (çerçioğlu Köyü)",
      "Merkez Mah (çitli Köyü)",
      "Merkez Mah (çotlu Köyü)",
      "Merkez Mah (elbeyli Köyü)",
      "Merkez Mah (gökçayır Köyü)",
      "Merkez Mah (gümüş Köyü)",
      "Merkez Mah (güzelyurt Köyü)",
      "Merkez Mah (karaguz Köyü)",
      "Merkez Mah (kuşcu Köyü)",
      "Merkez Mah (oluklu Köyü)",
      "Merkez Mah (pirsultanlı Köyü)",
      "Merkez Mah (yazlamazlı Köyü)",
      "Merkez Mah (yenifarsak Köyü)",
      "Merkez Mah (yeşilköy Köyü)",
      "Mezdağ Mah (gümüş Köyü)",
      "Nacarfarsağı Mah (farsak Köyü)",
      "Nasıflı Mah (yeşildere Köyü)",
      "Selverler Köyü",
      "Söğütlügöl Köyü",
      "Şamlar Mah (güzelyurt Köyü)",
      "Tabaklar Mah (gökçayır Köyü)",
      "Telliler Mah (alibozlu Köyü)",
      "Tozluyurt Mah (gümüş Köyü)",
      "Traşlar Mah (çotlu Köyü)",
      "Uzundere Mah (karagedik Köyü)",
      "Yavuz Sultan Selim Mah (alibozlu Köyü)",
      "Yeşil Mah (çerçioğlu Köyü)",
      "Yeşilyurt Köyü",
      "Yolatı Mah (yeşildere Köyü)",
      "Karacaören Mah (yarbaşı Beldesi)",
      "Karaçarlı Mah (yarbaşı Beldesi)",
      "Merkez Mah (yarbaşı Beldesi)"
    ],
    "Hasanbeyli": [
      "Cumhuriyet Mah",
      "Hürriyet Mah",
      "Merkez Mah",
      "Yeşilyurt Mah",
      "Çolaklı Köyü",
      "Çulhalı Köyü",
      "Heyik Mah (kalecik Köyü)",
      "Kalecik Köyü",
      "Kanlıgeçit Mah (kalecik Köyü)",
      "Karayiğit Köyü",
      "Sarayova Köyü",
      "Yanıkkışla Köyü"
    ],
    "Kadirli": [
      "Cemalpaşa Mah",
      "Şehit Halis Şişman Mah",
      "Şehit Kansu Küçükateş Mah",
      "7 Mart Mah",
      "Bağ Mah",
      "Cengiz Topel Mah",
      "Dere Mah",
      "Dervişpaşa Mah",
      "Kurtuluş Mah",
      "Pazar Mah",
      "Savrun Mah",
      "Şehit İbrahim Kundakçı Mah",
      "Şehit Mehmet Delikuş Mah",
      "Şehit Mehmet Hallaç Mah",
      "Şehit Mustafa Yağız Mah",
      "Şehit Orhan Gök Mah",
      "Şehit Vedat  Kocadallı Mah",
      "Tufanpaşa Mah",
      "Yeni Mah",
      "Yeşiltepe Mah",
      "Acaroba Mah (kızyusuflu Köyü)",
      "Ağılkaya Mah (mezretli Köyü)",
      "Ağlıca Mah (değirmendere Köyü)",
      "Ahmetfakılar Mah (aydınlar Köyü)",
      "Ahmetsavrun Mah (kiremitli Köyü)",
      "Akarca Mah (yenigün Köyü)",
      "Akgedik Mah (kayasuyu Köyü)",
      "Akkızlar Mah (hardallık Köyü)",
      "Akköprü Köyü",
      "Akova Köyü",
      "Akpınar Mah (koçlu Köyü)",
      "Alabeyli Mah (çiğcik Köyü)",
      "Aliortaklı Mah (kesim Köyü)",
      "Alisayit Çiftliği Mah (mecidiye Köyü)",
      "Aliveliler Mah (kesim Köyü)",
      "Altunerler Mah (mezretli Köyü)",
      "Anberinarkı Köyü",
      "Aras Mah (kösepınarı Köyü)",
      "Arslantaş Mah (karatepe Köyü)",
      "Aşağı Köşkerli Tüysüzler Mah (kayasuyu Köyü)",
      "Aşağıbozkuyu Köyü",
      "Aşağıçiyanlı Köyü",
      "Atasanlı Mah (kesim Köyü)",
      "Ayvacık Mah (değirmendere Köyü)",
      "Azaplı Köyü",
      "Bahçeciler Mah (aydınlar Köyü)",
      "Baysun Karamüftüoğlu Çiftliği Mah (yeniköy Köyü)",
      "Bekereci Köyü",
      "Bozerler Mah (yukarıçiyanlı Köyü)",
      "Cennetler Mah (kızyusuflu Köyü)",
      "Coşkunlar Köyü",
      "Çanaklı Mah (sarıtanışmanlı Köyü)",
      "Çatallar Mah (koçlu Köyü)",
      "Çaygeçit Köyü",
      "Çevlik Mah (yenigün Köyü)",
      "Çınar Deresi Mah (mezretli Köyü)",
      "Çınar Köyü",
      "Çınarlı Mah (değirmendere Köyü)",
      "Çıplaklar Mah (öksüzlü Köyü)",
      "Çiğdemli Köyü",
      "Çiğilli Mah (çiğdemli Köyü)",
      "Çildirler Mah (aydınlar Köyü)",
      "Çinçikler Solaklar Mah (yukarıçiyanlı Köyü)",
      "Çizmeliler Mah (yeniköy Köyü)",
      "Çolakerollar Mah (kızyusuflu Köyü)",
      "Çontarlar Mah (karakütük Köyü)",
      "Çöplüler Mah (aydınlar Köyü)",
      "Çukurköprü Köyü",
      "Çukurören Mah (koçlu Köyü)",
      "Deliayşeler Mah (kesim Köyü)",
      "Demirciler Mah (kesim Köyü)",
      "Dere Mah (kayasuyu Köyü)",
      "Dertililer Mah (karakütük Köyü)",
      "Devrişli Mah (kiremitli Köyü)",
      "Döğüş Gediği Mah (yukarıçiyanlı Köyü)",
      "Durmuşsofular Köyü",
      "Elmalıkayseri Mah (yoğunoluk Köyü)",
      "Ericek Mah (tahta Köyü)",
      "Fakılar Mah (kesim Köyü)",
      "Ganiağalar Mah (çiğcik Köyü)",
      "Gedik Mah (mehedinli Köyü)",
      "Gıraçobası Mah (bahadırlı Köyü)",
      "Göçmenler Mah (aydınlar Köyü)",
      "Göçmenler Mah (hardallık Köyü)",
      "Göçmenler Mah (kümbet Köyü)",
      "Gökalan Mah (mehedinli Köyü)",
      "Gökbüğet Mah (kösepınarı Köyü)",
      "Gözüböyüklü Mah (çiğdemli Köyü)",
      "Günece Mah (yoğunoluk Köyü)",
      "Güzeller Mah (mezretli Köyü)",
      "Hacıabdiler Mah (bahadırlı Köyü)",
      "Hacıahmetler Mah (kesim Köyü)",
      "Hacıhaliloğlu Köyü",
      "Hamam Mah (oruçbey Köyü)",
      "Harkaştığı Köyü",
      "Hasarkaya Mah (göztaşı Köyü)",
      "Hayvalı Mah (yukarıçiyanlı Köyü)",
      "Hocalar Mah (kiremitli Köyü)",
      "İlbistanlı Köyü",
      "İmirzeler Mah (kesim Köyü)",
      "İnci Mah (tahta Köyü)",
      "İncikler Mah (kesim Köyü)",
      "İsalar Mah (sarıtanışmanlı Köyü)",
      "İspirler Mah (yukarıçiyanlı Köyü)",
      "İstanbulcık Mah (koçlu Köyü)",
      "Kabayar Köyü",
      "Kadirliosb Mah (yusufizzettin Köyü)",
      "Kale Mah (değirmendere Köyü)",
      "Kalealtı Mah (koçlu Köyü)",
      "Karabacak Köyü",
      "Karacaaliler Mah (karakütük Köyü)",
      "Karaceliler Mah (halitağalar Köyü)",
      "Karafakıllar Mah (sarıtanışmanlı Köyü)",
      "Karakütük Köyü",
      "Karapınar Mah (göztaşı Köyü)",
      "Karataylar Mah (halitağalar Köyü)",
      "Karatepe Köyü",
      "Karatopaklı Mah (yukarıçiyanlı Köyü)",
      "Karayılanlı Mah (mezretli Köyü)",
      "Kartın Mah (aydınlar Köyü)",
      "Kastal Mah (yoğunoluk Köyü)",
      "Kaş Mah (yoğunoluk Köyü)",
      "Kepirler Mah (mezretli Köyü)",
      "Kerimli Köyü",
      "Kesikkeli Köyü",
      "Kesmeli Tepe Mah (mehedinli Köyü)",
      "Kıstılar Mah (kızyusuflu Köyü)",
      "Kiremitli Köyü",
      "Kocaaliler Mah (yenigün Köyü)",
      "Kocaboğalar Mah (koçlu Köyü)",
      "Konaklı Mah (mezretli Köyü)",
      "Köraliuşağı Mah (karakütük Köyü)",
      "Kösepınarı Köyü",
      "Köşkerli Mah (kayasuyu Köyü)",
      "Kümbet Köyü",
      "Maksutoluğu Mah (değirmendere Köyü)",
      "Merkez Mah (aydınlar Köyü)",
      "Merkez Mah (çiğcik Köyü)",
      "Merkez Mah (değirmendere Köyü)",
      "Merkez Mah (erdoğdu Köyü)",
      "Merkez Mah (göztaşı Köyü)",
      "Merkez Mah (halitağalar Köyü)",
      "Merkez Mah (hardallık Köyü)",
      "Merkez Mah (kayasuyu Köyü)",
      "Merkez Mah (koçlu Köyü)",
      "Merkez Mah (mecidiye Köyü)",
      "Merkez Mah (oruçbey Köyü)",
      "Merkez Mah (sofular Köyü)",
      "Merkez Mah (tahta Köyü)",
      "Merkez Mah (topraktepe Köyü)",
      "Merkez Mah (tozlu Köyü)",
      "Merkez Mah (yoğunoluk Köyü)",
      "Merkez Mah (yusufizzettin Köyü)",
      "Mezililer Mah (kayasuyu Köyü)",
      "Mezretli Mah (mezretli Köyü)",
      "Murtlutarla Mah (mehedinli Köyü)",
      "Narlıkışla Köyü",
      "Nurcular Mah (sarıtanışmanlı Köyü)",
      "Olucakgediği Mah (kösepınarı Köyü)",
      "Orta Mahalle (tozlu Köyü)",
      "Öksüzler Mah (öksüzlü Köyü)",
      "Ören Mah (kızyusuflu Köyü)",
      "Özdemirler Mah (öksüzlü Köyü)",
      "Pampallı Mah (yusufizzettin Köyü)",
      "Pürçek Mah (tahta Köyü)",
      "Rifat Mah (kiremitli Köyü)",
      "Saltalılar Mah (kesim Köyü)",
      "Sarıböğsek Mah (karakütük Köyü)",
      "Sarıcaferli Mah (karakütük Köyü)",
      "Sarıdüz Mah (karatepe Köyü)",
      "Sarıkızlar Mah (yeniköy Köyü)",
      "Sarıtanışmanlı Köyü",
      "Semerciler Mah (yukarıçiyanlı Köyü)",
      "Sıyrıngaç Mah (kösepınarı Köyü)",
      "Siteler Mah (kızyusuflu Köyü)",
      "Siteler Su Sporları Merkezi Mah (kızyusuflu Köyü)",
      "Soğancılar Mah (kiremitli Köyü)",
      "Soysallı Mah (halitağalar Köyü)",
      "Söğütlüdere Köyü",
      "Söğütoluğu Mah (değirmendere Köyü)",
      "Süleymanlı Mah (koçlu Köyü)",
      "Şabaplı Köyü",
      "Tapsızlar Mah (kayasuyu Köyü)",
      "Tatarlı Köyü",
      "Teberik Mah (göztaşı Köyü)",
      "Tekeli Köyü",
      "Tekerekli Mah (yukarıçiyanlı Köyü)",
      "Teslimeler Mah (mehedinli Köyü)",
      "Tıbılılar Mah (topraktepe Köyü)",
      "Topalahmetler Mah (kızyusuflu Köyü)",
      "Torunlar Mah (koçlu Köyü)",
      "Tosbağlı Mah (kızyusuflu Köyü)",
      "Turna Mah (değirmendere Köyü)",
      "Tüccar Mah (aydınlar Köyü)",
      "Üçtepe Mah (göztaşı Köyü)",
      "Üdürükler Mah (yukarıçiyanlı Köyü)",
      "Üzümlü Mah (koçlu Köyü)",
      "Vahapoğlu Mah (topraktepe Köyü)",
      "Vayvaylı Köyü",
      "Veliler Çolaklar Mah (kesim Köyü)",
      "Yalnızdut Köyü",
      "Yanıklar Mah (harkaştığı Köyü)",
      "Yapalak Mah (tahta Köyü)",
      "Yarmadibi Mah (erdoğdu Köyü)",
      "Yaylapınarı Mah (kızyusuflu Köyü)",
      "Yazdamı Mah (mehedinli Köyü)",
      "Yenigün Köyü",
      "Yeniyer Mah (mecidiye Köyü)",
      "Yeşilyurt Mah (kerimli Köyü)",
      "Yozcular Mah (topraktepe Köyü)",
      "Yukarıbozkuyu Köyü",
      "Zeynepli Mah (kayasuyu Köyü)",
      "Zindeğen Mah (yoğunoluk Köyü)",
      "Ziyanlı Mah (harkaştığı Köyü)"
    ],
    "Merkez": [
      "Adnan Menderes Mah",
      "Ahmet Yesevi Mah",
      "Ali Bekirli Mah",
      "Alibeyli Mah",
      "Baş Mah",
      "Cumhuriyet Mah",
      "Dr.ihsan Göknal Mah",
      "Dumlupınar Mah",
      "Esenevler Mah",
      "Eyüp Sultan Mah",
      "Fakıuşağı Mah",
      "Fatih Mah",
      "Gebeli Mah",
      "Hacı Osmanlı Mah",
      "Haraz Mah",
      "İstiklal Mah",
      "Karacay Mah",
      "Kazım Karabekir Mah",
      "Kurtuluş Mah",
      "M.akif Ersoy Mah",
      "M.fevzi Çakmak Mah",
      "Mevlana Mah",
      "Mimar Sinan Mah",
      "Rahime Hatun Mah",
      "Raufbey Mah",
      "Rızaiye Mah",
      "Selimiye Mah",
      "Şirinevler Mah",
      "Ulaşlı Mah",
      "Vatan Mah",
      "Yaverpaşa Mah",
      "Yedi Ocak Mah",
      "Yeni Mah",
      "Yeşil Yurt Mah",
      "Yıldırım Beyazıt Mah",
      "Yunus Emre Mah",
      "Cumhuriyet Mah (cevdetiye Beldesi)",
      "Karataş Mah (cevdetiye Beldesi)",
      "Kocatepe Mah (cevdetiye Beldesi)",
      "Yeşiltepe Mah (cevdetiye Beldesi)",
      "Abuzerler Mah (kırıklı Köyü)",
      "Akarca Mah (şekerdere Köyü)",
      "Aktaş Mah (dervişli Köyü)",
      "Ali Çavuşlar Mah (ıssızca Köyü)",
      "Arslanlı Köyü",
      "Aydınlar Mah (dervişli Köyü)",
      "Babaoğlu Mah (kazmaca Köyü)",
      "Bahçe Köyü",
      "Bıçakçı Mah (dervişli Köyü)",
      "Cumhuriyet Mah (kırmıtlı Köyü)",
      "Çağşak Köyü",
      "Çamlıbel Mah (kazmaca Köyü)",
      "Çanakcı Mah (kırıklı Köyü)",
      "Çatalmazı Mah (kayalı Köyü)",
      "Çona Köyü",
      "Çürük Armut Mah (çona Köyü)",
      "D400 Altı Mah (serinova Köyü)",
      "D400 Üstü Mah (serinova Köyü)",
      "Davulbazlar Mah (dereli Köyü)",
      "Davutlar Mah (yarpuz Köyü)",
      "Değirmen Ocağı Köyü",
      "Dereli Köyü",
      "Dereobası Köyü",
      "Dereobası Mah (kırmacılı Köyü)",
      "Gazi Sinan Mah (kırmıtlı Köyü)",
      "Gültepe Mah (kırmacılı Köyü)",
      "Hamus Mah (kumarlı Köyü)",
      "Haraz Mah (çona Köyü)",
      "Hemite Köyü",
      "İbiş Ağalar E-24 Karayolu Üzeri Mah (dervişli Köyü)",
      "Kahyalar Mah (dervişli Köyü)",
      "Kanlı Koz Mah (çona Köyü)",
      "Kanlıgeçit Mah (kırıklı Köyü)",
      "Karacakışla Mah (kumarlı Köyü)",
      "Karacalar Köyü",
      "Karataş Köyü",
      "Kayalı Köyü",
      "Koçyurdu Köyü",
      "Köyyeri Köyü",
      "Kumluca Mah (dereobası Köyü)",
      "Küllü Köyü",
      "Küşne Mah (küllü Köyü)",
      "Mağraönü Mah (kumarlı Köyü)",
      "Merkez Mah (akyar Köyü)",
      "Merkez Mah (çardak Köyü)",
      "Merkez Mah (dervişli Köyü)",
      "Merkez Mah (ıssızca Köyü)",
      "Merkez Mah (kazmaca Köyü)",
      "Merkez Mah (kesmeburun Köyü)",
      "Merkez Mah (kırıklı Köyü)",
      "Merkez Mah (kırmacılı Köyü)",
      "Merkez Mah (şekerdere Köyü)",
      "Merkez Mah (tehçi Köyü)",
      "Merkez Mamure İstasyonu Mah (dervişli Köyü)",
      "Meydan Mah (kazmaca Köyü)",
      "Nergizlik Mah (kazmaca Köyü)",
      "Nohuttepe Köyü",
      "Orhaniye Köyü",
      "Oruçgazi Köyü",
      "Sakarcalık Köyü",
      "Sakızgediği Köyü",
      "Sarpınağzı Köyü",
      "Selimiye Köyü",
      "Serdar Köyü",
      "Seyrantepe Mah (kırmıtlı Köyü)",
      "Tülücüler Mah (kazmaca Köyü)",
      "Tülücüler Mah (kırmacılı Köyü)",
      "Yarpuz Köyü",
      "Yeniköy Köyü",
      "Yukarıçona Mah (çona Köyü)"
    ],
    "Sumbas": [
      "Armağanlı Mah (mehmetli Beldesi)",
      "Cumhuriyet Mah (mehmetli Beldesi)",
      "Yeni Mah (mehmetli Beldesi)",
      "Agedik Mah (yeşilyayla Köyü)",
      "Akçalıuşağı Mah (akçataş Köyü)",
      "Akyar Mah (akdam Köyü)",
      "Alasırt Mah (çiçeklidere Köyü)",
      "Alişanlı Mah (kızılömerli Köyü)",
      "Aydınlar Mah (akçataş Köyü)",
      "Bağdaş Mah (esenli Köyü)",
      "Bağyeri Mah (gafarlı Köyü)",
      "Cemiller Mah (gafarlı Köyü)",
      "Çıkıkalan Mah (çiçeklidere Köyü)",
      "Çintizli Mah (akçataş Köyü)",
      "Çukurfenk Mah (yeşilyayla Köyü)",
      "Davutlu Mah (akdam Köyü)",
      "Delialiler Mah (akdam Köyü)",
      "Demirciler Mah (köseli Köyü)",
      "Dineker Mah (gafarlı Köyü)",
      "Diniker Mah (akçataş Köyü)",
      "Ellezli Mah (gafarlı Köyü)",
      "Evciler Mah (akdam Köyü)",
      "Fındıklar Mah (yeşilyayla Köyü)",
      "Galipli Mah (yeşilyayla Köyü)",
      "Gazeller Mah (esenli Köyü)",
      "Geceli Mah (gafarlı Köyü)",
      "Gençaliler Mah (köseli Köyü)",
      "Geyikağılı Mah (yeşilyayla Köyü)",
      "Gökçebel Mah (esenli Köyü)",
      "Gökgedik Mah (gafarlı Köyü)",
      "Göz Mah (akçataş Köyü)",
      "Güveller Mah (gafarlı Köyü)",
      "Harmancık Mah (gafarlı Köyü)",
      "Işıklı Mah (akdam Köyü)",
      "İncirliburun Mah (akçataş Köyü)",
      "İncirliburun Mah (köseli Köyü)",
      "Kalfa Mah (alibeyli Köyü)",
      "Kalkan Mah (çiçeklidere Köyü)",
      "Karagedik Mah (yeşilyayla Köyü)",
      "Karşıyaka Mah (akçataş Köyü)",
      "Kayseri Mah (yeşilyayla Köyü)",
      "Kesmesur Mah (gafarlı Köyü)",
      "Kırıkköprü Mah (çiçeklidere Köyü)",
      "Kürtler Mah (akdam Köyü)",
      "Merkez Mah (akçataş Köyü)",
      "Merkez Mah (akdam Köyü)",
      "Merkez Mah (alibeyli Köyü)",
      "Merkez Mah (çiçeklidere Köyü)",
      "Merkez Mah (esenli Köyü)",
      "Merkez Mah (gafarlı Köyü)",
      "Merkez Mah (hüyük Köyü)",
      "Merkez Mah (kızılömerli Köyü)",
      "Merkez Mah (köseli Köyü)",
      "Merkez Mah (küçükçınar Köyü)",
      "Merkez Mah (reşadiye Köyü)",
      "Merkez Mah (yazıboyu Köyü)",
      "Merkez Mah (yeşilyayla Köyü)",
      "Müstenler Mah (yazıboyu Köyü)",
      "Safiyeler Mah (yeşilyayla Köyü)",
      "Tahtalı Mah (çiçeklidere Köyü)",
      "Taşköprü Mah (gafarlı Köyü)",
      "Taşocağı Mah (gafarlı Köyü)",
      "Terelik Mah (gafarlı Köyü)",
      "Yeni Cennetli Mah (esenli Köyü)",
      "Yirce Mah (çiçeklidere Köyü)",
      "Zincarcık Mah (çiçeklidere Köyü)",
      "Döğenli Mah",
      "Karaömerli Mah"
    ],
    "Toprakkale": [
      "Arslanpınarı Köyü",
      "İnceler Mah (arslanpınarı Köyü)",
      "Lalegölü Köyü",
      "Sayhüyük Köyü",
      "Çamlıkevler Mah",
      "Dagıstan Mah",
      "Fatıh Sultan Mehmet Mah",
      "Göçmenler Mah",
      "Karataş Mah",
      "Kışla Mah",
      "Kumarlı Mah",
      "Sazlık Mah",
      "Tepe Mah",
      "Büyüktüysüz Mah (türkmen Beldesi)",
      "Cumhuriyet Mah (türkmen Beldesi)",
      "Fatih Mah (türkmen Beldesi)"
    ]
  },
  "Düzce": {
    "Akçakoca": [
      "Ayazlı Mah",
      "Cumhuriyet Mah",
      "Hacı Yusuflar Mah",
      "Orhangazi Mah",
      "Osmaniye Mah",
      "Yalı Mah",
      "Yeni Mah",
      "Yukarı Mah",
      "Acara Mah (doğancılar Köyü)",
      "Ahmetdağı Mah (tahirli Köyü)",
      "Akkaya Köyü",
      "Aktaş Köyü",
      "Altunçay Köyü",
      "Arabacı Köyü",
      "Balatlı Köyü",
      "Battallar Mah (karatavuk Köyü)",
      "Beyhanlı Köyü",
      "Beylik Ağacı Mah (kurukavak Köyü)",
      "Beyören Köyü",
      "Çayağzı Köyü",
      "Çiçekpınar Köyü",
      "Dadalı Köyü",
      "Davutağa Köyü",
      "Deredibi Köyü",
      "Dereköy Köyü",
      "Dilaver Köyü",
      "Doğancılar Mah (doğancılar Köyü)",
      "Döngelli Köyü",
      "Döngelli Mah (döngelli Köyü)",
      "Edilli Ağzı Mah (edilli Köyü)",
      "Edilli Köyü",
      "Esmahanım Köyü",
      "Fakıllı Köyü",
      "Giresunlular Mah (doğancılar Köyü)",
      "Göktepe Köyü",
      "Hemşin Köyü",
      "Kalkın Köyü",
      "Karaburun 2 Mah (hasançavuş Köyü)",
      "Karaburun Mah (hasançavuş Köyü)",
      "Kayadibi Mah (karatavuk Köyü)",
      "Keçikaya Mah (paşalar Köyü)",
      "Kepenç Köyü",
      "Kınık Köyü",
      "Kirazlı Köyü",
      "Kirazyanı Mah (çayağzı Köyü)",
      "Koçar Köyü",
      "Koçullu Köyü",
      "Köyiçi Mah (hasançavuş Köyü)",
      "Köyiçi Mah (karatavuk Köyü)",
      "Kumpınar Mah (çayağzı Köyü)",
      "Kurugöl Köyü",
      "Kurukavak Mah (kurukavak Köyü)",
      "Küpler Köyü",
      "Melenağzı Köyü",
      "Merkez Mah (karatavuk Köyü)",
      "Nazımbey Köyü",
      "Ortanca Köyü",
      "Paşalar Köyü",
      "Sarıyayla Köyü",
      "Subaşı Köyü",
      "Tahirli Köyü",
      "Tepeköy Köyü",
      "Uğurlu Köyü",
      "Yalı Mah (beyhanlı Köyü)",
      "Yenice Köyü",
      "Yeşilköy Köyü"
    ],
    "Cumayeri": [
      "Çevrik Mah",
      "Mehmet Akif Mah",
      "Orta Mah",
      "Yaka Mah",
      "Yeni Mah",
      "Akpınar Köyü",
      "Ali Usta Mah (çelikdere Köyü)",
      "Alt Mah (çelikdere Köyü)",
      "Arif Mah (üvezbeli Köyü)",
      "Cami Mah (subaşı Köyü)",
      "Çamlıpınar Köyü",
      "Değirmen Mah (subaşı Köyü)",
      "Dere Mah (kızılüzüm Köyü)",
      "Dere Mah (yenitepe Köyü)",
      "Elmalıdere Mah (yeşiltepe Köyü)",
      "Esentepe Köyü",
      "Eskioğlu Mah (yeşiltepe Köyü)",
      "Fırınyanı Mah (ordulukaradere Köyü)",
      "Güney Mah (ordulukaradere Köyü)",
      "Harmankaya Köyü",
      "Hatipoğlu Mah (kızılüzüm Köyü)",
      "Iğdır Köyü",
      "İmriz Mah (hamascık Köyü)",
      "Kabaçayır Mah (avlayan Köyü)",
      "Kaşaltı Mah (üvezbeli Köyü)",
      "Kersen Düzü Mah (üvezbeli Köyü)",
      "Kıran Mah (çelikdere Köyü)",
      "Kıran Mah (üvezbeli Köyü)",
      "Kıran Mah (yeşiltepe Köyü)",
      "Korazoğlu Mah (dokuzdeğirmen Köyü)",
      "Kozlar Mah (avlayan Köyü)",
      "Kuru Ali Mah (kızılüzüm Köyü)",
      "Kuz Mah (ordulukaradere Köyü)",
      "Küreklik Mah (üvezbeli Köyü)",
      "Merkez Mah (avlayan Köyü)",
      "Merkez Mah (büyükmelen Köyü)",
      "Merkez Mah (çelikdere Köyü)",
      "Merkez Mah (dokuzdeğirmen Köyü)",
      "Merkez Mah (hamascık Köyü)",
      "Merkez Mah (kızılüzüm Köyü)",
      "Merkez Mah (ordulukaradere Köyü)",
      "Merkez Mah (sırtpınar Köyü)",
      "Merkez Mah (üvezbeli Köyü)",
      "Merkez Mah (yenitepe Köyü)",
      "Mısırlık Köyü",
      "Okul Mah (ordulukaradere Köyü)",
      "Orta Mah (yeşiltepe Köyü)",
      "Osmancık Mah (avlayan Köyü)",
      "Ören Köyü",
      "Ören Mah (sırtpınar Köyü)",
      "Öreniçi Mah (çelikdere Köyü)",
      "Sıvazoğlu Mah (üvezbeli Köyü)",
      "Süleyman Hancı Mah (büyükmelen Köyü)",
      "Şakir Mah (ordulukaradere Köyü)",
      "Taşlık Köyü",
      "Tomas Mah (hamascık Köyü)",
      "Yukarıavlayan Köyü"
    ],
    "Çilimli": [
      "Arabacı Mah",
      "Mahirağa Mah",
      "Şerefiye Mah",
      "Topçular Mah",
      "Ulucami Mah",
      "Yeşil Mah",
      "Yeşiltepe Mah",
      "Alimler Mah (pırpır Köyü)",
      "Bıçkıbaşı Köyü",
      "Çakallar Mah (pırpır Köyü)",
      "Çalılık Köyü",
      "Çilimli Osb Mah (söğütlü Köyü)",
      "Dikmeli Mah (dikmeli Köyü)",
      "Döngelli Köyü",
      "Esenli Köyü",
      "Gülebeler Mah (dikmeli Köyü)",
      "Hızardere Köyü",
      "İshaklar Köyü",
      "Kafyayla Köyü",
      "Kanal Mah (pırpır Köyü)",
      "Karaçörtlen Köyü",
      "Kavaklık Mah (kırkharman Köyü)",
      "Kiraztarla Köyü",
      "Kocaveliler Mah (pırpır Köyü)",
      "Kuşoğlu Köyü",
      "Kültür Mah (pırpır Köyü)",
      "Merkez Mah (alacamescit Köyü)",
      "Merkez Mah (dikmeli Köyü)",
      "Merkez Mah (kırkharman Köyü)",
      "Merkez Mah (yenivakıf Köyü)",
      "Orman Mah (alacamescit Köyü)",
      "Orta Mah (pırpır Köyü)",
      "Ömercikler Mah (pırpır Köyü)",
      "Sarımeşe Köyü",
      "Söğütlü Mah (söğütlü Köyü)",
      "Tepeköy Köyü",
      "Yeni Mah (yenivakıf Köyü)",
      "Yeniköy Köyü",
      "Yukarıkaraköy Köyü",
      "Yukarıköy Mah (kırkharman Köyü)"
    ],
    "Gölyaka": [
      "Açma Mah",
      "Cumakırı Mah",
      "Esen Mah",
      "Fatih Mah",
      "İmamlar Mah",
      "Kuyudüzü Mah",
      "Kültür Mah",
      "Yazıpınar Mah",
      "Yeni Mah",
      "Yeşil Mah",
      "Açma Köyü",
      "Aksu Köyü",
      "Albayrak Mah (saçmalıpınar Köyü)",
      "Alt Mah (bekiroğlu Köyü)",
      "Bakacak Köyü",
      "Balkaya Mah (saçmalıpınar Köyü)",
      "Bıçkı Mah (saçmalıpınar Köyü)",
      "Cevizlik Mah (hamamüstü Köyü)",
      "Cino Mah (yunusefendi Köyü)",
      "Çay Köyü",
      "Deli Mehmet Mah (güzeldere Köyü)",
      "Delihüseyin Mah (değirmentepe Köyü)",
      "Dere Mah (çamlıbel Köyü)",
      "Dere Mah (hamamüstü Köyü)",
      "Dursunlu Mah (değirmentepe Köyü)",
      "Gölcük Mah (hamamüstü Köyü)",
      "Güney Mah (saçmalıpınar Köyü)",
      "Güzeldere Köyü",
      "Hacıoğlu Mah (bekiroğlu Köyü)",
      "Hacısüleymanbey Köyü",
      "Hacıyakup Köyü",
      "İçmeler Köyü",
      "Karaca Mah (çamlıbel Köyü)",
      "Karamahmut Mah (saçmalıpınar Köyü)",
      "Kemeryanı Köyü",
      "Kıran Mah (saçmalıpınar Köyü)",
      "Kızılcık Mah (değirmentepe Köyü)",
      "Kum Mah (bekiroğlu Köyü)",
      "Kurtdüzü Mah (saçmalıpınar Köyü)",
      "Merkez Mah (bekiroğlu Köyü)",
      "Merkez Mah (çamlıbel Köyü)",
      "Merkez Mah (değirmentepe Köyü)",
      "Merkez Mah (hamamüstü Köyü)",
      "Merkez Mah (yunusefendi Köyü)",
      "Muhapdede Köyü",
      "Orta Mah (hamamüstü Köyü)",
      "Orta Mah (saçmalıpınar Köyü)",
      "Sarıdere Köyü",
      "Şimşirlitepe Mah (saçmalıpınar Köyü)",
      "Taşlık Köyü",
      "Yanık 1 Mah (saçmalıpınar Köyü)",
      "Yanık 2 Mah (saçmalıpınar Köyü)",
      "Yazlık  Mah (yazlık Köyü)",
      "Yazlık Köyü",
      "Yeni Mah (saçmalıpınar Köyü)",
      "Yeşilova Köyü",
      "Zekeriya Köyü"
    ],
    "Gümüşova": [
      "Fatih Mah",
      "Hacılar Mah",
      "Kışla Mah",
      "Kültür Mah",
      "Merkez Mah",
      "Yeni Mah",
      "Adaköy Köyü",
      "Adaköyü Mah (adaköy Köyü)",
      "Ardıçdibi Köyü",
      "Çaybükü Köyü",
      "Çaybükü Mah (çaybükü Köyü)",
      "Dededüzü Köyü",
      "Dereköy Köyü",
      "Elmacık Köyü",
      "Hacıkadirler Köyü",
      "Hacıkadirler Mah (hacıkadirler Köyü)",
      "Halilbey Köyü",
      "Kahveleryanı Köyü",
      "Kahveleryanı Mah (kahveleryanı Köyü)",
      "Kıyıköy Köyü",
      "Pazarcık Köyü",
      "Selamlar Mah (selamlar Köyü)",
      "Soğuksu Köyü",
      "Sultaniye Köyü",
      "Yakabaşı Köyü",
      "Yakabaşı Mah (yakabaşı Köyü)",
      "Yeşilyayla Köyü",
      "Yıldıztepe Köyü",
      "Yongalık Köyü"
    ],
    "Kaynaşlı": [
      "Çele Mah",
      "Eskiköy Mah",
      "Karaçalı Mah",
      "Kumluca Mah",
      "Merkez Mah",
      "Sarıyer Mah",
      "Şimşir Mah",
      "28 Evler Mah (darıyeri Yörükler Köyü)",
      "Alt Mah (çatalçam Köyü)",
      "Alt Mah (hacıazizler Köyü)",
      "Başyazıcıoğlu Dağ Evleri Mah (darıyeribakacak Köyü)",
      "Bektaşlı Mah (bıçkıyanı Köyü)",
      "Bülbüldere Mah (çamoluk Köyü)",
      "Çakırsayvan Köyü",
      "Çamlık Mah (çatalçam Köyü)",
      "Çaykara Mah (yeşiltepe Köyü)",
      "Çillioğlu Mah (sarıçökek Köyü)",
      "Çimenlikoruluk Mah (tavak Köyü)",
      "D-100 Boludağı Karayolu Mah (darıyeribakacak Köyü)",
      "D-100 Karayolu Mah (darıyerihasanbey Köyü)",
      "Degirmenyanı Mah (sarıçökek Köyü)",
      "Dere Mah (çamlıca Köyü)",
      "Dere Mah (dipsizgöl Köyü)",
      "Dereboyu Mah (darıyerihasanbey Köyü)",
      "Dip Mah (darıyerihasanbey Köyü)",
      "Doğantepe Mah (dipsizgöl Köyü)",
      "Düzgöstek Mah (yeniyurt Köyü)",
      "Düzormanı Mah (sarıçökek Köyü)",
      "Eğreltili Mah (yeniyurt Köyü)",
      "Elmalı Mah (darıyerihasanbey Köyü)",
      "Fatih Mah (üçköprü Köyü)",
      "Fenerbahçe Mah (üçköprü Köyü)",
      "Fındıklı Köyü",
      "Fındıklı Mah (çatalçam Köyü)",
      "Güldere Mah (darıyerihasanbey Köyü)",
      "Güney Mah (sazköy Köyü)",
      "Hacımehmet Mah (darıyerimengencik Köyü)",
      "Hamzalı Mah (bıçkıyanı Köyü)",
      "Hendanoğlu Mah (darıyerihasanbey Köyü)",
      "İlhanlı Mah (yeniyurt Köyü)",
      "Kahveci Mah (darıyerimengencik Köyü)",
      "Karşı Mah (yeniyurt Köyü)",
      "Koytaklı Mah (çamlıca Köyü)",
      "Kulubeyanı Mah (darıyerihasanbey Köyü)",
      "Kuzumlu Mah (bıçkıyanı Köyü)",
      "Kültür Mah (dipsizgöl Köyü)",
      "Mehmetpınar Mah (yeniyurt Köyü)",
      "Merkez Mah (altunköy Köyü)",
      "Merkez Mah (bıçkıyanı Köyü)",
      "Merkez Mah (çamlıca Köyü)",
      "Merkez Mah (çamoluk Köyü)",
      "Merkez Mah (çatalçam Köyü)",
      "Merkez Mah (darıyeri Yörükler Köyü)",
      "Merkez Mah (darıyeribakacak Köyü)",
      "Merkez Mah (darıyerihasanbey Köyü)",
      "Merkez Mah (darıyerimengencik Köyü)",
      "Merkez Mah (dipsizgöl Köyü)",
      "Merkez Mah (hacıazizler Köyü)",
      "Merkez Mah (muratbey Köyü)",
      "Merkez Mah (sarıçökek Köyü)",
      "Merkez Mah (sazköy Köyü)",
      "Merkez Mah (tavak Köyü)",
      "Merkez Mah (yeniyurt Köyü)",
      "Merkez Mah (yeşiltepe Köyü)",
      "Meşelik Mah (darıyerihasanbey Köyü)",
      "Oflu Mah (altunköy Köyü)",
      "Onbaşı Mah (tavak Köyü)",
      "Orta Mah (dipsizgöl Köyü)",
      "Orta Mah (hacıazizler Köyü)",
      "Osmançavuş Mah (tavak Köyü)",
      "Sağlık Mah (dipsizgöl Köyü)",
      "Sinekli Mah (çakırsayvan Köyü)",
      "Soğuksu Mah (yeşiltepe Köyü)",
      "Şafak Mah (üçköprü Köyü)",
      "Şevki Mah (darıyerihasanbey Köyü)",
      "Şirinevler Mah (darıyerihasanbey Köyü)",
      "Tahtalık Mah (sarıçökek Köyü)",
      "Taşaltı Mah (darıyerihasanbey Köyü)",
      "Tekirsu Mah (dipsizgöl Köyü)",
      "Tütekyatak Mah (yeniyurt Köyü)",
      "Ufuk Mah (üçköprü Köyü)",
      "Üst Mah (çatalçam Köyü)",
      "Velioğlu Aliosman Mah (muratbey Köyü)",
      "Veyselusta Mah (tavak Köyü)",
      "Yağcılar Bilal Mah (muratbey Köyü)",
      "Yenidoğan Mah (üçköprü Köyü)"
    ],
    "Merkez": [
      "Bahçelievler Mah",
      "Çakırlar Mah",
      "Çamlıevler Mah",
      "Demetevler Mah",
      "Esentepe Mah",
      "Güzelbahçe Mah",
      "Kazukoğlu Mah",
      "Kuyumcuhacıali Mah",
      "Nalbantoğlu Mah",
      "Sallar Mah",
      "Tokuşlar Mah",
      "Yahyalar Mah",
      "Yeşiltepe Mah",
      "Yukarı Yahyalar Mah",
      "Beytepe Mah (beyköy Beldesi)",
      "Büyükaçma Köyü",
      "Cumhuriyet Mah (beyköy Beldesi)",
      "Cumhuriyet Osb2 Mah (beyköy Beldesi)",
      "Çalıcuma Köyü",
      "Değirmenbaşı Mah (beyköy Beldesi)",
      "İstiklal Mah (beyköy Beldesi)",
      "İstiklal Osb1 Mah (beyköy Beldesi)",
      "Kültür Mah (beyköy Beldesi)",
      "Muradiyemengencik Köyü",
      "Ovapınar Köyü",
      "Yeni Mah (beyköy Beldesi)",
      "Ballar Mah (boğaziçi Beldesi)",
      "Capoğlu Mah (kabalak Köyü)",
      "Çayırtarla Mah (boğaziçi Beldesi)",
      "Dinler Mah (kabalak Köyü)",
      "Dokuzpınar Mah (boğaziçi Beldesi)",
      "İzmirli Mah (kabalak Köyü)",
      "Merkez Mah (kabalak Köyü)",
      "Mezarlık Mah (kabalak Köyü)",
      "Şekerpınar Mah (boğaziçi Beldesi)",
      "Tekirpınar Mah (kabalak Köyü)",
      "Yazlık Mah (boğaziçi Beldesi)",
      "Yeşilköy Mah (boğaziçi Beldesi)",
      "Aziziye Mah",
      "Burhaniye Mah",
      "Camikebir Mah",
      "Cedidiye Mah",
      "Fevziçakmak Mah",
      "Kiremitocağı Mah",
      "Kültür Mah",
      "Mergiç Mah",
      "Nusrettin Mah",
      "Şerefiye Mah",
      "Uzunmustafa Mah",
      "Ağaköyü Mah",
      "Azmimilli Mah",
      "Çay Mah",
      "Darıcı Mah",
      "Şıralık Mah",
      "Akınlar Mah",
      "Arapçiftliği Mah",
      "Çamköy Mah",
      "Fatih Mah",
      "Hamidiye Mah",
      "Kara Hacımusa Mah",
      "Körpeşler Mah",
      "Sancaklar Mah",
      "Sarayyeri Mah",
      "Yeni Mah",
      "Akpınar Mah",
      "Beyciler Mah",
      "Cumhuriyet Mah",
      "Çavuşlar Mah",
      "Dedeler Mah",
      "Derelitütüncü Mah",
      "Karaca Mah",
      "Koçyazı Mah",
      "Soğukpınar Mah",
      "Çiftepınarlar Mah",
      "Orhangazi Mah",
      "Şehit Bayram Gökmen Mah",
      "Şehit Hüseyin Kıl Mah",
      "Şehit Kemal Işıldak Mah",
      "Şehit Murat Demir Mah",
      "Terzialiler Mah",
      "Açmalar Mah (asar Köyü)",
      "Afanoğlu Mah (yeni Aynalı Köyü)",
      "Akbıyıklar Köyü",
      "Akçalar Mah (otluoğlu Köyü)",
      "Aktarla Köyü",
      "Akyazı Köyü",
      "Alaçam Mah (derdin Köyü)",
      "Altınpınar Köyü",
      "Aşağı Mah (yörük Köyü)",
      "Aynalı Köyü",
      "Bahçelievler Mah (derdin Köyü)",
      "Bataklı Çiftlik Köyü",
      "Bostanlık Köyü",
      "Bucakkurulu Mah (samandere Köyü)",
      "Bük Mah (çınardüzü Köyü)",
      "Cuma Mah (aydınpınar Köyü)",
      "Cumhuriyet Mah (üçyol Köyü)",
      "Çakırhacı İbrahim Köyü",
      "Çakmanlar Mah (sinirci Köyü)",
      "Çam Mah (eski Mengencik Köyü)",
      "Çamlık Mah (uğur Köyü)",
      "Çamlısu Köyü",
      "Çayırbaşı Mah (nasırlı Köyü)",
      "Çınarlı Köyü",
      "Çiçek Mah (istilli Köyü)",
      "Çiftlik Köyü",
      "Çimen Mah (yeni Taşköprü Köyü)",
      "Çobanoğlu Mah (yeni Aynalı Köyü)",
      "Çorak Mah (kaymakçı Köyü)",
      "Çorak Mah (uğur Köyü)",
      "Değirmen Mah (gölormanı Köyü)",
      "Değirmenüstü Mah (samandere Köyü)",
      "Demirciler Mah (asar Köyü)",
      "Depo Mah (gölormanı Köyü)",
      "Dere Mah (derdin Köyü)",
      "Dere Mah (kurtsuyu Köyü)",
      "Develi Besni Köyü",
      "Develi Mah (hacı Ahmetler Köyü)",
      "Doğanlı Köyü",
      "Doğanlı Mah (doğanlı Köyü)",
      "Doruk Mah (derdin Köyü)",
      "Duraklar Köyü",
      "Efendi Mah (hocaoğlu Köyü)",
      "Eminaçma Köyü",
      "Erdemli Köyü",
      "Esentepe Köyü",
      "Fabrika Mah (derdin Köyü)",
      "Fındıkçukuru Mah (uğur Köyü)",
      "Fındıklı Aksu Köyü",
      "Gıcır Mah (otluoğlu Köyü)",
      "Gökçe Köyü",
      "Güldere Köyü",
      "Gümüşpınar Köyü",
      "Günbaşı Mah (günbaşı Köyü)",
      "Gündolaması Köyü",
      "Hacı Aliler Köyü",
      "Hacımustafadüzü Mah (samandere Köyü)",
      "Hacıyatağı Mah (samandere Köyü)",
      "Hakkı Hoca Mah (aydınpınar Köyü)",
      "Hamamdağı Mah (derdin Köyü)",
      "Hamamüstü Mah (derdin Köyü)",
      "Hamza Mah (aybaşı Köyü)",
      "Hasanlar Köyü",
      "Hatıplar Mah (sinirci Köyü)",
      "Hatipli Mah (hatipli Ketenciler Köyü)",
      "Hecinler Mah (esençam Köyü)",
      "Hürriyet Mah (üçyol Köyü)",
      "İhsaniye Köyü",
      "İslahiye Köyü",
      "İslahiye Mah (islahiye Köyü)",
      "İstiklal Mah (üçyol Köyü)",
      "Kadıoğlu Köyü",
      "Kaledibi Köyü",
      "Kalyoncu Mah (gölormanı Köyü)",
      "Kara Ağaç Mah (günbaşı Köyü)",
      "Karaçavuş Mah (gölormanı Köyü)",
      "Karadere Hasanağa Köyü",
      "Karaömer Mah (düverdüzü Köyü)",
      "Karasakal Mah (gölormanı Köyü)",
      "Kardelen Mah (derdin Köyü)",
      "Kasım Mah (kemerkasım Köyü)",
      "Kavakbıçkı Köyü",
      "Kavaklar Mah (sinirci Köyü)",
      "Kemer Mah (kemerkasım Köyü)",
      "Ketenciler Mah (hatipli Ketenciler Köyü)",
      "Kırkacak Mah (güven Köyü)",
      "Kızılcık Köyü",
      "Kireçkuyusu Mah (güven Köyü)",
      "Kocayayla Mah (samandere Köyü)",
      "Konaklı Köyü",
      "Kozluk Köyü",
      "Köprübaşı Köyü",
      "Kurudere Mah (dağdibi Köyü)",
      "Kuruluk Mah (çınardüzü Köyü)",
      "Kuruoğlu Mah (ozanlar Köyü)",
      "Kuşaçması Köyü",
      "Kuşyuvası Mah (samandere Köyü)",
      "Kutlu Köyü",
      "Küçükahmet Köyü",
      "Küçükmehmet Köyü",
      "Kürt Mah (ballıca Köyü)",
      "Mamure Köyü",
      "Merkez Mah (asar Köyü)",
      "Merkez Mah (aybaşı Köyü)",
      "Merkez Mah (aydınpınar Köyü)",
      "Merkez Mah (bahçe Köyü)",
      "Merkez Mah (ballıca Köyü)",
      "Merkez Mah (çınardüzü Köyü)",
      "Merkez Mah (dağdibi Köyü)",
      "Merkez Mah (düverdüzü Köyü)",
      "Merkez Mah (düz Köyü)",
      "Merkez Mah (esençam Köyü)",
      "Merkez Mah (eski Mengencik Köyü)",
      "Merkez Mah (gölormanı Köyü)",
      "Merkez Mah (günbaşı Köyü)",
      "Merkez Mah (güven Köyü)",
      "Merkez Mah (hacı Ahmetler Köyü)",
      "Merkez Mah (hocaoğlu Köyü)",
      "Merkez Mah (istilli Köyü)",
      "Merkez Mah (kaymakçı Köyü)",
      "Merkez Mah (kirazlı Köyü)",
      "Merkez Mah (kurtsuyu Köyü)",
      "Merkez Mah (muncurlu Köyü)",
      "Merkez Mah (nasırlı Köyü)",
      "Merkez Mah (otluoğlu Köyü)",
      "Merkez Mah (ozanlar Köyü)",
      "Merkez Mah (samandere Köyü)",
      "Merkez Mah (sinirci Köyü)",
      "Merkez Mah (taşköprü Köyü)",
      "Merkez Mah (uğur Köyü)",
      "Merkez Mah (üçyol Köyü)",
      "Merkez Mah (yeni Aynalı Köyü)",
      "Merkez Mah (yeni Taşköprü Köyü)",
      "Merkez Mah (yörük Köyü)",
      "Mollaoğlu Mah (ozanlar Köyü)",
      "Muncurlu Mah (muncurlu Köyü)",
      "Musababa Köyü",
      "Musababa Mah (musababa Köyü)",
      "Nuhlar Mah (nasırlı Köyü)",
      "Nuhlar Mah (nuhlar Köyü)",
      "Nusret Yılmaz Mah (gölormanı Köyü)",
      "Orta Mah (otluoğlu Köyü)",
      "Orta Mah (yeni Aynalı Köyü)",
      "Osmanca Köyü",
      "Otlaklar Mah (kurtsuyu Köyü)",
      "Ova Mah (yeni Aynalı Köyü)",
      "Özyanık Köyü",
      "Paşakonağı Köyü",
      "Paşaormanı Köyü",
      "Petekli Mah (kurtsuyu Köyü)",
      "Pınarlar Köyü",
      "Poyraz Mah (günbaşı Köyü)",
      "Sadık Mah (samandere Köyü)",
      "Sancakdere Köyü",
      "Santral Mah (aydınpınar Köyü)",
      "Sarıçam Mah (çınardüzü Köyü)",
      "Sarıkasım Mah (nasırlı Köyü)",
      "Suncuk Köyü",
      "Şaziye Köyü",
      "Şose Altı Mah (aydınpınar Köyü)",
      "Tantan Kuyu Mah (kurtsuyu Köyü)",
      "Tatil Köyü Mah (derdin Köyü)",
      "Tepe Altı Mah (güven Köyü)",
      "Tınaz Mah (yeni Taşköprü Köyü)",
      "Tokmaktarla Mah (nasırlı Köyü)",
      "Tonyalı Mah (kurtsuyu Köyü)",
      "Turaplar Köyü",
      "Tütünlük Mah (samandere Köyü)",
      "Uçuk Mah (uğur Köyü)",
      "Uzunali Mah (gölormanı Köyü)",
      "Üçkese Mah (esençam Köyü)",
      "Yaka Köyü",
      "Yamalı Mah (istilli Köyü)",
      "Yanık Mah (derdin Köyü)",
      "Yayakbaşı Köyü",
      "Yayla Köyü",
      "Yaylakapı Mah (aydınpınar Köyü)",
      "Yeni Karaköy Köyü",
      "Yeni Mah (bahçe Köyü)",
      "Yeni Mah (kirazlı Köyü)",
      "Yeşil Mah (aydınpınar Köyü)",
      "Yeşilçam Köyü",
      "Yeşilçam Mah (yeşilçam Köyü)",
      "Yeşilçimen Köyü",
      "Yılankaya Mah (aydınpınar Köyü)",
      "Yukarı Mah (günbaşı Köyü)",
      "Yukarı Mah (yörük Köyü)",
      "Yunuslar Mah (kemerkasım Köyü)"
    ],
    "Yığılca": [
      "Aksu Mah (hoşafoğlu Köyü)",
      "Asar Köyü",
      "Aşağı Mah (hacılar Köyü)",
      "Aşağı Mah (yılgın Köyü)",
      "Avutluk Mah (dibektaş Köyü)",
      "Aydın Mah (dutlar Köyü)",
      "Aydınyayla Köyü",
      "Belen Mah (hocatman Köyü)",
      "Çayırcık Mah (kırık Köyü)",
      "Çırnık Mah (aksaklar Köyü)",
      "Çiftlik Köyü",
      "Çorak Mah (bekirler Köyü)",
      "Dereiçi Mah (yılgın Köyü)",
      "Doğancılar Mah (redifler Köyü)",
      "Dokuz Mah (hacıyeri Köyü)",
      "Elmas Mah (dibektaş Köyü)",
      "Erenler Mah (tıraşlar Köyü)",
      "Gaziler Köyü",
      "Gelenöz Köyü",
      "Güney Köyü",
      "Güney Mah (çamlı Köyü)",
      "Güney Mah (geriş Köyü)",
      "Güneyaltı Mah (güney Köyü)",
      "Hebeler Köyü",
      "İğneler Köyü",
      "İsmailçayırı Mah (akçaören Köyü)",
      "Karakiraz Mah (kırık Köyü)",
      "Kazaklar Mah (gökçeağaç Köyü)",
      "Kirseyanı Mah (hocatman Köyü)",
      "Köseler Köyü",
      "Kuruca Mah (yeniyer Köyü)",
      "Kuruhüseyin Mah (dibektaş Köyü)",
      "Kuzey Mah (çamlı Köyü)",
      "Mehmetköy Mah (aksaklar Köyü)",
      "Melen Kıyısı Mah (bekirler Köyü)",
      "Mengen Köyü",
      "Merkez Mah (akçaören Köyü)",
      "Merkez Mah (bekirler Köyü)",
      "Merkez Mah (çukurören Köyü)",
      "Merkez Mah (dibektaş Köyü)",
      "Merkez Mah (doğanlar Köyü)",
      "Merkez Mah (dutlar Köyü)",
      "Merkez Mah (geriş Köyü)",
      "Merkez Mah (gökçeağaç Köyü)",
      "Merkez Mah (hacıyeri Köyü)",
      "Merkez Mah (hocatman Köyü)",
      "Merkez Mah (hoşafoğlu Köyü)",
      "Merkez Mah (karakaş Köyü)",
      "Merkez Mah (kırık Köyü)",
      "Merkez Mah (kocaoğlu Köyü)",
      "Merkez Mah (naşlar Köyü)",
      "Merkez Mah (redifler Köyü)",
      "Merkez Mah (tıraşlar Köyü)",
      "Merkez Mah (yeniyer Köyü)",
      "Orhangazi Köyü",
      "Orta Mah (aksaklar Köyü)",
      "Orta Mah (hocaköy Köyü)",
      "Osmancık Mah (yılgın Köyü)",
      "Pınarcık Mah (kocaoğlu Köyü)",
      "Resuller Mah (çukurören Köyü)",
      "Salavat Mah (kırık Köyü)",
      "Sarıkaya Köyü",
      "Setlik Mah (geriş Köyü)",
      "Şaban Mah (gökçeağaç Köyü)",
      "Şabanlar Mah (gökçeağaç Köyü)",
      "Şerenaltı Mah (naşlar Köyü)",
      "Tavukpınarı Mah (çamlı Köyü)",
      "Tuğrul Köyü",
      "Turnacılar Mah (akçaören Köyü)",
      "Vayıslar Mah (doğanlar Köyü)",
      "Yağcılar Köyü",
      "Yaplar Mah (karakaş Köyü)",
      "Yaylatepe Köyü",
      "Yoğunpelit Köyü",
      "Yörükler Mah (gökçeağaç Köyü)",
      "Yukarı Akçaören Mah (kocaoğlu Köyü)",
      "Yukarı Mah (çamlı Köyü)",
      "Yukarı Mah (hacılar Köyü)",
      "Yukarı Mah (hocaköy Köyü)",
      "Yukarı Mah (yılgın Köyü)",
      "Ahmetçiler Mah",
      "Atatürk Mah",
      "Mareşal Fevzi  Çakmak Mah",
      "Orhangazi Mah"
    ]
  }
};

export const cities = Object.keys(turkeyLocations);

export function getNeighborhoods(city, district) {
  if (!city || !district) return [];
  return turkeyNeighborhoods[city]?.[district] || [];
}
